import * as React$4 from 'react';
import React__default, { createContext, useContext, useLayoutEffect, useEffect, useRef, useCallback, useMemo, forwardRef, createElement, useState, cloneElement, Children, isValidElement, Component, useImperativeHandle, Fragment, useReducer } from 'react';

function ownKeys$o(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$o(Object(source), !0).forEach(function (key) {
      _defineProperty$n(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$o(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck$6(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$6(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$6(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$6(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$6(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty$n(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$d() {
  _extends$d = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$d.apply(this, arguments);
}

function _inherits$4(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf$4(subClass, superClass);
}

function _getPrototypeOf$4(o) {
  _getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$4(o);
}

function _setPrototypeOf$4(o, p) {
  _setPrototypeOf$4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf$4(o, p);
}

function _isNativeReflectConstruct$5() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized$4(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$4(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$4(self);
}

function _createSuper$5(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$5();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$4(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$4(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$4(this, result);
  };
}

function _slicedToArray$5(arr, i) {
  return _arrayWithHoles$5(arr) || _iterableToArrayLimit$5(arr, i) || _unsupportedIterableToArray$d(arr, i) || _nonIterableRest$5();
}

function _toConsumableArray$5(arr) {
  return _arrayWithoutHoles$5(arr) || _iterableToArray$6(arr) || _unsupportedIterableToArray$d(arr) || _nonIterableSpread$5();
}

function _arrayWithoutHoles$5(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$d(arr);
}

function _arrayWithHoles$5(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray$6(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit$5(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray$d(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$d(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$d(o, minLen);
}

function _arrayLikeToArray$d(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread$5() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest$5() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function useDimensions() {
  var _React$useState = React$4.useState({
    width: undefined,
    height: undefined
  }),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      windowSize = _React$useState2[0],
      setWindowSize = _React$useState2[1];
  React$4.useEffect(function () {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return windowSize;
}

var Colors = {
  BLUE: '#0098DB',
  LIGHT_BLUE: '#E4F3FA',
  GREY: '#37424A',
  BLACK: '#333333',
  YELLOW: '#FEE000',
  ORANGE: '#FF9932',
  GREEN: '#00CA8B',
  WHITE: '#FFFFFF',
  PURPLE: '#FF3699',
  GRADIENT: '#E5F4FB',
  BLUE_GREY: '#F6F8FB',
  LIGHT_GREY: '#FBFBFB',
  MEDIUM_GREY: '#CCCCCC',
  LIGHT_WHITE: '#F5F5F5',
  DARK_GREY: '#88888D',
  MEDIUM_WHITE: '#EFEFEF',
  DARK_WHITE: '#898B8F',
  RED: '#EF6B6B',
  MEDIUM_BLUE: '#007DC1',
  LIGHT_GREEN: '#CCF4E8',
  LIGHT_ORANGE: '#FFF0E0',
  DARK_ORANGE: '#FF9020',
  LIGHT_RED: '#FDE9E9',
  DARK_RED: '#EE5151'
};

var keyObject = {
  BLUE: 'blue',
  GREEN: 'green',
  PURPLE: 'purple',
  WHITE: 'white',
  RED: 'red',
  GREY: 'grey',
  YELLOW: 'yellow',
  ORANGE: 'orange',
  CUSTOM_YELLOW_ORANGE: 'custom-yellow-orange',
  WHITE_INVERT: 'white-invert',
  PURPLE_INVERT: 'purple-invert',
  BLUE_INVERT: 'blue-invert',
  WHITE_ALT: 'white-alt',
  BLACK: 'black',
  GRADIENT: 'gradient'
};
var ColorSchemesArray = [{
  type: 'blue',
  vibrant: Colors.BLUE,
  delicate: "".concat(Colors.BLUE, "25"),
  dark_shade: '#4db7e6',
  text: Colors.WHITE,
  border: Colors.BLUE
}, {
  type: 'green',
  vibrant: Colors.GREEN,
  delicate: "".concat(Colors.GREEN, "25"),
  dark_shade: '#00AF78',
  text: Colors.WHITE,
  border: Colors.GREEN
}, {
  type: 'purple',
  vibrant: Colors.PURPLE,
  delicate: "".concat(Colors.PURPLE, "25"),
  dark_shade: '#ff72b8',
  text: Colors.WHITE,
  border: Colors.PURPLE
}, {
  type: 'white',
  vibrant: Colors.WHITE,
  delicate: "".concat(Colors.WHITE, "25"),
  dark_shade: Colors.MEDIUM_WHITE,
  text: Colors.GREY,
  border: Colors.MEDIUM_WHITE
}, {
  type: 'red',
  vibrant: Colors.RED,
  delicate: "".concat(Colors.RED, "25"),
  dark_shade: Colors.RED,
  text: Colors.WHITE,
  border: Colors.RED
}, {
  type: 'grey',
  vibrant: Colors.MEDIUM_GREY,
  delicate: "".concat(Colors.MEDIUM_GREY, "25"),
  dark_shade: Colors.MEDIUM_GREY,
  text: Colors.DARK_GREY,
  border: Colors.MEDIUM_GREY
}, {
  type: 'yellow',
  vibrant: Colors.YELLOW,
  delicate: "".concat(Colors.YELLOW, "25"),
  dark_shade: Colors.YELLOW,
  text: Colors.BLACK,
  border: Colors.YELLOW
}, {
  type: 'orange',
  vibrant: Colors.ORANGE,
  delicate: "".concat(Colors.ORANGE, "25"),
  dark_shade: Colors.ORANGE,
  text: Colors.WHITE,
  border: Colors.ORANGE
}, {
  type: 'custom-yellow-orange',
  vibrant: Colors.WHITE,
  delicate: '#FABE38',
  dark_shade: Colors.MEDIUM_WHITE,
  text: '#FABE38',
  border: Colors.WHITE
}, {
  type: 'white-invert',
  vibrant: 'transparent',
  delicate: "".concat(Colors.WHITE, "25"),
  dark_shade: Colors.MEDIUM_WHITE,
  text: Colors.WHITE,
  border: Colors.WHITE
}, {
  type: 'purple-invert',
  vibrant: "".concat(Colors.PURPLE, "25"),
  delicate: "".concat(Colors.PURPLE, "25"),
  dark_shade: Colors.PURPLE,
  text: Colors.PURPLE,
  border: Colors.PURPLE
}, {
  type: 'blue-invert',
  vibrant: Colors.BLUE,
  delicate: "".concat(Colors.BLUE, "25"),
  dark_shade: '#4db7e6',
  text: Colors.BLUE,
  border: Colors.BLUE
}, {
  type: 'white-alt',
  vibrant: Colors.WHITE,
  delicate: "".concat(Colors.WHITE, "25"),
  dark_shade: Colors.MEDIUM_WHITE,
  text: Colors.WHITE,
  border: Colors.WHITE
}, {
  type: 'black',
  vibrant: Colors.GREY,
  delicate: "".concat(Colors.GREY, "25"),
  dark_shade: Colors.GREY,
  text: Colors.WHITE,
  border: Colors.GREY
}, {
  type: 'gradient',
  vibrant: Colors.GRADIENT,
  delicate: "".concat(Colors.GRADIENT, "25"),
  dark_shade: Colors.BLUE,
  text: Colors.GREY,
  border: Colors.GRADIENT
}];

var getColorScheme = function getColorScheme(name) {
  return ColorSchemesArray.find(function (e) {
    return e.type === name;
  });
};
var ColorSchemes = keyObject;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var htmlReactParser = {exports: {}};

var lib$2 = {};

var possibleStandardNamesOptimized$1 = {};

var SAME$1 = 0;
possibleStandardNamesOptimized$1.SAME = SAME$1;
var CAMELCASE$1 = 1;
possibleStandardNamesOptimized$1.CAMELCASE = CAMELCASE$1;
possibleStandardNamesOptimized$1.possibleStandardNames = {
  accept: 0,
  acceptCharset: 1,
  'accept-charset': 'acceptCharset',
  accessKey: 1,
  action: 0,
  allowFullScreen: 1,
  alt: 0,
  as: 0,
  async: 0,
  autoCapitalize: 1,
  autoComplete: 1,
  autoCorrect: 1,
  autoFocus: 1,
  autoPlay: 1,
  autoSave: 1,
  capture: 0,
  cellPadding: 1,
  cellSpacing: 1,
  challenge: 0,
  charSet: 1,
  checked: 0,
  children: 0,
  cite: 0,
  class: 'className',
  classID: 1,
  className: 1,
  cols: 0,
  colSpan: 1,
  content: 0,
  contentEditable: 1,
  contextMenu: 1,
  controls: 0,
  controlsList: 1,
  coords: 0,
  crossOrigin: 1,
  dangerouslySetInnerHTML: 1,
  data: 0,
  dateTime: 1,
  default: 0,
  defaultChecked: 1,
  defaultValue: 1,
  defer: 0,
  dir: 0,
  disabled: 0,
  disablePictureInPicture: 1,
  disableRemotePlayback: 1,
  download: 0,
  draggable: 0,
  encType: 1,
  enterKeyHint: 1,
  for: 'htmlFor',
  form: 0,
  formMethod: 1,
  formAction: 1,
  formEncType: 1,
  formNoValidate: 1,
  formTarget: 1,
  frameBorder: 1,
  headers: 0,
  height: 0,
  hidden: 0,
  high: 0,
  href: 0,
  hrefLang: 1,
  htmlFor: 1,
  httpEquiv: 1,
  'http-equiv': 'httpEquiv',
  icon: 0,
  id: 0,
  innerHTML: 1,
  inputMode: 1,
  integrity: 0,
  is: 0,
  itemID: 1,
  itemProp: 1,
  itemRef: 1,
  itemScope: 1,
  itemType: 1,
  keyParams: 1,
  keyType: 1,
  kind: 0,
  label: 0,
  lang: 0,
  list: 0,
  loop: 0,
  low: 0,
  manifest: 0,
  marginWidth: 1,
  marginHeight: 1,
  max: 0,
  maxLength: 1,
  media: 0,
  mediaGroup: 1,
  method: 0,
  min: 0,
  minLength: 1,
  multiple: 0,
  muted: 0,
  name: 0,
  noModule: 1,
  nonce: 0,
  noValidate: 1,
  open: 0,
  optimum: 0,
  pattern: 0,
  placeholder: 0,
  playsInline: 1,
  poster: 0,
  preload: 0,
  profile: 0,
  radioGroup: 1,
  readOnly: 1,
  referrerPolicy: 1,
  rel: 0,
  required: 0,
  reversed: 0,
  role: 0,
  rows: 0,
  rowSpan: 1,
  sandbox: 0,
  scope: 0,
  scoped: 0,
  scrolling: 0,
  seamless: 0,
  selected: 0,
  shape: 0,
  size: 0,
  sizes: 0,
  span: 0,
  spellCheck: 1,
  src: 0,
  srcDoc: 1,
  srcLang: 1,
  srcSet: 1,
  start: 0,
  step: 0,
  style: 0,
  summary: 0,
  tabIndex: 1,
  target: 0,
  title: 0,
  type: 0,
  useMap: 1,
  value: 0,
  width: 0,
  wmode: 0,
  wrap: 0,
  about: 0,
  accentHeight: 1,
  'accent-height': 'accentHeight',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 1,
  'alignment-baseline': 'alignmentBaseline',
  allowReorder: 1,
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 1,
  'arabic-form': 'arabicForm',
  ascent: 0,
  attributeName: 1,
  attributeType: 1,
  autoReverse: 1,
  azimuth: 0,
  baseFrequency: 1,
  baselineShift: 1,
  'baseline-shift': 'baselineShift',
  baseProfile: 1,
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 1,
  capHeight: 1,
  'cap-height': 'capHeight',
  clip: 0,
  clipPath: 1,
  'clip-path': 'clipPath',
  clipPathUnits: 1,
  clipRule: 1,
  'clip-rule': 'clipRule',
  color: 0,
  colorInterpolation: 1,
  'color-interpolation': 'colorInterpolation',
  colorInterpolationFilters: 1,
  'color-interpolation-filters': 'colorInterpolationFilters',
  colorProfile: 1,
  'color-profile': 'colorProfile',
  colorRendering: 1,
  'color-rendering': 'colorRendering',
  contentScriptType: 1,
  contentStyleType: 1,
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  datatype: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 1,
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 1,
  'dominant-baseline': 'dominantBaseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 1,
  elevation: 0,
  enableBackground: 1,
  'enable-background': 'enableBackground',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 1,
  fill: 0,
  fillOpacity: 1,
  'fill-opacity': 'fillOpacity',
  fillRule: 1,
  'fill-rule': 'fillRule',
  filter: 0,
  filterRes: 1,
  filterUnits: 1,
  floodOpacity: 1,
  'flood-opacity': 'floodOpacity',
  floodColor: 1,
  'flood-color': 'floodColor',
  focusable: 0,
  fontFamily: 1,
  'font-family': 'fontFamily',
  fontSize: 1,
  'font-size': 'fontSize',
  fontSizeAdjust: 1,
  'font-size-adjust': 'fontSizeAdjust',
  fontStretch: 1,
  'font-stretch': 'fontStretch',
  fontStyle: 1,
  'font-style': 'fontStyle',
  fontVariant: 1,
  'font-variant': 'fontVariant',
  fontWeight: 1,
  'font-weight': 'fontWeight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 1,
  'glyph-name': 'glyphName',
  glyphOrientationHorizontal: 1,
  'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
  glyphOrientationVertical: 1,
  'glyph-orientation-vertical': 'glyphOrientationVertical',
  glyphRef: 1,
  gradientTransform: 1,
  gradientUnits: 1,
  hanging: 0,
  horizAdvX: 1,
  'horiz-adv-x': 'horizAdvX',
  horizOriginX: 1,
  'horiz-origin-x': 'horizOriginX',
  ideographic: 0,
  imageRendering: 1,
  'image-rendering': 'imageRendering',
  in2: 0,
  in: 0,
  inlist: 0,
  intercept: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  k: 0,
  kernelMatrix: 1,
  kernelUnitLength: 1,
  kerning: 0,
  keyPoints: 1,
  keySplines: 1,
  keyTimes: 1,
  lengthAdjust: 1,
  letterSpacing: 1,
  'letter-spacing': 'letterSpacing',
  lightingColor: 1,
  'lighting-color': 'lightingColor',
  limitingConeAngle: 1,
  local: 0,
  markerEnd: 1,
  'marker-end': 'markerEnd',
  markerHeight: 1,
  markerMid: 1,
  'marker-mid': 'markerMid',
  markerStart: 1,
  'marker-start': 'markerStart',
  markerUnits: 1,
  markerWidth: 1,
  mask: 0,
  maskContentUnits: 1,
  maskUnits: 1,
  mathematical: 0,
  mode: 0,
  numOctaves: 1,
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 1,
  'overline-position': 'overlinePosition',
  overlineThickness: 1,
  'overline-thickness': 'overlineThickness',
  paintOrder: 1,
  'paint-order': 'paintOrder',
  panose1: 0,
  'panose-1': 'panose1',
  pathLength: 1,
  patternContentUnits: 1,
  patternTransform: 1,
  patternUnits: 1,
  pointerEvents: 1,
  'pointer-events': 'pointerEvents',
  points: 0,
  pointsAtX: 1,
  pointsAtY: 1,
  pointsAtZ: 1,
  prefix: 0,
  preserveAlpha: 1,
  preserveAspectRatio: 1,
  primitiveUnits: 1,
  property: 0,
  r: 0,
  radius: 0,
  refX: 1,
  refY: 1,
  renderingIntent: 1,
  'rendering-intent': 'renderingIntent',
  repeatCount: 1,
  repeatDur: 1,
  requiredExtensions: 1,
  requiredFeatures: 1,
  resource: 0,
  restart: 0,
  result: 0,
  results: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  security: 0,
  seed: 0,
  shapeRendering: 1,
  'shape-rendering': 'shapeRendering',
  slope: 0,
  spacing: 0,
  specularConstant: 1,
  specularExponent: 1,
  speed: 0,
  spreadMethod: 1,
  startOffset: 1,
  stdDeviation: 1,
  stemh: 0,
  stemv: 0,
  stitchTiles: 1,
  stopColor: 1,
  'stop-color': 'stopColor',
  stopOpacity: 1,
  'stop-opacity': 'stopOpacity',
  strikethroughPosition: 1,
  'strikethrough-position': 'strikethroughPosition',
  strikethroughThickness: 1,
  'strikethrough-thickness': 'strikethroughThickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 1,
  'stroke-dasharray': 'strokeDasharray',
  strokeDashoffset: 1,
  'stroke-dashoffset': 'strokeDashoffset',
  strokeLinecap: 1,
  'stroke-linecap': 'strokeLinecap',
  strokeLinejoin: 1,
  'stroke-linejoin': 'strokeLinejoin',
  strokeMiterlimit: 1,
  'stroke-miterlimit': 'strokeMiterlimit',
  strokeWidth: 1,
  'stroke-width': 'strokeWidth',
  strokeOpacity: 1,
  'stroke-opacity': 'strokeOpacity',
  suppressContentEditableWarning: 1,
  suppressHydrationWarning: 1,
  surfaceScale: 1,
  systemLanguage: 1,
  tableValues: 1,
  targetX: 1,
  targetY: 1,
  textAnchor: 1,
  'text-anchor': 'textAnchor',
  textDecoration: 1,
  'text-decoration': 'textDecoration',
  textLength: 1,
  textRendering: 1,
  'text-rendering': 'textRendering',
  to: 0,
  transform: 0,
  typeof: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 1,
  'underline-position': 'underlinePosition',
  underlineThickness: 1,
  'underline-thickness': 'underlineThickness',
  unicode: 0,
  unicodeBidi: 1,
  'unicode-bidi': 'unicodeBidi',
  unicodeRange: 1,
  'unicode-range': 'unicodeRange',
  unitsPerEm: 1,
  'units-per-em': 'unitsPerEm',
  unselectable: 0,
  vAlphabetic: 1,
  'v-alphabetic': 'vAlphabetic',
  values: 0,
  vectorEffect: 1,
  'vector-effect': 'vectorEffect',
  version: 0,
  vertAdvY: 1,
  'vert-adv-y': 'vertAdvY',
  vertOriginX: 1,
  'vert-origin-x': 'vertOriginX',
  vertOriginY: 1,
  'vert-origin-y': 'vertOriginY',
  vHanging: 1,
  'v-hanging': 'vHanging',
  vIdeographic: 1,
  'v-ideographic': 'vIdeographic',
  viewBox: 1,
  viewTarget: 1,
  visibility: 0,
  vMathematical: 1,
  'v-mathematical': 'vMathematical',
  vocab: 0,
  widths: 0,
  wordSpacing: 1,
  'word-spacing': 'wordSpacing',
  writingMode: 1,
  'writing-mode': 'writingMode',
  x1: 0,
  x2: 0,
  x: 0,
  xChannelSelector: 1,
  xHeight: 1,
  'x-height': 'xHeight',
  xlinkActuate: 1,
  'xlink:actuate': 'xlinkActuate',
  xlinkArcrole: 1,
  'xlink:arcrole': 'xlinkArcrole',
  xlinkHref: 1,
  'xlink:href': 'xlinkHref',
  xlinkRole: 1,
  'xlink:role': 'xlinkRole',
  xlinkShow: 1,
  'xlink:show': 'xlinkShow',
  xlinkTitle: 1,
  'xlink:title': 'xlinkTitle',
  xlinkType: 1,
  'xlink:type': 'xlinkType',
  xmlBase: 1,
  'xml:base': 'xmlBase',
  xmlLang: 1,
  'xml:lang': 'xmlLang',
  xmlns: 0,
  'xml:space': 'xmlSpace',
  xmlnsXlink: 1,
  'xmlns:xlink': 'xmlnsXlink',
  xmlSpace: 1,
  y1: 0,
  y2: 0,
  y: 0,
  yChannelSelector: 1,
  z: 0,
  zoomAndPan: 1
};

Object.defineProperty(lib$2, '__esModule', { value: true });
function _slicedToArray$4(arr, i) {
  return _arrayWithHoles$4(arr) || _iterableToArrayLimit$4(arr, i) || _unsupportedIterableToArray$c(arr, i) || _nonIterableRest$4();
}
function _arrayWithHoles$4(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit$4(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _unsupportedIterableToArray$c(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$c(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$c(o, minLen);
}
function _arrayLikeToArray$c(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest$4() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var RESERVED = 0;
var STRING = 1;
var BOOLEANISH_STRING = 2;
var BOOLEAN = 3;
var OVERLOADED_BOOLEAN = 4;
var NUMERIC = 5;
var POSITIVE_NUMERIC = 6;
function getPropertyInfo(name) {
  return properties.hasOwnProperty(name) ? properties[name] : null;
}
function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
  this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
  this.attributeName = attributeName;
  this.attributeNamespace = attributeNamespace;
  this.mustUseProperty = mustUseProperty;
  this.propertyName = name;
  this.type = type;
  this.sanitizeURL = sanitizeURL;
  this.removeEmptyString = removeEmptyString;
}
var properties = {};
var reservedProps = ['children', 'dangerouslySetInnerHTML',
'defaultValue', 'defaultChecked', 'innerHTML', 'suppressContentEditableWarning', 'suppressHydrationWarning', 'style'];
reservedProps.forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, RESERVED, false,
  name,
  null,
  false,
  false);
});
[['acceptCharset', 'accept-charset'], ['className', 'class'], ['htmlFor', 'for'], ['httpEquiv', 'http-equiv']].forEach(function (_ref) {
  var _ref2 = _slicedToArray$4(_ref, 2),
      name = _ref2[0],
      attributeName = _ref2[1];
  properties[name] = new PropertyInfoRecord(name, STRING, false,
  attributeName,
  null,
  false,
  false);
});
['contentEditable', 'draggable', 'spellCheck', 'value'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false,
  name.toLowerCase(),
  null,
  false,
  false);
});
['autoReverse', 'externalResourcesRequired', 'focusable', 'preserveAlpha'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false,
  name,
  null,
  false,
  false);
});
['allowFullScreen', 'async',
'autoFocus', 'autoPlay', 'controls', 'default', 'defer', 'disabled', 'disablePictureInPicture', 'disableRemotePlayback', 'formNoValidate', 'hidden', 'loop', 'noModule', 'noValidate', 'open', 'playsInline', 'readOnly', 'required', 'reversed', 'scoped', 'seamless',
'itemScope'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEAN, false,
  name.toLowerCase(),
  null,
  false,
  false);
});
['checked',
'multiple', 'muted', 'selected'
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, BOOLEAN, true,
  name,
  null,
  false,
  false);
});
['capture', 'download'
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false,
  name,
  null,
  false,
  false);
});
['cols', 'rows', 'size', 'span'
].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false,
  name,
  null,
  false,
  false);
});
['rowSpan', 'start'].forEach(function (name) {
  properties[name] = new PropertyInfoRecord(name, NUMERIC, false,
  name.toLowerCase(),
  null,
  false,
  false);
});
var CAMELIZE = /[\-\:]([a-z])/g;
var capitalize$2 = function capitalize(token) {
  return token[1].toUpperCase();
};
['accent-height', 'alignment-baseline', 'arabic-form', 'baseline-shift', 'cap-height', 'clip-path', 'clip-rule', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'dominant-baseline', 'enable-background', 'fill-opacity', 'fill-rule', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'glyph-name', 'glyph-orientation-horizontal', 'glyph-orientation-vertical', 'horiz-adv-x', 'horiz-origin-x', 'image-rendering', 'letter-spacing', 'lighting-color', 'marker-end', 'marker-mid', 'marker-start', 'overline-position', 'overline-thickness', 'paint-order', 'panose-1', 'pointer-events', 'rendering-intent', 'shape-rendering', 'stop-color', 'stop-opacity', 'strikethrough-position', 'strikethrough-thickness', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke-width', 'text-anchor', 'text-decoration', 'text-rendering', 'underline-position', 'underline-thickness', 'unicode-bidi', 'unicode-range', 'units-per-em', 'v-alphabetic', 'v-hanging', 'v-ideographic', 'v-mathematical', 'vector-effect', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'word-spacing', 'writing-mode', 'xmlns:xlink', 'x-height'
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize$2);
  properties[name] = new PropertyInfoRecord(name, STRING, false,
  attributeName, null,
  false,
  false);
});
['xlink:actuate', 'xlink:arcrole', 'xlink:role', 'xlink:show', 'xlink:title', 'xlink:type'
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize$2);
  properties[name] = new PropertyInfoRecord(name, STRING, false,
  attributeName, 'http://www.w3.org/1999/xlink', false,
  false);
});
['xml:base', 'xml:lang', 'xml:space'
].forEach(function (attributeName) {
  var name = attributeName.replace(CAMELIZE, capitalize$2);
  properties[name] = new PropertyInfoRecord(name, STRING, false,
  attributeName, 'http://www.w3.org/XML/1998/namespace', false,
  false);
});
['tabIndex', 'crossOrigin'].forEach(function (attributeName) {
  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false,
  attributeName.toLowerCase(),
  null,
  false,
  false);
});
var xlinkHref = 'xlinkHref';
properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false,
'xlink:href', 'http://www.w3.org/1999/xlink', true,
false);
['src', 'href', 'action', 'formAction'].forEach(function (attributeName) {
  properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false,
  attributeName.toLowerCase(),
  null,
  true,
  true);
});
var _require$2 = possibleStandardNamesOptimized$1,
    CAMELCASE = _require$2.CAMELCASE,
    SAME = _require$2.SAME,
    possibleStandardNamesOptimized = _require$2.possibleStandardNames;
var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
var isCustomAttribute = RegExp.prototype.test.bind(
new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));
var possibleStandardNames = Object.keys(possibleStandardNamesOptimized).reduce(function (accumulator, standardName) {
  var propName = possibleStandardNamesOptimized[standardName];
  if (propName === SAME) {
    accumulator[standardName] = standardName;
  } else if (propName === CAMELCASE) {
    accumulator[standardName.toLowerCase()] = standardName;
  } else {
    accumulator[standardName] = propName;
  }
  return accumulator;
}, {});
lib$2.BOOLEAN = BOOLEAN;
lib$2.BOOLEANISH_STRING = BOOLEANISH_STRING;
lib$2.NUMERIC = NUMERIC;
lib$2.OVERLOADED_BOOLEAN = OVERLOADED_BOOLEAN;
lib$2.POSITIVE_NUMERIC = POSITIVE_NUMERIC;
lib$2.RESERVED = RESERVED;
lib$2.STRING = STRING;
lib$2.getPropertyInfo = getPropertyInfo;
lib$2.isCustomAttribute = isCustomAttribute;
lib$2.possibleStandardNames = possibleStandardNames;

var cjs = {};

var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var NEWLINE_REGEX = /\n/g;
var WHITESPACE_REGEX = /^\s*/;
var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var COLON_REGEX = /^:\s*/;
var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var SEMICOLON_REGEX = /^[;\s]*/;
var TRIM_REGEX = /^\s+|\s+$/g;
var NEWLINE = '\n';
var FORWARD_SLASH = '/';
var ASTERISK = '*';
var EMPTY_STRING = '';
var TYPE_COMMENT = 'comment';
var TYPE_DECLARATION = 'declaration';
var inlineStyleParser = function(style, options) {
  if (typeof style !== 'string') {
    throw new TypeError('First argument must be a string');
  }
  if (!style) return [];
  options = options || {};
  var lineno = 1;
  var column = 1;
  function updatePosition(str) {
    var lines = str.match(NEWLINE_REGEX);
    if (lines) lineno += lines.length;
    var i = str.lastIndexOf(NEWLINE);
    column = ~i ? str.length - i : column + str.length;
  }
  function position() {
    var start = { line: lineno, column: column };
    return function(node) {
      node.position = new Position(start);
      whitespace();
      return node;
    };
  }
  function Position(start) {
    this.start = start;
    this.end = { line: lineno, column: column };
    this.source = options.source;
  }
  Position.prototype.content = style;
  function error(msg) {
    var err = new Error(
      options.source + ':' + lineno + ':' + column + ': ' + msg
    );
    err.reason = msg;
    err.filename = options.source;
    err.line = lineno;
    err.column = column;
    err.source = style;
    if (options.silent) ; else {
      throw err;
    }
  }
  function match(re) {
    var m = re.exec(style);
    if (!m) return;
    var str = m[0];
    updatePosition(str);
    style = style.slice(str.length);
    return m;
  }
  function whitespace() {
    match(WHITESPACE_REGEX);
  }
  function comments(rules) {
    var c;
    rules = rules || [];
    while ((c = comment())) {
      if (c !== false) {
        rules.push(c);
      }
    }
    return rules;
  }
  function comment() {
    var pos = position();
    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;
    var i = 2;
    while (
      EMPTY_STRING != style.charAt(i) &&
      (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))
    ) {
      ++i;
    }
    i += 2;
    if (EMPTY_STRING === style.charAt(i - 1)) {
      return error('End of comment missing');
    }
    var str = style.slice(2, i - 2);
    column += 2;
    updatePosition(str);
    style = style.slice(i);
    column += 2;
    return pos({
      type: TYPE_COMMENT,
      comment: str
    });
  }
  function declaration() {
    var pos = position();
    var prop = match(PROPERTY_REGEX);
    if (!prop) return;
    comment();
    if (!match(COLON_REGEX)) return error("property missing ':'");
    var val = match(VALUE_REGEX);
    var ret = pos({
      type: TYPE_DECLARATION,
      property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
      value: val
        ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING))
        : EMPTY_STRING
    });
    match(SEMICOLON_REGEX);
    return ret;
  }
  function declarations() {
    var decls = [];
    comments(decls);
    var decl;
    while ((decl = declaration())) {
      if (decl !== false) {
        decls.push(decl);
        comments(decls);
      }
    }
    return decls;
  }
  whitespace();
  return declarations();
};
function trim(str) {
  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
}

var parse$3 = inlineStyleParser;
function StyleToObject(style, iterator) {
  var output = null;
  if (!style || typeof style !== 'string') {
    return output;
  }
  var declaration;
  var declarations = parse$3(style);
  var hasIterator = typeof iterator === 'function';
  var property;
  var value;
  for (var i = 0, len = declarations.length; i < len; i++) {
    declaration = declarations[i];
    property = declaration.property;
    value = declaration.value;
    if (hasIterator) {
      iterator(property, value, declaration);
    } else if (value) {
      output || (output = {});
      output[property] = value;
    }
  }
  return output;
}
var styleToObject = StyleToObject;

var utilities$4 = {};

utilities$4.__esModule = true;
utilities$4.camelCase = void 0;
var CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9-]+$/;
var HYPHEN_REGEX = /-([a-z])/g;
var NO_HYPHEN_REGEX = /^[^-]+$/;
var VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
var MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
var skipCamelCase = function (property) {
    return !property ||
        NO_HYPHEN_REGEX.test(property) ||
        CUSTOM_PROPERTY_REGEX.test(property);
};
var capitalize$1 = function (match, character) {
    return character.toUpperCase();
};
var trimHyphen = function (match, prefix) { return "".concat(prefix, "-"); };
var camelCase = function (property, options) {
    if (options === void 0) { options = {}; }
    if (skipCamelCase(property)) {
        return property;
    }
    property = property.toLowerCase();
    if (options.reactCompat) {
        property = property.replace(MS_VENDOR_PREFIX_REGEX, trimHyphen);
    }
    else {
        property = property.replace(VENDOR_PREFIX_REGEX, trimHyphen);
    }
    return property.replace(HYPHEN_REGEX, capitalize$1);
};
utilities$4.camelCase = camelCase;

(function (exports) {
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var style_to_object_1 = __importDefault(styleToObject);
var utilities_1 = utilities$4;
function StyleToJS(style, options) {
    var output = {};
    if (!style || typeof style !== 'string') {
        return output;
    }
    (0, style_to_object_1["default"])(style, function (property, value) {
        if (property && value) {
            output[(0, utilities_1.camelCase)(property, options)] = value;
        }
    });
    return output;
}
exports["default"] = StyleToJS;
}(cjs));
getDefaultExportFromCjs(cjs);

var React$3 = React__default;
var styleToJS = cjs.default;
function invertObject(obj, override) {
  if (!obj || typeof obj !== 'object') {
    throw new TypeError('First argument must be an object');
  }
  var key;
  var value;
  var isOverridePresent = typeof override === 'function';
  var overrides = {};
  var result = {};
  for (key in obj) {
    value = obj[key];
    if (isOverridePresent) {
      overrides = override(key, value);
      if (overrides && overrides.length === 2) {
        result[overrides[0]] = overrides[1];
        continue;
      }
    }
    if (typeof value === 'string') {
      result[value] = key;
    }
  }
  return result;
}
function isCustomComponent(tagName, props) {
  if (tagName.indexOf('-') === -1) {
    return props && typeof props.is === 'string';
  }
  switch (tagName) {
    case 'annotation-xml':
    case 'color-profile':
    case 'font-face':
    case 'font-face-src':
    case 'font-face-uri':
    case 'font-face-format':
    case 'font-face-name':
    case 'missing-glyph':
      return false;
    default:
      return true;
  }
}
var styleToJSOptions = { reactCompat: true };
function setStyleProp$1(style, props) {
  if (style === null || style === undefined) {
    return;
  }
  try {
    props.style = styleToJS(style, styleToJSOptions);
  } catch (err) {
    props.style = {};
  }
}
var PRESERVE_CUSTOM_ATTRIBUTES = React$3.version.split('.')[0] >= 16;
var elementsWithNoTextChildren = new Set([
  'tr',
  'tbody',
  'thead',
  'tfoot',
  'colgroup',
  'table',
  'head',
  'html',
  'frameset'
]);
function canTextBeChildOfNode$1(node) {
  return !elementsWithNoTextChildren.has(node.name);
}
var utilities$3 = {
  PRESERVE_CUSTOM_ATTRIBUTES: PRESERVE_CUSTOM_ATTRIBUTES,
  invertObject: invertObject,
  isCustomComponent: isCustomComponent,
  setStyleProp: setStyleProp$1,
  canTextBeChildOfNode: canTextBeChildOfNode$1,
  elementsWithNoTextChildren: elementsWithNoTextChildren
};

var reactProperty = lib$2;
var utilities$2 = utilities$3;
var attributesToProps$2 = function attributesToProps(attributes) {
  attributes = attributes || {};
  var valueOnlyInputs = {
    reset: true,
    submit: true
  };
  var attributeName;
  var attributeNameLowerCased;
  var attributeValue;
  var propName;
  var propertyInfo;
  var props = {};
  var inputIsValueOnly = attributes.type && valueOnlyInputs[attributes.type];
  for (attributeName in attributes) {
    attributeValue = attributes[attributeName];
    if (reactProperty.isCustomAttribute(attributeName)) {
      props[attributeName] = attributeValue;
      continue;
    }
    attributeNameLowerCased = attributeName.toLowerCase();
    propName = getPropName(attributeNameLowerCased);
    if (propName) {
      propertyInfo = reactProperty.getPropertyInfo(propName);
      if (
        (propName === 'checked' || propName === 'value') &&
        !inputIsValueOnly
      ) {
        propName = getPropName('default' + attributeNameLowerCased);
      }
      props[propName] = attributeValue;
      switch (propertyInfo && propertyInfo.type) {
        case reactProperty.BOOLEAN:
          props[propName] = true;
          break;
        case reactProperty.OVERLOADED_BOOLEAN:
          if (attributeValue === '') {
            props[propName] = true;
          }
          break;
      }
      continue;
    }
    if (utilities$2.PRESERVE_CUSTOM_ATTRIBUTES) {
      props[attributeName] = attributeValue;
    }
  }
  utilities$2.setStyleProp(attributes.style, props);
  return props;
};
function getPropName(attributeName) {
  return reactProperty.possibleStandardNames[attributeName];
}

var React$2 = React__default;
var attributesToProps$1 = attributesToProps$2;
var utilities$1 = utilities$3;
var setStyleProp = utilities$1.setStyleProp;
var canTextBeChildOfNode = utilities$1.canTextBeChildOfNode;
function domToReact$1(nodes, options) {
  options = options || {};
  var library = options.library || React$2;
  var cloneElement = library.cloneElement;
  var createElement = library.createElement;
  var isValidElement = library.isValidElement;
  var result = [];
  var node;
  var isWhitespace;
  var hasReplace = typeof options.replace === 'function';
  var replaceElement;
  var props;
  var children;
  var trim = options.trim;
  for (var i = 0, len = nodes.length; i < len; i++) {
    node = nodes[i];
    if (hasReplace) {
      replaceElement = options.replace(node);
      if (isValidElement(replaceElement)) {
        if (len > 1) {
          replaceElement = cloneElement(replaceElement, {
            key: replaceElement.key || i
          });
        }
        result.push(replaceElement);
        continue;
      }
    }
    if (node.type === 'text') {
      isWhitespace = !node.data.trim().length;
      if (isWhitespace && node.parent && !canTextBeChildOfNode(node.parent)) {
        continue;
      }
      if (trim && isWhitespace) {
        continue;
      }
      result.push(node.data);
      continue;
    }
    props = node.attribs;
    if (skipAttributesToProps(node)) {
      setStyleProp(props.style, props);
    } else if (props) {
      props = attributesToProps$1(props);
    }
    children = null;
    switch (node.type) {
      case 'script':
      case 'style':
        if (node.children[0]) {
          props.dangerouslySetInnerHTML = {
            __html: node.children[0].data
          };
        }
        break;
      case 'tag':
        if (node.name === 'textarea' && node.children[0]) {
          props.defaultValue = node.children[0].data;
        } else if (node.children && node.children.length) {
          children = domToReact$1(node.children, options);
        }
        break;
      default:
        continue;
    }
    if (len > 1) {
      props.key = i;
    }
    result.push(createElement(node.name, props, children));
  }
  return result.length === 1 ? result[0] : result;
}
function skipAttributesToProps(node) {
  return (
    utilities$1.PRESERVE_CUSTOM_ATTRIBUTES &&
    node.type === 'tag' &&
    utilities$1.isCustomComponent(node.name, node.attribs)
  );
}
var domToReact_1 = domToReact$1;

var Parser$2 = {};

var Tokenizer$1 = {};

var decode_codepoint = {};

Object.defineProperty(decode_codepoint, "__esModule", { value: true });
var decodeMap = new Map([
    [0, 65533],
    [128, 8364],
    [130, 8218],
    [131, 402],
    [132, 8222],
    [133, 8230],
    [134, 8224],
    [135, 8225],
    [136, 710],
    [137, 8240],
    [138, 352],
    [139, 8249],
    [140, 338],
    [142, 381],
    [145, 8216],
    [146, 8217],
    [147, 8220],
    [148, 8221],
    [149, 8226],
    [150, 8211],
    [151, 8212],
    [152, 732],
    [153, 8482],
    [154, 353],
    [155, 8250],
    [156, 339],
    [158, 382],
    [159, 376],
]);
var fromCodePoint =
String.fromCodePoint ||
    function (codePoint) {
        var output = "";
        if (codePoint > 0xffff) {
            codePoint -= 0x10000;
            output += String.fromCharCode(((codePoint >>> 10) & 0x3ff) | 0xd800);
            codePoint = 0xdc00 | (codePoint & 0x3ff);
        }
        output += String.fromCharCode(codePoint);
        return output;
    };
function decodeCodePoint(codePoint) {
    var _a;
    if ((codePoint >= 0xd800 && codePoint <= 0xdfff) || codePoint > 0x10ffff) {
        return "\uFFFD";
    }
    return fromCodePoint((_a = decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint);
}
decode_codepoint.default = decodeCodePoint;

var decode = {};

var decodeDataHtml = {};

Object.defineProperty(decodeDataHtml, "__esModule", { value: true });
decodeDataHtml.default = new Uint16Array([14866, 60, 237, 340, 721, 1312, 1562, 1654, 1838, 1957, 2183, 2239, 2301, 2958, 3037, 3893, 4123, 4298, 4330, 4801, 5191, 5395, 5752, 5903, 5943, 5972, 6050, 0, 0, 0, 0, 0, 0, 6135, 6565, 7422, 8183, 8738, 9242, 9503, 9938, 10189, 10573, 10637, 10715, 11950, 12246, 13539, 13950, 14445, 14533, 15364, 16514, 16980, 17390, 17763, 17849, 18036, 18125, 4096, 69, 77, 97, 98, 99, 102, 103, 108, 109, 110, 111, 112, 114, 115, 116, 117, 92, 100, 106, 115, 122, 137, 142, 151, 157, 163, 167, 182, 196, 204, 220, 229, 108, 105, 103, 33024, 198, 59, 32768, 198, 80, 33024, 38, 59, 32768, 38, 99, 117, 116, 101, 33024, 193, 59, 32768, 193, 114, 101, 118, 101, 59, 32768, 258, 512, 105, 121, 127, 134, 114, 99, 33024, 194, 59, 32768, 194, 59, 32768, 1040, 114, 59, 32896, 55349, 56580, 114, 97, 118, 101, 33024, 192, 59, 32768, 192, 112, 104, 97, 59, 32768, 913, 97, 99, 114, 59, 32768, 256, 100, 59, 32768, 10835, 512, 103, 112, 172, 177, 111, 110, 59, 32768, 260, 102, 59, 32896, 55349, 56632, 112, 108, 121, 70, 117, 110, 99, 116, 105, 111, 110, 59, 32768, 8289, 105, 110, 103, 33024, 197, 59, 32768, 197, 512, 99, 115, 209, 214, 114, 59, 32896, 55349, 56476, 105, 103, 110, 59, 32768, 8788, 105, 108, 100, 101, 33024, 195, 59, 32768, 195, 109, 108, 33024, 196, 59, 32768, 196, 2048, 97, 99, 101, 102, 111, 114, 115, 117, 253, 278, 282, 310, 315, 321, 327, 332, 512, 99, 114, 258, 267, 107, 115, 108, 97, 115, 104, 59, 32768, 8726, 583, 271, 274, 59, 32768, 10983, 101, 100, 59, 32768, 8966, 121, 59, 32768, 1041, 768, 99, 114, 116, 289, 296, 306, 97, 117, 115, 101, 59, 32768, 8757, 110, 111, 117, 108, 108, 105, 115, 59, 32768, 8492, 97, 59, 32768, 914, 114, 59, 32896, 55349, 56581, 112, 102, 59, 32896, 55349, 56633, 101, 118, 101, 59, 32768, 728, 99, 114, 59, 32768, 8492, 109, 112, 101, 113, 59, 32768, 8782, 3584, 72, 79, 97, 99, 100, 101, 102, 104, 105, 108, 111, 114, 115, 117, 368, 373, 380, 426, 461, 466, 487, 491, 495, 533, 593, 695, 701, 707, 99, 121, 59, 32768, 1063, 80, 89, 33024, 169, 59, 32768, 169, 768, 99, 112, 121, 387, 393, 419, 117, 116, 101, 59, 32768, 262, 512, 59, 105, 398, 400, 32768, 8914, 116, 97, 108, 68, 105, 102, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 32768, 8517, 108, 101, 121, 115, 59, 32768, 8493, 1024, 97, 101, 105, 111, 435, 441, 449, 454, 114, 111, 110, 59, 32768, 268, 100, 105, 108, 33024, 199, 59, 32768, 199, 114, 99, 59, 32768, 264, 110, 105, 110, 116, 59, 32768, 8752, 111, 116, 59, 32768, 266, 512, 100, 110, 471, 478, 105, 108, 108, 97, 59, 32768, 184, 116, 101, 114, 68, 111, 116, 59, 32768, 183, 114, 59, 32768, 8493, 105, 59, 32768, 935, 114, 99, 108, 101, 1024, 68, 77, 80, 84, 508, 513, 520, 526, 111, 116, 59, 32768, 8857, 105, 110, 117, 115, 59, 32768, 8854, 108, 117, 115, 59, 32768, 8853, 105, 109, 101, 115, 59, 32768, 8855, 111, 512, 99, 115, 539, 562, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 32768, 8754, 101, 67, 117, 114, 108, 121, 512, 68, 81, 573, 586, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 32768, 8221, 117, 111, 116, 101, 59, 32768, 8217, 1024, 108, 110, 112, 117, 602, 614, 648, 664, 111, 110, 512, 59, 101, 609, 611, 32768, 8759, 59, 32768, 10868, 768, 103, 105, 116, 621, 629, 634, 114, 117, 101, 110, 116, 59, 32768, 8801, 110, 116, 59, 32768, 8751, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 32768, 8750, 512, 102, 114, 653, 656, 59, 32768, 8450, 111, 100, 117, 99, 116, 59, 32768, 8720, 110, 116, 101, 114, 67, 108, 111, 99, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 32768, 8755, 111, 115, 115, 59, 32768, 10799, 99, 114, 59, 32896, 55349, 56478, 112, 512, 59, 67, 713, 715, 32768, 8915, 97, 112, 59, 32768, 8781, 2816, 68, 74, 83, 90, 97, 99, 101, 102, 105, 111, 115, 743, 758, 763, 768, 773, 795, 809, 821, 826, 910, 1295, 512, 59, 111, 748, 750, 32768, 8517, 116, 114, 97, 104, 100, 59, 32768, 10513, 99, 121, 59, 32768, 1026, 99, 121, 59, 32768, 1029, 99, 121, 59, 32768, 1039, 768, 103, 114, 115, 780, 786, 790, 103, 101, 114, 59, 32768, 8225, 114, 59, 32768, 8609, 104, 118, 59, 32768, 10980, 512, 97, 121, 800, 806, 114, 111, 110, 59, 32768, 270, 59, 32768, 1044, 108, 512, 59, 116, 815, 817, 32768, 8711, 97, 59, 32768, 916, 114, 59, 32896, 55349, 56583, 512, 97, 102, 831, 897, 512, 99, 109, 836, 891, 114, 105, 116, 105, 99, 97, 108, 1024, 65, 68, 71, 84, 852, 859, 877, 884, 99, 117, 116, 101, 59, 32768, 180, 111, 581, 864, 867, 59, 32768, 729, 98, 108, 101, 65, 99, 117, 116, 101, 59, 32768, 733, 114, 97, 118, 101, 59, 32768, 96, 105, 108, 100, 101, 59, 32768, 732, 111, 110, 100, 59, 32768, 8900, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 32768, 8518, 2113, 920, 0, 0, 0, 925, 946, 0, 1139, 102, 59, 32896, 55349, 56635, 768, 59, 68, 69, 931, 933, 938, 32768, 168, 111, 116, 59, 32768, 8412, 113, 117, 97, 108, 59, 32768, 8784, 98, 108, 101, 1536, 67, 68, 76, 82, 85, 86, 961, 978, 996, 1080, 1101, 1125, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 32768, 8751, 111, 1093, 985, 0, 0, 988, 59, 32768, 168, 110, 65, 114, 114, 111, 119, 59, 32768, 8659, 512, 101, 111, 1001, 1034, 102, 116, 768, 65, 82, 84, 1010, 1017, 1029, 114, 114, 111, 119, 59, 32768, 8656, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 8660, 101, 101, 59, 32768, 10980, 110, 103, 512, 76, 82, 1041, 1068, 101, 102, 116, 512, 65, 82, 1049, 1056, 114, 114, 111, 119, 59, 32768, 10232, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 10234, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 10233, 105, 103, 104, 116, 512, 65, 84, 1089, 1096, 114, 114, 111, 119, 59, 32768, 8658, 101, 101, 59, 32768, 8872, 112, 1042, 1108, 0, 0, 1115, 114, 114, 111, 119, 59, 32768, 8657, 111, 119, 110, 65, 114, 114, 111, 119, 59, 32768, 8661, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 32768, 8741, 110, 1536, 65, 66, 76, 82, 84, 97, 1152, 1179, 1186, 1236, 1272, 1288, 114, 114, 111, 119, 768, 59, 66, 85, 1163, 1165, 1170, 32768, 8595, 97, 114, 59, 32768, 10515, 112, 65, 114, 114, 111, 119, 59, 32768, 8693, 114, 101, 118, 101, 59, 32768, 785, 101, 102, 116, 1315, 1196, 0, 1209, 0, 1220, 105, 103, 104, 116, 86, 101, 99, 116, 111, 114, 59, 32768, 10576, 101, 101, 86, 101, 99, 116, 111, 114, 59, 32768, 10590, 101, 99, 116, 111, 114, 512, 59, 66, 1229, 1231, 32768, 8637, 97, 114, 59, 32768, 10582, 105, 103, 104, 116, 805, 1245, 0, 1256, 101, 101, 86, 101, 99, 116, 111, 114, 59, 32768, 10591, 101, 99, 116, 111, 114, 512, 59, 66, 1265, 1267, 32768, 8641, 97, 114, 59, 32768, 10583, 101, 101, 512, 59, 65, 1279, 1281, 32768, 8868, 114, 114, 111, 119, 59, 32768, 8615, 114, 114, 111, 119, 59, 32768, 8659, 512, 99, 116, 1300, 1305, 114, 59, 32896, 55349, 56479, 114, 111, 107, 59, 32768, 272, 4096, 78, 84, 97, 99, 100, 102, 103, 108, 109, 111, 112, 113, 115, 116, 117, 120, 1344, 1348, 1354, 1363, 1386, 1391, 1396, 1405, 1413, 1460, 1475, 1483, 1514, 1527, 1531, 1538, 71, 59, 32768, 330, 72, 33024, 208, 59, 32768, 208, 99, 117, 116, 101, 33024, 201, 59, 32768, 201, 768, 97, 105, 121, 1370, 1376, 1383, 114, 111, 110, 59, 32768, 282, 114, 99, 33024, 202, 59, 32768, 202, 59, 32768, 1069, 111, 116, 59, 32768, 278, 114, 59, 32896, 55349, 56584, 114, 97, 118, 101, 33024, 200, 59, 32768, 200, 101, 109, 101, 110, 116, 59, 32768, 8712, 512, 97, 112, 1418, 1423, 99, 114, 59, 32768, 274, 116, 121, 1060, 1431, 0, 0, 1444, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 32768, 9723, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 32768, 9643, 512, 103, 112, 1465, 1470, 111, 110, 59, 32768, 280, 102, 59, 32896, 55349, 56636, 115, 105, 108, 111, 110, 59, 32768, 917, 117, 512, 97, 105, 1489, 1504, 108, 512, 59, 84, 1495, 1497, 32768, 10869, 105, 108, 100, 101, 59, 32768, 8770, 108, 105, 98, 114, 105, 117, 109, 59, 32768, 8652, 512, 99, 105, 1519, 1523, 114, 59, 32768, 8496, 109, 59, 32768, 10867, 97, 59, 32768, 919, 109, 108, 33024, 203, 59, 32768, 203, 512, 105, 112, 1543, 1549, 115, 116, 115, 59, 32768, 8707, 111, 110, 101, 110, 116, 105, 97, 108, 69, 59, 32768, 8519, 1280, 99, 102, 105, 111, 115, 1572, 1576, 1581, 1620, 1648, 121, 59, 32768, 1060, 114, 59, 32896, 55349, 56585, 108, 108, 101, 100, 1060, 1591, 0, 0, 1604, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 32768, 9724, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 32768, 9642, 1601, 1628, 0, 1633, 0, 0, 1639, 102, 59, 32896, 55349, 56637, 65, 108, 108, 59, 32768, 8704, 114, 105, 101, 114, 116, 114, 102, 59, 32768, 8497, 99, 114, 59, 32768, 8497, 3072, 74, 84, 97, 98, 99, 100, 102, 103, 111, 114, 115, 116, 1678, 1683, 1688, 1701, 1708, 1729, 1734, 1739, 1742, 1748, 1828, 1834, 99, 121, 59, 32768, 1027, 33024, 62, 59, 32768, 62, 109, 109, 97, 512, 59, 100, 1696, 1698, 32768, 915, 59, 32768, 988, 114, 101, 118, 101, 59, 32768, 286, 768, 101, 105, 121, 1715, 1721, 1726, 100, 105, 108, 59, 32768, 290, 114, 99, 59, 32768, 284, 59, 32768, 1043, 111, 116, 59, 32768, 288, 114, 59, 32896, 55349, 56586, 59, 32768, 8921, 112, 102, 59, 32896, 55349, 56638, 101, 97, 116, 101, 114, 1536, 69, 70, 71, 76, 83, 84, 1766, 1783, 1794, 1803, 1809, 1821, 113, 117, 97, 108, 512, 59, 76, 1775, 1777, 32768, 8805, 101, 115, 115, 59, 32768, 8923, 117, 108, 108, 69, 113, 117, 97, 108, 59, 32768, 8807, 114, 101, 97, 116, 101, 114, 59, 32768, 10914, 101, 115, 115, 59, 32768, 8823, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32768, 10878, 105, 108, 100, 101, 59, 32768, 8819, 99, 114, 59, 32896, 55349, 56482, 59, 32768, 8811, 2048, 65, 97, 99, 102, 105, 111, 115, 117, 1854, 1861, 1874, 1880, 1884, 1897, 1919, 1934, 82, 68, 99, 121, 59, 32768, 1066, 512, 99, 116, 1866, 1871, 101, 107, 59, 32768, 711, 59, 32768, 94, 105, 114, 99, 59, 32768, 292, 114, 59, 32768, 8460, 108, 98, 101, 114, 116, 83, 112, 97, 99, 101, 59, 32768, 8459, 833, 1902, 0, 1906, 102, 59, 32768, 8461, 105, 122, 111, 110, 116, 97, 108, 76, 105, 110, 101, 59, 32768, 9472, 512, 99, 116, 1924, 1928, 114, 59, 32768, 8459, 114, 111, 107, 59, 32768, 294, 109, 112, 533, 1940, 1950, 111, 119, 110, 72, 117, 109, 112, 59, 32768, 8782, 113, 117, 97, 108, 59, 32768, 8783, 3584, 69, 74, 79, 97, 99, 100, 102, 103, 109, 110, 111, 115, 116, 117, 1985, 1990, 1996, 2001, 2010, 2025, 2030, 2034, 2043, 2077, 2134, 2155, 2160, 2167, 99, 121, 59, 32768, 1045, 108, 105, 103, 59, 32768, 306, 99, 121, 59, 32768, 1025, 99, 117, 116, 101, 33024, 205, 59, 32768, 205, 512, 105, 121, 2015, 2022, 114, 99, 33024, 206, 59, 32768, 206, 59, 32768, 1048, 111, 116, 59, 32768, 304, 114, 59, 32768, 8465, 114, 97, 118, 101, 33024, 204, 59, 32768, 204, 768, 59, 97, 112, 2050, 2052, 2070, 32768, 8465, 512, 99, 103, 2057, 2061, 114, 59, 32768, 298, 105, 110, 97, 114, 121, 73, 59, 32768, 8520, 108, 105, 101, 115, 59, 32768, 8658, 837, 2082, 0, 2110, 512, 59, 101, 2086, 2088, 32768, 8748, 512, 103, 114, 2093, 2099, 114, 97, 108, 59, 32768, 8747, 115, 101, 99, 116, 105, 111, 110, 59, 32768, 8898, 105, 115, 105, 98, 108, 101, 512, 67, 84, 2120, 2127, 111, 109, 109, 97, 59, 32768, 8291, 105, 109, 101, 115, 59, 32768, 8290, 768, 103, 112, 116, 2141, 2146, 2151, 111, 110, 59, 32768, 302, 102, 59, 32896, 55349, 56640, 97, 59, 32768, 921, 99, 114, 59, 32768, 8464, 105, 108, 100, 101, 59, 32768, 296, 828, 2172, 0, 2177, 99, 121, 59, 32768, 1030, 108, 33024, 207, 59, 32768, 207, 1280, 99, 102, 111, 115, 117, 2193, 2206, 2211, 2217, 2232, 512, 105, 121, 2198, 2203, 114, 99, 59, 32768, 308, 59, 32768, 1049, 114, 59, 32896, 55349, 56589, 112, 102, 59, 32896, 55349, 56641, 820, 2222, 0, 2227, 114, 59, 32896, 55349, 56485, 114, 99, 121, 59, 32768, 1032, 107, 99, 121, 59, 32768, 1028, 1792, 72, 74, 97, 99, 102, 111, 115, 2253, 2258, 2263, 2269, 2283, 2288, 2294, 99, 121, 59, 32768, 1061, 99, 121, 59, 32768, 1036, 112, 112, 97, 59, 32768, 922, 512, 101, 121, 2274, 2280, 100, 105, 108, 59, 32768, 310, 59, 32768, 1050, 114, 59, 32896, 55349, 56590, 112, 102, 59, 32896, 55349, 56642, 99, 114, 59, 32896, 55349, 56486, 2816, 74, 84, 97, 99, 101, 102, 108, 109, 111, 115, 116, 2323, 2328, 2333, 2374, 2396, 2775, 2780, 2797, 2804, 2934, 2954, 99, 121, 59, 32768, 1033, 33024, 60, 59, 32768, 60, 1280, 99, 109, 110, 112, 114, 2344, 2350, 2356, 2360, 2370, 117, 116, 101, 59, 32768, 313, 98, 100, 97, 59, 32768, 923, 103, 59, 32768, 10218, 108, 97, 99, 101, 116, 114, 102, 59, 32768, 8466, 114, 59, 32768, 8606, 768, 97, 101, 121, 2381, 2387, 2393, 114, 111, 110, 59, 32768, 317, 100, 105, 108, 59, 32768, 315, 59, 32768, 1051, 512, 102, 115, 2401, 2702, 116, 2560, 65, 67, 68, 70, 82, 84, 85, 86, 97, 114, 2423, 2470, 2479, 2530, 2537, 2561, 2618, 2666, 2683, 2690, 512, 110, 114, 2428, 2441, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 32768, 10216, 114, 111, 119, 768, 59, 66, 82, 2451, 2453, 2458, 32768, 8592, 97, 114, 59, 32768, 8676, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 8646, 101, 105, 108, 105, 110, 103, 59, 32768, 8968, 111, 838, 2485, 0, 2498, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 32768, 10214, 110, 805, 2503, 0, 2514, 101, 101, 86, 101, 99, 116, 111, 114, 59, 32768, 10593, 101, 99, 116, 111, 114, 512, 59, 66, 2523, 2525, 32768, 8643, 97, 114, 59, 32768, 10585, 108, 111, 111, 114, 59, 32768, 8970, 105, 103, 104, 116, 512, 65, 86, 2546, 2553, 114, 114, 111, 119, 59, 32768, 8596, 101, 99, 116, 111, 114, 59, 32768, 10574, 512, 101, 114, 2566, 2591, 101, 768, 59, 65, 86, 2574, 2576, 2583, 32768, 8867, 114, 114, 111, 119, 59, 32768, 8612, 101, 99, 116, 111, 114, 59, 32768, 10586, 105, 97, 110, 103, 108, 101, 768, 59, 66, 69, 2604, 2606, 2611, 32768, 8882, 97, 114, 59, 32768, 10703, 113, 117, 97, 108, 59, 32768, 8884, 112, 768, 68, 84, 86, 2626, 2638, 2649, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 32768, 10577, 101, 101, 86, 101, 99, 116, 111, 114, 59, 32768, 10592, 101, 99, 116, 111, 114, 512, 59, 66, 2659, 2661, 32768, 8639, 97, 114, 59, 32768, 10584, 101, 99, 116, 111, 114, 512, 59, 66, 2676, 2678, 32768, 8636, 97, 114, 59, 32768, 10578, 114, 114, 111, 119, 59, 32768, 8656, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8660, 115, 1536, 69, 70, 71, 76, 83, 84, 2716, 2730, 2741, 2750, 2756, 2768, 113, 117, 97, 108, 71, 114, 101, 97, 116, 101, 114, 59, 32768, 8922, 117, 108, 108, 69, 113, 117, 97, 108, 59, 32768, 8806, 114, 101, 97, 116, 101, 114, 59, 32768, 8822, 101, 115, 115, 59, 32768, 10913, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32768, 10877, 105, 108, 100, 101, 59, 32768, 8818, 114, 59, 32896, 55349, 56591, 512, 59, 101, 2785, 2787, 32768, 8920, 102, 116, 97, 114, 114, 111, 119, 59, 32768, 8666, 105, 100, 111, 116, 59, 32768, 319, 768, 110, 112, 119, 2811, 2899, 2904, 103, 1024, 76, 82, 108, 114, 2821, 2848, 2860, 2887, 101, 102, 116, 512, 65, 82, 2829, 2836, 114, 114, 111, 119, 59, 32768, 10229, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 10231, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 10230, 101, 102, 116, 512, 97, 114, 2868, 2875, 114, 114, 111, 119, 59, 32768, 10232, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 10234, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 10233, 102, 59, 32896, 55349, 56643, 101, 114, 512, 76, 82, 2911, 2922, 101, 102, 116, 65, 114, 114, 111, 119, 59, 32768, 8601, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 8600, 768, 99, 104, 116, 2941, 2945, 2948, 114, 59, 32768, 8466, 59, 32768, 8624, 114, 111, 107, 59, 32768, 321, 59, 32768, 8810, 2048, 97, 99, 101, 102, 105, 111, 115, 117, 2974, 2978, 2982, 3007, 3012, 3022, 3028, 3033, 112, 59, 32768, 10501, 121, 59, 32768, 1052, 512, 100, 108, 2987, 2998, 105, 117, 109, 83, 112, 97, 99, 101, 59, 32768, 8287, 108, 105, 110, 116, 114, 102, 59, 32768, 8499, 114, 59, 32896, 55349, 56592, 110, 117, 115, 80, 108, 117, 115, 59, 32768, 8723, 112, 102, 59, 32896, 55349, 56644, 99, 114, 59, 32768, 8499, 59, 32768, 924, 2304, 74, 97, 99, 101, 102, 111, 115, 116, 117, 3055, 3060, 3067, 3089, 3201, 3206, 3874, 3880, 3889, 99, 121, 59, 32768, 1034, 99, 117, 116, 101, 59, 32768, 323, 768, 97, 101, 121, 3074, 3080, 3086, 114, 111, 110, 59, 32768, 327, 100, 105, 108, 59, 32768, 325, 59, 32768, 1053, 768, 103, 115, 119, 3096, 3160, 3194, 97, 116, 105, 118, 101, 768, 77, 84, 86, 3108, 3121, 3145, 101, 100, 105, 117, 109, 83, 112, 97, 99, 101, 59, 32768, 8203, 104, 105, 512, 99, 110, 3128, 3137, 107, 83, 112, 97, 99, 101, 59, 32768, 8203, 83, 112, 97, 99, 101, 59, 32768, 8203, 101, 114, 121, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 32768, 8203, 116, 101, 100, 512, 71, 76, 3168, 3184, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 32768, 8811, 101, 115, 115, 76, 101, 115, 115, 59, 32768, 8810, 76, 105, 110, 101, 59, 32768, 10, 114, 59, 32896, 55349, 56593, 1024, 66, 110, 112, 116, 3215, 3222, 3238, 3242, 114, 101, 97, 107, 59, 32768, 8288, 66, 114, 101, 97, 107, 105, 110, 103, 83, 112, 97, 99, 101, 59, 32768, 160, 102, 59, 32768, 8469, 3328, 59, 67, 68, 69, 71, 72, 76, 78, 80, 82, 83, 84, 86, 3269, 3271, 3293, 3312, 3352, 3430, 3455, 3551, 3589, 3625, 3678, 3821, 3861, 32768, 10988, 512, 111, 117, 3276, 3286, 110, 103, 114, 117, 101, 110, 116, 59, 32768, 8802, 112, 67, 97, 112, 59, 32768, 8813, 111, 117, 98, 108, 101, 86, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 32768, 8742, 768, 108, 113, 120, 3319, 3327, 3345, 101, 109, 101, 110, 116, 59, 32768, 8713, 117, 97, 108, 512, 59, 84, 3335, 3337, 32768, 8800, 105, 108, 100, 101, 59, 32896, 8770, 824, 105, 115, 116, 115, 59, 32768, 8708, 114, 101, 97, 116, 101, 114, 1792, 59, 69, 70, 71, 76, 83, 84, 3373, 3375, 3382, 3394, 3404, 3410, 3423, 32768, 8815, 113, 117, 97, 108, 59, 32768, 8817, 117, 108, 108, 69, 113, 117, 97, 108, 59, 32896, 8807, 824, 114, 101, 97, 116, 101, 114, 59, 32896, 8811, 824, 101, 115, 115, 59, 32768, 8825, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32896, 10878, 824, 105, 108, 100, 101, 59, 32768, 8821, 117, 109, 112, 533, 3437, 3448, 111, 119, 110, 72, 117, 109, 112, 59, 32896, 8782, 824, 113, 117, 97, 108, 59, 32896, 8783, 824, 101, 512, 102, 115, 3461, 3492, 116, 84, 114, 105, 97, 110, 103, 108, 101, 768, 59, 66, 69, 3477, 3479, 3485, 32768, 8938, 97, 114, 59, 32896, 10703, 824, 113, 117, 97, 108, 59, 32768, 8940, 115, 1536, 59, 69, 71, 76, 83, 84, 3506, 3508, 3515, 3524, 3531, 3544, 32768, 8814, 113, 117, 97, 108, 59, 32768, 8816, 114, 101, 97, 116, 101, 114, 59, 32768, 8824, 101, 115, 115, 59, 32896, 8810, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32896, 10877, 824, 105, 108, 100, 101, 59, 32768, 8820, 101, 115, 116, 101, 100, 512, 71, 76, 3561, 3578, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 32896, 10914, 824, 101, 115, 115, 76, 101, 115, 115, 59, 32896, 10913, 824, 114, 101, 99, 101, 100, 101, 115, 768, 59, 69, 83, 3603, 3605, 3613, 32768, 8832, 113, 117, 97, 108, 59, 32896, 10927, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32768, 8928, 512, 101, 105, 3630, 3645, 118, 101, 114, 115, 101, 69, 108, 101, 109, 101, 110, 116, 59, 32768, 8716, 103, 104, 116, 84, 114, 105, 97, 110, 103, 108, 101, 768, 59, 66, 69, 3663, 3665, 3671, 32768, 8939, 97, 114, 59, 32896, 10704, 824, 113, 117, 97, 108, 59, 32768, 8941, 512, 113, 117, 3683, 3732, 117, 97, 114, 101, 83, 117, 512, 98, 112, 3694, 3712, 115, 101, 116, 512, 59, 69, 3702, 3705, 32896, 8847, 824, 113, 117, 97, 108, 59, 32768, 8930, 101, 114, 115, 101, 116, 512, 59, 69, 3722, 3725, 32896, 8848, 824, 113, 117, 97, 108, 59, 32768, 8931, 768, 98, 99, 112, 3739, 3757, 3801, 115, 101, 116, 512, 59, 69, 3747, 3750, 32896, 8834, 8402, 113, 117, 97, 108, 59, 32768, 8840, 99, 101, 101, 100, 115, 1024, 59, 69, 83, 84, 3771, 3773, 3781, 3793, 32768, 8833, 113, 117, 97, 108, 59, 32896, 10928, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32768, 8929, 105, 108, 100, 101, 59, 32896, 8831, 824, 101, 114, 115, 101, 116, 512, 59, 69, 3811, 3814, 32896, 8835, 8402, 113, 117, 97, 108, 59, 32768, 8841, 105, 108, 100, 101, 1024, 59, 69, 70, 84, 3834, 3836, 3843, 3854, 32768, 8769, 113, 117, 97, 108, 59, 32768, 8772, 117, 108, 108, 69, 113, 117, 97, 108, 59, 32768, 8775, 105, 108, 100, 101, 59, 32768, 8777, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 32768, 8740, 99, 114, 59, 32896, 55349, 56489, 105, 108, 100, 101, 33024, 209, 59, 32768, 209, 59, 32768, 925, 3584, 69, 97, 99, 100, 102, 103, 109, 111, 112, 114, 115, 116, 117, 118, 3921, 3927, 3936, 3951, 3958, 3963, 3972, 3996, 4002, 4034, 4037, 4055, 4071, 4078, 108, 105, 103, 59, 32768, 338, 99, 117, 116, 101, 33024, 211, 59, 32768, 211, 512, 105, 121, 3941, 3948, 114, 99, 33024, 212, 59, 32768, 212, 59, 32768, 1054, 98, 108, 97, 99, 59, 32768, 336, 114, 59, 32896, 55349, 56594, 114, 97, 118, 101, 33024, 210, 59, 32768, 210, 768, 97, 101, 105, 3979, 3984, 3989, 99, 114, 59, 32768, 332, 103, 97, 59, 32768, 937, 99, 114, 111, 110, 59, 32768, 927, 112, 102, 59, 32896, 55349, 56646, 101, 110, 67, 117, 114, 108, 121, 512, 68, 81, 4014, 4027, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 32768, 8220, 117, 111, 116, 101, 59, 32768, 8216, 59, 32768, 10836, 512, 99, 108, 4042, 4047, 114, 59, 32896, 55349, 56490, 97, 115, 104, 33024, 216, 59, 32768, 216, 105, 573, 4060, 4067, 100, 101, 33024, 213, 59, 32768, 213, 101, 115, 59, 32768, 10807, 109, 108, 33024, 214, 59, 32768, 214, 101, 114, 512, 66, 80, 4085, 4109, 512, 97, 114, 4090, 4094, 114, 59, 32768, 8254, 97, 99, 512, 101, 107, 4101, 4104, 59, 32768, 9182, 101, 116, 59, 32768, 9140, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 32768, 9180, 2304, 97, 99, 102, 104, 105, 108, 111, 114, 115, 4141, 4150, 4154, 4159, 4163, 4166, 4176, 4198, 4284, 114, 116, 105, 97, 108, 68, 59, 32768, 8706, 121, 59, 32768, 1055, 114, 59, 32896, 55349, 56595, 105, 59, 32768, 934, 59, 32768, 928, 117, 115, 77, 105, 110, 117, 115, 59, 32768, 177, 512, 105, 112, 4181, 4194, 110, 99, 97, 114, 101, 112, 108, 97, 110, 101, 59, 32768, 8460, 102, 59, 32768, 8473, 1024, 59, 101, 105, 111, 4207, 4209, 4251, 4256, 32768, 10939, 99, 101, 100, 101, 115, 1024, 59, 69, 83, 84, 4223, 4225, 4232, 4244, 32768, 8826, 113, 117, 97, 108, 59, 32768, 10927, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32768, 8828, 105, 108, 100, 101, 59, 32768, 8830, 109, 101, 59, 32768, 8243, 512, 100, 112, 4261, 4267, 117, 99, 116, 59, 32768, 8719, 111, 114, 116, 105, 111, 110, 512, 59, 97, 4278, 4280, 32768, 8759, 108, 59, 32768, 8733, 512, 99, 105, 4289, 4294, 114, 59, 32896, 55349, 56491, 59, 32768, 936, 1024, 85, 102, 111, 115, 4306, 4313, 4318, 4323, 79, 84, 33024, 34, 59, 32768, 34, 114, 59, 32896, 55349, 56596, 112, 102, 59, 32768, 8474, 99, 114, 59, 32896, 55349, 56492, 3072, 66, 69, 97, 99, 101, 102, 104, 105, 111, 114, 115, 117, 4354, 4360, 4366, 4395, 4417, 4473, 4477, 4481, 4743, 4764, 4776, 4788, 97, 114, 114, 59, 32768, 10512, 71, 33024, 174, 59, 32768, 174, 768, 99, 110, 114, 4373, 4379, 4383, 117, 116, 101, 59, 32768, 340, 103, 59, 32768, 10219, 114, 512, 59, 116, 4389, 4391, 32768, 8608, 108, 59, 32768, 10518, 768, 97, 101, 121, 4402, 4408, 4414, 114, 111, 110, 59, 32768, 344, 100, 105, 108, 59, 32768, 342, 59, 32768, 1056, 512, 59, 118, 4422, 4424, 32768, 8476, 101, 114, 115, 101, 512, 69, 85, 4433, 4458, 512, 108, 113, 4438, 4446, 101, 109, 101, 110, 116, 59, 32768, 8715, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 32768, 8651, 112, 69, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 32768, 10607, 114, 59, 32768, 8476, 111, 59, 32768, 929, 103, 104, 116, 2048, 65, 67, 68, 70, 84, 85, 86, 97, 4501, 4547, 4556, 4607, 4614, 4671, 4719, 4736, 512, 110, 114, 4506, 4519, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 32768, 10217, 114, 111, 119, 768, 59, 66, 76, 4529, 4531, 4536, 32768, 8594, 97, 114, 59, 32768, 8677, 101, 102, 116, 65, 114, 114, 111, 119, 59, 32768, 8644, 101, 105, 108, 105, 110, 103, 59, 32768, 8969, 111, 838, 4562, 0, 4575, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 32768, 10215, 110, 805, 4580, 0, 4591, 101, 101, 86, 101, 99, 116, 111, 114, 59, 32768, 10589, 101, 99, 116, 111, 114, 512, 59, 66, 4600, 4602, 32768, 8642, 97, 114, 59, 32768, 10581, 108, 111, 111, 114, 59, 32768, 8971, 512, 101, 114, 4619, 4644, 101, 768, 59, 65, 86, 4627, 4629, 4636, 32768, 8866, 114, 114, 111, 119, 59, 32768, 8614, 101, 99, 116, 111, 114, 59, 32768, 10587, 105, 97, 110, 103, 108, 101, 768, 59, 66, 69, 4657, 4659, 4664, 32768, 8883, 97, 114, 59, 32768, 10704, 113, 117, 97, 108, 59, 32768, 8885, 112, 768, 68, 84, 86, 4679, 4691, 4702, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 32768, 10575, 101, 101, 86, 101, 99, 116, 111, 114, 59, 32768, 10588, 101, 99, 116, 111, 114, 512, 59, 66, 4712, 4714, 32768, 8638, 97, 114, 59, 32768, 10580, 101, 99, 116, 111, 114, 512, 59, 66, 4729, 4731, 32768, 8640, 97, 114, 59, 32768, 10579, 114, 114, 111, 119, 59, 32768, 8658, 512, 112, 117, 4748, 4752, 102, 59, 32768, 8477, 110, 100, 73, 109, 112, 108, 105, 101, 115, 59, 32768, 10608, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8667, 512, 99, 104, 4781, 4785, 114, 59, 32768, 8475, 59, 32768, 8625, 108, 101, 68, 101, 108, 97, 121, 101, 100, 59, 32768, 10740, 3328, 72, 79, 97, 99, 102, 104, 105, 109, 111, 113, 115, 116, 117, 4827, 4842, 4849, 4856, 4889, 4894, 4949, 4955, 4967, 4973, 5059, 5065, 5070, 512, 67, 99, 4832, 4838, 72, 99, 121, 59, 32768, 1065, 121, 59, 32768, 1064, 70, 84, 99, 121, 59, 32768, 1068, 99, 117, 116, 101, 59, 32768, 346, 1280, 59, 97, 101, 105, 121, 4867, 4869, 4875, 4881, 4886, 32768, 10940, 114, 111, 110, 59, 32768, 352, 100, 105, 108, 59, 32768, 350, 114, 99, 59, 32768, 348, 59, 32768, 1057, 114, 59, 32896, 55349, 56598, 111, 114, 116, 1024, 68, 76, 82, 85, 4906, 4917, 4928, 4940, 111, 119, 110, 65, 114, 114, 111, 119, 59, 32768, 8595, 101, 102, 116, 65, 114, 114, 111, 119, 59, 32768, 8592, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 8594, 112, 65, 114, 114, 111, 119, 59, 32768, 8593, 103, 109, 97, 59, 32768, 931, 97, 108, 108, 67, 105, 114, 99, 108, 101, 59, 32768, 8728, 112, 102, 59, 32896, 55349, 56650, 1091, 4979, 0, 0, 4983, 116, 59, 32768, 8730, 97, 114, 101, 1024, 59, 73, 83, 85, 4994, 4996, 5010, 5052, 32768, 9633, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 59, 32768, 8851, 117, 512, 98, 112, 5016, 5033, 115, 101, 116, 512, 59, 69, 5024, 5026, 32768, 8847, 113, 117, 97, 108, 59, 32768, 8849, 101, 114, 115, 101, 116, 512, 59, 69, 5043, 5045, 32768, 8848, 113, 117, 97, 108, 59, 32768, 8850, 110, 105, 111, 110, 59, 32768, 8852, 99, 114, 59, 32896, 55349, 56494, 97, 114, 59, 32768, 8902, 1024, 98, 99, 109, 112, 5079, 5102, 5155, 5158, 512, 59, 115, 5084, 5086, 32768, 8912, 101, 116, 512, 59, 69, 5093, 5095, 32768, 8912, 113, 117, 97, 108, 59, 32768, 8838, 512, 99, 104, 5107, 5148, 101, 101, 100, 115, 1024, 59, 69, 83, 84, 5120, 5122, 5129, 5141, 32768, 8827, 113, 117, 97, 108, 59, 32768, 10928, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32768, 8829, 105, 108, 100, 101, 59, 32768, 8831, 84, 104, 97, 116, 59, 32768, 8715, 59, 32768, 8721, 768, 59, 101, 115, 5165, 5167, 5185, 32768, 8913, 114, 115, 101, 116, 512, 59, 69, 5176, 5178, 32768, 8835, 113, 117, 97, 108, 59, 32768, 8839, 101, 116, 59, 32768, 8913, 2816, 72, 82, 83, 97, 99, 102, 104, 105, 111, 114, 115, 5213, 5221, 5227, 5241, 5252, 5274, 5279, 5323, 5362, 5368, 5378, 79, 82, 78, 33024, 222, 59, 32768, 222, 65, 68, 69, 59, 32768, 8482, 512, 72, 99, 5232, 5237, 99, 121, 59, 32768, 1035, 121, 59, 32768, 1062, 512, 98, 117, 5246, 5249, 59, 32768, 9, 59, 32768, 932, 768, 97, 101, 121, 5259, 5265, 5271, 114, 111, 110, 59, 32768, 356, 100, 105, 108, 59, 32768, 354, 59, 32768, 1058, 114, 59, 32896, 55349, 56599, 512, 101, 105, 5284, 5300, 835, 5289, 0, 5297, 101, 102, 111, 114, 101, 59, 32768, 8756, 97, 59, 32768, 920, 512, 99, 110, 5305, 5315, 107, 83, 112, 97, 99, 101, 59, 32896, 8287, 8202, 83, 112, 97, 99, 101, 59, 32768, 8201, 108, 100, 101, 1024, 59, 69, 70, 84, 5335, 5337, 5344, 5355, 32768, 8764, 113, 117, 97, 108, 59, 32768, 8771, 117, 108, 108, 69, 113, 117, 97, 108, 59, 32768, 8773, 105, 108, 100, 101, 59, 32768, 8776, 112, 102, 59, 32896, 55349, 56651, 105, 112, 108, 101, 68, 111, 116, 59, 32768, 8411, 512, 99, 116, 5383, 5388, 114, 59, 32896, 55349, 56495, 114, 111, 107, 59, 32768, 358, 5426, 5417, 5444, 5458, 5473, 0, 5480, 5485, 0, 0, 0, 0, 0, 5494, 5500, 5564, 5579, 0, 5726, 5732, 5738, 5745, 512, 99, 114, 5421, 5429, 117, 116, 101, 33024, 218, 59, 32768, 218, 114, 512, 59, 111, 5435, 5437, 32768, 8607, 99, 105, 114, 59, 32768, 10569, 114, 820, 5449, 0, 5453, 121, 59, 32768, 1038, 118, 101, 59, 32768, 364, 512, 105, 121, 5462, 5469, 114, 99, 33024, 219, 59, 32768, 219, 59, 32768, 1059, 98, 108, 97, 99, 59, 32768, 368, 114, 59, 32896, 55349, 56600, 114, 97, 118, 101, 33024, 217, 59, 32768, 217, 97, 99, 114, 59, 32768, 362, 512, 100, 105, 5504, 5548, 101, 114, 512, 66, 80, 5511, 5535, 512, 97, 114, 5516, 5520, 114, 59, 32768, 95, 97, 99, 512, 101, 107, 5527, 5530, 59, 32768, 9183, 101, 116, 59, 32768, 9141, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 32768, 9181, 111, 110, 512, 59, 80, 5555, 5557, 32768, 8899, 108, 117, 115, 59, 32768, 8846, 512, 103, 112, 5568, 5573, 111, 110, 59, 32768, 370, 102, 59, 32896, 55349, 56652, 2048, 65, 68, 69, 84, 97, 100, 112, 115, 5595, 5624, 5635, 5648, 5664, 5671, 5682, 5712, 114, 114, 111, 119, 768, 59, 66, 68, 5606, 5608, 5613, 32768, 8593, 97, 114, 59, 32768, 10514, 111, 119, 110, 65, 114, 114, 111, 119, 59, 32768, 8645, 111, 119, 110, 65, 114, 114, 111, 119, 59, 32768, 8597, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 32768, 10606, 101, 101, 512, 59, 65, 5655, 5657, 32768, 8869, 114, 114, 111, 119, 59, 32768, 8613, 114, 114, 111, 119, 59, 32768, 8657, 111, 119, 110, 97, 114, 114, 111, 119, 59, 32768, 8661, 101, 114, 512, 76, 82, 5689, 5700, 101, 102, 116, 65, 114, 114, 111, 119, 59, 32768, 8598, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 8599, 105, 512, 59, 108, 5718, 5720, 32768, 978, 111, 110, 59, 32768, 933, 105, 110, 103, 59, 32768, 366, 99, 114, 59, 32896, 55349, 56496, 105, 108, 100, 101, 59, 32768, 360, 109, 108, 33024, 220, 59, 32768, 220, 2304, 68, 98, 99, 100, 101, 102, 111, 115, 118, 5770, 5776, 5781, 5785, 5798, 5878, 5883, 5889, 5895, 97, 115, 104, 59, 32768, 8875, 97, 114, 59, 32768, 10987, 121, 59, 32768, 1042, 97, 115, 104, 512, 59, 108, 5793, 5795, 32768, 8873, 59, 32768, 10982, 512, 101, 114, 5803, 5806, 59, 32768, 8897, 768, 98, 116, 121, 5813, 5818, 5866, 97, 114, 59, 32768, 8214, 512, 59, 105, 5823, 5825, 32768, 8214, 99, 97, 108, 1024, 66, 76, 83, 84, 5837, 5842, 5848, 5859, 97, 114, 59, 32768, 8739, 105, 110, 101, 59, 32768, 124, 101, 112, 97, 114, 97, 116, 111, 114, 59, 32768, 10072, 105, 108, 100, 101, 59, 32768, 8768, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 32768, 8202, 114, 59, 32896, 55349, 56601, 112, 102, 59, 32896, 55349, 56653, 99, 114, 59, 32896, 55349, 56497, 100, 97, 115, 104, 59, 32768, 8874, 1280, 99, 101, 102, 111, 115, 5913, 5919, 5925, 5930, 5936, 105, 114, 99, 59, 32768, 372, 100, 103, 101, 59, 32768, 8896, 114, 59, 32896, 55349, 56602, 112, 102, 59, 32896, 55349, 56654, 99, 114, 59, 32896, 55349, 56498, 1024, 102, 105, 111, 115, 5951, 5956, 5959, 5965, 114, 59, 32896, 55349, 56603, 59, 32768, 926, 112, 102, 59, 32896, 55349, 56655, 99, 114, 59, 32896, 55349, 56499, 2304, 65, 73, 85, 97, 99, 102, 111, 115, 117, 5990, 5995, 6000, 6005, 6014, 6027, 6032, 6038, 6044, 99, 121, 59, 32768, 1071, 99, 121, 59, 32768, 1031, 99, 121, 59, 32768, 1070, 99, 117, 116, 101, 33024, 221, 59, 32768, 221, 512, 105, 121, 6019, 6024, 114, 99, 59, 32768, 374, 59, 32768, 1067, 114, 59, 32896, 55349, 56604, 112, 102, 59, 32896, 55349, 56656, 99, 114, 59, 32896, 55349, 56500, 109, 108, 59, 32768, 376, 2048, 72, 97, 99, 100, 101, 102, 111, 115, 6066, 6071, 6078, 6092, 6097, 6119, 6123, 6128, 99, 121, 59, 32768, 1046, 99, 117, 116, 101, 59, 32768, 377, 512, 97, 121, 6083, 6089, 114, 111, 110, 59, 32768, 381, 59, 32768, 1047, 111, 116, 59, 32768, 379, 835, 6102, 0, 6116, 111, 87, 105, 100, 116, 104, 83, 112, 97, 99, 101, 59, 32768, 8203, 97, 59, 32768, 918, 114, 59, 32768, 8488, 112, 102, 59, 32768, 8484, 99, 114, 59, 32896, 55349, 56501, 5938, 6159, 6168, 6175, 0, 6214, 6222, 6233, 0, 0, 0, 0, 6242, 6267, 6290, 6429, 6444, 0, 6495, 6503, 6531, 6540, 0, 6547, 99, 117, 116, 101, 33024, 225, 59, 32768, 225, 114, 101, 118, 101, 59, 32768, 259, 1536, 59, 69, 100, 105, 117, 121, 6187, 6189, 6193, 6196, 6203, 6210, 32768, 8766, 59, 32896, 8766, 819, 59, 32768, 8767, 114, 99, 33024, 226, 59, 32768, 226, 116, 101, 33024, 180, 59, 32768, 180, 59, 32768, 1072, 108, 105, 103, 33024, 230, 59, 32768, 230, 512, 59, 114, 6226, 6228, 32768, 8289, 59, 32896, 55349, 56606, 114, 97, 118, 101, 33024, 224, 59, 32768, 224, 512, 101, 112, 6246, 6261, 512, 102, 112, 6251, 6257, 115, 121, 109, 59, 32768, 8501, 104, 59, 32768, 8501, 104, 97, 59, 32768, 945, 512, 97, 112, 6271, 6284, 512, 99, 108, 6276, 6280, 114, 59, 32768, 257, 103, 59, 32768, 10815, 33024, 38, 59, 32768, 38, 1077, 6295, 0, 0, 6326, 1280, 59, 97, 100, 115, 118, 6305, 6307, 6312, 6315, 6322, 32768, 8743, 110, 100, 59, 32768, 10837, 59, 32768, 10844, 108, 111, 112, 101, 59, 32768, 10840, 59, 32768, 10842, 1792, 59, 101, 108, 109, 114, 115, 122, 6340, 6342, 6345, 6349, 6391, 6410, 6422, 32768, 8736, 59, 32768, 10660, 101, 59, 32768, 8736, 115, 100, 512, 59, 97, 6356, 6358, 32768, 8737, 2098, 6368, 6371, 6374, 6377, 6380, 6383, 6386, 6389, 59, 32768, 10664, 59, 32768, 10665, 59, 32768, 10666, 59, 32768, 10667, 59, 32768, 10668, 59, 32768, 10669, 59, 32768, 10670, 59, 32768, 10671, 116, 512, 59, 118, 6397, 6399, 32768, 8735, 98, 512, 59, 100, 6405, 6407, 32768, 8894, 59, 32768, 10653, 512, 112, 116, 6415, 6419, 104, 59, 32768, 8738, 59, 32768, 197, 97, 114, 114, 59, 32768, 9084, 512, 103, 112, 6433, 6438, 111, 110, 59, 32768, 261, 102, 59, 32896, 55349, 56658, 1792, 59, 69, 97, 101, 105, 111, 112, 6458, 6460, 6463, 6469, 6472, 6476, 6480, 32768, 8776, 59, 32768, 10864, 99, 105, 114, 59, 32768, 10863, 59, 32768, 8778, 100, 59, 32768, 8779, 115, 59, 32768, 39, 114, 111, 120, 512, 59, 101, 6488, 6490, 32768, 8776, 113, 59, 32768, 8778, 105, 110, 103, 33024, 229, 59, 32768, 229, 768, 99, 116, 121, 6509, 6514, 6517, 114, 59, 32896, 55349, 56502, 59, 32768, 42, 109, 112, 512, 59, 101, 6524, 6526, 32768, 8776, 113, 59, 32768, 8781, 105, 108, 100, 101, 33024, 227, 59, 32768, 227, 109, 108, 33024, 228, 59, 32768, 228, 512, 99, 105, 6551, 6559, 111, 110, 105, 110, 116, 59, 32768, 8755, 110, 116, 59, 32768, 10769, 4096, 78, 97, 98, 99, 100, 101, 102, 105, 107, 108, 110, 111, 112, 114, 115, 117, 6597, 6602, 6673, 6688, 6701, 6707, 6768, 6773, 6891, 6898, 6999, 7023, 7309, 7316, 7334, 7383, 111, 116, 59, 32768, 10989, 512, 99, 114, 6607, 6652, 107, 1024, 99, 101, 112, 115, 6617, 6623, 6632, 6639, 111, 110, 103, 59, 32768, 8780, 112, 115, 105, 108, 111, 110, 59, 32768, 1014, 114, 105, 109, 101, 59, 32768, 8245, 105, 109, 512, 59, 101, 6646, 6648, 32768, 8765, 113, 59, 32768, 8909, 583, 6656, 6661, 101, 101, 59, 32768, 8893, 101, 100, 512, 59, 103, 6667, 6669, 32768, 8965, 101, 59, 32768, 8965, 114, 107, 512, 59, 116, 6680, 6682, 32768, 9141, 98, 114, 107, 59, 32768, 9142, 512, 111, 121, 6693, 6698, 110, 103, 59, 32768, 8780, 59, 32768, 1073, 113, 117, 111, 59, 32768, 8222, 1280, 99, 109, 112, 114, 116, 6718, 6731, 6738, 6743, 6749, 97, 117, 115, 512, 59, 101, 6726, 6728, 32768, 8757, 59, 32768, 8757, 112, 116, 121, 118, 59, 32768, 10672, 115, 105, 59, 32768, 1014, 110, 111, 117, 59, 32768, 8492, 768, 97, 104, 119, 6756, 6759, 6762, 59, 32768, 946, 59, 32768, 8502, 101, 101, 110, 59, 32768, 8812, 114, 59, 32896, 55349, 56607, 103, 1792, 99, 111, 115, 116, 117, 118, 119, 6789, 6809, 6834, 6850, 6872, 6879, 6884, 768, 97, 105, 117, 6796, 6800, 6805, 112, 59, 32768, 8898, 114, 99, 59, 32768, 9711, 112, 59, 32768, 8899, 768, 100, 112, 116, 6816, 6821, 6827, 111, 116, 59, 32768, 10752, 108, 117, 115, 59, 32768, 10753, 105, 109, 101, 115, 59, 32768, 10754, 1090, 6840, 0, 0, 6846, 99, 117, 112, 59, 32768, 10758, 97, 114, 59, 32768, 9733, 114, 105, 97, 110, 103, 108, 101, 512, 100, 117, 6862, 6868, 111, 119, 110, 59, 32768, 9661, 112, 59, 32768, 9651, 112, 108, 117, 115, 59, 32768, 10756, 101, 101, 59, 32768, 8897, 101, 100, 103, 101, 59, 32768, 8896, 97, 114, 111, 119, 59, 32768, 10509, 768, 97, 107, 111, 6905, 6976, 6994, 512, 99, 110, 6910, 6972, 107, 768, 108, 115, 116, 6918, 6927, 6935, 111, 122, 101, 110, 103, 101, 59, 32768, 10731, 113, 117, 97, 114, 101, 59, 32768, 9642, 114, 105, 97, 110, 103, 108, 101, 1024, 59, 100, 108, 114, 6951, 6953, 6959, 6965, 32768, 9652, 111, 119, 110, 59, 32768, 9662, 101, 102, 116, 59, 32768, 9666, 105, 103, 104, 116, 59, 32768, 9656, 107, 59, 32768, 9251, 770, 6981, 0, 6991, 771, 6985, 0, 6988, 59, 32768, 9618, 59, 32768, 9617, 52, 59, 32768, 9619, 99, 107, 59, 32768, 9608, 512, 101, 111, 7004, 7019, 512, 59, 113, 7009, 7012, 32896, 61, 8421, 117, 105, 118, 59, 32896, 8801, 8421, 116, 59, 32768, 8976, 1024, 112, 116, 119, 120, 7032, 7037, 7049, 7055, 102, 59, 32896, 55349, 56659, 512, 59, 116, 7042, 7044, 32768, 8869, 111, 109, 59, 32768, 8869, 116, 105, 101, 59, 32768, 8904, 3072, 68, 72, 85, 86, 98, 100, 104, 109, 112, 116, 117, 118, 7080, 7101, 7126, 7147, 7182, 7187, 7208, 7233, 7240, 7246, 7253, 7274, 1024, 76, 82, 108, 114, 7089, 7092, 7095, 7098, 59, 32768, 9559, 59, 32768, 9556, 59, 32768, 9558, 59, 32768, 9555, 1280, 59, 68, 85, 100, 117, 7112, 7114, 7117, 7120, 7123, 32768, 9552, 59, 32768, 9574, 59, 32768, 9577, 59, 32768, 9572, 59, 32768, 9575, 1024, 76, 82, 108, 114, 7135, 7138, 7141, 7144, 59, 32768, 9565, 59, 32768, 9562, 59, 32768, 9564, 59, 32768, 9561, 1792, 59, 72, 76, 82, 104, 108, 114, 7162, 7164, 7167, 7170, 7173, 7176, 7179, 32768, 9553, 59, 32768, 9580, 59, 32768, 9571, 59, 32768, 9568, 59, 32768, 9579, 59, 32768, 9570, 59, 32768, 9567, 111, 120, 59, 32768, 10697, 1024, 76, 82, 108, 114, 7196, 7199, 7202, 7205, 59, 32768, 9557, 59, 32768, 9554, 59, 32768, 9488, 59, 32768, 9484, 1280, 59, 68, 85, 100, 117, 7219, 7221, 7224, 7227, 7230, 32768, 9472, 59, 32768, 9573, 59, 32768, 9576, 59, 32768, 9516, 59, 32768, 9524, 105, 110, 117, 115, 59, 32768, 8863, 108, 117, 115, 59, 32768, 8862, 105, 109, 101, 115, 59, 32768, 8864, 1024, 76, 82, 108, 114, 7262, 7265, 7268, 7271, 59, 32768, 9563, 59, 32768, 9560, 59, 32768, 9496, 59, 32768, 9492, 1792, 59, 72, 76, 82, 104, 108, 114, 7289, 7291, 7294, 7297, 7300, 7303, 7306, 32768, 9474, 59, 32768, 9578, 59, 32768, 9569, 59, 32768, 9566, 59, 32768, 9532, 59, 32768, 9508, 59, 32768, 9500, 114, 105, 109, 101, 59, 32768, 8245, 512, 101, 118, 7321, 7326, 118, 101, 59, 32768, 728, 98, 97, 114, 33024, 166, 59, 32768, 166, 1024, 99, 101, 105, 111, 7343, 7348, 7353, 7364, 114, 59, 32896, 55349, 56503, 109, 105, 59, 32768, 8271, 109, 512, 59, 101, 7359, 7361, 32768, 8765, 59, 32768, 8909, 108, 768, 59, 98, 104, 7372, 7374, 7377, 32768, 92, 59, 32768, 10693, 115, 117, 98, 59, 32768, 10184, 573, 7387, 7399, 108, 512, 59, 101, 7392, 7394, 32768, 8226, 116, 59, 32768, 8226, 112, 768, 59, 69, 101, 7406, 7408, 7411, 32768, 8782, 59, 32768, 10926, 512, 59, 113, 7416, 7418, 32768, 8783, 59, 32768, 8783, 6450, 7448, 0, 7523, 7571, 7576, 7613, 0, 7618, 7647, 0, 0, 7764, 0, 0, 7779, 0, 0, 7899, 7914, 7949, 7955, 0, 8158, 0, 8176, 768, 99, 112, 114, 7454, 7460, 7509, 117, 116, 101, 59, 32768, 263, 1536, 59, 97, 98, 99, 100, 115, 7473, 7475, 7480, 7487, 7500, 7505, 32768, 8745, 110, 100, 59, 32768, 10820, 114, 99, 117, 112, 59, 32768, 10825, 512, 97, 117, 7492, 7496, 112, 59, 32768, 10827, 112, 59, 32768, 10823, 111, 116, 59, 32768, 10816, 59, 32896, 8745, 65024, 512, 101, 111, 7514, 7518, 116, 59, 32768, 8257, 110, 59, 32768, 711, 1024, 97, 101, 105, 117, 7531, 7544, 7552, 7557, 833, 7536, 0, 7540, 115, 59, 32768, 10829, 111, 110, 59, 32768, 269, 100, 105, 108, 33024, 231, 59, 32768, 231, 114, 99, 59, 32768, 265, 112, 115, 512, 59, 115, 7564, 7566, 32768, 10828, 109, 59, 32768, 10832, 111, 116, 59, 32768, 267, 768, 100, 109, 110, 7582, 7589, 7596, 105, 108, 33024, 184, 59, 32768, 184, 112, 116, 121, 118, 59, 32768, 10674, 116, 33280, 162, 59, 101, 7603, 7605, 32768, 162, 114, 100, 111, 116, 59, 32768, 183, 114, 59, 32896, 55349, 56608, 768, 99, 101, 105, 7624, 7628, 7643, 121, 59, 32768, 1095, 99, 107, 512, 59, 109, 7635, 7637, 32768, 10003, 97, 114, 107, 59, 32768, 10003, 59, 32768, 967, 114, 1792, 59, 69, 99, 101, 102, 109, 115, 7662, 7664, 7667, 7742, 7745, 7752, 7757, 32768, 9675, 59, 32768, 10691, 768, 59, 101, 108, 7674, 7676, 7680, 32768, 710, 113, 59, 32768, 8791, 101, 1074, 7687, 0, 0, 7709, 114, 114, 111, 119, 512, 108, 114, 7695, 7701, 101, 102, 116, 59, 32768, 8634, 105, 103, 104, 116, 59, 32768, 8635, 1280, 82, 83, 97, 99, 100, 7719, 7722, 7725, 7730, 7736, 59, 32768, 174, 59, 32768, 9416, 115, 116, 59, 32768, 8859, 105, 114, 99, 59, 32768, 8858, 97, 115, 104, 59, 32768, 8861, 59, 32768, 8791, 110, 105, 110, 116, 59, 32768, 10768, 105, 100, 59, 32768, 10991, 99, 105, 114, 59, 32768, 10690, 117, 98, 115, 512, 59, 117, 7771, 7773, 32768, 9827, 105, 116, 59, 32768, 9827, 1341, 7785, 7804, 7850, 0, 7871, 111, 110, 512, 59, 101, 7791, 7793, 32768, 58, 512, 59, 113, 7798, 7800, 32768, 8788, 59, 32768, 8788, 1086, 7809, 0, 0, 7820, 97, 512, 59, 116, 7814, 7816, 32768, 44, 59, 32768, 64, 768, 59, 102, 108, 7826, 7828, 7832, 32768, 8705, 110, 59, 32768, 8728, 101, 512, 109, 120, 7838, 7844, 101, 110, 116, 59, 32768, 8705, 101, 115, 59, 32768, 8450, 824, 7854, 0, 7866, 512, 59, 100, 7858, 7860, 32768, 8773, 111, 116, 59, 32768, 10861, 110, 116, 59, 32768, 8750, 768, 102, 114, 121, 7877, 7881, 7886, 59, 32896, 55349, 56660, 111, 100, 59, 32768, 8720, 33280, 169, 59, 115, 7892, 7894, 32768, 169, 114, 59, 32768, 8471, 512, 97, 111, 7903, 7908, 114, 114, 59, 32768, 8629, 115, 115, 59, 32768, 10007, 512, 99, 117, 7918, 7923, 114, 59, 32896, 55349, 56504, 512, 98, 112, 7928, 7938, 512, 59, 101, 7933, 7935, 32768, 10959, 59, 32768, 10961, 512, 59, 101, 7943, 7945, 32768, 10960, 59, 32768, 10962, 100, 111, 116, 59, 32768, 8943, 1792, 100, 101, 108, 112, 114, 118, 119, 7969, 7983, 7996, 8009, 8057, 8147, 8152, 97, 114, 114, 512, 108, 114, 7977, 7980, 59, 32768, 10552, 59, 32768, 10549, 1089, 7989, 0, 0, 7993, 114, 59, 32768, 8926, 99, 59, 32768, 8927, 97, 114, 114, 512, 59, 112, 8004, 8006, 32768, 8630, 59, 32768, 10557, 1536, 59, 98, 99, 100, 111, 115, 8022, 8024, 8031, 8044, 8049, 8053, 32768, 8746, 114, 99, 97, 112, 59, 32768, 10824, 512, 97, 117, 8036, 8040, 112, 59, 32768, 10822, 112, 59, 32768, 10826, 111, 116, 59, 32768, 8845, 114, 59, 32768, 10821, 59, 32896, 8746, 65024, 1024, 97, 108, 114, 118, 8066, 8078, 8116, 8123, 114, 114, 512, 59, 109, 8073, 8075, 32768, 8631, 59, 32768, 10556, 121, 768, 101, 118, 119, 8086, 8104, 8109, 113, 1089, 8093, 0, 0, 8099, 114, 101, 99, 59, 32768, 8926, 117, 99, 99, 59, 32768, 8927, 101, 101, 59, 32768, 8910, 101, 100, 103, 101, 59, 32768, 8911, 101, 110, 33024, 164, 59, 32768, 164, 101, 97, 114, 114, 111, 119, 512, 108, 114, 8134, 8140, 101, 102, 116, 59, 32768, 8630, 105, 103, 104, 116, 59, 32768, 8631, 101, 101, 59, 32768, 8910, 101, 100, 59, 32768, 8911, 512, 99, 105, 8162, 8170, 111, 110, 105, 110, 116, 59, 32768, 8754, 110, 116, 59, 32768, 8753, 108, 99, 116, 121, 59, 32768, 9005, 4864, 65, 72, 97, 98, 99, 100, 101, 102, 104, 105, 106, 108, 111, 114, 115, 116, 117, 119, 122, 8221, 8226, 8231, 8267, 8282, 8296, 8327, 8351, 8366, 8379, 8466, 8471, 8487, 8621, 8647, 8676, 8697, 8712, 8720, 114, 114, 59, 32768, 8659, 97, 114, 59, 32768, 10597, 1024, 103, 108, 114, 115, 8240, 8246, 8252, 8256, 103, 101, 114, 59, 32768, 8224, 101, 116, 104, 59, 32768, 8504, 114, 59, 32768, 8595, 104, 512, 59, 118, 8262, 8264, 32768, 8208, 59, 32768, 8867, 572, 8271, 8278, 97, 114, 111, 119, 59, 32768, 10511, 97, 99, 59, 32768, 733, 512, 97, 121, 8287, 8293, 114, 111, 110, 59, 32768, 271, 59, 32768, 1076, 768, 59, 97, 111, 8303, 8305, 8320, 32768, 8518, 512, 103, 114, 8310, 8316, 103, 101, 114, 59, 32768, 8225, 114, 59, 32768, 8650, 116, 115, 101, 113, 59, 32768, 10871, 768, 103, 108, 109, 8334, 8339, 8344, 33024, 176, 59, 32768, 176, 116, 97, 59, 32768, 948, 112, 116, 121, 118, 59, 32768, 10673, 512, 105, 114, 8356, 8362, 115, 104, 116, 59, 32768, 10623, 59, 32896, 55349, 56609, 97, 114, 512, 108, 114, 8373, 8376, 59, 32768, 8643, 59, 32768, 8642, 1280, 97, 101, 103, 115, 118, 8390, 8418, 8421, 8428, 8433, 109, 768, 59, 111, 115, 8398, 8400, 8415, 32768, 8900, 110, 100, 512, 59, 115, 8407, 8409, 32768, 8900, 117, 105, 116, 59, 32768, 9830, 59, 32768, 9830, 59, 32768, 168, 97, 109, 109, 97, 59, 32768, 989, 105, 110, 59, 32768, 8946, 768, 59, 105, 111, 8440, 8442, 8461, 32768, 247, 100, 101, 33280, 247, 59, 111, 8450, 8452, 32768, 247, 110, 116, 105, 109, 101, 115, 59, 32768, 8903, 110, 120, 59, 32768, 8903, 99, 121, 59, 32768, 1106, 99, 1088, 8478, 0, 0, 8483, 114, 110, 59, 32768, 8990, 111, 112, 59, 32768, 8973, 1280, 108, 112, 116, 117, 119, 8498, 8504, 8509, 8556, 8570, 108, 97, 114, 59, 32768, 36, 102, 59, 32896, 55349, 56661, 1280, 59, 101, 109, 112, 115, 8520, 8522, 8535, 8542, 8548, 32768, 729, 113, 512, 59, 100, 8528, 8530, 32768, 8784, 111, 116, 59, 32768, 8785, 105, 110, 117, 115, 59, 32768, 8760, 108, 117, 115, 59, 32768, 8724, 113, 117, 97, 114, 101, 59, 32768, 8865, 98, 108, 101, 98, 97, 114, 119, 101, 100, 103, 101, 59, 32768, 8966, 110, 768, 97, 100, 104, 8578, 8585, 8597, 114, 114, 111, 119, 59, 32768, 8595, 111, 119, 110, 97, 114, 114, 111, 119, 115, 59, 32768, 8650, 97, 114, 112, 111, 111, 110, 512, 108, 114, 8608, 8614, 101, 102, 116, 59, 32768, 8643, 105, 103, 104, 116, 59, 32768, 8642, 563, 8625, 8633, 107, 97, 114, 111, 119, 59, 32768, 10512, 1088, 8638, 0, 0, 8643, 114, 110, 59, 32768, 8991, 111, 112, 59, 32768, 8972, 768, 99, 111, 116, 8654, 8666, 8670, 512, 114, 121, 8659, 8663, 59, 32896, 55349, 56505, 59, 32768, 1109, 108, 59, 32768, 10742, 114, 111, 107, 59, 32768, 273, 512, 100, 114, 8681, 8686, 111, 116, 59, 32768, 8945, 105, 512, 59, 102, 8692, 8694, 32768, 9663, 59, 32768, 9662, 512, 97, 104, 8702, 8707, 114, 114, 59, 32768, 8693, 97, 114, 59, 32768, 10607, 97, 110, 103, 108, 101, 59, 32768, 10662, 512, 99, 105, 8725, 8729, 121, 59, 32768, 1119, 103, 114, 97, 114, 114, 59, 32768, 10239, 4608, 68, 97, 99, 100, 101, 102, 103, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 120, 8774, 8788, 8807, 8844, 8849, 8852, 8866, 8895, 8929, 8977, 8989, 9004, 9046, 9136, 9151, 9171, 9184, 9199, 512, 68, 111, 8779, 8784, 111, 116, 59, 32768, 10871, 116, 59, 32768, 8785, 512, 99, 115, 8793, 8801, 117, 116, 101, 33024, 233, 59, 32768, 233, 116, 101, 114, 59, 32768, 10862, 1024, 97, 105, 111, 121, 8816, 8822, 8835, 8841, 114, 111, 110, 59, 32768, 283, 114, 512, 59, 99, 8828, 8830, 32768, 8790, 33024, 234, 59, 32768, 234, 108, 111, 110, 59, 32768, 8789, 59, 32768, 1101, 111, 116, 59, 32768, 279, 59, 32768, 8519, 512, 68, 114, 8857, 8862, 111, 116, 59, 32768, 8786, 59, 32896, 55349, 56610, 768, 59, 114, 115, 8873, 8875, 8883, 32768, 10906, 97, 118, 101, 33024, 232, 59, 32768, 232, 512, 59, 100, 8888, 8890, 32768, 10902, 111, 116, 59, 32768, 10904, 1024, 59, 105, 108, 115, 8904, 8906, 8914, 8917, 32768, 10905, 110, 116, 101, 114, 115, 59, 32768, 9191, 59, 32768, 8467, 512, 59, 100, 8922, 8924, 32768, 10901, 111, 116, 59, 32768, 10903, 768, 97, 112, 115, 8936, 8941, 8960, 99, 114, 59, 32768, 275, 116, 121, 768, 59, 115, 118, 8950, 8952, 8957, 32768, 8709, 101, 116, 59, 32768, 8709, 59, 32768, 8709, 112, 512, 49, 59, 8966, 8975, 516, 8970, 8973, 59, 32768, 8196, 59, 32768, 8197, 32768, 8195, 512, 103, 115, 8982, 8985, 59, 32768, 331, 112, 59, 32768, 8194, 512, 103, 112, 8994, 8999, 111, 110, 59, 32768, 281, 102, 59, 32896, 55349, 56662, 768, 97, 108, 115, 9011, 9023, 9028, 114, 512, 59, 115, 9017, 9019, 32768, 8917, 108, 59, 32768, 10723, 117, 115, 59, 32768, 10865, 105, 768, 59, 108, 118, 9036, 9038, 9043, 32768, 949, 111, 110, 59, 32768, 949, 59, 32768, 1013, 1024, 99, 115, 117, 118, 9055, 9071, 9099, 9128, 512, 105, 111, 9060, 9065, 114, 99, 59, 32768, 8790, 108, 111, 110, 59, 32768, 8789, 1082, 9077, 0, 0, 9081, 109, 59, 32768, 8770, 97, 110, 116, 512, 103, 108, 9088, 9093, 116, 114, 59, 32768, 10902, 101, 115, 115, 59, 32768, 10901, 768, 97, 101, 105, 9106, 9111, 9116, 108, 115, 59, 32768, 61, 115, 116, 59, 32768, 8799, 118, 512, 59, 68, 9122, 9124, 32768, 8801, 68, 59, 32768, 10872, 112, 97, 114, 115, 108, 59, 32768, 10725, 512, 68, 97, 9141, 9146, 111, 116, 59, 32768, 8787, 114, 114, 59, 32768, 10609, 768, 99, 100, 105, 9158, 9162, 9167, 114, 59, 32768, 8495, 111, 116, 59, 32768, 8784, 109, 59, 32768, 8770, 512, 97, 104, 9176, 9179, 59, 32768, 951, 33024, 240, 59, 32768, 240, 512, 109, 114, 9189, 9195, 108, 33024, 235, 59, 32768, 235, 111, 59, 32768, 8364, 768, 99, 105, 112, 9206, 9210, 9215, 108, 59, 32768, 33, 115, 116, 59, 32768, 8707, 512, 101, 111, 9220, 9230, 99, 116, 97, 116, 105, 111, 110, 59, 32768, 8496, 110, 101, 110, 116, 105, 97, 108, 101, 59, 32768, 8519, 4914, 9262, 0, 9276, 0, 9280, 9287, 0, 0, 9318, 9324, 0, 9331, 0, 9352, 9357, 9386, 0, 9395, 9497, 108, 108, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 32768, 8786, 121, 59, 32768, 1092, 109, 97, 108, 101, 59, 32768, 9792, 768, 105, 108, 114, 9293, 9299, 9313, 108, 105, 103, 59, 32768, 64259, 1082, 9305, 0, 0, 9309, 103, 59, 32768, 64256, 105, 103, 59, 32768, 64260, 59, 32896, 55349, 56611, 108, 105, 103, 59, 32768, 64257, 108, 105, 103, 59, 32896, 102, 106, 768, 97, 108, 116, 9337, 9341, 9346, 116, 59, 32768, 9837, 105, 103, 59, 32768, 64258, 110, 115, 59, 32768, 9649, 111, 102, 59, 32768, 402, 833, 9361, 0, 9366, 102, 59, 32896, 55349, 56663, 512, 97, 107, 9370, 9375, 108, 108, 59, 32768, 8704, 512, 59, 118, 9380, 9382, 32768, 8916, 59, 32768, 10969, 97, 114, 116, 105, 110, 116, 59, 32768, 10765, 512, 97, 111, 9399, 9491, 512, 99, 115, 9404, 9487, 1794, 9413, 9443, 9453, 9470, 9474, 0, 9484, 1795, 9421, 9426, 9429, 9434, 9437, 0, 9440, 33024, 189, 59, 32768, 189, 59, 32768, 8531, 33024, 188, 59, 32768, 188, 59, 32768, 8533, 59, 32768, 8537, 59, 32768, 8539, 772, 9447, 0, 9450, 59, 32768, 8532, 59, 32768, 8534, 1285, 9459, 9464, 0, 0, 9467, 33024, 190, 59, 32768, 190, 59, 32768, 8535, 59, 32768, 8540, 53, 59, 32768, 8536, 775, 9478, 0, 9481, 59, 32768, 8538, 59, 32768, 8541, 56, 59, 32768, 8542, 108, 59, 32768, 8260, 119, 110, 59, 32768, 8994, 99, 114, 59, 32896, 55349, 56507, 4352, 69, 97, 98, 99, 100, 101, 102, 103, 105, 106, 108, 110, 111, 114, 115, 116, 118, 9537, 9547, 9575, 9582, 9595, 9600, 9679, 9684, 9694, 9700, 9705, 9725, 9773, 9779, 9785, 9810, 9917, 512, 59, 108, 9542, 9544, 32768, 8807, 59, 32768, 10892, 768, 99, 109, 112, 9554, 9560, 9572, 117, 116, 101, 59, 32768, 501, 109, 97, 512, 59, 100, 9567, 9569, 32768, 947, 59, 32768, 989, 59, 32768, 10886, 114, 101, 118, 101, 59, 32768, 287, 512, 105, 121, 9587, 9592, 114, 99, 59, 32768, 285, 59, 32768, 1075, 111, 116, 59, 32768, 289, 1024, 59, 108, 113, 115, 9609, 9611, 9614, 9633, 32768, 8805, 59, 32768, 8923, 768, 59, 113, 115, 9621, 9623, 9626, 32768, 8805, 59, 32768, 8807, 108, 97, 110, 116, 59, 32768, 10878, 1024, 59, 99, 100, 108, 9642, 9644, 9648, 9667, 32768, 10878, 99, 59, 32768, 10921, 111, 116, 512, 59, 111, 9655, 9657, 32768, 10880, 512, 59, 108, 9662, 9664, 32768, 10882, 59, 32768, 10884, 512, 59, 101, 9672, 9675, 32896, 8923, 65024, 115, 59, 32768, 10900, 114, 59, 32896, 55349, 56612, 512, 59, 103, 9689, 9691, 32768, 8811, 59, 32768, 8921, 109, 101, 108, 59, 32768, 8503, 99, 121, 59, 32768, 1107, 1024, 59, 69, 97, 106, 9714, 9716, 9719, 9722, 32768, 8823, 59, 32768, 10898, 59, 32768, 10917, 59, 32768, 10916, 1024, 69, 97, 101, 115, 9734, 9737, 9751, 9768, 59, 32768, 8809, 112, 512, 59, 112, 9743, 9745, 32768, 10890, 114, 111, 120, 59, 32768, 10890, 512, 59, 113, 9756, 9758, 32768, 10888, 512, 59, 113, 9763, 9765, 32768, 10888, 59, 32768, 8809, 105, 109, 59, 32768, 8935, 112, 102, 59, 32896, 55349, 56664, 97, 118, 101, 59, 32768, 96, 512, 99, 105, 9790, 9794, 114, 59, 32768, 8458, 109, 768, 59, 101, 108, 9802, 9804, 9807, 32768, 8819, 59, 32768, 10894, 59, 32768, 10896, 34304, 62, 59, 99, 100, 108, 113, 114, 9824, 9826, 9838, 9843, 9849, 9856, 32768, 62, 512, 99, 105, 9831, 9834, 59, 32768, 10919, 114, 59, 32768, 10874, 111, 116, 59, 32768, 8919, 80, 97, 114, 59, 32768, 10645, 117, 101, 115, 116, 59, 32768, 10876, 1280, 97, 100, 101, 108, 115, 9867, 9882, 9887, 9906, 9912, 833, 9872, 0, 9879, 112, 114, 111, 120, 59, 32768, 10886, 114, 59, 32768, 10616, 111, 116, 59, 32768, 8919, 113, 512, 108, 113, 9893, 9899, 101, 115, 115, 59, 32768, 8923, 108, 101, 115, 115, 59, 32768, 10892, 101, 115, 115, 59, 32768, 8823, 105, 109, 59, 32768, 8819, 512, 101, 110, 9922, 9932, 114, 116, 110, 101, 113, 113, 59, 32896, 8809, 65024, 69, 59, 32896, 8809, 65024, 2560, 65, 97, 98, 99, 101, 102, 107, 111, 115, 121, 9958, 9963, 10015, 10020, 10026, 10060, 10065, 10085, 10147, 10171, 114, 114, 59, 32768, 8660, 1024, 105, 108, 109, 114, 9972, 9978, 9982, 9988, 114, 115, 112, 59, 32768, 8202, 102, 59, 32768, 189, 105, 108, 116, 59, 32768, 8459, 512, 100, 114, 9993, 9998, 99, 121, 59, 32768, 1098, 768, 59, 99, 119, 10005, 10007, 10012, 32768, 8596, 105, 114, 59, 32768, 10568, 59, 32768, 8621, 97, 114, 59, 32768, 8463, 105, 114, 99, 59, 32768, 293, 768, 97, 108, 114, 10033, 10048, 10054, 114, 116, 115, 512, 59, 117, 10041, 10043, 32768, 9829, 105, 116, 59, 32768, 9829, 108, 105, 112, 59, 32768, 8230, 99, 111, 110, 59, 32768, 8889, 114, 59, 32896, 55349, 56613, 115, 512, 101, 119, 10071, 10078, 97, 114, 111, 119, 59, 32768, 10533, 97, 114, 111, 119, 59, 32768, 10534, 1280, 97, 109, 111, 112, 114, 10096, 10101, 10107, 10136, 10141, 114, 114, 59, 32768, 8703, 116, 104, 116, 59, 32768, 8763, 107, 512, 108, 114, 10113, 10124, 101, 102, 116, 97, 114, 114, 111, 119, 59, 32768, 8617, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8618, 102, 59, 32896, 55349, 56665, 98, 97, 114, 59, 32768, 8213, 768, 99, 108, 116, 10154, 10159, 10165, 114, 59, 32896, 55349, 56509, 97, 115, 104, 59, 32768, 8463, 114, 111, 107, 59, 32768, 295, 512, 98, 112, 10176, 10182, 117, 108, 108, 59, 32768, 8259, 104, 101, 110, 59, 32768, 8208, 5426, 10211, 0, 10220, 0, 10239, 10255, 10267, 0, 10276, 10312, 0, 0, 10318, 10371, 10458, 10485, 10491, 0, 10500, 10545, 10558, 99, 117, 116, 101, 33024, 237, 59, 32768, 237, 768, 59, 105, 121, 10226, 10228, 10235, 32768, 8291, 114, 99, 33024, 238, 59, 32768, 238, 59, 32768, 1080, 512, 99, 120, 10243, 10247, 121, 59, 32768, 1077, 99, 108, 33024, 161, 59, 32768, 161, 512, 102, 114, 10259, 10262, 59, 32768, 8660, 59, 32896, 55349, 56614, 114, 97, 118, 101, 33024, 236, 59, 32768, 236, 1024, 59, 105, 110, 111, 10284, 10286, 10300, 10306, 32768, 8520, 512, 105, 110, 10291, 10296, 110, 116, 59, 32768, 10764, 116, 59, 32768, 8749, 102, 105, 110, 59, 32768, 10716, 116, 97, 59, 32768, 8489, 108, 105, 103, 59, 32768, 307, 768, 97, 111, 112, 10324, 10361, 10365, 768, 99, 103, 116, 10331, 10335, 10357, 114, 59, 32768, 299, 768, 101, 108, 112, 10342, 10345, 10351, 59, 32768, 8465, 105, 110, 101, 59, 32768, 8464, 97, 114, 116, 59, 32768, 8465, 104, 59, 32768, 305, 102, 59, 32768, 8887, 101, 100, 59, 32768, 437, 1280, 59, 99, 102, 111, 116, 10381, 10383, 10389, 10403, 10409, 32768, 8712, 97, 114, 101, 59, 32768, 8453, 105, 110, 512, 59, 116, 10396, 10398, 32768, 8734, 105, 101, 59, 32768, 10717, 100, 111, 116, 59, 32768, 305, 1280, 59, 99, 101, 108, 112, 10420, 10422, 10427, 10444, 10451, 32768, 8747, 97, 108, 59, 32768, 8890, 512, 103, 114, 10432, 10438, 101, 114, 115, 59, 32768, 8484, 99, 97, 108, 59, 32768, 8890, 97, 114, 104, 107, 59, 32768, 10775, 114, 111, 100, 59, 32768, 10812, 1024, 99, 103, 112, 116, 10466, 10470, 10475, 10480, 121, 59, 32768, 1105, 111, 110, 59, 32768, 303, 102, 59, 32896, 55349, 56666, 97, 59, 32768, 953, 114, 111, 100, 59, 32768, 10812, 117, 101, 115, 116, 33024, 191, 59, 32768, 191, 512, 99, 105, 10504, 10509, 114, 59, 32896, 55349, 56510, 110, 1280, 59, 69, 100, 115, 118, 10521, 10523, 10526, 10531, 10541, 32768, 8712, 59, 32768, 8953, 111, 116, 59, 32768, 8949, 512, 59, 118, 10536, 10538, 32768, 8948, 59, 32768, 8947, 59, 32768, 8712, 512, 59, 105, 10549, 10551, 32768, 8290, 108, 100, 101, 59, 32768, 297, 828, 10562, 0, 10567, 99, 121, 59, 32768, 1110, 108, 33024, 239, 59, 32768, 239, 1536, 99, 102, 109, 111, 115, 117, 10585, 10598, 10603, 10609, 10615, 10630, 512, 105, 121, 10590, 10595, 114, 99, 59, 32768, 309, 59, 32768, 1081, 114, 59, 32896, 55349, 56615, 97, 116, 104, 59, 32768, 567, 112, 102, 59, 32896, 55349, 56667, 820, 10620, 0, 10625, 114, 59, 32896, 55349, 56511, 114, 99, 121, 59, 32768, 1112, 107, 99, 121, 59, 32768, 1108, 2048, 97, 99, 102, 103, 104, 106, 111, 115, 10653, 10666, 10680, 10685, 10692, 10697, 10702, 10708, 112, 112, 97, 512, 59, 118, 10661, 10663, 32768, 954, 59, 32768, 1008, 512, 101, 121, 10671, 10677, 100, 105, 108, 59, 32768, 311, 59, 32768, 1082, 114, 59, 32896, 55349, 56616, 114, 101, 101, 110, 59, 32768, 312, 99, 121, 59, 32768, 1093, 99, 121, 59, 32768, 1116, 112, 102, 59, 32896, 55349, 56668, 99, 114, 59, 32896, 55349, 56512, 5888, 65, 66, 69, 72, 97, 98, 99, 100, 101, 102, 103, 104, 106, 108, 109, 110, 111, 112, 114, 115, 116, 117, 118, 10761, 10783, 10789, 10799, 10804, 10957, 11011, 11047, 11094, 11349, 11372, 11382, 11409, 11414, 11451, 11478, 11526, 11698, 11711, 11755, 11823, 11910, 11929, 768, 97, 114, 116, 10768, 10773, 10777, 114, 114, 59, 32768, 8666, 114, 59, 32768, 8656, 97, 105, 108, 59, 32768, 10523, 97, 114, 114, 59, 32768, 10510, 512, 59, 103, 10794, 10796, 32768, 8806, 59, 32768, 10891, 97, 114, 59, 32768, 10594, 4660, 10824, 0, 10830, 0, 10838, 0, 0, 0, 0, 0, 10844, 10850, 0, 10867, 10870, 10877, 0, 10933, 117, 116, 101, 59, 32768, 314, 109, 112, 116, 121, 118, 59, 32768, 10676, 114, 97, 110, 59, 32768, 8466, 98, 100, 97, 59, 32768, 955, 103, 768, 59, 100, 108, 10857, 10859, 10862, 32768, 10216, 59, 32768, 10641, 101, 59, 32768, 10216, 59, 32768, 10885, 117, 111, 33024, 171, 59, 32768, 171, 114, 2048, 59, 98, 102, 104, 108, 112, 115, 116, 10894, 10896, 10907, 10911, 10915, 10919, 10923, 10928, 32768, 8592, 512, 59, 102, 10901, 10903, 32768, 8676, 115, 59, 32768, 10527, 115, 59, 32768, 10525, 107, 59, 32768, 8617, 112, 59, 32768, 8619, 108, 59, 32768, 10553, 105, 109, 59, 32768, 10611, 108, 59, 32768, 8610, 768, 59, 97, 101, 10939, 10941, 10946, 32768, 10923, 105, 108, 59, 32768, 10521, 512, 59, 115, 10951, 10953, 32768, 10925, 59, 32896, 10925, 65024, 768, 97, 98, 114, 10964, 10969, 10974, 114, 114, 59, 32768, 10508, 114, 107, 59, 32768, 10098, 512, 97, 107, 10979, 10991, 99, 512, 101, 107, 10985, 10988, 59, 32768, 123, 59, 32768, 91, 512, 101, 115, 10996, 10999, 59, 32768, 10635, 108, 512, 100, 117, 11005, 11008, 59, 32768, 10639, 59, 32768, 10637, 1024, 97, 101, 117, 121, 11020, 11026, 11040, 11044, 114, 111, 110, 59, 32768, 318, 512, 100, 105, 11031, 11036, 105, 108, 59, 32768, 316, 108, 59, 32768, 8968, 98, 59, 32768, 123, 59, 32768, 1083, 1024, 99, 113, 114, 115, 11056, 11060, 11072, 11090, 97, 59, 32768, 10550, 117, 111, 512, 59, 114, 11067, 11069, 32768, 8220, 59, 32768, 8222, 512, 100, 117, 11077, 11083, 104, 97, 114, 59, 32768, 10599, 115, 104, 97, 114, 59, 32768, 10571, 104, 59, 32768, 8626, 1280, 59, 102, 103, 113, 115, 11105, 11107, 11228, 11231, 11250, 32768, 8804, 116, 1280, 97, 104, 108, 114, 116, 11119, 11136, 11157, 11169, 11216, 114, 114, 111, 119, 512, 59, 116, 11128, 11130, 32768, 8592, 97, 105, 108, 59, 32768, 8610, 97, 114, 112, 111, 111, 110, 512, 100, 117, 11147, 11153, 111, 119, 110, 59, 32768, 8637, 112, 59, 32768, 8636, 101, 102, 116, 97, 114, 114, 111, 119, 115, 59, 32768, 8647, 105, 103, 104, 116, 768, 97, 104, 115, 11180, 11194, 11204, 114, 114, 111, 119, 512, 59, 115, 11189, 11191, 32768, 8596, 59, 32768, 8646, 97, 114, 112, 111, 111, 110, 115, 59, 32768, 8651, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 32768, 8621, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 32768, 8907, 59, 32768, 8922, 768, 59, 113, 115, 11238, 11240, 11243, 32768, 8804, 59, 32768, 8806, 108, 97, 110, 116, 59, 32768, 10877, 1280, 59, 99, 100, 103, 115, 11261, 11263, 11267, 11286, 11298, 32768, 10877, 99, 59, 32768, 10920, 111, 116, 512, 59, 111, 11274, 11276, 32768, 10879, 512, 59, 114, 11281, 11283, 32768, 10881, 59, 32768, 10883, 512, 59, 101, 11291, 11294, 32896, 8922, 65024, 115, 59, 32768, 10899, 1280, 97, 100, 101, 103, 115, 11309, 11317, 11322, 11339, 11344, 112, 112, 114, 111, 120, 59, 32768, 10885, 111, 116, 59, 32768, 8918, 113, 512, 103, 113, 11328, 11333, 116, 114, 59, 32768, 8922, 103, 116, 114, 59, 32768, 10891, 116, 114, 59, 32768, 8822, 105, 109, 59, 32768, 8818, 768, 105, 108, 114, 11356, 11362, 11368, 115, 104, 116, 59, 32768, 10620, 111, 111, 114, 59, 32768, 8970, 59, 32896, 55349, 56617, 512, 59, 69, 11377, 11379, 32768, 8822, 59, 32768, 10897, 562, 11386, 11405, 114, 512, 100, 117, 11391, 11394, 59, 32768, 8637, 512, 59, 108, 11399, 11401, 32768, 8636, 59, 32768, 10602, 108, 107, 59, 32768, 9604, 99, 121, 59, 32768, 1113, 1280, 59, 97, 99, 104, 116, 11425, 11427, 11432, 11440, 11446, 32768, 8810, 114, 114, 59, 32768, 8647, 111, 114, 110, 101, 114, 59, 32768, 8990, 97, 114, 100, 59, 32768, 10603, 114, 105, 59, 32768, 9722, 512, 105, 111, 11456, 11462, 100, 111, 116, 59, 32768, 320, 117, 115, 116, 512, 59, 97, 11470, 11472, 32768, 9136, 99, 104, 101, 59, 32768, 9136, 1024, 69, 97, 101, 115, 11487, 11490, 11504, 11521, 59, 32768, 8808, 112, 512, 59, 112, 11496, 11498, 32768, 10889, 114, 111, 120, 59, 32768, 10889, 512, 59, 113, 11509, 11511, 32768, 10887, 512, 59, 113, 11516, 11518, 32768, 10887, 59, 32768, 8808, 105, 109, 59, 32768, 8934, 2048, 97, 98, 110, 111, 112, 116, 119, 122, 11543, 11556, 11561, 11616, 11640, 11660, 11667, 11680, 512, 110, 114, 11548, 11552, 103, 59, 32768, 10220, 114, 59, 32768, 8701, 114, 107, 59, 32768, 10214, 103, 768, 108, 109, 114, 11569, 11596, 11604, 101, 102, 116, 512, 97, 114, 11577, 11584, 114, 114, 111, 119, 59, 32768, 10229, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 10231, 97, 112, 115, 116, 111, 59, 32768, 10236, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 10230, 112, 97, 114, 114, 111, 119, 512, 108, 114, 11627, 11633, 101, 102, 116, 59, 32768, 8619, 105, 103, 104, 116, 59, 32768, 8620, 768, 97, 102, 108, 11647, 11651, 11655, 114, 59, 32768, 10629, 59, 32896, 55349, 56669, 117, 115, 59, 32768, 10797, 105, 109, 101, 115, 59, 32768, 10804, 562, 11671, 11676, 115, 116, 59, 32768, 8727, 97, 114, 59, 32768, 95, 768, 59, 101, 102, 11687, 11689, 11695, 32768, 9674, 110, 103, 101, 59, 32768, 9674, 59, 32768, 10731, 97, 114, 512, 59, 108, 11705, 11707, 32768, 40, 116, 59, 32768, 10643, 1280, 97, 99, 104, 109, 116, 11722, 11727, 11735, 11747, 11750, 114, 114, 59, 32768, 8646, 111, 114, 110, 101, 114, 59, 32768, 8991, 97, 114, 512, 59, 100, 11742, 11744, 32768, 8651, 59, 32768, 10605, 59, 32768, 8206, 114, 105, 59, 32768, 8895, 1536, 97, 99, 104, 105, 113, 116, 11768, 11774, 11779, 11782, 11798, 11817, 113, 117, 111, 59, 32768, 8249, 114, 59, 32896, 55349, 56513, 59, 32768, 8624, 109, 768, 59, 101, 103, 11790, 11792, 11795, 32768, 8818, 59, 32768, 10893, 59, 32768, 10895, 512, 98, 117, 11803, 11806, 59, 32768, 91, 111, 512, 59, 114, 11812, 11814, 32768, 8216, 59, 32768, 8218, 114, 111, 107, 59, 32768, 322, 34816, 60, 59, 99, 100, 104, 105, 108, 113, 114, 11841, 11843, 11855, 11860, 11866, 11872, 11878, 11885, 32768, 60, 512, 99, 105, 11848, 11851, 59, 32768, 10918, 114, 59, 32768, 10873, 111, 116, 59, 32768, 8918, 114, 101, 101, 59, 32768, 8907, 109, 101, 115, 59, 32768, 8905, 97, 114, 114, 59, 32768, 10614, 117, 101, 115, 116, 59, 32768, 10875, 512, 80, 105, 11890, 11895, 97, 114, 59, 32768, 10646, 768, 59, 101, 102, 11902, 11904, 11907, 32768, 9667, 59, 32768, 8884, 59, 32768, 9666, 114, 512, 100, 117, 11916, 11923, 115, 104, 97, 114, 59, 32768, 10570, 104, 97, 114, 59, 32768, 10598, 512, 101, 110, 11934, 11944, 114, 116, 110, 101, 113, 113, 59, 32896, 8808, 65024, 69, 59, 32896, 8808, 65024, 3584, 68, 97, 99, 100, 101, 102, 104, 105, 108, 110, 111, 112, 115, 117, 11978, 11984, 12061, 12075, 12081, 12095, 12100, 12104, 12170, 12181, 12188, 12204, 12207, 12223, 68, 111, 116, 59, 32768, 8762, 1024, 99, 108, 112, 114, 11993, 11999, 12019, 12055, 114, 33024, 175, 59, 32768, 175, 512, 101, 116, 12004, 12007, 59, 32768, 9794, 512, 59, 101, 12012, 12014, 32768, 10016, 115, 101, 59, 32768, 10016, 512, 59, 115, 12024, 12026, 32768, 8614, 116, 111, 1024, 59, 100, 108, 117, 12037, 12039, 12045, 12051, 32768, 8614, 111, 119, 110, 59, 32768, 8615, 101, 102, 116, 59, 32768, 8612, 112, 59, 32768, 8613, 107, 101, 114, 59, 32768, 9646, 512, 111, 121, 12066, 12072, 109, 109, 97, 59, 32768, 10793, 59, 32768, 1084, 97, 115, 104, 59, 32768, 8212, 97, 115, 117, 114, 101, 100, 97, 110, 103, 108, 101, 59, 32768, 8737, 114, 59, 32896, 55349, 56618, 111, 59, 32768, 8487, 768, 99, 100, 110, 12111, 12118, 12146, 114, 111, 33024, 181, 59, 32768, 181, 1024, 59, 97, 99, 100, 12127, 12129, 12134, 12139, 32768, 8739, 115, 116, 59, 32768, 42, 105, 114, 59, 32768, 10992, 111, 116, 33024, 183, 59, 32768, 183, 117, 115, 768, 59, 98, 100, 12155, 12157, 12160, 32768, 8722, 59, 32768, 8863, 512, 59, 117, 12165, 12167, 32768, 8760, 59, 32768, 10794, 564, 12174, 12178, 112, 59, 32768, 10971, 114, 59, 32768, 8230, 112, 108, 117, 115, 59, 32768, 8723, 512, 100, 112, 12193, 12199, 101, 108, 115, 59, 32768, 8871, 102, 59, 32896, 55349, 56670, 59, 32768, 8723, 512, 99, 116, 12212, 12217, 114, 59, 32896, 55349, 56514, 112, 111, 115, 59, 32768, 8766, 768, 59, 108, 109, 12230, 12232, 12240, 32768, 956, 116, 105, 109, 97, 112, 59, 32768, 8888, 97, 112, 59, 32768, 8888, 6144, 71, 76, 82, 86, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 108, 109, 111, 112, 114, 115, 116, 117, 118, 119, 12294, 12315, 12364, 12376, 12393, 12472, 12496, 12547, 12553, 12636, 12641, 12703, 12725, 12747, 12752, 12876, 12881, 12957, 13033, 13089, 13294, 13359, 13384, 13499, 512, 103, 116, 12299, 12303, 59, 32896, 8921, 824, 512, 59, 118, 12308, 12311, 32896, 8811, 8402, 59, 32896, 8811, 824, 768, 101, 108, 116, 12322, 12348, 12352, 102, 116, 512, 97, 114, 12329, 12336, 114, 114, 111, 119, 59, 32768, 8653, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8654, 59, 32896, 8920, 824, 512, 59, 118, 12357, 12360, 32896, 8810, 8402, 59, 32896, 8810, 824, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8655, 512, 68, 100, 12381, 12387, 97, 115, 104, 59, 32768, 8879, 97, 115, 104, 59, 32768, 8878, 1280, 98, 99, 110, 112, 116, 12404, 12409, 12415, 12420, 12452, 108, 97, 59, 32768, 8711, 117, 116, 101, 59, 32768, 324, 103, 59, 32896, 8736, 8402, 1280, 59, 69, 105, 111, 112, 12431, 12433, 12437, 12442, 12446, 32768, 8777, 59, 32896, 10864, 824, 100, 59, 32896, 8779, 824, 115, 59, 32768, 329, 114, 111, 120, 59, 32768, 8777, 117, 114, 512, 59, 97, 12459, 12461, 32768, 9838, 108, 512, 59, 115, 12467, 12469, 32768, 9838, 59, 32768, 8469, 836, 12477, 0, 12483, 112, 33024, 160, 59, 32768, 160, 109, 112, 512, 59, 101, 12489, 12492, 32896, 8782, 824, 59, 32896, 8783, 824, 1280, 97, 101, 111, 117, 121, 12507, 12519, 12525, 12540, 12544, 833, 12512, 0, 12515, 59, 32768, 10819, 111, 110, 59, 32768, 328, 100, 105, 108, 59, 32768, 326, 110, 103, 512, 59, 100, 12532, 12534, 32768, 8775, 111, 116, 59, 32896, 10861, 824, 112, 59, 32768, 10818, 59, 32768, 1085, 97, 115, 104, 59, 32768, 8211, 1792, 59, 65, 97, 100, 113, 115, 120, 12568, 12570, 12575, 12596, 12602, 12608, 12623, 32768, 8800, 114, 114, 59, 32768, 8663, 114, 512, 104, 114, 12581, 12585, 107, 59, 32768, 10532, 512, 59, 111, 12590, 12592, 32768, 8599, 119, 59, 32768, 8599, 111, 116, 59, 32896, 8784, 824, 117, 105, 118, 59, 32768, 8802, 512, 101, 105, 12613, 12618, 97, 114, 59, 32768, 10536, 109, 59, 32896, 8770, 824, 105, 115, 116, 512, 59, 115, 12631, 12633, 32768, 8708, 59, 32768, 8708, 114, 59, 32896, 55349, 56619, 1024, 69, 101, 115, 116, 12650, 12654, 12688, 12693, 59, 32896, 8807, 824, 768, 59, 113, 115, 12661, 12663, 12684, 32768, 8817, 768, 59, 113, 115, 12670, 12672, 12676, 32768, 8817, 59, 32896, 8807, 824, 108, 97, 110, 116, 59, 32896, 10878, 824, 59, 32896, 10878, 824, 105, 109, 59, 32768, 8821, 512, 59, 114, 12698, 12700, 32768, 8815, 59, 32768, 8815, 768, 65, 97, 112, 12710, 12715, 12720, 114, 114, 59, 32768, 8654, 114, 114, 59, 32768, 8622, 97, 114, 59, 32768, 10994, 768, 59, 115, 118, 12732, 12734, 12744, 32768, 8715, 512, 59, 100, 12739, 12741, 32768, 8956, 59, 32768, 8954, 59, 32768, 8715, 99, 121, 59, 32768, 1114, 1792, 65, 69, 97, 100, 101, 115, 116, 12767, 12772, 12776, 12781, 12785, 12853, 12858, 114, 114, 59, 32768, 8653, 59, 32896, 8806, 824, 114, 114, 59, 32768, 8602, 114, 59, 32768, 8229, 1024, 59, 102, 113, 115, 12794, 12796, 12821, 12842, 32768, 8816, 116, 512, 97, 114, 12802, 12809, 114, 114, 111, 119, 59, 32768, 8602, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8622, 768, 59, 113, 115, 12828, 12830, 12834, 32768, 8816, 59, 32896, 8806, 824, 108, 97, 110, 116, 59, 32896, 10877, 824, 512, 59, 115, 12847, 12850, 32896, 10877, 824, 59, 32768, 8814, 105, 109, 59, 32768, 8820, 512, 59, 114, 12863, 12865, 32768, 8814, 105, 512, 59, 101, 12871, 12873, 32768, 8938, 59, 32768, 8940, 105, 100, 59, 32768, 8740, 512, 112, 116, 12886, 12891, 102, 59, 32896, 55349, 56671, 33536, 172, 59, 105, 110, 12899, 12901, 12936, 32768, 172, 110, 1024, 59, 69, 100, 118, 12911, 12913, 12917, 12923, 32768, 8713, 59, 32896, 8953, 824, 111, 116, 59, 32896, 8949, 824, 818, 12928, 12931, 12934, 59, 32768, 8713, 59, 32768, 8951, 59, 32768, 8950, 105, 512, 59, 118, 12942, 12944, 32768, 8716, 818, 12949, 12952, 12955, 59, 32768, 8716, 59, 32768, 8958, 59, 32768, 8957, 768, 97, 111, 114, 12964, 12992, 12999, 114, 1024, 59, 97, 115, 116, 12974, 12976, 12983, 12988, 32768, 8742, 108, 108, 101, 108, 59, 32768, 8742, 108, 59, 32896, 11005, 8421, 59, 32896, 8706, 824, 108, 105, 110, 116, 59, 32768, 10772, 768, 59, 99, 101, 13006, 13008, 13013, 32768, 8832, 117, 101, 59, 32768, 8928, 512, 59, 99, 13018, 13021, 32896, 10927, 824, 512, 59, 101, 13026, 13028, 32768, 8832, 113, 59, 32896, 10927, 824, 1024, 65, 97, 105, 116, 13042, 13047, 13066, 13077, 114, 114, 59, 32768, 8655, 114, 114, 768, 59, 99, 119, 13056, 13058, 13062, 32768, 8603, 59, 32896, 10547, 824, 59, 32896, 8605, 824, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8603, 114, 105, 512, 59, 101, 13084, 13086, 32768, 8939, 59, 32768, 8941, 1792, 99, 104, 105, 109, 112, 113, 117, 13104, 13128, 13151, 13169, 13174, 13179, 13194, 1024, 59, 99, 101, 114, 13113, 13115, 13120, 13124, 32768, 8833, 117, 101, 59, 32768, 8929, 59, 32896, 10928, 824, 59, 32896, 55349, 56515, 111, 114, 116, 1086, 13137, 0, 0, 13142, 105, 100, 59, 32768, 8740, 97, 114, 97, 108, 108, 101, 108, 59, 32768, 8742, 109, 512, 59, 101, 13157, 13159, 32768, 8769, 512, 59, 113, 13164, 13166, 32768, 8772, 59, 32768, 8772, 105, 100, 59, 32768, 8740, 97, 114, 59, 32768, 8742, 115, 117, 512, 98, 112, 13186, 13190, 101, 59, 32768, 8930, 101, 59, 32768, 8931, 768, 98, 99, 112, 13201, 13241, 13254, 1024, 59, 69, 101, 115, 13210, 13212, 13216, 13219, 32768, 8836, 59, 32896, 10949, 824, 59, 32768, 8840, 101, 116, 512, 59, 101, 13226, 13229, 32896, 8834, 8402, 113, 512, 59, 113, 13235, 13237, 32768, 8840, 59, 32896, 10949, 824, 99, 512, 59, 101, 13247, 13249, 32768, 8833, 113, 59, 32896, 10928, 824, 1024, 59, 69, 101, 115, 13263, 13265, 13269, 13272, 32768, 8837, 59, 32896, 10950, 824, 59, 32768, 8841, 101, 116, 512, 59, 101, 13279, 13282, 32896, 8835, 8402, 113, 512, 59, 113, 13288, 13290, 32768, 8841, 59, 32896, 10950, 824, 1024, 103, 105, 108, 114, 13303, 13307, 13315, 13319, 108, 59, 32768, 8825, 108, 100, 101, 33024, 241, 59, 32768, 241, 103, 59, 32768, 8824, 105, 97, 110, 103, 108, 101, 512, 108, 114, 13330, 13344, 101, 102, 116, 512, 59, 101, 13338, 13340, 32768, 8938, 113, 59, 32768, 8940, 105, 103, 104, 116, 512, 59, 101, 13353, 13355, 32768, 8939, 113, 59, 32768, 8941, 512, 59, 109, 13364, 13366, 32768, 957, 768, 59, 101, 115, 13373, 13375, 13380, 32768, 35, 114, 111, 59, 32768, 8470, 112, 59, 32768, 8199, 2304, 68, 72, 97, 100, 103, 105, 108, 114, 115, 13403, 13409, 13415, 13420, 13426, 13439, 13446, 13476, 13493, 97, 115, 104, 59, 32768, 8877, 97, 114, 114, 59, 32768, 10500, 112, 59, 32896, 8781, 8402, 97, 115, 104, 59, 32768, 8876, 512, 101, 116, 13431, 13435, 59, 32896, 8805, 8402, 59, 32896, 62, 8402, 110, 102, 105, 110, 59, 32768, 10718, 768, 65, 101, 116, 13453, 13458, 13462, 114, 114, 59, 32768, 10498, 59, 32896, 8804, 8402, 512, 59, 114, 13467, 13470, 32896, 60, 8402, 105, 101, 59, 32896, 8884, 8402, 512, 65, 116, 13481, 13486, 114, 114, 59, 32768, 10499, 114, 105, 101, 59, 32896, 8885, 8402, 105, 109, 59, 32896, 8764, 8402, 768, 65, 97, 110, 13506, 13511, 13532, 114, 114, 59, 32768, 8662, 114, 512, 104, 114, 13517, 13521, 107, 59, 32768, 10531, 512, 59, 111, 13526, 13528, 32768, 8598, 119, 59, 32768, 8598, 101, 97, 114, 59, 32768, 10535, 9252, 13576, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 13579, 0, 13596, 13617, 13653, 13659, 13673, 13695, 13708, 0, 0, 13713, 13750, 0, 13788, 13794, 0, 13815, 13890, 13913, 13937, 13944, 59, 32768, 9416, 512, 99, 115, 13583, 13591, 117, 116, 101, 33024, 243, 59, 32768, 243, 116, 59, 32768, 8859, 512, 105, 121, 13600, 13613, 114, 512, 59, 99, 13606, 13608, 32768, 8858, 33024, 244, 59, 32768, 244, 59, 32768, 1086, 1280, 97, 98, 105, 111, 115, 13627, 13632, 13638, 13642, 13646, 115, 104, 59, 32768, 8861, 108, 97, 99, 59, 32768, 337, 118, 59, 32768, 10808, 116, 59, 32768, 8857, 111, 108, 100, 59, 32768, 10684, 108, 105, 103, 59, 32768, 339, 512, 99, 114, 13663, 13668, 105, 114, 59, 32768, 10687, 59, 32896, 55349, 56620, 1600, 13680, 0, 0, 13684, 0, 13692, 110, 59, 32768, 731, 97, 118, 101, 33024, 242, 59, 32768, 242, 59, 32768, 10689, 512, 98, 109, 13699, 13704, 97, 114, 59, 32768, 10677, 59, 32768, 937, 110, 116, 59, 32768, 8750, 1024, 97, 99, 105, 116, 13721, 13726, 13741, 13746, 114, 114, 59, 32768, 8634, 512, 105, 114, 13731, 13735, 114, 59, 32768, 10686, 111, 115, 115, 59, 32768, 10683, 110, 101, 59, 32768, 8254, 59, 32768, 10688, 768, 97, 101, 105, 13756, 13761, 13766, 99, 114, 59, 32768, 333, 103, 97, 59, 32768, 969, 768, 99, 100, 110, 13773, 13779, 13782, 114, 111, 110, 59, 32768, 959, 59, 32768, 10678, 117, 115, 59, 32768, 8854, 112, 102, 59, 32896, 55349, 56672, 768, 97, 101, 108, 13800, 13804, 13809, 114, 59, 32768, 10679, 114, 112, 59, 32768, 10681, 117, 115, 59, 32768, 8853, 1792, 59, 97, 100, 105, 111, 115, 118, 13829, 13831, 13836, 13869, 13875, 13879, 13886, 32768, 8744, 114, 114, 59, 32768, 8635, 1024, 59, 101, 102, 109, 13845, 13847, 13859, 13864, 32768, 10845, 114, 512, 59, 111, 13853, 13855, 32768, 8500, 102, 59, 32768, 8500, 33024, 170, 59, 32768, 170, 33024, 186, 59, 32768, 186, 103, 111, 102, 59, 32768, 8886, 114, 59, 32768, 10838, 108, 111, 112, 101, 59, 32768, 10839, 59, 32768, 10843, 768, 99, 108, 111, 13896, 13900, 13908, 114, 59, 32768, 8500, 97, 115, 104, 33024, 248, 59, 32768, 248, 108, 59, 32768, 8856, 105, 573, 13917, 13924, 100, 101, 33024, 245, 59, 32768, 245, 101, 115, 512, 59, 97, 13930, 13932, 32768, 8855, 115, 59, 32768, 10806, 109, 108, 33024, 246, 59, 32768, 246, 98, 97, 114, 59, 32768, 9021, 5426, 13972, 0, 14013, 0, 14017, 14053, 0, 14058, 14086, 0, 0, 14107, 14199, 0, 14202, 0, 0, 14229, 14425, 0, 14438, 114, 1024, 59, 97, 115, 116, 13981, 13983, 13997, 14009, 32768, 8741, 33280, 182, 59, 108, 13989, 13991, 32768, 182, 108, 101, 108, 59, 32768, 8741, 1082, 14003, 0, 0, 14007, 109, 59, 32768, 10995, 59, 32768, 11005, 59, 32768, 8706, 121, 59, 32768, 1087, 114, 1280, 99, 105, 109, 112, 116, 14028, 14033, 14038, 14043, 14046, 110, 116, 59, 32768, 37, 111, 100, 59, 32768, 46, 105, 108, 59, 32768, 8240, 59, 32768, 8869, 101, 110, 107, 59, 32768, 8241, 114, 59, 32896, 55349, 56621, 768, 105, 109, 111, 14064, 14074, 14080, 512, 59, 118, 14069, 14071, 32768, 966, 59, 32768, 981, 109, 97, 116, 59, 32768, 8499, 110, 101, 59, 32768, 9742, 768, 59, 116, 118, 14092, 14094, 14103, 32768, 960, 99, 104, 102, 111, 114, 107, 59, 32768, 8916, 59, 32768, 982, 512, 97, 117, 14111, 14132, 110, 512, 99, 107, 14117, 14128, 107, 512, 59, 104, 14123, 14125, 32768, 8463, 59, 32768, 8462, 118, 59, 32768, 8463, 115, 2304, 59, 97, 98, 99, 100, 101, 109, 115, 116, 14152, 14154, 14160, 14163, 14168, 14179, 14182, 14188, 14193, 32768, 43, 99, 105, 114, 59, 32768, 10787, 59, 32768, 8862, 105, 114, 59, 32768, 10786, 512, 111, 117, 14173, 14176, 59, 32768, 8724, 59, 32768, 10789, 59, 32768, 10866, 110, 33024, 177, 59, 32768, 177, 105, 109, 59, 32768, 10790, 119, 111, 59, 32768, 10791, 59, 32768, 177, 768, 105, 112, 117, 14208, 14216, 14221, 110, 116, 105, 110, 116, 59, 32768, 10773, 102, 59, 32896, 55349, 56673, 110, 100, 33024, 163, 59, 32768, 163, 2560, 59, 69, 97, 99, 101, 105, 110, 111, 115, 117, 14249, 14251, 14254, 14258, 14263, 14336, 14348, 14367, 14413, 14418, 32768, 8826, 59, 32768, 10931, 112, 59, 32768, 10935, 117, 101, 59, 32768, 8828, 512, 59, 99, 14268, 14270, 32768, 10927, 1536, 59, 97, 99, 101, 110, 115, 14283, 14285, 14293, 14302, 14306, 14331, 32768, 8826, 112, 112, 114, 111, 120, 59, 32768, 10935, 117, 114, 108, 121, 101, 113, 59, 32768, 8828, 113, 59, 32768, 10927, 768, 97, 101, 115, 14313, 14321, 14326, 112, 112, 114, 111, 120, 59, 32768, 10937, 113, 113, 59, 32768, 10933, 105, 109, 59, 32768, 8936, 105, 109, 59, 32768, 8830, 109, 101, 512, 59, 115, 14343, 14345, 32768, 8242, 59, 32768, 8473, 768, 69, 97, 115, 14355, 14358, 14362, 59, 32768, 10933, 112, 59, 32768, 10937, 105, 109, 59, 32768, 8936, 768, 100, 102, 112, 14374, 14377, 14402, 59, 32768, 8719, 768, 97, 108, 115, 14384, 14390, 14396, 108, 97, 114, 59, 32768, 9006, 105, 110, 101, 59, 32768, 8978, 117, 114, 102, 59, 32768, 8979, 512, 59, 116, 14407, 14409, 32768, 8733, 111, 59, 32768, 8733, 105, 109, 59, 32768, 8830, 114, 101, 108, 59, 32768, 8880, 512, 99, 105, 14429, 14434, 114, 59, 32896, 55349, 56517, 59, 32768, 968, 110, 99, 115, 112, 59, 32768, 8200, 1536, 102, 105, 111, 112, 115, 117, 14457, 14462, 14467, 14473, 14480, 14486, 114, 59, 32896, 55349, 56622, 110, 116, 59, 32768, 10764, 112, 102, 59, 32896, 55349, 56674, 114, 105, 109, 101, 59, 32768, 8279, 99, 114, 59, 32896, 55349, 56518, 768, 97, 101, 111, 14493, 14513, 14526, 116, 512, 101, 105, 14499, 14508, 114, 110, 105, 111, 110, 115, 59, 32768, 8461, 110, 116, 59, 32768, 10774, 115, 116, 512, 59, 101, 14520, 14522, 32768, 63, 113, 59, 32768, 8799, 116, 33024, 34, 59, 32768, 34, 5376, 65, 66, 72, 97, 98, 99, 100, 101, 102, 104, 105, 108, 109, 110, 111, 112, 114, 115, 116, 117, 120, 14575, 14597, 14603, 14608, 14775, 14829, 14865, 14901, 14943, 14966, 15000, 15139, 15159, 15176, 15182, 15236, 15261, 15267, 15309, 15352, 15360, 768, 97, 114, 116, 14582, 14587, 14591, 114, 114, 59, 32768, 8667, 114, 59, 32768, 8658, 97, 105, 108, 59, 32768, 10524, 97, 114, 114, 59, 32768, 10511, 97, 114, 59, 32768, 10596, 1792, 99, 100, 101, 110, 113, 114, 116, 14623, 14637, 14642, 14650, 14672, 14679, 14751, 512, 101, 117, 14628, 14632, 59, 32896, 8765, 817, 116, 101, 59, 32768, 341, 105, 99, 59, 32768, 8730, 109, 112, 116, 121, 118, 59, 32768, 10675, 103, 1024, 59, 100, 101, 108, 14660, 14662, 14665, 14668, 32768, 10217, 59, 32768, 10642, 59, 32768, 10661, 101, 59, 32768, 10217, 117, 111, 33024, 187, 59, 32768, 187, 114, 2816, 59, 97, 98, 99, 102, 104, 108, 112, 115, 116, 119, 14703, 14705, 14709, 14720, 14723, 14727, 14731, 14735, 14739, 14744, 14748, 32768, 8594, 112, 59, 32768, 10613, 512, 59, 102, 14714, 14716, 32768, 8677, 115, 59, 32768, 10528, 59, 32768, 10547, 115, 59, 32768, 10526, 107, 59, 32768, 8618, 112, 59, 32768, 8620, 108, 59, 32768, 10565, 105, 109, 59, 32768, 10612, 108, 59, 32768, 8611, 59, 32768, 8605, 512, 97, 105, 14756, 14761, 105, 108, 59, 32768, 10522, 111, 512, 59, 110, 14767, 14769, 32768, 8758, 97, 108, 115, 59, 32768, 8474, 768, 97, 98, 114, 14782, 14787, 14792, 114, 114, 59, 32768, 10509, 114, 107, 59, 32768, 10099, 512, 97, 107, 14797, 14809, 99, 512, 101, 107, 14803, 14806, 59, 32768, 125, 59, 32768, 93, 512, 101, 115, 14814, 14817, 59, 32768, 10636, 108, 512, 100, 117, 14823, 14826, 59, 32768, 10638, 59, 32768, 10640, 1024, 97, 101, 117, 121, 14838, 14844, 14858, 14862, 114, 111, 110, 59, 32768, 345, 512, 100, 105, 14849, 14854, 105, 108, 59, 32768, 343, 108, 59, 32768, 8969, 98, 59, 32768, 125, 59, 32768, 1088, 1024, 99, 108, 113, 115, 14874, 14878, 14885, 14897, 97, 59, 32768, 10551, 100, 104, 97, 114, 59, 32768, 10601, 117, 111, 512, 59, 114, 14892, 14894, 32768, 8221, 59, 32768, 8221, 104, 59, 32768, 8627, 768, 97, 99, 103, 14908, 14934, 14938, 108, 1024, 59, 105, 112, 115, 14918, 14920, 14925, 14931, 32768, 8476, 110, 101, 59, 32768, 8475, 97, 114, 116, 59, 32768, 8476, 59, 32768, 8477, 116, 59, 32768, 9645, 33024, 174, 59, 32768, 174, 768, 105, 108, 114, 14950, 14956, 14962, 115, 104, 116, 59, 32768, 10621, 111, 111, 114, 59, 32768, 8971, 59, 32896, 55349, 56623, 512, 97, 111, 14971, 14990, 114, 512, 100, 117, 14977, 14980, 59, 32768, 8641, 512, 59, 108, 14985, 14987, 32768, 8640, 59, 32768, 10604, 512, 59, 118, 14995, 14997, 32768, 961, 59, 32768, 1009, 768, 103, 110, 115, 15007, 15123, 15127, 104, 116, 1536, 97, 104, 108, 114, 115, 116, 15022, 15039, 15060, 15086, 15099, 15111, 114, 114, 111, 119, 512, 59, 116, 15031, 15033, 32768, 8594, 97, 105, 108, 59, 32768, 8611, 97, 114, 112, 111, 111, 110, 512, 100, 117, 15050, 15056, 111, 119, 110, 59, 32768, 8641, 112, 59, 32768, 8640, 101, 102, 116, 512, 97, 104, 15068, 15076, 114, 114, 111, 119, 115, 59, 32768, 8644, 97, 114, 112, 111, 111, 110, 115, 59, 32768, 8652, 105, 103, 104, 116, 97, 114, 114, 111, 119, 115, 59, 32768, 8649, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 32768, 8605, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 32768, 8908, 103, 59, 32768, 730, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 32768, 8787, 768, 97, 104, 109, 15146, 15151, 15156, 114, 114, 59, 32768, 8644, 97, 114, 59, 32768, 8652, 59, 32768, 8207, 111, 117, 115, 116, 512, 59, 97, 15168, 15170, 32768, 9137, 99, 104, 101, 59, 32768, 9137, 109, 105, 100, 59, 32768, 10990, 1024, 97, 98, 112, 116, 15191, 15204, 15209, 15229, 512, 110, 114, 15196, 15200, 103, 59, 32768, 10221, 114, 59, 32768, 8702, 114, 107, 59, 32768, 10215, 768, 97, 102, 108, 15216, 15220, 15224, 114, 59, 32768, 10630, 59, 32896, 55349, 56675, 117, 115, 59, 32768, 10798, 105, 109, 101, 115, 59, 32768, 10805, 512, 97, 112, 15241, 15253, 114, 512, 59, 103, 15247, 15249, 32768, 41, 116, 59, 32768, 10644, 111, 108, 105, 110, 116, 59, 32768, 10770, 97, 114, 114, 59, 32768, 8649, 1024, 97, 99, 104, 113, 15276, 15282, 15287, 15290, 113, 117, 111, 59, 32768, 8250, 114, 59, 32896, 55349, 56519, 59, 32768, 8625, 512, 98, 117, 15295, 15298, 59, 32768, 93, 111, 512, 59, 114, 15304, 15306, 32768, 8217, 59, 32768, 8217, 768, 104, 105, 114, 15316, 15322, 15328, 114, 101, 101, 59, 32768, 8908, 109, 101, 115, 59, 32768, 8906, 105, 1024, 59, 101, 102, 108, 15338, 15340, 15343, 15346, 32768, 9657, 59, 32768, 8885, 59, 32768, 9656, 116, 114, 105, 59, 32768, 10702, 108, 117, 104, 97, 114, 59, 32768, 10600, 59, 32768, 8478, 6706, 15391, 15398, 15404, 15499, 15516, 15592, 0, 15606, 15660, 0, 0, 15752, 15758, 0, 15827, 15863, 15886, 16000, 16006, 16038, 16086, 0, 16467, 0, 0, 16506, 99, 117, 116, 101, 59, 32768, 347, 113, 117, 111, 59, 32768, 8218, 2560, 59, 69, 97, 99, 101, 105, 110, 112, 115, 121, 15424, 15426, 15429, 15441, 15446, 15458, 15463, 15482, 15490, 15495, 32768, 8827, 59, 32768, 10932, 833, 15434, 0, 15437, 59, 32768, 10936, 111, 110, 59, 32768, 353, 117, 101, 59, 32768, 8829, 512, 59, 100, 15451, 15453, 32768, 10928, 105, 108, 59, 32768, 351, 114, 99, 59, 32768, 349, 768, 69, 97, 115, 15470, 15473, 15477, 59, 32768, 10934, 112, 59, 32768, 10938, 105, 109, 59, 32768, 8937, 111, 108, 105, 110, 116, 59, 32768, 10771, 105, 109, 59, 32768, 8831, 59, 32768, 1089, 111, 116, 768, 59, 98, 101, 15507, 15509, 15512, 32768, 8901, 59, 32768, 8865, 59, 32768, 10854, 1792, 65, 97, 99, 109, 115, 116, 120, 15530, 15535, 15556, 15562, 15566, 15572, 15587, 114, 114, 59, 32768, 8664, 114, 512, 104, 114, 15541, 15545, 107, 59, 32768, 10533, 512, 59, 111, 15550, 15552, 32768, 8600, 119, 59, 32768, 8600, 116, 33024, 167, 59, 32768, 167, 105, 59, 32768, 59, 119, 97, 114, 59, 32768, 10537, 109, 512, 105, 110, 15578, 15584, 110, 117, 115, 59, 32768, 8726, 59, 32768, 8726, 116, 59, 32768, 10038, 114, 512, 59, 111, 15597, 15600, 32896, 55349, 56624, 119, 110, 59, 32768, 8994, 1024, 97, 99, 111, 121, 15614, 15619, 15632, 15654, 114, 112, 59, 32768, 9839, 512, 104, 121, 15624, 15629, 99, 121, 59, 32768, 1097, 59, 32768, 1096, 114, 116, 1086, 15640, 0, 0, 15645, 105, 100, 59, 32768, 8739, 97, 114, 97, 108, 108, 101, 108, 59, 32768, 8741, 33024, 173, 59, 32768, 173, 512, 103, 109, 15664, 15681, 109, 97, 768, 59, 102, 118, 15673, 15675, 15678, 32768, 963, 59, 32768, 962, 59, 32768, 962, 2048, 59, 100, 101, 103, 108, 110, 112, 114, 15698, 15700, 15705, 15715, 15725, 15735, 15739, 15745, 32768, 8764, 111, 116, 59, 32768, 10858, 512, 59, 113, 15710, 15712, 32768, 8771, 59, 32768, 8771, 512, 59, 69, 15720, 15722, 32768, 10910, 59, 32768, 10912, 512, 59, 69, 15730, 15732, 32768, 10909, 59, 32768, 10911, 101, 59, 32768, 8774, 108, 117, 115, 59, 32768, 10788, 97, 114, 114, 59, 32768, 10610, 97, 114, 114, 59, 32768, 8592, 1024, 97, 101, 105, 116, 15766, 15788, 15796, 15808, 512, 108, 115, 15771, 15783, 108, 115, 101, 116, 109, 105, 110, 117, 115, 59, 32768, 8726, 104, 112, 59, 32768, 10803, 112, 97, 114, 115, 108, 59, 32768, 10724, 512, 100, 108, 15801, 15804, 59, 32768, 8739, 101, 59, 32768, 8995, 512, 59, 101, 15813, 15815, 32768, 10922, 512, 59, 115, 15820, 15822, 32768, 10924, 59, 32896, 10924, 65024, 768, 102, 108, 112, 15833, 15839, 15857, 116, 99, 121, 59, 32768, 1100, 512, 59, 98, 15844, 15846, 32768, 47, 512, 59, 97, 15851, 15853, 32768, 10692, 114, 59, 32768, 9023, 102, 59, 32896, 55349, 56676, 97, 512, 100, 114, 15868, 15882, 101, 115, 512, 59, 117, 15875, 15877, 32768, 9824, 105, 116, 59, 32768, 9824, 59, 32768, 8741, 768, 99, 115, 117, 15892, 15921, 15977, 512, 97, 117, 15897, 15909, 112, 512, 59, 115, 15903, 15905, 32768, 8851, 59, 32896, 8851, 65024, 112, 512, 59, 115, 15915, 15917, 32768, 8852, 59, 32896, 8852, 65024, 117, 512, 98, 112, 15927, 15952, 768, 59, 101, 115, 15934, 15936, 15939, 32768, 8847, 59, 32768, 8849, 101, 116, 512, 59, 101, 15946, 15948, 32768, 8847, 113, 59, 32768, 8849, 768, 59, 101, 115, 15959, 15961, 15964, 32768, 8848, 59, 32768, 8850, 101, 116, 512, 59, 101, 15971, 15973, 32768, 8848, 113, 59, 32768, 8850, 768, 59, 97, 102, 15984, 15986, 15996, 32768, 9633, 114, 566, 15991, 15994, 59, 32768, 9633, 59, 32768, 9642, 59, 32768, 9642, 97, 114, 114, 59, 32768, 8594, 1024, 99, 101, 109, 116, 16014, 16019, 16025, 16031, 114, 59, 32896, 55349, 56520, 116, 109, 110, 59, 32768, 8726, 105, 108, 101, 59, 32768, 8995, 97, 114, 102, 59, 32768, 8902, 512, 97, 114, 16042, 16053, 114, 512, 59, 102, 16048, 16050, 32768, 9734, 59, 32768, 9733, 512, 97, 110, 16058, 16081, 105, 103, 104, 116, 512, 101, 112, 16067, 16076, 112, 115, 105, 108, 111, 110, 59, 32768, 1013, 104, 105, 59, 32768, 981, 115, 59, 32768, 175, 1280, 98, 99, 109, 110, 112, 16096, 16221, 16288, 16291, 16295, 2304, 59, 69, 100, 101, 109, 110, 112, 114, 115, 16115, 16117, 16120, 16125, 16137, 16143, 16154, 16160, 16166, 32768, 8834, 59, 32768, 10949, 111, 116, 59, 32768, 10941, 512, 59, 100, 16130, 16132, 32768, 8838, 111, 116, 59, 32768, 10947, 117, 108, 116, 59, 32768, 10945, 512, 69, 101, 16148, 16151, 59, 32768, 10955, 59, 32768, 8842, 108, 117, 115, 59, 32768, 10943, 97, 114, 114, 59, 32768, 10617, 768, 101, 105, 117, 16173, 16206, 16210, 116, 768, 59, 101, 110, 16181, 16183, 16194, 32768, 8834, 113, 512, 59, 113, 16189, 16191, 32768, 8838, 59, 32768, 10949, 101, 113, 512, 59, 113, 16201, 16203, 32768, 8842, 59, 32768, 10955, 109, 59, 32768, 10951, 512, 98, 112, 16215, 16218, 59, 32768, 10965, 59, 32768, 10963, 99, 1536, 59, 97, 99, 101, 110, 115, 16235, 16237, 16245, 16254, 16258, 16283, 32768, 8827, 112, 112, 114, 111, 120, 59, 32768, 10936, 117, 114, 108, 121, 101, 113, 59, 32768, 8829, 113, 59, 32768, 10928, 768, 97, 101, 115, 16265, 16273, 16278, 112, 112, 114, 111, 120, 59, 32768, 10938, 113, 113, 59, 32768, 10934, 105, 109, 59, 32768, 8937, 105, 109, 59, 32768, 8831, 59, 32768, 8721, 103, 59, 32768, 9834, 3328, 49, 50, 51, 59, 69, 100, 101, 104, 108, 109, 110, 112, 115, 16322, 16327, 16332, 16337, 16339, 16342, 16356, 16368, 16382, 16388, 16394, 16405, 16411, 33024, 185, 59, 32768, 185, 33024, 178, 59, 32768, 178, 33024, 179, 59, 32768, 179, 32768, 8835, 59, 32768, 10950, 512, 111, 115, 16347, 16351, 116, 59, 32768, 10942, 117, 98, 59, 32768, 10968, 512, 59, 100, 16361, 16363, 32768, 8839, 111, 116, 59, 32768, 10948, 115, 512, 111, 117, 16374, 16378, 108, 59, 32768, 10185, 98, 59, 32768, 10967, 97, 114, 114, 59, 32768, 10619, 117, 108, 116, 59, 32768, 10946, 512, 69, 101, 16399, 16402, 59, 32768, 10956, 59, 32768, 8843, 108, 117, 115, 59, 32768, 10944, 768, 101, 105, 117, 16418, 16451, 16455, 116, 768, 59, 101, 110, 16426, 16428, 16439, 32768, 8835, 113, 512, 59, 113, 16434, 16436, 32768, 8839, 59, 32768, 10950, 101, 113, 512, 59, 113, 16446, 16448, 32768, 8843, 59, 32768, 10956, 109, 59, 32768, 10952, 512, 98, 112, 16460, 16463, 59, 32768, 10964, 59, 32768, 10966, 768, 65, 97, 110, 16473, 16478, 16499, 114, 114, 59, 32768, 8665, 114, 512, 104, 114, 16484, 16488, 107, 59, 32768, 10534, 512, 59, 111, 16493, 16495, 32768, 8601, 119, 59, 32768, 8601, 119, 97, 114, 59, 32768, 10538, 108, 105, 103, 33024, 223, 59, 32768, 223, 5938, 16538, 16552, 16557, 16579, 16584, 16591, 0, 16596, 16692, 0, 0, 0, 0, 0, 16731, 16780, 0, 16787, 16908, 0, 0, 0, 16938, 1091, 16543, 0, 0, 16549, 103, 101, 116, 59, 32768, 8982, 59, 32768, 964, 114, 107, 59, 32768, 9140, 768, 97, 101, 121, 16563, 16569, 16575, 114, 111, 110, 59, 32768, 357, 100, 105, 108, 59, 32768, 355, 59, 32768, 1090, 111, 116, 59, 32768, 8411, 108, 114, 101, 99, 59, 32768, 8981, 114, 59, 32896, 55349, 56625, 1024, 101, 105, 107, 111, 16604, 16641, 16670, 16684, 835, 16609, 0, 16624, 101, 512, 52, 102, 16614, 16617, 59, 32768, 8756, 111, 114, 101, 59, 32768, 8756, 97, 768, 59, 115, 118, 16631, 16633, 16638, 32768, 952, 121, 109, 59, 32768, 977, 59, 32768, 977, 512, 99, 110, 16646, 16665, 107, 512, 97, 115, 16652, 16660, 112, 112, 114, 111, 120, 59, 32768, 8776, 105, 109, 59, 32768, 8764, 115, 112, 59, 32768, 8201, 512, 97, 115, 16675, 16679, 112, 59, 32768, 8776, 105, 109, 59, 32768, 8764, 114, 110, 33024, 254, 59, 32768, 254, 829, 16696, 16701, 16727, 100, 101, 59, 32768, 732, 101, 115, 33536, 215, 59, 98, 100, 16710, 16712, 16723, 32768, 215, 512, 59, 97, 16717, 16719, 32768, 8864, 114, 59, 32768, 10801, 59, 32768, 10800, 116, 59, 32768, 8749, 768, 101, 112, 115, 16737, 16741, 16775, 97, 59, 32768, 10536, 1024, 59, 98, 99, 102, 16750, 16752, 16757, 16762, 32768, 8868, 111, 116, 59, 32768, 9014, 105, 114, 59, 32768, 10993, 512, 59, 111, 16767, 16770, 32896, 55349, 56677, 114, 107, 59, 32768, 10970, 97, 59, 32768, 10537, 114, 105, 109, 101, 59, 32768, 8244, 768, 97, 105, 112, 16793, 16798, 16899, 100, 101, 59, 32768, 8482, 1792, 97, 100, 101, 109, 112, 115, 116, 16813, 16868, 16873, 16876, 16883, 16889, 16893, 110, 103, 108, 101, 1280, 59, 100, 108, 113, 114, 16828, 16830, 16836, 16850, 16853, 32768, 9653, 111, 119, 110, 59, 32768, 9663, 101, 102, 116, 512, 59, 101, 16844, 16846, 32768, 9667, 113, 59, 32768, 8884, 59, 32768, 8796, 105, 103, 104, 116, 512, 59, 101, 16862, 16864, 32768, 9657, 113, 59, 32768, 8885, 111, 116, 59, 32768, 9708, 59, 32768, 8796, 105, 110, 117, 115, 59, 32768, 10810, 108, 117, 115, 59, 32768, 10809, 98, 59, 32768, 10701, 105, 109, 101, 59, 32768, 10811, 101, 122, 105, 117, 109, 59, 32768, 9186, 768, 99, 104, 116, 16914, 16926, 16931, 512, 114, 121, 16919, 16923, 59, 32896, 55349, 56521, 59, 32768, 1094, 99, 121, 59, 32768, 1115, 114, 111, 107, 59, 32768, 359, 512, 105, 111, 16942, 16947, 120, 116, 59, 32768, 8812, 104, 101, 97, 100, 512, 108, 114, 16956, 16967, 101, 102, 116, 97, 114, 114, 111, 119, 59, 32768, 8606, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8608, 4608, 65, 72, 97, 98, 99, 100, 102, 103, 104, 108, 109, 111, 112, 114, 115, 116, 117, 119, 17016, 17021, 17026, 17043, 17057, 17072, 17095, 17110, 17119, 17139, 17172, 17187, 17202, 17290, 17330, 17336, 17365, 17381, 114, 114, 59, 32768, 8657, 97, 114, 59, 32768, 10595, 512, 99, 114, 17031, 17039, 117, 116, 101, 33024, 250, 59, 32768, 250, 114, 59, 32768, 8593, 114, 820, 17049, 0, 17053, 121, 59, 32768, 1118, 118, 101, 59, 32768, 365, 512, 105, 121, 17062, 17069, 114, 99, 33024, 251, 59, 32768, 251, 59, 32768, 1091, 768, 97, 98, 104, 17079, 17084, 17090, 114, 114, 59, 32768, 8645, 108, 97, 99, 59, 32768, 369, 97, 114, 59, 32768, 10606, 512, 105, 114, 17100, 17106, 115, 104, 116, 59, 32768, 10622, 59, 32896, 55349, 56626, 114, 97, 118, 101, 33024, 249, 59, 32768, 249, 562, 17123, 17135, 114, 512, 108, 114, 17128, 17131, 59, 32768, 8639, 59, 32768, 8638, 108, 107, 59, 32768, 9600, 512, 99, 116, 17144, 17167, 1088, 17150, 0, 0, 17163, 114, 110, 512, 59, 101, 17156, 17158, 32768, 8988, 114, 59, 32768, 8988, 111, 112, 59, 32768, 8975, 114, 105, 59, 32768, 9720, 512, 97, 108, 17177, 17182, 99, 114, 59, 32768, 363, 33024, 168, 59, 32768, 168, 512, 103, 112, 17192, 17197, 111, 110, 59, 32768, 371, 102, 59, 32896, 55349, 56678, 1536, 97, 100, 104, 108, 115, 117, 17215, 17222, 17233, 17257, 17262, 17280, 114, 114, 111, 119, 59, 32768, 8593, 111, 119, 110, 97, 114, 114, 111, 119, 59, 32768, 8597, 97, 114, 112, 111, 111, 110, 512, 108, 114, 17244, 17250, 101, 102, 116, 59, 32768, 8639, 105, 103, 104, 116, 59, 32768, 8638, 117, 115, 59, 32768, 8846, 105, 768, 59, 104, 108, 17270, 17272, 17275, 32768, 965, 59, 32768, 978, 111, 110, 59, 32768, 965, 112, 97, 114, 114, 111, 119, 115, 59, 32768, 8648, 768, 99, 105, 116, 17297, 17320, 17325, 1088, 17303, 0, 0, 17316, 114, 110, 512, 59, 101, 17309, 17311, 32768, 8989, 114, 59, 32768, 8989, 111, 112, 59, 32768, 8974, 110, 103, 59, 32768, 367, 114, 105, 59, 32768, 9721, 99, 114, 59, 32896, 55349, 56522, 768, 100, 105, 114, 17343, 17348, 17354, 111, 116, 59, 32768, 8944, 108, 100, 101, 59, 32768, 361, 105, 512, 59, 102, 17360, 17362, 32768, 9653, 59, 32768, 9652, 512, 97, 109, 17370, 17375, 114, 114, 59, 32768, 8648, 108, 33024, 252, 59, 32768, 252, 97, 110, 103, 108, 101, 59, 32768, 10663, 3840, 65, 66, 68, 97, 99, 100, 101, 102, 108, 110, 111, 112, 114, 115, 122, 17420, 17425, 17437, 17443, 17613, 17617, 17623, 17667, 17672, 17678, 17693, 17699, 17705, 17711, 17754, 114, 114, 59, 32768, 8661, 97, 114, 512, 59, 118, 17432, 17434, 32768, 10984, 59, 32768, 10985, 97, 115, 104, 59, 32768, 8872, 512, 110, 114, 17448, 17454, 103, 114, 116, 59, 32768, 10652, 1792, 101, 107, 110, 112, 114, 115, 116, 17469, 17478, 17485, 17494, 17515, 17526, 17578, 112, 115, 105, 108, 111, 110, 59, 32768, 1013, 97, 112, 112, 97, 59, 32768, 1008, 111, 116, 104, 105, 110, 103, 59, 32768, 8709, 768, 104, 105, 114, 17501, 17505, 17508, 105, 59, 32768, 981, 59, 32768, 982, 111, 112, 116, 111, 59, 32768, 8733, 512, 59, 104, 17520, 17522, 32768, 8597, 111, 59, 32768, 1009, 512, 105, 117, 17531, 17537, 103, 109, 97, 59, 32768, 962, 512, 98, 112, 17542, 17560, 115, 101, 116, 110, 101, 113, 512, 59, 113, 17553, 17556, 32896, 8842, 65024, 59, 32896, 10955, 65024, 115, 101, 116, 110, 101, 113, 512, 59, 113, 17571, 17574, 32896, 8843, 65024, 59, 32896, 10956, 65024, 512, 104, 114, 17583, 17589, 101, 116, 97, 59, 32768, 977, 105, 97, 110, 103, 108, 101, 512, 108, 114, 17600, 17606, 101, 102, 116, 59, 32768, 8882, 105, 103, 104, 116, 59, 32768, 8883, 121, 59, 32768, 1074, 97, 115, 104, 59, 32768, 8866, 768, 101, 108, 114, 17630, 17648, 17654, 768, 59, 98, 101, 17637, 17639, 17644, 32768, 8744, 97, 114, 59, 32768, 8891, 113, 59, 32768, 8794, 108, 105, 112, 59, 32768, 8942, 512, 98, 116, 17659, 17664, 97, 114, 59, 32768, 124, 59, 32768, 124, 114, 59, 32896, 55349, 56627, 116, 114, 105, 59, 32768, 8882, 115, 117, 512, 98, 112, 17685, 17689, 59, 32896, 8834, 8402, 59, 32896, 8835, 8402, 112, 102, 59, 32896, 55349, 56679, 114, 111, 112, 59, 32768, 8733, 116, 114, 105, 59, 32768, 8883, 512, 99, 117, 17716, 17721, 114, 59, 32896, 55349, 56523, 512, 98, 112, 17726, 17740, 110, 512, 69, 101, 17732, 17736, 59, 32896, 10955, 65024, 59, 32896, 8842, 65024, 110, 512, 69, 101, 17746, 17750, 59, 32896, 10956, 65024, 59, 32896, 8843, 65024, 105, 103, 122, 97, 103, 59, 32768, 10650, 1792, 99, 101, 102, 111, 112, 114, 115, 17777, 17783, 17815, 17820, 17826, 17829, 17842, 105, 114, 99, 59, 32768, 373, 512, 100, 105, 17788, 17809, 512, 98, 103, 17793, 17798, 97, 114, 59, 32768, 10847, 101, 512, 59, 113, 17804, 17806, 32768, 8743, 59, 32768, 8793, 101, 114, 112, 59, 32768, 8472, 114, 59, 32896, 55349, 56628, 112, 102, 59, 32896, 55349, 56680, 59, 32768, 8472, 512, 59, 101, 17834, 17836, 32768, 8768, 97, 116, 104, 59, 32768, 8768, 99, 114, 59, 32896, 55349, 56524, 5428, 17871, 17891, 0, 17897, 0, 17902, 17917, 0, 0, 17920, 17935, 17940, 17945, 0, 0, 17977, 17992, 0, 18008, 18024, 18029, 768, 97, 105, 117, 17877, 17881, 17886, 112, 59, 32768, 8898, 114, 99, 59, 32768, 9711, 112, 59, 32768, 8899, 116, 114, 105, 59, 32768, 9661, 114, 59, 32896, 55349, 56629, 512, 65, 97, 17906, 17911, 114, 114, 59, 32768, 10234, 114, 114, 59, 32768, 10231, 59, 32768, 958, 512, 65, 97, 17924, 17929, 114, 114, 59, 32768, 10232, 114, 114, 59, 32768, 10229, 97, 112, 59, 32768, 10236, 105, 115, 59, 32768, 8955, 768, 100, 112, 116, 17951, 17956, 17970, 111, 116, 59, 32768, 10752, 512, 102, 108, 17961, 17965, 59, 32896, 55349, 56681, 117, 115, 59, 32768, 10753, 105, 109, 101, 59, 32768, 10754, 512, 65, 97, 17981, 17986, 114, 114, 59, 32768, 10233, 114, 114, 59, 32768, 10230, 512, 99, 113, 17996, 18001, 114, 59, 32896, 55349, 56525, 99, 117, 112, 59, 32768, 10758, 512, 112, 116, 18012, 18018, 108, 117, 115, 59, 32768, 10756, 114, 105, 59, 32768, 9651, 101, 101, 59, 32768, 8897, 101, 100, 103, 101, 59, 32768, 8896, 2048, 97, 99, 101, 102, 105, 111, 115, 117, 18052, 18068, 18081, 18087, 18092, 18097, 18103, 18109, 99, 512, 117, 121, 18058, 18065, 116, 101, 33024, 253, 59, 32768, 253, 59, 32768, 1103, 512, 105, 121, 18073, 18078, 114, 99, 59, 32768, 375, 59, 32768, 1099, 110, 33024, 165, 59, 32768, 165, 114, 59, 32896, 55349, 56630, 99, 121, 59, 32768, 1111, 112, 102, 59, 32896, 55349, 56682, 99, 114, 59, 32896, 55349, 56526, 512, 99, 109, 18114, 18118, 121, 59, 32768, 1102, 108, 33024, 255, 59, 32768, 255, 2560, 97, 99, 100, 101, 102, 104, 105, 111, 115, 119, 18145, 18152, 18166, 18171, 18186, 18191, 18196, 18204, 18210, 18216, 99, 117, 116, 101, 59, 32768, 378, 512, 97, 121, 18157, 18163, 114, 111, 110, 59, 32768, 382, 59, 32768, 1079, 111, 116, 59, 32768, 380, 512, 101, 116, 18176, 18182, 116, 114, 102, 59, 32768, 8488, 97, 59, 32768, 950, 114, 59, 32896, 55349, 56631, 99, 121, 59, 32768, 1078, 103, 114, 97, 114, 114, 59, 32768, 8669, 112, 102, 59, 32896, 55349, 56683, 99, 114, 59, 32896, 55349, 56527, 512, 106, 110, 18221, 18224, 59, 32768, 8205, 106, 59, 32768, 8204]);

var decodeDataXml = {};

Object.defineProperty(decodeDataXml, "__esModule", { value: true });
decodeDataXml.default = new Uint16Array([1024, 97, 103, 108, 113, 9, 23, 27, 31, 1086, 15, 0, 0, 19, 112, 59, 32768, 38, 111, 115, 59, 32768, 39, 116, 59, 32768, 62, 116, 59, 32768, 60, 117, 111, 116, 59, 32768, 34]);

(function (exports) {
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeXML = exports.decodeHTMLStrict = exports.decodeHTML = exports.determineBranch = exports.JUMP_OFFSET_BASE = exports.BinTrieFlags = exports.xmlDecodeTree = exports.htmlDecodeTree = void 0;
var decode_data_html_1 = __importDefault(decodeDataHtml);
exports.htmlDecodeTree = decode_data_html_1.default;
var decode_data_xml_1 = __importDefault(decodeDataXml);
exports.xmlDecodeTree = decode_data_xml_1.default;
var decode_codepoint_1 = __importDefault(decode_codepoint);
var BinTrieFlags;
(function (BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["HAS_VALUE"] = 32768] = "HAS_VALUE";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 32512] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["MULTI_BYTE"] = 128] = "MULTI_BYTE";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})(BinTrieFlags = exports.BinTrieFlags || (exports.BinTrieFlags = {}));
exports.JUMP_OFFSET_BASE = 48  - 1;
function getDecoder(decodeTree) {
    return function decodeHTMLBinary(str, strict) {
        var ret = "";
        var lastIdx = 0;
        var strIdx = 0;
        while ((strIdx = str.indexOf("&", strIdx)) >= 0) {
            ret += str.slice(lastIdx, strIdx);
            lastIdx = strIdx;
            strIdx += 1;
            if (str.charCodeAt(strIdx) === 35 ) {
                var start = strIdx + 1;
                var base = 10;
                var cp = str.charCodeAt(start);
                if ((cp | 32 ) === 120 ) {
                    base = 16;
                    strIdx += 1;
                    start += 1;
                }
                while (((cp = str.charCodeAt(++strIdx)) >= 48  &&
                    cp <= 57 ) ||
                    (base === 16 &&
                        (cp | 32 ) >= 97  &&
                        (cp | 32 ) <= 102 ))
                    ;
                if (start !== strIdx) {
                    var entity = str.substring(start, strIdx);
                    var parsed = parseInt(entity, base);
                    if (str.charCodeAt(strIdx) === 59 ) {
                        strIdx += 1;
                    }
                    else if (strict) {
                        continue;
                    }
                    ret += decode_codepoint_1.default(parsed);
                    lastIdx = strIdx;
                }
                continue;
            }
            var result = null;
            var excess = 1;
            var treeIdx = 0;
            var current = decodeTree[treeIdx];
            for (; strIdx < str.length; strIdx++, excess++) {
                treeIdx = determineBranch(decodeTree, current, treeIdx + 1, str.charCodeAt(strIdx));
                if (treeIdx < 0)
                    break;
                current = decodeTree[treeIdx];
                if (current & BinTrieFlags.HAS_VALUE) {
                    if (strict && str.charCodeAt(strIdx) !== 59 ) {
                        treeIdx += 1;
                    }
                    else {
                        result =
                            current & BinTrieFlags.MULTI_BYTE
                                ? String.fromCharCode(decodeTree[++treeIdx], decodeTree[++treeIdx])
                                : String.fromCharCode(decodeTree[++treeIdx]);
                        excess = 0;
                    }
                }
            }
            if (result != null) {
                ret += result;
                lastIdx = strIdx - excess + 1;
            }
        }
        return ret + str.slice(lastIdx);
    };
}
function determineBranch(decodeTree, current, nodeIdx, char) {
    if (current <= 128) {
        return char === current ? nodeIdx : -1;
    }
    var branchCount = (current & BinTrieFlags.BRANCH_LENGTH) >> 8;
    if (branchCount === 0) {
        return -1;
    }
    if (branchCount === 1) {
        return char === decodeTree[nodeIdx] ? nodeIdx + 1 : -1;
    }
    var jumpOffset = current & BinTrieFlags.JUMP_TABLE;
    if (jumpOffset) {
        var value = char - exports.JUMP_OFFSET_BASE - jumpOffset;
        return value < 0 || value > branchCount
            ? -1
            : decodeTree[nodeIdx + value] - 1;
    }
    var lo = nodeIdx;
    var hi = lo + branchCount - 1;
    while (lo <= hi) {
        var mid = (lo + hi) >>> 1;
        var midVal = decodeTree[mid];
        if (midVal < char) {
            lo = mid + 1;
        }
        else if (midVal > char) {
            hi = mid - 1;
        }
        else {
            return decodeTree[mid + branchCount];
        }
    }
    return -1;
}
exports.determineBranch = determineBranch;
var htmlDecoder = getDecoder(decode_data_html_1.default);
var xmlDecoder = getDecoder(decode_data_xml_1.default);
function decodeHTML(str) {
    return htmlDecoder(str, false);
}
exports.decodeHTML = decodeHTML;
function decodeHTMLStrict(str) {
    return htmlDecoder(str, true);
}
exports.decodeHTMLStrict = decodeHTMLStrict;
function decodeXML(str) {
    return xmlDecoder(str, true);
}
exports.decodeXML = decodeXML;
}(decode));
getDefaultExportFromCjs(decode);

var __importDefault$2 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(Tokenizer$1, "__esModule", { value: true });
var decode_codepoint_1 = __importDefault$2(decode_codepoint);
var decode_1 = decode;
function isWhitespace(c) {
    return (c === 32  ||
        c === 10  ||
        c === 9  ||
        c === 12  ||
        c === 13 );
}
function isEndOfTagSection(c) {
    return c === 47  || c === 62  || isWhitespace(c);
}
function isNumber$1(c) {
    return c >= 48  && c <= 57 ;
}
function isASCIIAlpha(c) {
    return ((c >= 97  && c <= 122 ) ||
        (c >= 65  && c <= 90 ));
}
var Sequences = {
    Cdata: new Uint16Array([0x43, 0x44, 0x41, 0x54, 0x41, 0x5b]),
    CdataEnd: new Uint16Array([0x5d, 0x5d, 0x3e]),
    CommentEnd: new Uint16Array([0x2d, 0x2d, 0x3e]),
    ScriptEnd: new Uint16Array([
        0x3c, 0x2f, 0x73, 0x63, 0x72, 0x69, 0x70, 0x74,
    ]),
    StyleEnd: new Uint16Array([0x3c, 0x2f, 0x73, 0x74, 0x79, 0x6c, 0x65]),
    TitleEnd: new Uint16Array([0x3c, 0x2f, 0x74, 0x69, 0x74, 0x6c, 0x65]),
};
var Tokenizer =  (function () {
    function Tokenizer(_a, cbs) {
        var _b = _a.xmlMode, xmlMode = _b === void 0 ? false : _b, _c = _a.decodeEntities, decodeEntities = _c === void 0 ? true : _c;
        this.cbs = cbs;
        this._state = 1 ;
        this.buffer = "";
        this.sectionStart = 0;
        this._index = 0;
        this.bufferOffset = 0;
        this.baseState = 1 ;
        this.isSpecial = false;
        this.running = true;
        this.ended = false;
        this.sequenceIndex = 0;
        this.trieIndex = 0;
        this.trieCurrent = 0;
        this.trieResult = null;
        this.entityExcess = 0;
        this.xmlMode = xmlMode;
        this.decodeEntities = decodeEntities;
        this.entityTrie = xmlMode ? decode_1.xmlDecodeTree : decode_1.htmlDecodeTree;
    }
    Tokenizer.prototype.reset = function () {
        this._state = 1 ;
        this.buffer = "";
        this.sectionStart = 0;
        this._index = 0;
        this.bufferOffset = 0;
        this.baseState = 1 ;
        this.currentSequence = undefined;
        this.running = true;
        this.ended = false;
    };
    Tokenizer.prototype.write = function (chunk) {
        if (this.ended)
            return this.cbs.onerror(Error(".write() after done!"));
        this.buffer += chunk;
        this.parse();
    };
    Tokenizer.prototype.end = function (chunk) {
        if (this.ended)
            return this.cbs.onerror(Error(".end() after done!"));
        if (chunk)
            this.write(chunk);
        this.ended = true;
        if (this.running)
            this.finish();
    };
    Tokenizer.prototype.pause = function () {
        this.running = false;
    };
    Tokenizer.prototype.resume = function () {
        this.running = true;
        if (this._index < this.buffer.length) {
            this.parse();
        }
        if (this.ended) {
            this.finish();
        }
    };
    Tokenizer.prototype.getAbsoluteSectionStart = function () {
        return this.sectionStart + this.bufferOffset;
    };
    Tokenizer.prototype.getAbsoluteIndex = function () {
        return this.bufferOffset + this._index;
    };
    Tokenizer.prototype.stateText = function (c) {
        if (c === 60  ||
            (!this.decodeEntities && this.fastForwardTo(60 ))) {
            if (this._index > this.sectionStart) {
                this.cbs.ontext(this.getSection());
            }
            this._state = 2 ;
            this.sectionStart = this._index;
        }
        else if (this.decodeEntities && c === 38 ) {
            this._state = 25 ;
        }
    };
    Tokenizer.prototype.stateSpecialStartSequence = function (c) {
        var isEnd = this.sequenceIndex === this.currentSequence.length;
        var isMatch = isEnd
            ?
                isEndOfTagSection(c)
            :
                (c | 0x20) === this.currentSequence[this.sequenceIndex];
        if (!isMatch) {
            this.isSpecial = false;
        }
        else if (!isEnd) {
            this.sequenceIndex++;
            return;
        }
        this.sequenceIndex = 0;
        this._state = 3 ;
        this.stateInTagName(c);
    };
    Tokenizer.prototype.stateInSpecialTag = function (c) {
        if (this.sequenceIndex === this.currentSequence.length) {
            if (c === 62  || isWhitespace(c)) {
                var endOfText = this._index - this.currentSequence.length;
                if (this.sectionStart < endOfText) {
                    var actualIndex = this._index;
                    this._index = endOfText;
                    this.cbs.ontext(this.getSection());
                    this._index = actualIndex;
                }
                this.isSpecial = false;
                this.sectionStart = endOfText + 2;
                this.stateInClosingTagName(c);
                return;
            }
            this.sequenceIndex = 0;
        }
        if ((c | 0x20) === this.currentSequence[this.sequenceIndex]) {
            this.sequenceIndex += 1;
        }
        else if (this.sequenceIndex === 0) {
            if (this.currentSequence === Sequences.TitleEnd) {
                if (this.decodeEntities && c === 38 ) {
                    this._state = 25 ;
                }
            }
            else if (this.fastForwardTo(60 )) {
                this.sequenceIndex = 1;
            }
        }
        else {
            this.sequenceIndex = Number(c === 60 );
        }
    };
    Tokenizer.prototype.stateCDATASequence = function (c) {
        if (c === Sequences.Cdata[this.sequenceIndex]) {
            if (++this.sequenceIndex === Sequences.Cdata.length) {
                this._state = 21 ;
                this.currentSequence = Sequences.CdataEnd;
                this.sequenceIndex = 0;
                this.sectionStart = this._index + 1;
            }
        }
        else {
            this.sequenceIndex = 0;
            this._state = 16 ;
            this.stateInDeclaration(c);
        }
    };
    Tokenizer.prototype.fastForwardTo = function (c) {
        while (++this._index < this.buffer.length) {
            if (this.buffer.charCodeAt(this._index) === c) {
                return true;
            }
        }
        this._index = this.buffer.length - 1;
        return false;
    };
    Tokenizer.prototype.stateInCommentLike = function (c) {
        if (c === this.currentSequence[this.sequenceIndex]) {
            if (++this.sequenceIndex === this.currentSequence.length) {
                var section = this.buffer.slice(this.sectionStart, this._index - 2);
                if (this.currentSequence === Sequences.CdataEnd) {
                    this.cbs.oncdata(section);
                }
                else {
                    this.cbs.oncomment(section);
                }
                this.sequenceIndex = 0;
                this.sectionStart = this._index + 1;
                this._state = 1 ;
            }
        }
        else if (this.sequenceIndex === 0) {
            if (this.fastForwardTo(this.currentSequence[0])) {
                this.sequenceIndex = 1;
            }
        }
        else if (c !== this.currentSequence[this.sequenceIndex - 1]) {
            this.sequenceIndex = 0;
        }
    };
    Tokenizer.prototype.isTagStartChar = function (c) {
        return this.xmlMode ? !isEndOfTagSection(c) : isASCIIAlpha(c);
    };
    Tokenizer.prototype.startSpecial = function (sequence, offset) {
        this.isSpecial = true;
        this.currentSequence = sequence;
        this.sequenceIndex = offset;
        this._state = 23 ;
    };
    Tokenizer.prototype.stateBeforeTagName = function (c) {
        if (c === 33 ) {
            this._state = 15 ;
            this.sectionStart = this._index + 1;
        }
        else if (c === 63 ) {
            this._state = 17 ;
            this.sectionStart = this._index + 1;
        }
        else if (this.isTagStartChar(c)) {
            var lower = c | 0x20;
            this.sectionStart = this._index;
            if (!this.xmlMode && lower === Sequences.TitleEnd[2]) {
                this.startSpecial(Sequences.TitleEnd, 3);
            }
            else {
                this._state =
                    !this.xmlMode && lower === Sequences.ScriptEnd[2]
                        ? 22
                        : 3 ;
            }
        }
        else if (c === 47 ) {
            this._state = 5 ;
        }
        else {
            this._state = 1 ;
            this.stateText(c);
        }
    };
    Tokenizer.prototype.stateInTagName = function (c) {
        if (isEndOfTagSection(c)) {
            this.cbs.onopentagname(this.getSection());
            this.sectionStart = -1;
            this._state = 8 ;
            this.stateBeforeAttributeName(c);
        }
    };
    Tokenizer.prototype.stateBeforeClosingTagName = function (c) {
        if (isWhitespace(c)) ;
        else if (c === 62 ) {
            this._state = 1 ;
        }
        else {
            this._state = this.isTagStartChar(c)
                ? 6
                : 20 ;
            this.sectionStart = this._index;
        }
    };
    Tokenizer.prototype.stateInClosingTagName = function (c) {
        if (c === 62  || isWhitespace(c)) {
            this.cbs.onclosetag(this.getSection());
            this.sectionStart = -1;
            this._state = 7 ;
            this.stateAfterClosingTagName(c);
        }
    };
    Tokenizer.prototype.stateAfterClosingTagName = function (c) {
        if (c === 62  || this.fastForwardTo(62 )) {
            this._state = 1 ;
            this.sectionStart = this._index + 1;
        }
    };
    Tokenizer.prototype.stateBeforeAttributeName = function (c) {
        if (c === 62 ) {
            this.cbs.onopentagend();
            if (this.isSpecial) {
                this._state = 24 ;
                this.sequenceIndex = 0;
            }
            else {
                this._state = 1 ;
            }
            this.baseState = this._state;
            this.sectionStart = this._index + 1;
        }
        else if (c === 47 ) {
            this._state = 4 ;
        }
        else if (!isWhitespace(c)) {
            this._state = 9 ;
            this.sectionStart = this._index;
        }
    };
    Tokenizer.prototype.stateInSelfClosingTag = function (c) {
        if (c === 62 ) {
            this.cbs.onselfclosingtag();
            this._state = 1 ;
            this.baseState = 1 ;
            this.sectionStart = this._index + 1;
            this.isSpecial = false;
        }
        else if (!isWhitespace(c)) {
            this._state = 8 ;
            this.stateBeforeAttributeName(c);
        }
    };
    Tokenizer.prototype.stateInAttributeName = function (c) {
        if (c === 61  || isEndOfTagSection(c)) {
            this.cbs.onattribname(this.getSection());
            this.sectionStart = -1;
            this._state = 10 ;
            this.stateAfterAttributeName(c);
        }
    };
    Tokenizer.prototype.stateAfterAttributeName = function (c) {
        if (c === 61 ) {
            this._state = 11 ;
        }
        else if (c === 47  || c === 62 ) {
            this.cbs.onattribend(undefined);
            this._state = 8 ;
            this.stateBeforeAttributeName(c);
        }
        else if (!isWhitespace(c)) {
            this.cbs.onattribend(undefined);
            this._state = 9 ;
            this.sectionStart = this._index;
        }
    };
    Tokenizer.prototype.stateBeforeAttributeValue = function (c) {
        if (c === 34 ) {
            this._state = 12 ;
            this.sectionStart = this._index + 1;
        }
        else if (c === 39 ) {
            this._state = 13 ;
            this.sectionStart = this._index + 1;
        }
        else if (!isWhitespace(c)) {
            this.sectionStart = this._index;
            this._state = 14 ;
            this.stateInAttributeValueNoQuotes(c);
        }
    };
    Tokenizer.prototype.handleInAttributeValue = function (c, quote) {
        if (c === quote ||
            (!this.decodeEntities && this.fastForwardTo(quote))) {
            this.cbs.onattribdata(this.getSection());
            this.sectionStart = -1;
            this.cbs.onattribend(String.fromCharCode(quote));
            this._state = 8 ;
        }
        else if (this.decodeEntities && c === 38 ) {
            this.baseState = this._state;
            this._state = 25 ;
        }
    };
    Tokenizer.prototype.stateInAttributeValueDoubleQuotes = function (c) {
        this.handleInAttributeValue(c, 34 );
    };
    Tokenizer.prototype.stateInAttributeValueSingleQuotes = function (c) {
        this.handleInAttributeValue(c, 39 );
    };
    Tokenizer.prototype.stateInAttributeValueNoQuotes = function (c) {
        if (isWhitespace(c) || c === 62 ) {
            this.cbs.onattribdata(this.getSection());
            this.sectionStart = -1;
            this.cbs.onattribend(null);
            this._state = 8 ;
            this.stateBeforeAttributeName(c);
        }
        else if (this.decodeEntities && c === 38 ) {
            this.baseState = this._state;
            this._state = 25 ;
        }
    };
    Tokenizer.prototype.stateBeforeDeclaration = function (c) {
        if (c === 91 ) {
            this._state = 19 ;
            this.sequenceIndex = 0;
        }
        else {
            this._state =
                c === 45
                    ? 18
                    : 16 ;
        }
    };
    Tokenizer.prototype.stateInDeclaration = function (c) {
        if (c === 62  || this.fastForwardTo(62 )) {
            this.cbs.ondeclaration(this.getSection());
            this._state = 1 ;
            this.sectionStart = this._index + 1;
        }
    };
    Tokenizer.prototype.stateInProcessingInstruction = function (c) {
        if (c === 62  || this.fastForwardTo(62 )) {
            this.cbs.onprocessinginstruction(this.getSection());
            this._state = 1 ;
            this.sectionStart = this._index + 1;
        }
    };
    Tokenizer.prototype.stateBeforeComment = function (c) {
        if (c === 45 ) {
            this._state = 21 ;
            this.currentSequence = Sequences.CommentEnd;
            this.sequenceIndex = 2;
            this.sectionStart = this._index + 1;
        }
        else {
            this._state = 16 ;
        }
    };
    Tokenizer.prototype.stateInSpecialComment = function (c) {
        if (c === 62  || this.fastForwardTo(62 )) {
            this.cbs.oncomment(this.getSection());
            this._state = 1 ;
            this.sectionStart = this._index + 1;
        }
    };
    Tokenizer.prototype.stateBeforeSpecialS = function (c) {
        var lower = c | 0x20;
        if (lower === Sequences.ScriptEnd[3]) {
            this.startSpecial(Sequences.ScriptEnd, 4);
        }
        else if (lower === Sequences.StyleEnd[3]) {
            this.startSpecial(Sequences.StyleEnd, 4);
        }
        else {
            this._state = 3 ;
            this.stateInTagName(c);
        }
    };
    Tokenizer.prototype.stateBeforeEntity = function (c) {
        this.entityExcess = 1;
        if (c === 35 ) {
            this._state = 26 ;
        }
        else if (c === 38 ) ;
        else {
            this.trieIndex = 0;
            this.trieCurrent = this.entityTrie[0];
            this.trieResult = null;
            this._state = 27 ;
            this.stateInNamedEntity(c);
        }
    };
    Tokenizer.prototype.stateInNamedEntity = function (c) {
        this.entityExcess += 1;
        this.trieIndex = (0, decode_1.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, c);
        if (this.trieIndex < 0) {
            this.emitNamedEntity();
            this._index--;
            return;
        }
        this.trieCurrent = this.entityTrie[this.trieIndex];
        if (this.trieCurrent & decode_1.BinTrieFlags.HAS_VALUE) {
            if (!this.allowLegacyEntity() && c !== 59 ) {
                this.trieIndex += 1;
            }
            else {
                var entityStart = this._index - this.entityExcess + 1;
                if (entityStart > this.sectionStart) {
                    this.emitPartial(this.buffer.substring(this.sectionStart, entityStart));
                }
                this.trieResult =
                    this.trieCurrent & decode_1.BinTrieFlags.MULTI_BYTE
                        ? String.fromCharCode(this.entityTrie[++this.trieIndex], this.entityTrie[++this.trieIndex])
                        : String.fromCharCode(this.entityTrie[++this.trieIndex]);
                this.entityExcess = 0;
                this.sectionStart = this._index + 1;
            }
        }
    };
    Tokenizer.prototype.emitNamedEntity = function () {
        if (this.trieResult) {
            this.emitPartial(this.trieResult);
        }
        this._state = this.baseState;
    };
    Tokenizer.prototype.stateBeforeNumericEntity = function (c) {
        if ((c | 0x20) === 120 ) {
            this.entityExcess++;
            this._state = 29 ;
        }
        else {
            this._state = 28 ;
            this.stateInNumericEntity(c);
        }
    };
    Tokenizer.prototype.decodeNumericEntity = function (base, strict) {
        var entityStart = this._index - this.entityExcess - 1;
        var numberStart = entityStart + 2 + (base >> 4);
        if (numberStart !== this._index) {
            if (entityStart > this.sectionStart) {
                this.emitPartial(this.buffer.substring(this.sectionStart, entityStart));
            }
            var entity = this.buffer.substring(numberStart, this._index);
            var parsed = parseInt(entity, base);
            this.emitPartial((0, decode_codepoint_1.default)(parsed));
            this.sectionStart = this._index + Number(strict);
        }
        this._state = this.baseState;
    };
    Tokenizer.prototype.stateInNumericEntity = function (c) {
        if (c === 59 ) {
            this.decodeNumericEntity(10, true);
        }
        else if (!isNumber$1(c)) {
            if (this.allowLegacyEntity()) {
                this.decodeNumericEntity(10, false);
            }
            else {
                this._state = this.baseState;
            }
            this._index--;
        }
        else {
            this.entityExcess++;
        }
    };
    Tokenizer.prototype.stateInHexEntity = function (c) {
        if (c === 59 ) {
            this.decodeNumericEntity(16, true);
        }
        else if ((c < 97  || c > 102 ) &&
            (c < 65  || c > 70 ) &&
            !isNumber$1(c)) {
            if (this.allowLegacyEntity()) {
                this.decodeNumericEntity(16, false);
            }
            else {
                this._state = this.baseState;
            }
            this._index--;
        }
        else {
            this.entityExcess++;
        }
    };
    Tokenizer.prototype.allowLegacyEntity = function () {
        return (!this.xmlMode &&
            (this.baseState === 1  ||
                this.baseState === 24 ));
    };
    Tokenizer.prototype.cleanup = function () {
        if (this.running &&
            this.sectionStart !== this._index &&
            (this._state === 1  ||
                (this._state === 24  &&
                    this.sequenceIndex === 0))) {
            this.cbs.ontext(this.buffer.substr(this.sectionStart));
            this.sectionStart = this._index;
        }
        var start = this.sectionStart < 0 ? this._index : this.sectionStart;
        this.buffer =
            start === this.buffer.length ? "" : this.buffer.substr(start);
        this._index -= start;
        this.bufferOffset += start;
        if (this.sectionStart > 0) {
            this.sectionStart = 0;
        }
    };
    Tokenizer.prototype.shouldContinue = function () {
        return this._index < this.buffer.length && this.running;
    };
    Tokenizer.prototype.parse = function () {
        while (this.shouldContinue()) {
            var c = this.buffer.charCodeAt(this._index);
            if (this._state === 1 ) {
                this.stateText(c);
            }
            else if (this._state === 23 ) {
                this.stateSpecialStartSequence(c);
            }
            else if (this._state === 24 ) {
                this.stateInSpecialTag(c);
            }
            else if (this._state === 19 ) {
                this.stateCDATASequence(c);
            }
            else if (this._state === 12 ) {
                this.stateInAttributeValueDoubleQuotes(c);
            }
            else if (this._state === 9 ) {
                this.stateInAttributeName(c);
            }
            else if (this._state === 21 ) {
                this.stateInCommentLike(c);
            }
            else if (this._state === 20 ) {
                this.stateInSpecialComment(c);
            }
            else if (this._state === 8 ) {
                this.stateBeforeAttributeName(c);
            }
            else if (this._state === 3 ) {
                this.stateInTagName(c);
            }
            else if (this._state === 6 ) {
                this.stateInClosingTagName(c);
            }
            else if (this._state === 2 ) {
                this.stateBeforeTagName(c);
            }
            else if (this._state === 10 ) {
                this.stateAfterAttributeName(c);
            }
            else if (this._state === 13 ) {
                this.stateInAttributeValueSingleQuotes(c);
            }
            else if (this._state === 11 ) {
                this.stateBeforeAttributeValue(c);
            }
            else if (this._state === 5 ) {
                this.stateBeforeClosingTagName(c);
            }
            else if (this._state === 7 ) {
                this.stateAfterClosingTagName(c);
            }
            else if (this._state === 22 ) {
                this.stateBeforeSpecialS(c);
            }
            else if (this._state === 14 ) {
                this.stateInAttributeValueNoQuotes(c);
            }
            else if (this._state === 4 ) {
                this.stateInSelfClosingTag(c);
            }
            else if (this._state === 16 ) {
                this.stateInDeclaration(c);
            }
            else if (this._state === 15 ) {
                this.stateBeforeDeclaration(c);
            }
            else if (this._state === 18 ) {
                this.stateBeforeComment(c);
            }
            else if (this._state === 17 ) {
                this.stateInProcessingInstruction(c);
            }
            else if (this._state === 27 ) {
                this.stateInNamedEntity(c);
            }
            else if (this._state === 25 ) {
                this.stateBeforeEntity(c);
            }
            else if (this._state === 29 ) {
                this.stateInHexEntity(c);
            }
            else if (this._state === 28 ) {
                this.stateInNumericEntity(c);
            }
            else {
                this.stateBeforeNumericEntity(c);
            }
            this._index++;
        }
        this.cleanup();
    };
    Tokenizer.prototype.finish = function () {
        if (this._state === 27 ) {
            this.emitNamedEntity();
        }
        if (this.sectionStart < this._index) {
            this.handleTrailingData();
        }
        this.cbs.onend();
    };
    Tokenizer.prototype.handleTrailingData = function () {
        var data = this.buffer.substr(this.sectionStart);
        if (this._state === 21 ) {
            if (this.currentSequence === Sequences.CdataEnd) {
                this.cbs.oncdata(data);
            }
            else {
                this.cbs.oncomment(data);
            }
        }
        else if (this._state === 28  &&
            this.allowLegacyEntity()) {
            this.decodeNumericEntity(10, false);
        }
        else if (this._state === 29  &&
            this.allowLegacyEntity()) {
            this.decodeNumericEntity(16, false);
        }
        else if (this._state === 3  ||
            this._state === 8  ||
            this._state === 11  ||
            this._state === 10  ||
            this._state === 9  ||
            this._state === 13  ||
            this._state === 12  ||
            this._state === 14  ||
            this._state === 6 ) ;
        else {
            this.cbs.ontext(data);
        }
    };
    Tokenizer.prototype.getSection = function () {
        return this.buffer.substring(this.sectionStart, this._index);
    };
    Tokenizer.prototype.emitPartial = function (value) {
        if (this.baseState !== 1  &&
            this.baseState !== 24 ) {
            this.cbs.onattribdata(value);
        }
        else {
            this.cbs.ontext(value);
        }
    };
    return Tokenizer;
}());
Tokenizer$1.default = Tokenizer;

var __importDefault$1 = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(Parser$2, "__esModule", { value: true });
Parser$2.Parser = void 0;
var Tokenizer_1 = __importDefault$1(Tokenizer$1);
var formTags = new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea",
]);
var pTag = new Set(["p"]);
var tableSectionTags = new Set(["thead", "tbody"]);
var ddtTags = new Set(["dd", "dt"]);
var rtpTags = new Set(["rt", "rp"]);
var openImpliesClose = new Map([
    ["tr", new Set(["tr", "th", "td"])],
    ["th", new Set(["th"])],
    ["td", new Set(["thead", "th", "td"])],
    ["body", new Set(["head", "link", "script"])],
    ["li", new Set(["li"])],
    ["p", pTag],
    ["h1", pTag],
    ["h2", pTag],
    ["h3", pTag],
    ["h4", pTag],
    ["h5", pTag],
    ["h6", pTag],
    ["select", formTags],
    ["input", formTags],
    ["output", formTags],
    ["button", formTags],
    ["datalist", formTags],
    ["textarea", formTags],
    ["option", new Set(["option"])],
    ["optgroup", new Set(["optgroup", "option"])],
    ["dd", ddtTags],
    ["dt", ddtTags],
    ["address", pTag],
    ["article", pTag],
    ["aside", pTag],
    ["blockquote", pTag],
    ["details", pTag],
    ["div", pTag],
    ["dl", pTag],
    ["fieldset", pTag],
    ["figcaption", pTag],
    ["figure", pTag],
    ["footer", pTag],
    ["form", pTag],
    ["header", pTag],
    ["hr", pTag],
    ["main", pTag],
    ["nav", pTag],
    ["ol", pTag],
    ["pre", pTag],
    ["section", pTag],
    ["table", pTag],
    ["ul", pTag],
    ["rt", rtpTags],
    ["rp", rtpTags],
    ["tbody", tableSectionTags],
    ["tfoot", tableSectionTags],
]);
var voidElements = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr",
]);
var foreignContextElements = new Set(["math", "svg"]);
var htmlIntegrationElements = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title",
]);
var reNameEnd = /\s|\//;
var Parser$1 =  (function () {
    function Parser(cbs, options) {
        if (options === void 0) { options = {}; }
        var _a, _b, _c, _d, _e;
        this.options = options;
        this.startIndex = 0;
        this.endIndex = 0;
        this.openTagStart = 0;
        this.tagname = "";
        this.attribname = "";
        this.attribvalue = "";
        this.attribs = null;
        this.stack = [];
        this.foreignContext = [];
        this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
        this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : !options.xmlMode;
        this.lowerCaseAttributeNames =
            (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : !options.xmlMode;
        this.tokenizer = new ((_c = options.Tokenizer) !== null && _c !== void 0 ? _c : Tokenizer_1.default)(this.options, this);
        (_e = (_d = this.cbs).onparserinit) === null || _e === void 0 ? void 0 : _e.call(_d, this);
    }
    Parser.prototype.ontext = function (data) {
        var _a, _b;
        var idx = this.tokenizer.getAbsoluteIndex();
        this.endIndex = idx - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 ? void 0 : _b.call(_a, data);
        this.startIndex = idx;
    };
    Parser.prototype.isVoidElement = function (name) {
        return !this.options.xmlMode && voidElements.has(name);
    };
    Parser.prototype.onopentagname = function (name) {
        this.endIndex = this.tokenizer.getAbsoluteIndex();
        if (this.lowerCaseTagNames) {
            name = name.toLowerCase();
        }
        this.emitOpenTag(name);
    };
    Parser.prototype.emitOpenTag = function (name) {
        var _a, _b, _c, _d;
        this.openTagStart = this.startIndex;
        this.tagname = name;
        var impliesClose = !this.options.xmlMode && openImpliesClose.get(name);
        if (impliesClose) {
            while (this.stack.length > 0 &&
                impliesClose.has(this.stack[this.stack.length - 1])) {
                var el = this.stack.pop();
                (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a, el, true);
            }
        }
        if (!this.isVoidElement(name)) {
            this.stack.push(name);
            if (foreignContextElements.has(name)) {
                this.foreignContext.push(true);
            }
            else if (htmlIntegrationElements.has(name)) {
                this.foreignContext.push(false);
            }
        }
        (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 ? void 0 : _d.call(_c, name);
        if (this.cbs.onopentag)
            this.attribs = {};
    };
    Parser.prototype.endOpenTag = function (isImplied) {
        var _a, _b;
        this.startIndex = this.openTagStart;
        this.endIndex = this.tokenizer.getAbsoluteIndex();
        if (this.attribs) {
            (_b = (_a = this.cbs).onopentag) === null || _b === void 0 ? void 0 : _b.call(_a, this.tagname, this.attribs, isImplied);
            this.attribs = null;
        }
        if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) {
            this.cbs.onclosetag(this.tagname, true);
        }
        this.tagname = "";
    };
    Parser.prototype.onopentagend = function () {
        this.endOpenTag(false);
        this.startIndex = this.endIndex + 1;
    };
    Parser.prototype.onclosetag = function (name) {
        var _a, _b, _c, _d, _e, _f;
        this.endIndex = this.tokenizer.getAbsoluteIndex();
        if (this.lowerCaseTagNames) {
            name = name.toLowerCase();
        }
        if (foreignContextElements.has(name) ||
            htmlIntegrationElements.has(name)) {
            this.foreignContext.pop();
        }
        if (!this.isVoidElement(name)) {
            var pos = this.stack.lastIndexOf(name);
            if (pos !== -1) {
                if (this.cbs.onclosetag) {
                    var count = this.stack.length - pos;
                    while (count--) {
                        this.cbs.onclosetag(this.stack.pop(), count !== 0);
                    }
                }
                else
                    this.stack.length = pos;
            }
            else if (!this.options.xmlMode && name === "p") {
                this.emitOpenTag(name);
                this.closeCurrentTag(true);
            }
        }
        else if (!this.options.xmlMode && name === "br") {
            (_b = (_a = this.cbs).onopentagname) === null || _b === void 0 ? void 0 : _b.call(_a, name);
            (_d = (_c = this.cbs).onopentag) === null || _d === void 0 ? void 0 : _d.call(_c, name, {}, true);
            (_f = (_e = this.cbs).onclosetag) === null || _f === void 0 ? void 0 : _f.call(_e, name, false);
        }
        this.startIndex = this.endIndex + 1;
    };
    Parser.prototype.onselfclosingtag = function () {
        if (this.options.xmlMode ||
            this.options.recognizeSelfClosing ||
            this.foreignContext[this.foreignContext.length - 1]) {
            this.closeCurrentTag(false);
            this.startIndex = this.endIndex + 1;
        }
        else {
            this.onopentagend();
        }
    };
    Parser.prototype.closeCurrentTag = function (isOpenImplied) {
        var _a, _b;
        var name = this.tagname;
        this.endOpenTag(isOpenImplied);
        if (this.stack[this.stack.length - 1] === name) {
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 ? void 0 : _b.call(_a, name, !isOpenImplied);
            this.stack.pop();
        }
    };
    Parser.prototype.onattribname = function (name) {
        this.startIndex = this.tokenizer.getAbsoluteSectionStart();
        if (this.lowerCaseAttributeNames) {
            name = name.toLowerCase();
        }
        this.attribname = name;
    };
    Parser.prototype.onattribdata = function (value) {
        this.attribvalue += value;
    };
    Parser.prototype.onattribend = function (quote) {
        var _a, _b;
        this.endIndex = this.tokenizer.getAbsoluteIndex();
        (_b = (_a = this.cbs).onattribute) === null || _b === void 0 ? void 0 : _b.call(_a, this.attribname, this.attribvalue, quote);
        if (this.attribs &&
            !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) {
            this.attribs[this.attribname] = this.attribvalue;
        }
        this.attribname = "";
        this.attribvalue = "";
    };
    Parser.prototype.getInstructionName = function (value) {
        var idx = value.search(reNameEnd);
        var name = idx < 0 ? value : value.substr(0, idx);
        if (this.lowerCaseTagNames) {
            name = name.toLowerCase();
        }
        return name;
    };
    Parser.prototype.ondeclaration = function (value) {
        this.endIndex = this.tokenizer.getAbsoluteIndex();
        if (this.cbs.onprocessinginstruction) {
            var name_1 = this.getInstructionName(value);
            this.cbs.onprocessinginstruction("!" + name_1, "!" + value);
        }
        this.startIndex = this.endIndex + 1;
    };
    Parser.prototype.onprocessinginstruction = function (value) {
        this.endIndex = this.tokenizer.getAbsoluteIndex();
        if (this.cbs.onprocessinginstruction) {
            var name_2 = this.getInstructionName(value);
            this.cbs.onprocessinginstruction("?" + name_2, "?" + value);
        }
        this.startIndex = this.endIndex + 1;
    };
    Parser.prototype.oncomment = function (value) {
        var _a, _b, _c, _d;
        this.endIndex = this.tokenizer.getAbsoluteIndex();
        (_b = (_a = this.cbs).oncomment) === null || _b === void 0 ? void 0 : _b.call(_a, value);
        (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 ? void 0 : _d.call(_c);
        this.startIndex = this.endIndex + 1;
    };
    Parser.prototype.oncdata = function (value) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.endIndex = this.tokenizer.getAbsoluteIndex();
        if (this.options.xmlMode || this.options.recognizeCDATA) {
            (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 ? void 0 : _b.call(_a);
            (_d = (_c = this.cbs).ontext) === null || _d === void 0 ? void 0 : _d.call(_c, value);
            (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 ? void 0 : _f.call(_e);
        }
        else {
            (_h = (_g = this.cbs).oncomment) === null || _h === void 0 ? void 0 : _h.call(_g, "[CDATA[" + value + "]]");
            (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 ? void 0 : _k.call(_j);
        }
        this.startIndex = this.endIndex + 1;
    };
    Parser.prototype.onerror = function (err) {
        var _a, _b;
        (_b = (_a = this.cbs).onerror) === null || _b === void 0 ? void 0 : _b.call(_a, err);
    };
    Parser.prototype.onend = function () {
        var _a, _b;
        if (this.cbs.onclosetag) {
            this.endIndex = this.startIndex;
            for (var i = this.stack.length; i > 0; this.cbs.onclosetag(this.stack[--i], true))
                ;
        }
        (_b = (_a = this.cbs).onend) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    Parser.prototype.reset = function () {
        var _a, _b, _c, _d;
        (_b = (_a = this.cbs).onreset) === null || _b === void 0 ? void 0 : _b.call(_a);
        this.tokenizer.reset();
        this.tagname = "";
        this.attribname = "";
        this.attribs = null;
        this.stack = [];
        this.startIndex = 0;
        this.endIndex = 0;
        (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 ? void 0 : _d.call(_c, this);
    };
    Parser.prototype.parseComplete = function (data) {
        this.reset();
        this.end(data);
    };
    Parser.prototype.write = function (chunk) {
        this.tokenizer.write(chunk);
    };
    Parser.prototype.end = function (chunk) {
        this.tokenizer.end(chunk);
    };
    Parser.prototype.pause = function () {
        this.tokenizer.pause();
    };
    Parser.prototype.resume = function () {
        this.tokenizer.resume();
    };
    Parser.prototype.parseChunk = function (chunk) {
        this.write(chunk);
    };
    Parser.prototype.done = function (chunk) {
        this.end(chunk);
    };
    return Parser;
}());
Parser$2.Parser = Parser$1;

var lib$1 = {};

var lib = {};

(function (exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.Doctype = exports.CDATA = exports.Tag = exports.Style = exports.Script = exports.Comment = exports.Directive = exports.Text = exports.Root = exports.isTag = exports.ElementType = void 0;
var ElementType;
(function (ElementType) {
    ElementType["Root"] = "root";
    ElementType["Text"] = "text";
    ElementType["Directive"] = "directive";
    ElementType["Comment"] = "comment";
    ElementType["Script"] = "script";
    ElementType["Style"] = "style";
    ElementType["Tag"] = "tag";
    ElementType["CDATA"] = "cdata";
    ElementType["Doctype"] = "doctype";
})(ElementType = exports.ElementType || (exports.ElementType = {}));
function isTag(elem) {
    return (elem.type === ElementType.Tag ||
        elem.type === ElementType.Script ||
        elem.type === ElementType.Style);
}
exports.isTag = isTag;
exports.Root = ElementType.Root;
exports.Text = ElementType.Text;
exports.Directive = ElementType.Directive;
exports.Comment = ElementType.Comment;
exports.Script = ElementType.Script;
exports.Style = ElementType.Style;
exports.Tag = ElementType.Tag;
exports.CDATA = ElementType.CDATA;
exports.Doctype = ElementType.Doctype;
}(lib));
getDefaultExportFromCjs(lib);

var node$1 = {};

var __extends$1 = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$3 = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$3 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$3.apply(this, arguments);
};
Object.defineProperty(node$1, "__esModule", { value: true });
node$1.cloneNode = node$1.hasChildren = node$1.isDocument = node$1.isDirective = node$1.isComment = node$1.isText = node$1.isCDATA = node$1.isTag = node$1.Element = node$1.Document = node$1.NodeWithChildren = node$1.ProcessingInstruction = node$1.Comment = node$1.Text = node$1.DataNode = node$1.Node = void 0;
var domelementtype_1 = lib;
var nodeTypes = new Map([
    [domelementtype_1.ElementType.Tag, 1],
    [domelementtype_1.ElementType.Script, 1],
    [domelementtype_1.ElementType.Style, 1],
    [domelementtype_1.ElementType.Directive, 1],
    [domelementtype_1.ElementType.Text, 3],
    [domelementtype_1.ElementType.CDATA, 4],
    [domelementtype_1.ElementType.Comment, 8],
    [domelementtype_1.ElementType.Root, 9],
]);
var Node =  (function () {
    function Node(type) {
        this.type = type;
        this.parent = null;
        this.prev = null;
        this.next = null;
        this.startIndex = null;
        this.endIndex = null;
    }
    Object.defineProperty(Node.prototype, "nodeType", {
        get: function () {
            var _a;
            return (_a = nodeTypes.get(this.type)) !== null && _a !== void 0 ? _a : 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "parentNode", {
        get: function () {
            return this.parent;
        },
        set: function (parent) {
            this.parent = parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "previousSibling", {
        get: function () {
            return this.prev;
        },
        set: function (prev) {
            this.prev = prev;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "nextSibling", {
        get: function () {
            return this.next;
        },
        set: function (next) {
            this.next = next;
        },
        enumerable: false,
        configurable: true
    });
    Node.prototype.cloneNode = function (recursive) {
        if (recursive === void 0) { recursive = false; }
        return cloneNode(this, recursive);
    };
    return Node;
}());
node$1.Node = Node;
var DataNode =  (function (_super) {
    __extends$1(DataNode, _super);
    function DataNode(type, data) {
        var _this = _super.call(this, type) || this;
        _this.data = data;
        return _this;
    }
    Object.defineProperty(DataNode.prototype, "nodeValue", {
        get: function () {
            return this.data;
        },
        set: function (data) {
            this.data = data;
        },
        enumerable: false,
        configurable: true
    });
    return DataNode;
}(Node));
node$1.DataNode = DataNode;
var Text$1 =  (function (_super) {
    __extends$1(Text, _super);
    function Text(data) {
        return _super.call(this, domelementtype_1.ElementType.Text, data) || this;
    }
    return Text;
}(DataNode));
node$1.Text = Text$1;
var Comment =  (function (_super) {
    __extends$1(Comment, _super);
    function Comment(data) {
        return _super.call(this, domelementtype_1.ElementType.Comment, data) || this;
    }
    return Comment;
}(DataNode));
node$1.Comment = Comment;
var ProcessingInstruction =  (function (_super) {
    __extends$1(ProcessingInstruction, _super);
    function ProcessingInstruction(name, data) {
        var _this = _super.call(this, domelementtype_1.ElementType.Directive, data) || this;
        _this.name = name;
        return _this;
    }
    return ProcessingInstruction;
}(DataNode));
node$1.ProcessingInstruction = ProcessingInstruction;
var NodeWithChildren =  (function (_super) {
    __extends$1(NodeWithChildren, _super);
    function NodeWithChildren(type, children) {
        var _this = _super.call(this, type) || this;
        _this.children = children;
        return _this;
    }
    Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
        get: function () {
            var _a;
            return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
        get: function () {
            return this.children.length > 0
                ? this.children[this.children.length - 1]
                : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
        get: function () {
            return this.children;
        },
        set: function (children) {
            this.children = children;
        },
        enumerable: false,
        configurable: true
    });
    return NodeWithChildren;
}(Node));
node$1.NodeWithChildren = NodeWithChildren;
var Document =  (function (_super) {
    __extends$1(Document, _super);
    function Document(children) {
        return _super.call(this, domelementtype_1.ElementType.Root, children) || this;
    }
    return Document;
}(NodeWithChildren));
node$1.Document = Document;
var Element$1 =  (function (_super) {
    __extends$1(Element, _super);
    function Element(name, attribs, children, type) {
        if (children === void 0) { children = []; }
        if (type === void 0) { type = name === "script"
            ? domelementtype_1.ElementType.Script
            : name === "style"
                ? domelementtype_1.ElementType.Style
                : domelementtype_1.ElementType.Tag; }
        var _this = _super.call(this, type, children) || this;
        _this.name = name;
        _this.attribs = attribs;
        return _this;
    }
    Object.defineProperty(Element.prototype, "tagName", {
        get: function () {
            return this.name;
        },
        set: function (name) {
            this.name = name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "attributes", {
        get: function () {
            var _this = this;
            return Object.keys(this.attribs).map(function (name) {
                var _a, _b;
                return ({
                    name: name,
                    value: _this.attribs[name],
                    namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                    prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name],
                });
            });
        },
        enumerable: false,
        configurable: true
    });
    return Element;
}(NodeWithChildren));
node$1.Element = Element$1;
function isTag(node) {
    return (0, domelementtype_1.isTag)(node);
}
node$1.isTag = isTag;
function isCDATA(node) {
    return node.type === domelementtype_1.ElementType.CDATA;
}
node$1.isCDATA = isCDATA;
function isText(node) {
    return node.type === domelementtype_1.ElementType.Text;
}
node$1.isText = isText;
function isComment(node) {
    return node.type === domelementtype_1.ElementType.Comment;
}
node$1.isComment = isComment;
function isDirective(node) {
    return node.type === domelementtype_1.ElementType.Directive;
}
node$1.isDirective = isDirective;
function isDocument(node) {
    return node.type === domelementtype_1.ElementType.Root;
}
node$1.isDocument = isDocument;
function hasChildren(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
node$1.hasChildren = hasChildren;
function cloneNode(node, recursive) {
    if (recursive === void 0) { recursive = false; }
    var result;
    if (isText(node)) {
        result = new Text$1(node.data);
    }
    else if (isComment(node)) {
        result = new Comment(node.data);
    }
    else if (isTag(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_1 = new Element$1(node.name, __assign$3({}, node.attribs), children);
        children.forEach(function (child) { return (child.parent = clone_1); });
        if (node.namespace != null) {
            clone_1.namespace = node.namespace;
        }
        if (node["x-attribsNamespace"]) {
            clone_1["x-attribsNamespace"] = __assign$3({}, node["x-attribsNamespace"]);
        }
        if (node["x-attribsPrefix"]) {
            clone_1["x-attribsPrefix"] = __assign$3({}, node["x-attribsPrefix"]);
        }
        result = clone_1;
    }
    else if (isCDATA(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_2 = new NodeWithChildren(domelementtype_1.ElementType.CDATA, children);
        children.forEach(function (child) { return (child.parent = clone_2); });
        result = clone_2;
    }
    else if (isDocument(node)) {
        var children = recursive ? cloneChildren(node.children) : [];
        var clone_3 = new Document(children);
        children.forEach(function (child) { return (child.parent = clone_3); });
        if (node["x-mode"]) {
            clone_3["x-mode"] = node["x-mode"];
        }
        result = clone_3;
    }
    else if (isDirective(node)) {
        var instruction = new ProcessingInstruction(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    }
    else {
        throw new Error("Not implemented yet: ".concat(node.type));
    }
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) {
        result.sourceCodeLocation = node.sourceCodeLocation;
    }
    return result;
}
node$1.cloneNode = cloneNode;
function cloneChildren(childs) {
    var children = childs.map(function (child) { return cloneNode(child, true); });
    for (var i = 1; i < children.length; i++) {
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}

(function (exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomHandler = void 0;
var domelementtype_1 = lib;
var node_1 = node$1;
__exportStar(node$1, exports);
var reWhitespace = /\s+/g;
var defaultOpts = {
    normalizeWhitespace: false,
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false,
};
var DomHandler =  (function () {
    function DomHandler(callback, options, elementCB) {
        this.dom = [];
        this.root = new node_1.Document(this.dom);
        this.done = false;
        this.tagStack = [this.root];
        this.lastNode = null;
        this.parser = null;
        if (typeof options === "function") {
            elementCB = options;
            options = defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    DomHandler.prototype.onparserinit = function (parser) {
        this.parser = parser;
    };
    DomHandler.prototype.onreset = function () {
        this.dom = [];
        this.root = new node_1.Document(this.dom);
        this.done = false;
        this.tagStack = [this.root];
        this.lastNode = null;
        this.parser = null;
    };
    DomHandler.prototype.onend = function () {
        if (this.done)
            return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    };
    DomHandler.prototype.onerror = function (error) {
        this.handleCallback(error);
    };
    DomHandler.prototype.onclosetag = function () {
        this.lastNode = null;
        var elem = this.tagStack.pop();
        if (this.options.withEndIndices) {
            elem.endIndex = this.parser.endIndex;
        }
        if (this.elementCB)
            this.elementCB(elem);
    };
    DomHandler.prototype.onopentag = function (name, attribs) {
        var type = this.options.xmlMode ? domelementtype_1.ElementType.Tag : undefined;
        var element = new node_1.Element(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    };
    DomHandler.prototype.ontext = function (data) {
        var normalizeWhitespace = this.options.normalizeWhitespace;
        var lastNode = this.lastNode;
        if (lastNode && lastNode.type === domelementtype_1.ElementType.Text) {
            if (normalizeWhitespace) {
                lastNode.data = (lastNode.data + data).replace(reWhitespace, " ");
            }
            else {
                lastNode.data += data;
            }
            if (this.options.withEndIndices) {
                lastNode.endIndex = this.parser.endIndex;
            }
        }
        else {
            if (normalizeWhitespace) {
                data = data.replace(reWhitespace, " ");
            }
            var node = new node_1.Text(data);
            this.addNode(node);
            this.lastNode = node;
        }
    };
    DomHandler.prototype.oncomment = function (data) {
        if (this.lastNode && this.lastNode.type === domelementtype_1.ElementType.Comment) {
            this.lastNode.data += data;
            return;
        }
        var node = new node_1.Comment(data);
        this.addNode(node);
        this.lastNode = node;
    };
    DomHandler.prototype.oncommentend = function () {
        this.lastNode = null;
    };
    DomHandler.prototype.oncdatastart = function () {
        var text = new node_1.Text("");
        var node = new node_1.NodeWithChildren(domelementtype_1.ElementType.CDATA, [text]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    };
    DomHandler.prototype.oncdataend = function () {
        this.lastNode = null;
    };
    DomHandler.prototype.onprocessinginstruction = function (name, data) {
        var node = new node_1.ProcessingInstruction(name, data);
        this.addNode(node);
    };
    DomHandler.prototype.handleCallback = function (error) {
        if (typeof this.callback === "function") {
            this.callback(error, this.dom);
        }
        else if (error) {
            throw error;
        }
    };
    DomHandler.prototype.addNode = function (node) {
        var parent = this.tagStack[this.tagStack.length - 1];
        var previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) {
            node.startIndex = this.parser.startIndex;
        }
        if (this.options.withEndIndices) {
            node.endIndex = this.parser.endIndex;
        }
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    };
    return DomHandler;
}());
exports.DomHandler = DomHandler;
exports.default = DomHandler;
}(lib$1));
getDefaultExportFromCjs(lib$1);

function unsetRootParent$1(nodes) {
  for (var index = 0, len = nodes.length; index < len; index++) {
    var node = nodes[index];
    node.parent = null;
  }
  return nodes;
}
var utilities = {
  unsetRootParent: unsetRootParent$1
};

var Parser = Parser$2.Parser;
var DomHandler = lib$1.DomHandler;
var unsetRootParent = utilities.unsetRootParent;
function HTMLDOMParser(html, options) {
  if (typeof html !== 'string') {
    throw new TypeError('First argument must be a string.');
  }
  if (html === '') {
    return [];
  }
  var handler = new DomHandler(undefined, options);
  new Parser(handler, options).end(html);
  return unsetRootParent(handler.dom);
}
var htmlToDom = HTMLDOMParser;

var htmlDomParser = htmlToDom;

var domToReact = domToReact_1;
var attributesToProps = attributesToProps$2;
var htmlToDOM = htmlDomParser;
htmlToDOM =
  typeof htmlToDOM.default === 'function' ? htmlToDOM.default : htmlToDOM;
var domParserOptions = { lowerCaseAttributeNames: false };
function HTMLReactParser(html, options) {
  if (typeof html !== 'string') {
    throw new TypeError('First argument must be a string');
  }
  if (html === '') {
    return [];
  }
  options = options || {};
  return domToReact(
    htmlToDOM(html, options.htmlparser2 || domParserOptions),
    options
  );
}
HTMLReactParser.domToReact = domToReact;
HTMLReactParser.htmlToDOM = htmlToDOM;
HTMLReactParser.attributesToProps = attributesToProps;
HTMLReactParser.Element = lib$1.Element;
htmlReactParser.exports = HTMLReactParser;
htmlReactParser.exports.default = HTMLReactParser;
var HTMLReactParser$1 = htmlReactParser.exports;

HTMLReactParser$1.domToReact;
HTMLReactParser$1.htmlToDOM;
HTMLReactParser$1.attributesToProps;
HTMLReactParser$1.Element;

var Currency = [{iso:"EUR",symbol:"&#8364;"},{iso:"USD",symbol:"&#36;"},{iso:"GBP",symbol:"&#163;"}];

function getCurrency(iso, type) {
  var currency = Currency.find(function (e) {
    return e.iso === iso;
  });
  switch (type) {
    case 'iso':
      return HTMLReactParser$1(currency.iso);
    case 'symbol':
      return HTMLReactParser$1(currency.symbol);
    default:
      return HTMLReactParser$1(currency.iso);
  }
}

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign$2 = function() {
    __assign$2 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$2.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var createDefinition = function (propNames) { return ({
    isEnabled: function (props) { return propNames.some(function (name) { return !!props[name]; }); },
}); };
var featureDefinitions = {
    measureLayout: createDefinition(["layout", "layoutId", "drag"]),
    animation: createDefinition([
        "animate",
        "exit",
        "variants",
        "whileHover",
        "whileTap",
        "whileFocus",
        "whileDrag",
        "whileInView",
    ]),
    exit: createDefinition(["exit"]),
    drag: createDefinition(["drag", "dragControls"]),
    focus: createDefinition(["whileFocus"]),
    hover: createDefinition(["whileHover", "onHoverStart", "onHoverEnd"]),
    tap: createDefinition(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
    pan: createDefinition([
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd",
    ]),
    inView: createDefinition([
        "whileInView",
        "onViewportEnter",
        "onViewportLeave",
    ]),
};
function loadFeatures(features) {
    for (var key in features) {
        if (features[key] === null)
            continue;
        if (key === "projectionNodeConstructor") {
            featureDefinitions.projectionNodeConstructor = features[key];
        }
        else {
            featureDefinitions[key].Component = features[key];
        }
    }
}

var warning$3 = function () { };
var invariant = function () { };
if (process.env.NODE_ENV !== 'production') {
    warning$3 = function (check, message) {
        if (!check && typeof console !== 'undefined') {
            console.warn(message);
        }
    };
    invariant = function (check, message) {
        if (!check) {
            throw new Error(message);
        }
    };
}

var LazyContext = createContext({ strict: false });

var featureNames = Object.keys(featureDefinitions);
var numFeatures = featureNames.length;
function useFeatures(props, visualElement, preloadedFeatures) {
    var features = [];
    var lazyContext = useContext(LazyContext);
    if (!visualElement)
        return null;
    if (process.env.NODE_ENV !== "production" &&
        preloadedFeatures &&
        lazyContext.strict) {
        invariant(false, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
    }
    for (var i = 0; i < numFeatures; i++) {
        var name_1 = featureNames[i];
        var _a = featureDefinitions[name_1], isEnabled = _a.isEnabled, Component = _a.Component;
        if (isEnabled(props) && Component) {
            features.push(React$4.createElement(Component, __assign$2({ key: name_1 }, props, { visualElement: visualElement })));
        }
    }
    return features;
}

var MotionConfigContext = createContext({
    transformPagePoint: function (p) { return p; },
    isStatic: false,
});

var MotionContext = createContext({});
function useVisualElementContext() {
    return useContext(MotionContext).visualElement;
}

var PresenceContext = createContext(null);

var isBrowser = typeof window !== "undefined";

var useIsomorphicLayoutEffect = isBrowser ? useLayoutEffect : useEffect;

function useVisualElement(Component, visualState, props, createVisualElement) {
    var lazyContext = useContext(LazyContext);
    var parent = useVisualElementContext();
    var presenceContext = useContext(PresenceContext);
    var visualElementRef = useRef(undefined);
    if (!createVisualElement)
        createVisualElement = lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) {
        visualElementRef.current = createVisualElement(Component, {
            visualState: visualState,
            parent: parent,
            props: props,
            presenceId: presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id,
            blockInitialAnimation: (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false,
        });
    }
    var visualElement = visualElementRef.current;
    useIsomorphicLayoutEffect(function () {
        visualElement === null || visualElement === void 0 ? void 0 : visualElement.syncRender();
    });
    useEffect(function () {
        var _a;
        (_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.animationState) === null || _a === void 0 ? void 0 : _a.animateChanges();
    });
    useIsomorphicLayoutEffect(function () { return function () { return visualElement === null || visualElement === void 0 ? void 0 : visualElement.notifyUnmount(); }; }, []);
    return visualElement;
}

function isRefObject(ref) {
    return (typeof ref === "object" &&
        Object.prototype.hasOwnProperty.call(ref, "current"));
}

function useMotionRef(visualState, visualElement, externalRef) {
    return useCallback(function (instance) {
        var _a;
        instance && ((_a = visualState.mount) === null || _a === void 0 ? void 0 : _a.call(visualState, instance));
        if (visualElement) {
            instance
                ? visualElement.mount(instance)
                : visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") {
                externalRef(instance);
            }
            else if (isRefObject(externalRef)) {
                externalRef.current = instance;
            }
        }
    },
    [visualElement]);
}

function isVariantLabels(v) {
    return Array.isArray(v);
}
function isVariantLabel(v) {
    return typeof v === "string" || isVariantLabels(v);
}
function getCurrent(visualElement) {
    var current = {};
    visualElement.forEachValue(function (value, key) { return (current[key] = value.get()); });
    return current;
}
function getVelocity$1(visualElement) {
    var velocity = {};
    visualElement.forEachValue(function (value, key) { return (velocity[key] = value.getVelocity()); });
    return velocity;
}
function resolveVariantFromProps(props, definition, custom, currentValues, currentVelocity) {
    var _a;
    if (currentValues === void 0) { currentValues = {}; }
    if (currentVelocity === void 0) { currentVelocity = {}; }
    if (typeof definition === "function") {
        definition = definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues, currentVelocity);
    }
    if (typeof definition === "string") {
        definition = (_a = props.variants) === null || _a === void 0 ? void 0 : _a[definition];
    }
    if (typeof definition === "function") {
        definition = definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues, currentVelocity);
    }
    return definition;
}
function resolveVariant(visualElement, definition, custom) {
    var props = visualElement.getProps();
    return resolveVariantFromProps(props, definition, custom !== null && custom !== void 0 ? custom : props.custom, getCurrent(visualElement), getVelocity$1(visualElement));
}
function checkIfControllingVariants(props) {
    var _a;
    return (typeof ((_a = props.animate) === null || _a === void 0 ? void 0 : _a.start) === "function" ||
        isVariantLabel(props.initial) ||
        isVariantLabel(props.animate) ||
        isVariantLabel(props.whileHover) ||
        isVariantLabel(props.whileDrag) ||
        isVariantLabel(props.whileTap) ||
        isVariantLabel(props.whileFocus) ||
        isVariantLabel(props.exit));
}
function checkIfVariantNode(props) {
    return Boolean(checkIfControllingVariants(props) || props.variants);
}

function getCurrentTreeVariants(props, context) {
    if (checkIfControllingVariants(props)) {
        var initial = props.initial, animate = props.animate;
        return {
            initial: initial === false || isVariantLabel(initial)
                ? initial
                : undefined,
            animate: isVariantLabel(animate) ? animate : undefined,
        };
    }
    return props.inherit !== false ? context : {};
}

function useCreateMotionContext(props) {
    var _a = getCurrentTreeVariants(props, useContext(MotionContext)), initial = _a.initial, animate = _a.animate;
    return useMemo(function () { return ({ initial: initial, animate: animate }); }, [variantLabelsAsDependency(initial), variantLabelsAsDependency(animate)]);
}
function variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

function useConstant(init) {
    var ref = useRef(null);
    if (ref.current === null) {
        ref.current = init();
    }
    return ref.current;
}

const defaultTimestep = (1 / 60) * 1000;
const getCurrentTime = typeof performance !== "undefined"
    ? () => performance.now()
    : () => Date.now();
const onNextFrame = typeof window !== "undefined"
    ? (callback) => window.requestAnimationFrame(callback)
    : (callback) => setTimeout(() => callback(getCurrentTime()), defaultTimestep);

function createRenderStep(runNextFrame) {
    let toRun = [];
    let toRunNextFrame = [];
    let numToRun = 0;
    let isProcessing = false;
    let flushNextFrame = false;
    const toKeepAlive = new WeakSet();
    const step = {
        schedule: (callback, keepAlive = false, immediate = false) => {
            const addToCurrentFrame = immediate && isProcessing;
            const buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive)
                toKeepAlive.add(callback);
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                if (addToCurrentFrame && isProcessing)
                    numToRun = toRun.length;
            }
            return callback;
        },
        cancel: (callback) => {
            const index = toRunNextFrame.indexOf(callback);
            if (index !== -1)
                toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        process: (frameData) => {
            if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [toRun, toRunNextFrame] = [toRunNextFrame, toRun];
            toRunNextFrame.length = 0;
            numToRun = toRun.length;
            if (numToRun) {
                for (let i = 0; i < numToRun; i++) {
                    const callback = toRun[i];
                    callback(frameData);
                    if (toKeepAlive.has(callback)) {
                        step.schedule(callback);
                        runNextFrame();
                    }
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        },
    };
    return step;
}

const maxElapsed = 40;
let useDefaultElapsed = true;
let runNextFrame = false;
let isProcessing = false;
const frame = {
    delta: 0,
    timestamp: 0,
};
const stepsOrder = [
    "read",
    "update",
    "preRender",
    "render",
    "postRender",
];
const steps = stepsOrder.reduce((acc, key) => {
    acc[key] = createRenderStep(() => (runNextFrame = true));
    return acc;
}, {});
const sync = stepsOrder.reduce((acc, key) => {
    const step = steps[key];
    acc[key] = (process, keepAlive = false, immediate = false) => {
        if (!runNextFrame)
            startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
const cancelSync = stepsOrder.reduce((acc, key) => {
    acc[key] = steps[key].cancel;
    return acc;
}, {});
const flushSync = stepsOrder.reduce((acc, key) => {
    acc[key] = () => steps[key].process(frame);
    return acc;
}, {});
const processStep = (stepId) => steps[stepId].process(frame);
const processFrame = (timestamp) => {
    runNextFrame = false;
    frame.delta = useDefaultElapsed
        ? defaultTimestep
        : Math.max(Math.min(timestamp - frame.timestamp, maxElapsed), 1);
    frame.timestamp = timestamp;
    isProcessing = true;
    stepsOrder.forEach(processStep);
    isProcessing = false;
    if (runNextFrame) {
        useDefaultElapsed = false;
        onNextFrame(processFrame);
    }
};
const startLoop = () => {
    runNextFrame = true;
    useDefaultElapsed = true;
    if (!isProcessing)
        onNextFrame(processFrame);
};
const getFrameData = () => frame;

const clamp$1 = (min, max, v) => Math.min(Math.max(v, min), max);

const safeMin = 0.001;
const minDuration = 0.01;
const maxDuration = 10.0;
const minDamping = 0.05;
const maxDamping = 1;
function findSpring({ duration = 800, bounce = 0.25, velocity = 0, mass = 1, }) {
    let envelope;
    let derivative;
    warning$3(duration <= maxDuration * 1000, "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    dampingRatio = clamp$1(minDamping, maxDamping, dampingRatio);
    duration = clamp$1(minDuration, maxDuration, duration / 1000);
    if (dampingRatio < 1) {
        envelope = (undampedFreq) => {
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = calcAngularFreq(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return safeMin - (a / b) * c;
        };
        derivative = (undampedFreq) => {
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + safeMin > 0 ? -1 : 1;
            return (factor * ((d - e) * f)) / g;
        };
    }
    else {
        envelope = (undampedFreq) => {
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -safeMin + a * b;
        };
        derivative = (undampedFreq) => {
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = approximateRoot(envelope, derivative, initialGuess);
    duration = duration * 1000;
    if (isNaN(undampedFreq)) {
        return {
            stiffness: 100,
            damping: 10,
            duration,
        };
    }
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration,
        };
    }
}
const rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for (let i = 1; i < rootIterations; i++) {
        result = result - envelope(result) / derivative(result);
    }
    return result;
}
function calcAngularFreq(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

const durationKeys = ["duration", "bounce"];
const physicsKeys = ["stiffness", "damping", "mass"];
function isSpringType(options, keys) {
    return keys.some((key) => options[key] !== undefined);
}
function getSpringOptions(options) {
    let springOptions = Object.assign({ velocity: 0.0, stiffness: 100, damping: 10, mass: 1.0, isResolvedFromDuration: false }, options);
    if (!isSpringType(options, physicsKeys) &&
        isSpringType(options, durationKeys)) {
        const derived = findSpring(options);
        springOptions = Object.assign(Object.assign(Object.assign({}, springOptions), derived), { velocity: 0.0, mass: 1.0 });
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function spring(_a) {
    var { from = 0.0, to = 1.0, restSpeed = 2, restDelta } = _a, options = __rest(_a, ["from", "to", "restSpeed", "restDelta"]);
    const state = { done: false, value: from };
    let { stiffness, damping, mass, velocity, duration, isResolvedFromDuration, } = getSpringOptions(options);
    let resolveSpring = zero$2;
    let resolveVelocity = zero$2;
    function createSpring() {
        const initialVelocity = velocity ? -(velocity / 1000) : 0.0;
        const initialDelta = to - from;
        const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
        const undampedAngularFreq = Math.sqrt(stiffness / mass) / 1000;
        if (restDelta === undefined) {
            restDelta = Math.min(Math.abs(to - from) / 100, 0.4);
        }
        if (dampingRatio < 1) {
            const angularFreq = calcAngularFreq(undampedAngularFreq, dampingRatio);
            resolveSpring = (t) => {
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return (to -
                    envelope *
                        (((initialVelocity +
                            dampingRatio * undampedAngularFreq * initialDelta) /
                            angularFreq) *
                            Math.sin(angularFreq * t) +
                            initialDelta * Math.cos(angularFreq * t)));
            };
            resolveVelocity = (t) => {
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return (dampingRatio *
                    undampedAngularFreq *
                    envelope *
                    ((Math.sin(angularFreq * t) *
                        (initialVelocity +
                            dampingRatio *
                                undampedAngularFreq *
                                initialDelta)) /
                        angularFreq +
                        initialDelta * Math.cos(angularFreq * t)) -
                    envelope *
                        (Math.cos(angularFreq * t) *
                            (initialVelocity +
                                dampingRatio *
                                    undampedAngularFreq *
                                    initialDelta) -
                            angularFreq *
                                initialDelta *
                                Math.sin(angularFreq * t)));
            };
        }
        else if (dampingRatio === 1) {
            resolveSpring = (t) => to -
                Math.exp(-undampedAngularFreq * t) *
                    (initialDelta +
                        (initialVelocity + undampedAngularFreq * initialDelta) *
                            t);
        }
        else {
            const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
            resolveSpring = (t) => {
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                const freqForT = Math.min(dampedAngularFreq * t, 300);
                return (to -
                    (envelope *
                        ((initialVelocity +
                            dampingRatio * undampedAngularFreq * initialDelta) *
                            Math.sinh(freqForT) +
                            dampedAngularFreq *
                                initialDelta *
                                Math.cosh(freqForT))) /
                        dampedAngularFreq);
            };
        }
    }
    createSpring();
    return {
        next: (t) => {
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                const currentVelocity = resolveVelocity(t) * 1000;
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(to - current) <= restDelta;
                state.done =
                    isBelowVelocityThreshold && isBelowDisplacementThreshold;
            }
            else {
                state.done = t >= duration;
            }
            state.value = state.done ? to : current;
            return state;
        },
        flipTarget: () => {
            velocity = -velocity;
            [from, to] = [to, from];
            createSpring();
        },
    };
}
spring.needsInterpolation = (a, b) => typeof a === "string" || typeof b === "string";
const zero$2 = (_t) => 0;

const progress = (from, to, value) => {
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

const mix = (from, to, progress) => -progress * from + progress * to + from;

const clamp = (min, max) => (v) => Math.max(Math.min(v, max), min);
const sanitize = (v) => (v % 1 ? Number(v.toFixed(5)) : v);
const floatRegex = /(-)?([\d]*\.?[\d])+/g;
const colorRegex = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi;
const singleColorRegex = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function isString$1(v) {
    return typeof v === 'string';
}

const number$2 = {
    test: (v) => typeof v === 'number',
    parse: parseFloat,
    transform: (v) => v,
};
const alpha = Object.assign(Object.assign({}, number$2), { transform: clamp(0, 1) });
const scale = Object.assign(Object.assign({}, number$2), { default: 1 });

const createUnitType = (unit) => ({
    test: (v) => isString$1(v) && v.endsWith(unit) && v.split(' ').length === 1,
    parse: parseFloat,
    transform: (v) => `${v}${unit}`,
});
const degrees = createUnitType('deg');
const percent = createUnitType('%');
const px = createUnitType('px');
const vh = createUnitType('vh');
const vw = createUnitType('vw');
const progressPercentage = Object.assign(Object.assign({}, percent), { parse: (v) => percent.parse(v) / 100, transform: (v) => percent.transform(v * 100) });

const isColorString = (type, testProp) => (v) => {
    return Boolean((isString$1(v) && singleColorRegex.test(v) && v.startsWith(type)) ||
        (testProp && Object.prototype.hasOwnProperty.call(v, testProp)));
};
const splitColor = (aName, bName, cName) => (v) => {
    if (!isString$1(v))
        return v;
    const [a, b, c, alpha] = v.match(floatRegex);
    return {
        [aName]: parseFloat(a),
        [bName]: parseFloat(b),
        [cName]: parseFloat(c),
        alpha: alpha !== undefined ? parseFloat(alpha) : 1,
    };
};

const hsla$1 = {
    test: isColorString('hsl', 'hue'),
    parse: splitColor('hue', 'saturation', 'lightness'),
    transform: ({ hue, saturation, lightness, alpha: alpha$1 = 1 }) => {
        return ('hsla(' +
            Math.round(hue) +
            ', ' +
            percent.transform(sanitize(saturation)) +
            ', ' +
            percent.transform(sanitize(lightness)) +
            ', ' +
            sanitize(alpha.transform(alpha$1)) +
            ')');
    },
};

const clampRgbUnit = clamp(0, 255);
const rgbUnit = Object.assign(Object.assign({}, number$2), { transform: (v) => Math.round(clampRgbUnit(v)) });
const rgba$1 = {
    test: isColorString('rgb', 'red'),
    parse: splitColor('red', 'green', 'blue'),
    transform: ({ red, green, blue, alpha: alpha$1 = 1 }) => 'rgba(' +
        rgbUnit.transform(red) +
        ', ' +
        rgbUnit.transform(green) +
        ', ' +
        rgbUnit.transform(blue) +
        ', ' +
        sanitize(alpha.transform(alpha$1)) +
        ')',
};

function parseHex(v) {
    let r = '';
    let g = '';
    let b = '';
    let a = '';
    if (v.length > 5) {
        r = v.substr(1, 2);
        g = v.substr(3, 2);
        b = v.substr(5, 2);
        a = v.substr(7, 2);
    }
    else {
        r = v.substr(1, 1);
        g = v.substr(2, 1);
        b = v.substr(3, 1);
        a = v.substr(4, 1);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1,
    };
}
const hex$1 = {
    test: isColorString('#'),
    parse: parseHex,
    transform: rgba$1.transform,
};

const color$1 = {
    test: (v) => rgba$1.test(v) || hex$1.test(v) || hsla$1.test(v),
    parse: (v) => {
        if (rgba$1.test(v)) {
            return rgba$1.parse(v);
        }
        else if (hsla$1.test(v)) {
            return hsla$1.parse(v);
        }
        else {
            return hex$1.parse(v);
        }
    },
    transform: (v) => {
        return isString$1(v)
            ? v
            : v.hasOwnProperty('red')
                ? rgba$1.transform(v)
                : hsla$1.transform(v);
    },
};

const colorToken = '${c}';
const numberToken = '${n}';
function test$3(v) {
    var _a, _b, _c, _d;
    return (isNaN(v) &&
        isString$1(v) &&
        ((_b = (_a = v.match(floatRegex)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + ((_d = (_c = v.match(colorRegex)) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0);
}
function analyse$1(v) {
    if (typeof v === 'number')
        v = `${v}`;
    const values = [];
    let numColors = 0;
    const colors = v.match(colorRegex);
    if (colors) {
        numColors = colors.length;
        v = v.replace(colorRegex, colorToken);
        values.push(...colors.map(color$1.parse));
    }
    const numbers = v.match(floatRegex);
    if (numbers) {
        v = v.replace(floatRegex, numberToken);
        values.push(...numbers.map(number$2.parse));
    }
    return { values, numColors, tokenised: v };
}
function parse$2(v) {
    return analyse$1(v).values;
}
function createTransformer(v) {
    const { values, numColors, tokenised } = analyse$1(v);
    const numValues = values.length;
    return (v) => {
        let output = tokenised;
        for (let i = 0; i < numValues; i++) {
            output = output.replace(i < numColors ? colorToken : numberToken, i < numColors ? color$1.transform(v[i]) : sanitize(v[i]));
        }
        return output;
    };
}
const convertNumbersToZero = (v) => typeof v === 'number' ? 0 : v;
function getAnimatableNone$1(v) {
    const parsed = parse$2(v);
    const transformer = createTransformer(v);
    return transformer(parsed.map(convertNumbersToZero));
}
const complex = { test: test$3, parse: parse$2, createTransformer, getAnimatableNone: getAnimatableNone$1 };

const maxDefaults = new Set(['brightness', 'contrast', 'saturate', 'opacity']);
function applyDefaultFilter(v) {
    let [name, value] = v.slice(0, -1).split('(');
    if (name === 'drop-shadow')
        return v;
    const [number] = value.match(floatRegex) || [];
    if (!number)
        return v;
    const unit = value.replace(number, '');
    let defaultValue = maxDefaults.has(name) ? 1 : 0;
    if (number !== value)
        defaultValue *= 100;
    return name + '(' + defaultValue + unit + ')';
}
const functionRegex = /([a-z-]*)\(.*?\)/g;
const filter$3 = Object.assign(Object.assign({}, complex), { getAnimatableNone: (v) => {
        const functions = v.match(functionRegex);
        return functions ? functions.map(applyDefaultFilter).join(' ') : v;
    } });

function hueToRgb(p, q, t) {
    if (t < 0)
        t += 1;
    if (t > 1)
        t -= 1;
    if (t < 1 / 6)
        return p + (q - p) * 6 * t;
    if (t < 1 / 2)
        return q;
    if (t < 2 / 3)
        return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function hslaToRgba({ hue, saturation, lightness, alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) {
        red = green = blue = lightness;
    }
    else {
        const q = lightness < 0.5
            ? lightness * (1 + saturation)
            : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = hueToRgb(p, q, hue + 1 / 3);
        green = hueToRgb(p, q, hue);
        blue = hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha,
    };
}

const mixLinearColor = (from, to, v) => {
    const fromExpo = from * from;
    const toExpo = to * to;
    return Math.sqrt(Math.max(0, v * (toExpo - fromExpo) + fromExpo));
};
const colorTypes = [hex$1, rgba$1, hsla$1];
const getColorType = (v) => colorTypes.find((type) => type.test(v));
const notAnimatable = (color) => `'${color}' is not an animatable color. Use the equivalent color code instead.`;
const mixColor = (from, to) => {
    let fromColorType = getColorType(from);
    let toColorType = getColorType(to);
    invariant(!!fromColorType, notAnimatable(from));
    invariant(!!toColorType, notAnimatable(to));
    let fromColor = fromColorType.parse(from);
    let toColor = toColorType.parse(to);
    if (fromColorType === hsla$1) {
        fromColor = hslaToRgba(fromColor);
        fromColorType = rgba$1;
    }
    if (toColorType === hsla$1) {
        toColor = hslaToRgba(toColor);
        toColorType = rgba$1;
    }
    const blended = Object.assign({}, fromColor);
    return (v) => {
        for (const key in blended) {
            if (key !== "alpha") {
                blended[key] = mixLinearColor(fromColor[key], toColor[key], v);
            }
        }
        blended.alpha = mix(fromColor.alpha, toColor.alpha, v);
        return fromColorType.transform(blended);
    };
};

const isNum = (v) => typeof v === 'number';

const combineFunctions = (a, b) => (v) => b(a(v));
const pipe = (...transformers) => transformers.reduce(combineFunctions);

function getMixer(origin, target) {
    if (isNum(origin)) {
        return (v) => mix(origin, target, v);
    }
    else if (color$1.test(origin)) {
        return mixColor(origin, target);
    }
    else {
        return mixComplex(origin, target);
    }
}
const mixArray = (from, to) => {
    const output = [...from];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i) => getMixer(fromThis, to[i]));
    return (v) => {
        for (let i = 0; i < numValues; i++) {
            output[i] = blendValue[i](v);
        }
        return output;
    };
};
const mixObject = (origin, target) => {
    const output = Object.assign(Object.assign({}, origin), target);
    const blendValue = {};
    for (const key in output) {
        if (origin[key] !== undefined && target[key] !== undefined) {
            blendValue[key] = getMixer(origin[key], target[key]);
        }
    }
    return (v) => {
        for (const key in blendValue) {
            output[key] = blendValue[key](v);
        }
        return output;
    };
};
function analyse(value) {
    const parsed = complex.parse(value);
    const numValues = parsed.length;
    let numNumbers = 0;
    let numRGB = 0;
    let numHSL = 0;
    for (let i = 0; i < numValues; i++) {
        if (numNumbers || typeof parsed[i] === "number") {
            numNumbers++;
        }
        else {
            if (parsed[i].hue !== undefined) {
                numHSL++;
            }
            else {
                numRGB++;
            }
        }
    }
    return { parsed, numNumbers, numRGB, numHSL };
}
const mixComplex = (origin, target) => {
    const template = complex.createTransformer(target);
    const originStats = analyse(origin);
    const targetStats = analyse(target);
    const canInterpolate = originStats.numHSL === targetStats.numHSL &&
        originStats.numRGB === targetStats.numRGB &&
        originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) {
        return pipe(mixArray(originStats.parsed, targetStats.parsed), template);
    }
    else {
        warning$3(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (p) => `${p > 0 ? target : origin}`;
    }
};

const mixNumber = (from, to) => (p) => mix(from, to, p);
function detectMixerFactory(v) {
    if (typeof v === 'number') {
        return mixNumber;
    }
    else if (typeof v === 'string') {
        if (color$1.test(v)) {
            return mixColor;
        }
        else {
            return mixComplex;
        }
    }
    else if (Array.isArray(v)) {
        return mixArray;
    }
    else if (typeof v === 'object') {
        return mixObject;
    }
}
function createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for (let i = 0; i < numMixers; i++) {
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] : ease;
            mixer = pipe(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
function fastInterpolate([from, to], [mixer]) {
    return (v) => mixer(progress(from, to, v));
}
function slowInterpolate(input, mixers) {
    const inputLength = input.length;
    const lastInputIndex = inputLength - 1;
    return (v) => {
        let mixerIndex = 0;
        let foundMixerIndex = false;
        if (v <= input[0]) {
            foundMixerIndex = true;
        }
        else if (v >= input[lastInputIndex]) {
            mixerIndex = lastInputIndex - 1;
            foundMixerIndex = true;
        }
        if (!foundMixerIndex) {
            let i = 1;
            for (; i < inputLength; i++) {
                if (input[i] > v || i === lastInputIndex) {
                    break;
                }
            }
            mixerIndex = i - 1;
        }
        const progressInRange = progress(input[mixerIndex], input[mixerIndex + 1], v);
        return mixers[mixerIndex](progressInRange);
    };
}
function interpolate$1(input, output, { clamp: isClamp = true, ease, mixer } = {}) {
    const inputLength = input.length;
    invariant(inputLength === output.length, 'Both input and output ranges must be the same length');
    invariant(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, 'Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.');
    if (input[0] > input[inputLength - 1]) {
        input = [].concat(input);
        output = [].concat(output);
        input.reverse();
        output.reverse();
    }
    const mixers = createMixers(output, ease, mixer);
    const interpolator = inputLength === 2
        ? fastInterpolate(input, mixers)
        : slowInterpolate(input, mixers);
    return isClamp
        ? (v) => interpolator(clamp$1(input[0], input[inputLength - 1], v))
        : interpolator;
}

const reverseEasing = easing => p => 1 - easing(1 - p);
const mirrorEasing = easing => p => p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
const createExpoIn = (power) => p => Math.pow(p, power);
const createBackIn = (power) => p => p * p * ((power + 1) * p - power);
const createAnticipate = (power) => {
    const backEasing = createBackIn(power);
    return p => (p *= 2) < 1
        ? 0.5 * backEasing(p)
        : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
};

const DEFAULT_OVERSHOOT_STRENGTH = 1.525;
const BOUNCE_FIRST_THRESHOLD = 4.0 / 11.0;
const BOUNCE_SECOND_THRESHOLD = 8.0 / 11.0;
const BOUNCE_THIRD_THRESHOLD = 9.0 / 10.0;
const linear$2 = p => p;
const easeIn = createExpoIn(2);
const easeOut = reverseEasing(easeIn);
const easeInOut = mirrorEasing(easeIn);
const circIn = p => 1 - Math.sin(Math.acos(p));
const circOut = reverseEasing(circIn);
const circInOut = mirrorEasing(circOut);
const backIn = createBackIn(DEFAULT_OVERSHOOT_STRENGTH);
const backOut = reverseEasing(backIn);
const backInOut = mirrorEasing(backIn);
const anticipate = createAnticipate(DEFAULT_OVERSHOOT_STRENGTH);
const ca = 4356.0 / 361.0;
const cb = 35442.0 / 1805.0;
const cc = 16061.0 / 1805.0;
const bounceOut = (p) => {
    if (p === 1 || p === 0)
        return p;
    const p2 = p * p;
    return p < BOUNCE_FIRST_THRESHOLD
        ? 7.5625 * p2
        : p < BOUNCE_SECOND_THRESHOLD
            ? 9.075 * p2 - 9.9 * p + 3.4
            : p < BOUNCE_THIRD_THRESHOLD
                ? ca * p2 - cb * p + cc
                : 10.8 * p * p - 20.52 * p + 10.72;
};
const bounceIn = reverseEasing(bounceOut);
const bounceInOut = (p) => p < 0.5
    ? 0.5 * (1.0 - bounceOut(1.0 - p * 2.0))
    : 0.5 * bounceOut(p * 2.0 - 1.0) + 0.5;

function defaultEasing(values, easing) {
    return values.map(() => easing || easeInOut).splice(0, values.length - 1);
}
function defaultOffset(values) {
    const numValues = values.length;
    return values.map((_value, i) => i !== 0 ? i / (numValues - 1) : 0);
}
function convertOffsetToTimes(offset, duration) {
    return offset.map((o) => o * duration);
}
function keyframes$1({ from = 0, to = 1, ease, offset, duration = 300, }) {
    const state = { done: false, value: from };
    const values = Array.isArray(to) ? to : [from, to];
    const times = convertOffsetToTimes(offset && offset.length === values.length
        ? offset
        : defaultOffset(values), duration);
    function createInterpolator() {
        return interpolate$1(times, values, {
            ease: Array.isArray(ease) ? ease : defaultEasing(values, ease),
        });
    }
    let interpolator = createInterpolator();
    return {
        next: (t) => {
            state.value = interpolator(t);
            state.done = t >= duration;
            return state;
        },
        flipTarget: () => {
            values.reverse();
            interpolator = createInterpolator();
        },
    };
}

function decay({ velocity = 0, from = 0, power = 0.8, timeConstant = 350, restDelta = 0.5, modifyTarget, }) {
    const state = { done: false, value: from };
    let amplitude = power * velocity;
    const ideal = from + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    if (target !== ideal)
        amplitude = target - from;
    return {
        next: (t) => {
            const delta = -amplitude * Math.exp(-t / timeConstant);
            state.done = !(delta > restDelta || delta < -restDelta);
            state.value = state.done ? target : target + delta;
            return state;
        },
        flipTarget: () => { },
    };
}

const types = { keyframes: keyframes$1, spring, decay };
function detectAnimationFromOptions(config) {
    if (Array.isArray(config.to)) {
        return keyframes$1;
    }
    else if (types[config.type]) {
        return types[config.type];
    }
    const keys = new Set(Object.keys(config));
    if (keys.has("ease") ||
        (keys.has("duration") && !keys.has("dampingRatio"))) {
        return keyframes$1;
    }
    else if (keys.has("dampingRatio") ||
        keys.has("stiffness") ||
        keys.has("mass") ||
        keys.has("damping") ||
        keys.has("restSpeed") ||
        keys.has("restDelta")) {
        return spring;
    }
    return keyframes$1;
}

function loopElapsed(elapsed, duration, delay = 0) {
    return elapsed - duration - delay;
}
function reverseElapsed(elapsed, duration, delay = 0, isForwardPlayback = true) {
    return isForwardPlayback
        ? loopElapsed(duration + -elapsed, duration, delay)
        : duration - (elapsed - duration) + delay;
}
function hasRepeatDelayElapsed(elapsed, duration, delay, isForwardPlayback) {
    return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
}

const framesync = (update) => {
    const passTimestamp = ({ delta }) => update(delta);
    return {
        start: () => sync.update(passTimestamp, true),
        stop: () => cancelSync.update(passTimestamp),
    };
};
function animate$1(_a) {
    var _b, _c;
    var { from, autoplay = true, driver = framesync, elapsed = 0, repeat: repeatMax = 0, repeatType = "loop", repeatDelay = 0, onPlay, onStop, onComplete, onRepeat, onUpdate } = _a, options = __rest(_a, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]);
    let { to } = options;
    let driverControls;
    let repeatCount = 0;
    let computedDuration = options.duration;
    let latest;
    let isComplete = false;
    let isForwardPlayback = true;
    let interpolateFromNumber;
    const animator = detectAnimationFromOptions(options);
    if ((_c = (_b = animator).needsInterpolation) === null || _c === void 0 ? void 0 : _c.call(_b, from, to)) {
        interpolateFromNumber = interpolate$1([0, 100], [from, to], {
            clamp: false,
        });
        from = 0;
        to = 100;
    }
    const animation = animator(Object.assign(Object.assign({}, options), { from, to }));
    function repeat() {
        repeatCount++;
        if (repeatType === "reverse") {
            isForwardPlayback = repeatCount % 2 === 0;
            elapsed = reverseElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback);
        }
        else {
            elapsed = loopElapsed(elapsed, computedDuration, repeatDelay);
            if (repeatType === "mirror")
                animation.flipTarget();
        }
        isComplete = false;
        onRepeat && onRepeat();
    }
    function complete() {
        driverControls.stop();
        onComplete && onComplete();
    }
    function update(delta) {
        if (!isForwardPlayback)
            delta = -delta;
        elapsed += delta;
        if (!isComplete) {
            const state = animation.next(Math.max(0, elapsed));
            latest = state.value;
            if (interpolateFromNumber)
                latest = interpolateFromNumber(latest);
            isComplete = isForwardPlayback ? state.done : elapsed <= 0;
        }
        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(latest);
        if (isComplete) {
            if (repeatCount === 0)
                computedDuration !== null && computedDuration !== void 0 ? computedDuration : (computedDuration = elapsed);
            if (repeatCount < repeatMax) {
                hasRepeatDelayElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback) && repeat();
            }
            else {
                complete();
            }
        }
    }
    function play() {
        onPlay === null || onPlay === void 0 ? void 0 : onPlay();
        driverControls = driver(update);
        driverControls.start();
    }
    autoplay && play();
    return {
        stop: () => {
            onStop === null || onStop === void 0 ? void 0 : onStop();
            driverControls.stop();
        },
    };
}

function velocityPerSecond(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

function inertia({ from = 0, velocity = 0, min, max, power = 0.8, timeConstant = 750, bounceStiffness = 500, bounceDamping = 10, restDelta = 1, modifyTarget, driver, onUpdate, onComplete, onStop, }) {
    let currentAnimation;
    function isOutOfBounds(v) {
        return (min !== undefined && v < min) || (max !== undefined && v > max);
    }
    function boundaryNearest(v) {
        if (min === undefined)
            return max;
        if (max === undefined)
            return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    }
    function startAnimation(options) {
        currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop();
        currentAnimation = animate$1(Object.assign(Object.assign({}, options), { driver, onUpdate: (v) => {
                var _a;
                onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(v);
                (_a = options.onUpdate) === null || _a === void 0 ? void 0 : _a.call(options, v);
            }, onComplete,
            onStop }));
    }
    function startSpring(options) {
        startAnimation(Object.assign({ type: "spring", stiffness: bounceStiffness, damping: bounceDamping, restDelta }, options));
    }
    if (isOutOfBounds(from)) {
        startSpring({ from, velocity, to: boundaryNearest(from) });
    }
    else {
        let target = power * velocity + from;
        if (typeof modifyTarget !== "undefined")
            target = modifyTarget(target);
        const boundary = boundaryNearest(target);
        const heading = boundary === min ? -1 : 1;
        let prev;
        let current;
        const checkBoundary = (v) => {
            prev = current;
            current = v;
            velocity = velocityPerSecond(v - prev, getFrameData().delta);
            if ((heading === 1 && v > boundary) ||
                (heading === -1 && v < boundary)) {
                startSpring({ from: v, to: boundary, velocity });
            }
        };
        startAnimation({
            type: "decay",
            from,
            velocity,
            timeConstant,
            power,
            restDelta,
            modifyTarget,
            onUpdate: isOutOfBounds(target) ? checkBoundary : undefined,
        });
    }
    return {
        stop: () => currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop(),
    };
}

const isPoint = (point) => point.hasOwnProperty('x') && point.hasOwnProperty('y');

const isPoint3D = (point) => isPoint(point) && point.hasOwnProperty('z');

const distance1D = (a, b) => Math.abs(a - b);
function distance(a, b) {
    if (isNum(a) && isNum(b)) {
        return distance1D(a, b);
    }
    else if (isPoint(a) && isPoint(b)) {
        const xDelta = distance1D(a.x, b.x);
        const yDelta = distance1D(a.y, b.y);
        const zDelta = isPoint3D(a) && isPoint3D(b) ? distance1D(a.z, b.z) : 0;
        return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2) + Math.pow(zDelta, 2));
    }
}

const a = (a1, a2) => 1.0 - 3.0 * a2 + 3.0 * a1;
const b$1 = (a1, a2) => 3.0 * a2 - 6.0 * a1;
const c$1 = (a1) => 3.0 * a1;
const calcBezier = (t, a1, a2) => ((a(a1, a2) * t + b$1(a1, a2)) * t + c$1(a1)) * t;
const getSlope = (t, a1, a2) => 3.0 * a(a1, a2) * t * t + 2.0 * b$1(a1, a2) * t + c$1(a1);
const subdivisionPrecision = 0.0000001;
const subdivisionMaxIterations = 10;
function binarySubdivide(aX, aA, aB, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = calcBezier(currentT, mX1, mX2) - aX;
        if (currentX > 0.0) {
            aB = currentT;
        }
        else {
            aA = currentT;
        }
    } while (Math.abs(currentX) > subdivisionPrecision &&
        ++i < subdivisionMaxIterations);
    return currentT;
}
const newtonIterations = 8;
const newtonMinSlope = 0.001;
function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for (let i = 0; i < newtonIterations; ++i) {
        const currentSlope = getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0.0) {
            return aGuessT;
        }
        const currentX = calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
}
const kSplineTableSize = 11;
const kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
function cubicBezier(mX1, mY1, mX2, mY2) {
    if (mX1 === mY1 && mX2 === mY2)
        return linear$2;
    const sampleValues = new Float32Array(kSplineTableSize);
    for (let i = 0; i < kSplineTableSize; ++i) {
        sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
    }
    function getTForX(aX) {
        let intervalStart = 0.0;
        let currentSample = 1;
        const lastSample = kSplineTableSize - 1;
        for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
            intervalStart += kSampleStepSize;
        }
        --currentSample;
        const dist = (aX - sampleValues[currentSample]) /
            (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        const guessForT = intervalStart + dist * kSampleStepSize;
        const initialSlope = getSlope(guessForT, mX1, mX2);
        if (initialSlope >= newtonMinSlope) {
            return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        }
        else if (initialSlope === 0.0) {
            return guessForT;
        }
        else {
            return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
        }
    }
    return (t) => t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
}

function addUniqueItem(arr, item) {
    arr.indexOf(item) === -1 && arr.push(item);
}
function removeItem(arr, item) {
    var index = arr.indexOf(item);
    index > -1 && arr.splice(index, 1);
}

var SubscriptionManager =  (function () {
    function SubscriptionManager() {
        this.subscriptions = [];
    }
    SubscriptionManager.prototype.add = function (handler) {
        var _this = this;
        addUniqueItem(this.subscriptions, handler);
        return function () { return removeItem(_this.subscriptions, handler); };
    };
    SubscriptionManager.prototype.notify = function (a, b, c) {
        var numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions)
            return;
        if (numSubscriptions === 1) {
            this.subscriptions[0](a, b, c);
        }
        else {
            for (var i = 0; i < numSubscriptions; i++) {
                var handler = this.subscriptions[i];
                handler && handler(a, b, c);
            }
        }
    };
    SubscriptionManager.prototype.getSize = function () {
        return this.subscriptions.length;
    };
    SubscriptionManager.prototype.clear = function () {
        this.subscriptions.length = 0;
    };
    return SubscriptionManager;
}());

var isFloat = function (value) {
    return !isNaN(parseFloat(value));
};
var MotionValue =  (function () {
    function MotionValue(init) {
        var _this = this;
        this.timeDelta = 0;
        this.lastUpdated = 0;
        this.updateSubscribers = new SubscriptionManager();
        this.velocityUpdateSubscribers = new SubscriptionManager();
        this.renderSubscribers = new SubscriptionManager();
        this.canTrackVelocity = false;
        this.updateAndNotify = function (v, render) {
            if (render === void 0) { render = true; }
            _this.prev = _this.current;
            _this.current = v;
            var _a = getFrameData(), delta = _a.delta, timestamp = _a.timestamp;
            if (_this.lastUpdated !== timestamp) {
                _this.timeDelta = delta;
                _this.lastUpdated = timestamp;
                sync.postRender(_this.scheduleVelocityCheck);
            }
            if (_this.prev !== _this.current) {
                _this.updateSubscribers.notify(_this.current);
            }
            if (_this.velocityUpdateSubscribers.getSize()) {
                _this.velocityUpdateSubscribers.notify(_this.getVelocity());
            }
            if (render) {
                _this.renderSubscribers.notify(_this.current);
            }
        };
        this.scheduleVelocityCheck = function () { return sync.postRender(_this.velocityCheck); };
        this.velocityCheck = function (_a) {
            var timestamp = _a.timestamp;
            if (timestamp !== _this.lastUpdated) {
                _this.prev = _this.current;
                _this.velocityUpdateSubscribers.notify(_this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = isFloat(this.current);
    }
    MotionValue.prototype.onChange = function (subscription) {
        return this.updateSubscribers.add(subscription);
    };
    MotionValue.prototype.clearListeners = function () {
        this.updateSubscribers.clear();
    };
    MotionValue.prototype.onRenderRequest = function (subscription) {
        subscription(this.get());
        return this.renderSubscribers.add(subscription);
    };
    MotionValue.prototype.attach = function (passiveEffect) {
        this.passiveEffect = passiveEffect;
    };
    MotionValue.prototype.set = function (v, render) {
        if (render === void 0) { render = true; }
        if (!render || !this.passiveEffect) {
            this.updateAndNotify(v, render);
        }
        else {
            this.passiveEffect(v, this.updateAndNotify);
        }
    };
    MotionValue.prototype.get = function () {
        return this.current;
    };
    MotionValue.prototype.getPrevious = function () {
        return this.prev;
    };
    MotionValue.prototype.getVelocity = function () {
        return this.canTrackVelocity
            ?
                velocityPerSecond(parseFloat(this.current) -
                    parseFloat(this.prev), this.timeDelta)
            : 0;
    };
    MotionValue.prototype.start = function (animation) {
        var _this = this;
        this.stop();
        return new Promise(function (resolve) {
            _this.hasAnimated = true;
            _this.stopAnimation = animation(resolve);
        }).then(function () { return _this.clearAnimation(); });
    };
    MotionValue.prototype.stop = function () {
        if (this.stopAnimation)
            this.stopAnimation();
        this.clearAnimation();
    };
    MotionValue.prototype.isAnimating = function () {
        return !!this.stopAnimation;
    };
    MotionValue.prototype.clearAnimation = function () {
        this.stopAnimation = null;
    };
    MotionValue.prototype.destroy = function () {
        this.updateSubscribers.clear();
        this.renderSubscribers.clear();
        this.stop();
    };
    return MotionValue;
}());
function motionValue(init) {
    return new MotionValue(init);
}

var isMotionValue = function (value) {
    return Boolean(value !== null && typeof value === "object" && value.getVelocity);
};

var secondsToMilliseconds = function (seconds) { return seconds * 1000; };

var easingLookup = {
    linear: linear$2,
    easeIn: easeIn,
    easeInOut: easeInOut,
    easeOut: easeOut,
    circIn: circIn,
    circInOut: circInOut,
    circOut: circOut,
    backIn: backIn,
    backInOut: backInOut,
    backOut: backOut,
    anticipate: anticipate,
    bounceIn: bounceIn,
    bounceInOut: bounceInOut,
    bounceOut: bounceOut,
};
var easingDefinitionToFunction = function (definition) {
    if (Array.isArray(definition)) {
        invariant(definition.length === 4, "Cubic bezier arrays must contain four numerical values.");
        var _a = __read(definition, 4), x1 = _a[0], y1 = _a[1], x2 = _a[2], y2 = _a[3];
        return cubicBezier(x1, y1, x2, y2);
    }
    else if (typeof definition === "string") {
        invariant(easingLookup[definition] !== undefined, "Invalid easing type '".concat(definition, "'"));
        return easingLookup[definition];
    }
    return definition;
};
var isEasingArray = function (ease) {
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

var isAnimatable = function (key, value) {
    if (key === "zIndex")
        return false;
    if (typeof value === "number" || Array.isArray(value))
        return true;
    if (typeof value === "string" &&
        complex.test(value) &&
        !value.startsWith("url(")
    ) {
        return true;
    }
    return false;
};

var isKeyframesTarget = function (v) {
    return Array.isArray(v);
};

var underDampedSpring = function () { return ({
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10,
}); };
var criticallyDampedSpring = function (to) { return ({
    type: "spring",
    stiffness: 550,
    damping: to === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10,
}); };
var linearTween = function () { return ({
    type: "keyframes",
    ease: "linear",
    duration: 0.3,
}); };
var keyframes = function (values) { return ({
    type: "keyframes",
    duration: 0.8,
    values: values,
}); };
var defaultTransitions = {
    x: underDampedSpring,
    y: underDampedSpring,
    z: underDampedSpring,
    rotate: underDampedSpring,
    rotateX: underDampedSpring,
    rotateY: underDampedSpring,
    rotateZ: underDampedSpring,
    scaleX: criticallyDampedSpring,
    scaleY: criticallyDampedSpring,
    scale: criticallyDampedSpring,
    opacity: linearTween,
    backgroundColor: linearTween,
    color: linearTween,
    default: criticallyDampedSpring,
};
var getDefaultTransition = function (valueKey, to) {
    var transitionFactory;
    if (isKeyframesTarget(to)) {
        transitionFactory = keyframes;
    }
    else {
        transitionFactory =
            defaultTransitions[valueKey] || defaultTransitions.default;
    }
    return __assign$2({ to: to }, transitionFactory(to));
};

var int$1 = __assign$2(__assign$2({}, number$2), { transform: Math.round });

var numberValueTypes = {
    borderWidth: px,
    borderTopWidth: px,
    borderRightWidth: px,
    borderBottomWidth: px,
    borderLeftWidth: px,
    borderRadius: px,
    radius: px,
    borderTopLeftRadius: px,
    borderTopRightRadius: px,
    borderBottomRightRadius: px,
    borderBottomLeftRadius: px,
    width: px,
    maxWidth: px,
    height: px,
    maxHeight: px,
    size: px,
    top: px,
    right: px,
    bottom: px,
    left: px,
    padding: px,
    paddingTop: px,
    paddingRight: px,
    paddingBottom: px,
    paddingLeft: px,
    margin: px,
    marginTop: px,
    marginRight: px,
    marginBottom: px,
    marginLeft: px,
    rotate: degrees,
    rotateX: degrees,
    rotateY: degrees,
    rotateZ: degrees,
    scale: scale,
    scaleX: scale,
    scaleY: scale,
    scaleZ: scale,
    skew: degrees,
    skewX: degrees,
    skewY: degrees,
    distance: px,
    translateX: px,
    translateY: px,
    translateZ: px,
    x: px,
    y: px,
    z: px,
    perspective: px,
    transformPerspective: px,
    opacity: alpha,
    originX: progressPercentage,
    originY: progressPercentage,
    originZ: px,
    zIndex: int$1,
    fillOpacity: alpha,
    strokeOpacity: alpha,
    numOctaves: int$1,
};

var defaultValueTypes = __assign$2(__assign$2({}, numberValueTypes), {
    color: color$1, backgroundColor: color$1, outlineColor: color$1, fill: color$1, stroke: color$1,
    borderColor: color$1, borderTopColor: color$1, borderRightColor: color$1, borderBottomColor: color$1, borderLeftColor: color$1, filter: filter$3, WebkitFilter: filter$3 });
var getDefaultValueType = function (key) { return defaultValueTypes[key]; };

function getAnimatableNone(key, value) {
    var _a;
    var defaultValueType = getDefaultValueType(key);
    if (defaultValueType !== filter$3)
        defaultValueType = complex;
    return (_a = defaultValueType.getAnimatableNone) === null || _a === void 0 ? void 0 : _a.call(defaultValueType, value);
}

var instantAnimationState = {
    current: false,
};

var isCustomValue = function (v) {
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
var resolveFinalValueInKeyframes = function (v) {
    return isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
};

function isTransitionDefined(_a) {
    _a.when; _a.delay; _a.delayChildren; _a.staggerChildren; _a.staggerDirection; _a.repeat; _a.repeatType; _a.repeatDelay; _a.from; var transition = __rest(_a, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
    return !!Object.keys(transition).length;
}
var legacyRepeatWarning = false;
function convertTransitionToAnimationOptions(_a) {
    var ease = _a.ease, times = _a.times, yoyo = _a.yoyo, flip = _a.flip, loop = _a.loop, transition = __rest(_a, ["ease", "times", "yoyo", "flip", "loop"]);
    var options = __assign$2({}, transition);
    if (times)
        options["offset"] = times;
    if (transition.duration)
        options["duration"] = secondsToMilliseconds(transition.duration);
    if (transition.repeatDelay)
        options.repeatDelay = secondsToMilliseconds(transition.repeatDelay);
    if (ease) {
        options["ease"] = isEasingArray(ease)
            ? ease.map(easingDefinitionToFunction)
            : easingDefinitionToFunction(ease);
    }
    if (transition.type === "tween")
        options.type = "keyframes";
    if (yoyo || loop || flip) {
        warning$3(!legacyRepeatWarning, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options.");
        legacyRepeatWarning = true;
        if (yoyo) {
            options.repeatType = "reverse";
        }
        else if (loop) {
            options.repeatType = "loop";
        }
        else if (flip) {
            options.repeatType = "mirror";
        }
        options.repeat = loop || yoyo || flip || transition.repeat;
    }
    if (transition.type !== "spring")
        options.type = "keyframes";
    return options;
}
function getDelayFromTransition(transition, key) {
    var _a, _b;
    var valueTransition = getValueTransition(transition, key) || {};
    return (_b = (_a = valueTransition.delay) !== null && _a !== void 0 ? _a : transition.delay) !== null && _b !== void 0 ? _b : 0;
}
function hydrateKeyframes(options) {
    if (Array.isArray(options.to) && options.to[0] === null) {
        options.to = __spreadArray([], __read(options.to), false);
        options.to[0] = options.from;
    }
    return options;
}
function getPopmotionAnimationOptions(transition, options, key) {
    var _a;
    if (Array.isArray(options.to)) {
        (_a = transition.duration) !== null && _a !== void 0 ? _a : (transition.duration = 0.8);
    }
    hydrateKeyframes(options);
    if (!isTransitionDefined(transition)) {
        transition = __assign$2(__assign$2({}, transition), getDefaultTransition(key, options.to));
    }
    return __assign$2(__assign$2({}, options), convertTransitionToAnimationOptions(transition));
}
function getAnimation(key, value, target, transition, onComplete) {
    var _a;
    var valueTransition = getValueTransition(transition, key);
    var origin = (_a = valueTransition.from) !== null && _a !== void 0 ? _a : value.get();
    var isTargetAnimatable = isAnimatable(key, target);
    if (origin === "none" && isTargetAnimatable && typeof target === "string") {
        origin = getAnimatableNone(key, target);
    }
    else if (isZero(origin) && typeof target === "string") {
        origin = getZeroUnit(target);
    }
    else if (!Array.isArray(target) &&
        isZero(target) &&
        typeof origin === "string") {
        target = getZeroUnit(origin);
    }
    var isOriginAnimatable = isAnimatable(key, origin);
    warning$3(isOriginAnimatable === isTargetAnimatable, "You are trying to animate ".concat(key, " from \"").concat(origin, "\" to \"").concat(target, "\". ").concat(origin, " is not an animatable value - to enable this animation set ").concat(origin, " to a value animatable to ").concat(target, " via the `style` property."));
    function start() {
        var options = {
            from: origin,
            to: target,
            velocity: value.getVelocity(),
            onComplete: onComplete,
            onUpdate: function (v) { return value.set(v); },
        };
        return valueTransition.type === "inertia" ||
            valueTransition.type === "decay"
            ? inertia(__assign$2(__assign$2({}, options), valueTransition))
            : animate$1(__assign$2(__assign$2({}, getPopmotionAnimationOptions(valueTransition, options, key)), { onUpdate: function (v) {
                    var _a;
                    options.onUpdate(v);
                    (_a = valueTransition.onUpdate) === null || _a === void 0 ? void 0 : _a.call(valueTransition, v);
                }, onComplete: function () {
                    var _a;
                    options.onComplete();
                    (_a = valueTransition.onComplete) === null || _a === void 0 ? void 0 : _a.call(valueTransition);
                } }));
    }
    function set() {
        var _a, _b;
        var finalTarget = resolveFinalValueInKeyframes(target);
        value.set(finalTarget);
        onComplete();
        (_a = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onUpdate) === null || _a === void 0 ? void 0 : _a.call(valueTransition, finalTarget);
        (_b = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onComplete) === null || _b === void 0 ? void 0 : _b.call(valueTransition);
        return { stop: function () { } };
    }
    return !isOriginAnimatable ||
        !isTargetAnimatable ||
        valueTransition.type === false
        ? set
        : start;
}
function isZero(value) {
    return (value === 0 ||
        (typeof value === "string" &&
            parseFloat(value) === 0 &&
            value.indexOf(" ") === -1));
}
function getZeroUnit(potentialUnitType) {
    return typeof potentialUnitType === "number"
        ? 0
        : getAnimatableNone("", potentialUnitType);
}
function getValueTransition(transition, key) {
    return transition[key] || transition["default"] || transition;
}
function startAnimation(key, value, target, transition) {
    if (transition === void 0) { transition = {}; }
    if (instantAnimationState.current) {
        transition = { type: false };
    }
    return value.start(function (onComplete) {
        var delayTimer;
        var controls;
        var animation = getAnimation(key, value, target, transition, onComplete);
        var delay = getDelayFromTransition(transition, key);
        var start = function () { return (controls = animation()); };
        if (delay) {
            delayTimer = setTimeout(start, secondsToMilliseconds(delay));
        }
        else {
            start();
        }
        return function () {
            clearTimeout(delayTimer);
            controls === null || controls === void 0 ? void 0 : controls.stop();
        };
    });
}

function animate(from, to, transition) {
    if (transition === void 0) { transition = {}; }
    var value = isMotionValue(from) ? from : motionValue(from);
    startAnimation("", value, to, transition);
    return {
        stop: function () { return value.stop(); },
        isAnimating: function () { return value.isAnimating(); },
    };
}

var borders = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"];
var numBorders = borders.length;
var asNumber$1 = function (value) {
    return typeof value === "string" ? parseFloat(value) : value;
};
var isPx = function (value) {
    return typeof value === "number" || px.test(value);
};
function mixValues(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    var _a, _b, _c, _d;
    if (shouldCrossfadeOpacity) {
        target.opacity = mix(0,
        (_a = lead.opacity) !== null && _a !== void 0 ? _a : 1, easeCrossfadeIn(progress));
        target.opacityExit = mix((_b = follow.opacity) !== null && _b !== void 0 ? _b : 1, 0, easeCrossfadeOut(progress));
    }
    else if (isOnlyMember) {
        target.opacity = mix((_c = follow.opacity) !== null && _c !== void 0 ? _c : 1, (_d = lead.opacity) !== null && _d !== void 0 ? _d : 1, progress);
    }
    for (var i = 0; i < numBorders; i++) {
        var borderLabel = "border".concat(borders[i], "Radius");
        var followRadius = getRadius(follow, borderLabel);
        var leadRadius = getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined)
            continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        var canMix = followRadius === 0 ||
            leadRadius === 0 ||
            isPx(followRadius) === isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max(mix(asNumber$1(followRadius), asNumber$1(leadRadius), progress), 0);
            if (percent.test(leadRadius) || percent.test(followRadius)) {
                target[borderLabel] += "%";
            }
        }
        else {
            target[borderLabel] = leadRadius;
        }
    }
    if (follow.rotate || lead.rotate) {
        target.rotate = mix(follow.rotate || 0, lead.rotate || 0, progress);
    }
}
function getRadius(values, radiusName) {
    var _a;
    return (_a = values[radiusName]) !== null && _a !== void 0 ? _a : values.borderRadius;
}
var easeCrossfadeIn = compress(0, 0.5, circOut);
var easeCrossfadeOut = compress(0.5, 0.95, linear$2);
function compress(min, max, easing) {
    return function (p) {
        if (p < min)
            return 0;
        if (p > max)
            return 1;
        return easing(progress(min, max, p));
    };
}

function copyAxisInto(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
function copyBoxInto(box, originBox) {
    copyAxisInto(box.x, originBox.x);
    copyAxisInto(box.y, originBox.y);
}

function isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function hasScale(_a) {
    var scale = _a.scale, scaleX = _a.scaleX, scaleY = _a.scaleY;
    return (!isIdentityScale(scale) ||
        !isIdentityScale(scaleX) ||
        !isIdentityScale(scaleY));
}
function hasTransform(values) {
    return (hasScale(values) ||
        hasTranslate(values.x) ||
        hasTranslate(values.y) ||
        values.z ||
        values.rotate ||
        values.rotateX ||
        values.rotateY);
}
function hasTranslate(value) {
    return value && value !== "0%";
}

function scalePoint(point, scale, originPoint) {
    var distanceFromOrigin = point - originPoint;
    var scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
function applyPointDelta(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) {
        point = scalePoint(point, boxScale, originPoint);
    }
    return scalePoint(point, scale, originPoint) + translate;
}
function applyAxisDelta(axis, translate, scale, originPoint, boxScale) {
    if (translate === void 0) { translate = 0; }
    if (scale === void 0) { scale = 1; }
    axis.min = applyPointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = applyPointDelta(axis.max, translate, scale, originPoint, boxScale);
}
function applyBoxDelta(box, _a) {
    var x = _a.x, y = _a.y;
    applyAxisDelta(box.x, x.translate, x.scale, x.originPoint);
    applyAxisDelta(box.y, y.translate, y.scale, y.originPoint);
}
function applyTreeDeltas(box, treeScale, treePath, isSharedTransition) {
    var _a, _b;
    if (isSharedTransition === void 0) { isSharedTransition = false; }
    var treeLength = treePath.length;
    if (!treeLength)
        return;
    treeScale.x = treeScale.y = 1;
    var node;
    var delta;
    for (var i = 0; i < treeLength; i++) {
        node = treePath[i];
        delta = node.projectionDelta;
        if (((_b = (_a = node.instance) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.display) === "contents")
            continue;
        if (isSharedTransition &&
            node.options.layoutScroll &&
            node.scroll &&
            node !== node.root) {
            transformBox(box, { x: -node.scroll.x, y: -node.scroll.y });
        }
        if (delta) {
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            applyBoxDelta(box, delta);
        }
        if (isSharedTransition && hasTransform(node.latestValues)) {
            transformBox(box, node.latestValues);
        }
    }
}
function translateAxis(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
function transformAxis(axis, transforms, _a) {
    var _b = __read(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    var axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    var originPoint = mix(axis.min, axis.max, axisOrigin);
    applyAxisDelta(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
var xKeys$1 = ["x", "scaleX", "originX"];
var yKeys$1 = ["y", "scaleY", "originY"];
function transformBox(box, transform) {
    transformAxis(box.x, transform, xKeys$1);
    transformAxis(box.y, transform, yKeys$1);
}

function calcLength(axis) {
    return axis.max - axis.min;
}
function isNear(value, target, maxDistance) {
    if (target === void 0) { target = 0; }
    if (maxDistance === void 0) { maxDistance = 0.01; }
    return distance(value, target) < maxDistance;
}
function calcAxisDelta(delta, source, target, origin) {
    if (origin === void 0) { origin = 0.5; }
    delta.origin = origin;
    delta.originPoint = mix(source.min, source.max, delta.origin);
    delta.scale = calcLength(target) / calcLength(source);
    if (isNear(delta.scale, 1, 0.0001) || isNaN(delta.scale))
        delta.scale = 1;
    delta.translate =
        mix(target.min, target.max, delta.origin) - delta.originPoint;
    if (isNear(delta.translate) || isNaN(delta.translate))
        delta.translate = 0;
}
function calcBoxDelta(delta, source, target, origin) {
    calcAxisDelta(delta.x, source.x, target.x, origin === null || origin === void 0 ? void 0 : origin.originX);
    calcAxisDelta(delta.y, source.y, target.y, origin === null || origin === void 0 ? void 0 : origin.originY);
}
function calcRelativeAxis(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + calcLength(relative);
}
function calcRelativeBox(target, relative, parent) {
    calcRelativeAxis(target.x, relative.x, parent.x);
    calcRelativeAxis(target.y, relative.y, parent.y);
}
function calcRelativeAxisPosition(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + calcLength(layout);
}
function calcRelativePosition(target, layout, parent) {
    calcRelativeAxisPosition(target.x, layout.x, parent.x);
    calcRelativeAxisPosition(target.y, layout.y, parent.y);
}

function removePointDelta(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = scalePoint(point, 1 / scale, originPoint);
    if (boxScale !== undefined) {
        point = scalePoint(point, 1 / boxScale, originPoint);
    }
    return point;
}
function removeAxisDelta(axis, translate, scale, origin, boxScale, originAxis, sourceAxis) {
    if (translate === void 0) { translate = 0; }
    if (scale === void 0) { scale = 1; }
    if (origin === void 0) { origin = 0.5; }
    if (originAxis === void 0) { originAxis = axis; }
    if (sourceAxis === void 0) { sourceAxis = axis; }
    if (percent.test(translate)) {
        translate = parseFloat(translate);
        var relativeProgress = mix(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number")
        return;
    var originPoint = mix(originAxis.min, originAxis.max, origin);
    if (axis === originAxis)
        originPoint -= translate;
    axis.min = removePointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = removePointDelta(axis.max, translate, scale, originPoint, boxScale);
}
function removeAxisTransforms(axis, transforms, _a, origin, sourceAxis) {
    var _b = __read(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    removeAxisDelta(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
var xKeys = ["x", "scaleX", "originX"];
var yKeys = ["y", "scaleY", "originY"];
function removeBoxTransforms(box, transforms, originBox, sourceBox) {
    removeAxisTransforms(box.x, transforms, xKeys, originBox === null || originBox === void 0 ? void 0 : originBox.x, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.x);
    removeAxisTransforms(box.y, transforms, yKeys, originBox === null || originBox === void 0 ? void 0 : originBox.y, sourceBox === null || sourceBox === void 0 ? void 0 : sourceBox.y);
}

var createAxisDelta = function () { return ({
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0,
}); };
var createDelta = function () { return ({
    x: createAxisDelta(),
    y: createAxisDelta(),
}); };
var createAxis = function () { return ({ min: 0, max: 0 }); };
var createBox = function () { return ({
    x: createAxis(),
    y: createAxis(),
}); };

function isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function isDeltaZero(delta) {
    return isAxisDeltaZero(delta.x) && isAxisDeltaZero(delta.y);
}
function boxEquals(a, b) {
    return (a.x.min === b.x.min &&
        a.x.max === b.x.max &&
        a.y.min === b.y.min &&
        a.y.max === b.y.max);
}

var NodeStack =  (function () {
    function NodeStack() {
        this.members = [];
    }
    NodeStack.prototype.add = function (node) {
        addUniqueItem(this.members, node);
        node.scheduleRender();
    };
    NodeStack.prototype.remove = function (node) {
        removeItem(this.members, node);
        if (node === this.prevLead) {
            this.prevLead = undefined;
        }
        if (node === this.lead) {
            var prevLead = this.members[this.members.length - 1];
            if (prevLead) {
                this.promote(prevLead);
            }
        }
    };
    NodeStack.prototype.relegate = function (node) {
        var indexOfNode = this.members.findIndex(function (member) { return node === member; });
        if (indexOfNode === 0)
            return false;
        var prevLead;
        for (var i = indexOfNode; i >= 0; i--) {
            var member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        }
        else {
            return false;
        }
    };
    NodeStack.prototype.promote = function (node, preserveFollowOpacity) {
        var _a;
        var prevLead = this.lead;
        if (node === prevLead)
            return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) {
                node.resumeFrom.preserveOpacity = true;
            }
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues =
                    prevLead.animationValues || prevLead.latestValues;
                node.snapshot.isShared = true;
            }
            if ((_a = node.root) === null || _a === void 0 ? void 0 : _a.isUpdating) {
                node.isLayoutDirty = true;
            }
            var crossfade = node.options.crossfade;
            if (crossfade === false) {
                prevLead.hide();
            }
        }
    };
    NodeStack.prototype.exitAnimationComplete = function () {
        this.members.forEach(function (node) {
            var _a, _b, _c, _d, _e;
            (_b = (_a = node.options).onExitComplete) === null || _b === void 0 ? void 0 : _b.call(_a);
            (_e = (_c = node.resumingFrom) === null || _c === void 0 ? void 0 : (_d = _c.options).onExitComplete) === null || _e === void 0 ? void 0 : _e.call(_d);
        });
    };
    NodeStack.prototype.scheduleRender = function () {
        this.members.forEach(function (node) {
            node.instance && node.scheduleRender(false);
        });
    };
    NodeStack.prototype.removeLeadSnapshot = function () {
        if (this.lead && this.lead.snapshot) {
            this.lead.snapshot = undefined;
        }
    };
    return NodeStack;
}());

var scaleCorrectors = {};
function addScaleCorrector(correctors) {
    Object.assign(scaleCorrectors, correctors);
}

var identityProjection = "translate3d(0px, 0px, 0) scale(1, 1)";
function buildProjectionTransform(delta, treeScale, latestTransform) {
    var xTranslate = delta.x.translate / treeScale.x;
    var yTranslate = delta.y.translate / treeScale.y;
    var transform = "translate3d(".concat(xTranslate, "px, ").concat(yTranslate, "px, 0) ");
    if (latestTransform) {
        var rotate = latestTransform.rotate, rotateX = latestTransform.rotateX, rotateY = latestTransform.rotateY;
        if (rotate)
            transform += "rotate(".concat(rotate, "deg) ");
        if (rotateX)
            transform += "rotateX(".concat(rotateX, "deg) ");
        if (rotateY)
            transform += "rotateY(".concat(rotateY, "deg) ");
    }
    transform += "scale(".concat(delta.x.scale, ", ").concat(delta.y.scale, ")");
    return transform === identityProjection ? "none" : transform;
}

function eachAxis(callback) {
    return [callback("x"), callback("y")];
}

var transformAxes = ["", "X", "Y", "Z"];
var order = ["translate", "scale", "rotate", "skew"];
var transformProps = ["transformPerspective", "x", "y", "z"];
order.forEach(function (operationKey) {
    return transformAxes.forEach(function (axesKey) {
        return transformProps.push(operationKey + axesKey);
    });
});
function sortTransformProps(a, b) {
    return transformProps.indexOf(a) - transformProps.indexOf(b);
}
var transformPropSet = new Set(transformProps);
function isTransformProp(key) {
    return transformPropSet.has(key);
}
var transformOriginProps = new Set(["originX", "originY", "originZ"]);
function isTransformOriginProp(key) {
    return transformOriginProps.has(key);
}

var compareByDepth = function (a, b) {
    return a.depth - b.depth;
};

var FlatTree =  (function () {
    function FlatTree() {
        this.children = [];
        this.isDirty = false;
    }
    FlatTree.prototype.add = function (child) {
        addUniqueItem(this.children, child);
        this.isDirty = true;
    };
    FlatTree.prototype.remove = function (child) {
        removeItem(this.children, child);
        this.isDirty = true;
    };
    FlatTree.prototype.forEach = function (callback) {
        this.isDirty && this.children.sort(compareByDepth);
        this.isDirty = false;
        this.children.forEach(callback);
    };
    return FlatTree;
}());

function resolveMotionValue(value) {
    var unwrappedValue = isMotionValue(value) ? value.get() : value;
    return isCustomValue(unwrappedValue)
        ? unwrappedValue.toValue()
        : unwrappedValue;
}

var animationTarget = 1000;
var globalProjectionState = {
    hasAnimatedSinceResize: true,
    hasEverUpdated: false,
};
function createProjectionNode(_a) {
    var attachResizeListener = _a.attachResizeListener, defaultParent = _a.defaultParent, measureScroll = _a.measureScroll, resetTransform = _a.resetTransform;
    return  (function () {
        function ProjectionNode(id, latestValues, parent) {
            var _this = this;
            if (latestValues === void 0) { latestValues = {}; }
            if (parent === void 0) { parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent(); }
            this.children = new Set();
            this.options = {};
            this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            this.isLayoutDirty = false;
            this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            this.isUpdating = false;
            this.isSVG = false;
            this.needsReset = false;
            this.shouldResetTransform = false;
            this.treeScale = { x: 1, y: 1 };
            this.eventHandlers = new Map();
            this.potentialNodes = new Map();
            this.checkUpdateFailed = function () {
                if (_this.isUpdating) {
                    _this.isUpdating = false;
                    _this.clearAllSnapshots();
                }
            };
            this.updateProjection = function () {
                _this.nodes.forEach(resolveTargetDelta);
                _this.nodes.forEach(calcProjection);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            this.sharedNodes = new Map();
            this.id = id;
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? __spreadArray(__spreadArray([], __read(parent.path), false), [parent], false) : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            id && this.root.registerPotentialNode(id, this);
            for (var i = 0; i < this.path.length; i++) {
                this.path[i].shouldResetTransform = true;
            }
            if (this.root === this)
                this.nodes = new FlatTree();
        }
        ProjectionNode.prototype.addEventListener = function (name, handler) {
            if (!this.eventHandlers.has(name)) {
                this.eventHandlers.set(name, new SubscriptionManager());
            }
            return this.eventHandlers.get(name).add(handler);
        };
        ProjectionNode.prototype.notifyListeners = function (name) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            var subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager === null || subscriptionManager === void 0 ? void 0 : subscriptionManager.notify.apply(subscriptionManager, __spreadArray([], __read(args), false));
        };
        ProjectionNode.prototype.hasListeners = function (name) {
            return this.eventHandlers.has(name);
        };
        ProjectionNode.prototype.registerPotentialNode = function (id, node) {
            this.potentialNodes.set(id, node);
        };
        ProjectionNode.prototype.mount = function (instance, isLayoutDirty) {
            var _this = this;
            var _a;
            if (isLayoutDirty === void 0) { isLayoutDirty = false; }
            if (this.instance)
                return;
            this.isSVG =
                instance instanceof SVGElement && instance.tagName !== "svg";
            this.instance = instance;
            var _b = this.options, layoutId = _b.layoutId, layout = _b.layout, visualElement = _b.visualElement;
            if (visualElement && !visualElement.getInstance()) {
                visualElement.mount(instance);
            }
            this.root.nodes.add(this);
            (_a = this.parent) === null || _a === void 0 ? void 0 : _a.children.add(this);
            this.id && this.root.potentialNodes.delete(this.id);
            if (isLayoutDirty && (layout || layoutId)) {
                this.isLayoutDirty = true;
            }
            if (attachResizeListener) {
                var unblockTimeout_1;
                var resizeUnblockUpdate_1 = function () {
                    return (_this.root.updateBlockedByResize = false);
                };
                attachResizeListener(instance, function () {
                    _this.root.updateBlockedByResize = true;
                    clearTimeout(unblockTimeout_1);
                    unblockTimeout_1 = setTimeout(resizeUnblockUpdate_1, 250);
                    if (globalProjectionState.hasAnimatedSinceResize) {
                        globalProjectionState.hasAnimatedSinceResize = false;
                        _this.nodes.forEach(finishAnimation);
                    }
                });
            }
            if (layoutId) {
                this.root.registerSharedNode(layoutId, this);
            }
            if (this.options.animate !== false &&
                visualElement &&
                (layoutId || layout)) {
                this.addEventListener("didUpdate", function (_a) {
                    var _b, _c, _d, _e, _f;
                    var delta = _a.delta, hasLayoutChanged = _a.hasLayoutChanged, hasRelativeTargetChanged = _a.hasRelativeTargetChanged, newLayout = _a.layout;
                    if (_this.isTreeAnimationBlocked()) {
                        _this.target = undefined;
                        _this.relativeTarget = undefined;
                        return;
                    }
                    var layoutTransition = (_c = (_b = _this.options.transition) !== null && _b !== void 0 ? _b : visualElement.getDefaultTransition()) !== null && _c !== void 0 ? _c : defaultLayoutTransition;
                    var onLayoutAnimationComplete = visualElement.getProps().onLayoutAnimationComplete;
                    var targetChanged = !_this.targetLayout ||
                        !boxEquals(_this.targetLayout, newLayout) ||
                        hasRelativeTargetChanged;
                    var hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                    if (((_d = _this.resumeFrom) === null || _d === void 0 ? void 0 : _d.instance) ||
                        hasOnlyRelativeTargetChanged ||
                        (hasLayoutChanged &&
                            (targetChanged || !_this.currentAnimation))) {
                        if (_this.resumeFrom) {
                            _this.resumingFrom = _this.resumeFrom;
                            _this.resumingFrom.resumingFrom = undefined;
                        }
                        _this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                        _this.startAnimation(__assign$2(__assign$2({}, getValueTransition(layoutTransition, "layout")), { onComplete: onLayoutAnimationComplete }));
                    }
                    else {
                        _this.isLead() && ((_f = (_e = _this.options).onExitComplete) === null || _f === void 0 ? void 0 : _f.call(_e));
                    }
                    _this.targetLayout = newLayout;
                });
            }
        };
        ProjectionNode.prototype.unmount = function () {
            var _a, _b;
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.remove(this);
            (_b = this.parent) === null || _b === void 0 ? void 0 : _b.children.delete(this);
            this.instance = undefined;
            cancelSync.preRender(this.updateProjection);
        };
        ProjectionNode.prototype.blockUpdate = function () {
            this.updateManuallyBlocked = true;
        };
        ProjectionNode.prototype.unblockUpdate = function () {
            this.updateManuallyBlocked = false;
        };
        ProjectionNode.prototype.isUpdateBlocked = function () {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        };
        ProjectionNode.prototype.isTreeAnimationBlocked = function () {
            var _a;
            return (this.isAnimationBlocked ||
                ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isTreeAnimationBlocked()) ||
                false);
        };
        ProjectionNode.prototype.startUpdate = function () {
            var _a;
            if (this.isUpdateBlocked())
                return;
            this.isUpdating = true;
            (_a = this.nodes) === null || _a === void 0 ? void 0 : _a.forEach(resetRotation);
        };
        ProjectionNode.prototype.willUpdate = function (shouldNotifyListeners) {
            var _a, _b, _c;
            if (shouldNotifyListeners === void 0) { shouldNotifyListeners = true; }
            if (this.root.isUpdateBlocked()) {
                (_b = (_a = this.options).onExitComplete) === null || _b === void 0 ? void 0 : _b.call(_a);
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty)
                return;
            this.isLayoutDirty = true;
            for (var i = 0; i < this.path.length; i++) {
                var node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll();
            }
            var _d = this.options, layoutId = _d.layoutId, layout = _d.layout;
            if (layoutId === undefined && !layout)
                return;
            var transformTemplate = (_c = this.options.visualElement) === null || _c === void 0 ? void 0 : _c.getProps().transformTemplate;
            this.prevTransformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        };
        ProjectionNode.prototype.didUpdate = function () {
            var updateWasBlocked = this.isUpdateBlocked();
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach(clearMeasurements);
                return;
            }
            if (!this.isUpdating)
                return;
            this.isUpdating = false;
            if (this.potentialNodes.size) {
                this.potentialNodes.forEach(mountNodeEarly);
                this.potentialNodes.clear();
            }
            this.nodes.forEach(resetTransformStyle);
            this.nodes.forEach(updateLayout);
            this.nodes.forEach(notifyLayoutUpdate);
            this.clearAllSnapshots();
            flushSync.update();
            flushSync.preRender();
            flushSync.render();
        };
        ProjectionNode.prototype.clearAllSnapshots = function () {
            this.nodes.forEach(clearSnapshot);
            this.sharedNodes.forEach(removeLeadSnapshots);
        };
        ProjectionNode.prototype.scheduleUpdateProjection = function () {
            sync.preRender(this.updateProjection, false, true);
        };
        ProjectionNode.prototype.scheduleCheckAfterUnmount = function () {
            var _this = this;
            sync.postRender(function () {
                if (_this.isLayoutDirty) {
                    _this.root.didUpdate();
                }
                else {
                    _this.root.checkUpdateFailed();
                }
            });
        };
        ProjectionNode.prototype.updateSnapshot = function () {
            if (this.snapshot || !this.instance)
                return;
            var measured = this.measure();
            var layout = this.removeTransform(this.removeElementScroll(measured));
            roundBox(layout);
            this.snapshot = {
                measured: measured,
                layout: layout,
                latestValues: {},
            };
        };
        ProjectionNode.prototype.updateLayout = function () {
            var _a;
            if (!this.instance)
                return;
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) &&
                !this.isLayoutDirty) {
                return;
            }
            if (this.resumeFrom && !this.resumeFrom.instance) {
                for (var i = 0; i < this.path.length; i++) {
                    var node = this.path[i];
                    node.updateScroll();
                }
            }
            var measured = this.measure();
            roundBox(measured);
            var prevLayout = this.layout;
            this.layout = {
                measured: measured,
                actual: this.removeElementScroll(measured),
            };
            this.layoutCorrected = createBox();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.actual);
            (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.notifyLayoutMeasure(this.layout.actual, prevLayout === null || prevLayout === void 0 ? void 0 : prevLayout.actual);
        };
        ProjectionNode.prototype.updateScroll = function () {
            if (this.options.layoutScroll && this.instance) {
                this.scroll = measureScroll(this.instance);
            }
        };
        ProjectionNode.prototype.resetTransform = function () {
            var _a;
            if (!resetTransform)
                return;
            var isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            var hasProjection = this.projectionDelta && !isDeltaZero(this.projectionDelta);
            var transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            var transformTemplateValue = transformTemplate === null || transformTemplate === void 0 ? void 0 : transformTemplate(this.latestValues, "");
            var transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested &&
                (hasProjection ||
                    hasTransform(this.latestValues) ||
                    transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        };
        ProjectionNode.prototype.measure = function () {
            var visualElement = this.options.visualElement;
            if (!visualElement)
                return createBox();
            var box = visualElement.measureViewportBox();
            var scroll = this.root.scroll;
            if (scroll) {
                translateAxis(box.x, scroll.x);
                translateAxis(box.y, scroll.y);
            }
            return box;
        };
        ProjectionNode.prototype.removeElementScroll = function (box) {
            var boxWithoutScroll = createBox();
            copyBoxInto(boxWithoutScroll, box);
            for (var i = 0; i < this.path.length; i++) {
                var node = this.path[i];
                var scroll_1 = node.scroll, options = node.options;
                if (node !== this.root && scroll_1 && options.layoutScroll) {
                    translateAxis(boxWithoutScroll.x, scroll_1.x);
                    translateAxis(boxWithoutScroll.y, scroll_1.y);
                }
            }
            return boxWithoutScroll;
        };
        ProjectionNode.prototype.applyTransform = function (box, transformOnly) {
            if (transformOnly === void 0) { transformOnly = false; }
            var withTransforms = createBox();
            copyBoxInto(withTransforms, box);
            for (var i = 0; i < this.path.length; i++) {
                var node = this.path[i];
                if (!transformOnly &&
                    node.options.layoutScroll &&
                    node.scroll &&
                    node !== node.root) {
                    transformBox(withTransforms, {
                        x: -node.scroll.x,
                        y: -node.scroll.y,
                    });
                }
                if (!hasTransform(node.latestValues))
                    continue;
                transformBox(withTransforms, node.latestValues);
            }
            if (hasTransform(this.latestValues)) {
                transformBox(withTransforms, this.latestValues);
            }
            return withTransforms;
        };
        ProjectionNode.prototype.removeTransform = function (box) {
            var _a;
            var boxWithoutTransform = createBox();
            copyBoxInto(boxWithoutTransform, box);
            for (var i = 0; i < this.path.length; i++) {
                var node = this.path[i];
                if (!node.instance)
                    continue;
                if (!hasTransform(node.latestValues))
                    continue;
                hasScale(node.latestValues) && node.updateSnapshot();
                var sourceBox = createBox();
                var nodeBox = node.measure();
                copyBoxInto(sourceBox, nodeBox);
                removeBoxTransforms(boxWithoutTransform, node.latestValues, (_a = node.snapshot) === null || _a === void 0 ? void 0 : _a.layout, sourceBox);
            }
            if (hasTransform(this.latestValues)) {
                removeBoxTransforms(boxWithoutTransform, this.latestValues);
            }
            return boxWithoutTransform;
        };
        ProjectionNode.prototype.setTargetDelta = function (delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
        };
        ProjectionNode.prototype.setOptions = function (options) {
            var _a;
            this.options = __assign$2(__assign$2(__assign$2({}, this.options), options), { crossfade: (_a = options.crossfade) !== null && _a !== void 0 ? _a : true });
        };
        ProjectionNode.prototype.clearMeasurements = function () {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        };
        ProjectionNode.prototype.resolveTargetDelta = function () {
            var _a;
            var _b = this.options, layout = _b.layout, layoutId = _b.layoutId;
            if (!this.layout || !(layout || layoutId))
                return;
            if (!this.targetDelta && !this.relativeTarget) {
                this.relativeParent = this.getClosestProjectingParent();
                if (this.relativeParent && this.relativeParent.layout) {
                    this.relativeTarget = createBox();
                    this.relativeTargetOrigin = createBox();
                    calcRelativePosition(this.relativeTargetOrigin, this.layout.actual, this.relativeParent.layout.actual);
                    copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
                }
            }
            if (!this.relativeTarget && !this.targetDelta)
                return;
            if (!this.target) {
                this.target = createBox();
                this.targetWithTransforms = createBox();
            }
            if (this.relativeTarget &&
                this.relativeTargetOrigin &&
                ((_a = this.relativeParent) === null || _a === void 0 ? void 0 : _a.target)) {
                calcRelativeBox(this.target, this.relativeTarget, this.relativeParent.target);
            }
            else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) {
                    this.target = this.applyTransform(this.layout.actual);
                }
                else {
                    copyBoxInto(this.target, this.layout.actual);
                }
                applyBoxDelta(this.target, this.targetDelta);
            }
            else {
                copyBoxInto(this.target, this.layout.actual);
            }
            if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                this.relativeParent = this.getClosestProjectingParent();
                if (this.relativeParent &&
                    Boolean(this.relativeParent.resumingFrom) ===
                        Boolean(this.resumingFrom) &&
                    !this.relativeParent.options.layoutScroll &&
                    this.relativeParent.target) {
                    this.relativeTarget = createBox();
                    this.relativeTargetOrigin = createBox();
                    calcRelativePosition(this.relativeTargetOrigin, this.target, this.relativeParent.target);
                    copyBoxInto(this.relativeTarget, this.relativeTargetOrigin);
                }
            }
        };
        ProjectionNode.prototype.getClosestProjectingParent = function () {
            if (!this.parent || hasTransform(this.parent.latestValues))
                return undefined;
            if ((this.parent.relativeTarget || this.parent.targetDelta) &&
                this.parent.layout) {
                return this.parent;
            }
            else {
                return this.parent.getClosestProjectingParent();
            }
        };
        ProjectionNode.prototype.calcProjection = function () {
            var _a;
            var _b = this.options, layout = _b.layout, layoutId = _b.layoutId;
            this.isTreeAnimating = Boolean(((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isTreeAnimating) ||
                this.currentAnimation ||
                this.pendingAnimation);
            if (!this.isTreeAnimating) {
                this.targetDelta = this.relativeTarget = undefined;
            }
            if (!this.layout || !(layout || layoutId))
                return;
            var lead = this.getLead();
            copyBoxInto(this.layoutCorrected, this.layout.actual);
            applyTreeDeltas(this.layoutCorrected, this.treeScale, this.path, Boolean(this.resumingFrom) || this !== lead);
            var target = lead.target;
            if (!target)
                return;
            if (!this.projectionDelta) {
                this.projectionDelta = createDelta();
                this.projectionDeltaWithTransform = createDelta();
            }
            var prevTreeScaleX = this.treeScale.x;
            var prevTreeScaleY = this.treeScale.y;
            var prevProjectionTransform = this.projectionTransform;
            calcBoxDelta(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = buildProjectionTransform(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform ||
                this.treeScale.x !== prevTreeScaleX ||
                this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
        };
        ProjectionNode.prototype.hide = function () {
            this.isVisible = false;
        };
        ProjectionNode.prototype.show = function () {
            this.isVisible = true;
        };
        ProjectionNode.prototype.scheduleRender = function (notifyAll) {
            var _a, _b, _c;
            if (notifyAll === void 0) { notifyAll = true; }
            (_b = (_a = this.options).scheduleRender) === null || _b === void 0 ? void 0 : _b.call(_a);
            notifyAll && ((_c = this.getStack()) === null || _c === void 0 ? void 0 : _c.scheduleRender());
            if (this.resumingFrom && !this.resumingFrom.instance) {
                this.resumingFrom = undefined;
            }
        };
        ProjectionNode.prototype.setAnimationOrigin = function (delta, hasOnlyRelativeTargetChanged) {
            var _this = this;
            var _a;
            if (hasOnlyRelativeTargetChanged === void 0) { hasOnlyRelativeTargetChanged = false; }
            var snapshot = this.snapshot;
            var snapshotLatestValues = (snapshot === null || snapshot === void 0 ? void 0 : snapshot.latestValues) || {};
            var mixedValues = __assign$2({}, this.latestValues);
            var targetDelta = createDelta();
            this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            var relativeLayout = createBox();
            var isSharedLayoutAnimation = snapshot === null || snapshot === void 0 ? void 0 : snapshot.isShared;
            var isOnlyMember = (((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.members.length) || 0) <= 1;
            var shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation &&
                !isOnlyMember &&
                this.options.crossfade === true &&
                !this.path.some(hasOpacityCrossfade));
            this.mixTargetDelta = function (latest) {
                var _a;
                var progress = latest / 1000;
                mixAxisDelta(targetDelta.x, delta.x, progress);
                mixAxisDelta(targetDelta.y, delta.y, progress);
                _this.setTargetDelta(targetDelta);
                if (_this.relativeTarget &&
                    _this.relativeTargetOrigin &&
                    _this.layout &&
                    ((_a = _this.relativeParent) === null || _a === void 0 ? void 0 : _a.layout)) {
                    calcRelativePosition(relativeLayout, _this.layout.actual, _this.relativeParent.layout.actual);
                    mixBox(_this.relativeTarget, _this.relativeTargetOrigin, relativeLayout, progress);
                }
                if (isSharedLayoutAnimation) {
                    _this.animationValues = mixedValues;
                    mixValues(mixedValues, snapshotLatestValues, _this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                _this.root.scheduleUpdateProjection();
                _this.scheduleRender();
            };
            this.mixTargetDelta(0);
        };
        ProjectionNode.prototype.startAnimation = function (options) {
            var _this = this;
            var _a, _b;
            (_a = this.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            if (this.resumingFrom) {
                (_b = this.resumingFrom.currentAnimation) === null || _b === void 0 ? void 0 : _b.stop();
            }
            if (this.pendingAnimation) {
                cancelSync.update(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            this.pendingAnimation = sync.update(function () {
                globalProjectionState.hasAnimatedSinceResize = true;
                _this.currentAnimation = animate(0, animationTarget, __assign$2(__assign$2({}, options), { onUpdate: function (latest) {
                        var _a;
                        _this.mixTargetDelta(latest);
                        (_a = options.onUpdate) === null || _a === void 0 ? void 0 : _a.call(options, latest);
                    }, onComplete: function () {
                        var _a;
                        (_a = options.onComplete) === null || _a === void 0 ? void 0 : _a.call(options);
                        _this.completeAnimation();
                    } }));
                if (_this.resumingFrom) {
                    _this.resumingFrom.currentAnimation = _this.currentAnimation;
                }
                _this.pendingAnimation = undefined;
            });
        };
        ProjectionNode.prototype.completeAnimation = function () {
            var _a;
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.exitAnimationComplete();
            this.resumingFrom =
                this.currentAnimation =
                    this.animationValues =
                        undefined;
            this.notifyListeners("animationComplete");
        };
        ProjectionNode.prototype.finishAnimation = function () {
            var _a;
            if (this.currentAnimation) {
                (_a = this.mixTargetDelta) === null || _a === void 0 ? void 0 : _a.call(this, animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        };
        ProjectionNode.prototype.applyTransformsToTarget = function () {
            var _a = this.getLead(), targetWithTransforms = _a.targetWithTransforms, target = _a.target, layout = _a.layout, latestValues = _a.latestValues;
            if (!targetWithTransforms || !target || !layout)
                return;
            copyBoxInto(targetWithTransforms, target);
            transformBox(targetWithTransforms, latestValues);
            calcBoxDelta(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        };
        ProjectionNode.prototype.registerSharedNode = function (layoutId, node) {
            var _a, _b, _c;
            if (!this.sharedNodes.has(layoutId)) {
                this.sharedNodes.set(layoutId, new NodeStack());
            }
            var stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            node.promote({
                transition: (_a = node.options.initialPromotionConfig) === null || _a === void 0 ? void 0 : _a.transition,
                preserveFollowOpacity: (_c = (_b = node.options.initialPromotionConfig) === null || _b === void 0 ? void 0 : _b.shouldPreserveFollowOpacity) === null || _c === void 0 ? void 0 : _c.call(_b, node),
            });
        };
        ProjectionNode.prototype.isLead = function () {
            var stack = this.getStack();
            return stack ? stack.lead === this : true;
        };
        ProjectionNode.prototype.getLead = function () {
            var _a;
            var layoutId = this.options.layoutId;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        };
        ProjectionNode.prototype.getPrevLead = function () {
            var _a;
            var layoutId = this.options.layoutId;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        };
        ProjectionNode.prototype.getStack = function () {
            var layoutId = this.options.layoutId;
            if (layoutId)
                return this.root.sharedNodes.get(layoutId);
        };
        ProjectionNode.prototype.promote = function (_a) {
            var _b = _a === void 0 ? {} : _a, needsReset = _b.needsReset, transition = _b.transition, preserveFollowOpacity = _b.preserveFollowOpacity;
            var stack = this.getStack();
            if (stack)
                stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition)
                this.setOptions({ transition: transition });
        };
        ProjectionNode.prototype.relegate = function () {
            var stack = this.getStack();
            if (stack) {
                return stack.relegate(this);
            }
            else {
                return false;
            }
        };
        ProjectionNode.prototype.resetRotation = function () {
            var visualElement = this.options.visualElement;
            if (!visualElement)
                return;
            var hasRotate = false;
            var resetValues = {};
            for (var i = 0; i < transformAxes.length; i++) {
                var axis = transformAxes[i];
                var key = "rotate" + axis;
                if (!visualElement.getStaticValue(key)) {
                    continue;
                }
                hasRotate = true;
                resetValues[key] = visualElement.getStaticValue(key);
                visualElement.setStaticValue(key, 0);
            }
            if (!hasRotate)
                return;
            visualElement === null || visualElement === void 0 ? void 0 : visualElement.syncRender();
            for (var key in resetValues) {
                visualElement.setStaticValue(key, resetValues[key]);
            }
            visualElement.scheduleRender();
        };
        ProjectionNode.prototype.getProjectionStyles = function (styleProp) {
            var _a, _b, _c, _d, _e, _f;
            if (styleProp === void 0) { styleProp = {}; }
            var styles = {};
            if (!this.instance || this.isSVG)
                return styles;
            if (!this.isVisible) {
                return { visibility: "hidden" };
            }
            else {
                styles.visibility = "";
            }
            var transformTemplate = (_a = this.options.visualElement) === null || _a === void 0 ? void 0 : _a.getProps().transformTemplate;
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents =
                    resolveMotionValue(styleProp.pointerEvents) || "";
                styles.transform = transformTemplate
                    ? transformTemplate(this.latestValues, "")
                    : "none";
                return styles;
            }
            var lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                var emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = (_b = this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1;
                    emptyStyles.pointerEvents =
                        resolveMotionValue(styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !hasTransform(this.latestValues)) {
                    emptyStyles.transform = transformTemplate
                        ? transformTemplate({}, "")
                        : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            var valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = buildProjectionTransform(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) {
                styles.transform = transformTemplate(valuesToRender, styles.transform);
            }
            var _g = this.projectionDelta, x = _g.x, y = _g.y;
            styles.transformOrigin = "".concat(x.origin * 100, "% ").concat(y.origin * 100, "% 0");
            if (lead.animationValues) {
                styles.opacity =
                    lead === this
                        ? (_d = (_c = valuesToRender.opacity) !== null && _c !== void 0 ? _c : this.latestValues.opacity) !== null && _d !== void 0 ? _d : 1
                        : this.preserveOpacity
                            ? this.latestValues.opacity
                            : valuesToRender.opacityExit;
            }
            else {
                styles.opacity =
                    lead === this
                        ? (_e = valuesToRender.opacity) !== null && _e !== void 0 ? _e : ""
                        : (_f = valuesToRender.opacityExit) !== null && _f !== void 0 ? _f : 0;
            }
            for (var key in scaleCorrectors) {
                if (valuesToRender[key] === undefined)
                    continue;
                var _h = scaleCorrectors[key], correct = _h.correct, applyTo = _h.applyTo;
                var corrected = correct(valuesToRender[key], lead);
                if (applyTo) {
                    var num = applyTo.length;
                    for (var i = 0; i < num; i++) {
                        styles[applyTo[i]] = corrected;
                    }
                }
                else {
                    styles[key] = corrected;
                }
            }
            if (this.options.layoutId) {
                styles.pointerEvents =
                    lead === this
                        ? resolveMotionValue(styleProp.pointerEvents) || ""
                        : "none";
            }
            return styles;
        };
        ProjectionNode.prototype.clearSnapshot = function () {
            this.resumeFrom = this.snapshot = undefined;
        };
        ProjectionNode.prototype.resetTree = function () {
            this.root.nodes.forEach(function (node) { var _a; return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop(); });
            this.root.nodes.forEach(clearMeasurements);
            this.root.sharedNodes.clear();
        };
        return ProjectionNode;
    }());
}
function updateLayout(node) {
    node.updateLayout();
}
function notifyLayoutUpdate(node) {
    var _a, _b, _c, _d;
    var snapshot = (_b = (_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) !== null && _b !== void 0 ? _b : node.snapshot;
    if (node.isLead() &&
        node.layout &&
        snapshot &&
        node.hasListeners("didUpdate")) {
        var _e = node.layout, layout_1 = _e.actual, measuredLayout = _e.measured;
        if (node.options.animationType === "size") {
            eachAxis(function (axis) {
                var axisSnapshot = snapshot.isShared
                    ? snapshot.measured[axis]
                    : snapshot.layout[axis];
                var length = calcLength(axisSnapshot);
                axisSnapshot.min = layout_1[axis].min;
                axisSnapshot.max = axisSnapshot.min + length;
            });
        }
        else if (node.options.animationType === "position") {
            eachAxis(function (axis) {
                var axisSnapshot = snapshot.isShared
                    ? snapshot.measured[axis]
                    : snapshot.layout[axis];
                var length = calcLength(layout_1[axis]);
                axisSnapshot.max = axisSnapshot.min + length;
            });
        }
        var layoutDelta = createDelta();
        calcBoxDelta(layoutDelta, layout_1, snapshot.layout);
        var visualDelta = createDelta();
        if (snapshot.isShared) {
            calcBoxDelta(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measured);
        }
        else {
            calcBoxDelta(visualDelta, layout_1, snapshot.layout);
        }
        var hasLayoutChanged = !isDeltaZero(layoutDelta);
        var hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            node.relativeParent = node.getClosestProjectingParent();
            if (node.relativeParent && !node.relativeParent.resumeFrom) {
                var _f = node.relativeParent, parentSnapshot = _f.snapshot, parentLayout = _f.layout;
                if (parentSnapshot && parentLayout) {
                    var relativeSnapshot = createBox();
                    calcRelativePosition(relativeSnapshot, snapshot.layout, parentSnapshot.layout);
                    var relativeLayout = createBox();
                    calcRelativePosition(relativeLayout, layout_1, parentLayout.actual);
                    if (!boxEquals(relativeSnapshot, relativeLayout)) {
                        hasRelativeTargetChanged = true;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout_1,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged,
        });
    }
    else if (node.isLead()) {
        (_d = (_c = node.options).onExitComplete) === null || _d === void 0 ? void 0 : _d.call(_c);
    }
    node.options.transition = undefined;
}
function clearSnapshot(node) {
    node.clearSnapshot();
}
function clearMeasurements(node) {
    node.clearMeasurements();
}
function resetTransformStyle(node) {
    node.resetTransform();
}
function finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
}
function resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function calcProjection(node) {
    node.calcProjection();
}
function resetRotation(node) {
    node.resetRotation();
}
function removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function mixAxisDelta(output, delta, p) {
    output.translate = mix(delta.translate, 0, p);
    output.scale = mix(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function mixAxis(output, from, to, p) {
    output.min = mix(from.min, to.min, p);
    output.max = mix(from.max, to.max, p);
}
function mixBox(output, from, to, p) {
    mixAxis(output.x, from.x, to.x, p);
    mixAxis(output.y, from.y, to.y, p);
}
function hasOpacityCrossfade(node) {
    return (node.animationValues && node.animationValues.opacityExit !== undefined);
}
var defaultLayoutTransition = {
    duration: 0.45,
    ease: [0.4, 0, 0.1, 1],
};
function mountNodeEarly(node, id) {
    var searchNode = node.root;
    for (var i = node.path.length - 1; i >= 0; i--) {
        if (Boolean(node.path[i].instance)) {
            searchNode = node.path[i];
            break;
        }
    }
    var searchElement = searchNode && searchNode !== node.root ? searchNode.instance : document;
    var element = searchElement.querySelector("[data-projection-id=\"".concat(id, "\"]"));
    if (element)
        node.mount(element, true);
}
function roundAxis(axis) {
    axis.min = Math.round(axis.min);
    axis.max = Math.round(axis.max);
}
function roundBox(box) {
    roundAxis(box.x);
    roundAxis(box.y);
}

var id = 1;
function useProjectionId() {
    return useConstant(function () {
        if (globalProjectionState.hasEverUpdated) {
            return id++;
        }
    });
}

var LayoutGroupContext = createContext({});

var SwitchLayoutGroupContext = createContext({});

function useProjection(projectionId, _a, visualElement, ProjectionNodeConstructor) {
    var _b;
    var layoutId = _a.layoutId, layout = _a.layout, drag = _a.drag, dragConstraints = _a.dragConstraints, layoutScroll = _a.layoutScroll;
    var initialPromotionConfig = useContext(SwitchLayoutGroupContext);
    if (!ProjectionNodeConstructor ||
        !visualElement ||
        (visualElement === null || visualElement === void 0 ? void 0 : visualElement.projection)) {
        return;
    }
    visualElement.projection = new ProjectionNodeConstructor(projectionId, visualElement.getLatestValues(), (_b = visualElement.parent) === null || _b === void 0 ? void 0 : _b.projection);
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || (dragConstraints && isRefObject(dragConstraints)),
        visualElement: visualElement,
        scheduleRender: function () { return visualElement.scheduleRender(); },
        animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        layoutScroll: layoutScroll,
    });
}

var VisualElementHandler =  (function (_super) {
    __extends(VisualElementHandler, _super);
    function VisualElementHandler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VisualElementHandler.prototype.getSnapshotBeforeUpdate = function () {
        this.updateProps();
        return null;
    };
    VisualElementHandler.prototype.componentDidUpdate = function () { };
    VisualElementHandler.prototype.updateProps = function () {
        var _a = this.props, visualElement = _a.visualElement, props = _a.props;
        if (visualElement)
            visualElement.setProps(props);
    };
    VisualElementHandler.prototype.render = function () {
        return this.props.children;
    };
    return VisualElementHandler;
}(React__default.Component));

function createMotionComponent(_a) {
    var preloadedFeatures = _a.preloadedFeatures, createVisualElement = _a.createVisualElement, projectionNodeConstructor = _a.projectionNodeConstructor, useRender = _a.useRender, useVisualState = _a.useVisualState, Component = _a.Component;
    preloadedFeatures && loadFeatures(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        var layoutId = useLayoutId(props);
        props = __assign$2(__assign$2({}, props), { layoutId: layoutId });
        var config = useContext(MotionConfigContext);
        var features = null;
        var context = useCreateMotionContext(props);
        var projectionId = config.isStatic ? undefined : useProjectionId();
        var visualState = useVisualState(props, config.isStatic);
        if (!config.isStatic && isBrowser) {
            context.visualElement = useVisualElement(Component, visualState, __assign$2(__assign$2({}, config), props), createVisualElement);
            useProjection(projectionId, props, context.visualElement, projectionNodeConstructor ||
                featureDefinitions.projectionNodeConstructor);
            features = useFeatures(props, context.visualElement, preloadedFeatures);
        }
        return (React$4.createElement(VisualElementHandler, { visualElement: context.visualElement, props: __assign$2(__assign$2({}, config), props) },
            features,
            React$4.createElement(MotionContext.Provider, { value: context }, useRender(Component, props, projectionId, useMotionRef(visualState, context.visualElement, externalRef), visualState, config.isStatic, context.visualElement))));
    }
    return forwardRef(MotionComponent);
}
function useLayoutId(_a) {
    var _b;
    var layoutId = _a.layoutId;
    var layoutGroupId = (_b = useContext(LayoutGroupContext)) === null || _b === void 0 ? void 0 : _b.id;
    return layoutGroupId && layoutId !== undefined
        ? layoutGroupId + "-" + layoutId
        : layoutId;
}

function createMotionProxy(createConfig) {
    function custom(Component, customMotionComponentConfig) {
        if (customMotionComponentConfig === void 0) { customMotionComponentConfig = {}; }
        return createMotionComponent(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") {
        return custom;
    }
    var componentCache = new Map();
    return new Proxy(custom, {
        get: function (_target, key) {
            if (!componentCache.has(key)) {
                componentCache.set(key, custom(key));
            }
            return componentCache.get(key);
        },
    });
}

var lowercaseSVGElements = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "tspan",
    "use",
    "view",
];

function isSVGComponent(Component) {
    if (
    typeof Component !== "string" ||
        Component.includes("-")) {
        return false;
    }
    else if (
    lowercaseSVGElements.indexOf(Component) > -1 ||
        /[A-Z]/.test(Component)) {
        return true;
    }
    return false;
}

function isForcedMotionValue(key, _a) {
    var layout = _a.layout, layoutId = _a.layoutId;
    return (isTransformProp(key) ||
        isTransformOriginProp(key) ||
        ((layout || layoutId !== undefined) &&
            (!!scaleCorrectors[key] || key === "opacity")));
}

var translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective",
};
function buildTransform(_a, _b, transformIsDefault, transformTemplate) {
    var transform = _a.transform, transformKeys = _a.transformKeys;
    var _c = _b.enableHardwareAcceleration, enableHardwareAcceleration = _c === void 0 ? true : _c, _d = _b.allowTransformNone, allowTransformNone = _d === void 0 ? true : _d;
    var transformString = "";
    transformKeys.sort(sortTransformProps);
    var transformHasZ = false;
    var numTransformKeys = transformKeys.length;
    for (var i = 0; i < numTransformKeys; i++) {
        var key = transformKeys[i];
        transformString += "".concat(translateAlias[key] || key, "(").concat(transform[key], ") ");
        if (key === "z")
            transformHasZ = true;
    }
    if (!transformHasZ && enableHardwareAcceleration) {
        transformString += "translateZ(0)";
    }
    else {
        transformString = transformString.trim();
    }
    if (transformTemplate) {
        transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    }
    else if (allowTransformNone && transformIsDefault) {
        transformString = "none";
    }
    return transformString;
}
function buildTransformOrigin(_a) {
    var _b = _a.originX, originX = _b === void 0 ? "50%" : _b, _c = _a.originY, originY = _c === void 0 ? "50%" : _c, _d = _a.originZ, originZ = _d === void 0 ? 0 : _d;
    return "".concat(originX, " ").concat(originY, " ").concat(originZ);
}

function isCSSVariable$1(key) {
    return key.startsWith("--");
}

var getValueAsType = function (value, type) {
    return type && typeof value === "number"
        ? type.transform(value)
        : value;
};

function buildHTMLStyles(state, latestValues, options, transformTemplate) {
    var _a;
    var style = state.style, vars = state.vars, transform = state.transform, transformKeys = state.transformKeys, transformOrigin = state.transformOrigin;
    transformKeys.length = 0;
    var hasTransform = false;
    var hasTransformOrigin = false;
    var transformIsNone = true;
    for (var key in latestValues) {
        var value = latestValues[key];
        if (isCSSVariable$1(key)) {
            vars[key] = value;
            continue;
        }
        var valueType = numberValueTypes[key];
        var valueAsType = getValueAsType(value, valueType);
        if (isTransformProp(key)) {
            hasTransform = true;
            transform[key] = valueAsType;
            transformKeys.push(key);
            if (!transformIsNone)
                continue;
            if (value !== ((_a = valueType.default) !== null && _a !== void 0 ? _a : 0))
                transformIsNone = false;
        }
        else if (isTransformOriginProp(key)) {
            transformOrigin[key] = valueAsType;
            hasTransformOrigin = true;
        }
        else {
            style[key] = valueAsType;
        }
    }
    if (hasTransform) {
        style.transform = buildTransform(state, options, transformIsNone, transformTemplate);
    }
    else if (transformTemplate) {
        style.transform = transformTemplate({}, "");
    }
    else if (!latestValues.transform && style.transform) {
        style.transform = "none";
    }
    if (hasTransformOrigin) {
        style.transformOrigin = buildTransformOrigin(transformOrigin);
    }
}

var createHtmlRenderState = function () { return ({
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {},
}); };

function copyRawValuesOnly(target, source, props) {
    for (var key in source) {
        if (!isMotionValue(source[key]) && !isForcedMotionValue(key, props)) {
            target[key] = source[key];
        }
    }
}
function useInitialMotionValues(_a, visualState, isStatic) {
    var transformTemplate = _a.transformTemplate;
    return useMemo(function () {
        var state = createHtmlRenderState();
        buildHTMLStyles(state, visualState, { enableHardwareAcceleration: !isStatic }, transformTemplate);
        var vars = state.vars, style = state.style;
        return __assign$2(__assign$2({}, vars), style);
    }, [visualState]);
}
function useStyle(props, visualState, isStatic) {
    var styleProp = props.style || {};
    var style = {};
    copyRawValuesOnly(style, styleProp, props);
    Object.assign(style, useInitialMotionValues(props, visualState, isStatic));
    if (props.transformValues) {
        style = props.transformValues(style);
    }
    return style;
}
function useHTMLProps(props, visualState, isStatic) {
    var htmlProps = {};
    var style = useStyle(props, visualState, isStatic);
    if (Boolean(props.drag) && props.dragListener !== false) {
        htmlProps.draggable = false;
        style.userSelect =
            style.WebkitUserSelect =
                style.WebkitTouchCallout =
                    "none";
        style.touchAction =
            props.drag === true
                ? "none"
                : "pan-".concat(props.drag === "x" ? "y" : "x");
    }
    htmlProps.style = style;
    return htmlProps;
}

var validMotionProps = new Set([
    "initial",
    "animate",
    "exit",
    "style",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "layout",
    "layoutId",
    "layoutDependency",
    "onLayoutAnimationComplete",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "drag",
    "dragControls",
    "dragListener",
    "dragConstraints",
    "dragDirectionLock",
    "dragSnapToOrigin",
    "_dragX",
    "_dragY",
    "dragElastic",
    "dragMomentum",
    "dragPropagation",
    "dragTransition",
    "whileDrag",
    "onPan",
    "onPanStart",
    "onPanEnd",
    "onPanSessionStart",
    "onTap",
    "onTapStart",
    "onTapCancel",
    "onHoverStart",
    "onHoverEnd",
    "whileFocus",
    "whileTap",
    "whileHover",
    "whileInView",
    "onViewportEnter",
    "onViewportLeave",
    "viewport",
    "layoutScroll",
]);
function isValidMotionProp(key) {
    return validMotionProps.has(key);
}

var shouldForward = function (key) { return !isValidMotionProp(key); };
function loadExternalIsValidProp(isValidProp) {
    if (!isValidProp)
        return;
    shouldForward = function (key) {
        return key.startsWith("on") ? !isValidMotionProp(key) : isValidProp(key);
    };
}
try {
    loadExternalIsValidProp(require("@emotion/is-prop-valid").default);
}
catch (_a) {
}
function filterProps(props, isDom, forwardMotionProps) {
    var filteredProps = {};
    for (var key in props) {
        if (shouldForward(key) ||
            (forwardMotionProps === true && isValidMotionProp(key)) ||
            (!isDom && !isValidMotionProp(key)) ||
            (props["draggable"] && key.startsWith("onDrag"))) {
            filteredProps[key] = props[key];
        }
    }
    return filteredProps;
}

function calcOrigin$1(origin, offset, size) {
    return typeof origin === "string"
        ? origin
        : px.transform(offset + size * origin);
}
function calcSVGTransformOrigin(dimensions, originX, originY) {
    var pxOriginX = calcOrigin$1(originX, dimensions.x, dimensions.width);
    var pxOriginY = calcOrigin$1(originY, dimensions.y, dimensions.height);
    return "".concat(pxOriginX, " ").concat(pxOriginY);
}

var dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray",
};
var camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray",
};
function buildSVGPath(attrs, length, spacing, offset, useDashCase) {
    if (spacing === void 0) { spacing = 1; }
    if (offset === void 0) { offset = 0; }
    if (useDashCase === void 0) { useDashCase = true; }
    attrs.pathLength = 1;
    var keys = useDashCase ? dashKeys : camelKeys;
    attrs[keys.offset] = px.transform(-offset);
    var pathLength = px.transform(length);
    var pathSpacing = px.transform(spacing);
    attrs[keys.array] = "".concat(pathLength, " ").concat(pathSpacing);
}

function buildSVGAttrs(state, _a, options, transformTemplate) {
    var attrX = _a.attrX, attrY = _a.attrY, originX = _a.originX, originY = _a.originY, pathLength = _a.pathLength, _b = _a.pathSpacing, pathSpacing = _b === void 0 ? 1 : _b, _c = _a.pathOffset, pathOffset = _c === void 0 ? 0 : _c,
    latest = __rest(_a, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);
    buildHTMLStyles(state, latest, options, transformTemplate);
    state.attrs = state.style;
    state.style = {};
    var attrs = state.attrs, style = state.style, dimensions = state.dimensions;
    if (attrs.transform) {
        if (dimensions)
            style.transform = attrs.transform;
        delete attrs.transform;
    }
    if (dimensions &&
        (originX !== undefined || originY !== undefined || style.transform)) {
        style.transformOrigin = calcSVGTransformOrigin(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    }
    if (attrX !== undefined)
        attrs.x = attrX;
    if (attrY !== undefined)
        attrs.y = attrY;
    if (pathLength !== undefined) {
        buildSVGPath(attrs, pathLength, pathSpacing, pathOffset, false);
    }
}

var createSvgRenderState = function () { return (__assign$2(__assign$2({}, createHtmlRenderState()), { attrs: {} })); };

function useSVGProps(props, visualState) {
    var visualProps = useMemo(function () {
        var state = createSvgRenderState();
        buildSVGAttrs(state, visualState, { enableHardwareAcceleration: false }, props.transformTemplate);
        return __assign$2(__assign$2({}, state.attrs), { style: __assign$2({}, state.style) });
    }, [visualState]);
    if (props.style) {
        var rawStyles = {};
        copyRawValuesOnly(rawStyles, props.style, props);
        visualProps.style = __assign$2(__assign$2({}, rawStyles), visualProps.style);
    }
    return visualProps;
}

function createUseRender(forwardMotionProps) {
    if (forwardMotionProps === void 0) { forwardMotionProps = false; }
    var useRender = function (Component, props, projectionId, ref, _a, isStatic) {
        var latestValues = _a.latestValues;
        var useVisualProps = isSVGComponent(Component)
            ? useSVGProps
            : useHTMLProps;
        var visualProps = useVisualProps(props, latestValues, isStatic);
        var filteredProps = filterProps(props, typeof Component === "string", forwardMotionProps);
        var elementProps = __assign$2(__assign$2(__assign$2({}, filteredProps), visualProps), { ref: ref });
        if (projectionId) {
            elementProps["data-projection-id"] = projectionId;
        }
        return createElement(Component, elementProps);
    };
    return useRender;
}

var CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
var REPLACE_TEMPLATE = "$1-$2";
var camelToDash = function (str) {
    return str.replace(CAMEL_CASE_PATTERN, REPLACE_TEMPLATE).toLowerCase();
};

function renderHTML(element, _a, styleProp, projection) {
    var style = _a.style, vars = _a.vars;
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    for (var key in vars) {
        element.style.setProperty(key, vars[key]);
    }
}

var camelCaseAttributes = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
]);

function renderSVG(element, renderState) {
    renderHTML(element, renderState);
    for (var key in renderState.attrs) {
        element.setAttribute(!camelCaseAttributes.has(key) ? camelToDash(key) : key, renderState.attrs[key]);
    }
}

function scrapeMotionValuesFromProps$1(props) {
    var style = props.style;
    var newValues = {};
    for (var key in style) {
        if (isMotionValue(style[key]) || isForcedMotionValue(key, props)) {
            newValues[key] = style[key];
        }
    }
    return newValues;
}

function scrapeMotionValuesFromProps(props) {
    var newValues = scrapeMotionValuesFromProps$1(props);
    for (var key in props) {
        if (isMotionValue(props[key])) {
            var targetKey = key === "x" || key === "y" ? "attr" + key.toUpperCase() : key;
            newValues[targetKey] = props[key];
        }
    }
    return newValues;
}

function isAnimationControls(v) {
    return typeof v === "object" && typeof v.start === "function";
}

function makeState(_a, props, context, presenceContext) {
    var scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps, createRenderState = _a.createRenderState, onMount = _a.onMount;
    var state = {
        latestValues: makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState(),
    };
    if (onMount) {
        state.mount = function (instance) { return onMount(props, instance, state); };
    }
    return state;
}
var makeUseVisualState = function (config) {
    return function (props, isStatic) {
        var context = useContext(MotionContext);
        var presenceContext = useContext(PresenceContext);
        return isStatic
            ? makeState(config, props, context, presenceContext)
            : useConstant(function () {
                return makeState(config, props, context, presenceContext);
            });
    };
};
function makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    var values = {};
    var blockInitialAnimation = (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false;
    var motionValues = scrapeMotionValues(props);
    for (var key in motionValues) {
        values[key] = resolveMotionValue(motionValues[key]);
    }
    var initial = props.initial, animate = props.animate;
    var isControllingVariants = checkIfControllingVariants(props);
    var isVariantNode = checkIfVariantNode(props);
    if (context &&
        isVariantNode &&
        !isControllingVariants &&
        props.inherit !== false) {
        initial !== null && initial !== void 0 ? initial : (initial = context.initial);
        animate !== null && animate !== void 0 ? animate : (animate = context.animate);
    }
    var initialAnimationIsBlocked = blockInitialAnimation || initial === false;
    var variantToSet = initialAnimationIsBlocked ? animate : initial;
    if (variantToSet &&
        typeof variantToSet !== "boolean" &&
        !isAnimationControls(variantToSet)) {
        var list = Array.isArray(variantToSet) ? variantToSet : [variantToSet];
        list.forEach(function (definition) {
            var resolved = resolveVariantFromProps(props, definition);
            if (!resolved)
                return;
            var transitionEnd = resolved.transitionEnd; resolved.transition; var target = __rest(resolved, ["transitionEnd", "transition"]);
            for (var key in target) {
                var valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    var index = initialAnimationIsBlocked
                        ? valueTarget.length - 1
                        : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) {
                    values[key] = valueTarget;
                }
            }
            for (var key in transitionEnd)
                values[key] = transitionEnd[key];
        });
    }
    return values;
}

var svgMotionConfig = {
    useVisualState: makeUseVisualState({
        scrapeMotionValuesFromProps: scrapeMotionValuesFromProps,
        createRenderState: createSvgRenderState,
        onMount: function (props, instance, _a) {
            var renderState = _a.renderState, latestValues = _a.latestValues;
            try {
                renderState.dimensions =
                    typeof instance.getBBox ===
                        "function"
                        ? instance.getBBox()
                        : instance.getBoundingClientRect();
            }
            catch (e) {
                renderState.dimensions = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0,
                };
            }
            buildSVGAttrs(renderState, latestValues, { enableHardwareAcceleration: false }, props.transformTemplate);
            renderSVG(instance, renderState);
        },
    }),
};

var htmlMotionConfig = {
    useVisualState: makeUseVisualState({
        scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
        createRenderState: createHtmlRenderState,
    }),
};

function createDomMotionConfig(Component, _a, preloadedFeatures, createVisualElement, projectionNodeConstructor) {
    var _b = _a.forwardMotionProps, forwardMotionProps = _b === void 0 ? false : _b;
    var baseConfig = isSVGComponent(Component)
        ? svgMotionConfig
        : htmlMotionConfig;
    return __assign$2(__assign$2({}, baseConfig), { preloadedFeatures: preloadedFeatures, useRender: createUseRender(forwardMotionProps), createVisualElement: createVisualElement, projectionNodeConstructor: projectionNodeConstructor, Component: Component });
}

var AnimationType;
(function (AnimationType) {
    AnimationType["Animate"] = "animate";
    AnimationType["Hover"] = "whileHover";
    AnimationType["Tap"] = "whileTap";
    AnimationType["Drag"] = "whileDrag";
    AnimationType["Focus"] = "whileFocus";
    AnimationType["InView"] = "whileInView";
    AnimationType["Exit"] = "exit";
})(AnimationType || (AnimationType = {}));

function addDomEvent(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return function () { return target.removeEventListener(eventName, handler, options); };
}
function useDomEvent(ref, eventName, handler, options) {
    useEffect(function () {
        var element = ref.current;
        if (handler && element) {
            return addDomEvent(element, eventName, handler, options);
        }
    }, [ref, eventName, handler, options]);
}

function useFocusGesture(_a) {
    var whileFocus = _a.whileFocus, visualElement = _a.visualElement;
    var onFocus = function () {
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Focus, true);
    };
    var onBlur = function () {
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Focus, false);
    };
    useDomEvent(visualElement, "focus", whileFocus ? onFocus : undefined);
    useDomEvent(visualElement, "blur", whileFocus ? onBlur : undefined);
}

function isMouseEvent(event) {
    if (typeof PointerEvent !== "undefined" && event instanceof PointerEvent) {
        return !!(event.pointerType === "mouse");
    }
    return event instanceof MouseEvent;
}
function isTouchEvent(event) {
    var hasTouches = !!event.touches;
    return hasTouches;
}

function filterPrimaryPointer(eventHandler) {
    return function (event) {
        var isMouseEvent = event instanceof MouseEvent;
        var isPrimaryPointer = !isMouseEvent ||
            (isMouseEvent && event.button === 0);
        if (isPrimaryPointer) {
            eventHandler(event);
        }
    };
}
var defaultPagePoint = { pageX: 0, pageY: 0 };
function pointFromTouch(e, pointType) {
    if (pointType === void 0) { pointType = "page"; }
    var primaryTouch = e.touches[0] || e.changedTouches[0];
    var point = primaryTouch || defaultPagePoint;
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"],
    };
}
function pointFromMouse(point, pointType) {
    if (pointType === void 0) { pointType = "page"; }
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"],
    };
}
function extractEventInfo(event, pointType) {
    if (pointType === void 0) { pointType = "page"; }
    return {
        point: isTouchEvent(event)
            ? pointFromTouch(event, pointType)
            : pointFromMouse(event, pointType),
    };
}
var wrapHandler = function (handler, shouldFilterPrimaryPointer) {
    if (shouldFilterPrimaryPointer === void 0) { shouldFilterPrimaryPointer = false; }
    var listener = function (event) {
        return handler(event, extractEventInfo(event));
    };
    return shouldFilterPrimaryPointer
        ? filterPrimaryPointer(listener)
        : listener;
};

var supportsPointerEvents = function () {
    return isBrowser && window.onpointerdown === null;
};
var supportsTouchEvents = function () {
    return isBrowser && window.ontouchstart === null;
};
var supportsMouseEvents = function () {
    return isBrowser && window.onmousedown === null;
};

var mouseEventNames = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave",
};
var touchEventNames = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel",
};
function getPointerEventName(name) {
    if (supportsPointerEvents()) {
        return name;
    }
    else if (supportsTouchEvents()) {
        return touchEventNames[name];
    }
    else if (supportsMouseEvents()) {
        return mouseEventNames[name];
    }
    return name;
}
function addPointerEvent(target, eventName, handler, options) {
    return addDomEvent(target, getPointerEventName(eventName), wrapHandler(handler, eventName === "pointerdown"), options);
}
function usePointerEvent(ref, eventName, handler, options) {
    return useDomEvent(ref, getPointerEventName(eventName), handler && wrapHandler(handler, eventName === "pointerdown"), options);
}

function createLock(name) {
    var lock = null;
    return function () {
        var openLock = function () {
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
var globalHorizontalLock = createLock("dragHorizontal");
var globalVerticalLock = createLock("dragVertical");
function getGlobalLock(drag) {
    var lock = false;
    if (drag === "y") {
        lock = globalVerticalLock();
    }
    else if (drag === "x") {
        lock = globalHorizontalLock();
    }
    else {
        var openHorizontal_1 = globalHorizontalLock();
        var openVertical_1 = globalVerticalLock();
        if (openHorizontal_1 && openVertical_1) {
            lock = function () {
                openHorizontal_1();
                openVertical_1();
            };
        }
        else {
            if (openHorizontal_1)
                openHorizontal_1();
            if (openVertical_1)
                openVertical_1();
        }
    }
    return lock;
}
function isDragActive() {
    var openGestureLock = getGlobalLock(true);
    if (!openGestureLock)
        return true;
    openGestureLock();
    return false;
}

function createHoverEvent(visualElement, isActive, callback) {
    return function (event, info) {
        var _a;
        if (!isMouseEvent(event) || isDragActive())
            return;
        (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Hover, isActive);
        callback === null || callback === void 0 ? void 0 : callback(event, info);
    };
}
function useHoverGesture(_a) {
    var onHoverStart = _a.onHoverStart, onHoverEnd = _a.onHoverEnd, whileHover = _a.whileHover, visualElement = _a.visualElement;
    usePointerEvent(visualElement, "pointerenter", onHoverStart || whileHover
        ? createHoverEvent(visualElement, true, onHoverStart)
        : undefined);
    usePointerEvent(visualElement, "pointerleave", onHoverEnd || whileHover
        ? createHoverEvent(visualElement, false, onHoverEnd)
        : undefined);
}

var isNodeOrChild = function (parent, child) {
    if (!child) {
        return false;
    }
    else if (parent === child) {
        return true;
    }
    else {
        return isNodeOrChild(parent, child.parentElement);
    }
};

function useUnmountEffect(callback) {
    return useEffect(function () { return function () { return callback(); }; }, []);
}

function useTapGesture(_a) {
    var onTap = _a.onTap, onTapStart = _a.onTapStart, onTapCancel = _a.onTapCancel, whileTap = _a.whileTap, visualElement = _a.visualElement;
    var hasPressListeners = onTap || onTapStart || onTapCancel || whileTap;
    var isPressing = useRef(false);
    var cancelPointerEndListeners = useRef(null);
    function removePointerEndListener() {
        var _a;
        (_a = cancelPointerEndListeners.current) === null || _a === void 0 ? void 0 : _a.call(cancelPointerEndListeners);
        cancelPointerEndListeners.current = null;
    }
    function checkPointerEnd() {
        var _a;
        removePointerEndListener();
        isPressing.current = false;
        (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Tap, false);
        return !isDragActive();
    }
    function onPointerUp(event, info) {
        if (!checkPointerEnd())
            return;
        !isNodeOrChild(visualElement.getInstance(), event.target)
            ? onTapCancel === null || onTapCancel === void 0 ? void 0 : onTapCancel(event, info)
            : onTap === null || onTap === void 0 ? void 0 : onTap(event, info);
    }
    function onPointerCancel(event, info) {
        if (!checkPointerEnd())
            return;
        onTapCancel === null || onTapCancel === void 0 ? void 0 : onTapCancel(event, info);
    }
    function onPointerDown(event, info) {
        var _a;
        removePointerEndListener();
        if (isPressing.current)
            return;
        isPressing.current = true;
        cancelPointerEndListeners.current = pipe(addPointerEvent(window, "pointerup", onPointerUp), addPointerEvent(window, "pointercancel", onPointerCancel));
        (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Tap, true);
        onTapStart === null || onTapStart === void 0 ? void 0 : onTapStart(event, info);
    }
    usePointerEvent(visualElement, "pointerdown", hasPressListeners ? onPointerDown : undefined);
    useUnmountEffect(removePointerEndListener);
}

var warned = new Set();
function warnOnce$1(condition, message, element) {
    if (condition || warned.has(message))
        return;
    console.warn(message);
    if (element)
        console.warn(element);
    warned.add(message);
}

var observerCallbacks = new WeakMap();
var observers = new WeakMap();
var fireObserverCallback = function (entry) {
    var _a;
    (_a = observerCallbacks.get(entry.target)) === null || _a === void 0 ? void 0 : _a(entry);
};
var fireAllObserverCallbacks = function (entries) {
    entries.forEach(fireObserverCallback);
};
function initIntersectionObserver(_a) {
    var root = _a.root, options = __rest(_a, ["root"]);
    var lookupRoot = root || document;
    if (!observers.has(lookupRoot)) {
        observers.set(lookupRoot, {});
    }
    var rootObservers = observers.get(lookupRoot);
    var key = JSON.stringify(options);
    if (!rootObservers[key]) {
        rootObservers[key] = new IntersectionObserver(fireAllObserverCallbacks, __assign$2({ root: root }, options));
    }
    return rootObservers[key];
}
function observeIntersection(element, options, callback) {
    var rootInteresectionObserver = initIntersectionObserver(options);
    observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return function () {
        observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}

function useViewport(_a) {
    var visualElement = _a.visualElement, whileInView = _a.whileInView, onViewportEnter = _a.onViewportEnter, onViewportLeave = _a.onViewportLeave, _b = _a.viewport, viewport = _b === void 0 ? {} : _b;
    var state = useRef({
        hasEnteredView: false,
        isInView: false,
    });
    var shouldObserve = Boolean(whileInView || onViewportEnter || onViewportLeave);
    if (viewport.once && state.current.hasEnteredView)
        shouldObserve = false;
    var useObserver = typeof IntersectionObserver === "undefined"
        ? useMissingIntersectionObserver
        : useIntersectionObserver;
    useObserver(shouldObserve, state.current, visualElement, viewport);
}
var thresholdNames = {
    some: 0,
    all: 1,
};
function useIntersectionObserver(shouldObserve, state, visualElement, _a) {
    var root = _a.root, rootMargin = _a.margin, _b = _a.amount, amount = _b === void 0 ? "some" : _b, once = _a.once;
    useEffect(function () {
        if (!shouldObserve)
            return;
        var options = {
            root: root === null || root === void 0 ? void 0 : root.current,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : thresholdNames[amount],
        };
        var intersectionCallback = function (entry) {
            var _a;
            var isIntersecting = entry.isIntersecting;
            if (state.isInView === isIntersecting)
                return;
            state.isInView = isIntersecting;
            if (once && !isIntersecting && state.hasEnteredView) {
                return;
            }
            else if (isIntersecting) {
                state.hasEnteredView = true;
            }
            (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.InView, isIntersecting);
            var props = visualElement.getProps();
            var callback = isIntersecting
                ? props.onViewportEnter
                : props.onViewportLeave;
            callback === null || callback === void 0 ? void 0 : callback(entry);
        };
        return observeIntersection(visualElement.getInstance(), options, intersectionCallback);
    }, [shouldObserve, root, rootMargin, amount]);
}
function useMissingIntersectionObserver(shouldObserve, state, visualElement) {
    useEffect(function () {
        if (!shouldObserve)
            return;
        if (process.env.NODE_ENV !== "production") {
            warnOnce$1(false, "IntersectionObserver not available on this device. whileInView animations will trigger on mount.");
        }
        requestAnimationFrame(function () {
            var _a;
            state.hasEnteredView = true;
            var onViewportEnter = visualElement.getProps().onViewportEnter;
            onViewportEnter === null || onViewportEnter === void 0 ? void 0 : onViewportEnter(null);
            (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.InView, true);
        });
    }, [shouldObserve]);
}

var makeRenderlessComponent = function (hook) { return function (props) {
    hook(props);
    return null;
}; };

var gestureAnimations = {
    inView: makeRenderlessComponent(useViewport),
    tap: makeRenderlessComponent(useTapGesture),
    focus: makeRenderlessComponent(useFocusGesture),
    hover: makeRenderlessComponent(useHoverGesture),
};

function usePresence() {
    var context = useContext(PresenceContext);
    if (context === null)
        return [true, null];
    var isPresent = context.isPresent, onExitComplete = context.onExitComplete, register = context.register;
    var id = useUniqueId();
    useEffect(function () { return register(id); }, []);
    var safeToRemove = function () { return onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete(id); };
    return !isPresent && onExitComplete ? [false, safeToRemove] : [true];
}
var counter$1 = 0;
var incrementId = function () { return counter$1++; };
var useUniqueId = function () { return useConstant(incrementId); };

function shallowCompare(next, prev) {
    if (!Array.isArray(prev))
        return false;
    var prevLength = prev.length;
    if (prevLength !== next.length)
        return false;
    for (var i = 0; i < prevLength; i++) {
        if (prev[i] !== next[i])
            return false;
    }
    return true;
}

var isNumericalString = function (v) { return /^\-?\d*\.?\d+$/.test(v); };

var isZeroValueString = function (v) { return /^0[^.\s]+$/.test(v); };

var testValueType = function (v) { return function (type) { return type.test(v); }; };

var auto = {
    test: function (v) { return v === "auto"; },
    parse: function (v) { return v; },
};

var dimensionValueTypes = [number$2, px, percent, degrees, vw, vh, auto];
var findDimensionValueType = function (v) {
    return dimensionValueTypes.find(testValueType(v));
};

var valueTypes = __spreadArray(__spreadArray([], __read(dimensionValueTypes), false), [color$1, complex], false);
var findValueType = function (v) { return valueTypes.find(testValueType(v)); };

function setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) {
        visualElement.getValue(key).set(value);
    }
    else {
        visualElement.addValue(key, motionValue(value));
    }
}
function setTarget(visualElement, definition) {
    var resolved = resolveVariant(visualElement, definition);
    var _a = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {}, _b = _a.transitionEnd, transitionEnd = _b === void 0 ? {} : _b; _a.transition; var target = __rest(_a, ["transitionEnd", "transition"]);
    target = __assign$2(__assign$2({}, target), transitionEnd);
    for (var key in target) {
        var value = resolveFinalValueInKeyframes(target[key]);
        setMotionValue(visualElement, key, value);
    }
}
function checkTargetForNewValues(visualElement, target, origin) {
    var _a, _b, _c;
    var _d;
    var newValueKeys = Object.keys(target).filter(function (key) { return !visualElement.hasValue(key); });
    var numNewValues = newValueKeys.length;
    if (!numNewValues)
        return;
    for (var i = 0; i < numNewValues; i++) {
        var key = newValueKeys[i];
        var targetValue = target[key];
        var value = null;
        if (Array.isArray(targetValue)) {
            value = targetValue[0];
        }
        if (value === null) {
            value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        }
        if (value === undefined || value === null)
            continue;
        if (typeof value === "string" &&
            (isNumericalString(value) || isZeroValueString(value))) {
            value = parseFloat(value);
        }
        else if (!findValueType(value) && complex.test(targetValue)) {
            value = getAnimatableNone(key, targetValue);
        }
        visualElement.addValue(key, motionValue(value));
        (_c = (_d = origin)[key]) !== null && _c !== void 0 ? _c : (_d[key] = value);
        visualElement.setBaseTarget(key, value);
    }
}
function getOriginFromTransition(key, transition) {
    if (!transition)
        return;
    var valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function getOrigin(target, transition, visualElement) {
    var _a, _b;
    var origin = {};
    for (var key in target) {
        origin[key] =
            (_a = getOriginFromTransition(key, transition)) !== null && _a !== void 0 ? _a : (_b = visualElement.getValue(key)) === null || _b === void 0 ? void 0 : _b.get();
    }
    return origin;
}

function animateVisualElement(visualElement, definition, options) {
    if (options === void 0) { options = {}; }
    visualElement.notifyAnimationStart(definition);
    var animation;
    if (Array.isArray(definition)) {
        var animations = definition.map(function (variant) {
            return animateVariant(visualElement, variant, options);
        });
        animation = Promise.all(animations);
    }
    else if (typeof definition === "string") {
        animation = animateVariant(visualElement, definition, options);
    }
    else {
        var resolvedDefinition = typeof definition === "function"
            ? resolveVariant(visualElement, definition, options.custom)
            : definition;
        animation = animateTarget(visualElement, resolvedDefinition, options);
    }
    return animation.then(function () {
        return visualElement.notifyAnimationComplete(definition);
    });
}
function animateVariant(visualElement, variant, options) {
    var _a;
    if (options === void 0) { options = {}; }
    var resolved = resolveVariant(visualElement, variant, options.custom);
    var _b = (resolved || {}).transition, transition = _b === void 0 ? visualElement.getDefaultTransition() || {} : _b;
    if (options.transitionOverride) {
        transition = options.transitionOverride;
    }
    var getAnimation = resolved
        ? function () { return animateTarget(visualElement, resolved, options); }
        : function () { return Promise.resolve(); };
    var getChildAnimations = ((_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.size)
        ? function (forwardDelay) {
            if (forwardDelay === void 0) { forwardDelay = 0; }
            var _a = transition.delayChildren, delayChildren = _a === void 0 ? 0 : _a, staggerChildren = transition.staggerChildren, staggerDirection = transition.staggerDirection;
            return animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
        }
        : function () { return Promise.resolve(); };
    var when = transition.when;
    if (when) {
        var _c = __read(when === "beforeChildren"
            ? [getAnimation, getChildAnimations]
            : [getChildAnimations, getAnimation], 2), first = _c[0], last = _c[1];
        return first().then(last);
    }
    else {
        return Promise.all([getAnimation(), getChildAnimations(options.delay)]);
    }
}
function animateTarget(visualElement, definition, _a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, _d = _c.delay, delay = _d === void 0 ? 0 : _d, transitionOverride = _c.transitionOverride, type = _c.type;
    var _e = visualElement.makeTargetAnimatable(definition), _f = _e.transition, transition = _f === void 0 ? visualElement.getDefaultTransition() : _f, transitionEnd = _e.transitionEnd, target = __rest(_e, ["transition", "transitionEnd"]);
    if (transitionOverride)
        transition = transitionOverride;
    var animations = [];
    var animationTypeState = type && ((_b = visualElement.animationState) === null || _b === void 0 ? void 0 : _b.getState()[type]);
    for (var key in target) {
        var value = visualElement.getValue(key);
        var valueTarget = target[key];
        if (!value ||
            valueTarget === undefined ||
            (animationTypeState &&
                shouldBlockAnimation(animationTypeState, key))) {
            continue;
        }
        var animation = startAnimation(key, value, valueTarget, __assign$2({ delay: delay }, transition));
        animations.push(animation);
    }
    return Promise.all(animations).then(function () {
        transitionEnd && setTarget(visualElement, transitionEnd);
    });
}
function animateChildren(visualElement, variant, delayChildren, staggerChildren, staggerDirection, options) {
    if (delayChildren === void 0) { delayChildren = 0; }
    if (staggerChildren === void 0) { staggerChildren = 0; }
    if (staggerDirection === void 0) { staggerDirection = 1; }
    var animations = [];
    var maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    var generateStaggerDuration = staggerDirection === 1
        ? function (i) {
            if (i === void 0) { i = 0; }
            return i * staggerChildren;
        }
        : function (i) {
            if (i === void 0) { i = 0; }
            return maxStaggerDuration - i * staggerChildren;
        };
    Array.from(visualElement.variantChildren)
        .sort(sortByTreeOrder)
        .forEach(function (child, i) {
        animations.push(animateVariant(child, variant, __assign$2(__assign$2({}, options), { delay: delayChildren + generateStaggerDuration(i) })).then(function () { return child.notifyAnimationComplete(variant); }));
    });
    return Promise.all(animations);
}
function sortByTreeOrder(a, b) {
    return a.sortNodePosition(b);
}
function shouldBlockAnimation(_a, key) {
    var protectedKeys = _a.protectedKeys, needsAnimating = _a.needsAnimating;
    var shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}

var variantPriorityOrder = [
    AnimationType.Animate,
    AnimationType.InView,
    AnimationType.Focus,
    AnimationType.Hover,
    AnimationType.Tap,
    AnimationType.Drag,
    AnimationType.Exit,
];
var reversePriorityOrder = __spreadArray([], __read(variantPriorityOrder), false).reverse();
var numAnimationTypes = variantPriorityOrder.length;
function animateList(visualElement) {
    return function (animations) {
        return Promise.all(animations.map(function (_a) {
            var animation = _a.animation, options = _a.options;
            return animateVisualElement(visualElement, animation, options);
        }));
    };
}
function createAnimationState(visualElement) {
    var animate = animateList(visualElement);
    var state = createState();
    var allAnimatedKeys = {};
    var isInitialRender = true;
    var buildResolvedTypeValues = function (acc, definition) {
        var resolved = resolveVariant(visualElement, definition);
        if (resolved) {
            resolved.transition; var transitionEnd = resolved.transitionEnd, target = __rest(resolved, ["transition", "transitionEnd"]);
            acc = __assign$2(__assign$2(__assign$2({}, acc), target), transitionEnd);
        }
        return acc;
    };
    function isAnimated(key) {
        return allAnimatedKeys[key] !== undefined;
    }
    function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    function animateChanges(options, changedActiveType) {
        var _a;
        var props = visualElement.getProps();
        var context = visualElement.getVariantContext(true) || {};
        var animations = [];
        var removedKeys = new Set();
        var encounteredKeys = {};
        var removedVariantIndex = Infinity;
        var _loop_1 = function (i) {
            var type = reversePriorityOrder[i];
            var typeState = state[type];
            var prop = (_a = props[type]) !== null && _a !== void 0 ? _a : context[type];
            var propIsVariant = isVariantLabel(prop);
            var activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false)
                removedVariantIndex = i;
            var isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            if (isInherited &&
                isInitialRender &&
                visualElement.manuallyAnimateOnMount) {
                isInherited = false;
            }
            typeState.protectedKeys = __assign$2({}, encounteredKeys);
            if (
            (!typeState.isActive && activeDelta === null) ||
                (!prop && !typeState.prevProp) ||
                isAnimationControls(prop) ||
                typeof prop === "boolean") {
                return "continue";
            }
            var variantDidChange = checkVariantsDidChange(typeState.prevProp, prop);
            var shouldAnimateType = variantDidChange ||
                (type === changedActiveType &&
                    typeState.isActive &&
                    !isInherited &&
                    propIsVariant) ||
                (i > removedVariantIndex && propIsVariant);
            var definitionList = Array.isArray(prop) ? prop : [prop];
            var resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false)
                resolvedValues = {};
            var _b = typeState.prevResolvedValues, prevResolvedValues = _b === void 0 ? {} : _b;
            var allKeys = __assign$2(__assign$2({}, prevResolvedValues), resolvedValues);
            var markToAnimate = function (key) {
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for (var key in allKeys) {
                var next = resolvedValues[key];
                var prev = prevResolvedValues[key];
                if (encounteredKeys.hasOwnProperty(key))
                    continue;
                if (next !== prev) {
                    if (isKeyframesTarget(next) && isKeyframesTarget(prev)) {
                        if (!shallowCompare(next, prev) || variantDidChange) {
                            markToAnimate(key);
                        }
                        else {
                            typeState.protectedKeys[key] = true;
                        }
                    }
                    else if (next !== undefined) {
                        markToAnimate(key);
                    }
                    else {
                        removedKeys.add(key);
                    }
                }
                else if (next !== undefined && removedKeys.has(key)) {
                    markToAnimate(key);
                }
                else {
                    typeState.protectedKeys[key] = true;
                }
            }
            typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            if (typeState.isActive) {
                encounteredKeys = __assign$2(__assign$2({}, encounteredKeys), resolvedValues);
            }
            if (isInitialRender && visualElement.blockInitialAnimation) {
                shouldAnimateType = false;
            }
            if (shouldAnimateType && !isInherited) {
                animations.push.apply(animations, __spreadArray([], __read(definitionList.map(function (animation) { return ({
                    animation: animation,
                    options: __assign$2({ type: type }, options),
                }); })), false));
            }
        };
        for (var i = 0; i < numAnimationTypes; i++) {
            _loop_1(i);
        }
        allAnimatedKeys = __assign$2({}, encounteredKeys);
        if (removedKeys.size) {
            var fallbackAnimation_1 = {};
            removedKeys.forEach(function (key) {
                var fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) {
                    fallbackAnimation_1[key] = fallbackTarget;
                }
            });
            animations.push({ animation: fallbackAnimation_1 });
        }
        var shouldAnimate = Boolean(animations.length);
        if (isInitialRender &&
            props.initial === false &&
            !visualElement.manuallyAnimateOnMount) {
            shouldAnimate = false;
        }
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    function setActive(type, isActive, options) {
        var _a;
        if (state[type].isActive === isActive)
            return Promise.resolve();
        (_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach(function (child) { var _a; return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive); });
        state[type].isActive = isActive;
        return animateChanges(options, type);
    }
    return {
        isAnimated: isAnimated,
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: function () { return state; },
    };
}
function checkVariantsDidChange(prev, next) {
    if (typeof next === "string") {
        return next !== prev;
    }
    else if (isVariantLabels(next)) {
        return !shallowCompare(next, prev);
    }
    return false;
}
function createTypeState(isActive) {
    if (isActive === void 0) { isActive = false; }
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {},
    };
}
function createState() {
    var _a;
    return _a = {},
        _a[AnimationType.Animate] = createTypeState(true),
        _a[AnimationType.InView] = createTypeState(),
        _a[AnimationType.Hover] = createTypeState(),
        _a[AnimationType.Tap] = createTypeState(),
        _a[AnimationType.Drag] = createTypeState(),
        _a[AnimationType.Focus] = createTypeState(),
        _a[AnimationType.Exit] = createTypeState(),
        _a;
}

var animations = {
    animation: makeRenderlessComponent(function (_a) {
        var visualElement = _a.visualElement, animate = _a.animate;
        visualElement.animationState || (visualElement.animationState = createAnimationState(visualElement));
        if (isAnimationControls(animate)) {
            useEffect(function () { return animate.subscribe(visualElement); }, [animate]);
        }
    }),
    exit: makeRenderlessComponent(function (props) {
        var custom = props.custom, visualElement = props.visualElement;
        var _a = __read(usePresence(), 2), isPresent = _a[0], safeToRemove = _a[1];
        var presenceContext = useContext(PresenceContext);
        useEffect(function () {
            var _a, _b;
            visualElement.isPresent = isPresent;
            var animation = (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Exit, !isPresent, { custom: (_b = presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.custom) !== null && _b !== void 0 ? _b : custom });
            !isPresent && (animation === null || animation === void 0 ? void 0 : animation.then(safeToRemove));
        }, [isPresent]);
    }),
};

var PanSession =  (function () {
    function PanSession(event, handlers, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, transformPagePoint = _b.transformPagePoint;
        this.startEvent = null;
        this.lastMoveEvent = null;
        this.lastMoveEventInfo = null;
        this.handlers = {};
        this.updatePoint = function () {
            if (!(_this.lastMoveEvent && _this.lastMoveEventInfo))
                return;
            var info = getPanInfo(_this.lastMoveEventInfo, _this.history);
            var isPanStarted = _this.startEvent !== null;
            var isDistancePastThreshold = distance(info.offset, { x: 0, y: 0 }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold)
                return;
            var point = info.point;
            var timestamp = getFrameData().timestamp;
            _this.history.push(__assign$2(__assign$2({}, point), { timestamp: timestamp }));
            var _a = _this.handlers, onStart = _a.onStart, onMove = _a.onMove;
            if (!isPanStarted) {
                onStart && onStart(_this.lastMoveEvent, info);
                _this.startEvent = _this.lastMoveEvent;
            }
            onMove && onMove(_this.lastMoveEvent, info);
        };
        this.handlePointerMove = function (event, info) {
            _this.lastMoveEvent = event;
            _this.lastMoveEventInfo = transformPoint(info, _this.transformPagePoint);
            if (isMouseEvent(event) && event.buttons === 0) {
                _this.handlePointerUp(event, info);
                return;
            }
            sync.update(_this.updatePoint, true);
        };
        this.handlePointerUp = function (event, info) {
            _this.end();
            var _a = _this.handlers, onEnd = _a.onEnd, onSessionEnd = _a.onSessionEnd;
            var panInfo = getPanInfo(transformPoint(info, _this.transformPagePoint), _this.history);
            if (_this.startEvent && onEnd) {
                onEnd(event, panInfo);
            }
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        if (isTouchEvent(event) && event.touches.length > 1)
            return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        var info = extractEventInfo(event);
        var initialInfo = transformPoint(info, this.transformPagePoint);
        var point = initialInfo.point;
        var timestamp = getFrameData().timestamp;
        this.history = [__assign$2(__assign$2({}, point), { timestamp: timestamp })];
        var onSessionStart = handlers.onSessionStart;
        onSessionStart &&
            onSessionStart(event, getPanInfo(initialInfo, this.history));
        this.removeListeners = pipe(addPointerEvent(window, "pointermove", this.handlePointerMove), addPointerEvent(window, "pointerup", this.handlePointerUp), addPointerEvent(window, "pointercancel", this.handlePointerUp));
    }
    PanSession.prototype.updateHandlers = function (handlers) {
        this.handlers = handlers;
    };
    PanSession.prototype.end = function () {
        this.removeListeners && this.removeListeners();
        cancelSync.update(this.updatePoint);
    };
    return PanSession;
}());
function transformPoint(info, transformPagePoint) {
    return transformPagePoint ? { point: transformPagePoint(info.point) } : info;
}
function subtractPoint(a, b) {
    return { x: a.x - b.x, y: a.y - b.y };
}
function getPanInfo(_a, history) {
    var point = _a.point;
    return {
        point: point,
        delta: subtractPoint(point, lastDevicePoint(history)),
        offset: subtractPoint(point, startDevicePoint(history)),
        velocity: getVelocity(history, 0.1),
    };
}
function startDevicePoint(history) {
    return history[0];
}
function lastDevicePoint(history) {
    return history[history.length - 1];
}
function getVelocity(history, timeDelta) {
    if (history.length < 2) {
        return { x: 0, y: 0 };
    }
    var i = history.length - 1;
    var timestampedPoint = null;
    var lastPoint = lastDevicePoint(history);
    while (i >= 0) {
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp >
            secondsToMilliseconds(timeDelta)) {
            break;
        }
        i--;
    }
    if (!timestampedPoint) {
        return { x: 0, y: 0 };
    }
    var time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
    if (time === 0) {
        return { x: 0, y: 0 };
    }
    var currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time,
    };
    if (currentVelocity.x === Infinity) {
        currentVelocity.x = 0;
    }
    if (currentVelocity.y === Infinity) {
        currentVelocity.y = 0;
    }
    return currentVelocity;
}

function applyConstraints(point, _a, elastic) {
    var min = _a.min, max = _a.max;
    if (min !== undefined && point < min) {
        point = elastic ? mix(min, point, elastic.min) : Math.max(point, min);
    }
    else if (max !== undefined && point > max) {
        point = elastic ? mix(max, point, elastic.max) : Math.min(point, max);
    }
    return point;
}
function calcRelativeAxisConstraints(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined
            ? axis.max + max - (axis.max - axis.min)
            : undefined,
    };
}
function calcRelativeConstraints(layoutBox, _a) {
    var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
    return {
        x: calcRelativeAxisConstraints(layoutBox.x, left, right),
        y: calcRelativeAxisConstraints(layoutBox.y, top, bottom),
    };
}
function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
    var _a;
    var min = constraintsAxis.min - layoutAxis.min;
    var max = constraintsAxis.max - layoutAxis.max;
    if (constraintsAxis.max - constraintsAxis.min <
        layoutAxis.max - layoutAxis.min) {
        _a = __read([max, min], 2), min = _a[0], max = _a[1];
    }
    return { min: min, max: max };
}
function calcViewportConstraints(layoutBox, constraintsBox) {
    return {
        x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
        y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y),
    };
}
function calcOrigin(source, target) {
    var origin = 0.5;
    var sourceLength = calcLength(source);
    var targetLength = calcLength(target);
    if (targetLength > sourceLength) {
        origin = progress(target.min, target.max - sourceLength, source.min);
    }
    else if (sourceLength > targetLength) {
        origin = progress(source.min, source.max - targetLength, target.min);
    }
    return clamp$1(0, 1, origin);
}
function rebaseAxisConstraints(layout, constraints) {
    var relativeConstraints = {};
    if (constraints.min !== undefined) {
        relativeConstraints.min = constraints.min - layout.min;
    }
    if (constraints.max !== undefined) {
        relativeConstraints.max = constraints.max - layout.min;
    }
    return relativeConstraints;
}
var defaultElastic = 0.35;
function resolveDragElastic(dragElastic) {
    if (dragElastic === void 0) { dragElastic = defaultElastic; }
    if (dragElastic === false) {
        dragElastic = 0;
    }
    else if (dragElastic === true) {
        dragElastic = defaultElastic;
    }
    return {
        x: resolveAxisElastic(dragElastic, "left", "right"),
        y: resolveAxisElastic(dragElastic, "top", "bottom"),
    };
}
function resolveAxisElastic(dragElastic, minLabel, maxLabel) {
    return {
        min: resolvePointElastic(dragElastic, minLabel),
        max: resolvePointElastic(dragElastic, maxLabel),
    };
}
function resolvePointElastic(dragElastic, label) {
    var _a;
    return typeof dragElastic === "number"
        ? dragElastic
        : (_a = dragElastic[label]) !== null && _a !== void 0 ? _a : 0;
}

function convertBoundingBoxToBox(_a) {
    var top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom;
    return {
        x: { min: left, max: right },
        y: { min: top, max: bottom },
    };
}
function convertBoxToBoundingBox(_a) {
    var x = _a.x, y = _a.y;
    return { top: y.min, right: x.max, bottom: y.max, left: x.min };
}
function transformBoxPoints(point, transformPoint) {
    if (!transformPoint)
        return point;
    var topLeft = transformPoint({ x: point.left, y: point.top });
    var bottomRight = transformPoint({ x: point.right, y: point.bottom });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x,
    };
}

function measureViewportBox(instance, transformPoint) {
    return convertBoundingBoxToBox(transformBoxPoints(instance.getBoundingClientRect(), transformPoint));
}
function measurePageBox(element, rootProjectionNode, transformPagePoint) {
    var viewportBox = measureViewportBox(element, transformPagePoint);
    var scroll = rootProjectionNode.scroll;
    if (scroll) {
        translateAxis(viewportBox.x, scroll.x);
        translateAxis(viewportBox.y, scroll.y);
    }
    return viewportBox;
}

var elementDragControls = new WeakMap();
var VisualElementDragControls =  (function () {
    function VisualElementDragControls(visualElement) {
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = { x: 0, y: 0 };
        this.constraints = false;
        this.hasMutatedConstraints = false;
        this.elastic = createBox();
        this.visualElement = visualElement;
    }
    VisualElementDragControls.prototype.start = function (originEvent, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.snapToCursor, snapToCursor = _c === void 0 ? false : _c;
        if (this.visualElement.isPresent === false)
            return;
        var onSessionStart = function (event) {
            _this.stopAnimation();
            if (snapToCursor) {
                _this.snapToCursor(extractEventInfo(event, "page").point);
            }
        };
        var onStart = function (event, info) {
            var _a;
            var _b = _this.getProps(), drag = _b.drag, dragPropagation = _b.dragPropagation, onDragStart = _b.onDragStart;
            if (drag && !dragPropagation) {
                if (_this.openGlobalLock)
                    _this.openGlobalLock();
                _this.openGlobalLock = getGlobalLock(drag);
                if (!_this.openGlobalLock)
                    return;
            }
            _this.isDragging = true;
            _this.currentDirection = null;
            _this.resolveConstraints();
            if (_this.visualElement.projection) {
                _this.visualElement.projection.isAnimationBlocked = true;
                _this.visualElement.projection.target = undefined;
            }
            eachAxis(function (axis) {
                var _a, _b;
                var current = _this.getAxisMotionValue(axis).get() || 0;
                if (percent.test(current)) {
                    var measuredAxis = (_b = (_a = _this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.actual[axis];
                    if (measuredAxis) {
                        var length_1 = calcLength(measuredAxis);
                        current = length_1 * (parseFloat(current) / 100);
                    }
                }
                _this.originPoint[axis] = current;
            });
            onDragStart === null || onDragStart === void 0 ? void 0 : onDragStart(event, info);
            (_a = _this.visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Drag, true);
        };
        var onMove = function (event, info) {
            var _a = _this.getProps(), dragPropagation = _a.dragPropagation, dragDirectionLock = _a.dragDirectionLock, onDirectionLock = _a.onDirectionLock, onDrag = _a.onDrag;
            if (!dragPropagation && !_this.openGlobalLock)
                return;
            var offset = info.offset;
            if (dragDirectionLock && _this.currentDirection === null) {
                _this.currentDirection = getCurrentDirection(offset);
                if (_this.currentDirection !== null) {
                    onDirectionLock === null || onDirectionLock === void 0 ? void 0 : onDirectionLock(_this.currentDirection);
                }
                return;
            }
            _this.updateAxis("x", info.point, offset);
            _this.updateAxis("y", info.point, offset);
            _this.visualElement.syncRender();
            onDrag === null || onDrag === void 0 ? void 0 : onDrag(event, info);
        };
        var onSessionEnd = function (event, info) {
            return _this.stop(event, info);
        };
        this.panSession = new PanSession(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
        }, { transformPagePoint: this.visualElement.getTransformPagePoint() });
    };
    VisualElementDragControls.prototype.stop = function (event, info) {
        var isDragging = this.isDragging;
        this.cancel();
        if (!isDragging)
            return;
        var velocity = info.velocity;
        this.startAnimation(velocity);
        var onDragEnd = this.getProps().onDragEnd;
        onDragEnd === null || onDragEnd === void 0 ? void 0 : onDragEnd(event, info);
    };
    VisualElementDragControls.prototype.cancel = function () {
        var _a, _b;
        this.isDragging = false;
        if (this.visualElement.projection) {
            this.visualElement.projection.isAnimationBlocked = false;
        }
        (_a = this.panSession) === null || _a === void 0 ? void 0 : _a.end();
        this.panSession = undefined;
        var dragPropagation = this.getProps().dragPropagation;
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        (_b = this.visualElement.animationState) === null || _b === void 0 ? void 0 : _b.setActive(AnimationType.Drag, false);
    };
    VisualElementDragControls.prototype.updateAxis = function (axis, _point, offset) {
        var drag = this.getProps().drag;
        if (!offset || !shouldDrag(axis, drag, this.currentDirection))
            return;
        var axisValue = this.getAxisMotionValue(axis);
        var next = this.originPoint[axis] + offset[axis];
        if (this.constraints && this.constraints[axis]) {
            next = applyConstraints(next, this.constraints[axis], this.elastic[axis]);
        }
        axisValue.set(next);
    };
    VisualElementDragControls.prototype.resolveConstraints = function () {
        var _this = this;
        var _a = this.getProps(), dragConstraints = _a.dragConstraints, dragElastic = _a.dragElastic;
        var layout = (this.visualElement.projection || {}).layout;
        var prevConstraints = this.constraints;
        if (dragConstraints && isRefObject(dragConstraints)) {
            if (!this.constraints) {
                this.constraints = this.resolveRefConstraints();
            }
        }
        else {
            if (dragConstraints && layout) {
                this.constraints = calcRelativeConstraints(layout.actual, dragConstraints);
            }
            else {
                this.constraints = false;
            }
        }
        this.elastic = resolveDragElastic(dragElastic);
        if (prevConstraints !== this.constraints &&
            layout &&
            this.constraints &&
            !this.hasMutatedConstraints) {
            eachAxis(function (axis) {
                if (_this.getAxisMotionValue(axis)) {
                    _this.constraints[axis] = rebaseAxisConstraints(layout.actual[axis], _this.constraints[axis]);
                }
            });
        }
    };
    VisualElementDragControls.prototype.resolveRefConstraints = function () {
        var _a = this.getProps(), constraints = _a.dragConstraints, onMeasureDragConstraints = _a.onMeasureDragConstraints;
        if (!constraints || !isRefObject(constraints))
            return false;
        var constraintsElement = constraints.current;
        invariant(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        var projection = this.visualElement.projection;
        if (!projection || !projection.layout)
            return false;
        var constraintsBox = measurePageBox(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        var measuredConstraints = calcViewportConstraints(projection.layout.actual, constraintsBox);
        if (onMeasureDragConstraints) {
            var userConstraints = onMeasureDragConstraints(convertBoxToBoundingBox(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) {
                measuredConstraints = convertBoundingBoxToBox(userConstraints);
            }
        }
        return measuredConstraints;
    };
    VisualElementDragControls.prototype.startAnimation = function (velocity) {
        var _this = this;
        var _a = this.getProps(), drag = _a.drag, dragMomentum = _a.dragMomentum, dragElastic = _a.dragElastic, dragTransition = _a.dragTransition, dragSnapToOrigin = _a.dragSnapToOrigin, onDragTransitionEnd = _a.onDragTransitionEnd;
        var constraints = this.constraints || {};
        var momentumAnimations = eachAxis(function (axis) {
            var _a;
            if (!shouldDrag(axis, drag, _this.currentDirection)) {
                return;
            }
            var transition = (_a = constraints === null || constraints === void 0 ? void 0 : constraints[axis]) !== null && _a !== void 0 ? _a : {};
            if (dragSnapToOrigin)
                transition = { min: 0, max: 0 };
            var bounceStiffness = dragElastic ? 200 : 1000000;
            var bounceDamping = dragElastic ? 40 : 10000000;
            var inertia = __assign$2(__assign$2({ type: "inertia", velocity: dragMomentum ? velocity[axis] : 0, bounceStiffness: bounceStiffness, bounceDamping: bounceDamping, timeConstant: 750, restDelta: 1, restSpeed: 10 }, dragTransition), transition);
            return _this.startAxisValueAnimation(axis, inertia);
        });
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    };
    VisualElementDragControls.prototype.startAxisValueAnimation = function (axis, transition) {
        var axisValue = this.getAxisMotionValue(axis);
        return startAnimation(axis, axisValue, 0, transition);
    };
    VisualElementDragControls.prototype.stopAnimation = function () {
        var _this = this;
        eachAxis(function (axis) { return _this.getAxisMotionValue(axis).stop(); });
    };
    VisualElementDragControls.prototype.getAxisMotionValue = function (axis) {
        var _a, _b;
        var dragKey = "_drag" + axis.toUpperCase();
        var externalMotionValue = this.visualElement.getProps()[dragKey];
        return externalMotionValue
            ? externalMotionValue
            : this.visualElement.getValue(axis, (_b = (_a = this.visualElement.getProps().initial) === null || _a === void 0 ? void 0 : _a[axis]) !== null && _b !== void 0 ? _b : 0);
    };
    VisualElementDragControls.prototype.snapToCursor = function (point) {
        var _this = this;
        eachAxis(function (axis) {
            var drag = _this.getProps().drag;
            if (!shouldDrag(axis, drag, _this.currentDirection))
                return;
            var projection = _this.visualElement.projection;
            var axisValue = _this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                var _a = projection.layout.actual[axis], min = _a.min, max = _a.max;
                axisValue.set(point[axis] - mix(min, max, 0.5));
            }
        });
    };
    VisualElementDragControls.prototype.scalePositionWithinConstraints = function () {
        var _this = this;
        var _a;
        var _b = this.getProps(), drag = _b.drag, dragConstraints = _b.dragConstraints;
        var projection = this.visualElement.projection;
        if (!isRefObject(dragConstraints) || !projection || !this.constraints)
            return;
        this.stopAnimation();
        var boxProgress = { x: 0, y: 0 };
        eachAxis(function (axis) {
            var axisValue = _this.getAxisMotionValue(axis);
            if (axisValue) {
                var latest = axisValue.get();
                boxProgress[axis] = calcOrigin({ min: latest, max: latest }, _this.constraints[axis]);
            }
        });
        var transformTemplate = this.visualElement.getProps().transformTemplate;
        this.visualElement.getInstance().style.transform = transformTemplate
            ? transformTemplate({}, "")
            : "none";
        (_a = projection.root) === null || _a === void 0 ? void 0 : _a.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        eachAxis(function (axis) {
            if (!shouldDrag(axis, drag, null))
                return;
            var axisValue = _this.getAxisMotionValue(axis);
            var _a = _this.constraints[axis], min = _a.min, max = _a.max;
            axisValue.set(mix(min, max, boxProgress[axis]));
        });
    };
    VisualElementDragControls.prototype.addListeners = function () {
        var _this = this;
        var _a;
        elementDragControls.set(this.visualElement, this);
        var element = this.visualElement.getInstance();
        var stopPointerListener = addPointerEvent(element, "pointerdown", function (event) {
            var _a = _this.getProps(), drag = _a.drag, _b = _a.dragListener, dragListener = _b === void 0 ? true : _b;
            drag && dragListener && _this.start(event);
        });
        var measureDragConstraints = function () {
            var dragConstraints = _this.getProps().dragConstraints;
            if (isRefObject(dragConstraints)) {
                _this.constraints = _this.resolveRefConstraints();
            }
        };
        var projection = this.visualElement.projection;
        var stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            (_a = projection.root) === null || _a === void 0 ? void 0 : _a.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        var stopResizeListener = addDomEvent(window, "resize", function () {
            _this.scalePositionWithinConstraints();
        });
        projection.addEventListener("didUpdate", (function (_a) {
            var delta = _a.delta, hasLayoutChanged = _a.hasLayoutChanged;
            if (_this.isDragging && hasLayoutChanged) {
                eachAxis(function (axis) {
                    var motionValue = _this.getAxisMotionValue(axis);
                    if (!motionValue)
                        return;
                    _this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                _this.visualElement.syncRender();
            }
        }));
        return function () {
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
        };
    };
    VisualElementDragControls.prototype.getProps = function () {
        var props = this.visualElement.getProps();
        var _a = props.drag, drag = _a === void 0 ? false : _a, _b = props.dragDirectionLock, dragDirectionLock = _b === void 0 ? false : _b, _c = props.dragPropagation, dragPropagation = _c === void 0 ? false : _c, _d = props.dragConstraints, dragConstraints = _d === void 0 ? false : _d, _e = props.dragElastic, dragElastic = _e === void 0 ? defaultElastic : _e, _f = props.dragMomentum, dragMomentum = _f === void 0 ? true : _f;
        return __assign$2(__assign$2({}, props), { drag: drag, dragDirectionLock: dragDirectionLock, dragPropagation: dragPropagation, dragConstraints: dragConstraints, dragElastic: dragElastic, dragMomentum: dragMomentum });
    };
    return VisualElementDragControls;
}());
function shouldDrag(direction, drag, currentDirection) {
    return ((drag === true || drag === direction) &&
        (currentDirection === null || currentDirection === direction));
}
function getCurrentDirection(offset, lockThreshold) {
    if (lockThreshold === void 0) { lockThreshold = 10; }
    var direction = null;
    if (Math.abs(offset.y) > lockThreshold) {
        direction = "y";
    }
    else if (Math.abs(offset.x) > lockThreshold) {
        direction = "x";
    }
    return direction;
}

function useDrag(props) {
    var groupDragControls = props.dragControls, visualElement = props.visualElement;
    var dragControls = useConstant(function () { return new VisualElementDragControls(visualElement); });
    useEffect(function () { return groupDragControls && groupDragControls.subscribe(dragControls); }, [dragControls, groupDragControls]);
    useEffect(function () { return dragControls.addListeners(); }, [dragControls]);
}

function usePanGesture(_a) {
    var onPan = _a.onPan, onPanStart = _a.onPanStart, onPanEnd = _a.onPanEnd, onPanSessionStart = _a.onPanSessionStart, visualElement = _a.visualElement;
    var hasPanEvents = onPan || onPanStart || onPanEnd || onPanSessionStart;
    var panSession = useRef(null);
    var transformPagePoint = useContext(MotionConfigContext).transformPagePoint;
    var handlers = {
        onSessionStart: onPanSessionStart,
        onStart: onPanStart,
        onMove: onPan,
        onEnd: function (event, info) {
            panSession.current = null;
            onPanEnd && onPanEnd(event, info);
        },
    };
    useEffect(function () {
        if (panSession.current !== null) {
            panSession.current.updateHandlers(handlers);
        }
    });
    function onPointerDown(event) {
        panSession.current = new PanSession(event, handlers, {
            transformPagePoint: transformPagePoint,
        });
    }
    usePointerEvent(visualElement, "pointerdown", hasPanEvents && onPointerDown);
    useUnmountEffect(function () { return panSession.current && panSession.current.end(); });
}

var drag = {
    pan: makeRenderlessComponent(usePanGesture),
    drag: makeRenderlessComponent(useDrag),
};

var names$3 = [
    "LayoutMeasure",
    "BeforeLayoutMeasure",
    "LayoutUpdate",
    "ViewportBoxUpdate",
    "Update",
    "Render",
    "AnimationComplete",
    "LayoutAnimationComplete",
    "AnimationStart",
    "SetAxisTarget",
    "Unmount",
];
function createLifecycles() {
    var managers = names$3.map(function () { return new SubscriptionManager(); });
    var propSubscriptions = {};
    var lifecycles = {
        clearAllListeners: function () { return managers.forEach(function (manager) { return manager.clear(); }); },
        updatePropListeners: function (props) {
            names$3.forEach(function (name) {
                var _a;
                var on = "on" + name;
                var propListener = props[on];
                (_a = propSubscriptions[name]) === null || _a === void 0 ? void 0 : _a.call(propSubscriptions);
                if (propListener) {
                    propSubscriptions[name] = lifecycles[on](propListener);
                }
            });
        },
    };
    managers.forEach(function (manager, i) {
        lifecycles["on" + names$3[i]] = function (handler) { return manager.add(handler); };
        lifecycles["notify" + names$3[i]] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            manager.notify.apply(manager, __spreadArray([], __read(args), false));
        };
    });
    return lifecycles;
}

function updateMotionValuesFromProps(element, next, prev) {
    var _a;
    for (var key in next) {
        var nextValue = next[key];
        var prevValue = prev[key];
        if (isMotionValue(nextValue)) {
            element.addValue(key, nextValue);
        }
        else if (isMotionValue(prevValue)) {
            element.addValue(key, motionValue(nextValue));
        }
        else if (prevValue !== nextValue) {
            if (element.hasValue(key)) {
                var existingValue = element.getValue(key);
                !existingValue.hasAnimated && existingValue.set(nextValue);
            }
            else {
                element.addValue(key, motionValue((_a = element.getStaticValue(key)) !== null && _a !== void 0 ? _a : nextValue));
            }
        }
    }
    for (var key in prev) {
        if (next[key] === undefined)
            element.removeValue(key);
    }
    return next;
}

var visualElement = function (_a) {
    var _b = _a.treeType, treeType = _b === void 0 ? "" : _b, build = _a.build, getBaseTarget = _a.getBaseTarget, makeTargetAnimatable = _a.makeTargetAnimatable, measureViewportBox = _a.measureViewportBox, renderInstance = _a.render, readValueFromInstance = _a.readValueFromInstance, removeValueFromRenderState = _a.removeValueFromRenderState, sortNodePosition = _a.sortNodePosition, scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps;
    return function (_a, options) {
        var parent = _a.parent, props = _a.props, presenceId = _a.presenceId, blockInitialAnimation = _a.blockInitialAnimation, visualState = _a.visualState;
        if (options === void 0) { options = {}; }
        var isMounted = false;
        var latestValues = visualState.latestValues, renderState = visualState.renderState;
        var instance;
        var lifecycles = createLifecycles();
        var values = new Map();
        var valueSubscriptions = new Map();
        var prevMotionValues = {};
        var baseTarget = __assign$2({}, latestValues);
        var removeFromVariantTree;
        function render() {
            if (!instance || !isMounted)
                return;
            triggerBuild();
            renderInstance(instance, renderState, props.style, element.projection);
        }
        function triggerBuild() {
            build(element, renderState, latestValues, options, props);
        }
        function update() {
            lifecycles.notifyUpdate(latestValues);
        }
        function bindToMotionValue(key, value) {
            var removeOnChange = value.onChange(function (latestValue) {
                latestValues[key] = latestValue;
                props.onUpdate && sync.update(update, false, true);
            });
            var removeOnRenderRequest = value.onRenderRequest(element.scheduleRender);
            valueSubscriptions.set(key, function () {
                removeOnChange();
                removeOnRenderRequest();
            });
        }
        var initialMotionValues = scrapeMotionValuesFromProps(props);
        for (var key in initialMotionValues) {
            var value = initialMotionValues[key];
            if (latestValues[key] !== undefined && isMotionValue(value)) {
                value.set(latestValues[key], false);
            }
        }
        var isControllingVariants = checkIfControllingVariants(props);
        var isVariantNode = checkIfVariantNode(props);
        var element = __assign$2(__assign$2({ treeType: treeType,
            current: null,
            depth: parent ? parent.depth + 1 : 0, parent: parent, children: new Set(),
            presenceId: presenceId,
            variantChildren: isVariantNode ? new Set() : undefined,
            isVisible: undefined,
            manuallyAnimateOnMount: Boolean(parent === null || parent === void 0 ? void 0 : parent.isMounted()),
            blockInitialAnimation: blockInitialAnimation,
            isMounted: function () { return Boolean(instance); }, mount: function (newInstance) {
                isMounted = true;
                instance = element.current = newInstance;
                if (element.projection) {
                    element.projection.mount(newInstance);
                }
                if (isVariantNode && parent && !isControllingVariants) {
                    removeFromVariantTree = parent === null || parent === void 0 ? void 0 : parent.addVariantChild(element);
                }
                parent === null || parent === void 0 ? void 0 : parent.children.add(element);
                element.setProps(props);
            },
            unmount: function () {
                var _a;
                (_a = element.projection) === null || _a === void 0 ? void 0 : _a.unmount();
                cancelSync.update(update);
                cancelSync.render(render);
                valueSubscriptions.forEach(function (remove) { return remove(); });
                removeFromVariantTree === null || removeFromVariantTree === void 0 ? void 0 : removeFromVariantTree();
                parent === null || parent === void 0 ? void 0 : parent.children.delete(element);
                lifecycles.clearAllListeners();
                instance = undefined;
                isMounted = false;
            },
            addVariantChild: function (child) {
                var _a;
                var closestVariantNode = element.getClosestVariantNode();
                if (closestVariantNode) {
                    (_a = closestVariantNode.variantChildren) === null || _a === void 0 ? void 0 : _a.add(child);
                    return function () {
                        return closestVariantNode.variantChildren.delete(child);
                    };
                }
            }, sortNodePosition: function (other) {
                if (!sortNodePosition || treeType !== other.treeType)
                    return 0;
                return sortNodePosition(element.getInstance(), other.getInstance());
            },
            getClosestVariantNode: function () {
                return isVariantNode ? element : parent === null || parent === void 0 ? void 0 : parent.getClosestVariantNode();
            },
            getLayoutId: function () { return props.layoutId; },
            getInstance: function () { return instance; },
            getStaticValue: function (key) { return latestValues[key]; }, setStaticValue: function (key, value) { return (latestValues[key] = value); },
            getLatestValues: function () { return latestValues; },
            setVisibility: function (visibility) {
                if (element.isVisible === visibility)
                    return;
                element.isVisible = visibility;
                element.scheduleRender();
            },
            makeTargetAnimatable: function (target, canMutate) {
                if (canMutate === void 0) { canMutate = true; }
                return makeTargetAnimatable(element, target, props, canMutate);
            },
            measureViewportBox: function () {
                return measureViewportBox(instance, props);
            },
            addValue: function (key, value) {
                if (element.hasValue(key))
                    element.removeValue(key);
                values.set(key, value);
                latestValues[key] = value.get();
                bindToMotionValue(key, value);
            },
            removeValue: function (key) {
                var _a;
                values.delete(key);
                (_a = valueSubscriptions.get(key)) === null || _a === void 0 ? void 0 : _a();
                valueSubscriptions.delete(key);
                delete latestValues[key];
                removeValueFromRenderState(key, renderState);
            },
            hasValue: function (key) { return values.has(key); },
            getValue: function (key, defaultValue) {
                var value = values.get(key);
                if (value === undefined && defaultValue !== undefined) {
                    value = motionValue(defaultValue);
                    element.addValue(key, value);
                }
                return value;
            },
            forEachValue: function (callback) { return values.forEach(callback); },
            readValue: function (key) {
                var _a;
                return (_a = latestValues[key]) !== null && _a !== void 0 ? _a : readValueFromInstance(instance, key, options);
            },
            setBaseTarget: function (key, value) {
                baseTarget[key] = value;
            },
            getBaseTarget: function (key) {
                if (getBaseTarget) {
                    var target = getBaseTarget(props, key);
                    if (target !== undefined && !isMotionValue(target))
                        return target;
                }
                return baseTarget[key];
            } }, lifecycles), {
            build: function () {
                triggerBuild();
                return renderState;
            },
            scheduleRender: function () {
                sync.render(render, false, true);
            },
            syncRender: render,
            setProps: function (newProps) {
                if (newProps.transformTemplate || props.transformTemplate) {
                    element.scheduleRender();
                }
                props = newProps;
                lifecycles.updatePropListeners(newProps);
                prevMotionValues = updateMotionValuesFromProps(element, scrapeMotionValuesFromProps(props), prevMotionValues);
            }, getProps: function () { return props; },
            getVariant: function (name) { var _a; return (_a = props.variants) === null || _a === void 0 ? void 0 : _a[name]; },
            getDefaultTransition: function () { return props.transition; }, getTransformPagePoint: function () {
                return props.transformPagePoint;
            },
            getVariantContext: function (startAtParent) {
                if (startAtParent === void 0) { startAtParent = false; }
                if (startAtParent)
                    return parent === null || parent === void 0 ? void 0 : parent.getVariantContext();
                if (!isControllingVariants) {
                    var context_1 = (parent === null || parent === void 0 ? void 0 : parent.getVariantContext()) || {};
                    if (props.initial !== undefined) {
                        context_1.initial = props.initial;
                    }
                    return context_1;
                }
                var context = {};
                for (var i = 0; i < numVariantProps; i++) {
                    var name_1 = variantProps[i];
                    var prop = props[name_1];
                    if (isVariantLabel(prop) || prop === false) {
                        context[name_1] = prop;
                    }
                }
                return context;
            } });
        return element;
    };
};
var variantProps = __spreadArray(["initial"], __read(variantPriorityOrder), false);
var numVariantProps = variantProps.length;

function isCSSVariable(value) {
    return typeof value === "string" && value.startsWith("var(--");
}
var cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function parseCSSVariable(current) {
    var match = cssVariableRegex.exec(current);
    if (!match)
        return [,];
    var _a = __read(match, 3), token = _a[1], fallback = _a[2];
    return [token, fallback];
}
var maxDepth = 4;
function getVariableValue(current, element, depth) {
    if (depth === void 0) { depth = 1; }
    invariant(depth <= maxDepth, "Max CSS variable fallback depth detected in property \"".concat(current, "\". This may indicate a circular fallback dependency."));
    var _a = __read(parseCSSVariable(current), 2), token = _a[0], fallback = _a[1];
    if (!token)
        return;
    var resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        return resolved.trim();
    }
    else if (isCSSVariable(fallback)) {
        return getVariableValue(fallback, element, depth + 1);
    }
    else {
        return fallback;
    }
}
function resolveCSSVariables(visualElement, _a, transitionEnd) {
    var _b;
    var target = __rest(_a, []);
    var element = visualElement.getInstance();
    if (!(element instanceof Element))
        return { target: target, transitionEnd: transitionEnd };
    if (transitionEnd) {
        transitionEnd = __assign$2({}, transitionEnd);
    }
    visualElement.forEachValue(function (value) {
        var current = value.get();
        if (!isCSSVariable(current))
            return;
        var resolved = getVariableValue(current, element);
        if (resolved)
            value.set(resolved);
    });
    for (var key in target) {
        var current = target[key];
        if (!isCSSVariable(current))
            continue;
        var resolved = getVariableValue(current, element);
        if (!resolved)
            continue;
        target[key] = resolved;
        if (transitionEnd)
            (_b = transitionEnd[key]) !== null && _b !== void 0 ? _b : (transitionEnd[key] = current);
    }
    return { target: target, transitionEnd: transitionEnd };
}

var positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
]);
var isPositionalKey = function (key) { return positionalKeys.has(key); };
var hasPositionalKey = function (target) {
    return Object.keys(target).some(isPositionalKey);
};
var setAndResetVelocity = function (value, to) {
    value.set(to, false);
    value.set(to);
};
var isNumOrPxType = function (v) {
    return v === number$2 || v === px;
};
var BoundingBoxDimension;
(function (BoundingBoxDimension) {
    BoundingBoxDimension["width"] = "width";
    BoundingBoxDimension["height"] = "height";
    BoundingBoxDimension["left"] = "left";
    BoundingBoxDimension["right"] = "right";
    BoundingBoxDimension["top"] = "top";
    BoundingBoxDimension["bottom"] = "bottom";
})(BoundingBoxDimension || (BoundingBoxDimension = {}));
var getPosFromMatrix = function (matrix, pos) {
    return parseFloat(matrix.split(", ")[pos]);
};
var getTranslateFromMatrix = function (pos2, pos3) {
    return function (_bbox, _a) {
        var transform = _a.transform;
        if (transform === "none" || !transform)
            return 0;
        var matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) {
            return getPosFromMatrix(matrix3d[1], pos3);
        }
        else {
            var matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) {
                return getPosFromMatrix(matrix[1], pos2);
            }
            else {
                return 0;
            }
        }
    };
};
var transformKeys = new Set(["x", "y", "z"]);
var nonTranslationalTransformKeys = transformProps.filter(function (key) { return !transformKeys.has(key); });
function removeNonTranslationalTransform(visualElement) {
    var removedTransforms = [];
    nonTranslationalTransformKeys.forEach(function (key) {
        var value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([key, value.get()]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    if (removedTransforms.length)
        visualElement.syncRender();
    return removedTransforms;
}
var positionalValues = {
    width: function (_a, _b) {
        var x = _a.x;
        var _c = _b.paddingLeft, paddingLeft = _c === void 0 ? "0" : _c, _d = _b.paddingRight, paddingRight = _d === void 0 ? "0" : _d;
        return x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight);
    },
    height: function (_a, _b) {
        var y = _a.y;
        var _c = _b.paddingTop, paddingTop = _c === void 0 ? "0" : _c, _d = _b.paddingBottom, paddingBottom = _d === void 0 ? "0" : _d;
        return y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom);
    },
    top: function (_bbox, _a) {
        var top = _a.top;
        return parseFloat(top);
    },
    left: function (_bbox, _a) {
        var left = _a.left;
        return parseFloat(left);
    },
    bottom: function (_a, _b) {
        var y = _a.y;
        var top = _b.top;
        return parseFloat(top) + (y.max - y.min);
    },
    right: function (_a, _b) {
        var x = _a.x;
        var left = _b.left;
        return parseFloat(left) + (x.max - x.min);
    },
    x: getTranslateFromMatrix(4, 13),
    y: getTranslateFromMatrix(5, 14),
};
var convertChangedValueTypes = function (target, visualElement, changedKeys) {
    var originBbox = visualElement.measureViewportBox();
    var element = visualElement.getInstance();
    var elementComputedStyle = getComputedStyle(element);
    var display = elementComputedStyle.display;
    var origin = {};
    if (display === "none") {
        visualElement.setStaticValue("display", target.display || "block");
    }
    changedKeys.forEach(function (key) {
        origin[key] = positionalValues[key](originBbox, elementComputedStyle);
    });
    visualElement.syncRender();
    var targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach(function (key) {
        var value = visualElement.getValue(key);
        setAndResetVelocity(value, origin[key]);
        target[key] = positionalValues[key](targetBbox, elementComputedStyle);
    });
    return target;
};
var checkAndConvertChangedValueTypes = function (visualElement, target, origin, transitionEnd) {
    if (origin === void 0) { origin = {}; }
    if (transitionEnd === void 0) { transitionEnd = {}; }
    target = __assign$2({}, target);
    transitionEnd = __assign$2({}, transitionEnd);
    var targetPositionalKeys = Object.keys(target).filter(isPositionalKey);
    var removedTransformValues = [];
    var hasAttemptedToRemoveTransformValues = false;
    var changedValueTypeKeys = [];
    targetPositionalKeys.forEach(function (key) {
        var value = visualElement.getValue(key);
        if (!visualElement.hasValue(key))
            return;
        var from = origin[key];
        var fromType = findDimensionValueType(from);
        var to = target[key];
        var toType;
        if (isKeyframesTarget(to)) {
            var numKeyframes = to.length;
            var fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = findDimensionValueType(from);
            for (var i = fromIndex; i < numKeyframes; i++) {
                if (!toType) {
                    toType = findDimensionValueType(to[i]);
                    invariant(toType === fromType ||
                        (isNumOrPxType(fromType) && isNumOrPxType(toType)), "Keyframes must be of the same dimension as the current value");
                }
                else {
                    invariant(findDimensionValueType(to[i]) === toType, "All keyframes must be of the same type");
                }
            }
        }
        else {
            toType = findDimensionValueType(to);
        }
        if (fromType !== toType) {
            if (isNumOrPxType(fromType) && isNumOrPxType(toType)) {
                var current = value.get();
                if (typeof current === "string") {
                    value.set(parseFloat(current));
                }
                if (typeof to === "string") {
                    target[key] = parseFloat(to);
                }
                else if (Array.isArray(to) && toType === px) {
                    target[key] = to.map(parseFloat);
                }
            }
            else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) &&
                (toType === null || toType === void 0 ? void 0 : toType.transform) &&
                (from === 0 || to === 0)) {
                if (from === 0) {
                    value.set(toType.transform(from));
                }
                else {
                    target[key] = fromType.transform(to);
                }
            }
            else {
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues =
                        removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] =
                    transitionEnd[key] !== undefined
                        ? transitionEnd[key]
                        : target[key];
                setAndResetVelocity(value, to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        var convertedTarget = convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        if (removedTransformValues.length) {
            removedTransformValues.forEach(function (_a) {
                var _b = __read(_a, 2), key = _b[0], value = _b[1];
                visualElement.getValue(key).set(value);
            });
        }
        visualElement.syncRender();
        return { target: convertedTarget, transitionEnd: transitionEnd };
    }
    else {
        return { target: target, transitionEnd: transitionEnd };
    }
};
function unitConversion(visualElement, target, origin, transitionEnd) {
    return hasPositionalKey(target)
        ? checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd)
        : { target: target, transitionEnd: transitionEnd };
}

var parseDomVariant = function (visualElement, target, origin, transitionEnd) {
    var resolved = resolveCSSVariables(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return unitConversion(visualElement, target, origin, transitionEnd);
};

function getComputedStyle$1(element) {
    return window.getComputedStyle(element);
}
var htmlConfig = {
    treeType: "dom",
    readValueFromInstance: function (domElement, key) {
        if (isTransformProp(key)) {
            var defaultType = getDefaultValueType(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        else {
            var computedStyle = getComputedStyle$1(domElement);
            return ((isCSSVariable$1(key)
                ? computedStyle.getPropertyValue(key)
                : computedStyle[key]) || 0);
        }
    },
    sortNodePosition: function (a, b) {
        return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    },
    getBaseTarget: function (props, key) {
        var _a;
        return (_a = props.style) === null || _a === void 0 ? void 0 : _a[key];
    },
    measureViewportBox: function (element, _a) {
        var transformPagePoint = _a.transformPagePoint;
        return measureViewportBox(element, transformPagePoint);
    },
    resetTransform: function (element, domElement, props) {
        var transformTemplate = props.transformTemplate;
        domElement.style.transform = transformTemplate
            ? transformTemplate({}, "")
            : "none";
        element.scheduleRender();
    },
    restoreTransform: function (instance, mutableState) {
        instance.style.transform = mutableState.style.transform;
    },
    removeValueFromRenderState: function (key, _a) {
        var vars = _a.vars, style = _a.style;
        delete vars[key];
        delete style[key];
    },
    makeTargetAnimatable: function (element, _a, _b, isMounted) {
        var transformValues = _b.transformValues;
        if (isMounted === void 0) { isMounted = true; }
        var transition = _a.transition, transitionEnd = _a.transitionEnd, target = __rest(_a, ["transition", "transitionEnd"]);
        var origin = getOrigin(target, transition || {}, element);
        if (transformValues) {
            if (transitionEnd)
                transitionEnd = transformValues(transitionEnd);
            if (target)
                target = transformValues(target);
            if (origin)
                origin = transformValues(origin);
        }
        if (isMounted) {
            checkTargetForNewValues(element, target, origin);
            var parsed = parseDomVariant(element, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return __assign$2({ transition: transition, transitionEnd: transitionEnd }, target);
    },
    scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
    build: function (element, renderState, latestValues, options, props) {
        if (element.isVisible !== undefined) {
            renderState.style.visibility = element.isVisible
                ? "visible"
                : "hidden";
        }
        buildHTMLStyles(renderState, latestValues, options, props.transformTemplate);
    },
    render: renderHTML,
};
var htmlVisualElement = visualElement(htmlConfig);

var svgVisualElement = visualElement(__assign$2(__assign$2({}, htmlConfig), { getBaseTarget: function (props, key) {
        return props[key];
    }, readValueFromInstance: function (domElement, key) {
        var _a;
        if (isTransformProp(key)) {
            return ((_a = getDefaultValueType(key)) === null || _a === void 0 ? void 0 : _a.default) || 0;
        }
        key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
        return domElement.getAttribute(key);
    }, scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, build: function (_element, renderState, latestValues, options, props) {
        buildSVGAttrs(renderState, latestValues, options, props.transformTemplate);
    }, render: renderSVG }));

var createDomVisualElement = function (Component, options) {
    return isSVGComponent(Component)
        ? svgVisualElement(options, { enableHardwareAcceleration: false })
        : htmlVisualElement(options, { enableHardwareAcceleration: true });
};

function pixelsToPercent(pixels, axis) {
    if (axis.max === axis.min)
        return 0;
    return (pixels / (axis.max - axis.min)) * 100;
}
var correctBorderRadius = {
    correct: function (latest, node) {
        if (!node.target)
            return latest;
        if (typeof latest === "string") {
            if (px.test(latest)) {
                latest = parseFloat(latest);
            }
            else {
                return latest;
            }
        }
        var x = pixelsToPercent(latest, node.target.x);
        var y = pixelsToPercent(latest, node.target.y);
        return "".concat(x, "% ").concat(y, "%");
    },
};

var varToken = "_$css";
var correctBoxShadow = {
    correct: function (latest, _a) {
        var treeScale = _a.treeScale, projectionDelta = _a.projectionDelta;
        var original = latest;
        var containsCSSVariables = latest.includes("var(");
        var cssVariables = [];
        if (containsCSSVariables) {
            latest = latest.replace(cssVariableRegex, function (match) {
                cssVariables.push(match);
                return varToken;
            });
        }
        var shadow = complex.parse(latest);
        if (shadow.length > 5)
            return original;
        var template = complex.createTransformer(latest);
        var offset = typeof shadow[0] !== "number" ? 1 : 0;
        var xScale = projectionDelta.x.scale * treeScale.x;
        var yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        var averageScale = mix(xScale, yScale, 0.5);
        if (typeof shadow[2 + offset] === "number")
            shadow[2 + offset] /= averageScale;
        if (typeof shadow[3 + offset] === "number")
            shadow[3 + offset] /= averageScale;
        var output = template(shadow);
        if (containsCSSVariables) {
            var i_1 = 0;
            output = output.replace(varToken, function () {
                var cssVariable = cssVariables[i_1];
                i_1++;
                return cssVariable;
            });
        }
        return output;
    },
};

var MeasureLayoutWithContext =  (function (_super) {
    __extends(MeasureLayoutWithContext, _super);
    function MeasureLayoutWithContext() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MeasureLayoutWithContext.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, visualElement = _a.visualElement, layoutGroup = _a.layoutGroup, switchLayoutGroup = _a.switchLayoutGroup, layoutId = _a.layoutId;
        var projection = visualElement.projection;
        addScaleCorrector(defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup === null || layoutGroup === void 0 ? void 0 : layoutGroup.group)
                layoutGroup.group.add(projection);
            if ((switchLayoutGroup === null || switchLayoutGroup === void 0 ? void 0 : switchLayoutGroup.register) && layoutId) {
                switchLayoutGroup.register(projection);
            }
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", function () {
                _this.safeToRemove();
            });
            projection.setOptions(__assign$2(__assign$2({}, projection.options), { onExitComplete: function () { return _this.safeToRemove(); } }));
        }
        globalProjectionState.hasEverUpdated = true;
    };
    MeasureLayoutWithContext.prototype.getSnapshotBeforeUpdate = function (prevProps) {
        var _this = this;
        var _a = this.props, layoutDependency = _a.layoutDependency, visualElement = _a.visualElement, drag = _a.drag, isPresent = _a.isPresent;
        var projection = visualElement.projection;
        if (!projection)
            return null;
        projection.isPresent = isPresent;
        if (drag ||
            prevProps.layoutDependency !== layoutDependency ||
            layoutDependency === undefined) {
            projection.willUpdate();
        }
        else {
            this.safeToRemove();
        }
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) {
                projection.promote();
            }
            else if (!projection.relegate()) {
                sync.postRender(function () {
                    var _a;
                    if (!((_a = projection.getStack()) === null || _a === void 0 ? void 0 : _a.members.length)) {
                        _this.safeToRemove();
                    }
                });
            }
        }
        return null;
    };
    MeasureLayoutWithContext.prototype.componentDidUpdate = function () {
        var projection = this.props.visualElement.projection;
        if (projection) {
            projection.root.didUpdate();
            if (!projection.currentAnimation && projection.isLead()) {
                this.safeToRemove();
            }
        }
    };
    MeasureLayoutWithContext.prototype.componentWillUnmount = function () {
        var _a = this.props, visualElement = _a.visualElement, layoutGroup = _a.layoutGroup, promoteContext = _a.switchLayoutGroup;
        var projection = visualElement.projection;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup === null || layoutGroup === void 0 ? void 0 : layoutGroup.group)
                layoutGroup.group.remove(projection);
            if (promoteContext === null || promoteContext === void 0 ? void 0 : promoteContext.deregister)
                promoteContext.deregister(projection);
        }
    };
    MeasureLayoutWithContext.prototype.safeToRemove = function () {
        var safeToRemove = this.props.safeToRemove;
        safeToRemove === null || safeToRemove === void 0 ? void 0 : safeToRemove();
    };
    MeasureLayoutWithContext.prototype.render = function () {
        return null;
    };
    return MeasureLayoutWithContext;
}(React__default.Component));
function MeasureLayout(props) {
    var _a = __read(usePresence(), 2), isPresent = _a[0], safeToRemove = _a[1];
    var layoutGroup = useContext(LayoutGroupContext);
    return (React__default.createElement(MeasureLayoutWithContext, __assign$2({}, props, { layoutGroup: layoutGroup, switchLayoutGroup: useContext(SwitchLayoutGroupContext), isPresent: isPresent, safeToRemove: safeToRemove })));
}
var defaultScaleCorrectors = {
    borderRadius: __assign$2(__assign$2({}, correctBorderRadius), { applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
        ] }),
    borderTopLeftRadius: correctBorderRadius,
    borderTopRightRadius: correctBorderRadius,
    borderBottomLeftRadius: correctBorderRadius,
    borderBottomRightRadius: correctBorderRadius,
    boxShadow: correctBoxShadow,
};

var layoutFeatures = {
    measureLayout: MeasureLayout,
};

var DocumentProjectionNode = createProjectionNode({
    attachResizeListener: function (ref, notify) {
        ref.addEventListener("resize", notify, { passive: true });
        return function () { return ref.removeEventListener("resize", notify); };
    },
    measureScroll: function () { return ({
        x: document.documentElement.scrollLeft || document.body.scrollLeft,
        y: document.documentElement.scrollTop || document.body.scrollTop,
    }); },
});

var rootProjectionNode = {
    current: undefined,
};
var HTMLProjectionNode = createProjectionNode({
    measureScroll: function (instance) { return ({
        x: instance.scrollLeft,
        y: instance.scrollTop,
    }); },
    defaultParent: function () {
        if (!rootProjectionNode.current) {
            var documentNode = new DocumentProjectionNode(0, {});
            documentNode.mount(window);
            documentNode.setOptions({ layoutScroll: true });
            rootProjectionNode.current = documentNode;
        }
        return rootProjectionNode.current;
    },
    resetTransform: function (instance, value) {
        instance.style.transform = value !== null && value !== void 0 ? value : "none";
    },
});

var featureBundle = __assign$2(__assign$2(__assign$2(__assign$2({}, animations), gestureAnimations), drag), layoutFeatures);
var motion =  createMotionProxy(function (Component, config) {
    return createDomMotionConfig(Component, config, featureBundle, createDomVisualElement, HTMLProjectionNode);
});

function useForceUpdate() {
    var isUnmountingRef = useRef(false);
    var _a = __read(useState(0), 2), forcedRenderCount = _a[0], setForcedRenderCount = _a[1];
    useUnmountEffect(function () { return (isUnmountingRef.current = true); });
    var forceRender = useCallback(function () {
        !isUnmountingRef.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [forcedRenderCount]);
    var deferredForceRender = useCallback(function () { return sync.postRender(forceRender); }, [forceRender]);
    return [deferredForceRender, forcedRenderCount];
}

var presenceId = 0;
function getPresenceId() {
    var id = presenceId;
    presenceId++;
    return id;
}
var PresenceChild = function (_a) {
    var children = _a.children, initial = _a.initial, isPresent = _a.isPresent, onExitComplete = _a.onExitComplete, custom = _a.custom, presenceAffectsLayout = _a.presenceAffectsLayout;
    var presenceChildren = useConstant(newChildrenMap);
    var id = useConstant(getPresenceId);
    var context = useMemo(function () { return ({
        id: id,
        initial: initial,
        isPresent: isPresent,
        custom: custom,
        onExitComplete: function (childId) {
            var e_1, _a;
            presenceChildren.set(childId, true);
            try {
                for (var _b = __values(presenceChildren.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var isComplete = _c.value;
                    if (!isComplete)
                        return;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete();
        },
        register: function (childId) {
            presenceChildren.set(childId, false);
            return function () { return presenceChildren.delete(childId); };
        },
    }); },
    presenceAffectsLayout ? undefined : [isPresent]);
    useMemo(function () {
        presenceChildren.forEach(function (_, key) { return presenceChildren.set(key, false); });
    }, [isPresent]);
    React$4.useEffect(function () {
        !isPresent && !presenceChildren.size && (onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete());
    }, [isPresent]);
    return (React$4.createElement(PresenceContext.Provider, { value: context }, children));
};
function newChildrenMap() {
    return new Map();
}

function getChildKey(child) {
    return child.key || "";
}
function updateChildLookup(children, allChildren) {
    var seenChildren = process.env.NODE_ENV !== "production" ? new Set() : null;
    children.forEach(function (child) {
        var key = getChildKey(child);
        if (process.env.NODE_ENV !== "production" && seenChildren) {
            if (seenChildren.has(key)) {
                console.warn("Children of AnimatePresence require unique keys. \"".concat(key, "\" is a duplicate."));
            }
            seenChildren.add(key);
        }
        allChildren.set(key, child);
    });
}
function onlyElements(children) {
    var filtered = [];
    Children.forEach(children, function (child) {
        if (isValidElement(child))
            filtered.push(child);
    });
    return filtered;
}
var AnimatePresence = function (_a) {
    var children = _a.children, custom = _a.custom, _b = _a.initial, initial = _b === void 0 ? true : _b, onExitComplete = _a.onExitComplete, exitBeforeEnter = _a.exitBeforeEnter, _c = _a.presenceAffectsLayout, presenceAffectsLayout = _c === void 0 ? true : _c;
    var _d = __read(useForceUpdate(), 1), forceRender = _d[0];
    var forceRenderLayoutGroup = useContext(LayoutGroupContext).forceRender;
    if (forceRenderLayoutGroup)
        forceRender = forceRenderLayoutGroup;
    var isInitialRender = useRef(true);
    var isMounted = useRef(true);
    useEffect(function () { return function () {
        isMounted.current = false;
    }; }, []);
    var filteredChildren = onlyElements(children);
    var presentChildren = useRef(filteredChildren);
    var allChildren = useRef(new Map()).current;
    var exiting = useRef(new Set()).current;
    updateChildLookup(filteredChildren, allChildren);
    if (isInitialRender.current) {
        isInitialRender.current = false;
        return (React$4.createElement(React$4.Fragment, null, filteredChildren.map(function (child) { return (React$4.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, initial: initial ? undefined : false, presenceAffectsLayout: presenceAffectsLayout }, child)); })));
    }
    var childrenToRender = __spreadArray([], __read(filteredChildren), false);
    var presentKeys = presentChildren.current.map(getChildKey);
    var targetKeys = filteredChildren.map(getChildKey);
    var numPresent = presentKeys.length;
    for (var i = 0; i < numPresent; i++) {
        var key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1) {
            exiting.add(key);
        }
        else {
            exiting.delete(key);
        }
    }
    if (exitBeforeEnter && exiting.size) {
        childrenToRender = [];
    }
    exiting.forEach(function (key) {
        if (targetKeys.indexOf(key) !== -1)
            return;
        var child = allChildren.get(key);
        if (!child)
            return;
        var insertionIndex = presentKeys.indexOf(key);
        var onExit = function () {
            allChildren.delete(key);
            exiting.delete(key);
            var removeIndex = presentChildren.current.findIndex(function (presentChild) { return presentChild.key === key; });
            presentChildren.current.splice(removeIndex, 1);
            if (!exiting.size) {
                presentChildren.current = filteredChildren;
                if (isMounted.current === false) {
                    return;
                }
                forceRender();
                onExitComplete && onExitComplete();
            }
        };
        childrenToRender.splice(insertionIndex, 0, React$4.createElement(PresenceChild, { key: getChildKey(child), isPresent: false, onExitComplete: onExit, custom: custom, presenceAffectsLayout: presenceAffectsLayout }, child));
    });
    childrenToRender = childrenToRender.map(function (child) {
        var key = child.key;
        return exiting.has(key) ? (child) : (React$4.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, presenceAffectsLayout: presenceAffectsLayout }, child));
    });
    presentChildren.current = childrenToRender;
    if (process.env.NODE_ENV !== "production" &&
        exitBeforeEnter &&
        childrenToRender.length > 1) {
        console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour.");
    }
    return (React$4.createElement(React$4.Fragment, null, exiting.size
        ? childrenToRender
        : childrenToRender.map(function (child) { return cloneElement(child); })));
};

function counter(from, to, duration, toFixed) {
  var _React$useState = React__default.useState(from),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      currentValue = _React$useState2[0],
      setValue = _React$useState2[1];
  React__default.useEffect(function () {
    var controls = animate(from, to, {
      duration: duration !== null && duration !== void 0 ? duration : 1,
      onUpdate: function onUpdate(value) {
        setValue(value.toFixed(toFixed));
      }
    });
    return function () {
      return controls.stop();
    };
  }, [from, to]);
  return currentValue;
}

function truncate(input) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  if (input.length > length) {
    return "".concat(input.substring(0, length), "...");
  }
  return input;
}

var useDidMountEffect = function useDidMountEffect(func, deps) {
  var didMount = React$4.useRef(false);
  React$4.useEffect(function () {
    if (didMount.current) func();else didMount.current = true;
  }, deps);
};

function getScrollHeight() {
  var _React$useState = React$4.useState(0),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      scrollHeight = _React$useState2[0],
      setScrollHeight = _React$useState2[1];
  React$4.useEffect(function () {
    function handleScroll() {
      setScrollHeight(window.pageYOffset);
    }
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return function () {
      return window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return scrollHeight;
}

function getScrollDirection() {
  var _React$useState = React$4.useState(0),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      y = _React$useState2[0],
      setY = _React$useState2[1];
  var _React$useState3 = React$4.useState(''),
      _React$useState4 = _slicedToArray$5(_React$useState3, 2),
      direction = _React$useState4[0],
      setDirection = _React$useState4[1];
  var handleNavigation = React$4.useCallback(function (e) {
    var window = e.currentTarget;
    if (y > window.scrollY) {
      setDirection('up');
    } else if (y < window.scrollY) {
      setDirection('down');
    }
    setY(window.scrollY);
  }, [y]);
  React$4.useEffect(function () {
    setY(window.scrollY);
    window.addEventListener('scroll', handleNavigation);
    return function () {
      window.removeEventListener('scroll', handleNavigation);
    };
  }, [handleNavigation]);
  return direction;
}

function filterBasedOnId(data) {
  for (var _len = arguments.length, ids = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    ids[_key - 1] = arguments[_key];
  }
  return data.filter(function (e) {
    return ids.includes(e._id);
  }).sort(function (a, b) {
    return ids.indexOf(a._id) - ids.indexOf(b._id);
  });
}

function filterBasedOnType(data, type) {
  return data.filter(function (e) {
    return e._type === type;
  });
}

var useCurrencyFormat = function useCurrencyFormat(locale) {
  return function (amount, currency) {
    var _React$useState = React__default.useState(amount),
        _React$useState2 = _slicedToArray$5(_React$useState, 2),
        currentAmount = _React$useState2[0],
        setCurrentAmount = _React$useState2[1];
    React__default.useEffect(function () {
      var e = Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 10
      });
      setCurrentAmount(e.format(amount));
    }, [amount]);
    return currentAmount;
  };
};

function easeOutQuart(x) {
  return 1 - Math.pow(1 - x, 4);
}
function animateScroll(_ref) {
  var targetPosition = _ref.targetPosition,
      initialPosition = _ref.initialPosition,
      duration = _ref.duration;
  var start;
  var position;
  var animationFrame;
  var _window = window,
      requestAnimationFrame = _window.requestAnimationFrame;
  var _window2 = window,
      cancelAnimationFrame = _window2.cancelAnimationFrame;
  var maxAvailableScroll = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  var amountOfPixelsToScroll = initialPosition - targetPosition;
  function step(timestamp) {
    if (start === undefined) {
      start = timestamp;
    }
    var elapsed = timestamp - start;
    var relativeProgress = elapsed / duration;
    var easedProgress = easeOutQuart(relativeProgress);
    position = initialPosition - amountOfPixelsToScroll * Math.min(easedProgress, 1);
    window.scrollTo(0, position);
    if (initialPosition !== maxAvailableScroll && window.scrollY === maxAvailableScroll) {
      cancelAnimationFrame(animationFrame);
      return;
    }
    if (elapsed < duration) {
      animationFrame = requestAnimationFrame(step);
    }
  }
  animationFrame = requestAnimationFrame(step);
}

var getElementPosition = function getElementPosition(element) {
  return element.offsetTop;
};
function scrollTo(_ref) {
  var id = _ref.id,
      _ref$ref = _ref.ref,
      ref = _ref$ref === void 0 ? null : _ref$ref,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 3000 : _ref$duration;
  var initialPosition = window.scrollY;
  var element = ref ? ref.current : id ? document.getElementById(id) : null;
  if (!element) {
    console.error('[BCU Library]: Invalid element, are you sure you\'ve provided element id or react ref?');
    return;
  }
  animateScroll({
    targetPosition: getElementPosition(element),
    initialPosition: initialPosition,
    duration: duration
  });
}

var toCapital = (function (str) {
  return str.replace(/(^\w|\s\w)/g, function (m) {
    return m.toUpperCase();
  });
});

var useSweetName = function useSweetName(_) {
  return function (name) {
    switch (name) {
      case 'HIDDEN':
        return _('name.hidden', {
          ns: 'chargepoint'
        });
      case 'UMOVE':
        return _('name.umove', {
          ns: 'chargepoint'
        });
      case 'NANO':
        return _('name.nanocharge', {
          ns: 'chargepoint'
        });
      default:
        return _('chargePoint', {
          ns: 'ui'
        });
    }
  };
};

var useCountDecimals = function useCountDecimals() {
  return function (value) {
    if (value % 1 !== 0) return value.toString().split('.')[1].length;
    return 0;
  };
};

function useRandomConfetti() {
  var types = ['C', 'Figure', 'Oval', 'Stripes'];
  var colors = [Colors.GREEN, Colors.ORANGE, Colors.YELLOW, Colors.PURPLE];
  return {
    type: types[Math.floor(Math.random() * types.length)],
    color: colors[Math.floor(Math.random() * colors.length)]
  };
}

function useRandomPosition() {
  var array = ['top left', 'top right', 'bottom left', 'bottom right'];
  var options = array[Math.floor(Math.random() * array.length)];
  var getValues = function getValues() {
    switch (options) {
      case 'top left':
        return {
          top: 0,
          left: 0,
          right: 'inherit',
          bottom: 'inherit'
        };
      case 'top right':
        return {
          top: 0,
          left: 'inherit',
          right: 0,
          bottom: 'inherit'
        };
      case 'bottom left':
        return {
          top: 'inherit',
          left: 0,
          right: 'inherit',
          bottom: 0
        };
      case 'bottom right':
        return {
          top: 'inherit',
          left: 'inherit',
          right: 0,
          bottom: 0
        };
      default:
        return {
          top: 0,
          left: 0,
          right: 'inherit',
          bottom: 'inherit'
        };
    }
  };
  var position = getValues();
  return {
    top: position.top,
    left: position.left,
    right: position.right,
    bottom: position.bottom
  };
}

var countryData = [{name:"Afghanistan",region:"Asia",timezones:{"Asia/Kabul":"+04:30"},iso:{"alpha-2":"AF","alpha-3":"AFG",numeric:"004"},phone:["+93"],emoji:"🇦🇫",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AF.svg"},{name:"Albania",region:"Europe",timezones:{"Europe/Tirane":"+02:00"},iso:{"alpha-2":"AL","alpha-3":"ALB",numeric:"008"},iban:{length:28},phone:["+355"],emoji:"🇦🇱",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AL.svg"},{name:"Algeria",region:"Africa",timezones:{"Africa/Algiers":"+01:00"},iso:{"alpha-2":"DZ","alpha-3":"DZA",numeric:"012"},phone:["+213"],emoji:"🇩🇿",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DZ.svg"},{name:"American Samoa",region:"Oceania",timezones:{"Pacific/Pago_Pago":"-11:00"},iso:{"alpha-2":"AS","alpha-3":"ASM",numeric:"016"},phone:["+1-684"],emoji:"🇦🇸",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AS.svg"},{name:"Andorra",region:"Europe",timezones:{"Europe/Andorra":"+02:00"},iso:{"alpha-2":"AD","alpha-3":"AND",numeric:"020"},iban:{length:24},phone:["+376"],emoji:"🇦🇩",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AD.svg"},{name:"Angola",region:"Africa",timezones:{"Africa/Luanda":"+01:00"},iso:{"alpha-2":"AO","alpha-3":"AGO",numeric:"024"},phone:["+244"],emoji:"🇦🇴",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AO.svg"},{name:"Anguilla",region:"Americas",timezones:{"America/Anguilla":"-04:00"},iso:{"alpha-2":"AI","alpha-3":"AIA",numeric:"660"},phone:["+1-264"],emoji:"🇦🇮",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AI.svg"},{name:"Antarctica",region:"",timezones:{"Antarctica/Casey":"+11:00","Antarctica/Davis":"+07:00","Antarctica/DumontDUrville":"+10:00","Antarctica/Mawson":"+05:00","Antarctica/McMurdo":"+12:00","Antarctica/Palmer":"-03:00","Antarctica/Rothera":"-03:00","Antarctica/Syowa":"+03:00","Antarctica/Troll":"+02:00","Antarctica/Vostok":"+06:00"},iso:{"alpha-2":"AQ","alpha-3":"ATA",numeric:"010"},phone:["+"],emoji:"🇦🇶",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AQ.svg"},{name:"Antigua and Barbuda",region:"Americas",timezones:{"America/Antigua":"-04:00"},iso:{"alpha-2":"AG","alpha-3":"ATG",numeric:"028"},phone:["+1-268"],emoji:"🇦🇬",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AG.svg"},{name:"Argentina",region:"Americas",timezones:{"America/Argentina/Buenos_Aires":"-03:00","America/Argentina/Catamarca":"-03:00","America/Argentina/Cordoba":"-03:00","America/Argentina/Jujuy":"-03:00","America/Argentina/La_Rioja":"-03:00","America/Argentina/Mendoza":"-03:00","America/Argentina/Rio_Gallegos":"-03:00","America/Argentina/Salta":"-03:00","America/Argentina/San_Juan":"-03:00","America/Argentina/San_Luis":"-03:00","America/Argentina/Tucuman":"-03:00","America/Argentina/Ushuaia":"-03:00"},iso:{"alpha-2":"AR","alpha-3":"ARG",numeric:"032"},phone:["+54"],emoji:"🇦🇷",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AR.svg"},{name:"Armenia",region:"Asia",timezones:{"Asia/Yerevan":"+04:00"},iso:{"alpha-2":"AM","alpha-3":"ARM",numeric:"051"},phone:["+374"],emoji:"🇦🇲",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AM.svg"},{name:"Aruba",region:"Americas",timezones:{"America/Aruba":"-04:00"},iso:{"alpha-2":"AW","alpha-3":"ABW",numeric:"533"},phone:["+297"],emoji:"🇦🇼",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AW.svg"},{name:"Australia",region:"Oceania",timezones:{"Antarctica/Macquarie":"+10:00","Australia/Adelaide":"+09:30","Australia/Brisbane":"+10:00","Australia/Broken_Hill":"+09:30","Australia/Darwin":"+09:30","Australia/Eucla":"+08:45","Australia/Hobart":"+10:00","Australia/Lindeman":"+10:00","Australia/Lord_Howe":"+10:30","Australia/Melbourne":"+10:00","Australia/Perth":"+08:00","Australia/Sydney":"+10:00"},iso:{"alpha-2":"AU","alpha-3":"AUS",numeric:"036"},phone:["+61"],emoji:"🇦🇺",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AU.svg"},{name:"Austria",region:"Europe",timezones:{"Europe/Vienna":"+02:00"},iso:{"alpha-2":"AT","alpha-3":"AUT",numeric:"040"},iban:{length:20},phone:["+43"],emoji:"🇦🇹",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AT.svg"},{name:"Azerbaijan",region:"Asia",timezones:{"Asia/Baku":"+04:00"},iso:{"alpha-2":"AZ","alpha-3":"AZE",numeric:"031"},iban:{length:28},phone:["+994"],emoji:"🇦🇿",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AZ.svg"},{name:"Bahamas",region:"Americas",timezones:{"America/Nassau":"-04:00"},iso:{"alpha-2":"BS","alpha-3":"BHS",numeric:"044"},phone:["+1-242"],emoji:"🇧🇸",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BS.svg"},{name:"Bahrain",region:"Asia",timezones:{"Asia/Bahrain":"+03:00"},iso:{"alpha-2":"BH","alpha-3":"BHR",numeric:"048"},iban:{length:22},phone:["+973"],emoji:"🇧🇭",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BH.svg"},{name:"Bangladesh",region:"Asia",timezones:{"Asia/Dhaka":"+06:00"},iso:{"alpha-2":"BD","alpha-3":"BGD",numeric:"050"},phone:["+880"],emoji:"🇧🇩",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BD.svg"},{name:"Barbados",region:"Americas",timezones:{"America/Barbados":"-04:00"},iso:{"alpha-2":"BB","alpha-3":"BRB",numeric:"052"},phone:["+1-246"],emoji:"🇧🇧",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BB.svg"},{name:"Belarus",region:"Europe",timezones:{"Europe/Minsk":"+03:00"},iso:{"alpha-2":"BY","alpha-3":"BLR",numeric:"112"},iban:{length:28},phone:["+375"],emoji:"🇧🇾",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BY.svg"},{name:"Belgium",region:"Europe",timezones:{"Europe/Brussels":"+02:00"},iso:{"alpha-2":"BE","alpha-3":"BEL",numeric:"056"},iban:{length:16},phone:["+32"],emoji:"🇧🇪",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BE.svg"},{name:"Belize",region:"Americas",timezones:{"America/Belize":"-06:00"},iso:{"alpha-2":"BZ","alpha-3":"BLZ",numeric:"084"},phone:["+501"],emoji:"🇧🇿",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BZ.svg"},{name:"Benin",region:"Africa",timezones:{"Africa/Porto-Novo":"+01:00"},iso:{"alpha-2":"BJ","alpha-3":"BEN",numeric:"204"},phone:["+229"],emoji:"🇧🇯",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BJ.svg"},{name:"Bermuda",region:"Americas",timezones:{"Atlantic/Bermuda":"-03:00"},iso:{"alpha-2":"BM","alpha-3":"BMU",numeric:"060"},phone:["+1-441"],emoji:"🇧🇲",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BM.svg"},{name:"Bhutan",region:"Asia",timezones:{"Asia/Thimphu":"+06:00"},iso:{"alpha-2":"BT","alpha-3":"BTN",numeric:"064"},phone:["+975"],emoji:"🇧🇹",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BT.svg"},{name:"Bolivia, Plurinational State of",region:"Americas",timezones:{"America/La_Paz":"-04:00"},iso:{"alpha-2":"BO","alpha-3":"BOL",numeric:"068"},phone:["+591"],emoji:"🇧🇴",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BO.svg"},{name:"Bonaire, Sint Eustatius and Saba",region:"Americas",timezones:{"America/Kralendijk":"-04:00"},iso:{"alpha-2":"BQ","alpha-3":"BES",numeric:"535"},phone:["+599"],emoji:"🇧🇶",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BQ.svg"},{name:"Bosnia and Herzegovina",region:"Europe",timezones:{"Europe/Sarajevo":"+02:00"},iso:{"alpha-2":"BA","alpha-3":"BIH",numeric:"070"},iban:{length:20},phone:["+387"],emoji:"🇧🇦",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BA.svg"},{name:"Botswana",region:"Africa",timezones:{"Africa/Gaborone":"+02:00"},iso:{"alpha-2":"BW","alpha-3":"BWA",numeric:"072"},phone:["+267"],emoji:"🇧🇼",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BW.svg"},{name:"Brazil",region:"Americas",timezones:{"America/Araguaina":"-03:00","America/Bahia":"-03:00","America/Belem":"-03:00","America/Boa_Vista":"-04:00","America/Campo_Grande":"-04:00","America/Cuiaba":"-04:00","America/Eirunepe":"-05:00","America/Fortaleza":"-03:00","America/Maceio":"-03:00","America/Manaus":"-04:00","America/Noronha":"-02:00","America/Porto_Velho":"-04:00","America/Recife":"-03:00","America/Rio_Branco":"-05:00","America/Santarem":"-03:00","America/Sao_Paulo":"-03:00"},iso:{"alpha-2":"BR","alpha-3":"BRA",numeric:"076"},iban:{length:29},phone:["+55"],emoji:"🇧🇷",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BR.svg"},{name:"British Indian Ocean Territory",region:"Africa",timezones:{"Indian/Chagos":"+06:00"},iso:{"alpha-2":"IO","alpha-3":"IOT",numeric:"086"},phone:["+246"],emoji:"🇮🇴",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IO.svg"},{name:"Brunei Darussalam",region:"Asia",timezones:{"Asia/Brunei":"+08:00"},iso:{"alpha-2":"BN","alpha-3":"BRN",numeric:"096"},phone:["+673"],emoji:"🇧🇳",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BN.svg"},{name:"Bulgaria",region:"Europe",timezones:{"Europe/Sofia":"+03:00"},iso:{"alpha-2":"BG","alpha-3":"BGR",numeric:"100"},iban:{length:22},phone:["+359"],emoji:"🇧🇬",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BG.svg"},{name:"Burkina Faso",region:"Africa",timezones:{"Africa/Ouagadougou":"+00:00"},iso:{"alpha-2":"BF","alpha-3":"BFA",numeric:"854"},phone:["+226"],emoji:"🇧🇫",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BF.svg"},{name:"Burundi",region:"Africa",timezones:{"Africa/Bujumbura":"+02:00"},iso:{"alpha-2":"BI","alpha-3":"BDI",numeric:"108"},iban:{length:28},phone:["+257"],emoji:"🇧🇮",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BI.svg"},{name:"Cambodia",region:"Asia",timezones:{"Asia/Phnom_Penh":"+07:00"},iso:{"alpha-2":"KH","alpha-3":"KHM",numeric:"116"},phone:["+855"],emoji:"🇰🇭",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KH.svg"},{name:"Cameroon",region:"Africa",timezones:{"Africa/Douala":"+01:00"},iso:{"alpha-2":"CM","alpha-3":"CMR",numeric:"120"},phone:["+237"],emoji:"🇨🇲",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CM.svg"},{name:"Canada",region:"Americas",timezones:{"America/Atikokan":"-05:00","America/Blanc-Sablon":"-04:00","America/Cambridge_Bay":"-06:00","America/Creston":"-07:00","America/Dawson":"-07:00","America/Dawson_Creek":"-07:00","America/Edmonton":"-06:00","America/Fort_Nelson":"-07:00","America/Glace_Bay":"-03:00","America/Goose_Bay":"-03:00","America/Halifax":"-03:00","America/Inuvik":"-06:00","America/Iqaluit":"-04:00","America/Moncton":"-03:00","America/Rankin_Inlet":"-05:00","America/Regina":"-06:00","America/Resolute":"-05:00","America/St_Johns":"-02:30","America/Swift_Current":"-06:00","America/Toronto":"-04:00","America/Vancouver":"-07:00","America/Whitehorse":"-07:00","America/Winnipeg":"-05:00"},iso:{"alpha-2":"CA","alpha-3":"CAN",numeric:"124"},phone:["+1"],emoji:"🇨🇦",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CA.svg"},{name:"Cape Verde",region:"Africa",timezones:{"Atlantic/Cape_Verde":"-01:00"},iso:{"alpha-2":"CV","alpha-3":"CPV",numeric:"132"},phone:["+238"],emoji:"🇨🇻",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CV.svg"},{name:"Cayman Islands",region:"Americas",timezones:{"America/Cayman":"-05:00"},iso:{"alpha-2":"KY","alpha-3":"CYM",numeric:"136"},phone:["+1-345"],emoji:"🇰🇾",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KY.svg"},{name:"Central African Republic",region:"Africa",timezones:{"Africa/Bangui":"+01:00"},iso:{"alpha-2":"CF","alpha-3":"CAF",numeric:"140"},phone:["+236"],emoji:"🇨🇫",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CF.svg"},{name:"Chad",region:"Africa",timezones:{"Africa/Ndjamena":"+01:00"},iso:{"alpha-2":"TD","alpha-3":"TCD",numeric:"148"},phone:["+235"],emoji:"🇹🇩",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TD.svg"},{name:"Chile",region:"Americas",timezones:{"America/Punta_Arenas":"-03:00","America/Santiago":"-04:00","Pacific/Easter":"-06:00"},iso:{"alpha-2":"CL","alpha-3":"CHL",numeric:"152"},phone:["+56"],emoji:"🇨🇱",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CL.svg"},{name:"China",region:"Asia",timezones:{"Asia/Shanghai":"+08:00","Asia/Urumqi":"+06:00"},iso:{"alpha-2":"CN","alpha-3":"CHN",numeric:"156"},phone:["+86"],emoji:"🇨🇳",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CN.svg"},{name:"Christmas Island",region:"Oceania",timezones:{"Indian/Christmas":"+07:00"},iso:{"alpha-2":"CX","alpha-3":"CXR",numeric:"162"},phone:["+61"],emoji:"🇨🇽",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CX.svg"},{name:"Cocos (Keeling) Islands",region:"Oceania",timezones:{"Indian/Cocos":"+06:30"},iso:{"alpha-2":"CC","alpha-3":"CCK",numeric:"166"},phone:["+61"],emoji:"🇨🇨",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CC.svg"},{name:"Colombia",region:"Americas",timezones:{"America/Bogota":"-05:00"},iso:{"alpha-2":"CO","alpha-3":"COL",numeric:"170"},phone:["+57"],emoji:"🇨🇴",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CO.svg"},{name:"Comoros",region:"Africa",timezones:{"Indian/Comoro":"+03:00"},iso:{"alpha-2":"KM","alpha-3":"COM",numeric:"174"},phone:["+269"],emoji:"🇰🇲",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KM.svg"},{name:"Congo",region:"Africa",timezones:{"Africa/Brazzaville":"+01:00"},iso:{"alpha-2":"CG","alpha-3":"COG",numeric:"178"},phone:["+242"],emoji:"🇨🇬",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CG.svg"},{name:"Congo, the Democratic Republic of the",region:"Africa",timezones:{"Africa/Kinshasa":"+01:00","Africa/Lubumbashi":"+02:00"},iso:{"alpha-2":"CD","alpha-3":"COD",numeric:"180"},phone:["+243"],emoji:"🇨🇩",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CD.svg"},{name:"Cook Islands",region:"Oceania",timezones:{"Pacific/Rarotonga":"-10:00"},iso:{"alpha-2":"CK","alpha-3":"COK",numeric:"184"},phone:["+682"],emoji:"🇨🇰",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CK.svg"},{name:"Costa Rica",region:"Americas",timezones:{"America/Costa_Rica":"-06:00"},iso:{"alpha-2":"CR","alpha-3":"CRI",numeric:"188"},iban:{length:22},phone:["+506"],emoji:"🇨🇷",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CR.svg"},{name:"Croatia",region:"Europe",timezones:{"Europe/Zagreb":"+02:00"},iso:{"alpha-2":"HR","alpha-3":"HRV",numeric:"191"},iban:{length:21},phone:["+385"],emoji:"🇭🇷",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HR.svg"},{name:"Cuba",region:"Americas",timezones:{"America/Havana":"-04:00"},iso:{"alpha-2":"CU","alpha-3":"CUB",numeric:"192"},phone:["+53"],emoji:"🇨🇺",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CU.svg"},{name:"Curaçao",region:"Americas",timezones:{"America/Curacao":"-04:00"},iso:{"alpha-2":"CW","alpha-3":"CUW",numeric:"531"},phone:["+599"],emoji:"🇨🇼",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CW.svg"},{name:"Cyprus",region:"Asia",timezones:{"Asia/Famagusta":"+03:00","Asia/Nicosia":"+03:00"},iso:{"alpha-2":"CY","alpha-3":"CYP",numeric:"196"},iban:{length:28},phone:["+357"],emoji:"🇨🇾",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CY.svg"},{name:"Czech Republic",region:"Europe",timezones:{"Europe/Prague":"+02:00"},iso:{"alpha-2":"CZ","alpha-3":"CZE",numeric:"203"},iban:{length:24},phone:["+420"],emoji:"🇨🇿",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CZ.svg"},{name:"Côte d'Ivoire",region:"Africa",timezones:{"Africa/Abidjan":"+00:00"},iso:{"alpha-2":"CI","alpha-3":"CIV",numeric:"384"},phone:["+225"],emoji:"🇨🇮",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CI.svg"},{name:"Denmark",region:"Europe",timezones:{"Europe/Copenhagen":"+02:00"},iso:{"alpha-2":"DK","alpha-3":"DNK",numeric:"208"},iban:{length:18},phone:["+45"],emoji:"🇩🇰",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DK.svg"},{name:"Djibouti",region:"Africa",timezones:{"Africa/Djibouti":"+03:00"},iso:{"alpha-2":"DJ","alpha-3":"DJI",numeric:"262"},phone:["+253"],emoji:"🇩🇯",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DJ.svg"},{name:"Dominica",region:"Americas",timezones:{"America/Dominica":"-04:00"},iso:{"alpha-2":"DM","alpha-3":"DMA",numeric:"212"},phone:["+1-767"],emoji:"🇩🇲",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DM.svg"},{name:"Dominican Republic",region:"Americas",timezones:{"America/Santo_Domingo":"-04:00"},iso:{"alpha-2":"DO","alpha-3":"DOM",numeric:"214"},iban:{length:28},phone:["+1-809","+1-829"],emoji:"🇩🇴",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DO.svg"},{name:"Ecuador",region:"Americas",timezones:{"America/Guayaquil":"-05:00","Pacific/Galapagos":"-06:00"},iso:{"alpha-2":"EC","alpha-3":"ECU",numeric:"218"},phone:["+593"],emoji:"🇪🇨",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EC.svg"},{name:"Egypt",region:"Africa",timezones:{"Africa/Cairo":"+02:00"},iso:{"alpha-2":"EG","alpha-3":"EGY",numeric:"818"},iban:{length:29},phone:["+20"],emoji:"🇪🇬",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EG.svg"},{name:"El Salvador",region:"Americas",timezones:{"America/El_Salvador":"-06:00"},iso:{"alpha-2":"SV","alpha-3":"SLV",numeric:"222"},iban:{length:28},phone:["+503"],emoji:"🇸🇻",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SV.svg"},{name:"Equatorial Guinea",region:"Africa",timezones:{"Africa/Malabo":"+01:00"},iso:{"alpha-2":"GQ","alpha-3":"GNQ",numeric:"226"},phone:["+240"],emoji:"🇬🇶",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GQ.svg"},{name:"Eritrea",region:"Africa",timezones:{"Africa/Asmara":"+03:00"},iso:{"alpha-2":"ER","alpha-3":"ERI",numeric:"232"},phone:["+291"],emoji:"🇪🇷",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ER.svg"},{name:"Estonia",region:"Europe",timezones:{"Europe/Tallinn":"+03:00"},iso:{"alpha-2":"EE","alpha-3":"EST",numeric:"233"},iban:{length:20},phone:["+372"],emoji:"🇪🇪",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EE.svg"},{name:"Ethiopia",region:"Africa",timezones:{"Africa/Addis_Ababa":"+03:00"},iso:{"alpha-2":"ET","alpha-3":"ETH",numeric:"231"},phone:["+251"],emoji:"🇪🇹",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ET.svg"},{name:"Falkland Islands (Malvinas)",region:"Americas",timezones:{"Atlantic/Stanley":"-03:00"},iso:{"alpha-2":"FK","alpha-3":"FLK",numeric:"238"},phone:["+500"],emoji:"🇫🇰",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FK.svg"},{name:"Faroe Islands",region:"Europe",timezones:{"Atlantic/Faroe":"+01:00"},iso:{"alpha-2":"FO","alpha-3":"FRO",numeric:"234"},iban:{length:18},phone:["+298"],emoji:"🇫🇴",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FO.svg"},{name:"Fiji",region:"Oceania",timezones:{"Pacific/Fiji":"+12:00"},iso:{"alpha-2":"FJ","alpha-3":"FJI",numeric:"242"},phone:["+679"],emoji:"🇫🇯",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FJ.svg"},{name:"Finland",region:"Europe",timezones:{"Europe/Helsinki":"+03:00"},iso:{"alpha-2":"FI","alpha-3":"FIN",numeric:"246"},iban:{length:18},phone:["+358"],emoji:"🇫🇮",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FI.svg"},{name:"France",region:"Europe",timezones:{"Europe/Paris":"+02:00"},iso:{"alpha-2":"FR","alpha-3":"FRA",numeric:"250"},iban:{length:27},phone:["+33"],emoji:"🇫🇷",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FR.svg"},{name:"French Guiana",region:"Americas",timezones:{"America/Cayenne":"-03:00"},iso:{"alpha-2":"GF","alpha-3":"GUF",numeric:"254"},phone:["+594"],emoji:"🇬🇫",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GF.svg"},{name:"French Polynesia",region:"Oceania",timezones:{"Pacific/Gambier":"-09:00","Pacific/Marquesas":"-09:30","Pacific/Tahiti":"-10:00"},iso:{"alpha-2":"PF","alpha-3":"PYF",numeric:"258"},phone:["+689"],emoji:"🇵🇫",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PF.svg"},{name:"French Southern Territories",region:"Africa",timezones:{"Indian/Kerguelen":"+05:00"},iso:{"alpha-2":"TF","alpha-3":"ATF",numeric:"260"},phone:["+"],emoji:"🇹🇫",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TF.svg"},{name:"Gabon",region:"Africa",timezones:{"Africa/Libreville":"+01:00"},iso:{"alpha-2":"GA","alpha-3":"GAB",numeric:"266"},phone:["+241"],emoji:"🇬🇦",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GA.svg"},{name:"Gambia",region:"Africa",timezones:{"Africa/Banjul":"+00:00"},iso:{"alpha-2":"GM","alpha-3":"GMB",numeric:"270"},phone:["+220"],emoji:"🇬🇲",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GM.svg"},{name:"Georgia",region:"Asia",timezones:{"Asia/Tbilisi":"+04:00"},iso:{"alpha-2":"GE","alpha-3":"GEO",numeric:"268"},iban:{length:22},phone:["+995"],emoji:"🇬🇪",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GE.svg"},{name:"Germany",region:"Europe",timezones:{"Europe/Berlin":"+02:00","Europe/Busingen":"+02:00"},iso:{"alpha-2":"DE","alpha-3":"DEU",numeric:"276"},iban:{length:22},phone:["+49"],emoji:"🇩🇪",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DE.svg"},{name:"Ghana",region:"Africa",timezones:{"Africa/Accra":"+00:00"},iso:{"alpha-2":"GH","alpha-3":"GHA",numeric:"288"},phone:["+233"],emoji:"🇬🇭",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GH.svg"},{name:"Gibraltar",region:"Europe",timezones:{"Europe/Gibraltar":"+02:00"},iso:{"alpha-2":"GI","alpha-3":"GIB",numeric:"292"},iban:{length:23},phone:["+350"],emoji:"🇬🇮",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GI.svg"},{name:"Greece",region:"Europe",timezones:{"Europe/Athens":"+03:00"},iso:{"alpha-2":"GR","alpha-3":"GRC",numeric:"300"},iban:{length:27},phone:["+30"],emoji:"🇬🇷",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GR.svg"},{name:"Greenland",region:"Americas",timezones:{"America/Danmarkshavn":"+00:00","America/Nuuk":"-02:00","America/Scoresbysund":"+00:00","America/Thule":"-03:00"},iso:{"alpha-2":"GL","alpha-3":"GRL",numeric:"304"},iban:{length:18},phone:["+299"],emoji:"🇬🇱",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GL.svg"},{name:"Grenada",region:"Americas",timezones:{"America/Grenada":"-04:00"},iso:{"alpha-2":"GD","alpha-3":"GRD",numeric:"308"},phone:["+1-473"],emoji:"🇬🇩",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GD.svg"},{name:"Guadeloupe",region:"Americas",timezones:{"America/Guadeloupe":"-04:00"},iso:{"alpha-2":"GP","alpha-3":"GLP",numeric:"312"},phone:["+590"],emoji:"🇬🇵",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GP.svg"},{name:"Guam",region:"Oceania",timezones:{"Pacific/Guam":"+10:00"},iso:{"alpha-2":"GU","alpha-3":"GUM",numeric:"316"},phone:["+1-671"],emoji:"🇬🇺",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GU.svg"},{name:"Guatemala",region:"Americas",timezones:{"America/Guatemala":"-06:00"},iso:{"alpha-2":"GT","alpha-3":"GTM",numeric:"320"},iban:{length:28},phone:["+502"],emoji:"🇬🇹",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GT.svg"},{name:"Guernsey",region:"Europe",timezones:{"Europe/Guernsey":"+01:00"},iso:{"alpha-2":"GG","alpha-3":"GGY",numeric:"831"},phone:["+44-1481"],emoji:"🇬🇬",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GG.svg"},{name:"Guinea",region:"Africa",timezones:{"Africa/Conakry":"+00:00"},iso:{"alpha-2":"GN","alpha-3":"GIN",numeric:"324"},phone:["+224"],emoji:"🇬🇳",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GN.svg"},{name:"Guinea-Bissau",region:"Africa",timezones:{"Africa/Bissau":"+00:00"},iso:{"alpha-2":"GW","alpha-3":"GNB",numeric:"624"},phone:["+245"],emoji:"🇬🇼",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GW.svg"},{name:"Guyana",region:"Americas",timezones:{"America/Guyana":"-04:00"},iso:{"alpha-2":"GY","alpha-3":"GUY",numeric:"328"},phone:["+592"],emoji:"🇬🇾",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GY.svg"},{name:"Haiti",region:"Americas",timezones:{"America/Port-au-Prince":"-04:00"},iso:{"alpha-2":"HT","alpha-3":"HTI",numeric:"332"},phone:["+509"],emoji:"🇭🇹",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HT.svg"},{name:"Holy See (Vatican City State)",region:"Europe",timezones:{"Europe/Vatican":"+02:00"},iso:{"alpha-2":"VA","alpha-3":"VAT",numeric:"336"},iban:{length:22},phone:["+379"],emoji:"🇻🇦",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VA.svg"},{name:"Honduras",region:"Americas",timezones:{"America/Tegucigalpa":"-06:00"},iso:{"alpha-2":"HN","alpha-3":"HND",numeric:"340"},phone:["+504"],emoji:"🇭🇳",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HN.svg"},{name:"Hong Kong",region:"Asia",timezones:{"Asia/Hong_Kong":"+08:00"},iso:{"alpha-2":"HK","alpha-3":"HKG",numeric:"344"},phone:["+852"],emoji:"🇭🇰",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HK.svg"},{name:"Hungary",region:"Europe",timezones:{"Europe/Budapest":"+02:00"},iso:{"alpha-2":"HU","alpha-3":"HUN",numeric:"348"},iban:{length:28},phone:["+36"],emoji:"🇭🇺",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HU.svg"},{name:"Iceland",region:"Europe",timezones:{"Atlantic/Reykjavik":"+00:00"},iso:{"alpha-2":"IS","alpha-3":"ISL",numeric:"352"},iban:{length:26},phone:["+354"],emoji:"🇮🇸",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IS.svg"},{name:"India",region:"Asia",timezones:{"Asia/Kolkata":"+05:30"},iso:{"alpha-2":"IN","alpha-3":"IND",numeric:"356"},phone:["+91"],emoji:"🇮🇳",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IN.svg"},{name:"Indonesia",region:"Asia",timezones:{"Asia/Jakarta":"+07:00","Asia/Jayapura":"+09:00","Asia/Makassar":"+08:00","Asia/Pontianak":"+07:00"},iso:{"alpha-2":"ID","alpha-3":"IDN",numeric:"360"},phone:["+62"],emoji:"🇮🇩",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ID.svg"},{name:"Iran, Islamic Republic of",region:"Asia",timezones:{"Asia/Tehran":"+03:30"},iso:{"alpha-2":"IR","alpha-3":"IRN",numeric:"364"},phone:["+98"],emoji:"🇮🇷",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IR.svg"},{name:"Iraq",region:"Asia",timezones:{"Asia/Baghdad":"+03:00"},iso:{"alpha-2":"IQ","alpha-3":"IRQ",numeric:"368"},iban:{length:23},phone:["+964"],emoji:"🇮🇶",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IQ.svg"},{name:"Ireland",region:"Europe",timezones:{"Europe/Dublin":"+01:00"},iso:{"alpha-2":"IE","alpha-3":"IRL",numeric:"372"},iban:{length:22},phone:["+353"],emoji:"🇮🇪",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IE.svg"},{name:"Isle of Man",region:"Europe",timezones:{"Europe/Isle_of_Man":"+01:00"},iso:{"alpha-2":"IM","alpha-3":"IMN",numeric:"833"},phone:["+44-1624"],emoji:"🇮🇲",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IM.svg"},{name:"Israel",region:"Asia",timezones:{"Asia/Jerusalem":"+03:00"},iso:{"alpha-2":"IL","alpha-3":"ISR",numeric:"376"},iban:{length:23},phone:["+972"],emoji:"🇮🇱",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IL.svg"},{name:"Italy",region:"Europe",timezones:{"Europe/Rome":"+02:00"},iso:{"alpha-2":"IT","alpha-3":"ITA",numeric:"380"},iban:{length:27},phone:["+39"],emoji:"🇮🇹",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IT.svg"},{name:"Jamaica",region:"Americas",timezones:{"America/Jamaica":"-05:00"},iso:{"alpha-2":"JM","alpha-3":"JAM",numeric:"388"},phone:["+1-876"],emoji:"🇯🇲",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JM.svg"},{name:"Japan",region:"Asia",timezones:{"Asia/Tokyo":"+09:00"},iso:{"alpha-2":"JP","alpha-3":"JPN",numeric:"392"},phone:["+81"],emoji:"🇯🇵",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JP.svg"},{name:"Jersey",region:"Europe",timezones:{"Europe/Jersey":"+01:00"},iso:{"alpha-2":"JE","alpha-3":"JEY",numeric:"832"},phone:["+44-1534"],emoji:"🇯🇪",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JE.svg"},{name:"Jordan",region:"Asia",timezones:{"Asia/Amman":"+03:00"},iso:{"alpha-2":"JO","alpha-3":"JOR",numeric:"400"},iban:{length:30},phone:["+962"],emoji:"🇯🇴",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JO.svg"},{name:"Kazakhstan",region:"Asia",timezones:{"Asia/Almaty":"+06:00","Asia/Aqtau":"+05:00","Asia/Aqtobe":"+05:00","Asia/Atyrau":"+05:00","Asia/Oral":"+05:00","Asia/Qostanay":"+06:00","Asia/Qyzylorda":"+05:00"},iso:{"alpha-2":"KZ","alpha-3":"KAZ",numeric:"398"},iban:{length:20},phone:["+7"],emoji:"🇰🇿",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KZ.svg"},{name:"Kenya",region:"Africa",timezones:{"Africa/Nairobi":"+03:00"},iso:{"alpha-2":"KE","alpha-3":"KEN",numeric:"404"},phone:["+254"],emoji:"🇰🇪",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KE.svg"},{name:"Kiribati",region:"Oceania",timezones:{"Pacific/Kanton":"+13:00","Pacific/Kiritimati":"+14:00","Pacific/Tarawa":"+12:00"},iso:{"alpha-2":"KI","alpha-3":"KIR",numeric:"296"},phone:["+686"],emoji:"🇰🇮",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KI.svg"},{name:"North Korea",offical:"Democratic People's Republic of Korea",region:"Asia",timezones:{"Asia/Pyongyang":"+09:00"},iso:{"alpha-2":"KP","alpha-3":"PRK",numeric:"408"},phone:["+850"],emoji:"🇰🇵",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KP.svg"},{name:"South Korea",offical:"Republic of Korea",region:"Asia",timezones:{"Asia/Seoul":"+09:00"},iso:{"alpha-2":"KR","alpha-3":"KOR",numeric:"410"},phone:["+82"],emoji:"🇰🇷",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KR.svg"},{name:"Kosovo",region:"Europe",timezones:{"Europe/Pristina":"+02:00"},iso:{"alpha-2":"XK","alpha-3":"XXK",numeric:"926"},iban:{length:20},phone:["+383"],emoji:"🇽🇰",image:""},{name:"Kuwait",region:"Asia",timezones:{"Asia/Kuwait":"+03:00"},iso:{"alpha-2":"KW","alpha-3":"KWT",numeric:"414"},iban:{length:30},phone:["+965"],emoji:"🇰🇼",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KW.svg"},{name:"Kyrgyzstan",region:"Asia",timezones:{"Asia/Bishkek":"+06:00"},iso:{"alpha-2":"KG","alpha-3":"KGZ",numeric:"417"},phone:["+996"],emoji:"🇰🇬",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KG.svg"},{name:"Lao People's Democratic Republic",region:"Asia",timezones:{"Asia/Vientiane":"+07:00"},iso:{"alpha-2":"LA","alpha-3":"LAO",numeric:"418"},phone:["+856"],emoji:"🇱🇦",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LA.svg"},{name:"Latvia",region:"Europe",timezones:{"Europe/Riga":"+03:00"},iso:{"alpha-2":"LV","alpha-3":"LVA",numeric:"428"},iban:{length:21},phone:["+371"],emoji:"🇱🇻",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LV.svg"},{name:"Lebanon",region:"Asia",timezones:{"Asia/Beirut":"+03:00"},iso:{"alpha-2":"LB","alpha-3":"LBN",numeric:"422"},iban:{length:28},phone:["+961"],emoji:"🇱🇧",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LB.svg"},{name:"Lesotho",region:"Africa",timezones:{"Africa/Maseru":"+02:00"},iso:{"alpha-2":"LS","alpha-3":"LSO",numeric:"426"},phone:["+266"],emoji:"🇱🇸",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LS.svg"},{name:"Liberia",region:"Africa",timezones:{"Africa/Monrovia":"+00:00"},iso:{"alpha-2":"LR","alpha-3":"LBR",numeric:"430"},phone:["+231"],emoji:"🇱🇷",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LR.svg"},{name:"Libya",region:"Africa",timezones:{"Africa/Tripoli":"+02:00"},iso:{"alpha-2":"LY","alpha-3":"LBY",numeric:"434"},iban:{length:25},phone:["+218"],emoji:"🇱🇾",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LY.svg"},{name:"Liechtenstein",region:"Europe",timezones:{"Europe/Vaduz":"+02:00"},iso:{"alpha-2":"LI","alpha-3":"LIE",numeric:"438"},iban:{length:21},phone:["+423"],emoji:"🇱🇮",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LI.svg"},{name:"Lithuania",region:"Europe",timezones:{"Europe/Vilnius":"+03:00"},iso:{"alpha-2":"LT","alpha-3":"LTU",numeric:"440"},iban:{length:20},phone:["+370"],emoji:"🇱🇹",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LT.svg"},{name:"Luxembourg",region:"Europe",timezones:{"Europe/Luxembourg":"+02:00"},iso:{"alpha-2":"LU","alpha-3":"LUX",numeric:"442"},iban:{length:20},phone:["+352"],emoji:"🇱🇺",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LU.svg"},{name:"Macao",region:"Asia",timezones:{"Asia/Macau":"+08:00"},iso:{"alpha-2":"MO","alpha-3":"MAC",numeric:"446"},phone:["+853"],emoji:"🇲🇴",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MO.svg"},{name:"Madagascar",region:"Africa",timezones:{"Indian/Antananarivo":"+03:00"},iso:{"alpha-2":"MG","alpha-3":"MDG",numeric:"450"},phone:["+261"],emoji:"🇲🇬",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MG.svg"},{name:"Malawi",region:"Africa",timezones:{"Africa/Blantyre":"+02:00"},iso:{"alpha-2":"MW","alpha-3":"MWI",numeric:"454"},phone:["+265"],emoji:"🇲🇼",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MW.svg"},{name:"Malaysia",region:"Asia",timezones:{"Asia/Kuala_Lumpur":"+08:00","Asia/Kuching":"+08:00"},iso:{"alpha-2":"MY","alpha-3":"MYS",numeric:"458"},phone:["+60"],emoji:"🇲🇾",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MY.svg"},{name:"Maldives",region:"Asia",timezones:{"Indian/Maldives":"+05:00"},iso:{"alpha-2":"MV","alpha-3":"MDV",numeric:"462"},phone:["+960"],emoji:"🇲🇻",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MV.svg"},{name:"Mali",region:"Africa",timezones:{"Africa/Bamako":"+00:00"},iso:{"alpha-2":"ML","alpha-3":"MLI",numeric:"466"},phone:["+223"],emoji:"🇲🇱",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ML.svg"},{name:"Malta",region:"Europe",timezones:{"Europe/Malta":"+02:00"},iso:{"alpha-2":"MT","alpha-3":"MLT",numeric:"470"},iban:{length:31},phone:["+356"],emoji:"🇲🇹",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MT.svg"},{name:"Marshall Islands",region:"Oceania",timezones:{"Pacific/Kwajalein":"+12:00","Pacific/Majuro":"+12:00"},iso:{"alpha-2":"MH","alpha-3":"MHL",numeric:"584"},phone:["+692"],emoji:"🇲🇭",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MH.svg"},{name:"Martinique",region:"Americas",timezones:{"America/Martinique":"-04:00"},iso:{"alpha-2":"MQ","alpha-3":"MTQ",numeric:"474"},phone:["+596"],emoji:"🇲🇶",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MQ.svg"},{name:"Mauritania",region:"Africa",timezones:{"Africa/Nouakchott":"+00:00"},iso:{"alpha-2":"MR","alpha-3":"MRT",numeric:"478"},iban:{length:27},phone:["+222"],emoji:"🇲🇷",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MR.svg"},{name:"Mauritius",region:"Africa",timezones:{"Indian/Mauritius":"+04:00"},iso:{"alpha-2":"MU","alpha-3":"MUS",numeric:"480"},iban:{length:30},phone:["+230"],emoji:"🇲🇺",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MU.svg"},{name:"Mayotte",region:"Africa",timezones:{"Indian/Mayotte":"+03:00"},iso:{"alpha-2":"YT","alpha-3":"MYT",numeric:"175"},phone:["+262"],emoji:"🇾🇹",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/YT.svg"},{name:"Mexico",region:"Americas",timezones:{"America/Bahia_Banderas":"-06:00","America/Cancun":"-05:00","America/Chihuahua":"-06:00","America/Ciudad_Juarez":"-06:00","America/Hermosillo":"-07:00","America/Matamoros":"-05:00","America/Mazatlan":"-07:00","America/Merida":"-06:00","America/Mexico_City":"-06:00","America/Monterrey":"-06:00","America/Ojinaga":"-05:00","America/Tijuana":"-07:00"},iso:{"alpha-2":"MX","alpha-3":"MEX",numeric:"484"},phone:["+52"],emoji:"🇲🇽",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MX.svg"},{name:"Micronesia, Federated States of",region:"Oceania",timezones:{"Pacific/Chuuk":"+10:00","Pacific/Kosrae":"+11:00","Pacific/Pohnpei":"+11:00"},iso:{"alpha-2":"FM","alpha-3":"FSM",numeric:"583"},phone:["+691"],emoji:"🇫🇲",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FM.svg"},{name:"Moldova, Republic of",region:"Europe",timezones:{"Europe/Chisinau":"+03:00"},iso:{"alpha-2":"MD","alpha-3":"MDA",numeric:"498"},iban:{length:24},phone:["+373"],emoji:"🇲🇩",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MD.svg"},{name:"Monaco",region:"Europe",timezones:{"Europe/Monaco":"+02:00"},iso:{"alpha-2":"MC","alpha-3":"MCO",numeric:"492"},iban:{length:27},phone:["+377"],emoji:"🇲🇨",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MC.svg"},{name:"Mongolia",region:"Asia",timezones:{"Asia/Choibalsan":"+08:00","Asia/Hovd":"+07:00","Asia/Ulaanbaatar":"+08:00"},iso:{"alpha-2":"MN","alpha-3":"MNG",numeric:"496"},phone:["+976"],emoji:"🇲🇳",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MN.svg"},{name:"Montenegro",region:"Europe",timezones:{"Europe/Podgorica":"+02:00"},iso:{"alpha-2":"ME","alpha-3":"MNE",numeric:"499"},iban:{length:22},phone:["+382"],emoji:"🇲🇪",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ME.svg"},{name:"Montserrat",region:"Americas",timezones:{"America/Montserrat":"-04:00"},iso:{"alpha-2":"MS","alpha-3":"MSR",numeric:"500"},phone:["+1-664"],emoji:"🇲🇸",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MS.svg"},{name:"Morocco",region:"Africa",timezones:{"Africa/Casablanca":"+00:00","Africa/El_Aaiun":"+00:00"},iso:{"alpha-2":"MA","alpha-3":"MAR",numeric:"504"},phone:["+212"],emoji:"🇲🇦",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MA.svg"},{name:"Mozambique",region:"Africa",timezones:{"Africa/Maputo":"+02:00"},iso:{"alpha-2":"MZ","alpha-3":"MOZ",numeric:"508"},phone:["+258"],emoji:"🇲🇿",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MZ.svg"},{name:"Myanmar",region:"Asia",timezones:{"Asia/Yangon":"+06:30"},iso:{"alpha-2":"MM","alpha-3":"MMR",numeric:"104"},phone:["+95"],emoji:"🇲🇲",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MM.svg"},{name:"Namibia",region:"Africa",timezones:{"Africa/Windhoek":"+02:00"},iso:{"alpha-2":"NA","alpha-3":"NAM",numeric:"516"},phone:["+264"],emoji:"🇳🇦",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NA.svg"},{name:"Nauru",region:"Oceania",timezones:{"Pacific/Nauru":"+12:00"},iso:{"alpha-2":"NR","alpha-3":"NRU",numeric:"520"},phone:["+674"],emoji:"🇳🇷",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NR.svg"},{name:"Nepal",region:"Asia",timezones:{"Asia/Kathmandu":"+05:45"},iso:{"alpha-2":"NP","alpha-3":"NPL",numeric:"524"},phone:["+977"],emoji:"🇳🇵",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NP.svg"},{name:"Netherlands",region:"Europe",timezones:{"Europe/Amsterdam":"+02:00"},iso:{"alpha-2":"NL","alpha-3":"NLD",numeric:"528"},iban:{length:18},phone:["+31"],emoji:"🇳🇱",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NL.svg"},{name:"New Caledonia",region:"Oceania",timezones:{"Pacific/Noumea":"+11:00"},iso:{"alpha-2":"NC","alpha-3":"NCL",numeric:"540"},phone:["+687"],emoji:"🇳🇨",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NC.svg"},{name:"New Zealand",region:"Oceania",timezones:{"Pacific/Auckland":"+12:00","Pacific/Chatham":"+12:45"},iso:{"alpha-2":"NZ","alpha-3":"NZL",numeric:"554"},phone:["+64"],emoji:"🇳🇿",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NZ.svg"},{name:"Nicaragua",region:"Americas",timezones:{"America/Managua":"-06:00"},iso:{"alpha-2":"NI","alpha-3":"NIC",numeric:"558"},phone:["+505"],emoji:"🇳🇮",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NI.svg"},{name:"Niger",region:"Africa",timezones:{"Africa/Niamey":"+01:00"},iso:{"alpha-2":"NE","alpha-3":"NER",numeric:"562"},phone:["+227"],emoji:"🇳🇪",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NE.svg"},{name:"Nigeria",region:"Africa",timezones:{"Africa/Lagos":"+01:00"},iso:{"alpha-2":"NG","alpha-3":"NGA",numeric:"566"},phone:["+234"],emoji:"🇳🇬",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NG.svg"},{name:"Niue",region:"Oceania",timezones:{"Pacific/Niue":"-11:00"},iso:{"alpha-2":"NU","alpha-3":"NIU",numeric:"570"},phone:["+683"],emoji:"🇳🇺",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NU.svg"},{name:"Norfolk Island",region:"Oceania",timezones:{"Pacific/Norfolk":"+11:00"},iso:{"alpha-2":"NF","alpha-3":"NFK",numeric:"574"},phone:["+672"],emoji:"🇳🇫",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NF.svg"},{name:"North Macedonia, Republic of",region:"Europe",timezones:{"Europe/Skopje":"+02:00"},iso:{"alpha-2":"MK","alpha-3":"MKD",numeric:"807"},iban:{length:19},phone:["+389"],emoji:"🇲🇰",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MK.svg"},{name:"Northern Mariana Islands",region:"Oceania",timezones:{"Pacific/Saipan":"+10:00"},iso:{"alpha-2":"MP","alpha-3":"MNP",numeric:"580"},phone:["+1-670"],emoji:"🇲🇵",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MP.svg"},{name:"Norway",region:"Europe",timezones:{"Europe/Oslo":"+02:00"},iso:{"alpha-2":"NO","alpha-3":"NOR",numeric:"578"},iban:{length:15},phone:["+47"],emoji:"🇳🇴",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NO.svg"},{name:"Oman",region:"Asia",timezones:{"Asia/Muscat":"+04:00"},iso:{"alpha-2":"OM","alpha-3":"OMN",numeric:"512"},phone:["+968"],emoji:"🇴🇲",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/OM.svg"},{name:"Pakistan",region:"Asia",timezones:{"Asia/Karachi":"+05:00"},iso:{"alpha-2":"PK","alpha-3":"PAK",numeric:"586"},iban:{length:24},phone:["+92"],emoji:"🇵🇰",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PK.svg"},{name:"Palau",region:"Oceania",timezones:{"Pacific/Palau":"+09:00"},iso:{"alpha-2":"PW","alpha-3":"PLW",numeric:"585"},phone:["+680"],emoji:"🇵🇼",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PW.svg"},{name:"Palestine, State of",region:"Asia",timezones:{"Asia/Gaza":"+02:00","Asia/Hebron":"+02:00"},iso:{"alpha-2":"PS","alpha-3":"PSE",numeric:"275"},iban:{length:29},phone:["+970"],emoji:"🇵🇸",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PS.svg"},{name:"Panama",region:"Americas",timezones:{"America/Panama":"-05:00"},iso:{"alpha-2":"PA","alpha-3":"PAN",numeric:"591"},phone:["+507"],emoji:"🇵🇦",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PA.svg"},{name:"Papua New Guinea",region:"Oceania",timezones:{"Pacific/Bougainville":"+11:00","Pacific/Port_Moresby":"+10:00"},iso:{"alpha-2":"PG","alpha-3":"PNG",numeric:"598"},phone:["+675"],emoji:"🇵🇬",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PG.svg"},{name:"Paraguay",region:"Americas",timezones:{"America/Asuncion":"-04:00"},iso:{"alpha-2":"PY","alpha-3":"PRY",numeric:"600"},phone:["+595"],emoji:"🇵🇾",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PY.svg"},{name:"Peru",region:"Americas",timezones:{"America/Lima":"-05:00"},iso:{"alpha-2":"PE","alpha-3":"PER",numeric:"604"},phone:["+51"],emoji:"🇵🇪",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PE.svg"},{name:"Philippines",region:"Asia",timezones:{"Asia/Manila":"+08:00"},iso:{"alpha-2":"PH","alpha-3":"PHL",numeric:"608"},phone:["+63"],emoji:"🇵🇭",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PH.svg"},{name:"Pitcairn",region:"Oceania",timezones:{"Pacific/Pitcairn":"-08:00"},iso:{"alpha-2":"PN","alpha-3":"PCN",numeric:"612"},phone:["+870"],emoji:"🇵🇳",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PN.svg"},{name:"Poland",region:"Europe",timezones:{"Europe/Warsaw":"+02:00"},iso:{"alpha-2":"PL","alpha-3":"POL",numeric:"616"},iban:{length:28},phone:["+48"],emoji:"🇵🇱",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PL.svg"},{name:"Portugal",region:"Europe",timezones:{"Atlantic/Azores":"+00:00","Atlantic/Madeira":"+01:00","Europe/Lisbon":"+01:00"},iso:{"alpha-2":"PT","alpha-3":"PRT",numeric:"620"},iban:{length:25},phone:["+351"],emoji:"🇵🇹",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PT.svg"},{name:"Puerto Rico",region:"Americas",timezones:{"America/Puerto_Rico":"-04:00"},iso:{"alpha-2":"PR","alpha-3":"PRI",numeric:"630"},phone:["+1-787","+1-939"],emoji:"🇵🇷",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PR.svg"},{name:"Qatar",region:"Asia",timezones:{"Asia/Qatar":"+03:00"},iso:{"alpha-2":"QA","alpha-3":"QAT",numeric:"634"},iban:{length:29},phone:["+974"],emoji:"🇶🇦",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/QA.svg"},{name:"Romania",region:"Europe",timezones:{"Europe/Bucharest":"+03:00"},iso:{"alpha-2":"RO","alpha-3":"ROU",numeric:"642"},iban:{length:24},phone:["+40"],emoji:"🇷🇴",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RO.svg"},{name:"Russian Federation",region:"Europe",timezones:{"Asia/Anadyr":"+12:00","Asia/Barnaul":"+07:00","Asia/Chita":"+09:00","Asia/Irkutsk":"+08:00","Asia/Kamchatka":"+12:00","Asia/Khandyga":"+09:00","Asia/Krasnoyarsk":"+07:00","Asia/Magadan":"+11:00","Asia/Novokuznetsk":"+07:00","Asia/Novosibirsk":"+07:00","Asia/Omsk":"+06:00","Asia/Sakhalin":"+11:00","Asia/Srednekolymsk":"+11:00","Asia/Tomsk":"+07:00","Asia/Ust-Nera":"+10:00","Asia/Vladivostok":"+10:00","Asia/Yakutsk":"+09:00","Asia/Yekaterinburg":"+05:00","Europe/Astrakhan":"+04:00","Europe/Kaliningrad":"+02:00","Europe/Kirov":"+03:00","Europe/Moscow":"+03:00","Europe/Samara":"+04:00","Europe/Saratov":"+04:00","Europe/Ulyanovsk":"+04:00","Europe/Volgograd":"+03:00"},iso:{"alpha-2":"RU","alpha-3":"RUS",numeric:"643"},phone:["+7"],emoji:"🇷🇺",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RU.svg"},{name:"Rwanda",region:"Africa",timezones:{"Africa/Kigali":"+02:00"},iso:{"alpha-2":"RW","alpha-3":"RWA",numeric:"646"},phone:["+250"],emoji:"🇷🇼",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RW.svg"},{name:"Réunion",region:"Africa",timezones:{"Indian/Reunion":"+04:00"},iso:{"alpha-2":"RE","alpha-3":"REU",numeric:"638"},phone:["+262"],emoji:"🇷🇪",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RE.svg"},{name:"Saint Barthélemy",region:"Americas",timezones:{"America/St_Barthelemy":"-04:00"},iso:{"alpha-2":"BL","alpha-3":"BLM",numeric:"652"},phone:["+590"],emoji:"🇧🇱",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BL.svg"},{name:"Saint Helena, Ascension and Tristan da Cunha",region:"Africa",timezones:{"Atlantic/St_Helena":"+00:00"},iso:{"alpha-2":"SH","alpha-3":"SHN",numeric:"654"},phone:["+290"],emoji:"🇸🇭",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SH.svg"},{name:"Saint Kitts and Nevis",region:"Americas",timezones:{"America/St_Kitts":"-04:00"},iso:{"alpha-2":"KN","alpha-3":"KNA",numeric:"659"},phone:["+1-869"],emoji:"🇰🇳",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KN.svg"},{name:"Saint Lucia",region:"Americas",timezones:{"America/St_Lucia":"-04:00"},iso:{"alpha-2":"LC","alpha-3":"LCA",numeric:"662"},iban:{length:32},phone:["+1-758"],emoji:"🇱🇨",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LC.svg"},{name:"Saint Martin (French part)",region:"Americas",timezones:{"America/Marigot":"-04:00"},iso:{"alpha-2":"MF","alpha-3":"MAF",numeric:"663"},phone:["+590"],emoji:"🇲🇫",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MF.svg"},{name:"Saint Pierre and Miquelon",region:"Americas",timezones:{"America/Miquelon":"-02:00"},iso:{"alpha-2":"PM","alpha-3":"SPM",numeric:"666"},phone:["+508"],emoji:"🇵🇲",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PM.svg"},{name:"Saint Vincent and the Grenadines",region:"Americas",timezones:{"America/St_Vincent":"-04:00"},iso:{"alpha-2":"VC","alpha-3":"VCT",numeric:"670"},phone:["+1-784"],emoji:"🇻🇨",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VC.svg"},{name:"Samoa",region:"Oceania",timezones:{"Pacific/Apia":"+13:00"},iso:{"alpha-2":"WS","alpha-3":"WSM",numeric:"882"},phone:["+685"],emoji:"🇼🇸",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/WS.svg"},{name:"San Marino",region:"Europe",timezones:{"Europe/San_Marino":"+02:00"},iso:{"alpha-2":"SM","alpha-3":"SMR",numeric:"674"},iban:{length:27},phone:["+378"],emoji:"🇸🇲",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SM.svg"},{name:"Sao Tome and Principe",region:"Africa",timezones:{"Africa/Sao_Tome":"+00:00"},iso:{"alpha-2":"ST","alpha-3":"STP",numeric:"678"},iban:{length:25},phone:["+239"],emoji:"🇸🇹",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ST.svg"},{name:"Saudi Arabia",region:"Asia",timezones:{"Asia/Riyadh":"+03:00"},iso:{"alpha-2":"SA","alpha-3":"SAU",numeric:"682"},iban:{length:24},phone:["+966"],emoji:"🇸🇦",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SA.svg"},{name:"Senegal",region:"Africa",timezones:{"Africa/Dakar":"+00:00"},iso:{"alpha-2":"SN","alpha-3":"SEN",numeric:"686"},phone:["+221"],emoji:"🇸🇳",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SN.svg"},{name:"Serbia",region:"Europe",timezones:{"Europe/Belgrade":"+02:00"},iso:{"alpha-2":"RS","alpha-3":"SRB",numeric:"688"},iban:{length:22},phone:["+381"],emoji:"🇷🇸",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RS.svg"},{name:"Seychelles",region:"Africa",timezones:{"Indian/Mahe":"+04:00"},iso:{"alpha-2":"SC","alpha-3":"SYC",numeric:"690"},iban:{length:31},phone:["+248"],emoji:"🇸🇨",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SC.svg"},{name:"Sierra Leone",region:"Africa",timezones:{"Africa/Freetown":"+00:00"},iso:{"alpha-2":"SL","alpha-3":"SLE",numeric:"694"},phone:["+232"],emoji:"🇸🇱",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SL.svg"},{name:"Singapore",region:"Asia",timezones:{"Asia/Singapore":"+08:00"},iso:{"alpha-2":"SG","alpha-3":"SGP",numeric:"702"},phone:["+65"],emoji:"🇸🇬",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SG.svg"},{name:"Sint Maarten (Dutch part)",region:"Americas",timezones:{"America/Lower_Princes":"-04:00"},iso:{"alpha-2":"SX","alpha-3":"SXM",numeric:"534"},phone:["+599"],emoji:"🇸🇽",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SX.svg"},{name:"Slovakia",region:"Europe",timezones:{"Europe/Bratislava":"+02:00"},iso:{"alpha-2":"SK","alpha-3":"SVK",numeric:"703"},iban:{length:24},phone:["+421"],emoji:"🇸🇰",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SK.svg"},{name:"Slovenia",region:"Europe",timezones:{"Europe/Ljubljana":"+02:00"},iso:{"alpha-2":"SI","alpha-3":"SVN",numeric:"705"},iban:{length:19},phone:["+386"],emoji:"🇸🇮",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SI.svg"},{name:"Solomon Islands",region:"Oceania",timezones:{"Pacific/Guadalcanal":"+11:00"},iso:{"alpha-2":"SB","alpha-3":"SLB",numeric:"090"},phone:["+677"],emoji:"🇸🇧",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SB.svg"},{name:"Somalia",region:"Africa",timezones:{"Africa/Mogadishu":"+03:00"},iso:{"alpha-2":"SO","alpha-3":"SOM",numeric:"706"},phone:["+252"],emoji:"🇸🇴",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SO.svg"},{name:"South Africa",region:"Africa",timezones:{"Africa/Johannesburg":"+02:00"},iso:{"alpha-2":"ZA","alpha-3":"ZAF",numeric:"710"},phone:["+27"],emoji:"🇿🇦",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZA.svg"},{name:"South Georgia and the South Sandwich Islands",region:"Americas",timezones:{"Atlantic/South_Georgia":"-02:00"},iso:{"alpha-2":"GS","alpha-3":"SGS",numeric:"239"},phone:["+500"],emoji:"🇬🇸",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GS.svg"},{name:"South Sudan",region:"Africa",timezones:{"Africa/Juba":"+02:00"},iso:{"alpha-2":"SS","alpha-3":"SSD",numeric:"728"},phone:["+211"],emoji:"🇸🇸",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SS.svg"},{name:"Spain",region:"Europe",timezones:{"Africa/Ceuta":"+02:00","Atlantic/Canary":"+01:00","Europe/Madrid":"+02:00"},iso:{"alpha-2":"ES","alpha-3":"ESP",numeric:"724"},iban:{length:24},phone:["+34"],emoji:"🇪🇸",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ES.svg"},{name:"Sri Lanka",region:"Asia",timezones:{"Asia/Colombo":"+05:30"},iso:{"alpha-2":"LK","alpha-3":"LKA",numeric:"144"},phone:["+94"],emoji:"🇱🇰",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LK.svg"},{name:"Sudan",region:"Africa",timezones:{"Africa/Khartoum":"+02:00"},iso:{"alpha-2":"SD","alpha-3":"SDN",numeric:"729"},iban:{length:18},phone:["+249"],emoji:"🇸🇩",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SD.svg"},{name:"Suriname",region:"Americas",timezones:{"America/Paramaribo":"-03:00"},iso:{"alpha-2":"SR","alpha-3":"SUR",numeric:"740"},phone:["+597"],emoji:"🇸🇷",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SR.svg"},{name:"Svalbard and Jan Mayen",region:"Europe",timezones:{"Arctic/Longyearbyen":"+02:00"},iso:{"alpha-2":"SJ","alpha-3":"SJM",numeric:"744"},phone:["+47"],emoji:"🇸🇯",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SJ.svg"},{name:"Swaziland",region:"Africa",timezones:{"Africa/Mbabane":"+02:00"},iso:{"alpha-2":"SZ","alpha-3":"SWZ",numeric:"748"},phone:["+268"],emoji:"🇸🇿",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SZ.svg"},{name:"Sweden",region:"Europe",timezones:{"Europe/Stockholm":"+02:00"},iso:{"alpha-2":"SE","alpha-3":"SWE",numeric:"752"},iban:{length:24},phone:["+46"],emoji:"🇸🇪",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SE.svg"},{name:"Switzerland",region:"Europe",timezones:{"Europe/Zurich":"+02:00"},iso:{"alpha-2":"CH","alpha-3":"CHE",numeric:"756"},iban:{length:21},phone:["+41"],emoji:"🇨🇭",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CH.svg"},{name:"Syrian Arab Republic",region:"Asia",timezones:{"Asia/Damascus":"+03:00"},iso:{"alpha-2":"SY","alpha-3":"SYR",numeric:"760"},phone:["+963"],emoji:"🇸🇾",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SY.svg"},{name:"Taiwan, Province of China",region:"Asia",timezones:{"Asia/Taipei":"+08:00"},iso:{"alpha-2":"TW","alpha-3":"TWN",numeric:"158"},phone:["+886"],emoji:"🇹🇼",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TW.svg"},{name:"Tajikistan",region:"Asia",timezones:{"Asia/Dushanbe":"+05:00"},iso:{"alpha-2":"TJ","alpha-3":"TJK",numeric:"762"},phone:["+992"],emoji:"🇹🇯",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TJ.svg"},{name:"Tanzania, United Republic of",region:"Africa",timezones:{"Africa/Dar_es_Salaam":"+03:00"},iso:{"alpha-2":"TZ","alpha-3":"TZA",numeric:"834"},phone:["+255"],emoji:"🇹🇿",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TZ.svg"},{name:"Thailand",region:"Asia",timezones:{"Asia/Bangkok":"+07:00"},iso:{"alpha-2":"TH","alpha-3":"THA",numeric:"764"},phone:["+66"],emoji:"🇹🇭",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TH.svg"},{name:"Timor-Leste",region:"Asia",timezones:{"Asia/Dili":"+09:00"},iso:{"alpha-2":"TL","alpha-3":"TLS",numeric:"626"},iban:{length:23},phone:["+670"],emoji:"🇹🇱",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TL.svg"},{name:"Togo",region:"Africa",timezones:{"Africa/Lome":"+00:00"},iso:{"alpha-2":"TG","alpha-3":"TGO",numeric:"768"},phone:["+228"],emoji:"🇹🇬",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TG.svg"},{name:"Tokelau",region:"Oceania",timezones:{"Pacific/Fakaofo":"+13:00"},iso:{"alpha-2":"TK","alpha-3":"TKL",numeric:"772"},phone:["+690"],emoji:"🇹🇰",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TK.svg"},{name:"Tonga",region:"Oceania",timezones:{"Pacific/Tongatapu":"+13:00"},iso:{"alpha-2":"TO","alpha-3":"TON",numeric:"776"},phone:["+676"],emoji:"🇹🇴",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TO.svg"},{name:"Trinidad and Tobago",region:"Americas",timezones:{"America/Port_of_Spain":"-04:00"},iso:{"alpha-2":"TT","alpha-3":"TTO",numeric:"780"},phone:["+1-868"],emoji:"🇹🇹",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TT.svg"},{name:"Tunisia",region:"Africa",timezones:{"Africa/Tunis":"+01:00"},iso:{"alpha-2":"TN","alpha-3":"TUN",numeric:"788"},iban:{length:24},phone:["+216"],emoji:"🇹🇳",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TN.svg"},{name:"Turkey",region:"Asia",timezones:{"Europe/Istanbul":"+03:00"},iso:{"alpha-2":"TR","alpha-3":"TUR",numeric:"792"},iban:{length:26},phone:["+90"],emoji:"🇹🇷",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TR.svg"},{name:"Turkmenistan",region:"Asia",timezones:{"Asia/Ashgabat":"+05:00"},iso:{"alpha-2":"TM","alpha-3":"TKM",numeric:"795"},phone:["+993"],emoji:"🇹🇲",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TM.svg"},{name:"Turks and Caicos Islands",region:"Americas",timezones:{"America/Grand_Turk":"-04:00"},iso:{"alpha-2":"TC","alpha-3":"TCA",numeric:"796"},phone:["+1-649"],emoji:"🇹🇨",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TC.svg"},{name:"Tuvalu",region:"Oceania",timezones:{"Pacific/Funafuti":"+12:00"},iso:{"alpha-2":"TV","alpha-3":"TUV",numeric:"798"},phone:["+688"],emoji:"🇹🇻",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TV.svg"},{name:"Uganda",region:"Africa",timezones:{"Africa/Kampala":"+03:00"},iso:{"alpha-2":"UG","alpha-3":"UGA",numeric:"800"},phone:["+256"],emoji:"🇺🇬",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UG.svg"},{name:"Ukraine",region:"Europe",timezones:{"Europe/Kyiv":"+03:00","Europe/Simferopol":"+03:00"},iso:{"alpha-2":"UA","alpha-3":"UKR",numeric:"804"},iban:{length:29},phone:["+380"],emoji:"🇺🇦",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UA.svg"},{name:"United Arab Emirates",region:"Asia",timezones:{"Asia/Dubai":"+04:00"},iso:{"alpha-2":"AE","alpha-3":"ARE",numeric:"784"},iban:{length:23},phone:["+971"],emoji:"🇦🇪",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AE.svg"},{name:"United Kingdom",region:"Europe",timezones:{"Europe/London":"+01:00"},iso:{"alpha-2":"GB","alpha-3":"GBR",numeric:"826"},iban:{length:22},phone:["+44"],emoji:"🇬🇧",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GB.svg"},{name:"United States",region:"Americas",timezones:{"America/Adak":"-09:00","America/Anchorage":"-08:00","America/Boise":"-06:00","America/Chicago":"-05:00","America/Denver":"-06:00","America/Detroit":"-04:00","America/Indiana/Indianapolis":"-04:00","America/Indiana/Knox":"-05:00","America/Indiana/Marengo":"-04:00","America/Indiana/Petersburg":"-04:00","America/Indiana/Tell_City":"-05:00","America/Indiana/Vevay":"-04:00","America/Indiana/Vincennes":"-04:00","America/Indiana/Winamac":"-04:00","America/Juneau":"-08:00","America/Kentucky/Louisville":"-04:00","America/Kentucky/Monticello":"-04:00","America/Los_Angeles":"-07:00","America/Menominee":"-05:00","America/Metlakatla":"-08:00","America/New_York":"-04:00","America/Nome":"-08:00","America/North_Dakota/Beulah":"-05:00","America/North_Dakota/Center":"-05:00","America/North_Dakota/New_Salem":"-05:00","America/Phoenix":"-07:00","America/Sitka":"-08:00","America/Yakutat":"-08:00","Pacific/Honolulu":"-10:00"},iso:{"alpha-2":"US","alpha-3":"USA",numeric:"840"},phone:["+1"],emoji:"🇺🇸",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/US.svg"},{name:"United States Minor Outlying Islands",region:"Oceania",timezones:{"Pacific/Midway":"-11:00","Pacific/Wake":"+12:00"},iso:{"alpha-2":"UM","alpha-3":"UMI",numeric:"581"},phone:["+1"],emoji:"🇺🇲",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UM.svg"},{name:"Uruguay",region:"Americas",timezones:{"America/Montevideo":"-03:00"},iso:{"alpha-2":"UY","alpha-3":"URY",numeric:"858"},phone:["+598"],emoji:"🇺🇾",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UY.svg"},{name:"Uzbekistan",region:"Asia",timezones:{"Asia/Samarkand":"+05:00","Asia/Tashkent":"+05:00"},iso:{"alpha-2":"UZ","alpha-3":"UZB",numeric:"860"},phone:["+998"],emoji:"🇺🇿",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UZ.svg"},{name:"Vanuatu",region:"Oceania",timezones:{"Pacific/Efate":"+11:00"},iso:{"alpha-2":"VU","alpha-3":"VUT",numeric:"548"},phone:["+678"],emoji:"🇻🇺",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VU.svg"},{name:"Venezuela, Bolivarian Republic of",region:"Americas",timezones:{"America/Caracas":"-04:00"},iso:{"alpha-2":"VE","alpha-3":"VEN",numeric:"862"},phone:["+58"],emoji:"🇻🇪",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VE.svg"},{name:"Viet Nam",region:"Asia",timezones:{"Asia/Ho_Chi_Minh":"+07:00"},iso:{"alpha-2":"VN","alpha-3":"VNM",numeric:"704"},phone:["+84"],emoji:"🇻🇳",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VN.svg"},{name:"Virgin Islands, British",region:"Americas",timezones:{"America/Tortola":"-04:00"},iso:{"alpha-2":"VG","alpha-3":"VGB",numeric:"092"},iban:{length:24},phone:["+1-284"],emoji:"🇻🇬",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VG.svg"},{name:"Virgin Islands, U.S.",region:"Americas",timezones:{"America/St_Thomas":"-04:00"},iso:{"alpha-2":"VI","alpha-3":"VIR",numeric:"850"},phone:["+1-340"],emoji:"🇻🇮",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VI.svg"},{name:"Wallis and Futuna",region:"Oceania",timezones:{"Pacific/Wallis":"+12:00"},iso:{"alpha-2":"WF","alpha-3":"WLF",numeric:"876"},phone:["+681"],emoji:"🇼🇫",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/WF.svg"},{name:"Yemen",region:"Asia",timezones:{"Asia/Aden":"+03:00"},iso:{"alpha-2":"YE","alpha-3":"YEM",numeric:"887"},phone:["+967"],emoji:"🇾🇪",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/YE.svg"},{name:"Zambia",region:"Africa",timezones:{"Africa/Lusaka":"+02:00"},iso:{"alpha-2":"ZM","alpha-3":"ZMB",numeric:"894"},phone:["+260"],emoji:"🇿🇲",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZM.svg"},{name:"Zimbabwe",region:"Africa",timezones:{"Africa/Harare":"+02:00"},iso:{"alpha-2":"ZW","alpha-3":"ZWE",numeric:"716"},phone:["+263"],emoji:"🇿🇼",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZW.svg"},{name:"Åland Islands",region:"Europe",timezones:{"Europe/Mariehamn":"+03:00"},iso:{"alpha-2":"AX","alpha-3":"ALA",numeric:"248"},phone:["+358-18"],emoji:"🇦🇽",image:"https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AX.svg"}];

var useCountry = function useCountry() {
  var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (timezone === '' || !timezone) {
    return null;
  }
  var country = countryData.find(function (i) {
    return i.timezones[timezone];
  });
  return _objectSpread2(_objectSpread2({}, country), {}, {
    code: country.iso['alpha-2']
  });
};

function useOutsideClick(ref, func) {
  React__default.useEffect(function () {
    function handleClickOutside(event) {
      var exempt = false;
      if (ref.current !== undefined && ref.current !== null) {
        if (Object.keys(event.target.dataset).length !== 0) {
          var _JSON$parse, _event$target$dataset;
          if ((_JSON$parse = JSON.parse((_event$target$dataset = event.target.dataset) === null || _event$target$dataset === void 0 ? void 0 : _event$target$dataset.module)) !== null && _JSON$parse !== void 0 && _JSON$parse.outsideClickExemption) {
            var _JSON$parse2, _ref$current, _JSON$parse3;
            if (((_JSON$parse2 = JSON.parse((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getAttribute('data-module'))) === null || _JSON$parse2 === void 0 ? void 0 : _JSON$parse2.id) === ((_JSON$parse3 = JSON.parse(event.target.dataset.module)) === null || _JSON$parse3 === void 0 ? void 0 : _JSON$parse3.id)) {
              exempt = true;
            }
          }
        }
        if (!exempt) {
          if (ref.current && !ref.current.contains(event.target)) {
            func();
          }
        }
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
}

var metadata = {"version":4,"country_calling_codes":{"1":["US","AG","AI","AS","BB","BM","BS","CA","DM","DO","GD","GU","JM","KN","KY","LC","MP","MS","PR","SX","TC","TT","VC","VG","VI"],"7":["RU","KZ"],"20":["EG"],"27":["ZA"],"30":["GR"],"31":["NL"],"32":["BE"],"33":["FR"],"34":["ES"],"36":["HU"],"39":["IT","VA"],"40":["RO"],"41":["CH"],"43":["AT"],"44":["GB","GG","IM","JE"],"45":["DK"],"46":["SE"],"47":["NO","SJ"],"48":["PL"],"49":["DE"],"51":["PE"],"52":["MX"],"53":["CU"],"54":["AR"],"55":["BR"],"56":["CL"],"57":["CO"],"58":["VE"],"60":["MY"],"61":["AU","CC","CX"],"62":["ID"],"63":["PH"],"64":["NZ"],"65":["SG"],"66":["TH"],"81":["JP"],"82":["KR"],"84":["VN"],"86":["CN"],"90":["TR"],"91":["IN"],"92":["PK"],"93":["AF"],"94":["LK"],"95":["MM"],"98":["IR"],"211":["SS"],"212":["MA","EH"],"213":["DZ"],"216":["TN"],"218":["LY"],"220":["GM"],"221":["SN"],"222":["MR"],"223":["ML"],"224":["GN"],"225":["CI"],"226":["BF"],"227":["NE"],"228":["TG"],"229":["BJ"],"230":["MU"],"231":["LR"],"232":["SL"],"233":["GH"],"234":["NG"],"235":["TD"],"236":["CF"],"237":["CM"],"238":["CV"],"239":["ST"],"240":["GQ"],"241":["GA"],"242":["CG"],"243":["CD"],"244":["AO"],"245":["GW"],"246":["IO"],"247":["AC"],"248":["SC"],"249":["SD"],"250":["RW"],"251":["ET"],"252":["SO"],"253":["DJ"],"254":["KE"],"255":["TZ"],"256":["UG"],"257":["BI"],"258":["MZ"],"260":["ZM"],"261":["MG"],"262":["RE","YT"],"263":["ZW"],"264":["NA"],"265":["MW"],"266":["LS"],"267":["BW"],"268":["SZ"],"269":["KM"],"290":["SH","TA"],"291":["ER"],"297":["AW"],"298":["FO"],"299":["GL"],"350":["GI"],"351":["PT"],"352":["LU"],"353":["IE"],"354":["IS"],"355":["AL"],"356":["MT"],"357":["CY"],"358":["FI","AX"],"359":["BG"],"370":["LT"],"371":["LV"],"372":["EE"],"373":["MD"],"374":["AM"],"375":["BY"],"376":["AD"],"377":["MC"],"378":["SM"],"380":["UA"],"381":["RS"],"382":["ME"],"383":["XK"],"385":["HR"],"386":["SI"],"387":["BA"],"389":["MK"],"420":["CZ"],"421":["SK"],"423":["LI"],"500":["FK"],"501":["BZ"],"502":["GT"],"503":["SV"],"504":["HN"],"505":["NI"],"506":["CR"],"507":["PA"],"508":["PM"],"509":["HT"],"590":["GP","BL","MF"],"591":["BO"],"592":["GY"],"593":["EC"],"594":["GF"],"595":["PY"],"596":["MQ"],"597":["SR"],"598":["UY"],"599":["CW","BQ"],"670":["TL"],"672":["NF"],"673":["BN"],"674":["NR"],"675":["PG"],"676":["TO"],"677":["SB"],"678":["VU"],"679":["FJ"],"680":["PW"],"681":["WF"],"682":["CK"],"683":["NU"],"685":["WS"],"686":["KI"],"687":["NC"],"688":["TV"],"689":["PF"],"690":["TK"],"691":["FM"],"692":["MH"],"850":["KP"],"852":["HK"],"853":["MO"],"855":["KH"],"856":["LA"],"880":["BD"],"886":["TW"],"960":["MV"],"961":["LB"],"962":["JO"],"963":["SY"],"964":["IQ"],"965":["KW"],"966":["SA"],"967":["YE"],"968":["OM"],"970":["PS"],"971":["AE"],"972":["IL"],"973":["BH"],"974":["QA"],"975":["BT"],"976":["MN"],"977":["NP"],"992":["TJ"],"993":["TM"],"994":["AZ"],"995":["GE"],"996":["KG"],"998":["UZ"]},"countries":{"AC":["247","00","(?:[01589]\\d|[46])\\d{4}",[5,6]],"AD":["376","00","(?:1|6\\d)\\d{7}|[135-9]\\d{5}",[6,8,9],[["(\\d{3})(\\d{3})","$1 $2",["[135-9]"]],["(\\d{4})(\\d{4})","$1 $2",["1"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]]],"AE":["971","00","(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",[5,6,7,8,9,10,11,12],[["(\\d{3})(\\d{2,9})","$1 $2",["60|8"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[236]|[479][2-8]"],"0$1"],["(\\d{3})(\\d)(\\d{5})","$1 $2 $3",["[479]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"]],"0"],"AF":["93","00","[2-7]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],"0"],"AG":["1","011","(?:268|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([457]\\d{6})$|1","268$1",0,"268"],"AI":["1","011","(?:264|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2457]\\d{6})$|1","264$1",0,"264"],"AL":["355","00","(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",[6,7,8,9],[["(\\d{3})(\\d{3,4})","$1 $2",["80|9"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["[23578]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["6"],"0$1"]],"0"],"AM":["374","00","(?:[1-489]\\d|55|60|77)\\d{6}",[8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[89]0"],"0 $1"],["(\\d{3})(\\d{5})","$1 $2",["2|3[12]"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["1|47"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[3-9]"],"0$1"]],"0"],"AO":["244","00","[29]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[29]"]]]],"AR":["54","00","(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",[10,11],[["(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",1],["(\\d)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",0,"$1 $2 $3-$4"],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 15-$3-$4",["91"],"0$1",0,"$1 $2 $3-$4"],["(\\d{3})(\\d{3})(\\d{5})","$1-$2-$3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9"],"0$1",0,"$1 $2 $3-$4"]],"0",0,"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?","9$1"],"AS":["1","011","(?:[58]\\d\\d|684|900)\\d{7}",[10],0,"1",0,"([267]\\d{6})$|1","684$1",0,"684"],"AT":["43","00","1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",[4,5,6,7,8,9,10,11,12,13],[["(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],["(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],["(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],"0$1"],["(\\d{4})(\\d{3,9})","$1 $2",["[2-467]|5[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],"0"],"AU":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",[5,6,7,8,9,10,12],[["(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|4"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]]],"0",0,"(183[12])|0",0,0,0,[["(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",[9]],["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,["163\\d{2,6}",[5,6,7,8,9]],["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"AW":["297","00","(?:[25-79]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[25-9]"]]]],"AX":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",[5,6,7,8,9,10,11,12],0,"0",0,0,0,0,"18",0,"00"],"AZ":["994","00","365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365[45]|46","1[28]|2|365(?:4|5[02])|46"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[13-9]"],"0$1"]],"0"],"BA":["387","00","6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],"0"],"BB":["1","011","(?:246|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","246$1",0,"246"],"BD":["880","00","[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{4,6})","$1-$2",["31[5-8]|[459]1"],"0$1"],["(\\d{3})(\\d{3,7})","$1-$2",["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],"0$1"],["(\\d{4})(\\d{3,6})","$1-$2",["[13-9]|22"],"0$1"],["(\\d)(\\d{7,8})","$1-$2",["2"],"0$1"]],"0"],"BE":["32","00","4\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[239]|4[23]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[15-8]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4"],"0$1"]],"0"],"BF":["226","00","[025-7]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[025-7]"]]]],"BG":["359","00","00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",[6,7,8,9,12],[["(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["43[1-6]|70[1-9]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],"0"],"BH":["973","00","[136-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[13679]|8[02-4679]"]]]],"BI":["257","00","(?:[267]\\d|31)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2367]"]]]],"BJ":["229","00","[24-689]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-689]"]]]],"BL":["590","00","590\\d{6}|(?:69|80|9\\d)\\d{7}",[9],0,"0",0,0,0,0,0,[["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]],"BM":["1","011","(?:441|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","441$1",0,"441"],"BN":["673","00","[2-578]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-578]"]]]],"BO":["591","00(?:1\\d)?","(?:[2-467]\\d\\d|8001)\\d{5}",[8,9],[["(\\d)(\\d{7})","$1 $2",["[23]|4[46]"]],["(\\d{8})","$1",["[67]"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["8"]]],"0",0,"0(1\\d)?"],"BQ":["599","00","(?:[34]1|7\\d)\\d{5}",[7],0,0,0,0,0,0,"[347]"],"BR":["55","00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)","(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",[8,9,10,11],[["(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)","4(?:02|37)0|[34]00"]],["(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)"],["(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)"]],"0",0,"(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2"],"BS":["1","011","(?:242|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([3-8]\\d{6})$|1","242$1",0,"242"],"BT":["975","00","[17]\\d{7}|[2-8]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]]],"BW":["267","00","(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",[7,8,10],[["(\\d{2})(\\d{5})","$1 $2",["90"]],["(\\d{3})(\\d{4})","$1 $2",["[24-6]|3[15-9]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37]"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["8"]]]],"BY":["375","810","(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3})","$1 $2",["800"],"8 $1"],["(\\d{3})(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"],["(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],"8 0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:[56]|7[467])|2[1-3]"],"8 0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-4]"],"8 0$1"],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["[89]"],"8 $1"]],"8",0,"0|80?",0,0,0,0,"8~10"],"BZ":["501","00","(?:0800\\d|[2-8])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],["(\\d)(\\d{3})(\\d{4})(\\d{3})","$1-$2-$3-$4",["0"]]]],"CA":["1","011","(?:[2-8]\\d|90)\\d{8}|3\\d{6}",[7,10],0,"1",0,0,0,0,0,[["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",[10]],["",[10]],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",[10]],["900[2-9]\\d{6}",[10]],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",[10]],0,["310\\d{4}",[7]],0,["600[2-9]\\d{6}",[10]]]],"CC":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10,12],0,"0",0,"([59]\\d{7})$|0","8$1",0,0,[["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",[9]],["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"CD":["243","00","[189]\\d{8}|[1-68]\\d{6}",[7,9],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[1-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]"],"0$1"]],"0"],"CF":["236","00","(?:[27]\\d{3}|8776)\\d{4}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[278]"]]]],"CG":["242","00","222\\d{6}|(?:0\\d|80)\\d{7}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]]]],"CH":["41","00","8\\d{11}|[2-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]|81"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["8"],"0$1"]],"0"],"CI":["225","00","[02]\\d{9}",[10],[["(\\d{2})(\\d{2})(\\d)(\\d{5})","$1 $2 $3 $4",["2"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3 $4",["0"]]]],"CK":["682","00","[2-578]\\d{4}",[5],[["(\\d{2})(\\d{3})","$1 $2",["[2-578]"]]]],"CL":["56","(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0","12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",[9,10,11],[["(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-36]"],"($1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9[2-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],"($1)"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]]],"CM":["237","00","[26]\\d{8}|88\\d{6,7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["88"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]|88"]]]],"CN":["86","00|1(?:[12]\\d|79)\\d\\d00","1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",[7,8,9,10,11,12],[["(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]","(?:10|2[0-57-9])(?:10|9[56])","10(?:10|9[56])|2[0-57-9](?:100|9[56])"],"0$1"],["(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]","(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]","85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])","85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1",1],["(\\d{3})(\\d{7,8})","$1 $2",["9"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",1]],"0",0,"(1(?:[12]\\d|79)\\d\\d)|0",0,0,0,0,"00"],"CO":["57","00(?:4(?:[14]4|56)|[579])","(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",[10,11],[["(\\d{3})(\\d{7})","$1 $2",["6"],"($1)"],["(\\d{3})(\\d{7})","$1 $2",["3[0-357]|91"]],["(\\d)(\\d{3})(\\d{7})","$1-$2-$3",["1"],"0$1",0,"$1 $2 $3"]],"0",0,"0(4(?:[14]4|56)|[579])?"],"CR":["506","00","(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",[8,10],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[3-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]"]]],0,0,"(19(?:0[0-2468]|1[09]|20|66|77|99))"],"CU":["53","119","[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}",[6,7,8,10],[["(\\d{2})(\\d{4,6})","$1 $2",["2[1-4]|[34]"],"(0$1)"],["(\\d)(\\d{6,7})","$1 $2",["7"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["[56]"],"0$1"],["(\\d{3})(\\d{7})","$1 $2",["8"],"0$1"]],"0"],"CV":["238","0","(?:[2-59]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2-589]"]]]],"CW":["599","00","(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[3467]"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["9[4-8]"]]],0,0,0,0,0,"[69]"],"CX":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10,12],0,"0",0,"([59]\\d{7})$|0","8$1",0,0,[["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",[9]],["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[016-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"CY":["357","00","(?:[279]\\d|[58]0)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[257-9]"]]]],"CZ":["420","00","(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["96"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]]],"DE":["49","00","[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",[4,5,6,7,8,9,10,11,12,13,14,15],[["(\\d{2})(\\d{3,13})","$1 $2",["3[02]|40|[68]9"],"0$1"],["(\\d{3})(\\d{3,12})","$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1","2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],"0$1"],["(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["138"],"0$1"],["(\\d{5})(\\d{2,10})","$1 $2",["3"],"0$1"],["(\\d{3})(\\d{5,11})","$1 $2",["181"],"0$1"],["(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["1(?:3|80)|9"],"0$1"],["(\\d{3})(\\d{7,8})","$1 $2",["1[67]"],"0$1"],["(\\d{3})(\\d{7,12})","$1 $2",["8"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["185","1850","18500"],"0$1"],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["18[68]"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["15[0568]"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["15[1279]"],"0$1"],["(\\d{3})(\\d{8})","$1 $2",["18"],"0$1"],["(\\d{3})(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"],"0$1"],["(\\d{4})(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"],"0$1"],["(\\d{3})(\\d{2})(\\d{8})","$1 $2 $3",["15"],"0$1"]],"0"],"DJ":["253","00","(?:2\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[27]"]]]],"DK":["45","00","[2-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-9]"]]]],"DM":["1","011","(?:[58]\\d\\d|767|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","767$1",0,"767"],"DO":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"8001|8[024]9"],"DZ":["213","00","(?:[1-4]|[5-79]\\d|80)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"],"0$1"]],"0"],"EC":["593","00","1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",[8,9,10,11],[["(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[2-7]"],"(0$1)",0,"$1-$2-$3"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],"0"],"EE":["372","00","8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]],["(\\d{4})(\\d{3,4})","$1 $2",["[45]|8(?:00|[1-49])","[45]|8(?:00[1-9]|[1-49])"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"EG":["20","00","[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",[8,9,10],[["(\\d)(\\d{7,8})","$1 $2",["[23]"],"0$1"],["(\\d{2})(\\d{6,7})","$1 $2",["1[35]|[4-6]|8[2468]|9[235-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{8})","$1 $2",["1"],"0$1"]],"0"],"EH":["212","00","[5-8]\\d{8}",[9],0,"0",0,0,0,0,"528[89]"],"ER":["291","00","[178]\\d{6}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[178]"],"0$1"]],"0"],"ES":["34","00","[5-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"]]]],"ET":["251","00","(?:11|[2-579]\\d)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-579]"],"0$1"]],"0"],"FI":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",[5,6,7,8,9,10,11,12],[["(\\d)(\\d{4,9})","$1 $2",["[2568][1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"],["(\\d{3})(\\d{3,7})","$1 $2",["[12]00|[368]|70[07-9]"],"0$1"],["(\\d{2})(\\d{4,8})","$1 $2",["[1245]|7[135]"],"0$1"],["(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"]],"0",0,0,0,0,"1[03-79]|[2-9]",0,"00"],"FJ":["679","0(?:0|52)","45\\d{5}|(?:0800\\d|[235-9])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1 $2",["[235-9]|45"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]],0,0,0,0,0,0,0,"00"],"FK":["500","00","[2-7]\\d{4}",[5]],"FM":["691","00","(?:[39]\\d\\d|820)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[389]"]]]],"FO":["298","00","[2-9]\\d{5}",[6],[["(\\d{6})","$1",["[2-9]"]]],0,0,"(10(?:01|[12]0|88))"],"FR":["33","00","[1-9]\\d{8}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],"0"],"GA":["241","00","(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",[7,8],[["(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["11|[67]"],"0$1"]],0,0,"0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})","$1"],"GB":["44","00","[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",[7,9,10],[["(\\d{3})(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["845","8454","84546","845464"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["800"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["1(?:[2-69][02-9]|[78])"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[25]|7(?:0|6[02-9])","[25]|7(?:0|6(?:[03-9]|2[356]))"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[1389]"],"0$1"]],"0",0,0,0,0,0,[["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",[9,10]],["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",[10]],["56\\d{8}",[10]]],0," x"],"GD":["1","011","(?:473|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","473$1",0,"473"],"GE":["995","00","(?:[3-57]\\d\\d|800)\\d{6}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["32"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[57]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"]],"0"],"GF":["594","00","[56]94\\d{6}|(?:80|9\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[56]|9[47]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[89]"],"0$1"]],"0"],"GG":["44","00","(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",[7,9,10],0,"0",0,"([25-9]\\d{5})$|0","1481$1",0,0,[["1481[25-9]\\d{5}",[10]],["7(?:(?:781|839)\\d|911[17])\\d{5}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",[10]],["56\\d{8}",[10]]]],"GH":["233","00","(?:[235]\\d{3}|800)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"]],"0"],"GI":["350","00","(?:[25]\\d|60)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["2"]]]],"GL":["299","00","(?:19|[2-689]\\d|70)\\d{4}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["19|[2-9]"]]]],"GM":["220","00","[2-9]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"GN":["224","00","722\\d{6}|(?:3|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[67]"]]]],"GP":["590","00","590\\d{6}|(?:69|80|9\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0",0,0,0,0,0,[["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"],["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]],"GQ":["240","00","222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{6})","$1 $2",["[89]"]]]],"GR":["30","00","5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",[10,11,12],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],["(\\d{4})(\\d{6})","$1 $2",["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2689]"]],["(\\d{3})(\\d{3,4})(\\d{5})","$1 $2 $3",["8"]]]],"GT":["502","00","(?:1\\d{3}|[2-7])\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"GU":["1","011","(?:[58]\\d\\d|671|900)\\d{7}",[10],0,"1",0,"([3-9]\\d{6})$|1","671$1",0,"671"],"GW":["245","00","[49]\\d{8}|4\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["40"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"]]]],"GY":["592","001","9008\\d{3}|(?:[2-467]\\d\\d|862)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-46-9]"]]]],"HK":["852","00(?:30|5[09]|[126-9]?)","8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",[5,6,7,8,9,11],[["(\\d{3})(\\d{2,5})","$1 $2",["900","9003"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{3})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],0,0,0,0,0,0,0,"00"],"HN":["504","00","8\\d{10}|[237-9]\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1-$2",["[237-9]"]]]],"HR":["385","00","(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",[6,7,8,9],[["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["6[01]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{4})(\\d{3})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-5]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"]],"0"],"HT":["509","00","(?:[2-489]\\d|55)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[2-589]"]]]],"HU":["36","00","[235-7]\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"06 $1"]],"06"],"ID":["62","00[89]","(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",[7,8,9,10,11,12,13],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],["(\\d{2})(\\d{5,9})","$1 $2",["2[124]|[36]1"],"(0$1)"],["(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],["(\\d{3})(\\d{5,8})","$1 $2",["[2-79]"],"(0$1)"],["(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"],"0$1"],["(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],["(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"]],"0"],"IE":["353","00","(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"],"(0$1)"],["(\\d{3})(\\d{5})","$1 $2",["[45]0"],"(0$1)"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2569]|4[1-69]|7[14]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["81"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[78]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["4"],"(0$1)"],["(\\d{2})(\\d)(\\d{3})(\\d{4})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"IL":["972","0(?:0|1[2-9])","1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",[7,8,9,10,11,12],[["(\\d{4})(\\d{3})","$1-$2",["125"]],["(\\d{4})(\\d{2})(\\d{2})","$1-$2-$3",["121"]],["(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1-$2-$3",["12"]],["(\\d{4})(\\d{6})","$1-$2",["159"]],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})","$1-$2 $3-$4",["15"]]],"0"],"IM":["44","00","1624\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"([25-8]\\d{5})$|0","1624$1",0,"74576|(?:16|7[56])24"],"IN":["91","00","(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",[8,9,10,11,12,13],[["(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],0,1],["(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],0,1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-7]|80[2-46]","11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],"0$1",1],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]","1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",1],["(\\d{5})(\\d{5})","$1 $2",["[6-9]"],"0$1",1],["(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["1(?:6|8[06])","1(?:6|8[06]0)"],0,1],["(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18"],0,1]],"0"],"IO":["246","00","3\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["3"]]]],"IQ":["964","00","(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"IR":["98","00","[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",[4,5,6,7,10],[["(\\d{4,5})","$1",["96"],"0$1"],["(\\d{2})(\\d{4,5})","$1 $2",["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"],"0$1"]],"0"],"IS":["354","00|1(?:0(?:01|[12]0)|100)","(?:38\\d|[4-9])\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]],0,0,0,0,0,0,0,"00"],"IT":["39","00","0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",[6,7,8,9,10,11],[["(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],["(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],["(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],["(\\d{4})(\\d{4})","$1 $2",["894"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["1(?:44|[679])|[378]"]],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]|14"]],["(\\d{2})(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["3"]]],0,0,0,0,0,0,[["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"],["3[1-9]\\d{8}|3[2-9]\\d{7}",[9,10]],["80(?:0\\d{3}|3)\\d{3}",[6,9]],["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",[6,8,9,10]],["1(?:78\\d|99)\\d{6}",[9,10]],0,0,0,["55\\d{8}",[10]],["84(?:[08]\\d{3}|[17])\\d{3}",[6,9]]]],"JE":["44","00","1534\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"([0-24-8]\\d{5})$|0","1534$1",0,0,[["1534[0-24-8]\\d{5}"],["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"],["80(?:07(?:35|81)|8901)\\d{4}"],["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"],["701511\\d{4}"],0,["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"],["56\\d{8}"]]],"JM":["1","011","(?:[58]\\d\\d|658|900)\\d{7}",[10],0,"1",0,0,0,0,"658|876"],"JO":["962","00","(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],["(\\d{3})(\\d{5,6})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["70"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"JP":["81","010","00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",[8,9,10,11,12,13,14,15,16,17],[["(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],["(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["[36]|4(?:2[09]|7[01])","[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],"0$1"],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[289][2-9]|5[3-9]|7[2-4679]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[257-9]"],"0$1"]],"0",0,"(000[259]\\d{6})$|(?:(?:003768)0?)|0","$1"],"KE":["254","000","(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",[7,8,9,10],[["(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[17]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0"],"KG":["996","00","8\\d{9}|[235-9]\\d{8}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["3(?:1[346]|[24-79])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-79]|88"],"0$1"],["(\\d{3})(\\d{3})(\\d)(\\d{2,3})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"KH":["855","00[14-9]","1\\d{9}|[1-9]\\d{7,8}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"KI":["686","00","(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",[5,8],0,"0"],"KM":["269","00","[3478]\\d{6}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[3478]"]]]],"KN":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","869$1",0,"869"],"KP":["850","00|99","85\\d{6}|(?:19\\d|[2-7])\\d{7}",[8,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"]],"0"],"KR":["82","00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))","00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",[5,6,8,9,10,11,12,13,14],[["(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1"],["(\\d{4})(\\d{4})","$1-$2",["1"]],["(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60|8"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1"]],"0",0,"0(8(?:[1-46-8]|5\\d\\d))?"],"KW":["965","00","18\\d{5}|(?:[2569]\\d|41)\\d{6}",[7,8],[["(\\d{4})(\\d{3,4})","$1 $2",["[169]|2(?:[235]|4[1-35-9])|52"]],["(\\d{3})(\\d{5})","$1 $2",["[245]"]]]],"KY":["1","011","(?:345|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","345$1",0,"345"],"KZ":["7","810","(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",[10,14],0,"8",0,0,0,0,"33|7",0,"8~10"],"LA":["856","00","[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30[013-9]"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[23]"],"0$1"]],"0"],"LB":["961","00","[27-9]\\d{7}|[13-9]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27-9]"]]],"0"],"LC":["1","011","(?:[58]\\d\\d|758|900)\\d{7}",[10],0,"1",0,"([2-8]\\d{6})$|1","758$1",0,"758"],"LI":["423","00","[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",[7,9],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2379]|8(?:0[09]|7)","[2379]|8(?:0(?:02|9)|7)"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["69"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],"0",0,"(1001)|0"],"LK":["94","00","[1-9]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-689]"],"0$1"]],"0"],"LR":["231","00","(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[4-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23578]"],"0$1"]],"0"],"LS":["266","00","(?:[256]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2568]"]]]],"LT":["370","00","(?:[3469]\\d|52|[78]0)\\d{6}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["52[0-7]"],"(8-$1)",1],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"8 $1",1],["(\\d{2})(\\d{6})","$1 $2",["37|4(?:[15]|6[1-8])"],"(8-$1)",1],["(\\d{3})(\\d{5})","$1 $2",["[3-6]"],"(8-$1)",1]],"8",0,"[08]"],"LU":["352","00","35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",[4,5,6,7,8,9,10,11],[["(\\d{2})(\\d{3})","$1 $2",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20[2-689]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["80[01]|90[015]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})","$1 $2 $3 $4",["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]],0,0,"(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"],"LV":["371","00","(?:[268]\\d|90)\\d{6}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[269]|8[01]"]]]],"LY":["218","00","[2-9]\\d{8}",[9],[["(\\d{2})(\\d{7})","$1-$2",["[2-9]"],"0$1"]],"0"],"MA":["212","00","[5-8]\\d{8}",[9],[["(\\d{5})(\\d{4})","$1-$2",["5(?:29|38)","5(?:29[1289]|389)","529(?:1[1-46-9]|2[013-8]|90)|5(?:298|389)[0-46-9]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5[45]"],"0$1"],["(\\d{4})(\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9]|9)|892","5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"],"0$1"],["(\\d{2})(\\d{7})","$1-$2",["8"],"0$1"],["(\\d{3})(\\d{6})","$1-$2",["[5-7]"],"0$1"]],"0",0,0,0,0,0,[["5293[01]\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|9[0-289])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[0189]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"],["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[017]\\d|2[0-2]|6[0-8]|8[0-3]))\\d{6}"],["80\\d{7}"],["89\\d{7}"],0,0,0,0,["592(?:4[0-2]|93)\\d{4}"]]],"MC":["377","00","(?:[3489]|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[389]"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"]],"0"],"MD":["373","00","(?:[235-7]\\d|[89]0)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[25-7]"],"0$1"]],"0"],"ME":["382","00","(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"0$1"]],"0"],"MF":["590","00","590\\d{6}|(?:69|80|9\\d)\\d{7}",[9],0,"0",0,0,0,0,0,[["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]],"MG":["261","00","[23]\\d{8}",[9],[["(\\d{2})(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",["[23]"],"0$1"]],"0",0,"([24-9]\\d{6})$|0","20$1"],"MH":["692","011","329\\d{4}|(?:[256]\\d|45)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1-$2",["[2-6]"]]],"1"],"MK":["389","00","[2-578]\\d{7}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2|34[47]|4(?:[37]7|5[47]|64)"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[347]"],"0$1"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"],"0$1"]],"0"],"ML":["223","00","[24-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]]],"MM":["95","00","1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",[6,7,8,9,10],[["(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[4-7]|8[1-35]"],"0$1"],["(\\d)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92"],"0$1"],["(\\d)(\\d{5})(\\d{4})","$1 $2 $3",["9"],"0$1"]],"0"],"MN":["976","001","[12]\\d{7,9}|[5-9]\\d{7}",[8,9,10],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[5-9]"]],["(\\d{3})(\\d{5,6})","$1 $2",["[12]2[1-3]"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["[12](?:27|3[2-8]|4[2-68]|5[1-4689])","[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["[12]"],"0$1"]],"0"],"MO":["853","00","0800\\d{3}|(?:28|[68]\\d)\\d{6}",[7,8],[["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{4})(\\d{4})","$1 $2",["[268]"]]]],"MP":["1","011","[58]\\d{9}|(?:67|90)0\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","670$1",0,"670"],"MQ":["596","00","596\\d{6}|(?:69|80|9\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"MR":["222","00","(?:[2-4]\\d\\d|800)\\d{5}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-48]"]]]],"MS":["1","011","(?:[58]\\d\\d|664|900)\\d{7}",[10],0,"1",0,"([34]\\d{6})$|1","664$1",0,"664"],"MT":["356","00","3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2357-9]"]]]],"MU":["230","0(?:0|[24-7]0|3[03])","(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[2-46]|8[013]"]],["(\\d{4})(\\d{4})","$1 $2",["[57]"]],["(\\d{5})(\\d{5})","$1 $2",["8"]]],0,0,0,0,0,0,0,"020"],"MV":["960","0(?:0|19)","(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",[7,10],[["(\\d{3})(\\d{4})","$1-$2",["[34679]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"]]],0,0,0,0,0,0,0,"00"],"MW":["265","00","(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",[7,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[137-9]"],"0$1"]],"0"],"MX":["52","0[09]","1(?:(?:[27]2|44|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}",[10,11],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"],0,1],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 $3 $4",["1(?:33|5[56]|81)"],0,1],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 $3 $4",["1"],0,1]],"01",0,"0(?:[12]|4[45])|1",0,0,0,0,"00"],"MY":["60","00","1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1-$2 $3",["1(?:[02469]|[378][1-9]|53)|8","1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3-$4",["1(?:[367]|80)"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2 $3",["15"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2 $3",["1"],"0$1"]],"0"],"MZ":["258","00","(?:2|8\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-79]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"NA":["264","00","[68]\\d{7,8}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["87"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"NC":["687","00","(?:050|[2-57-9]\\d\\d)\\d{3}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[02-57-9]"]]]],"NE":["227","00","[027-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["08"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[089]|2[013]|7[047]"]]]],"NF":["672","00","[13]\\d{5}",[6],[["(\\d{2})(\\d{4})","$1 $2",["1[0-3]"]],["(\\d)(\\d{5})","$1 $2",["[13]"]]],0,0,"([0-258]\\d{4})$","3$1"],"NG":["234","009","(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",[7,8,10,11,12,13,14],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["78"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|9(?:0[3-9]|[1-9])"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[3-7]|8[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]"],"0$1"],["(\\d{3})(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]"],"0$1"]],"0"],"NI":["505","00","(?:1800|[25-8]\\d{3})\\d{4}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[125-8]"]]]],"NL":["31","00","(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",[5,6,7,8,9,10,11],[["(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],["(\\d)(\\d{8})","$1 $2",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-578]|91"],"0$1"],["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3",["9"],"0$1"]],"0"],"NO":["47","00","(?:0|[2-9]\\d{3})\\d{4}",[5,8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["8"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]"]]],0,0,0,0,0,"[02-689]|7[0-8]"],"NP":["977","00","(?:1\\d|9)\\d{9}|[1-9]\\d{7}",[8,10,11],[["(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],["(\\d{2})(\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],"0$1"],["(\\d{3})(\\d{7})","$1-$2",["9"]]],"0"],"NR":["674","00","(?:444|(?:55|8\\d)\\d|666)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[4-68]"]]]],"NU":["683","00","(?:[47]|888\\d)\\d{3}",[4,7],[["(\\d{3})(\\d{4})","$1 $2",["8"]]]],"NZ":["64","0(?:0|161)","[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,8})","$1 $2",["8[1-579]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["50[036-8]|[89]0","50(?:[0367]|88)|[89]0"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["24|[346]|7[2-57-9]|9[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|[59]|80"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1|2[028]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:[169]|7[0-35-9])|7|86"],"0$1"]],"0",0,0,0,0,0,0,"00"],"OM":["968","00","(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",[7,8,9],[["(\\d{3})(\\d{4,6})","$1 $2",["[58]"]],["(\\d{2})(\\d{6})","$1 $2",["2"]],["(\\d{4})(\\d{4})","$1 $2",["[179]"]]]],"PA":["507","00","(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",[7,8,10,11],[["(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],["(\\d{4})(\\d{4})","$1-$2",["[68]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]]],"PE":["51","00|19(?:1[124]|77|90)00","(?:[14-8]|9\\d)\\d{7}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["80"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["1"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[4-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],"0",0,0,0,0,0,0,"00"," Anexo "],"PF":["689","00","4\\d{5}(?:\\d{2})?|8\\d{7,8}",[6,8,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4|8[7-9]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"PG":["675","00|140[1-3]","(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["18|[2-69]|85"]],["(\\d{4})(\\d{4})","$1 $2",["[78]"]]],0,0,0,0,0,0,0,"00"],"PH":["63","00","(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",[6,8,9,10,11,12,13],[["(\\d)(\\d{5})","$1 $2",["2"],"(0$1)"],["(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)"],["(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|8[2-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1"]]],"0"],"PK":["92","00","122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2,7})","$1 $2 $3",["[89]0"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["1"]],["(\\d{3})(\\d{6,7})","$1 $2",["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])","9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],"(0$1)"],["(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],"(0$1)"],["(\\d{5})(\\d{5})","$1 $2",["58"],"(0$1)"],["(\\d{3})(\\d{7})","$1 $2",["3"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[24-9]"],"(0$1)"]],"0"],"PL":["48","00","(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",[6,7,8,9,10],[["(\\d{5})","$1",["19"]],["(\\d{3})(\\d{3})","$1 $2",["11|20|64"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1","(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[2-8]|[2-7]|8[1-79]|9[145]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["8"]]]],"PM":["508","00","[45]\\d{5}|(?:708|80\\d)\\d{6}",[6,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[45]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"PR":["1","011","(?:[589]\\d\\d|787)\\d{7}",[10],0,"1",0,0,0,0,"787|939"],"PS":["970","00","[2489]2\\d{6}|(?:1\\d|5)\\d{8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2489]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["5"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"PT":["351","00","1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["16|[236-9]"]]]],"PW":["680","01[12]","(?:[24-8]\\d\\d|345|900)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"PY":["595","00","59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],["(\\d{3})(\\d{4,5})","$1 $2",["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["87"]],["(\\d{3})(\\d{6})","$1 $2",["9(?:[5-79]|8[1-6])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],"0"],"QA":["974","00","800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",[7,8,9,11],[["(\\d{3})(\\d{4})","$1 $2",["2[16]|8"]],["(\\d{4})(\\d{4})","$1 $2",["[3-7]"]]]],"RE":["262","00","(?:26|[689]\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2689]"],"0$1"]],"0",0,0,0,0,0,[["26(?:2\\d\\d|3(?:0\\d|1[0-5]))\\d{4}"],["69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-27]|8[0-8]|9[0-479]))\\d{4}"],["80\\d{7}"],["89[1-37-9]\\d{6}"],0,0,0,0,["9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}"],["8(?:1[019]|2[0156]|84|90)\\d{6}"]]],"RO":["40","00","(?:[2378]\\d|90)\\d{7}|[23]\\d{5}",[6,9],[["(\\d{3})(\\d{3})","$1 $2",["2[3-6]","2[3-6]\\d9"],"0$1"],["(\\d{2})(\\d{4})","$1 $2",["219|31"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[237-9]"],"0$1"]],"0",0,0,0,0,0,0,0," int "],"RS":["381","00","38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",[6,7,8,9,10,11,12],[["(\\d{3})(\\d{3,9})","$1 $2",["(?:2[389]|39)0|[7-9]"],"0$1"],["(\\d{2})(\\d{5,10})","$1 $2",["[1-36]"],"0$1"]],"0"],"RU":["7","810","8\\d{13}|[347-9]\\d{9}",[10,14],[["(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],"8 ($1)",1],["(\\d{5})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[349]|8(?:[02-7]|1[1-8])"],"8 ($1)",1],["(\\d{4})(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3 $4",["8"],"8 ($1)"]],"8",0,0,0,0,"3[04-689]|[489]",0,"8~10"],"RW":["250","00","(?:06|[27]\\d\\d|[89]00)\\d{6}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"]]],"0"],"SA":["966","00","92\\d{7}|(?:[15]|8\\d)\\d{8}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["9"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["81"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],"0"],"SB":["677","0[01]","(?:[1-6]|[7-9]\\d\\d)\\d{4}",[5,7],[["(\\d{2})(\\d{5})","$1 $2",["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]],"SC":["248","010|0[0-2]","800\\d{4}|(?:[249]\\d|64)\\d{5}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]|9[57]"]]],0,0,0,0,0,0,0,"00"],"SD":["249","00","[19]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[19]"],"0$1"]],"0"],"SE":["46","00","(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{4})","$1-$2",["9(?:00|39|44|9)"],"0$1",0,"$1 $2"],["(\\d{2})(\\d{3})(\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3"],["(\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{2,3})(\\d{3})","$1-$2 $3",["9(?:00|39|44)"],"0$1",0,"$1 $2 $3"],["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3 $4"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["10|7"],"0$1",0,"$1 $2 $3 $4"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["[26]"],"0$1",0,"$1 $2 $3 $4 $5"]],"0"],"SG":["65","0[0-3]\\d","(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",[8,10,11],[["(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:0[1-8]|[1-9])"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],["(\\d{4})(\\d{4})(\\d{3})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"SH":["290","00","(?:[256]\\d|8)\\d{3}",[4,5],0,0,0,0,0,0,"[256]"],"SI":["386","00|10(?:22|66|88|99)","[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",[5,6,7,8],[["(\\d{2})(\\d{3,6})","$1 $2",["8[09]|9"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["59|8"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-57]"],"(0$1)"]],"0",0,0,0,0,0,0,"00"],"SJ":["47","00","0\\d{4}|(?:[489]\\d|79)\\d{6}",[5,8],0,0,0,0,0,0,"79"],"SK":["421","00","[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",[6,7,9],[["(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",["21"],"0$1"],["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1","[3-5][1-8]1[67]"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"]],"0"],"SL":["232","00","(?:[237-9]\\d|66)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[236-9]"],"(0$1)"]],"0"],"SM":["378","00","(?:0549|[5-7]\\d)\\d{6}",[8,10],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],["(\\d{4})(\\d{6})","$1 $2",["0"]]],0,0,"([89]\\d{5})$","0549$1"],"SN":["221","00","(?:[378]\\d|93)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]]]],"SO":["252","00","[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",[6,7,8,9],[["(\\d{2})(\\d{4})","$1 $2",["8[125]"]],["(\\d{6})","$1",["[134]"]],["(\\d)(\\d{6})","$1 $2",["[15]|2[0-79]|3[0-46-8]|4[0-7]"]],["(\\d)(\\d{7})","$1 $2",["(?:2|90)4|[67]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[348]|64|79|90"]],["(\\d{2})(\\d{5,7})","$1 $2",["1|28|6[0-35-9]|77|9[2-9]"]]],"0"],"SR":["597","00","(?:[2-5]|68|[78]\\d)\\d{5}",[6,7],[["(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["56"]],["(\\d{3})(\\d{3})","$1-$2",["[2-5]"]],["(\\d{3})(\\d{4})","$1-$2",["[6-8]"]]]],"SS":["211","00","[19]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[19]"],"0$1"]],"0"],"ST":["239","00","(?:22|9\\d)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[29]"]]]],"SV":["503","00","[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",[7,8,11],[["(\\d{3})(\\d{4})","$1 $2",["[89]"]],["(\\d{4})(\\d{4})","$1 $2",["[267]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]]],"SX":["1","011","7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"(5\\d{6})$|1","721$1",0,"721"],"SY":["963","00","[1-39]\\d{8}|[1-5]\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-5]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1",1]],"0"],"SZ":["268","00","0800\\d{4}|(?:[237]\\d|900)\\d{6}",[8,9],[["(\\d{4})(\\d{4})","$1 $2",["[0237]"]],["(\\d{5})(\\d{4})","$1 $2",["9"]]]],"TA":["290","00","8\\d{3}",[4],0,0,0,0,0,0,"8"],"TC":["1","011","(?:[58]\\d\\d|649|900)\\d{7}",[10],0,"1",0,"([2-479]\\d{6})$|1","649$1",0,"649"],"TD":["235","00|16","(?:22|[69]\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2679]"]]],0,0,0,0,0,0,0,"00"],"TG":["228","00","[279]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[279]"]]]],"TH":["66","00[1-9]","(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",[8,9,10,13],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"TJ":["992","810","[0-57-9]\\d{8}",[9],[["(\\d{6})(\\d)(\\d{2})","$1 $2 $3",["331","3317"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["44[04]|[34]7"]],["(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3[1-5]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[0-57-9]"]]],0,0,0,0,0,0,0,"8~10"],"TK":["690","00","[2-47]\\d{3,6}",[4,5,6,7]],"TL":["670","00","7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[2-489]|70"]],["(\\d{4})(\\d{4})","$1 $2",["7"]]]],"TM":["993","810","[1-6]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"],"(8 $1)"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-5]"],"(8 $1)"],["(\\d{2})(\\d{6})","$1 $2",["6"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],"TN":["216","00","[2-57-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]"]]]],"TO":["676","00","(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",[5,7],[["(\\d{2})(\\d{3})","$1-$2",["[2-4]|50|6[09]|7[0-24-69]|8[05]"]],["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{3})(\\d{4})","$1 $2",["[5-9]"]]]],"TR":["90","00","4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",[7,10,12,13],[["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[01589]|90"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:[0-59]|61)","5(?:[0-59]|616)","5(?:[0-59]|6161)"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24][1-8]|3[1-9]"],"(0$1)",1],["(\\d{3})(\\d{3})(\\d{6,7})","$1 $2 $3",["80"],"0$1",1]],"0"],"TT":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-46-8]\\d{6})$|1","868$1",0,"868"],"TV":["688","00","(?:2|7\\d\\d|90)\\d{4}",[5,6,7],[["(\\d{2})(\\d{3})","$1 $2",["2"]],["(\\d{2})(\\d{4})","$1 $2",["90"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"TW":["886","0(?:0[25-79]|19)","[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",[7,8,9,10,11],[["(\\d{2})(\\d)(\\d{4})","$1 $2 $3",["202"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[258]0"],"0$1"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]","[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,5})","$1 $2 $3",["7"],"0$1"]],"0",0,0,0,0,0,0,0,"#"],"TZ":["255","00[056]","(?:[25-8]\\d|41|90)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[24]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["5"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"],"0$1"]],"0"],"UA":["380","00","[89]\\d{9}|[3-9]\\d{8}",[9,10],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]","6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])","3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|89|9[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0",0,0,0,0,0,0,"0~0"],"UG":["256","00[057]","800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",[9],[["(\\d{4})(\\d{5})","$1 $2",["202","2024"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[27-9]|4(?:6[45]|[7-9])"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[34]"],"0$1"]],"0"],"US":["1","011","[2-9]\\d{9}|3\\d{6}",[10],[["(\\d{3})(\\d{4})","$1-$2",["310"],0,1],["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",["[2-9]"],0,1,"$1-$2-$3"]],"1",0,0,0,0,0,[["5056(?:[0-35-9]\\d|4[46])\\d{4}|(?:4722|505[2-57-9]|983[29])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[0-2]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"],[""],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]],"UY":["598","0(?:0|1[3-9]\\d)","(?:0004|4)\\d{9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",[7,8,10,13],[["(\\d{3})(\\d{4})","$1 $2",["405|8|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[124]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["4"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["0"]]],"0",0,0,0,0,0,0,"00"," int. "],"UZ":["998","810","200\\d{6}|(?:33|[5-79]\\d|88)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-9]"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],"VA":["39","00","0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",[6,7,8,9,10,11],0,0,0,0,0,0,"06698"],"VC":["1","011","(?:[58]\\d\\d|784|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","784$1",0,"784"],"VE":["58","00","[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",[10],[["(\\d{3})(\\d{7})","$1-$2",["[24-689]"],"0$1"]],"0"],"VG":["1","011","(?:284|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-578]\\d{6})$|1","284$1",0,"284"],"VI":["1","011","[58]\\d{9}|(?:34|90)0\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","340$1",0,"340"],"VN":["84","00","[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["80"],"0$1",1],["(\\d{4})(\\d{4,6})","$1 $2",["1"],0,1],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["6"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[357-9]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2[48]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",1]],"0"],"VU":["678","00","[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",[5,7],[["(\\d{3})(\\d{4})","$1 $2",["[57-9]"]]]],"WF":["681","00","(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",[6,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[478]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"WS":["685","0","(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",[5,6,7,10],[["(\\d{5})","$1",["[2-5]|6[1-9]"]],["(\\d{3})(\\d{3,7})","$1 $2",["[68]"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"XK":["383","00","[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[23]"],"0$1"]],"0"],"YE":["967","00","(?:1|7\\d)\\d{7}|[1-7]\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7(?:[24-6]|8[0-7])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"]],"0"],"YT":["262","00","(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",[9],0,"0",0,0,0,0,0,[["269(?:0[0-467]|5[0-4]|6\\d|[78]0)\\d{4}"],["639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"],["80\\d{7}"],0,0,0,0,0,["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]],"ZA":["27","00","[1-79]\\d{8}|8\\d{4,9}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["860"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"ZM":["260","00","800\\d{6}|(?:21|63|[79]\\d)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[79]"],"0$1"]],"0"],"ZW":["263","00","2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",[5,6,7,8,9,10],[["(\\d{3})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"],"0$1"],["(\\d)(\\d{3})(\\d{2,4})","$1 $2 $3",["[49]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["80"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2","2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)","2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["29[013-9]|39|54"],"0$1"],["(\\d{4})(\\d{3,5})","$1 $2",["(?:25|54)8","258|5483"],"0$1"]],"0"]},"nonGeographic":{"800":["800",0,"(?:00|[1-9]\\d)\\d{6}",[8],[["(\\d{4})(\\d{4})","$1 $2",["\\d"]]],0,0,0,0,0,0,[0,0,["(?:00|[1-9]\\d)\\d{6}"]]],"808":["808",0,"[1-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,0,["[1-9]\\d{7}"]]],"870":["870",0,"7\\d{11}|[35-7]\\d{8}",[9,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[35-7]"]]],0,0,0,0,0,0,[0,["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]],"878":["878",0,"10\\d{10}",[12],[["(\\d{2})(\\d{5})(\\d{5})","$1 $2 $3",["1"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["10\\d{10}"]]],"881":["881",0,"[0-36-9]\\d{8}",[9],[["(\\d)(\\d{3})(\\d{5})","$1 $2 $3",["[0-36-9]"]]],0,0,0,0,0,0,[0,["[0-36-9]\\d{8}"]]],"882":["882",0,"[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",[7,8,9,10,11,12],[["(\\d{2})(\\d{5})","$1 $2",["16|342"]],["(\\d{2})(\\d{6})","$1 $2",["49"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["1[36]|9"]],["(\\d{2})(\\d{4})(\\d{3})","$1 $2 $3",["3[23]"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["16"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|23|3(?:[15]|4[57])|4|51"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["34"]],["(\\d{2})(\\d{4,5})(\\d{5})","$1 $2 $3",["[1-35]"]]],0,0,0,0,0,0,[0,["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",[7,8,9,10,12]],0,0,0,0,0,0,["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]],"883":["883",0,"(?:[1-4]\\d|51)\\d{6,10}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2,8})","$1 $2 $3",["[14]|2[24-689]|3[02-689]|51[24-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["510"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["21"]],["(\\d{4})(\\d{4})(\\d{4})","$1 $2 $3",["51[13]"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[235]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[013-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]],"888":["888",0,"\\d{11}",[11],[["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3"]],0,0,0,0,0,0,[0,0,0,0,0,0,["\\d{11}"]]],"979":["979",0,"[1359]\\d{8}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[1359]"]]],0,0,0,0,0,0,[0,0,0,["[1359]\\d{8}"]]]}};

function withMetadataArgument(func, _arguments) {
	var args = Array.prototype.slice.call(_arguments);
	args.push(metadata);
	return func.apply(this, args)
}

function _typeof$7(obj) { "@babel/helpers - typeof"; return _typeof$7 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$7(obj); }
function _defineProperties$5(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass$5(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$5(Constructor.prototype, protoProps); if (staticProps) _defineProperties$5(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck$5(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits$3(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$3(subClass, superClass); }
function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = _getPrototypeOf$3(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$3(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$3(this, result); }; }
function _possibleConstructorReturn$3(self, call) { if (call && (_typeof$7(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$3(self); }
function _assertThisInitialized$3(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf$3(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf$3(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct$4()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf$3(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf$3(o, p) { _setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$3(o, p); }
function _getPrototypeOf$3(o) { _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$3(o); }
var ParseError = function (_Error) {
  _inherits$3(ParseError, _Error);
  var _super = _createSuper$4(ParseError);
  function ParseError(code) {
    var _this;
    _classCallCheck$5(this, ParseError);
    _this = _super.call(this, code);
    Object.setPrototypeOf(_assertThisInitialized$3(_this), ParseError.prototype);
    _this.name = _this.constructor.name;
    return _this;
  }
  return _createClass$5(ParseError);
}( _wrapNativeSuper(Error));

var MIN_LENGTH_FOR_NSN = 2;
var MAX_LENGTH_FOR_NSN = 17;
var MAX_LENGTH_COUNTRY_CODE = 3;
var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9";
var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var SLASHES = "\uFF0F/";
var DOTS = "\uFF0E.";
var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]";
var TILDES = "~\u2053\u223C\uFF5E";
var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
var PLUS_CHARS = "+\uFF0B";

function compare (a, b) {
  a = a.split('-');
  b = b.split('-');
  var pa = a[0].split('.');
  var pb = b[0].split('.');
  for (var i = 0; i < 3; i++) {
    var na = Number(pa[i]);
    var nb = Number(pb[i]);
    if (na > nb) return 1;
    if (nb > na) return -1;
    if (!isNaN(na) && isNaN(nb)) return 1;
    if (isNaN(na) && !isNaN(nb)) return -1;
  }
  if (a[1] && b[1]) {
    return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
  }
  return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}

function _typeof$6(obj) { "@babel/helpers - typeof"; return _typeof$6 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$6(obj); }
function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$4(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass$4(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$4(Constructor.prototype, protoProps); if (staticProps) _defineProperties$4(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
var V3 = '1.2.0';
var V4 = '1.7.35';
var DEFAULT_EXT_PREFIX = ' ext. ';
var CALLING_CODE_REG_EXP = /^\d+$/;
var Metadata = function () {
  function Metadata(metadata) {
    _classCallCheck$4(this, Metadata);
    validateMetadata(metadata);
    this.metadata = metadata;
    setVersion.call(this, metadata);
  }
  _createClass$4(Metadata, [{
    key: "getCountries",
    value: function getCountries() {
      return Object.keys(this.metadata.countries).filter(function (_) {
        return _ !== '001';
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3) return;
      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== undefined;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }
      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        var countryCodes = this.countryCallingCodes()[callingCode];
        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    }
  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(countryCode, callingCode) {
      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
        callingCode = countryCode;
        countryCode = null;
      }
      if (countryCode && countryCode !== '001') {
        if (!this.hasCountry(countryCode)) {
          throw new Error("Unknown country: ".concat(countryCode));
        }
        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }
        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = undefined;
      }
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];
      if (countryCodes) {
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }
        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);
      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);
      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }
      if (this.nonGeographic()) {
        var metadata = this.nonGeographic()[callingCode];
        if (metadata) {
          return metadata;
        }
      } else {
        var countryCodes = this.countryCallingCodes()[callingCode];
        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return this.metadata.countries['001'];
        }
      }
    }
  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    }
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    }
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    }
  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    }
  }, {
    key: "type",
    value: function type(_type) {
      return this.numberingPlan.type(_type);
    }
  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1) return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    }
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      return this.selectNumberingPlan(callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== undefined;
    }
  }]);
  return Metadata;
}();
var NumberingPlan = function () {
  function NumberingPlan(metadata, globalMetadataObject) {
    _classCallCheck$4(this, NumberingPlan);
    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata;
    setVersion.call(this, globalMetadataObject.metadata);
  }
  _createClass$4(NumberingPlan, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    }
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[1];
    }
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2) return this.metadata[1];
      return this.metadata[2];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1) return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata) {
      return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
  }, {
    key: "formats",
    value: function formats() {
      var _this = this;
      var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats.map(function (_) {
        return new Format(_, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata) {
      return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      if (this.types() && this.types().length === 0) {
        return false;
      }
      return !!this.types();
    }
  }, {
    key: "type",
    value: function type(_type2) {
      if (this.hasTypes() && getType(this.types(), _type2)) {
        return new Type(getType(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2) return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);
  return NumberingPlan;
}();
var Format = function () {
  function Format(format, metadata) {
    _classCallCheck$4(this, Format);
    this._format = format;
    this.metadata = metadata;
  }
  _createClass$4(Format, [{
    key: "pattern",
    value: function pattern() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() &&
      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule())
      ? true : false;
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);
  return Format;
}();
var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var Type = function () {
  function Type(type, metadata) {
    _classCallCheck$4(this, Type);
    this.type = type;
    this.metadata = metadata;
  }
  _createClass$4(Type, [{
    key: "pattern",
    value: function pattern() {
      if (this.metadata.v1) return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1) return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);
  return Type;
}();
function getType(types, type) {
  switch (type) {
    case 'FIXED_LINE':
      return types[0];
    case 'MOBILE':
      return types[1];
    case 'TOLL_FREE':
      return types[2];
    case 'PREMIUM_RATE':
      return types[3];
    case 'PERSONAL_NUMBER':
      return types[4];
    case 'VOICEMAIL':
      return types[5];
    case 'UAN':
      return types[6];
    case 'PAGER':
      return types[7];
    case 'VOIP':
      return types[8];
    case 'SHARED_COST':
      return types[9];
  }
}
function validateMetadata(metadata) {
  if (!metadata) {
    throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
  }
  if (!is_object(metadata) || !is_object(metadata.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(is_object(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + type_of(metadata) + ': ' + metadata, "."));
  }
}
var is_object = function is_object(_) {
  return _typeof$6(_) === 'object';
};
var type_of = function type_of(_) {
  return _typeof$6(_);
};
function getCountryCallingCode(country, metadata) {
  metadata = new Metadata(metadata);
  if (metadata.hasCountry(country)) {
    return metadata.country(country).countryCallingCode();
  }
  throw new Error("Unknown country: ".concat(country));
}
function isSupportedCountry(country, metadata) {
  return metadata.countries.hasOwnProperty(country);
}
function setVersion(metadata) {
  var version = metadata.version;
  if (typeof version === 'number') {
    this.v1 = version === 1;
    this.v2 = version === 2;
    this.v3 = version === 3;
    this.v4 = version === 4;
  } else {
    if (!version) {
      this.v1 = true;
    } else if (compare(version, V3) === -1) {
      this.v2 = true;
    } else if (compare(version, V4) === -1) {
      this.v3 = true;
    } else {
      this.v4 = true;
    }
  }
}

var RFC3966_EXTN_PREFIX = ';ext=';
var getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
  return "([".concat(VALID_DIGITS, "]{1,").concat(maxLength, "})");
};
function createExtensionPattern(purpose) {
  var extLimitAfterExplicitLabel = '20';
  var extLimitAfterLikelyLabel = '15';
  var extLimitAfterAmbiguousChar = '9';
  var extLimitWhenNotSure = '6';
  var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*";
  var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
  var optionalExtnSuffix = "#?";
  var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)";
  var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)";
  var ambiguousSeparator = "[- ]+";
  var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*";
  var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
  var rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel);
  var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
  var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  var americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
  var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
  var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}

var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + VALID_DIGITS + ']{' + MIN_LENGTH_FOR_NSN + '}';
var VALID_PHONE_NUMBER = '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){3,}' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*';
var VALID_PHONE_NUMBER_START_REG_EXP = new RegExp('^' + '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){1,2}' + '$', 'i');
var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER +
'(?:' + createExtensionPattern() + ')?';
var VALID_PHONE_NUMBER_PATTERN = new RegExp(
'^' + MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' +
'^' + VALID_PHONE_NUMBER_WITH_EXTENSION + '$', 'i');
function isViablePhoneNumber(number) {
  return number.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number);
}
function isViablePhoneNumberStart(number) {
  return VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}

var EXTN_PATTERN = new RegExp('(?:' + createExtensionPattern() + ')$', 'i');
function extractExtension(number) {
  var start = number.search(EXTN_PATTERN);
  if (start < 0) {
    return {};
  }
  var numberWithoutExtension = number.slice(0, start);
  var matches = number.match(EXTN_PATTERN);
  var i = 1;
  while (i < matches.length) {
    if (matches[i]) {
      return {
        number: numberWithoutExtension,
        ext: matches[i]
      };
    }
    i++;
  }
}

var DIGITS = {
  '0': '0',
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  "\uFF10": '0',
  "\uFF11": '1',
  "\uFF12": '2',
  "\uFF13": '3',
  "\uFF14": '4',
  "\uFF15": '5',
  "\uFF16": '6',
  "\uFF17": '7',
  "\uFF18": '8',
  "\uFF19": '9',
  "\u0660": '0',
  "\u0661": '1',
  "\u0662": '2',
  "\u0663": '3',
  "\u0664": '4',
  "\u0665": '5',
  "\u0666": '6',
  "\u0667": '7',
  "\u0668": '8',
  "\u0669": '9',
  "\u06F0": '0',
  "\u06F1": '1',
  "\u06F2": '2',
  "\u06F3": '3',
  "\u06F4": '4',
  "\u06F5": '5',
  "\u06F6": '6',
  "\u06F7": '7',
  "\u06F8": '8',
  "\u06F9": '9'
};
function parseDigit(character) {
  return DIGITS[character];
}

function _createForOfIteratorHelperLoose$4(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$b(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$b(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$b(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$b(o, minLen); }
function _arrayLikeToArray$b(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function parseIncompletePhoneNumber(string) {
  var result = '';
  for (var _iterator = _createForOfIteratorHelperLoose$4(string.split('')), _step; !(_step = _iterator()).done;) {
    var character = _step.value;
    result += parsePhoneNumberCharacter(character, result) || '';
  }
  return result;
}
function parsePhoneNumberCharacter(character, prevParsedCharacters) {
  if (character === '+') {
    if (prevParsedCharacters) {
      return;
    }
    return '+';
  }
  return parseDigit(character);
}

function _createForOfIteratorHelperLoose$3(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$a(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$a(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$a(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$a(o, minLen); }
function _arrayLikeToArray$a(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function mergeArrays(a, b) {
  var merged = a.slice();
  for (var _iterator = _createForOfIteratorHelperLoose$3(b), _step; !(_step = _iterator()).done;) {
    var element = _step.value;
    if (a.indexOf(element) < 0) {
      merged.push(element);
    }
  }
  return merged.sort(function (a, b) {
    return a - b;
  });
}

function checkNumberLength(nationalNumber, metadata) {
  return checkNumberLengthForType(nationalNumber, undefined, metadata);
}
function checkNumberLengthForType(nationalNumber, type, metadata) {
  var type_info = metadata.type(type);
  var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths();
  if (!possible_lengths) {
    return 'IS_POSSIBLE';
  }
  if (type === 'FIXED_LINE_OR_MOBILE') {
    if (!metadata.type('FIXED_LINE')) {
      return checkNumberLengthForType(nationalNumber, 'MOBILE', metadata);
    }
    var mobile_type = metadata.type('MOBILE');
    if (mobile_type) {
      possible_lengths = mergeArrays(possible_lengths, mobile_type.possibleLengths());
    }
  }
  else if (type && !type_info) {
    return 'INVALID_LENGTH';
  }
  var actual_length = nationalNumber.length;
  var minimum_length = possible_lengths[0];
  if (minimum_length === actual_length) {
    return 'IS_POSSIBLE';
  }
  if (minimum_length > actual_length) {
    return 'TOO_SHORT';
  }
  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return 'TOO_LONG';
  }
  return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}

function isPossiblePhoneNumber(input, options, metadata) {
  if (options === undefined) {
    options = {};
  }
  metadata = new Metadata(metadata);
  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error('Invalid phone number object passed');
    }
    metadata.selectNumberingPlan(input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }
    if (input.country) {
      if (!metadata.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }
      metadata.country(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error('Invalid phone number object passed');
      }
      metadata.selectNumberingPlan(input.countryCallingCode);
    }
  }
  if (metadata.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, metadata);
  } else {
    if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) {
      return true;
    } else {
      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
  }
}
function isPossibleNumber(nationalNumber, metadata) {
  switch (checkNumberLength(nationalNumber, metadata)) {
    case 'IS_POSSIBLE':
      return true;
    default:
      return false;
  }
}

function matchesEntirely(text, regular_expression) {
  text = text || '';
  return new RegExp('^(?:' + regular_expression + ')$').test(text);
}

function _createForOfIteratorHelperLoose$2(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$9(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$9(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$9(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$9(o, minLen); }
function _arrayLikeToArray$9(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var NON_FIXED_LINE_PHONE_TYPES = ['MOBILE', 'PREMIUM_RATE', 'TOLL_FREE', 'SHARED_COST', 'VOIP', 'PERSONAL_NUMBER', 'PAGER', 'UAN', 'VOICEMAIL'];
function getNumberType(input, options, metadata) {
  options = options || {};
  if (!input.country) {
    return;
  }
  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern())) {
    return;
  }
  if (isNumberTypeEqualTo(nationalNumber, 'FIXED_LINE', metadata)) {
    if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') {
      return 'FIXED_LINE_OR_MOBILE';
    }
    if (!metadata.type('MOBILE')) {
      return 'FIXED_LINE_OR_MOBILE';
    }
    if (isNumberTypeEqualTo(nationalNumber, 'MOBILE', metadata)) {
      return 'FIXED_LINE_OR_MOBILE';
    }
    return 'FIXED_LINE';
  }
  for (var _iterator = _createForOfIteratorHelperLoose$2(NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;) {
    var type = _step.value;
    if (isNumberTypeEqualTo(nationalNumber, type, metadata)) {
      return type;
    }
  }
}
function isNumberTypeEqualTo(nationalNumber, type, metadata) {
  type = metadata.type(type);
  if (!type || !type.pattern()) {
    return false;
  }
  if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }
  return matchesEntirely(nationalNumber, type.pattern());
}

function isValidNumber(input, options, metadata) {
  options = options || {};
  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode);
  if (metadata.hasTypes()) {
    return getNumberType(input, options, metadata.metadata) !== undefined;
  }
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  return matchesEntirely(nationalNumber, metadata.nationalNumberPattern());
}

function getPossibleCountriesForNumber(callingCode, nationalNumber, metadata) {
  var _metadata = new Metadata(metadata);
  var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
  if (!possibleCountries) {
    return [];
  }
  return possibleCountries.filter(function (country) {
    return couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
  });
}
function couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
  var _metadata = new Metadata(metadata);
  _metadata.selectNumberingPlan(country);
  if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) {
    return true;
  }
  return false;
}

function applyInternationalSeparatorStyle(formattedNumber) {
  return formattedNumber.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), 'g'), ' ').trim();
}

var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number, format, _ref) {
  var useInternationalFormat = _ref.useInternationalFormat,
      withNationalPrefix = _ref.withNationalPrefix;
      _ref.carrierCode;
      _ref.metadata;
  var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() :
  withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format());
  if (useInternationalFormat) {
    return applyInternationalSeparatorStyle(formattedNumber);
  }
  return formattedNumber;
}

var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function getIddPrefix(country, callingCode, metadata) {
  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);
  if (countryMetadata.defaultIDDPrefix()) {
    return countryMetadata.defaultIDDPrefix();
  }
  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }
}

function formatRFC3966(_ref) {
  var number = _ref.number,
      ext = _ref.ext;
  if (!number) {
    return '';
  }
  if (number[0] !== '+') {
    throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
  }
  return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}

function _createForOfIteratorHelperLoose$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$8(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$8(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$8(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$8(o, minLen); }
function _arrayLikeToArray$8(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys$n(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$n(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$n(Object(source), !0).forEach(function (key) { _defineProperty$m(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$n(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$m(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata) {
    return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
  }
};
function formatNumber(input, format, options, metadata) {
  if (options) {
    options = _objectSpread$n(_objectSpread$n({}, DEFAULT_OPTIONS), options);
  } else {
    options = DEFAULT_OPTIONS;
  }
  metadata = new Metadata(metadata);
  if (input.country && input.country !== '001') {
    if (!metadata.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }
    metadata.country(input.country);
  } else if (input.countryCallingCode) {
    metadata.selectNumberingPlan(input.countryCallingCode);
  } else return input.phone || '';
  var countryCallingCode = metadata.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  var number;
  switch (format) {
    case 'NATIONAL':
      if (!nationalNumber) {
        return '';
      }
      number = formatNationalNumber(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
      return addExtension(number, input.ext, metadata, options.formatExtension);
    case 'INTERNATIONAL':
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }
      number = formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata, options);
      number = "+".concat(countryCallingCode, " ").concat(number);
      return addExtension(number, input.ext, metadata, options.formatExtension);
    case 'E.164':
      return "+".concat(countryCallingCode).concat(nationalNumber);
    case 'RFC3966':
      return formatRFC3966({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });
    case 'IDD':
      if (!options.fromCountry) {
        return;
      }
      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
      return addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
    default:
      throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
  }
}
function formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
  var format = chooseFormatForNumber(metadata.formats(), number);
  if (!format) {
    return number;
  }
  return formatNationalNumberUsingFormat(number, format, {
    useInternationalFormat: formatAs === 'INTERNATIONAL',
    withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
    carrierCode: carrierCode,
    metadata: metadata
  });
}
function chooseFormatForNumber(availableFormats, nationalNnumber) {
  for (var _iterator = _createForOfIteratorHelperLoose$1(availableFormats), _step; !(_step = _iterator()).done;) {
    var format = _step.value;
    if (format.leadingDigitsPatterns().length > 0) {
      var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1];
      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
        continue;
      }
    }
    if (matchesEntirely(nationalNnumber, format.pattern())) {
      return format;
    }
  }
}
function addExtension(formattedNumber, ext, metadata, formatExtension) {
  return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
  var fromCountryCallingCode = getCountryCallingCode(fromCountry, metadata.metadata);
  if (fromCountryCallingCode === countryCallingCode) {
    var formattedNumber = formatNationalNumber(nationalNumber, carrierCode, 'NATIONAL', metadata);
    if (countryCallingCode === '1') {
      return countryCallingCode + ' ' + formattedNumber;
    }
    return formattedNumber;
  }
  var iddPrefix = getIddPrefix(fromCountry, undefined, metadata.metadata);
  if (iddPrefix) {
    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata));
  }
}

function ownKeys$m(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$m(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$m(Object(source), !0).forEach(function (key) { _defineProperty$l(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$m(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$l(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$3(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass$3(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$3(Constructor.prototype, protoProps); if (staticProps) _defineProperties$3(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
var PhoneNumber = function () {
  function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
    _classCallCheck$3(this, PhoneNumber);
    if (!countryOrCountryCallingCode) {
      throw new TypeError('`country` or `countryCallingCode` not passed');
    }
    if (!nationalNumber) {
      throw new TypeError('`nationalNumber` not passed');
    }
    if (!metadata) {
      throw new TypeError('`metadata` not passed');
    }
    var _getCountryAndCountry = getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata),
        country = _getCountryAndCountry.country,
        countryCallingCode = _getCountryAndCountry.countryCallingCode;
    this.country = country;
    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = '+' + this.countryCallingCode + this.nationalNumber;
    this.getMetadata = function () {
      return metadata;
    };
  }
  _createClass$3(PhoneNumber, [{
    key: "setExt",
    value: function setExt(ext) {
      this.ext = ext;
    }
  }, {
    key: "getPossibleCountries",
    value: function getPossibleCountries() {
      if (this.country) {
        return [this.country];
      }
      return getPossibleCountriesForNumber(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function isPossible() {
      return isPossiblePhoneNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return isValidNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata = new Metadata(this.getMetadata());
      return metadata.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    }
  }, {
    key: "getType",
    value: function getType() {
      return getNumberType(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function format(_format, options) {
      return formatNumber(this, _format, options ? _objectSpread$m(_objectSpread$m({}, options), {}, {
        v2: true
      }) : {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format('NATIONAL', options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format('INTERNATIONAL', options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format('RFC3966', options);
    }
  }]);
  return PhoneNumber;
}();
var isCountryCode = function isCountryCode(value) {
  return /^[A-Z]{2}$/.test(value);
};
function getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
  var country;
  var countryCallingCode;
  var metadata = new Metadata(metadataJson);
  if (isCountryCode(countryOrCountryCallingCode)) {
    country = countryOrCountryCallingCode;
    metadata.selectNumberingPlan(country);
    countryCallingCode = metadata.countryCallingCode();
  } else {
    countryCallingCode = countryOrCountryCallingCode;
  }
  return {
    country: country,
    countryCallingCode: countryCallingCode
  };
}

var CAPTURING_DIGIT_PATTERN = new RegExp('([' + VALID_DIGITS + '])');
function stripIddPrefix(number, country, callingCode, metadata) {
  if (!country) {
    return;
  }
  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);
  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
  if (number.search(IDDPrefixPattern) !== 0) {
    return;
  }
  number = number.slice(number.match(IDDPrefixPattern)[0].length);
  var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);
  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === '0') {
      return;
    }
  }
  return number;
}

function extractNationalNumberFromPossiblyIncompleteNumber(number, metadata) {
  if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
    var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
    var prefixMatch = prefixPattern.exec(number);
    if (prefixMatch) {
      var nationalNumber;
      var carrierCode;
      var capturedGroupsCount = prefixMatch.length - 1;
      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
      if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
        nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule());
        if (capturedGroupsCount > 1) {
          carrierCode = prefixMatch[1];
        }
      }
      else {
        var prefixBeforeNationalNumber = prefixMatch[0];
        nationalNumber = number.slice(prefixBeforeNationalNumber.length);
        if (hasCapturedGroups) {
          carrierCode = prefixMatch[1];
        }
      }
      var nationalPrefix;
      if (hasCapturedGroups) {
        var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
        var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup);
        if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) {
          nationalPrefix = metadata.numberingPlan.nationalPrefix();
        }
      } else {
        nationalPrefix = prefixMatch[0];
      }
      return {
        nationalNumber: nationalNumber,
        nationalPrefix: nationalPrefix,
        carrierCode: carrierCode
      };
    }
  }
  return {
    nationalNumber: number
  };
}

function extractNationalNumber(number, metadata) {
  var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number, metadata),
      carrierCode = _extractNationalNumbe.carrierCode,
      nationalNumber = _extractNationalNumbe.nationalNumber;
  if (nationalNumber !== number) {
    if (!shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) {
      return {
        nationalNumber: number
      };
    }
    if (metadata.possibleLengths()) {
      if (!isPossibleIncompleteNationalNumber(nationalNumber, metadata)) {
        return {
          nationalNumber: number
        };
      }
    }
  }
  return {
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
}
function shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
  if (matchesEntirely(nationalNumberBefore, metadata.nationalNumberPattern()) && !matchesEntirely(nationalNumberAfter, metadata.nationalNumberPattern())) {
    return false;
  }
  return true;
}
function isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
  switch (checkNumberLength(nationalNumber, metadata)) {
    case 'TOO_SHORT':
    case 'INVALID_LENGTH':
      return false;
    default:
      return true;
  }
}

function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata) {
  var countryCallingCode = country ? getCountryCallingCode(country, metadata) : callingCode;
  if (number.indexOf(countryCallingCode) === 0) {
    metadata = new Metadata(metadata);
    metadata.selectNumberingPlan(country, callingCode);
    var possibleShorterNumber = number.slice(countryCallingCode.length);
    var _extractNationalNumbe = extractNationalNumber(possibleShorterNumber, metadata),
        possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
    var _extractNationalNumbe2 = extractNationalNumber(number, metadata),
        nationalNumber = _extractNationalNumbe2.nationalNumber;
    if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || checkNumberLength(nationalNumber, metadata) === 'TOO_LONG') {
      return {
        countryCallingCode: countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }
  return {
    number: number
  };
}

function extractCountryCallingCode(number, country, callingCode, metadata) {
  if (!number) {
    return {};
  }
  var isNumberWithIddPrefix;
  if (number[0] !== '+') {
    var numberWithoutIDD = stripIddPrefix(number, country, callingCode, metadata);
    if (numberWithoutIDD && numberWithoutIDD !== number) {
      isNumberWithIddPrefix = true;
      number = '+' + numberWithoutIDD;
    } else {
      if (country || callingCode) {
        var _extractCountryCallin = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata),
            countryCallingCode = _extractCountryCallin.countryCallingCode,
            shorterNumber = _extractCountryCallin.number;
        if (countryCallingCode) {
          return {
            countryCallingCodeSource: 'FROM_NUMBER_WITHOUT_PLUS_SIGN',
            countryCallingCode: countryCallingCode,
            number: shorterNumber
          };
        }
      }
      return {
        number: number
      };
    }
  }
  if (number[1] === '0') {
    return {};
  }
  metadata = new Metadata(metadata);
  var i = 2;
  while (i - 1 <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
    var _countryCallingCode = number.slice(1, i);
    if (metadata.hasCallingCode(_countryCallingCode)) {
      metadata.selectNumberingPlan(_countryCallingCode);
      return {
        countryCallingCodeSource: isNumberWithIddPrefix ? 'FROM_NUMBER_WITH_IDD' : 'FROM_NUMBER_WITH_PLUS_SIGN',
        countryCallingCode: _countryCallingCode,
        number: number.slice(i)
      };
    }
    i++;
  }
  return {};
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$7(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$7(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$7(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$7(o, minLen); }
function _arrayLikeToArray$7(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function getCountryByNationalNumber(nationalPhoneNumber, _ref) {
  var countries = _ref.countries,
      defaultCountry = _ref.defaultCountry,
      metadata = _ref.metadata;
  metadata = new Metadata(metadata);
  var matchingCountries = [];
  for (var _iterator = _createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done;) {
    var country = _step.value;
    metadata.country(country);
    if (metadata.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) {
        return country;
      }
    }
    else if (getNumberType({
      phone: nationalPhoneNumber,
      country: country
    }, undefined, metadata.metadata)) {
      if (defaultCountry) {
        if (country === defaultCountry) {
          return country;
        }
        matchingCountries.push(country);
      } else {
        return country;
      }
    }
  }
  if (matchingCountries.length > 0) {
    return matchingCountries[0];
  }
}

var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function getCountryByCallingCode(callingCode, _ref) {
  var nationalPhoneNumber = _ref.nationalNumber,
      defaultCountry = _ref.defaultCountry,
      metadata = _ref.metadata;
  if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
    if (metadata.isNonGeographicCallingCode(callingCode)) {
      return '001';
    }
  }
  var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
  if (!possibleCountries) {
    return;
  }
  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }
  return getCountryByNationalNumber(nationalPhoneNumber, {
    countries: possibleCountries,
    defaultCountry: defaultCountry,
    metadata: metadata.metadata
  });
}

var PLUS_SIGN = '+';
var RFC3966_VISUAL_SEPARATOR_ = '[\\-\\.\\(\\)]?';
var RFC3966_PHONE_DIGIT_ = '(' + '[' + VALID_DIGITS + ']' + '|' + RFC3966_VISUAL_SEPARATOR_ + ')';
var RFC3966_GLOBAL_NUMBER_DIGITS_ = '^' + '\\' + PLUS_SIGN + RFC3966_PHONE_DIGIT_ + '*' + '[' + VALID_DIGITS + ']' + RFC3966_PHONE_DIGIT_ + '*' + '$';
var RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(RFC3966_GLOBAL_NUMBER_DIGITS_, 'g');
var ALPHANUM_ = VALID_DIGITS;
var RFC3966_DOMAINLABEL_ = '[' + ALPHANUM_ + ']+((\\-)*[' + ALPHANUM_ + '])*';
var VALID_ALPHA_ = 'a-zA-Z';
var RFC3966_TOPLABEL_ = '[' + VALID_ALPHA_ + ']+((\\-)*[' + ALPHANUM_ + '])*';
var RFC3966_DOMAINNAME_ = '^(' + RFC3966_DOMAINLABEL_ + '\\.)*' + RFC3966_TOPLABEL_ + '\\.?$';
var RFC3966_DOMAINNAME_PATTERN_ = new RegExp(RFC3966_DOMAINNAME_, 'g');
var RFC3966_PREFIX_ = 'tel:';
var RFC3966_PHONE_CONTEXT_ = ';phone-context=';
var RFC3966_ISDN_SUBADDRESS_ = ';isub=';
function extractPhoneContext(numberToExtractFrom) {
  var indexOfPhoneContext = numberToExtractFrom.indexOf(RFC3966_PHONE_CONTEXT_);
  if (indexOfPhoneContext < 0) {
    return null;
  }
  var phoneContextStart = indexOfPhoneContext + RFC3966_PHONE_CONTEXT_.length;
  if (phoneContextStart >= numberToExtractFrom.length) {
    return '';
  }
  var phoneContextEnd = numberToExtractFrom.indexOf(';', phoneContextStart);
  if (phoneContextEnd >= 0) {
    return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
  } else {
    return numberToExtractFrom.substring(phoneContextStart);
  }
}
function isPhoneContextValid(phoneContext) {
  if (phoneContext === null) {
    return true;
  }
  if (phoneContext.length === 0) {
    return false;
  }
  return RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}

function extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(numberToParse, _ref) {
  var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
  var phoneContext = extractPhoneContext(numberToParse);
  if (!isPhoneContextValid(phoneContext)) {
    throw new ParseError('NOT_A_NUMBER');
  }
  var phoneNumberString;
  if (phoneContext === null) {
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || '';
  } else {
    phoneNumberString = '';
    if (phoneContext.charAt(0) === PLUS_SIGN) {
      phoneNumberString += phoneContext;
    }
    var indexOfRfc3966Prefix = numberToParse.indexOf(RFC3966_PREFIX_);
    var indexOfNationalNumber;
    if (indexOfRfc3966Prefix >= 0) {
      indexOfNationalNumber = indexOfRfc3966Prefix + RFC3966_PREFIX_.length;
    } else {
      indexOfNationalNumber = 0;
    }
    var indexOfPhoneContext = numberToParse.indexOf(RFC3966_PHONE_CONTEXT_);
    phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
  }
  var indexOfIsdn = phoneNumberString.indexOf(RFC3966_ISDN_SUBADDRESS_);
  if (indexOfIsdn > 0) {
    phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
  }
  if (phoneNumberString !== '') {
    return phoneNumberString;
  }
}

var MAX_INPUT_STRING_LENGTH = 250;
var PHONE_NUMBER_START_PATTERN = new RegExp('[' + PLUS_CHARS + VALID_DIGITS + ']');
var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + VALID_DIGITS + '#' + ']+$');
function parse$1(text, options, metadata) {
  options = options || {};
  metadata = new Metadata(metadata);
  if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
    if (options.v2) {
      throw new ParseError('INVALID_COUNTRY');
    }
    throw new Error("Unknown country: ".concat(options.defaultCountry));
  }
  var _parseInput = parseInput(text, options.v2, options.extract),
      formattedPhoneNumber = _parseInput.number,
      ext = _parseInput.ext,
      error = _parseInput.error;
  if (!formattedPhoneNumber) {
    if (options.v2) {
      if (error === 'TOO_SHORT') {
        throw new ParseError('TOO_SHORT');
      }
      throw new ParseError('NOT_A_NUMBER');
    }
    return {};
  }
  var _parsePhoneNumber = parsePhoneNumber$1(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata),
      country = _parsePhoneNumber.country,
      nationalNumber = _parsePhoneNumber.nationalNumber,
      countryCallingCode = _parsePhoneNumber.countryCallingCode,
      countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource,
      carrierCode = _parsePhoneNumber.carrierCode;
  if (!metadata.hasSelectedNumberingPlan()) {
    if (options.v2) {
      throw new ParseError('INVALID_COUNTRY');
    }
    return {};
  }
  if (!nationalNumber || nationalNumber.length < MIN_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError('TOO_SHORT');
    }
    return {};
  }
  if (nationalNumber.length > MAX_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError('TOO_LONG');
    }
    return {};
  }
  if (options.v2) {
    var phoneNumber = new PhoneNumber(countryCallingCode, nationalNumber, metadata.metadata);
    if (country) {
      phoneNumber.country = country;
    }
    if (carrierCode) {
      phoneNumber.carrierCode = carrierCode;
    }
    if (ext) {
      phoneNumber.ext = ext;
    }
    phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
    return phoneNumber;
  }
  var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) : false;
  if (!options.extended) {
    return valid ? result(country, nationalNumber, ext) : {};
  }
  return {
    country: country,
    countryCallingCode: countryCallingCode,
    carrierCode: carrierCode,
    valid: valid,
    possible: valid ? true : options.extended === true && metadata.possibleLengths() && isPossibleNumber(nationalNumber, metadata) ? true : false,
    phone: nationalNumber,
    ext: ext
  };
}
function _extractFormattedPhoneNumber(text, extract, throwOnError) {
  if (!text) {
    return;
  }
  if (text.length > MAX_INPUT_STRING_LENGTH) {
    if (throwOnError) {
      throw new ParseError('TOO_LONG');
    }
    return;
  }
  if (extract === false) {
    return text;
  }
  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);
  if (startsAt < 0) {
    return;
  }
  return text
  .slice(startsAt)
  .replace(AFTER_PHONE_NUMBER_END_PATTERN, '');
}
function parseInput(text, v2, extract) {
  var number = extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(text, {
    extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
      return _extractFormattedPhoneNumber(text, extract, v2);
    }
  });
  if (!number) {
    return {};
  }
  if (!isViablePhoneNumber(number)) {
    if (isViablePhoneNumberStart(number)) {
      return {
        error: 'TOO_SHORT'
      };
    }
    return {};
  }
  var withExtensionStripped = extractExtension(number);
  if (withExtensionStripped.ext) {
    return withExtensionStripped;
  }
  return {
    number: number
  };
}
function result(country, nationalNumber, ext) {
  var result = {
    country: country,
    phone: nationalNumber
  };
  if (ext) {
    result.ext = ext;
  }
  return result;
}
function parsePhoneNumber$1(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
  var _extractCountryCallin = extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata),
      countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource,
      countryCallingCode = _extractCountryCallin.countryCallingCode,
      number = _extractCountryCallin.number;
  var country;
  if (countryCallingCode) {
    metadata.selectNumberingPlan(countryCallingCode);
  }
  else if (number && (defaultCountry || defaultCallingCode)) {
    metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
    if (defaultCountry) {
      country = defaultCountry;
    }
    countryCallingCode = defaultCallingCode || getCountryCallingCode(defaultCountry, metadata.metadata);
  } else return {};
  if (!number) {
    return {
      countryCallingCodeSource: countryCallingCodeSource,
      countryCallingCode: countryCallingCode
    };
  }
  var _extractNationalNumbe = extractNationalNumber(parseIncompletePhoneNumber(number), metadata),
      nationalNumber = _extractNationalNumbe.nationalNumber,
      carrierCode = _extractNationalNumbe.carrierCode;
  var exactCountry = getCountryByCallingCode(countryCallingCode, {
    nationalNumber: nationalNumber,
    defaultCountry: defaultCountry,
    metadata: metadata
  });
  if (exactCountry) {
    country = exactCountry;
    if (exactCountry === '001') ; else {
      metadata.country(country);
    }
  }
  return {
    country: country,
    countryCallingCode: countryCallingCode,
    countryCallingCodeSource: countryCallingCodeSource,
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
}

function ownKeys$l(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$l(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$l(Object(source), !0).forEach(function (key) { _defineProperty$k(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$l(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$k(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function parsePhoneNumberWithError(text, options, metadata) {
  return parse$1(text, _objectSpread$l(_objectSpread$l({}, options), {}, {
    v2: true
  }), metadata);
}

function _typeof$5(obj) { "@babel/helpers - typeof"; return _typeof$5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$5(obj); }
function ownKeys$k(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$k(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$k(Object(source), !0).forEach(function (key) { _defineProperty$j(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$k(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$j(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray$3(arr, i) { return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i) || _unsupportedIterableToArray$6(arr, i) || _nonIterableRest$3(); }
function _nonIterableRest$3() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$6(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$6(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen); }
function _arrayLikeToArray$6(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$3(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$3(arr) { if (Array.isArray(arr)) return arr; }
function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args),
      _Array$prototype$slic2 = _slicedToArray$3(_Array$prototype$slic, 4),
      arg_1 = _Array$prototype$slic2[0],
      arg_2 = _Array$prototype$slic2[1],
      arg_3 = _Array$prototype$slic2[2],
      arg_4 = _Array$prototype$slic2[3];
  var text;
  var options;
  var metadata;
  if (typeof arg_1 === 'string') {
    text = arg_1;
  } else throw new TypeError('A text for parsing must be a string.');
  if (!arg_2 || typeof arg_2 === 'string') {
    if (arg_4) {
      options = arg_3;
      metadata = arg_4;
    } else {
      options = undefined;
      metadata = arg_3;
    }
    if (arg_2) {
      options = _objectSpread$k({
        defaultCountry: arg_2
      }, options);
    }
  }
  else if (isObject$2(arg_2)) {
    if (arg_3) {
      options = arg_2;
      metadata = arg_3;
    } else {
      metadata = arg_2;
    }
  } else throw new Error("Invalid second argument: ".concat(arg_2));
  return {
    text: text,
    options: options,
    metadata: metadata
  };
}
var isObject$2 = function isObject(_) {
  return _typeof$5(_) === 'object';
};

function ownKeys$j(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$j(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$j(Object(source), !0).forEach(function (key) { _defineProperty$i(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$j(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$i(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function parsePhoneNumber(text, options, metadata) {
  if (options && options.defaultCountry && !isSupportedCountry(options.defaultCountry, metadata)) {
    options = _objectSpread$j(_objectSpread$j({}, options), {}, {
      defaultCountry: undefined
    });
  }
  try {
    return parsePhoneNumberWithError(text, options, metadata);
  } catch (error) {
    if (error instanceof ParseError) ; else {
      throw error;
    }
  }
}

function ownKeys$i(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$i(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$i(Object(source), !0).forEach(function (key) { _defineProperty$h(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$i(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$h(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function isValidPhoneNumber$1() {
  var _normalizeArguments = normalizeArguments(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;
  options = _objectSpread$i(_objectSpread$i({}, options), {}, {
    extract: false
  });
  var phoneNumber = parsePhoneNumber(text, options, metadata);
  return phoneNumber && phoneNumber.isValid() || false;
}

function isValidPhoneNumber() {
	return withMetadataArgument(isValidPhoneNumber$1, arguments)
}

function usePhoneValidation(number, countryCode) {
  return isValidPhoneNumber(number, countryCode);
}

function handleOptimizeAttributes(attributes) {
  if (attributes.single === undefined && attributes.all === undefined) {
    return attributes;
  }
  if (attributes.all === undefined) {
    return {
      single: attributes.single,
      all: undefined
    };
  }
  return {
    single: Object.assign(attributes.all, attributes.single),
    all: attributes.all
  };
}
function handleAttributeFusion(newAtt, defaultAtt) {
  var fusedAttributes = {
    single: _objectSpread2(_objectSpread2({}, defaultAtt.single), newAtt.single),
    all: _objectSpread2(_objectSpread2({}, defaultAtt.all), newAtt.all)
  };
  if (Object.keys(fusedAttributes.all).length === 0) {
    delete fusedAttributes.all;
  }
  if (Object.keys(fusedAttributes.single).length === 0) {
    delete fusedAttributes.single;
  }
  fusedAttributes = handleOptimizeAttributes(fusedAttributes);
  return fusedAttributes;
}
function addSingleAttributes(ref, attributes) {
  if (attributes !== undefined) {
    ref.setAttribute('data-module', JSON.stringify(attributes));
  }
}
function addAllAttributes(ref, attributes) {
  if (Object.keys(ref.children).length === 0) {
    addSingleAttributes(ref, attributes);
    return;
  }
  Object.keys(ref.children).forEach(function (e) {
    if (attributes !== undefined) {
      ref.setAttribute('data-module', JSON.stringify(attributes));
    }
    addAllAttributes(ref.children[e], attributes);
  });
}
function useDataAttributes(ref, attributes, initialAttributes, hasState) {
  var dependency = [];
  if (hasState !== undefined) {
    dependency.push(hasState);
  }
  React__default.useEffect(function () {
    if (ref.current !== undefined && ref.current !== null) {
      if (attributes !== undefined && initialAttributes !== undefined) {
        var fusedAttributes = handleAttributeFusion(attributes, initialAttributes);
        addAllAttributes(ref.current, fusedAttributes.all);
        addSingleAttributes(ref.current, fusedAttributes.single);
      } else if (attributes !== undefined && initialAttributes === undefined) {
        var handledAttributes = handleOptimizeAttributes(attributes);
        addAllAttributes(ref.current, handledAttributes.all);
        addSingleAttributes(ref.current, handledAttributes.single);
      } else if (attributes === undefined && initialAttributes !== undefined) {
        var _handledAttributes = handleOptimizeAttributes(initialAttributes);
        addAllAttributes(ref.current, _handledAttributes.all);
        addSingleAttributes(ref.current, _handledAttributes.single);
      }
    }
  }, dependency);
}

var Breakpoint = {
  fd: 330,
  xs: 576,
  sm: 768,
  md: 992,
  lg: 1100,
  xl: 1400,
  xxl: 1440,
  max: 1800
};

function Row$1(props) {
  var _props$breakpoint;
  var size = useDimensions();
  var breakpoint = Number.isInteger(props.breakpoint) ? props.breakpoint : Breakpoint[(_props$breakpoint = props.breakpoint) !== null && _props$breakpoint !== void 0 ? _props$breakpoint : 'xs'];
  var calcChildWidth = "".concat(props.children.map(function () {
    return "".concat(100 / props.children.length, "%");
  }), " ");
  var renderChild = function renderChild(child, key) {
    return React$4.createElement("div", {
      key: key,
      style: {
        height: '100%',
        width: '100%',
        gridRow: props.invert ? 'unset' : size.width < breakpoint ? key + 1 : size.width <= Breakpoint.xxl && props.children.length === 4 ? key >= 2 ? 1 : 2 : 1
      }
    }, child);
  };
  return React$4.createElement("div", {
    style: {
      width: '100%',
      height: 'auto',
      display: 'grid',
      gridTemplateColumns: size.width < breakpoint ? '100%' : size.width <= Breakpoint.xxl ? props.disableAuto && props.share ? "".concat(props.share.toString().split(',').join('% '), "%") : '50% 50%' : props.share ? "".concat(props.share.toString().split(',').join('% '), "%") : calcChildWidth.replace(/[,]+/g, ' ')
    }
  }, props.invert ? props.children.map(function (child, key) {
    return renderChild(child, key);
  }).reverse() : props.children.map(function (child, key) {
    return renderChild(child, key);
  }));
}

function Auto(props) {
  var isEven = function isEven(e) {
    if (e % 2 === 0) return true;
    return false;
  };
  var renderChild = function renderChild(child, key) {
    var _ref, _props$gap;
    return React$4.createElement("div", {
      key: key,
      className: "FlexGapLeft FlexGapRight FlexGapTop",
      style: {
        width: props.spacing ? props.children.length === 3 ? "".concat(isEven(key) ? 40 : 20, "%") : "".concat(100 / props.children.length, "%") : "".concat(100 / props.children.length, "%"),
        flex: "1 0 ".concat((_ref = "".concat(props.minWidth, "px")) !== null && _ref !== void 0 ? _ref : '290px'),
        alignSelf: 'stretch',
        marginBottom: (_props$gap = props.gap) !== null && _props$gap !== void 0 ? _props$gap : 0
      }
    }, child);
  };
  return React$4.createElement("div", {
    style: {
      width: '100%',
      height: 'auto',
      display: 'flex',
      flexWrap: 'wrap'
    }
  }, props.invert ? props.children.map(function (child, key) {
    return renderChild(child, key);
  }).reverse() : props.children.map(function (child, key) {
    return renderChild(child, key);
  }));
}

function Container(props) {
  var render = function render(e) {
    switch (e) {
      case 'row':
        return React$4.createElement(Row$1, {
          share: props.share,
          invert: props.invert,
          breakpoint: props.breakpoint,
          disableAuto: props.disableAuto
        }, props.children);
      case 'auto':
        return React$4.createElement(Auto, {
          invert: props.invert,
          minWidth: props.minWidth,
          gap: props.gap,
          spacing: props.spacing
        }, props.children);
      default:
        return React$4.createElement(Row$1, {
          share: props.share,
          invert: props.invert,
          breakpoint: props.breakpoint,
          disableAuto: props.disableAuto
        }, props.children);
    }
  };
  return React$4.createElement("div", null, render(props.type));
}

function MainContainer$1(props) {
  var size = useDimensions();
  return React$4.createElement("div", {
    style: {
      width: size.width < Breakpoint.xxl ? '94%' : '75%',
      maxWidth: 1600,
      marginLeft: size.width < Breakpoint.xxl ? '3%' : size.width < Breakpoint.max ? '12.5%' : 'auto',
      marginRight: size.width < Breakpoint.xxl ? '3%' : size.width < Breakpoint.max ? '12.5%' : 'auto'
    }
  }, props.children);
}

function LargeContainer(props) {
  var _props$height;
  var size = useDimensions();
  return React$4.createElement("div", {
    style: {
      width: size.width < Breakpoint.xxl ? '100%' : '80%',
      maxWidth: 1650,
      height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 'auto',
      marginLeft: size.width < Breakpoint.xxl ? 0 : size.width < Breakpoint.max ? '10%' : 'auto',
      marginRight: size.width < Breakpoint.xxl ? 0 : size.width < Breakpoint.max ? '10%' : 'auto'
    }
  }, props.children);
}

function MainContainer(props) {
  var size = useDimensions();
  return React$4.createElement("div", {
    style: {
      width: size.width < Breakpoint.xxl ? '94%' : '65%',
      maxWidth: 1400,
      marginLeft: size.width < Breakpoint.xxl ? '3%' : size.width < Breakpoint.max ? '17.5%' : 'auto',
      marginRight: size.width < Breakpoint.xxl ? '3%' : size.width < Breakpoint.max ? '17.5%' : 'auto'
    }
  }, props.children);
}

var IconSetFA = [{name:"AngleDown",type:"light",viewBox:"0 0 256 512",path:[{d:"M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z"}]},{name:"AngleRight",type:"light",viewBox:"0 0 192 512",path:[{d:"M166.9 264.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L127.3 256 25.1 155.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116c4.6 4.7 4.6 12.3-.1 17z"}]},{name:"ArrowDown",type:"light",viewBox:"0 0 448 512",path:[{d:"M441.9 250.1l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L250 385.4V44c0-6.6-5.4-12-12-12h-28c-6.6 0-12 5.4-12 12v341.4L42.9 230.3c-4.7-4.7-12.3-4.7-17 0L6.1 250.1c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z"}]},{name:"ArrowLeft",type:"light",viewBox:"0 0 448 512",path:[{d:"M229.9 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L94.569 282H436c6.627 0 12-5.373 12-12v-28c0-6.627-5.373-12-12-12H94.569l155.13-155.13c4.686-4.686 4.686-12.284 0-16.971L229.9 38.101c-4.686-4.686-12.284-4.686-16.971 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971L212.929 473.9c4.686 4.686 12.284 4.686 16.971-.001z"}]},{name:"ArrowRight",type:"light",viewBox:"0 0 448 512",path:[{d:"M218.101 38.101L198.302 57.9c-4.686 4.686-4.686 12.284 0 16.971L353.432 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h341.432l-155.13 155.13c-4.686 4.686-4.686 12.284 0 16.971l19.799 19.799c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L235.071 38.101c-4.686-4.687-12.284-4.687-16.97 0z"}]},{name:"Bomb",type:"light",viewBox:"0 0 512 512",path:[{d:"M440.5 88.5l-52 52L415 167c9.4 9.4 9.4 24.6 0 33.9l-17.4 17.4c11.8 26.1 18.4 55.1 18.4 85.6 0 114.9-93.1 208-208 208S0 418.9 0 304 93.1 96 208 96c30.5 0 59.5 6.6 85.6 18.4L311 97c9.4-9.4 24.6-9.4 33.9 0l26.5 26.5 52-52 17.1 17zM500 60h-24c-6.6 0-12 5.4-12 12s5.4 12 12 12h24c6.6 0 12-5.4 12-12s-5.4-12-12-12zM440 0c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12s12-5.4 12-12V12c0-6.6-5.4-12-12-12zm33.9 55l17-17c4.7-4.7 4.7-12.3 0-17-4.7-4.7-12.3-4.7-17 0l-17 17c-4.7 4.7-4.7 12.3 0 17 4.8 4.7 12.4 4.7 17 0zm-67.8 0c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17zm67.8 34c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17zM112 272c0-35.3 28.7-64 64-64 8.8 0 16-7.2 16-16s-7.2-16-16-16c-52.9 0-96 43.1-96 96 0 8.8 7.2 16 16 16s16-7.2 16-16z"}]},{name:"Check",type:"light",viewBox:"0 0 512 512",path:[{d:"M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z"}]},{name:"CheckCircle",type:"light",viewBox:"0 0 24 24",path:[{d:"m10.6 16.6l7.05-7.05l-1.4-1.4l-5.65 5.65l-2.85-2.85l-1.4 1.4l4.25 4.25ZM12 22q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22Z"}]},{name:"Headset",type:"light",viewBox:"0 0 512 512",path:[{d:"M192 224c0-17.67-14.33-32-32-32h-32c-35.35 0-64 28.65-64 64v63.64c0 35.35 28.65 64 64 64h32c17.67 0 32-14.33 32-32V224zm-32 127.64h-32c-17.64 0-32-14.36-32-32V256c0-17.64 14.36-32 32-32h32v127.64zm224 32c35.35 0 64-28.65 64-64V256c0-35.35-28.65-64-64-64h-32c-17.67 0-32 14.33-32 32v127.64c0 17.67 14.33 32 32 32h32zM352 224h32c17.64 0 32 14.36 32 32v63.64c0 17.64-14.36 32-32 32h-32V224zM256 0C113.97 0 3.92 117.82.1 256L0 280c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8l.09-24C35.43 135.19 131.63 32 256 32c123.5 0 224 100.48 224 224v176c0 26.47-21.53 48-48 48h-82.94c1.79-5.03 2.94-10.36 2.94-16 0-26.51-21.49-48-48-48h-64c-26.51 0-48 21.49-48 48s21.49 48 48 48h192c44.12 0 80-35.89 80-80V256C512 114.85 397.16 0 256 0zm48 480h-64c-8.82 0-16-7.18-16-16s7.18-16 16-16h64c8.82 0 16 7.18 16 16s-7.18 16-16 16z"}]},{name:"Heart",type:"solid",viewBox:"0 0 512 512",path:[{d:"M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"}]},{name:"Heart",type:"light",viewBox:"0 0 512 512",path:[{d:"M462.3 62.7c-54.5-46.4-136-38.7-186.6 13.5L256 96.6l-19.7-20.3C195.5 34.1 113.2 8.7 49.7 62.7c-62.8 53.6-66.1 149.8-9.9 207.8l193.5 199.8c6.2 6.4 14.4 9.7 22.6 9.7 8.2 0 16.4-3.2 22.6-9.7L472 270.5c56.4-58 53.1-154.2-9.7-207.8zm-13.1 185.6L256.4 448.1 62.8 248.3c-38.4-39.6-46.4-115.1 7.7-161.2 54.8-46.8 119.2-12.9 142.8 11.5l42.7 44.1 42.7-44.1c23.2-24 88.2-58 142.8-11.5 54 46 46.1 121.5 7.7 161.2z"}]},{name:"House",type:"light",viewBox:"0 0 576 512",path:[{d:"M541 229.16l-232.85-190a32.16 32.16 0 0 0-40.38 0L35 229.16a8 8 0 0 0-1.16 11.24l10.1 12.41a8 8 0 0 0 11.2 1.19L96 220.62v243a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-128l64 .3V464a16 16 0 0 0 16 16l128-.33a16 16 0 0 0 16-16V220.62L520.86 254a8 8 0 0 0 11.25-1.16l10.1-12.41a8 8 0 0 0-1.21-11.27zm-93.11 218.59h.1l-96 .3V319.88a16.05 16.05 0 0 0-15.95-16l-96-.27a16 16 0 0 0-16.05 16v128.14H128V194.51L288 63.94l160 130.57z"}]},{name:"HouseAlt",type:"light",viewBox:"0 0 576 512",path:[{d:"M570.53,242,512,190.75V48a16,16,0,0,0-16-16H400a16,16,0,0,0-16,16V78.75L298.53,4a16,16,0,0,0-21.06,0L5.47,242a16,16,0,0,0,21.07,24.09L64,233.27V464a48.05,48.05,0,0,0,48,48H464a48.05,48.05,0,0,0,48-48V233.27l37.46,32.79A16,16,0,0,0,570.53,242ZM480,464a16,16,0,0,1-16,16H112a16,16,0,0,1-16-16V205.27l192-168,192,168Zm0-301.25-64-56V64h64ZM208,218.67V325.34A26.75,26.75,0,0,0,234.66,352H341.3A26.76,26.76,0,0,0,368,325.34V218.67A26.75,26.75,0,0,0,341.3,192H234.66A26.74,26.74,0,0,0,208,218.67ZM240,224h96v96H240Z"}]},{name:"Language",type:"light",viewBox:"0 0 640 512",path:[{d:"M184 119.2c0-7-5.7-12.7-12.7-12.7h-.1c-3.4 0-6.6 1.3-8.9 3.7l-28.5 28.5c-2.4 2.4-3.7 5.6-3.7 8.9v.1c0 7 5.7 12.7 12.7 12.7h18c3.4 0 6.6-1.3 8.9-3.7l10.5-10.5c2.4-2.4 3.7-5.6 3.7-8.9v-18.1zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm48 458.4V432c0-26.5-21.5-48-48-48h-20.2c-3.9 0-13.1-3.1-16.2-5.4l-22.2-16.7c-3.4-2.5-5.4-6.6-5.4-10.8v-23.9c0-4.7 2.5-9.1 6.5-11.6l42.9-25.7c2.1-1.3 4.5-1.9 6.9-1.9h31.2c3.2 0 6.3 1.2 8.8 3.2l52.2 44.8h30.2l17.3 17.3c9.5 9.5 22.1 14.7 35.5 14.7h16.8c-29.9 49.1-78.7 85.3-136.3 98.4zM448.5 336h-32.9c-4.8 0-9.5-1.9-12.9-5.3l-17.3-17.3c-6-6-14.1-9.4-22.6-9.4h-18.3l-43.2-37.1c-8.2-7.1-18.7-10.9-29.6-10.9h-31.2c-8.2 0-16.3 2.2-23.4 6.5l-42.9 25.7c-13.7 8.2-22.1 23-22.1 39v23.9c0 14.3 6.7 27.8 18.2 36.4l22.2 16.7c8.6 6.5 24.6 11.8 35.4 11.8h20.2c8.8 0 16 7.2 16 16v39.2c-5.3.4-10.6.8-16 .8-119.1 0-216-96.9-216-216 0-118.9 96.5-215.6 215.3-216L232 51.1c-10.2 7.7-16 19.2-16 31.4v23.2c0 6.4 3.1 17 5.9 22.3-.8 2.1-21.1 15-24.6 18.5-8.6 8.6-13.3 20-13.3 32.1V195c0 25 20.4 45.4 45.4 45.4h25.3c11 0 21.2-3.9 29.2-10.6 3.9 1.4 8.2 2.1 12.6 2.1h13.4c25.6 0 32.2-20.2 36.1-21.5 5.1 9.1 13.5 16.2 23.5 19.5-4.3 14.2-.9 30.3 10.1 41.6l18.2 19.1c8.7 8.9 20.6 13.9 32.7 13.9h27.7c-2.4 10.8-5.7 21.3-9.7 31.5zm-17.8-63.6c-3.6 0-7.1-1.5-9.6-4L402.6 249a9.93 9.93 0 0 1 .1-14c12.6-12.6 10.5-8.6 10.5-17.8 0-2.5-1-4.9-2.8-6.7l-7.9-7.9c-1.8-1.8-4.2-2.8-6.7-2.8h-13.4c-8.5 0-12.6-10.3-6.7-16.2l7.9-7.3c1.8-1.8 4.2-2.8 6.7-2.8h8.3c5.2 0 9.5-4.2 9.5-9.5v-10.2c0-5.2-4.2-9.5-9.5-9.5h-28.2c-7.4 0-13.4 6-13.4 13.4v5.6c0 5.8-3.7 10.9-9.2 12.7l-26.5 8.8c-4.3 1.4-4.6 5-4.6 8.2 0 3.7-3 6.7-6.7 6.7h-13.4c-3.7 0-6.7-3-6.7-6.7 0-8.4-12.5-8.6-15.3-3-9 12.4-11.5 18.2-19.9 18.2h-25.3c-7.4 0-13.4-6-13.4-13.4v-16.4c0-3.6 1.4-7 3.9-9.5 19.5-14 29.6-17.6 29.6-31.5 0-2.9 1.8-5.5 4.6-6.4l33.6-11.2c1.4-.5 2.7-1.2 3.7-2.3L313.9 95c5-5 3.5-14.9-6.7-14.9h-17.4L276.4 99v6.7c0 3.7-3 6.7-6.7 6.7h-15c-3.7 0-6.7-3-6.7-6.7V82.5c0-2.1 1-4.1 2.7-5.4l44-31.9C391.4 66.7 464 153 464 256c0 5.5-.4 11-.8 16.4h-32.5z"}]},{name:"Leaf",type:"light",viewBox:"0 0 576 512",path:[{d:"M546.2 9.7c-2.9-6.5-8.6-9.7-14.3-9.7-5.3 0-10.7 2.8-14 8.5C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 20.9 3.4 40.9 9.6 59.7C29.3 413 1.4 489.4.9 490.7c-2.9 8.3 1.5 17.5 9.8 20.4 7.9 2.8 17.4-1.1 20.4-9.8.4-1.2 23.9-65.1 87.6-122.7C151.1 438.9 214.7 480 288 480c6.9 0 13.7-.4 20.4-1.1C465.5 467.5 576 326.8 576 154.3c0-50.2-10.8-102.2-29.8-144.6zM305 447.1c-5.9.6-11.6.9-17 .9-63.3 0-117.6-37.2-143.5-90.6C196.3 319 268.6 288 368 288c8.8 0 16-7.2 16-16s-7.2-16-16-16c-102.8 0-179 31-234.8 70.4-3.1-12.4-5.2-25.1-5.2-38.4 0-88.2 71.8-160 160-160h80c63.3 0 121-28.4 159.7-77.2 10.5 32.3 16.3 68.7 16.3 103.5 0 159.6-100.1 282.7-239 292.8z"}]},{name:"MagicWand",type:"light",viewBox:"0 0 512 512",path:[{d:"M80 160l26.66-53.33L160 80l-53.33-26.67L80 0 53.33 53.33 0 80l53.33 26.67L80 160zm351.99 128l-26.66 53.33L351.99 368l53.33 26.67L431.99 448l26.66-53.33L511.98 368l-53.33-26.67L431.99 288zm-208-192l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zm208 96c8.84 0 16-7.16 16-16v-34.11L502.02 82c13.81-15.22 13.22-38.53-1.31-53.09l-17.66-17.63c-14.5-14.52-37.84-15.08-53-1.36L157.28 256H112c-8.84 0-16 7.16-16 16v39.28l-78.53 70.84-.06.05C6.72 391.86.38 405.69.04 420.12c-.37 14.44 5.28 28.58 15.5 38.81l37.53 37.52c9.87 9.92 23.5 15.55 37.5 15.55 22.17 0 35.57-13.37 39.28-17.47L402.78 192h29.21zM94.22 462.36c-.82.91-4.23 3.24-7.22.17l-37.53-37.52c-2.97-3.01-.73-6.44.16-7.27L455.49 51.61l4.91 4.88L94.22 462.36z"}]},{name:"Minus",type:"light",viewBox:"0 0 384 512",path:[{d:"M376 232H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h368c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"}]},{name:"Office",viewBox:"0 0 448 512",path:[{d:"M192 107v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12zm116-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-128 96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm128 0h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-128 96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm128 0h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm140 205v20H0v-20c0-6.627 5.373-12 12-12h20V24C32 10.745 42.745 0 56 0h336c13.255 0 24 10.745 24 24v456h20c6.627 0 12 5.373 12 12zm-64-12V32H64v448h128v-85c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v85h128z"}]},{name:"Pause",type:"light",viewBox:"0 0 448 512",path:[{d:"M192 79v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48zm-48 346V85c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h84c3.3 0 6-2.7 6-6zM448 79v352c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48zm-48 346V85c0-3.3-2.7-6-6-6h-84c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h84c3.3 0 6-2.7 6-6z"}]},{name:"Play",type:"light",viewBox:"0 0 448 512",path:[{d:"M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6zM48 453.5v-395c0-4.6 5.1-7.5 9.1-5.2l334.2 197.5c3.9 2.3 3.9 8 0 10.3L57.1 458.7c-4 2.3-9.1-.6-9.1-5.2z"}]},{name:"Required",type:"light",viewBox:"0 0 480 512",path:[{d:"M471.99 334.43L336.06 256l135.93-78.43c7.66-4.42 10.28-14.2 5.86-21.86l-32.02-55.43c-4.42-7.65-14.21-10.28-21.87-5.86l-135.93 78.43V16c0-8.84-7.17-16-16.01-16h-64.04c-8.84 0-16.01 7.16-16.01 16v156.86L56.04 94.43c-7.66-4.42-17.45-1.79-21.87 5.86L2.15 155.71c-4.42 7.65-1.8 17.44 5.86 21.86L143.94 256 8.01 334.43c-7.66 4.42-10.28 14.21-5.86 21.86l32.02 55.43c4.42 7.65 14.21 10.27 21.87 5.86l135.93-78.43V496c0 8.84 7.17 16 16.01 16h64.04c8.84 0 16.01-7.16 16.01-16V339.14l135.93 78.43c7.66 4.42 17.45 1.8 21.87-5.86l32.02-55.43c4.42-7.65 1.8-17.43-5.86-21.85z"}]},{name:"YouTube",type:"light",viewBox:"0 0 576 512",path:[{d:"M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"}]},{name:"Linkedin",type:"light",viewBox:"0 0 448 512",path:[{d:"M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"}]},{name:"Instagram",type:"light",viewBox:"0 0 448 512",path:[{d:"M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"}]},{name:"At",type:"light",viewBox:"0 0 512 512",path:[{d:"M256 8C118.941 8 8 118.919 8 256c0 137.058 110.919 248 248 248 52.925 0 104.68-17.078 147.092-48.319 5.501-4.052 6.423-11.924 2.095-17.211l-5.074-6.198c-4.018-4.909-11.193-5.883-16.307-2.129C346.93 457.208 301.974 472 256 472c-119.373 0-216-96.607-216-216 0-119.375 96.607-216 216-216 118.445 0 216 80.024 216 200 0 72.873-52.819 108.241-116.065 108.241-19.734 0-23.695-10.816-19.503-33.868l32.07-164.071c1.449-7.411-4.226-14.302-11.777-14.302h-12.421a12 12 0 0 0-11.781 9.718c-2.294 11.846-2.86 13.464-3.861 25.647-11.729-27.078-38.639-43.023-73.375-43.023-68.044 0-133.176 62.95-133.176 157.027 0 61.587 33.915 98.354 90.723 98.354 39.729 0 70.601-24.278 86.633-46.982-1.211 27.786 17.455 42.213 45.975 42.213C453.089 378.954 504 321.729 504 240 504 103.814 393.863 8 256 8zm-37.92 342.627c-36.681 0-58.58-25.108-58.58-67.166 0-74.69 50.765-121.545 97.217-121.545 38.857 0 58.102 27.79 58.102 65.735 0 58.133-38.369 122.976-96.739 122.976z"}]},{name:"User",type:"light",viewBox:"0 0 512 512",path:[{d:"M256 32c61.8 0 112 50.2 112 112s-50.2 112-112 112-112-50.2-112-112S194.2 32 256 32m128 320c52.9 0 96 43.1 96 96v32H32v-32c0-52.9 43.1-96 96-96 85 0 67.3 16 128 16 60.9 0 42.9-16 128-16M256 0c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144S335.5 0 256 0zm128 320c-92.4 0-71 16-128 16-56.8 0-35.7-16-128-16C57.3 320 0 377.3 0 448v32c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-32c0-70.7-57.3-128-128-128z"}]},{name:"Bell",type:"light",viewBox:"0 0 512 512",path:[{d:"M224 480c-17.66 0-32-14.38-32-32.03h-32c0 35.31 28.72 64.03 64 64.03s64-28.72 64-64.03h-32c0 17.65-14.34 32.03-32 32.03zm209.38-145.19c-27.96-26.62-49.34-54.48-49.34-148.91 0-79.59-63.39-144.5-144.04-152.35V16c0-8.84-7.16-16-16-16s-16 7.16-16 16v17.56C127.35 41.41 63.96 106.31 63.96 185.9c0 94.42-21.39 122.29-49.35 148.91-13.97 13.3-18.38 33.41-11.25 51.23C10.64 404.24 28.16 416 48 416h352c19.84 0 37.36-11.77 44.64-29.97 7.13-17.82 2.71-37.92-11.26-51.22zM400 384H48c-14.23 0-21.34-16.47-11.32-26.01 34.86-33.19 59.28-70.34 59.28-172.08C95.96 118.53 153.23 64 224 64c70.76 0 128.04 54.52 128.04 121.9 0 101.35 24.21 138.7 59.28 172.08C421.38 367.57 414.17 384 400 384z"}]},{name:"SignOut",type:"light",viewBox:"0 0 512 512",path:[{d:"M48 64h132c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H48c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h132c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48zm279 19.5l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l132 131.4H172c-6.6 0-12 5.4-12 12v10c0 6.6 5.4 12 12 12h279.9L320 404.4c-4.7 4.7-4.7 12.3 0 17l7.1 7.1c4.7 4.7 12.3 4.7 17 0l164.5-164c4.7-4.7 4.7-12.3 0-17L344 83.5c-4.7-4.7-12.3-4.7-17 0z"}]},{name:"TabMenu",type:"light",viewBox:"0 0 512 512",path:[{d:"M442,176L6,176C2.708,176 0,173.292 0,170L0,146C-0,142.708 2.708,140 6,140L442,140C445.292,140 448,142.708 448,146L448,170C448,173.292 445.292,176 442,176ZM442,366L110,366C106.708,366 104,363.292 104,360L104,336C104,332.708 106.708,330 110,330L442,330C445.292,330 448,332.708 448,336L448,360C448,363.292 445.292,366 442,366Z"}]},{name:"TabHome",type:"light",viewBox:"0 0 512 512",path:[{d:"M128,136C114.75,136 104,146.74 104,160C104,173.25 114.75,184 128,184C141.25,184 152,173.25 152,160C152,146.74 141.25,136 128,136ZM128,328C114.75,328 104,338.74 104,352C104,365.25 114.75,376 128,376C141.25,376 152,365.25 152,352C152,338.74 141.25,328 128,328ZM320,136C306.75,136 296,146.74 296,160C296,173.25 306.75,184 320,184C333.25,184 344,173.25 344,160C344,146.74 333.25,136 320,136ZM320,328C306.75,328 296,338.74 296,352C296,365.25 306.75,376 320,376C333.25,376 344,365.25 344,352C344,338.74 333.25,328 320,328Z"}]},{name:"CalendarCheck",type:"light",viewBox:"0 0 448 512",path:[{d:"M400 64h-48V12c0-6.627-5.373-12-12-12h-8c-6.627 0-12 5.373-12 12v52H128V12c0-6.627-5.373-12-12-12h-8c-6.627 0-12 5.373-12 12v52H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zM48 96h352c8.822 0 16 7.178 16 16v48H32v-48c0-8.822 7.178-16 16-16zm352 384H48c-8.822 0-16-7.178-16-16V192h384v272c0 8.822-7.178 16-16 16zm-66.467-194.937l-134.791 133.71c-4.7 4.663-12.288 4.642-16.963-.046l-67.358-67.552c-4.683-4.697-4.672-12.301.024-16.985l8.505-8.48c4.697-4.683 12.301-4.672 16.984.024l50.442 50.587 117.782-116.837c4.709-4.671 12.313-4.641 16.985.068l8.458 8.527c4.672 4.709 4.641 12.313-.068 16.984z"}]},{name:"ChevronRight",type:"light",viewBox:"0 0 256 512",path:[{d:"M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"}]},{name:"ChevronLeft",type:"light",viewBox:"0 0 256 512",path:[{d:"M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"}]},{name:"Search",type:"light",viewBox:"0 0 512 512",path:[{d:"M508.5 481.6l-129-129c-2.3-2.3-5.3-3.5-8.5-3.5h-10.3C395 312 416 262.5 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c54.5 0 104-21 141.1-55.2V371c0 3.2 1.3 6.2 3.5 8.5l129 129c4.7 4.7 12.3 4.7 17 0l9.9-9.9c4.7-4.7 4.7-12.3 0-17zM208 384c-97.3 0-176-78.7-176-176S110.7 32 208 32s176 78.7 176 176-78.7 176-176 176z"}]},{name:"Ellipsis-H",type:"light",viewBox:"0 0 320 512",path:[{d:"M192 256c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm88-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-240 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"}]},{name:"Bin",type:"light",viewBox:"0 0 448 512",path:[{d:"M296 432h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8zm-160 0h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8zM440 64H336l-33.6-44.8A48 48 0 0 0 264 0h-80a48 48 0 0 0-38.4 19.2L112 64H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v368a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V96h24a8 8 0 0 0 8-8V72a8 8 0 0 0-8-8zM171.2 38.4A16.1 16.1 0 0 1 184 32h80a16.1 16.1 0 0 1 12.8 6.4L296 64H152zM384 464a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16V96h320zm-168-32h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8z"}]},{name:"BuildingWithCar",type:"light",viewBox:"0 0 640 512",path:[{d:"M595.4 294.44l-15.88-68.83A63.71 63.71 0 0 0 517.16 176H344.07a63.7 63.7 0 0 0-62.36 49.61l-16.28 70.55C241 308.44 224 333.49 224 362.67v55.11a46.14 46.14 0 0 0 32 43.75V496a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-32h256v32a16 16 0 0 0 16 16h16a16 16 0 0 0 16-16v-34.47a46.14 46.14 0 0 0 32-43.75v-55.11a74.7 74.7 0 0 0-44.6-68.23zM312.89 232.8a32 32 0 0 1 31.18-24.8h173.09a32 32 0 0 1 31.18 24.8l12.73 55.2H300.15zM608 417.78A14.24 14.24 0 0 1 593.78 432H270.22A14.24 14.24 0 0 1 256 417.78v-55.11A42.72 42.72 0 0 1 298.67 320h266.66A42.72 42.72 0 0 1 608 362.67zM320 48v96h32V48a48 48 0 0 0-48-48H48A48 48 0 0 0 0 48v392a8 8 0 0 0 8 8h16a8 8 0 0 0 8-8V48a16 16 0 0 1 16-16h256a16 16 0 0 1 16 16zM204 96a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm-56 96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm0 96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm160 64a20 20 0 1 0 20 20 20 20 0 0 0-20-20zm248 0a20 20 0 1 0 20 20 20 20 0 0 0-20-20zM148 96h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zm102.53 122.42a96.81 96.81 0 0 1 5.16-15.95A11.86 11.86 0 0 0 244 192h-40a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h37.85z"}]},{name:"Garage",type:"light",viewBox:"0 0 640 512",path:[{d:"M368,416H272a16,16,0,0,0,0,32h96a16,16,0,0,0,0-32ZM610.59,118.33,338.59,3.75a48,48,0,0,0-37.18,0l-272,114.58A47.84,47.84,0,0,0,0,162.53V504a8,8,0,0,0,8,8H24a8,8,0,0,0,8-8V162.53a16,16,0,0,1,9.81-14.79l272-114.6a15.75,15.75,0,0,1,12.38,0l272,114.6A15.91,15.91,0,0,1,608,162.53V504a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V162.53A47.84,47.84,0,0,0,610.59,118.33ZM512,192H128a32,32,0,0,0-32,32V504a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V352H512V504a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V224A32,32,0,0,0,512,192Zm0,128H128V224H512Z"}]},{name:"Parking",type:"light",viewBox:"0 0 496 512",path:[{d:"M268.1 127.91H176c-4.42 0-8 3.58-8 8v240c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-72h72c51.43 0 92.68-44.32 87.57-96.78-4.45-45.71-45.54-79.22-91.47-79.22zm3.9 144h-72v-112h72c30.88 0 56 25.12 56 56s-25.12 56-56 56zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 464c-119.1 0-216-96.9-216-216S128.9 40 248 40s216 96.9 216 216-96.9 216-216 216z"}]},{name:"Warehouse",type:"light",viewBox:"0 0 640 512",path:[{d:"M512 224H128c-17.7 0-32 14.4-32 32v248c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-56h384v56c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V256c0-17.6-14.3-32-32-32zm0 192H128v-64h384v64zm0-96H128v-64h384v64zm98.6-201.7L338.6 3.7c-11.8-5-25.3-5-37.2 0l-272 114.6C11.5 125.8 0 143.2 0 162.5V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V162.5c0-6.5 3.8-12.2 9.8-14.8l272-114.6c3.9-1.7 8.5-1.7 12.4 0l272 114.6c6 2.5 9.8 8.3 9.8 14.8V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V162.5c0-19.3-11.5-36.7-29.4-44.2z"}]},{name:"WarehouseBoxes",type:"light",viewBox:"0 0 640 512",path:[{d:"M528 352H352V240c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zM320 480H128v-96h192v96zm0-128H128v-96h192v96zm192 128H352v-96h160v96zm98.6-361.7L338.6 3.7c-11.8-5-25.3-5-37.2 0l-272 114.6C11.5 125.8 0 143.2 0 162.5V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V162.5c0-6.5 3.8-12.2 9.8-14.8l272-114.6c3.9-1.7 8.5-1.7 12.4 0l272 114.6c6 2.5 9.8 8.3 9.8 14.8V504c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V162.5c0-19.3-11.5-36.7-29.4-44.2z"}]},{name:"Plug",type:"light",viewBox:"0 0 384 512",path:[{d:"M352,128H304V16a16,16,0,0,0-32,0V128H112V16a16,16,0,0,0-32,0V128H32A32,32,0,0,0,0,160v32a32,32,0,0,0,32,32v32c0,82.75,63.37,150.22,144,158.38V512h32V414.38c80.63-8.16,144-75.63,144-158.38V224a32,32,0,0,0,32-32V160A32,32,0,0,0,352,128ZM320,256a128,128,0,0,1-256,0V224H320Zm32-64H32V160H352Z"}]},{name:"HouseSignal",type:"light",viewBox:"0 0 640 512",path:[{d:"M0,224v32c141.38,0,256,114.62,256,256h32C288,352.94,159.06,224,0,224Zm0,96v32A160,160,0,0,1,160,512h32C192,406,106,320,0,320Zm0,96v32a64,64,0,0,1,64,64H96A96,96,0,0,0,0,416ZM634.53,200,576,148.76V48a16,16,0,1,0-32,0v72.74L410.53,4a16,16,0,0,0-21.06,0L224,148.76h0L165.47,200a16,16,0,1,0,21.06,24.09L224,191.29h0v70.79a337.37,337.37,0,0,1,32,32.61V168a15.35,15.35,0,0,0-.81-4L400,37.27l144,126V368a16,16,0,0,1-16,16H310.61a333,333,0,0,1,11.29,32H528a48.05,48.05,0,0,0,48-48V191.28l37.46,32.79A16,16,0,0,0,634.53,200ZM442.67,288A21.39,21.39,0,0,0,464,266.67V181.34A21.39,21.39,0,0,0,442.67,160h-85.3A21.39,21.39,0,0,0,336,181.34v85.33A21.39,21.39,0,0,0,357.37,288ZM368,192H432v64H368Z"}]},{name:"Ballot",type:"light",viewBox:"0 0 448 512",path:[{d:"M144 80h-32c-17.7 0-32 14.4-32 32v32c0 17.6 14.3 32 32 32h32c17.7 0 32-14.4 32-32v-32c0-17.6-14.3-32-32-32zm0 64h-32v-32h32v32zM416 0H32C14.3 0 0 14.4 0 32v448c0 17.6 14.3 32 32 32h384c17.7 0 32-14.4 32-32V32c0-17.6-14.3-32-32-32zm0 480H32V32h384v448zm-72-240H216c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h128c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-200 96h-32c-17.7 0-32 14.4-32 32v32c0 17.6 14.3 32 32 32h32c17.7 0 32-14.4 32-32v-32c0-17.6-14.3-32-32-32zm0 64h-32v-32h32v32zm200-32H216c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h128c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm0-256H216c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h128c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm-200 96h-32c-17.7 0-32 14.4-32 32v32c0 17.6 14.3 32 32 32h32c17.7 0 32-14.4 32-32v-32c0-17.6-14.3-32-32-32zm0 64h-32v-32h32v32z"}]},{name:"Card",type:"light",viewBox:"0 0 576 512",path:[{d:"M528 31H48C21.5 31 0 52.5 0 79v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V79c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V79c0-8.8 7.2-16 16-16h480c8.8 0 16 7.2 16 16v352zm-352-68v8c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v8c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12z"}]},{name:"CalendarDay",type:"light",viewBox:"0 0 448 512",path:[{d:"M400 64h-48V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v56H128V8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v56H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V192h384v272zm0-304H32v-48c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v48zM112 384h96c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16zm16-96h64v64h-64v-64z"}]},{name:"CalendarClear",type:"light",viewBox:"0 0 1664 1792",path:[{d:"m1111 1385l-46 46q-9 9-22 9t-23-9l-188-189l-188 189q-10 9-23 9t-22-9l-46-46q-9-9-9-22t9-23l189-188l-189-188q-9-10-9-23t9-22l46-46q9-9 22-9t23 9l188 188l188-188q10-9 23-9t22 9l46 46q9 9 9 22t-9 23l-188 188l188 188q9 10 9 23t-9 22zm-983 279h1408V640H128v1024zM512 448V160q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v288q0 14 9 23t23 9h64q14 0 23-9t9-23zm768 0V160q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v288q0 14 9 23t23 9h64q14 0 23-9t9-23zm384-64v1280q0 52-38 90t-90 38H128q-52 0-90-38t-38-90V384q0-52 38-90t90-38h128v-96q0-66 47-113T416 0h64q66 0 113 47t47 113v96h384v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h128q52 0 90 38t38 90z"}]},{name:"Cog",type:"light",viewBox:"0 0 512 512",path:[{d:"M482.696 299.276l-32.61-18.827a195.168 195.168 0 0 0 0-48.899l32.61-18.827c9.576-5.528 14.195-16.902 11.046-27.501-11.214-37.749-31.175-71.728-57.535-99.595-7.634-8.07-19.817-9.836-29.437-4.282l-32.562 18.798a194.125 194.125 0 0 0-42.339-24.48V38.049c0-11.13-7.652-20.804-18.484-23.367-37.644-8.909-77.118-8.91-114.77 0-10.831 2.563-18.484 12.236-18.484 23.367v37.614a194.101 194.101 0 0 0-42.339 24.48L105.23 81.345c-9.621-5.554-21.804-3.788-29.437 4.282-26.36 27.867-46.321 61.847-57.535 99.595-3.149 10.599 1.47 21.972 11.046 27.501l32.61 18.827a195.168 195.168 0 0 0 0 48.899l-32.61 18.827c-9.576 5.528-14.195 16.902-11.046 27.501 11.214 37.748 31.175 71.728 57.535 99.595 7.634 8.07 19.817 9.836 29.437 4.283l32.562-18.798a194.08 194.08 0 0 0 42.339 24.479v37.614c0 11.13 7.652 20.804 18.484 23.367 37.645 8.909 77.118 8.91 114.77 0 10.831-2.563 18.484-12.236 18.484-23.367v-37.614a194.138 194.138 0 0 0 42.339-24.479l32.562 18.798c9.62 5.554 21.803 3.788 29.437-4.283 26.36-27.867 46.321-61.847 57.535-99.595 3.149-10.599-1.47-21.972-11.046-27.501zm-65.479 100.461l-46.309-26.74c-26.988 23.071-36.559 28.876-71.039 41.059v53.479a217.145 217.145 0 0 1-87.738 0v-53.479c-33.621-11.879-43.355-17.395-71.039-41.059l-46.309 26.74c-19.71-22.09-34.689-47.989-43.929-75.958l46.329-26.74c-6.535-35.417-6.538-46.644 0-82.079l-46.329-26.74c9.24-27.969 24.22-53.869 43.929-75.969l46.309 26.76c27.377-23.434 37.063-29.065 71.039-41.069V44.464a216.79 216.79 0 0 1 87.738 0v53.479c33.978 12.005 43.665 17.637 71.039 41.069l46.309-26.76c19.709 22.099 34.689 47.999 43.929 75.969l-46.329 26.74c6.536 35.426 6.538 46.644 0 82.079l46.329 26.74c-9.24 27.968-24.219 53.868-43.929 75.957zM256 160c-52.935 0-96 43.065-96 96s43.065 96 96 96 96-43.065 96-96-43.065-96-96-96zm0 160c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z"}]},{name:"Scroll",type:"light",viewBox:"0 0 640 512",path:[{d:"M608 352h-64V112C544 50.25 493.75 0 432 0H80C35.88 0 0 35.89 0 80v80c0 17.64 14.34 32 32 32h96v224c0 51.11 40.25 92.62 90.66 95.46v.54h312C590.94 512 640 462.95 640 402.67V384c0-17.64-14.34-32-32-32zM128 160H32V80c0-26.47 21.53-48 48-48s48 21.53 48 48v80zm160 256c0 35.3-28.72 64-64 64s-64-28.7-64-64V80c0-18-5.97-34.62-16.03-48H432c44.12 0 80 35.89 80 80v240H320c-17.66 0-32 14.36-32 32v32zm320-13.33c0 42.64-34.69 77.33-77.34 77.33H295.03c15.35-17.02 24.97-39.32 24.97-64v-32h288v18.67z"}]},{name:"Pencil",type:"light",viewBox:"0 0 512 512",path:[{d:"M493.255 56.236l-37.49-37.49c-24.993-24.993-65.515-24.994-90.51 0L12.838 371.162.151 485.346c-1.698 15.286 11.22 28.203 26.504 26.504l114.184-12.687 352.417-352.417c24.992-24.994 24.992-65.517-.001-90.51zM164.686 347.313c6.249 6.249 16.379 6.248 22.627 0L368 166.627l30.059 30.059L174 420.745V386h-48v-48H91.255l224.059-224.059L345.373 144 164.686 324.687c-6.249 6.248-6.249 16.378 0 22.626zm-38.539 121.285l-58.995 6.555-30.305-30.305 6.555-58.995L63.255 366H98v48h48v34.745l-19.853 19.853zm344.48-344.48l-49.941 49.941-82.745-82.745 49.941-49.941c12.505-12.505 32.748-12.507 45.255 0l37.49 37.49c12.506 12.506 12.507 32.747 0 45.255z"}]},{name:"Info",type:"light",viewBox:"0 0 192 512",path:[{d:"M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"}]},{name:"Folder",type:"light",viewBox:"0 0 512 512",path:[{d:"M194.74 96l54.63 54.63c6 6 14.14 9.37 22.63 9.37h192c8.84 0 16 7.16 16 16v224c0 8.84-7.16 16-16 16H48c-8.84 0-16-7.16-16-16V112c0-8.84 7.16-16 16-16h146.74M48 64C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48H272l-54.63-54.63c-6-6-14.14-9.37-22.63-9.37H48z"}]},{name:"InfoCircle",type:"light",viewBox:"0 0 512 512",path:[{d:"M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-36 344h12V232h-12c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h48c6.627 0 12 5.373 12 12v140h12c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12h-72c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12zm36-240c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"}]},{name:"ExclamationCircle",type:"light",viewBox:"0 0 512 512",path:[{d:"M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z"}]},{name:"ExclamationTriangle",type:"light",viewBox:"0 0 576 512",path:[{d:"M270.2 160h35.5c3.4 0 6.1 2.8 6 6.2l-7.5 196c-.1 3.2-2.8 5.8-6 5.8h-20.5c-3.2 0-5.9-2.5-6-5.8l-7.5-196c-.1-3.4 2.6-6.2 6-6.2zM288 388c-15.5 0-28 12.5-28 28s12.5 28 28 28 28-12.5 28-28-12.5-28-28-28zm281.5 52L329.6 24c-18.4-32-64.7-32-83.2 0L6.5 440c-18.4 31.9 4.6 72 41.6 72H528c36.8 0 60-40 41.5-72zM528 480H48c-12.3 0-20-13.3-13.9-24l240-416c6.1-10.6 21.6-10.7 27.7 0l240 416c6.2 10.6-1.5 24-13.8 24z"}]},{name:"ExclamationTriangle",type:"solid",viewBox:"0 0 576 512",path:[{d:"M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"}]},{name:"Plus",type:"light",viewBox:"0 0 384 512",path:[{d:"M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"}]},{name:"RocketLaunch",type:"light",viewBox:"0 0 512 512",path:[{d:"M368.05829,88.0293a55.99512,55.99512,0,1,0,55.99215,55.99414A56.01694,56.01694,0,0,0,368.05829,88.0293Zm0,79.99218a23.998,23.998,0,1,1,23.99608-23.998A24.02247,24.02247,0,0,1,368.05829,168.02148ZM505.1656,19.29492C503.98982,13.832,498.18123,8.0293,492.71835,6.86133,460.63244,0,435.48793,0,410.45084,0,307.26342,0,245.38261,55.19727,199.18734,127.98828H95.01555c-16.293,0-35.58786,11.92188-42.87692,26.4961L2.73242,253.27344A28.4,28.4,0,0,0,.2168,263.97656a24.00493,24.00493,0,0,0,23.99607,23.998H128.13466a95.98845,95.98845,0,0,1,95.98625,95.99023V487.95508a24.00243,24.00243,0,0,0,23.99608,23.998,28.53884,28.53884,0,0,0,10.70116-2.51562l98.71671-49.40039c14.55663-7.28516,26.46678-26.5625,26.46678-42.83984V312.76758C456.568,266.46094,511.982,204.37109,511.982,101.69336,512.0738,76.54492,512.0738,51.39648,505.1656,19.29492ZM37.15427,255.97656l43.60152-87.18164c1.85156-3.70508,10.11523-8.81054,14.25976-8.81054h85.08c-13.93554,28.06054-31.71287,63.99609-47.55465,95.99218l.0664.45313C131.08778,256.377,61.01753,255.97656,37.15427,255.97656Zm314.8513,161.22071c0,4.13085-5.09179,12.375-8.789,14.22461L256.115,475.01172c0-23.90234-.4043-94.06055-.46094-95.60938l.36719.04688c31.99606-15.82617,67.80267-33.58984,95.85929-47.541l.125.002Zm-102.078-70.51368a127.62739,127.62739,0,0,0-84.6347-84.55468c52.02731-103.98633,99.76945-230.13282,245.158-230.13282,21.164,0,41.29684,0,65.41987,4.1875,4.26562,24.377,4.1914,44.38477,4.11523,65.50977C479.98594,246.66406,353.00752,295.1543,249.92753,346.68359Zm-147.494-26.71289C54.35347,319.9707,2.03125,359.31836.168,480H0v32H32v-.23242C203.617,508.42969,216.8885,396.74414,165.80065,345.40039,150.85925,330.38477,127.22255,319.9707,102.43351,319.9707Zm52.914,109.39844c-12.83593,31.14844-57.63667,49.42969-123.36709,50.55078.06446-3.55469-1.11914-127.88867,70.45307-127.88867,15.09569,0,31.11521,6.29492,40.81051,16.03906C156.05456,380.94336,164.6483,406.80273,155.34753,429.36914Z"}]},{name:"QuestionMarkCircle",type:"light",viewBox:"0 0 512 512",path:[{d:"M256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28zm7.67-24h-16c-6.627 0-12-5.373-12-12v-.381c0-70.343 77.44-63.619 77.44-107.408 0-20.016-17.761-40.211-57.44-40.211-29.144 0-44.265 9.649-59.211 28.692-3.908 4.98-11.054 5.995-16.248 2.376l-13.134-9.15c-5.625-3.919-6.86-11.771-2.645-17.177C185.658 133.514 210.842 116 255.67 116c52.32 0 97.44 29.751 97.44 80.211 0 67.414-77.44 63.849-77.44 107.408V304c0 6.627-5.373 12-12 12zM256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8z"}]},{name:"HandHoldingSeedling",type:"light",viewBox:"0 0 576 512",path:[{d:"M248.9 192H272v56c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-56h23.1C411.4 192 480 113 480 16V0h-55.1C364.9 0 313 40.1 288 98.1 263 40.1 211.1 0 151.1 0H96v16c0 97 68.6 176 152.9 176zm176-160h22.4c-6.7 71.9-58 128-120.1 128h-22.4c6.6-71.9 58-128 120.1-128zm-273.8 0c62.1 0 113.4 56.1 120.1 128h-22.4c-62.1 0-113.4-56.1-120.1-128h22.4zm407.2 301.6c-9.6-8.6-22.1-13.4-35.2-13.4-12.5 0-24.8 4.3-34.6 12.2l-61.6 49.3c-1.9 1.5-4.2 2.3-6.7 2.3h-41.6c4.6-9.6 6.5-20.7 4.8-32.3-4-27.9-29.6-47.7-57.8-47.7H181.3c-20.8 0-41 6.7-57.6 19.2L85.3 352H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h88l46.9-35.2c11.1-8.3 24.6-12.8 38.4-12.8H328c13.3 0 24 10.7 24 24s-10.7 24-24 24h-88c-8.8 0-16 7.2-16 16s7.2 16 16 16h180.2c9.7 0 19.1-3.3 26.7-9.3l61.6-49.2c4.2-3.4 9.5-5.2 14.6-5.2 5 0 9.9 1.7 13.8 5.2 10.1 9.1 9.3 24.5-.9 32.6l-100.8 80.7c-7.6 6.1-17 9.3-26.7 9.3H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h400.5c17 0 33.4-5.8 46.6-16.4L556 415c12.2-9.8 19.5-24.4 20-40s-6-30.8-17.7-41.4z"}]},{name:"Phone",type:"light",viewBox:"0 0 512 512",path:[{d:"M493.09 351.3L384.7 304.8a31.36 31.36 0 0 0-36.5 8.9l-44.1 53.9A350 350 0 0 1 144.5 208l53.9-44.1a31.35 31.35 0 0 0 8.9-36.49l-46.5-108.5A31.33 31.33 0 0 0 125 .81L24.2 24.11A31.05 31.05 0 0 0 0 54.51C0 307.8 205.3 512 457.49 512A31.23 31.23 0 0 0 488 487.7L511.19 387a31.21 31.21 0 0 0-18.1-35.7zM456.89 480C222.4 479.7 32.3 289.7 32.1 55.21l99.6-23 46 107.39-72.8 59.5C153.3 302.3 209.4 358.6 313 407.2l59.5-72.8 107.39 46z"}]},{name:"Envelope",type:"light",viewBox:"0 0 512 512",path:[{d:"M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM48 96h416c8.8 0 16 7.2 16 16v41.4c-21.9 18.5-53.2 44-150.6 121.3-16.9 13.4-50.2 45.7-73.4 45.3-23.2.4-56.6-31.9-73.4-45.3C85.2 197.4 53.9 171.9 32 153.4V112c0-8.8 7.2-16 16-16zm416 320H48c-8.8 0-16-7.2-16-16V195c22.8 18.7 58.8 47.6 130.7 104.7 20.5 16.4 56.7 52.5 93.3 52.3 36.4.3 72.3-35.5 93.3-52.3 71.9-57.1 107.9-86 130.7-104.7v205c0 8.8-7.2 16-16 16z"}]},{name:"EnvelopeOpen",type:"light",viewBox:"0 0 512 512",path:[{d:"M349.32 52.26C328.278 35.495 292.938 0 256 0c-36.665 0-71.446 34.769-93.31 52.26-34.586 27.455-109.525 87.898-145.097 117.015A47.99 47.99 0 0 0 0 206.416V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V206.413a47.989 47.989 0 0 0-17.597-37.144C458.832 140.157 383.906 79.715 349.32 52.26zM464 480H48c-8.837 0-16-7.163-16-16V206.161c0-4.806 2.155-9.353 5.878-12.392C64.16 172.315 159.658 95.526 182.59 77.32 200.211 63.27 232.317 32 256 32c23.686 0 55.789 31.27 73.41 45.32 22.932 18.207 118.436 95.008 144.714 116.468a15.99 15.99 0 0 1 5.876 12.39V464c0 8.837-7.163 16-16 16zm-8.753-216.312c4.189 5.156 3.393 12.732-1.776 16.905-22.827 18.426-55.135 44.236-104.156 83.148-21.045 16.8-56.871 52.518-93.318 52.258-36.58.264-72.826-35.908-93.318-52.263-49.015-38.908-81.321-64.716-104.149-83.143-5.169-4.173-5.966-11.749-1.776-16.905l5.047-6.212c4.169-5.131 11.704-5.925 16.848-1.772 22.763 18.376 55.014 44.143 103.938 82.978 16.85 13.437 50.201 45.69 73.413 45.315 23.219.371 56.562-31.877 73.413-45.315 48.929-38.839 81.178-64.605 103.938-82.978 5.145-4.153 12.679-3.359 16.848 1.772l5.048 6.212z"}]},{name:"Bug",type:"solid",viewBox:"0 0 576 512",path:[{d:"M511.988 288.9c-.478 17.43-15.217 31.1-32.653 31.1H424v16c0 21.864-4.882 42.584-13.6 61.145l60.228 60.228c12.496 12.497 12.496 32.758 0 45.255-12.498 12.497-32.759 12.496-45.256 0l-54.736-54.736C345.886 467.965 314.351 480 280 480V236c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v244c-34.351 0-65.886-12.035-90.636-32.108l-54.736 54.736c-12.498 12.497-32.759 12.496-45.256 0-12.496-12.497-12.496-32.758 0-45.255l60.228-60.228C92.882 378.584 88 357.864 88 336v-16H32.666C15.23 320 .491 306.33.013 288.9-.484 270.816 14.028 256 32 256h56v-58.745l-46.628-46.628c-12.496-12.497-12.496-32.758 0-45.255 12.498-12.497 32.758-12.497 45.256 0L141.255 160h229.489l54.627-54.627c12.498-12.497 32.758-12.497 45.256 0 12.496 12.497 12.496 32.758 0 45.255L424 197.255V256h56c17.972 0 32.484 14.816 31.988 32.9zM257 0c-61.856 0-112 50.144-112 112h224C369 50.144 318.856 0 257 0z"}]},{name:"Flag",type:"solid",viewBox:"0 0 512 512",path:[{d:"M32 0C14.3 0 0 14.3 0 32v464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32C64 14.3 49.7 0 32 0zm430.6 4.2C291.3 91.5 305.4-62.2 96 32.4V384c185.7-92.2 221.7 53.3 397.5-23.1 11.4-5 18.5-16.5 18.5-28.8V30.8c0-25.1-26.8-38.1-49.4-26.6z"}]},{name:"QuoteRight",type:"solid",viewBox:"0 0 512 512",path:[{d:"M464 32H336c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48zm-288 0H48C21.5 32 0 53.5 0 80v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48z"}]},{name:"QuoteLeft",type:"solid",viewBox:"0 0 512 512",path:[{d:"M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"}]},{name:"Lock",type:"light",viewBox:"0 0 384 512",path:[{d:"M336,256L96,256C96,185.4 120.9,108.388 191.5,108.388C262.1,108.388 288,185.4 288,256L320,256C320,167.6 280.4,76.688 192,76.388C103.5,76.088 64,167.6 64,256L48,256C21.5,256 0,277.5 0,304L0,464C0,490.5 21.5,512 48,512L336,512C362.5,512 384,490.5 384,464L384,304C384,277.5 362.5,256 336,256ZM352,464C352,472.8 344.8,480 336,480L48,480C39.2,480 32,472.8 32,464L32,304C32,295.2 39.2,288 48,288L336,288C344.8,288 352,295.2 352,304L352,464ZM192,432C183.2,432 176,424.8 176,416L176,352C176,343.2 183.2,336 192,336C200.8,336 208,343.2 208,352L208,416C208,424.8 200.8,432 192,432Z"}]},{name:"Lock",type:"solid",viewBox:"0 0 448 512",path:[{d:"M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zM264 392c0 22.1-17.9 40-40 40s-40-17.9-40-40v-48c0-22.1 17.9-40 40-40s40 17.9 40 40v48zm32-168H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"}]},{name:"Unlock",type:"light",viewBox:"0 0 384 512",path:[{d:"M336 256H96v-96c0-70.6 25.4-128 96-128s96 57.4 96 128v20c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12v-18.5C320 73.1 280.9.3 192.5 0 104-.3 64 71.6 64 160v96H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm16 208c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v160zm-160-32c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 8.8-7.2 16-16 16z"}]},{name:"Unlock",type:"solid",viewBox:"0 0 448 512",path:[{d:"M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zM264 408c0 22.1-17.9 40-40 40s-40-17.9-40-40v-48c0-22.1 17.9-40 40-40s40 17.9 40 40v48z"}]},{name:"ChartBar",type:"light",viewBox:"0 0 512 512",path:[{d:"M424 352h16c4.4 0 8-3.6 8-8V104c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8zm-96 0h16c4.4 0 8-3.6 8-8V200c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8zm-192 0h16c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8zm96 0h16c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v208c0 4.4 3.6 8 8 8zm272 64H32V72c0-4.42-3.58-8-8-8H8c-4.42 0-8 3.58-8 8v360c0 8.84 7.16 16 16 16h488c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8z"}]},{name:"WindTurbine",type:"light",viewBox:"0 0 514 512",path:[{d:"M323.48 430.84a45.94 45.94 0 0 0 77.94-47l-67.74-155.58a16.75 16.75 0 0 1-.22-12.89L393.92 62.7A45.82 45.82 0 0 0 314.18 19L218 152.06a16.9 16.9 0 0 1-11 6.74L39.45 185.34a45.93 45.93 0 0 0 2.24 91L207 294.27 195 480h-32.3a36.94 36.94 0 0 0-33 20.42 8 8 0 0 0 7.11 11.58h240a8 8 0 0 0 7.15-11.58 36.93 36.93 0 0 0-33-20.42h-32.33l-3.86-59.58 7 8.3zM227 480l9.83-151.64 43.16 51L286.56 480zm17-199.46a48.85 48.85 0 0 0-32.84-18l-166-18a13.83 13.83 0 0 1-12.35-13.44v-.2a13.82 13.82 0 0 1 11.65-14L212 190.41a48.75 48.75 0 0 0 31.91-19.6l96.2-133.09a13.83 13.83 0 0 1 24.06 13.19l-60.46 152.68a48.77 48.77 0 0 0 .64 37.45l67.73 155.52a13.82 13.82 0 0 1-5.49 17.33l-.17.1a13.83 13.83 0 0 1-18-3.17zM256.8 200a24 24 0 1 0 24 24 24 24 0 0 0-24-24z"}]},{name:"Link",type:"light",viewBox:"0 0 512 512",path:[{d:"M301.148 394.702l-79.2 79.19c-50.778 50.799-133.037 50.824-183.84 0-50.799-50.778-50.824-133.037 0-183.84l79.19-79.2a132.833 132.833 0 0 1 3.532-3.403c7.55-7.005 19.795-2.004 20.208 8.286.193 4.807.598 9.607 1.216 14.384.481 3.717-.746 7.447-3.397 10.096-16.48 16.469-75.142 75.128-75.3 75.286-36.738 36.759-36.731 96.188 0 132.94 36.759 36.738 96.188 36.731 132.94 0l79.2-79.2.36-.36c36.301-36.672 36.14-96.07-.37-132.58-8.214-8.214-17.577-14.58-27.585-19.109-4.566-2.066-7.426-6.667-7.134-11.67a62.197 62.197 0 0 1 2.826-15.259c2.103-6.601 9.531-9.961 15.919-7.28 15.073 6.324 29.187 15.62 41.435 27.868 50.688 50.689 50.679 133.17 0 183.851zm-90.296-93.554c12.248 12.248 26.362 21.544 41.435 27.868 6.388 2.68 13.816-.68 15.919-7.28a62.197 62.197 0 0 0 2.826-15.259c.292-5.003-2.569-9.604-7.134-11.67-10.008-4.528-19.371-10.894-27.585-19.109-36.51-36.51-36.671-95.908-.37-132.58l.36-.36 79.2-79.2c36.752-36.731 96.181-36.738 132.94 0 36.731 36.752 36.738 96.181 0 132.94-.157.157-58.819 58.817-75.3 75.286-2.651 2.65-3.878 6.379-3.397 10.096a163.156 163.156 0 0 1 1.216 14.384c.413 10.291 12.659 15.291 20.208 8.286a131.324 131.324 0 0 0 3.532-3.403l79.19-79.2c50.824-50.803 50.799-133.062 0-183.84-50.802-50.824-133.062-50.799-183.84 0l-79.2 79.19c-50.679 50.682-50.688 133.163 0 183.851z"}]},{name:"Unlink",type:"light",viewBox:"0 0 512 512",path:[{d:"M207.889 137.235c-4.686-4.686-4.686-12.284 0-16.971l82.159-82.159c50.81-50.813 133.046-50.803 183.848 0 50.812 50.81 50.802 133.048-.001 183.847l-82.159 82.159c-4.686 4.686-12.284 4.686-16.971 0l-8.485-8.485c-4.686-4.686-4.686-12.284 0-16.971l82.159-82.159c36.739-36.741 36.735-96.2 0-132.936-36.741-36.741-96.199-36.736-132.937-.001l-82.159 82.159c-4.686 4.686-12.284 4.686-16.971 0l-8.483-8.483zm-11.391 311.294c-36.65 36.65-96.286 36.651-132.937-.001-36.736-36.736-36.739-96.194 0-132.936l82.19-82.19c4.686-4.686 4.686-12.284 0-16.971l-8.485-8.485c-4.686-4.686-12.284-4.686-16.971 0l-82.19 82.189c-50.802 50.8-50.813 133.038 0 183.848 50.686 50.688 133.162 50.687 183.847 0l82.19-82.19c4.686-4.686 4.686-12.284 0-16.971l-8.484-8.484c-4.686-4.686-12.284-4.686-16.971 0l-82.189 82.191zM11.999 3.515L3.514 12c-4.686 4.686-4.686 12.284 0 16.971L483.03 508.485c4.686 4.686 12.284 4.686 16.971 0l8.485-8.485c4.686-4.686 4.686-12.284 0-16.971L28.97 3.515c-4.686-4.687-12.284-4.687-16.971 0z"}]},{name:"Comments",type:"light",viewBox:"0 0 576 512",path:[{d:"M512 160h-96V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v160c0 35.3 28.7 64 64 64h32v52c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4l76.9-43.5V384c0 35.3 28.7 64 64 64h96l108.9 61.6c2.2 1.6 4.7 2.4 7.1 2.4 6.2 0 12-4.9 12-12v-52h32c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64zM64 256c-17.6 0-32-14.4-32-32V64c0-17.6 14.4-32 32-32h288c17.6 0 32 14.4 32 32v160c0 17.6-14.4 32-32 32H215.6l-7.3 4.2-80.3 45.4V256zm480 128c0 17.6-14.4 32-32 32h-64v49.6l-80.2-45.4-7.3-4.2H256c-17.6 0-32-14.4-32-32v-96h128c35.3 0 64-28.7 64-64v-32h96c17.6 0 32 14.4 32 32z"}]},{name:"Comments",type:"solid",viewBox:"0 0 576 512",path:[{d:"M416 224V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v160c0 35.3 28.7 64 64 64v54.2c0 8 9.1 12.6 15.5 7.8l82.8-62.1H352c35.3.1 64-28.6 64-63.9zm96-64h-64v64c0 52.9-43.1 96-96 96H192v64c0 35.3 28.7 64 64 64h125.7l82.8 62.1c6.4 4.8 15.5.2 15.5-7.8V448h32c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64z"}]},{name:"Square",type:"solid",viewBox:"0 0 448 512",path:[{d:"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"}]},{name:"Snooze",type:"light",viewBox:"0 0 448 512",path:[{d:"M176 272H24a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h131.19L3.72 469.75A16.06 16.06 0 0 0 0 480v16a16 16 0 0 0 16 16h168a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H36.81l151.48-165.77A15.94 15.94 0 0 0 192 304v-16a16 16 0 0 0-16-16zM272 0H168a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h78l-98.56 125.2a16.07 16.07 0 0 0-3.44 9.91V176a16 16 0 0 0 16 16h120a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-94l98.56-125.2a16.07 16.07 0 0 0 3.44-9.91V16a16 16 0 0 0-16-16zm176 248.89V240a16 16 0 0 0-16-16H328a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h78l-98.56 125.2a16.07 16.07 0 0 0-3.44 9.91V400a16 16 0 0 0 16 16h120a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8h-94l98.59-125.2a16.07 16.07 0 0 0 3.41-9.91z"}]},{name:"CarBump",type:"light",viewBox:"0 0 576 512",path:[{d:"M157.56 410.15l233.93-105.9 13.63 28.39c11.28 23.48 40.13 33.68 64.31 22.73l14.62-6.62c24.19-10.95 34.69-38.96 23.41-62.44L446.1 158.56c-15.37-32-50.16-48.79-84.38-44.08L306.3 56.86c-23.84-24.78-61.39-31.85-93.04-17.52L63.1 107.32c-31.65 14.33-50.21 46.8-45.98 80.46l9.84 78.25C1.24 288.46-7.87 325.13 7.5 357.12l61.36 127.75c11.28 23.48 40.13 33.68 64.31 22.73l14.62-6.62c24.19-10.95 34.69-38.96 23.41-62.44l-13.64-28.39zm320.67-110.61c3.76 7.83.25 17.17-7.8 20.81l-14.62 6.62c-8.05 3.65-17.68.26-21.44-7.57l-13.63-28.39 43.86-19.86 13.63 28.39zM76.73 135.71L226.9 67.73c19.04-8.62 41.48-4.4 55.82 10.51l45.49 47.29L57.22 248.21l-8.08-64.22c-2.54-20.26 8.55-39.66 27.59-48.28zm57.43 336.88l-14.62 6.62c-8.05 3.65-17.68.26-21.44-7.58l-13.64-28.39 43.86-19.86 13.63 28.39c3.77 7.84.26 17.18-7.79 20.82zm-63.33-57.73l-34.09-70.97c-11.28-23.48-.78-51.49 23.41-62.44l292.41-132.38c24.19-10.95 53.04-.75 64.31 22.73l20.45 42.58 13.63 28.39-43.86 19.86-29.24 13.24L70.83 414.86zm327.25-217.32c-9.87-20.54-34.24-27.65-57.96-16.91-22.02 9.97-40.54 43.45-30.02 65.35 5.1 10.63 19.01 26.03 54.84 9.81l9.22-4.28c23.73-10.74 33.78-33.43 23.92-53.97zm-34.14 32.68c-2.85 1.29-6.01 2.83-9.22 4.28-9.62 4.36-19.63 7.92-22.69 1.55-4.08-8.49 6.91-28.97 18.31-34.13 11.4-5.16 21.72-2.95 25.8 5.54s-.8 17.6-12.2 22.76zm-270.9 62.27c-23.72 10.74-33.78 33.44-23.91 53.97 9.87 20.54 34.24 27.65 57.96 16.91l9.3-4.11c35.83-16.22 32.61-36.47 27.51-47.09-10.52-21.9-48.83-29.65-70.86-19.68zm33.13 45.48c-3.21 1.45-6.46 2.81-9.3 4.11-11.4 5.16-21.72 2.94-25.8-5.55-4.08-8.49.81-17.59 12.21-22.75s34.62-.17 38.7 8.32c3.05 6.36-6.19 11.52-15.81 15.87zm449.49 154.78c-10.72-51.84-57.56-89.47-111.34-89.47S363.72 440.91 353 492.75c-1.81 8.66 3.75 17.12 12.41 18.92 8.5 1.73 17.09-3.77 18.91-12.42 7.69-37.06 41.31-63.97 80-63.97s72.34 26.91 80.03 63.97c1.56 7.55 8.22 12.75 15.63 12.75 1.09 0 2.19-.11 3.28-.33 8.65-1.79 14.21-10.26 12.4-18.92z"}]},{name:"PowerOff",type:"light",viewBox:"0 0 512 512",path:[{d:"M388.5 46.3C457.9 90.3 504 167.8 504 256c0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 168 54 90.3 123.5 46.3c5.8-3.7 13.5-1.8 16.9 4.2l3.9 7c3.1 5.6 1.3 12.6-4.1 16C79.9 112 40 179.6 40 256c0 119.9 97.3 216 216 216 119.9 0 216-97.3 216-216 0-77-40.1-144.2-100.3-182.4-5.4-3.4-7.2-10.5-4.1-16l3.9-7c3.4-6.1 11.2-7.9 17-4.3zM272 276V12c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v264c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12z"}]},{name:"Sync",type:"light",viewBox:"0 0 512 512",path:[{d:"M492 8h-10c-6.627 0-12 5.373-12 12v110.627C426.929 57.261 347.224 8 256 8 123.228 8 14.824 112.338 8.31 243.493 7.971 250.311 13.475 256 20.301 256h10.016c6.353 0 11.646-4.949 11.977-11.293C48.157 132.216 141.097 42 256 42c82.862 0 154.737 47.077 190.289 116H332c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h160c6.627 0 12-5.373 12-12V20c0-6.627-5.373-12-12-12zm-.301 248h-10.015c-6.352 0-11.647 4.949-11.977 11.293C463.841 380.158 370.546 470 256 470c-82.608 0-154.672-46.952-190.299-116H180c6.627 0 12-5.373 12-12v-10c0-6.627-5.373-12-12-12H20c-6.627 0-12 5.373-12 12v160c0 6.627 5.373 12 12 12h10c6.627 0 12-5.373 12-12V381.373C85.071 454.739 164.777 504 256 504c132.773 0 241.176-104.338 247.69-235.493.339-6.818-5.165-12.507-11.991-12.507z"}]},{name:"Clock",type:"light",viewBox:"0 0 512 512",path:[{d:"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216zm-148.9 88.3l-81.2-59c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h14c6.6 0 12 5.4 12 12v146.3l70.5 51.3c5.4 3.9 6.5 11.4 2.6 16.8l-8.2 11.3c-3.9 5.3-11.4 6.5-16.8 2.6z"}]},{name:"ParkingSquare",type:"light",viewBox:"0 0 448 512",path:[{d:"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v352zM244.1 127.9H152c-4.4 0-8 3.6-8 8v240c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-72h72c51.4 0 92.7-44.3 87.6-96.8-4.4-45.7-45.5-79.2-91.5-79.2zM248 272h-72V160h72c30.9 0 56 25.1 56 56s-25.1 56-56 56z"}]},{name:"PhoneLaptop",type:"light",viewBox:"0 0 640 512",path:[{d:"M608 128H416a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h192a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32zm0 352H416V160h192zM96 32h384v64h32V32a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v256H16a16 16 0 0 0-16 16v16a64.14 64.14 0 0 0 63.91 64H352v-32H63.91A32 32 0 0 1 32 320h320v-32H96z"}]},{name:"ParkingSlash",type:"light",viewBox:"0 0 640 512",path:[{d:"M496 64c8.8 0 16 7.2 16 16v266.1l32 25.2V80c0-26.5-21.5-48-48-48H144.1c-8.4 0-16.2 2.4-23.1 6.2L153.8 64zm-82.2 204.8c12.9-16.9 20.1-38.3 17.8-61.6-4.5-45.7-45.5-79.2-91.5-79.2H248c-3.3 0-5.5 2.2-6.8 5l34.3 27H344c30.9 0 56 25.1 56 56 0 12.5-4.2 23.9-11.2 33.2zM637 485.2L23 1.8C19.6-1 14.5-.5 11.8 3l-10 12.5C-1 19-.4 24 3 26.7l614 483.5c3.4 2.8 8.5 2.2 11.2-1.2l10-12.5c2.8-3.5 2.3-8.5-1.2-11.3zM264.1 383.9c4.4 0 8-3.6 8-8v-72h31.2l-63.2-49.7v121.7c0 4.4 3.6 8 8 8zm-120 64c-8.8 0-16-7.2-16-16V166l-32-25.2v291.1c0 26.5 21.5 48 48 48H496c8.4 0 16.1-2.3 23-6.1l-32.9-25.9z"}]},{name:"Mobile",type:"light",viewBox:"0 0 320 512",path:[{d:"M192 416c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zM320 48v416c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h224c26.5 0 48 21.5 48 48zm-32 0c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v416c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V48z"}]},{name:"Circle",type:"light",viewBox:"0 0 512 512",path:[{d:"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216z"}]},{name:"Circle",type:"solid",viewBox:"0 0 512 512",path:[{d:"M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"}]},{name:"File",type:"light",viewBox:"0 0 384 512",path:[{d:"M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zm-22.6 22.7c2.1 2.1 3.5 4.6 4.2 7.4H256V32.5c2.8.7 5.3 2.1 7.4 4.2l83.9 83.9zM336 480H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h176v104c0 13.3 10.7 24 24 24h104v304c0 8.8-7.2 16-16 16zm-48-244v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm0 64v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm0 64v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12z"}]},{name:"Keyboard",type:"light",viewBox:"0 0 576 512",path:[{d:"M528 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm16 336c0 8.823-7.177 16-16 16H48c-8.823 0-16-7.177-16-16V112c0-8.823 7.177-16 16-16h480c8.823 0 16 7.177 16 16v288zM168 268v-24c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm96 0v-24c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm96 0v-24c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm96 0v-24c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm-336 80v-24c0-6.627-5.373-12-12-12H84c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm384 0v-24c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zM120 188v-24c0-6.627-5.373-12-12-12H84c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm96 0v-24c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm96 0v-24c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm96 0v-24c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm96 0v-24c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12zm-96 152v-8c0-6.627-5.373-12-12-12H180c-6.627 0-12 5.373-12 12v8c0 6.627 5.373 12 12 12h216c6.627 0 12-5.373 12-12z"}]},{name:"PartyPopper",type:"light",viewBox:"0 0 24 24",path:[{d:"M18 8.31c-.36-.41-.73-.82-1.12-1.21l-.29-.27.14-.12a3.15 3.15 0 0 0 .9-3.49A3.91 3.91 0 0 0 14 1v2a2 2 0 0 1 1.76 1c.17.4 0 .84-.47 1.31-.07.08-.15.13-.22.2-3-2.41-6.29-3.77-7.9-2.16a2.16 2.16 0 0 0-.41.59v.1l-.18.53-4.41 13.1A3.28 3.28 0 0 0 5.28 22a3.21 3.21 0 0 0 1-.17L20 17.28a1 1 0 0 0 .43-.31l.21-.18c1.43-1.44.51-4.21-1.41-6.9A6.63 6.63 0 0 1 23 9V7a8.44 8.44 0 0 0-5 1.31zM5.7 19.93a1.29 1.29 0 0 1-1.63-1.63l1.36-4.1a10.7 10.7 0 0 0 4.29 4.39zm7-2.33a8.87 8.87 0 0 1-6.3-6.29l1-3 .06.09c.11.22.25.45.39.68s.16.29.26.44.33.48.51.73.19.28.3.42.43.55.66.82l.29.35c.34.39.7.77 1.08 1.16s.68.64 1 1l.33.28.78.63.37.28c.28.2.55.4.83.58l.31.2c.36.22.72.43 1.07.61h.05zm6.51-2.23h-.06c-.69.38-3.56-.57-6.79-3.81-.34-.34-.66-.67-.95-1l-.29-.35-.53-.64-.29-.4c-.13-.19-.27-.37-.39-.55l-.26-.42-.29-.47c-.08-.14-.14-.27-.21-.4s-.15-.26-.21-.4a3.31 3.31 0 0 1-.14-.36c-.05-.13-.11-.26-.15-.38S8.6 6 8.57 5.88s-.05-.22-.07-.32a2.26 2.26 0 0 1 0-.26 1 1 0 0 1 0-.24l.11-.31c.36-.36 2.23 0 4.73 1.9A4.13 4.13 0 0 1 12 7v2a6.45 6.45 0 0 0 3-.94l.48.46c.42.42.81.85 1.18 1.28a5.32 5.32 0 0 0-.6 3.4l2-.39a3.57 3.57 0 0 1 0-1.12 11.3 11.3 0 0 1 .81 1.45c.56 1.32.52 2.06.34 2.23z"}]},{name:"ArrowUpAlt",type:"light",viewBox:"0 0 448 512",path:[{d:"M180.573 448C169.211 448 160 438.789 160 427.428V255.991H43.021c-7.125 0-10.695-8.612-5.66-13.653L209.444 70.035c8.036-8.046 21.076-8.047 29.112 0L410.64 242.338c5.035 5.041 1.464 13.653-5.66 13.653H288v171.437C288 438.79 278.789 448 267.427 448h-86.854m0 32h86.855C296.416 480 320 456.416 320 427.428V287.991h84.979c35.507 0 53.497-43.04 28.302-68.266L261.198 47.422c-20.55-20.576-53.842-20.58-74.396 0L14.719 219.724c-25.091 25.122-7.351 68.266 28.302 68.266H128v139.437C128 456.416 151.584 480 180.573 480z"}]},{name:"TachoMeter",type:"light",viewBox:"0 0 576 512",path:[{d:"M288 288c-6.04 0-11.77 1.11-17.3 2.67l-75.76-97.4c-8.12-10.45-23.12-12.38-33.69-4.2-10.44 8.12-12.34 23.2-4.19 33.67l75.75 97.39c-5.45 9.42-8.81 20.21-8.81 31.88 0 11.72 3.38 22.55 8.88 32h110.25c5.5-9.45 8.88-20.28 8.88-32C352 316.65 323.35 288 288 288zm0-256C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm212.27 400H75.73C57.56 397.63 48 359.12 48 320 48 187.66 155.66 80 288 80s240 107.66 240 240c0 39.12-9.56 77.63-27.73 112z"}]},{name:"Stopwatch",type:"light",viewBox:"0 0 448 512",path:[{d:"M393.9 184l22.6-22.6c4.7-4.7 4.7-12.3 0-17l-17-17c-4.7-4.7-12.3-4.7-17 0l-20.7 20.7c-31.1-27.5-70.4-45.9-113.8-50.8V48h28c6.6 0 12-5.4 12-12V12c0-6.6-5.4-12-12-12H172c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h28v49.4C96.4 109.3 16 197.2 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-44.7-14.1-86.1-38.1-120zM224 464c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160zm12-112h-24c-6.6 0-12-5.4-12-12V204c0-6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v136c0 6.6-5.4 12-12 12z"}]},{name:"Invoice",type:"light",viewbox:"0 0 64 64",path:[{d:"M6 3v26h16v-2H8V5h10v6h6v2h2V9.6l-.3-.3l-6-6l-.3-.3zm14 3.4L22.6 9H20zM10 13v2h12v-2zm17 2v2c-1.7.3-3 1.7-3 3.5c0 2 1.5 3.5 3.5 3.5h1c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5H25v2h2v2h2v-2c1.7-.3 3-1.7 3-3.5c0-2-1.5-3.5-3.5-3.5h-1c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5H31v-2h-2v-2zm-17 3v2h7v-2zm9 0v2h3v-2zm-9 4v2h7v-2zm9 0v2h3v-2z"}]},{name:"PenSquare",viewBox:"0 0 448 512",path:[{d:"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm16 400c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v352zm-67.1-324.3c-15.6-15.6-40.9-15.6-56.6 0L72 328l-7.9 71.4C63 409 71.1 417 80.7 416l71.3-8 220.3-220.3c15.6-15.6 15.6-40.9 0-56.6l-23.4-23.4zM137.3 377.4l-39.1 4.3 4.3-39.1 162.7-162.7 34.7 34.7-162.6 162.8zm212.4-212.3l-27 27-34.7-34.7 27-27c3.1-3.1 8.2-3.1 11.3 0l23.4 23.4c3.1 3.1 3.1 8.2 0 11.3z"}]},{name:"ArrowUp",type:"light",viewBox:"0 0 448 512",path:[{d:"M 441.9 250.1 L 422.1 230.3 C 417.4 225.6 409.8 225.6 405.1 230.3 L 250 385.4 L 250 44 C 250 37.4 244.6 32 238 32 L 210 32 C 203.4 32 198 37.4 198 44 L 198 385.4 L 42.9 230.3 C 38.2 225.6 30.6 225.6 25.9 230.3 L 6.1 250.1 C 1.4 254.8 1.4 262.4 6.1 267.1 L 215.5 476.5 C 220.2 481.2 227.8 481.2 232.5 476.5 L 441.9 267.1 C 446.6 262.4 446.6 254.8 441.9 250.1 Z",style:"transform-origin: 224px 256.013px;",transform:"matrix(-1, 0, 0, -1, -0.000036829168, -0.000068248755)"}]},{name:"Xmark",type:"light",viewBox:"0 0 16 16",path:[{d:"M14.6666 14.6667L1.33325 1.33334M14.6666 1.33334L1.33325 14.6667"}]},{name:"Fire",type:"solid",viewBox:"0 0 384 512",path:[{d:"M216 23.86c0-23.8-30.65-32.77-44.15-13.04C48 191.85 224 200 224 288c0 35.63-29.11 64.46-64.85 63.99-35.17-.45-63.15-29.77-63.15-64.94v-85.51c0-21.7-26.47-32.23-41.43-16.5C27.8 213.16 0 261.33 0 320c0 105.87 86.13 192 192 192s192-86.13 192-192c0-170.29-168-193-168-296.14z"}]},{name:"Square",type:"solid",viewBox:"0 0 448 512",path:[{d:"M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"}]}];

var IconSetFeather = [{name:"Eye",viewBox:"0 0 24 24",path:[{d:"M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"}],circle:[{cx:"12",cy:"12",r:"3"}]},{name:"EyeSlash",viewBox:"0 0 24 24",path:[{d:"M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"}],line:[{x1:"1",y1:"1",x2:"23",y2:"23"}]},{name:"ChevronLeft",viewBox:"0 0 24 24",points:[{points:"15 18 9 12 15 6"}]},{name:"ChevronRight",viewBox:"0 0 24 24",points:[{points:"9 18 15 12 9 6"}]},{name:"ChevronDown",viewBox:"0 0 24 24",points:[{points:"6 9 12 15 18 9"}]},{name:"ChevronUp",viewBox:"0 0 24 24",points:[{points:"18 15 12 9 6 15"}]},{name:"Times",viewBox:"0 0 24 24",line:[{x1:"18",y1:"6",x2:"6",y2:"18"},{x1:"6",y1:"6",x2:"18",y2:"18"}]},{name:"List",viewBox:"0 0 24 24",line:[{x1:"8",y1:"6",x2:"21",y2:"6"},{x1:"8",y1:"12",x2:"21",y2:"12"},{x1:"8",y1:"18",x2:"21",y2:"18"},{x1:"3",y1:"6",x2:"3.01",y2:"6"},{x1:"3",y1:"12",x2:"3.01",y2:"12"},{x1:"3",y1:"18",x2:"3.01",y2:"18"}]},{name:"Grid",viewBox:"0 0 24 24",rect:[{x:"3",y:"3",width:"7",height:"7"},{x:"14",y:"3",width:"7",height:"7"},{x:"14",y:"14",width:"7",height:"7"},{x:"3",y:"14",width:"7",height:"7"}]},{name:"Map",viewBox:"0 0 24 24",points:[{points:"1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"}],line:[{x1:"8",y1:"2",x2:"8",y2:"18"},{x1:"16",y1:"6",x2:"16",y2:"22"}]},{name:"MapPin",viewBox:"0 0 24 24",path:[{d:"M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"}],circle:[{cx:"12",cy:"10",r:"3"}]},{name:"Download",viewBox:"0 0 24 24",path:[{d:"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"}],points:[{points:"7 10 12 15 17 10"}],line:[{x1:"12",y1:"15",x2:"12",y2:"3"}]},{name:"Filter",viewBox:"0 0 24 24",points:[{points:"22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"}]},{name:"Edit",viewBox:"0 0 24 24",path:[{d:"M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"},{d:"M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"}]},{name:"Upload",viewBox:"0 0 24 24",path:[{d:"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"}],points:[{points:"17 8 12 3 7 8"}],line:[{x1:"12",y1:"3",x2:"12",y2:"15"}]},{name:"Bin",viewBox:"0 0 24 24",points:[{points:"3 6 5 6 21 6"}],path:[{d:"M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"}]},{name:"Save",viewBox:"0 0 24 24",path:[{d:"M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"}],points:[{points:"17 21 17 13 7 13 7 21"},{points:"7 3 7 8 15 8"}]},{name:"Search",viewBox:"0 0 24 24",circle:[{cx:"11",cy:"11",r:"8"}],line:[{x1:"21",y1:"21",x2:"16.65",y2:"16.65"}]},{name:"Calendar",viewBox:"0 0 24 24",rect:[{x:"3",y:"4",width:"18",height:"18",rx:"2",ry:"2"}],line:[{x1:"16",y1:"2",x2:"16",y2:"6"},{x1:"8",y1:"2",x2:"8",y2:"6"},{x1:"3",y1:"10",x2:"21",y2:"10"}]},{name:"CheckSquare",viewBox:"0 0 24 24",polyline:[{points:"9 11 12 14 22 4"}],path:[{d:"M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"}]},{name:"Command",viewBox:"0 0 24 24",path:[{d:"M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 3 3 0 0 0-3-3z"}]},{name:"Xmark",viewBox:"0 0 24 24",line:[{x1:"18",y1:"6",x2:"6",y2:"18"},{x1:"6",y1:"6",x2:"18",y2:"18"}]},{name:"Info",viewBox:"0 0 24 24",circle:[{cx:"12",cy:"12",r:"10"}],line:[{x1:"12",y1:"16",x2:"12",y2:"12"},{x1:"12",y1:"8",x2:"12.01",y2:"8"}]}];

var IconSetBlueCurrent = [{name:"UMOVE",viewBox:"0 0 2500 2500",path:[{d:"M1142.36 2441.48h214.286c458.809-18.976 573.762-163.321 573.762-338.333v-1706c0-187.899-186.078-340.453-680.905-340.453S568.598 209.248 568.598 397.147v1706c.517 182.246 116.264 337.72 573.762 338.333m107.143-700.262c147.833 0 267.857 120.024 267.857 267.857 0 147.834-120.024 267.857-267.857 267.857-147.833 0-267.857-120.023-267.857-267.857 0-147.833 120.024-267.857 267.857-267.857Z",style:{fill:"none",fillRule:"nonzero",stroke:"#37424A",strokeWidth:"113.39px"}},{d:"M1666.17 294.79h-54.167c-29.256 0-52.976 23.721-52.976 52.977v435.119c0 131.494-106.601 238.095-238.095 238.095h-142.858c-131.494 0-238.095-106.601-238.095-238.095V347.808c0-29.279-23.738-53.018-53.018-53.018h-54.125v500c0 184.096 149.238 333.334 333.334 333.334h166.666c96.792 0 183.953-41.256 244.846-107.143 54.928-59.429 88.488-138.887 88.488-226.191v-500Z",style:{fill:"#37424A",fillRule:"nonzero",stroke:"none"}}]},{name:"NanoCharge",viewBox:"0 0 1830 1809",path:[{d:"M1440.01 601.213c0-287.648-233.185-520.833-520.833-520.833h-9.181c-287.648 0-520.833 233.185-520.833 520.833v608.492c0 287.649 233.185 520.834 520.833 520.834h9.181c287.648 0 520.833-233.185 520.833-520.834V601.213Z",style:{stroke:"#000000",strokeWidth:"66.67px"}},{d:"M1081.05 387.89c9.963 12.072 17.849 35.616 21.84 62.876 6.162 42.094 2.725 93.314-21.386 127.749-4.237 6.051-2.764 14.405 3.287 18.642 6.052 4.237 14.406 2.764 18.643-3.288 27.784-39.679 33.046-98.476 25.945-146.982-4.852-33.141-15.569-61.363-27.682-76.038-4.703-5.698-13.147-6.506-18.845-1.803-5.697 4.702-6.505 13.147-1.802 18.844ZM1025.01 424.891c8.701 8.921 15.604 29.142 17.365 51.295 1.786 22.482-1.923 47.305-16.946 65.233-4.745 5.662-4 14.111 1.662 18.857 5.662 4.745 14.112 4.001 18.858-1.662 19.538-23.315 25.437-55.311 23.113-84.549-2.35-29.569-13.273-55.958-24.887-67.866-5.157-5.289-13.64-5.395-18.928-.237-5.29 5.158-5.395 13.64-.237 18.929ZM971.596 458.063c.246.479 3.632 7.149 4.974 12.854 2.609 11.087 3.184 26.134-5.368 38.355-4.236 6.053-2.761 14.407 3.293 18.642 6.053 4.235 14.406 2.76 18.642-3.293 13.377-19.117 13.574-42.492 9.493-59.835-3.044-12.942-8.751-22.507-12.392-25.927-5.384-5.059-13.862-4.794-18.921.59-4.958 5.278-4.802 13.528.279 18.614ZM727.468 370.849c-12.113 14.675-22.831 42.897-27.683 76.038-7.101 48.506-1.838 107.303 25.946 146.982 4.236 6.052 12.59 7.525 18.642 3.288 6.051-4.237 7.525-12.591 3.287-18.642-24.111-34.435-27.548-85.655-21.386-127.749 3.991-27.26 11.878-50.804 21.841-62.876 4.703-5.697 3.895-14.142-1.803-18.844-5.697-4.703-14.141-3.895-18.844 1.803ZM784.997 406.199c-11.614 11.908-22.537 38.297-24.888 67.866-2.323 29.238 3.576 61.234 23.114 84.549 4.745 5.663 13.195 6.407 18.858 1.662 5.661-4.746 6.407-13.195 1.661-18.857-15.023-17.928-18.732-42.751-16.945-65.233 1.761-22.153 8.664-42.374 17.365-51.295 5.158-5.289 5.052-13.771-.237-18.929-5.288-5.158-13.771-5.052-18.928.237ZM857.867 458.063c5.082-5.086 5.237-13.336.279-18.614-5.058-5.384-13.537-5.649-18.921-.59-3.641 3.42-9.348 12.985-12.392 25.927-4.081 17.343-3.884 40.718 9.494 59.835 4.236 6.053 12.589 7.528 18.642 3.293 6.053-4.235 7.528-12.589 3.292-18.642-8.551-12.221-7.976-27.268-5.368-38.355 1.342-5.705 4.729-12.375 4.974-12.854Z",style:{stroke:"#000000",strokeWidth:"15px",fill:"#000000"}},{d:"M757.005 858.324h315.156c149.934 59.899 255.535 202.643 255.535 369.029 0 220.29-185.11 399.138-413.113 399.138s-413.112-178.848-413.112-399.138c0-166.386 105.601-309.13 255.534-369.029Z",style:{stroke:"#000000",strokeWidth:"66.67px"}}],circle:[{cx:"914.863",cy:"482.781",r:"20.079"}]}];

var Icon = function (_React$PureComponent) {
  _inherits$4(Icon, _React$PureComponent);
  var _super = _createSuper$5(Icon);
  function Icon() {
    _classCallCheck$6(this, Icon);
    return _super.apply(this, arguments);
  }
  _createClass$6(Icon, [{
    key: "render",
    value: function render() {
      var _this = this,
          _this$props$height,
          _this$props$width,
          _this$props$color,
          _this$props$color2,
          _this$props$strokeWid,
          _this$props$position,
          _this$props$marginLef,
          _this$props$marginRig,
          _this$props$marginTop,
          _this$props$marginBot,
          _this$props$opacity,
          _this$props$left,
          _this$props$right;
      var GrabIcon = function GrabIcon() {
        var e = null;
        switch (_this.props.iconSet) {
          case 'FA':
            e = IconSetFA.find(function (item) {
              return _this.props.type ? item.name === _this.props.name && item.type === _this.props.type : item.name === _this.props.name;
            });
            break;
          case 'Feather':
            e = IconSetFeather.find(function (item) {
              return item.name === _this.props.name;
            });
            break;
          case 'BlueCurrent':
            e = IconSetBlueCurrent.find(function (item) {
              return item.name === _this.props.name;
            });
            break;
          default:
            e = IconSetFA.find(function (item) {
              return item.name === _this.props.name;
            });
            break;
        }
        if (!e) {
          console.warn("[BCU Library]: props.name is undefined: Name: ".concat(_this.props.name, ", Height: ").concat(_this.props.height, ", Width: ").concat(_this.props.width, ", Color: ").concat(_this.props.color, ", IconSet: ").concat(_this.props.iconSet));
          return {
            viewBox: '0 0 0 0',
            path: false,
            circle: false,
            line: false,
            points: false,
            rect: false
          };
        }
        return {
          viewBox: e.viewBox,
          path: e.path,
          circle: e.circle,
          line: e.line,
          points: e.points,
          rect: e.rect,
          polyline: e.polyline
        };
      };
      return React__default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: GrabIcon().viewBox,
        height: (_this$props$height = this.props.height) !== null && _this$props$height !== void 0 ? _this$props$height : '10px',
        width: (_this$props$width = this.props.width) !== null && _this$props$width !== void 0 ? _this$props$width : '10px',
        fill: this.props.iconSet === 'Feather' || this.props.iconSet === 'BlueCurrent' ? 'transparent' : (_this$props$color = this.props.color) !== null && _this$props$color !== void 0 ? _this$props$color : Colors.RED,
        stroke: this.props.iconSet === 'Feather' ? (_this$props$color2 = this.props.color) !== null && _this$props$color2 !== void 0 ? _this$props$color2 : Colors.RED : 'transparent',
        strokeWidth: this.props.iconSet === 'Feather' ? (_this$props$strokeWid = this.props.strokeWidth) !== null && _this$props$strokeWid !== void 0 ? _this$props$strokeWid : 2 : this.props.strokeWidth,
        strokeLinejoin: this.props.iconSet === 'Feather' ? 'round' : 'none',
        strokeLinecap: this.props.iconSet === 'Feather' ? 'round' : 'none',
        style: {
          position: (_this$props$position = this.props.position) !== null && _this$props$position !== void 0 ? _this$props$position : 'relative',
          marginLeft: (_this$props$marginLef = this.props.marginLeft) !== null && _this$props$marginLef !== void 0 ? _this$props$marginLef : 0,
          marginRight: (_this$props$marginRig = this.props.marginRight) !== null && _this$props$marginRig !== void 0 ? _this$props$marginRig : 0,
          marginTop: (_this$props$marginTop = this.props.marginTop) !== null && _this$props$marginTop !== void 0 ? _this$props$marginTop : 0,
          marginBottom: (_this$props$marginBot = this.props.marginBottom) !== null && _this$props$marginBot !== void 0 ? _this$props$marginBot : 0,
          transition: this.props.transition,
          opacity: (_this$props$opacity = this.props.opacity) !== null && _this$props$opacity !== void 0 ? _this$props$opacity : 1,
          left: (_this$props$left = this.props.left) !== null && _this$props$left !== void 0 ? _this$props$left : 0,
          right: (_this$props$right = this.props.right) !== null && _this$props$right !== void 0 ? _this$props$right : 0,
          transform: this.props.transform,
          zIndex: this.props.zIndex
        }
      }, this.props.name === false ? React__default.createElement("div", {
        style: {
          height: 200,
          width: 200,
          backgroundColor: Colors.RED
        }
      }, React__default.createElement("p", null, "ERROR")) : React__default.createElement(React__default.Fragment, null, GrabIcon().path && GrabIcon().path.map(function (e, i) {
        return React__default.createElement("path", {
          key: i,
          d: e.d,
          style: {
            fill: _this.props.iconSet === 'BlueCurrent' ? e.style !== undefined && e.style.fill !== 'none' && e.style.fill ? _this.props.color : 'transparent' : e.style !== undefined ? e.style.fill : null,
            fillRule: e.style !== undefined && e.style.fillRule,
            stroke: _this.props.iconSet === 'BlueCurrent' ? e.style !== undefined && e.style.stroke !== 'none' && e.style.stroke ? _this.props.color : 'transparent' : e.style !== undefined && e.style.stroke,
            strokeWidth: e.style !== undefined && e.style.strokeWidth
          }
        });
      }), GrabIcon().circle && GrabIcon().circle.map(function (e, i) {
        return React__default.createElement("circle", {
          key: i,
          cx: e.cx,
          cy: e.cy,
          r: e.r
        });
      }), GrabIcon().line && GrabIcon().line.map(function (e, i) {
        return React__default.createElement("line", {
          key: i,
          x1: e.x1,
          y1: e.y1,
          x2: e.x2,
          y2: e.y2
        });
      }), GrabIcon().polyline && GrabIcon().polyline.map(function (e, i) {
        return React__default.createElement("polyline", {
          key: i,
          points: e.points
        });
      }), GrabIcon().points && GrabIcon().points.map(function (e, i) {
        return React__default.createElement("polyline", {
          key: i,
          points: e.points
        });
      }), GrabIcon().rect && GrabIcon().rect.map(function (e, i) {
        return React__default.createElement("rect", {
          key: i,
          x: e.x,
          y: e.y,
          height: e.height,
          width: e.width
        });
      })));
    }
  }]);
  return Icon;
}(React__default.PureComponent);

function Spinner(props) {
  var _props$size, _props$size2, _props$thickness, _props$color, _props$thickness2, _props$color2, _props$thickness3, _props$color3, _props$thickness4;
  return React$4.createElement("div", {
    style: {
      height: (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : 30,
      width: (_props$size2 = props.size) !== null && _props$size2 !== void 0 ? _props$size2 : 30,
      borderLeft: "solid ".concat((_props$thickness = props.thickness) !== null && _props$thickness !== void 0 ? _props$thickness : 3, "px ").concat((_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY),
      borderRight: "solid ".concat((_props$thickness2 = props.thickness) !== null && _props$thickness2 !== void 0 ? _props$thickness2 : 3, "px ").concat((_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : Colors.GREY),
      borderBottom: "solid ".concat((_props$thickness3 = props.thickness) !== null && _props$thickness3 !== void 0 ? _props$thickness3 : 3, "px ").concat((_props$color3 = props.color) !== null && _props$color3 !== void 0 ? _props$color3 : Colors.GREY),
      borderTop: "solid ".concat((_props$thickness4 = props.thickness) !== null && _props$thickness4 !== void 0 ? _props$thickness4 : 3, "px transparent"),
      borderRadius: '100%',
      backgroundColor: 'transparent',
      animation: 'spinner 1.3s linear infinite'
    }
  });
}

function Loaders(props) {
  var renderLoader = function renderLoader() {
    switch (props.type) {
      case 'spinner':
        return React$4.createElement(Spinner, {
          size: props.size,
          thickness: props.thickness,
          color: props.color
        });
      default:
        return React$4.createElement(Spinner, {
          size: props.size,
          thickness: props.thickness,
          color: props.color
        });
    }
  };
  return React$4.createElement(React$4.Fragment, null, renderLoader());
}

function Button$3(props) {
  var _props$alignItems, _props$width, _props$maxWidth, _props$minWidth, _props$height, _props$height2, _props$borderRadius, _props$border, _props$paddingLeft, _props$paddingRight, _props$paddingTop, _props$color, _props$fontSize, _props$flexDirection, _props$paddingTopText, _props$widthText, _props$maxWidthText, _props$textAlign, _props$textAlign2, _props$icon$color;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  var ref = React$4.useRef();
  var size = useDimensions();
  useDataAttributes(ref, props.dataAttributes);
  return React$4.createElement("button", {
    ref: ref,
    id: props.id,
    className: "".concat(props.disabled || props.loading ? 'Disabled' : 'Hover', " DisableSelection"),
    type: props.type === 'submit' ? 'submit' : 'button',
    onMouseEnter: function onMouseEnter() {
      !props.disableHover && setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      !props.disableHover && setHover(false);
    },
    onClick: props.disabled || props.loading ? null : props.onClick,
    "aria-label": props.ariaLabel,
    style: {
      display: 'flex',
      alignItems: (_props$alignItems = props.alignItems) !== null && _props$alignItems !== void 0 ? _props$alignItems : 'center',
      width: size.width < Breakpoint.fd ? '100%' : (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : '100%',
      maxWidth: (_props$maxWidth = props.maxWidth) !== null && _props$maxWidth !== void 0 ? _props$maxWidth : '100%',
      minWidth: (_props$minWidth = props.minWidth) !== null && _props$minWidth !== void 0 ? _props$minWidth : 150,
      minHeight: props.size === 'medium' ? (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 40 : (_props$height2 = props.height) !== null && _props$height2 !== void 0 ? _props$height2 : 50,
      borderRadius: ((_props$borderRadius = props.borderRadius) !== null && _props$borderRadius !== void 0 ? _props$borderRadius : props.size === 'medium') ? 7 : 10,
      border: (_props$border = props.border) !== null && _props$border !== void 0 ? _props$border : props.disabled ? "solid 2px ".concat(props.loading ? props.colorScheme.vibrant : Colors.MEDIUM_WHITE) : props.selected ? "solid 2px ".concat(props.colorScheme.border) : props.colorScheme.type === 'white' ? "solid 2px ".concat(props.colorScheme.border) : "solid 2px ".concat(hover || props.colorScheme.type === 'white-alt' || props.colorScheme.type === 'purple-invert' || props.colorScheme.type === 'blue-invert' ? props.colorScheme.border : 'transparent'),
      backgroundColor: props.disabled || hover ? props.colorScheme.type === 'white-alt' ? Colors.WHITE : props.colorScheme.type === 'white' ? Colors.LIGHT_GREY : props.colorScheme.delicate : props.colorScheme.type === 'white-alt' || props.colorScheme.type === 'blue-invert' ? 'transparent' : props.colorScheme.vibrant,
      paddingLeft: (_props$paddingLeft = props.paddingLeft) !== null && _props$paddingLeft !== void 0 ? _props$paddingLeft : 20,
      paddingRight: (_props$paddingRight = props.paddingRight) !== null && _props$paddingRight !== void 0 ? _props$paddingRight : 20,
      paddingTop: !props.alignItems === 'center' && ((_props$paddingTop = props.paddingTop) !== null && _props$paddingTop !== void 0 ? _props$paddingTop : 0),
      color: !props.disabled && hover ? props.colorScheme.type === 'white-alt' || props.colorScheme.type === 'white' || props.colorScheme.type === 'white-invert' ? hover ? props.colorScheme.type === 'white-invert' ? Colors.WHITE : (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY : props.colorScheme.text : props.colorScheme.vibrant : props.disabled ? props.disabled.color ? props.disabled.color : Colors.MEDIUM_WHITE : props.colorScheme.text,
      fontSize: props.size === 'medium' ? '1em' : (_props$fontSize = props.fontSize) !== null && _props$fontSize !== void 0 ? _props$fontSize : '1.1em',
      fontWeight: 500,
      transition: 'all 0.3s linear',
      flexDirection: (_props$flexDirection = props.flexDirection) !== null && _props$flexDirection !== void 0 ? _props$flexDirection : 'row'
    }
  }, props.loading ? React$4.createElement("div", {
    style: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, React$4.createElement(Loaders, {
    type: "spinner",
    size: 20,
    color: !props.disabled && hover ? props.colorScheme.vibrant : props.colorScheme.text
  })) : React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      paddingTop: (_props$paddingTopText = props.paddingTopText) !== null && _props$paddingTopText !== void 0 ? _props$paddingTopText : 0,
      width: (_props$widthText = props.widthText) !== null && _props$widthText !== void 0 ? _props$widthText : '100%',
      maxWidth: (_props$maxWidthText = props.maxWidthText) !== null && _props$maxWidthText !== void 0 ? _props$maxWidthText : 'auto'
    }
  }, React$4.createElement("p", {
    style: {
      width: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      textAlign: (_props$textAlign = props.textAlign) !== null && _props$textAlign !== void 0 ? _props$textAlign : 'center'
    }
  }, props.text), props.subText && React$4.createElement("p", {
    style: {
      width: '100%',
      fontSize: '0.9em',
      fontWeight: 300,
      color: Colors.GREY,
      textAlign: (_props$textAlign2 = props.textAlign) !== null && _props$textAlign2 !== void 0 ? _props$textAlign2 : 'center'
    }
  }, props.subText)), props.icon && React$4.createElement("div", {
    style: {
      width: 25,
      height: 35,
      maxWidth: 35,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, React$4.createElement(Icon, {
    name: props.icon.name,
    width: props.icon.width,
    height: props.icon.height,
    color: (_props$icon$color = props.icon.color) !== null && _props$icon$color !== void 0 ? _props$icon$color : Colors.GREY,
    iconSet: props.icon.iconSet
  })));
}

function Link$1(props) {
  var _props$borderRadius, _props$icon$width, _props$icon$height, _props$icon$color, _props$color;
  var ref = React$4.useRef();
  useDataAttributes(ref, props.dataAttributes);
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("button", {
    ref: ref,
    className: "".concat(props.disabled ? 'Disabled' : props.selected ? 'Default' : 'Hover', " DisableSelection"),
    type: "button",
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    onClick: props.disabled ? null : props.onClick,
    style: {
      height: props.height ? props.height : 40,
      width: props.width ? props.width : '100%',
      backgroundColor: props.selected ? Colors.LIGHT_WHITE : 'transparent',
      border: 'solid 0px transparent',
      textAlign: 'left',
      fontFamily: 'Museo-Sans',
      fontSize: '1.1em',
      fontWeight: 300,
      color: props.disabled ? Colors.MEDIUM_GREY : props.color ? props.color : Colors.GREY,
      position: 'relative',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      borderRadius: (_props$borderRadius = props.borderRadius) !== null && _props$borderRadius !== void 0 ? _props$borderRadius : 10,
      textDecoration: props.textDecoration && hover ? props.textDecoration : 'none',
      padding: 0
    }
  }, props.icon && React$4.createElement("div", {
    style: {
      height: 40,
      width: 30,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      paddingLeft: 5,
      marginRight: 10
    }
  }, React$4.createElement(Icon, {
    name: props.icon.name,
    width: (_props$icon$width = props.icon.width) !== null && _props$icon$width !== void 0 ? _props$icon$width : 15,
    height: (_props$icon$height = props.icon.height) !== null && _props$icon$height !== void 0 ? _props$icon$height : 15,
    color: props.disabled ? Colors.MEDIUM_GREY : (_props$icon$color = props.icon.color) !== null && _props$icon$color !== void 0 ? _props$icon$color : Colors.GREY,
    iconSet: props.icon.iconSet
  })), props.text, !props.removeArrow && React$4.createElement(AnimatePresence, null, !props.disabled && !props.selected && hover && React$4.createElement(motion.div, {
    style: {
      position: 'absolute',
      top: 10,
      marginRight: 15
    },
    initial: {
      right: 20,
      opacity: 0
    },
    animate: {
      right: 0,
      opacity: 1
    },
    exit: {
      right: 20,
      opacity: 0
    },
    transition: {
      duration: 0.2
    }
  }, React$4.createElement(Icon, {
    name: "ArrowRight",
    width: 15,
    height: 15,
    color: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY
  }))));
}

var dist = {};

var propTypes = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l$1=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n$1=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l$1:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n$1:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l$1;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n$1;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l$1};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n$1};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n$1||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
if (process.env.NODE_ENV !== "production") {
  (function() {
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' ||
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}
function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;
    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;
        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;
          default:
            var $$typeofType = type && type.$$typeof;
            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;
              default:
                return $$typeof;
            }
        }
      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }
  return undefined;
}
var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false;
function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true;
      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }
  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}
reactIs_development.AsyncMode = AsyncMode;
reactIs_development.ConcurrentMode = ConcurrentMode;
reactIs_development.ContextConsumer = ContextConsumer;
reactIs_development.ContextProvider = ContextProvider;
reactIs_development.Element = Element;
reactIs_development.ForwardRef = ForwardRef;
reactIs_development.Fragment = Fragment;
reactIs_development.Lazy = Lazy;
reactIs_development.Memo = Memo;
reactIs_development.Portal = Portal;
reactIs_development.Profiler = Profiler;
reactIs_development.StrictMode = StrictMode;
reactIs_development.Suspense = Suspense;
reactIs_development.isAsyncMode = isAsyncMode;
reactIs_development.isConcurrentMode = isConcurrentMode;
reactIs_development.isContextConsumer = isContextConsumer;
reactIs_development.isContextProvider = isContextProvider;
reactIs_development.isElement = isElement;
reactIs_development.isForwardRef = isForwardRef;
reactIs_development.isFragment = isFragment;
reactIs_development.isLazy = isLazy;
reactIs_development.isMemo = isMemo;
reactIs_development.isPortal = isPortal;
reactIs_development.isProfiler = isProfiler;
reactIs_development.isStrictMode = isStrictMode;
reactIs_development.isSuspense = isSuspense;
reactIs_development.isValidElementType = isValidElementType;
reactIs_development.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs.exports = reactIs_production_min;
} else {
  reactIs.exports = reactIs_development;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}
	return Object(val);
}
function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}
		var test1 = new String('abc');
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}
		return true;
	} catch (err) {
		return false;
	}
}
var objectAssign$6 = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;
	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);
		for (var key in from) {
			if (hasOwnProperty$1.call(from, key)) {
				to[key] = from[key];
			}
		}
		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}
	return to;
};

var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret$3;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning$1 = function() {};
if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has$2;
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {  }
  };
}
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        try {
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};
var checkPropTypes_1 = checkPropTypes$1;

var ReactIs$1 = reactIs.exports;
var assign = objectAssign$6;
var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var has = has$2;
var checkPropTypes = checkPropTypes_1;
var printWarning = function() {};
if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {}
  };
}
function emptyFunctionThatReturnsNull() {
  return null;
}
var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  var ANONYMOUS = '<<anonymous>>';
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };
  function is(x, y) {
    if (x === y) {
      return x !== 0 || 1 / x === 1 / y;
    } else {
      return x !== x && y !== y;
    }
  }
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  PropTypeError.prototype = Error.prototype;
  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;
      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }
  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        var preciseType = getPreciseType(propValue);
        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }
  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }
      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }
    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }
  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }
        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }
        return true;
      default:
        return false;
    }
  }
  function isSymbol(propType, propValue) {
    if (propType === 'symbol') {
      return true;
    }
    if (!propValue) {
      return false;
    }
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }
    return false;
  }
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }
  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var ReactPropTypesSecret = ReactPropTypesSecret_1;
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs.exports;
  var throwOnDirectAccess = true;
  propTypes.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  propTypes.exports = factoryWithThrowingShims();
}
var PropTypes$1 = propTypes.exports;

var baseUrl = 'https://docs.sanity.io/help/';
var generateHelpUrl$1 = function generateHelpUrl(slug) {
  return baseUrl + slug
};

var builder = {};

var urlForImage = {};

var parseAssetId$1 = {};

Object.defineProperty(parseAssetId$1, "__esModule", { value: true });
var example$3 = 'image-Tb9Ew8CXIwaY6R1kjMvI0uRR-2000x3000-jpg';
function parseAssetId(ref) {
    var _a = ref.split('-'), id = _a[1], dimensionString = _a[2], format = _a[3];
    if (!id || !dimensionString || !format) {
        throw new Error("Malformed asset _ref '" + ref + "'. Expected an id like \"" + example$3 + "\".");
    }
    var _b = dimensionString.split('x'), imgWidthStr = _b[0], imgHeightStr = _b[1];
    var width = +imgWidthStr;
    var height = +imgHeightStr;
    var isValidAssetId = isFinite(width) && isFinite(height);
    if (!isValidAssetId) {
        throw new Error("Malformed asset _ref '" + ref + "'. Expected an id like \"" + example$3 + "\".");
    }
    return { id: id, width: width, height: height, format: format };
}
parseAssetId$1.default = parseAssetId;

var parseSource$1 = {};

var __assign$1 = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign$1 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};
Object.defineProperty(parseSource$1, "__esModule", { value: true });
var isRef$1 = function (src) {
    var source = src;
    return source ? typeof source._ref === 'string' : false;
};
var isAsset = function (src) {
    var source = src;
    return source ? typeof source._id === 'string' : false;
};
var isAssetStub = function (src) {
    var source = src;
    return source && source.asset ? typeof source.asset.url === 'string' : false;
};
function parseSource(source) {
    if (!source) {
        return null;
    }
    var image;
    if (typeof source === 'string' && isUrl(source)) {
        image = {
            asset: { _ref: urlToId(source) },
        };
    }
    else if (typeof source === 'string') {
        image = {
            asset: { _ref: source },
        };
    }
    else if (isRef$1(source)) {
        image = {
            asset: source,
        };
    }
    else if (isAsset(source)) {
        image = {
            asset: {
                _ref: source._id || '',
            },
        };
    }
    else if (isAssetStub(source)) {
        image = {
            asset: {
                _ref: urlToId(source.asset.url),
            },
        };
    }
    else if (typeof source.asset === 'object') {
        image = source;
    }
    else {
        return null;
    }
    var img = source;
    if (img.crop) {
        image.crop = img.crop;
    }
    if (img.hotspot) {
        image.hotspot = img.hotspot;
    }
    return applyDefaults(image);
}
parseSource$1.default = parseSource;
function isUrl(url) {
    return /^https?:\/\//.test("" + url);
}
function urlToId(url) {
    var parts = url.split('/').slice(-1);
    return ("image-" + parts[0]).replace(/\.([a-z]+)$/, '-$1');
}
function applyDefaults(image) {
    if (image.crop && image.hotspot) {
        return image;
    }
    var result = __assign$1({}, image);
    if (!result.crop) {
        result.crop = {
            left: 0,
            top: 0,
            bottom: 0,
            right: 0,
        };
    }
    if (!result.hotspot) {
        result.hotspot = {
            x: 0.5,
            y: 0.5,
            height: 1.0,
            width: 1.0,
        };
    }
    return result;
}

(function (exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var parseAssetId_1 = __importDefault(parseAssetId$1);
var parseSource_1 = __importDefault(parseSource$1);
exports.parseSource = parseSource_1.default;
exports.SPEC_NAME_TO_URL_NAME_MAPPINGS = [
    ['width', 'w'],
    ['height', 'h'],
    ['format', 'fm'],
    ['download', 'dl'],
    ['blur', 'blur'],
    ['sharpen', 'sharp'],
    ['invert', 'invert'],
    ['orientation', 'or'],
    ['minHeight', 'min-h'],
    ['maxHeight', 'max-h'],
    ['minWidth', 'min-w'],
    ['maxWidth', 'max-w'],
    ['quality', 'q'],
    ['fit', 'fit'],
    ['crop', 'crop'],
    ['saturation', 'sat'],
    ['auto', 'auto'],
    ['dpr', 'dpr'],
    ['pad', 'pad'],
];
function urlForImage(options) {
    var spec = __assign({}, (options || {}));
    var source = spec.source;
    delete spec.source;
    var image = parseSource_1.default(source);
    if (!image) {
        return null;
    }
    var id = image.asset._ref || image.asset._id || '';
    var asset = parseAssetId_1.default(id);
    var cropLeft = Math.round(image.crop.left * asset.width);
    var cropTop = Math.round(image.crop.top * asset.height);
    var crop = {
        left: cropLeft,
        top: cropTop,
        width: Math.round(asset.width - image.crop.right * asset.width - cropLeft),
        height: Math.round(asset.height - image.crop.bottom * asset.height - cropTop),
    };
    var hotSpotVerticalRadius = (image.hotspot.height * asset.height) / 2;
    var hotSpotHorizontalRadius = (image.hotspot.width * asset.width) / 2;
    var hotSpotCenterX = image.hotspot.x * asset.width;
    var hotSpotCenterY = image.hotspot.y * asset.height;
    var hotspot = {
        left: hotSpotCenterX - hotSpotHorizontalRadius,
        top: hotSpotCenterY - hotSpotVerticalRadius,
        right: hotSpotCenterX + hotSpotHorizontalRadius,
        bottom: hotSpotCenterY + hotSpotVerticalRadius,
    };
    if (!(spec.rect || spec.focalPoint || spec.ignoreImageParams || spec.crop)) {
        spec = __assign(__assign({}, spec), fit({ crop: crop, hotspot: hotspot }, spec));
    }
    return specToImageUrl(__assign(__assign({}, spec), { asset: asset }));
}
exports.default = urlForImage;
function specToImageUrl(spec) {
    var cdnUrl = spec.baseUrl || 'https://cdn.sanity.io';
    var filename = spec.asset.id + "-" + spec.asset.width + "x" + spec.asset.height + "." + spec.asset.format;
    var baseUrl = cdnUrl + "/images/" + spec.projectId + "/" + spec.dataset + "/" + filename;
    var params = [];
    if (spec.rect) {
        var _a = spec.rect, left = _a.left, top_1 = _a.top, width = _a.width, height = _a.height;
        var isEffectiveCrop = left !== 0 || top_1 !== 0 || height !== spec.asset.height || width !== spec.asset.width;
        if (isEffectiveCrop) {
            params.push("rect=" + left + "," + top_1 + "," + width + "," + height);
        }
    }
    if (spec.bg) {
        params.push("bg=" + spec.bg);
    }
    if (spec.focalPoint) {
        params.push("fp-x=" + spec.focalPoint.x);
        params.push("fp-y=" + spec.focalPoint.y);
    }
    var flip = [spec.flipHorizontal && 'h', spec.flipVertical && 'v'].filter(Boolean).join('');
    if (flip) {
        params.push("flip=" + flip);
    }
    exports.SPEC_NAME_TO_URL_NAME_MAPPINGS.forEach(function (mapping) {
        var specName = mapping[0], param = mapping[1];
        if (typeof spec[specName] !== 'undefined') {
            params.push(param + "=" + encodeURIComponent(spec[specName]));
        }
        else if (typeof spec[param] !== 'undefined') {
            params.push(param + "=" + encodeURIComponent(spec[param]));
        }
    });
    if (params.length === 0) {
        return baseUrl;
    }
    return baseUrl + "?" + params.join('&');
}
function fit(source, spec) {
    var cropRect;
    var imgWidth = spec.width;
    var imgHeight = spec.height;
    if (!(imgWidth && imgHeight)) {
        return { width: imgWidth, height: imgHeight, rect: source.crop };
    }
    var crop = source.crop;
    var hotspot = source.hotspot;
    var desiredAspectRatio = imgWidth / imgHeight;
    var cropAspectRatio = crop.width / crop.height;
    if (cropAspectRatio > desiredAspectRatio) {
        var height = crop.height;
        var width = height * desiredAspectRatio;
        var top_2 = crop.top;
        var hotspotXCenter = (hotspot.right - hotspot.left) / 2 + hotspot.left;
        var left = hotspotXCenter - width / 2;
        if (left < crop.left) {
            left = crop.left;
        }
        else if (left + width > crop.left + crop.width) {
            left = crop.left + crop.width - width;
        }
        cropRect = {
            left: Math.round(left),
            top: Math.round(top_2),
            width: Math.round(width),
            height: Math.round(height),
        };
    }
    else {
        var width = crop.width;
        var height = width / desiredAspectRatio;
        var left = crop.left;
        var hotspotYCenter = (hotspot.bottom - hotspot.top) / 2 + hotspot.top;
        var top_3 = hotspotYCenter - height / 2;
        if (top_3 < crop.top) {
            top_3 = crop.top;
        }
        else if (top_3 + height > crop.top + crop.height) {
            top_3 = crop.top + crop.height - height;
        }
        cropRect = {
            left: Math.max(0, Math.floor(left)),
            top: Math.max(0, Math.floor(top_3)),
            width: Math.round(width),
            height: Math.round(height),
        };
    }
    return {
        width: imgWidth,
        height: imgHeight,
        rect: cropRect,
    };
}
}(urlForImage));
getDefaultExportFromCjs(urlForImage);

var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(builder, "__esModule", { value: true });
var urlForImage_1 = __importStar(urlForImage);
var validFits = ['clip', 'crop', 'fill', 'fillmax', 'max', 'scale', 'min'];
var validCrops = ['top', 'bottom', 'left', 'right', 'center', 'focalpoint', 'entropy'];
var validAutoModes = ['format'];
function isSanityClientLike(client) {
    return client ? typeof client.clientConfig === 'object' : false;
}
function rewriteSpecName(key) {
    var specs = urlForImage_1.SPEC_NAME_TO_URL_NAME_MAPPINGS;
    for (var _i = 0, specs_1 = specs; _i < specs_1.length; _i++) {
        var entry = specs_1[_i];
        var specName = entry[0], param = entry[1];
        if (key === specName || key === param) {
            return specName;
        }
    }
    return key;
}
function urlBuilder$1(options) {
    var client = options;
    if (isSanityClientLike(client)) {
        var _a = client.clientConfig, apiUrl = _a.apiHost, projectId = _a.projectId, dataset = _a.dataset;
        var apiHost = apiUrl || 'https://api.sanity.io';
        return new ImageUrlBuilder(null, {
            baseUrl: apiHost.replace(/^https:\/\/api\./, 'https://cdn.'),
            projectId: projectId,
            dataset: dataset,
        });
    }
    return new ImageUrlBuilder(null, options);
}
builder.default = urlBuilder$1;
var ImageUrlBuilder =  (function () {
    function ImageUrlBuilder(parent, options) {
        this.options = parent
            ? __assign(__assign({}, (parent.options || {})), (options || {})) : __assign({}, (options || {}));
    }
    ImageUrlBuilder.prototype.withOptions = function (options) {
        var baseUrl = options.baseUrl || this.options.baseUrl;
        var newOptions = { baseUrl: baseUrl };
        for (var key in options) {
            if (options.hasOwnProperty(key)) {
                var specKey = rewriteSpecName(key);
                newOptions[specKey] = options[key];
            }
        }
        return new ImageUrlBuilder(this, __assign({ baseUrl: baseUrl }, newOptions));
    };
    ImageUrlBuilder.prototype.image = function (source) {
        return this.withOptions({ source: source });
    };
    ImageUrlBuilder.prototype.dataset = function (dataset) {
        return this.withOptions({ dataset: dataset });
    };
    ImageUrlBuilder.prototype.projectId = function (projectId) {
        return this.withOptions({ projectId: projectId });
    };
    ImageUrlBuilder.prototype.bg = function (bg) {
        return this.withOptions({ bg: bg });
    };
    ImageUrlBuilder.prototype.dpr = function (dpr) {
        return this.withOptions({ dpr: dpr });
    };
    ImageUrlBuilder.prototype.width = function (width) {
        return this.withOptions({ width: width });
    };
    ImageUrlBuilder.prototype.height = function (height) {
        return this.withOptions({ height: height });
    };
    ImageUrlBuilder.prototype.focalPoint = function (x, y) {
        return this.withOptions({ focalPoint: { x: x, y: y } });
    };
    ImageUrlBuilder.prototype.maxWidth = function (maxWidth) {
        return this.withOptions({ maxWidth: maxWidth });
    };
    ImageUrlBuilder.prototype.minWidth = function (minWidth) {
        return this.withOptions({ minWidth: minWidth });
    };
    ImageUrlBuilder.prototype.maxHeight = function (maxHeight) {
        return this.withOptions({ maxHeight: maxHeight });
    };
    ImageUrlBuilder.prototype.minHeight = function (minHeight) {
        return this.withOptions({ minHeight: minHeight });
    };
    ImageUrlBuilder.prototype.size = function (width, height) {
        return this.withOptions({ width: width, height: height });
    };
    ImageUrlBuilder.prototype.blur = function (blur) {
        return this.withOptions({ blur: blur });
    };
    ImageUrlBuilder.prototype.sharpen = function (sharpen) {
        return this.withOptions({ sharpen: sharpen });
    };
    ImageUrlBuilder.prototype.rect = function (left, top, width, height) {
        return this.withOptions({ rect: { left: left, top: top, width: width, height: height } });
    };
    ImageUrlBuilder.prototype.format = function (format) {
        return this.withOptions({ format: format });
    };
    ImageUrlBuilder.prototype.invert = function (invert) {
        return this.withOptions({ invert: invert });
    };
    ImageUrlBuilder.prototype.orientation = function (orientation) {
        return this.withOptions({ orientation: orientation });
    };
    ImageUrlBuilder.prototype.quality = function (quality) {
        return this.withOptions({ quality: quality });
    };
    ImageUrlBuilder.prototype.forceDownload = function (download) {
        return this.withOptions({ download: download });
    };
    ImageUrlBuilder.prototype.flipHorizontal = function () {
        return this.withOptions({ flipHorizontal: true });
    };
    ImageUrlBuilder.prototype.flipVertical = function () {
        return this.withOptions({ flipVertical: true });
    };
    ImageUrlBuilder.prototype.ignoreImageParams = function () {
        return this.withOptions({ ignoreImageParams: true });
    };
    ImageUrlBuilder.prototype.fit = function (value) {
        if (validFits.indexOf(value) === -1) {
            throw new Error("Invalid fit mode \"" + value + "\"");
        }
        return this.withOptions({ fit: value });
    };
    ImageUrlBuilder.prototype.crop = function (value) {
        if (validCrops.indexOf(value) === -1) {
            throw new Error("Invalid crop mode \"" + value + "\"");
        }
        return this.withOptions({ crop: value });
    };
    ImageUrlBuilder.prototype.saturation = function (saturation) {
        return this.withOptions({ saturation: saturation });
    };
    ImageUrlBuilder.prototype.auto = function (value) {
        if (validAutoModes.indexOf(value) === -1) {
            throw new Error("Invalid auto mode \"" + value + "\"");
        }
        return this.withOptions({ auto: value });
    };
    ImageUrlBuilder.prototype.pad = function (pad) {
        return this.withOptions({ pad: pad });
    };
    ImageUrlBuilder.prototype.url = function () {
        return urlForImage_1.default(this.options);
    };
    ImageUrlBuilder.prototype.toString = function () {
        return this.url();
    };
    return ImageUrlBuilder;
}());
builder.ImageUrlBuilder = ImageUrlBuilder;

var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var builder_1 = __importDefault(builder);
var node = builder_1.default;

var generateHelpUrl = generateHelpUrl$1;
var urlBuilder = node;
var objectAssign$5 = objectAssign$6;
var enc = encodeURIComponent;
var materializeError = "You must either:\n  - Pass `projectId` and `dataset` to the block renderer\n  - Materialize images to include the `url` field.\n\nFor more information, see ".concat(generateHelpUrl('block-content-image-materializing'));
var getQueryString = function getQueryString(options) {
  var query = options.imageOptions;
  var keys = Object.keys(query);
  if (!keys.length) {
    return '';
  }
  var params = keys.map(function (key) {
    return "".concat(enc(key), "=").concat(enc(query[key]));
  });
  return "?".concat(params.join('&'));
};
var buildUrl = function buildUrl(props) {
  var node = props.node,
      options = props.options;
  var projectId = options.projectId,
      dataset = options.dataset;
  var asset = node.asset;
  if (!asset) {
    throw new Error('Image does not have required `asset` property');
  }
  if (asset.url) {
    return asset.url + getQueryString(options);
  }
  if (!projectId || !dataset) {
    throw new Error(materializeError);
  }
  var ref = asset._ref;
  if (!ref) {
    throw new Error('Invalid image reference in block, no `_ref` found on `asset`');
  }
  return urlBuilder(objectAssign$5({
    projectId: projectId,
    dataset: dataset
  }, options.imageOptions || {})).image(node).toString();
};
var getImageUrl$3 = buildUrl;

var objectAssign$4 = objectAssign$6;
var getImageUrl$2 = getImageUrl$3;
var serializers$1 = function (h, serializerOpts) {
  var serializeOptions = serializerOpts || {
    useDashedStyles: false
  };
  function BlockSerializer(props) {
    var node = props.node,
        serializers = props.serializers,
        options = props.options,
        isInline = props.isInline,
        children = props.children;
    var blockType = node._type;
    var serializer = serializers.types[blockType];
    if (!serializer) {
      throw new Error("Unknown block type \"".concat(blockType, "\", please specify a serializer for it in the `serializers.types` prop"));
    }
    return h(serializer, {
      node: node,
      options: options,
      isInline: isInline
    }, children);
  }
  function SpanSerializer(props) {
    var _props$node = props.node,
        mark = _props$node.mark,
        children = _props$node.children;
    var isPlain = typeof mark === 'string';
    var markType = isPlain ? mark : mark._type;
    var serializer = props.serializers.marks[markType];
    if (!serializer) {
      console.warn("Unknown mark type \"".concat(markType, "\", please specify a serializer for it in the `serializers.marks` prop"));
      return h(props.serializers.markFallback, null, children);
    }
    return h(serializer, props.node, children);
  }
  function ListSerializer(props) {
    var tag = props.type === 'bullet' ? 'ul' : 'ol';
    return h(tag, null, props.children);
  }
  function ListItemSerializer(props) {
    var children = !props.node.style || props.node.style === 'normal' ?
    props.children :
    h(props.serializers.types.block, props, props.children);
    return h('li', null, children);
  }
  function BlockTypeSerializer(props) {
    var style = props.node.style || 'normal';
    if (/^h\d/.test(style)) {
      return h(style, null, props.children);
    }
    return style === 'blockquote' ? h('blockquote', null, props.children) : h('p', null, props.children);
  }
  function RawMarkSerializer(tag, props) {
    return h(tag, null, props.children);
  }
  function UnderlineSerializer(props) {
    var style = serializeOptions.useDashedStyles ? {
      'text-decoration': 'underline'
    } : {
      textDecoration: 'underline'
    };
    return h('span', {
      style: style
    }, props.children);
  }
  function StrikeThroughSerializer(props) {
    return h('del', null, props.children);
  }
  function LinkSerializer(props) {
    return h('a', {
      href: props.mark.href
    }, props.children);
  }
  function ImageSerializer(props) {
    if (!props.node.asset) {
      return null;
    }
    var img = h('img', {
      src: getImageUrl$2(props)
    });
    return props.isInline ? img : h('figure', null, img);
  }
  function serializeSpan(span, serializers, index, options) {
    if (span === '\n' && serializers.hardBreak) {
      return h(serializers.hardBreak, {
        key: "hb-".concat(index)
      });
    }
    if (typeof span === 'string') {
      return serializers.text ? h(serializers.text, {
        key: "text-".concat(index)
      }, span) : span;
    }
    var children;
    if (span.children) {
      children = {
        children: span.children.map(function (child, i) {
          return options.serializeNode(child, i, span.children, true);
        })
      };
    }
    var serializedNode = objectAssign$4({}, span, children);
    return h(serializers.span, {
      key: span._key || "span-".concat(index),
      node: serializedNode,
      serializers: serializers
    });
  }
  var HardBreakSerializer = function HardBreakSerializer() {
    return h('br');
  };
  var defaultMarkSerializers = {
    strong: RawMarkSerializer.bind(null, 'strong'),
    em: RawMarkSerializer.bind(null, 'em'),
    code: RawMarkSerializer.bind(null, 'code'),
    underline: UnderlineSerializer,
    'strike-through': StrikeThroughSerializer,
    link: LinkSerializer
  };
  var defaultSerializers = {
    types: {
      block: BlockTypeSerializer,
      image: ImageSerializer
    },
    marks: defaultMarkSerializers,
    list: ListSerializer,
    listItem: ListItemSerializer,
    block: BlockSerializer,
    span: SpanSerializer,
    hardBreak: HardBreakSerializer,
    container: 'div',
    markFallback: 'span',
    text: undefined,
    empty: ''
  };
  return {
    defaultSerializers: defaultSerializers,
    serializeSpan: serializeSpan
  };
};

var defaultMarks = ['strong', 'em', 'code', 'underline', 'strike-through'];
var buildMarksTree$1 = function buildMarksTree(block) {
  var children = block.children,
      markDefs = block.markDefs;
  if (!children || !children.length) {
    return [];
  }
  var sortedMarks = children.map(sortMarksByOccurences);
  var rootNode = {
    _type: 'span',
    children: []
  };
  var nodeStack = [rootNode];
  children.forEach(function (span, i) {
    var marksNeeded = sortedMarks[i];
    if (!marksNeeded) {
      var lastNode = nodeStack[nodeStack.length - 1];
      lastNode.children.push(span);
      return;
    }
    var pos = 1;
    if (nodeStack.length > 1) {
      for (pos; pos < nodeStack.length; pos++) {
        var mark = nodeStack[pos].markKey;
        var index = marksNeeded.indexOf(mark);
        if (index === -1) {
          break;
        }
        marksNeeded.splice(index, 1);
      }
    }
    nodeStack = nodeStack.slice(0, pos);
    var currentNode = findLastParentNode(nodeStack);
    marksNeeded.forEach(function (mark) {
      var node = {
        _type: 'span',
        _key: span._key,
        children: [],
        mark: markDefs.find(function (def) {
          return def._key === mark;
        }) || mark,
        markKey: mark
      };
      currentNode.children.push(node);
      nodeStack.push(node);
      currentNode = node;
    });
    if (isTextSpan(span)) {
      var lines = span.text.split('\n');
      for (var line = lines.length; line-- > 1;) {
        lines.splice(line, 0, '\n');
      }
      currentNode.children = currentNode.children.concat(lines);
    } else {
      currentNode.children = currentNode.children.concat(span);
    }
  });
  return rootNode.children;
};
function sortMarksByOccurences(span, i, spans) {
  if (!span.marks || span.marks.length === 0) {
    return span.marks || [];
  }
  var markOccurences = span.marks.reduce(function (occurences, mark) {
    occurences[mark] = occurences[mark] ? occurences[mark] + 1 : 1;
    for (var siblingIndex = i + 1; siblingIndex < spans.length; siblingIndex++) {
      var sibling = spans[siblingIndex];
      if (sibling.marks && Array.isArray(sibling.marks) && sibling.marks.indexOf(mark) !== -1) {
        occurences[mark]++;
      } else {
        break;
      }
    }
    return occurences;
  }, {});
  var sortByOccurence = sortMarks.bind(null, markOccurences);
  return span.marks.slice().sort(sortByOccurence);
}
function sortMarks(occurences, markA, markB) {
  var aOccurences = occurences[markA] || 0;
  var bOccurences = occurences[markB] || 0;
  if (aOccurences !== bOccurences) {
    return bOccurences - aOccurences;
  }
  var aDefaultPos = defaultMarks.indexOf(markA);
  var bDefaultPos = defaultMarks.indexOf(markB);
  if (aDefaultPos !== bDefaultPos) {
    return aDefaultPos - bDefaultPos;
  }
  if (markA < markB) {
    return -1;
  } else if (markA > markB) {
    return 1;
  }
  return 0;
}
function isTextSpan(node) {
  return node._type === 'span' && typeof node.text === 'string' && (Array.isArray(node.marks) || typeof node.marks === 'undefined');
}
function findLastParentNode(nodes) {
  for (var i = nodes.length - 1; i >= 0; i--) {
    var node = nodes[i];
    if (node._type === 'span' && node.children) {
      return node;
    }
  }
  return undefined;
}
var buildMarksTree_1 = buildMarksTree$1;

var objectAssign$3 = objectAssign$6;
function nestLists$1(blocks) {
  var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'html';
  var tree = [];
  var currentList;
  for (var i = 0; i < blocks.length; i++) {
    var block = blocks[i];
    if (!isListBlock(block)) {
      tree.push(block);
      currentList = null;
      continue;
    }
    if (!currentList) {
      currentList = listFromBlock(block);
      tree.push(currentList);
      continue;
    }
    if (blockMatchesList(block, currentList)) {
      currentList.children.push(block);
      continue;
    }
    if (block.level > currentList.level) {
      var newList = listFromBlock(block);
      if (mode === 'html') {
        var lastListItem = lastChild(currentList);
        var newLastChild = objectAssign$3({}, lastListItem, {
          children: lastListItem.children.concat(newList)
        });
        currentList.children[currentList.children.length - 1] = newLastChild;
      } else {
        currentList.children.push(newList);
      }
      currentList = newList;
      continue;
    }
    if (block.level < currentList.level) {
      var match = findListMatching(tree[tree.length - 1], block);
      if (match) {
        currentList = match;
        currentList.children.push(block);
        continue;
      }
      currentList = listFromBlock(block);
      tree.push(currentList);
      continue;
    }
    if (block.listItem !== currentList.listItem) {
      var _match = findListMatching(tree[tree.length - 1], {
        level: block.level
      });
      if (_match && _match.listItem === block.listItem) {
        currentList = _match;
        currentList.children.push(block);
        continue;
      } else {
        currentList = listFromBlock(block);
        tree.push(currentList);
        continue;
      }
    }
    console.warn('Unknown state encountered for block', block);
    tree.push(block);
  }
  return tree;
}
function isListBlock(block) {
  return Boolean(block.listItem);
}
function blockMatchesList(block, list) {
  return block.level === list.level && block.listItem === list.listItem;
}
function listFromBlock(block) {
  return {
    _type: 'list',
    _key: "".concat(block._key, "-parent"),
    level: block.level,
    listItem: block.listItem,
    children: [block]
  };
}
function lastChild(block) {
  return block.children && block.children[block.children.length - 1];
}
function findListMatching(rootNode, matching) {
  var filterOnType = typeof matching.listItem === 'string';
  if (rootNode._type === 'list' && rootNode.level === matching.level && filterOnType && rootNode.listItem === matching.listItem) {
    return rootNode;
  }
  var node = lastChild(rootNode);
  if (!node) {
    return false;
  }
  return findListMatching(node, matching);
}
var nestLists_1 = nestLists$1;

var objectAssign$2 = objectAssign$6;
var generateKeys$1 = function (blocks) {
  return blocks.map(function (block) {
    if (block._key) {
      return block;
    }
    return objectAssign$2({
      _key: getStaticKey(block)
    }, block);
  });
};
function getStaticKey(item) {
  return checksum(JSON.stringify(item)).toString(36).replace(/[^A-Za-z0-9]/g, '');
}
function checksum(str) {
  var hash = 0;
  var strlen = str.length;
  if (strlen === 0) {
    return hash;
  }
  for (var i = 0; i < strlen; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash &= hash;
  }
  return hash;
}

function _typeof$4(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$4 = function _typeof(obj) { return typeof obj; }; } else { _typeof$4 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$4(obj); }
var objectAssign$1 = objectAssign$6;
var isDefined$2 = function isDefined(val) {
  return typeof val !== 'undefined';
};
var mergeSerializers$3 = function mergeSerializers(defaultSerializers, userSerializers) {
  return Object.keys(defaultSerializers).reduce(function (acc, key) {
    var type = _typeof$4(defaultSerializers[key]);
    if (type === 'function') {
      acc[key] = isDefined$2(userSerializers[key]) ? userSerializers[key] : defaultSerializers[key];
    } else if (type === 'object') {
      acc[key] = objectAssign$1({}, defaultSerializers[key], userSerializers[key]);
    } else {
      acc[key] = typeof userSerializers[key] === 'undefined' ? defaultSerializers[key] : userSerializers[key];
    }
    return acc;
  }, {});
};

var objectAssign = objectAssign$6;
var buildMarksTree = buildMarksTree_1;
var nestLists = nestLists_1;
var generateKeys = generateKeys$1;
var mergeSerializers$2 = mergeSerializers$3;
var optionProps = ['projectId', 'dataset', 'imageOptions'];
var isDefined$1 = function isDefined(val) {
  return typeof val !== 'undefined';
};
var defaults = {
  imageOptions: {}
};
function blocksToNodes$1(h, properties, defaultSerializers, serializeSpan) {
  var props = objectAssign({}, defaults, properties);
  var rawBlocks = Array.isArray(props.blocks) ? props.blocks : [props.blocks];
  var keyedBlocks = generateKeys(rawBlocks);
  var blocks = nestLists(keyedBlocks, props.listNestMode);
  var serializers = mergeSerializers$2(defaultSerializers, props.serializers || {});
  var options = optionProps.reduce(function (opts, key) {
    var value = props[key];
    if (isDefined$1(value)) {
      opts[key] = value;
    }
    return opts;
  }, {});
  function serializeNode(node, index, siblings, isInline) {
    if (isList(node)) {
      return serializeList(node);
    }
    if (isListItem(node)) {
      return serializeListItem(node, findListItemIndex(node, siblings));
    }
    if (isSpan(node)) {
      return serializeSpan(node, serializers, index, {
        serializeNode: serializeNode
      });
    }
    return serializeBlock(node, index, isInline);
  }
  function findListItemIndex(node, siblings) {
    var index = 0;
    for (var i = 0; i < siblings.length; i++) {
      if (siblings[i] === node) {
        return index;
      }
      if (!isListItem(siblings[i])) {
        continue;
      }
      index++;
    }
    return index;
  }
  function serializeBlock(block, index, isInline) {
    var tree = buildMarksTree(block);
    var children = tree.map(function (node, i, siblings) {
      return serializeNode(node, i, siblings, true);
    });
    var blockProps = {
      key: block._key || "block-".concat(index),
      node: block,
      isInline: isInline,
      serializers: serializers,
      options: options
    };
    return h(serializers.block, blockProps, children);
  }
  function serializeListItem(block, index) {
    var key = block._key;
    var tree = buildMarksTree(block);
    var children = tree.map(serializeNode);
    return h(serializers.listItem, {
      node: block,
      serializers: serializers,
      index: index,
      key: key,
      options: options
    }, children);
  }
  function serializeList(list) {
    var type = list.listItem;
    var level = list.level;
    var key = list._key;
    var children = list.children.map(serializeNode);
    return h(serializers.list, {
      key: key,
      level: level,
      type: type,
      options: options
    }, children);
  }
  var renderContainerOnSingleChild = Boolean(props.renderContainerOnSingleChild);
  var nodes = blocks.map(serializeNode);
  if (renderContainerOnSingleChild || nodes.length > 1) {
    var containerProps = props.className ? {
      className: props.className
    } : {};
    return h(serializers.container, containerProps, nodes);
  }
  if (nodes[0]) {
    return nodes[0];
  }
  return typeof serializers.empty === 'function' ? h(serializers.empty) : serializers.empty;
}
function isList(block) {
  return block._type === 'list' && block.listItem;
}
function isListItem(block) {
  return block._type === 'block' && block.listItem;
}
function isSpan(block) {
  return typeof block === 'string' || block.marks || block._type === 'span';
}
var blocksToNodes_1 = blocksToNodes$1;

var getSerializers$1 = serializers$1;
var _blocksToNodes = blocksToNodes_1;
var getImageUrl$1 = getImageUrl$3;
var mergeSerializers$1 = mergeSerializers$3;
var internals$2 = {
  blocksToNodes: function blocksToNodes(renderNode, props, defaultSerializers, serializeSpan) {
    if (defaultSerializers) {
      return _blocksToNodes(renderNode, props, defaultSerializers, serializeSpan);
    }
    var serializers = getSerializers$1(renderNode);
    return _blocksToNodes(renderNode, props, serializers.defaultSerializers, serializers.serializeSpan);
  },
  getSerializers: getSerializers$1,
  getImageUrl: getImageUrl$1,
  mergeSerializers: mergeSerializers$1
};

var internals$1 = internals$2;

var React$1 = React__default;
var _require$1 = internals$1,
    getSerializers = _require$1.getSerializers;
var renderNode$1 = React$1.createElement;
var _getSerializers = getSerializers(renderNode$1),
    defaultSerializers = _getSerializers.defaultSerializers,
    serializeSpan$1 = _getSerializers.serializeSpan;
var dom = {
  serializeSpan: serializeSpan$1,
  serializers: defaultSerializers,
  renderProps: { nestMarks: true }
};

var React = React__default;
var PropTypes = propTypes.exports;
var internals = internals$1;
var _require = dom,
    serializers = _require.serializers,
    serializeSpan = _require.serializeSpan,
    renderProps = _require.renderProps;
var getImageUrl = internals.getImageUrl,
    blocksToNodes = internals.blocksToNodes,
    mergeSerializers = internals.mergeSerializers;
var renderNode = React.createElement;
var SanityBlockContent = function SanityBlockContent(props) {
  var customSerializers = mergeSerializers(SanityBlockContent.defaultSerializers, props.serializers);
  var blockProps = Object.assign({}, renderProps, props, {
    serializers: customSerializers,
    blocks: props.blocks || []
  });
  return blocksToNodes(renderNode, blockProps, serializers, serializeSpan);
};
SanityBlockContent.defaultSerializers = serializers;
SanityBlockContent.getImageUrl = getImageUrl;
SanityBlockContent.propTypes = {
  className: PropTypes.string,
  renderContainerOnSingleChild: PropTypes.bool,
  projectId: PropTypes.string,
  dataset: PropTypes.string,
  imageOptions: PropTypes.object,
  serializers: PropTypes.shape({
    types: PropTypes.object,
    marks: PropTypes.object,
    list: PropTypes.func,
    listItem: PropTypes.func,
    block: PropTypes.func,
    span: PropTypes.func
  }),
  blocks: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({
    _type: PropTypes.string.isRequired
  })), PropTypes.shape({
    _type: PropTypes.string.isRequired
  })]).isRequired
};
SanityBlockContent.defaultProps = {
  renderContainerOnSingleChild: false,
  serializers: {},
  imageOptions: {}
};
var BlockContent = SanityBlockContent;

(function (exports) {
var K=Object.create,f=Object.defineProperty,R=Object.getPrototypeOf,E=Object.prototype.hasOwnProperty,A=Object.getOwnPropertyNames,G=Object.getOwnPropertyDescriptor,I=Object.getOwnPropertySymbols,J=Object.prototype.propertyIsEnumerable;var S=Object.assign,O=e=>f(e,"__esModule",{value:!0});var m=(e,n)=>{var l={};for(var r in e)E.call(e,r)&&n.indexOf(r)<0&&(l[r]=e[r]);if(e!=null&&I)for(var r of I(e))n.indexOf(r)<0&&J.call(e,r)&&(l[r]=e[r]);return l};var L=(e,n)=>{for(var l in n)f(e,l,{get:n[l],enumerable:!0});},Q=(e,n,l)=>{if(n&&typeof n=="object"||typeof n=="function")for(let r of A(n))!E.call(e,r)&&r!=="default"&&f(e,r,{get:()=>n[r],enumerable:!(l=G(n,r))||l.enumerable});return e},P=e=>Q(O(f(e!=null?K(R(e)):{},"default",e&&e.__esModule&&"default"in e?{get:()=>e.default,enumerable:!0}:{value:e,enumerable:!0})),e);O(exports);L(exports,{blockContentToPlainText:()=>Z,default:()=>X});var w=P(React__default),t=P(propTypes.exports),s=P(BlockContent),z=s.default.defaultSerializers,q=y=>{var{content:e,className:n,serializers:l={},dataset:r,projectId:p}=y,T=m(y,["content","className","serializers","dataset","projectId"]);if(!e)throw new Error("No `content` provided to PortableText.");return w.default.createElement(s.default,S({blocks:e,className:n,serializers:V(l),renderContainerOnSingleChild:!0,dataset:r,projectId:p},T))},X=q;q.propTypes={content:t.default.array.isRequired,className:t.default.string,projectId:t.default.string,dataset:t.default.string,serializers:t.default.shape({link:t.default.elementType,strong:t.default.elementType,em:t.default.elementType,underline:t.default.elementType,del:t.default.elementType,code:t.default.elementType,ul:t.default.elementType,ol:t.default.elementType,li:t.default.elementType,h1:t.default.elementType,h2:t.default.elementType,h3:t.default.elementType,h4:t.default.elementType,h5:t.default.elementType,h6:t.default.elementType,blockquote:t.default.elementType,container:t.default.elementType,block:t.default.elementType,span:t.default.elementType,hardBreak:t.default.elementType,unknownType:t.default.elementType,unknownMark:t.default.elementType})};var V=e=>{let{link:n,strong:l,em:r,underline:p,del:T,code:y,ul:a,ol:B,li:u,h1:h,h2:k,h3:C,h4:N,h5:j,h6:g,blockquote:x,container:M="div",block:U=z.BlockSerializer,span:W=z.SpanSerializer,hardBreak:$=z.HardBreakSerializer,unknownType:D=z.DefaultUnknownTypeSerializer,unknownMark:F="span"}=e,b=m(e,["link","strong","em","underline","del","code","ul","ol","li","h1","h2","h3","h4","h5","h6","blockquote","container","block","span","hardBreak","unknownType","unknownMark"]),_={h1:h,h2:k,h3:C,h4:N,h5:j,h6:g,blockquote:x};return {container:M,block:U,span:W,hardBreak:$,unknownType:D,unknownMark:F,marks:Y(S({link:n,strong:l,em:r,underline:p,code:y,"strike-through":T},b)),list:o=>{let{type:i,children:c}=o,d=i==="bullet"?a:B;return d?d({children:c}):s.default.defaultSerializers.list(o)},listItem:o=>{let{children:i}=o;return u?u({children:i}):s.default.defaultSerializers.listItem(o)},types:S({block:o=>{let{node:{style:i},children:c}=o;return _[i]?_[i]({children:c}):b[i]?b[i]({children:c}):s.default.defaultSerializers.types.block(o)}},Object.entries(b).reduce((o,[i,c])=>{let d=({node:H})=>w.default.createElement(c,H);return d.displayName=`${v(i)}Wrapper`,o[i]=d,o},{}))}},Y=e=>Object.entries(e).reduce((n,[l,r])=>{if(r){let p=k=>{var{_type:T,_key:y,mark:a,markKey:B,children:u}=k,h=m(k,["_type","_key","mark","markKey","children"]);if(typeof a=="object"){let j=m(a,["_type","_key"]);Object.entries(j).forEach(([g,x])=>{h[g]=x;});}return w.default.createElement(r,h,u)};p.displayName=`${v(l)}Wrapper`,n[l]=p;}return n},{}),Z=(e=[])=>e.map(n=>n._type==="block"&&n.children?n.children.map(l=>l.text).join(""):"").join(`

`),v=e=>e.slice(0,1).toUpperCase()+e.slice(1);
}(dist));
var PortableText = getDefaultExportFromCjs(dist);

function _typeof$3(obj) {
  "@babel/helpers - typeof";
  return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof$3(obj);
}

function _defineProperty$g(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$2(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$2(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$2(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

var matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34);/g;
var htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"'
};
var unescapeHtmlEntity = function unescapeHtmlEntity(m) {
  return htmlEntities[m];
};
var unescape = function unescape(text) {
  return text.replace(matchHtmlEntity, unescapeHtmlEntity);
};

function ownKeys$h(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$h(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$h(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$h(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape: unescape
};
var i18nInstance;
var I18nContext = createContext();
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = _objectSpread$h(_objectSpread$h({}, defaultOptions), options);
}
function getDefaults() {
  return defaultOptions;
}
var ReportNamespaces = function () {
  function ReportNamespaces() {
    _classCallCheck$2(this, ReportNamespaces);
    this.usedNamespaces = {};
  }
  _createClass$2(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;
      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);
  return ReportNamespaces;
}();
function setI18n(instance) {
  i18nInstance = instance;
}
function getI18n() {
  return i18nInstance;
}
var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};

function warn() {
  if (console && console.warn) {
    var _console;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);
    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
}
function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };
      i18n.on('initialized', initialized);
    }
  });
}
function oldI18nextHasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;
  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  };
  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}
function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!i18n.languages || !i18n.languages.length) {
    warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }
  var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }
  return i18n.hasLoadedNamespace(ns, {
    precheck: function precheck(i18nInstance, loadNotPending) {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}

function _arrayWithHoles$2(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit$2(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}

function _arrayLikeToArray$5(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

function _unsupportedIterableToArray$5(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$5(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen);
}

function _nonIterableRest$2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray$2(arr, i) {
  return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray$5(arr, i) || _nonIterableRest$2();
}

function ownKeys$g(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$g(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$g(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$g(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var usePrevious = function usePrevious(value, ignore) {
  var ref = useRef();
  useEffect(function () {
    ref.current = ignore ? ref.current : value;
  }, [value, ignore]);
  return ref.current;
};
function useTranslation$1(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18nFromProps = props.i18n;
  var _ref = useContext(I18nContext) || {},
      i18nFromContext = _ref.i18n,
      defaultNSFromContext = _ref.defaultNS;
  var i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();
  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using initReactI18next');
    var notReadyT = function notReadyT(k) {
      return Array.isArray(k) ? k[k.length - 1] : k;
    };
    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }
  if (i18n.options.react && i18n.options.react.wait !== undefined) warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
  var i18nOptions = _objectSpread$g(_objectSpread$g(_objectSpread$g({}, getDefaults()), i18n.options.react), props);
  var useSuspense = i18nOptions.useSuspense,
      keyPrefix = i18nOptions.keyPrefix;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return hasLoadedNamespace(n, i18n, i18nOptions);
  });
  function getT() {
    return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }
  var _useState = useState(getT),
      _useState2 = _slicedToArray$2(_useState, 2),
      t = _useState2[0],
      setT = _useState2[1];
  var joinedNS = namespaces.join();
  var previousJoinedNS = usePrevious(joinedNS);
  var isMounted = useRef(true);
  useEffect(function () {
    var bindI18n = i18nOptions.bindI18n,
        bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;
    if (!ready && !useSuspense) {
      loadNamespaces(i18n, namespaces, function () {
        if (isMounted.current) setT(getT);
      });
    }
    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getT);
    }
    function boundReset() {
      if (isMounted.current) setT(getT);
    }
    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return function () {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [i18n, joinedNS]);
  var isInitial = useRef(true);
  useEffect(function () {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }
    isInitial.current = false;
  }, [i18n]);
  var ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(function (resolve) {
    loadNamespaces(i18n, namespaces, function () {
      resolve();
    });
  });
}

var useTranslation = function useTranslation() {
  var _useTranslationNext = useTranslation$1.apply(void 0, arguments),
      t = _useTranslationNext.t,
      i18n = _useTranslationNext.i18n;
  var _ = function _(key) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return HTMLReactParser$1(t(key, options));
  };
  return {
    _: _,
    i18n: i18n
  };
};

function _assertThisInitialized$2(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _setPrototypeOf$2(o, p) {
  _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf$2(o, p);
}

function _inherits$2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf$2(subClass, superClass);
}

function _possibleConstructorReturn$2(self, call) {
  if (call && (_typeof$3(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$2(self);
}

function _getPrototypeOf$2(o) {
  _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$2(o);
}

function _iterableToArray$5(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _toArray(arr) {
  return _arrayWithHoles$2(arr) || _iterableToArray$5(arr) || _unsupportedIterableToArray$5(arr) || _nonIterableRest$2();
}

function ownKeys$f(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$f(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$f(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$f(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};
var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck$2(this, Logger);
    this.init(concreteLogger, options);
  }
  _createClass$2(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, _objectSpread$f(_objectSpread$f({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }), this.options));
    }
  }]);
  return Logger;
}();
var baseLogger = new Logger();
var EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck$2(this, EventEmitter);
    this.observers = {};
  }
  _createClass$2(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;
      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];
        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;
      if (!listener) {
        delete this.observers[event];
        return;
      }
      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }
      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);
        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);
  return EventEmitter;
}();
function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy$4(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}
function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }
  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }
  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }
  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}
function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;
  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;
  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;
  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);
  if (value !== undefined) {
    return value;
  }
  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }
  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }
  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && typeof window.navigator.userAgentData === 'undefined' && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
var chars = [' ', ',', '?', '!', ';'];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
  nsSeparator = nsSeparator || '';
  keySeparator = keySeparator || '';
  var possibleChars = chars.filter(function (c) {
    return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
  });
  if (possibleChars.length === 0) return true;
  var r = new RegExp("(".concat(possibleChars.map(function (c) {
    return c === '?' ? '\\?' : c;
  }).join('|'), ")"));
  var matched = !r.test(key);
  if (!matched) {
    var ki = key.indexOf(keySeparator);
    if (ki > 0 && !r.test(key.substring(0, ki))) {
      matched = true;
    }
  }
  return matched;
}
function ownKeys$1$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1$1(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf$2(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$2(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$2(this, result); }; }
function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function deepFind(obj, path) {
  var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) return obj[path];
  var paths = path.split(keySeparator);
  var current = obj;
  for (var i = 0; i < paths.length; ++i) {
    if (!current) return undefined;
    if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) {
      return undefined;
    }
    if (current[paths[i]] === undefined) {
      var j = 2;
      var p = paths.slice(i, i + j).join(keySeparator);
      var mix = current[p];
      while (mix === undefined && paths.length > i + j) {
        j++;
        p = paths.slice(i, i + j).join(keySeparator);
        mix = current[p];
      }
      if (mix === undefined) return undefined;
      if (mix === null) return null;
      if (path.endsWith(p)) {
        if (typeof mix === 'string') return mix;
        if (p && typeof mix[p] === 'string') return mix[p];
      }
      var joinedPath = paths.slice(i + j).join(keySeparator);
      if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
      return undefined;
    }
    current = current[paths[i]];
  }
  return current;
}
var ResourceStore = function (_EventEmitter) {
  _inherits$2(ResourceStore, _EventEmitter);
  var _super = _createSuper$2(ResourceStore);
  function ResourceStore(data) {
    var _this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };
    _classCallCheck$2(this, ResourceStore);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized$2(_this));
    }
    _this.data = data || {};
    _this.options = options;
    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }
    if (_this.options.ignoreJSONStructure === undefined) {
      _this.options.ignoreJSONStructure = true;
    }
    return _this;
  }
  _createClass$2(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);
      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }
      var result = getPath(this.data, path);
      if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }
      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };
      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];
      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }
      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};
      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = _objectSpread$1$1(_objectSpread$1$1({}, pack), resources);
      }
      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }
      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return _objectSpread$1$1(_objectSpread$1$1({}, {}), this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "hasLanguageSomeTranslations",
    value: function hasLanguageSomeTranslations(lng) {
      var data = this.getDataByLanguage(lng);
      var n = data && Object.keys(data) || [];
      return !!n.find(function (v) {
        return data[v] && Object.keys(data[v]).length > 0;
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);
  return ResourceStore;
}(EventEmitter);
var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;
    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};
function ownKeys$2$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2$1(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _createSuper$1$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1$1(); return function _createSuperInternal() { var Super = _getPrototypeOf$2(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$2(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$2(this, result); }; }
function _isNativeReflectConstruct$1$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var checkedLoadedFor = {};
var Translator = function (_EventEmitter) {
  _inherits$2(Translator, _EventEmitter);
  var _super = _createSuper$1$1(Translator);
  function Translator(services) {
    var _this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck$2(this, Translator);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized$2(_this));
    }
    copy$4(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, _assertThisInitialized$2(_this));
    _this.options = options;
    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }
    _this.logger = baseLogger.create('translator');
    return _this;
  }
  _createClass$2(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      if (key === undefined || key === null) {
        return false;
      }
      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS || [];
      var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
      var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
      if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
        var m = key.match(this.interpolator.nestingRegexp);
        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }
        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }
      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;
      if (_typeof$3(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }
      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;
      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
          if (returnDetails) {
            resolved.res = "".concat(namespace).concat(nsSeparator).concat(key);
            return resolved;
          }
          return "".concat(namespace).concat(nsSeparator).concat(key);
        }
        if (returnDetails) {
          resolved.res = key;
          return resolved;
        }
        return key;
      }
      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          if (!this.options.returnedObjectHandler) {
            this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          }
          var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$2$1(_objectSpread$2$1({}, options), {}, {
            ns: namespaces
          })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
          if (returnDetails) {
            resolved.res = r;
            return resolved;
          }
          return r;
        }
        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, _objectSpread$2$1(_objectSpread$2$1({}, options), {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }
          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var hasDefaultValue = Translator.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }
        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }
        var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
        var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread$2$1(_objectSpread$2$1({}, options), {}, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }
          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }
          var send = function send(l, k, specificDefaultValue) {
            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
            }
            _this2.emit('missingKey', l, namespace, k, res);
          };
          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (language) {
                _this2.pluralResolver.getSuffixes(language, options).forEach(function (suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }
        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
        if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
          if (this.options.compatibilityAPI !== 'v1') {
            res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
          } else {
            res = this.options.parseMissingKeyHandler(res);
          }
        }
      }
      if (returnDetails) {
        resolved.res = res;
        return resolved;
      }
      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;
      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, _objectSpread$2$1(_objectSpread$2$1({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(_objectSpread$2$1(_objectSpread$2$1({}, options), {
          interpolation: _objectSpread$2$1(_objectSpread$2$1({}, this.options.interpolation), options.interpolation)
        }));
        var skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
        var nestBef;
        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }
        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = _objectSpread$2$1(_objectSpread$2$1({}, this.options.interpolation.defaultVariables), data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }
        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
            return null;
          }
          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }
      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;
      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$2$1({
          i18nResolved: resolved
        }, options) : options, this);
      }
      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;
        var extracted = _this4.extractFromKey(k, options);
        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
        var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;
          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }
          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKeys = [key];
            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
              var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
              if (needsPluralHandling) {
                finalKeys.push(key + pluralSuffix);
                if (needsZeroSuffixLookup) {
                  finalKeys.push(key + zeroSuffix);
                }
              }
              if (needsContextHandling) {
                var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                finalKeys.push(contextKey);
                if (needsPluralHandling) {
                  finalKeys.push(contextKey + pluralSuffix);
                  if (needsZeroSuffixLookup) {
                    finalKeys.push(contextKey + zeroSuffix);
                  }
                }
              }
            }
            var possibleKey;
            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix = 'defaultValue';
      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
          return true;
        }
      }
      return false;
    }
  }]);
  return Translator;
}(EventEmitter);
function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
var LanguageUtil = function () {
  function LanguageUtil(options) {
    _classCallCheck$2(this, LanguageUtil);
    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }
  _createClass$2(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');
        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }
        return p.join('-');
      }
      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }
      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;
      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;
        var cleanedLng = _this.formatLanguageCode(code);
        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });
      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;
          var lngOnly = _this.getLanguagePartFromCode(code);
          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }
      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;
      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];
      var addCode = function addCode(c) {
        if (!c) return;
        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }
      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);
  return LanguageUtil;
}();
var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
var deprecatedJsonVersions = ['v1', 'v2', 'v3'];
var suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}
var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck$2(this, PluralResolver);
    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === 'v4') && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
      this.options.compatibilityJSON = 'v3';
      this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
    }
    this.rules = createRules();
  }
  _createClass$2(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (this.shouldUseIntlApi()) {
        try {
          return new Intl.PluralRules(code, {
            type: options.ordinal ? 'ordinal' : 'cardinal'
          });
        } catch (_unused) {
          return;
        }
      }
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);
      if (this.shouldUseIntlApi()) {
        return rule && rule.resolvedOptions().pluralCategories.length > 1;
      }
      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.getSuffixes(code, options).map(function (suffix) {
        return "".concat(key).concat(suffix);
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);
      if (!rule) {
        return [];
      }
      if (this.shouldUseIntlApi()) {
        return rule.resolvedOptions().pluralCategories.sort(function (pluralCategory1, pluralCategory2) {
          return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
        }).map(function (pluralCategory) {
          return "".concat(_this.options.prepend).concat(pluralCategory);
        });
      }
      return rule.numbers.map(function (number) {
        return _this.getSuffix(code, number, options);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var rule = this.getRule(code, options);
      if (rule) {
        if (this.shouldUseIntlApi()) {
          return "".concat(this.options.prepend).concat(rule.select(count));
        }
        return this.getSuffixRetroCompatible(rule, count);
      }
      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }, {
    key: "getSuffixRetroCompatible",
    value: function getSuffixRetroCompatible(rule, count) {
      var _this2 = this;
      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];
      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }
      var returnSuffix = function returnSuffix() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };
      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
        return returnSuffix();
      } else if (this.options.compatibilityJSON === 'v2') {
        return returnSuffix();
      } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }
      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
  }, {
    key: "shouldUseIntlApi",
    value: function shouldUseIntlApi() {
      return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
    }
  }]);
  return PluralResolver;
}();
function ownKeys$3$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$3$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3$1(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck$2(this, Interpolator);
    this.logger = baseLogger.create('interpolator');
    this.options = options;
    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };
    this.init(options);
  }
  _createClass$2(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;
      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }
      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = getPathWithDefaults(data, defaultData, key);
          return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3$1(_objectSpread$3$1(_objectSpread$3$1({}, options), data), {}, {
            interpolationkey: key
          })) : path;
        }
        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, _objectSpread$3$1(_objectSpread$3$1(_objectSpread$3$1({}, options), data), {}, {
          interpolationkey: k
        }));
      };
      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;
        while (match = todo.regex.exec(str)) {
          var matchedVar = match[1].trim();
          value = handleFormat(matchedVar);
          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (options && options.hasOwnProperty(matchedVar)) {
              value = '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }
          var safeValue = todo.safeValue(value);
          str = str.replace(match[0], safeValue);
          if (skipOnVariables) {
            todo.regex.lastIndex += value.length;
            todo.regex.lastIndex -= match[0].length;
          } else {
            todo.regex.lastIndex = 0;
          }
          replaces++;
          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;
      var clonedOptions = _objectSpread$3$1({}, options);
      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;
      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        optionsString = optionsString.replace(/'/g, '"');
        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = _objectSpread$3$1(_objectSpread$3$1({}, inheritedOptions), clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }
        delete clonedOptions.defaultValue;
        return key;
      }
      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        var doReduce = false;
        if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }
        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);
        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }
        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, _objectSpread$3$1(_objectSpread$3$1({}, options), {}, {
              interpolationkey: match[1].trim()
            }));
          }, value.trim());
        }
        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }
      return str;
    }
  }]);
  return Interpolator;
}();
function ownKeys$4$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$4$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4$1(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function parseFormatStr(formatStr) {
  var formatName = formatStr.toLowerCase().trim();
  var formatOptions = {};
  if (formatStr.indexOf('(') > -1) {
    var p = formatStr.split('(');
    formatName = p[0].toLowerCase().trim();
    var optStr = p[1].substring(0, p[1].length - 1);
    if (formatName === 'currency' && optStr.indexOf(':') < 0) {
      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
    } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
      if (!formatOptions.range) formatOptions.range = optStr.trim();
    } else {
      var opts = optStr.split(';');
      opts.forEach(function (opt) {
        if (!opt) return;
        var _opt$split = opt.split(':'),
            _opt$split2 = _toArray(_opt$split),
            key = _opt$split2[0],
            rest = _opt$split2.slice(1);
        var val = rest.join(':').trim().replace(/^'+|'+$/g, '');
        if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
        if (val === 'false') formatOptions[key.trim()] = false;
        if (val === 'true') formatOptions[key.trim()] = true;
        if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
      });
    }
  }
  return {
    formatName: formatName,
    formatOptions: formatOptions
  };
}
var Formatter$1 = function () {
  function Formatter() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck$2(this, Formatter);
    this.logger = baseLogger.create('formatter');
    this.options = options;
    this.formats = {
      number: function number(val, lng, options) {
        return new Intl.NumberFormat(lng, options).format(val);
      },
      currency: function currency(val, lng, options) {
        return new Intl.NumberFormat(lng, _objectSpread$4$1(_objectSpread$4$1({}, options), {}, {
          style: 'currency'
        })).format(val);
      },
      datetime: function datetime(val, lng, options) {
        return new Intl.DateTimeFormat(lng, _objectSpread$4$1({}, options)).format(val);
      },
      relativetime: function relativetime(val, lng, options) {
        return new Intl.RelativeTimeFormat(lng, _objectSpread$4$1({}, options)).format(val, options.range || 'day');
      },
      list: function list(val, lng, options) {
        return new Intl.ListFormat(lng, _objectSpread$4$1({}, options)).format(val);
      }
    };
    this.init(options);
  }
  _createClass$2(Formatter, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var iOpts = options.interpolation;
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
    }
  }, {
    key: "add",
    value: function add(name, fc) {
      this.formats[name.toLowerCase().trim()] = fc;
    }
  }, {
    key: "format",
    value: function format(value, _format, lng, options) {
      var _this = this;
      var formats = _format.split(this.formatSeparator);
      var result = formats.reduce(function (mem, f) {
        var _parseFormatStr = parseFormatStr(f),
            formatName = _parseFormatStr.formatName,
            formatOptions = _parseFormatStr.formatOptions;
        if (_this.formats[formatName]) {
          var formatted = mem;
          try {
            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
            formatted = _this.formats[formatName](mem, l, _objectSpread$4$1(_objectSpread$4$1(_objectSpread$4$1({}, formatOptions), options), valOptions));
          } catch (error) {
            _this.logger.warn(error);
          }
          return formatted;
        } else {
          _this.logger.warn("there was no format function for ".concat(formatName));
        }
        return mem;
      }, value);
      return result;
    }
  }]);
  return Formatter;
}();
function ownKeys$5$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$5$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5$1(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _createSuper$2$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2$1(); return function _createSuperInternal() { var Super = _getPrototypeOf$2(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$2(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$2(this, result); }; }
function _isNativeReflectConstruct$2$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function removePending(q, name) {
  if (q.pending[name] !== undefined) {
    delete q.pending[name];
    q.pendingCount--;
  }
}
var Connector = function (_EventEmitter) {
  _inherits$2(Connector, _EventEmitter);
  var _super = _createSuper$2$1(Connector);
  function Connector(backend, store, services) {
    var _this;
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    _classCallCheck$2(this, Connector);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized$2(_this));
    }
    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.waitingReads = [];
    _this.maxParallelReads = options.maxParallelReads || 10;
    _this.readingCalls = 0;
    _this.state = {};
    _this.queue = [];
    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }
    return _this;
  }
  _createClass$2(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;
      var toLoad = {};
      var pending = {};
      var toLoadLanguages = {};
      var toLoadNamespaces = {};
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);
          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending[name] === undefined) pending[name] = true;
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending[name] === undefined) pending[name] = true;
            if (toLoad[name] === undefined) toLoad[name] = true;
            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
          }
        });
        if (!hasAllNamespaces) toLoadLanguages[lng] = true;
      });
      if (Object.keys(toLoad).length || Object.keys(pending).length) {
        this.queue.push({
          pending: pending,
          pendingCount: Object.keys(pending).length,
          loaded: {},
          errors: [],
          callback: callback
        });
      }
      return {
        toLoad: Object.keys(toLoad),
        pending: Object.keys(pending),
        toLoadLanguages: Object.keys(toLoadLanguages),
        toLoadNamespaces: Object.keys(toLoadNamespaces)
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);
      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }
      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        removePending(q, name);
        if (err) q.errors.push(err);
        if (q.pendingCount === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = {};
            var loadedKeys = q.loaded[l];
            if (loadedKeys.length) {
              loadedKeys.forEach(function (ns) {
                if (loaded[l][ns] === undefined) loaded[l][ns] = true;
              });
            }
          });
          q.done = true;
          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;
      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 350;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});
      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng: lng,
          ns: ns,
          fcName: fcName,
          tried: tried,
          wait: wait,
          callback: callback
        });
        return;
      }
      this.readingCalls++;
      return this.backend[fcName](lng, ns, function (err, data) {
        if (err && data && tried < 5) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }
        _this3.readingCalls--;
        if (_this3.waitingReads.length > 0) {
          var next = _this3.waitingReads.shift();
          _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
        }
        callback(err, data);
      });
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;
      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }
      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);
      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }
      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;
      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }
      if (key === undefined || key === null || key === '') return;
      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null, _objectSpread$5$1(_objectSpread$5$1({}, options), {}, {
          isUpdate: isUpdate
        }));
      }
      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);
  return Connector;
}(EventEmitter);
function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (_typeof$3(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];
      if (_typeof$3(args[2]) === 'object' || _typeof$3(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }
      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: true
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];
  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }
  return options;
}
function ownKeys$6$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$6$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6$1(Object(source), true).forEach(function (key) { _defineProperty$g(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf$2(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$2(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$2(this, result); }; }
function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function noop$1() {}
function bindMemberFunctions(inst) {
  var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach(function (mem) {
    if (typeof inst[mem] === 'function') {
      inst[mem] = inst[mem].bind(inst);
    }
  });
}
var I18n = function (_EventEmitter) {
  _inherits$2(I18n, _EventEmitter);
  var _super = _createSuper$3(I18n);
  function I18n() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;
    _classCallCheck$2(this, I18n);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(_assertThisInitialized$2(_this));
    }
    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };
    bindMemberFunctions(_assertThisInitialized$2(_this));
    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);
        return _possibleConstructorReturn$2(_this, _assertThisInitialized$2(_this));
      }
      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }
    return _this;
  }
  _createClass$2(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      if (typeof options === 'function') {
        callback = options;
        options = {};
      }
      if (!options.defaultNS && options.ns) {
        if (typeof options.ns === 'string') {
          options.defaultNS = options.ns;
        } else if (options.ns.indexOf('translation') < 0) {
          options.defaultNS = options.ns[0];
        }
      }
      var defOpts = get();
      this.options = _objectSpread$6$1(_objectSpread$6$1(_objectSpread$6$1({}, defOpts), this.options), transformOptions(options));
      if (this.options.compatibilityAPI !== 'v1') {
        this.options.interpolation = _objectSpread$6$1(_objectSpread$6$1({}, defOpts.interpolation), this.options.interpolation);
      }
      if (options.keySeparator !== undefined) {
        this.options.userDefinedKeySeparator = options.keySeparator;
      }
      if (options.nsSeparator !== undefined) {
        this.options.userDefinedNsSeparator = options.nsSeparator;
      }
      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }
      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }
        var formatter;
        if (this.modules.formatter) {
          formatter = this.modules.formatter;
        } else if (typeof Intl !== 'undefined') {
          formatter = Formatter$1;
        }
        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
          s.formatter = createClassOnDemand(formatter);
          s.formatter.init(s, this.options);
          this.options.interpolation.format = s.formatter.format.bind(s.formatter);
        }
        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }
          _this2.emit.apply(_this2, [event].concat(args));
        });
        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }
        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }
        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }
          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }
      this.format = this.options.interpolation.format;
      if (!callback) callback = noop$1;
      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }
      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }
      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;
          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;
          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
          return _this2;
        };
      });
      var deferred = defer();
      var load = function load() {
        var finish = function finish(err, t) {
          if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);
          _this2.emit('initialized', _this2.options);
          deferred.resolve(t);
          callback(err, t);
        };
        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
        _this2.changeLanguage(_this2.options.lng, finish);
      };
      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }
      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop$1;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;
      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];
        var append = function append(lng) {
          if (!lng) return;
          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };
        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }
        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }
        this.services.backendConnector.load(toLoad, this.options.ns, function (e) {
          if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
          usedCallback(e);
        });
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop$1;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
      if (module.type === 'backend') {
        this.modules.backend = module;
      }
      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }
      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }
      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }
      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }
      if (module.type === 'formatter') {
        this.modules.formatter = module;
      }
      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }
      return this;
    }
  }, {
    key: "setResolvedLanguage",
    value: function setResolvedLanguage(l) {
      if (!l || !this.languages) return;
      if (['cimode', 'dev'].indexOf(l) > -1) return;
      for (var li = 0; li < this.languages.length; li++) {
        var lngInLngs = this.languages[li];
        if (['cimode', 'dev'].indexOf(lngInLngs) > -1) continue;
        if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
          this.resolvedLanguage = lngInLngs;
          break;
        }
      }
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;
      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);
      var setLngProps = function setLngProps(l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
        _this4.resolvedLanguage = undefined;
        _this4.setResolvedLanguage(l);
      };
      var done = function done(err, l) {
        if (l) {
          setLngProps(l);
          _this4.translator.changeLanguage(l);
          _this4.isLanguageChangingTo = undefined;
          _this4.emit('languageChanged', l);
          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }
        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };
      var setLng = function setLng(lngs) {
        if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
        if (l) {
          if (!_this4.language) {
            setLngProps(l);
          }
          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }
        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };
      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }
      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns, keyPrefix) {
      var _this5 = this;
      var fixedT = function fixedT(key, opts) {
        var options;
        if (_typeof$3(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }
          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = _objectSpread$6$1({}, opts);
        }
        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
        var keySeparator = _this5.options.keySeparator || '.';
        var resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
        return _this5.t(resultKey, options);
      };
      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }
      fixedT.ns = ns;
      fixedT.keyPrefix = keyPrefix;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;
      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;
      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }
      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }
      var lng = this.resolvedLanguage || this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;
      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
      };
      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }
      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;
      var deferred = defer();
      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }
      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });
      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }
      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam', 'ckb'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop$1;
      var mergedOptions = _objectSpread$6$1(_objectSpread$6$1(_objectSpread$6$1({}, this.options), options), {
        isClone: true
      });
      var clone = new I18n(mergedOptions);
      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = _objectSpread$6$1({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }
        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }]);
  return I18n;
}(EventEmitter);
_defineProperty$g(I18n, "createInstance", function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var callback = arguments.length > 1 ? arguments[1] : undefined;
  return new I18n(options, callback);
});
var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;
instance.createInstance;
instance.init;
instance.loadResources;
instance.reloadResources;
instance.use;
instance.changeLanguage;
instance.getFixedT;
instance.t;
instance.exists;
instance.setDefaultNamespace;
instance.hasLoadedNamespace;
instance.loadNamespaces;
instance.loadLanguages;

var account$2="Account";var accountInformation$3="Accountinformatie";var accountUpdated$2="Account bijgewerkt";var alreadyHaveAnAccount$2="Heb je al een account?";var areYouSureLogout$2="Wanneer je uitlogt, moet je je gegevens gebruiken om terug te komen in deze app.";var backToLogin$2="Terug naar inloggen";var confirmEmail$2="Bevestig e-mail";var confirmEnterPassword$2="Om deze instelling te bevestigen, voer je wachtwoord in";var confirmNewPassword$2="Bevestig nieuw wachtwoord";var content$2={subtitle:"Log in met je Blue Current account"};var createNewPassword$2="Maak een nieuw wachtwoord";var email$6="E-mail";var enterEmailToResetPassword$2="Voer het e-mailadres van je account in. We sturen je dan een link om je wachtwoord opnieuw in te stellen.";var errors$5={emailRequired:"E-mail is verplicht",invalidCredentials:"Foutieve inloggegevens",invalidEmail:"Dit zou een geldig e-mail adres moeten zijn",invalidPassword:"Incorrect wachtwoord",passwordLength:"Wachtwoord moet tenminste 6 karakters lang zijn",passwordRequired:"Wachtwoord is verplicht",passwordsDoNotMatch:"Ingevoerde wachtwoorden komen niet overeen",registrationFailed:"Registratie mislukt",usernameRequired:"Gebruikersnaam is verplicht"};var forgotPassword$2="Wachtwoord vergeten";var forgotPasswordEnterPassword$2="Voer alstublieft uw nieuwe wachtwoord in";var logOut$2="Uitloggen";var login$2="Log in";var logout$2="Log uit";var newPassword$2="Nieuw wachtwoord";var noChargePoints$2="De omgeving kan niet worden geladen omdat je nog geen laadpunten hebt.";var oldPassword$2="Oude wachtwoord";var password$2="Wachtwoord";var passwordUpdated$5="Je wachtwoord is veranderd!";var phone$2="Telefoonnummer";var registered$2="Geregistreerd";var registration$2="Registratie";var resetPassword$2="Wachtwoord opnieuw instellen";var updatePassword$2="Wachtwoord aanpassen";var username$2="Gebruikersnaam";var AuthenticationNL = {account:account$2,accountInformation:accountInformation$3,accountUpdated:accountUpdated$2,alreadyHaveAnAccount:alreadyHaveAnAccount$2,areYouSureLogout:areYouSureLogout$2,backToLogin:backToLogin$2,confirmEmail:confirmEmail$2,confirmEnterPassword:confirmEnterPassword$2,confirmNewPassword:confirmNewPassword$2,content:content$2,createNewPassword:createNewPassword$2,email:email$6,enterEmailToResetPassword:enterEmailToResetPassword$2,errors:errors$5,forgotPassword:forgotPassword$2,forgotPasswordEnterPassword:forgotPasswordEnterPassword$2,logOut:logOut$2,login:login$2,logout:logout$2,newPassword:newPassword$2,noChargePoints:noChargePoints$2,oldPassword:oldPassword$2,password:password$2,passwordUpdated:passwordUpdated$5,phone:phone$2,registered:registered$2,registration:registration$2,resetPassword:resetPassword$2,updatePassword:updatePassword$2,username:username$2};

var account$1="Account";var accountInformation$2="Account information";var accountUpdated$1="Account updated";var alreadyHaveAnAccount$1="Already have an account?";var areYouSureLogout$1="When you log out, you will need to input your details to get back into this app.";var backToLogin$1="Back to login";var confirmEmail$1="Confirm e-mail";var confirmEnterPassword$1="To confirm this setting please enter your password";var confirmNewPassword$1="Confirm new password";var content$1={subtitle:"Sign in with your Blue Current account"};var createNewPassword$1="Create a new password";var email$5="E-mail";var enterEmailToResetPassword$1="Enter your account email address. We will then send you a link to reset your password.";var errors$4={emailRequired:"E-mail is required",invalidCredentials:"Invalid username or password",invalidEmail:"This should be a valid e-mail address",invalidPassword:"Invalid password",passwordLength:"Password must be at least 6 characters long",passwordRequired:"Password is required",passwordsDoNotMatch:"Passwords do not match",registrationFailed:"Registration failed",usernameRequired:"Username is required"};var forgotPassword$1="Forgot password";var forgotPasswordEnterPassword$1="Please enter your new password";var logOut$1="Log out";var login$1="Login";var logout$1="Logout";var newPassword$1="New password";var noChargePoints$1="The environment cannot be loaded because you don't have any charge points yet.";var oldPassword$1="Old password";var password$1="Password";var passwordUpdated$4="Your password has been updated";var phone$1="Phone number";var registered$1="Registered";var registration$1="Registration";var resetPassword$1="Reset your password";var updatePassword$1="Update password";var username$1="Username";var AuthenticationEN = {account:account$1,accountInformation:accountInformation$2,accountUpdated:accountUpdated$1,alreadyHaveAnAccount:alreadyHaveAnAccount$1,areYouSureLogout:areYouSureLogout$1,backToLogin:backToLogin$1,confirmEmail:confirmEmail$1,confirmEnterPassword:confirmEnterPassword$1,confirmNewPassword:confirmNewPassword$1,content:content$1,createNewPassword:createNewPassword$1,email:email$5,enterEmailToResetPassword:enterEmailToResetPassword$1,errors:errors$4,forgotPassword:forgotPassword$1,forgotPasswordEnterPassword:forgotPasswordEnterPassword$1,logOut:logOut$1,login:login$1,logout:logout$1,newPassword:newPassword$1,noChargePoints:noChargePoints$1,oldPassword:oldPassword$1,password:password$1,passwordUpdated:passwordUpdated$4,phone:phone$1,registered:registered$1,registration:registration$1,resetPassword:resetPassword$1,updatePassword:updatePassword$1,username:username$1};

var accountInformation$1="Informations du compte";var AuthenticationFR = {accountInformation:accountInformation$1};

var account="[AAAAççöööūūūกี้ṫ]";var accountInformation="[AAAAççöööūūūกี้ṫ îîîกี้ḟöööŕmåååṫîîîöööกี้]";var accountUpdated="[AAAAççöööūūūกี้ṫ ūūūþďåååṫéééď]";var alreadyHaveAnAccount="[AAAAļŕéééåååďÝ ḥåååvééé åååกี้ åååççöööūūūกี้ṫ?]";var areYouSureLogout="[WWḥéééกี้ Ýöööūūū ļöööǧ öööūūūṫ, Ýöööūūū wîîîļļ กี้ééééééď ṫööö îîîกี้þūūūṫ Ýöööūūūŕ ďéééṫåååîîîļš ṫööö ǧéééṫ båååçḱ îîîกี้ṫööö ṫḥîîîš åååþþ.]";var backToLogin="[BBåååçḱ ṫööö ļöööǧîîîกี้]";var confirmEmail="[CCöööกี้ḟîîîŕm ééé-måååîîîļ]";var confirmEnterPassword="[TTööö çöööกี้ḟîîîŕm ṫḥîîîš šéééṫṫîîîกี้ǧ þļéééåååšééé éééกี้ṫéééŕ Ýöööūūūŕ þåååššwöööŕď]";var confirmNewPassword="[CCöööกี้ḟîîîŕm กี้éééw þåååššwöööŕď]";var content={subtitle:"[SSîîîǧกี้ îîîกี้ wîîîṫḥ Ýöööūūūŕ Bļūūūééé Cūūūŕŕéééกี้ṫ åååççöööūūūกี้ṫ]"};var createNewPassword="[CCŕéééåååṫééé ååå กี้éééw þåååššwöööŕď]";var email$4="[EEEE-måååîîîļ]";var enterEmailToResetPassword="[EEEEกี้ṫéééŕ Ýöööūūūŕ åååççöööūūūกี้ṫ ééémåååîîîļ åååďďŕéééšš. Wééé wîîîļļ ṫḥéééกี้ šéééกี้ď Ýöööūūū ååå ļîîîกี้ḱ ṫööö ŕéééšéééṫ Ýöööūūūŕ þåååššwöööŕď.]";var errors$3={emailRequired:"[EEEE-måååîîîļ îîîš ŕéééqūūūîîîŕéééď]",invalidCredentials:"[IIIIกี้våååļîîîď ūūūšéééŕกี้åååmééé öööŕ þåååššwöööŕď]",invalidEmail:"[TTḥîîîš šḥöööūūūļď bééé ååå våååļîîîď ééé-måååîîîļ åååďďŕéééšš]",invalidPassword:"[IIIIกี้våååļîîîď þåååššwöööŕď]",passwordLength:"[PPåååššwöööŕď mūūūšṫ bééé åååṫ ļéééåååšṫ 6 çḥåååŕåååçṫéééŕš ļöööกี้ǧ]",passwordRequired:"[PPåååššwöööŕď îîîš ŕéééqūūūîîîŕéééď]",passwordsDoNotMatch:"[PPåååššwöööŕďš ďööö กี้öööṫ måååṫçḥ]",registrationFailed:"[RRéééǧîîîšṫŕåååṫîîîöööกี้ ḟåååîîîļéééď]",usernameRequired:"[UUUUšéééŕกี้åååmééé îîîš ŕéééqūūūîîîŕéééď]"};var forgotPassword="[FFöööŕǧöööṫ þåååššwöööŕď]";var forgotPasswordEnterPassword="[PPļéééåååšééé éééกี้ṫéééŕ Ýöööūūūŕ กี้éééw þåååššwöööŕď]";var logOut="[LLöööǧ öööūūūṫ]";var login="[LLöööǧîîîกี้]";var logout="[LLöööǧöööūūūṫ]";var newPassword="[NNéééw þåååššwöööŕď]";var noChargePoints="[TTḥééé éééกี้vîîîŕöööกี้méééกี้ṫ çåååกี้กี้öööṫ bééé ļöööåååďéééď béééçåååūūūšééé Ýöööūūū ďöööกี้'ṫ ḥåååvééé åååกี้Ý çḥåååŕǧééé þöööîîîกี้ṫš Ýéééṫ.]";var oldPassword="[OOOOļď þåååššwöööŕď]";var password="[PPåååššwöööŕď]";var passwordUpdated$3="[YYöööūūūŕ þåååššwöööŕď ḥåååš bééééééกี้ ūūūþďåååṫéééď]";var phone="[PPḥöööกี้ééé กี้ūūūmbéééŕ]";var registered="[RRéééǧîîîšṫéééŕéééď]";var registration="[RRéééǧîîîšṫŕåååṫîîîöööกี้]";var resetPassword="[RRéééšéééṫ Ýöööūūūŕ þåååššwöööŕď]";var updatePassword="[UUUUþďåååṫééé þåååššwöööŕď]";var username="[UUUUšéééŕกี้åååmééé]";var AuthenticationPSEUDO = {account:account,accountInformation:accountInformation,accountUpdated:accountUpdated,alreadyHaveAnAccount:alreadyHaveAnAccount,areYouSureLogout:areYouSureLogout,backToLogin:backToLogin,confirmEmail:confirmEmail,confirmEnterPassword:confirmEnterPassword,confirmNewPassword:confirmNewPassword,content:content,createNewPassword:createNewPassword,email:email$4,enterEmailToResetPassword:enterEmailToResetPassword,errors:errors$3,forgotPassword:forgotPassword,forgotPasswordEnterPassword:forgotPasswordEnterPassword,logOut:logOut,login:login,logout:logout,newPassword:newPassword,noChargePoints:noChargePoints,oldPassword:oldPassword,password:password,passwordUpdated:passwordUpdated$3,phone:phone,registered:registered,registration:registration,resetPassword:resetPassword,updatePassword:updatePassword,username:username};

var agreement$2="Contract";var analytics$2="Analytics";var analyticsDescription$2="Analytics helpt ons onze diensten te verbeteren door informatie over het gebruik ervan te verzamelen en te rapporteren.";var api$2="API";var apiKey$2="API Key";var appSettings$2="App instellingen";var beneficiaryEmail$2="Email begunstigde";var beneficiaryName$2="Begunstigde";var changePassword$2="Wachtwoord wijzigen";var changeSettings$2="Instellingen wijzigen";var developerMode$2="Geavanceerde opties";var developers$2="Geavanceerd";var en$2="English";var failedToLoadSetting$2="Er is iets misgegaan tijdens het laden van deze instelling";var firstName$2="Voornaam";var generateApiKey$2="API key genereren";var iban$2="IBAN";var ibanError$2={invalidCode:"IBAN is niet geldig",noAcceptedCountry:"Alleen IBANs uit {{accepted}} zijn mogelijk"};var language$2="Taal";var languageDescription$2="Selecteer de taal die wordt gebruikt voor het weergeven van menu's, berichten en notificaties";var lastName$2="Achternaam";var locationManagement$2="Locatiebeheer";var nl$2="Nederlands";var noPermissionToChangeSetting$2="Je beschikt niet over de benodigde rechten om deze instelling aan te passen";var personalInformation$2="Persoonlijke informatie";var preferences$2="Voorkeuren";var privacy$2="Privacy";var settings$7="Instellingen";var settingsSaved$2="Instellingen opgeslagen";var subscriptionType$2="Abonnements type";var homeAssistant$3="Home Assistant";var SettingsNL = {agreement:agreement$2,analytics:analytics$2,analyticsDescription:analyticsDescription$2,api:api$2,apiKey:apiKey$2,appSettings:appSettings$2,beneficiaryEmail:beneficiaryEmail$2,beneficiaryName:beneficiaryName$2,changePassword:changePassword$2,changeSettings:changeSettings$2,developerMode:developerMode$2,developers:developers$2,en:en$2,failedToLoadSetting:failedToLoadSetting$2,firstName:firstName$2,generateApiKey:generateApiKey$2,iban:iban$2,ibanError:ibanError$2,language:language$2,languageDescription:languageDescription$2,lastName:lastName$2,locationManagement:locationManagement$2,nl:nl$2,noPermissionToChangeSetting:noPermissionToChangeSetting$2,personalInformation:personalInformation$2,preferences:preferences$2,privacy:privacy$2,settings:settings$7,settingsSaved:settingsSaved$2,subscriptionType:subscriptionType$2,homeAssistant:homeAssistant$3};

var agreement$1="Agreement";var analytics$1="Analytics";var analyticsDescription$1="Analytics help us to improve our services by collecting and reporting information of its usage.";var api$1="API";var apiKey$1="API Key";var appSettings$1="App settings";var beneficiaryEmail$1="Email beneficiary";var beneficiaryName$1="Beneficiary";var changePassword$1="Change password";var changeSettings$1="Change settings";var developerMode$1="Advanced options";var developers$1="Advanced";var en$1="English";var failedToLoadSetting$1="Something went wrong while loading this setting";var firstName$1="First name";var generateApiKey$1="Generate API key";var iban$1="IBAN";var ibanError$1={invalidCode:"IBAN is not valid",noAcceptedCountry:"Only IBANs from {{accepted}} are accepted"};var language$1="Language";var languageDescription$1="Select the language that is used for menu's, messages and notifications";var lastName$1="Last name";var locationManagement$1="Location management";var nl$1="Nederlands";var noPermissionToChangeSetting$1="You don’t have the necessary edit permissions for this setting";var personalInformation$1="Personal information";var preferences$1="Preferences";var privacy$1="Privacy";var settings$6="Settings";var settingsSaved$1="Settings saved";var subscriptionType$1="Subscription type";var homeAssistant$2="Home Assistant";var SettingsEN = {agreement:agreement$1,analytics:analytics$1,analyticsDescription:analyticsDescription$1,api:api$1,apiKey:apiKey$1,appSettings:appSettings$1,beneficiaryEmail:beneficiaryEmail$1,beneficiaryName:beneficiaryName$1,changePassword:changePassword$1,changeSettings:changeSettings$1,developerMode:developerMode$1,developers:developers$1,en:en$1,failedToLoadSetting:failedToLoadSetting$1,firstName:firstName$1,generateApiKey:generateApiKey$1,iban:iban$1,ibanError:ibanError$1,language:language$1,languageDescription:languageDescription$1,lastName:lastName$1,locationManagement:locationManagement$1,nl:nl$1,noPermissionToChangeSetting:noPermissionToChangeSetting$1,personalInformation:personalInformation$1,preferences:preferences$1,privacy:privacy$1,settings:settings$6,settingsSaved:settingsSaved$1,subscriptionType:subscriptionType$1,homeAssistant:homeAssistant$2};

var settings$5="Paramètres";var homeAssistant$1="Home Assistant";var SettingsFR = {settings:settings$5,homeAssistant:homeAssistant$1};

var agreement="[AAAAǧŕééééééméééกี้ṫ]";var analytics="[AAAAกี้åååļÝṫîîîçš]";var analyticsDescription="[AAAAกี้åååļÝṫîîîçš ḥéééļþ ūūūš ṫööö îîîmþŕööövééé öööūūūŕ šéééŕvîîîçéééš bÝ çöööļļéééçṫîîîกี้ǧ åååกี้ď ŕéééþöööŕṫîîîกี้ǧ îîîกี้ḟöööŕmåååṫîîîöööกี้ öööḟ îîîṫš ūūūšåååǧééé.]";var api="[AAAAPIII]";var apiKey="[AAAAPIII KéééÝ]";var appSettings="[AAAAþþ šéééṫṫîîîกี้ǧš]";var beneficiaryEmail="[EEEEmåååîîîļ béééกี้éééḟîîîçîîîåååŕÝ]";var beneficiaryName="[BBéééกี้éééḟîîîçîîîåååŕÝ]";var changePassword="[CCḥåååกี้ǧééé þåååššwöööŕď]";var changeSettings="[CCḥåååกี้ǧééé šéééṫṫîîîกี้ǧš]";var developerMode="[AAAAďvåååกี้çéééď öööþṫîîîöööกี้š]";var developers="[AAAAďvåååกี้çéééď]";var en="[EEEEกี้ǧļîîîšḥ]";var failedToLoadSetting="[SSöööméééṫḥîîîกี้ǧ wéééกี้ṫ wŕöööกี้ǧ wḥîîîļééé ļöööåååďîîîกี้ǧ ṫḥîîîš šéééṫṫîîîกี้ǧ]";var firstName="[FFîîîŕšṫ กี้åååmééé]";var generateApiKey="[GGéééกี้éééŕåååṫééé AAAPIII ḱéééÝ]";var iban="[IIIIBAAAN]";var ibanError={invalidCode:"[IIIIBAAAN îîîš กี้öööṫ våååļîîîď]",noAcceptedCountry:"[OOOOกี้ļÝ IIIBAAANš ḟŕöööm {{åååççéééþṫéééď}} åååŕééé åååççéééþṫéééď]"};var language="[LLåååกี้ǧūūūåååǧééé]";var languageDescription="[SSéééļéééçṫ ṫḥééé ļåååกี้ǧūūūåååǧééé ṫḥåååṫ îîîš ūūūšéééď ḟöööŕ méééกี้ūūū'š, méééššåååǧéééš åååกี้ď กี้öööṫîîîḟîîîçåååṫîîîöööกี้š]";var lastName="[LLåååšṫ กี้åååmééé]";var locationManagement="[LLöööçåååṫîîîöööกี้ måååกี้åååǧéééméééกี้ṫ]";var nl="[NNéééďéééŕļåååกี้ďš]";var noPermissionToChangeSetting="[YYöööūūū ďöööกี้’ṫ ḥåååvééé ṫḥééé กี้éééçéééššåååŕÝ éééďîîîṫ þéééŕmîîîššîîîöööกี้š ḟöööŕ ṫḥîîîš šéééṫṫîîîกี้ǧ]";var personalInformation="[PPéééŕšöööกี้åååļ îîîกี้ḟöööŕmåååṫîîîöööกี้]";var preferences="[PPŕéééḟéééŕéééกี้çéééš]";var privacy="[PPŕîîîvåååçÝ]";var settings$4="[SSéééṫṫîîîกี้ǧš]";var settingsSaved="[SSéééṫṫîîîกี้ǧš šåååvéééď]";var subscriptionType="[SSūūūbšçŕîîîþṫîîîöööกี้ ṫÝþééé]";var homeAssistant="[HHööömééé AAAššîîîšṫåååกี้ṫ]";var SettingsPSEUDO = {agreement:agreement,analytics:analytics,analyticsDescription:analyticsDescription,api:api,apiKey:apiKey,appSettings:appSettings,beneficiaryEmail:beneficiaryEmail,beneficiaryName:beneficiaryName,changePassword:changePassword,changeSettings:changeSettings,developerMode:developerMode,developers:developers,en:en,failedToLoadSetting:failedToLoadSetting,firstName:firstName,generateApiKey:generateApiKey,iban:iban,ibanError:ibanError,language:language,languageDescription:languageDescription,lastName:lastName,locationManagement:locationManagement,nl:nl,noPermissionToChangeSetting:noPermissionToChangeSetting,personalInformation:personalInformation,preferences:preferences,privacy:privacy,settings:settings$4,settingsSaved:settingsSaved,subscriptionType:subscriptionType,homeAssistant:homeAssistant};

var about$2="Over ons";var accessibility$2={button:"Knop",input:"Invoerveld"};var actions$5="Acties";var active$2="Actief";var add$6="Toevoegen";var addChargeCard$2="Laadpas toevoegen";var addChargePoint$2="Laadpunt toevoegen";var addSeeChangeYourChargeCard$3="Laadpas toevoegen of aanpassen";var additionalInformation$3="Extra informatie";var address$2="Adres";var advanced$2="Geavanceerd";var all$2="Alles";var allChargeCards$3="Alle laadpassen";var allChargePoints$2="Alle laadpunten";var allContractInfoInOnePlace$2="Jouw contract informatie op één plek";var alwaysStartTourInSettings$2="Je kan altijd de rondleiding herstarten vanuit de instellingen";var amount$2="Bedrag";var amountMore$3="& {{amount}} meer";var amountWaiting$2="{{amount}} in de rij";var appDownload$2="App downloaden";var apply$2="Toepassen";var areYouSure$2="Weet je het zeker";var areYouSureFinish$2="Weet je zeker dat je af wilt ronden? Je kunt je antwoorden hierna niet meer wijzigen.";var areYouSureStopSession$2="Weet je zeker dat je je laadsessie wilt stoppen? Deze keuze is onomkeerbaar.";var arrangeThisYourselfOnline$2="Dit kan je direct zelf online regelen!";var atHome$2="Thuis laden";var back$2="Vorige";var backToDateSelection$2="Ga terug en pas je selectie aan";var batchSettings$3={scheduleChange:"Plan verandering",information:"<b>Let op:</b> Dit stelt alle gekozen instellingen in op de geselecteerde laadpunten. De instellingen die uitstaan (in het vorige scherm) worden ook uitgezet op het laadpunt."};var block$2="Blokkeren";var business$2="Zakelijk laden";var cable$2="Kabel";var cancel$2="Annuleren";var carNotConnected$2="Uw auto lijkt niet aangesloten te zijn.";var change$2="Wijzigen";var changeAccountInfoHere$3="Verander hier jouw account informatie";var changeProfile$2="Profiel wijzigen";var changeSchedule$2="Schema wijzigen";var changeYourSettingsHere$3="Pas hier je app instellingen aan";var charge$2="Laad";var chargeCard$3="Laadpas";var chargeCardNotOnThisList$2="Laadpas niet gekoppeld? Vul het serienummer hieronder in.";var chargeCardNumber$2="Laadpas nummer";var chargeCards$3="Laadpassen";var chargeEvenFaster$3="Nog sneller laden?";var chargePoint$3="Laadpunt";var chargePointName$2="Laadpunt naam";var chargePointNumber$2="Laadpunt nummer";var chargePoints$3="Laadpunten";var chargepointSettings$3="Laadpunt instellingen";var chargeSessionInformation$2="Laadsessie informatie";var chargingSession$2="Laadsessie";var choose$2="Kies";var clear$2="Wissen";var clickToReload$2="Klik om te herladen";var close$2="Sluiten";var company$2="Bedrijf";var companyName$2="Bedrijfsnaam";var confirm$2="Bevestigen";var connected$2="Gekoppeld";var connectionClosed$2="Verbinding verbroken!";var contact$2="Contact";var continueReading$2="Verder lezen";var cookie$2={button:"Accepteren",closeCookiePopup:"Cookie pop-up sluiten",text:"Deze website slaat cookies op uw computer op. Deze cookies worden gebruikt om uw website ervaring te verbeteren en u meer gepersonaliseerde diensten aan te bieden, zowel op deze website als via andere media. Voor meer informatie over de cookies die wij gebruiken, zie ons <a target=\"_blank\" href=\"https://www.bluecurrent.nl/legal/cookies\" style=\"text-decoration:underline;\">cookiebeleid</a>.",title:"Tijd voor cookies"};var copied$2="Gekopieerd";var copy$3="Kopiëren";var country$6="Land";var countryCode$2="Landcode";var currency$2={inEuro:"in €"};var customerType$2="Klanttype";var dashboard$3="Dashboard";var delayUntil$2="Uitstellen tot";var delayFrom$2="Uitstellen vanaf";var deselectAll$2="Selectie ongedaan maken";var disabled$2="Uitgeschakeld";var download$2="Download";var downloadApp$3="Download de app!";var downloadBrochure$2="Download brochure";var downloadResearch$2="Download het onderzoek";var dragDropFiles$2="Zet bestanden neer of klik hier om te uploaden";var duration$2="Tijdsduur";var edit$2="Aanpassen";var editChargeCard$2="Laadpas wijzigen";var emailCheck$2="We hebben je een e-mail gestuurd waarmee je je registratie kan voltooien";var emailNotRecieved$2="Geen email ontvangen?";var emailSend$2="E-mail is verzonden";var emailSentIfExist$2="Een e-mail is verstuurd als er een account met dat e-mail adres bestaat";var employee$2="Medewerker";var enabled$2="Ingeschakeld";var enterNewPassword$2="Voer je nieuwe wachtwoord in";var entrance$2="Ingang";var errors$2={"email-empty":"E-mail is een verplicht veld","email-invalid":"Gelieve een geldig e-mailadres in te vullen",emailMismatch:"E-mail komt niet overeen",fieldRequired:"Dit veld is verplicht","firstname-empty":"Voornaam is een verplicht veld",invalidChargepointNumber:"Incorrect laadpunt nummer","lastname-empty":"Achternaam is een verplicht veld",noConnectionBackend:"Het lukt niet te verbinden met onze servers, probeer het later opnieuw",noConsent:"Gelieve akkoord te gaan met onze TOS en ons privacybeleid","password-empty":"Wachtwoord is een verplicht veld","passwords-match":"De wachtwoorden komen niet overeen","phone-empty":"Telefoonnummer is een verplicht veld","phone-invalid":"Gelieve een geldig telefoonnummer in te vullen",somethingWrong:"Er is iets misgegaan"};var example$2="Voorbeeld";var excl$2="Excl.";var exclusive$2="Exclusief";var faq$2="Veelgestelde vragen";var features$2="Kenmerken";var feedback$2="Feedback";var fileUploaded$2="Bestand geüpload";var filter$2="Filter";var followOurAdventure$2="Volg ons avontuur";var free$3="Gratis";var from$2="Van";var garage$2="Garage";var getOnPlayStore$2="Ontdek het op Google Play";var gotIt$2="Begrepen";var grids$2="Grids";var group$2={allGroups:"Alle groepen",create:"Groep maken",deleteConfirmDialog:"Weet je zeker dat je deze groep wilt verwijderen? Deze actie is onomkeerbaar",edit:"Groep aanpassen",editGroups:"Groepen aanpassen",group:"Groep",groups:"Groepen",none:"Je hebt nog geen groep aangemaakt. Je ziet je groepen hier. ",update:"Bijwerken"};var help$2="Help";var home$2="Home";var houseNumber$6="Huisnummer";var houseNumberAdditions$2="Huisnummer toevoeging";var inCollaborationWith$2="In samenwerking met";var incl$2="Incl.";var inclusive$2="Inclusief ";var information$2="Informatie";var insightIntoTransactions$3="Overzicht van jouw laadsessies";var insights$2="Inzichten";var instanceConnectionClosed$2="De verbinding met uw instantie is verbroken";var invalidChargeCard$2="Ongeldige pas: Laadsessies met deze pas kunnen we niet in rekening brengen via de laadpasleverancier. Je kunt de pas wel gebruiken als 'sleutel' om laadsessies mee te starten of stoppen.";var lastSave$2="Opgeslagen om";var lastUpdate$2="Laatste wijziging";var learnMore$2="Leer meer";var leaveItToMe$2="Laa(d)t het maar aan mij over!";var letsCheckWithAdviceGuru$2="Tijd voor advies-Guru {{name}}";var linkChargeCards$3="Koppel laadpassen";var linkChargePoints$3="Koppel laadpunten";var linkedChargeCards$2="Gekoppelde laadpassen";var linkedChargePoints$2="Gekoppelde laadpunten";var linkedThirdPartyChargeCards$2="Gekoppelde derden laadpassen";var list$2="Lijst";var location$2="Locatie";var lock$2="Gelocked";var map$3="Kaart";var mobileApp$2={app:"App",description:"Wij maken elektrisch rijden nog makkelijker. Met onze app pak jij in handomdraai de controle over je laadpunt.",feature_adjustSettings:"Laadpunt instellingen aanpassen",feature_checkBuildingEnergy:"Bekijk de stroom die in je huis of gebouw wordt gebruikt",feature_howMuchYouAreCharging:"Zie hoeveel je aan het laden bent"};var model$2="Model";var moreInformation$2="Meer informatie over";var moreInformationContactUs$2="Meer informatie nodig? Neem dan contact met ons op!";var my$2="Mijn";var myChargeCards$2="Mijn laadpassen";var myDashboard$2="Mijn dashboard";var name$5="Naam";var newGeneration$2="Nieuwe generatie";var news$2="Nieuws";var next$2="Volgende";var no$2="Nee";var noChargeCard$2="Zonder laadpas";var noChargeCardsFound$2="Geen laadpassen gevonden";var noChargeCardsFoundInSelection$2="Er zijn geen laadpassen en transacties gevonden binnen je selectie.";var noChargePointsFound$2="Geen laadpunten gevonden";var noPlugChargeChargeCard$2="Plug & charge zonder laadpas";var noUpcomingEvent$2="Geen aankomend evenement";var notAFan$2="Geen fan van my.bluecurrent.nl?\n<br />\n<u>Ga terug naar de oude omgeving</u>";var notifications$2="Notificaties";var ok$2="Oké";var openOnMobile$2="Openen op telefoon";var optional$2="Optioneel";var or$2="Of";var other$2="Overige";var ourOtherSolutions$2="Onze andere oplossingen";var pages$2="Pagina's";var parking$2="Parkeren";var passwordUpdated$2="Je wachtwoord is succesvol aangepast.";var pay$2="Betalen";var payAttention$2="Let op";var paymentMethod$2="Betaalmethode";var perKilowattHour$2="per kWh";var place$2="Plaats";var plugInCar$2="Sluit uw auto aan om door te gaan";var pppsstIamHere$2="Pppsst ik zit hier!";var previous$2="Vorige";var products$2="Producten";var pursue$2="Doorgaan";var qrPayment$2="QR-betaling";var question$2={whatIsThe:"Wat is het",whatIsYour:"Wat is jouw"};var queue$2="Wachtrij";var quickAccess$2="Snel regelen";var readMore$2="Lees verder";var reference$2="Referentie";var removeFilters$2="Wis filters";var removeSelection$2="Verwijder selectie";var reportABug$2="Storing melden";var requestChargeCard$2="Laadpas aanvragen";var requestChargePoint$2="Laadpunt aanvragen";var requestChargePointBusiness$2="Zakelijke laadpunten aanvragen";var requestChargePointForAtHome$2="Laadpunt voor thuis aanvragen";var requestFreeChargePoint$2="(Gratis) exploitatie laadpunt aanvragen";var requiredAmountFieldsEmpty$2="Nog <b>{{amount}}</b> velden in te vullen";var requiredFieldEmpty$2="Nog <b>1</b> veld in te vullen";var research$2="Onderzoek";var reserve$2="Reserveren";var reserved$2="Gereserveerd";var resident$2="Bewoner";var save$2="Opslaan";var saved$2="Opgeslagen";var saving$2="Opslaan";var scanWithPhoneQrApp$2="Scan met je telefooncamera of QR-app om door te gaan";var scheduleMeeting$3="Afspraak inplannen";var screenshots$2="Schermafbeeldingen";var search$2="Zoeken";var seeYourChargePoints$3="Bekijk hier jouw laadpunten";var selectAll$2="Alles selecteren";var selectDefaultChargeCard$2="Selecteer een standaard laadpas";var selectPlugAndChargeCard$2="Selecteer een plug & charge laadpas";var selectProfile$2="Selecteer een profiel";var selected$2="Geselecteerd";var selectedChargecard$2="Geselecteerde laadpas";var send$2="Verzenden";var sendAgain$2="Opnieuw versturen";var serialNumber$2="Serienummer";var services$2="Diensten";var setUp$2="Instellen";var shortcuts$2="Snelkoppelingen";var showMore$2="Toon meer";var showOnGoogleMaps$2="Toon in Google Maps";var showingAmountChargePoint$2="{{amount}} van de {{total}} laadpunten zichtbaar";var selectedAmountChargePoint$3="{{amount}} van de {{total}} laadpunten geselecteerd";var signUp$2="Inschrijven";var signatureAgreement$2="Handtekening voor akkoord";var skip$2="Overslaan";var skipTour$2="Rondleiding overslaan";var spambox$2="E-mail niet gevonden? Controleer je spam.";var startKwh$2="Start kWh";var startTour$2="Start rondleiding";var street$2="Straat";var support$2="Support";var switchEmail$2="Verander e-mail adres";var symbol$2="Pictogram";var symbols$2="Pictogrammen";var tel$6="Tel";var test$2="Test";var thisIsExample$2="<b>Let op</b>: Dit is een voorbeeld!";var tip$2="Tip";var to$2="Tot";var totalCO2Emission$3="CO<sub>2</sub> uitstoot bespaard";var totalCost$2="Totale kosten";var totalEnergyUsage$2="Totaal energieverbruik";var totalTrees$3="Bomen geplant";var tour$2={step1:"Hier zie je de huidige status van een laadpunt.\n<br />\nTip: Klik op de drie bolletjes om een ander laadpunt te kiezen.",step2:"Hier zie je de eerst volgende gebeurtenissen. Bijvoorbeeld: uitbetalingen. ",step3:"Hier staan jouw laadpunten. Door op een laadpunt te drukken open je de laadpuntinstellingen.",step4:"Hier kan je de instellingen van een laadpunt wijzigen, waaronder het wijzigen van het tarief, het opnieuw opstarten/resetten van een laadpunt en meer.",step5:"Door op een laadpas te klikken kan je de laadpas naam wijzigen of de laadpas verwijderen.",step6:"Als je op een laadsessie drukt, krijg je extra informatie over die laadsessie.",step7:"Gebruik deze filters om de lijst met laadsessies te filteren. Na het instellen van de filters kan je een Excel-bestand downloaden, of klik op 'Declaratieoverzicht' om een declaratieoverzicht te downloaden."};var transaction$2="Transactie";var transactions$3="Laadsessies";var unblock$2="Deblokkeren";var units$9={kilogram:"Kilogram",kiloton:"Kiloton",megaton:"Megaton",ton:"Ton",kilogramRounded:"kg",kilotonRounded:"kt",megatonRounded:"Mt",tonRounded:"t"};var unlock$2="Unlocken";var upload$3={columnLabel:"In welke kolom zijn de {{type}}s?",column:"{{type}} kolom",complete:"Upload voltooid",excludeLabel:"Wilt u de laadpassen uitsluiten van betaling?",failed:"gefaalt",fileLimit:"Er kan maar 1 bestand tegelijk worden geupload",fileTooLarge:"Bestand is te groot",headersLabel:"Bevat het bestand koppen?",headers:"Bevat koppen",information:"Om het bestand correct uit te lezen moet u nog wat informatie geven over hoe het bestand is opgebouwd.",successful:"geslaagd",total:"Totaal",upload:"Upload",uploading:"Bestand aan het uploaden",unsupportedFile:"Bestandstype word niet ondersteund"};var usefullLinks$2="Handige linkjes";var viewAll$2="Toon alles";var viewLess$2="Toon minder";var viewTheEntire$2="Bekijk het gehele";var watchVideo$2="Video bekijken";var welcome$3="Welkom {{name}}";var welcomeBack$2="Welkom terug!";var whoops$2="Oeps!";var workAt$3="Werken bij";var yes$2="Ja";var youCanDoThisOnline$2="Dit kan je direct zelf online regelen!";var your$2="Jouw";var youreStillHere$2="Je bent er nog steeds! Te gek";var zipCode$6="Postcode";var sent$3="Verzonden";var returnToForm$3="Terug naar formulier";var backTo$3="Terug naar {{url}}";var select$3="Selecteer";var seeAll$2="Bekijk alle";var keyboardShortcuts$3="Keyboard shortcuts";var navigation$3="Navigeren";var control$3="Bedienen";var previousQuestion$3="Vorige vraag";var nextQuestion$3="Volgende vraag";var forExample$3="Bijv";var notProvided$3="Niet ingevuld";var everythingInANutshell$3="Alles nog even op een rijtje";var savingFailed$3="Opslaan mislukt";var sendingFailed$3="Verzenden mislukt";var searchingAddress$3="Adres aan het opzoeken";var couldntAutocompleteAddress$3="We konden je adres niet automatisch invullen. Wil je ons helpen?";var itsTakingLongerThanExpected$3="Het duurt iets langer dan verwacht, maar we zijn nog steeds bezig.";var makeSureToSaveProgress$3="Zorg ervoor dat je je voortgang opslaat voordat je weggaat";var noAgreementFound$3="Geen agreement gevonden";var overview$3="Overzicht";var tryAgainLaterOrContactUs$3="Er heeft zich een fout voorgedaan. Probeer het later nog eens of <a href=\"https://www.bluecurrent.nl/contact\" target=\"_blank\" rel=\"noreferrer\">neem contact met ons op</a> als de fout zich blijft voordoen.";var settingLanguage$3="Taal instellen";var noPhotosProvided$3="Geen foto's toegevoegd";var reset$3="Reset";var noteNotAllMandatoryQuestionsHaveBeenFilledIn$3="Niet alle vragen zijn ingevuld; zorg ervoor dat alle verplichte vragen zijn beantwoord voordat je ze indient.";var required$3="Verplicht";var maxKwh$3="Maximale kWh";var wellDone$3="Goed gedaan!";var endOfFirstFlow$3="Dankjewel voor het beantwoorden van onze vragen. We hebben nu voldoende informatie om voor je aan de slag te gaan.\n<br /><br />\nBinnen enkele werkdagen ontvang je een e-mail met daarin de voortgang van je aanvraag. Als we een offerte voorleggen aan een derde (zoals je werkgever, tankpasleverancier of leasemaatschappij) kan dit tot 10 werkdagen duren. Hebben we toch meer informatie nodig? Dan nemen we zo snel mogelijk contact met je op.\n<br /><br/>\nIs dit je eerste elektrische auto? Overweeg dan om deze URLs te bewaren:<br/>\n- Op <a href=\"https://www.youtube.com/watch?v=ZmqtT_x22vg\" target=\"_blank\">YouTube</a> legt de ANWB in vijf minuten uit hoe het laadproces werkt.<br/>\n- In <a href=\"https://help.bluecurrent.nl/nl/knowledge\" target=\"_blank\">onze FAQ</a> vind je nuttige informatie over onze dienstverlening.\n";var invoices$2="Facturen";var status$8="Status";var exit$3="Uitgang";var forAtHome$3="Voor Thuis";var forBusiness$3="Voor Zakelijk";var quotation$3="Offerte";var getQuote$3="Offerte aanvragen";var registerToCharge$3="Registreer om te beginnen met laden";var reimbursementInformation$3="Vergoeding informatie";var repeatEach$3="Herhaal elke";var energy$3="Energie";var calculateYourSavings$3="Bereken je voordeel";var now$4="Nu";var positive$3="Positief";var negative$3="Negatief";var electricity$3="Elektriciteit";var gas$3="Gas";var allInPrice$3="All-in prijs";var marketPrice$3="Marktprijs";var marketPriceInclVat$3="Marktprijs incl. BTW";var marketPriceInclPurchaseFeeEnergyTaxVat$3="Marktprijs incl. inkoopvergoeding, energiebelasting & BTW";var UiNL = {about:about$2,accessibility:accessibility$2,actions:actions$5,active:active$2,add:add$6,addChargeCard:addChargeCard$2,addChargePoint:addChargePoint$2,addSeeChangeYourChargeCard:addSeeChangeYourChargeCard$3,additionalInformation:additionalInformation$3,address:address$2,advanced:advanced$2,all:all$2,allChargeCards:allChargeCards$3,allChargePoints:allChargePoints$2,allContractInfoInOnePlace:allContractInfoInOnePlace$2,alwaysStartTourInSettings:alwaysStartTourInSettings$2,amount:amount$2,amountMore:amountMore$3,amountWaiting:amountWaiting$2,appDownload:appDownload$2,apply:apply$2,areYouSure:areYouSure$2,areYouSureFinish:areYouSureFinish$2,areYouSureStopSession:areYouSureStopSession$2,arrangeThisYourselfOnline:arrangeThisYourselfOnline$2,atHome:atHome$2,back:back$2,backToDateSelection:backToDateSelection$2,batchSettings:batchSettings$3,block:block$2,business:business$2,cable:cable$2,cancel:cancel$2,carNotConnected:carNotConnected$2,change:change$2,changeAccountInfoHere:changeAccountInfoHere$3,changeProfile:changeProfile$2,changeSchedule:changeSchedule$2,changeYourSettingsHere:changeYourSettingsHere$3,charge:charge$2,chargeCard:chargeCard$3,chargeCardNotOnThisList:chargeCardNotOnThisList$2,chargeCardNumber:chargeCardNumber$2,chargeCards:chargeCards$3,chargeEvenFaster:chargeEvenFaster$3,chargePoint:chargePoint$3,chargePointName:chargePointName$2,chargePointNumber:chargePointNumber$2,chargePoints:chargePoints$3,chargepointSettings:chargepointSettings$3,chargeSessionInformation:chargeSessionInformation$2,chargingSession:chargingSession$2,choose:choose$2,clear:clear$2,clickToReload:clickToReload$2,close:close$2,company:company$2,companyName:companyName$2,confirm:confirm$2,connected:connected$2,connectionClosed:connectionClosed$2,contact:contact$2,"continue":"Volgende",continueReading:continueReading$2,cookie:cookie$2,copied:copied$2,copy:copy$3,country:country$6,countryCode:countryCode$2,currency:currency$2,customerType:customerType$2,dashboard:dashboard$3,delayUntil:delayUntil$2,delayFrom:delayFrom$2,"delete":"Verwijderen",deselectAll:deselectAll$2,disabled:disabled$2,download:download$2,downloadApp:downloadApp$3,downloadBrochure:downloadBrochure$2,downloadResearch:downloadResearch$2,dragDropFiles:dragDropFiles$2,duration:duration$2,edit:edit$2,editChargeCard:editChargeCard$2,emailCheck:emailCheck$2,emailNotRecieved:emailNotRecieved$2,emailSend:emailSend$2,emailSentIfExist:emailSentIfExist$2,employee:employee$2,enabled:enabled$2,enterNewPassword:enterNewPassword$2,entrance:entrance$2,errors:errors$2,example:example$2,excl:excl$2,exclusive:exclusive$2,faq:faq$2,features:features$2,feedback:feedback$2,fileUploaded:fileUploaded$2,filter:filter$2,followOurAdventure:followOurAdventure$2,free:free$3,from:from$2,garage:garage$2,getOnPlayStore:getOnPlayStore$2,gotIt:gotIt$2,grids:grids$2,group:group$2,help:help$2,home:home$2,houseNumber:houseNumber$6,houseNumberAdditions:houseNumberAdditions$2,inCollaborationWith:inCollaborationWith$2,incl:incl$2,inclusive:inclusive$2,information:information$2,insightIntoTransactions:insightIntoTransactions$3,insights:insights$2,instanceConnectionClosed:instanceConnectionClosed$2,invalidChargeCard:invalidChargeCard$2,lastSave:lastSave$2,lastUpdate:lastUpdate$2,learnMore:learnMore$2,leaveItToMe:leaveItToMe$2,letsCheckWithAdviceGuru:letsCheckWithAdviceGuru$2,linkChargeCards:linkChargeCards$3,linkChargePoints:linkChargePoints$3,linkedChargeCards:linkedChargeCards$2,linkedChargePoints:linkedChargePoints$2,linkedThirdPartyChargeCards:linkedThirdPartyChargeCards$2,list:list$2,location:location$2,lock:lock$2,map:map$3,mobileApp:mobileApp$2,model:model$2,moreInformation:moreInformation$2,moreInformationContactUs:moreInformationContactUs$2,my:my$2,myChargeCards:myChargeCards$2,myDashboard:myDashboard$2,name:name$5,newGeneration:newGeneration$2,news:news$2,next:next$2,no:no$2,noChargeCard:noChargeCard$2,noChargeCardsFound:noChargeCardsFound$2,noChargeCardsFoundInSelection:noChargeCardsFoundInSelection$2,noChargePointsFound:noChargePointsFound$2,noPlugChargeChargeCard:noPlugChargeChargeCard$2,noUpcomingEvent:noUpcomingEvent$2,notAFan:notAFan$2,notifications:notifications$2,ok:ok$2,openOnMobile:openOnMobile$2,optional:optional$2,or:or$2,other:other$2,ourOtherSolutions:ourOtherSolutions$2,pages:pages$2,parking:parking$2,passwordUpdated:passwordUpdated$2,pay:pay$2,payAttention:payAttention$2,paymentMethod:paymentMethod$2,perKilowattHour:perKilowattHour$2,place:place$2,plugInCar:plugInCar$2,pppsstIamHere:pppsstIamHere$2,previous:previous$2,products:products$2,pursue:pursue$2,qrPayment:qrPayment$2,question:question$2,queue:queue$2,quickAccess:quickAccess$2,readMore:readMore$2,reference:reference$2,removeFilters:removeFilters$2,removeSelection:removeSelection$2,reportABug:reportABug$2,requestChargeCard:requestChargeCard$2,requestChargePoint:requestChargePoint$2,requestChargePointBusiness:requestChargePointBusiness$2,requestChargePointForAtHome:requestChargePointForAtHome$2,requestFreeChargePoint:requestFreeChargePoint$2,requiredAmountFieldsEmpty:requiredAmountFieldsEmpty$2,requiredFieldEmpty:requiredFieldEmpty$2,research:research$2,reserve:reserve$2,reserved:reserved$2,resident:resident$2,save:save$2,saved:saved$2,saving:saving$2,scanWithPhoneQrApp:scanWithPhoneQrApp$2,scheduleMeeting:scheduleMeeting$3,screenshots:screenshots$2,search:search$2,seeYourChargePoints:seeYourChargePoints$3,selectAll:selectAll$2,selectDefaultChargeCard:selectDefaultChargeCard$2,selectPlugAndChargeCard:selectPlugAndChargeCard$2,selectProfile:selectProfile$2,selected:selected$2,selectedChargecard:selectedChargecard$2,send:send$2,sendAgain:sendAgain$2,serialNumber:serialNumber$2,services:services$2,setUp:setUp$2,shortcuts:shortcuts$2,showMore:showMore$2,showOnGoogleMaps:showOnGoogleMaps$2,showingAmountChargePoint:showingAmountChargePoint$2,selectedAmountChargePoint:selectedAmountChargePoint$3,signUp:signUp$2,signatureAgreement:signatureAgreement$2,skip:skip$2,skipTour:skipTour$2,spambox:spambox$2,startKwh:startKwh$2,startTour:startTour$2,street:street$2,support:support$2,switchEmail:switchEmail$2,symbol:symbol$2,symbols:symbols$2,tel:tel$6,test:test$2,thisIsExample:thisIsExample$2,tip:tip$2,to:to$2,totalCO2Emission:totalCO2Emission$3,totalCost:totalCost$2,totalEnergyUsage:totalEnergyUsage$2,totalTrees:totalTrees$3,tour:tour$2,transaction:transaction$2,transactions:transactions$3,unblock:unblock$2,units:units$9,unlock:unlock$2,upload:upload$3,usefullLinks:usefullLinks$2,viewAll:viewAll$2,viewLess:viewLess$2,viewTheEntire:viewTheEntire$2,watchVideo:watchVideo$2,welcome:welcome$3,welcomeBack:welcomeBack$2,whoops:whoops$2,workAt:workAt$3,yes:yes$2,youCanDoThisOnline:youCanDoThisOnline$2,your:your$2,youreStillHere:youreStillHere$2,zipCode:zipCode$6,sent:sent$3,returnToForm:returnToForm$3,backTo:backTo$3,select:select$3,seeAll:seeAll$2,keyboardShortcuts:keyboardShortcuts$3,navigation:navigation$3,control:control$3,previousQuestion:previousQuestion$3,nextQuestion:nextQuestion$3,forExample:forExample$3,notProvided:notProvided$3,everythingInANutshell:everythingInANutshell$3,savingFailed:savingFailed$3,sendingFailed:sendingFailed$3,searchingAddress:searchingAddress$3,couldntAutocompleteAddress:couldntAutocompleteAddress$3,itsTakingLongerThanExpected:itsTakingLongerThanExpected$3,makeSureToSaveProgress:makeSureToSaveProgress$3,noAgreementFound:noAgreementFound$3,overview:overview$3,tryAgainLaterOrContactUs:tryAgainLaterOrContactUs$3,settingLanguage:settingLanguage$3,noPhotosProvided:noPhotosProvided$3,reset:reset$3,noteNotAllMandatoryQuestionsHaveBeenFilledIn:noteNotAllMandatoryQuestionsHaveBeenFilledIn$3,required:required$3,maxKwh:maxKwh$3,wellDone:wellDone$3,endOfFirstFlow:endOfFirstFlow$3,invoices:invoices$2,status:status$8,exit:exit$3,forAtHome:forAtHome$3,forBusiness:forBusiness$3,quotation:quotation$3,getQuote:getQuote$3,registerToCharge:registerToCharge$3,reimbursementInformation:reimbursementInformation$3,repeatEach:repeatEach$3,energy:energy$3,calculateYourSavings:calculateYourSavings$3,now:now$4,positive:positive$3,negative:negative$3,electricity:electricity$3,gas:gas$3,allInPrice:allInPrice$3,marketPrice:marketPrice$3,marketPriceInclVat:marketPriceInclVat$3,marketPriceInclPurchaseFeeEnergyTaxVat:marketPriceInclPurchaseFeeEnergyTaxVat$3};

var about$1="About us";var accessibility$1={button:"Button",input:"Input"};var actions$4="Actions";var active$1="Active";var add$5="Add";var addChargeCard$1="Add charge card";var addChargePoint$1="Add charge point";var addSeeChangeYourChargeCard$2="Add or change your charge cards";var additionalInformation$2="Additional information";var address$1="Address";var advanced$1="Advanced";var all$1="All";var allChargeCards$2="All charge cards";var allChargePoints$1="All charge points";var allContractInfoInOnePlace$1="Your contract information in one place";var alwaysStartTourInSettings$1="You can always restart the tour from the settings";var amount$1="Amount";var amountMore$2="& {{amount}} more";var amountWaiting$1="{{amount}} waiting";var appDownload$1="Download app";var apply$1="Apply";var areYouSure$1="Are you sure";var areYouSureFinish$1="Are you sure you want to submit? You can't change your answers after submitting.";var areYouSureStopSession$1="Are you sure you want to stop your charging session. This choice is irreversible.";var arrangeThisYourselfOnline$1="You can do this yourself online!";var atHome$1="Charging for at home";var back$1="Back";var backToDateSelection$1="Go back and adjust your selection";var batchSettings$2={scheduleChange:"Schedule change",information:"<b>NB</b> This will set all the selected chargepoints to the chosen settings. This will turn off all the settings that are turned off in the previous screen."};var block$1="Block";var business$1="Charging for Business";var cable$1="Cable";var cancel$1="Cancel";var carNotConnected$1="Your car seems to not be connected.";var change$1="Change";var changeAccountInfoHere$2="Change your account information";var changeProfile$1="Change profile";var changeSchedule$1="Change schedule";var changeYourSettingsHere$2="Change your app settings here";var charge$1="Charge";var chargeCard$2="Charge card";var chargeCardNotOnThisList$1="Charge card not linked? Enter the serial number below.";var chargeCardNumber$1="Charge card number";var chargeCards$2="Charge cards";var chargeEvenFaster$2="Charge even faster!";var chargePoint$2="Charge point";var chargePointName$1="Charge point name";var chargePointNumber$1="Charge point number";var chargePoints$2="Charge points";var chargepointSettings$2="Charge point settings";var chargeSessionInformation$1="Charge session information";var chargingSession$1="Charging session";var choose$1="Choose";var clear$1="Clear";var clickToReload$1="Click to reload";var close$1="Close";var company$1="Company";var companyName$1="Company name";var confirm$1="Confirm";var connected$1="Connected";var connectionClosed$1="Connection closed!";var contact$1="Contact";var continueReading$1="Continue reading";var cookie$1={button:"Accept",closeCookiePopup:"Close cookie pop-up",text:"This website stores cookies on your computer. These cookies are used to improve your website experience and provide more personalized services to you, both on this website and through other media. To find out more about the cookies we use, see our <a target=\"_blank\" href=\"https://www.bluecurrent.nl/legal/cookies\" style=\"text-decoration:underline;\">cookie policy</a>.",title:"Time for cookies"};var copied$1="Copied";var copy$2="Copy";var country$5="Country";var countryCode$1="Country code";var currency$1={inEuro:"in €"};var customerType$1="Customer type";var dashboard$2="Dashboard";var delayUntil$1="Delay until";var delayFrom$1="Delay from";var deselectAll$1="Deselect all";var disabled$1="Disabled";var download$1="Download";var downloadApp$2="Download the app!";var downloadBrochure$1="Download brochure";var downloadResearch$1="Download research";var dragDropFiles$1="Drop files or click here to upload";var duration$1="Duration";var edit$1="Edit";var editChargeCard$1="Edit charge card";var emailCheck$1="We've sent you an e-mail that you can use to complete your registration";var emailNotRecieved$1="No email received?";var emailSend$1="E-mail has been sent";var emailSentIfExist$1="If an account with that e-mail exists, an email has been sent to it";var employee$1="Employee";var enabled$1="Enabled";var enterNewPassword$1="Enter your new password";var entrance$1="Entrance";var errors$1={"email-empty":"E-mail is a required field","email-invalid":"Please enter a valid e-mail address",emailMismatch:"E-mail doesn't match",fieldRequired:"This field is required","firstname-empty":"Firstname is a required field",invalidChargepointNumber:"Invalid charging point number","lastname-empty":"Lastname is a required field",noConnectionBackend:"We are unable to connect to our servers, please try again later",noConsent:"Please consent to our TOS and Privacy policy","password-empty":"Password is a required field","passwords-match":"Passwords must match","phone-empty":"Phone number is a required field","phone-invalid":"Please enter a valid phone number",somethingWrong:"Something went wrong"};var example$1="Example";var excl$1="Excl.";var exclusive$1="Excluding";var faq$1="Frequently asked questions";var features$1="Features";var feedback$1="Feedback";var fileUploaded$1="File uploaded";var filter$1="Filter";var followOurAdventure$1="Follow our adventure";var free$2="Free";var from$1="From";var garage$1="Garage";var getOnPlayStore$1="Get it on Google Play";var gotIt$1="Got it";var grids$1="Grids";var group$1={allGroups:"All groups",create:"Create group",deleteConfirmDialog:"Are you sure you want to delete this group? This action is irreversible",edit:"Edit group",editGroups:"Edit groups",group:"Group",groups:"Groups",none:"You haven't created a group yet, you will see your created groups here.",update:"Update"};var help$1="Help";var home$1="Home";var houseNumber$5="House number";var houseNumberAdditions$1="Apt. Suite etc. ";var inCollaborationWith$1="In collaboration with";var incl$1="Incl.";var inclusive$1="Including";var information$1="Information";var insightIntoTransactions$2="Insight into your charge sessions";var insights$1="Insights";var instanceConnectionClosed$1="The connection with your instance has been closed";var invalidChargeCard$1="Invalid card: Charging sessions with this card cannot be billed via the card provider. You can use the card as a 'key' that to start and stop charging sessions.";var lastSave$1="Last save";var lastUpdate$1="Last update";var learnMore$1="Learn more";var leaveItToMe$1="Leave it to me!";var letsCheckWithAdviceGuru$1="Let's check with advice-Guru {{name}}";var linkChargeCards$2="Link charge card";var linkChargePoints$2="Link charge points";var linkedChargeCards$1="Linked charge cards";var linkedChargePoints$1="Linked charge points";var linkedThirdPartyChargeCards$1="Third party cards";var list$1="List";var location$1="Location";var lock$1="Lock";var map$2="Map";var mobileApp$1={app:"App",description:"We make electric driving even easier. With our app, you can take charge of your charge point in no time at all. ",feature_adjustSettings:"Adjust charge point settings",feature_checkBuildingEnergy:"Insight into the power consumption of the building",feature_howMuchYouAreCharging:"See how much you are charging"};var model$1="Model";var moreInformation$1="More information about";var moreInformationContactUs$1="Would you like more information? Contact us!";var my$1="My";var myChargeCards$1="My charge cards";var myDashboard$1="My dashboard";var name$4="Name";var newGeneration$1="New generation";var news$1="News";var next$1="Next";var no$1="No";var noChargeCard$1="Without charge card";var noChargeCardsFound$1="No charge cards found";var noChargeCardsFoundInSelection$1="No chargecards or transactions have been found within your selection.";var noChargePointsFound$1="No charge points found";var noPlugChargeChargeCard$1="Plug & charge without charge card";var noUpcomingEvent$1="No upcoming event";var notAFan$1="Not a fan of my.bluecurrent.nl?\n<br />\n<u>Return to the old platform</u>";var notifications$1="Notifications";var ok$1="Ok";var openOnMobile$1="Open on mobile";var optional$1="Optional";var or$1="Or";var other$1="Other";var ourOtherSolutions$1="Our other solutions";var pages$1="Pages";var parking$1="Parking";var passwordUpdated$1="Your password has been updated succesfully.";var pay$1="Pay";var payAttention$1="Pay attention";var paymentMethod$1="Payment method";var perKilowattHour$1="per kWh";var place$1="City";var plugInCar$1="Plug in your car to continue";var pppsstIamHere$1="Pppsst I'm here!";var previous$1="Previous";var products$1="Products";var pursue$1="Continue";var qrPayment$1="QR-payment";var question$1={whatIsThe:"What is the",whatIsYour:"What is your"};var queue$1="Queue";var quickAccess$1="Quick access";var readMore$1="Read more";var reference$1="Reference";var removeFilters$1="Clear filters";var removeSelection$1="Remove selection";var reportABug$1="Report a bug";var requestChargeCard$1="Request charge card";var requestChargePoint$1="Request charge point";var requestChargePointBusiness$1="Request charge points for businesses";var requestChargePointForAtHome$1="Request charge point for at home ";var requestFreeChargePoint$1="Request (Free) exploitation charge point";var requiredAmountFieldsEmpty$1="<b>{{amount}}</b> more fields to fill in";var requiredFieldEmpty$1="<b>1</b> more field to fill in";var research$1="Research";var reserve$1="Reserve";var reserved$1="Reserved";var resident$1="Resident";var save$1="Save";var saved$1="Saved";var saving$1="Saving";var scanWithPhoneQrApp$1="Scan with your phone camera or QR app to continue";var scheduleMeeting$2="Schedule meeting";var screenshots$1="Screenshots";var search$1="Search";var seeYourChargePoints$2="See your charge points";var selectAll$1="Select all";var selectDefaultChargeCard$1="Select default charge card";var selectPlugAndChargeCard$1="Select plug & charge card";var selectProfile$1="Select a profile";var selected$1="Selected";var selectedChargecard$1="Selected charge card";var send$1="Send";var sendAgain$1="Send again";var serialNumber$1="Serial number";var services$1="Services";var setUp$1="Set up";var shortcuts$1="Shortcuts";var showMore$1="Show more";var showOnGoogleMaps$1="Show on Google Maps";var showingAmountChargePoint$1="Showing {{amount}} out of {{total}} charge points";var selectedAmountChargePoint$2="Selected {{amount}} out of {{total}} charge points";var signUp$1="Sign up";var signatureAgreement$1="Signature agreement";var skip$1="Skip";var skipTour$1="Skip tour";var spambox$1="Didn't find the e-mail? Check your spam.";var startKwh$1="Start kWh";var startTour$1="Start tour";var street$1="Street";var support$1="Support";var switchEmail$1="Switch email address";var symbol$1="Symbol";var symbols$1="Symbols";var tel$5="Tel";var test$1="Test";var thisIsExample$1="<b>NB</b> This is an example!";var tip$1="Hint";var to$1="To";var totalCO2Emission$2="CO<sub>2</sub> emissions saved";var totalCost$1="Total cost";var totalEnergyUsage$1="Total energy usage";var totalTrees$2="Trees planted";var tour$1={step1:"Here you'll find the current status of your charge point.\n<br />\nTip: Click on the three dots to switch to other charge points.",step2:"Here you'll see the first upcoming events. For example, reimbursements.",step3:"Here you'll find your charge points. You can click on a charge point to open the charge point settings.",step4:"Here you can change the settings of your charge point, including changing the tariff, rebooting/resetting your charge point, and more.",step5:"You can click on a charge card to change your charge card name or remove the charge card entirely.",step6:"When you click on a charge session, you'll find some additional information about that charge session.",step7:"Use these filters to filter the charge sessions list. After setting the filters you can download an Excel file, or click 'Declaration Overview' to download a declaration overview."};var transaction$1="Transaction";var transactions$2="Charge sessions";var unblock$1="Unblock";var units$8={kilogram:"Kilogram",kiloton:"Kiloton",megaton:"Megaton",ton:"Ton",kilogramRounded:"kg",kilotonRounded:"kt",megatonRounded:"Mt",tonRounded:"t"};var unlock$1="Unlock";var upload$2={columnLabel:"In what column are the {{type}}s?",column:"{{type}} column",complete:"Upload complete",excludeLabel:"Do you want to exclude the chargecards from payment?",failed:"failed",fileLimit:"Only 1 file can be uploaded at once",fileTooLarge:"File is too large",headersLabel:"Does the file contain headers?",headers:"Contains headers",information:"To read the file correctly, you'll need to provide more information about how the file is structured.",successful:"successful",total:"Total",upload:"Upload",uploading:"Uploading file",unsupportedFile:"Unsupported file type"};var usefullLinks$1="Usefull links";var viewAll$1="View all";var viewLess$1="View le";var viewTheEntire$1="View the entire";var watchVideo$1="Watch video";var welcome$2="Welcome {{name}}";var welcomeBack$1="Welcome back!";var whoops$1="Whoops!";var workAt$2="Work at";var yes$1="Yes";var youCanDoThisOnline$1="You can quickly arrage the yourself online!";var your$1="Your";var youreStillHere$1="Awesome! You're still here";var zipCode$5="Zip code";var sent$2="Submitted";var returnToForm$2="Return to form";var backTo$2="Back to {{url}}";var select$2="Select";var seeAll$1="See all";var keyboardShortcuts$2="Keyboard shortcuts";var navigation$2="Navigation";var control$2="Control";var previousQuestion$2="Previous question";var nextQuestion$2="Next question";var forExample$2="For example";var notProvided$2="Not provided";var everythingInANutshell$2="Everything in a nutshell";var savingFailed$2="Saving failed";var sendingFailed$2="Sending failed";var searchingAddress$2="Searching address";var couldntAutocompleteAddress$2="We couldn't automatically fill in your address. Can you help us out?";var itsTakingLongerThanExpected$2="It's taking a bit longer than expected, but we are still processing.";var makeSureToSaveProgress$2="Make sure to save your progress before leaving";var noAgreementFound$2="No agreement found";var overview$2="Overview";var tryAgainLaterOrContactUs$2="An error occurred. Please try again later or <a href=\"https://www.bluecurrent.nl/contact\" target=\"_blank\" rel=\"noreferrer\">contact us</a> if the error persists";var settingLanguage$2="Setting language";var noPhotosProvided$2="No photo(s) provided";var reset$2="Reset";var noteNotAllMandatoryQuestionsHaveBeenFilledIn$2="Note that not all questions have been filled in; ensure all required questions are completed before submitting.";var required$2="Required";var maxKwh$2="Max kWh";var wellDone$2="Well done!";var endOfFirstFlow$2="Thank you very much for taking the time to answer our questions. We now have enough information to prepare (for the installation of) your charge point.\n<br /><br />\nYou'll receive an email with a status update within several business days. If a quotation must be approved by a third party (i.e. your employer, fuel card provider or leasing company), this process may take up to 10 business days. We'll contact you as soon as possible if we have further questions.\n<br /><br />\nIs this your first electric vehicle? Consider boomarking these URLs:<br/>\n- Drive Green has a <a href=\"https://www.youtube.com/watch?v=XDrcdABiDU4\" target=\"_blank\">YouTube video</a> that explains the basics of EV charging. Although the video was intended for the UK market, it translates very well to continental Europe.<br/>\n- <a href=\"https://help.bluecurrent.nl/knowledge\" target=\"_blank\">Our FAQ</a> contains useful information about our services. ";var invoices$1="Invoices";var status$7="Status";var exit$2="Exit";var forAtHome$2="For At Home";var forBusiness$2="For Business";var quotation$2="Quotation";var getQuote$2="Get a quote";var registerToCharge$2="Register to start charging";var reimbursementInformation$2="Reimbursement information";var repeatEach$2="Repeat each";var energy$2="Energy";var calculateYourSavings$2="Calculate Your Savings";var now$3="Now";var positive$2="Positive";var negative$2="Negative";var electricity$2="Electricity";var gas$2="Gas";var allInPrice$2="All-in Price";var marketPrice$2="Market Price";var marketPriceInclVat$2="Market price incl.VAT";var marketPriceInclPurchaseFeeEnergyTaxVat$2="Market price incl. purchase fee, energy tax & VAT";var UiEN = {about:about$1,accessibility:accessibility$1,actions:actions$4,active:active$1,add:add$5,addChargeCard:addChargeCard$1,addChargePoint:addChargePoint$1,addSeeChangeYourChargeCard:addSeeChangeYourChargeCard$2,additionalInformation:additionalInformation$2,address:address$1,advanced:advanced$1,all:all$1,allChargeCards:allChargeCards$2,allChargePoints:allChargePoints$1,allContractInfoInOnePlace:allContractInfoInOnePlace$1,alwaysStartTourInSettings:alwaysStartTourInSettings$1,amount:amount$1,amountMore:amountMore$2,amountWaiting:amountWaiting$1,appDownload:appDownload$1,apply:apply$1,areYouSure:areYouSure$1,areYouSureFinish:areYouSureFinish$1,areYouSureStopSession:areYouSureStopSession$1,arrangeThisYourselfOnline:arrangeThisYourselfOnline$1,atHome:atHome$1,back:back$1,backToDateSelection:backToDateSelection$1,batchSettings:batchSettings$2,block:block$1,business:business$1,cable:cable$1,cancel:cancel$1,carNotConnected:carNotConnected$1,change:change$1,changeAccountInfoHere:changeAccountInfoHere$2,changeProfile:changeProfile$1,changeSchedule:changeSchedule$1,changeYourSettingsHere:changeYourSettingsHere$2,charge:charge$1,chargeCard:chargeCard$2,chargeCardNotOnThisList:chargeCardNotOnThisList$1,chargeCardNumber:chargeCardNumber$1,chargeCards:chargeCards$2,chargeEvenFaster:chargeEvenFaster$2,chargePoint:chargePoint$2,chargePointName:chargePointName$1,chargePointNumber:chargePointNumber$1,chargePoints:chargePoints$2,chargepointSettings:chargepointSettings$2,chargeSessionInformation:chargeSessionInformation$1,chargingSession:chargingSession$1,choose:choose$1,clear:clear$1,clickToReload:clickToReload$1,close:close$1,company:company$1,companyName:companyName$1,confirm:confirm$1,connected:connected$1,connectionClosed:connectionClosed$1,contact:contact$1,"continue":"Continue",continueReading:continueReading$1,cookie:cookie$1,copied:copied$1,copy:copy$2,country:country$5,countryCode:countryCode$1,currency:currency$1,customerType:customerType$1,dashboard:dashboard$2,delayUntil:delayUntil$1,delayFrom:delayFrom$1,"delete":"Delete",deselectAll:deselectAll$1,disabled:disabled$1,download:download$1,downloadApp:downloadApp$2,downloadBrochure:downloadBrochure$1,downloadResearch:downloadResearch$1,dragDropFiles:dragDropFiles$1,duration:duration$1,edit:edit$1,editChargeCard:editChargeCard$1,emailCheck:emailCheck$1,emailNotRecieved:emailNotRecieved$1,emailSend:emailSend$1,emailSentIfExist:emailSentIfExist$1,employee:employee$1,enabled:enabled$1,enterNewPassword:enterNewPassword$1,entrance:entrance$1,errors:errors$1,example:example$1,excl:excl$1,exclusive:exclusive$1,faq:faq$1,features:features$1,feedback:feedback$1,fileUploaded:fileUploaded$1,filter:filter$1,followOurAdventure:followOurAdventure$1,free:free$2,from:from$1,garage:garage$1,getOnPlayStore:getOnPlayStore$1,gotIt:gotIt$1,grids:grids$1,group:group$1,help:help$1,home:home$1,houseNumber:houseNumber$5,houseNumberAdditions:houseNumberAdditions$1,inCollaborationWith:inCollaborationWith$1,incl:incl$1,inclusive:inclusive$1,information:information$1,insightIntoTransactions:insightIntoTransactions$2,insights:insights$1,instanceConnectionClosed:instanceConnectionClosed$1,invalidChargeCard:invalidChargeCard$1,lastSave:lastSave$1,lastUpdate:lastUpdate$1,learnMore:learnMore$1,leaveItToMe:leaveItToMe$1,letsCheckWithAdviceGuru:letsCheckWithAdviceGuru$1,linkChargeCards:linkChargeCards$2,linkChargePoints:linkChargePoints$2,linkedChargeCards:linkedChargeCards$1,linkedChargePoints:linkedChargePoints$1,linkedThirdPartyChargeCards:linkedThirdPartyChargeCards$1,list:list$1,location:location$1,lock:lock$1,map:map$2,mobileApp:mobileApp$1,model:model$1,moreInformation:moreInformation$1,moreInformationContactUs:moreInformationContactUs$1,my:my$1,myChargeCards:myChargeCards$1,myDashboard:myDashboard$1,name:name$4,newGeneration:newGeneration$1,news:news$1,next:next$1,no:no$1,noChargeCard:noChargeCard$1,noChargeCardsFound:noChargeCardsFound$1,noChargeCardsFoundInSelection:noChargeCardsFoundInSelection$1,noChargePointsFound:noChargePointsFound$1,noPlugChargeChargeCard:noPlugChargeChargeCard$1,noUpcomingEvent:noUpcomingEvent$1,notAFan:notAFan$1,notifications:notifications$1,ok:ok$1,openOnMobile:openOnMobile$1,optional:optional$1,or:or$1,other:other$1,ourOtherSolutions:ourOtherSolutions$1,pages:pages$1,parking:parking$1,passwordUpdated:passwordUpdated$1,pay:pay$1,payAttention:payAttention$1,paymentMethod:paymentMethod$1,perKilowattHour:perKilowattHour$1,place:place$1,plugInCar:plugInCar$1,pppsstIamHere:pppsstIamHere$1,previous:previous$1,products:products$1,pursue:pursue$1,qrPayment:qrPayment$1,question:question$1,queue:queue$1,quickAccess:quickAccess$1,readMore:readMore$1,reference:reference$1,removeFilters:removeFilters$1,removeSelection:removeSelection$1,reportABug:reportABug$1,requestChargeCard:requestChargeCard$1,requestChargePoint:requestChargePoint$1,requestChargePointBusiness:requestChargePointBusiness$1,requestChargePointForAtHome:requestChargePointForAtHome$1,requestFreeChargePoint:requestFreeChargePoint$1,requiredAmountFieldsEmpty:requiredAmountFieldsEmpty$1,requiredFieldEmpty:requiredFieldEmpty$1,research:research$1,reserve:reserve$1,reserved:reserved$1,resident:resident$1,save:save$1,saved:saved$1,saving:saving$1,scanWithPhoneQrApp:scanWithPhoneQrApp$1,scheduleMeeting:scheduleMeeting$2,screenshots:screenshots$1,search:search$1,seeYourChargePoints:seeYourChargePoints$2,selectAll:selectAll$1,selectDefaultChargeCard:selectDefaultChargeCard$1,selectPlugAndChargeCard:selectPlugAndChargeCard$1,selectProfile:selectProfile$1,selected:selected$1,selectedChargecard:selectedChargecard$1,send:send$1,sendAgain:sendAgain$1,serialNumber:serialNumber$1,services:services$1,setUp:setUp$1,shortcuts:shortcuts$1,showMore:showMore$1,showOnGoogleMaps:showOnGoogleMaps$1,showingAmountChargePoint:showingAmountChargePoint$1,selectedAmountChargePoint:selectedAmountChargePoint$2,signUp:signUp$1,signatureAgreement:signatureAgreement$1,skip:skip$1,skipTour:skipTour$1,spambox:spambox$1,startKwh:startKwh$1,startTour:startTour$1,street:street$1,support:support$1,switchEmail:switchEmail$1,symbol:symbol$1,symbols:symbols$1,tel:tel$5,test:test$1,thisIsExample:thisIsExample$1,tip:tip$1,to:to$1,totalCO2Emission:totalCO2Emission$2,totalCost:totalCost$1,totalEnergyUsage:totalEnergyUsage$1,totalTrees:totalTrees$2,tour:tour$1,transaction:transaction$1,transactions:transactions$2,unblock:unblock$1,units:units$8,unlock:unlock$1,upload:upload$2,usefullLinks:usefullLinks$1,viewAll:viewAll$1,viewLess:viewLess$1,viewTheEntire:viewTheEntire$1,watchVideo:watchVideo$1,welcome:welcome$2,welcomeBack:welcomeBack$1,whoops:whoops$1,workAt:workAt$2,yes:yes$1,youCanDoThisOnline:youCanDoThisOnline$1,your:your$1,youreStillHere:youreStillHere$1,zipCode:zipCode$5,sent:sent$2,returnToForm:returnToForm$2,backTo:backTo$2,select:select$2,seeAll:seeAll$1,keyboardShortcuts:keyboardShortcuts$2,navigation:navigation$2,control:control$2,previousQuestion:previousQuestion$2,nextQuestion:nextQuestion$2,forExample:forExample$2,notProvided:notProvided$2,everythingInANutshell:everythingInANutshell$2,savingFailed:savingFailed$2,sendingFailed:sendingFailed$2,searchingAddress:searchingAddress$2,couldntAutocompleteAddress:couldntAutocompleteAddress$2,itsTakingLongerThanExpected:itsTakingLongerThanExpected$2,makeSureToSaveProgress:makeSureToSaveProgress$2,noAgreementFound:noAgreementFound$2,overview:overview$2,tryAgainLaterOrContactUs:tryAgainLaterOrContactUs$2,settingLanguage:settingLanguage$2,noPhotosProvided:noPhotosProvided$2,reset:reset$2,noteNotAllMandatoryQuestionsHaveBeenFilledIn:noteNotAllMandatoryQuestionsHaveBeenFilledIn$2,required:required$2,maxKwh:maxKwh$2,wellDone:wellDone$2,endOfFirstFlow:endOfFirstFlow$2,invoices:invoices$1,status:status$7,exit:exit$2,forAtHome:forAtHome$2,forBusiness:forBusiness$2,quotation:quotation$2,getQuote:getQuote$2,registerToCharge:registerToCharge$2,reimbursementInformation:reimbursementInformation$2,repeatEach:repeatEach$2,energy:energy$2,calculateYourSavings:calculateYourSavings$2,now:now$3,positive:positive$2,negative:negative$2,electricity:electricity$2,gas:gas$2,allInPrice:allInPrice$2,marketPrice:marketPrice$2,marketPriceInclVat:marketPriceInclVat$2,marketPriceInclPurchaseFeeEnergyTaxVat:marketPriceInclPurchaseFeeEnergyTaxVat$2};

var welcome$1="Bienvenue {{name}}";var transactions$1="Séances de charge";var downloadApp$1="Téléchargez l'application";var chargeEvenFaster$1="Chargez encore plus vite?";var totalTrees$1="Arbre(s) planté(s)";var dashboard$1="Tableau de bord";var totalCO2Emission$1="Réduction des émissions de CO<sub>2</sub>";var units$7={kiloton:"Kilotonne",megaton:"Mégatonne",ton:"Tonne(s)"};var free$1="Gratuite";var additionalInformation$1="Informations supplémentaires";var chargePoints$1="Bornes de recharge";var chargeCards$1="Carte de recharge";var allChargeCards$1="Toutes les cartes de recharge";var seeYourChargePoints$1="Voir vos bornes de recharge";var chargePoint$1="Borne de recharge";var changeYourSettingsHere$1="Changez vos paramètres";var changeAccountInfoHere$1="Changez vos informations de compte";var insightIntoTransactions$1="Aperçu de vos sessions de charge";var chargeCard$1="Carte de recharge";var addSeeChangeYourChargeCard$1="Ajouter, afficher ou modifier une carte de recharge";var amountMore$1="";var chargepointSettings$1="";var linkChargeCards$1="";var linkChargePoints$1="";var selectedAmountChargePoint$1="";var upload$1={information:"",complete:"",headersLabel:"",headers:"",columnLabel:"",column:"",excludeLabel:"",failed:"",fileLimit:"",fileTooLarge:"",successful:"",total:"",upload:"",uploading:"",unsupportedFile:""};var batchSettings$1={scheduleChange:"",information:""};var scheduleMeeting$1="";var workAt$1="";var sent$1="";var returnToForm$1="";var backTo$1="";var select$1="";var keyboardShortcuts$1="";var navigation$1="";var control$1="";var previousQuestion$1="";var nextQuestion$1="";var forExample$1="";var notProvided$1="";var everythingInANutshell$1="";var savingFailed$1="";var sendingFailed$1="";var searchingAddress$1="";var couldntAutocompleteAddress$1="";var itsTakingLongerThanExpected$1="";var makeSureToSaveProgress$1="";var noAgreementFound$1="";var overview$1="";var tryAgainLaterOrContactUs$1="";var settingLanguage$1="";var noPhotosProvided$1="";var reset$1="";var noteNotAllMandatoryQuestionsHaveBeenFilledIn$1="";var required$1="";var maxKwh$1="";var wellDone$1="";var endOfFirstFlow$1="";var exit$1="";var forAtHome$1="";var forBusiness$1="";var quotation$1="";var getQuote$1="";var registerToCharge$1="";var reimbursementInformation$1="";var repeatEach$1="";var energy$1="";var calculateYourSavings$1="";var now$2="";var positive$1="";var negative$1="";var electricity$1="";var gas$1="";var allInPrice$1="";var marketPrice$1="";var marketPriceInclVat$1="";var marketPriceInclPurchaseFeeEnergyTaxVat$1="";var UiFR = {welcome:welcome$1,transactions:transactions$1,downloadApp:downloadApp$1,chargeEvenFaster:chargeEvenFaster$1,totalTrees:totalTrees$1,dashboard:dashboard$1,totalCO2Emission:totalCO2Emission$1,units:units$7,free:free$1,additionalInformation:additionalInformation$1,chargePoints:chargePoints$1,chargeCards:chargeCards$1,allChargeCards:allChargeCards$1,seeYourChargePoints:seeYourChargePoints$1,chargePoint:chargePoint$1,changeYourSettingsHere:changeYourSettingsHere$1,changeAccountInfoHere:changeAccountInfoHere$1,insightIntoTransactions:insightIntoTransactions$1,chargeCard:chargeCard$1,addSeeChangeYourChargeCard:addSeeChangeYourChargeCard$1,amountMore:amountMore$1,chargepointSettings:chargepointSettings$1,linkChargeCards:linkChargeCards$1,linkChargePoints:linkChargePoints$1,selectedAmountChargePoint:selectedAmountChargePoint$1,upload:upload$1,batchSettings:batchSettings$1,scheduleMeeting:scheduleMeeting$1,workAt:workAt$1,sent:sent$1,returnToForm:returnToForm$1,backTo:backTo$1,select:select$1,keyboardShortcuts:keyboardShortcuts$1,navigation:navigation$1,control:control$1,previousQuestion:previousQuestion$1,nextQuestion:nextQuestion$1,forExample:forExample$1,notProvided:notProvided$1,everythingInANutshell:everythingInANutshell$1,savingFailed:savingFailed$1,sendingFailed:sendingFailed$1,searchingAddress:searchingAddress$1,couldntAutocompleteAddress:couldntAutocompleteAddress$1,itsTakingLongerThanExpected:itsTakingLongerThanExpected$1,makeSureToSaveProgress:makeSureToSaveProgress$1,noAgreementFound:noAgreementFound$1,overview:overview$1,tryAgainLaterOrContactUs:tryAgainLaterOrContactUs$1,settingLanguage:settingLanguage$1,noPhotosProvided:noPhotosProvided$1,reset:reset$1,noteNotAllMandatoryQuestionsHaveBeenFilledIn:noteNotAllMandatoryQuestionsHaveBeenFilledIn$1,required:required$1,maxKwh:maxKwh$1,wellDone:wellDone$1,endOfFirstFlow:endOfFirstFlow$1,exit:exit$1,forAtHome:forAtHome$1,forBusiness:forBusiness$1,quotation:quotation$1,getQuote:getQuote$1,registerToCharge:registerToCharge$1,reimbursementInformation:reimbursementInformation$1,repeatEach:repeatEach$1,energy:energy$1,calculateYourSavings:calculateYourSavings$1,now:now$2,positive:positive$1,negative:negative$1,electricity:electricity$1,gas:gas$1,allInPrice:allInPrice$1,marketPrice:marketPrice$1,marketPriceInclVat:marketPriceInclVat$1,marketPriceInclPurchaseFeeEnergyTaxVat:marketPriceInclPurchaseFeeEnergyTaxVat$1};

var about="[AAAAböööūūūṫ ūūūš]";var accessibility={button:"[BBūūūṫṫöööกี้]",input:"[IIIIกี้þūūūṫ]"};var actions$3="[AAAAçṫîîîöööกี้š]";var active="[AAAAçṫîîîvééé]";var add$4="[AAAAďď]";var addChargeCard="[AAAAďď çḥåååŕǧééé çåååŕď]";var addChargePoint="[AAAAďď çḥåååŕǧééé þöööîîîกี้ṫ]";var addSeeChangeYourChargeCard="[AAAAďď öööŕ çḥåååกี้ǧééé Ýöööūūūŕ çḥåååŕǧééé çåååŕďš]";var additionalInformation="[AAAAďďîîîṫîîîöööกี้åååļ îîîกี้ḟöööŕmåååṫîîîöööกี้]";var address="[AAAAďďŕéééšš]";var advanced="[AAAAďvåååกี้çéééď]";var all="[AAAAļļ]";var allChargeCards="[AAAAļļ çḥåååŕǧééé çåååŕďš]";var allChargePoints="[AAAAļļ çḥåååŕǧééé þöööîîîกี้ṫš]";var allContractInfoInOnePlace="[YYöööūūūŕ çöööกี้ṫŕåååçṫ îîîกี้ḟöööŕmåååṫîîîöööกี้ îîîกี้ öööกี้ééé þļåååçééé]";var alwaysStartTourInSettings="[YYöööūūū çåååกี้ åååļwåååÝš ŕéééšṫåååŕṫ ṫḥééé ṫöööūūūŕ ḟŕöööm ṫḥééé šéééṫṫîîîกี้ǧš]";var amount="[AAAAmöööūūūกี้ṫ]";var amountMore="[&& {{åååmöööūūūกี้ṫ}} möööŕééé]";var amountWaiting="[{{{åååmöööūūūกี้ṫ}} wåååîîîṫîîîกี้ǧ]";var appDownload="[DDöööwกี้ļöööåååď åååþþ]";var apply="[AAAAþþļÝ]";var areYouSure="[AAAAŕééé Ýöööūūū šūūūŕééé]";var areYouSureFinish="[AAAAŕééé Ýöööūūū šūūūŕééé Ýöööūūū wåååกี้ṫ ṫööö šūūūbmîîîṫ? Yöööūūū çåååกี้'ṫ çḥåååกี้ǧééé Ýöööūūūŕ åååกี้šwéééŕš åååḟṫéééŕ šūūūbmîîîṫṫîîîกี้ǧ.]";var areYouSureStopSession="[AAAAŕééé Ýöööūūū šūūūŕééé Ýöööūūū wåååกี้ṫ ṫööö šṫöööþ Ýöööūūūŕ çḥåååŕǧîîîกี้ǧ šéééššîîîöööกี้. Tḥîîîš çḥöööîîîçééé îîîš îîîŕŕééévéééŕšîîîbļééé.]";var arrangeThisYourselfOnline="[YYöööūūū çåååกี้ ďööö ṫḥîîîš Ýöööūūūŕšéééļḟ öööกี้ļîîîกี้ééé!]";var atHome="[CCḥåååŕǧîîîกี้ǧ ḟöööŕ åååṫ ḥööömééé]";var back="[BBåååçḱ]";var backToDateSelection="[GGööö båååçḱ åååกี้ď åååďĵūūūšṫ Ýöööūūūŕ šéééļéééçṫîîîöööกี้]";var batchSettings={scheduleChange:"[SSçḥéééďūūūļééé çḥåååกี้ǧééé]",information:"<b>NB</b> This will set all the selected chargepoints to the chosen settings. This will turn off all the settings that are turned off in the previous screen."};var block="[BBļöööçḱ]";var business="[CCḥåååŕǧîîîกี้ǧ ḟöööŕ Būūūšîîîกี้éééšš]";var cable="[CCåååbļééé]";var cancel="[CCåååกี้çéééļ]";var carNotConnected="[YYöööūūūŕ çåååŕ šéééééémš ṫööö กี้öööṫ bééé çöööกี้กี้éééçṫéééď.]";var change="[CCḥåååกี้ǧééé]";var changeAccountInfoHere="[CCḥåååกี้ǧééé Ýöööūūūŕ åååççöööūūūกี้ṫ îîîกี้ḟöööŕmåååṫîîîöööกี้]";var changeProfile="[CCḥåååกี้ǧééé þŕöööḟîîîļééé]";var changeSchedule="[CCḥåååกี้ǧééé šçḥéééďūūūļééé]";var changeYourSettingsHere="[CCḥåååกี้ǧééé Ýöööūūūŕ åååþþ šéééṫṫîîîกี้ǧš ḥéééŕééé]";var charge="[CCḥåååŕǧééé]";var chargeCard="[CCḥåååŕǧééé çåååŕď]";var chargeCardNotOnThisList="[CCḥåååŕǧééé çåååŕď กี้öööṫ ļîîîกี้ḱéééď? EEEกี้ṫéééŕ ṫḥééé šéééŕîîîåååļ กี้ūūūmbéééŕ béééļöööw.]";var chargeCardNumber="[CCḥåååŕǧééé çåååŕď กี้ūūūmbéééŕ]";var chargeCards="[CCḥåååŕǧééé çåååŕďš]";var chargeEvenFaster="[CCḥåååŕǧééé ééévéééกี้ ḟåååšṫéééŕ!]";var chargePoint="[CCḥåååŕǧééé þöööîîîกี้ṫ]";var chargePointName="[CCḥåååŕǧééé þöööîîîกี้ṫ กี้åååmééé]";var chargePointNumber="[CCḥåååŕǧééé þöööîîîกี้ṫ กี้ūūūmbéééŕ]";var chargePoints="[CCḥåååŕǧééé þöööîîîกี้ṫš]";var chargepointSettings="[CCḥåååŕǧééé þöööîîîกี้ṫ šéééṫṫîîîกี้ǧš]";var chargeSessionInformation="[CCḥåååŕǧééé šéééššîîîöööกี้ îîîกี้ḟöööŕmåååṫîîîöööกี้]";var chargingSession="[CCḥåååŕǧîîîกี้ǧ šéééššîîîöööกี้]";var choose="[CCḥööööööšééé]";var clear="[CCļéééåååŕ]";var clickToReload="[CCļîîîçḱ ṫööö ŕéééļöööåååď]";var close="[CCļöööšééé]";var company="[CCööömþåååกี้Ý]";var companyName="[CCööömþåååกี้Ý กี้åååmééé]";var confirm="[CCöööกี้ḟîîîŕm]";var connected="[CCöööกี้กี้éééçṫéééď]";var connectionClosed="[CCöööกี้กี้éééçṫîîîöööกี้ çļöööšéééď!]";var contact="[CCöööกี้ṫåååçṫ]";var continueReading="[CCöööกี้ṫîîîกี้ūūūééé ŕéééåååďîîîกี้ǧ]";var cookie={button:"[AAAAççéééþṫ]",closeCookiePopup:"[CCļöööšééé çööööööḱîîîééé þöööþ-ūūūþ]",text:"This website stores cookies on your computer. These cookies are used to improve your website experience and provide more personalized services to you, both on this website and through other media. To find out more about the cookies we use, see our <a target=\"_blank\" href=\"https://www.bluecurrent.nl/legal/cookies\" style=\"text-decoration:underline;\">cookie policy</a>.",title:"[TTîîîmééé ḟöööŕ çööööööḱîîîéééš]"};var copied="[CCöööþîîîéééď]";var copy$1="[CCöööþÝ]";var country$4="[CCöööūūūกี้ṫŕÝ]";var countryCode="[CCöööūūūกี้ṫŕÝ çöööďééé]";var currency={inEuro:"[îîîîกี้ €]"};var customerType="[CCūūūšṫöööméééŕ ṫÝþééé]";var dashboard="[DDåååšḥböööåååŕď]";var delayUntil="[DDéééļåååÝ ūūūกี้ṫîîîļ]";var delayFrom="[DDéééļåååÝ ḟŕöööm]";var deselectAll="[DDéééšéééļéééçṫ åååļļ]";var disabled="[DDîîîšåååbļéééď]";var download="[DDöööwกี้ļöööåååď]";var downloadApp="[DDöööwกี้ļöööåååď ṫḥééé åååþþ!]";var downloadBrochure="[DDöööwกี้ļöööåååď bŕöööçḥūūūŕééé]";var downloadResearch="[DDöööwกี้ļöööåååď ŕéééšéééåååŕçḥ]";var dragDropFiles="[DDŕöööþ ḟîîîļéééš öööŕ çļîîîçḱ ḥéééŕééé ṫööö ūūūþļöööåååď]";var duration="[DDūūūŕåååṫîîîöööกี้]";var edit="[EEEEďîîîṫ]";var editChargeCard="[EEEEďîîîṫ çḥåååŕǧééé çåååŕď]";var emailCheck="[WWééé'vééé šéééกี้ṫ Ýöööūūū åååกี้ ééé-måååîîîļ ṫḥåååṫ Ýöööūūū çåååกี้ ūūūšééé ṫööö çööömþļéééṫééé Ýöööūūūŕ ŕéééǧîîîšṫŕåååṫîîîöööกี้]";var emailNotRecieved="[NNööö ééémåååîîîļ ŕéééçéééîîîvéééď?]";var emailSend="[EEEE-måååîîîļ ḥåååš bééééééกี้ šéééกี้ṫ]";var emailSentIfExist="[IIIIḟ åååกี้ åååççöööūūūกี้ṫ wîîîṫḥ ṫḥåååṫ ééé-måååîîîļ éééxîîîšṫš, åååกี้ ééémåååîîîļ ḥåååš bééééééกี้ šéééกี้ṫ ṫööö îîîṫ]";var employee="[EEEEmþļöööÝéééééé]";var enabled="[EEEEกี้åååbļéééď]";var enterNewPassword="[EEEEกี้ṫéééŕ Ýöööūūūŕ กี้éééw þåååššwöööŕď]";var entrance="[EEEEกี้ṫŕåååกี้çééé]";var errors={"email-empty":"[EEEE-måååîîîļ îîîš ååå ŕéééqūūūîîîŕéééď ḟîîîéééļď]","email-invalid":"[PPļéééåååšééé éééกี้ṫéééŕ ååå våååļîîîď ééé-måååîîîļ åååďďŕéééšš]",emailMismatch:"[EEEE-måååîîîļ ďöööéééšกี้'ṫ måååṫçḥ]",fieldRequired:"[TTḥîîîš ḟîîîéééļď îîîš ŕéééqūūūîîîŕéééď]","firstname-empty":"[FFîîîŕšṫกี้åååmééé îîîš ååå ŕéééqūūūîîîŕéééď ḟîîîéééļď]",invalidChargepointNumber:"[IIIIกี้våååļîîîď çḥåååŕǧîîîกี้ǧ þöööîîîกี้ṫ กี้ūūūmbéééŕ]","lastname-empty":"[LLåååšṫกี้åååmééé îîîš ååå ŕéééqūūūîîîŕéééď ḟîîîéééļď]",noConnectionBackend:"[WWééé åååŕééé ūūūกี้åååbļééé ṫööö çöööกี้กี้éééçṫ ṫööö öööūūūŕ šéééŕvéééŕš, þļéééåååšééé ṫŕÝ åååǧåååîîîกี้ ļåååṫéééŕ]",noConsent:"[PPļéééåååšééé çöööกี้šéééกี้ṫ ṫööö öööūūūŕ TOOOS åååกี้ď PŕîîîvåååçÝ þöööļîîîçÝ]","password-empty":"[PPåååššwöööŕď îîîš ååå ŕéééqūūūîîîŕéééď ḟîîîéééļď]","passwords-match":"[PPåååššwöööŕďš mūūūšṫ måååṫçḥ]","phone-empty":"[PPḥöööกี้ééé กี้ūūūmbéééŕ îîîš ååå ŕéééqūūūîîîŕéééď ḟîîîéééļď]","phone-invalid":"[PPļéééåååšééé éééกี้ṫéééŕ ååå våååļîîîď þḥöööกี้ééé กี้ūūūmbéééŕ]",somethingWrong:"[SSöööméééṫḥîîîกี้ǧ wéééกี้ṫ wŕöööกี้ǧ]"};var example="[EEEExåååmþļééé]";var excl="[EEEExçļ.]";var exclusive="[EEEExçļūūūďîîîกี้ǧ]";var faq="[FFŕéééqūūūéééกี้ṫļÝ åååšḱéééď qūūūéééšṫîîîöööกี้š]";var features="[FFéééåååṫūūūŕéééš]";var feedback="[FFééééééďbåååçḱ]";var fileUploaded="[FFîîîļééé ūūūþļöööåååďéééď]";var filter="[FFîîîļṫéééŕ]";var followOurAdventure="[FFöööļļöööw öööūūūŕ åååďvéééกี้ṫūūūŕééé]";var free="[FFŕéééééé]";var from="[FFŕöööm]";var garage="[GGåååŕåååǧééé]";var getOnPlayStore="[GGéééṫ îîîṫ öööกี้ Gööööööǧļééé PļåååÝ]";var gotIt="[GGöööṫ îîîṫ]";var grids="[GGŕîîîďš]";var group={allGroups:"[AAAAļļ ǧŕöööūūūþš]",create:"[CCŕéééåååṫééé ǧŕöööūūūþ]",deleteConfirmDialog:"[AAAAŕééé Ýöööūūū šūūūŕééé Ýöööūūū wåååกี้ṫ ṫööö ďéééļéééṫééé ṫḥîîîš ǧŕöööūūūþ? Tḥîîîš åååçṫîîîöööกี้ îîîš îîîŕŕééévéééŕšîîîbļééé]",edit:"[EEEEďîîîṫ ǧŕöööūūūþ]",editGroups:"[EEEEďîîîṫ ǧŕöööūūūþš]",group:"[GGŕöööūūūþ]",groups:"[GGŕöööūūūþš]",none:"[YYöööūūū ḥåååvéééกี้'ṫ çŕéééåååṫéééď ååå ǧŕöööūūūþ Ýéééṫ, Ýöööūūū wîîîļļ šéééééé Ýöööūūūŕ çŕéééåååṫéééď ǧŕöööūūūþš ḥéééŕééé.]",update:"[UUUUþďåååṫééé]"};var help="[HHéééļþ]";var home="[HHööömééé]";var houseNumber$4="[HHöööūūūšééé กี้ūūūmbéééŕ]";var houseNumberAdditions="[AAAAþṫ. Sūūūîîîṫééé éééṫç. ]";var inCollaborationWith="[IIIIกี้ çöööļļåååböööŕåååṫîîîöööกี้ wîîîṫḥ]";var incl="[IIIIกี้çļ.]";var inclusive="[IIIIกี้çļūūūďîîîกี้ǧ]";var information="[IIIIกี้ḟöööŕmåååṫîîîöööกี้]";var insightIntoTransactions="[IIIIกี้šîîîǧḥṫ îîîกี้ṫööö Ýöööūūūŕ çḥåååŕǧééé šéééššîîîöööกี้š]";var insights="[IIIIกี้šîîîǧḥṫš]";var instanceConnectionClosed="[TTḥééé çöööกี้กี้éééçṫîîîöööกี้ wîîîṫḥ Ýöööūūūŕ îîîกี้šṫåååกี้çééé ḥåååš bééééééกี้ çļöööšéééď]";var invalidChargeCard="[IIIIกี้våååļîîîď çåååŕď: Cḥåååŕǧîîîกี้ǧ šéééššîîîöööกี้š wîîîṫḥ ṫḥîîîš çåååŕď çåååกี้กี้öööṫ bééé bîîîļļéééď vîîîååå ṫḥééé çåååŕď þŕööövîîîďéééŕ. Yöööūūū çåååกี้ ūūūšééé ṫḥééé çåååŕď åååš ååå 'ḱéééÝ' ṫḥåååṫ ṫööö šṫåååŕṫ åååกี้ď šṫöööþ çḥåååŕǧîîîกี้ǧ šéééššîîîöööกี้š.]";var lastSave="[LLåååšṫ šåååvééé]";var lastUpdate="[LLåååšṫ ūūūþďåååṫééé]";var learnMore="[LLéééåååŕกี้ möööŕééé]";var leaveItToMe="[LLéééåååvééé îîîṫ ṫööö mééé!]";var letsCheckWithAdviceGuru="[LLéééṫ'š çḥéééçḱ wîîîṫḥ åååďvîîîçééé-Gūūūŕūūū {{กี้åååmééé}}]";var linkChargeCards="[LLîîîกี้ḱ çḥåååŕǧééé çåååŕď]";var linkChargePoints="[LLîîîกี้ḱ çḥåååŕǧééé þöööîîîกี้ṫš]";var linkedChargeCards="[LLîîîกี้ḱéééď çḥåååŕǧééé çåååŕďš]";var linkedChargePoints="[LLîîîกี้ḱéééď çḥåååŕǧééé þöööîîîกี้ṫš]";var linkedThirdPartyChargeCards="[TTḥîîîŕď þåååŕṫÝ çåååŕďš]";var list="[LLîîîšṫ]";var location="[LLöööçåååṫîîîöööกี้]";var lock="[LLöööçḱ]";var map$1="[MMåååþ]";var mobileApp={app:"[AAAAþþ]",description:"[WWééé måååḱééé éééļéééçṫŕîîîç ďŕîîîvîîîกี้ǧ ééévéééกี้ éééåååšîîîéééŕ. Wîîîṫḥ öööūūūŕ åååþþ, Ýöööūūū çåååกี้ ṫåååḱééé çḥåååŕǧééé öööḟ Ýöööūūūŕ çḥåååŕǧééé þöööîîîกี้ṫ îîîกี้ กี้ööö ṫîîîmééé åååṫ åååļļ. ]",feature_adjustSettings:"[AAAAďĵūūūšṫ çḥåååŕǧééé þöööîîîกี้ṫ šéééṫṫîîîกี้ǧš]",feature_checkBuildingEnergy:"[IIIIกี้šîîîǧḥṫ îîîกี้ṫööö ṫḥééé þöööwéééŕ çöööกี้šūūūmþṫîîîöööกี้ öööḟ ṫḥééé būūūîîîļďîîîกี้ǧ]",feature_howMuchYouAreCharging:"[SSéééééé ḥöööw mūūūçḥ Ýöööūūū åååŕééé çḥåååŕǧîîîกี้ǧ]"};var model="[MMöööďéééļ]";var moreInformation="[MMöööŕééé îîîกี้ḟöööŕmåååṫîîîöööกี้ åååböööūūūṫ]";var moreInformationContactUs="[WWöööūūūļď Ýöööūūū ļîîîḱééé möööŕééé îîîกี้ḟöööŕmåååṫîîîöööกี้? Cöööกี้ṫåååçṫ ūūūš!]";var my="[MMÝ]";var myChargeCards="[MMÝ çḥåååŕǧééé çåååŕďš]";var myDashboard="[MMÝ ďåååšḥböööåååŕď]";var name$3="[NNåååmééé]";var newGeneration="[NNéééw ǧéééกี้éééŕåååṫîîîöööกี้]";var news="[NNéééwš]";var next="[NNéééxṫ]";var no="[NNööö]";var noChargeCard="[WWîîîṫḥöööūūūṫ çḥåååŕǧééé çåååŕď]";var noChargeCardsFound="[NNööö çḥåååŕǧééé çåååŕďš ḟöööūūūกี้ď]";var noChargeCardsFoundInSelection="[NNööö çḥåååŕǧéééçåååŕďš öööŕ ṫŕåååกี้šåååçṫîîîöööกี้š ḥåååvééé bééééééกี้ ḟöööūūūกี้ď wîîîṫḥîîîกี้ Ýöööūūūŕ šéééļéééçṫîîîöööกี้.]";var noChargePointsFound="[NNööö çḥåååŕǧééé þöööîîîกี้ṫš ḟöööūūūกี้ď]";var noPlugChargeChargeCard="[PPļūūūǧ & çḥåååŕǧééé wîîîṫḥöööūūūṫ çḥåååŕǧééé çåååŕď]";var noUpcomingEvent="[NNööö ūūūþçööömîîîกี้ǧ ééévéééกี้ṫ]";var notAFan="Not a fan of my.bluecurrent.nl?\n<br />\n<u>Return to the old platform</u>";var notifications="[NNöööṫîîîḟîîîçåååṫîîîöööกี้š]";var ok="[OOOOḱ]";var openOnMobile="[OOOOþéééกี้ öööกี้ möööbîîîļééé]";var optional="[OOOOþṫîîîöööกี้åååļ]";var or="[OOOOŕ]";var other="[OOOOṫḥéééŕ]";var ourOtherSolutions="[OOOOūūūŕ öööṫḥéééŕ šöööļūūūṫîîîöööกี้š]";var pages="[PPåååǧéééš]";var parking="[PPåååŕḱîîîกี้ǧ]";var passwordUpdated="[YYöööūūūŕ þåååššwöööŕď ḥåååš bééééééกี้ ūūūþďåååṫéééď šūūūççéééšḟūūūļļÝ.]";var pay="[PPåååÝ]";var payAttention="[PPåååÝ åååṫṫéééกี้ṫîîîöööกี้]";var paymentMethod="[PPåååÝméééกี้ṫ méééṫḥöööď]";var perKilowattHour="[þþéééŕ ḱWḥ]";var place="[CCîîîṫÝ]";var plugInCar="[PPļūūūǧ îîîกี้ Ýöööūūūŕ çåååŕ ṫööö çöööกี้ṫîîîกี้ūūūééé]";var pppsstIamHere="[PPþþššṫ III'm ḥéééŕééé!]";var previous="[PPŕééévîîîöööūūūš]";var products="[PPŕöööďūūūçṫš]";var pursue="[CCöööกี้ṫîîîกี้ūūūééé]";var qrPayment="[QQR-þåååÝméééกี้ṫ]";var question={whatIsThe:"[WWḥåååṫ îîîš ṫḥééé]",whatIsYour:"[WWḥåååṫ îîîš Ýöööūūūŕ]"};var queue="[QQūūūéééūūūééé]";var quickAccess="[QQūūūîîîçḱ åååççéééšš]";var readMore="[RRéééåååď möööŕééé]";var reference="[RRéééḟéééŕéééกี้çééé]";var removeFilters="[CCļéééåååŕ ḟîîîļṫéééŕš]";var removeSelection="[RRééémööövééé šéééļéééçṫîîîöööกี้]";var reportABug="[RRéééþöööŕṫ ååå būūūǧ]";var requestChargeCard="[RRéééqūūūéééšṫ çḥåååŕǧééé çåååŕď]";var requestChargePoint="[RRéééqūūūéééšṫ çḥåååŕǧééé þöööîîîกี้ṫ]";var requestChargePointBusiness="[RRéééqūūūéééšṫ çḥåååŕǧééé þöööîîîกี้ṫš ḟöööŕ būūūšîîîกี้éééššéééš]";var requestChargePointForAtHome="[RRéééqūūūéééšṫ çḥåååŕǧééé þöööîîîกี้ṫ ḟöööŕ åååṫ ḥööömééé ]";var requestFreeChargePoint="[RRéééqūūūéééšṫ (Fŕéééééé) éééxþļöööîîîṫåååṫîîîöööกี้ çḥåååŕǧééé þöööîîîกี้ṫ]";var requiredAmountFieldsEmpty="<b>{{amount}}</b> more fields to fill in";var requiredFieldEmpty="<b>1</b> more field to fill in";var research="[RRéééšéééåååŕçḥ]";var reserve="[RRéééšéééŕvééé]";var reserved="[RRéééšéééŕvéééď]";var resident="[RRéééšîîîďéééกี้ṫ]";var save="[SSåååvééé]";var saved="[SSåååvéééď]";var saving="[SSåååvîîîกี้ǧ]";var scanWithPhoneQrApp="[SSçåååกี้ wîîîṫḥ Ýöööūūūŕ þḥöööกี้ééé çåååméééŕååå öööŕ QR åååþþ ṫööö çöööกี้ṫîîîกี้ūūūééé]";var scheduleMeeting="[SSçḥéééďūūūļééé mééééééṫîîîกี้ǧ]";var screenshots="[SSçŕééééééกี้šḥöööṫš]";var search="[SSéééåååŕçḥ]";var seeYourChargePoints="[SSéééééé Ýöööūūūŕ çḥåååŕǧééé þöööîîîกี้ṫš]";var selectAll="[SSéééļéééçṫ åååļļ]";var selectDefaultChargeCard="[SSéééļéééçṫ ďéééḟåååūūūļṫ çḥåååŕǧééé çåååŕď]";var selectPlugAndChargeCard="[SSéééļéééçṫ þļūūūǧ & çḥåååŕǧééé çåååŕď]";var selectProfile="[SSéééļéééçṫ ååå þŕöööḟîîîļééé]";var selected="[SSéééļéééçṫéééď]";var selectedChargecard="[SSéééļéééçṫéééď çḥåååŕǧééé çåååŕď]";var send="[SSéééกี้ď]";var sendAgain="[SSéééกี้ď åååǧåååîîîกี้]";var serialNumber="[SSéééŕîîîåååļ กี้ūūūmbéééŕ]";var services="[SSéééŕvîîîçéééš]";var setUp="[SSéééṫ ūūūþ]";var shortcuts="[SSḥöööŕṫçūūūṫš]";var showMore="[SSḥöööw möööŕééé]";var showOnGoogleMaps="[SSḥöööw öööกี้ Gööööööǧļééé Måååþš]";var showingAmountChargePoint="[SSḥöööwîîîกี้ǧ {{åååmöööūūūกี้ṫ}} öööūūūṫ öööḟ {{ṫöööṫåååļ}} çḥåååŕǧééé þöööîîîกี้ṫš]";var selectedAmountChargePoint="[SSéééļéééçṫéééď {{åååmöööūūūกี้ṫ}} öööūūūṫ öööḟ {{ṫöööṫåååļ}} çḥåååŕǧééé þöööîîîกี้ṫš]";var signUp="[SSîîîǧกี้ ūūūþ]";var signatureAgreement="[SSîîîǧกี้åååṫūūūŕééé åååǧŕééééééméééกี้ṫ]";var skip="[SSḱîîîþ]";var skipTour="[SSḱîîîþ ṫöööūūūŕ]";var spambox="[DDîîîďกี้'ṫ ḟîîîกี้ď ṫḥééé ééé-måååîîîļ? Cḥéééçḱ Ýöööūūūŕ šþåååm.]";var startKwh="[SSṫåååŕṫ ḱWḥ]";var startTour="[SSṫåååŕṫ ṫöööūūūŕ]";var street="[SSṫŕééééééṫ]";var support="[SSūūūþþöööŕṫ]";var switchEmail="[SSwîîîṫçḥ ééémåååîîîļ åååďďŕéééšš]";var symbol="[SSÝmböööļ]";var symbols="[SSÝmböööļš]";var tel$4="[TTéééļ]";var test="[TTéééšṫ]";var thisIsExample="<b>NB</b> This is an example!";var tip="[HHîîîกี้ṫ]";var to="[TTööö]";var totalCO2Emission="CO<sub>2</sub> emissions saved";var totalCost="[TTöööṫåååļ çöööšṫ]";var totalEnergyUsage="[TTöööṫåååļ éééกี้éééŕǧÝ ūūūšåååǧééé]";var totalTrees="[TTŕééééééš þļåååกี้ṫéééď]";var tour={step1:"Here you'll find the current status of your charge point.\n<br />\nTip: Click on the three dots to switch to other charge points.",step2:"[HHéééŕééé Ýöööūūū'ļļ šéééééé ṫḥééé ḟîîîŕšṫ ūūūþçööömîîîกี้ǧ ééévéééกี้ṫš. Föööŕ éééxåååmþļééé, ŕéééîîîmbūūūŕšéééméééกี้ṫš.]",step3:"[HHéééŕééé Ýöööūūū'ļļ ḟîîîกี้ď Ýöööūūūŕ çḥåååŕǧééé þöööîîîกี้ṫš. Yöööūūū çåååกี้ çļîîîçḱ öööกี้ ååå çḥåååŕǧééé þöööîîîกี้ṫ ṫööö öööþéééกี้ ṫḥééé çḥåååŕǧééé þöööîîîกี้ṫ šéééṫṫîîîกี้ǧš.]",step4:"[HHéééŕééé Ýöööūūū çåååกี้ çḥåååกี้ǧééé ṫḥééé šéééṫṫîîîกี้ǧš öööḟ Ýöööūūūŕ çḥåååŕǧééé þöööîîîกี้ṫ, îîîกี้çļūūūďîîîกี้ǧ çḥåååกี้ǧîîîกี้ǧ ṫḥééé ṫåååŕîîîḟḟ, ŕééébööööööṫîîîกี้ǧ/ŕéééšéééṫṫîîîกี้ǧ Ýöööūūūŕ çḥåååŕǧééé þöööîîîกี้ṫ, åååกี้ď möööŕééé.]",step5:"[YYöööūūū çåååกี้ çļîîîçḱ öööกี้ ååå çḥåååŕǧééé çåååŕď ṫööö çḥåååกี้ǧééé Ýöööūūūŕ çḥåååŕǧééé çåååŕď กี้åååmééé öööŕ ŕééémööövééé ṫḥééé çḥåååŕǧééé çåååŕď éééกี้ṫîîîŕéééļÝ.]",step6:"[WWḥéééกี้ Ýöööūūū çļîîîçḱ öööกี้ ååå çḥåååŕǧééé šéééššîîîöööกี้, Ýöööūūū'ļļ ḟîîîกี้ď šööömééé åååďďîîîṫîîîöööกี้åååļ îîîกี้ḟöööŕmåååṫîîîöööกี้ åååböööūūūṫ ṫḥåååṫ çḥåååŕǧééé šéééššîîîöööกี้.]",step7:"[UUUUšééé ṫḥéééšééé ḟîîîļṫéééŕš ṫööö ḟîîîļṫéééŕ ṫḥééé çḥåååŕǧééé šéééššîîîöööกี้š ļîîîšṫ. AAAḟṫéééŕ šéééṫṫîîîกี้ǧ ṫḥééé ḟîîîļṫéééŕš Ýöööūūū çåååกี้ ďöööwกี้ļöööåååď åååกี้ EEExçéééļ ḟîîîļééé, öööŕ çļîîîçḱ 'Déééçļåååŕåååṫîîîöööกี้ OOOvéééŕvîîîéééw' ṫööö ďöööwกี้ļöööåååď ååå ďéééçļåååŕåååṫîîîöööกี้ ööövéééŕvîîîéééw.]"};var transaction="[TTŕåååกี้šåååçṫîîîöööกี้]";var transactions="[CCḥåååŕǧééé šéééššîîîöööกี้š]";var unblock="[UUUUกี้bļöööçḱ]";var units$6={kilogram:"[KKîîîļöööǧŕåååm]",kiloton:"[KKîîîļöööṫöööกี้]",megaton:"[MMéééǧåååṫöööกี้]",ton:"[TTöööกี้]",kilogramRounded:"[ḱḱǧ]",kilotonRounded:"[ḱḱṫ]",megatonRounded:"[MMṫ]",tonRounded:"[ṫṫ]"};var unlock="[UUUUกี้ļöööçḱ]";var upload={columnLabel:"[IIIIกี้ wḥåååṫ çöööļūūūmกี้ åååŕééé ṫḥééé {{ṫÝþééé}}š?]",column:"[{{{ṫÝþééé}} çöööļūūūmกี้]",complete:"[UUUUþļöööåååď çööömþļéééṫééé]",excludeLabel:"[DDööö Ýöööūūū wåååกี้ṫ ṫööö éééxçļūūūďééé ṫḥééé çḥåååŕǧéééçåååŕďš ḟŕöööm þåååÝméééกี้ṫ?]",failed:"[ḟḟåååîîîļéééď]",fileLimit:"[OOOOกี้ļÝ 1 ḟîîîļééé çåååกี้ bééé ūūūþļöööåååďéééď åååṫ öööกี้çééé]",fileTooLarge:"[FFîîîļééé îîîš ṫöööööö ļåååŕǧééé]",headersLabel:"[DDöööéééš ṫḥééé ḟîîîļééé çöööกี้ṫåååîîîกี้ ḥéééåååďéééŕš?]",headers:"[CCöööกี้ṫåååîîîกี้š ḥéééåååďéééŕš]",information:"[TTööö ŕéééåååď ṫḥééé ḟîîîļééé çöööŕŕéééçṫļÝ, Ýöööūūū'ļļ กี้ééééééď ṫööö þŕööövîîîďééé möööŕééé îîîกี้ḟöööŕmåååṫîîîöööกี้ åååböööūūūṫ ḥöööw ṫḥééé ḟîîîļééé îîîš šṫŕūūūçṫūūūŕéééď.]",successful:"[ššūūūççéééššḟūūūļ]",total:"[TTöööṫåååļ]",upload:"[UUUUþļöööåååď]",uploading:"[UUUUþļöööåååďîîîกี้ǧ ḟîîîļééé]",unsupportedFile:"[UUUUกี้šūūūþþöööŕṫéééď ḟîîîļééé ṫÝþééé]"};var usefullLinks="[UUUUšéééḟūūūļļ ļîîîกี้ḱš]";var viewAll="[VVîîîéééw åååļļ]";var viewLess="[VVîîîéééw ļééé]";var viewTheEntire="[VVîîîéééw ṫḥééé éééกี้ṫîîîŕééé]";var watchVideo="[WWåååṫçḥ vîîîďéééööö]";var welcome="[WWéééļçööömééé {{กี้åååmééé}}]";var welcomeBack="[WWéééļçööömééé båååçḱ!]";var whoops="[WWḥööööööþš!]";var workAt="[WWöööŕḱ åååṫ]";var yes="[YYéééš]";var youCanDoThisOnline="[YYöööūūū çåååกี้ qūūūîîîçḱļÝ åååŕŕåååǧééé ṫḥééé Ýöööūūūŕšéééļḟ öööกี้ļîîîกี้ééé!]";var your="[YYöööūūūŕ]";var youreStillHere="[AAAAwéééšööömééé! Yöööūūū'ŕééé šṫîîîļļ ḥéééŕééé]";var zipCode$4="[ZZîîîþ çöööďééé]";var sent="[SSūūūbmîîîṫṫéééď]";var returnToForm="[RRéééṫūūūŕกี้ ṫööö ḟöööŕm]";var backTo="[BBåååçḱ ṫööö {{ūūūŕļ}}]";var select="[SSéééļéééçṫ]";var seeAll="[SSéééééé åååļļ]";var keyboardShortcuts="[KKéééÝböööåååŕď šḥöööŕṫçūūūṫš]";var navigation="[NNåååvîîîǧåååṫîîîöööกี้]";var control="[CCöööกี้ṫŕöööļ]";var previousQuestion="[PPŕééévîîîöööūūūš qūūūéééšṫîîîöööกี้]";var nextQuestion="[NNéééxṫ qūūūéééšṫîîîöööกี้]";var forExample="[FFöööŕ éééxåååmþļééé]";var notProvided="[NNöööṫ þŕööövîîîďéééď]";var everythingInANutshell="[EEEEvéééŕÝṫḥîîîกี้ǧ îîîกี้ ååå กี้ūūūṫšḥéééļļ]";var savingFailed="[SSåååvîîîกี้ǧ ḟåååîîîļéééď]";var sendingFailed="[SSéééกี้ďîîîกี้ǧ ḟåååîîîļéééď]";var searchingAddress="[SSéééåååŕçḥîîîกี้ǧ åååďďŕéééšš]";var couldntAutocompleteAddress="[WWééé çöööūūūļďกี้'ṫ åååūūūṫööömåååṫîîîçåååļļÝ ḟîîîļļ îîîกี้ Ýöööūūūŕ åååďďŕéééšš. Cåååกี้ Ýöööūūū ḥéééļþ ūūūš öööūūūṫ?]";var itsTakingLongerThanExpected="[IIIIṫ'š ṫåååḱîîîกี้ǧ ååå bîîîṫ ļöööกี้ǧéééŕ ṫḥåååกี้ éééxþéééçṫéééď, būūūṫ wééé åååŕééé šṫîîîļļ þŕöööçéééššîîîกี้ǧ.]";var makeSureToSaveProgress="[MMåååḱééé šūūūŕééé ṫööö šåååvééé Ýöööūūūŕ þŕöööǧŕéééšš béééḟöööŕééé ļéééåååvîîîกี้ǧ]";var noAgreementFound="[NNööö åååǧŕééééééméééกี้ṫ ḟöööūūūกี้ď]";var overview="[OOOOvéééŕvîîîéééw]";var tryAgainLaterOrContactUs="An error occurred. Please try again later or <a href=\"https://www.bluecurrent.nl/contact\" target=\"_blank\" rel=\"noreferrer\">contact us</a> if the error persists";var settingLanguage="[SSéééṫṫîîîกี้ǧ ļåååกี้ǧūūūåååǧééé]";var noPhotosProvided="[NNööö þḥöööṫööö(š) þŕööövîîîďéééď]";var reset="[RRéééšéééṫ]";var noteNotAllMandatoryQuestionsHaveBeenFilledIn="[NNöööṫééé ṫḥåååṫ กี้öööṫ åååļļ qūūūéééšṫîîîöööกี้š ḥåååvééé bééééééกี้ ḟîîîļļéééď îîîกี้; éééกี้šūūūŕééé åååļļ ŕéééqūūūîîîŕéééď qūūūéééšṫîîîöööกี้š åååŕééé çööömþļéééṫéééď béééḟöööŕééé šūūūbmîîîṫṫîîîกี้ǧ.]";var required="[RRéééqūūūîîîŕéééď]";var maxKwh="[MMåååx ḱWḥ]";var wellDone="[WWéééļļ ďöööกี้ééé!]";var endOfFirstFlow="Thank you very much for taking the time to answer our questions. We now have enough information to prepare (for the installation of) your charge point.\n<br /><br />\nYou'll receive an email with a status update within several business days. If a quotation must be approved by a third party (i.e. your employer, fuel card provider or leasing company), this process may take up to 10 business days. We'll contact you as soon as possible if we have further questions.\n<br /><br />\nIs this your first electric vehicle? Consider boomarking these URLs:<br/>\n- Drive Green has a <a href=\"https://www.youtube.com/watch?v=XDrcdABiDU4\" target=\"_blank\">YouTube video</a> that explains the basics of EV charging. Although the video was intended for the UK market, it translates very well to continental Europe.<br/>\n- <a href=\"https://help.bluecurrent.nl/knowledge\" target=\"_blank\">Our FAQ</a> contains useful information about our services. ";var invoices="[IIIIกี้vöööîîîçéééš]";var status$6="[SSṫåååṫūūūš]";var exit="[EEEExîîîṫ]";var forAtHome="[FFöööŕ AAAṫ Hööömééé]";var forBusiness="[FFöööŕ Būūūšîîîกี้éééšš]";var quotation="[QQūūūöööṫåååṫîîîöööกี้]";var getQuote="[GGéééṫ ååå qūūūöööṫééé]";var registerToCharge="[RRéééǧîîîšṫéééŕ ṫööö šṫåååŕṫ çḥåååŕǧîîîกี้ǧ]";var reimbursementInformation="[RRéééîîîmbūūūŕšéééméééกี้ṫ îîîกี้ḟöööŕmåååṫîîîöööกี้]";var repeatEach="[RRéééþéééåååṫ éééåååçḥ]";var energy="[EEEEกี้éééŕǧÝ]";var calculateYourSavings="[CCåååļçūūūļåååṫééé Yöööūūūŕ Såååvîîîกี้ǧš]";var now$1="[NNöööw]";var positive="[PPöööšîîîṫîîîvééé]";var negative="[NNéééǧåååṫîîîvééé]";var electricity="[EEEEļéééçṫŕîîîçîîîṫÝ]";var gas="[GGåååš]";var allInPrice="[AAAAļļ-îîîกี้ Pŕîîîçééé]";var marketPrice="[MMåååŕḱéééṫ Pŕîîîçééé]";var marketPriceInclVat="[MMåååŕḱéééṫ þŕîîîçééé îîîกี้çļ.VAAAT]";var marketPriceInclPurchaseFeeEnergyTaxVat="[MMåååŕḱéééṫ þŕîîîçééé îîîกี้çļ. þūūūŕçḥåååšééé ḟéééééé, éééกี้éééŕǧÝ ṫåååx & VAAAT]";var UiPSEUDO = {about:about,accessibility:accessibility,actions:actions$3,active:active,add:add$4,addChargeCard:addChargeCard,addChargePoint:addChargePoint,addSeeChangeYourChargeCard:addSeeChangeYourChargeCard,additionalInformation:additionalInformation,address:address,advanced:advanced,all:all,allChargeCards:allChargeCards,allChargePoints:allChargePoints,allContractInfoInOnePlace:allContractInfoInOnePlace,alwaysStartTourInSettings:alwaysStartTourInSettings,amount:amount,amountMore:amountMore,amountWaiting:amountWaiting,appDownload:appDownload,apply:apply,areYouSure:areYouSure,areYouSureFinish:areYouSureFinish,areYouSureStopSession:areYouSureStopSession,arrangeThisYourselfOnline:arrangeThisYourselfOnline,atHome:atHome,back:back,backToDateSelection:backToDateSelection,batchSettings:batchSettings,block:block,business:business,cable:cable,cancel:cancel,carNotConnected:carNotConnected,change:change,changeAccountInfoHere:changeAccountInfoHere,changeProfile:changeProfile,changeSchedule:changeSchedule,changeYourSettingsHere:changeYourSettingsHere,charge:charge,chargeCard:chargeCard,chargeCardNotOnThisList:chargeCardNotOnThisList,chargeCardNumber:chargeCardNumber,chargeCards:chargeCards,chargeEvenFaster:chargeEvenFaster,chargePoint:chargePoint,chargePointName:chargePointName,chargePointNumber:chargePointNumber,chargePoints:chargePoints,chargepointSettings:chargepointSettings,chargeSessionInformation:chargeSessionInformation,chargingSession:chargingSession,choose:choose,clear:clear,clickToReload:clickToReload,close:close,company:company,companyName:companyName,confirm:confirm,connected:connected,connectionClosed:connectionClosed,contact:contact,"continue":"[CCöööกี้ṫîîîกี้ūūūééé]",continueReading:continueReading,cookie:cookie,copied:copied,copy:copy$1,country:country$4,countryCode:countryCode,currency:currency,customerType:customerType,dashboard:dashboard,delayUntil:delayUntil,delayFrom:delayFrom,"delete":"[DDéééļéééṫééé]",deselectAll:deselectAll,disabled:disabled,download:download,downloadApp:downloadApp,downloadBrochure:downloadBrochure,downloadResearch:downloadResearch,dragDropFiles:dragDropFiles,duration:duration,edit:edit,editChargeCard:editChargeCard,emailCheck:emailCheck,emailNotRecieved:emailNotRecieved,emailSend:emailSend,emailSentIfExist:emailSentIfExist,employee:employee,enabled:enabled,enterNewPassword:enterNewPassword,entrance:entrance,errors:errors,example:example,excl:excl,exclusive:exclusive,faq:faq,features:features,feedback:feedback,fileUploaded:fileUploaded,filter:filter,followOurAdventure:followOurAdventure,free:free,from:from,garage:garage,getOnPlayStore:getOnPlayStore,gotIt:gotIt,grids:grids,group:group,help:help,home:home,houseNumber:houseNumber$4,houseNumberAdditions:houseNumberAdditions,inCollaborationWith:inCollaborationWith,incl:incl,inclusive:inclusive,information:information,insightIntoTransactions:insightIntoTransactions,insights:insights,instanceConnectionClosed:instanceConnectionClosed,invalidChargeCard:invalidChargeCard,lastSave:lastSave,lastUpdate:lastUpdate,learnMore:learnMore,leaveItToMe:leaveItToMe,letsCheckWithAdviceGuru:letsCheckWithAdviceGuru,linkChargeCards:linkChargeCards,linkChargePoints:linkChargePoints,linkedChargeCards:linkedChargeCards,linkedChargePoints:linkedChargePoints,linkedThirdPartyChargeCards:linkedThirdPartyChargeCards,list:list,location:location,lock:lock,map:map$1,mobileApp:mobileApp,model:model,moreInformation:moreInformation,moreInformationContactUs:moreInformationContactUs,my:my,myChargeCards:myChargeCards,myDashboard:myDashboard,name:name$3,newGeneration:newGeneration,news:news,next:next,no:no,noChargeCard:noChargeCard,noChargeCardsFound:noChargeCardsFound,noChargeCardsFoundInSelection:noChargeCardsFoundInSelection,noChargePointsFound:noChargePointsFound,noPlugChargeChargeCard:noPlugChargeChargeCard,noUpcomingEvent:noUpcomingEvent,notAFan:notAFan,notifications:notifications,ok:ok,openOnMobile:openOnMobile,optional:optional,or:or,other:other,ourOtherSolutions:ourOtherSolutions,pages:pages,parking:parking,passwordUpdated:passwordUpdated,pay:pay,payAttention:payAttention,paymentMethod:paymentMethod,perKilowattHour:perKilowattHour,place:place,plugInCar:plugInCar,pppsstIamHere:pppsstIamHere,previous:previous,products:products,pursue:pursue,qrPayment:qrPayment,question:question,queue:queue,quickAccess:quickAccess,readMore:readMore,reference:reference,removeFilters:removeFilters,removeSelection:removeSelection,reportABug:reportABug,requestChargeCard:requestChargeCard,requestChargePoint:requestChargePoint,requestChargePointBusiness:requestChargePointBusiness,requestChargePointForAtHome:requestChargePointForAtHome,requestFreeChargePoint:requestFreeChargePoint,requiredAmountFieldsEmpty:requiredAmountFieldsEmpty,requiredFieldEmpty:requiredFieldEmpty,research:research,reserve:reserve,reserved:reserved,resident:resident,save:save,saved:saved,saving:saving,scanWithPhoneQrApp:scanWithPhoneQrApp,scheduleMeeting:scheduleMeeting,screenshots:screenshots,search:search,seeYourChargePoints:seeYourChargePoints,selectAll:selectAll,selectDefaultChargeCard:selectDefaultChargeCard,selectPlugAndChargeCard:selectPlugAndChargeCard,selectProfile:selectProfile,selected:selected,selectedChargecard:selectedChargecard,send:send,sendAgain:sendAgain,serialNumber:serialNumber,services:services,setUp:setUp,shortcuts:shortcuts,showMore:showMore,showOnGoogleMaps:showOnGoogleMaps,showingAmountChargePoint:showingAmountChargePoint,selectedAmountChargePoint:selectedAmountChargePoint,signUp:signUp,signatureAgreement:signatureAgreement,skip:skip,skipTour:skipTour,spambox:spambox,startKwh:startKwh,startTour:startTour,street:street,support:support,switchEmail:switchEmail,symbol:symbol,symbols:symbols,tel:tel$4,test:test,thisIsExample:thisIsExample,tip:tip,to:to,totalCO2Emission:totalCO2Emission,totalCost:totalCost,totalEnergyUsage:totalEnergyUsage,totalTrees:totalTrees,tour:tour,transaction:transaction,transactions:transactions,unblock:unblock,units:units$6,unlock:unlock,upload:upload,usefullLinks:usefullLinks,viewAll:viewAll,viewLess:viewLess,viewTheEntire:viewTheEntire,watchVideo:watchVideo,welcome:welcome,welcomeBack:welcomeBack,whoops:whoops,workAt:workAt,yes:yes,youCanDoThisOnline:youCanDoThisOnline,your:your,youreStillHere:youreStillHere,zipCode:zipCode$4,sent:sent,returnToForm:returnToForm,backTo:backTo,select:select,seeAll:seeAll,keyboardShortcuts:keyboardShortcuts,navigation:navigation,control:control,previousQuestion:previousQuestion,nextQuestion:nextQuestion,forExample:forExample,notProvided:notProvided,everythingInANutshell:everythingInANutshell,savingFailed:savingFailed,sendingFailed:sendingFailed,searchingAddress:searchingAddress,couldntAutocompleteAddress:couldntAutocompleteAddress,itsTakingLongerThanExpected:itsTakingLongerThanExpected,makeSureToSaveProgress:makeSureToSaveProgress,noAgreementFound:noAgreementFound,overview:overview,tryAgainLaterOrContactUs:tryAgainLaterOrContactUs,settingLanguage:settingLanguage,noPhotosProvided:noPhotosProvided,reset:reset,noteNotAllMandatoryQuestionsHaveBeenFilledIn:noteNotAllMandatoryQuestionsHaveBeenFilledIn,required:required,maxKwh:maxKwh,wellDone:wellDone,endOfFirstFlow:endOfFirstFlow,invoices:invoices,status:status$6,exit:exit,forAtHome:forAtHome,forBusiness:forBusiness,quotation:quotation,getQuote:getQuote,registerToCharge:registerToCharge,reimbursementInformation:reimbursementInformation,repeatEach:repeatEach,energy:energy,calculateYourSavings:calculateYourSavings,now:now$1,positive:positive,negative:negative,electricity:electricity,gas:gas,allInPrice:allInPrice,marketPrice:marketPrice,marketPriceInclVat:marketPriceInclVat,marketPriceInclPurchaseFeeEnergyTaxVat:marketPriceInclPurchaseFeeEnergyTaxVat};

var clearDates$2="Verwijder datums";var date$5="Datum";var dateTime$2="Datum & tijd";var endDate$2="Einddatum";var endTime$2="Eindtijd";var month$2="Maand";var monthly$2="Maandelijks";var period$2="Periode";var quarter$2="Kwartaal";var quarterly$2="Per kwartaal";var startDate$2="Begindatum";var startTime$2="Starttijd";var time$2="Tijd";var today$2="Vandaag";var units$5={day:"Dag",hour:"Uur",min:"Min",minute:"Minuut",month:"Maand",second:"Seconde",week:"Week",year:"Jaar"};var weekdays$3={fri:"Vr",friday:"Vrijdag",mon:"Ma",monday:"Maandag",sat:"Za",saturday:"Zaterdag",sun:"Zo",sunday:"Zondag",thur:"Do",thursday:"Donderdag",tue:"Di",tuesday:"Dinsdag",wed:"Wo",wednesday:"Woensdag"};var weekly$2="Wekelijks";var year$2="Jaar";var yearly$2="Jaarlijks";var yesterday$2="Gisteren";var weekday$2="Weekdagen";var DatesNL = {clearDates:clearDates$2,date:date$5,dateTime:dateTime$2,endDate:endDate$2,endTime:endTime$2,month:month$2,monthly:monthly$2,period:period$2,quarter:quarter$2,quarterly:quarterly$2,startDate:startDate$2,startTime:startTime$2,time:time$2,today:today$2,units:units$5,weekdays:weekdays$3,weekly:weekly$2,year:year$2,yearly:yearly$2,yesterday:yesterday$2,weekday:weekday$2};

var clearDates$1="Clear dates";var date$4="Date";var dateTime$1="Date & time";var endDate$1="End date";var endTime$1="End time";var month$1="Month";var monthly$1="Monthly";var period$1="Period";var quarter$1="Quarter";var quarterly$1="Quarterly";var startDate$1="Start date";var startTime$1="Start time";var time$1="Time";var today$1="Today";var units$4={day:"Day",hour:"Hour",min:"Min",minute:"Minute",month:"Month",second:"Second",week:"Week",year:"Year"};var weekdays$2={fri:"Fri",friday:"Friday",mon:"Mon",monday:"Monday",sat:"Sat",saturday:"Saturday",sun:"Sun",sunday:"Sunday",thur:"Thu",thursday:"Thursday",tue:"Tue",tuesday:"Tuesday",wed:"Wed",wednesday:"Wednesday"};var weekly$1="Weekly";var year$1="Year";var yearly$1="Yearly";var yesterday$1="Yesterday";var weekday$1="Weekdays";var DatesEN = {clearDates:clearDates$1,date:date$4,dateTime:dateTime$1,endDate:endDate$1,endTime:endTime$1,month:month$1,monthly:monthly$1,period:period$1,quarter:quarter$1,quarterly:quarterly$1,startDate:startDate$1,startTime:startTime$1,time:time$1,today:today$1,units:units$4,weekdays:weekdays$2,weekly:weekly$1,year:year$1,yearly:yearly$1,yesterday:yesterday$1,weekday:weekday$1};

var DatesFR = {};

var clearDates="[CCļéééåååŕ ďåååṫéééš]";var date$3="[DDåååṫééé]";var dateTime="[DDåååṫééé & ṫîîîmééé]";var endDate="[EEEEกี้ď ďåååṫééé]";var endTime="[EEEEกี้ď ṫîîîmééé]";var month="[MMöööกี้ṫḥ]";var monthly="[MMöööกี้ṫḥļÝ]";var period="[PPéééŕîîîöööď]";var quarter="[QQūūūåååŕṫéééŕ]";var quarterly="[QQūūūåååŕṫéééŕļÝ]";var startDate="[SSṫåååŕṫ ďåååṫééé]";var startTime="[SSṫåååŕṫ ṫîîîmééé]";var time="[TTîîîmééé]";var today="[TTöööďåååÝ]";var units$3={day:"[DDåååÝ]",hour:"[HHöööūūūŕ]",min:"[MMîîîกี้]",minute:"[MMîîîกี้ūūūṫééé]",month:"[MMöööกี้ṫḥ]",second:"[SSéééçöööกี้ď]",week:"[WWééééééḱ]",year:"[YYéééåååŕ]"};var weekdays$1={fri:"[FFŕîîî]",friday:"[FFŕîîîďåååÝ]",mon:"[MMöööกี้]",monday:"[MMöööกี้ďåååÝ]",sat:"[SSåååṫ]",saturday:"[SSåååṫūūūŕďåååÝ]",sun:"[SSūūūกี้]",sunday:"[SSūūūกี้ďåååÝ]",thur:"[TTḥūūū]",thursday:"[TTḥūūūŕšďåååÝ]",tue:"[TTūūūééé]",tuesday:"[TTūūūéééšďåååÝ]",wed:"[WWéééď]",wednesday:"[WWéééďกี้éééšďåååÝ]"};var weekly="[WWééééééḱļÝ]";var year="[YYéééåååŕ]";var yearly="[YYéééåååŕļÝ]";var yesterday="[YYéééšṫéééŕďåååÝ]";var weekday="[WWééééééḱďåååÝš]";var DatesPSEUDO = {clearDates:clearDates,date:date$3,dateTime:dateTime,endDate:endDate,endTime:endTime,month:month,monthly:monthly,period:period,quarter:quarter,quarterly:quarterly,startDate:startDate,startTime:startTime,time:time,today:today,units:units$3,weekdays:weekdays$1,weekly:weekly,year:year,yearly:yearly,yesterday:yesterday,weekday:weekday};

var stateRegionProvince$3="Staat / Regio / Provincie";var postalCode$3="Postcode";var houseNumber$3="Huisnummer";var streetName$3="Straatnaam";var cityLocality$3="Stad / Plaats";var countryRegion$3="Land / Regio";var state$3="Staat";var zipCode$3="ZIP code";var city$3="Stad";var country$3="Land";var administrativeRegion$3="Administratieve regio";var stateRegionTerritory$3="Staat / Regio / Gebied";var addition$3="Toevoeging";var add$3="Toev.";var AddressNL = {stateRegionProvince:stateRegionProvince$3,postalCode:postalCode$3,houseNumber:houseNumber$3,streetName:streetName$3,cityLocality:cityLocality$3,countryRegion:countryRegion$3,state:state$3,zipCode:zipCode$3,city:city$3,country:country$3,administrativeRegion:administrativeRegion$3,stateRegionTerritory:stateRegionTerritory$3,addition:addition$3,add:add$3};

var stateRegionProvince$2="State / Region / Province";var postalCode$2="Postal code";var houseNumber$2="House number";var streetName$2="Street name";var cityLocality$2="City / Locality";var countryRegion$2="Country / Region";var state$2="State";var zipCode$2="ZIP code";var city$2="City";var country$2="Country";var administrativeRegion$2="Administrative Region";var stateRegionTerritory$2="State / Region / Territory";var addition$2="Addition";var add$2="Add.";var AddressEN = {stateRegionProvince:stateRegionProvince$2,postalCode:postalCode$2,houseNumber:houseNumber$2,streetName:streetName$2,cityLocality:cityLocality$2,countryRegion:countryRegion$2,state:state$2,zipCode:zipCode$2,city:city$2,country:country$2,administrativeRegion:administrativeRegion$2,stateRegionTerritory:stateRegionTerritory$2,addition:addition$2,add:add$2};

var stateRegionProvince$1="";var postalCode$1="";var houseNumber$1="";var streetName$1="";var cityLocality$1="";var countryRegion$1="";var state$1="";var zipCode$1="";var city$1="";var country$1="";var administrativeRegion$1="";var stateRegionTerritory$1="";var addition$1="";var add$1="";var AddressFR = {stateRegionProvince:stateRegionProvince$1,postalCode:postalCode$1,houseNumber:houseNumber$1,streetName:streetName$1,cityLocality:cityLocality$1,countryRegion:countryRegion$1,state:state$1,zipCode:zipCode$1,city:city$1,country:country$1,administrativeRegion:administrativeRegion$1,stateRegionTerritory:stateRegionTerritory$1,addition:addition$1,add:add$1};

var stateRegionProvince="[SSṫåååṫééé / Réééǧîîîöööกี้ / Pŕööövîîîกี้çééé]";var postalCode="[PPöööšṫåååļ çöööďééé]";var houseNumber="[HHöööūūūšééé กี้ūūūmbéééŕ]";var streetName="[SSṫŕééééééṫ กี้åååmééé]";var cityLocality="[CCîîîṫÝ / LöööçåååļîîîṫÝ]";var countryRegion="[CCöööūūūกี้ṫŕÝ / Réééǧîîîöööกี้]";var state="[SSṫåååṫééé]";var zipCode="[ZZIIIP çöööďééé]";var city="[CCîîîṫÝ]";var country="[CCöööūūūกี้ṫŕÝ]";var administrativeRegion="[AAAAďmîîîกี้îîîšṫŕåååṫîîîvééé Réééǧîîîöööกี้]";var stateRegionTerritory="[SSṫåååṫééé / Réééǧîîîöööกี้ / TéééŕŕîîîṫöööŕÝ]";var addition="[AAAAďďîîîṫîîîöööกี้]";var add="[AAAAďď.]";var AddressPSEUDO = {stateRegionProvince:stateRegionProvince,postalCode:postalCode,houseNumber:houseNumber,streetName:streetName,cityLocality:cityLocality,countryRegion:countryRegion,state:state,zipCode:zipCode,city:city,country:country,administrativeRegion:administrativeRegion,stateRegionTerritory:stateRegionTerritory,addition:addition,add:add};

var actions$2={availabilityChanged:"De beschikbaarheid van laadpunt {{id}} is aangepast",cableDetected:"Laadkabel aangesloten",carDetected:"Auto aangesloten",makeAvailable:"Maak beschikbaar",makeUnavailable:"Maak onbeschikbaar",offPeakChargingSuccess:"Schema succesvol opgeslagen",overrideTimeout:"Meteen laden",reboot:"Opnieuw opstarten",rebootWarning:"Dit start je laadpunt volledig opnieuw op, alleen gebruiken wanneer noodzakelijk",rebooted:"Laadpunt {{id}} is opnieuw opgestart",reset:"Reset",resetSuccess:"{{id}} is gereset",startSession:"Start sessie",stopSession:"Stop sessie",unlock:"Connector unlocken",unlocked:"De kabel van laadpunt {{id}} is losgekoppeld",boost:"Boost"};var activityStatus$3="Status";var bcuNumber$2="BCU nummer";var charged$2="Geladen";var chargingProfiles$3={delayedCharging:"Uitgesteld Laden",delayedChargingSet:"Uitgesteld Laden is ingesteld tot",name:"Slim Laden",priceBasedCharging:"Prijsgestuurd Laden",profiledCharging:"Slim laadprofiel gebruiken",profilesDisabledNoPermissionToChangeSetting:"Sommige profielen zijn uitgeschakeld vanwege onvoldoende rechten",solarBasedCharging:"Laden op basis van zon"};var error$6={availableFailed:"Kan de beschikbaarheid van laadpunt {{id}} niet veranderen",availableFailedStillCharging:"Kan niet de beschikbaarheid van laadpunt {{id}} veranderen. Laadsessie bezig.",error:"Je laadpunt is in error, of er is een tijdelijk communicatieprobleem",ledInteractionFailed:"Kan led interactie instelling niet aanpassen",nameFailed:"Kan laadpunt naam niet aanpassen",offline:"{{model}} is offline, of er is een tijdelijk communicatieprobleem",plugAndChargeFailed:"Kan plug & charge instelling niet aanpassen",plugAndChargeNotificationFailed:"Kan plug & charge notificatie instelling niet aanpassen",publicChargingFailed:"Kan publiek laden instelling niet aanpassen",rebootFailed:"Kan laadpunt {{id}} niet herstarten!",resetFailed:"Kon laadpunt {{id}} niet resetten!",smartChargingFailed:"Kan slim laden instelling niet aanpassen",somethingWrong:"Er is iets misgegaan!",startChargingFailed:"Kon de laadsessie niet starten op {{id}}!",stopChargingFailed:"Laadsessie op {{id}} is niet gestopt!",unavailable:"{{model}} is niet beschikbaar. Dit kan je aanpassen door je {{model}} op beschikbaar te zetten.",unlockFailed:"Kon kabel niet van laadpunt {{id}} loskoppelen!",vehicleError:"Je auto geeft een error, of er is een tijdelijk communicatieprobleem",vehicleNotFound:"Er is geen voertuig gekoppeld"};var info$2={publicChargingDisabled:"Bezoekers kunnen gebruik maken van jouw {{model}}. Vrijwel alle geldige laadpassen worden geaccepteerd. ",publicChargingEnabled:"Bezoekers kunnen geen gebruik maken van jouw {{model}}, alleen gekoppelde laadpassen worden toegestaan."};var name$2={hidden:"Hidden",hiddenNanocharge:"Hidden & NanoCharge",nanocharge:"NanoCharge",umove:"U:MOVE"};var offline$3={lastOnline:"Laatst online",maxOfflineCharging:"Max. offline laden"};var plugChargeEnabled$2="Plug & charge ingeschakeld";var settingDisabledDuringChargeSession$2="Deze instelling is uitgeschakeld terwijl een laadsessie bezig is";var settings$3={ledInteraction:"Leds alleen aan bij interactie",plugCharge:"Plug & charge",publicCharging:"Alleen gekoppelde laadpassen",publishLocation:"Publiceer locatie",smartCharging:"Slim laden",tariffHint:"Hoe stel ik mijn laadtarief juist in? <a href=\"https://help.bluecurrent.nl/nl/knowledge/hoe-wijzig-ik-het-laadtarief-van-mijn-laadpunt\" target=\"_blank\" style=\"color:#0098DB;text-decoration:underline\">Klik hier voor meer informatie.</a>",capacityTariff:"Capaciteitstarief"};var status$5={available:"Beschikbaar",charging:"Laden",delayed:"Ingepland",done:"Gereed",error:"Error",offline:"Offline",reserved:"Gereserveerd",unavailable:"Niet beschikbaar"};var units$2={ampere:"Ampère",kwh:"kWh",volt:"Volt",voltage:"Voltage"};var updates$3={resetFailed:"{{id}} kon niet resetten!",resetSuccess:"{{id}} is gereset!",resetting:"{{id}} resetten...",startCharging:"Laadsessie starten op {{id}}...",startChargingSuccess:"{{id}} is aan het laden!",stopCharging:"Laadsessie op {{id}} aan het stoppen...",stopChargingSuccess:"{{id}} is gestopt met laden!",startDelayedChargingSuccess:"Laadsessie van {{id}} is uitgesteld tot: {{time}}"};var warning$2={ledInteraction:"<b>Let op:</b> Standaard zie je aan de kleur van de led-verlichting ten allen tijde of jouw laadpunt beschikbaar, aan het laden of in error is. Zet je de instelling Led interaction aan, dan zet je deze verlichting uit. Alleen bij een verandering van de status gaat de led-verlichting nog 10 seconden aan, zodat je op dat moment nog kan zien of alles in orde is.",ledInteractionOff:"<b>Let op:</b> Aan de kleur van de led-verlichting kan je zien of jouw {{model}} beschikbaar, aan het laden of in error is.\n<br/><br/>\nZet je de instelling `Led's alleen aan bij interactie` uit, dan zet je deze verlichting aan.",plugAndCharge:"<b>Let op:</b> Iedereen met een geldige laadpas kan bij jouw {{model}} zijn auto opladen.\n<br />\n<br />\nSta je dit liever niet toe? Dan moet je de passen die wel gebruikt mogen worden opvoeren in <a href=\"{{url}}\" rel=\"noreferrer\">\"Laadpassen\"</a>.",plugAndChargeNotification:"<b>Let op:</b> Ontvang notificaties wanneer een auto is gekoppeld & en een laadsessie gestart is op je {{model}}",plugAndChargeNotificationOff:"<b>Let op:</b> Ontvang geen notificaties wanneer een auto is gekoppeld & en een laadsessie gestart is op je {{model}}",plugAndChargeOff:"<b>Let op:</b> Je schakelt plug & charge uit. Zonder plug & charge kun je een laadsessie starten vanuit de Blue Current app, of door een laadpas voor de lamp van je {{model}} te houden.",publicCharging:"<b>Let op:</b> Als je dit aanzet kan iedereen met een geldige laadpas bij jouw {{model}} zijn auto opladen.",publicChargingOff:"<b>Let op:</b> Bezoekers kunnen geen gebruik maken van jouw {{model}}, alleen gekoppelde laadpassen worden toegestaan.",publishLocation:"<b>Let op:</b> Maak zo de locatie van jouw laadpunt zichtbaar op apps en websites, zodat ook andere kunnen zien waar jouw laadpunt zich bevindt.\n<br />\n<br />\nDit gaat via het bedrijf eco-movement, dat bekend is van de website <a href=\"https://oplaadpalen.nl\">oplaadpalen.nl\n<br />\n<br />Let op. Eenmaal gepubliceerd is dit moeilijk terug te draaien.</a>.",publishLocationOff:"<b>Let op:</b> Iedereen met een geldige laadpas kan bij jouw {{model}} zijn auto opladen.\n<br />\n<br />\nSta je dit liever niet toe? Dan moet je de passen die wel gebruikt mogen worden opvoeren in <a href=\"{{url}}\" rel=\"noreferrer\">\"Laadpassen\"</a>.",tariff:"<b>Let op</b> Dit verandert het tarief op je laadpunt wanneer een nieuwe transactie binnenkomt. ",tariffPublishLocationOff:"Wanneer je je laadpunt op een gratis tarief zet, wordt Publiceer locatie automatisch uitgezet."};var priceBasedCharging$3={shortExplanation:"Dynamische energietarieven gebruiken om te laden als de stroom goedkoper is.",departureTime:"Verwachtte vertrektijd",sustainableCharging:"Duurzaam Laden",minMaxKwhError:"Minimaal 1 kWh en maximaal 80 kWh",longExplanation:"Op basis van de EPEX SPOT day-ahead markt en het gemiddeld verbruik in je huishouden proberen we zo veel mogelijk kWh te laden op de tijden dat de stroom het goedkoopst is. We kunnen je batterij aan het begin van je laadsessie vast een stukje opladen, zodat je bij nood nooit leeg staat.<br /><br />Vertel ons wanneer je verwacht te vertrekken, hoeveel kWh je een 'normale' laadsessie is en hoeveel kWh je wilt dat we aan het begin van je sessie laden.",expectedSizeOfChargingSession:"Verwachtte grootte van laadsessie",immediatelyCharge:"Begin laadsessie met"};var capacityTariff$3={minMaxError:"Maximale kWh moet tussen 0,01 kWh en 80 kWh zijn.",minMaxInfo:"0,01 kWh tot maximaal 80 kWh",successNotification:"Capaciteitstarief is ingesteld op max {{value}} kWh"};var roamingTariff$3={minMaxError:"Vergoeding moet tussen {{minValue}} / kWh en {{maxValue}} / kWh zijn",allAmountsAreExclVAT:"Alle bedragen zijn excl. BTW",reimbursementChanged:"Vergoeding veranderd naar {{value}} / kWh",description:"Stel hier je vergoeding per kWh in voor betaalde laadsessies.",chargedToChargingCardSupplier:"Doorbelast aan laadpasleverancier",allAmountsAreInclVAT:"Alle bedragen zijn incl. BTW"};var solarBasedCharging$3={description:"Lorem ipsum",minMaxKwhError:"Minimaal 1 kWh en maximaal 80 kWh",startTime:"Starttijd",endTime:"Eindtijd",minKwh:"Minimale kWh"};var delayedCharging$3={selectAtLeastOneDay:"Selecteer minimaal één dag",chargingSessionWillStartEndOnDifferentDays:"Je laadsessie begint en eindigt op verschillende dagen",shortExplanation:"Je laadsessie uitstellen om het piekmoment in je huishouden te vermijden.",longExplanation:"Je laadsessie uitstellen om een piekmoment in je huishouden te vermijden. Kies de dagen waarop je je laadsessie uit wilt stellen en geef een tijdsbestek op.",additionalInformation:"Als je de laadsessie tussen {{from}} en {{until}} start, dan beginnen we om {{until}} met laden."};var ChargePointNL = {actions:actions$2,activityStatus:activityStatus$3,bcuNumber:bcuNumber$2,charged:charged$2,chargingProfiles:chargingProfiles$3,error:error$6,info:info$2,name:name$2,offline:offline$3,plugChargeEnabled:plugChargeEnabled$2,settingDisabledDuringChargeSession:settingDisabledDuringChargeSession$2,settings:settings$3,status:status$5,units:units$2,updates:updates$3,warning:warning$2,priceBasedCharging:priceBasedCharging$3,capacityTariff:capacityTariff$3,roamingTariff:roamingTariff$3,solarBasedCharging:solarBasedCharging$3,delayedCharging:delayedCharging$3};

var actions$1={availabilityChanged:"Updated the availability of charge point {{id}}",cableDetected:"Charging cable connected",carDetected:"Car detected",makeAvailable:"Set available",makeUnavailable:"Set unavailable",offPeakChargingSuccess:"Succesfully saved schedule",overrideTimeout:"Charge directly",reboot:"Reboot",rebootWarning:"This will fully reboot your charge point, only use when necessary",rebooted:"Charge point {{id}} has been rebooted",reset:"Reset",resetSuccess:"{{id}} has been resetted",startSession:"Start session",stopSession:"Stop session",unlock:"Unlock connector",unlocked:"The cable of charge point {{id}} is unlocked",boost:"Boost"};var activityStatus$2="Status";var bcuNumber$1="BCU number";var charged$1="Charged";var chargingProfiles$2={delayedCharging:"Delayed Charging",delayedChargingSet:"Delayed Charging is set until",name:"Smart Charging",priceBasedCharging:"Price-Based Charging",profiledCharging:"Use smart charging profile",profilesDisabledNoPermissionToChangeSetting:"Some profiles are disabled due to insufficient edit permissions",solarBasedCharging:"Solar Based Charging"};var error$5={availableFailed:"Couldn't set availability of charge point {{id}}",availableFailedStillCharging:"Can't change the availability of charge point {{id}}. Charging session in progress.",error:"Your charge point is in error, or there could be a temporary communication issue",ledInteractionFailed:"Coulnd't update led interaction setting",nameFailed:"Couldn't change charge point name",offline:"{{model}} may be offline, or there could be a temporary communication issue",paidChargingFailed:"Couldn't set paid charging on {{id}}",plugAndChargeFailed:"Coulnd't update plug & charge setting",plugAndChargeNotificationFailed:"Coulnd't update plug & charge notification setting",publicChargingFailed:"Coulnd't update public charging setting",publishLocationFailed:"Couldn't publish {{id}}'s location",rebootFailed:"Couldn't reboot charge point {{id}}!",resetFailed:"Couldn't reset charge point {{id}}!",smartChargingFailed:"Coulnd't update smart charging setting",somethingWrong:"Something went wrong!",startChargingFailed:"Couldn't start the charging session on {{id}}!",stopChargingFailed:"Charging session on {{id}} failed to stop!",unavailable:"{{model}} is unavailable. You can adjust this by setting your {{model}} to available.",unlockFailed:"Couldn't unlock cable from charge point {{id}}!",vehicleError:"Your car has an error, or there could be a temporary communication issue",vehicleNotFound:"No vehicle is connected"};var info$1={publicChargingDisabled:"Visitors can use your {{model}}. Almost all valid charge cards are accepted.",publicChargingEnabled:"Visitors can't make use of your {{model}}. Only linked charge cards are allowed."};var name$1={hidden:"Hidden",hiddenNanocharge:"Hidden & NanoCharge",nanocharge:"NanoCharge",umove:"U:MOVE"};var offline$2={lastOnline:"Last online",maxOfflineCharging:"Max. offline charging"};var plugChargeEnabled$1="Plug & charge enabled";var settingDisabledDuringChargeSession$1="This setting is disabled during charge sessions";var settings$2={ledInteraction:"Turn LEDs on, only when interacting",plugCharge:"Plug & charge",publicCharging:"Linked charge cards only",publishLocation:"Publish location",smartCharging:"Smart charging",tariffHint:"How do I configure my chargepoint tariff? <a href=\"https://help.bluecurrent.nl/knowledge/hoe-wijzig-ik-het-laadtarief-van-mijn-laadpunt\" target=\"_blank\" style=\"color:#0098DB;text-decoration:underline\">Click here for more information.</a>",capacityTariff:"Capacity tariff"};var status$4={available:"Available",charging:"Charging",delayed:"Scheduled",done:"Done",error:"Error",offline:"Offline",reserved:"Reserved",unavailable:"Unavailable"};var units$1={ampere:"Ampère",kwh:"kWh",volt:"Volt",voltage:"Voltage"};var updates$2={resetFailed:"{{id}} failed to reset!",resetSuccess:"{{id}} has been reset!",resetting:"Resetting {{id}}...",startCharging:"Starting charge session on {{id}}...",startChargingSuccess:"{{id}} started charging!",stopCharging:"Stopping charge session on {{id}}...",stopChargingSuccess:"{{id}} stopped charging!",startDelayedChargingSuccess:"Charging session of {{id}} is delayed till: {{time}}"};var warning$1={ledInteraction:"<b>NB</b> By default the lights on your charge point indicate the status is of your charge point. If LED interaction is enabled, the charge point lights are off. Only when the status of the charge point changes the lights will go on for 10 seconds. That way you can see that everything is alright.",ledInteractionOff:"<b>NB</b> The lights on your {{model}} indicate what the status is of your {{model}}.\n<br/><br/>\nIf `Turn led's only on when interacting` is disabled, the charge point lights are on.",plugAndCharge:"<b>NB</b> Everybody with a valid charge card can charge their car at your {{model}}.\n<br />\n<br />\nWould you rather not allow this? Then you have to enter the charge cards that can be used in <a href=\"{{url}}\" rel=\"noreferrer\">\"Charge cards\"</a>.",plugAndChargeNotification:"<b>NB</b> Receive notifications when a car is connected & starting a charge session on your {{model}}.",plugAndChargeNotificationOff:"<b>NB</b> Stop recieving notifications when a car is connected & starting a charge session on your {{model}}.",plugAndChargeOff:"<b>NB</b> You are about to disable plug & charge. In order to start a charge session you can either use the Blue Current app, or you can hold a charge card in front of the lights on your {{model}}.",publicCharging:"<b>NB</b> If turn this on everybody with a valid charge card can charge their car at your {{model}}.",publicChargingOff:"<b>NB</b> Visitors can't make use of your {{model}}. Only linked charge cards are allowed.",publishLocation:"<b>NB</b> Make the location of your charge point visible to the world. Your charge point will be published to apps & websites to show people where your charge point is. \n<br />\n<br />\nThis will go through eco-movement, also known from <a href=\"https://oplaadpalen.nl\">oplaadpalen.nl</a>.\n<br />\n<br />NB. This is hard to revert once published.",publishLocationOff:"<b>NB</b> Everybody with a valid charge card can charge their car at your {{model}}.\n<br />\n<br />\nWould you rather not allow this? Then you have to enter the charge cards that can be used in <a href=\"{{url}}\" rel=\"noreferrer\">\"Charge cards\"</a>.",tariff:"<b>NB</b> This will change the tariff on your charge point when a new transaction happens. ",tariffPublishLocationOff:"When setting your chargepoint to a free tariff, publish location will automatically be disabled."};var delayedCharging$2={shortExplanation:"Delay your charging session to avoid your peak usage time.",longExplanation:"Delay your charging session to avoid your peak usage time. Select the days when you want to delay your charging session and provide a start and end time.",selectAtLeastOneDay:"Select at least one day",chargingSessionWillStartEndOnDifferentDays:"Your charging session will start and end on different days",additionalInformation:"If you start your charging session between {{from}} and {{until}}, then we'll start charging at {{until}}."};var priceBasedCharging$2={shortExplanation:"Use the hourly price of dynamic energy contracts to charge when the price is lowest.",departureTime:"Expected departure time",sustainableCharging:"Sustainable Charging",minMaxKwhError:"Minimum of 1 kWh and maximum of 80 kWh",longExplanation:"Based on the EPEX SPOT day-ahead market and the average consumption in your household, we try to charge as much as possible at the times when electricity is cheapest. We can charge your battery a bit at the start of your charging session, so you can always leave if something comes up.<br /><br />Tell us when you expect to leave, how many kWh a ‘normal’ charging session is for you, and how many kWh you want us to charge at the start of your session.",expectedSizeOfChargingSession:"Expected size of the charging session",immediatelyCharge:"Immediately charge"};var capacityTariff$2={minMaxError:"Maximum kWh must be between 0,01 kWh and 80 kWh.",minMaxInfo:"0,01 kWh to a maximum of 80 kWh",successNotification:"Capacity tariff is set to max {{value}} kWh"};var roamingTariff$2={minMaxError:"Reimbursement must be between {{minValue}} / kWh and {{maxValue}} / kWh",allAmountsAreExclVAT:"All amounts are excl. VAT",reimbursementChanged:"Reimbursement changed to {{value}} / kWh",description:"Set your reimbursement rate per kWh for paid transactions.",chargedToChargingCardSupplier:"Charged to charging card supplier",allAmountsAreInclVAT:"All amounts are incl. VAT"};var solarBasedCharging$2={description:"Lorem ipsum",minMaxKwhError:"Minimum of 1 kWh and maximum of 80 kWh",startTime:"Start time",endTime:"End time",minKwh:"Minimum kWh"};var ChargePointEN = {actions:actions$1,activityStatus:activityStatus$2,bcuNumber:bcuNumber$1,charged:charged$1,chargingProfiles:chargingProfiles$2,error:error$5,info:info$1,name:name$1,offline:offline$2,plugChargeEnabled:plugChargeEnabled$1,settingDisabledDuringChargeSession:settingDisabledDuringChargeSession$1,settings:settings$2,status:status$4,units:units$1,updates:updates$2,warning:warning$1,delayedCharging:delayedCharging$2,priceBasedCharging:priceBasedCharging$2,capacityTariff:capacityTariff$2,roamingTariff:roamingTariff$2,solarBasedCharging:solarBasedCharging$2};

var status$3={available:"Disponible",unavailable:"Indisponible",error:"Erreur",offline:"Déconnecté",charging:"En charge"};var activityStatus$1="Statut";var error$4={availableFailed:"Impossible de définir la disponibilité de la borne de recharge {{id}}",offline:"{{model}} est peut-être déconnecté ou il peut y avoir un problème de communication temporaire",error:"Votre point de charge est en erreur, ou il pourrait y avoir un problème de communication temporaire"};var offline$1={lastOnline:"Dernière connexion",maxOfflineCharging:"Vitesse de recharge hors connexion maximal"};var settings$1={capacityTariff:""};var capacityTariff$1={minMaxError:"",minMaxInfo:"",successNotification:""};var roamingTariff$1={minMaxError:"",allAmountsAreExclVAT:"",reimbursementChanged:"",description:"",chargedToChargingCardSupplier:"",allAmountsAreInclVAT:""};var priceBasedCharging$1={minMaxKwhError:"",longExplanation:"",expectedSizeOfChargingSession:"",immediatelyCharge:""};var chargingProfiles$1={profilesDisabledNoPermissionToChangeSetting:"",solarBasedCharging:""};var solarBasedCharging$1={description:"",minMaxKwhError:"",startTime:"",endTime:"",minKwh:""};var delayedCharging$1={selectAtLeastOneDay:"",chargingSessionWillStartEndOnDifferentDays:"",longExplanation:"",additionalInformation:""};var updates$1={startDelayedChargingSuccess:""};var ChargePointFR = {status:status$3,activityStatus:activityStatus$1,error:error$4,offline:offline$1,settings:settings$1,capacityTariff:capacityTariff$1,roamingTariff:roamingTariff$1,priceBasedCharging:priceBasedCharging$1,chargingProfiles:chargingProfiles$1,solarBasedCharging:solarBasedCharging$1,delayedCharging:delayedCharging$1,updates:updates$1};

var actions={availabilityChanged:"[UUUUþďåååṫéééď ṫḥééé åååvåååîîîļåååbîîîļîîîṫÝ öööḟ çḥåååŕǧééé þöööîîîกี้ṫ {{îîîď}}]",cableDetected:"[CCḥåååŕǧîîîกี้ǧ çåååbļééé çöööกี้กี้éééçṫéééď]",carDetected:"[CCåååŕ ďéééṫéééçṫéééď]",makeAvailable:"[SSéééṫ åååvåååîîîļåååbļééé]",makeUnavailable:"[SSéééṫ ūūūกี้åååvåååîîîļåååbļééé]",offPeakChargingSuccess:"[SSūūūççéééšḟūūūļļÝ šåååvéééď šçḥéééďūūūļééé]",overrideTimeout:"[CCḥåååŕǧééé ďîîîŕéééçṫļÝ]",reboot:"[RRééébööööööṫ]",rebootWarning:"[TTḥîîîš wîîîļļ ḟūūūļļÝ ŕééébööööööṫ Ýöööūūūŕ çḥåååŕǧééé þöööîîîกี้ṫ, öööกี้ļÝ ūūūšééé wḥéééกี้ กี้éééçéééššåååŕÝ]",rebooted:"[CCḥåååŕǧééé þöööîîîกี้ṫ {{îîîď}} ḥåååš bééééééกี้ ŕééébööööööṫéééď]",reset:"[RRéééšéééṫ]",resetSuccess:"[{{{îîîď}} ḥåååš bééééééกี้ ŕéééšéééṫṫéééď]",startSession:"[SSṫåååŕṫ šéééššîîîöööกี้]",stopSession:"[SSṫöööþ šéééššîîîöööกี้]",unlock:"[UUUUกี้ļöööçḱ çöööกี้กี้éééçṫöööŕ]",unlocked:"[TTḥééé çåååbļééé öööḟ çḥåååŕǧééé þöööîîîกี้ṫ {{îîîď}} îîîš ūūūกี้ļöööçḱéééď]",boost:"[BBööööööšṫ]"};var activityStatus="[SSṫåååṫūūūš]";var bcuNumber="[BBCUUU กี้ūūūmbéééŕ]";var charged="[CCḥåååŕǧéééď]";var chargingProfiles={delayedCharging:"[DDéééļåååÝéééď Cḥåååŕǧîîîกี้ǧ]",delayedChargingSet:"[DDéééļåååÝéééď Cḥåååŕǧîîîกี้ǧ îîîš šéééṫ ūūūกี้ṫîîîļ]",name:"[SSmåååŕṫ Cḥåååŕǧîîîกี้ǧ]",priceBasedCharging:"[PPŕîîîçééé-Båååšéééď Cḥåååŕǧîîîกี้ǧ]",profiledCharging:"[UUUUšééé šmåååŕṫ çḥåååŕǧîîîกี้ǧ þŕöööḟîîîļééé]",profilesDisabledNoPermissionToChangeSetting:"[SSööömééé þŕöööḟîîîļéééš åååŕééé ďîîîšåååbļéééď ďūūūééé ṫööö îîîกี้šūūūḟḟîîîçîîîéééกี้ṫ éééďîîîṫ þéééŕmîîîššîîîöööกี้š]",solarBasedCharging:"[SSöööļåååŕ Båååšéééď Cḥåååŕǧîîîกี้ǧ]"};var error$3={availableFailed:"[CCöööūūūļďกี้'ṫ šéééṫ åååvåååîîîļåååbîîîļîîîṫÝ öööḟ çḥåååŕǧééé þöööîîîกี้ṫ {{îîîď}}]",availableFailedStillCharging:"[CCåååกี้'ṫ çḥåååกี้ǧééé ṫḥééé åååvåååîîîļåååbîîîļîîîṫÝ öööḟ çḥåååŕǧééé þöööîîîกี้ṫ {{îîîď}}. Cḥåååŕǧîîîกี้ǧ šéééššîîîöööกี้ îîîกี้ þŕöööǧŕéééšš.]",error:"[YYöööūūūŕ çḥåååŕǧééé þöööîîîกี้ṫ îîîš îîîกี้ éééŕŕöööŕ, öööŕ ṫḥéééŕééé çöööūūūļď bééé ååå ṫééémþöööŕåååŕÝ çööömmūūūกี้îîîçåååṫîîîöööกี้ îîîššūūūééé]",ledInteractionFailed:"[CCöööūūūļกี้ď'ṫ ūūūþďåååṫééé ļéééď îîîกี้ṫéééŕåååçṫîîîöööกี้ šéééṫṫîîîกี้ǧ]",nameFailed:"[CCöööūūūļďกี้'ṫ çḥåååกี้ǧééé çḥåååŕǧééé þöööîîîกี้ṫ กี้åååmééé]",offline:"[{{{möööďéééļ}} måååÝ bééé öööḟḟļîîîกี้ééé, öööŕ ṫḥéééŕééé çöööūūūļď bééé ååå ṫééémþöööŕåååŕÝ çööömmūūūกี้îîîçåååṫîîîöööกี้ îîîššūūūééé]",paidChargingFailed:"[CCöööūūūļďกี้'ṫ šéééṫ þåååîîîď çḥåååŕǧîîîกี้ǧ öööกี้ {{îîîď}}]",plugAndChargeFailed:"[CCöööūūūļกี้ď'ṫ ūūūþďåååṫééé þļūūūǧ & çḥåååŕǧééé šéééṫṫîîîกี้ǧ]",plugAndChargeNotificationFailed:"[CCöööūūūļกี้ď'ṫ ūūūþďåååṫééé þļūūūǧ & çḥåååŕǧééé กี้öööṫîîîḟîîîçåååṫîîîöööกี้ šéééṫṫîîîกี้ǧ]",publicChargingFailed:"[CCöööūūūļกี้ď'ṫ ūūūþďåååṫééé þūūūbļîîîç çḥåååŕǧîîîกี้ǧ šéééṫṫîîîกี้ǧ]",publishLocationFailed:"[CCöööūūūļďกี้'ṫ þūūūbļîîîšḥ {{îîîď}}'š ļöööçåååṫîîîöööกี้]",rebootFailed:"[CCöööūūūļďกี้'ṫ ŕééébööööööṫ çḥåååŕǧééé þöööîîîกี้ṫ {{îîîď}}!]",resetFailed:"[CCöööūūūļďกี้'ṫ ŕéééšéééṫ çḥåååŕǧééé þöööîîîกี้ṫ {{îîîď}}!]",smartChargingFailed:"[CCöööūūūļกี้ď'ṫ ūūūþďåååṫééé šmåååŕṫ çḥåååŕǧîîîกี้ǧ šéééṫṫîîîกี้ǧ]",somethingWrong:"[SSöööméééṫḥîîîกี้ǧ wéééกี้ṫ wŕöööกี้ǧ!]",startChargingFailed:"[CCöööūūūļďกี้'ṫ šṫåååŕṫ ṫḥééé çḥåååŕǧîîîกี้ǧ šéééššîîîöööกี้ öööกี้ {{îîîď}}!]",stopChargingFailed:"[CCḥåååŕǧîîîกี้ǧ šéééššîîîöööกี้ öööกี้ {{îîîď}} ḟåååîîîļéééď ṫööö šṫöööþ!]",unavailable:"[{{{möööďéééļ}} îîîš ūūūกี้åååvåååîîîļåååbļééé. Yöööūūū çåååกี้ åååďĵūūūšṫ ṫḥîîîš bÝ šéééṫṫîîîกี้ǧ Ýöööūūūŕ {{möööďéééļ}} ṫööö åååvåååîîîļåååbļééé.]",unlockFailed:"[CCöööūūūļďกี้'ṫ ūūūกี้ļöööçḱ çåååbļééé ḟŕöööm çḥåååŕǧééé þöööîîîกี้ṫ {{îîîď}}!]",vehicleError:"[YYöööūūūŕ çåååŕ ḥåååš åååกี้ éééŕŕöööŕ, öööŕ ṫḥéééŕééé çöööūūūļď bééé ååå ṫééémþöööŕåååŕÝ çööömmūūūกี้îîîçåååṫîîîöööกี้ îîîššūūūééé]",vehicleNotFound:"[NNööö véééḥîîîçļééé îîîš çöööกี้กี้éééçṫéééď]"};var info={publicChargingDisabled:"[VVîîîšîîîṫöööŕš çåååกี้ ūūūšééé Ýöööūūūŕ {{möööďéééļ}}. AAAļmöööšṫ åååļļ våååļîîîď çḥåååŕǧééé çåååŕďš åååŕééé åååççéééþṫéééď.]",publicChargingEnabled:"[VVîîîšîîîṫöööŕš çåååกี้'ṫ måååḱééé ūūūšééé öööḟ Ýöööūūūŕ {{möööďéééļ}}. OOOกี้ļÝ ļîîîกี้ḱéééď çḥåååŕǧééé çåååŕďš åååŕééé åååļļöööwéééď.]"};var name={hidden:"[HHîîîďďéééกี้]",hiddenNanocharge:"[HHîîîďďéééกี้ & Nåååกี้öööCḥåååŕǧééé]",nanocharge:"[NNåååกี้öööCḥåååŕǧééé]",umove:"[UUUU:MOOOVEEE]"};var offline={lastOnline:"[LLåååšṫ öööกี้ļîîîกี้ééé]",maxOfflineCharging:"[MMåååx. öööḟḟļîîîกี้ééé çḥåååŕǧîîîกี้ǧ]"};var plugChargeEnabled="[PPļūūūǧ & çḥåååŕǧééé éééกี้åååbļéééď]";var settingDisabledDuringChargeSession="[TTḥîîîš šéééṫṫîîîกี้ǧ îîîš ďîîîšåååbļéééď ďūūūŕîîîกี้ǧ çḥåååŕǧééé šéééššîîîöööกี้š]";var settings={ledInteraction:"[TTūūūŕกี้ LEEEDš öööกี้, öööกี้ļÝ wḥéééกี้ îîîกี้ṫéééŕåååçṫîîîกี้ǧ]",plugCharge:"[PPļūūūǧ & çḥåååŕǧééé]",publicCharging:"[LLîîîกี้ḱéééď çḥåååŕǧééé çåååŕďš öööกี้ļÝ]",publishLocation:"[PPūūūbļîîîšḥ ļöööçåååṫîîîöööกี้]",smartCharging:"[SSmåååŕṫ çḥåååŕǧîîîกี้ǧ]",tariffHint:"How do I configure my chargepoint tariff? <a href=\"https://help.bluecurrent.nl/knowledge/hoe-wijzig-ik-het-laadtarief-van-mijn-laadpunt\" target=\"_blank\" style=\"color:#0098DB;text-decoration:underline\">Click here for more information.</a>",capacityTariff:"[CCåååþåååçîîîṫÝ ṫåååŕîîîḟḟ]"};var status$2={available:"[AAAAvåååîîîļåååbļééé]",charging:"[CCḥåååŕǧîîîกี้ǧ]",delayed:"[SSçḥéééďūūūļéééď]",done:"[DDöööกี้ééé]",error:"[EEEEŕŕöööŕ]",offline:"[OOOOḟḟļîîîกี้ééé]",reserved:"[RRéééšéééŕvéééď]",unavailable:"[UUUUกี้åååvåååîîîļåååbļééé]"};var units={ampere:"[AAAAmþèŕééé]",kwh:"[ḱḱWḥ]",volt:"[VVöööļṫ]",voltage:"[VVöööļṫåååǧééé]"};var updates={resetFailed:"[{{{îîîď}} ḟåååîîîļéééď ṫööö ŕéééšéééṫ!]",resetSuccess:"[{{{îîîď}} ḥåååš bééééééกี้ ŕéééšéééṫ!]",resetting:"[RRéééšéééṫṫîîîกี้ǧ {{îîîď}}...]",startCharging:"[SSṫåååŕṫîîîกี้ǧ çḥåååŕǧééé šéééššîîîöööกี้ öööกี้ {{îîîď}}...]",startChargingSuccess:"[{{{îîîď}} šṫåååŕṫéééď çḥåååŕǧîîîกี้ǧ!]",stopCharging:"[SSṫöööþþîîîกี้ǧ çḥåååŕǧééé šéééššîîîöööกี้ öööกี้ {{îîîď}}...]",stopChargingSuccess:"[{{{îîîď}} šṫöööþþéééď çḥåååŕǧîîîกี้ǧ!]",startDelayedChargingSuccess:"[CCḥåååŕǧîîîกี้ǧ šéééššîîîöööกี้ öööḟ {{îîîď}} îîîš ďéééļåååÝéééď ṫîîîļļ: {{ṫîîîmééé}}]"};var warning={ledInteraction:"<b>NB</b> By default the lights on your charge point indicate the status is of your charge point. If LED interaction is enabled, the charge point lights are off. Only when the status of the charge point changes the lights will go on for 10 seconds. That way you can see that everything is alright.",ledInteractionOff:"<b>NB</b> The lights on your {{model}} indicate what the status is of your {{model}}.\n<br/><br/>\nIf `Turn led's only on when interacting` is disabled, the charge point lights are on.",plugAndCharge:"<b>NB</b> Everybody with a valid charge card can charge their car at your {{model}}.\n<br />\n<br />\nWould you rather not allow this? Then you have to enter the charge cards that can be used in <a href=\"{{url}}\" rel=\"noreferrer\">\"Charge cards\"</a>.",plugAndChargeNotification:"<b>NB</b> Receive notifications when a car is connected & starting a charge session on your {{model}}.",plugAndChargeNotificationOff:"<b>NB</b> Stop recieving notifications when a car is connected & starting a charge session on your {{model}}.",plugAndChargeOff:"<b>NB</b> You are about to disable plug & charge. In order to start a charge session you can either use the Blue Current app, or you can hold a charge card in front of the lights on your {{model}}.",publicCharging:"<b>NB</b> If turn this on everybody with a valid charge card can charge their car at your {{model}}.",publicChargingOff:"<b>NB</b> Visitors can't make use of your {{model}}. Only linked charge cards are allowed.",publishLocation:"<b>NB</b> Make the location of your charge point visible to the world. Your charge point will be published to apps & websites to show people where your charge point is. \n<br />\n<br />\nThis will go through eco-movement, also known from <a href=\"https://oplaadpalen.nl\">oplaadpalen.nl</a>.\n<br />\n<br />NB. This is hard to revert once published.",publishLocationOff:"<b>NB</b> Everybody with a valid charge card can charge their car at your {{model}}.\n<br />\n<br />\nWould you rather not allow this? Then you have to enter the charge cards that can be used in <a href=\"{{url}}\" rel=\"noreferrer\">\"Charge cards\"</a>.",tariff:"<b>NB</b> This will change the tariff on your charge point when a new transaction happens. ",tariffPublishLocationOff:"[WWḥéééกี้ šéééṫṫîîîกี้ǧ Ýöööūūūŕ çḥåååŕǧéééþöööîîîกี้ṫ ṫööö ååå ḟŕéééééé ṫåååŕîîîḟḟ, þūūūbļîîîšḥ ļöööçåååṫîîîöööกี้ wîîîļļ åååūūūṫööömåååṫîîîçåååļļÝ bééé ďîîîšåååbļéééď.]"};var delayedCharging={shortExplanation:"[DDéééļåååÝ Ýöööūūūŕ çḥåååŕǧîîîกี้ǧ šéééššîîîöööกี้ ṫööö åååvöööîîîď Ýöööūūūŕ þéééåååḱ ūūūšåååǧééé ṫîîîmééé.]",longExplanation:"[DDéééļåååÝ Ýöööūūūŕ çḥåååŕǧîîîกี้ǧ šéééššîîîöööกี้ ṫööö åååvöööîîîď Ýöööūūūŕ þéééåååḱ ūūūšåååǧééé ṫîîîmééé. Séééļéééçṫ ṫḥééé ďåååÝš wḥéééกี้ Ýöööūūū wåååกี้ṫ ṫööö ďéééļåååÝ Ýöööūūūŕ çḥåååŕǧîîîกี้ǧ šéééššîîîöööกี้ åååกี้ď þŕööövîîîďééé ååå šṫåååŕṫ åååกี้ď éééกี้ď ṫîîîmééé.]",selectAtLeastOneDay:"[SSéééļéééçṫ åååṫ ļéééåååšṫ öööกี้ééé ďåååÝ]",chargingSessionWillStartEndOnDifferentDays:"[YYöööūūūŕ çḥåååŕǧîîîกี้ǧ šéééššîîîöööกี้ wîîîļļ šṫåååŕṫ åååกี้ď éééกี้ď öööกี้ ďîîîḟḟéééŕéééกี้ṫ ďåååÝš]",additionalInformation:"[IIIIḟ Ýöööūūū šṫåååŕṫ Ýöööūūūŕ çḥåååŕǧîîîกี้ǧ šéééššîîîöööกี้ béééṫwééééééกี้ {{ḟŕöööm}} åååกี้ď {{ūūūกี้ṫîîîļ}}, ṫḥéééกี้ wééé'ļļ šṫåååŕṫ çḥåååŕǧîîîกี้ǧ åååṫ {{ūūūกี้ṫîîîļ}}.]"};var priceBasedCharging={shortExplanation:"[UUUUšééé ṫḥééé ḥöööūūūŕļÝ þŕîîîçééé öööḟ ďÝกี้åååmîîîç éééกี้éééŕǧÝ çöööกี้ṫŕåååçṫš ṫööö çḥåååŕǧééé wḥéééกี้ ṫḥééé þŕîîîçééé îîîš ļöööwéééšṫ.]",departureTime:"[EEEExþéééçṫéééď ďéééþåååŕṫūūūŕééé ṫîîîmééé]",sustainableCharging:"[SSūūūšṫåååîîîกี้åååbļééé Cḥåååŕǧîîîกี้ǧ]",minMaxKwhError:"[MMîîîกี้îîîmūūūm öööḟ 1 ḱWḥ åååกี้ď måååxîîîmūūūm öööḟ 80 ḱWḥ]",longExplanation:"Based on the EPEX SPOT day-ahead market and the average consumption in your household, we try to charge as much as possible at the times when electricity is cheapest. We can charge your battery a bit at the start of your charging session, so you can always leave if something comes up.<br /><br />Tell us when you expect to leave, how many kWh a ‘normal’ charging session is for you, and how many kWh you want us to charge at the start of your session.",expectedSizeOfChargingSession:"[EEEExþéééçṫéééď šîîîžééé öööḟ ṫḥééé çḥåååŕǧîîîกี้ǧ šéééššîîîöööกี้]",immediatelyCharge:"[IIIImméééďîîîåååṫéééļÝ çḥåååŕǧééé]"};var capacityTariff={minMaxError:"[MMåååxîîîmūūūm ḱWḥ mūūūšṫ bééé béééṫwééééééกี้ 0,01 ḱWḥ åååกี้ď 80 ḱWḥ.]",minMaxInfo:"[00,01 ḱWḥ ṫööö ååå måååxîîîmūūūm öööḟ 80 ḱWḥ]",successNotification:"[CCåååþåååçîîîṫÝ ṫåååŕîîîḟḟ îîîš šéééṫ ṫööö måååx {{våååļūūūééé}} ḱWḥ]"};var roamingTariff={minMaxError:"[RRéééîîîmbūūūŕšéééméééกี้ṫ mūūūšṫ bééé béééṫwééééééกี้ {{mîîîกี้Våååļūūūééé}} / ḱWḥ åååกี้ď {{måååxVåååļūūūééé}} / ḱWḥ]",allAmountsAreExclVAT:"[AAAAļļ åååmöööūūūกี้ṫš åååŕééé éééxçļ. VAAAT]",reimbursementChanged:"[RRéééîîîmbūūūŕšéééméééกี้ṫ çḥåååกี้ǧéééď ṫööö {{våååļūūūééé}} / ḱWḥ]",description:"[SSéééṫ Ýöööūūūŕ ŕéééîîîmbūūūŕšéééméééกี้ṫ ŕåååṫééé þéééŕ ḱWḥ ḟöööŕ þåååîîîď ṫŕåååกี้šåååçṫîîîöööกี้š.]",chargedToChargingCardSupplier:"[CCḥåååŕǧéééď ṫööö çḥåååŕǧîîîกี้ǧ çåååŕď šūūūþþļîîîéééŕ]",allAmountsAreInclVAT:"[AAAAļļ åååmöööūūūกี้ṫš åååŕééé îîîกี้çļ. VAAAT]"};var solarBasedCharging={description:"[LLöööŕééém îîîþšūūūm]",minMaxKwhError:"[MMîîîกี้îîîmūūūm öööḟ 1 ḱWḥ åååกี้ď måååxîîîmūūūm öööḟ 80 ḱWḥ]",startTime:"[SSṫåååŕṫ ṫîîîmééé]",endTime:"[EEEEกี้ď ṫîîîmééé]",minKwh:"[MMîîîกี้îîîmūūūm ḱWḥ]"};var ChargePointPSEUDO = {actions:actions,activityStatus:activityStatus,bcuNumber:bcuNumber,charged:charged,chargingProfiles:chargingProfiles,error:error$3,info:info,name:name,offline:offline,plugChargeEnabled:plugChargeEnabled,settingDisabledDuringChargeSession:settingDisabledDuringChargeSession,settings:settings,status:status$2,units:units,updates:updates,warning:warning,delayedCharging:delayedCharging,priceBasedCharging:priceBasedCharging,capacityTariff:capacityTariff,roamingTariff:roamingTariff,solarBasedCharging:solarBasedCharging};

var administrationCosts$2="Administratie kosten";var currentTariff$2="Huidig tarief";var declaration$2="Declaratie";var declarationOverview$3="Declaratieoverzicht";var deposit$2="Borg";var editTariff$2="Tarief wijzigen";var noTransactionsFound$2="Geen laadsessies gevonden";var paidCharging$2="Betaald laden";var rate$2="Tarief";var reasonNoSettlement$3={cardIsFree:"De laadpas is op dit laadpunt uitgezonderd van betaling. Deze laadsessie wordt niet in rekening gebracht op de pas.",invalidChargecard:"We kunnen deze laadsessie niet via de laadpas verrekenen, omdat de laadpasverstrekker de kaart als ongeldig aangemerkt heeft.",priceTooLow:"Het stroomverbruik of de totaalprijs van deze laadsessie is te klein en wordt niet in rekening gebracht op de laadpas.",reasonUnknown:"Onbekende reden",startedWithApp:"Deze laadsessie is gestart vanuit onze mobiele app en wordt niet via een laadpas verrekend.",startedWithPlugAndCharge:"Deze laadsessie is gestart middels plug & charge en wordt niet via een laadpas verrekend.",stationIsFree:"Betaald laden staat uit, of het tarief van het laadpunt is op 'gratis' ingesteld.",usageTooLow:"Het gebruik is te laag"};var reimbursement$3="Uitbetaling";var tariff$2="Tarief";var tariffs$2="Tarieven";var vat$2="BTW";var compensation$3="Jouw vergoeding";var FinanceNL = {administrationCosts:administrationCosts$2,currentTariff:currentTariff$2,declaration:declaration$2,declarationOverview:declarationOverview$3,deposit:deposit$2,editTariff:editTariff$2,noTransactionsFound:noTransactionsFound$2,paidCharging:paidCharging$2,rate:rate$2,reasonNoSettlement:reasonNoSettlement$3,reimbursement:reimbursement$3,tariff:tariff$2,tariffs:tariffs$2,vat:vat$2,compensation:compensation$3};

var administrationCosts$1="Administration costs";var currentTariff$1="Current tariff";var declaration$1="Declaration";var declarationOverview$2="Declaration overview";var deposit$1="Deposit";var editTariff$1="Edit tariff";var noTransactionsFound$1="No charge sessions found";var paidCharging$1="Paid charging";var rate$1="Rate";var reasonNoSettlement$2={cardIsFree:"This charge session will not be billed to the charge card, as the card has been exempted on this charge point.",invalidChargecard:"We are unable to bill this charge session to the charge card provider, because the provider has marked the card as invalid.",priceTooLow:"The power consumption or total price of this charge session is too low. It will not be billed to the charge card.",reasonUnknown:"Reason unknown",startedWithApp:"This charge session was started through our mobile app and will not be billed to a charge card.",startedWithPlugAndCharge:"This charge session was started through plug & charge and will not be billed to a charge card.",stationIsFree:"Paid charging has been turned off, or the rate at the charge point has been set to 'free'.",usageTooLow:"The usage is too low"};var reimbursement$2="Reimbursement";var tariff$1="Tariff";var tariffs$1="Tarrifs";var vat$1="VAT";var compensation$2="Your reimbursement";var FinanceEN = {administrationCosts:administrationCosts$1,currentTariff:currentTariff$1,declaration:declaration$1,declarationOverview:declarationOverview$2,deposit:deposit$1,editTariff:editTariff$1,noTransactionsFound:noTransactionsFound$1,paidCharging:paidCharging$1,rate:rate$1,reasonNoSettlement:reasonNoSettlement$2,reimbursement:reimbursement$2,tariff:tariff$1,tariffs:tariffs$1,vat:vat$1,compensation:compensation$2};

var reimbursement$1="Remboursement";var reasonNoSettlement$1={usageTooLow:"Pas chargé suffisamment",stationIsFree:"La recharge payante est désactivée, ou le tarif de la borne de recharge est réglé sur 'gratuit'."};var declarationOverview$1="Récapitulatif des déclarations";var compensation$1="";var FinanceFR = {reimbursement:reimbursement$1,reasonNoSettlement:reasonNoSettlement$1,declarationOverview:declarationOverview$1,compensation:compensation$1};

var administrationCosts="[AAAAďmîîîกี้îîîšṫŕåååṫîîîöööกี้ çöööšṫš]";var currentTariff="[CCūūūŕŕéééกี้ṫ ṫåååŕîîîḟḟ]";var declaration="[DDéééçļåååŕåååṫîîîöööกี้]";var declarationOverview="[DDéééçļåååŕåååṫîîîöööกี้ ööövéééŕvîîîéééw]";var deposit="[DDéééþöööšîîîṫ]";var editTariff="[EEEEďîîîṫ ṫåååŕîîîḟḟ]";var noTransactionsFound="[NNööö çḥåååŕǧééé šéééššîîîöööกี้š ḟöööūūūกี้ď]";var paidCharging="[PPåååîîîď çḥåååŕǧîîîกี้ǧ]";var rate="[RRåååṫééé]";var reasonNoSettlement={cardIsFree:"[TTḥîîîš çḥåååŕǧééé šéééššîîîöööกี้ wîîîļļ กี้öööṫ bééé bîîîļļéééď ṫööö ṫḥééé çḥåååŕǧééé çåååŕď, åååš ṫḥééé çåååŕď ḥåååš bééééééกี้ éééxééémþṫéééď öööกี้ ṫḥîîîš çḥåååŕǧééé þöööîîîกี้ṫ.]",invalidChargecard:"[WWééé åååŕééé ūūūกี้åååbļééé ṫööö bîîîļļ ṫḥîîîš çḥåååŕǧééé šéééššîîîöööกี้ ṫööö ṫḥééé çḥåååŕǧééé çåååŕď þŕööövîîîďéééŕ, béééçåååūūūšééé ṫḥééé þŕööövîîîďéééŕ ḥåååš måååŕḱéééď ṫḥééé çåååŕď åååš îîîกี้våååļîîîď.]",priceTooLow:"[TTḥééé þöööwéééŕ çöööกี้šūūūmþṫîîîöööกี้ öööŕ ṫöööṫåååļ þŕîîîçééé öööḟ ṫḥîîîš çḥåååŕǧééé šéééššîîîöööกี้ îîîš ṫöööööö ļöööw. IIIṫ wîîîļļ กี้öööṫ bééé bîîîļļéééď ṫööö ṫḥééé çḥåååŕǧééé çåååŕď.]",reasonUnknown:"[RRéééåååšöööกี้ ūūūกี้ḱกี้öööwกี้]",startedWithApp:"[TTḥîîîš çḥåååŕǧééé šéééššîîîöööกี้ wåååš šṫåååŕṫéééď ṫḥŕöööūūūǧḥ öööūūūŕ möööbîîîļééé åååþþ åååกี้ď wîîîļļ กี้öööṫ bééé bîîîļļéééď ṫööö ååå çḥåååŕǧééé çåååŕď.]",startedWithPlugAndCharge:"[TTḥîîîš çḥåååŕǧééé šéééššîîîöööกี้ wåååš šṫåååŕṫéééď ṫḥŕöööūūūǧḥ þļūūūǧ & çḥåååŕǧééé åååกี้ď wîîîļļ กี้öööṫ bééé bîîîļļéééď ṫööö ååå çḥåååŕǧééé çåååŕď.]",stationIsFree:"[PPåååîîîď çḥåååŕǧîîîกี้ǧ ḥåååš bééééééกี้ ṫūūūŕกี้éééď öööḟḟ, öööŕ ṫḥééé ŕåååṫééé åååṫ ṫḥééé çḥåååŕǧééé þöööîîîกี้ṫ ḥåååš bééééééกี้ šéééṫ ṫööö 'ḟŕéééééé'.]",usageTooLow:"[TTḥééé ūūūšåååǧééé îîîš ṫöööööö ļöööw]"};var reimbursement="[RRéééîîîmbūūūŕšéééméééกี้ṫ]";var tariff="[TTåååŕîîîḟḟ]";var tariffs="[TTåååŕŕîîîḟš]";var vat="[VVAAAT]";var compensation="[YYöööūūūŕ ŕéééîîîmbūūūŕšéééméééกี้ṫ]";var FinancePSEUDO = {administrationCosts:administrationCosts,currentTariff:currentTariff,declaration:declaration,declarationOverview:declarationOverview,deposit:deposit,editTariff:editTariff,noTransactionsFound:noTransactionsFound,paidCharging:paidCharging,rate:rate,reasonNoSettlement:reasonNoSettlement,reimbursement:reimbursement,tariff:tariff,tariffs:tariffs,vat:vat,compensation:compensation};

var blueCurrent$2="Blue Current";var copyright$7="© {{date}} Blue Current, Alle rechten voorbehouden";var email$3="samen@bluecurrent.nl";var forInstallers$2="Voor installateurs";var forLease$2="Voor lease";var forBusinessLocations$2="Zakelijke laadpaal bij uw bedrijf?";var invest$2={downloadPitchDeck:"Download pitch deck",email:"investeren@bluecurrent.nl",emailFormatted:"investeren@bluecurrent.nl",hasAlreadyReserved:"Al voor <span style=\"font-family: 'Caveat';font-size: 1.25em; padding-right: 3px; color: #FFFFFF; font-weight: 700;\">{{amount}}</span> aan aandelen gereserveerd!",invest:"Investeer",investNow:"Investeer nu",ourMission:"Onze missie",reserve:"Reserveer",reserveAShare:"Aandelen reserveren",seoDescription:"Help mee de transitie naar duurzame mobiliteit te versnellen",seoTitle:"Word mede-eigenaar van Blue Current",stayInformed:"Geïnformeerd blijven",success:"Onze eerste fundingronde is succesvol afgerond met <span style=\"font-family: 'Caveat';font-size: 1.25em; padding-right: 3px; color: #FFFFFF; font-weight: 700;\">{{amount}}</span>!",tel:"change tel invest",telFormatted:"change tel invest",togetherToSustainableMobility:"Samen op weg naar volledig duurzame elektrische mobiliteit",watchVideo:"Bekijk de video",whyInvest:"Waarom investeren"};var lease$2={annoyedByClingingChargePoint:"<span style=\"font-size:2.2em\">{{amount}}%</span><br /> stoort zich aan <span style=\"color:#FEE000\">laadpaalklevers</span>"};var notFormatted$3={email:"samen@bluecurrent.nl",tel:"+310850466050",telBE:"+3238087838"};var openingHours$2={week:"07:59 - 20:02",weekend:"08:59 - 17:03"};var slogan$2="Samen de transitie naar duurzame mobiliteit versnellen";var tel$3="NL: +31 (0) 85 04 66 050";var toBlueCurrentWebsite$2="Naar bluecurrent.nl";var togetherTowardsSustainableFuture$3="Samen naar een duurzame toekomst";var week$2="Maandag t/m vrijdag";var weekend$2="Zaterdag";var learnMoreAbout$3="Lees meer over Blue Current op: <a href=\"https://www.bluecurrent.nl\">bluecurrent.nl</a>";var telBE$3="BE: +32 (3) 808 78 38";var BrandingNL = {blueCurrent:blueCurrent$2,copyright:copyright$7,email:email$3,forInstallers:forInstallers$2,forLease:forLease$2,forBusinessLocations:forBusinessLocations$2,invest:invest$2,lease:lease$2,notFormatted:notFormatted$3,openingHours:openingHours$2,slogan:slogan$2,tel:tel$3,toBlueCurrentWebsite:toBlueCurrentWebsite$2,togetherTowardsSustainableFuture:togetherTowardsSustainableFuture$3,week:week$2,weekend:weekend$2,learnMoreAbout:learnMoreAbout$3,telBE:telBE$3};

var blueCurrent$1="Blue Current";var copyright$6="© {{date}} Blue Current, All rights reserved";var email$2="samen@bluecurrent.nl";var forInstallers$1="For installers";var forLease$1="For lease";var forBusinessLocations$1="Business charging point at your location?";var invest$1={downloadPitchDeck:"Download pitch deck",email:"invest@bluecurrent.nl",emailFormatted:"invest@bluecurrent.nl",hasAlreadyReserved:"Already for <span style=\"font-family: 'Caveat';font-size: 1.25em; padding-right: 3px; color: #FFFFFF; font-weight: 700;\">{{amount}}</span> in shares reserved!",invest:"Invest",investNow:"Invest now",ourMission:"Our mission",reserve:"Reserve",reserveAShare:"Reserve shares",seoDescription:"Help accelerate the transition towards sustainable mobility",seoTitle:"Become co-owner of Blue Current",stayInformed:"Stay informed",success:"Successfully completed our first funding round with <span style=\"font-family: 'Caveat';font-size: 1.25em; padding-right: 3px; color: #FFFFFF; font-weight: 700;\">{{amount}}</span>!",tel:"change tel invest",telFormatted:"change tel invest",togetherToSustainableMobility:"Working together towards fully sustainable mobility",watchVideo:"Watch the video",whyInvest:"Why invest"};var lease$1={annoyedByClingingChargePoint:"<span style=\"font-size:2.2em\">{{amount}}%</span><br /> is annoyed by <span style=\"color:#FEE000\">charge point clingers</span>"};var notFormatted$2={email:"samen@bluecurrent.nl",tel:"+310850466050",telBE:"+3238087838"};var openingHours$1={week:"07:59 - 20:02",weekend:"08:59 - 17:03"};var slogan$1="Accelerate the transition to sustainable mobility together";var tel$2="NL: +31 (0) 85 04 66 050";var toBlueCurrentWebsite$1="To bluecurrent.nl";var togetherTowardsSustainableFuture$2="Together towards a sustainable future";var week$1="Monday to Friday";var weekend$1="Saturday";var learnMoreAbout$2="Learn more about Blue Current at: <a href=\"https://www.bluecurrent.nl\">bluecurrent.nl</a>";var telBE$2="BE: +32 (3) 808 78 38";var BrandingEN = {blueCurrent:blueCurrent$1,copyright:copyright$6,email:email$2,forInstallers:forInstallers$1,forLease:forLease$1,forBusinessLocations:forBusinessLocations$1,invest:invest$1,lease:lease$1,notFormatted:notFormatted$2,openingHours:openingHours$1,slogan:slogan$1,tel:tel$2,toBlueCurrentWebsite:toBlueCurrentWebsite$1,togetherTowardsSustainableFuture:togetherTowardsSustainableFuture$2,week:week$1,weekend:weekend$1,learnMoreAbout:learnMoreAbout$2,telBE:telBE$2};

var copyright$5="© {{date}} Blue Current, Tous droits réservés";var togetherTowardsSustainableFuture$1="";var learnMoreAbout$1="";var notFormatted$1={telBE:"+3238087838",tel:"+310850466050",email:"samen@bluecurrent.nl"};var tel$1="NL: +31 (0) 85 04 66 050";var email$1="samen@bluecurrent.nl";var telBE$1="BE: +32 (3) 808 78 38";var BrandingFR = {copyright:copyright$5,togetherTowardsSustainableFuture:togetherTowardsSustainableFuture$1,learnMoreAbout:learnMoreAbout$1,notFormatted:notFormatted$1,tel:tel$1,email:email$1,telBE:telBE$1};

var blueCurrent="[BBļūūūééé Cūūūŕŕéééกี้ṫ]";var copyright$4="[©© {{ďåååṫééé}} Bļūūūééé Cūūūŕŕéééกี้ṫ, AAAļļ ŕîîîǧḥṫš ŕéééšéééŕvéééď]";var email="[ššåååméééกี้@bļūūūéééçūūūŕŕéééกี้ṫ.กี้ļ]";var forInstallers="[FFöööŕ îîîกี้šṫåååļļéééŕš]";var forLease="[FFöööŕ ļéééåååšééé]";var forBusinessLocations="[BBūūūšîîîกี้éééšš çḥåååŕǧîîîกี้ǧ þöööîîîกี้ṫ åååṫ Ýöööūūūŕ ļöööçåååṫîîîöööกี้?]";var invest={downloadPitchDeck:"[DDöööwกี้ļöööåååď þîîîṫçḥ ďéééçḱ]",email:"[îîîîกี้véééšṫ@bļūūūéééçūūūŕŕéééกี้ṫ.กี้ļ]",emailFormatted:"[îîîîกี้véééšṫ@bļūūūéééçūūūŕŕéééกี้ṫ.กี้ļ]",hasAlreadyReserved:"Already for <span style=\"font-family: 'Caveat';font-size: 1.25em; padding-right: 3px; color: #FFFFFF; font-weight: 700;\">{{amount}}</span> in shares reserved!",invest:"[IIIIกี้véééšṫ]",investNow:"[IIIIกี้véééšṫ กี้öööw]",ourMission:"[OOOOūūūŕ mîîîššîîîöööกี้]",reserve:"[RRéééšéééŕvééé]",reserveAShare:"[RRéééšéééŕvééé šḥåååŕéééš]",seoDescription:"[HHéééļþ åååççéééļéééŕåååṫééé ṫḥééé ṫŕåååกี้šîîîṫîîîöööกี้ ṫöööwåååŕďš šūūūšṫåååîîîกี้åååbļééé möööbîîîļîîîṫÝ]",seoTitle:"[BBéééçööömééé çööö-öööwกี้éééŕ öööḟ Bļūūūééé Cūūūŕŕéééกี้ṫ]",stayInformed:"[SSṫåååÝ îîîกี้ḟöööŕméééď]",success:"Successfully completed our first funding round with <span style=\"font-family: 'Caveat';font-size: 1.25em; padding-right: 3px; color: #FFFFFF; font-weight: 700;\">{{amount}}</span>!",tel:"[ççḥåååกี้ǧééé ṫéééļ îîîกี้véééšṫ]",telFormatted:"[ççḥåååกี้ǧééé ṫéééļ îîîกี้véééšṫ]",togetherToSustainableMobility:"[WWöööŕḱîîîกี้ǧ ṫöööǧéééṫḥéééŕ ṫöööwåååŕďš ḟūūūļļÝ šūūūšṫåååîîîกี้åååbļééé möööbîîîļîîîṫÝ]",watchVideo:"[WWåååṫçḥ ṫḥééé vîîîďéééööö]",whyInvest:"[WWḥÝ îîîกี้véééšṫ]"};var lease={annoyedByClingingChargePoint:"<span style=\"font-size:2.2em\">{{amount}}%</span><br /> is annoyed by <span style=\"color:#FEE000\">charge point clingers</span>"};var notFormatted={email:"[ššåååméééกี้@bļūūūéééçūūūŕŕéééกี้ṫ.กี้ļ]",tel:"[++310850466050]",telBE:"[++3238087838]"};var openingHours={week:"[007:59 - 20:02]",weekend:"[008:59 - 17:03]"};var slogan="[AAAAççéééļéééŕåååṫééé ṫḥééé ṫŕåååกี้šîîîṫîîîöööกี้ ṫööö šūūūšṫåååîîîกี้åååbļééé möööbîîîļîîîṫÝ ṫöööǧéééṫḥéééŕ]";var tel="[NNL: +31 (0) 85 04 66 050]";var toBlueCurrentWebsite="[TTööö bļūūūéééçūūūŕŕéééกี้ṫ.กี้ļ]";var togetherTowardsSustainableFuture="[TTöööǧéééṫḥéééŕ ṫöööwåååŕďš ååå šūūūšṫåååîîîกี้åååbļééé ḟūūūṫūūūŕééé]";var week="[MMöööกี้ďåååÝ ṫööö FŕîîîďåååÝ]";var weekend="[SSåååṫūūūŕďåååÝ]";var learnMoreAbout="Learn more about Blue Current at: <a href=\"https://www.bluecurrent.nl\">bluecurrent.nl</a>";var telBE="[BBEEE: +32 (3) 808 78 38]";var BrandingPSEUDO = {blueCurrent:blueCurrent,copyright:copyright$4,email:email,forInstallers:forInstallers,forLease:forLease,forBusinessLocations:forBusinessLocations,invest:invest,lease:lease,notFormatted:notFormatted,openingHours:openingHours,slogan:slogan,tel:tel,toBlueCurrentWebsite:toBlueCurrentWebsite,togetherTowardsSustainableFuture:togetherTowardsSustainableFuture,week:week,weekend:weekend,learnMoreAbout:learnMoreAbout,telBE:telBE};

var allRightsReserved$2="Alle rechten voorbehouden";var byPressingYouAccept$2="Door op '{{button}}' te drukken accepteer je onze <a href=\"{{href}}\" target=\"_blank\">{{link}}</a>";var chamberOfCommerce$2="KVK";var copyright$3="© {{date}} Blue Current, Alle rechten voorbehouden";var pleaseConsent$2="Door dit vakje aan te vinken ga je in akkoord met onze <a href={{policy}}>privacy policy</a> en <a href={{tos}}>TOS</a>";var privacyPolicy$3="Privacybeleid";var recaptchaPolicy$2="Deze site wordt beschermd door reCAPTCHA. Onze <a  target=\"_blank\" href=\"https://www.bluecurrent.nl/legal/privacy-statement\" target=\"_blank\">Privacy Statement</a> is van toepassing.";var requestDeletePersonalData$2="Persoonsgegevens opvragen/verwijderen";var termsConditions$3="Algemene voorwaarden";var LegalNL = {allRightsReserved:allRightsReserved$2,byPressingYouAccept:byPressingYouAccept$2,chamberOfCommerce:chamberOfCommerce$2,copyright:copyright$3,pleaseConsent:pleaseConsent$2,privacyPolicy:privacyPolicy$3,recaptchaPolicy:recaptchaPolicy$2,requestDeletePersonalData:requestDeletePersonalData$2,termsConditions:termsConditions$3};

var allRightsReserved$1="All rights reserved";var byPressingYouAccept$1="By pressing '{{button}}' you agree to our <a href=\"{{href}}\" target=\"_blank\">{{link}}</a>";var chamberOfCommerce$1="Chamber of Commerce";var copyright$2="© {{date}} Blue Current, All rights reserved";var pleaseConsent$1="Checking this box you consent to our <a href={{policy}}>privacy policy</a> and <a href={{tos}}>TOS</a>";var privacyPolicy$2="Privacy policy";var recaptchaPolicy$1="This site is protected by reCAPTCHA, our <a target=\"_blank\" href=\"https://www.bluecurrent.nl/legal/privacy-statement\" target=\"_blank\">Privacy Policy</a> apply.";var requestDeletePersonalData$1="Request/Delete personal data";var termsConditions$2="Terms & conditions";var LegalEN = {allRightsReserved:allRightsReserved$1,byPressingYouAccept:byPressingYouAccept$1,chamberOfCommerce:chamberOfCommerce$1,copyright:copyright$2,pleaseConsent:pleaseConsent$1,privacyPolicy:privacyPolicy$2,recaptchaPolicy:recaptchaPolicy$1,requestDeletePersonalData:requestDeletePersonalData$1,termsConditions:termsConditions$2};

var copyright$1="© {{date}} Blue Current, Tous droits réservés";var privacyPolicy$1="Déclaration de confidentialité";var termsConditions$1="Conditions générales d'utilisation";var LegalFR = {copyright:copyright$1,privacyPolicy:privacyPolicy$1,termsConditions:termsConditions$1};

var allRightsReserved="[AAAAļļ ŕîîîǧḥṫš ŕéééšéééŕvéééď]";var byPressingYouAccept="By pressing '{{button}}' you agree to our <a href=\"{{href}}\" target=\"_blank\">{{link}}</a>";var chamberOfCommerce="[CCḥåååmbéééŕ öööḟ Cööömméééŕçééé]";var copyright="[©© {{ďåååṫééé}} Bļūūūééé Cūūūŕŕéééกี้ṫ, AAAļļ ŕîîîǧḥṫš ŕéééšéééŕvéééď]";var pleaseConsent="Checking this box you consent to our <a href={{policy}}>privacy policy</a> and <a href={{tos}}>TOS</a>";var privacyPolicy="[PPŕîîîvåååçÝ þöööļîîîçÝ]";var recaptchaPolicy="This site is protected by reCAPTCHA, our <a target=\"_blank\" href=\"https://www.bluecurrent.nl/legal/privacy-statement\" target=\"_blank\">Privacy Policy</a> apply.";var requestDeletePersonalData="[RRéééqūūūéééšṫ/Déééļéééṫééé þéééŕšöööกี้åååļ ďåååṫååå]";var termsConditions="[TTéééŕmš & çöööกี้ďîîîṫîîîöööกี้š]";var LegalPSEUDO = {allRightsReserved:allRightsReserved,byPressingYouAccept:byPressingYouAccept,chamberOfCommerce:chamberOfCommerce,copyright:copyright,pleaseConsent:pleaseConsent,privacyPolicy:privacyPolicy,recaptchaPolicy:recaptchaPolicy,requestDeletePersonalData:requestDeletePersonalData,termsConditions:termsConditions};

var authenticationChargeCard$2="We kunnen geen laadsessie op deze pas in rekening brengen, maar je kunt de pas wel gebruiken om een gratis laadsessie te starten en te stoppen. Koppel de pas hiervoor aan je laadpunt.";var chargeCardExpired$2="De laadpasleverancier heeft deze pas op {{date}} als verlopen aangemerkt. Nieuwe laadsessies met deze pas kunnen niet verrekend worden.";var defaultCard$2="Standaard laadpas";var deleteCardDialog$2="Weet je zeker dat je deze laadpas wilt verwijderen? We verwijderen de pas ook van alle laadpunten die aan je account gekoppeld zijn.";var duplicateCard$2="Kaart al toegevoegd";var excluded$2="Uitgezonderd";var excludedOnChargePoints$3="Uitsluiten van betaling";var excludedOnExplanation$2="Je laadpas zal gratis kunnen laden op de laadpunten die je hieronder selecteert. ";var invalidCardNumber$2="Serienummer bestaat niet";var linkedChargePointsExplanation$2="Je laadpas wordt gekoppeld aan de laadpunten die je hier selecteert.";var noCardsFound$2="Geen laadpassen gevonden";var notMyChargeCards$2="Niet mijn laadpassen";var plugAndChargeCard$2="Plug & charge laadpas";var serialNumberEmpty$2="Serienummer kan niet leeg zijn";var exampleCard$3="bijv.: NL-NED-1234567-X";var ChargeCardNL = {authenticationChargeCard:authenticationChargeCard$2,chargeCardExpired:chargeCardExpired$2,defaultCard:defaultCard$2,deleteCardDialog:deleteCardDialog$2,duplicateCard:duplicateCard$2,excluded:excluded$2,excludedOnChargePoints:excludedOnChargePoints$3,excludedOnExplanation:excludedOnExplanation$2,invalidCardNumber:invalidCardNumber$2,linkedChargePointsExplanation:linkedChargePointsExplanation$2,noCardsFound:noCardsFound$2,notMyChargeCards:notMyChargeCards$2,plugAndChargeCard:plugAndChargeCard$2,serialNumberEmpty:serialNumberEmpty$2,exampleCard:exampleCard$3};

var authenticationChargeCard$1="We cannot settle a charging session on this card, but you can use the card to start and stop a free charging session. Link the chargecard to your charging point to do this.";var chargeCardExpired$1="The charge card provider has marked this card as expired on {{date}}. New charging sessions with this card cannot be billed via the card provider.";var defaultCard$1="Default charge card";var deleteCardDialog$1="Are you sure you want to remove this chargecard? We will also delete the card from all charge points connected to your account.";var duplicateCard$1="Card already added";var excluded$1="Excluded";var excludedOnChargePoints$2="Exclude from payment";var excludedOnExplanation$1="Your chargecard will be able to charge for free on the charge points you select here.";var invalidCardNumber$1="Serial number is invalid";var linkedChargePointsExplanation$1="Your card will be connected to the charge points you select here.";var noCardsFound$1="No charge cards found";var notMyChargeCards$1="Not my charge cards";var plugAndChargeCard$1="Plug & charge card";var serialNumberEmpty$1="Serial number can't be empty";var exampleCard$2="e.g.: EN-ENG-1234567-X";var ChargeCardEN = {authenticationChargeCard:authenticationChargeCard$1,chargeCardExpired:chargeCardExpired$1,defaultCard:defaultCard$1,deleteCardDialog:deleteCardDialog$1,duplicateCard:duplicateCard$1,excluded:excluded$1,excludedOnChargePoints:excludedOnChargePoints$2,excludedOnExplanation:excludedOnExplanation$1,invalidCardNumber:invalidCardNumber$1,linkedChargePointsExplanation:linkedChargePointsExplanation$1,noCardsFound:noCardsFound$1,notMyChargeCards:notMyChargeCards$1,plugAndChargeCard:plugAndChargeCard$1,serialNumberEmpty:serialNumberEmpty$1,exampleCard:exampleCard$2};

var excludedOnChargePoints$1="";var exampleCard$1="";var ChargeCardFR = {excludedOnChargePoints:excludedOnChargePoints$1,exampleCard:exampleCard$1};

var authenticationChargeCard="[WWééé çåååกี้กี้öööṫ šéééṫṫļééé ååå çḥåååŕǧîîîกี้ǧ šéééššîîîöööกี้ öööกี้ ṫḥîîîš çåååŕď, būūūṫ Ýöööūūū çåååกี้ ūūūšééé ṫḥééé çåååŕď ṫööö šṫåååŕṫ åååกี้ď šṫöööþ ååå ḟŕéééééé çḥåååŕǧîîîกี้ǧ šéééššîîîöööกี้. Lîîîกี้ḱ ṫḥééé çḥåååŕǧéééçåååŕď ṫööö Ýöööūūūŕ çḥåååŕǧîîîกี้ǧ þöööîîîกี้ṫ ṫööö ďööö ṫḥîîîš.]";var chargeCardExpired="[TTḥééé çḥåååŕǧééé çåååŕď þŕööövîîîďéééŕ ḥåååš måååŕḱéééď ṫḥîîîš çåååŕď åååš éééxþîîîŕéééď öööกี้ {{ďåååṫééé}}. Néééw çḥåååŕǧîîîกี้ǧ šéééššîîîöööกี้š wîîîṫḥ ṫḥîîîš çåååŕď çåååกี้กี้öööṫ bééé bîîîļļéééď vîîîååå ṫḥééé çåååŕď þŕööövîîîďéééŕ.]";var defaultCard="[DDéééḟåååūūūļṫ çḥåååŕǧééé çåååŕď]";var deleteCardDialog="[AAAAŕééé Ýöööūūū šūūūŕééé Ýöööūūū wåååกี้ṫ ṫööö ŕééémööövééé ṫḥîîîš çḥåååŕǧéééçåååŕď? Wééé wîîîļļ åååļšööö ďéééļéééṫééé ṫḥééé çåååŕď ḟŕöööm åååļļ çḥåååŕǧééé þöööîîîกี้ṫš çöööกี้กี้éééçṫéééď ṫööö Ýöööūūūŕ åååççöööūūūกี้ṫ.]";var duplicateCard="[CCåååŕď åååļŕéééåååďÝ åååďďéééď]";var excluded="[EEEExçļūūūďéééď]";var excludedOnChargePoints="[EEEExçļūūūďééé ḟŕöööm þåååÝméééกี้ṫ]";var excludedOnExplanation="[YYöööūūūŕ çḥåååŕǧéééçåååŕď wîîîļļ bééé åååbļééé ṫööö çḥåååŕǧééé ḟöööŕ ḟŕéééééé öööกี้ ṫḥééé çḥåååŕǧééé þöööîîîกี้ṫš Ýöööūūū šéééļéééçṫ ḥéééŕééé.]";var invalidCardNumber="[SSéééŕîîîåååļ กี้ūūūmbéééŕ îîîš îîîกี้våååļîîîď]";var linkedChargePointsExplanation="[YYöööūūūŕ çåååŕď wîîîļļ bééé çöööกี้กี้éééçṫéééď ṫööö ṫḥééé çḥåååŕǧééé þöööîîîกี้ṫš Ýöööūūū šéééļéééçṫ ḥéééŕééé.]";var noCardsFound="[NNööö çḥåååŕǧééé çåååŕďš ḟöööūūūกี้ď]";var notMyChargeCards="[NNöööṫ mÝ çḥåååŕǧééé çåååŕďš]";var plugAndChargeCard="[PPļūūūǧ & çḥåååŕǧééé çåååŕď]";var serialNumberEmpty="[SSéééŕîîîåååļ กี้ūūūmbéééŕ çåååกี้'ṫ bééé ééémþṫÝ]";var exampleCard="[éééé.ǧ.: EEEN-EEENG-1234567-X]";var ChargeCardPSEUDO = {authenticationChargeCard:authenticationChargeCard,chargeCardExpired:chargeCardExpired,defaultCard:defaultCard,deleteCardDialog:deleteCardDialog,duplicateCard:duplicateCard,excluded:excluded,excludedOnChargePoints:excludedOnChargePoints,excludedOnExplanation:excludedOnExplanation,invalidCardNumber:invalidCardNumber,linkedChargePointsExplanation:linkedChargePointsExplanation,noCardsFound:noCardsFound,notMyChargeCards:notMyChargeCards,plugAndChargeCard:plugAndChargeCard,serialNumberEmpty:serialNumberEmpty,exampleCard:exampleCard};

var error$2={noDataFound:"Geen data beschikbaar"};var graph$2={ampere:"-> Ampère",kwh:"-> kWh",time:"-> Tijd"};var legend$2={averageOneChargePoint:"Laadpunt gemiddelde fase 1",averageOneGrid:"Grid gemiddelde fase 1",averageThreeChargePoint:"Laadpunt gemiddelde 3",averageThreeGrid:"Grid gemiddelde fase 3",averageTwoChargePoint:"Laadpunt gemiddelde fase 2",averageTwoGrid:"Grid gemiddelde fase 2",chargedKwhChargePoint:"kWh geladen bij laadpunt",legend:"Legenda:",maxReservedCurrent:"Maximaal gereserveerd voor laadpunt",offlineCurrent:"Standaard offline stroomwaarde bij laden",phaseOneChargePoint:"Laadpunt fase 1",phaseOneGrid:"Grid fase 1",phaseThreeChargePoint:"Laadpunt fase 3",phaseThreeGrid:"Grid fase 3",phaseTwoChargePoint:"Laadpunt fase 2",phaseTwoGrid:"Grid fase 2"};var names$2={average:"Gemiddelde verbruik van huis en laadpunt",household:"Verbruik van huis en laadpunt",lastSession:"Laatste laadsessie",smartChargingDataTransfer:"Beschikbare stroom, ten opzichte van daadwerkelijk gebruikt"};var tooltip$2={time:"Tijd: ",value:"Waarde: "};var InsightsNL = {error:error$2,graph:graph$2,legend:legend$2,names:names$2,tooltip:tooltip$2};

var error$1={noDataFound:"No data available"};var graph$1={ampere:"-> Ampere",kwh:"-> kWh",time:"-> Time"};var legend$1={averageOneChargePoint:"Average of charge point phase 1",averageOneGrid:"Average of grid phase 1",averageThreeChargePoint:"Average of charge point phase 3",averageThreeGrid:"Average of grid phase 3",averageTwoChargePoint:"Average of charge point phase 2",averageTwoGrid:"Average of grid phase 2",chargedKwhChargePoint:"kWh charged at charge point",legend:"Legend:",maxReservedCurrent:"Maximum reserved for the charge point",offlineCurrent:"The default offline current",phaseOneChargePoint:"Charge point phase 1",phaseOneGrid:"Grid phase 1",phaseThreeChargePoint:"Charge point phase 3",phaseThreeGrid:"Grid phase 3",phaseTwoChargePoint:"Charge point phase 2",phaseTwoGrid:"Grid phase 2"};var names$1={average:"Average of house and charge point",household:"Usage in house and charge point",lastSession:"Last charge session",smartChargingDataTransfer:"Actual usage of the car"};var tooltip$1={time:"Time: ",value:"Value: "};var InsightsEN = {error:error$1,graph:graph$1,legend:legend$1,names:names$1,tooltip:tooltip$1};

var InsightsFR = {};

var error={noDataFound:"[NNööö ďåååṫååå åååvåååîîîļåååbļééé]"};var graph={ampere:"[--> AAAmþéééŕééé]",kwh:"[--> ḱWḥ]",time:"[--> Tîîîmééé]"};var legend={averageOneChargePoint:"[AAAAvéééŕåååǧééé öööḟ çḥåååŕǧééé þöööîîîกี้ṫ þḥåååšééé 1]",averageOneGrid:"[AAAAvéééŕåååǧééé öööḟ ǧŕîîîď þḥåååšééé 1]",averageThreeChargePoint:"[AAAAvéééŕåååǧééé öööḟ çḥåååŕǧééé þöööîîîกี้ṫ þḥåååšééé 3]",averageThreeGrid:"[AAAAvéééŕåååǧééé öööḟ ǧŕîîîď þḥåååšééé 3]",averageTwoChargePoint:"[AAAAvéééŕåååǧééé öööḟ çḥåååŕǧééé þöööîîîกี้ṫ þḥåååšééé 2]",averageTwoGrid:"[AAAAvéééŕåååǧééé öööḟ ǧŕîîîď þḥåååšééé 2]",chargedKwhChargePoint:"[ḱḱWḥ çḥåååŕǧéééď åååṫ çḥåååŕǧééé þöööîîîกี้ṫ]",legend:"[LLéééǧéééกี้ď:]",maxReservedCurrent:"[MMåååxîîîmūūūm ŕéééšéééŕvéééď ḟöööŕ ṫḥééé çḥåååŕǧééé þöööîîîกี้ṫ]",offlineCurrent:"[TTḥééé ďéééḟåååūūūļṫ öööḟḟļîîîกี้ééé çūūūŕŕéééกี้ṫ]",phaseOneChargePoint:"[CCḥåååŕǧééé þöööîîîกี้ṫ þḥåååšééé 1]",phaseOneGrid:"[GGŕîîîď þḥåååšééé 1]",phaseThreeChargePoint:"[CCḥåååŕǧééé þöööîîîกี้ṫ þḥåååšééé 3]",phaseThreeGrid:"[GGŕîîîď þḥåååšééé 3]",phaseTwoChargePoint:"[CCḥåååŕǧééé þöööîîîกี้ṫ þḥåååšééé 2]",phaseTwoGrid:"[GGŕîîîď þḥåååšééé 2]"};var names={average:"[AAAAvéééŕåååǧééé öööḟ ḥöööūūūšééé åååกี้ď çḥåååŕǧééé þöööîîîกี้ṫ]",household:"[UUUUšåååǧééé îîîกี้ ḥöööūūūšééé åååกี้ď çḥåååŕǧééé þöööîîîกี้ṫ]",lastSession:"[LLåååšṫ çḥåååŕǧééé šéééššîîîöööกี้]",smartChargingDataTransfer:"[AAAAçṫūūūåååļ ūūūšåååǧééé öööḟ ṫḥééé çåååŕ]"};var tooltip={time:"[TTîîîmééé: ]",value:"[VVåååļūūūééé: ]"};var InsightsPSEUDO = {error:error,graph:graph,legend:legend,names:names,tooltip:tooltip};

var unsuccessful$2={duplicate:"Je staat al in de wachtrij",freestation:"Laadpunt vrij. Je kan beginnen met laden",notConfirmed:"Je registratie is nog niet voltooid",unauthorised:"Je hebt geen toegang"};var ParkingNL = {unsuccessful:unsuccessful$2};

var unsuccessful$1={duplicate:"You're already waiting in the queue",freestation:"Charge point available. You're ready to charge",notConfirmed:"Your registration isn't complete",unauthorised:"You're not authorised"};var ParkingEN = {unsuccessful:unsuccessful$1};

var ParkingFR = {};

var unsuccessful={duplicate:"[YYöööūūū'ŕééé åååļŕéééåååďÝ wåååîîîṫîîîกี้ǧ îîîกี้ ṫḥééé qūūūéééūūūééé]",freestation:"[CCḥåååŕǧééé þöööîîîกี้ṫ åååvåååîîîļåååbļééé. Yöööūūū'ŕééé ŕéééåååďÝ ṫööö çḥåååŕǧééé]",notConfirmed:"[YYöööūūūŕ ŕéééǧîîîšṫŕåååṫîîîöööกี้ îîîšกี้'ṫ çööömþļéééṫééé]",unauthorised:"[YYöööūūū'ŕééé กี้öööṫ åååūūūṫḥöööŕîîîšéééď]"};var ParkingPSEUDO = {unsuccessful:unsuccessful};

var AFG$3="Afghanistan";var ALB$3="Albanië";var DZA$3="Algeria";var ASM$3="Amerikaans-Samoa";var AND$3="Andorra";var AGO$3="Angola";var AIA$3="Anguilla";var ATA$3="Antarctica";var ATG$3="Antigua en Barbuda";var ARG$3="Argentinië";var ARM$3="Armenië";var ABW$3="Aruba";var AUS$3="Australië";var AUT$3="Oostenrijk";var AZE$3="Azerbeidzjan";var BHS$3="Bahama's";var BHR$3="Bahrein";var BGD$3="Bangladesh";var BRB$3="Barbados";var BLR$3="Wit-Rusland";var BEL$3="België";var BLZ$3="Belize";var BEN$3="Benin";var BMU$3="Bermuda";var BTN$3="Bhutan";var BOL$3="Bolivia, Plurinationale staat van";var BES$3="Bonaire, Sint Eustatius en Saba";var BIH$3="Bosnië en Herzegovina";var BWA$3="Botswana";var BRA$3="Brazilië";var IOT$3="Brits Territorium in de Indische Oceaan";var BRN$3="Brunei Darussalam";var BGR$3="Bulgarije";var BFA$3="Burkina Faso";var BDI$3="Burundi";var KHM$3="Cambodja";var CMR$3="Kameroen";var CAN$3="Canada";var CPV$3="Cape Verde";var CYM$3="Kaaimaneilanden";var CAF$3="Centraal-Afrikaanse Republiek";var TCD$3="Chad";var CHL$3="Chili";var CHN$3="China";var CXR$3="Kerstmis Eiland";var CCK$3="Cocos (Keeling) Eilanden";var COL$3="Colombia";var COM$3="Comoren";var COG$3="Congo";var COD$3="Congo, de Democratische Republiek Congo";var COK$3="Cook Eilanden";var CRI$3="Costa Rica";var HRV$3="Kroatië";var CUB$3="Cuba";var CUW$3="Curaçao";var CYP$3="Cyprus";var CZE$3="Tsjechië";var CIV$3="Ivoorkust";var DNK$3="Denemarken";var DJI$3="Djibouti";var DMA$3="Dominica";var DOM$3="Dominicaanse Republiek";var ECU$3="Ecuador";var EGY$3="Egypte";var SLV$3="El Salvador";var GNQ$3="Equatoriaal-Guinea";var ERI$3="Eritrea";var EST$3="Estland";var ETH$3="Ethiopië";var FLK$3="Falklandeilanden (Malvinas)";var FRO$3="Faeröer";var FJI$3="Fiji";var FIN$3="Finland";var FRA$3="Frankrijk";var GUF$3="Frans Guyana";var PYF$3="Frans Polynesië";var ATF$3="Franse zuidelijke gebieden";var GAB$3="Gabon";var GMB$3="Gambia";var GEO$3="Georgië";var DEU$3="Duitsland";var GHA$3="Ghana";var GIB$3="Gibraltar";var GRC$3="Griekenland";var GRL$3="Greenland";var GRD$3="Grenada";var GLP$3="Guadeloupe";var GUM$3="Guam";var GTM$3="Guatemala";var GGY$3="Guernsey";var GIN$3="Guinee";var GNB$3="Guinee-Bissau";var GUY$3="Guyana";var HTI$3="Haïti";var VAT$3="Heilige Stoel (Vaticaanstad)";var HND$3="Honduras";var HKG$3="Hongkong";var HUN$3="Hongarije";var ISL$3="IJsland";var IND$3="India";var IDN$3="Indonesië";var IRN$3="Iran, Islamitische Republiek";var IRQ$3="Irak";var IRL$3="Ierland";var IMN$3="Eiland Man";var ISR$3="Israël";var ITA$3="Italië";var JAM$3="Jamaica";var JPN$3="Japan";var JEY$3="Jersey";var JOR$3="Jordan";var KAZ$3="Kazachstan";var KEN$3="Kenia";var KIR$3="Kiribati";var PRK$3="Noord-Korea";var KOR$3="Zuid-Korea";var XXK$3="Kosovo";var KWT$3="Koeweit";var KGZ$3="Kirgizië";var LAO$3="Democratische Volksrepubliek Laos";var LVA$3="Letland";var LBN$3="Libanon";var LSO$3="Lesotho";var LBR$3="Liberia";var LBY$3="Libië";var LIE$3="Liechtenstein";var LTU$3="Litouwen";var LUX$3="Luxemburg";var MAC$3="Macau";var MDG$3="Madagaskar";var MWI$3="Malawi";var MYS$3="Maleisië";var MDV$3="Malediven";var MLI$3="Mali";var MLT$3="Malta";var MHL$3="Marshalleilanden";var MTQ$3="Martinique";var MRT$3="Mauritanië";var MUS$3="Mauritius";var MYT$3="Mayotte";var MEX$3="Mexico";var FSM$3="Micronesië, Federale Staten van";var MDA$3="Moldavië, Republiek";var MCO$3="Monaco";var MNG$3="Mongolië";var MNE$3="Montenegro";var MSR$3="Montserrat";var MAR$3="Marokko";var MOZ$3="Mozambique";var MMR$3="Myanmar";var NAM$3="Namibië";var NRU$3="Nauru";var NPL$3="Nepal";var NLD$3="Nederland";var NCL$3="Nieuw-Caledonië";var NZL$3="Nieuw-Zeeland";var NIC$3="Nicaragua";var NER$3="Niger";var NGA$3="Nigeria";var NIU$3="Niue";var NFK$3="Norfolk Eiland";var MKD$3="Noord-Macedonië";var MNP$3="Noordelijke Marianen";var NOR$3="Noorwegen";var OMN$3="Oman";var PAK$3="Pakistan";var PLW$3="Palau";var PSE$3="Palestina, Staat";var PAN$3="Panama";var PNG$3="Papoea-Nieuw-Guinea";var PRY$3="Paraguay";var PER$3="Peru";var PHL$3="Filipijnen";var PCN$3="Pitcairn";var POL$3="Polen";var PRT$3="Portugal";var PRI$3="Puerto Rico";var QAT$3="Qatar";var ROU$3="Roemenië";var RUS$3="Russische Federatie";var RWA$3="Rwanda";var REU$3="Vergadering";var BLM$3="Saint Barthélemy";var SHN$3="Sint Helena, Hemelvaart en Tristan da Cunha";var KNA$3="Saint Kitts en Nevis";var LCA$3="Saint Lucia";var MAF$3="Sint Maarten (Frans deel)";var SPM$3="Saint-Pierre en Miquelon";var VCT$3="Saint Vincent en de Grenadines";var WSM$3="Samoa";var SMR$3="San Marino";var STP$3="Sao Tomé en Principe";var SAU$3="Saoedi-Arabië";var SEN$3="Senegal";var SRB$3="Servië";var SYC$3="Seychellen";var SLE$3="Sierra Leone";var SGP$3="Singapore";var SXM$3="Sint Maarten (Dutch part)";var SVK$3="Slowakije";var SVN$3="Slovenië";var SLB$3="Salomoneilanden";var SOM$3="Somalië";var ZAF$3="Zuid-Afrika";var SGS$3="Zuid-Georgië en de Zuidelijke Sandwicheilanden";var SSD$3="Zuid-Soedan";var ESP$3="Spanje";var LKA$3="Sri Lanka";var SDN$3="Soedan";var SUR$3="Suriname";var SJM$3="Spitsbergen en Jan Mayen";var SWZ$3="Swaziland";var SWE$3="Zweden";var CHE$3="Zwitserland";var SYR$3="Arabische Republiek Syrië";var TWN$3="Taiwan, provincie China";var TJK$3="Tadzjikistan";var TZA$3="Tanzania, Verenigde Republiek";var THA$3="Thailand";var TLS$3="Oost-Timor";var TGO$3="Togo";var TKL$3="Tokelau";var TON$3="Tonga";var TTO$3="Trinidad en Tobago";var TUN$3="Tunesië";var TUR$3="Kalkoen";var TKM$3="Turkmenistan";var TCA$3="Turks- en Caicoseilanden";var TUV$3="Tuvalu";var UGA$3="Oeganda";var UKR$3="Oekraïne";var ARE$3="Verenigde Arabische Emiraten";var GBR$3="Verenigd Koninkrijk";var USA$3="Verenigde Staten";var UMI$3="Amerikaanse ondergeschikte afgelegen eilanden";var URY$3="Uruguay";var UZB$3="Oezbekistan";var VUT$3="Vanuatu";var VEN$3="Venezuela, Bolivariaanse Republiek";var VNM$3="Viet Nam";var VGB$3="Maagdeneilanden, Britse";var VIR$3="Maagdeneilanden, VS";var WLF$3="Wallis en Futuna";var YEM$3="Jemen";var ZMB$3="Zambia";var ZWE$3="Zimbabwe";var ALA$3="Åland-eilanden";var CountryNL = {AFG:AFG$3,ALB:ALB$3,DZA:DZA$3,ASM:ASM$3,AND:AND$3,AGO:AGO$3,AIA:AIA$3,ATA:ATA$3,ATG:ATG$3,ARG:ARG$3,ARM:ARM$3,ABW:ABW$3,AUS:AUS$3,AUT:AUT$3,AZE:AZE$3,BHS:BHS$3,BHR:BHR$3,BGD:BGD$3,BRB:BRB$3,BLR:BLR$3,BEL:BEL$3,BLZ:BLZ$3,BEN:BEN$3,BMU:BMU$3,BTN:BTN$3,BOL:BOL$3,BES:BES$3,BIH:BIH$3,BWA:BWA$3,BRA:BRA$3,IOT:IOT$3,BRN:BRN$3,BGR:BGR$3,BFA:BFA$3,BDI:BDI$3,KHM:KHM$3,CMR:CMR$3,CAN:CAN$3,CPV:CPV$3,CYM:CYM$3,CAF:CAF$3,TCD:TCD$3,CHL:CHL$3,CHN:CHN$3,CXR:CXR$3,CCK:CCK$3,COL:COL$3,COM:COM$3,COG:COG$3,COD:COD$3,COK:COK$3,CRI:CRI$3,HRV:HRV$3,CUB:CUB$3,CUW:CUW$3,CYP:CYP$3,CZE:CZE$3,CIV:CIV$3,DNK:DNK$3,DJI:DJI$3,DMA:DMA$3,DOM:DOM$3,ECU:ECU$3,EGY:EGY$3,SLV:SLV$3,GNQ:GNQ$3,ERI:ERI$3,EST:EST$3,ETH:ETH$3,FLK:FLK$3,FRO:FRO$3,FJI:FJI$3,FIN:FIN$3,FRA:FRA$3,GUF:GUF$3,PYF:PYF$3,ATF:ATF$3,GAB:GAB$3,GMB:GMB$3,GEO:GEO$3,DEU:DEU$3,GHA:GHA$3,GIB:GIB$3,GRC:GRC$3,GRL:GRL$3,GRD:GRD$3,GLP:GLP$3,GUM:GUM$3,GTM:GTM$3,GGY:GGY$3,GIN:GIN$3,GNB:GNB$3,GUY:GUY$3,HTI:HTI$3,VAT:VAT$3,HND:HND$3,HKG:HKG$3,HUN:HUN$3,ISL:ISL$3,IND:IND$3,IDN:IDN$3,IRN:IRN$3,IRQ:IRQ$3,IRL:IRL$3,IMN:IMN$3,ISR:ISR$3,ITA:ITA$3,JAM:JAM$3,JPN:JPN$3,JEY:JEY$3,JOR:JOR$3,KAZ:KAZ$3,KEN:KEN$3,KIR:KIR$3,PRK:PRK$3,KOR:KOR$3,XXK:XXK$3,KWT:KWT$3,KGZ:KGZ$3,LAO:LAO$3,LVA:LVA$3,LBN:LBN$3,LSO:LSO$3,LBR:LBR$3,LBY:LBY$3,LIE:LIE$3,LTU:LTU$3,LUX:LUX$3,MAC:MAC$3,MDG:MDG$3,MWI:MWI$3,MYS:MYS$3,MDV:MDV$3,MLI:MLI$3,MLT:MLT$3,MHL:MHL$3,MTQ:MTQ$3,MRT:MRT$3,MUS:MUS$3,MYT:MYT$3,MEX:MEX$3,FSM:FSM$3,MDA:MDA$3,MCO:MCO$3,MNG:MNG$3,MNE:MNE$3,MSR:MSR$3,MAR:MAR$3,MOZ:MOZ$3,MMR:MMR$3,NAM:NAM$3,NRU:NRU$3,NPL:NPL$3,NLD:NLD$3,NCL:NCL$3,NZL:NZL$3,NIC:NIC$3,NER:NER$3,NGA:NGA$3,NIU:NIU$3,NFK:NFK$3,MKD:MKD$3,MNP:MNP$3,NOR:NOR$3,OMN:OMN$3,PAK:PAK$3,PLW:PLW$3,PSE:PSE$3,PAN:PAN$3,PNG:PNG$3,PRY:PRY$3,PER:PER$3,PHL:PHL$3,PCN:PCN$3,POL:POL$3,PRT:PRT$3,PRI:PRI$3,QAT:QAT$3,ROU:ROU$3,RUS:RUS$3,RWA:RWA$3,REU:REU$3,BLM:BLM$3,SHN:SHN$3,KNA:KNA$3,LCA:LCA$3,MAF:MAF$3,SPM:SPM$3,VCT:VCT$3,WSM:WSM$3,SMR:SMR$3,STP:STP$3,SAU:SAU$3,SEN:SEN$3,SRB:SRB$3,SYC:SYC$3,SLE:SLE$3,SGP:SGP$3,SXM:SXM$3,SVK:SVK$3,SVN:SVN$3,SLB:SLB$3,SOM:SOM$3,ZAF:ZAF$3,SGS:SGS$3,SSD:SSD$3,ESP:ESP$3,LKA:LKA$3,SDN:SDN$3,SUR:SUR$3,SJM:SJM$3,SWZ:SWZ$3,SWE:SWE$3,CHE:CHE$3,SYR:SYR$3,TWN:TWN$3,TJK:TJK$3,TZA:TZA$3,THA:THA$3,TLS:TLS$3,TGO:TGO$3,TKL:TKL$3,TON:TON$3,TTO:TTO$3,TUN:TUN$3,TUR:TUR$3,TKM:TKM$3,TCA:TCA$3,TUV:TUV$3,UGA:UGA$3,UKR:UKR$3,ARE:ARE$3,GBR:GBR$3,USA:USA$3,UMI:UMI$3,URY:URY$3,UZB:UZB$3,VUT:VUT$3,VEN:VEN$3,VNM:VNM$3,VGB:VGB$3,VIR:VIR$3,WLF:WLF$3,YEM:YEM$3,ZMB:ZMB$3,ZWE:ZWE$3,ALA:ALA$3};

var AFG$2="Afghanistan";var ALB$2="Albania";var DZA$2="Algeria";var ASM$2="American Samoa";var AND$2="Andorra";var AGO$2="Angola";var AIA$2="Anguilla";var ATA$2="Antarctica";var ATG$2="Antigua and Barbuda";var ARG$2="Argentina";var ARM$2="Armenia";var ABW$2="Aruba";var AUS$2="Australia";var AUT$2="Austria";var AZE$2="Azerbaijan";var BHS$2="Bahamas";var BHR$2="Bahrain";var BGD$2="Bangladesh";var BRB$2="Barbados";var BLR$2="Belarus";var BEL$2="Belgium";var BLZ$2="Belize";var BEN$2="Benin";var BMU$2="Bermuda";var BTN$2="Bhutan";var BOL$2="Bolivia, Plurinational State of";var BES$2="Bonaire, Sint Eustatius and Saba";var BIH$2="Bosnia and Herzegovina";var BWA$2="Botswana";var BRA$2="Brazil";var IOT$2="British Indian Ocean Territory";var BRN$2="Brunei Darussalam";var BGR$2="Bulgaria";var BFA$2="Burkina Faso";var BDI$2="Burundi";var KHM$2="Cambodia";var CMR$2="Cameroon";var CAN$2="Canada";var CPV$2="Cape Verde";var CYM$2="Cayman Islands";var CAF$2="Central African Republic";var TCD$2="Chad";var CHL$2="Chile";var CHN$2="China";var CXR$2="Christmas Island";var CCK$2="Cocos (Keeling) Islands";var COL$2="Colombia";var COM$2="Comoros";var COG$2="Congo";var COD$2="Congo, the Democratic Republic of the";var COK$2="Cook Islands";var CRI$2="Costa Rica";var HRV$2="Croatia";var CUB$2="Cuba";var CUW$2="Curaçao";var CYP$2="Cyprus";var CZE$2="Czech Republic";var CIV$2="Ivory Coast";var DNK$2="Denmark";var DJI$2="Djibouti";var DMA$2="Dominica";var DOM$2="Dominican Republic";var ECU$2="Ecuador";var EGY$2="Egypt";var SLV$2="El Salvador";var GNQ$2="Equatorial Guinea";var ERI$2="Eritrea";var EST$2="Estonia";var ETH$2="Ethiopia";var FLK$2="Falkland Islands (Malvinas)";var FRO$2="Faroe Islands";var FJI$2="Fiji";var FIN$2="Finland";var FRA$2="France";var GUF$2="French Guiana";var PYF$2="French Polynesia";var ATF$2="French Southern Territories";var GAB$2="Gabon";var GMB$2="Gambia";var GEO$2="Georgia";var DEU$2="Germany";var GHA$2="Ghana";var GIB$2="Gibraltar";var GRC$2="Greece";var GRL$2="Greenland";var GRD$2="Grenada";var GLP$2="Guadeloupe";var GUM$2="Guam";var GTM$2="Guatemala";var GGY$2="Guernsey";var GIN$2="Guinea";var GNB$2="Guinea-Bissau";var GUY$2="Guyana";var HTI$2="Haiti";var VAT$2="Holy See (Vatican City State)";var HND$2="Honduras";var HKG$2="Hong Kong";var HUN$2="Hungary";var ISL$2="Iceland";var IND$2="India";var IDN$2="Indonesia";var IRN$2="Iran, Islamic Republic of";var IRQ$2="Iraq";var IRL$2="Ireland";var IMN$2="Isle of Man";var ISR$2="Israel";var ITA$2="Italy";var JAM$2="Jamaica";var JPN$2="Japan";var JEY$2="Jersey";var JOR$2="Jordan";var KAZ$2="Kazakhstan";var KEN$2="Kenya";var KIR$2="Kiribati";var PRK$2="North Korea";var KOR$2="South Korea";var XXK$2="Kosovo";var KWT$2="Kuwait";var KGZ$2="Kyrgyzstan";var LAO$2="Lao People's Democratic Republic";var LVA$2="Latvia";var LBN$2="Lebanon";var LSO$2="Lesotho";var LBR$2="Liberia";var LBY$2="Libya";var LIE$2="Liechtenstein";var LTU$2="Lithuania";var LUX$2="Luxembourg";var MAC$2="Macao";var MDG$2="Madagascar";var MWI$2="Malawi";var MYS$2="Malaysia";var MDV$2="Maldives";var MLI$2="Mali";var MLT$2="Malta";var MHL$2="Marshall Islands";var MTQ$2="Martinique";var MRT$2="Mauritania";var MUS$2="Mauritius";var MYT$2="Mayotte";var MEX$2="Mexico";var FSM$2="Micronesia, Federated States of";var MDA$2="Moldova, Republic of";var MCO$2="Monaco";var MNG$2="Mongolia";var MNE$2="Montenegro";var MSR$2="Montserrat";var MAR$2="Morocco";var MOZ$2="Mozambique";var MMR$2="Myanmar";var NAM$2="Namibia";var NRU$2="Nauru";var NPL$2="Nepal";var NLD$2="Netherlands";var NCL$2="New Caledonia";var NZL$2="New Zealand";var NIC$2="Nicaragua";var NER$2="Niger";var NGA$2="Nigeria";var NIU$2="Niue";var NFK$2="Norfolk Island";var MKD$2="North Macedonia, Republic of";var MNP$2="Northern Mariana Islands";var NOR$2="Norway";var OMN$2="Oman";var PAK$2="Pakistan";var PLW$2="Palau";var PSE$2="Palestine, State of";var PAN$2="Panama";var PNG$2="Papua New Guinea";var PRY$2="Paraguay";var PER$2="Peru";var PHL$2="Philippines";var PCN$2="Pitcairn";var POL$2="Poland";var PRT$2="Portugal";var PRI$2="Puerto Rico";var QAT$2="Qatar";var ROU$2="Romania";var RUS$2="Russian Federation";var RWA$2="Rwanda";var REU$2="Meeting";var BLM$2="Saint Barthélemy";var SHN$2="Saint Helena, Ascension and Tristan da Cunha";var KNA$2="Saint Kitts and Nevis";var LCA$2="Saint Lucia";var MAF$2="Saint Martin (French part)";var SPM$2="Saint Pierre and Miquelon";var VCT$2="Saint Vincent and the Grenadines";var WSM$2="Samoa";var SMR$2="San Marino";var STP$2="Sao Tome and Principe";var SAU$2="Saudi Arabia";var SEN$2="Senegal";var SRB$2="Serbia";var SYC$2="Seychelles";var SLE$2="Sierra Leone";var SGP$2="Singapore";var SXM$2="Saint Martin (Dutch part)";var SVK$2="Slovakia";var SVN$2="Slovenia";var SLB$2="Solomon Islands";var SOM$2="Somalia";var ZAF$2="South Africa";var SGS$2="South Georgia and the South Sandwich Islands";var SSD$2="South Sudan";var ESP$2="Spain";var LKA$2="Sri Lanka";var SDN$2="Sudan";var SUR$2="Suriname";var SJM$2="Svalbard and Jan Mayen";var SWZ$2="Swaziland";var SWE$2="Sweden";var CHE$2="Switzerland";var SYR$2="Syrian Arab Republic";var TWN$2="Taiwan, Province of China";var TJK$2="Tajikistan";var TZA$2="Tanzania, United Republic of";var THA$2="Thailand";var TLS$2="East Timor";var TGO$2="Togo";var TKL$2="Tokelau";var TON$2="Tonga";var TTO$2="Trinidad and Tobago";var TUN$2="Tunisia";var TUR$2="Turkey";var TKM$2="Turkmenistan";var TCA$2="Turks and Caicos Islands";var TUV$2="Tuvalu";var UGA$2="Uganda";var UKR$2="Ukraine";var ARE$2="United Arab Emirates";var GBR$2="United Kingdom";var USA$2="United States";var UMI$2="United States Minor Outlying Islands";var URY$2="Uruguay";var UZB$2="Uzbekistan";var VUT$2="Vanuatu";var VEN$2="Venezuela, Bolivarian Republic of";var VNM$2="Viet Nam";var VGB$2="Virgin Islands, British";var VIR$2="Virgin Islands, U.S.";var WLF$2="Wallis and Futuna";var YEM$2="Yemen";var ZMB$2="Zambia";var ZWE$2="Zimbabwe";var ALA$2="Åland Islands";var CountryEN = {AFG:AFG$2,ALB:ALB$2,DZA:DZA$2,ASM:ASM$2,AND:AND$2,AGO:AGO$2,AIA:AIA$2,ATA:ATA$2,ATG:ATG$2,ARG:ARG$2,ARM:ARM$2,ABW:ABW$2,AUS:AUS$2,AUT:AUT$2,AZE:AZE$2,BHS:BHS$2,BHR:BHR$2,BGD:BGD$2,BRB:BRB$2,BLR:BLR$2,BEL:BEL$2,BLZ:BLZ$2,BEN:BEN$2,BMU:BMU$2,BTN:BTN$2,BOL:BOL$2,BES:BES$2,BIH:BIH$2,BWA:BWA$2,BRA:BRA$2,IOT:IOT$2,BRN:BRN$2,BGR:BGR$2,BFA:BFA$2,BDI:BDI$2,KHM:KHM$2,CMR:CMR$2,CAN:CAN$2,CPV:CPV$2,CYM:CYM$2,CAF:CAF$2,TCD:TCD$2,CHL:CHL$2,CHN:CHN$2,CXR:CXR$2,CCK:CCK$2,COL:COL$2,COM:COM$2,COG:COG$2,COD:COD$2,COK:COK$2,CRI:CRI$2,HRV:HRV$2,CUB:CUB$2,CUW:CUW$2,CYP:CYP$2,CZE:CZE$2,CIV:CIV$2,DNK:DNK$2,DJI:DJI$2,DMA:DMA$2,DOM:DOM$2,ECU:ECU$2,EGY:EGY$2,SLV:SLV$2,GNQ:GNQ$2,ERI:ERI$2,EST:EST$2,ETH:ETH$2,FLK:FLK$2,FRO:FRO$2,FJI:FJI$2,FIN:FIN$2,FRA:FRA$2,GUF:GUF$2,PYF:PYF$2,ATF:ATF$2,GAB:GAB$2,GMB:GMB$2,GEO:GEO$2,DEU:DEU$2,GHA:GHA$2,GIB:GIB$2,GRC:GRC$2,GRL:GRL$2,GRD:GRD$2,GLP:GLP$2,GUM:GUM$2,GTM:GTM$2,GGY:GGY$2,GIN:GIN$2,GNB:GNB$2,GUY:GUY$2,HTI:HTI$2,VAT:VAT$2,HND:HND$2,HKG:HKG$2,HUN:HUN$2,ISL:ISL$2,IND:IND$2,IDN:IDN$2,IRN:IRN$2,IRQ:IRQ$2,IRL:IRL$2,IMN:IMN$2,ISR:ISR$2,ITA:ITA$2,JAM:JAM$2,JPN:JPN$2,JEY:JEY$2,JOR:JOR$2,KAZ:KAZ$2,KEN:KEN$2,KIR:KIR$2,PRK:PRK$2,KOR:KOR$2,XXK:XXK$2,KWT:KWT$2,KGZ:KGZ$2,LAO:LAO$2,LVA:LVA$2,LBN:LBN$2,LSO:LSO$2,LBR:LBR$2,LBY:LBY$2,LIE:LIE$2,LTU:LTU$2,LUX:LUX$2,MAC:MAC$2,MDG:MDG$2,MWI:MWI$2,MYS:MYS$2,MDV:MDV$2,MLI:MLI$2,MLT:MLT$2,MHL:MHL$2,MTQ:MTQ$2,MRT:MRT$2,MUS:MUS$2,MYT:MYT$2,MEX:MEX$2,FSM:FSM$2,MDA:MDA$2,MCO:MCO$2,MNG:MNG$2,MNE:MNE$2,MSR:MSR$2,MAR:MAR$2,MOZ:MOZ$2,MMR:MMR$2,NAM:NAM$2,NRU:NRU$2,NPL:NPL$2,NLD:NLD$2,NCL:NCL$2,NZL:NZL$2,NIC:NIC$2,NER:NER$2,NGA:NGA$2,NIU:NIU$2,NFK:NFK$2,MKD:MKD$2,MNP:MNP$2,NOR:NOR$2,OMN:OMN$2,PAK:PAK$2,PLW:PLW$2,PSE:PSE$2,PAN:PAN$2,PNG:PNG$2,PRY:PRY$2,PER:PER$2,PHL:PHL$2,PCN:PCN$2,POL:POL$2,PRT:PRT$2,PRI:PRI$2,QAT:QAT$2,ROU:ROU$2,RUS:RUS$2,RWA:RWA$2,REU:REU$2,BLM:BLM$2,SHN:SHN$2,KNA:KNA$2,LCA:LCA$2,MAF:MAF$2,SPM:SPM$2,VCT:VCT$2,WSM:WSM$2,SMR:SMR$2,STP:STP$2,SAU:SAU$2,SEN:SEN$2,SRB:SRB$2,SYC:SYC$2,SLE:SLE$2,SGP:SGP$2,SXM:SXM$2,SVK:SVK$2,SVN:SVN$2,SLB:SLB$2,SOM:SOM$2,ZAF:ZAF$2,SGS:SGS$2,SSD:SSD$2,ESP:ESP$2,LKA:LKA$2,SDN:SDN$2,SUR:SUR$2,SJM:SJM$2,SWZ:SWZ$2,SWE:SWE$2,CHE:CHE$2,SYR:SYR$2,TWN:TWN$2,TJK:TJK$2,TZA:TZA$2,THA:THA$2,TLS:TLS$2,TGO:TGO$2,TKL:TKL$2,TON:TON$2,TTO:TTO$2,TUN:TUN$2,TUR:TUR$2,TKM:TKM$2,TCA:TCA$2,TUV:TUV$2,UGA:UGA$2,UKR:UKR$2,ARE:ARE$2,GBR:GBR$2,USA:USA$2,UMI:UMI$2,URY:URY$2,UZB:UZB$2,VUT:VUT$2,VEN:VEN$2,VNM:VNM$2,VGB:VGB$2,VIR:VIR$2,WLF:WLF$2,YEM:YEM$2,ZMB:ZMB$2,ZWE:ZWE$2,ALA:ALA$2};

var AFG$1="Afghanistan";var ALB$1="Albanie";var DZA$1="Algérie";var ASM$1="Samoa américaines";var AND$1="Andorre";var AGO$1="Angola";var AIA$1="Anguilla";var ATA$1="Antarctique";var ATG$1="Antigua et Barbuda";var ARG$1="Argentine";var ARM$1="Arménie";var ABW$1="Aruba";var AUS$1="Australie";var AUT$1="Autriche";var AZE$1="Azerbaïdjan";var BHS$1="Bahamas";var BHR$1="Bahreïn";var BGD$1="Bangladesh";var BRB$1="Barbade";var BLR$1="Bélarus";var BEL$1="Belgique";var BLZ$1="Belize";var BEN$1="Bénin";var BMU$1="Bermudes";var BTN$1="Bhoutan";var BOL$1="Bolivie, État plurinational de";var BES$1="Bonaire, Saint-Eustache et Saba";var BIH$1="Bosnie et Herzégovine";var BWA$1="Botswana";var BRA$1="Brésil";var IOT$1="Territoire britannique de l'océan Indien";var BRN$1="Brunei Darussalam";var BGR$1="Bulgarie";var BFA$1="Burkina Faso";var BDI$1="Burundi";var KHM$1="Cambodge";var CMR$1="Cameroun";var CAN$1="Canada";var CPV$1="Cap Vert";var CYM$1="Îles Caïmans";var CAF$1="République centrafricaine";var TCD$1="Tchad";var CHL$1="Chili";var CHN$1="Chine";var CXR$1="L'île de Noël";var CCK$1="Îles Cocos (Keeling)";var COL$1="Colombie";var COM$1="Comores";var COG$1="Congo";var COD$1="Congo, République démocratique du";var COK$1="Îles Cook";var CRI$1="Costa Rica";var HRV$1="Croatie";var CUB$1="Cuba";var CUW$1="Curaçao";var CYP$1="Chypre";var CZE$1="République tchèque";var CIV$1="Côte d'Ivoire";var DNK$1="Danemark";var DJI$1="Djibouti";var DMA$1="Dominique";var DOM$1="République dominicaine";var ECU$1="Équateur";var EGY$1="Égypte";var SLV$1="El Salvador";var GNQ$1="Guinée équatoriale";var ERI$1="Erythrée";var EST$1="Estonie";var ETH$1="Éthiopie";var FLK$1="Îles Malouines (Malvinas)";var FRO$1="Îles Féroé";var FJI$1="Fidji";var FIN$1="Finlande";var FRA$1="France";var GUF$1="Guyane française";var PYF$1="Polynésie française";var ATF$1="Terres australes françaises";var GAB$1="Gabon";var GMB$1="Gambie";var GEO$1="Géorgie";var DEU$1="Allemagne";var GHA$1="Ghana";var GIB$1="Gibraltar";var GRC$1="Grèce";var GRL$1="Groenland";var GRD$1="Grenade";var GLP$1="Guadeloupe";var GUM$1="Guam";var GTM$1="Guatemala";var GGY$1="Guernesey";var GIN$1="Guinée";var GNB$1="Guinée-Bissau";var GUY$1="Guyane";var HTI$1="Haïti";var VAT$1="Saint-Siège (État de la Cité du Vatican)";var HND$1="Honduras";var HKG$1="Hong Kong";var HUN$1="Hongrie";var ISL$1="Islande";var IND$1="Inde";var IDN$1="Indonésie";var IRN$1="Iran, République islamique d'";var IRQ$1="L'Irak";var IRL$1="Irlande";var IMN$1="Île de Man";var ISR$1="Israël";var ITA$1="Italie";var JAM$1="Jamaïque";var JPN$1="Japon";var JEY$1="Jersey";var JOR$1="Jordanie";var KAZ$1="Kazakhstan";var KEN$1="Kenya";var KIR$1="Kiribati";var PRK$1="Corée du Nord";var KOR$1="Corée du Sud";var XXK$1="Kosovo";var KWT$1="Koweït";var KGZ$1="Kirghizistan";var LAO$1="République démocratique populaire lao";var LVA$1="Lettonie";var LBN$1="Liban";var LSO$1="Lesotho";var LBR$1="Libéria";var LBY$1="Libye";var LIE$1="Liechtenstein";var LTU$1="Lituanie";var LUX$1="Luxembourg";var MAC$1="Macao";var MDG$1="Madagascar";var MWI$1="Malawi";var MYS$1="Malaisie";var MDV$1="Maldives";var MLI$1="Mali";var MLT$1="Malte";var MHL$1="Îles Marshall";var MTQ$1="Martinique";var MRT$1="Mauritanie";var MUS$1="Maurice";var MYT$1="Mayotte";var MEX$1="Mexique";var FSM$1="Micronésie, États fédérés de";var MDA$1="Moldavie, République de";var MCO$1="Monaco";var MNG$1="Mongolie";var MNE$1="Monténégro";var MSR$1="Montserrat";var MAR$1="Maroc";var MOZ$1="Mozambique";var MMR$1="Myanmar";var NAM$1="Namibie";var NRU$1="Nauru";var NPL$1="Népal";var NLD$1="Pays-Bas";var NCL$1="Nouvelle-Calédonie";var NZL$1="Nouvelle-Zélande";var NIC$1="Nicaragua";var NER$1="Niger";var NGA$1="Nigeria";var NIU$1="Niue";var NFK$1="Île Norfolk";var MKD$1="Macédoine du Nord, République de";var MNP$1="Mariannes du Nord (Îles)";var NOR$1="Norvège";var OMN$1="Oman";var PAK$1="Pakistan";var PLW$1="Palau";var PSE$1="Palestine, État de";var PAN$1="Panama";var PNG$1="Papouasie-Nouvelle-Guinée";var PRY$1="Paraguay";var PER$1="Pérou";var PHL$1="Philippines";var PCN$1="Pitcairn";var POL$1="Pologne";var PRT$1="Portugal";var PRI$1="Porto Rico";var QAT$1="Qatar";var ROU$1="Roumanie";var RUS$1="Fédération de Russie";var RWA$1="Rwanda";var REU$1="Réunion";var BLM$1="Saint Barthélemy";var SHN$1="Sainte-Hélène, Ascension et Tristan da Cunha";var KNA$1="Saint-Kitts-et-Nevis";var LCA$1="Sainte-Lucie";var MAF$1="Saint Martin (partie française)";var SPM$1="Saint-Pierre et Miquelon";var VCT$1="Saint-Vincent-et-les-Grenadines";var WSM$1="Samoa";var SMR$1="Saint-Marin";var STP$1="Sao Tomé et Principe";var SAU$1="Arabie Saoudite";var SEN$1="Sénégal";var SRB$1="Serbie";var SYC$1="Seychelles";var SLE$1="Sierra Leone";var SGP$1="Singapour";var SXM$1="Sint Maarten (partie néerlandaise)";var SVK$1="Slovaquie";var SVN$1="Slovénie";var SLB$1="Îles Salomon";var SOM$1="Somalie";var ZAF$1="Afrique du Sud";var SGS$1="Géorgie du Sud et îles Sandwich du Sud";var SSD$1="Sud Soudan";var ESP$1="Espagne";var LKA$1="Sri Lanka";var SDN$1="Soudan";var SUR$1="Suriname";var SJM$1="Svalbard et Jan Mayen";var SWZ$1="Swaziland";var SWE$1="Suède";var CHE$1="Suisse";var SYR$1="République arabe syrienne";var TWN$1="Taïwan, Province de Chine";var TJK$1="Tadjikistan";var TZA$1="Tanzanie, République unie de";var THA$1="Thaïlande";var TLS$1="Timor oriental";var TGO$1="Togo";var TKL$1="Tokelau";var TON$1="Tonga";var TTO$1="Trinité-et-Tobago";var TUN$1="Tunisie";var TUR$1="Turquie";var TKM$1="Turkménistan";var TCA$1="Îles Turks et Caicos";var TUV$1="Tuvalu";var UGA$1="Ouganda";var UKR$1="Ukraine";var ARE$1="Émirats arabes unis";var GBR$1="Royaume-Uni";var USA$1="États-Unis";var UMI$1="Îles mineures éloignées des États-Unis";var URY$1="Uruguay";var UZB$1="Ouzbékistan";var VUT$1="Vanuatu";var VEN$1="Venezuela, République bolivarienne du";var VNM$1="Viet Nam";var VGB$1="Îles Vierges britanniques";var VIR$1="Îles Vierges, États-Unis";var WLF$1="Wallis et Futuna";var YEM$1="Yémen";var ZMB$1="Zambie";var ZWE$1="Zimbabwe";var ALA$1="Îles Åland";var CountryFR = {AFG:AFG$1,ALB:ALB$1,DZA:DZA$1,ASM:ASM$1,AND:AND$1,AGO:AGO$1,AIA:AIA$1,ATA:ATA$1,ATG:ATG$1,ARG:ARG$1,ARM:ARM$1,ABW:ABW$1,AUS:AUS$1,AUT:AUT$1,AZE:AZE$1,BHS:BHS$1,BHR:BHR$1,BGD:BGD$1,BRB:BRB$1,BLR:BLR$1,BEL:BEL$1,BLZ:BLZ$1,BEN:BEN$1,BMU:BMU$1,BTN:BTN$1,BOL:BOL$1,BES:BES$1,BIH:BIH$1,BWA:BWA$1,BRA:BRA$1,IOT:IOT$1,BRN:BRN$1,BGR:BGR$1,BFA:BFA$1,BDI:BDI$1,KHM:KHM$1,CMR:CMR$1,CAN:CAN$1,CPV:CPV$1,CYM:CYM$1,CAF:CAF$1,TCD:TCD$1,CHL:CHL$1,CHN:CHN$1,CXR:CXR$1,CCK:CCK$1,COL:COL$1,COM:COM$1,COG:COG$1,COD:COD$1,COK:COK$1,CRI:CRI$1,HRV:HRV$1,CUB:CUB$1,CUW:CUW$1,CYP:CYP$1,CZE:CZE$1,CIV:CIV$1,DNK:DNK$1,DJI:DJI$1,DMA:DMA$1,DOM:DOM$1,ECU:ECU$1,EGY:EGY$1,SLV:SLV$1,GNQ:GNQ$1,ERI:ERI$1,EST:EST$1,ETH:ETH$1,FLK:FLK$1,FRO:FRO$1,FJI:FJI$1,FIN:FIN$1,FRA:FRA$1,GUF:GUF$1,PYF:PYF$1,ATF:ATF$1,GAB:GAB$1,GMB:GMB$1,GEO:GEO$1,DEU:DEU$1,GHA:GHA$1,GIB:GIB$1,GRC:GRC$1,GRL:GRL$1,GRD:GRD$1,GLP:GLP$1,GUM:GUM$1,GTM:GTM$1,GGY:GGY$1,GIN:GIN$1,GNB:GNB$1,GUY:GUY$1,HTI:HTI$1,VAT:VAT$1,HND:HND$1,HKG:HKG$1,HUN:HUN$1,ISL:ISL$1,IND:IND$1,IDN:IDN$1,IRN:IRN$1,IRQ:IRQ$1,IRL:IRL$1,IMN:IMN$1,ISR:ISR$1,ITA:ITA$1,JAM:JAM$1,JPN:JPN$1,JEY:JEY$1,JOR:JOR$1,KAZ:KAZ$1,KEN:KEN$1,KIR:KIR$1,PRK:PRK$1,KOR:KOR$1,XXK:XXK$1,KWT:KWT$1,KGZ:KGZ$1,LAO:LAO$1,LVA:LVA$1,LBN:LBN$1,LSO:LSO$1,LBR:LBR$1,LBY:LBY$1,LIE:LIE$1,LTU:LTU$1,LUX:LUX$1,MAC:MAC$1,MDG:MDG$1,MWI:MWI$1,MYS:MYS$1,MDV:MDV$1,MLI:MLI$1,MLT:MLT$1,MHL:MHL$1,MTQ:MTQ$1,MRT:MRT$1,MUS:MUS$1,MYT:MYT$1,MEX:MEX$1,FSM:FSM$1,MDA:MDA$1,MCO:MCO$1,MNG:MNG$1,MNE:MNE$1,MSR:MSR$1,MAR:MAR$1,MOZ:MOZ$1,MMR:MMR$1,NAM:NAM$1,NRU:NRU$1,NPL:NPL$1,NLD:NLD$1,NCL:NCL$1,NZL:NZL$1,NIC:NIC$1,NER:NER$1,NGA:NGA$1,NIU:NIU$1,NFK:NFK$1,MKD:MKD$1,MNP:MNP$1,NOR:NOR$1,OMN:OMN$1,PAK:PAK$1,PLW:PLW$1,PSE:PSE$1,PAN:PAN$1,PNG:PNG$1,PRY:PRY$1,PER:PER$1,PHL:PHL$1,PCN:PCN$1,POL:POL$1,PRT:PRT$1,PRI:PRI$1,QAT:QAT$1,ROU:ROU$1,RUS:RUS$1,RWA:RWA$1,REU:REU$1,BLM:BLM$1,SHN:SHN$1,KNA:KNA$1,LCA:LCA$1,MAF:MAF$1,SPM:SPM$1,VCT:VCT$1,WSM:WSM$1,SMR:SMR$1,STP:STP$1,SAU:SAU$1,SEN:SEN$1,SRB:SRB$1,SYC:SYC$1,SLE:SLE$1,SGP:SGP$1,SXM:SXM$1,SVK:SVK$1,SVN:SVN$1,SLB:SLB$1,SOM:SOM$1,ZAF:ZAF$1,SGS:SGS$1,SSD:SSD$1,ESP:ESP$1,LKA:LKA$1,SDN:SDN$1,SUR:SUR$1,SJM:SJM$1,SWZ:SWZ$1,SWE:SWE$1,CHE:CHE$1,SYR:SYR$1,TWN:TWN$1,TJK:TJK$1,TZA:TZA$1,THA:THA$1,TLS:TLS$1,TGO:TGO$1,TKL:TKL$1,TON:TON$1,TTO:TTO$1,TUN:TUN$1,TUR:TUR$1,TKM:TKM$1,TCA:TCA$1,TUV:TUV$1,UGA:UGA$1,UKR:UKR$1,ARE:ARE$1,GBR:GBR$1,USA:USA$1,UMI:UMI$1,URY:URY$1,UZB:UZB$1,VUT:VUT$1,VEN:VEN$1,VNM:VNM$1,VGB:VGB$1,VIR:VIR$1,WLF:WLF$1,YEM:YEM$1,ZMB:ZMB$1,ZWE:ZWE$1,ALA:ALA$1};

var AFG="[AAAAḟǧḥåååกี้îîîšṫåååกี้]";var ALB="[AAAAļbåååกี้îîîååå]";var DZA="[AAAAļǧéééŕîîîååå]";var ASM="[AAAAméééŕîîîçåååกี้ Såååmöööååå]";var AND="[AAAAกี้ďöööŕŕååå]";var AGO="[AAAAกี้ǧöööļååå]";var AIA="[AAAAกี้ǧūūūîîîļļååå]";var ATA="[AAAAกี้ṫåååŕçṫîîîçååå]";var ATG="[AAAAกี้ṫîîîǧūūūååå åååกี้ď Båååŕbūūūďååå]";var ARG="[AAAAŕǧéééกี้ṫîîîกี้ååå]";var ARM="[AAAAŕméééกี้îîîååå]";var ABW="[AAAAŕūūūbååå]";var AUS="[AAAAūūūšṫŕåååļîîîååå]";var AUT="[AAAAūūūšṫŕîîîååå]";var AZE="[AAAAžéééŕbåååîîîĵåååกี้]";var BHS="[BBåååḥåååmåååš]";var BHR="[BBåååḥŕåååîîîกี้]";var BGD="[BBåååกี้ǧļåååďéééšḥ]";var BRB="[BBåååŕbåååďöööš]";var BLR="[BBéééļåååŕūūūš]";var BEL="[BBéééļǧîîîūūūm]";var BLZ="[BBéééļîîîžééé]";var BEN="[BBéééกี้îîîกี้]";var BMU="[BBéééŕmūūūďååå]";var BTN="[BBḥūūūṫåååกี้]";var BOL="[BBöööļîîîvîîîååå, Pļūūūŕîîîกี้åååṫîîîöööกี้åååļ Sṫåååṫééé öööḟ]";var BES="[BBöööกี้åååîîîŕééé, Sîîîกี้ṫ EEEūūūšṫåååṫîîîūūūš åååกี้ď Såååbååå]";var BIH="[BBöööšกี้îîîååå åååกี้ď Héééŕžéééǧööövîîîกี้ååå]";var BWA="[BBöööṫšwåååกี้ååå]";var BRA="[BBŕåååžîîîļ]";var IOT="[BBŕîîîṫîîîšḥ IIIกี้ďîîîåååกี้ OOOçéééåååกี้ TéééŕŕîîîṫöööŕÝ]";var BRN="[BBŕūūūกี้éééîîî Dåååŕūūūššåååļåååm]";var BGR="[BBūūūļǧåååŕîîîååå]";var BFA="[BBūūūŕḱîîîกี้ååå Fåååšööö]";var BDI="[BBūūūŕūūūกี้ďîîî]";var KHM="[CCåååmböööďîîîååå]";var CMR="[CCåååméééŕööööööกี้]";var CAN="[CCåååกี้åååďååå]";var CPV="[CCåååþééé Véééŕďééé]";var CYM="[CCåååÝmåååกี้ IIIšļåååกี้ďš]";var CAF="[CCéééกี้ṫŕåååļ AAAḟŕîîîçåååกี้ Réééþūūūbļîîîç]";var TCD="[CCḥåååď]";var CHL="[CCḥîîîļééé]";var CHN="[CCḥîîîกี้ååå]";var CXR="[CCḥŕîîîšṫmåååš IIIšļåååกี้ď]";var CCK="[CCöööçöööš (Kééééééļîîîกี้ǧ) IIIšļåååกี้ďš]";var COL="[CCöööļööömbîîîååå]";var COM="[CCööömöööŕöööš]";var COG="[CCöööกี้ǧööö]";var COD="[CCöööกี้ǧööö, ṫḥééé Dééémöööçŕåååṫîîîç Réééþūūūbļîîîç öööḟ ṫḥééé]";var COK="[CCööööööḱ IIIšļåååกี้ďš]";var CRI="[CCöööšṫååå Rîîîçååå]";var HRV="[CCŕöööåååṫîîîååå]";var CUB="[CCūūūbååå]";var CUW="[CCūūūŕåååçåååööö]";var CYP="[CCÝþŕūūūš]";var CZE="[CCžéééçḥ Réééþūūūbļîîîç]";var CIV="[IIIIvöööŕÝ Cöööåååšṫ]";var DNK="[DDéééกี้måååŕḱ]";var DJI="[DDĵîîîböööūūūṫîîî]";var DMA="[DDööömîîîกี้îîîçååå]";var DOM="[DDööömîîîกี้îîîçåååกี้ Réééþūūūbļîîîç]";var ECU="[EEEEçūūūåååďöööŕ]";var EGY="[EEEEǧÝþṫ]";var SLV="[EEEEļ Såååļvåååďöööŕ]";var GNQ="[EEEEqūūūåååṫöööŕîîîåååļ Gūūūîîîกี้éééååå]";var ERI="[EEEEŕîîîṫŕéééååå]";var EST="[EEEEšṫöööกี้îîîååå]";var ETH="[EEEEṫḥîîîöööþîîîååå]";var FLK="[FFåååļḱļåååกี้ď IIIšļåååกี้ďš (Måååļvîîîกี้åååš)]";var FRO="[FFåååŕöööééé IIIšļåååกี้ďš]";var FJI="[FFîîîĵîîî]";var FIN="[FFîîîกี้ļåååกี้ď]";var FRA="[FFŕåååกี้çééé]";var GUF="[FFŕéééกี้çḥ Gūūūîîîåååกี้ååå]";var PYF="[FFŕéééกี้çḥ PöööļÝกี้éééšîîîååå]";var ATF="[FFŕéééกี้çḥ Söööūūūṫḥéééŕกี้ Téééŕŕîîîṫöööŕîîîéééš]";var GAB="[GGåååböööกี้]";var GMB="[GGåååmbîîîååå]";var GEO="[GGéééöööŕǧîîîååå]";var DEU="[GGéééŕmåååกี้Ý]";var GHA="[GGḥåååกี้ååå]";var GIB="[GGîîîbŕåååļṫåååŕ]";var GRC="[GGŕééééééçééé]";var GRL="[GGŕééééééกี้ļåååกี้ď]";var GRD="[GGŕéééกี้åååďååå]";var GLP="[GGūūūåååďéééļöööūūūþééé]";var GUM="[GGūūūåååm]";var GTM="[GGūūūåååṫééémåååļååå]";var GGY="[GGūūūéééŕกี้šéééÝ]";var GIN="[GGūūūîîîกี้éééååå]";var GNB="[GGūūūîîîกี้éééååå-Bîîîššåååūūū]";var GUY="[GGūūūÝåååกี้ååå]";var HTI="[HHåååîîîṫîîî]";var VAT="[HHöööļÝ Séééééé (Våååṫîîîçåååกี้ CîîîṫÝ Sṫåååṫééé)]";var HND="[HHöööกี้ďūūūŕåååš]";var HKG="[HHöööกี้ǧ Köööกี้ǧ]";var HUN="[HHūūūกี้ǧåååŕÝ]";var ISL="[IIIIçéééļåååกี้ď]";var IND="[IIIIกี้ďîîîååå]";var IDN="[IIIIกี้ďöööกี้éééšîîîååå]";var IRN="[IIIIŕåååกี้, IIIšļåååmîîîç Réééþūūūbļîîîç öööḟ]";var IRQ="[IIIIŕåååq]";var IRL="[IIIIŕéééļåååกี้ď]";var IMN="[IIIIšļééé öööḟ Måååกี้]";var ISR="[IIIIšŕåååéééļ]";var ITA="[IIIIṫåååļÝ]";var JAM="[JJåååmåååîîîçååå]";var JPN="[JJåååþåååกี้]";var JEY="[JJéééŕšéééÝ]";var JOR="[JJöööŕďåååกี้]";var KAZ="[KKåååžåååḱḥšṫåååกี้]";var KEN="[KKéééกี้Ýååå]";var KIR="[KKîîîŕîîîbåååṫîîî]";var PRK="[NNöööŕṫḥ Köööŕéééååå]";var KOR="[SSöööūūūṫḥ Köööŕéééååå]";var XXK="[KKöööšööövööö]";var KWT="[KKūūūwåååîîîṫ]";var KGZ="[KKÝŕǧÝžšṫåååกี้]";var LAO="[LLåååööö Péééöööþļééé'š Dééémöööçŕåååṫîîîç Réééþūūūbļîîîç]";var LVA="[LLåååṫvîîîååå]";var LBN="[LLééébåååกี้öööกี้]";var LSO="[LLéééšöööṫḥööö]";var LBR="[LLîîîbéééŕîîîååå]";var LBY="[LLîîîbÝååå]";var LIE="[LLîîîéééçḥṫéééกี้šṫéééîîîกี้]";var LTU="[LLîîîṫḥūūūåååกี้îîîååå]";var LUX="[LLūūūxééémböööūūūŕǧ]";var MAC="[MMåååçåååööö]";var MDG="[MMåååďåååǧåååšçåååŕ]";var MWI="[MMåååļåååwîîî]";var MYS="[MMåååļåååÝšîîîååå]";var MDV="[MMåååļďîîîvéééš]";var MLI="[MMåååļîîî]";var MLT="[MMåååļṫååå]";var MHL="[MMåååŕšḥåååļļ IIIšļåååกี้ďš]";var MTQ="[MMåååŕṫîîîกี้îîîqūūūééé]";var MRT="[MMåååūūūŕîîîṫåååกี้îîîååå]";var MUS="[MMåååūūūŕîîîṫîîîūūūš]";var MYT="[MMåååÝöööṫṫééé]";var MEX="[MMéééxîîîçööö]";var FSM="[MMîîîçŕöööกี้éééšîîîååå, Féééďéééŕåååṫéééď Sṫåååṫéééš öööḟ]";var MDA="[MMöööļďööövååå, Réééþūūūbļîîîç öööḟ]";var MCO="[MMöööกี้åååçööö]";var MNG="[MMöööกี้ǧöööļîîîååå]";var MNE="[MMöööกี้ṫéééกี้éééǧŕööö]";var MSR="[MMöööกี้ṫšéééŕŕåååṫ]";var MAR="[MMöööŕöööççööö]";var MOZ="[MMöööžåååmbîîîqūūūééé]";var MMR="[MMÝåååกี้måååŕ]";var NAM="[NNåååmîîîbîîîååå]";var NRU="[NNåååūūūŕūūū]";var NPL="[NNéééþåååļ]";var NLD="[NNéééṫḥéééŕļåååกี้ďš]";var NCL="[NNéééw Cåååļéééďöööกี้îîîååå]";var NZL="[NNéééw Zéééåååļåååกี้ď]";var NIC="[NNîîîçåååŕåååǧūūūååå]";var NER="[NNîîîǧéééŕ]";var NGA="[NNîîîǧéééŕîîîååå]";var NIU="[NNîîîūūūééé]";var NFK="[NNöööŕḟöööļḱ IIIšļåååกี้ď]";var MKD="[NNöööŕṫḥ Måååçéééďöööกี้îîîååå, Réééþūūūbļîîîç öööḟ]";var MNP="[NNöööŕṫḥéééŕกี้ Måååŕîîîåååกี้ååå IIIšļåååกี้ďš]";var NOR="[NNöööŕwåååÝ]";var OMN="[OOOOmåååกี้]";var PAK="[PPåååḱîîîšṫåååกี้]";var PLW="[PPåååļåååūūū]";var PSE="[PPåååļéééšṫîîîกี้ééé, Sṫåååṫééé öööḟ]";var PAN="[PPåååกี้åååmååå]";var PNG="[PPåååþūūūååå Néééw Gūūūîîîกี้éééååå]";var PRY="[PPåååŕåååǧūūūåååÝ]";var PER="[PPéééŕūūū]";var PHL="[PPḥîîîļîîîþþîîîกี้éééš]";var PCN="[PPîîîṫçåååîîîŕกี้]";var POL="[PPöööļåååกี้ď]";var PRT="[PPöööŕṫūūūǧåååļ]";var PRI="[PPūūūéééŕṫööö Rîîîçööö]";var QAT="[QQåååṫåååŕ]";var ROU="[RRööömåååกี้îîîååå]";var RUS="[RRūūūššîîîåååกี้ Féééďéééŕåååṫîîîöööกี้]";var RWA="[RRwåååกี้ďååå]";var REU="[MMééééééṫîîîกี้ǧ]";var BLM="[SSåååîîîกี้ṫ BåååŕṫḥéļééémÝ]";var SHN="[SSåååîîîกี้ṫ Héééļéééกี้ååå, AAAšçéééกี้šîîîöööกี้ åååกี้ď Tŕîîîšṫåååกี้ ďååå Cūūūกี้ḥååå]";var KNA="[SSåååîîîกี้ṫ Kîîîṫṫš åååกี้ď Nééévîîîš]";var LCA="[SSåååîîîกี้ṫ Lūūūçîîîååå]";var MAF="[SSåååîîîกี้ṫ Måååŕṫîîîกี้ (Fŕéééกี้çḥ þåååŕṫ)]";var SPM="[SSåååîîîกี้ṫ Pîîîéééŕŕééé åååกี้ď Mîîîqūūūéééļöööกี้]";var VCT="[SSåååîîîกี้ṫ Vîîîกี้çéééกี้ṫ åååกี้ď ṫḥééé Gŕéééกี้åååďîîîกี้éééš]";var WSM="[SSåååmöööååå]";var SMR="[SSåååกี้ Måååŕîîîกี้ööö]";var STP="[SSåååööö Tööömééé åååกี้ď Pŕîîîกี้çîîîþééé]";var SAU="[SSåååūūūďîîî AAAŕåååbîîîååå]";var SEN="[SSéééกี้éééǧåååļ]";var SRB="[SSéééŕbîîîååå]";var SYC="[SSéééÝçḥéééļļéééš]";var SLE="[SSîîîéééŕŕååå Léééöööกี้ééé]";var SGP="[SSîîîกี้ǧåååþöööŕééé]";var SXM="[SSåååîîîกี้ṫ Måååŕṫîîîกี้ (Dūūūṫçḥ þåååŕṫ)]";var SVK="[SSļööövåååḱîîîååå]";var SVN="[SSļööövéééกี้îîîååå]";var SLB="[SSöööļööömöööกี้ IIIšļåååกี้ďš]";var SOM="[SSööömåååļîîîååå]";var ZAF="[SSöööūūūṫḥ AAAḟŕîîîçååå]";var SGS="[SSöööūūūṫḥ Géééöööŕǧîîîååå åååกี้ď ṫḥééé Söööūūūṫḥ Såååกี้ďwîîîçḥ IIIšļåååกี้ďš]";var SSD="[SSöööūūūṫḥ Sūūūďåååกี้]";var ESP="[SSþåååîîîกี้]";var LKA="[SSŕîîî Låååกี้ḱååå]";var SDN="[SSūūūďåååกี้]";var SUR="[SSūūūŕîîîกี้åååmééé]";var SJM="[SSvåååļbåååŕď åååกี้ď Jåååกี้ MåååÝéééกี้]";var SWZ="[SSwåååžîîîļåååกี้ď]";var SWE="[SSwéééďéééกี้]";var CHE="[SSwîîîṫžéééŕļåååกี้ď]";var SYR="[SSÝŕîîîåååกี้ AAAŕåååb Réééþūūūbļîîîç]";var TWN="[TTåååîîîwåååกี้, Pŕööövîîîกี้çééé öööḟ Cḥîîîกี้ååå]";var TJK="[TTåååĵîîîḱîîîšṫåååกี้]";var TZA="[TTåååกี้žåååกี้îîîååå, UUUกี้îîîṫéééď Réééþūūūbļîîîç öööḟ]";var THA="[TTḥåååîîîļåååกี้ď]";var TLS="[EEEEåååšṫ Tîîîmöööŕ]";var TGO="[TTöööǧööö]";var TKL="[TTöööḱéééļåååūūū]";var TON="[TTöööกี้ǧååå]";var TTO="[TTŕîîîกี้îîîďåååď åååกี้ď Töööbåååǧööö]";var TUN="[TTūūūกี้îîîšîîîååå]";var TUR="[TTūūūŕḱéééÝ]";var TKM="[TTūūūŕḱméééกี้îîîšṫåååกี้]";var TCA="[TTūūūŕḱš åååกี้ď Cåååîîîçöööš IIIšļåååกี้ďš]";var TUV="[TTūūūvåååļūūū]";var UGA="[UUUUǧåååกี้ďååå]";var UKR="[UUUUḱŕåååîîîกี้ééé]";var ARE="[UUUUกี้îîîṫéééď AAAŕåååb EEEmîîîŕåååṫéééš]";var GBR="[UUUUกี้îîîṫéééď Kîîîกี้ǧďöööm]";var USA="[UUUUกี้îîîṫéééď Sṫåååṫéééš]";var UMI="[UUUUกี้îîîṫéééď Sṫåååṫéééš Mîîîกี้öööŕ OOOūūūṫļÝîîîกี้ǧ IIIšļåååกี้ďš]";var URY="[UUUUŕūūūǧūūūåååÝ]";var UZB="[UUUUžbéééḱîîîšṫåååกี้]";var VUT="[VVåååกี้ūūūåååṫūūū]";var VEN="[VVéééกี้éééžūūūéééļååå, Böööļîîîvåååŕîîîåååกี้ Réééþūūūbļîîîç öööḟ]";var VNM="[VVîîîéééṫ Nåååm]";var VGB="[VVîîîŕǧîîîกี้ IIIšļåååกี้ďš, Bŕîîîṫîîîšḥ]";var VIR="[VVîîîŕǧîîîกี้ IIIšļåååกี้ďš, UUU.S.]";var WLF="[WWåååļļîîîš åååกี้ď Fūūūṫūūūกี้ååå]";var YEM="[YYéééméééกี้]";var ZMB="[ZZåååmbîîîååå]";var ZWE="[ZZîîîmbåååbwééé]";var ALA="[ÅÅļåååกี้ď IIIšļåååกี้ďš]";var CountryPSEUDO = {AFG:AFG,ALB:ALB,DZA:DZA,ASM:ASM,AND:AND,AGO:AGO,AIA:AIA,ATA:ATA,ATG:ATG,ARG:ARG,ARM:ARM,ABW:ABW,AUS:AUS,AUT:AUT,AZE:AZE,BHS:BHS,BHR:BHR,BGD:BGD,BRB:BRB,BLR:BLR,BEL:BEL,BLZ:BLZ,BEN:BEN,BMU:BMU,BTN:BTN,BOL:BOL,BES:BES,BIH:BIH,BWA:BWA,BRA:BRA,IOT:IOT,BRN:BRN,BGR:BGR,BFA:BFA,BDI:BDI,KHM:KHM,CMR:CMR,CAN:CAN,CPV:CPV,CYM:CYM,CAF:CAF,TCD:TCD,CHL:CHL,CHN:CHN,CXR:CXR,CCK:CCK,COL:COL,COM:COM,COG:COG,COD:COD,COK:COK,CRI:CRI,HRV:HRV,CUB:CUB,CUW:CUW,CYP:CYP,CZE:CZE,CIV:CIV,DNK:DNK,DJI:DJI,DMA:DMA,DOM:DOM,ECU:ECU,EGY:EGY,SLV:SLV,GNQ:GNQ,ERI:ERI,EST:EST,ETH:ETH,FLK:FLK,FRO:FRO,FJI:FJI,FIN:FIN,FRA:FRA,GUF:GUF,PYF:PYF,ATF:ATF,GAB:GAB,GMB:GMB,GEO:GEO,DEU:DEU,GHA:GHA,GIB:GIB,GRC:GRC,GRL:GRL,GRD:GRD,GLP:GLP,GUM:GUM,GTM:GTM,GGY:GGY,GIN:GIN,GNB:GNB,GUY:GUY,HTI:HTI,VAT:VAT,HND:HND,HKG:HKG,HUN:HUN,ISL:ISL,IND:IND,IDN:IDN,IRN:IRN,IRQ:IRQ,IRL:IRL,IMN:IMN,ISR:ISR,ITA:ITA,JAM:JAM,JPN:JPN,JEY:JEY,JOR:JOR,KAZ:KAZ,KEN:KEN,KIR:KIR,PRK:PRK,KOR:KOR,XXK:XXK,KWT:KWT,KGZ:KGZ,LAO:LAO,LVA:LVA,LBN:LBN,LSO:LSO,LBR:LBR,LBY:LBY,LIE:LIE,LTU:LTU,LUX:LUX,MAC:MAC,MDG:MDG,MWI:MWI,MYS:MYS,MDV:MDV,MLI:MLI,MLT:MLT,MHL:MHL,MTQ:MTQ,MRT:MRT,MUS:MUS,MYT:MYT,MEX:MEX,FSM:FSM,MDA:MDA,MCO:MCO,MNG:MNG,MNE:MNE,MSR:MSR,MAR:MAR,MOZ:MOZ,MMR:MMR,NAM:NAM,NRU:NRU,NPL:NPL,NLD:NLD,NCL:NCL,NZL:NZL,NIC:NIC,NER:NER,NGA:NGA,NIU:NIU,NFK:NFK,MKD:MKD,MNP:MNP,NOR:NOR,OMN:OMN,PAK:PAK,PLW:PLW,PSE:PSE,PAN:PAN,PNG:PNG,PRY:PRY,PER:PER,PHL:PHL,PCN:PCN,POL:POL,PRT:PRT,PRI:PRI,QAT:QAT,ROU:ROU,RUS:RUS,RWA:RWA,REU:REU,BLM:BLM,SHN:SHN,KNA:KNA,LCA:LCA,MAF:MAF,SPM:SPM,VCT:VCT,WSM:WSM,SMR:SMR,STP:STP,SAU:SAU,SEN:SEN,SRB:SRB,SYC:SYC,SLE:SLE,SGP:SGP,SXM:SXM,SVK:SVK,SVN:SVN,SLB:SLB,SOM:SOM,ZAF:ZAF,SGS:SGS,SSD:SSD,ESP:ESP,LKA:LKA,SDN:SDN,SUR:SUR,SJM:SJM,SWZ:SWZ,SWE:SWE,CHE:CHE,SYR:SYR,TWN:TWN,TJK:TJK,TZA:TZA,THA:THA,TLS:TLS,TGO:TGO,TKL:TKL,TON:TON,TTO:TTO,TUN:TUN,TUR:TUR,TKM:TKM,TCA:TCA,TUV:TUV,UGA:UGA,UKR:UKR,ARE:ARE,GBR:GBR,USA:USA,UMI:UMI,URY:URY,UZB:UZB,VUT:VUT,VEN:VEN,VNM:VNM,VGB:VGB,VIR:VIR,WLF:WLF,YEM:YEM,ZMB:ZMB,ZWE:ZWE,ALA:ALA};

var status$1={any:"Alle",paid:"Betaald",inPayment:"In betaling",notPaid:"Niet betaald",partial:"Gedeeltelijk betaald",reversed:"Gecrediteerd",invoicingLegacy:"Facturatie legacy"};var sorting$1={highestPrice:"Hoogste prijs",lowestPrice:"Laagste prijs",dateAscending:"Datum oplopend",dateDescending:"Datum aflopend"};var downloadPdf$1="Download PDF";var dateLocales$1="nl-NL";var noInvoicesFound$1="Geen facturen gevonden";var Pdf$1="PDF";var sortBy$1="Sorteren bij";var date$2="Datum";var InvoicesNL = {status:status$1,sorting:sorting$1,downloadPdf:downloadPdf$1,dateLocales:dateLocales$1,noInvoicesFound:noInvoicesFound$1,Pdf:Pdf$1,sortBy:sortBy$1,date:date$2};

var status={any:"Any",paid:"Paid",inPayment:"In payment",notPaid:"Not paid",partial:"Partially payed",reversed:"Reversed",invoicingLegacy:"Invoicing legacy"};var sorting={highestPrice:"Highest price",lowestPrice:"Lowest price",dateAscending:"Date ascending",dateDescending:"Date descending"};var downloadPdf="Download PDF";var dateLocales="en-GB";var noInvoicesFound="No invoices found";var Pdf="PDF";var sortBy="Sort by";var date$1="Date";var InvoicesEN = {status:status,sorting:sorting,downloadPdf:downloadPdf,dateLocales:dateLocales,noInvoicesFound:noInvoicesFound,Pdf:Pdf,sortBy:sortBy,date:date$1};

instance.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'en',
  ns: ['authentication', 'settings', 'ui', 'dates', 'finance', 'branding', 'legal', 'chargecard', 'chargepoint', 'insights', 'parking', 'country', 'invoices'],
  detection: {
    caches: []
  },
  resources: {
    nl: {
      authentication: AuthenticationNL,
      settings: SettingsNL,
      ui: UiNL,
      dates: DatesNL,
      address: AddressNL,
      chargepoint: ChargePointNL,
      finance: FinanceNL,
      branding: BrandingNL,
      legal: LegalNL,
      chargecard: ChargeCardNL,
      insights: InsightsNL,
      parking: ParkingNL,
      country: CountryNL,
      invoices: InvoicesNL
    },
    en: {
      authentication: AuthenticationEN,
      settings: SettingsEN,
      ui: UiEN,
      dates: DatesEN,
      address: AddressEN,
      chargepoint: ChargePointEN,
      finance: FinanceEN,
      branding: BrandingEN,
      legal: LegalEN,
      chargecard: ChargeCardEN,
      insights: InsightsEN,
      parking: ParkingEN,
      country: CountryEN,
      invoices: InvoicesEN
    },
    fr: {
      authentication: AuthenticationFR,
      settings: SettingsFR,
      ui: UiFR,
      dates: DatesFR,
      address: AddressFR,
      chargepoint: ChargePointFR,
      finance: FinanceFR,
      branding: BrandingFR,
      legal: LegalFR,
      chargecard: ChargeCardFR,
      insights: InsightsFR,
      parking: ParkingFR,
      country: CountryFR
    },
    pseudo: {
      authentication: AuthenticationPSEUDO,
      settings: SettingsPSEUDO,
      ui: UiPSEUDO,
      dates: DatesPSEUDO,
      address: AddressPSEUDO,
      chargepoint: ChargePointPSEUDO,
      finance: FinancePSEUDO,
      branding: BrandingPSEUDO,
      legal: LegalPSEUDO,
      chargecard: ChargeCardPSEUDO,
      insights: InsightsPSEUDO,
      parking: ParkingPSEUDO,
      country: CountryPSEUDO
    }
  }
});

var Lang = {
  useTranslation: useTranslation
};

function ChatOnWhatsApp() {
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 207,
    height: 48,
    fill: "none"
  }, React__default.createElement("rect", {
    width: 207,
    height: 48,
    fill: "#25D366",
    rx: 12
  }), React__default.createElement("g", {
    clipPath: "url(#a)"
  }, React__default.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M27.746 12.447a11.374 11.374 0 0 1 7.799 3.163 11.286 11.286 0 0 1 3.49 7.785c.106 2.9-.907 5.75-2.828 7.926a11.298 11.298 0 0 1-8.202 3.849 11.361 11.361 0 0 1-.325.004c-1.705 0-3.395-.384-4.925-1.12l-5.948 1.322a.087.087 0 0 1-.103-.097l1.004-6.014a11.386 11.386 0 0 1-1.387-5.128 11.29 11.29 0 0 1 3.096-8.128 11.296 11.296 0 0 1 8.273-3.562h.056Zm-.063 1.972a9.576 9.576 0 0 0-.273.004c-5.176.148-9.267 4.48-9.119 9.657a9.402 9.402 0 0 0 1.288 4.487l.173.294-.744 4.08 4.039-.952.305.158a9.396 9.396 0 0 0 4.596 1.052c5.177-.149 9.268-4.48 9.12-9.657-.147-5.085-4.33-9.123-9.385-9.123Zm-3.929 3.902c.19.006.38.012.547.024.203.015.427.031.626.513.236.572.747 2 .814 2.145.067.145.11.313.008.5-.1.188-.152.306-.3.468-.147.162-.31.363-.442.486-.148.138-.3.288-.143.579.157.29.7 1.242 1.525 2.025 1.06 1.005 1.91 1.337 2.247 1.495a.75.75 0 0 0 .312.084c.12 0 .218-.051.31-.145.178-.18.713-.804.938-1.09.117-.15.224-.204.34-.204.092 0 .19.034.306.08.258.103 1.639.837 1.92.988.28.151.468.229.536.35.067.121.05.692-.208 1.351-.258.66-1.442 1.267-1.966 1.298-.154.01-.305.03-.501.03-.476 0-1.216-.124-2.899-.85-2.863-1.232-4.602-4.262-4.739-4.456-.136-.195-1.116-1.583-1.073-2.988.043-1.404.8-2.071 1.071-2.349.26-.266.556-.334.747-.334h.024Z",
    clipRule: "evenodd"
  })), React__default.createElement("path", {
    fill: "#fff",
    d: "M56.798 22.416h2.432a4.604 4.604 0 0 0-.544-1.76 4.137 4.137 0 0 0-1.104-1.28 4.626 4.626 0 0 0-1.504-.8 5.681 5.681 0 0 0-1.776-.272c-.874 0-1.664.155-2.368.464-.693.31-1.28.736-1.76 1.28s-.848 1.184-1.104 1.92a7.068 7.068 0 0 0-.384 2.368c0 .832.128 1.61.384 2.336a5.575 5.575 0 0 0 1.104 1.872c.48.533 1.067.955 1.76 1.264.704.299 1.494.448 2.368.448.704 0 1.35-.107 1.936-.32a4.488 4.488 0 0 0 1.536-.928c.438-.405.79-.896 1.056-1.472a5.807 5.807 0 0 0 .496-1.936h-2.432c-.096.768-.362 1.387-.8 1.856-.426.47-1.024.704-1.792.704-.565 0-1.045-.107-1.44-.32a2.822 2.822 0 0 1-.96-.88 3.93 3.93 0 0 1-.544-1.216 6.2 6.2 0 0 1-.16-1.408c0-.501.054-.987.16-1.456.118-.47.299-.885.544-1.248.246-.373.566-.667.96-.88.395-.224.875-.336 1.44-.336.31 0 .603.053.88.16a2.43 2.43 0 0 1 1.328 1.056c.15.235.246.496.288.784Zm4.003-3.84V30h2.272v-4.336c0-.843.14-1.445.416-1.808.278-.373.726-.56 1.344-.56.544 0 .923.17 1.136.512.214.33.32.837.32 1.52V30h2.272v-5.088c0-.512-.048-.976-.144-1.392-.085-.427-.24-.784-.464-1.072a2.125 2.125 0 0 0-.928-.688c-.384-.17-.88-.256-1.488-.256-.426 0-.864.112-1.312.336-.448.213-.816.56-1.104 1.04h-.048v-4.304h-2.272Zm9.389 5.696c.032-.533.165-.976.4-1.328a2.723 2.723 0 0 1 .896-.848 3.768 3.768 0 0 1 1.216-.448 6.7 6.7 0 0 1 1.376-.144c.416 0 .837.032 1.264.096.426.053.816.165 1.168.336.352.17.64.41.864.72.224.299.336.699.336 1.2v4.304c0 .373.021.73.064 1.072.042.341.117.597.224.768h-2.304a5.194 5.194 0 0 1-.112-.384 5.45 5.45 0 0 1-.048-.416c-.363.373-.79.635-1.28.784a5.139 5.139 0 0 1-1.504.224c-.395 0-.763-.048-1.104-.144a2.527 2.527 0 0 1-.896-.448 2.162 2.162 0 0 1-.608-.768c-.139-.31-.208-.677-.208-1.104 0-.47.08-.853.24-1.152.17-.31.384-.555.64-.736.266-.181.565-.315.896-.4a8.783 8.783 0 0 1 1.024-.224c.341-.053.677-.096 1.008-.128.33-.032.624-.08.88-.144a1.61 1.61 0 0 0 .608-.272c.15-.128.218-.31.208-.544 0-.245-.043-.437-.128-.576a.753.753 0 0 0-.32-.336 1.044 1.044 0 0 0-.464-.16 3.045 3.045 0 0 0-.56-.048c-.448 0-.8.096-1.056.288-.256.192-.406.512-.448.96H70.19Zm5.248 1.68a1.108 1.108 0 0 1-.368.208 4.241 4.241 0 0 1-.464.112 6.456 6.456 0 0 1-.512.08 9.509 9.509 0 0 0-.544.08 4.491 4.491 0 0 0-.512.128 1.51 1.51 0 0 0-.432.224.983.983 0 0 0-.288.336 1.106 1.106 0 0 0-.112.528c0 .203.037.373.112.512a.921.921 0 0 0 .304.336c.128.075.277.128.448.16.17.032.347.048.528.048.448 0 .795-.075 1.04-.224.245-.15.427-.325.544-.528a1.67 1.67 0 0 0 .208-.64c.032-.213.048-.384.048-.512v-.848Zm6.915-4.224v-2.48h-2.272v2.48h-1.376v1.52h1.376v4.88c0 .416.07.752.208 1.008a1.5 1.5 0 0 0 .56.592c.246.139.523.23.832.272.32.053.656.08 1.008.08.224 0 .454-.005.688-.016.235-.01.448-.032.64-.064v-1.76a3.203 3.203 0 0 1-.336.048c-.117.01-.24.016-.368.016-.384 0-.64-.064-.768-.192s-.192-.384-.192-.768v-4.096h1.664v-1.52h-1.664Zm9.214 4.144c0-.33.033-.656.097-.976.063-.32.17-.603.32-.848.16-.245.367-.443.623-.592.256-.16.576-.24.96-.24s.704.08.96.24c.267.15.475.347.624.592.16.245.272.528.336.848a4.964 4.964 0 0 1 0 1.952c-.064.31-.176.592-.336.848-.149.245-.357.443-.624.592-.256.15-.576.224-.96.224s-.704-.075-.96-.224a1.843 1.843 0 0 1-.624-.592 2.794 2.794 0 0 1-.32-.848 4.964 4.964 0 0 1-.095-.976Zm-2.271 0c0 .661.1 1.259.303 1.792.203.533.491.992.864 1.376.374.373.822.661 1.345.864s1.109.304 1.76.304c.65 0 1.237-.101 1.76-.304.533-.203.986-.49 1.36-.864.373-.384.66-.843.863-1.376.203-.533.305-1.13.305-1.792s-.102-1.259-.304-1.792a3.782 3.782 0 0 0-.865-1.376 3.701 3.701 0 0 0-1.36-.88c-.522-.213-1.109-.32-1.76-.32-.65 0-1.237.107-1.76.32A3.782 3.782 0 0 0 89.6 24.08c-.202.533-.303 1.13-.303 1.792Zm10.037-4.144V30h2.272v-4.336c0-.843.138-1.445.416-1.808.277-.373.725-.56 1.344-.56.544 0 .922.17 1.136.512.213.33.32.837.32 1.52V30h2.272v-5.088c0-.512-.048-.976-.144-1.392-.086-.427-.24-.784-.464-1.072a2.13 2.13 0 0 0-.928-.688c-.384-.17-.88-.256-1.488-.256-.48 0-.95.112-1.408.336-.459.213-.832.56-1.12 1.04h-.048v-1.152h-2.16ZM124.39 30l3.072-11.424h-2.464l-1.872 7.872h-.032l-1.952-7.872h-2.352l-1.984 7.776h-.032l-1.808-7.776h-2.512L115.478 30h2.544l1.904-7.776h.032L121.894 30h2.496Zm3.99-11.424V30h2.272v-4.336c0-.843.138-1.445.416-1.808.277-.373.725-.56 1.344-.56.544 0 .922.17 1.136.512.213.33.32.837.32 1.52V30h2.272v-5.088c0-.512-.048-.976-.144-1.392-.086-.427-.24-.784-.464-1.072a2.13 2.13 0 0 0-.928-.688c-.384-.17-.88-.256-1.488-.256-.427 0-.864.112-1.312.336-.448.213-.816.56-1.104 1.04h-.048v-4.304h-2.272Zm9.388 5.696c.032-.533.165-.976.4-1.328.235-.352.533-.635.896-.848a3.771 3.771 0 0 1 1.216-.448 6.7 6.7 0 0 1 1.376-.144c.416 0 .837.032 1.264.096a3.71 3.71 0 0 1 1.168.336c.352.17.64.41.864.72.224.299.336.699.336 1.2v4.304c0 .373.021.73.064 1.072.043.341.117.597.224.768h-2.304a5.052 5.052 0 0 1-.112-.384 5.886 5.886 0 0 1-.048-.416c-.363.373-.789.635-1.28.784s-.992.224-1.504.224a4.06 4.06 0 0 1-1.104-.144 2.53 2.53 0 0 1-.896-.448 2.16 2.16 0 0 1-.608-.768c-.139-.31-.208-.677-.208-1.104 0-.47.08-.853.24-1.152.171-.31.384-.555.64-.736.267-.181.565-.315.896-.4.341-.096.683-.17 1.024-.224.341-.053.677-.096 1.008-.128.331-.032.624-.08.88-.144.256-.064.459-.155.608-.272.149-.128.219-.31.208-.544 0-.245-.043-.437-.128-.576a.752.752 0 0 0-.32-.336 1.045 1.045 0 0 0-.464-.16 3.044 3.044 0 0 0-.56-.048c-.448 0-.8.096-1.056.288-.256.192-.405.512-.448.96h-2.272Zm5.248 1.68a1.111 1.111 0 0 1-.368.208 6.478 6.478 0 0 1-.976.192 9.522 9.522 0 0 0-.544.08 4.497 4.497 0 0 0-.512.128 1.51 1.51 0 0 0-.432.224.992.992 0 0 0-.288.336 1.103 1.103 0 0 0-.112.528c0 .203.037.373.112.512.075.139.176.25.304.336.128.075.277.128.448.16.171.032.347.048.528.048.448 0 .795-.075 1.04-.224s.427-.325.544-.528c.117-.213.187-.427.208-.64.032-.213.048-.384.048-.512v-.848Zm6.916-4.224v-2.48h-2.272v2.48h-1.376v1.52h1.376v4.88c0 .416.069.752.208 1.008.138.256.325.453.56.592.245.139.522.23.832.272.32.053.656.08 1.008.08.224 0 .453-.005.688-.016.234-.01.448-.032.64-.064v-1.76a3.226 3.226 0 0 1-.336.048c-.118.01-.24.016-.369.016-.383 0-.639-.064-.767-.192s-.192-.384-.192-.768v-4.096h1.664v-1.52h-1.664Zm4.505 5.584h-2.16c.021.555.144 1.019.368 1.392.234.363.528.656.88.88.362.224.773.384 1.232.48a6.85 6.85 0 0 0 2.784 0c.458-.085.864-.24 1.216-.464.352-.224.634-.517.848-.88.224-.373.336-.832.336-1.376 0-.384-.075-.704-.224-.96a1.955 1.955 0 0 0-.592-.656 3.034 3.034 0 0 0-.848-.432 9.164 9.164 0 0 0-.96-.272 38.534 38.534 0 0 0-.944-.208 9.356 9.356 0 0 1-.832-.208 1.838 1.838 0 0 1-.576-.32.621.621 0 0 1-.224-.496c0-.17.042-.304.128-.4a.813.813 0 0 1 .304-.24c.128-.053.266-.085.416-.096.149-.021.288-.032.416-.032.405 0 .757.08 1.056.24.298.15.464.443.496.88h2.16c-.043-.512-.176-.933-.4-1.264a2.5 2.5 0 0 0-.816-.816 3.455 3.455 0 0 0-1.136-.432 6.671 6.671 0 0 0-2.608 0 3.369 3.369 0 0 0-1.152.416 2.29 2.29 0 0 0-.832.8c-.203.341-.304.779-.304 1.312 0 .363.074.672.224.928.149.245.346.453.592.624.245.16.522.293.832.4.32.096.645.181.976.256.81.17 1.44.341 1.888.512.458.17.688.427.688.768a.878.878 0 0 1-.144.512 1.195 1.195 0 0 1-.368.32 1.963 1.963 0 0 1-.48.176 2.693 2.693 0 0 1-.496.048 2.694 2.694 0 0 1-.656-.08 1.791 1.791 0 0 1-.544-.24 1.536 1.536 0 0 1-.4-.432 1.35 1.35 0 0 1-.144-.64Zm9.953-1.728 1.488-4.192h.032l1.44 4.192h-2.96Zm.24-7.008L160.31 30h2.528l.896-2.544h4.272L168.87 30h2.608l-4.272-11.424h-2.576Zm11.769 9.936c-.362 0-.672-.075-.928-.224s-.464-.341-.624-.576a2.894 2.894 0 0 1-.336-.848 4.964 4.964 0 0 1-.096-.976c0-.341.032-.672.096-.992.064-.32.171-.603.32-.848.16-.245.363-.443.608-.592.256-.16.571-.24.944-.24.363 0 .667.08.912.24.256.15.464.352.624.608.16.245.272.528.336.848.075.32.112.645.112.976s-.032.656-.096.976c-.064.32-.176.603-.336.848a1.75 1.75 0 0 1-.608.576c-.245.15-.554.224-.928.224Zm-4.176-6.784v11.168h2.272v-3.92h.032c.278.405.63.715 1.056.928.438.203.912.304 1.424.304.608 0 1.136-.117 1.584-.352a3.26 3.26 0 0 0 1.136-.944c.31-.395.539-.848.688-1.36a5.66 5.66 0 0 0 .224-1.6c0-.587-.074-1.147-.224-1.68a4.097 4.097 0 0 0-.688-1.424 3.459 3.459 0 0 0-1.168-.976c-.469-.245-1.029-.368-1.68-.368a3.24 3.24 0 0 0-1.408.304c-.426.203-.778.528-1.056.976h-.032v-1.056h-2.16Zm13.958 6.784c-.363 0-.672-.075-.928-.224s-.464-.341-.624-.576a2.84 2.84 0 0 1-.336-.848 4.964 4.964 0 0 1-.096-.976c0-.341.032-.672.096-.992.064-.32.17-.603.32-.848.16-.245.362-.443.608-.592.256-.16.57-.24.944-.24.362 0 .666.08.912.24.256.15.464.352.624.608.16.245.272.528.336.848.074.32.112.645.112.976s-.032.656-.096.976c-.064.32-.176.603-.336.848-.15.235-.352.427-.608.576-.246.15-.555.224-.928.224Zm-4.176-6.784v11.168h2.272v-3.92h.032c.277.405.629.715 1.056.928.437.203.912.304 1.424.304.608 0 1.136-.117 1.584-.352.458-.235.837-.55 1.136-.944a4.01 4.01 0 0 0 .688-1.36 5.697 5.697 0 0 0 .224-1.6c0-.587-.075-1.147-.224-1.68a4.132 4.132 0 0 0-.688-1.424 3.478 3.478 0 0 0-1.168-.976c-.47-.245-1.03-.368-1.68-.368-.512 0-.982.101-1.408.304-.427.203-.779.528-1.056.976h-.032v-1.056h-2.16Z"
  }), React__default.createElement("defs", null, React__default.createElement("clipPath", {
    id: "a"
  }, React__default.createElement("path", {
    fill: "#fff",
    d: "M16 11.5h24v24H16z"
  }))));
}

function ChatOnWhatsAppButton() {
  return React$4.createElement("a", {
    href: "https://wa.me/+310850466050",
    target: "_blank",
    rel: "noreferrer"
  }, React$4.createElement(ChatOnWhatsApp, null));
}

var getHeadingTag = function getHeadingTag(heading) {
  switch (heading) {
    case 1:
      return 'h1';
    case 3:
      return 'h3';
    case 4:
      return 'h4';
    case 5:
      return 'h5';
    case 6:
      return 'h6';
    default:
      return 'h2';
  }
};
function Title(props) {
  var _props$fontFamily, _props$fontSize, _props$fontWeight, _props$color, _props$textAlign, _props$whiteSpace, _props$wordBreak, _props$textTransform, _props$textDecoration, _props$textWrap, _props$lineHeight;
  var style = {
    fontFamily: (_props$fontFamily = props.fontFamily) !== null && _props$fontFamily !== void 0 ? _props$fontFamily : 'Museo-Sans',
    fontSize: (_props$fontSize = props.fontSize) !== null && _props$fontSize !== void 0 ? _props$fontSize : '2em',
    fontWeight: (_props$fontWeight = props.fontWeight) !== null && _props$fontWeight !== void 0 ? _props$fontWeight : 700,
    color: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    textAlign: (_props$textAlign = props.textAlign) !== null && _props$textAlign !== void 0 ? _props$textAlign : 'left',
    whiteSpace: (_props$whiteSpace = props.whiteSpace) !== null && _props$whiteSpace !== void 0 ? _props$whiteSpace : 'normal',
    wordBreak: (_props$wordBreak = props.wordBreak) !== null && _props$wordBreak !== void 0 ? _props$wordBreak : 'normal',
    textTransform: (_props$textTransform = props.textTransform) !== null && _props$textTransform !== void 0 ? _props$textTransform : 'none',
    textDecoration: (_props$textDecoration = props.textDecoration) !== null && _props$textDecoration !== void 0 ? _props$textDecoration : 'none',
    textWrap: (_props$textWrap = props.textWrap) !== null && _props$textWrap !== void 0 ? _props$textWrap : 'wrap',
    lineHeight: (_props$lineHeight = props.lineHeight) !== null && _props$lineHeight !== void 0 ? _props$lineHeight : 'normal'
  };
  return props.portableText ? React$4.createElement(PortableTextComponent, {
    content: props.children,
    fontFamily: style.fontFamily,
    fontSize: style.fontSize,
    fontWeight: style.fontWeight,
    color: style.color,
    textAlign: style.textAlign,
    lineHeight: style.lineHeight,
    textTransform: style.textTransform,
    textDecoration: style.textDecoration,
    textWrap: style.textWrap,
    whiteSpace: style.whiteSpace,
    wordBreak: style.wordBreak,
    heading: props.heading
  }) : React$4.createElement(getHeadingTag(props.heading), {
    style: _objectSpread2({}, style)
  }, props.children);
}

function PortableTextComponent(props) {
  var _props$fontFamily, _props$fontSize, _props$fontWeight, _props$color, _props$textAlign, _props$lineHeight, _props$textTransform, _props$textDecoration, _props$whiteSpace, _props$wordBreak, _props$fontFamily2, _props$fontSize2, _props$color2, _props$textAlign2, _props$lineHeight2, _props$textTransform2, _props$textDecoration2, _props$whiteSpace2, _props$wordBreak2, _props$color3;
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var heading = props.heading;
  var _normal = {
    fontFamily: (_props$fontFamily = props.fontFamily) !== null && _props$fontFamily !== void 0 ? _props$fontFamily : 'Museo-Sans',
    fontSize: (_props$fontSize = props.fontSize) !== null && _props$fontSize !== void 0 ? _props$fontSize : '1.2em',
    fontWeight: (_props$fontWeight = props.fontWeight) !== null && _props$fontWeight !== void 0 ? _props$fontWeight : 300,
    color: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    textAlign: (_props$textAlign = props.textAlign) !== null && _props$textAlign !== void 0 ? _props$textAlign : 'left',
    lineHeight: (_props$lineHeight = props.lineHeight) !== null && _props$lineHeight !== void 0 ? _props$lineHeight : 1.1,
    height: 'auto',
    position: 'relative',
    textTransform: (_props$textTransform = props.textTransform) !== null && _props$textTransform !== void 0 ? _props$textTransform : 'none',
    textDecoration: (_props$textDecoration = props.textDecoration) !== null && _props$textDecoration !== void 0 ? _props$textDecoration : 'none',
    whiteSpace: (_props$whiteSpace = props.whiteSpace) !== null && _props$whiteSpace !== void 0 ? _props$whiteSpace : 'normal',
    wordBreak: (_props$wordBreak = props.wordBreak) !== null && _props$wordBreak !== void 0 ? _props$wordBreak : 'normal'
  };
  var h3Style = {
    fontFamily: (_props$fontFamily2 = props.fontFamily) !== null && _props$fontFamily2 !== void 0 ? _props$fontFamily2 : 'Museo-Sans',
    fontSize: (_props$fontSize2 = props.fontSize) !== null && _props$fontSize2 !== void 0 ? _props$fontSize2 : '1.2em',
    fontWeight: 500,
    color: (_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : Colors.GREY,
    textAlign: (_props$textAlign2 = props.textAlign) !== null && _props$textAlign2 !== void 0 ? _props$textAlign2 : 'left',
    lineHeight: (_props$lineHeight2 = props.lineHeight) !== null && _props$lineHeight2 !== void 0 ? _props$lineHeight2 : 1.1,
    height: 'auto',
    position: 'relative',
    textTransform: (_props$textTransform2 = props.textTransform) !== null && _props$textTransform2 !== void 0 ? _props$textTransform2 : 'none',
    textDecoration: (_props$textDecoration2 = props.textDecoration) !== null && _props$textDecoration2 !== void 0 ? _props$textDecoration2 : 'none',
    whiteSpace: (_props$whiteSpace2 = props.whiteSpace) !== null && _props$whiteSpace2 !== void 0 ? _props$whiteSpace2 : 'normal',
    wordBreak: (_props$wordBreak2 = props.wordBreak) !== null && _props$wordBreak2 !== void 0 ? _props$wordBreak2 : 'normal',
    paddingTop: 25
  };
  var strongStyle = {
    fontWeight: 700
  };
  var semistrongStyle = {
    fontWeight: 500
  };
  var linkStyle = {
    textDecoration: 'underline',
    color: Colors.BLUE
  };
  var subscriptStyle = {
    fontSize: '0.7em',
    color: (_props$color3 = props.color) !== null && _props$color3 !== void 0 ? _props$color3 : Colors.GREY,
    position: 'absolute',
    marginTop: 10
  };
  return React__default.createElement(PortableText, {
    content: props.content,
    className: "PortableText",
    serializers: {
      normal: function normal(props) {
        return React__default.createElement(Text, _extends$d({
          fontFamily: _normal.fontFamily,
          fontSize: _normal.fontSize,
          fontWeight: _normal.fontWeight,
          color: _normal.color,
          textAlign: _normal.textAlign,
          lineHeight: _normal.lineHeight,
          textTransform: _normal.textTransform,
          textDecoration: _normal.textDecoration,
          textWrap: _normal.textWrap,
          whiteSpace: _normal.whiteSpace,
          heading: heading
        }, props));
      },
      h3: function h3(props) {
        return React__default.createElement(Title, _extends$d({
          fontFamily: h3Style.fontFamily,
          fontSize: h3Style.fontSize,
          fontWeight: h3Style.fontWeight,
          color: h3Style.color,
          textAlign: h3Style.textAlign,
          lineHeight: h3Style.lineHeight,
          textTransform: h3Style.textTransform,
          textDecoration: h3Style.textDecoration,
          textWrap: h3Style.textWrap,
          whiteSpace: h3Style.whiteSpace,
          heading: heading !== null && heading !== void 0 ? heading : 3
        }, props));
      },
      strong: function strong(props) {
        return React__default.createElement("span", _extends$d({
          style: strongStyle
        }, props));
      },
      semistrong: function semistrong(props) {
        return React__default.createElement("span", _extends$d({
          style: semistrongStyle
        }, props));
      },
      subscript: function subscript(props) {
        return React__default.createElement("span", {
          style: {
            paddingRight: 8
          }
        }, React__default.createElement("sub", _extends$d({
          style: subscriptStyle
        }, props)));
      },
      link: function link(props) {
        return React__default.createElement("a", _extends$d({
          target: "_blank",
          rel: "noreferrer",
          style: linkStyle
        }, props));
      },
      li: function li(props) {
        return React__default.createElement("li", _extends$d({
          style: _normal
        }, props));
      },
      ol: function ol(props) {
        return React__default.createElement("ol", props);
      },
      hardBreak: function hardBreak(props) {
        return React__default.createElement("br", null);
      },
      blockquote: function blockquote(props) {
        return React__default.createElement("div", {
          style: {
            padding: 45,
            backgroundColor: Colors.LIGHT_BLUE,
            borderRadius: 10,
            position: 'relative',
            width: '100%'
          }
        }, React__default.createElement("div", {
          style: {
            position: 'absolute',
            left: 15,
            top: 15
          }
        }, React__default.createElement(Icon, {
          name: "QuoteLeft",
          height: 20,
          width: 20,
          color: "#CAE5F2",
          iconSet: "FA"
        })), React__default.createElement("h3", _extends$d({
          style: {
            fontFamily: 'Museo-Sans',
            fontWeight: 300,
            fontSize: '1.2em',
            lineHeight: 1.2,
            padding: 0
          }
        }, props)), React__default.createElement("div", {
          style: {
            position: 'absolute',
            right: 15,
            bottom: 15
          }
        }, React__default.createElement(Icon, {
          name: "QuoteLeft",
          height: 20,
          width: 20,
          color: "#CAE5F2",
          iconSet: "FA"
        })));
      },
      payAttention: function payAttention(props) {
        return React__default.createElement("div", {
          style: {
            paddingLeft: 20,
            paddingRight: 20,
            paddingTop: 15,
            paddingBottom: 15,
            backgroundColor: Colors.GRADIENT,
            border: "solid 2px ".concat(Colors.BLUE),
            borderRadius: 10,
            marginTop: 12
          }
        }, React__default.createElement("p", {
          style: {
            color: Colors.BLUE,
            fontSize: '1.2em',
            fontWeight: 500,
            lineHeight: 1.1,
            fontFamily: 'Museo-Sans'
          }
        }, "".concat(_('payAttention', {
          ns: 'ui'
        }), ":")), React__default.createElement("p", _extends$d({
          style: {
            color: Colors.BLUE,
            fontSize: '1.2em',
            fontWeight: 300,
            lineHeight: 1.3,
            fontFamily: 'Museo-Sans'
          }
        }, props)));
      },
      checkItem: function checkItem(props) {
        return React__default.createElement("div", {
          style: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'flex-start'
          }
        }, React__default.createElement("div", {
          style: {
            height: '100%',
            minWidth: 25,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
            paddingTop: 17,
            paddingRight: 10
          }
        }, React__default.createElement(Icon, {
          name: "Check",
          height: 15,
          width: 15,
          color: Colors.GREEN,
          iconSet: "FA"
        })), React__default.createElement("p", _extends$d({
          style: {
            color: Colors.GREY,
            fontSize: '1.2em',
            fontWeight: 300,
            lineHeight: 1.3,
            fontFamily: 'Museo-Sans'
          }
        }, props)));
      },
      negativeItem: function negativeItem(props) {
        return React__default.createElement("div", {
          style: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'flex-start'
          }
        }, React__default.createElement("div", {
          style: {
            height: '100%',
            minWidth: 25,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
            paddingTop: 17,
            paddingRight: 10
          }
        }, React__default.createElement(Icon, {
          name: "Times",
          height: 17,
          width: 17,
          color: Colors.RED,
          iconSet: "Feather"
        })), React__default.createElement("p", _extends$d({
          style: {
            color: Colors.GREY,
            fontSize: '1.2em',
            fontWeight: 300,
            lineHeight: 1.3,
            fontFamily: 'Museo-Sans'
          }
        }, props)));
      },
      squareItem: function squareItem(props) {
        return React__default.createElement("div", {
          style: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'flex-start'
          }
        }, React__default.createElement("div", {
          style: {
            height: '100%',
            minWidth: 25,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'center',
            paddingTop: 20,
            paddingRight: 10,
            paddingLeft: 2
          }
        }, React__default.createElement(Icon, {
          name: "Square",
          height: 7.5,
          width: 7.5,
          color: Colors.GREY,
          iconSet: "FA"
        })), React__default.createElement("p", _extends$d({
          style: {
            color: Colors.GREY,
            fontSize: '1.2em',
            fontWeight: 300,
            lineHeight: 1.3,
            fontFamily: 'Museo-Sans'
          }
        }, props)));
      },
      whatsappStyle: function whatsappStyle() {
        return React__default.createElement(ChatOnWhatsAppButton, null);
      }
    }
  });
}

function Text(props) {
  var _props$fontFamily, _props$fontSize, _props$fontWeight, _props$color, _props$textAlign, _props$lineHeight, _props$minWidth, _props$textTransform, _props$textDecoration, _props$whiteSpace, _props$wordBreak, _props$paddingLeft;
  var _React$useState = React$4.useState(props.children),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      text = _React$useState2[0],
      setText = _React$useState2[1];
  var _React$useState3 = React$4.useState(false),
      _React$useState4 = _slicedToArray$5(_React$useState3, 2),
      dotsAnimation = _React$useState4[0],
      setDotsAnimation = _React$useState4[1];
  React$4.useEffect(function () {
    var dots = '...';
    if (props.animate && text.slice(text.length - 3) === dots) {
      setDotsAnimation(true);
      setText(text.slice(text, -3));
    } else setText(props.children);
  }, [props.children]);
  var getHeadingTag = function getHeadingTag(heading) {
    switch (heading) {
      case 1:
        return 'h1';
      case 2:
        return 'h2';
      case 3:
        return 'h3';
      case 4:
        return 'h4';
      case 5:
        return 'h5';
      case 6:
        return 'h6';
      default:
        return 'p';
    }
  };
  var style = {
    fontFamily: (_props$fontFamily = props.fontFamily) !== null && _props$fontFamily !== void 0 ? _props$fontFamily : 'Museo-Sans',
    fontSize: (_props$fontSize = props.fontSize) !== null && _props$fontSize !== void 0 ? _props$fontSize : '1.2em',
    fontWeight: (_props$fontWeight = props.fontWeight) !== null && _props$fontWeight !== void 0 ? _props$fontWeight : 300,
    color: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    textAlign: (_props$textAlign = props.textAlign) !== null && _props$textAlign !== void 0 ? _props$textAlign : 'left',
    lineHeight: (_props$lineHeight = props.lineHeight) !== null && _props$lineHeight !== void 0 ? _props$lineHeight : 1.1,
    height: 'auto',
    minWidth: (_props$minWidth = props.minWidth) !== null && _props$minWidth !== void 0 ? _props$minWidth : 'auto',
    position: 'relative',
    textTransform: (_props$textTransform = props.textTransform) !== null && _props$textTransform !== void 0 ? _props$textTransform : 'none',
    textDecoration: (_props$textDecoration = props.textDecoration) !== null && _props$textDecoration !== void 0 ? _props$textDecoration : 'none',
    whiteSpace: (_props$whiteSpace = props.whiteSpace) !== null && _props$whiteSpace !== void 0 ? _props$whiteSpace : 'normal',
    wordBreak: (_props$wordBreak = props.wordBreak) !== null && _props$wordBreak !== void 0 ? _props$wordBreak : 'normal',
    paddingLeft: (_props$paddingLeft = props.paddingLeft) !== null && _props$paddingLeft !== void 0 ? _props$paddingLeft : 'none'
  };
  return props.portableText ? React$4.createElement(PortableTextComponent, {
    content: props.children,
    fontFamily: props.fontFamily,
    fontSize: props.fontSize,
    fontWeight: props.fontWeight,
    color: props.color,
    textAlign: props.textAlign,
    lineHeight: props.lineHeight,
    textTransform: props.textTransform,
    textDecoration: props.textDecoration,
    whiteSpace: props.whiteSpace,
    wordBreak: props.wordBreak,
    heading: props.heading,
    paddingLeft: props.paddingLeft
  }) : props.animate ? React$4.createElement("p", {
    className: "TextComponent",
    style: _objectSpread2({}, style)
  }, text, props.animate && dotsAnimation && React$4.createElement("span", {
    className: "TextDots"
  }, React$4.createElement("span", null, "."), React$4.createElement("span", null, "."), React$4.createElement("span", null, "."))) : React$4.createElement(getHeadingTag(props.heading), {
    style: _objectSpread2({}, style)
  }, text);
}

function IconButton(props) {
  var _props$height, _props$height2, _props$height3, _props$height4, _props$height5, _props$border, _props$borderRadius, _props$icon$width, _props$icon$height, _props$icon$hoverColo, _props$icon$color, _props$color, _props$fontSize;
  var ref = React$4.useRef();
  useDataAttributes(ref, props.dataAttributes);
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("button", {
    ref: ref,
    className: "".concat(props.disabled ? 'Disabled' : 'Hover', " DisableSelection"),
    type: "button",
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    onClick: props.disabled ? null : props.onClick,
    style: {
      height: props.size === 'medium' ? (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 40 : (_props$height2 = props.height) !== null && _props$height2 !== void 0 ? _props$height2 : 50,
      width: props.fullWidth ? '100%' : props.size === 'medium' ? (_props$height3 = props.height) !== null && _props$height3 !== void 0 ? _props$height3 : 40 : props.text ? (_props$height4 = props.height) !== null && _props$height4 !== void 0 ? _props$height4 : 'auto' : (_props$height5 = props.height) !== null && _props$height5 !== void 0 ? _props$height5 : 50,
      border: (_props$border = props.border) !== null && _props$border !== void 0 ? _props$border : props.disabled ? "solid 2px ".concat(Colors.MEDIUM_WHITE) : "solid 2px ".concat(props.colorScheme.border),
      backgroundColor: props.disabled || hover ? props.colorScheme.type === 'white' ? Colors.LIGHT_GREY : props.colorScheme.delicate : props.colorScheme.type === 'white-alt' || props.colorScheme.type === 'blue-invert' || props.selectable ? 'transparent' : props.colorScheme.vibrant,
      borderRadius: ((_props$borderRadius = props.borderRadius) !== null && _props$borderRadius !== void 0 ? _props$borderRadius : props.size === 'medium') ? 7 : 10,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'all 0.3s linear'
    }
  }, props.loading ? React$4.createElement(Loaders, {
    size: 20
  }) : React$4.createElement("div", {
    style: {
      paddingLeft: props.text ? 10 : 0,
      height: '100%',
      width: 'auto',
      display: props.hideIcon ? 'none' : 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, React$4.createElement(Icon, {
    name: props.icon.name,
    width: (_props$icon$width = props.icon.width) !== null && _props$icon$width !== void 0 ? _props$icon$width : 15,
    height: (_props$icon$height = props.icon.height) !== null && _props$icon$height !== void 0 ? _props$icon$height : 15,
    color: props.disabled ? Colors.MEDIUM_WHITE : hover ? (_props$icon$hoverColo = props.icon.hoverColor) !== null && _props$icon$hoverColo !== void 0 ? _props$icon$hoverColo : Colors.GREY : (_props$icon$color = props.icon.color) !== null && _props$icon$color !== void 0 ? _props$icon$color : Colors.GREY,
    iconSet: props.icon.iconSet
  })), props.text && React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      paddingLeft: 10,
      paddingRight: 10
    }
  }, React$4.createElement(Text, {
    color: !props.disabled && hover ? props.colorScheme.type === 'white-alt' || props.colorScheme.type === 'white' || props.colorScheme.type === 'white-invert' ? hover ? props.colorScheme.type === 'white-invert' ? Colors.WHITE : props.color ? props.color : Colors.GREY : props.colorScheme.text : props.colorScheme.vibrant : props.disabled ? props.disabled.color ? props.disabled.color : Colors.MEDIUM_WHITE : (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : props.colorScheme.text,
    fontWeight: 500,
    fontSize: (_props$fontSize = props.fontSize) !== null && _props$fontSize !== void 0 ? _props$fontSize : '1.1em'
  }, props.text)));
}

function Select(props) {
  var _props$borderRadius, _props$border, _props$icon$color;
  var ref = React$4.useRef();
  useDataAttributes(ref, props.dataAttributes);
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("button", {
    ref: ref,
    id: props.id,
    className: "".concat(props.disabled || props.loading ? 'Disabled' : 'Hover', " DisabledSelection"),
    type: props.type === 'submit' ? 'submit' : 'button',
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    onClick: props.disabled || props.loading ? null : props.onClick,
    "aria-label": props.ariaLabel,
    style: {
      minWidth: props.size === 'small' ? 50 : 150,
      maxWidth: props.size === 'small' ? 50 : '100%',
      width: props.size === 'large' ? '100%' : undefined,
      minHeight: 50,
      maxHeight: props.size === 'small' ? 50 : 'auto',
      borderRadius: (_props$borderRadius = props.borderRadius) !== null && _props$borderRadius !== void 0 ? _props$borderRadius : 10,
      paddingLeft: props.size === 'small' ? 2 : 20,
      paddingRight: props.size === 'small' ? 2 : 20,
      fontSize: '1.1em',
      fontWeight: 300,
      transition: 'all 0.3s linear',
      backgroundColor: props.selected ? props.disabled ? Colors.MEDIUM_WHITE : props.colorScheme.vibrant : !props.selected && (props.disabled || hover) ? props.disabled ? Colors.WHITE : props.colorScheme.type === 'white' ? Colors.LIGHT_GREY : props.colorScheme.delicate : props.colorScheme.vibrant,
      border: (_props$border = props.border) !== null && _props$border !== void 0 ? _props$border : props.error ? "solid 2px ".concat(Colors.RED) : props.selected ? props.disabled ? "solid 2px ".concat(Colors.MEDIUM_WHITE) : "solid 2px ".concat(props.loading ? props.colorScheme.vibrant : props.colorScheme.border) : props.disabled ? "solid 2px ".concat(Colors.MEDIUM_WHITE) : hover ? "solid 2px ".concat(props.colorScheme.border) : props.colorScheme.type === 'white' ? "solid 2px ".concat(props.colorScheme.border) : 'solid 2px transparent',
      color: props.selected ? props.disabled ? Colors.MEDIUM_GREY : props.colorScheme.text : !props.disabled && hover ? !props.selected && hover ? props.colorScheme.type === 'white' ? Colors.GREY : props.colorScheme.vibrant : props.colorScheme.text : props.disabled ? Colors.MEDIUM_WHITE : props.colorScheme.text
    }
  }, props.loading ? React$4.createElement("div", {
    style: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, React$4.createElement(Loaders, {
    type: "spinner",
    size: 20,
    color: !props.disabled && hover ? props.colorScheme.vibrant : props.colorScheme.text
  })) : props.icon ? React$4.createElement("div", {
    style: {
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, React$4.createElement(Icon, {
    name: props.icon.name,
    width: props.icon.width,
    height: props.icon.height,
    color: ((_props$icon$color = props.icon.color) !== null && _props$icon$color !== void 0 ? _props$icon$color : !props.disabled && hover) ? !props.selected && hover ? props.colorScheme.vibrant : props.colorScheme.text : props.disabled ? Colors.MEDIUM_WHITE : props.colorScheme.text,
    iconSet: props.icon.iconSet
  })) : props.text);
}

function ActionButton(props) {
  var _props$icon$height, _props$icon$width, _props$color, _props$color2, _props$color3, _props$color4, _props$color5, _props$color6, _props$color7, _props$color8;
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var ref = React$4.useRef();
  useDataAttributes(ref, props.dataAttributes);
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("button", {
    ref: ref,
    type: "button",
    className: props.loading || props.disabled ? 'Disabled' : 'Hover',
    onMouseEnter: function onMouseEnter() {
      if (!props.disabled) setHover(true);
      if (props.onMouseEnter) props.onMouseEnter();
    },
    onMouseLeave: function onMouseLeave() {
      if (!props.disabled) setHover(false);
      if (props.onMouseLeave) props.onMouseLeave();
    },
    onClick: function onClick() {
      if (!props.loading && !props.disabled) props.onClick();
    },
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      height: 'auto',
      minHeight: 70,
      backgroundColor: hover ? props.colorScheme.type === 'white-alt' ? Colors.WHITE : props.colorScheme.delicate : props.selected ? props.colorScheme.type === 'white-alt' ? props.colorScheme.delicate : props.colorScheme.vibrant : props.colorScheme.type === 'white-alt' ? 'transparent' : Colors.LIGHT_GREY,
      border: "solid 2px ".concat(hover ? props.colorScheme.type === 'white-alt' ? Colors.WHITE : props.colorScheme.delicate : props.selected ? props.colorScheme.type === 'white-alt' ? props.colorScheme.delicate : 'transparent' : props.colorScheme.type === 'white-alt' ? Colors.WHITE : Colors.MEDIUM_WHITE),
      borderRadius: 10,
      paddingLeft: 10,
      paddingRight: 10,
      fontSize: '1em',
      transition: 'all .2s linear',
      color: Colors.GREY
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start'
    }
  }, props.icon && React$4.createElement("div", {
    style: {
      height: '100%',
      width: 45,
      display: 'flex',
      flexDirection: 'columns',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, React$4.createElement(Icon, {
    name: props.icon.name,
    type: props.icon.type,
    height: (_props$icon$height = props.icon.height) !== null && _props$icon$height !== void 0 ? _props$icon$height : 35,
    width: (_props$icon$width = props.icon.width) !== null && _props$icon$width !== void 0 ? _props$icon$width : 35,
    color: props.disabled ? Colors.MEDIUM_GREY : hover ? props.colorScheme.type === 'white-alt' ? (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY : props.colorScheme.vibrant : props.selected ? props.colorScheme.type === 'white-alt' ? (_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : Colors.GREY : props.colorScheme.text : (_props$color3 = props.color) !== null && _props$color3 !== void 0 ? _props$color3 : Colors.GREY,
    iconSet: props.icon.set,
    transform: props.icon.transform
  })), React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center',
      marginLeft: 10
    }
  }, React$4.createElement(Text, {
    color: props.disabled ? Colors.MEDIUM_GREY : hover ? props.colorScheme.type === 'white-alt' ? (_props$color4 = props.color) !== null && _props$color4 !== void 0 ? _props$color4 : Colors.DARK_GREY : props.colorScheme.vibrant : props.selected ? props.colorScheme.text : props.colorScheme.type === 'white-alt' ? Colors.WHITE : (_props$color5 = props.color) !== null && _props$color5 !== void 0 ? _props$color5 : Colors.DARK_GREY,
    fontSize: "0.9em"
  }, props.text), props.subText && React$4.createElement("div", null, React$4.createElement(Text, {
    color: props.disabled ? Colors.MEDIUM_GREY : hover ? props.colorScheme.type === 'white-alt' ? (_props$color6 = props.color) !== null && _props$color6 !== void 0 ? _props$color6 : Colors.GREY : props.colorScheme.vibrant : props.selected ? props.colorScheme.text : props.colorScheme.type === 'white-alt' ? Colors.WHITE : (_props$color7 = props.color) !== null && _props$color7 !== void 0 ? _props$color7 : Colors.GREY,
    fontWeight: 500,
    fontSize: "1.35em"
  }, props.subText)))), React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-end'
    }
  }, props.disabled && React$4.createElement("div", {
    style: {
      marginRight: 15,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    }
  }, React$4.createElement(Text, {
    fontSize: "1em",
    color: props.selected ? props.colorScheme.text : Colors.MEDIUM_GREY
  }, _('disabled', {
    ns: 'ui'
  }))), React$4.createElement("div", {
    style: {
      height: 30,
      width: 30,
      display: 'flex',
      flexDirection: 'columns',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, props.loading ? React$4.createElement(Loaders, {
    size: 20,
    color: hover ? props.colorScheme.vibrant : props.selected ? props.colorScheme.text : props.colorScheme.type === 'white-alt' ? Colors.WHITE : Colors.DARK_GREY
  }) : React$4.createElement(Icon, {
    name: "AngleRight",
    height: 30,
    width: 30,
    color: props.disabled ? Colors.MEDIUM_GREY : hover ? props.colorScheme.type === 'white-alt' ? (_props$color8 = props.color) !== null && _props$color8 !== void 0 ? _props$color8 : Colors.GREY : props.colorScheme.vibrant : props.selected ? props.colorScheme.text : props.colorScheme.type === 'white-alt' ? Colors.WHITE : Colors.DARK_GREY,
    iconSet: "FA"
  }))));
}

function Buttons$1(props) {
  var renderButtons = function renderButtons() {
    var _props$colorScheme, _props$colorScheme2, _props$colorScheme3, _props$colorScheme4, _props$colorScheme5;
    switch (props.type) {
      case 'select':
        return React$4.createElement(Select, {
          id: props.id,
          text: props.text,
          icon: props.icon,
          colorScheme: getColorScheme("".concat((_props$colorScheme = props.colorScheme) !== null && _props$colorScheme !== void 0 ? _props$colorScheme : 'blue')),
          disabled: props.disabled,
          onClick: props.onClick,
          loading: props.loading,
          size: props.size,
          selected: props.selected,
          ariaLabel: props.ariaLabel,
          borderRadius: props.borderRadius,
          dataAttributes: props.dataAttributes,
          error: props.error
        });
      case 'link':
        return React$4.createElement(Link$1, {
          text: props.text,
          colorScheme: getColorScheme("".concat((_props$colorScheme2 = props.colorScheme) !== null && _props$colorScheme2 !== void 0 ? _props$colorScheme2 : 'blue')),
          disabled: props.disabled,
          onClick: props.onClick,
          loading: props.loading,
          icon: props.icon,
          selected: props.selected,
          borderRadius: props.borderRadius,
          dataAttributes: props.dataAttributes,
          height: props.height,
          width: props.width,
          color: props.color,
          textDecoration: props.textDecoration,
          removeArrow: props.removeArrow
        });
      case 'icon':
        return React$4.createElement(IconButton, {
          disabled: props.disabled,
          onClick: props.onClick,
          icon: props.icon,
          selected: props.selected,
          height: props.height,
          size: props.size,
          styling: props.styling,
          border: props.border,
          colorScheme: getColorScheme("".concat((_props$colorScheme3 = props.colorScheme) !== null && _props$colorScheme3 !== void 0 ? _props$colorScheme3 : 'blue')),
          borderRadius: props.borderRadius,
          loading: props.loading,
          fullWidth: props.fullWidth,
          dataAttributes: props.dataAttributes,
          text: props.text,
          fontSize: props.fontSize,
          color: props.color,
          hideIcon: props.hideIcon
        });
      case 'action':
        return React$4.createElement(ActionButton, {
          text: props.text,
          subText: props.subText,
          onClick: props.onClick,
          onMouseEnter: props.onMouseEnter,
          onMouseLeave: props.onMouseLeave,
          color: props.color,
          colorScheme: getColorScheme("".concat((_props$colorScheme4 = props.colorScheme) !== null && _props$colorScheme4 !== void 0 ? _props$colorScheme4 : 'blue')),
          loading: props.loading,
          icon: props.icon,
          disabled: props.disabled,
          border: props.border,
          selected: props.selected,
          dataAttributes: props.dataAttributes
        });
      default:
        return React$4.createElement(Button$3, {
          id: props.id,
          type: props.type,
          text: props.text,
          subText: props.subText,
          color: props.color,
          colorScheme: getColorScheme("".concat((_props$colorScheme5 = props.colorScheme) !== null && _props$colorScheme5 !== void 0 ? _props$colorScheme5 : 'blue')),
          disabled: props.disabled,
          onClick: props.onClick,
          loading: props.loading,
          size: props.size,
          height: props.height,
          border: props.border,
          selected: props.selected,
          fontSize: props.fontSize,
          ariaLabel: props.ariaLabel,
          borderRadius: props.borderRadius,
          dataAttributes: props.dataAttributes,
          width: props.width,
          maxWidth: props.maxWidth,
          minWidth: props.minWidth,
          icon: props.icon,
          paddingRight: props.paddingRight,
          paddingTop: props.paddingTop,
          paddingLeft: props.paddingLeft,
          textAlign: props.textAlign,
          alignItems: props.alignItems,
          paddingTopText: props.paddingTopText,
          widthText: props.widthText,
          maxWidthText: props.maxWidthText,
          disableHover: props.disableHover
        });
    }
  };
  return React$4.createElement(React$4.Fragment, null, renderButtons());
}

var TextInput = React$4.forwardRef(function (props, ref) {
  var _props$height, _props$maxHeight, _props$backgroundColo;
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      focused = _React$useState2[0],
      setFocused = _React$useState2[1];
  var _React$useState3 = React$4.useState(false),
      _React$useState4 = _slicedToArray$5(_React$useState3, 2),
      hasFeatures = _React$useState4[0],
      setFeatures = _React$useState4[1];
  var _React$useState5 = React$4.useState(false),
      _React$useState6 = _slicedToArray$5(_React$useState5, 2),
      passwordMask = _React$useState6[0],
      setPasswordMask = _React$useState6[1];
  var _React$useState7 = React$4.useState(false),
      _React$useState8 = _slicedToArray$5(_React$useState7, 2),
      hoverPasswordMask = _React$useState8[0],
      setHoverPasswordMask = _React$useState8[1];
  React$4.useEffect(function () {
    switch (props.type) {
      case 'password':
        setFeatures(true);
        break;
      default:
        setFeatures(false);
    }
    if (props.max) setFeatures(true);
    if (props.suffix) setFeatures(true);
    if (props.isLoading) setFeatures(true);
  });
  var onKeyUp = function onKeyUp(event) {
    switch (event.key) {
      case 'Enter':
        if (props.onEnter) props.onEnter();
        break;
      case 'Tab':
        if (props.onTab) props.onTab();
        break;
      default:
        if (props.onKeyUp) props.onKeyUp();
    }
  };
  return React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      height: 'auto'
    }
  }, React$4.createElement("div", {
    style: {
      width: '100%',
      height: 'auto'
    }
  }, props.label && React$4.createElement("label", {
    className: "DisableSelection",
    htmlFor: props.id,
    style: {
      color: Colors.GREY,
      fontSize: '1em',
      width: '100%',
      position: 'relative',
      height: props.label || !props.required ? 20 : 0,
      display: 'inline-block',
      marginBottom: 5
    }
  }, props.label && props.label, !props.required && !props.disabled && React$4.createElement("span", {
    style: {
      fontSize: '0.8em',
      position: 'absolute',
      marginTop: 2,
      paddingLeft: 6,
      color: Colors.DARK_GREY,
      whiteSpace: 'nowrap',
      width: 'auto',
      fontWeight: 300
    }
  }, "- ".concat(_('optional', {
    ns: 'ui'
  })))), props.multiline ? React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      height: 'auto'
    }
  }, React$4.createElement("textarea", {
    id: props.id,
    ref: props.ref,
    name: props.name,
    cols: props.cols,
    rows: props.rows,
    required: props.required,
    disabled: props.disabled,
    autoComplete: props.autocomplete,
    autoCorrect: props.autocorrect,
    placeholder: props.placeholder,
    readOnly: props.readonly,
    minLength: props.minLength,
    maxLength: props.maxLength,
    value: props.value,
    onChange: props.onChange
    ,
    autoFocus: props.autofocus,
    onKeyUp: onKeyUp,
    style: {
      width: '100%',
      maxWidth: '100%',
      height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 'auto',
      minHeight: 50,
      maxHeight: (_props$maxHeight = props.maxHeight) !== null && _props$maxHeight !== void 0 ? _props$maxHeight : 300,
      resize: 'vertical',
      boxSizing: 'border-box',
      WebKitBoxSizing: 'border-box',
      MozBoxSizing: 'border-box',
      borderTopRightRadius: 5,
      borderTopLeftRadius: 5,
      borderBottomRightRadius: 0,
      borderBottomLeftRadius: 5,
      borderTop: props.error ? "solid 2px ".concat(Colors.RED) : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderLeft: props.error ? "solid 2px ".concat(Colors.RED) : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderRight: hasFeatures ? 'solid 2px transparent' : props.error ? "solid 2px ".concat(Colors.RED) : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderBottom: props.error ? "solid 2px ".concat(Colors.RED) : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      outline: 'none',
      fontSize: '1.25em',
      fontFamily: 'Museo-Sans',
      fontWeight: 300,
      color: Colors.GREY,
      lineHeight: 1.1,
      whiteSpace: 'normal',
      padding: 10
    }
  })) : React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      height: 'auto'
    }
  }, props.prefix && React$4.createElement("div", {
    style: {
      height: 50,
      width: 'auto',
      paddingLeft: 7.5,
      paddingRight: 7.5,
      backgroundColor: Colors.RED
    }
  }), React$4.createElement("input", {
    ref: ref,
    className: props.disabled ? 'Disabled' : 'HoverText',
    onFocus: function onFocus() {
      if (props.onFocus !== undefined) props.onFocus();
      setFocused(true);
    },
    onBlur: function onBlur() {
      if (props.onBlur !== undefined) props.onBlur();
      setFocused(false);
    },
    value: props.value,
    onChange: props.onChange,
    onKeyUp: onKeyUp,
    disabled: props.disabled
    ,
    autoFocus: props.autofocus,
    autoComplete: props.autocomplete,
    autoCorrect: props.autocorrect,
    readOnly: props.readonly,
    "aria-label": props.ariaLabel,
    "aria-required": props.required,
    type: props.type === 'password' ? passwordMask ? 'text' : 'password' : props.type,
    id: props.id,
    name: props.name,
    placeholder: props.placeholder,
    required: props.required,
    maxLength: props.max,
    style: {
      height: 50,
      width: '100%',
      backgroundColor: (_props$backgroundColo = props.backgroundColor) !== null && _props$backgroundColo !== void 0 ? _props$backgroundColo : Colors.WHITE,
      borderTopRightRadius: hasFeatures ? 0 : 5,
      borderTopLeftRadius: 5,
      borderBottomRightRadius: hasFeatures ? 0 : 5,
      borderBottomLeftRadius: 5,
      borderTop: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderLeft: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderRight: hasFeatures ? 'solid 2px transparent' : props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderBottom: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      outline: 'none',
      fontSize: '1.25em',
      fontFamily: 'Museo-Sans',
      fontWeight: 300,
      color: props.disabled ? Colors.MEDIUM_GREY : Colors.GREY,
      padding: 10
    }
  }), props.isLoading && React$4.createElement("div", {
    className: "DisableSelection",
    style: {
      backgroundColor: Colors.WHITE,
      height: 50,
      width: 'auto',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      paddingLeft: 5,
      paddingRight: 15,
      marginLeft: -2,
      borderTop: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderBottom: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderRight: props.error ? "solid 2px ".concat(Colors.RED) : props.max || props.type === 'password' || !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderTopRightRadius: props.max || props.type === 'password' ? 0 : 5,
      borderBottomRightRadius: props.max || props.type === 'password' ? 0 : 5
    }
  }, React$4.createElement(Loaders, {
    size: 20
  })), props.max && React$4.createElement("div", {
    className: "DisableSelection",
    style: {
      backgroundColor: Colors.WHITE,
      height: 50,
      width: 'auto',
      marginLeft: -2,
      paddingRight: 7,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      borderTop: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderBottom: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderRight: props.error ? "solid 2px ".concat(Colors.RED) : props.type === 'password' || !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderLeft: 'solid 0px transparent',
      borderTopRightRadius: props.type === 'password' ? 0 : 5,
      borderBottomRightRadius: props.type === 'password' ? 0 : 5
    }
  }, React$4.createElement("div", {
    style: {
      backgroundColor: Colors.LIGHT_WHITE,
      padding: 5,
      borderRadius: 7
    }
  }, React$4.createElement(Text, {
    fontSize: "1.1em",
    fontWeight: 500,
    color: props.value && props.max - props.value.length < props.max / 100 * 20 + 1 ? Colors.RED : Colors.DARK_GREY
  }, props.value ? props.max - props.value.length : props.max))), props.suffix && React$4.createElement("div", {
    style: {
      height: 50,
      width: 'auto',
      minWidth: 52,
      paddingLeft: 7.5,
      paddingRight: 7.5,
      marginLeft: -5,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: Colors.LIGHT_GREY,
      borderTop: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderBottom: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderLeft: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderRight: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderTopRightRadius: 10,
      borderBottomRightRadius: 10
    }
  }, props.suffix), props.type === 'password' && React$4.createElement("button", {
    type: "button",
    className: "Hover",
    onMouseEnter: function onMouseEnter() {
      setHoverPasswordMask(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHoverPasswordMask(false);
    },
    onClick: function onClick() {
      setPasswordMask(!passwordMask);
    },
    style: {
      backgroundColor: Colors.WHITE,
      height: 50,
      width: 47,
      marginLeft: -2,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      borderTop: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderBottom: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderRight: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(focused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderLeft: 'solid 0px transparent',
      borderTopRightRadius: 5,
      borderBottomRightRadius: 5
    }
  }, React$4.createElement(Icon, {
    name: passwordMask ? 'Eye' : 'EyeSlash',
    iconSet: "Feather",
    height: 23,
    width: 23,
    color: hoverPasswordMask || passwordMask ? Colors.GREY : Colors.MEDIUM_GREY
  }))), props.error && React$4.createElement("div", {
    style: {
      marginTop: 5
    }
  }, React$4.createElement(Text, {
    fontSize: "1em",
    color: Colors.RED
  }, props.error)), props.hint && React$4.createElement("div", {
    style: {
      marginTop: 5
    }
  }, React$4.createElement(Text, {
    fontSize: "1em",
    color: Colors.DARK_WHITE
  }, props.hint))));
});

var Radio = React$4.forwardRef(function (props, ref) {
  return React$4.createElement("div", {
    ref: ref,
    style: {
      height: 20,
      width: 20,
      marginRight: 10,
      border: "solid 2px ".concat(!props.disabled && !props.isReadOnly && props.selected ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderRadius: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: props.disabled ? Colors.LIGHT_WHITE : 'transparent',
      paddingTop: 2
    }
  }, !props.disabled && props.selected && React$4.createElement(Icon, {
    name: "Check",
    height: 13,
    width: 13,
    color: props.isReadOnly ? Colors.MEDIUM_GREY : Colors.BLUE
  }));
});

var Checkbox = React$4.forwardRef(function (props, ref) {
  var _props$width;
  return (
    React$4.createElement(React$4.Fragment, null, React$4.createElement("div", {
      ref: ref,
      onClick: props.disabled ? null : props.onClick,
      onKeyDown: props.disabled ? null : props.onKeyDown,
      onKeyUp: props.disabled ? null : props.onKeyUp,
      role: "button",
      tabIndex: 0,
      className: "Hover",
      "aria-label": props.ariaLabel,
      style: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'left',
        width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : '100%',
        height: 26,
        backgroundColor: 'transparent',
        border: 'solid 0px transparent',
        fontSize: '1em'
      }
    }, React$4.createElement("div", {
      style: {
        height: 27,
        width: 27,
        marginRight: props.label ? 15 : 10,
        border: "solid 2px ".concat(!props.disabled && props.error ? Colors.RED : !props.disabled && props.selected ? Colors.BLUE : Colors.MEDIUM_WHITE),
        borderRadius: 7,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: !props.disabled && props.selected ? Colors.BLUE : props.disabled ? Colors.LIGHT_WHITE : 'transparent',
        marginTop: -1
      }
    }, props.selected && React$4.createElement("div", {
      style: {
        marginTop: 3
      }
    }, React$4.createElement(Icon, {
      name: "Check",
      height: 13,
      width: 13,
      color: Colors.WHITE
    }))), props.label && React$4.createElement("div", {
      style: {
        paddingTop: 1
      }
    }, React$4.createElement(Text, {
      color: !props.disabled && props.selected ? Colors.BLUE : Colors.GREY
    }, props.label))), props.hint && React$4.createElement("div", {
      style: {
        marginTop: 15
      }
    }, React$4.createElement(Text, {
      fontSize: "1em",
      color: Colors.DARK_WHITE
    }, props.hint)))
  );
});

var Switch = React$4.forwardRef(function (props, ref) {
  return React$4.createElement("button", {
    ref: ref,
    type: "button",
    className: "".concat(props.disabled || props.loading ? 'Disabled' : 'Hover', " DisableSelection"),
    onClick: props.disabled ? null : props.onClick,
    "aria-label": props.ariaLabel,
    style: {
      height: 30,
      width: 50,
      borderRadius: 20,
      backgroundColor: !props.disabled && props.value ? Colors.GREEN : props.disabled ? props.value ? "".concat(Colors.GREEN, "70") : Colors.WHITE : Colors.MEDIUM_WHITE,
      border: "solid 2px ".concat(!props.disabled && props.value ? Colors.GREEN : props.disabled ? props.value ? "".concat(Colors.GREEN, "70") : Colors.MEDIUM_WHITE : Colors.MEDIUM_WHITE),
      paddingTop: 2,
      paddingBottom: 2,
      paddingLeft: 2,
      paddingRight: 2,
      transition: 'all .2s linear',
      whiteSpace: 'nowrap'
    }
  }, React$4.createElement("div", {
    style: {
      height: 21,
      width: 21,
      backgroundColor: Colors.WHITE,
      borderRadius: '100%',
      border: "solid 2px ".concat(Colors.WHITE),
      boxShadow: "0px 0px 10px 1px ".concat(props.disabled ? "".concat(Colors.MEDIUM_GREY) : Colors.MEDIUM_GREY),
      transform: "translateX(".concat(props.value ? '22px' : '0px', ")"),
      transition: 'all .2s ease-in-out'
    }
  }));
});

function mergeClassNames() {
  return Array.prototype.slice.call(arguments).reduce(function (classList, arg) {
    return classList.concat(arg);
  }, []).filter(function (arg) {
    return typeof arg === 'string';
  }).join(' ');
}

var FUNC_ERROR_TEXT = 'Expected a function';
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;
var symbolTag = '[object Symbol]';
var reTrim = /^\s+|\s+$/g;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
var objectProto = Object.prototype;
var objectToString = objectProto.toString;
function before(n, func) {
  var result;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  n = toInteger(n);
  return function() {
    if (--n > 0) {
      result = func.apply(this, arguments);
    }
    if (n <= 1) {
      func = undefined;
    }
    return result;
  };
}
function once(func) {
  return before(2, func);
}
function isObject$1(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;
  return result === result ? (remainder ? result - remainder : result) : 0;
}
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject$1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}
var lodash_once = once;

function filterDuplicates(arr) {
  return arr.filter(function (el, index, self) {
    return self.indexOf(el) === index;
  });
}
function fixLowercaseProperties(arr) {
  return arr.map(function (el) {
    if (!el || el.indexOf('-') === -1 || el.toLowerCase() !== el) {
      return el;
    }
    var splitEl = el.split('-');
    return "".concat(splitEl[0], "-").concat(splitEl[1].toUpperCase());
  });
}
function getUserLocalesInternal() {
  var languageList = [];
  if (typeof window !== 'undefined') {
    if (window.navigator.languages) {
      languageList = languageList.concat(window.navigator.languages);
    }
    if (window.navigator.language) {
      languageList.push(window.navigator.language);
    }
    if (window.navigator.userLanguage) {
      languageList.push(window.navigator.userLanguage);
    }
    if (window.navigator.browserLanguage) {
      languageList.push(window.navigator.browserLanguage);
    }
    if (window.navigator.systemLanguage) {
      languageList.push(window.navigator.systemLanguage);
    }
  }
  languageList.push('en-US');
  return fixLowercaseProperties(filterDuplicates(languageList));
}
var getUserLocales = lodash_once(getUserLocalesInternal);
function getUserLocaleInternal() {
  return getUserLocales()[0];
}
var getUserLocale = lodash_once(getUserLocaleInternal);

function makeGetEdgeOfNeighbor(getPeriod, getEdgeOfPeriod, defaultOffset) {
  return function makeGetEdgeOfNeighborInternal(date) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOffset;
    var previousPeriod = getPeriod(date) + offset;
    return getEdgeOfPeriod(previousPeriod);
  };
}
function makeGetEnd(getBeginOfNextPeriod) {
  return function makeGetEndInternal(date) {
    return new Date(getBeginOfNextPeriod(date).getTime() - 1);
  };
}
function makeGetRange(functions) {
  return function makeGetRangeInternal(date) {
    return functions.map(function (fn) {
      return fn(date);
    });
  };
}
function getYear(date) {
  if (date instanceof Date) {
    return date.getFullYear();
  }
  if (typeof date === 'number') {
    return date;
  }
  var year = parseInt(date, 10);
  if (typeof date === 'string' && !isNaN(year)) {
    return year;
  }
  throw new Error("Failed to get year from date: ".concat(date, "."));
}
function getMonth(date) {
  if (date instanceof Date) {
    return date.getMonth();
  }
  throw new Error("Failed to get month from date: ".concat(date, "."));
}
function getDate(date) {
  if (date instanceof Date) {
    return date.getDate();
  }
  throw new Error("Failed to get year from date: ".concat(date, "."));
}
function getCenturyStart(date) {
  var year = getYear(date);
  var centuryStartYear = year + (-year + 1) % 100;
  var centuryStartDate = new Date();
  centuryStartDate.setFullYear(centuryStartYear, 0, 1);
  centuryStartDate.setHours(0, 0, 0, 0);
  return centuryStartDate;
}
var getPreviousCenturyStart = makeGetEdgeOfNeighbor(getYear, getCenturyStart, -100);
var getNextCenturyStart = makeGetEdgeOfNeighbor(getYear, getCenturyStart, 100);
var getCenturyEnd = makeGetEnd(getNextCenturyStart);
var getPreviousCenturyEnd = makeGetEdgeOfNeighbor(getYear, getCenturyEnd, -100);
var getCenturyRange = makeGetRange([getCenturyStart, getCenturyEnd]);
function getDecadeStart(date) {
  var year = getYear(date);
  var decadeStartYear = year + (-year + 1) % 10;
  var decadeStartDate = new Date();
  decadeStartDate.setFullYear(decadeStartYear, 0, 1);
  decadeStartDate.setHours(0, 0, 0, 0);
  return decadeStartDate;
}
var getPreviousDecadeStart = makeGetEdgeOfNeighbor(getYear, getDecadeStart, -10);
var getNextDecadeStart = makeGetEdgeOfNeighbor(getYear, getDecadeStart, 10);
var getDecadeEnd = makeGetEnd(getNextDecadeStart);
var getPreviousDecadeEnd = makeGetEdgeOfNeighbor(getYear, getDecadeEnd, -10);
var getDecadeRange = makeGetRange([getDecadeStart, getDecadeEnd]);
function getYearStart(date) {
  var year = getYear(date);
  var yearStartDate = new Date();
  yearStartDate.setFullYear(year, 0, 1);
  yearStartDate.setHours(0, 0, 0, 0);
  return yearStartDate;
}
var getPreviousYearStart = makeGetEdgeOfNeighbor(getYear, getYearStart, -1);
var getNextYearStart = makeGetEdgeOfNeighbor(getYear, getYearStart, 1);
var getYearEnd = makeGetEnd(getNextYearStart);
var getPreviousYearEnd = makeGetEdgeOfNeighbor(getYear, getYearEnd, -1);
var getYearRange = makeGetRange([getYearStart, getYearEnd]);
function makeGetEdgeOfNeighborMonth(getEdgeOfPeriod, defaultOffset) {
  return function makeGetEdgeOfNeighborMonthInternal(date) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOffset;
    var year = getYear(date);
    var month = getMonth(date) + offset;
    var previousPeriod = new Date();
    previousPeriod.setFullYear(year, month, 1);
    previousPeriod.setHours(0, 0, 0, 0);
    return getEdgeOfPeriod(previousPeriod);
  };
}
function getMonthStart(date) {
  var year = getYear(date);
  var month = getMonth(date);
  var monthStartDate = new Date();
  monthStartDate.setFullYear(year, month, 1);
  monthStartDate.setHours(0, 0, 0, 0);
  return monthStartDate;
}
var getPreviousMonthStart = makeGetEdgeOfNeighborMonth(getMonthStart, -1);
var getNextMonthStart = makeGetEdgeOfNeighborMonth(getMonthStart, 1);
var getMonthEnd = makeGetEnd(getNextMonthStart);
var getPreviousMonthEnd = makeGetEdgeOfNeighborMonth(getMonthEnd, -1);
var getMonthRange = makeGetRange([getMonthStart, getMonthEnd]);
function makeGetEdgeOfNeighborDay(getEdgeOfPeriod, defaultOffset) {
  return function makeGetEdgeOfNeighborDayInternal(date) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOffset;
    var year = getYear(date);
    var month = getMonth(date);
    var day = getDate(date) + offset;
    var previousPeriod = new Date();
    previousPeriod.setFullYear(year, month, day);
    previousPeriod.setHours(0, 0, 0, 0);
    return getEdgeOfPeriod(previousPeriod);
  };
}
function getDayStart(date) {
  var year = getYear(date);
  var month = getMonth(date);
  var day = getDate(date);
  var dayStartDate = new Date();
  dayStartDate.setFullYear(year, month, day);
  dayStartDate.setHours(0, 0, 0, 0);
  return dayStartDate;
}
var getNextDayStart = makeGetEdgeOfNeighborDay(getDayStart, 1);
var getDayEnd = makeGetEnd(getNextDayStart);
var getDayRange = makeGetRange([getDayStart, getDayEnd]);
function getDaysInMonth(date) {
  return getDate(getMonthEnd(date));
}

var _CALENDAR_TYPE_LOCALE;
function _toConsumableArray$4(arr) { return _arrayWithoutHoles$4(arr) || _iterableToArray$4(arr) || _unsupportedIterableToArray$4(arr) || _nonIterableSpread$4(); }
function _nonIterableSpread$4() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$4(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$4(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen); }
function _iterableToArray$4(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles$4(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$4(arr); }
function _arrayLikeToArray$4(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _defineProperty$f(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var CALENDAR_TYPES = {
  ARABIC: 'Arabic',
  HEBREW: 'Hebrew',
  ISO_8601: 'ISO 8601',
  US: 'US'
};
var CALENDAR_TYPE_LOCALES = (_CALENDAR_TYPE_LOCALE = {}, _defineProperty$f(_CALENDAR_TYPE_LOCALE, CALENDAR_TYPES.US, ['en-CA', 'en-US', 'es-AR', 'es-BO', 'es-CL', 'es-CO', 'es-CR', 'es-DO', 'es-EC', 'es-GT', 'es-HN', 'es-MX', 'es-NI', 'es-PA', 'es-PE', 'es-PR', 'es-SV', 'es-VE', 'pt-BR']), _defineProperty$f(_CALENDAR_TYPE_LOCALE, CALENDAR_TYPES.ARABIC, [
'ar', 'ar-AE', 'ar-BH', 'ar-DZ', 'ar-EG', 'ar-IQ', 'ar-JO', 'ar-KW', 'ar-LY', 'ar-OM', 'ar-QA', 'ar-SA', 'ar-SD', 'ar-SY', 'ar-YE', 'dv', 'dv-MV', 'ps', 'ps-AR']), _defineProperty$f(_CALENDAR_TYPE_LOCALE, CALENDAR_TYPES.HEBREW, ['he', 'he-IL']), _CALENDAR_TYPE_LOCALE);
var WEEKDAYS = _toConsumableArray$4(Array(7)).map(function (el, index) {
  return index;
});

var formatterCache = new Map();
function getFormatter(options) {
  return function (locale, date) {
    var localeWithDefault = locale || getUserLocale();
    if (!formatterCache.has(localeWithDefault)) {
      formatterCache.set(localeWithDefault, new Map());
    }
    var formatterCacheLocale = formatterCache.get(localeWithDefault);
    if (!formatterCacheLocale.has(options)) {
      formatterCacheLocale.set(options, new Intl.DateTimeFormat(localeWithDefault, options).format);
    }
    return formatterCacheLocale.get(options)(date);
  };
}
function toSafeHour(date) {
  var safeDate = new Date(date);
  return new Date(safeDate.setHours(12));
}
function getSafeFormatter(options) {
  return function (locale, date) {
    return getFormatter(options)(locale, toSafeHour(date));
  };
}
var formatDayOptions = {
  day: 'numeric'
};
var formatLongDateOptions = {
  day: 'numeric',
  month: 'long',
  year: 'numeric'
};
var formatMonthOptions = {
  month: 'long'
};
var formatMonthYearOptions = {
  month: 'long',
  year: 'numeric'
};
var formatShortWeekdayOptions = {
  weekday: 'short'
};
var formatWeekdayOptions = {
  weekday: 'long'
};
var formatYearOptions = {
  year: 'numeric'
};
var formatDay = getSafeFormatter(formatDayOptions);
var formatLongDate = getSafeFormatter(formatLongDateOptions);
var formatMonth = getSafeFormatter(formatMonthOptions);
var formatMonthYear = getSafeFormatter(formatMonthYearOptions);
var formatShortWeekday = getSafeFormatter(formatShortWeekdayOptions);
var formatWeekday = getSafeFormatter(formatWeekdayOptions);
var formatYear = getSafeFormatter(formatYearOptions);

var SUNDAY = WEEKDAYS[0];
var FRIDAY = WEEKDAYS[5];
var SATURDAY = WEEKDAYS[6];
function getDayOfWeek(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CALENDAR_TYPES.ISO_8601;
  var weekday = date.getDay();
  switch (calendarType) {
    case CALENDAR_TYPES.ISO_8601:
      return (weekday + 6) % 7;
    case CALENDAR_TYPES.ARABIC:
      return (weekday + 1) % 7;
    case CALENDAR_TYPES.HEBREW:
    case CALENDAR_TYPES.US:
      return weekday;
    default:
      throw new Error('Unsupported calendar type.');
  }
}
function getBeginOfCenturyYear(date) {
  var beginOfCentury = getCenturyStart(date);
  return getYear(beginOfCentury);
}
function getBeginOfDecadeYear(date) {
  var beginOfDecade = getDecadeStart(date);
  return getYear(beginOfDecade);
}
function getBeginOfWeek(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CALENDAR_TYPES.ISO_8601;
  var year = getYear(date);
  var monthIndex = getMonth(date);
  var day = date.getDate() - getDayOfWeek(date, calendarType);
  return new Date(year, monthIndex, day);
}
function getWeekNumber(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CALENDAR_TYPES.ISO_8601;
  var calendarTypeForWeekNumber = calendarType === CALENDAR_TYPES.US ? CALENDAR_TYPES.US : CALENDAR_TYPES.ISO_8601;
  var beginOfWeek = getBeginOfWeek(date, calendarType);
  var year = getYear(date) + 1;
  var dayInWeekOne;
  var beginOfFirstWeek;
  do {
    dayInWeekOne = new Date(year, 0, calendarTypeForWeekNumber === CALENDAR_TYPES.ISO_8601 ? 4 : 1);
    beginOfFirstWeek = getBeginOfWeek(dayInWeekOne, calendarType);
    year -= 1;
  } while (date < beginOfFirstWeek);
  return Math.round((beginOfWeek - beginOfFirstWeek) / (8.64e7 * 7)) + 1;
}
function getBegin(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getCenturyStart(date);
    case 'decade':
      return getDecadeStart(date);
    case 'year':
      return getYearStart(date);
    case 'month':
      return getMonthStart(date);
    case 'day':
      return getDayStart(date);
    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
function getBeginPrevious(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getPreviousCenturyStart(date);
    case 'decade':
      return getPreviousDecadeStart(date);
    case 'year':
      return getPreviousYearStart(date);
    case 'month':
      return getPreviousMonthStart(date);
    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
function getBeginNext(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getNextCenturyStart(date);
    case 'decade':
      return getNextDecadeStart(date);
    case 'year':
      return getNextYearStart(date);
    case 'month':
      return getNextMonthStart(date);
    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
var getBeginPrevious2 = function getBeginPrevious2(rangeType, date) {
  switch (rangeType) {
    case 'decade':
      return getPreviousDecadeStart(date, -100);
    case 'year':
      return getPreviousYearStart(date, -10);
    case 'month':
      return getPreviousMonthStart(date, -12);
    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
};
var getBeginNext2 = function getBeginNext2(rangeType, date) {
  switch (rangeType) {
    case 'decade':
      return getNextDecadeStart(date, 100);
    case 'year':
      return getNextYearStart(date, 10);
    case 'month':
      return getNextMonthStart(date, 12);
    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
};
function getEnd(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getCenturyEnd(date);
    case 'decade':
      return getDecadeEnd(date);
    case 'year':
      return getYearEnd(date);
    case 'month':
      return getMonthEnd(date);
    case 'day':
      return getDayEnd(date);
    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
function getEndPrevious(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getPreviousCenturyEnd(date);
    case 'decade':
      return getPreviousDecadeEnd(date);
    case 'year':
      return getPreviousYearEnd(date);
    case 'month':
      return getPreviousMonthEnd(date);
    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
var getEndPrevious2 = function getEndPrevious2(rangeType, date) {
  switch (rangeType) {
    case 'decade':
      return getPreviousDecadeEnd(date, -100);
    case 'year':
      return getPreviousYearEnd(date, -10);
    case 'month':
      return getPreviousMonthEnd(date, -12);
    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
};
function getRange(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getCenturyRange(date);
    case 'decade':
      return getDecadeRange(date);
    case 'year':
      return getYearRange(date);
    case 'month':
      return getMonthRange(date);
    case 'day':
      return getDayRange(date);
    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
function getValueRange(rangeType, date1, date2) {
  var rawNextValue = [date1, date2].sort(function (a, b) {
    return a - b;
  });
  return [getBegin(rangeType, rawNextValue[0]), getEnd(rangeType, rawNextValue[1])];
}
function toYearLabel(locale) {
  var formatYear$1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : formatYear;
  var dates = arguments.length > 2 ? arguments[2] : undefined;
  return dates.map(function (date) {
    return formatYear$1(locale, date);
  }).join(' – ');
}
function getCenturyLabel(locale, formatYear, date) {
  return toYearLabel(locale, formatYear, getCenturyRange(date));
}
function getDecadeLabel(locale, formatYear, date) {
  return toYearLabel(locale, formatYear, getDecadeRange(date));
}
function isWeekend(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CALENDAR_TYPES.ISO_8601;
  var weekday = date.getDay();
  switch (calendarType) {
    case CALENDAR_TYPES.ARABIC:
    case CALENDAR_TYPES.HEBREW:
      return weekday === FRIDAY || weekday === SATURDAY;
    case CALENDAR_TYPES.ISO_8601:
    case CALENDAR_TYPES.US:
      return weekday === SATURDAY || weekday === SUNDAY;
    default:
      throw new Error('Unsupported calendar type.');
  }
}

function _typeof$2(obj) { "@babel/helpers - typeof"; return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$2(obj); }
var calendarTypes = Object.values(CALENDAR_TYPES);
var allViews$1 = ['century', 'decade', 'year', 'month'];
var isCalendarType = PropTypes$1.oneOf(calendarTypes);
var isClassName = PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.arrayOf(PropTypes$1.string)]);
var isMinDate = function isMinDate(props, propName, componentName) {
  var minDate = props[propName];
  if (!minDate) {
    return null;
  }
  if (!(minDate instanceof Date)) {
    return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof$2(minDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
  }
  var maxDate = props.maxDate;
  if (maxDate && minDate > maxDate) {
    return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof$2(minDate), "` supplied to `").concat(componentName, "`, minDate cannot be larger than maxDate."));
  }
  return null;
};
var isMaxDate = function isMaxDate(props, propName, componentName) {
  var maxDate = props[propName];
  if (!maxDate) {
    return null;
  }
  if (!(maxDate instanceof Date)) {
    return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof$2(maxDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
  }
  var minDate = props.minDate;
  if (minDate && maxDate < minDate) {
    return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof$2(maxDate), "` supplied to `").concat(componentName, "`, maxDate cannot be smaller than minDate."));
  }
  return null;
};
var isRef = PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.shape({
  current: PropTypes$1.any
})]);
var isValue = PropTypes$1.oneOfType([PropTypes$1.instanceOf(Date), PropTypes$1.arrayOf(PropTypes$1.instanceOf(Date))]);
var isViews = PropTypes$1.arrayOf(PropTypes$1.oneOf(allViews$1));
var isView = function isView(props, propName, componentName) {
  var view = props[propName];
  var views = props.views;
  var allowedViews = views || allViews$1;
  if (view !== undefined && allowedViews.indexOf(view) === -1) {
    return new Error("Invalid prop `".concat(propName, "` of value `").concat(view, "` supplied to `").concat(componentName, "`, expected one of [").concat(allowedViews.map(function (a) {
      return "\"".concat(a, "\"");
    }).join(', '), "]."));
  }
  return null;
};
isView.isRequired = function (props, propName, componentName) {
  var view = props[propName];
  if (!view) {
    return new Error("The prop `".concat(propName, "` is marked as required in `").concat(componentName, "`, but its value is `").concat(view, "`."));
  }
  return isView(props, propName, componentName);
};
var tileGroupProps = {
  activeStartDate: PropTypes$1.instanceOf(Date).isRequired,
  hover: PropTypes$1.instanceOf(Date),
  locale: PropTypes$1.string,
  maxDate: isMaxDate,
  minDate: isMinDate,
  onClick: PropTypes$1.func,
  onMouseOver: PropTypes$1.func,
  tileClassName: PropTypes$1.oneOfType([PropTypes$1.func, isClassName]),
  tileContent: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.node]),
  value: isValue,
  valueType: PropTypes$1.string
};
var tileProps = {
  activeStartDate: PropTypes$1.instanceOf(Date).isRequired,
  classes: PropTypes$1.arrayOf(PropTypes$1.string).isRequired,
  date: PropTypes$1.instanceOf(Date).isRequired,
  locale: PropTypes$1.string,
  maxDate: isMaxDate,
  minDate: isMinDate,
  onClick: PropTypes$1.func,
  onMouseOver: PropTypes$1.func,
  style: PropTypes$1.objectOf(PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number])),
  tileClassName: PropTypes$1.oneOfType([PropTypes$1.func, isClassName]),
  tileContent: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.node]),
  tileDisabled: PropTypes$1.func
};

var className$6 = 'react-calendar__navigation';
function Navigation(_ref) {
  var activeStartDate = _ref.activeStartDate,
      drillUp = _ref.drillUp,
      _ref$formatMonthYear = _ref.formatMonthYear,
      formatMonthYear$1 = _ref$formatMonthYear === void 0 ? formatMonthYear : _ref$formatMonthYear,
      _ref$formatYear = _ref.formatYear,
      formatYear$1 = _ref$formatYear === void 0 ? formatYear : _ref$formatYear,
      locale = _ref.locale,
      maxDate = _ref.maxDate,
      minDate = _ref.minDate,
      _ref$navigationAriaLa = _ref.navigationAriaLabel,
      navigationAriaLabel = _ref$navigationAriaLa === void 0 ? '' : _ref$navigationAriaLa,
      navigationAriaLive = _ref.navigationAriaLive,
      navigationLabel = _ref.navigationLabel,
      _ref$next2AriaLabel = _ref.next2AriaLabel,
      next2AriaLabel = _ref$next2AriaLabel === void 0 ? '' : _ref$next2AriaLabel,
      _ref$next2Label = _ref.next2Label,
      next2Label = _ref$next2Label === void 0 ? '»' : _ref$next2Label,
      _ref$nextAriaLabel = _ref.nextAriaLabel,
      nextAriaLabel = _ref$nextAriaLabel === void 0 ? '' : _ref$nextAriaLabel,
      _ref$nextLabel = _ref.nextLabel,
      nextLabel = _ref$nextLabel === void 0 ? '›' : _ref$nextLabel,
      _ref$prev2AriaLabel = _ref.prev2AriaLabel,
      prev2AriaLabel = _ref$prev2AriaLabel === void 0 ? '' : _ref$prev2AriaLabel,
      _ref$prev2Label = _ref.prev2Label,
      prev2Label = _ref$prev2Label === void 0 ? '«' : _ref$prev2Label,
      _ref$prevAriaLabel = _ref.prevAriaLabel,
      prevAriaLabel = _ref$prevAriaLabel === void 0 ? '' : _ref$prevAriaLabel,
      _ref$prevLabel = _ref.prevLabel,
      prevLabel = _ref$prevLabel === void 0 ? '‹' : _ref$prevLabel,
      setActiveStartDate = _ref.setActiveStartDate,
      showDoubleView = _ref.showDoubleView,
      view = _ref.view,
      views = _ref.views;
  var drillUpAvailable = views.indexOf(view) > 0;
  var shouldShowPrevNext2Buttons = view !== 'century';
  var previousActiveStartDate = getBeginPrevious(view, activeStartDate);
  var previousActiveStartDate2 = shouldShowPrevNext2Buttons && getBeginPrevious2(view, activeStartDate);
  var nextActiveStartDate = getBeginNext(view, activeStartDate);
  var nextActiveStartDate2 = shouldShowPrevNext2Buttons && getBeginNext2(view, activeStartDate);
  var prevButtonDisabled = function () {
    if (previousActiveStartDate.getFullYear() < 0) {
      return true;
    }
    var previousActiveEndDate = getEndPrevious(view, activeStartDate);
    return minDate && minDate >= previousActiveEndDate;
  }();
  var prev2ButtonDisabled = shouldShowPrevNext2Buttons && function () {
    if (previousActiveStartDate2.getFullYear() < 0) {
      return true;
    }
    var previousActiveEndDate = getEndPrevious2(view, activeStartDate);
    return minDate && minDate >= previousActiveEndDate;
  }();
  var nextButtonDisabled = maxDate && maxDate < nextActiveStartDate;
  var next2ButtonDisabled = shouldShowPrevNext2Buttons && maxDate && maxDate < nextActiveStartDate2;
  function onClickPrevious() {
    setActiveStartDate(previousActiveStartDate, 'prev');
  }
  function onClickPrevious2() {
    setActiveStartDate(previousActiveStartDate2, 'prev2');
  }
  function onClickNext() {
    setActiveStartDate(nextActiveStartDate, 'next');
  }
  function onClickNext2() {
    setActiveStartDate(nextActiveStartDate2, 'next2');
  }
  function renderLabel(date) {
    var label = function () {
      switch (view) {
        case 'century':
          return getCenturyLabel(locale, formatYear$1, date);
        case 'decade':
          return getDecadeLabel(locale, formatYear$1, date);
        case 'year':
          return formatYear$1(locale, date);
        case 'month':
          return formatMonthYear$1(locale, date);
        default:
          throw new Error("Invalid view: ".concat(view, "."));
      }
    }();
    return navigationLabel ? navigationLabel({
      date: date,
      label: label,
      locale: locale || getUserLocale(),
      view: view
    }) : label;
  }
  function renderButton() {
    var labelClassName = "".concat(className$6, "__label");
    return React__default.createElement("button", {
      "aria-label": navigationAriaLabel,
      "aria-live": navigationAriaLive,
      className: labelClassName,
      disabled: !drillUpAvailable,
      onClick: drillUp,
      style: {
        flexGrow: 1
      },
      type: "button"
    }, React__default.createElement("span", {
      className: "".concat(labelClassName, "__labelText ").concat(labelClassName, "__labelText--from")
    }, renderLabel(activeStartDate)), showDoubleView && React__default.createElement(React__default.Fragment, null, React__default.createElement("span", {
      className: "".concat(labelClassName, "__divider")
    }, " \u2013 "), React__default.createElement("span", {
      className: "".concat(labelClassName, "__labelText ").concat(labelClassName, "__labelText--to")
    }, renderLabel(nextActiveStartDate))));
  }
  return React__default.createElement("div", {
    className: className$6
  }, prev2Label !== null && shouldShowPrevNext2Buttons && React__default.createElement("button", {
    "aria-label": prev2AriaLabel,
    className: "".concat(className$6, "__arrow ").concat(className$6, "__prev2-button"),
    disabled: prev2ButtonDisabled,
    onClick: onClickPrevious2,
    type: "button"
  }, prev2Label), prevLabel !== null && React__default.createElement("button", {
    "aria-label": prevAriaLabel,
    className: "".concat(className$6, "__arrow ").concat(className$6, "__prev-button"),
    disabled: prevButtonDisabled,
    onClick: onClickPrevious,
    type: "button"
  }, prevLabel), renderButton(), nextLabel !== null && React__default.createElement("button", {
    "aria-label": nextAriaLabel,
    className: "".concat(className$6, "__arrow ").concat(className$6, "__next-button"),
    disabled: nextButtonDisabled,
    onClick: onClickNext,
    type: "button"
  }, nextLabel), next2Label !== null && shouldShowPrevNext2Buttons && React__default.createElement("button", {
    "aria-label": next2AriaLabel,
    className: "".concat(className$6, "__arrow ").concat(className$6, "__next2-button"),
    disabled: next2ButtonDisabled,
    onClick: onClickNext2,
    type: "button"
  }, next2Label));
}
Navigation.propTypes = {
  activeStartDate: PropTypes$1.instanceOf(Date).isRequired,
  drillUp: PropTypes$1.func.isRequired,
  formatMonthYear: PropTypes$1.func,
  formatYear: PropTypes$1.func,
  locale: PropTypes$1.string,
  maxDate: PropTypes$1.instanceOf(Date),
  minDate: PropTypes$1.instanceOf(Date),
  navigationAriaLabel: PropTypes$1.string,
  navigationAriaLive: PropTypes$1.string,
  navigationLabel: PropTypes$1.func,
  next2AriaLabel: PropTypes$1.string,
  next2Label: PropTypes$1.node,
  nextAriaLabel: PropTypes$1.string,
  nextLabel: PropTypes$1.node,
  prev2AriaLabel: PropTypes$1.string,
  prev2Label: PropTypes$1.node,
  prevAriaLabel: PropTypes$1.string,
  prevLabel: PropTypes$1.node,
  setActiveStartDate: PropTypes$1.func.isRequired,
  showDoubleView: PropTypes$1.bool,
  view: isView.isRequired,
  views: isViews.isRequired
};

var _excluded$a = ["children", "className", "direction", "count", "offset", "style", "wrap"];
function _extends$c() { _extends$c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }
function ownKeys$e(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$e(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$e(Object(source), !0).forEach(function (key) { _defineProperty$e(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$e(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$e(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties$a(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$a(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$a(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function toPercent(num) {
  return "".concat(num, "%");
}
function Flex(_ref) {
  var children = _ref.children,
      className = _ref.className,
      direction = _ref.direction,
      count = _ref.count,
      offset = _ref.offset,
      style = _ref.style,
      wrap = _ref.wrap,
      otherProps = _objectWithoutProperties$a(_ref, _excluded$a);
  return React__default.createElement("div", _extends$c({
    className: className,
    style: _objectSpread$e({
      display: 'flex',
      flexDirection: direction,
      flexWrap: wrap ? 'wrap' : 'no-wrap'
    }, style)
  }, otherProps), React__default.Children.map(children, function (child, index) {
    return React__default.cloneElement(child, _objectSpread$e(_objectSpread$e({}, child.props), {}, {
      style: {
        flexBasis: toPercent(100 / count),
        flexShrink: 0,
        flexGrow: 0,
        overflow: 'hidden',
        marginLeft: offset && index === 0 ? toPercent(100 * offset / count) : null
      }
    }));
  }));
}
Flex.propTypes = {
  children: PropTypes$1.node,
  className: PropTypes$1.string,
  count: PropTypes$1.number.isRequired,
  direction: PropTypes$1.string,
  offset: PropTypes$1.number,
  style: PropTypes$1.objectOf(PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number])),
  wrap: PropTypes$1.bool
};

function _toConsumableArray$3(arr) { return _arrayWithoutHoles$3(arr) || _iterableToArray$3(arr) || _unsupportedIterableToArray$3(arr) || _nonIterableSpread$3(); }
function _nonIterableSpread$3() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$3(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }
function _iterableToArray$3(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles$3(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$3(arr); }
function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function between(value, min, max) {
  if (min && min > value) {
    return min;
  }
  if (max && max < value) {
    return max;
  }
  return value;
}
function isValueWithinRange(value, range) {
  return range[0] <= value && range[1] >= value;
}
function isRangeWithinRange(greaterRange, smallerRange) {
  return greaterRange[0] <= smallerRange[0] && greaterRange[1] >= smallerRange[1];
}
function doRangesOverlap(range1, range2) {
  return isValueWithinRange(range1[0], range2) || isValueWithinRange(range1[1], range2);
}
function getRangeClassNames(valueRange, dateRange, baseClassName) {
  var isRange = doRangesOverlap(dateRange, valueRange);
  var classes = [];
  if (isRange) {
    classes.push(baseClassName);
    var isRangeStart = isValueWithinRange(valueRange[0], dateRange);
    var isRangeEnd = isValueWithinRange(valueRange[1], dateRange);
    if (isRangeStart) {
      classes.push("".concat(baseClassName, "Start"));
    }
    if (isRangeEnd) {
      classes.push("".concat(baseClassName, "End"));
    }
    if (isRangeStart && isRangeEnd) {
      classes.push("".concat(baseClassName, "BothEnds"));
    }
  }
  return classes;
}
function getTileClasses() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      value = _ref.value,
      valueType = _ref.valueType,
      date = _ref.date,
      dateType = _ref.dateType,
      hover = _ref.hover;
  var className = 'react-calendar__tile';
  var classes = [className];
  if (!date) {
    return classes;
  }
  if (!Array.isArray(date) && !dateType) {
    throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
  }
  var now = new Date();
  var dateRange = Array.isArray(date) ? date : getRange(dateType, date);
  if (isValueWithinRange(now, dateRange)) {
    classes.push("".concat(className, "--now"));
  }
  if (!value) {
    return classes;
  }
  if (!Array.isArray(value) && !valueType) {
    throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
  }
  var valueRange = Array.isArray(value) ? value : getRange(valueType, value);
  if (isRangeWithinRange(valueRange, dateRange)) {
    classes.push("".concat(className, "--active"));
  } else if (doRangesOverlap(valueRange, dateRange)) {
    classes.push("".concat(className, "--hasActive"));
  }
  var valueRangeClassNames = getRangeClassNames(valueRange, dateRange, "".concat(className, "--range"));
  classes.push.apply(classes, _toConsumableArray$3(valueRangeClassNames));
  var valueArray = [].concat(value);
  if (hover && valueArray.length === 1) {
    var hoverRange = hover > valueRange[0] ? [valueRange[0], hover] : [hover, valueRange[0]];
    var hoverRangeClassNames = getRangeClassNames(hoverRange, dateRange, "".concat(className, "--hover"));
    classes.push.apply(classes, _toConsumableArray$3(hoverRangeClassNames));
  }
  return classes;
}

var _excluded$9 = ["className", "count", "dateTransform", "dateType", "end", "hover", "offset", "start", "step", "tile", "value", "valueType"];
function ownKeys$d(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$d(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$d(Object(source), !0).forEach(function (key) { _defineProperty$d(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$d(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$d(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _extends$b() { _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }
function _objectWithoutProperties$9(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$9(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$9(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function TileGroup(_ref) {
  var className = _ref.className,
      _ref$count = _ref.count,
      count = _ref$count === void 0 ? 3 : _ref$count,
      dateTransform = _ref.dateTransform,
      dateType = _ref.dateType,
      end = _ref.end,
      hover = _ref.hover,
      offset = _ref.offset,
      start = _ref.start,
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step,
      Tile = _ref.tile,
      value = _ref.value,
      valueType = _ref.valueType,
      tileProps = _objectWithoutProperties$9(_ref, _excluded$9);
  var tiles = [];
  for (var point = start; point <= end; point += step) {
    var date = dateTransform(point);
    tiles.push( React__default.createElement(Tile, _extends$b({
      key: date.getTime(),
      classes: getTileClasses({
        value: value,
        valueType: valueType,
        date: date,
        dateType: dateType,
        hover: hover
      }),
      date: date,
      point: point
    }, tileProps)));
  }
  return React__default.createElement(Flex, {
    className: className,
    count: count,
    offset: offset,
    wrap: true
  }, tiles);
}
TileGroup.propTypes = _objectSpread$d(_objectSpread$d({}, tileGroupProps), {}, {
  activeStartDate: PropTypes$1.instanceOf(Date),
  count: PropTypes$1.number,
  dateTransform: PropTypes$1.func.isRequired,
  dateType: PropTypes$1.string,
  offset: PropTypes$1.number,
  step: PropTypes$1.number,
  tile: PropTypes$1.func.isRequired
});

function _typeof$1(obj) { "@babel/helpers - typeof"; return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$1(obj); }
function ownKeys$c(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$c(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$c(Object(source), !0).forEach(function (key) { _defineProperty$c(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$c(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$1(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass$1(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$1(Constructor.prototype, protoProps); if (staticProps) _defineProperties$1(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$1(subClass, superClass); }
function _setPrototypeOf$1(o, p) { _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$1(o, p); }
function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf$1(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$1(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$1(this, result); }; }
function _possibleConstructorReturn$1(self, call) { if (call && (_typeof$1(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$1(self); }
function _assertThisInitialized$1(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf$1(o) { _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$1(o); }
function _defineProperty$c(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function datesAreDifferent(date1, date2) {
  return date1 && !date2 || !date1 && date2 || date1 && date2 && date1.getTime() !== date2.getTime();
}
function getValue$1(nextProps, prop) {
  var activeStartDate = nextProps.activeStartDate,
      date = nextProps.date,
      view = nextProps.view;
  return typeof prop === 'function' ? prop({
    activeStartDate: activeStartDate,
    date: date,
    view: view
  }) : prop;
}
var Tile = function (_Component) {
  _inherits$1(Tile, _Component);
  var _super = _createSuper$1(Tile);
  function Tile() {
    var _this;
    _classCallCheck$1(this, Tile);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$c(_assertThisInitialized$1(_this), "state", {});
    return _this;
  }
  _createClass$1(Tile, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          activeStartDate = _this$props.activeStartDate,
          children = _this$props.children,
          classes = _this$props.classes,
          date = _this$props.date,
          formatAbbr = _this$props.formatAbbr,
          locale = _this$props.locale,
          maxDate = _this$props.maxDate,
          maxDateTransform = _this$props.maxDateTransform,
          minDate = _this$props.minDate,
          minDateTransform = _this$props.minDateTransform,
          onClick = _this$props.onClick,
          onMouseOver = _this$props.onMouseOver,
          style = _this$props.style,
          tileDisabled = _this$props.tileDisabled,
          view = _this$props.view;
      var _this$state = this.state,
          tileClassName = _this$state.tileClassName,
          tileContent = _this$state.tileContent;
      return React__default.createElement("button", {
        className: mergeClassNames(classes, tileClassName),
        disabled: minDate && minDateTransform(minDate) > date || maxDate && maxDateTransform(maxDate) < date || tileDisabled && tileDisabled({
          activeStartDate: activeStartDate,
          date: date,
          view: view
        }),
        onClick: onClick && function (event) {
          return onClick(date, event);
        },
        onFocus: onMouseOver && function () {
          return onMouseOver(date);
        },
        onMouseOver: onMouseOver && function () {
          return onMouseOver(date);
        },
        style: style,
        type: "button"
      }, formatAbbr ? React__default.createElement("abbr", {
        "aria-label": formatAbbr(locale, date)
      }, children) : children, tileContent);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var activeStartDate = nextProps.activeStartDate,
          tileClassName = nextProps.tileClassName,
          tileContent = nextProps.tileContent;
      var nextState = {};
      if (tileClassName !== prevState.tileClassNameProps || datesAreDifferent(activeStartDate, prevState.activeStartDateProps)) {
        nextState.tileClassName = getValue$1(nextProps, tileClassName);
        nextState.tileClassNameProps = tileClassName;
      }
      if (tileContent !== prevState.tileContentProps || datesAreDifferent(activeStartDate, prevState.activeStartDateProps)) {
        nextState.tileContent = getValue$1(nextProps, tileContent);
        nextState.tileContentProps = tileContent;
      }
      nextState.activeStartDateProps = activeStartDate;
      return nextState;
    }
  }]);
  return Tile;
}(Component);
Tile.propTypes = _objectSpread$c(_objectSpread$c({}, tileProps), {}, {
  children: PropTypes$1.node.isRequired,
  formatAbbr: PropTypes$1.func,
  maxDateTransform: PropTypes$1.func.isRequired,
  minDateTransform: PropTypes$1.func.isRequired
});

var _excluded$8 = ["classes", "formatYear"];
function ownKeys$b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$b(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$b(Object(source), !0).forEach(function (key) { _defineProperty$b(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$b(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
function _objectWithoutProperties$8(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$8(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$8(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var className$5 = 'react-calendar__century-view__decades__decade';
function Decade(_ref) {
  var classes = _ref.classes,
      _ref$formatYear = _ref.formatYear,
      formatYear$1 = _ref$formatYear === void 0 ? formatYear : _ref$formatYear,
      otherProps = _objectWithoutProperties$8(_ref, _excluded$8);
  var date = otherProps.date,
      locale = otherProps.locale;
  return React__default.createElement(Tile, _extends$a({}, otherProps, {
    classes: [].concat(classes, className$5),
    maxDateTransform: getDecadeEnd,
    minDateTransform: getDecadeStart,
    view: "century"
  }), getDecadeLabel(locale, formatYear$1, date));
}
Decade.propTypes = _objectSpread$b(_objectSpread$b({}, tileProps), {}, {
  formatYear: PropTypes$1.func
});

function ownKeys$a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$a(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$a(Object(source), !0).forEach(function (key) { _defineProperty$a(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$a(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
function Decades(props) {
  var activeStartDate = props.activeStartDate;
  var start = getBeginOfCenturyYear(activeStartDate);
  var end = start + 99;
  return React__default.createElement(TileGroup, _extends$9({}, props, {
    className: "react-calendar__century-view__decades",
    dateTransform: getDecadeStart,
    dateType: "decade",
    end: end,
    start: start,
    step: 10,
    tile: Decade
  }));
}
Decades.propTypes = _objectSpread$a({}, tileGroupProps);

function CenturyView(props) {
  function renderDecades() {
    return React__default.createElement(Decades, props);
  }
  return React__default.createElement("div", {
    className: "react-calendar__century-view"
  }, renderDecades());
}

var _excluded$7 = ["classes", "formatYear"];
function ownKeys$9(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$9(Object(source), !0).forEach(function (key) { _defineProperty$9(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$9(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$9(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
function _objectWithoutProperties$7(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$7(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$7(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var className$4 = 'react-calendar__decade-view__years__year';
function Year(_ref) {
  var classes = _ref.classes,
      _ref$formatYear = _ref.formatYear,
      formatYear$1 = _ref$formatYear === void 0 ? formatYear : _ref$formatYear,
      otherProps = _objectWithoutProperties$7(_ref, _excluded$7);
  var date = otherProps.date,
      locale = otherProps.locale;
  return React__default.createElement(Tile, _extends$8({}, otherProps, {
    classes: [].concat(classes, className$4),
    maxDateTransform: getYearEnd,
    minDateTransform: getYearStart,
    view: "decade"
  }), formatYear$1(locale, date));
}
Year.propTypes = _objectSpread$9(_objectSpread$9({}, tileProps), {}, {
  formatYear: PropTypes$1.func
});

function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$8(Object(source), !0).forEach(function (key) { _defineProperty$8(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$8(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
function Years(props) {
  var activeStartDate = props.activeStartDate;
  var start = getBeginOfDecadeYear(activeStartDate);
  var end = start + 9;
  return React__default.createElement(TileGroup, _extends$7({}, props, {
    className: "react-calendar__decade-view__years",
    dateTransform: function dateTransform(year) {
      var date = new Date();
      date.setFullYear(year, 0, 1);
      date.setHours(0, 0, 0, 0);
      return date;
    },
    dateType: "year",
    end: end,
    start: start,
    tile: Year
  }));
}
Years.propTypes = _objectSpread$8({}, tileGroupProps);

function DecadeView(props) {
  function renderYears() {
    return React__default.createElement(Years, props);
  }
  return React__default.createElement("div", {
    className: "react-calendar__decade-view"
  }, renderYears());
}

var _excluded$6 = ["classes", "formatMonth", "formatMonthYear"];
function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$7(Object(source), !0).forEach(function (key) { _defineProperty$7(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$7(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
function _objectWithoutProperties$6(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$6(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$6(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var className$3 = 'react-calendar__year-view__months__month';
function Month(_ref) {
  var classes = _ref.classes,
      _ref$formatMonth = _ref.formatMonth,
      formatMonth$1 = _ref$formatMonth === void 0 ? formatMonth : _ref$formatMonth,
      _ref$formatMonthYear = _ref.formatMonthYear,
      formatMonthYear$1 = _ref$formatMonthYear === void 0 ? formatMonthYear : _ref$formatMonthYear,
      otherProps = _objectWithoutProperties$6(_ref, _excluded$6);
  var date = otherProps.date,
      locale = otherProps.locale;
  return React__default.createElement(Tile, _extends$6({}, otherProps, {
    classes: [].concat(classes, className$3),
    formatAbbr: formatMonthYear$1,
    maxDateTransform: getMonthEnd,
    minDateTransform: getMonthStart,
    view: "year"
  }), formatMonth$1(locale, date));
}
Month.propTypes = _objectSpread$7(_objectSpread$7({}, tileProps), {}, {
  formatMonth: PropTypes$1.func,
  formatMonthYear: PropTypes$1.func
});

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) { _defineProperty$6(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$6(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
function Months(props) {
  var activeStartDate = props.activeStartDate;
  var start = 0;
  var end = 11;
  var year = getYear(activeStartDate);
  return React__default.createElement(TileGroup, _extends$5({}, props, {
    className: "react-calendar__year-view__months",
    dateTransform: function dateTransform(monthIndex) {
      var date = new Date();
      date.setFullYear(year, monthIndex, 1);
      date.setHours(0, 0, 0, 0);
      return date;
    },
    dateType: "month",
    end: end,
    start: start,
    tile: Month
  }));
}
Months.propTypes = _objectSpread$6(_objectSpread$6({}, tileGroupProps), {}, {
  locale: PropTypes$1.string
});

function YearView(props) {
  function renderMonths() {
    return React__default.createElement(Months, props);
  }
  return React__default.createElement("div", {
    className: "react-calendar__year-view"
  }, renderMonths());
}

var _excluded$5 = ["formatDay", "formatLongDate", "calendarType", "classes", "currentMonthIndex"];
function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) { _defineProperty$5(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$5(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
function _objectWithoutProperties$5(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$5(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$5(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var className$2 = 'react-calendar__month-view__days__day';
function Day(_ref) {
  var _ref$formatDay = _ref.formatDay,
      formatDay$1 = _ref$formatDay === void 0 ? formatDay : _ref$formatDay,
      _ref$formatLongDate = _ref.formatLongDate,
      formatLongDate$1 = _ref$formatLongDate === void 0 ? formatLongDate : _ref$formatLongDate,
      calendarType = _ref.calendarType,
      classes = _ref.classes,
      currentMonthIndex = _ref.currentMonthIndex,
      otherProps = _objectWithoutProperties$5(_ref, _excluded$5);
  var date = otherProps.date,
      locale = otherProps.locale;
  return React__default.createElement(Tile, _extends$4({}, otherProps, {
    classes: [].concat(classes, className$2, isWeekend(date, calendarType) ? "".concat(className$2, "--weekend") : null, date.getMonth() !== currentMonthIndex ? "".concat(className$2, "--neighboringMonth") : null),
    formatAbbr: formatLongDate$1,
    maxDateTransform: getDayEnd,
    minDateTransform: getDayStart,
    view: "month"
  }), formatDay$1(locale, date));
}
Day.propTypes = _objectSpread$5(_objectSpread$5({}, tileProps), {}, {
  currentMonthIndex: PropTypes$1.number.isRequired,
  formatDay: PropTypes$1.func,
  formatLongDate: PropTypes$1.func
});

var _excluded$4 = ["showFixedNumberOfWeeks", "showNeighboringMonth"];
function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty$4(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$4(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
function _objectWithoutProperties$4(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$4(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$4(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function Days(props) {
  var activeStartDate = props.activeStartDate,
      calendarType = props.calendarType;
  var showFixedNumberOfWeeks = props.showFixedNumberOfWeeks,
      showNeighboringMonth = props.showNeighboringMonth,
      otherProps = _objectWithoutProperties$4(props, _excluded$4);
  var year = getYear(activeStartDate);
  var monthIndex = getMonth(activeStartDate);
  var hasFixedNumberOfWeeks = showFixedNumberOfWeeks || showNeighboringMonth;
  var dayOfWeek = getDayOfWeek(activeStartDate, calendarType);
  var offset = hasFixedNumberOfWeeks ? 0 : dayOfWeek;
  var start = (hasFixedNumberOfWeeks ? -dayOfWeek : 0) + 1;
  var end = function () {
    if (showFixedNumberOfWeeks) {
      return start + 6 * 7 - 1;
    }
    var daysInMonth = getDaysInMonth(activeStartDate);
    if (showNeighboringMonth) {
      var activeEndDate = new Date();
      activeEndDate.setFullYear(year, monthIndex, daysInMonth);
      activeEndDate.setHours(0, 0, 0, 0);
      var daysUntilEndOfTheWeek = 7 - getDayOfWeek(activeEndDate, calendarType) - 1;
      return daysInMonth + daysUntilEndOfTheWeek;
    }
    return daysInMonth;
  }();
  return React__default.createElement(TileGroup, _extends$3({}, otherProps, {
    className: "react-calendar__month-view__days",
    count: 7,
    currentMonthIndex: monthIndex,
    dateTransform: function dateTransform(day) {
      var date = new Date();
      date.setFullYear(year, monthIndex, day);
      date.setHours(0, 0, 0, 0);
      return date;
    },
    dateType: "day",
    end: end,
    offset: offset,
    start: start,
    tile: Day
  }));
}
Days.propTypes = _objectSpread$4({
  calendarType: isCalendarType.isRequired,
  showFixedNumberOfWeeks: PropTypes$1.bool,
  showNeighboringMonth: PropTypes$1.bool
}, tileGroupProps);

var className$1 = 'react-calendar__month-view__weekdays';
function Weekdays(props) {
  var calendarType = props.calendarType,
      _props$formatShortWee = props.formatShortWeekday,
      formatShortWeekday$1 = _props$formatShortWee === void 0 ? formatShortWeekday : _props$formatShortWee,
      locale = props.locale,
      onMouseLeave = props.onMouseLeave;
  var anyDate = new Date();
  var beginOfMonth = getMonthStart(anyDate);
  var year = getYear(beginOfMonth);
  var monthIndex = getMonth(beginOfMonth);
  var weekdays = [];
  for (var weekday = 1; weekday <= 7; weekday += 1) {
    var weekdayDate = new Date(year, monthIndex, weekday - getDayOfWeek(beginOfMonth, calendarType));
    var abbr = formatWeekday(locale, weekdayDate);
    weekdays.push( React__default.createElement("div", {
      key: weekday,
      className: "".concat(className$1, "__weekday")
    }, React__default.createElement("abbr", {
      "aria-label": abbr,
      title: abbr
    }, formatShortWeekday$1(locale, weekdayDate).replace('.', ''))));
  }
  return React__default.createElement(Flex, {
    className: className$1,
    count: 7,
    onFocus: onMouseLeave,
    onMouseOver: onMouseLeave
  }, weekdays);
}
Weekdays.propTypes = {
  calendarType: isCalendarType.isRequired,
  formatShortWeekday: PropTypes$1.func,
  locale: PropTypes$1.string,
  onMouseLeave: PropTypes$1.func
};

var _excluded$3 = ["date", "onClickWeekNumber", "weekNumber"];
function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty$3(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$3(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties$3(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$3(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$3(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var className = 'react-calendar__tile';
function WeekNumber(_ref) {
  var date = _ref.date,
      onClickWeekNumber = _ref.onClickWeekNumber,
      weekNumber = _ref.weekNumber,
      otherProps = _objectWithoutProperties$3(_ref, _excluded$3);
  var props = _objectSpread$3({
    className: className
  }, otherProps);
  var children = React__default.createElement("span", null, weekNumber);
  return onClickWeekNumber ? React__default.createElement("button", _extends$2({}, props, {
    onClick: function onClick(event) {
      return onClickWeekNumber(weekNumber, date, event);
    },
    type: "button"
  }), children) : React__default.createElement("div", props, children);
}
WeekNumber.propTypes = {
  date: PropTypes$1.instanceOf(Date).isRequired,
  onClickWeekNumber: PropTypes$1.func,
  weekNumber: PropTypes$1.node.isRequired
};

function WeekNumbers(props) {
  var activeStartDate = props.activeStartDate,
      calendarType = props.calendarType,
      onClickWeekNumber = props.onClickWeekNumber,
      onMouseLeave = props.onMouseLeave,
      showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;
  var numberOfWeeks = function () {
    if (showFixedNumberOfWeeks) {
      return 6;
    }
    var numberOfDays = getDaysInMonth(activeStartDate);
    var startWeekday = getDayOfWeek(activeStartDate, calendarType);
    var days = numberOfDays - (7 - startWeekday);
    return 1 + Math.ceil(days / 7);
  }();
  var dates = function () {
    var year = getYear(activeStartDate);
    var monthIndex = getMonth(activeStartDate);
    var day = getDate(activeStartDate);
    var result = [];
    for (var index = 0; index < numberOfWeeks; index += 1) {
      result.push(getBeginOfWeek(new Date(year, monthIndex, day + index * 7), calendarType));
    }
    return result;
  }();
  var weekNumbers = dates.map(function (date) {
    return getWeekNumber(date, calendarType);
  });
  return React__default.createElement(Flex, {
    className: "react-calendar__month-view__weekNumbers",
    count: numberOfWeeks,
    direction: "column",
    onFocus: onMouseLeave,
    onMouseOver: onMouseLeave,
    style: {
      flexBasis: 'calc(100% * (1 / 8)',
      flexShrink: 0
    }
  }, weekNumbers.map(function (weekNumber, weekIndex) {
    return React__default.createElement(WeekNumber, {
      key: weekNumber,
      date: dates[weekIndex],
      onClickWeekNumber: onClickWeekNumber,
      weekNumber: weekNumber
    });
  }));
}
WeekNumbers.propTypes = {
  activeStartDate: PropTypes$1.instanceOf(Date).isRequired,
  calendarType: isCalendarType.isRequired,
  onClickWeekNumber: PropTypes$1.func,
  onMouseLeave: PropTypes$1.func,
  showFixedNumberOfWeeks: PropTypes$1.bool
};

var _excluded$2 = ["calendarType", "formatShortWeekday", "onClickWeekNumber", "showWeekNumbers"];
function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
function _objectWithoutProperties$2(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$2(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$2(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function getCalendarTypeFromLocale(locale) {
  return Object.keys(CALENDAR_TYPE_LOCALES).find(function (calendarType) {
    return CALENDAR_TYPE_LOCALES[calendarType].includes(locale);
  }) || CALENDAR_TYPES.ISO_8601;
}
function MonthView(props) {
  var activeStartDate = props.activeStartDate,
      locale = props.locale,
      onMouseLeave = props.onMouseLeave,
      showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;
  var _props$calendarType = props.calendarType,
      calendarType = _props$calendarType === void 0 ? getCalendarTypeFromLocale(locale) : _props$calendarType,
      formatShortWeekday = props.formatShortWeekday,
      onClickWeekNumber = props.onClickWeekNumber,
      showWeekNumbers = props.showWeekNumbers,
      childProps = _objectWithoutProperties$2(props, _excluded$2);
  function renderWeekdays() {
    return React__default.createElement(Weekdays, {
      calendarType: calendarType,
      formatShortWeekday: formatShortWeekday,
      locale: locale,
      onMouseLeave: onMouseLeave
    });
  }
  function renderWeekNumbers() {
    if (!showWeekNumbers) {
      return null;
    }
    return React__default.createElement(WeekNumbers, {
      activeStartDate: activeStartDate,
      calendarType: calendarType,
      onClickWeekNumber: onClickWeekNumber,
      onMouseLeave: onMouseLeave,
      showFixedNumberOfWeeks: showFixedNumberOfWeeks
    });
  }
  function renderDays() {
    return React__default.createElement(Days, _extends$1({
      calendarType: calendarType
    }, childProps));
  }
  var className = 'react-calendar__month-view';
  return React__default.createElement("div", {
    className: mergeClassNames(className, showWeekNumbers ? "".concat(className, "--weekNumbers") : '')
  }, React__default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'flex-end'
    }
  }, renderWeekNumbers(), React__default.createElement("div", {
    style: {
      flexGrow: 1,
      width: '100%'
    }
  }, renderWeekdays(), renderDays())));
}
MonthView.propTypes = {
  activeStartDate: PropTypes$1.instanceOf(Date).isRequired,
  calendarType: isCalendarType,
  formatShortWeekday: PropTypes$1.func,
  locale: PropTypes$1.string,
  onClickWeekNumber: PropTypes$1.func,
  onMouseLeave: PropTypes$1.func,
  showFixedNumberOfWeeks: PropTypes$1.bool,
  showWeekNumbers: PropTypes$1.bool
};

var _excluded$1 = ["activeStartDate", "defaultActiveStartDate", "defaultValue", "defaultView", "maxDetail", "minDetail", "value", "view"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty$2(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties$1(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$1(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toConsumableArray$2(arr) { return _arrayWithoutHoles$2(arr) || _iterableToArray$2(arr) || _unsupportedIterableToArray$2(arr) || _nonIterableSpread$2(); }
function _nonIterableSpread$2() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }
function _iterableToArray$2(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles$2(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$2(arr); }
function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var defaultMinDate = new Date();
defaultMinDate.setFullYear(1, 0, 1);
defaultMinDate.setHours(0, 0, 0, 0);
var defaultMaxDate = new Date(8.64e15);
var baseClassName = 'react-calendar';
var allViews = ['century', 'decade', 'year', 'month'];
var allValueTypes = [].concat(_toConsumableArray$2(allViews.slice(1)), ['day']);
function toDate(value) {
  if (value instanceof Date) {
    return value;
  }
  return new Date(value);
}
function getLimitedViews(minDetail, maxDetail) {
  return allViews.slice(allViews.indexOf(minDetail), allViews.indexOf(maxDetail) + 1);
}
function isViewAllowed(view, minDetail, maxDetail) {
  var views = getLimitedViews(minDetail, maxDetail);
  return views.indexOf(view) !== -1;
}
function getView(view, minDetail, maxDetail) {
  if (isViewAllowed(view, minDetail, maxDetail)) {
    return view;
  }
  return maxDetail;
}
function getValueType(maxDetail) {
  return allValueTypes[allViews.indexOf(maxDetail)];
}
function getValue(value, index) {
  if (!value) {
    return null;
  }
  var rawValue = Array.isArray(value) && value.length === 2 ? value[index] : value;
  if (!rawValue) {
    return null;
  }
  var valueDate = toDate(rawValue);
  if (isNaN(valueDate.getTime())) {
    throw new Error("Invalid date: ".concat(value));
  }
  return valueDate;
}
function getDetailValue(_ref, index) {
  var value = _ref.value,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      maxDetail = _ref.maxDetail;
  var valuePiece = getValue(value, index);
  if (!valuePiece) {
    return null;
  }
  var valueType = getValueType(maxDetail);
  var detailValueFrom = [getBegin, getEnd][index](valueType, valuePiece);
  return between(detailValueFrom, minDate, maxDate);
}
var getDetailValueFrom = function getDetailValueFrom(args) {
  return getDetailValue(args, 0);
};
var getDetailValueTo = function getDetailValueTo(args) {
  return getDetailValue(args, 1);
};
var getDetailValueArray = function getDetailValueArray(args) {
  var value = args.value;
  if (Array.isArray(value)) {
    return value;
  }
  return [getDetailValueFrom, getDetailValueTo].map(function (fn) {
    return fn(args);
  });
};
function getActiveStartDate(props) {
  var maxDate = props.maxDate,
      maxDetail = props.maxDetail,
      minDate = props.minDate,
      minDetail = props.minDetail,
      value = props.value,
      view = props.view;
  var rangeType = getView(view, minDetail, maxDetail);
  var valueFrom = getDetailValueFrom({
    value: value,
    minDate: minDate,
    maxDate: maxDate,
    maxDetail: maxDetail
  }) || new Date();
  return getBegin(rangeType, valueFrom);
}
function getInitialActiveStartDate(props) {
  var activeStartDate = props.activeStartDate,
      defaultActiveStartDate = props.defaultActiveStartDate,
      defaultValue = props.defaultValue,
      defaultView = props.defaultView,
      maxDetail = props.maxDetail,
      minDetail = props.minDetail,
      value = props.value,
      view = props.view,
      otherProps = _objectWithoutProperties$1(props, _excluded$1);
  var rangeType = getView(view, minDetail, maxDetail);
  var valueFrom = activeStartDate || defaultActiveStartDate;
  if (valueFrom) {
    return getBegin(rangeType, valueFrom);
  }
  return getActiveStartDate(_objectSpread$2({
    maxDetail: maxDetail,
    minDetail: minDetail,
    value: value || defaultValue,
    view: view || defaultView
  }, otherProps));
}
var getIsSingleValue = function getIsSingleValue(value) {
  return value && [].concat(value).length === 1;
};
var Calendar$1 = function (_Component) {
  _inherits(Calendar, _Component);
  var _super = _createSuper(Calendar);
  function Calendar() {
    var _this;
    _classCallCheck(this, Calendar);
    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(_args));
    _defineProperty$2(_assertThisInitialized(_this), "state", {
      activeStartDate: _this.props.defaultActiveStartDate,
      value: _this.props.defaultValue,
      view: _this.props.defaultView
    });
    _defineProperty$2(_assertThisInitialized(_this), "setStateAndCallCallbacks", function (nextState, event, callback) {
      var _assertThisInitialize = _assertThisInitialized(_this),
          previousActiveStartDate = _assertThisInitialize.activeStartDate,
          previousView = _assertThisInitialize.view;
      var _this$props = _this.props,
          allowPartialRange = _this$props.allowPartialRange,
          onActiveStartDateChange = _this$props.onActiveStartDateChange,
          onChange = _this$props.onChange,
          onViewChange = _this$props.onViewChange,
          selectRange = _this$props.selectRange;
      var prevArgs = {
        activeStartDate: previousActiveStartDate,
        view: previousView
      };
      _this.setState(nextState, function () {
        var args = {
          action: nextState.action,
          activeStartDate: nextState.activeStartDate || _this.activeStartDate,
          value: nextState.value || _this.value,
          view: nextState.view || _this.view
        };
        function shouldUpdate(key) {
          return (
            key in nextState && (
            _typeof(nextState[key]) !== _typeof(prevArgs[key]) || (
            nextState[key] instanceof Date ? nextState[key].getTime() !== prevArgs[key].getTime() : nextState[key] !== prevArgs[key]))
          );
        }
        if (shouldUpdate('activeStartDate')) {
          if (onActiveStartDateChange) onActiveStartDateChange(args);
        }
        if (shouldUpdate('view')) {
          if (onViewChange) onViewChange(args);
        }
        if (shouldUpdate('value')) {
          if (onChange) {
            if (selectRange) {
              var isSingleValue = getIsSingleValue(nextState.value);
              if (!isSingleValue) {
                onChange(nextState.value, event);
              } else if (allowPartialRange) {
                onChange([nextState.value], event);
              }
            } else {
              onChange(nextState.value, event);
            }
          }
        }
        if (callback) callback(args);
      });
    });
    _defineProperty$2(_assertThisInitialized(_this), "setActiveStartDate", function (nextActiveStartDate, action) {
      _this.setStateAndCallCallbacks({
        action: action,
        activeStartDate: nextActiveStartDate
      });
    });
    _defineProperty$2(_assertThisInitialized(_this), "drillDown", function (nextActiveStartDate, event) {
      if (!_this.drillDownAvailable) {
        return;
      }
      _this.onClickTile(nextActiveStartDate, event);
      var _assertThisInitialize2 = _assertThisInitialized(_this),
          view = _assertThisInitialize2.view,
          views = _assertThisInitialize2.views;
      var onDrillDown = _this.props.onDrillDown;
      var nextView = views[views.indexOf(view) + 1];
      _this.setStateAndCallCallbacks({
        action: 'drillDown',
        activeStartDate: nextActiveStartDate,
        view: nextView
      }, undefined, onDrillDown);
    });
    _defineProperty$2(_assertThisInitialized(_this), "drillUp", function () {
      if (!_this.drillUpAvailable) {
        return;
      }
      var _assertThisInitialize3 = _assertThisInitialized(_this),
          activeStartDate = _assertThisInitialize3.activeStartDate,
          view = _assertThisInitialize3.view,
          views = _assertThisInitialize3.views;
      var onDrillUp = _this.props.onDrillUp;
      var nextView = views[views.indexOf(view) - 1];
      var nextActiveStartDate = getBegin(nextView, activeStartDate);
      _this.setStateAndCallCallbacks({
        action: 'drillUp',
        activeStartDate: nextActiveStartDate,
        view: nextView
      }, undefined, onDrillUp);
    });
    _defineProperty$2(_assertThisInitialized(_this), "onChange", function (value, event) {
      var selectRange = _this.props.selectRange;
      _this.onClickTile(value, event);
      var nextValue;
      if (selectRange) {
        var _assertThisInitialize4 = _assertThisInitialized(_this),
            previousValue = _assertThisInitialize4.value,
            valueType = _assertThisInitialize4.valueType;
        if (!getIsSingleValue(previousValue)) {
          nextValue = getBegin(valueType, value);
        } else {
          nextValue = getValueRange(valueType, previousValue, value);
        }
      } else {
        nextValue = _this.getProcessedValue(value);
      }
      var nextActiveStartDate = getActiveStartDate(_objectSpread$2(_objectSpread$2({}, _this.props), {}, {
        value: nextValue
      }));
      event.persist();
      _this.setStateAndCallCallbacks({
        action: 'onChange',
        activeStartDate: nextActiveStartDate,
        value: nextValue
      }, event);
    });
    _defineProperty$2(_assertThisInitialized(_this), "onClickTile", function (value, event) {
      var _assertThisInitialize5 = _assertThisInitialized(_this),
          view = _assertThisInitialize5.view;
      var _this$props2 = _this.props,
          onClickDay = _this$props2.onClickDay,
          onClickDecade = _this$props2.onClickDecade,
          onClickMonth = _this$props2.onClickMonth,
          onClickYear = _this$props2.onClickYear;
      var callback = function () {
        switch (view) {
          case 'century':
            return onClickDecade;
          case 'decade':
            return onClickYear;
          case 'year':
            return onClickMonth;
          case 'month':
            return onClickDay;
          default:
            throw new Error("Invalid view: ".concat(view, "."));
        }
      }();
      if (callback) callback(value, event);
    });
    _defineProperty$2(_assertThisInitialized(_this), "onMouseOver", function (value) {
      _this.setState(function (prevState) {
        if (prevState.hover && prevState.hover.getTime() === value.getTime()) {
          return null;
        }
        return {
          hover: value
        };
      });
    });
    _defineProperty$2(_assertThisInitialized(_this), "onMouseLeave", function () {
      _this.setState({
        hover: null
      });
    });
    return _this;
  }
  _createClass(Calendar, [{
    key: "activeStartDate",
    get: function get() {
      var activeStartDateProps = this.props.activeStartDate;
      var activeStartDateState = this.state.activeStartDate;
      return activeStartDateProps || activeStartDateState || getInitialActiveStartDate(this.props);
    }
  }, {
    key: "value",
    get: function get() {
      var _this$props3 = this.props,
          selectRange = _this$props3.selectRange,
          valueProps = _this$props3.value;
      var valueState = this.state.value;
      if (selectRange && getIsSingleValue(valueState)) {
        return valueState;
      }
      return valueProps !== undefined ? valueProps : valueState;
    }
  }, {
    key: "valueType",
    get: function get() {
      var maxDetail = this.props.maxDetail;
      return getValueType(maxDetail);
    }
  }, {
    key: "view",
    get: function get() {
      var _this$props4 = this.props,
          minDetail = _this$props4.minDetail,
          maxDetail = _this$props4.maxDetail,
          viewProps = _this$props4.view;
      var viewState = this.state.view;
      return getView(viewProps || viewState, minDetail, maxDetail);
    }
  }, {
    key: "views",
    get: function get() {
      var _this$props5 = this.props,
          minDetail = _this$props5.minDetail,
          maxDetail = _this$props5.maxDetail;
      return getLimitedViews(minDetail, maxDetail);
    }
  }, {
    key: "hover",
    get: function get() {
      var selectRange = this.props.selectRange;
      var hover = this.state.hover;
      return selectRange ? hover : null;
    }
  }, {
    key: "drillDownAvailable",
    get: function get() {
      var view = this.view,
          views = this.views;
      return views.indexOf(view) < views.length - 1;
    }
  }, {
    key: "drillUpAvailable",
    get: function get() {
      var view = this.view,
          views = this.views;
      return views.indexOf(view) > 0;
    }
  }, {
    key: "getProcessedValue",
    value: function getProcessedValue(value) {
      var _this$props6 = this.props,
          minDate = _this$props6.minDate,
          maxDate = _this$props6.maxDate,
          maxDetail = _this$props6.maxDetail,
          returnValue = _this$props6.returnValue;
      var processFunction = function () {
        switch (returnValue) {
          case 'start':
            return getDetailValueFrom;
          case 'end':
            return getDetailValueTo;
          case 'range':
            return getDetailValueArray;
          default:
            throw new Error('Invalid returnValue.');
        }
      }();
      return processFunction({
        value: value,
        minDate: minDate,
        maxDate: maxDate,
        maxDetail: maxDetail
      });
    }
  }, {
    key: "renderContent",
    value: function renderContent(next) {
      var currentActiveStartDate = this.activeStartDate,
          onMouseOver = this.onMouseOver,
          valueType = this.valueType,
          value = this.value,
          view = this.view;
      var _this$props7 = this.props,
          calendarType = _this$props7.calendarType,
          locale = _this$props7.locale,
          maxDate = _this$props7.maxDate,
          minDate = _this$props7.minDate,
          selectRange = _this$props7.selectRange,
          tileClassName = _this$props7.tileClassName,
          tileContent = _this$props7.tileContent,
          tileDisabled = _this$props7.tileDisabled;
      var hover = this.hover;
      var activeStartDate = next ? getBeginNext(view, currentActiveStartDate) : getBegin(view, currentActiveStartDate);
      var onClick = this.drillDownAvailable ? this.drillDown : this.onChange;
      var commonProps = {
        activeStartDate: activeStartDate,
        hover: hover,
        locale: locale,
        maxDate: maxDate,
        minDate: minDate,
        onClick: onClick,
        onMouseOver: selectRange ? onMouseOver : null,
        tileClassName: tileClassName,
        tileContent: tileContent,
        tileDisabled: tileDisabled,
        value: value,
        valueType: valueType
      };
      switch (view) {
        case 'century':
          {
            var formatYear = this.props.formatYear;
            return React__default.createElement(CenturyView, _extends({
              formatYear: formatYear
            }, commonProps));
          }
        case 'decade':
          {
            var _formatYear = this.props.formatYear;
            return React__default.createElement(DecadeView, _extends({
              formatYear: _formatYear
            }, commonProps));
          }
        case 'year':
          {
            var _this$props8 = this.props,
                formatMonth = _this$props8.formatMonth,
                formatMonthYear = _this$props8.formatMonthYear;
            return React__default.createElement(YearView, _extends({
              formatMonth: formatMonth,
              formatMonthYear: formatMonthYear
            }, commonProps));
          }
        case 'month':
          {
            var _this$props9 = this.props,
                formatDay = _this$props9.formatDay,
                formatLongDate = _this$props9.formatLongDate,
                formatShortWeekday = _this$props9.formatShortWeekday,
                onClickWeekNumber = _this$props9.onClickWeekNumber,
                showDoubleView = _this$props9.showDoubleView,
                showFixedNumberOfWeeks = _this$props9.showFixedNumberOfWeeks,
                showNeighboringMonth = _this$props9.showNeighboringMonth,
                showWeekNumbers = _this$props9.showWeekNumbers;
            var onMouseLeave = this.onMouseLeave;
            return React__default.createElement(MonthView, _extends({
              calendarType: calendarType,
              formatDay: formatDay,
              formatLongDate: formatLongDate,
              formatShortWeekday: formatShortWeekday,
              onClickWeekNumber: onClickWeekNumber,
              onMouseLeave: selectRange ? onMouseLeave : null,
              showFixedNumberOfWeeks: typeof showFixedNumberOfWeeks !== 'undefined' ? showFixedNumberOfWeeks : showDoubleView,
              showNeighboringMonth: showNeighboringMonth,
              showWeekNumbers: showWeekNumbers
            }, commonProps));
          }
        default:
          throw new Error("Invalid view: ".concat(view, "."));
      }
    }
  }, {
    key: "renderNavigation",
    value: function renderNavigation() {
      var showNavigation = this.props.showNavigation;
      if (!showNavigation) {
        return null;
      }
      var activeStartDate = this.activeStartDate,
          view = this.view,
          views = this.views;
      var _this$props10 = this.props,
          formatMonthYear = _this$props10.formatMonthYear,
          formatYear = _this$props10.formatYear,
          locale = _this$props10.locale,
          maxDate = _this$props10.maxDate,
          minDate = _this$props10.minDate,
          navigationAriaLabel = _this$props10.navigationAriaLabel,
          navigationAriaLive = _this$props10.navigationAriaLive,
          navigationLabel = _this$props10.navigationLabel,
          next2AriaLabel = _this$props10.next2AriaLabel,
          next2Label = _this$props10.next2Label,
          nextAriaLabel = _this$props10.nextAriaLabel,
          nextLabel = _this$props10.nextLabel,
          prev2AriaLabel = _this$props10.prev2AriaLabel,
          prev2Label = _this$props10.prev2Label,
          prevAriaLabel = _this$props10.prevAriaLabel,
          prevLabel = _this$props10.prevLabel,
          showDoubleView = _this$props10.showDoubleView;
      return React__default.createElement(Navigation, {
        activeStartDate: activeStartDate,
        drillUp: this.drillUp,
        formatMonthYear: formatMonthYear,
        formatYear: formatYear,
        locale: locale,
        maxDate: maxDate,
        minDate: minDate,
        navigationAriaLabel: navigationAriaLabel,
        navigationAriaLive: navigationAriaLive,
        navigationLabel: navigationLabel,
        next2AriaLabel: next2AriaLabel,
        next2Label: next2Label,
        nextAriaLabel: nextAriaLabel,
        nextLabel: nextLabel,
        prev2AriaLabel: prev2AriaLabel,
        prev2Label: prev2Label,
        prevAriaLabel: prevAriaLabel,
        prevLabel: prevLabel,
        setActiveStartDate: this.setActiveStartDate,
        showDoubleView: showDoubleView,
        view: view,
        views: views
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props11 = this.props,
          className = _this$props11.className,
          inputRef = _this$props11.inputRef,
          selectRange = _this$props11.selectRange,
          showDoubleView = _this$props11.showDoubleView;
      var onMouseLeave = this.onMouseLeave,
          value = this.value;
      var valueArray = [].concat(value);
      return React__default.createElement("div", {
        className: mergeClassNames(baseClassName, selectRange && valueArray.length === 1 && "".concat(baseClassName, "--selectRange"), showDoubleView && "".concat(baseClassName, "--doubleView"), className),
        ref: inputRef
      }, this.renderNavigation(), React__default.createElement("div", {
        className: "".concat(baseClassName, "__viewContainer"),
        onBlur: selectRange ? onMouseLeave : null,
        onMouseLeave: selectRange ? onMouseLeave : null
      }, this.renderContent(), showDoubleView && this.renderContent(true)));
    }
  }]);
  return Calendar;
}(Component);
Calendar$1.defaultProps = {
  maxDate: defaultMaxDate,
  maxDetail: 'month',
  minDate: defaultMinDate,
  minDetail: 'century',
  returnValue: 'start',
  showNavigation: true,
  showNeighboringMonth: true
};
var isActiveStartDate = PropTypes$1.instanceOf(Date);
var isLooseValue = PropTypes$1.oneOfType([PropTypes$1.string, isValue]);
Calendar$1.propTypes = {
  activeStartDate: isActiveStartDate,
  allowPartialRange: PropTypes$1.bool,
  calendarType: isCalendarType,
  className: isClassName,
  defaultActiveStartDate: isActiveStartDate,
  defaultValue: isLooseValue,
  defaultView: isView,
  formatDay: PropTypes$1.func,
  formatLongDate: PropTypes$1.func,
  formatMonth: PropTypes$1.func,
  formatMonthYear: PropTypes$1.func,
  formatShortWeekday: PropTypes$1.func,
  formatYear: PropTypes$1.func,
  inputRef: isRef,
  locale: PropTypes$1.string,
  maxDate: isMaxDate,
  maxDetail: PropTypes$1.oneOf(allViews),
  minDate: isMinDate,
  minDetail: PropTypes$1.oneOf(allViews),
  navigationAriaLabel: PropTypes$1.string,
  navigationAriaLive: PropTypes$1.oneOf(['off', 'polite', 'assertive']),
  navigationLabel: PropTypes$1.func,
  next2AriaLabel: PropTypes$1.string,
  next2Label: PropTypes$1.node,
  nextAriaLabel: PropTypes$1.string,
  nextLabel: PropTypes$1.node,
  onActiveStartDateChange: PropTypes$1.func,
  onChange: PropTypes$1.func,
  onClickDay: PropTypes$1.func,
  onClickDecade: PropTypes$1.func,
  onClickMonth: PropTypes$1.func,
  onClickWeekNumber: PropTypes$1.func,
  onClickYear: PropTypes$1.func,
  onDrillDown: PropTypes$1.func,
  onDrillUp: PropTypes$1.func,
  onViewChange: PropTypes$1.func,
  prev2AriaLabel: PropTypes$1.string,
  prev2Label: PropTypes$1.node,
  prevAriaLabel: PropTypes$1.string,
  prevLabel: PropTypes$1.node,
  returnValue: PropTypes$1.oneOf(['start', 'end', 'range']),
  selectRange: PropTypes$1.bool,
  showDoubleView: PropTypes$1.bool,
  showFixedNumberOfWeeks: PropTypes$1.bool,
  showNavigation: PropTypes$1.bool,
  showNeighboringMonth: PropTypes$1.bool,
  showWeekNumbers: PropTypes$1.bool,
  tileClassName: PropTypes$1.oneOfType([PropTypes$1.func, isClassName]),
  tileContent: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.node]),
  tileDisabled: PropTypes$1.func,
  value: isLooseValue,
  view: isView
};

var Calendar = Calendar$1;

class LuxonError extends Error {}
class InvalidDateTimeError extends LuxonError {
  constructor(reason) {
    super(`Invalid DateTime: ${reason.toMessage()}`);
  }
}
class InvalidIntervalError extends LuxonError {
  constructor(reason) {
    super(`Invalid Interval: ${reason.toMessage()}`);
  }
}
class InvalidDurationError extends LuxonError {
  constructor(reason) {
    super(`Invalid Duration: ${reason.toMessage()}`);
  }
}
class ConflictingSpecificationError extends LuxonError {}
class InvalidUnitError extends LuxonError {
  constructor(unit) {
    super(`Invalid unit ${unit}`);
  }
}
class InvalidArgumentError extends LuxonError {}
class ZoneIsAbstractError extends LuxonError {
  constructor() {
    super("Zone is an abstract class");
  }
}

const n = "numeric",
  s = "short",
  l = "long";
const DATE_SHORT = {
  year: n,
  month: n,
  day: n,
};
const DATE_MED = {
  year: n,
  month: s,
  day: n,
};
const DATE_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s,
};
const DATE_FULL = {
  year: n,
  month: l,
  day: n,
};
const DATE_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
};
const TIME_SIMPLE = {
  hour: n,
  minute: n,
};
const TIME_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n,
};
const TIME_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s,
};
const TIME_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l,
};
const TIME_24_SIMPLE = {
  hour: n,
  minute: n,
  hourCycle: "h23",
};
const TIME_24_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
};
const TIME_24_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: s,
};
const TIME_24_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: l,
};
const DATETIME_SHORT = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n,
};
const DATETIME_SHORT_WITH_SECONDS = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n,
  second: n,
};
const DATETIME_MED = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n,
};
const DATETIME_MED_WITH_SECONDS = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n,
  second: n,
};
const DATETIME_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s,
  hour: n,
  minute: n,
};
const DATETIME_FULL = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  timeZoneName: s,
};
const DATETIME_FULL_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s,
};
const DATETIME_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  timeZoneName: l,
};
const DATETIME_HUGE_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l,
};

class Zone {
  get type() {
    throw new ZoneIsAbstractError();
  }
  get name() {
    throw new ZoneIsAbstractError();
  }
  get ianaName() {
    return this.name;
  }
  get isUniversal() {
    throw new ZoneIsAbstractError();
  }
  offsetName(ts, opts) {
    throw new ZoneIsAbstractError();
  }
  formatOffset(ts, format) {
    throw new ZoneIsAbstractError();
  }
  offset(ts) {
    throw new ZoneIsAbstractError();
  }
  equals(otherZone) {
    throw new ZoneIsAbstractError();
  }
  get isValid() {
    throw new ZoneIsAbstractError();
  }
}

let singleton$1 = null;
class SystemZone extends Zone {
  static get instance() {
    if (singleton$1 === null) {
      singleton$1 = new SystemZone();
    }
    return singleton$1;
  }
  get type() {
    return "system";
  }
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  get isUniversal() {
    return false;
  }
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale);
  }
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  offset(ts) {
    return -new Date(ts).getTimezoneOffset();
  }
  equals(otherZone) {
    return otherZone.type === "system";
  }
  get isValid() {
    return true;
  }
}

let dtfCache = {};
function makeDTF(zone) {
  if (!dtfCache[zone]) {
    dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: zone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      era: "short",
    });
  }
  return dtfCache[zone];
}
const typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6,
};
function hackyOffset(dtf, date) {
  const formatted = dtf.format(date).replace(/\u200E/g, ""),
    parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted),
    [, fMonth, fDay, fYear, fadOrBc, fHour, fMinute, fSecond] = parsed;
  return [fYear, fMonth, fDay, fadOrBc, fHour, fMinute, fSecond];
}
function partsOffset(dtf, date) {
  const formatted = dtf.formatToParts(date);
  const filled = [];
  for (let i = 0; i < formatted.length; i++) {
    const { type, value } = formatted[i];
    const pos = typeToPos[type];
    if (type === "era") {
      filled[pos] = value;
    } else if (!isUndefined(pos)) {
      filled[pos] = parseInt(value, 10);
    }
  }
  return filled;
}
let ianaZoneCache = {};
class IANAZone extends Zone {
  static create(name) {
    if (!ianaZoneCache[name]) {
      ianaZoneCache[name] = new IANAZone(name);
    }
    return ianaZoneCache[name];
  }
  static resetCache() {
    ianaZoneCache = {};
    dtfCache = {};
  }
  static isValidSpecifier(s) {
    return this.isValidZone(s);
  }
  static isValidZone(zone) {
    if (!zone) {
      return false;
    }
    try {
      new Intl.DateTimeFormat("en-US", { timeZone: zone }).format();
      return true;
    } catch (e) {
      return false;
    }
  }
  constructor(name) {
    super();
    this.zoneName = name;
    this.valid = IANAZone.isValidZone(name);
  }
  get type() {
    return "iana";
  }
  get name() {
    return this.zoneName;
  }
  get isUniversal() {
    return false;
  }
  offsetName(ts, { format, locale }) {
    return parseZoneInfo(ts, format, locale, this.name);
  }
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  offset(ts) {
    const date = new Date(ts);
    if (isNaN(date)) return NaN;
    const dtf = makeDTF(this.name);
    let [year, month, day, adOrBc, hour, minute, second] = dtf.formatToParts
      ? partsOffset(dtf, date)
      : hackyOffset(dtf, date);
    if (adOrBc === "BC") {
      year = -Math.abs(year) + 1;
    }
    const adjustedHour = hour === 24 ? 0 : hour;
    const asUTC = objToLocalTS({
      year,
      month,
      day,
      hour: adjustedHour,
      minute,
      second,
      millisecond: 0,
    });
    let asTS = +date;
    const over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return (asUTC - asTS) / (60 * 1000);
  }
  equals(otherZone) {
    return otherZone.type === "iana" && otherZone.name === this.name;
  }
  get isValid() {
    return this.valid;
  }
}

let intlLFCache = {};
function getCachedLF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlLFCache[key];
  if (!dtf) {
    dtf = new Intl.ListFormat(locString, opts);
    intlLFCache[key] = dtf;
  }
  return dtf;
}
let intlDTCache = {};
function getCachedDTF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlDTCache[key];
  if (!dtf) {
    dtf = new Intl.DateTimeFormat(locString, opts);
    intlDTCache[key] = dtf;
  }
  return dtf;
}
let intlNumCache = {};
function getCachedINF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let inf = intlNumCache[key];
  if (!inf) {
    inf = new Intl.NumberFormat(locString, opts);
    intlNumCache[key] = inf;
  }
  return inf;
}
let intlRelCache = {};
function getCachedRTF(locString, opts = {}) {
  const { base, ...cacheKeyOpts } = opts;
  const key = JSON.stringify([locString, cacheKeyOpts]);
  let inf = intlRelCache[key];
  if (!inf) {
    inf = new Intl.RelativeTimeFormat(locString, opts);
    intlRelCache[key] = inf;
  }
  return inf;
}
let sysLocaleCache = null;
function systemLocale() {
  if (sysLocaleCache) {
    return sysLocaleCache;
  } else {
    sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
    return sysLocaleCache;
  }
}
function parseLocaleString(localeStr) {
  const xIndex = localeStr.indexOf("-x-");
  if (xIndex !== -1) {
    localeStr = localeStr.substring(0, xIndex);
  }
  const uIndex = localeStr.indexOf("-u-");
  if (uIndex === -1) {
    return [localeStr];
  } else {
    let options;
    let selectedStr;
    try {
      options = getCachedDTF(localeStr).resolvedOptions();
      selectedStr = localeStr;
    } catch (e) {
      const smaller = localeStr.substring(0, uIndex);
      options = getCachedDTF(smaller).resolvedOptions();
      selectedStr = smaller;
    }
    const { numberingSystem, calendar } = options;
    return [selectedStr, numberingSystem, calendar];
  }
}
function intlConfigString(localeStr, numberingSystem, outputCalendar) {
  if (outputCalendar || numberingSystem) {
    if (!localeStr.includes("-u-")) {
      localeStr += "-u";
    }
    if (outputCalendar) {
      localeStr += `-ca-${outputCalendar}`;
    }
    if (numberingSystem) {
      localeStr += `-nu-${numberingSystem}`;
    }
    return localeStr;
  } else {
    return localeStr;
  }
}
function mapMonths(f) {
  const ms = [];
  for (let i = 1; i <= 12; i++) {
    const dt = DateTime.utc(2016, i, 1);
    ms.push(f(dt));
  }
  return ms;
}
function mapWeekdays(f) {
  const ms = [];
  for (let i = 1; i <= 7; i++) {
    const dt = DateTime.utc(2016, 11, 13 + i);
    ms.push(f(dt));
  }
  return ms;
}
function listStuff(loc, length, defaultOK, englishFn, intlFn) {
  const mode = loc.listingMode(defaultOK);
  if (mode === "error") {
    return null;
  } else if (mode === "en") {
    return englishFn(length);
  } else {
    return intlFn(length);
  }
}
function supportsFastNumbers(loc) {
  if (loc.numberingSystem && loc.numberingSystem !== "latn") {
    return false;
  } else {
    return (
      loc.numberingSystem === "latn" ||
      !loc.locale ||
      loc.locale.startsWith("en") ||
      new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn"
    );
  }
}
class PolyNumberFormatter {
  constructor(intl, forceSimple, opts) {
    this.padTo = opts.padTo || 0;
    this.floor = opts.floor || false;
    const { padTo, floor, ...otherOpts } = opts;
    if (!forceSimple || Object.keys(otherOpts).length > 0) {
      const intlOpts = { useGrouping: false, ...opts };
      if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
      this.inf = getCachedINF(intl, intlOpts);
    }
  }
  format(i) {
    if (this.inf) {
      const fixed = this.floor ? Math.floor(i) : i;
      return this.inf.format(fixed);
    } else {
      const fixed = this.floor ? Math.floor(i) : roundTo(i, 3);
      return padStart(fixed, this.padTo);
    }
  }
}
class PolyDateFormatter {
  constructor(dt, intl, opts) {
    this.opts = opts;
    let z = undefined;
    if (dt.zone.isUniversal) {
      const gmtOffset = -1 * (dt.offset / 60);
      const offsetZ = gmtOffset >= 0 ? `Etc/GMT+${gmtOffset}` : `Etc/GMT${gmtOffset}`;
      if (dt.offset !== 0 && IANAZone.create(offsetZ).valid) {
        z = offsetZ;
        this.dt = dt;
      } else {
        z = "UTC";
        if (opts.timeZoneName) {
          this.dt = dt;
        } else {
          this.dt = dt.offset === 0 ? dt : DateTime.fromMillis(dt.ts + dt.offset * 60 * 1000);
        }
      }
    } else if (dt.zone.type === "system") {
      this.dt = dt;
    } else {
      this.dt = dt;
      z = dt.zone.name;
    }
    const intlOpts = { ...this.opts };
    intlOpts.timeZone = intlOpts.timeZone || z;
    this.dtf = getCachedDTF(intl, intlOpts);
  }
  format() {
    return this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    return this.dtf.formatToParts(this.dt.toJSDate());
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class PolyRelFormatter {
  constructor(intl, isEnglish, opts) {
    this.opts = { style: "long", ...opts };
    if (!isEnglish && hasRelative()) {
      this.rtf = getCachedRTF(intl, opts);
    }
  }
  format(count, unit) {
    if (this.rtf) {
      return this.rtf.format(count, unit);
    } else {
      return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
  }
  formatToParts(count, unit) {
    if (this.rtf) {
      return this.rtf.formatToParts(count, unit);
    } else {
      return [];
    }
  }
}
class Locale {
  static fromOpts(opts) {
    return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.defaultToEN);
  }
  static create(locale, numberingSystem, outputCalendar, defaultToEN = false) {
    const specifiedLocale = locale || Settings.defaultLocale;
    const localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale());
    const numberingSystemR = numberingSystem || Settings.defaultNumberingSystem;
    const outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
    return new Locale(localeR, numberingSystemR, outputCalendarR, specifiedLocale);
  }
  static resetCache() {
    sysLocaleCache = null;
    intlDTCache = {};
    intlNumCache = {};
    intlRelCache = {};
  }
  static fromObject({ locale, numberingSystem, outputCalendar } = {}) {
    return Locale.create(locale, numberingSystem, outputCalendar);
  }
  constructor(locale, numbering, outputCalendar, specifiedLocale) {
    const [parsedLocale, parsedNumberingSystem, parsedOutputCalendar] = parseLocaleString(locale);
    this.locale = parsedLocale;
    this.numberingSystem = numbering || parsedNumberingSystem || null;
    this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
    this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
    this.weekdaysCache = { format: {}, standalone: {} };
    this.monthsCache = { format: {}, standalone: {} };
    this.meridiemCache = null;
    this.eraCache = {};
    this.specifiedLocale = specifiedLocale;
    this.fastNumbersCached = null;
  }
  get fastNumbers() {
    if (this.fastNumbersCached == null) {
      this.fastNumbersCached = supportsFastNumbers(this);
    }
    return this.fastNumbersCached;
  }
  listingMode() {
    const isActuallyEn = this.isEnglish();
    const hasNoWeirdness =
      (this.numberingSystem === null || this.numberingSystem === "latn") &&
      (this.outputCalendar === null || this.outputCalendar === "gregory");
    return isActuallyEn && hasNoWeirdness ? "en" : "intl";
  }
  clone(alts) {
    if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
      return this;
    } else {
      return Locale.create(
        alts.locale || this.specifiedLocale,
        alts.numberingSystem || this.numberingSystem,
        alts.outputCalendar || this.outputCalendar,
        alts.defaultToEN || false
      );
    }
  }
  redefaultToEN(alts = {}) {
    return this.clone({ ...alts, defaultToEN: true });
  }
  redefaultToSystem(alts = {}) {
    return this.clone({ ...alts, defaultToEN: false });
  }
  months(length, format = false, defaultOK = true) {
    return listStuff(this, length, defaultOK, months, () => {
      const intl = format ? { month: length, day: "numeric" } : { month: length },
        formatStr = format ? "format" : "standalone";
      if (!this.monthsCache[formatStr][length]) {
        this.monthsCache[formatStr][length] = mapMonths((dt) => this.extract(dt, intl, "month"));
      }
      return this.monthsCache[formatStr][length];
    });
  }
  weekdays(length, format = false, defaultOK = true) {
    return listStuff(this, length, defaultOK, weekdays, () => {
      const intl = format
          ? { weekday: length, year: "numeric", month: "long", day: "numeric" }
          : { weekday: length },
        formatStr = format ? "format" : "standalone";
      if (!this.weekdaysCache[formatStr][length]) {
        this.weekdaysCache[formatStr][length] = mapWeekdays((dt) =>
          this.extract(dt, intl, "weekday")
        );
      }
      return this.weekdaysCache[formatStr][length];
    });
  }
  meridiems(defaultOK = true) {
    return listStuff(
      this,
      undefined,
      defaultOK,
      () => meridiems,
      () => {
        if (!this.meridiemCache) {
          const intl = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [DateTime.utc(2016, 11, 13, 9), DateTime.utc(2016, 11, 13, 19)].map(
            (dt) => this.extract(dt, intl, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(length, defaultOK = true) {
    return listStuff(this, length, defaultOK, eras, () => {
      const intl = { era: length };
      if (!this.eraCache[length]) {
        this.eraCache[length] = [DateTime.utc(-40, 1, 1), DateTime.utc(2017, 1, 1)].map((dt) =>
          this.extract(dt, intl, "era")
        );
      }
      return this.eraCache[length];
    });
  }
  extract(dt, intlOpts, field) {
    const df = this.dtFormatter(dt, intlOpts),
      results = df.formatToParts(),
      matching = results.find((m) => m.type.toLowerCase() === field);
    return matching ? matching.value : null;
  }
  numberFormatter(opts = {}) {
    return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
  }
  dtFormatter(dt, intlOpts = {}) {
    return new PolyDateFormatter(dt, this.intl, intlOpts);
  }
  relFormatter(opts = {}) {
    return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
  }
  listFormatter(opts = {}) {
    return getCachedLF(this.intl, opts);
  }
  isEnglish() {
    return (
      this.locale === "en" ||
      this.locale.toLowerCase() === "en-us" ||
      new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us")
    );
  }
  equals(other) {
    return (
      this.locale === other.locale &&
      this.numberingSystem === other.numberingSystem &&
      this.outputCalendar === other.outputCalendar
    );
  }
}

let singleton = null;
class FixedOffsetZone extends Zone {
  static get utcInstance() {
    if (singleton === null) {
      singleton = new FixedOffsetZone(0);
    }
    return singleton;
  }
  static instance(offset) {
    return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
  }
  static parseSpecifier(s) {
    if (s) {
      const r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (r) {
        return new FixedOffsetZone(signedOffset(r[1], r[2]));
      }
    }
    return null;
  }
  constructor(offset) {
    super();
    this.fixed = offset;
  }
  get type() {
    return "fixed";
  }
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${formatOffset(this.fixed, "narrow")}`;
  }
  get ianaName() {
    if (this.fixed === 0) {
      return "Etc/UTC";
    } else {
      return `Etc/GMT${formatOffset(-this.fixed, "narrow")}`;
    }
  }
  offsetName() {
    return this.name;
  }
  formatOffset(ts, format) {
    return formatOffset(this.fixed, format);
  }
  get isUniversal() {
    return true;
  }
  offset() {
    return this.fixed;
  }
  equals(otherZone) {
    return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
  }
  get isValid() {
    return true;
  }
}

class InvalidZone extends Zone {
  constructor(zoneName) {
    super();
    this.zoneName = zoneName;
  }
  get type() {
    return "invalid";
  }
  get name() {
    return this.zoneName;
  }
  get isUniversal() {
    return false;
  }
  offsetName() {
    return null;
  }
  formatOffset() {
    return "";
  }
  offset() {
    return NaN;
  }
  equals() {
    return false;
  }
  get isValid() {
    return false;
  }
}

function normalizeZone(input, defaultZone) {
  if (isUndefined(input) || input === null) {
    return defaultZone;
  } else if (input instanceof Zone) {
    return input;
  } else if (isString(input)) {
    const lowered = input.toLowerCase();
    if (lowered === "default") return defaultZone;
    else if (lowered === "local" || lowered === "system") return SystemZone.instance;
    else if (lowered === "utc" || lowered === "gmt") return FixedOffsetZone.utcInstance;
    else return FixedOffsetZone.parseSpecifier(lowered) || IANAZone.create(input);
  } else if (isNumber(input)) {
    return FixedOffsetZone.instance(input);
  } else if (typeof input === "object" && input.offset && typeof input.offset === "number") {
    return input;
  } else {
    return new InvalidZone(input);
  }
}

let now = () => Date.now(),
  defaultZone = "system",
  defaultLocale$1 = null,
  defaultNumberingSystem = null,
  defaultOutputCalendar = null,
  twoDigitCutoffYear = 60,
  throwOnInvalid;
class Settings {
  static get now() {
    return now;
  }
  static set now(n) {
    now = n;
  }
  static set defaultZone(zone) {
    defaultZone = zone;
  }
  static get defaultZone() {
    return normalizeZone(defaultZone, SystemZone.instance);
  }
  static get defaultLocale() {
    return defaultLocale$1;
  }
  static set defaultLocale(locale) {
    defaultLocale$1 = locale;
  }
  static get defaultNumberingSystem() {
    return defaultNumberingSystem;
  }
  static set defaultNumberingSystem(numberingSystem) {
    defaultNumberingSystem = numberingSystem;
  }
  static get defaultOutputCalendar() {
    return defaultOutputCalendar;
  }
  static set defaultOutputCalendar(outputCalendar) {
    defaultOutputCalendar = outputCalendar;
  }
  static get twoDigitCutoffYear() {
    return twoDigitCutoffYear;
  }
  static set twoDigitCutoffYear(cutoffYear) {
    twoDigitCutoffYear = cutoffYear % 100;
  }
  static get throwOnInvalid() {
    return throwOnInvalid;
  }
  static set throwOnInvalid(t) {
    throwOnInvalid = t;
  }
  static resetCaches() {
    Locale.resetCache();
    IANAZone.resetCache();
  }
}

function isUndefined(o) {
  return typeof o === "undefined";
}
function isNumber(o) {
  return typeof o === "number";
}
function isInteger(o) {
  return typeof o === "number" && o % 1 === 0;
}
function isString(o) {
  return typeof o === "string";
}
function isDate(o) {
  return Object.prototype.toString.call(o) === "[object Date]";
}
function hasRelative() {
  try {
    return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
  } catch (e) {
    return false;
  }
}
function maybeArray(thing) {
  return Array.isArray(thing) ? thing : [thing];
}
function bestBy(arr, by, compare) {
  if (arr.length === 0) {
    return undefined;
  }
  return arr.reduce((best, next) => {
    const pair = [by(next), next];
    if (!best) {
      return pair;
    } else if (compare(best[0], pair[0]) === best[0]) {
      return best;
    } else {
      return pair;
    }
  }, null)[1];
}
function pick(obj, keys) {
  return keys.reduce((a, k) => {
    a[k] = obj[k];
    return a;
  }, {});
}
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
function integerBetween(thing, bottom, top) {
  return isInteger(thing) && thing >= bottom && thing <= top;
}
function floorMod(x, n) {
  return x - n * Math.floor(x / n);
}
function padStart(input, n = 2) {
  const isNeg = input < 0;
  let padded;
  if (isNeg) {
    padded = "-" + ("" + -input).padStart(n, "0");
  } else {
    padded = ("" + input).padStart(n, "0");
  }
  return padded;
}
function parseInteger(string) {
  if (isUndefined(string) || string === null || string === "") {
    return undefined;
  } else {
    return parseInt(string, 10);
  }
}
function parseFloating(string) {
  if (isUndefined(string) || string === null || string === "") {
    return undefined;
  } else {
    return parseFloat(string);
  }
}
function parseMillis(fraction) {
  if (isUndefined(fraction) || fraction === null || fraction === "") {
    return undefined;
  } else {
    const f = parseFloat("0." + fraction) * 1000;
    return Math.floor(f);
  }
}
function roundTo(number, digits, towardZero = false) {
  const factor = 10 ** digits,
    rounder = towardZero ? Math.trunc : Math.round;
  return rounder(number * factor) / factor;
}
function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
function daysInMonth(year, month) {
  const modMonth = floorMod(month - 1, 12) + 1,
    modYear = year + (month - modMonth) / 12;
  if (modMonth === 2) {
    return isLeapYear(modYear) ? 29 : 28;
  } else {
    return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][modMonth - 1];
  }
}
function objToLocalTS(obj) {
  let d = Date.UTC(
    obj.year,
    obj.month - 1,
    obj.day,
    obj.hour,
    obj.minute,
    obj.second,
    obj.millisecond
  );
  if (obj.year < 100 && obj.year >= 0) {
    d = new Date(d);
    d.setUTCFullYear(d.getUTCFullYear() - 1900);
  }
  return +d;
}
function weeksInWeekYear(weekYear) {
  const p1 =
      (weekYear +
        Math.floor(weekYear / 4) -
        Math.floor(weekYear / 100) +
        Math.floor(weekYear / 400)) %
      7,
    last = weekYear - 1,
    p2 = (last + Math.floor(last / 4) - Math.floor(last / 100) + Math.floor(last / 400)) % 7;
  return p1 === 4 || p2 === 3 ? 53 : 52;
}
function untruncateYear(year) {
  if (year > 99) {
    return year;
  } else return year > Settings.twoDigitCutoffYear ? 1900 + year : 2000 + year;
}
function parseZoneInfo(ts, offsetFormat, locale, timeZone = null) {
  const date = new Date(ts),
    intlOpts = {
      hourCycle: "h23",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    };
  if (timeZone) {
    intlOpts.timeZone = timeZone;
  }
  const modified = { timeZoneName: offsetFormat, ...intlOpts };
  const parsed = new Intl.DateTimeFormat(locale, modified)
    .formatToParts(date)
    .find((m) => m.type.toLowerCase() === "timezonename");
  return parsed ? parsed.value : null;
}
function signedOffset(offHourStr, offMinuteStr) {
  let offHour = parseInt(offHourStr, 10);
  if (Number.isNaN(offHour)) {
    offHour = 0;
  }
  const offMin = parseInt(offMinuteStr, 10) || 0,
    offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
  return offHour * 60 + offMinSigned;
}
function asNumber(value) {
  const numericValue = Number(value);
  if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue))
    throw new InvalidArgumentError(`Invalid unit value ${value}`);
  return numericValue;
}
function normalizeObject(obj, normalizer) {
  const normalized = {};
  for (const u in obj) {
    if (hasOwnProperty(obj, u)) {
      const v = obj[u];
      if (v === undefined || v === null) continue;
      normalized[normalizer(u)] = asNumber(v);
    }
  }
  return normalized;
}
function formatOffset(offset, format) {
  const hours = Math.trunc(Math.abs(offset / 60)),
    minutes = Math.trunc(Math.abs(offset % 60)),
    sign = offset >= 0 ? "+" : "-";
  switch (format) {
    case "short":
      return `${sign}${padStart(hours, 2)}:${padStart(minutes, 2)}`;
    case "narrow":
      return `${sign}${hours}${minutes > 0 ? `:${minutes}` : ""}`;
    case "techie":
      return `${sign}${padStart(hours, 2)}${padStart(minutes, 2)}`;
    default:
      throw new RangeError(`Value format ${format} is out of range for property format`);
  }
}
function timeObject(obj) {
  return pick(obj, ["hour", "minute", "second", "millisecond"]);
}

const monthsLong = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const monthsShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
const monthsNarrow = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function months(length) {
  switch (length) {
    case "narrow":
      return [...monthsNarrow];
    case "short":
      return [...monthsShort];
    case "long":
      return [...monthsLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const weekdaysLong = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
const weekdaysShort = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const weekdaysNarrow = ["M", "T", "W", "T", "F", "S", "S"];
function weekdays(length) {
  switch (length) {
    case "narrow":
      return [...weekdaysNarrow];
    case "short":
      return [...weekdaysShort];
    case "long":
      return [...weekdaysLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const meridiems = ["AM", "PM"];
const erasLong = ["Before Christ", "Anno Domini"];
const erasShort = ["BC", "AD"];
const erasNarrow = ["B", "A"];
function eras(length) {
  switch (length) {
    case "narrow":
      return [...erasNarrow];
    case "short":
      return [...erasShort];
    case "long":
      return [...erasLong];
    default:
      return null;
  }
}
function meridiemForDateTime(dt) {
  return meridiems[dt.hour < 12 ? 0 : 1];
}
function weekdayForDateTime(dt, length) {
  return weekdays(length)[dt.weekday - 1];
}
function monthForDateTime(dt, length) {
  return months(length)[dt.month - 1];
}
function eraForDateTime(dt, length) {
  return eras(length)[dt.year < 0 ? 0 : 1];
}
function formatRelativeTime(unit, count, numeric = "always", narrow = false) {
  const units = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."],
  };
  const lastable = ["hours", "minutes", "seconds"].indexOf(unit) === -1;
  if (numeric === "auto" && lastable) {
    const isDay = unit === "days";
    switch (count) {
      case 1:
        return isDay ? "tomorrow" : `next ${units[unit][0]}`;
      case -1:
        return isDay ? "yesterday" : `last ${units[unit][0]}`;
      case 0:
        return isDay ? "today" : `this ${units[unit][0]}`;
    }
  }
  const isInPast = Object.is(count, -0) || count < 0,
    fmtValue = Math.abs(count),
    singular = fmtValue === 1,
    lilUnits = units[unit],
    fmtUnit = narrow
      ? singular
        ? lilUnits[1]
        : lilUnits[2] || lilUnits[1]
      : singular
      ? units[unit][0]
      : unit;
  return isInPast ? `${fmtValue} ${fmtUnit} ago` : `in ${fmtValue} ${fmtUnit}`;
}

function stringifyTokens(splits, tokenToString) {
  let s = "";
  for (const token of splits) {
    if (token.literal) {
      s += token.val;
    } else {
      s += tokenToString(token.val);
    }
  }
  return s;
}
const macroTokenToFormatOpts = {
  D: DATE_SHORT,
  DD: DATE_MED,
  DDD: DATE_FULL,
  DDDD: DATE_HUGE,
  t: TIME_SIMPLE,
  tt: TIME_WITH_SECONDS,
  ttt: TIME_WITH_SHORT_OFFSET,
  tttt: TIME_WITH_LONG_OFFSET,
  T: TIME_24_SIMPLE,
  TT: TIME_24_WITH_SECONDS,
  TTT: TIME_24_WITH_SHORT_OFFSET,
  TTTT: TIME_24_WITH_LONG_OFFSET,
  f: DATETIME_SHORT,
  ff: DATETIME_MED,
  fff: DATETIME_FULL,
  ffff: DATETIME_HUGE,
  F: DATETIME_SHORT_WITH_SECONDS,
  FF: DATETIME_MED_WITH_SECONDS,
  FFF: DATETIME_FULL_WITH_SECONDS,
  FFFF: DATETIME_HUGE_WITH_SECONDS,
};
class Formatter {
  static create(locale, opts = {}) {
    return new Formatter(locale, opts);
  }
  static parseFormat(fmt) {
    let current = null,
      currentFull = "",
      bracketed = false;
    const splits = [];
    for (let i = 0; i < fmt.length; i++) {
      const c = fmt.charAt(i);
      if (c === "'") {
        if (currentFull.length > 0) {
          splits.push({ literal: bracketed, val: currentFull });
        }
        current = null;
        currentFull = "";
        bracketed = !bracketed;
      } else if (bracketed) {
        currentFull += c;
      } else if (c === current) {
        currentFull += c;
      } else {
        if (currentFull.length > 0) {
          splits.push({ literal: false, val: currentFull });
        }
        currentFull = c;
        current = c;
      }
    }
    if (currentFull.length > 0) {
      splits.push({ literal: bracketed, val: currentFull });
    }
    return splits;
  }
  static macroTokenToFormatOpts(token) {
    return macroTokenToFormatOpts[token];
  }
  constructor(locale, formatOpts) {
    this.opts = formatOpts;
    this.loc = locale;
    this.systemLoc = null;
  }
  formatWithSystemDefault(dt, opts) {
    if (this.systemLoc === null) {
      this.systemLoc = this.loc.redefaultToSystem();
    }
    const df = this.systemLoc.dtFormatter(dt, { ...this.opts, ...opts });
    return df.format();
  }
  formatDateTime(dt, opts = {}) {
    const df = this.loc.dtFormatter(dt, { ...this.opts, ...opts });
    return df.format();
  }
  formatDateTimeParts(dt, opts = {}) {
    const df = this.loc.dtFormatter(dt, { ...this.opts, ...opts });
    return df.formatToParts();
  }
  formatInterval(interval, opts = {}) {
    const df = this.loc.dtFormatter(interval.start, { ...this.opts, ...opts });
    return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
  }
  resolvedOptions(dt, opts = {}) {
    const df = this.loc.dtFormatter(dt, { ...this.opts, ...opts });
    return df.resolvedOptions();
  }
  num(n, p = 0) {
    if (this.opts.forceSimple) {
      return padStart(n, p);
    }
    const opts = { ...this.opts };
    if (p > 0) {
      opts.padTo = p;
    }
    return this.loc.numberFormatter(opts).format(n);
  }
  formatDateTimeFromString(dt, fmt) {
    const knownEnglish = this.loc.listingMode() === "en",
      useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory",
      string = (opts, extract) => this.loc.extract(dt, opts, extract),
      formatOffset = (opts) => {
        if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) {
          return "Z";
        }
        return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
      },
      meridiem = () =>
        knownEnglish
          ? meridiemForDateTime(dt)
          : string({ hour: "numeric", hourCycle: "h12" }, "dayperiod"),
      month = (length, standalone) =>
        knownEnglish
          ? monthForDateTime(dt, length)
          : string(standalone ? { month: length } : { month: length, day: "numeric" }, "month"),
      weekday = (length, standalone) =>
        knownEnglish
          ? weekdayForDateTime(dt, length)
          : string(
              standalone ? { weekday: length } : { weekday: length, month: "long", day: "numeric" },
              "weekday"
            ),
      maybeMacro = (token) => {
        const formatOpts = Formatter.macroTokenToFormatOpts(token);
        if (formatOpts) {
          return this.formatWithSystemDefault(dt, formatOpts);
        } else {
          return token;
        }
      },
      era = (length) =>
        knownEnglish ? eraForDateTime(dt, length) : string({ era: length }, "era"),
      tokenToString = (token) => {
        switch (token) {
          case "S":
            return this.num(dt.millisecond);
          case "u":
          case "SSS":
            return this.num(dt.millisecond, 3);
          case "s":
            return this.num(dt.second);
          case "ss":
            return this.num(dt.second, 2);
          case "uu":
            return this.num(Math.floor(dt.millisecond / 10), 2);
          case "uuu":
            return this.num(Math.floor(dt.millisecond / 100));
          case "m":
            return this.num(dt.minute);
          case "mm":
            return this.num(dt.minute, 2);
          case "h":
            return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
          case "hh":
            return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
          case "H":
            return this.num(dt.hour);
          case "HH":
            return this.num(dt.hour, 2);
          case "Z":
            return formatOffset({ format: "narrow", allowZ: this.opts.allowZ });
          case "ZZ":
            return formatOffset({ format: "short", allowZ: this.opts.allowZ });
          case "ZZZ":
            return formatOffset({ format: "techie", allowZ: this.opts.allowZ });
          case "ZZZZ":
            return dt.zone.offsetName(dt.ts, { format: "short", locale: this.loc.locale });
          case "ZZZZZ":
            return dt.zone.offsetName(dt.ts, { format: "long", locale: this.loc.locale });
          case "z":
            return dt.zoneName;
          case "a":
            return meridiem();
          case "d":
            return useDateTimeFormatter ? string({ day: "numeric" }, "day") : this.num(dt.day);
          case "dd":
            return useDateTimeFormatter ? string({ day: "2-digit" }, "day") : this.num(dt.day, 2);
          case "c":
            return this.num(dt.weekday);
          case "ccc":
            return weekday("short", true);
          case "cccc":
            return weekday("long", true);
          case "ccccc":
            return weekday("narrow", true);
          case "E":
            return this.num(dt.weekday);
          case "EEE":
            return weekday("short", false);
          case "EEEE":
            return weekday("long", false);
          case "EEEEE":
            return weekday("narrow", false);
          case "L":
            return useDateTimeFormatter
              ? string({ month: "numeric", day: "numeric" }, "month")
              : this.num(dt.month);
          case "LL":
            return useDateTimeFormatter
              ? string({ month: "2-digit", day: "numeric" }, "month")
              : this.num(dt.month, 2);
          case "LLL":
            return month("short", true);
          case "LLLL":
            return month("long", true);
          case "LLLLL":
            return month("narrow", true);
          case "M":
            return useDateTimeFormatter
              ? string({ month: "numeric" }, "month")
              : this.num(dt.month);
          case "MM":
            return useDateTimeFormatter
              ? string({ month: "2-digit" }, "month")
              : this.num(dt.month, 2);
          case "MMM":
            return month("short", false);
          case "MMMM":
            return month("long", false);
          case "MMMMM":
            return month("narrow", false);
          case "y":
            return useDateTimeFormatter ? string({ year: "numeric" }, "year") : this.num(dt.year);
          case "yy":
            return useDateTimeFormatter
              ? string({ year: "2-digit" }, "year")
              : this.num(dt.year.toString().slice(-2), 2);
          case "yyyy":
            return useDateTimeFormatter
              ? string({ year: "numeric" }, "year")
              : this.num(dt.year, 4);
          case "yyyyyy":
            return useDateTimeFormatter
              ? string({ year: "numeric" }, "year")
              : this.num(dt.year, 6);
          case "G":
            return era("short");
          case "GG":
            return era("long");
          case "GGGGG":
            return era("narrow");
          case "kk":
            return this.num(dt.weekYear.toString().slice(-2), 2);
          case "kkkk":
            return this.num(dt.weekYear, 4);
          case "W":
            return this.num(dt.weekNumber);
          case "WW":
            return this.num(dt.weekNumber, 2);
          case "o":
            return this.num(dt.ordinal);
          case "ooo":
            return this.num(dt.ordinal, 3);
          case "q":
            return this.num(dt.quarter);
          case "qq":
            return this.num(dt.quarter, 2);
          case "X":
            return this.num(Math.floor(dt.ts / 1000));
          case "x":
            return this.num(dt.ts);
          default:
            return maybeMacro(token);
        }
      };
    return stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
  }
  formatDurationFromString(dur, fmt) {
    const tokenToField = (token) => {
        switch (token[0]) {
          case "S":
            return "millisecond";
          case "s":
            return "second";
          case "m":
            return "minute";
          case "h":
            return "hour";
          case "d":
            return "day";
          case "w":
            return "week";
          case "M":
            return "month";
          case "y":
            return "year";
          default:
            return null;
        }
      },
      tokenToString = (lildur) => (token) => {
        const mapped = tokenToField(token);
        if (mapped) {
          return this.num(lildur.get(mapped), token.length);
        } else {
          return token;
        }
      },
      tokens = Formatter.parseFormat(fmt),
      realTokens = tokens.reduce(
        (found, { literal, val }) => (literal ? found : found.concat(val)),
        []
      ),
      collapsed = dur.shiftTo(...realTokens.map(tokenToField).filter((t) => t));
    return stringifyTokens(tokens, tokenToString(collapsed));
  }
}

class Invalid {
  constructor(reason, explanation) {
    this.reason = reason;
    this.explanation = explanation;
  }
  toMessage() {
    if (this.explanation) {
      return `${this.reason}: ${this.explanation}`;
    } else {
      return this.reason;
    }
  }
}

const ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function combineRegexes(...regexes) {
  const full = regexes.reduce((f, r) => f + r.source, "");
  return RegExp(`^${full}$`);
}
function combineExtractors(...extractors) {
  return (m) =>
    extractors
      .reduce(
        ([mergedVals, mergedZone, cursor], ex) => {
          const [val, zone, next] = ex(m, cursor);
          return [{ ...mergedVals, ...val }, zone || mergedZone, next];
        },
        [{}, null, 1]
      )
      .slice(0, 2);
}
function parse(s, ...patterns) {
  if (s == null) {
    return [null, null];
  }
  for (const [regex, extractor] of patterns) {
    const m = regex.exec(s);
    if (m) {
      return extractor(m);
    }
  }
  return [null, null];
}
function simpleParse(...keys) {
  return (match, cursor) => {
    const ret = {};
    let i;
    for (i = 0; i < keys.length; i++) {
      ret[keys[i]] = parseInteger(match[cursor + i]);
    }
    return [ret, null, cursor + i];
  };
}
const offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
const isoExtendedZone = `(?:${offsetRegex.source}?(?:\\[(${ianaRegex.source})\\])?)?`;
const isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
const isoTimeRegex = RegExp(`${isoTimeBaseRegex.source}${isoExtendedZone}`);
const isoTimeExtensionRegex = RegExp(`(?:T${isoTimeRegex.source})?`);
const isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
const isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
const isoOrdinalRegex = /(\d{4})-?(\d{3})/;
const extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay");
const extractISOOrdinalData = simpleParse("year", "ordinal");
const sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/;
const sqlTimeRegex = RegExp(
  `${isoTimeBaseRegex.source} ?(?:${offsetRegex.source}|(${ianaRegex.source}))?`
);
const sqlTimeExtensionRegex = RegExp(`(?: ${sqlTimeRegex.source})?`);
function int(match, pos, fallback) {
  const m = match[pos];
  return isUndefined(m) ? fallback : parseInteger(m);
}
function extractISOYmd(match, cursor) {
  const item = {
    year: int(match, cursor),
    month: int(match, cursor + 1, 1),
    day: int(match, cursor + 2, 1),
  };
  return [item, null, cursor + 3];
}
function extractISOTime(match, cursor) {
  const item = {
    hours: int(match, cursor, 0),
    minutes: int(match, cursor + 1, 0),
    seconds: int(match, cursor + 2, 0),
    milliseconds: parseMillis(match[cursor + 3]),
  };
  return [item, null, cursor + 4];
}
function extractISOOffset(match, cursor) {
  const local = !match[cursor] && !match[cursor + 1],
    fullOffset = signedOffset(match[cursor + 1], match[cursor + 2]),
    zone = local ? null : FixedOffsetZone.instance(fullOffset);
  return [{}, zone, cursor + 3];
}
function extractIANAZone(match, cursor) {
  const zone = match[cursor] ? IANAZone.create(match[cursor]) : null;
  return [{}, zone, cursor + 1];
}
const isoTimeOnly = RegExp(`^T?${isoTimeBaseRegex.source}$`);
const isoDuration =
  /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function extractISODuration(match) {
  const [s, yearStr, monthStr, weekStr, dayStr, hourStr, minuteStr, secondStr, millisecondsStr] =
    match;
  const hasNegativePrefix = s[0] === "-";
  const negativeSeconds = secondStr && secondStr[0] === "-";
  const maybeNegate = (num, force = false) =>
    num !== undefined && (force || (num && hasNegativePrefix)) ? -num : num;
  return [
    {
      years: maybeNegate(parseFloating(yearStr)),
      months: maybeNegate(parseFloating(monthStr)),
      weeks: maybeNegate(parseFloating(weekStr)),
      days: maybeNegate(parseFloating(dayStr)),
      hours: maybeNegate(parseFloating(hourStr)),
      minutes: maybeNegate(parseFloating(minuteStr)),
      seconds: maybeNegate(parseFloating(secondStr), secondStr === "-0"),
      milliseconds: maybeNegate(parseMillis(millisecondsStr), negativeSeconds),
    },
  ];
}
const obsOffsets = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60,
};
function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  const result = {
    year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
    month: monthsShort.indexOf(monthStr) + 1,
    day: parseInteger(dayStr),
    hour: parseInteger(hourStr),
    minute: parseInteger(minuteStr),
  };
  if (secondStr) result.second = parseInteger(secondStr);
  if (weekdayStr) {
    result.weekday =
      weekdayStr.length > 3
        ? weekdaysLong.indexOf(weekdayStr) + 1
        : weekdaysShort.indexOf(weekdayStr) + 1;
  }
  return result;
}
const rfc2822 =
  /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function extractRFC2822(match) {
  const [
      ,
      weekdayStr,
      dayStr,
      monthStr,
      yearStr,
      hourStr,
      minuteStr,
      secondStr,
      obsOffset,
      milOffset,
      offHourStr,
      offMinuteStr,
    ] = match,
    result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  let offset;
  if (obsOffset) {
    offset = obsOffsets[obsOffset];
  } else if (milOffset) {
    offset = 0;
  } else {
    offset = signedOffset(offHourStr, offMinuteStr);
  }
  return [result, new FixedOffsetZone(offset)];
}
function preprocessRFC2822(s) {
  return s
    .replace(/\([^()]*\)|[\n\t]/g, " ")
    .replace(/(\s\s+)/g, " ")
    .trim();
}
const rfc1123 =
    /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/,
  rfc850 =
    /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/,
  ascii =
    /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function extractRFC1123Or850(match) {
  const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr] = match,
    result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}
function extractASCII(match) {
  const [, weekdayStr, monthStr, dayStr, hourStr, minuteStr, secondStr, yearStr] = match,
    result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}
const isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
const isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
const isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
const isoTimeCombinedRegex = combineRegexes(isoTimeRegex);
const extractISOYmdTimeAndOffset = combineExtractors(
  extractISOYmd,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOWeekTimeAndOffset = combineExtractors(
  extractISOWeekData,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOOrdinalDateAndTime = combineExtractors(
  extractISOOrdinalData,
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
const extractISOTimeAndOffset = combineExtractors(
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
function parseISODate(s) {
  return parse(
    s,
    [isoYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset],
    [isoWeekWithTimeExtensionRegex, extractISOWeekTimeAndOffset],
    [isoOrdinalWithTimeExtensionRegex, extractISOOrdinalDateAndTime],
    [isoTimeCombinedRegex, extractISOTimeAndOffset]
  );
}
function parseRFC2822Date(s) {
  return parse(preprocessRFC2822(s), [rfc2822, extractRFC2822]);
}
function parseHTTPDate(s) {
  return parse(
    s,
    [rfc1123, extractRFC1123Or850],
    [rfc850, extractRFC1123Or850],
    [ascii, extractASCII]
  );
}
function parseISODuration(s) {
  return parse(s, [isoDuration, extractISODuration]);
}
const extractISOTimeOnly = combineExtractors(extractISOTime);
function parseISOTimeOnly(s) {
  return parse(s, [isoTimeOnly, extractISOTimeOnly]);
}
const sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
const sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);
const extractISOTimeOffsetAndIANAZone = combineExtractors(
  extractISOTime,
  extractISOOffset,
  extractIANAZone
);
function parseSQL(s) {
  return parse(
    s,
    [sqlYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset],
    [sqlTimeCombinedRegex, extractISOTimeOffsetAndIANAZone]
  );
}

const INVALID$2 = "Invalid Duration";
const lowOrderMatrix = {
    weeks: {
      days: 7,
      hours: 7 * 24,
      minutes: 7 * 24 * 60,
      seconds: 7 * 24 * 60 * 60,
      milliseconds: 7 * 24 * 60 * 60 * 1000,
    },
    days: {
      hours: 24,
      minutes: 24 * 60,
      seconds: 24 * 60 * 60,
      milliseconds: 24 * 60 * 60 * 1000,
    },
    hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1000 },
    minutes: { seconds: 60, milliseconds: 60 * 1000 },
    seconds: { milliseconds: 1000 },
  },
  casualMatrix = {
    years: {
      quarters: 4,
      months: 12,
      weeks: 52,
      days: 365,
      hours: 365 * 24,
      minutes: 365 * 24 * 60,
      seconds: 365 * 24 * 60 * 60,
      milliseconds: 365 * 24 * 60 * 60 * 1000,
    },
    quarters: {
      months: 3,
      weeks: 13,
      days: 91,
      hours: 91 * 24,
      minutes: 91 * 24 * 60,
      seconds: 91 * 24 * 60 * 60,
      milliseconds: 91 * 24 * 60 * 60 * 1000,
    },
    months: {
      weeks: 4,
      days: 30,
      hours: 30 * 24,
      minutes: 30 * 24 * 60,
      seconds: 30 * 24 * 60 * 60,
      milliseconds: 30 * 24 * 60 * 60 * 1000,
    },
    ...lowOrderMatrix,
  },
  daysInYearAccurate = 146097.0 / 400,
  daysInMonthAccurate = 146097.0 / 4800,
  accurateMatrix = {
    years: {
      quarters: 4,
      months: 12,
      weeks: daysInYearAccurate / 7,
      days: daysInYearAccurate,
      hours: daysInYearAccurate * 24,
      minutes: daysInYearAccurate * 24 * 60,
      seconds: daysInYearAccurate * 24 * 60 * 60,
      milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000,
    },
    quarters: {
      months: 3,
      weeks: daysInYearAccurate / 28,
      days: daysInYearAccurate / 4,
      hours: (daysInYearAccurate * 24) / 4,
      minutes: (daysInYearAccurate * 24 * 60) / 4,
      seconds: (daysInYearAccurate * 24 * 60 * 60) / 4,
      milliseconds: (daysInYearAccurate * 24 * 60 * 60 * 1000) / 4,
    },
    months: {
      weeks: daysInMonthAccurate / 7,
      days: daysInMonthAccurate,
      hours: daysInMonthAccurate * 24,
      minutes: daysInMonthAccurate * 24 * 60,
      seconds: daysInMonthAccurate * 24 * 60 * 60,
      milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1000,
    },
    ...lowOrderMatrix,
  };
const orderedUnits$1 = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds",
];
const reverseUnits = orderedUnits$1.slice(0).reverse();
function clone$1(dur, alts, clear = false) {
  const conf = {
    values: clear ? alts.values : { ...dur.values, ...(alts.values || {}) },
    loc: dur.loc.clone(alts.loc),
    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
    matrix: alts.matrix || dur.matrix,
  };
  return new Duration(conf);
}
function antiTrunc(n) {
  return n < 0 ? Math.floor(n) : Math.ceil(n);
}
function convert(matrix, fromMap, fromUnit, toMap, toUnit) {
  const conv = matrix[toUnit][fromUnit],
    raw = fromMap[fromUnit] / conv,
    sameSign = Math.sign(raw) === Math.sign(toMap[toUnit]),
    added =
      !sameSign && toMap[toUnit] !== 0 && Math.abs(raw) <= 1 ? antiTrunc(raw) : Math.trunc(raw);
  toMap[toUnit] += added;
  fromMap[fromUnit] -= added * conv;
}
function normalizeValues(matrix, vals) {
  reverseUnits.reduce((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        convert(matrix, vals, previous, vals, current);
      }
      return current;
    } else {
      return previous;
    }
  }, null);
}
function removeZeroes(vals) {
  const newVals = {};
  for (const [key, value] of Object.entries(vals)) {
    if (value !== 0) {
      newVals[key] = value;
    }
  }
  return newVals;
}
class Duration {
  constructor(config) {
    const accurate = config.conversionAccuracy === "longterm" || false;
    let matrix = accurate ? accurateMatrix : casualMatrix;
    if (config.matrix) {
      matrix = config.matrix;
    }
    this.values = config.values;
    this.loc = config.loc || Locale.create();
    this.conversionAccuracy = accurate ? "longterm" : "casual";
    this.invalid = config.invalid || null;
    this.matrix = matrix;
    this.isLuxonDuration = true;
  }
  static fromMillis(count, opts) {
    return Duration.fromObject({ milliseconds: count }, opts);
  }
  static fromObject(obj, opts = {}) {
    if (obj == null || typeof obj !== "object") {
      throw new InvalidArgumentError(
        `Duration.fromObject: argument expected to be an object, got ${
          obj === null ? "null" : typeof obj
        }`
      );
    }
    return new Duration({
      values: normalizeObject(obj, Duration.normalizeUnit),
      loc: Locale.fromObject(opts),
      conversionAccuracy: opts.conversionAccuracy,
      matrix: opts.matrix,
    });
  }
  static fromDurationLike(durationLike) {
    if (isNumber(durationLike)) {
      return Duration.fromMillis(durationLike);
    } else if (Duration.isDuration(durationLike)) {
      return durationLike;
    } else if (typeof durationLike === "object") {
      return Duration.fromObject(durationLike);
    } else {
      throw new InvalidArgumentError(
        `Unknown duration argument ${durationLike} of type ${typeof durationLike}`
      );
    }
  }
  static fromISO(text, opts) {
    const [parsed] = parseISODuration(text);
    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }
  static fromISOTime(text, opts) {
    const [parsed] = parseISOTimeOnly(text);
    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDurationError(invalid);
    } else {
      return new Duration({ invalid });
    }
  }
  static normalizeUnit(unit) {
    const normalized = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds",
    }[unit ? unit.toLowerCase() : unit];
    if (!normalized) throw new InvalidUnitError(unit);
    return normalized;
  }
  static isDuration(o) {
    return (o && o.isLuxonDuration) || false;
  }
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  toFormat(fmt, opts = {}) {
    const fmtOpts = {
      ...opts,
      floor: opts.round !== false && opts.floor !== false,
    };
    return this.isValid
      ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt)
      : INVALID$2;
  }
  toHuman(opts = {}) {
    const l = orderedUnits$1
      .map((unit) => {
        const val = this.values[unit];
        if (isUndefined(val)) {
          return null;
        }
        return this.loc
          .numberFormatter({ style: "unit", unitDisplay: "long", ...opts, unit: unit.slice(0, -1) })
          .format(val);
      })
      .filter((n) => n);
    return this.loc
      .listFormatter({ type: "conjunction", style: opts.listStyle || "narrow", ...opts })
      .format(l);
  }
  toObject() {
    if (!this.isValid) return {};
    return { ...this.values };
  }
  toISO() {
    if (!this.isValid) return null;
    let s = "P";
    if (this.years !== 0) s += this.years + "Y";
    if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
    if (this.weeks !== 0) s += this.weeks + "W";
    if (this.days !== 0) s += this.days + "D";
    if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0)
      s += "T";
    if (this.hours !== 0) s += this.hours + "H";
    if (this.minutes !== 0) s += this.minutes + "M";
    if (this.seconds !== 0 || this.milliseconds !== 0)
      s += roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
    if (s === "P") s += "T0S";
    return s;
  }
  toISOTime(opts = {}) {
    if (!this.isValid) return null;
    const millis = this.toMillis();
    if (millis < 0 || millis >= 86400000) return null;
    opts = {
      suppressMilliseconds: false,
      suppressSeconds: false,
      includePrefix: false,
      format: "extended",
      ...opts,
    };
    const value = this.shiftTo("hours", "minutes", "seconds", "milliseconds");
    let fmt = opts.format === "basic" ? "hhmm" : "hh:mm";
    if (!opts.suppressSeconds || value.seconds !== 0 || value.milliseconds !== 0) {
      fmt += opts.format === "basic" ? "ss" : ":ss";
      if (!opts.suppressMilliseconds || value.milliseconds !== 0) {
        fmt += ".SSS";
      }
    }
    let str = value.toFormat(fmt);
    if (opts.includePrefix) {
      str = "T" + str;
    }
    return str;
  }
  toJSON() {
    return this.toISO();
  }
  toString() {
    return this.toISO();
  }
  toMillis() {
    return this.as("milliseconds");
  }
  valueOf() {
    return this.toMillis();
  }
  plus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration),
      result = {};
    for (const k of orderedUnits$1) {
      if (hasOwnProperty(dur.values, k) || hasOwnProperty(this.values, k)) {
        result[k] = dur.get(k) + this.get(k);
      }
    }
    return clone$1(this, { values: result }, true);
  }
  minus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration);
    return this.plus(dur.negate());
  }
  mapUnits(fn) {
    if (!this.isValid) return this;
    const result = {};
    for (const k of Object.keys(this.values)) {
      result[k] = asNumber(fn(this.values[k], k));
    }
    return clone$1(this, { values: result }, true);
  }
  get(unit) {
    return this[Duration.normalizeUnit(unit)];
  }
  set(values) {
    if (!this.isValid) return this;
    const mixed = { ...this.values, ...normalizeObject(values, Duration.normalizeUnit) };
    return clone$1(this, { values: mixed });
  }
  reconfigure({ locale, numberingSystem, conversionAccuracy, matrix } = {}) {
    const loc = this.loc.clone({ locale, numberingSystem });
    const opts = { loc, matrix, conversionAccuracy };
    return clone$1(this, opts);
  }
  as(unit) {
    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
  }
  normalize() {
    if (!this.isValid) return this;
    const vals = this.toObject();
    normalizeValues(this.matrix, vals);
    return clone$1(this, { values: vals }, true);
  }
  rescale() {
    if (!this.isValid) return this;
    const vals = removeZeroes(this.normalize().shiftToAll().toObject());
    return clone$1(this, { values: vals }, true);
  }
  shiftTo(...units) {
    if (!this.isValid) return this;
    if (units.length === 0) {
      return this;
    }
    units = units.map((u) => Duration.normalizeUnit(u));
    const built = {},
      accumulated = {},
      vals = this.toObject();
    let lastUnit;
    for (const k of orderedUnits$1) {
      if (units.indexOf(k) >= 0) {
        lastUnit = k;
        let own = 0;
        for (const ak in accumulated) {
          own += this.matrix[ak][k] * accumulated[ak];
          accumulated[ak] = 0;
        }
        if (isNumber(vals[k])) {
          own += vals[k];
        }
        const i = Math.trunc(own);
        built[k] = i;
        accumulated[k] = (own * 1000 - i * 1000) / 1000;
        for (const down in vals) {
          if (orderedUnits$1.indexOf(down) > orderedUnits$1.indexOf(k)) {
            convert(this.matrix, vals, down, built, k);
          }
        }
      } else if (isNumber(vals[k])) {
        accumulated[k] = vals[k];
      }
    }
    for (const key in accumulated) {
      if (accumulated[key] !== 0) {
        built[lastUnit] +=
          key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
      }
    }
    return clone$1(this, { values: built }, true).normalize();
  }
  shiftToAll() {
    if (!this.isValid) return this;
    return this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    );
  }
  negate() {
    if (!this.isValid) return this;
    const negated = {};
    for (const k of Object.keys(this.values)) {
      negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
    }
    return clone$1(this, { values: negated }, true);
  }
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  get isValid() {
    return this.invalid === null;
  }
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    if (!this.loc.equals(other.loc)) {
      return false;
    }
    function eq(v1, v2) {
      if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
      return v1 === v2;
    }
    for (const u of orderedUnits$1) {
      if (!eq(this.values[u], other.values[u])) {
        return false;
      }
    }
    return true;
  }
}

const INVALID$1 = "Invalid Interval";
function validateStartEnd(start, end) {
  if (!start || !start.isValid) {
    return Interval.invalid("missing or invalid start");
  } else if (!end || !end.isValid) {
    return Interval.invalid("missing or invalid end");
  } else if (end < start) {
    return Interval.invalid(
      "end before start",
      `The end of an interval must be after its start, but you had start=${start.toISO()} and end=${end.toISO()}`
    );
  } else {
    return null;
  }
}
class Interval {
  constructor(config) {
    this.s = config.start;
    this.e = config.end;
    this.invalid = config.invalid || null;
    this.isLuxonInterval = true;
  }
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidIntervalError(invalid);
    } else {
      return new Interval({ invalid });
    }
  }
  static fromDateTimes(start, end) {
    const builtStart = friendlyDateTime(start),
      builtEnd = friendlyDateTime(end);
    const validateError = validateStartEnd(builtStart, builtEnd);
    if (validateError == null) {
      return new Interval({
        start: builtStart,
        end: builtEnd,
      });
    } else {
      return validateError;
    }
  }
  static after(start, duration) {
    const dur = Duration.fromDurationLike(duration),
      dt = friendlyDateTime(start);
    return Interval.fromDateTimes(dt, dt.plus(dur));
  }
  static before(end, duration) {
    const dur = Duration.fromDurationLike(duration),
      dt = friendlyDateTime(end);
    return Interval.fromDateTimes(dt.minus(dur), dt);
  }
  static fromISO(text, opts) {
    const [s, e] = (text || "").split("/", 2);
    if (s && e) {
      let start, startIsValid;
      try {
        start = DateTime.fromISO(s, opts);
        startIsValid = start.isValid;
      } catch (e) {
        startIsValid = false;
      }
      let end, endIsValid;
      try {
        end = DateTime.fromISO(e, opts);
        endIsValid = end.isValid;
      } catch (e) {
        endIsValid = false;
      }
      if (startIsValid && endIsValid) {
        return Interval.fromDateTimes(start, end);
      }
      if (startIsValid) {
        const dur = Duration.fromISO(e, opts);
        if (dur.isValid) {
          return Interval.after(start, dur);
        }
      } else if (endIsValid) {
        const dur = Duration.fromISO(s, opts);
        if (dur.isValid) {
          return Interval.before(end, dur);
        }
      }
    }
    return Interval.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
  }
  static isInterval(o) {
    return (o && o.isLuxonInterval) || false;
  }
  get start() {
    return this.isValid ? this.s : null;
  }
  get end() {
    return this.isValid ? this.e : null;
  }
  get isValid() {
    return this.invalidReason === null;
  }
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  length(unit = "milliseconds") {
    return this.isValid ? this.toDuration(...[unit]).get(unit) : NaN;
  }
  count(unit = "milliseconds") {
    if (!this.isValid) return NaN;
    const start = this.start.startOf(unit),
      end = this.end.startOf(unit);
    return Math.floor(end.diff(start, unit).get(unit)) + 1;
  }
  hasSame(unit) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
  }
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  isAfter(dateTime) {
    if (!this.isValid) return false;
    return this.s > dateTime;
  }
  isBefore(dateTime) {
    if (!this.isValid) return false;
    return this.e <= dateTime;
  }
  contains(dateTime) {
    if (!this.isValid) return false;
    return this.s <= dateTime && this.e > dateTime;
  }
  set({ start, end } = {}) {
    if (!this.isValid) return this;
    return Interval.fromDateTimes(start || this.s, end || this.e);
  }
  splitAt(...dateTimes) {
    if (!this.isValid) return [];
    const sorted = dateTimes
        .map(friendlyDateTime)
        .filter((d) => this.contains(d))
        .sort(),
      results = [];
    let { s } = this,
      i = 0;
    while (s < this.e) {
      const added = sorted[i] || this.e,
        next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s, next));
      s = next;
      i += 1;
    }
    return results;
  }
  splitBy(duration) {
    const dur = Duration.fromDurationLike(duration);
    if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) {
      return [];
    }
    let { s } = this,
      idx = 1,
      next;
    const results = [];
    while (s < this.e) {
      const added = this.start.plus(dur.mapUnits((x) => x * idx));
      next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s, next));
      s = next;
      idx += 1;
    }
    return results;
  }
  divideEqually(numberOfParts) {
    if (!this.isValid) return [];
    return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
  }
  overlaps(other) {
    return this.e > other.s && this.s < other.e;
  }
  abutsStart(other) {
    if (!this.isValid) return false;
    return +this.e === +other.s;
  }
  abutsEnd(other) {
    if (!this.isValid) return false;
    return +other.e === +this.s;
  }
  engulfs(other) {
    if (!this.isValid) return false;
    return this.s <= other.s && this.e >= other.e;
  }
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    return this.s.equals(other.s) && this.e.equals(other.e);
  }
  intersection(other) {
    if (!this.isValid) return this;
    const s = this.s > other.s ? this.s : other.s,
      e = this.e < other.e ? this.e : other.e;
    if (s >= e) {
      return null;
    } else {
      return Interval.fromDateTimes(s, e);
    }
  }
  union(other) {
    if (!this.isValid) return this;
    const s = this.s < other.s ? this.s : other.s,
      e = this.e > other.e ? this.e : other.e;
    return Interval.fromDateTimes(s, e);
  }
  static merge(intervals) {
    const [found, final] = intervals
      .sort((a, b) => a.s - b.s)
      .reduce(
        ([sofar, current], item) => {
          if (!current) {
            return [sofar, item];
          } else if (current.overlaps(item) || current.abutsStart(item)) {
            return [sofar, current.union(item)];
          } else {
            return [sofar.concat([current]), item];
          }
        },
        [[], null]
      );
    if (final) {
      found.push(final);
    }
    return found;
  }
  static xor(intervals) {
    let start = null,
      currentCount = 0;
    const results = [],
      ends = intervals.map((i) => [
        { time: i.s, type: "s" },
        { time: i.e, type: "e" },
      ]),
      flattened = Array.prototype.concat(...ends),
      arr = flattened.sort((a, b) => a.time - b.time);
    for (const i of arr) {
      currentCount += i.type === "s" ? 1 : -1;
      if (currentCount === 1) {
        start = i.time;
      } else {
        if (start && +start !== +i.time) {
          results.push(Interval.fromDateTimes(start, i.time));
        }
        start = null;
      }
    }
    return Interval.merge(results);
  }
  difference(...intervals) {
    return Interval.xor([this].concat(intervals))
      .map((i) => this.intersection(i))
      .filter((i) => i && !i.isEmpty());
  }
  toString() {
    if (!this.isValid) return INVALID$1;
    return `[${this.s.toISO()} – ${this.e.toISO()})`;
  }
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid
      ? Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this)
      : INVALID$1;
  }
  toISO(opts) {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toISO(opts)}/${this.e.toISO(opts)}`;
  }
  toISODate() {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toISODate()}/${this.e.toISODate()}`;
  }
  toISOTime(opts) {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toISOTime(opts)}/${this.e.toISOTime(opts)}`;
  }
  toFormat(dateFormat, { separator = " – " } = {}) {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toFormat(dateFormat)}${separator}${this.e.toFormat(dateFormat)}`;
  }
  toDuration(unit, opts) {
    if (!this.isValid) {
      return Duration.invalid(this.invalidReason);
    }
    return this.e.diff(this.s, unit, opts);
  }
  mapEndpoints(mapFn) {
    return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
  }
}

class Info {
  static hasDST(zone = Settings.defaultZone) {
    const proto = DateTime.now().setZone(zone).set({ month: 12 });
    return !zone.isUniversal && proto.offset !== proto.set({ month: 6 }).offset;
  }
  static isValidIANAZone(zone) {
    return IANAZone.isValidZone(zone);
  }
  static normalizeZone(input) {
    return normalizeZone(input, Settings.defaultZone);
  }
  static months(
    length = "long",
    { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}
  ) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length);
  }
  static monthsFormat(
    length = "long",
    { locale = null, numberingSystem = null, locObj = null, outputCalendar = "gregory" } = {}
  ) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
  }
  static weekdays(length = "long", { locale = null, numberingSystem = null, locObj = null } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length);
  }
  static weekdaysFormat(
    length = "long",
    { locale = null, numberingSystem = null, locObj = null } = {}
  ) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length, true);
  }
  static meridiems({ locale = null } = {}) {
    return Locale.create(locale).meridiems();
  }
  static eras(length = "short", { locale = null } = {}) {
    return Locale.create(locale, null, "gregory").eras(length);
  }
  static features() {
    return { relative: hasRelative() };
  }
}

function dayDiff(earlier, later) {
  const utcDayStart = (dt) => dt.toUTC(0, { keepLocalTime: true }).startOf("day").valueOf(),
    ms = utcDayStart(later) - utcDayStart(earlier);
  return Math.floor(Duration.fromMillis(ms).as("days"));
}
function highOrderDiffs(cursor, later, units) {
  const differs = [
    ["years", (a, b) => b.year - a.year],
    ["quarters", (a, b) => b.quarter - a.quarter + (b.year - a.year) * 4],
    ["months", (a, b) => b.month - a.month + (b.year - a.year) * 12],
    [
      "weeks",
      (a, b) => {
        const days = dayDiff(a, b);
        return (days - (days % 7)) / 7;
      },
    ],
    ["days", dayDiff],
  ];
  const results = {};
  const earlier = cursor;
  let lowestOrder, highWater;
  for (const [unit, differ] of differs) {
    if (units.indexOf(unit) >= 0) {
      lowestOrder = unit;
      results[unit] = differ(cursor, later);
      highWater = earlier.plus(results);
      if (highWater > later) {
        results[unit]--;
        cursor = earlier.plus(results);
      } else {
        cursor = highWater;
      }
    }
  }
  return [cursor, results, highWater, lowestOrder];
}
function diff (earlier, later, units, opts) {
  let [cursor, results, highWater, lowestOrder] = highOrderDiffs(earlier, later, units);
  const remainingMillis = later - cursor;
  const lowerOrderUnits = units.filter(
    (u) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(u) >= 0
  );
  if (lowerOrderUnits.length === 0) {
    if (highWater < later) {
      highWater = cursor.plus({ [lowestOrder]: 1 });
    }
    if (highWater !== cursor) {
      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
  }
  const duration = Duration.fromObject(results, opts);
  if (lowerOrderUnits.length > 0) {
    return Duration.fromMillis(remainingMillis, opts)
      .shiftTo(...lowerOrderUnits)
      .plus(duration);
  } else {
    return duration;
  }
}

const numberingSystems = {
  arab: "[\u0660-\u0669]",
  arabext: "[\u06F0-\u06F9]",
  bali: "[\u1B50-\u1B59]",
  beng: "[\u09E6-\u09EF]",
  deva: "[\u0966-\u096F]",
  fullwide: "[\uFF10-\uFF19]",
  gujr: "[\u0AE6-\u0AEF]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[\u17E0-\u17E9]",
  knda: "[\u0CE6-\u0CEF]",
  laoo: "[\u0ED0-\u0ED9]",
  limb: "[\u1946-\u194F]",
  mlym: "[\u0D66-\u0D6F]",
  mong: "[\u1810-\u1819]",
  mymr: "[\u1040-\u1049]",
  orya: "[\u0B66-\u0B6F]",
  tamldec: "[\u0BE6-\u0BEF]",
  telu: "[\u0C66-\u0C6F]",
  thai: "[\u0E50-\u0E59]",
  tibt: "[\u0F20-\u0F29]",
  latn: "\\d",
};
const numberingSystemsUTF16 = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881],
};
const hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function parseDigits(str) {
  let value = parseInt(str, 10);
  if (isNaN(value)) {
    value = "";
    for (let i = 0; i < str.length; i++) {
      const code = str.charCodeAt(i);
      if (str[i].search(numberingSystems.hanidec) !== -1) {
        value += hanidecChars.indexOf(str[i]);
      } else {
        for (const key in numberingSystemsUTF16) {
          const [min, max] = numberingSystemsUTF16[key];
          if (code >= min && code <= max) {
            value += code - min;
          }
        }
      }
    }
    return parseInt(value, 10);
  } else {
    return value;
  }
}
function digitRegex({ numberingSystem }, append = "") {
  return new RegExp(`${numberingSystems[numberingSystem || "latn"]}${append}`);
}

const MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function intUnit(regex, post = (i) => i) {
  return { regex, deser: ([s]) => post(parseDigits(s)) };
}
const NBSP = String.fromCharCode(160);
const spaceOrNBSP = `[ ${NBSP}]`;
const spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");
function fixListRegex(s) {
  return s.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}
function stripInsensitivities(s) {
  return s
    .replace(/\./g, "")
    .replace(spaceOrNBSPRegExp, " ")
    .toLowerCase();
}
function oneOf(strings, startIndex) {
  if (strings === null) {
    return null;
  } else {
    return {
      regex: RegExp(strings.map(fixListRegex).join("|")),
      deser: ([s]) =>
        strings.findIndex((i) => stripInsensitivities(s) === stripInsensitivities(i)) + startIndex,
    };
  }
}
function offset(regex, groups) {
  return { regex, deser: ([, h, m]) => signedOffset(h, m), groups };
}
function simple(regex) {
  return { regex, deser: ([s]) => s };
}
function escapeToken(value) {
  return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function unitForToken(token, loc) {
  const one = digitRegex(loc),
    two = digitRegex(loc, "{2}"),
    three = digitRegex(loc, "{3}"),
    four = digitRegex(loc, "{4}"),
    six = digitRegex(loc, "{6}"),
    oneOrTwo = digitRegex(loc, "{1,2}"),
    oneToThree = digitRegex(loc, "{1,3}"),
    oneToSix = digitRegex(loc, "{1,6}"),
    oneToNine = digitRegex(loc, "{1,9}"),
    twoToFour = digitRegex(loc, "{2,4}"),
    fourToSix = digitRegex(loc, "{4,6}"),
    literal = (t) => ({ regex: RegExp(escapeToken(t.val)), deser: ([s]) => s, literal: true }),
    unitate = (t) => {
      if (token.literal) {
        return literal(t);
      }
      switch (t.val) {
        case "G":
          return oneOf(loc.eras("short", false), 0);
        case "GG":
          return oneOf(loc.eras("long", false), 0);
        case "y":
          return intUnit(oneToSix);
        case "yy":
          return intUnit(twoToFour, untruncateYear);
        case "yyyy":
          return intUnit(four);
        case "yyyyy":
          return intUnit(fourToSix);
        case "yyyyyy":
          return intUnit(six);
        case "M":
          return intUnit(oneOrTwo);
        case "MM":
          return intUnit(two);
        case "MMM":
          return oneOf(loc.months("short", true, false), 1);
        case "MMMM":
          return oneOf(loc.months("long", true, false), 1);
        case "L":
          return intUnit(oneOrTwo);
        case "LL":
          return intUnit(two);
        case "LLL":
          return oneOf(loc.months("short", false, false), 1);
        case "LLLL":
          return oneOf(loc.months("long", false, false), 1);
        case "d":
          return intUnit(oneOrTwo);
        case "dd":
          return intUnit(two);
        case "o":
          return intUnit(oneToThree);
        case "ooo":
          return intUnit(three);
        case "HH":
          return intUnit(two);
        case "H":
          return intUnit(oneOrTwo);
        case "hh":
          return intUnit(two);
        case "h":
          return intUnit(oneOrTwo);
        case "mm":
          return intUnit(two);
        case "m":
          return intUnit(oneOrTwo);
        case "q":
          return intUnit(oneOrTwo);
        case "qq":
          return intUnit(two);
        case "s":
          return intUnit(oneOrTwo);
        case "ss":
          return intUnit(two);
        case "S":
          return intUnit(oneToThree);
        case "SSS":
          return intUnit(three);
        case "u":
          return simple(oneToNine);
        case "uu":
          return simple(oneOrTwo);
        case "uuu":
          return intUnit(one);
        case "a":
          return oneOf(loc.meridiems(), 0);
        case "kkkk":
          return intUnit(four);
        case "kk":
          return intUnit(twoToFour, untruncateYear);
        case "W":
          return intUnit(oneOrTwo);
        case "WW":
          return intUnit(two);
        case "E":
        case "c":
          return intUnit(one);
        case "EEE":
          return oneOf(loc.weekdays("short", false, false), 1);
        case "EEEE":
          return oneOf(loc.weekdays("long", false, false), 1);
        case "ccc":
          return oneOf(loc.weekdays("short", true, false), 1);
        case "cccc":
          return oneOf(loc.weekdays("long", true, false), 1);
        case "Z":
        case "ZZ":
          return offset(new RegExp(`([+-]${oneOrTwo.source})(?::(${two.source}))?`), 2);
        case "ZZZ":
          return offset(new RegExp(`([+-]${oneOrTwo.source})(${two.source})?`), 2);
        case "z":
          return simple(/[a-z_+-/]{1,256}?/i);
        default:
          return literal(t);
      }
    };
  const unit = unitate(token) || {
    invalidReason: MISSING_FTP,
  };
  unit.token = token;
  return unit;
}
const partTypeStyleToTokenVal = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy",
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM",
  },
  day: {
    numeric: "d",
    "2-digit": "dd",
  },
  weekday: {
    short: "EEE",
    long: "EEEE",
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour: {
    numeric: "h",
    "2-digit": "hh",
  },
  minute: {
    numeric: "m",
    "2-digit": "mm",
  },
  second: {
    numeric: "s",
    "2-digit": "ss",
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ",
  },
};
function tokenForPart(part, formatOpts) {
  const { type, value } = part;
  if (type === "literal") {
    return {
      literal: true,
      val: value,
    };
  }
  const style = formatOpts[type];
  let val = partTypeStyleToTokenVal[type];
  if (typeof val === "object") {
    val = val[style];
  }
  if (val) {
    return {
      literal: false,
      val,
    };
  }
  return undefined;
}
function buildRegex(units) {
  const re = units.map((u) => u.regex).reduce((f, r) => `${f}(${r.source})`, "");
  return [`^${re}$`, units];
}
function match(input, regex, handlers) {
  const matches = input.match(regex);
  if (matches) {
    const all = {};
    let matchIndex = 1;
    for (const i in handlers) {
      if (hasOwnProperty(handlers, i)) {
        const h = handlers[i],
          groups = h.groups ? h.groups + 1 : 1;
        if (!h.literal && h.token) {
          all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
        }
        matchIndex += groups;
      }
    }
    return [matches, all];
  } else {
    return [matches, {}];
  }
}
function dateTimeFromMatches(matches) {
  const toField = (token) => {
    switch (token) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let zone = null;
  let specificOffset;
  if (!isUndefined(matches.z)) {
    zone = IANAZone.create(matches.z);
  }
  if (!isUndefined(matches.Z)) {
    if (!zone) {
      zone = new FixedOffsetZone(matches.Z);
    }
    specificOffset = matches.Z;
  }
  if (!isUndefined(matches.q)) {
    matches.M = (matches.q - 1) * 3 + 1;
  }
  if (!isUndefined(matches.h)) {
    if (matches.h < 12 && matches.a === 1) {
      matches.h += 12;
    } else if (matches.h === 12 && matches.a === 0) {
      matches.h = 0;
    }
  }
  if (matches.G === 0 && matches.y) {
    matches.y = -matches.y;
  }
  if (!isUndefined(matches.u)) {
    matches.S = parseMillis(matches.u);
  }
  const vals = Object.keys(matches).reduce((r, k) => {
    const f = toField(k);
    if (f) {
      r[f] = matches[k];
    }
    return r;
  }, {});
  return [vals, zone, specificOffset];
}
let dummyDateTimeCache = null;
function getDummyDateTime() {
  if (!dummyDateTimeCache) {
    dummyDateTimeCache = DateTime.fromMillis(1555555555555);
  }
  return dummyDateTimeCache;
}
function maybeExpandMacroToken(token, locale) {
  if (token.literal) {
    return token;
  }
  const formatOpts = Formatter.macroTokenToFormatOpts(token.val);
  const tokens = formatOptsToTokens(formatOpts, locale);
  if (tokens == null || tokens.includes(undefined)) {
    return token;
  }
  return tokens;
}
function expandMacroTokens(tokens, locale) {
  return Array.prototype.concat(...tokens.map((t) => maybeExpandMacroToken(t, locale)));
}
function explainFromTokens(locale, input, format) {
  const tokens = expandMacroTokens(Formatter.parseFormat(format), locale),
    units = tokens.map((t) => unitForToken(t, locale)),
    disqualifyingUnit = units.find((t) => t.invalidReason);
  if (disqualifyingUnit) {
    return { input, tokens, invalidReason: disqualifyingUnit.invalidReason };
  } else {
    const [regexString, handlers] = buildRegex(units),
      regex = RegExp(regexString, "i"),
      [rawMatches, matches] = match(input, regex, handlers),
      [result, zone, specificOffset] = matches
        ? dateTimeFromMatches(matches)
        : [null, null, undefined];
    if (hasOwnProperty(matches, "a") && hasOwnProperty(matches, "H")) {
      throw new ConflictingSpecificationError(
        "Can't include meridiem when specifying 24-hour format"
      );
    }
    return { input, tokens, regex, rawMatches, matches, result, zone, specificOffset };
  }
}
function parseFromTokens(locale, input, format) {
  const { result, zone, specificOffset, invalidReason } = explainFromTokens(locale, input, format);
  return [result, zone, specificOffset, invalidReason];
}
function formatOptsToTokens(formatOpts, locale) {
  if (!formatOpts) {
    return null;
  }
  const formatter = Formatter.create(locale, formatOpts);
  const parts = formatter.formatDateTimeParts(getDummyDateTime());
  return parts.map((p) => tokenForPart(p, formatOpts));
}

const nonLeapLadder = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334],
  leapLadder = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function unitOutOfRange(unit, value) {
  return new Invalid(
    "unit out of range",
    `you specified ${value} (of type ${typeof value}) as a ${unit}, which is invalid`
  );
}
function dayOfWeek(year, month, day) {
  const d = new Date(Date.UTC(year, month - 1, day));
  if (year < 100 && year >= 0) {
    d.setUTCFullYear(d.getUTCFullYear() - 1900);
  }
  const js = d.getUTCDay();
  return js === 0 ? 7 : js;
}
function computeOrdinal(year, month, day) {
  return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}
function uncomputeOrdinal(year, ordinal) {
  const table = isLeapYear(year) ? leapLadder : nonLeapLadder,
    month0 = table.findIndex((i) => i < ordinal),
    day = ordinal - table[month0];
  return { month: month0 + 1, day };
}
function gregorianToWeek(gregObj) {
  const { year, month, day } = gregObj,
    ordinal = computeOrdinal(year, month, day),
    weekday = dayOfWeek(year, month, day);
  let weekNumber = Math.floor((ordinal - weekday + 10) / 7),
    weekYear;
  if (weekNumber < 1) {
    weekYear = year - 1;
    weekNumber = weeksInWeekYear(weekYear);
  } else if (weekNumber > weeksInWeekYear(year)) {
    weekYear = year + 1;
    weekNumber = 1;
  } else {
    weekYear = year;
  }
  return { weekYear, weekNumber, weekday, ...timeObject(gregObj) };
}
function weekToGregorian(weekData) {
  const { weekYear, weekNumber, weekday } = weekData,
    weekdayOfJan4 = dayOfWeek(weekYear, 1, 4),
    yearInDays = daysInYear(weekYear);
  let ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 3,
    year;
  if (ordinal < 1) {
    year = weekYear - 1;
    ordinal += daysInYear(year);
  } else if (ordinal > yearInDays) {
    year = weekYear + 1;
    ordinal -= daysInYear(weekYear);
  } else {
    year = weekYear;
  }
  const { month, day } = uncomputeOrdinal(year, ordinal);
  return { year, month, day, ...timeObject(weekData) };
}
function gregorianToOrdinal(gregData) {
  const { year, month, day } = gregData;
  const ordinal = computeOrdinal(year, month, day);
  return { year, ordinal, ...timeObject(gregData) };
}
function ordinalToGregorian(ordinalData) {
  const { year, ordinal } = ordinalData;
  const { month, day } = uncomputeOrdinal(year, ordinal);
  return { year, month, day, ...timeObject(ordinalData) };
}
function hasInvalidWeekData(obj) {
  const validYear = isInteger(obj.weekYear),
    validWeek = integerBetween(obj.weekNumber, 1, weeksInWeekYear(obj.weekYear)),
    validWeekday = integerBetween(obj.weekday, 1, 7);
  if (!validYear) {
    return unitOutOfRange("weekYear", obj.weekYear);
  } else if (!validWeek) {
    return unitOutOfRange("week", obj.week);
  } else if (!validWeekday) {
    return unitOutOfRange("weekday", obj.weekday);
  } else return false;
}
function hasInvalidOrdinalData(obj) {
  const validYear = isInteger(obj.year),
    validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validOrdinal) {
    return unitOutOfRange("ordinal", obj.ordinal);
  } else return false;
}
function hasInvalidGregorianData(obj) {
  const validYear = isInteger(obj.year),
    validMonth = integerBetween(obj.month, 1, 12),
    validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validMonth) {
    return unitOutOfRange("month", obj.month);
  } else if (!validDay) {
    return unitOutOfRange("day", obj.day);
  } else return false;
}
function hasInvalidTimeData(obj) {
  const { hour, minute, second, millisecond } = obj;
  const validHour =
      integerBetween(hour, 0, 23) ||
      (hour === 24 && minute === 0 && second === 0 && millisecond === 0),
    validMinute = integerBetween(minute, 0, 59),
    validSecond = integerBetween(second, 0, 59),
    validMillisecond = integerBetween(millisecond, 0, 999);
  if (!validHour) {
    return unitOutOfRange("hour", hour);
  } else if (!validMinute) {
    return unitOutOfRange("minute", minute);
  } else if (!validSecond) {
    return unitOutOfRange("second", second);
  } else if (!validMillisecond) {
    return unitOutOfRange("millisecond", millisecond);
  } else return false;
}

const INVALID = "Invalid DateTime";
const MAX_DATE = 8.64e15;
function unsupportedZone(zone) {
  return new Invalid("unsupported zone", `the zone "${zone.name}" is not supported`);
}
function possiblyCachedWeekData(dt) {
  if (dt.weekData === null) {
    dt.weekData = gregorianToWeek(dt.c);
  }
  return dt.weekData;
}
function clone(inst, alts) {
  const current = {
    ts: inst.ts,
    zone: inst.zone,
    c: inst.c,
    o: inst.o,
    loc: inst.loc,
    invalid: inst.invalid,
  };
  return new DateTime({ ...current, ...alts, old: current });
}
function fixOffset(localTS, o, tz) {
  let utcGuess = localTS - o * 60 * 1000;
  const o2 = tz.offset(utcGuess);
  if (o === o2) {
    return [utcGuess, o];
  }
  utcGuess -= (o2 - o) * 60 * 1000;
  const o3 = tz.offset(utcGuess);
  if (o2 === o3) {
    return [utcGuess, o2];
  }
  return [localTS - Math.min(o2, o3) * 60 * 1000, Math.max(o2, o3)];
}
function tsToObj(ts, offset) {
  ts += offset * 60 * 1000;
  const d = new Date(ts);
  return {
    year: d.getUTCFullYear(),
    month: d.getUTCMonth() + 1,
    day: d.getUTCDate(),
    hour: d.getUTCHours(),
    minute: d.getUTCMinutes(),
    second: d.getUTCSeconds(),
    millisecond: d.getUTCMilliseconds(),
  };
}
function objToTS(obj, offset, zone) {
  return fixOffset(objToLocalTS(obj), offset, zone);
}
function adjustTime(inst, dur) {
  const oPre = inst.o,
    year = inst.c.year + Math.trunc(dur.years),
    month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3,
    c = {
      ...inst.c,
      year,
      month,
      day:
        Math.min(inst.c.day, daysInMonth(year, month)) +
        Math.trunc(dur.days) +
        Math.trunc(dur.weeks) * 7,
    },
    millisToAdd = Duration.fromObject({
      years: dur.years - Math.trunc(dur.years),
      quarters: dur.quarters - Math.trunc(dur.quarters),
      months: dur.months - Math.trunc(dur.months),
      weeks: dur.weeks - Math.trunc(dur.weeks),
      days: dur.days - Math.trunc(dur.days),
      hours: dur.hours,
      minutes: dur.minutes,
      seconds: dur.seconds,
      milliseconds: dur.milliseconds,
    }).as("milliseconds"),
    localTS = objToLocalTS(c);
  let [ts, o] = fixOffset(localTS, oPre, inst.zone);
  if (millisToAdd !== 0) {
    ts += millisToAdd;
    o = inst.zone.offset(ts);
  }
  return { ts, o };
}
function parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
  const { setZone, zone } = opts;
  if (parsed && Object.keys(parsed).length !== 0) {
    const interpretationZone = parsedZone || zone,
      inst = DateTime.fromObject(parsed, {
        ...opts,
        zone: interpretationZone,
        specificOffset,
      });
    return setZone ? inst : inst.setZone(zone);
  } else {
    return DateTime.invalid(
      new Invalid("unparsable", `the input "${text}" can't be parsed as ${format}`)
    );
  }
}
function toTechFormat(dt, format, allowZ = true) {
  return dt.isValid
    ? Formatter.create(Locale.create("en-US"), {
        allowZ,
        forceSimple: true,
      }).formatDateTimeFromString(dt, format)
    : null;
}
function toISODate(o, extended) {
  const longFormat = o.c.year > 9999 || o.c.year < 0;
  let c = "";
  if (longFormat && o.c.year >= 0) c += "+";
  c += padStart(o.c.year, longFormat ? 6 : 4);
  if (extended) {
    c += "-";
    c += padStart(o.c.month);
    c += "-";
    c += padStart(o.c.day);
  } else {
    c += padStart(o.c.month);
    c += padStart(o.c.day);
  }
  return c;
}
function toISOTime(
  o,
  extended,
  suppressSeconds,
  suppressMilliseconds,
  includeOffset,
  extendedZone
) {
  let c = padStart(o.c.hour);
  if (extended) {
    c += ":";
    c += padStart(o.c.minute);
    if (o.c.second !== 0 || !suppressSeconds) {
      c += ":";
    }
  } else {
    c += padStart(o.c.minute);
  }
  if (o.c.second !== 0 || !suppressSeconds) {
    c += padStart(o.c.second);
    if (o.c.millisecond !== 0 || !suppressMilliseconds) {
      c += ".";
      c += padStart(o.c.millisecond, 3);
    }
  }
  if (includeOffset) {
    if (o.isOffsetFixed && o.offset === 0 && !extendedZone) {
      c += "Z";
    } else if (o.o < 0) {
      c += "-";
      c += padStart(Math.trunc(-o.o / 60));
      c += ":";
      c += padStart(Math.trunc(-o.o % 60));
    } else {
      c += "+";
      c += padStart(Math.trunc(o.o / 60));
      c += ":";
      c += padStart(Math.trunc(o.o % 60));
    }
  }
  if (extendedZone) {
    c += "[" + o.zone.ianaName + "]";
  }
  return c;
}
const defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  },
  defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  },
  defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  };
const orderedUnits = ["year", "month", "day", "hour", "minute", "second", "millisecond"],
  orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond",
  ],
  orderedOrdinalUnits = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function normalizeUnit(unit) {
  const normalized = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal",
  }[unit.toLowerCase()];
  if (!normalized) throw new InvalidUnitError(unit);
  return normalized;
}
function quickDT(obj, opts) {
  const zone = normalizeZone(opts.zone, Settings.defaultZone),
    loc = Locale.fromObject(opts),
    tsNow = Settings.now();
  let ts, o;
  if (!isUndefined(obj.year)) {
    for (const u of orderedUnits) {
      if (isUndefined(obj[u])) {
        obj[u] = defaultUnitValues[u];
      }
    }
    const invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);
    if (invalid) {
      return DateTime.invalid(invalid);
    }
    const offsetProvis = zone.offset(tsNow);
    [ts, o] = objToTS(obj, offsetProvis, zone);
  } else {
    ts = tsNow;
  }
  return new DateTime({ ts, zone, loc, o });
}
function diffRelative(start, end, opts) {
  const round = isUndefined(opts.round) ? true : opts.round,
    format = (c, unit) => {
      c = roundTo(c, round || opts.calendary ? 0 : 2, true);
      const formatter = end.loc.clone(opts).relFormatter(opts);
      return formatter.format(c, unit);
    },
    differ = (unit) => {
      if (opts.calendary) {
        if (!end.hasSame(start, unit)) {
          return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
        } else return 0;
      } else {
        return end.diff(start, unit).get(unit);
      }
    };
  if (opts.unit) {
    return format(differ(opts.unit), opts.unit);
  }
  for (const unit of opts.units) {
    const count = differ(unit);
    if (Math.abs(count) >= 1) {
      return format(count, unit);
    }
  }
  return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function lastOpts(argList) {
  let opts = {},
    args;
  if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
    opts = argList[argList.length - 1];
    args = Array.from(argList).slice(0, argList.length - 1);
  } else {
    args = Array.from(argList);
  }
  return [opts, args];
}
class DateTime {
  constructor(config) {
    const zone = config.zone || Settings.defaultZone;
    let invalid =
      config.invalid ||
      (Number.isNaN(config.ts) ? new Invalid("invalid input") : null) ||
      (!zone.isValid ? unsupportedZone(zone) : null);
    this.ts = isUndefined(config.ts) ? Settings.now() : config.ts;
    let c = null,
      o = null;
    if (!invalid) {
      const unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
      if (unchanged) {
        [c, o] = [config.old.c, config.old.o];
      } else {
        const ot = zone.offset(this.ts);
        c = tsToObj(this.ts, ot);
        invalid = Number.isNaN(c.year) ? new Invalid("invalid input") : null;
        c = invalid ? null : c;
        o = invalid ? null : ot;
      }
    }
    this._zone = zone;
    this.loc = config.loc || Locale.create();
    this.invalid = invalid;
    this.weekData = null;
    this.c = c;
    this.o = o;
    this.isLuxonDateTime = true;
  }
  static now() {
    return new DateTime({});
  }
  static local() {
    const [opts, args] = lastOpts(arguments),
      [year, month, day, hour, minute, second, millisecond] = args;
    return quickDT({ year, month, day, hour, minute, second, millisecond }, opts);
  }
  static utc() {
    const [opts, args] = lastOpts(arguments),
      [year, month, day, hour, minute, second, millisecond] = args;
    opts.zone = FixedOffsetZone.utcInstance;
    return quickDT({ year, month, day, hour, minute, second, millisecond }, opts);
  }
  static fromJSDate(date, options = {}) {
    const ts = isDate(date) ? date.valueOf() : NaN;
    if (Number.isNaN(ts)) {
      return DateTime.invalid("invalid input");
    }
    const zoneToUse = normalizeZone(options.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }
    return new DateTime({
      ts: ts,
      zone: zoneToUse,
      loc: Locale.fromObject(options),
    });
  }
  static fromMillis(milliseconds, options = {}) {
    if (!isNumber(milliseconds)) {
      throw new InvalidArgumentError(
        `fromMillis requires a numerical input, but received a ${typeof milliseconds} with value ${milliseconds}`
      );
    } else if (milliseconds < -MAX_DATE || milliseconds > MAX_DATE) {
      return DateTime.invalid("Timestamp out of range");
    } else {
      return new DateTime({
        ts: milliseconds,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options),
      });
    }
  }
  static fromSeconds(seconds, options = {}) {
    if (!isNumber(seconds)) {
      throw new InvalidArgumentError("fromSeconds requires a numerical input");
    } else {
      return new DateTime({
        ts: seconds * 1000,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options),
      });
    }
  }
  static fromObject(obj, opts = {}) {
    obj = obj || {};
    const zoneToUse = normalizeZone(opts.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }
    const tsNow = Settings.now(),
      offsetProvis = !isUndefined(opts.specificOffset)
        ? opts.specificOffset
        : zoneToUse.offset(tsNow),
      normalized = normalizeObject(obj, normalizeUnit),
      containsOrdinal = !isUndefined(normalized.ordinal),
      containsGregorYear = !isUndefined(normalized.year),
      containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day),
      containsGregor = containsGregorYear || containsGregorMD,
      definiteWeekDef = normalized.weekYear || normalized.weekNumber,
      loc = Locale.fromObject(opts);
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    const useWeekData = definiteWeekDef || (normalized.weekday && !containsGregor);
    let units,
      defaultValues,
      objNow = tsToObj(tsNow, offsetProvis);
    if (useWeekData) {
      units = orderedWeekUnits;
      defaultValues = defaultWeekUnitValues;
      objNow = gregorianToWeek(objNow);
    } else if (containsOrdinal) {
      units = orderedOrdinalUnits;
      defaultValues = defaultOrdinalUnitValues;
      objNow = gregorianToOrdinal(objNow);
    } else {
      units = orderedUnits;
      defaultValues = defaultUnitValues;
    }
    let foundFirst = false;
    for (const u of units) {
      const v = normalized[u];
      if (!isUndefined(v)) {
        foundFirst = true;
      } else if (foundFirst) {
        normalized[u] = defaultValues[u];
      } else {
        normalized[u] = objNow[u];
      }
    }
    const higherOrderInvalid = useWeekData
        ? hasInvalidWeekData(normalized)
        : containsOrdinal
        ? hasInvalidOrdinalData(normalized)
        : hasInvalidGregorianData(normalized),
      invalid = higherOrderInvalid || hasInvalidTimeData(normalized);
    if (invalid) {
      return DateTime.invalid(invalid);
    }
    const gregorian = useWeekData
        ? weekToGregorian(normalized)
        : containsOrdinal
        ? ordinalToGregorian(normalized)
        : normalized,
      [tsFinal, offsetFinal] = objToTS(gregorian, offsetProvis, zoneToUse),
      inst = new DateTime({
        ts: tsFinal,
        zone: zoneToUse,
        o: offsetFinal,
        loc,
      });
    if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
      return DateTime.invalid(
        "mismatched weekday",
        `you can't specify both a weekday of ${normalized.weekday} and a date of ${inst.toISO()}`
      );
    }
    return inst;
  }
  static fromISO(text, opts = {}) {
    const [vals, parsedZone] = parseISODate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
  }
  static fromRFC2822(text, opts = {}) {
    const [vals, parsedZone] = parseRFC2822Date(text);
    return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
  }
  static fromHTTP(text, opts = {}) {
    const [vals, parsedZone] = parseHTTPDate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
  }
  static fromFormat(text, fmt, opts = {}) {
    if (isUndefined(text) || isUndefined(fmt)) {
      throw new InvalidArgumentError("fromFormat requires an input string and a format");
    }
    const { locale = null, numberingSystem = null } = opts,
      localeToUse = Locale.fromOpts({
        locale,
        numberingSystem,
        defaultToEN: true,
      }),
      [vals, parsedZone, specificOffset, invalid] = parseFromTokens(localeToUse, text, fmt);
    if (invalid) {
      return DateTime.invalid(invalid);
    } else {
      return parseDataToDateTime(vals, parsedZone, opts, `format ${fmt}`, text, specificOffset);
    }
  }
  static fromString(text, fmt, opts = {}) {
    return DateTime.fromFormat(text, fmt, opts);
  }
  static fromSQL(text, opts = {}) {
    const [vals, parsedZone] = parseSQL(text);
    return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
  }
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDateTimeError(invalid);
    } else {
      return new DateTime({ invalid });
    }
  }
  static isDateTime(o) {
    return (o && o.isLuxonDateTime) || false;
  }
  static parseFormatForOpts(formatOpts, localeOpts = {}) {
    const tokenList = formatOptsToTokens(formatOpts, Locale.fromObject(localeOpts));
    return !tokenList ? null : tokenList.map((t) => (t ? t.val : null)).join("");
  }
  static expandFormat(fmt, localeOpts = {}) {
    const expanded = expandMacroTokens(Formatter.parseFormat(fmt), Locale.fromObject(localeOpts));
    return expanded.map((t) => t.val).join("");
  }
  get(unit) {
    return this[unit];
  }
  get isValid() {
    return this.invalid === null;
  }
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  get zone() {
    return this._zone;
  }
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  get weekYear() {
    return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
  }
  get weekNumber() {
    return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
  }
  get weekday() {
    return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
  }
  get ordinal() {
    return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
  }
  get monthShort() {
    return this.isValid ? Info.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  get monthLong() {
    return this.isValid ? Info.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  get weekdayShort() {
    return this.isValid ? Info.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  get weekdayLong() {
    return this.isValid ? Info.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  get offsetNameShort() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "short",
        locale: this.locale,
      });
    } else {
      return null;
    }
  }
  get offsetNameLong() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "long",
        locale: this.locale,
      });
    } else {
      return null;
    }
  }
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  get isInDST() {
    if (this.isOffsetFixed) {
      return false;
    } else {
      return (
        this.offset > this.set({ month: 1, day: 1 }).offset ||
        this.offset > this.set({ month: 5 }).offset
      );
    }
  }
  get isInLeapYear() {
    return isLeapYear(this.year);
  }
  get daysInMonth() {
    return daysInMonth(this.year, this.month);
  }
  get daysInYear() {
    return this.isValid ? daysInYear(this.year) : NaN;
  }
  get weeksInWeekYear() {
    return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
  }
  resolvedLocaleOptions(opts = {}) {
    const { locale, numberingSystem, calendar } = Formatter.create(
      this.loc.clone(opts),
      opts
    ).resolvedOptions(this);
    return { locale, numberingSystem, outputCalendar: calendar };
  }
  toUTC(offset = 0, opts = {}) {
    return this.setZone(FixedOffsetZone.instance(offset), opts);
  }
  toLocal() {
    return this.setZone(Settings.defaultZone);
  }
  setZone(zone, { keepLocalTime = false, keepCalendarTime = false } = {}) {
    zone = normalizeZone(zone, Settings.defaultZone);
    if (zone.equals(this.zone)) {
      return this;
    } else if (!zone.isValid) {
      return DateTime.invalid(unsupportedZone(zone));
    } else {
      let newTS = this.ts;
      if (keepLocalTime || keepCalendarTime) {
        const offsetGuess = zone.offset(this.ts);
        const asObj = this.toObject();
        [newTS] = objToTS(asObj, offsetGuess, zone);
      }
      return clone(this, { ts: newTS, zone });
    }
  }
  reconfigure({ locale, numberingSystem, outputCalendar } = {}) {
    const loc = this.loc.clone({ locale, numberingSystem, outputCalendar });
    return clone(this, { loc });
  }
  setLocale(locale) {
    return this.reconfigure({ locale });
  }
  set(values) {
    if (!this.isValid) return this;
    const normalized = normalizeObject(values, normalizeUnit),
      settingWeekStuff =
        !isUndefined(normalized.weekYear) ||
        !isUndefined(normalized.weekNumber) ||
        !isUndefined(normalized.weekday),
      containsOrdinal = !isUndefined(normalized.ordinal),
      containsGregorYear = !isUndefined(normalized.year),
      containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day),
      containsGregor = containsGregorYear || containsGregorMD,
      definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    let mixed;
    if (settingWeekStuff) {
      mixed = weekToGregorian({ ...gregorianToWeek(this.c), ...normalized });
    } else if (!isUndefined(normalized.ordinal)) {
      mixed = ordinalToGregorian({ ...gregorianToOrdinal(this.c), ...normalized });
    } else {
      mixed = { ...this.toObject(), ...normalized };
      if (isUndefined(normalized.day)) {
        mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
      }
    }
    const [ts, o] = objToTS(mixed, this.o, this.zone);
    return clone(this, { ts, o });
  }
  plus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration);
    return clone(this, adjustTime(this, dur));
  }
  minus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration).negate();
    return clone(this, adjustTime(this, dur));
  }
  startOf(unit) {
    if (!this.isValid) return this;
    const o = {},
      normalizedUnit = Duration.normalizeUnit(unit);
    switch (normalizedUnit) {
      case "years":
        o.month = 1;
      case "quarters":
      case "months":
        o.day = 1;
      case "weeks":
      case "days":
        o.hour = 0;
      case "hours":
        o.minute = 0;
      case "minutes":
        o.second = 0;
      case "seconds":
        o.millisecond = 0;
        break;
    }
    if (normalizedUnit === "weeks") {
      o.weekday = 1;
    }
    if (normalizedUnit === "quarters") {
      const q = Math.ceil(this.month / 3);
      o.month = (q - 1) * 3 + 1;
    }
    return this.set(o);
  }
  endOf(unit) {
    return this.isValid
      ? this.plus({ [unit]: 1 })
          .startOf(unit)
          .minus(1)
      : this;
  }
  toFormat(fmt, opts = {}) {
    return this.isValid
      ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt)
      : INVALID;
  }
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid
      ? Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this)
      : INVALID;
  }
  toLocaleParts(opts = {}) {
    return this.isValid
      ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this)
      : [];
  }
  toISO({
    format = "extended",
    suppressSeconds = false,
    suppressMilliseconds = false,
    includeOffset = true,
    extendedZone = false,
  } = {}) {
    if (!this.isValid) {
      return null;
    }
    const ext = format === "extended";
    let c = toISODate(this, ext);
    c += "T";
    c += toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
    return c;
  }
  toISODate({ format = "extended" } = {}) {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, format === "extended");
  }
  toISOWeekDate() {
    return toTechFormat(this, "kkkk-'W'WW-c");
  }
  toISOTime({
    suppressMilliseconds = false,
    suppressSeconds = false,
    includeOffset = true,
    includePrefix = false,
    extendedZone = false,
    format = "extended",
  } = {}) {
    if (!this.isValid) {
      return null;
    }
    let c = includePrefix ? "T" : "";
    return (
      c +
      toISOTime(
        this,
        format === "extended",
        suppressSeconds,
        suppressMilliseconds,
        includeOffset,
        extendedZone
      )
    );
  }
  toRFC2822() {
    return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
  }
  toHTTP() {
    return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  toSQLDate() {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, true);
  }
  toSQLTime({ includeOffset = true, includeZone = false, includeOffsetSpace = true } = {}) {
    let fmt = "HH:mm:ss.SSS";
    if (includeZone || includeOffset) {
      if (includeOffsetSpace) {
        fmt += " ";
      }
      if (includeZone) {
        fmt += "z";
      } else if (includeOffset) {
        fmt += "ZZ";
      }
    }
    return toTechFormat(this, fmt, true);
  }
  toSQL(opts = {}) {
    if (!this.isValid) {
      return null;
    }
    return `${this.toSQLDate()} ${this.toSQLTime(opts)}`;
  }
  toString() {
    return this.isValid ? this.toISO() : INVALID;
  }
  valueOf() {
    return this.toMillis();
  }
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  toSeconds() {
    return this.isValid ? this.ts / 1000 : NaN;
  }
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1000) : NaN;
  }
  toJSON() {
    return this.toISO();
  }
  toBSON() {
    return this.toJSDate();
  }
  toObject(opts = {}) {
    if (!this.isValid) return {};
    const base = { ...this.c };
    if (opts.includeConfig) {
      base.outputCalendar = this.outputCalendar;
      base.numberingSystem = this.loc.numberingSystem;
      base.locale = this.loc.locale;
    }
    return base;
  }
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  diff(otherDateTime, unit = "milliseconds", opts = {}) {
    if (!this.isValid || !otherDateTime.isValid) {
      return Duration.invalid("created by diffing an invalid DateTime");
    }
    const durOpts = { locale: this.locale, numberingSystem: this.numberingSystem, ...opts };
    const units = maybeArray(unit).map(Duration.normalizeUnit),
      otherIsLater = otherDateTime.valueOf() > this.valueOf(),
      earlier = otherIsLater ? this : otherDateTime,
      later = otherIsLater ? otherDateTime : this,
      diffed = diff(earlier, later, units, durOpts);
    return otherIsLater ? diffed.negate() : diffed;
  }
  diffNow(unit = "milliseconds", opts = {}) {
    return this.diff(DateTime.now(), unit, opts);
  }
  until(otherDateTime) {
    return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
  }
  hasSame(otherDateTime, unit) {
    if (!this.isValid) return false;
    const inputMs = otherDateTime.valueOf();
    const adjustedToZone = this.setZone(otherDateTime.zone, { keepLocalTime: true });
    return adjustedToZone.startOf(unit) <= inputMs && inputMs <= adjustedToZone.endOf(unit);
  }
  equals(other) {
    return (
      this.isValid &&
      other.isValid &&
      this.valueOf() === other.valueOf() &&
      this.zone.equals(other.zone) &&
      this.loc.equals(other.loc)
    );
  }
  toRelative(options = {}) {
    if (!this.isValid) return null;
    const base = options.base || DateTime.fromObject({}, { zone: this.zone }),
      padding = options.padding ? (this < base ? -options.padding : options.padding) : 0;
    let units = ["years", "months", "days", "hours", "minutes", "seconds"];
    let unit = options.unit;
    if (Array.isArray(options.unit)) {
      units = options.unit;
      unit = undefined;
    }
    return diffRelative(base, this.plus(padding), {
      ...options,
      numeric: "always",
      units,
      unit,
    });
  }
  toRelativeCalendar(options = {}) {
    if (!this.isValid) return null;
    return diffRelative(options.base || DateTime.fromObject({}, { zone: this.zone }), this, {
      ...options,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: true,
    });
  }
  static min(...dateTimes) {
    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("min requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.min);
  }
  static max(...dateTimes) {
    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("max requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, (i) => i.valueOf(), Math.max);
  }
  static fromFormatExplain(text, fmt, options = {}) {
    const { locale = null, numberingSystem = null } = options,
      localeToUse = Locale.fromOpts({
        locale,
        numberingSystem,
        defaultToEN: true,
      });
    return explainFromTokens(localeToUse, text, fmt);
  }
  static fromStringExplain(text, fmt, options = {}) {
    return DateTime.fromFormatExplain(text, fmt, options);
  }
  static get DATE_SHORT() {
    return DATE_SHORT;
  }
  static get DATE_MED() {
    return DATE_MED;
  }
  static get DATE_MED_WITH_WEEKDAY() {
    return DATE_MED_WITH_WEEKDAY;
  }
  static get DATE_FULL() {
    return DATE_FULL;
  }
  static get DATE_HUGE() {
    return DATE_HUGE;
  }
  static get TIME_SIMPLE() {
    return TIME_SIMPLE;
  }
  static get TIME_WITH_SECONDS() {
    return TIME_WITH_SECONDS;
  }
  static get TIME_WITH_SHORT_OFFSET() {
    return TIME_WITH_SHORT_OFFSET;
  }
  static get TIME_WITH_LONG_OFFSET() {
    return TIME_WITH_LONG_OFFSET;
  }
  static get TIME_24_SIMPLE() {
    return TIME_24_SIMPLE;
  }
  static get TIME_24_WITH_SECONDS() {
    return TIME_24_WITH_SECONDS;
  }
  static get TIME_24_WITH_SHORT_OFFSET() {
    return TIME_24_WITH_SHORT_OFFSET;
  }
  static get TIME_24_WITH_LONG_OFFSET() {
    return TIME_24_WITH_LONG_OFFSET;
  }
  static get DATETIME_SHORT() {
    return DATETIME_SHORT;
  }
  static get DATETIME_SHORT_WITH_SECONDS() {
    return DATETIME_SHORT_WITH_SECONDS;
  }
  static get DATETIME_MED() {
    return DATETIME_MED;
  }
  static get DATETIME_MED_WITH_SECONDS() {
    return DATETIME_MED_WITH_SECONDS;
  }
  static get DATETIME_MED_WITH_WEEKDAY() {
    return DATETIME_MED_WITH_WEEKDAY;
  }
  static get DATETIME_FULL() {
    return DATETIME_FULL;
  }
  static get DATETIME_FULL_WITH_SECONDS() {
    return DATETIME_FULL_WITH_SECONDS;
  }
  static get DATETIME_HUGE() {
    return DATETIME_HUGE;
  }
  static get DATETIME_HUGE_WITH_SECONDS() {
    return DATETIME_HUGE_WITH_SECONDS;
  }
}
function friendlyDateTime(dateTimeish) {
  if (DateTime.isDateTime(dateTimeish)) {
    return dateTimeish;
  } else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) {
    return DateTime.fromJSDate(dateTimeish);
  } else if (dateTimeish && typeof dateTimeish === "object") {
    return DateTime.fromObject(dateTimeish);
  } else {
    throw new InvalidArgumentError(
      `Unknown datetime argument: ${dateTimeish}, of type ${typeof dateTimeish}`
    );
  }
}

var Backgrounds = {
  BLUR: 'rgba(255,255,255,0.85)',
  GREEN: 'linear-gradient(167deg, rgba(0,202,139,1) 0%, rgba(51,213,162,1) 100%)',
  BLUE: 'linear-gradient(167deg, rgba(0,152,219,1) 0%, rgba(128,190,224,1) 100%)',
  YELLOW: 'linear-gradient(167deg, rgba(254,224,0,1) 0%, rgba(254,233,77,1) 100%)',
  ORANGE: 'linear-gradient(145deg, rgba(250,190,56,1) 0%, rgba(242,176,45,1) 100%)',
  PURPLE: 'linear-gradient(167deg, rgba(255,54,153,1) 0%, rgba(255,50,181,1) 100%)',
  RED: 'linear-gradient(167deg, rgba(239,107,107,1) 0%, rgba(241,77,77,1) 100%)'
};

function Date$1(props) {
  var _props$height, _props$height2, _props$borderRadius;
  var _Lang$useTranslation = Lang.useTranslation(),
      i18n = _Lang$useTranslation.i18n;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      active = _React$useState2[0],
      setActive = _React$useState2[1];
  var _React$useState3 = React$4.useState(false),
      _React$useState4 = _slicedToArray$5(_React$useState3, 2),
      hover = _React$useState4[0],
      setHover = _React$useState4[1];
  var _React$useState5 = React$4.useState(''),
      _React$useState6 = _slicedToArray$5(_React$useState5, 2),
      value = _React$useState6[0],
      setValue = _React$useState6[1];
  var ref = React$4.useRef(null);
  var placeholder = '.. / .. / ..';
  React$4.useEffect(function () {
    var date = DateTime.fromJSDate(props.value).setLocale(i18n.language);
    if (props.format) {
      var result = date.toLocaleString(props.format);
      setValue(result);
    } else {
      var _result = date.toLocaleString({
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });
      setValue(_result);
    }
  }, [props.value, props.format]);
  React$4.useEffect(function () {
    function clickHandler(event) {
      if (ref.current && !ref.current.contains(event.target)) setActive(false);
    }
    document.addEventListener('mousedown', clickHandler);
    return function () {
      document.removeEventListener('mousedown', clickHandler);
    };
  }, [ref]);
  var align = function align(position) {
    switch (position) {
      case 'left':
        return 'flex-start';
      case 'right':
        return 'flex-end';
      default:
        return 'center';
    }
  };
  return React$4.createElement("div", {
    ref: ref,
    style: {
      position: 'relative',
      width: '100%'
    }
  }, props.title && React$4.createElement("div", {
    style: {
      marginBottom: 7
    }
  }, React$4.createElement(Text, {
    fontWeight: 500,
    fontSize: "1em"
  }, props.title)), React$4.createElement("button", {
    type: "button",
    className: "Hover",
    onClick: function onClick() {
      setActive(!active);
    },
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    style: {
      width: '100%',
      height: props.size === 'medium' ? (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 40 : (_props$height2 = props.height) !== null && _props$height2 !== void 0 ? _props$height2 : 50,
      borderRadius: ((_props$borderRadius = props.borderRadius) !== null && _props$borderRadius !== void 0 ? _props$borderRadius : props.size === 'medium') ? 7 : 10,
      position: 'relative',
      border: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      backgroundColor: props.disabled ? Colors.MEDIUM_WHITE : hover ? Colors.LIGHT_GREY : Colors.WHITE,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 15,
      paddingRight: 5,
      fontSize: '1em'
    }
  }, React$4.createElement(Text, {
    fontWeight: 300
  }, props.value ? value : placeholder), React$4.createElement("div", {
    style: {
      height: 30,
      width: 30,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      transform: "rotate(".concat(active ? 180 : 0, "deg)")
    }
  }, React$4.createElement(Icon, {
    name: "AngleDown",
    height: 25,
    width: 25,
    color: Colors.GREY,
    iconSet: "FA"
  }))), active && React$4.createElement("div", {
    style: {
      width: '100%',
      maxWidth: 350,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: align(props.align),
      position: 'absolute',
      zIndex: 10
    }
  }, React$4.createElement("div", {
    className: "Blur",
    style: {
      height: 'auto',
      width: '100%',
      minWidth: 351,
      background: Backgrounds.BLUR,
      marginTop: 15,
      border: "solid 1px ".concat(Colors.MEDIUM_WHITE),
      borderRadius: 10,
      boxShadow: "0px 0px 25px 0px ".concat(Colors.GREY, "25"),
      overflow: 'hidden',
      padding: 15
    }
  }, React$4.createElement(Calendar, {
    value: props.value,
    onChange: props.onChange,
    minDate: props.minDate,
    maxDate: props.maxDate,
    maxDetail: props.maxDetail
  }))));
}

function Modal(props) {
  var _props$width;
  var size = useDimensions();
  var onBackgroundClick = function onBackgroundClick(e) {
    if (e.target === e.currentTarget) props.onClose();
  };
  var _onKeyDown = function onKeyDown(e) {
    if (e.key === 'Escape') {
      props.onClose();
    }
  };
  return React$4.createElement(AnimatePresence, null, props.visible && React$4.createElement("div", {
    tabIndex: 0,
    role: "button",
    onKeyDown: function onKeyDown(e) {
      return _onKeyDown(e);
    },
    onMouseDown: onBackgroundClick,
    style: {
      width: '100%',
      height: '100svh',
      position: 'fixed',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      justifyContent: 'flex-start',
      zIndex: 2147483004,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    }
  }, React$4.createElement(motion.div, {
    style: {
      width: ((_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : size.width < Breakpoint.sm) ? '100%' : '60%',
      maxWidth: size.width < Breakpoint.sm ? '100%' : 640,
      maxHeight: '100%',
      height: '100%',
      minHeight: 120,
      borderTopLeftRadius: size.width < Breakpoint.sm ? 0 : 10,
      borderBottomLeftRadius: size.width < Breakpoint.sm ? 0 : 10,
      overflow: 'hidden',
      zIndex: 2147483004,
      borderLeft: "solid ".concat(size.width < Breakpoint.sm ? '0px transparent' : "2px ".concat(Colors.MEDIUM_WHITE)),
      boxShadow: "0px 0px 25px 0px ".concat(Colors.GREY, "25"),
      backgroundColor: Colors.WHITE
    },
    initial: {
      translateX: 640
    },
    animate: {
      translateX: 0
    },
    exit: {
      translateX: 640
    },
    transition: {
      ease: 'easeInOut',
      duration: 0.3
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      flex: 'auto',
      height: '100%'
    }
  }, React$4.createElement("div", {
    style: {
      height: !props.title && !props.subTitle || size.width < Breakpoint.sm ? 60 : 120,
      borderBottom: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: size.width < Breakpoint.sm ? 'center' : 'initial',
      paddingLeft: 15,
      paddingTop: size.width < Breakpoint.sm ? 0 : 30,
      paddingBottom: size.width < Breakpoint.sm ? 0 : 30
    }
  }, props.title && React$4.createElement(Text, {
    fontWeight: size.width < Breakpoint.sm ? 300 : 700,
    fontSize: size.width < Breakpoint.sm ? '1.3em' : '2em'
  }, props.title), size.width >= Breakpoint.sm && props.subTitle && React$4.createElement("div", {
    style: {
      marginTop: 5
    }
  }, React$4.createElement(Text, {
    fontSize: "1.1em"
  }, props.subTitle))), React$4.createElement("button", {
    type: "button",
    className: "Hover",
    onClick: function onClick() {
      return props.onClose();
    },
    style: {
      height: 58,
      width: 58,
      backgroundColor: 'transparent',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      borderLeft: "solid ".concat(!props.title && !props.subTitle || size.width < Breakpoint.sm ? "2px ".concat(Colors.MEDIUM_WHITE) : '0px transparent'),
      borderRight: 'solid 0px transparent',
      borderTop: 'solid 0px transparent',
      borderBottom: 'solid 0px transparent'
    }
  }, React$4.createElement(Icon, {
    name: "Times",
    height: 25,
    width: 25,
    color: Colors.GREY,
    iconSet: "Feather"
  }))), props.children))));
}

var Item$8 = function Item(item) {
  return React$4.createElement(React$4.Fragment, null, React$4.createElement("div", {
    style: {
      paddingLeft: 15,
      paddingRight: 15,
      paddingTop: 15,
      paddingBottom: 5,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      borderTop: "solid 2px ".concat(Colors.MEDIUM_WHITE)
    }
  }, React$4.createElement(Text, {
    color: Colors.DARK_GREY
  }, "".concat(item.title, ":")), React$4.createElement(Text, {
    fontWeight: 500
  }, item.formatted)), React$4.createElement("div", {
    style: {
      width: '100%',
      overflow: 'hidden',
      borderTop: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      marginTop: 10,
      height: 'auto',
      maxHeight: item.active ? 337 : 0,
      transition: 'all 0.4s linear',
      transform: 'translateY(2px)'
    }
  }, React$4.createElement("div", {
    style: {
      paddingTop: 15,
      paddingBottom: 15,
      paddingLeft: 15,
      paddingRight: 15
    }
  }, React$4.createElement(Calendar, {
    value: item.value,
    onChange: item.onChange,
    minDate: item.minDate,
    maxDate: item.maxDate,
    maxDetail: item.maxDetail
  }))));
};
function ModalContent(props) {
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var _React$useState = React$4.useState(0),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      page = _React$useState2[0],
      setPage = _React$useState2[1];
  return React$4.createElement(React$4.Fragment, null, React$4.createElement("div", {
    style: {
      height: '100%',
      overflowY: 'scroll'
    }
  }, React$4.createElement("div", null, React$4.createElement(Item$8, {
    title: _('from', {
      ns: 'ui'
    }),
    formatted: props.start.formatted,
    value: props.start.value,
    onChange: props.start.onChange,
    minDate: props.start.minDate,
    maxDate: props.start.maxDate,
    maxDetail: props.start.maxDetail,
    active: page === 0
  })), React$4.createElement("div", null, React$4.createElement(Item$8, {
    title: _('to', {
      ns: 'ui'
    }),
    formatted: props.end.formatted,
    value: props.end.value,
    onChange: props.end.onChange,
    minDate: props.end.minDate,
    maxDate: props.end.maxDate,
    maxDetail: props.end.maxDetail,
    active: page === 1
  })), React$4.createElement("div", {
    style: {
      width: '100%',
      borderTop: "solid 2px ".concat(Colors.MEDIUM_WHITE)
    }
  })), React$4.createElement("div", {
    style: {
      borderTop: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: 15
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row'
    }
  }, page === 1 && React$4.createElement("div", {
    style: {
      width: 'auto',
      marginRight: 15
    }
  }, React$4.createElement(Buttons$1, {
    type: "icon",
    icon: {
      name: 'ArrowLeft',
      height: 20,
      width: 20,
      color: Colors.GREY,
      iconSet: 'FA'
    },
    onClick: function onClick() {
      setPage(0);
    },
    colorScheme: "white"
  })), React$4.createElement("div", {
    style: {
      width: 'auto',
      marginRight: 15
    }
  }, React$4.createElement(Buttons$1, {
    type: "icon",
    icon: {
      name: 'CalendarClear',
      height: 20,
      width: 20,
      color: Colors.GREY,
      iconSet: 'FA'
    },
    onClick: props.onClear,
    colorScheme: "white"
  }))), React$4.createElement("div", {
    style: {
      width: 'auto'
    }
  }, React$4.createElement(Buttons$1, {
    text: _('next', {
      ns: 'ui'
    }),
    onClick: function onClick() {
      if (page === 0) setPage(1);
      if (page === 1) props.onClose();
    }
  }))));
}

var Item$7 = function Item(item) {
  return React$4.createElement("div", {
    style: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingLeft: 7,
      paddingRight: 5,
      paddingTop: item.align === 'vertical' ? 10 : 0,
      paddingBottom: item.align === 'vertical' ? 10 : 0
    }
  }, React$4.createElement(Text, {
    color: Colors.DARK_GREY
  }, "".concat(item.text, ":")), React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2
    }
  }, React$4.createElement(Text, {
    fontWeight: 500
  }, item.value), React$4.createElement("div", {
    style: {
      height: 30,
      width: 30,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      transform: "rotate(".concat(item.active ? 180 : 0, "deg)")
    }
  }, React$4.createElement(Icon, {
    name: "AngleDown",
    height: 25,
    width: 25,
    color: Colors.GREY,
    iconSet: "FA"
  }))));
};
function FromToDate(props) {
  var _props$height, _props$height2, _props$borderRadius;
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._,
      i18n = _Lang$useTranslation.i18n;
  var ref = React$4.useRef(null);
  var containerRef = React$4.useRef(null);
  var _React$useState = React$4.useState('100%'),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      height = _React$useState2[0],
      setHeight = _React$useState2[1];
  var _React$useState3 = React$4.useState(false),
      _React$useState4 = _slicedToArray$5(_React$useState3, 2),
      active = _React$useState4[0],
      setActive = _React$useState4[1];
  var _React$useState5 = React$4.useState(false),
      _React$useState6 = _slicedToArray$5(_React$useState5, 2),
      hover = _React$useState6[0],
      setHover = _React$useState6[1];
  var onClose = function onClose() {
    setActive(false);
    if (props.onClose) props.onClose();
  };
  var getHeight = function getHeight() {
    if (props.align === 'horizontal' && active && containerRef.current.clientHeight !== null) {
      setHeight(containerRef === null || containerRef === void 0 ? void 0 : containerRef.current.clientHeight);
    }
  };
  React$4.useEffect(function () {
    getHeight();
  }, [active]);
  React$4.useEffect(function () {
    window.addEventListener('resize', getHeight);
    return function () {
      return window.removeEventListener('resize', getHeight);
    };
  }, []);
  var placeholder = '.. / .. / ..';
  var valueHandler = function valueHandler(dateValue) {
    var date = DateTime.fromJSDate(dateValue).setLocale(i18n.language);
    if (props.format) {
      return date.toLocaleString(props.format);
    }
    return props.align === 'vertical' ? date.toLocaleString({
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    }) : date.toLocaleString({
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };
  React$4.useEffect(function () {
    function clickHandler(event) {
      if (props.align === 'horizontal' && ref.current && !ref.current.contains(event.target)) setActive(false);
    }
    document.addEventListener('mousedown', clickHandler);
    return function () {
      document.removeEventListener('mousedown', clickHandler);
    };
  }, [ref]);
  return React$4.createElement(React$4.Fragment, null, React$4.createElement("div", {
    ref: ref,
    style: {
      position: 'relative',
      width: '100%'
    }
  }, React$4.createElement("button", {
    type: "button",
    className: "Hover",
    onClick: function onClick() {
      setActive(!active);
    },
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    style: {
      width: '100%',
      height: props.align === 'vertical' ? '100%' : props.size === 'medium' ? (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 40 : (_props$height2 = props.height) !== null && _props$height2 !== void 0 ? _props$height2 : 50,
      position: 'relative',
      borderRadius: ((_props$borderRadius = props.borderRadius) !== null && _props$borderRadius !== void 0 ? _props$borderRadius : props.size === 'medium') ? 7 : 10,
      border: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      backgroundColor: props.disabled ? Colors.MEDIUM_WHITE : hover ? Colors.LIGHT_GREY : Colors.WHITE,
      display: 'flex',
      flexDirection: props.align === 'vertical' ? 'column' : 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingTop: 0,
      paddingBottom: 0
    }
  }, React$4.createElement(Item$7, {
    text: _('from', {
      ns: 'ui'
    }),
    align: props.align,
    value: props.start.value ? valueHandler(props.start.value) : placeholder,
    active: active
  }), React$4.createElement("div", {
    style: {
      minWidth: props.align === 'vertical' ? '100%' : 2,
      height: props.align === 'vertical' ? 2 : '100%',
      backgroundColor: Colors.MEDIUM_WHITE
    }
  }), React$4.createElement(Item$7, {
    text: _('to', {
      ns: 'ui'
    }),
    align: props.align,
    value: props.end.value ? valueHandler(props.end.value) : placeholder,
    active: active
  })), props.align === 'horizontal' && active && React$4.createElement("div", {
    style: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'center'
    }
  }, React$4.createElement("div", {
    ref: containerRef,
    className: "Blur",
    style: {
      position: 'absolute',
      height: 'auto',
      width: '100%',
      minWidth: 702,
      background: Backgrounds.BLUR,
      marginTop: 15,
      border: "solid 1px ".concat(Colors.MEDIUM_WHITE),
      borderRadius: 10,
      boxShadow: "0px 0px 25px 0px ".concat(Colors.GREY, "25"),
      overflow: 'hidden'
    }
  }, React$4.createElement("div", {
    style: {
      height: 450,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: 15
    }
  }, React$4.createElement("div", {
    style: {
      width: '100%',
      height: 'auto',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center'
    }
  }, React$4.createElement("div", {
    style: {
      paddingTop: 15,
      paddingLeft: 15,
      paddingBottom: 15
    }
  }, React$4.createElement(Calendar, {
    value: props.start.value,
    onChange: props.start.onChange,
    minDate: props.start.minDate,
    maxDate: props.start.maxDate,
    maxDetail: props.start.maxDetail
  }))), React$4.createElement("div", {
    style: {
      minWidth: 2,
      height: height,
      backgroundColor: Colors.MEDIUM_WHITE
    }
  }), React$4.createElement("div", {
    style: {
      width: '100%',
      height: 'auto',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center'
    }
  }, React$4.createElement("div", {
    style: {
      paddingTop: 15,
      paddingRight: 15,
      paddingBottom: 15
    }
  }, React$4.createElement(Calendar, {
    value: props.end.value,
    onChange: props.end.onChange,
    minDate: props.end.minDate,
    maxDate: props.end.maxDate,
    maxDetail: props.end.maxDetail
  })))), props.onClear && React$4.createElement("div", {
    style: {
      height: 60,
      width: '100%',
      borderTop: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-end',
      paddingRight: 15,
      paddingLeft: 15
    }
  }, React$4.createElement("div", {
    style: {
      width: 'auto'
    }
  }, React$4.createElement(Buttons$1, {
    text: _('removeSelection', {
      ns: 'ui'
    }),
    size: "medium",
    colorScheme: "white",
    onClick: props.onClear
  })))))), React$4.createElement(Modal, {
    visible: props.align === 'vertical' && active,
    width: "100%",
    onClose: onClose
  }, React$4.createElement(ModalContent, {
    onClose: onClose,
    start: _objectSpread2({
      formatted: props.start.value ? valueHandler(props.start.value) : placeholder
    }, props.start),
    end: _objectSpread2({
      formatted: props.end.value ? valueHandler(props.end.value) : placeholder
    }, props.end),
    onClear: props.onClear
  })));
}

var Range = React$4.forwardRef(function (props, ref) {
  var _props$max, _props$min, _props$step, _props$orient;
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var max = (_props$max = props.max) !== null && _props$max !== void 0 ? _props$max : 100;
  return React$4.createElement("div", {
    style: {
      width: '100%',
      height: 'auto'
    }
  }, React$4.createElement("label", {
    className: "DisableSelection",
    htmlFor: props.id,
    style: {
      color: Colors.GREY,
      fontSize: '1em',
      width: '100%',
      backgroundColor: 'transparent',
      position: 'relative'
    }
  }, props.label, !props.required && !props.disabled && React$4.createElement("span", {
    style: {
      fontSize: '0.8em',
      position: 'absolute',
      marginTop: 2,
      paddingLeft: 6,
      color: Colors.DARK_GREY,
      whiteSpace: 'nowrap'
    }
  }, "- ".concat(_('optional', {
    ns: 'ui'
  })))), React$4.createElement("div", {
    style: {
      width: '100%',
      marginTop: 10
    }
  }, React$4.createElement("input", {
    ref: ref,
    type: "range",
    id: props.id,
    name: props.name,
    "aria-label": props.ariaLabel,
    min: (_props$min = props.min) !== null && _props$min !== void 0 ? _props$min : 1,
    max: max,
    step: (_props$step = props.step) !== null && _props$step !== void 0 ? _props$step : 'any',
    orient: (_props$orient = props.orient) !== null && _props$orient !== void 0 ? _props$orient : 'horizontal',
    onChange: props.onChange,
    value: props.value,
    style: {
      width: '100%',
      backgroundSize: "".concat(props.value * 100 / max, "% 100%")
    }
  })), React$4.createElement("div", {
    style: {
      width: '100%',
      marginTop: 15
    }
  }, React$4.createElement(Text, {
    textAlign: "center",
    fontWeight: 500
  }, props.formattedValue)));
});

var Number$1 = React$4.forwardRef(function (props, ref) {
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      isFocused = _React$useState2[0],
      setFocused = _React$useState2[1];
  var onKeyUp = function onKeyUp(event) {
    switch (event.key) {
      case 'Enter':
        if (props.onEnter) props.onEnter();
        break;
      case 'Tab':
        if (props.onTab) props.onTab();
        break;
      default:
        if (props.onKeyUp) props.onKeyUp();
    }
  };
  return React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%'
    }
  }, React$4.createElement("div", {
    style: {
      width: '100%',
      height: 'auto'
    }
  }, props.label && React$4.createElement("label", {
    className: "DisableSelection",
    htmlFor: props.id,
    style: {
      color: Colors.GREY,
      fontSize: '1em',
      width: '100%',
      position: 'relative',
      height: props.label || !props.required ? 20 : 0,
      display: 'inline-block',
      marginBottom: 5
    }
  }, props.label && props.label, !props.required && !props.disabled && React$4.createElement("span", {
    style: {
      fontSize: '0.8em',
      position: 'absolute',
      marginTop: 2,
      paddingLeft: 6,
      color: Colors.DARK_GREY,
      whiteSpace: 'nowrap',
      width: 'auto',
      fontWeight: 300
    }
  }, "- ".concat(_('optional', {
    ns: 'ui'
  })))), React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%'
    }
  }, React$4.createElement("input", {
    ref: ref,
    className: props.disabled ? 'Disabled' : 'Hover',
    onFocus: function onFocus() {
      if (props.onFocus) props.onFocus();
      setFocused(true);
    },
    onBlur: function onBlur() {
      if (props.onBlur) props.onBlur();
      setFocused(false);
    },
    onWheel: function onWheel() {
      return document.activeElement.blur();
    },
    value: props.value,
    onChange: props.onChange,
    onKeyUp: onKeyUp,
    disabled: props.disabled,
    autoComplete: props.autocomplete,
    readOnly: props.readonly,
    "aria-label": props.ariaLabel,
    "aria-required": props.required,
    id: props.id,
    name: props.name,
    placeholder: props.placeholder,
    required: props.required,
    max: props.max,
    min: props.min,
    step: props.step,
    lang: props.lang,
    type: "number"
    ,
    autoFocus: props.autofocus,
    style: {
      height: 50,
      width: '100%',
      backgroundColor: Colors.WHITE,
      borderTopRightRadius: 5,
      borderTopLeftRadius: 5,
      borderBottomRightRadius: 5,
      borderBottomLeftRadius: 5,
      borderTop: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(isFocused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderLeft: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(isFocused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderRight: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(isFocused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderBottom: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(isFocused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      outline: 'none',
      fontSize: '1.25em',
      fontFamily: 'Museo-Sans',
      fontWeight: 300,
      color: props.disabled ? Colors.MEDIUM_GREY : Colors.GREY,
      padding: 10
    }
  }), props.suffix && React$4.createElement("div", {
    style: {
      height: 50,
      width: 'auto',
      minWidth: 52,
      paddingLeft: 7.5,
      paddingRight: 7.5,
      marginLeft: -5,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: Colors.LIGHT_GREY,
      borderTop: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderBottom: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderLeft: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(isFocused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderRight: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderTopRightRadius: 10,
      borderBottomRightRadius: 10
    }
  }, props.suffix)), props.error && React$4.createElement("div", {
    style: {
      marginTop: 5
    }
  }, React$4.createElement(Text, {
    fontSize: "1em",
    color: Colors.RED
  }, props.error))));
});

var COMMON_MIME_TYPES = new Map([
    ['aac', 'audio/aac'],
    ['abw', 'application/x-abiword'],
    ['arc', 'application/x-freearc'],
    ['avif', 'image/avif'],
    ['avi', 'video/x-msvideo'],
    ['azw', 'application/vnd.amazon.ebook'],
    ['bin', 'application/octet-stream'],
    ['bmp', 'image/bmp'],
    ['bz', 'application/x-bzip'],
    ['bz2', 'application/x-bzip2'],
    ['cda', 'application/x-cdf'],
    ['csh', 'application/x-csh'],
    ['css', 'text/css'],
    ['csv', 'text/csv'],
    ['doc', 'application/msword'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    ['eot', 'application/vnd.ms-fontobject'],
    ['epub', 'application/epub+zip'],
    ['gz', 'application/gzip'],
    ['gif', 'image/gif'],
    ['heic', 'image/heic'],
    ['heif', 'image/heif'],
    ['htm', 'text/html'],
    ['html', 'text/html'],
    ['ico', 'image/vnd.microsoft.icon'],
    ['ics', 'text/calendar'],
    ['jar', 'application/java-archive'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['js', 'text/javascript'],
    ['json', 'application/json'],
    ['jsonld', 'application/ld+json'],
    ['mid', 'audio/midi'],
    ['midi', 'audio/midi'],
    ['mjs', 'text/javascript'],
    ['mp3', 'audio/mpeg'],
    ['mp4', 'video/mp4'],
    ['mpeg', 'video/mpeg'],
    ['mpkg', 'application/vnd.apple.installer+xml'],
    ['odp', 'application/vnd.oasis.opendocument.presentation'],
    ['ods', 'application/vnd.oasis.opendocument.spreadsheet'],
    ['odt', 'application/vnd.oasis.opendocument.text'],
    ['oga', 'audio/ogg'],
    ['ogv', 'video/ogg'],
    ['ogx', 'application/ogg'],
    ['opus', 'audio/opus'],
    ['otf', 'font/otf'],
    ['png', 'image/png'],
    ['pdf', 'application/pdf'],
    ['php', 'application/x-httpd-php'],
    ['ppt', 'application/vnd.ms-powerpoint'],
    ['pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
    ['rar', 'application/vnd.rar'],
    ['rtf', 'application/rtf'],
    ['sh', 'application/x-sh'],
    ['svg', 'image/svg+xml'],
    ['swf', 'application/x-shockwave-flash'],
    ['tar', 'application/x-tar'],
    ['tif', 'image/tiff'],
    ['tiff', 'image/tiff'],
    ['ts', 'video/mp2t'],
    ['ttf', 'font/ttf'],
    ['txt', 'text/plain'],
    ['vsd', 'application/vnd.visio'],
    ['wav', 'audio/wav'],
    ['weba', 'audio/webm'],
    ['webm', 'video/webm'],
    ['webp', 'image/webp'],
    ['woff', 'font/woff'],
    ['woff2', 'font/woff2'],
    ['xhtml', 'application/xhtml+xml'],
    ['xls', 'application/vnd.ms-excel'],
    ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    ['xml', 'application/xml'],
    ['xul', 'application/vnd.mozilla.xul+xml'],
    ['zip', 'application/zip'],
    ['7z', 'application/x-7z-compressed'],
    ['mkv', 'video/x-matroska'],
    ['mov', 'video/quicktime'],
    ['msg', 'application/vnd.ms-outlook']
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if (typeof f.path !== 'string') {
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string'
                ? path
                : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                    ? webkitRelativePath
                    : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.')
            .pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}

var FILES_TO_IGNORE = [
    '.DS_Store',
    'Thumbs.db'
];
function fromEvent(evt) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (isObject(evt) && isDataTransfer(evt.dataTransfer)) {
                return [2 , getDataTransferFiles(evt.dataTransfer, evt.type)];
            }
            else if (isChangeEvt(evt)) {
                return [2 , getInputFiles(evt)];
            }
            else if (Array.isArray(evt) && evt.every(function (item) { return 'getFile' in item && typeof item.getFile === 'function'; })) {
                return [2 , getFsHandleFiles(evt)];
            }
            return [2 , []];
        });
    });
}
function isDataTransfer(value) {
    return isObject(value);
}
function isChangeEvt(value) {
    return isObject(value) && isObject(value.target);
}
function isObject(v) {
    return typeof v === 'object' && v !== null;
}
function getInputFiles(evt) {
    return fromList(evt.target.files).map(function (file) { return toFileWithPath(file); });
}
function getFsHandleFiles(handles) {
    return __awaiter(this, void 0, void 0, function () {
        var files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 , Promise.all(handles.map(function (h) { return h.getFile(); }))];
                case 1:
                    files = _a.sent();
                    return [2 , files.map(function (file) { return toFileWithPath(file); })];
            }
        });
    });
}
function getDataTransferFiles(dt, type) {
    return __awaiter(this, void 0, void 0, function () {
        var items, files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!dt.items) return [3 , 2];
                    items = fromList(dt.items)
                        .filter(function (item) { return item.kind === 'file'; });
                    if (type !== 'drop') {
                        return [2 , items];
                    }
                    return [4 , Promise.all(items.map(toFilePromises))];
                case 1:
                    files = _a.sent();
                    return [2 , noIgnoredFiles(flatten(files))];
                case 2: return [2 , noIgnoredFiles(fromList(dt.files)
                        .map(function (file) { return toFileWithPath(file); }))];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
}
function fromList(items) {
    if (items === null) {
        return [];
    }
    var files = [];
    for (var i = 0; i < items.length; i++) {
        var file = items[i];
        files.push(file);
    }
    return files;
}
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    var entry = item.webkitGetAsEntry();
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item);
}
function flatten(items) {
    return items.reduce(function (acc, files) { return __spreadArray(__spreadArray([], __read(acc), false), __read((Array.isArray(files) ? flatten(files) : [files])), false); }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) {
        return Promise.reject("".concat(item, " is not a File"));
    }
    var fwp = toFileWithPath(file);
    return Promise.resolve(fwp);
}
function fromEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 , entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
        });
    });
}
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function (resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            reader.readEntries(function (batch) { return __awaiter(_this, void 0, void 0, function () {
                var files, err_1, items;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!batch.length) return [3 , 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 , Promise.all(entries)];
                        case 2:
                            files = _a.sent();
                            resolve(files);
                            return [3 , 4];
                        case 3:
                            err_1 = _a.sent();
                            reject(err_1);
                            return [3 , 4];
                        case 4: return [3 , 6];
                        case 5:
                            items = Promise.all(batch.map(fromEntry));
                            entries.push(items);
                            readEntries();
                            _a.label = 6;
                        case 6: return [2 ];
                    }
                });
            }); }, function (err) {
                reject(err);
            });
        }
        readEntries();
    });
}
function fromFileEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 , new Promise(function (resolve, reject) {
                    entry.file(function (file) {
                        var fwp = toFileWithPath(file, entry.fullPath);
                        resolve(fwp);
                    }, function (err) {
                        reject(err);
                    });
                })];
        });
    });
}

var _default = function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = (file.type || '').toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();
      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith('/*')) {
        return baseMimeType === validType.replace(/\/.*$/, '');
      }
      return mimeType === validType;
    });
  }
  return true;
};

function _toConsumableArray$1(arr) { return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1(); }
function _nonIterableSpread$1() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray$1(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles$1(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$1(arr); }
function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1(); }
function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }
function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit$1(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }
var FILE_INVALID_TYPE = "file-invalid-type";
var FILE_TOO_LARGE = "file-too-large";
var FILE_TOO_SMALL = "file-too-small";
var TOO_MANY_FILES = "too-many-files";
var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: "Too many files"
};
function fileAccepted(file, accept) {
  var isAcceptable = file.type === "application/x-moz-file" || _default(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }
  return [true, null];
}
function isDefined(value) {
  return value !== undefined && value !== null;
}
function allFilesAccepted(_ref) {
  var files = _ref.files,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      multiple = _ref.multiple,
      maxFiles = _ref.maxFiles,
      validator = _ref.validator;
  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }
  return files.every(function (file) {
    var _fileAccepted = fileAccepted(file, accept),
        _fileAccepted2 = _slicedToArray$1(_fileAccepted, 1),
        accepted = _fileAccepted2[0];
    var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
        _fileMatchSize2 = _slicedToArray$1(_fileMatchSize, 1),
        sizeMatch = _fileMatchSize2[0];
    var customErrors = validator ? validator(file) : null;
    return accepted && sizeMatch && !customErrors;
  });
}
function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === "function") {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== "undefined") {
    return event.cancelBubble;
  }
  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  }
  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === "Files" || type === "application/x-moz-file";
  });
}
function onDocumentDragOver(event) {
  event.preventDefault();
}
function isIe(userAgent) {
  return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function isEdge(userAgent) {
  return userAgent.indexOf("Edge/") !== -1;
}
function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }
      return isPropagationStopped(event);
    });
  };
}
function canUseFileSystemAccessAPI() {
  return "showOpenFilePicker" in window;
}
function pickerOptionsFromAccept(accept) {
  if (isDefined(accept)) {
    var acceptForPicker = Object.entries(accept).filter(function (_ref2) {
      var _ref3 = _slicedToArray$1(_ref2, 2),
          mimeType = _ref3[0],
          ext = _ref3[1];
      var ok = true;
      if (!isMIMEType(mimeType)) {
        console.warn("Skipped \"".concat(mimeType, "\" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types."));
        ok = false;
      }
      if (!Array.isArray(ext) || !ext.every(isExt)) {
        console.warn("Skipped \"".concat(mimeType, "\" because an invalid file extension was provided."));
        ok = false;
      }
      return ok;
    }).reduce(function (agg, _ref4) {
      var _ref5 = _slicedToArray$1(_ref4, 2),
          mimeType = _ref5[0],
          ext = _ref5[1];
      return _objectSpread$1(_objectSpread$1({}, agg), {}, _defineProperty$1({}, mimeType, ext));
    }, {});
    return [{
      accept: acceptForPicker
    }];
  }
  return accept;
}
function acceptPropAsAcceptAttr(accept) {
  if (isDefined(accept)) {
    return Object.entries(accept).reduce(function (a, _ref6) {
      var _ref7 = _slicedToArray$1(_ref6, 2),
          mimeType = _ref7[0],
          ext = _ref7[1];
      return [].concat(_toConsumableArray$1(a), [mimeType], _toConsumableArray$1(ext));
    }, [])
    .filter(function (v) {
      return isMIMEType(v) || isExt(v);
    }).join(",");
  }
  return undefined;
}
function isAbort(v) {
  return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
function isSecurityError(v) {
  return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
function isMIMEType(v) {
  return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || /\w+\/[-+.\w]+/g.test(v);
}
function isExt(v) {
  return /^.*\.[\w]+$/.test(v);
}

var _excluded = ["children"],
    _excluded2 = ["open"],
    _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"],
    _excluded4 = ["refKey", "onChange", "onClick"];
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Dropzone = forwardRef(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties(_ref, _excluded);
  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties(_useDropzone, _excluded2);
  useImperativeHandle(ref, function () {
    return {
      open: open
    };
  }, [open]);
  return React__default.createElement(Fragment, null, children(_objectSpread(_objectSpread({}, props), {}, {
    open: open
  })));
});
Dropzone.displayName = "Dropzone";
var defaultProps = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null,
  useFsAccessApi: true,
  autoFocus: false
};
Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = {
  children: PropTypes$1.func,
  accept: PropTypes$1.objectOf(PropTypes$1.arrayOf(PropTypes$1.string)),
  multiple: PropTypes$1.bool,
  preventDropOnDocument: PropTypes$1.bool,
  noClick: PropTypes$1.bool,
  noKeyboard: PropTypes$1.bool,
  noDrag: PropTypes$1.bool,
  noDragEventsBubbling: PropTypes$1.bool,
  minSize: PropTypes$1.number,
  maxSize: PropTypes$1.number,
  maxFiles: PropTypes$1.number,
  disabled: PropTypes$1.bool,
  getFilesFromEvent: PropTypes$1.func,
  onFileDialogCancel: PropTypes$1.func,
  onFileDialogOpen: PropTypes$1.func,
  useFsAccessApi: PropTypes$1.bool,
  autoFocus: PropTypes$1.bool,
  onDragEnter: PropTypes$1.func,
  onDragLeave: PropTypes$1.func,
  onDragOver: PropTypes$1.func,
  onDrop: PropTypes$1.func,
  onDropAccepted: PropTypes$1.func,
  onDropRejected: PropTypes$1.func,
  onError: PropTypes$1.func,
  validator: PropTypes$1.func
};
var initialState$1 = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  acceptedFiles: [],
  fileRejections: []
};
function useDropzone() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
      accept = _defaultProps$props.accept,
      disabled = _defaultProps$props.disabled,
      getFilesFromEvent = _defaultProps$props.getFilesFromEvent,
      maxSize = _defaultProps$props.maxSize,
      minSize = _defaultProps$props.minSize,
      multiple = _defaultProps$props.multiple,
      maxFiles = _defaultProps$props.maxFiles,
      onDragEnter = _defaultProps$props.onDragEnter,
      onDragLeave = _defaultProps$props.onDragLeave,
      onDragOver = _defaultProps$props.onDragOver,
      onDrop = _defaultProps$props.onDrop,
      onDropAccepted = _defaultProps$props.onDropAccepted,
      onDropRejected = _defaultProps$props.onDropRejected,
      onFileDialogCancel = _defaultProps$props.onFileDialogCancel,
      onFileDialogOpen = _defaultProps$props.onFileDialogOpen,
      useFsAccessApi = _defaultProps$props.useFsAccessApi,
      autoFocus = _defaultProps$props.autoFocus,
      preventDropOnDocument = _defaultProps$props.preventDropOnDocument,
      noClick = _defaultProps$props.noClick,
      noKeyboard = _defaultProps$props.noKeyboard,
      noDrag = _defaultProps$props.noDrag,
      noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling,
      onError = _defaultProps$props.onError,
      validator = _defaultProps$props.validator;
  var acceptAttr = useMemo(function () {
    return acceptPropAsAcceptAttr(accept);
  }, [accept]);
  var pickerTypes = useMemo(function () {
    return pickerOptionsFromAccept(accept);
  }, [accept]);
  var onFileDialogOpenCb = useMemo(function () {
    return typeof onFileDialogOpen === "function" ? onFileDialogOpen : noop;
  }, [onFileDialogOpen]);
  var onFileDialogCancelCb = useMemo(function () {
    return typeof onFileDialogCancel === "function" ? onFileDialogCancel : noop;
  }, [onFileDialogCancel]);
  var rootRef = useRef(null);
  var inputRef = useRef(null);
  var _useReducer = useReducer(reducer, initialState$1),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];
  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive;
  var fsAccessApiWorksRef = useRef(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && canUseFileSystemAccessAPI());
  var onWindowFocus = function onWindowFocus() {
    if (!fsAccessApiWorksRef.current && isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;
          if (!files.length) {
            dispatch({
              type: "closeDialog"
            });
            onFileDialogCancelCb();
          }
        }
      }, 300);
    }
  };
  useEffect(function () {
    window.addEventListener("focus", onWindowFocus, false);
    return function () {
      window.removeEventListener("focus", onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancelCb, fsAccessApiWorksRef]);
  var dragTargetsRef = useRef([]);
  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      return;
    }
    event.preventDefault();
    dragTargetsRef.current = [];
  };
  useEffect(function () {
    if (preventDropOnDocument) {
      document.addEventListener("dragover", onDocumentDragOver, false);
      document.addEventListener("drop", onDocumentDrop, false);
    }
    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener("dragover", onDocumentDragOver);
        document.removeEventListener("drop", onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]);
  useEffect(function () {
    if (!disabled && autoFocus && rootRef.current) {
      rootRef.current.focus();
    }
    return function () {};
  }, [rootRef, autoFocus, disabled]);
  var onErrCb = useCallback(function (e) {
    if (onError) {
      onError(e);
    } else {
      console.error(e);
    }
  }, [onError]);
  var onDragEnterCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [event.target]);
    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }
        var fileCount = files.length;
        var isDragAccept = fileCount > 0 && allFilesAccepted({
          files: files,
          accept: acceptAttr,
          minSize: minSize,
          maxSize: maxSize,
          multiple: multiple,
          maxFiles: maxFiles,
          validator: validator
        });
        var isDragReject = fileCount > 0 && !isDragAccept;
        dispatch({
          isDragAccept: isDragAccept,
          isDragReject: isDragReject,
          isDragActive: true,
          type: "setDraggedFiles"
        });
        if (onDragEnter) {
          onDragEnter(event);
        }
      }).catch(function (e) {
        return onErrCb(e);
      });
    }
  }, [getFilesFromEvent, onDragEnter, onErrCb, noDragEventsBubbling, acceptAttr, minSize, maxSize, multiple, maxFiles, validator]);
  var onDragOverCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = isEvtWithFiles(event);
    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = "copy";
      } catch (_unused) {}
    }
    if (hasFiles && onDragOver) {
      onDragOver(event);
    }
    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var targets = dragTargetsRef.current.filter(function (target) {
      return rootRef.current && rootRef.current.contains(target);
    });
    var targetIdx = targets.indexOf(event.target);
    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }
    dragTargetsRef.current = targets;
    if (targets.length > 0) {
      return;
    }
    dispatch({
      type: "setDraggedFiles",
      isDragActive: false,
      isDragAccept: false,
      isDragReject: false
    });
    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var setFiles = useCallback(function (files, event) {
    var acceptedFiles = [];
    var fileRejections = [];
    files.forEach(function (file) {
      var _fileAccepted = fileAccepted(file, acceptAttr),
          _fileAccepted2 = _slicedToArray(_fileAccepted, 2),
          accepted = _fileAccepted2[0],
          acceptError = _fileAccepted2[1];
      var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
          _fileMatchSize2 = _slicedToArray(_fileMatchSize, 2),
          sizeMatch = _fileMatchSize2[0],
          sizeError = _fileMatchSize2[1];
      var customErrors = validator ? validator(file) : null;
      if (accepted && sizeMatch && !customErrors) {
        acceptedFiles.push(file);
      } else {
        var errors = [acceptError, sizeError];
        if (customErrors) {
          errors = errors.concat(customErrors);
        }
        fileRejections.push({
          file: file,
          errors: errors.filter(function (e) {
            return e;
          })
        });
      }
    });
    if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
      acceptedFiles.forEach(function (file) {
        fileRejections.push({
          file: file,
          errors: [TOO_MANY_FILES_REJECTION]
        });
      });
      acceptedFiles.splice(0);
    }
    dispatch({
      acceptedFiles: acceptedFiles,
      fileRejections: fileRejections,
      type: "setFiles"
    });
    if (onDrop) {
      onDrop(acceptedFiles, fileRejections, event);
    }
    if (fileRejections.length > 0 && onDropRejected) {
      onDropRejected(fileRejections, event);
    }
    if (acceptedFiles.length > 0 && onDropAccepted) {
      onDropAccepted(acceptedFiles, event);
    }
  }, [dispatch, multiple, acceptAttr, minSize, maxSize, maxFiles, onDrop, onDropAccepted, onDropRejected, validator]);
  var onDropCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];
    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }
        setFiles(files, event);
      }).catch(function (e) {
        return onErrCb(e);
      });
    }
    dispatch({
      type: "reset"
    });
  }, [getFilesFromEvent, setFiles, onErrCb, noDragEventsBubbling]);
  var openFileDialog = useCallback(function () {
    if (fsAccessApiWorksRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb();
      var opts = {
        multiple: multiple,
        types: pickerTypes
      };
      window.showOpenFilePicker(opts).then(function (handles) {
        return getFilesFromEvent(handles);
      }).then(function (files) {
        setFiles(files, null);
        dispatch({
          type: "closeDialog"
        });
      }).catch(function (e) {
        if (isAbort(e)) {
          onFileDialogCancelCb(e);
          dispatch({
            type: "closeDialog"
          });
        } else if (isSecurityError(e)) {
          fsAccessApiWorksRef.current = false;
          if (inputRef.current) {
            inputRef.current.value = null;
            inputRef.current.click();
          } else {
            onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
          }
        } else {
          onErrCb(e);
        }
      });
      return;
    }
    if (inputRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb();
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch, onFileDialogOpenCb, onFileDialogCancelCb, useFsAccessApi, setFiles, onErrCb, pickerTypes, multiple]);
  var onKeyDownCb = useCallback(function (event) {
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }
    if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, openFileDialog]);
  var onFocusCb = useCallback(function () {
    dispatch({
      type: "focus"
    });
  }, []);
  var onBlurCb = useCallback(function () {
    dispatch({
      type: "blur"
    });
  }, []);
  var onClickCb = useCallback(function () {
    if (noClick) {
      return;
    }
    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [noClick, openFileDialog]);
  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };
  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };
  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };
  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };
  var getRootProps = useMemo(function () {
    return function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey,
          role = _ref2.role,
          onKeyDown = _ref2.onKeyDown,
          onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          onClick = _ref2.onClick,
          onDragEnter = _ref2.onDragEnter,
          onDragOver = _ref2.onDragOver,
          onDragLeave = _ref2.onDragLeave,
          onDrop = _ref2.onDrop,
          rest = _objectWithoutProperties(_ref2, _excluded3);
      return _objectSpread(_objectSpread(_defineProperty({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb)),
        role: typeof role === "string" && role !== "" ? role : "presentation"
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = useCallback(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = useMemo(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey,
          onChange = _ref3.onChange,
          onClick = _ref3.onClick,
          rest = _objectWithoutProperties(_ref3, _excluded4);
      var inputProps = _defineProperty({
        accept: acceptAttr,
        multiple: multiple,
        type: "file",
        style: {
          display: "none"
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        tabIndex: -1
      }, refKey, inputRef);
      return _objectSpread(_objectSpread({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  return _objectSpread(_objectSpread({}, state), {}, {
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}
function reducer(state, action) {
  switch (action.type) {
    case "focus":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: true
      });
    case "blur":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: false
      });
    case "openDialog":
      return _objectSpread(_objectSpread({}, initialState$1), {}, {
        isFileDialogActive: true
      });
    case "closeDialog":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFileDialogActive: false
      });
    case "setDraggedFiles":
      return _objectSpread(_objectSpread({}, state), {}, {
        isDragActive: action.isDragActive,
        isDragAccept: action.isDragAccept,
        isDragReject: action.isDragReject
      });
    case "setFiles":
      return _objectSpread(_objectSpread({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections
      });
    case "reset":
      return _objectSpread({}, initialState$1);
    default:
      return state;
  }
}
function noop() {}

var File = React$4.forwardRef(function (props, ref) {
  var _props$file;
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var dropzone = React$4.useRef();
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  var _React$useState3 = React$4.useState('100%'),
      _React$useState4 = _slicedToArray$5(_React$useState3, 2),
      height = _React$useState4[0],
      setHeight = _React$useState4[1];
  var _useDropzone = useDropzone({
    onDrop: props.onDrop
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps;
  function change() {
    setHover(true);
  }
  function reset() {
    setHover(false);
  }
  React$4.useEffect(function () {
    if (dropzone.current !== undefined && dropzone.current !== null) {
      dropzone.current.addEventListener('dragover', change, false);
      dropzone.current.addEventListener('dragleave', reset, false);
    }
    return function () {
      if (dropzone.current !== undefined && dropzone.current !== null) {
        dropzone.current.removeEventListener('dragover', change, false);
        dropzone.current.removeEventListener('dragleave', reset, false);
      }
    };
  }, [dropzone]);
  var getHeight = function getHeight() {
    if (dropzone.current !== undefined && dropzone.current !== null && dropzone.current.clientHeight !== null) {
      setHeight(dropzone.current.clientHeight);
    }
  };
  React$4.useEffect(function () {
    getHeight();
  }, [height]);
  React$4.useEffect(function () {
    window.addEventListener('resize', getHeight);
    return function () {
      window.addEventListener('resize', getHeight);
    };
  }, []);
  return React$4.createElement("div", {
    style: {
      height: '100%',
      width: '100%',
      position: 'relative'
    }
  }, props.label && React$4.createElement("div", {
    style: {
      height: 'auto',
      marginBottom: 10
    }
  }, React$4.createElement("label", {
    className: "DisableSelection",
    htmlFor: props.id,
    style: {
      color: Colors.GREY,
      fontSize: '1em',
      width: '100%',
      position: 'relative',
      height: props.label || !props.required ? 20 : 0,
      display: 'inline-block'
    }
  }, props.label && props.label, !props.required && !props.disabled && React$4.createElement("span", {
    style: {
      fontSize: '0.8em',
      position: 'absolute',
      marginTop: 2,
      paddingLeft: 6,
      color: Colors.DARK_GREY,
      whiteSpace: 'nowrap',
      width: 'auto',
      fontWeight: 300
    }
  }, "- ".concat(_('optional', {
    ns: 'ui'
  }))))), React$4.createElement("div", {
    style: {
      position: 'relative',
      height: '100%',
      width: '100%'
    }
  }, React$4.createElement("div", {
    className: "Hover DisableSelection",
    style: {
      height: '100%',
      minHeight: 150,
      width: 'auto',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: props.file || hover ? Colors.MEDIUM_WHITE : Colors.LIGHT_GREY,
      padding: 10,
      borderRadius: 10
    }
  }, props.loading ? React$4.createElement(Loaders, null) : React$4.createElement(React$4.Fragment, null, React$4.createElement(Icon, {
    name: "Upload",
    height: 50,
    width: 50,
    color: props.file || hover ? Colors.DARK_GREY : Colors.MEDIUM_GREY,
    iconSet: "Feather"
  }), React$4.createElement("div", {
    style: {
      marginTop: 15
    }
  }, React$4.createElement(Text, {
    color: props.file || hover ? Colors.DARK_GREY : Colors.MEDIUM_GREY,
    textAlign: "center"
  }, (_props$file = props.file) !== null && _props$file !== void 0 ? _props$file : _('dragDropFiles', {
    ns: 'ui'
  }))))), React$4.createElement("div", _extends$d({}, getRootProps(), {
    ref: dropzone,
    "aria-label": props.ariaLabel,
    className: "Hover DisableSelection",
    style: {
      height: '100%',
      width: '100%',
      border: "dashed 2px ".concat(props.file || hover ? Colors.DARK_GREY : Colors.MEDIUM_WHITE),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'absolute',
      top: 0,
      borderRadius: 10
    },
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    }
  }), React$4.createElement("input", _extends$d({}, getInputProps(), {
    ref: ref,
    id: props.id,
    name: props.name,
    accept: props.accept,
    required: props.required,
    className: "Hover",
    style: {
      opacity: 0,
      minHeight: height !== null && height !== void 0 ? height : '100%',
      width: '100%'
    }
  })))));
});

var Time = React$4.forwardRef(function (props, ref) {
  var _props$height, _props$width;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      isFocused = _React$useState2[0],
      setFocused = _React$useState2[1];
  return React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      height: 'auto'
    }
  }, React$4.createElement("div", {
    style: {
      width: '100%',
      height: 'auto'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      height: 'auto'
    }
  }, React$4.createElement("input", {
    ref: ref,
    type: "time",
    name: props.name,
    value: props.value,
    min: props.min,
    max: props.max,
    step: props.step,
    disabled: props.disabled,
    onChange: props.onChange,
    onFocus: function onFocus() {
      if (props.onFocus !== undefined) props.onFocus();
      setFocused(true);
    },
    onBlur: function onBlur() {
      if (props.onBlur !== undefined) props.onBlur();
      setFocused(false);
    },
    className: props.disabled ? 'Disabled' : 'HoverText',
    style: {
      height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 50,
      width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : '100%',
      backgroundColor: props.disabled ? Colors.LIGHT_GREY : Colors.WHITE,
      borderTopRightRadius: 5,
      borderTopLeftRadius: 5,
      borderBottomRightRadius: 5,
      borderBottomLeftRadius: 5,
      borderTop: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(isFocused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderLeft: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(isFocused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderRight: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(isFocused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderBottom: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(isFocused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      outline: 'none',
      fontSize: '1.25em',
      fontFamily: 'Museo-Sans',
      fontWeight: 300,
      color: props.disabled ? Colors.MEDIUM_GREY : Colors.GREY,
      lineHeight: 1.1,
      whiteSpace: 'normal',
      padding: 10
    }
  }), props.suffix && React$4.createElement("div", {
    style: {
      height: 50,
      width: 'auto',
      minWidth: 52,
      paddingLeft: 7.5,
      paddingRight: 7.5,
      marginLeft: -5,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: Colors.LIGHT_GREY,
      borderTop: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderBottom: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderLeft: props.error ? "solid 2px ".concat(Colors.RED) : !props.styling ? 'solid 0px transparent' : "solid 2px ".concat(isFocused ? Colors.BLUE : Colors.MEDIUM_WHITE),
      borderRight: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderTopRightRadius: 10,
      borderBottomRightRadius: 10
    }
  }, props.suffix))));
});

var Copy = React$4.forwardRef(function (props, ref) {
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  var _React$useState3 = React$4.useState(false),
      _React$useState4 = _slicedToArray$5(_React$useState3, 2),
      clicked = _React$useState4[0],
      setClicked = _React$useState4[1];
  return React$4.createElement("div", {
    style: {
      width: '100%',
      height: 'auto',
      position: 'relative'
    },
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    }
  }, props.label && React$4.createElement("label", {
    className: "DisableSelection",
    htmlFor: props.id,
    style: {
      color: Colors.GREY,
      fontSize: '1em',
      width: '100%',
      position: 'relative',
      height: 20,
      display: 'inline-block'
    }
  }, props.label), React$4.createElement(AnimatePresence, null, hover && React$4.createElement(motion.div, {
    style: {
      position: 'absolute',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      top: props.label ? -5 : -27.5,
      width: '100%'
    },
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    }
  }, React$4.createElement("div", {
    style: {
      height: 'auto',
      width: 'auto',
      backgroundColor: Colors.GREY,
      paddingTop: 5,
      paddingBottom: 5,
      paddingLeft: 10,
      paddingRight: 10,
      borderRadius: 7
    }
  }, React$4.createElement(Text, {
    fontSize: "0.9em",
    color: Colors.WHITE,
    fontWeight: 100
  }, _(clicked ? 'copied' : 'copy', {
    ns: 'ui'
  }))))), React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      height: 'auto',
      position: 'relative'
    }
  }, React$4.createElement("div", {
    ref: ref,
    className: "HoverText",
    type: "button",
    onClick: function onClick() {
      navigator.clipboard.writeText(props.value);
      setClicked(true);
      setTimeout(function () {
        setHover(false);
        setClicked(false);
      }, 500);
    },
    style: {
      height: 50,
      width: '100%',
      marginTop: 5,
      backgroundColor: Colors.WHITE,
      fontSize: '1em',
      padding: 10,
      border: "".concat(hover ? 'dashed' : 'solid', " 2px ").concat(Colors.MEDIUM_WHITE),
      borderRadius: 7
    },
    "aria-label": "Copy"
  }, React$4.createElement(Text, null, props.value))));
});

function Search(props) {
  var _props$height, _props$height2, _props$borderRadius;
  var size = useDimensions();
  var height = props.size === 'medium' ? (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 40 : (_props$height2 = props.height) !== null && _props$height2 !== void 0 ? _props$height2 : 50;
  var onKeyUp = function onKeyUp(event) {
    switch (event.key) {
      case 'Enter':
        if (props.onEnter) props.onEnter();
        break;
      case 'Tab':
        if (props.onTab) props.onTab();
        break;
      default:
        if (props.onKeyUp) props.onKeyUp();
    }
  };
  return React$4.createElement("div", {
    style: {
      height: height,
      width: '100%',
      backgroundColor: Colors.WHITE,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      border: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderRadius: ((_props$borderRadius = props.borderRadius) !== null && _props$borderRadius !== void 0 ? _props$borderRadius : props.size === 'medium') ? 7 : 10,
      overflow: 'hidden'
    }
  }, React$4.createElement("input", {
    type: "text",
    id: props.id,
    name: props.name,
    placeholder: props.placeholder,
    required: props.required,
    value: props.value,
    onChange: props.onChange,
    onKeyUp: onKeyUp,
    disabled: props.disabled,
    autoComplete: props.autocomplete,
    "aria-label": props.ariaLabel,
    "aria-required": props.required,
    onFocus: function onFocus() {
      if (props.onFocus !== undefined) props.onFocus();
    },
    onBlur: function onBlur() {
      if (props.onBlur !== undefined) props.onBlur();
    },
    style: {
      height: '100%',
      width: '100%',
      border: 'solid 0px transparent',
      backgroundColor: 'transparent',
      paddingLeft: 10,
      paddingRight: 10,
      outline: 'none',
      fontSize: '1.1em',
      fontFamily: 'Museo-Sans',
      fontWeight: 300,
      color: props.disabled ? Colors.MEDIUM_GREY : Colors.GREY
    }
  }), size.width >= Breakpoint.fd && React$4.createElement("div", {
    style: {
      height: '100%',
      width: height,
      backgroundColor: Colors.WHITE,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, React$4.createElement(Icon, {
    name: "Search",
    height: 22,
    width: 22,
    color: Colors.MEDIUM_GREY,
    iconSet: "Feather"
  })));
}

var handleCountryDataFilter = function handleCountryDataFilter(event) {
  var phone = event.phone[0];
  if (event.region !== 'Europe') return false;
  if (phone.includes('-')) return false;
  if (phone === '+') return false;
  return true;
};

function handleCountryName(name) {
  if (name.includes(',')) {
    return name.split(', ')[0];
  }
  return name;
}

function Item$6(props) {
  var ref = React__default.useRef();
  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      isHover = _React$useState2[0],
      setHover = _React$useState2[1];
  useDataAttributes(ref, props.dataAttributes, {
    all: {
      functionality: true
    }
  });
  var isItemHighlighted = isHover || props.isHighlight.countryIso === props.countryIso;
  return React__default.createElement("button", {
    ref: ref,
    id: props.id,
    type: "button",
    style: {
      width: '100%',
      height: 50,
      padding: 8,
      border: 'none',
      cursor: 'pointer',
      backgroundColor: isItemHighlighted ? Colors.LIGHT_GREY : 'initial',
      borderTop: "solid ".concat(isItemHighlighted ? 2 : 0, "px ").concat(!props.isFirst && isItemHighlighted ? Colors.MEDIUM_WHITE : 'transparent'),
      borderBottom: "solid ".concat(isItemHighlighted ? 2 : 0, "px ").concat(!props.isLast && isItemHighlighted ? Colors.MEDIUM_WHITE : 'transparent')
    },
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    onClick: function onClick() {
      props.setSelected({
        countryIso: props.countryIso,
        countryCode: props.countryCode
      });
    }
  }, React__default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 8
    }
  }, props.selected.country === props.country && React__default.createElement(Icon, {
    iconSet: "FA",
    name: "Check",
    type: "light",
    color: Colors.DARK_GREY,
    height: 15,
    width: 15
  }), React__default.createElement(Text, {
    fontSize: "1rem",
    fontWeight: props.selected.country === props.country ? 500 : 300,
    color: isItemHighlighted ? Colors.GREY : Colors.DARK_GREY
  }, "".concat(props.country, " (").concat(props.countryCode, ")"))));
}

function Dropdown$1(props) {
  var size = useDimensions();
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var ref = React$4.useRef();
  var phoneRef = React$4.useRef();
  var _React$useState = React$4.useState('select'),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      selected = _React$useState2[0],
      _setSelected = _React$useState2[1];
  var _React$useState3 = React$4.useState(false),
      _React$useState4 = _slicedToArray$5(_React$useState3, 2),
      isHighlight = _React$useState4[0],
      setHighlight = _React$useState4[1];
  var _React$useState5 = React$4.useState(false),
      _React$useState6 = _slicedToArray$5(_React$useState5, 2),
      isEnterClick = _React$useState6[0],
      setEnterClick = _React$useState6[1];
  var _React$useState7 = React$4.useState('a'),
      _React$useState8 = _slicedToArray$5(_React$useState7, 2),
      itemInView = _React$useState8[0],
      setItemInView = _React$useState8[1];
  React$4.useEffect(function () {
    if (!props.value) return;
    _setSelected(props.value);
  }, [props.value]);
  useDidMountEffect(function () {
    props.onClose();
  }, [selected]);
  useDataAttributes(phoneRef, props.dataAttributes, {
    all: {
      id: props.id,
      outsideClickExemption: true,
      functionality: true
    }
  });
  useDataAttributes(ref, undefined, {
    single: {
      id: props.id
    }
  }, props.isVisible);
  useOutsideClick(ref, function () {
    props.onClose();
  });
  React$4.useEffect(function () {
    if (props.isVisible) {
      var keyDownHandler = function keyDownHandler(event) {
        var data = countryData.filter(handleCountryDataFilter);
        var keyFilter = function keyFilter(key) {
          return data.filter(function (object) {
            return object.iso['alpha-3'].toLowerCase().startsWith(key);
          });
        };
        var element = function element(object) {
          return document.getElementById("".concat(props.id, "_").concat(object.iso['alpha-3'].toLowerCase()));
        };
        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
          var currentItem = data.find(function (object) {
            return object.iso['alpha-3'].toLowerCase().startsWith(itemInView);
          });
          var currentIndex = data.indexOf(currentItem);
          var nextItem = event.key === 'ArrowUp' ? data[currentIndex - 1] : data[currentIndex + 1];
          if (element !== undefined && nextItem !== undefined) {
            setItemInView(nextItem.iso['alpha-3'].toLowerCase());
            element(nextItem).scrollIntoView({
              block: 'nearest',
              inline: 'nearest'
            });
            setHighlight({
              countryIso: handleCountryName(nextItem.iso['alpha-3']),
              countryCode: nextItem.phone
            });
          }
        } else if (keyFilter(event.key)[0] !== undefined) {
          setItemInView(keyFilter(event.key)[0].iso['alpha-3'].toLowerCase());
          element(keyFilter(event.key)[0]).scrollIntoView({
            block: 'nearest',
            inline: 'nearest'
          });
          setHighlight({
            countryIso: handleCountryName(keyFilter(event.key)[0].iso['alpha-3']),
            countryCode: keyFilter(event.key)[0].phone
          });
        }
        if (event.key === 'Enter') {
          _setSelected({
            countryIso: isHighlight.countryIso,
            countryCode: isHighlight.countryCode
          });
          setEnterClick(true);
          props.onChange({
            countryIso: isHighlight.countryIso,
            countryCode: isHighlight.countryCode
          });
          props.onClose();
        }
        return null;
      };
      window.addEventListener('keydown', keyDownHandler);
      return function () {
        window.removeEventListener('keydown', keyDownHandler);
      };
    }
    return null;
  }, [props.isVisible, itemInView, isHighlight]);
  return React$4.createElement(React$4.Fragment, null, React$4.createElement("button", {
    ref: phoneRef,
    type: "button",
    id: "phoneInput",
    style: {
      width: '25%',
      height: 50,
      backgroundColor: props.isVisible ? Colors.LIGHT_GREY : Colors.WHITE,
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      border: props.error ? "solid 2px ".concat(Colors.RED) : "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderTopLeftRadius: 5,
      borderBottomLeftRadius: 5,
      paddingLeft: 8,
      paddingRight: 8,
      position: 'relative'
    },
    onClick: function onClick() {
      if (!isEnterClick) {
        props.onClick();
      }
      setEnterClick(false);
    }
  }, React$4.createElement(Text, {
    color: Colors.DARK_GREY
  }, selected === 'select' || !selected ? _('select', {
    ns: 'ui'
  }) : size.width < Breakpoint.md ? "(".concat(selected.countryCode, ")") : "".concat(_(selected.countryIso, {
    ns: 'country'
  }), " (").concat(selected.countryCode, ")")), React$4.createElement(Icon, {
    iconSet: "Feather",
    name: props.isVisible ? 'ChevronUp' : 'ChevronDown',
    type: "solid",
    height: 25,
    width: 25,
    color: Colors.DARK_GREY
  })), props.isVisible && React$4.createElement("div", {
    ref: ref,
    style: {
      position: 'absolute',
      top: props.isLabelVisible ? 80 : 55,
      zIndex: 1,
      width: size.width < Breakpoint.sm ? '100%' : '50%',
      backgroundColor: Colors.WHITE,
      border: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderRadius: 7.5,
      overflow: 'hidden',
      height: props.max ? "calc(".concat(props.max, "*50px)") : '200px'
    }
  }, React$4.createElement("div", {
    style: {
      position: 'relative',
      height: '100%',
      overflowY: 'scroll',
      overflowX: 'hidden'
    }
  }, countryData.filter(handleCountryDataFilter).map(function (item, index) {
    return React$4.createElement(Item$6, {
      key: item.name,
      id: "".concat(props.id, "_").concat(item.iso['alpha-3'].toLowerCase()),
      country: _(item.iso['alpha-3'], {
        ns: 'country'
      }),
      countryIso: item.iso['alpha-3'],
      countryCode: item.phone[0],
      selected: selected,
      setSelected: function setSelected(event) {
        _setSelected(event);
        props.onChange(event);
      },
      isHighlight: isHighlight,
      isFirst: index === 0,
      isLast: index + 1 === countryData.filter(handleCountryDataFilter).length
    });
  }))));
}

function Input$1(props) {
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var handleInputChange = function handleInputChange(e) {
    var regex = /[^-\s][0-9]{8,11}$/;
    var inputValue = '';
    inputValue = e.value.split(' ').join('');
    var result = inputValue;
    if (inputValue.match(regex)) {
      result = inputValue;
    }
    return result;
  };
  var onKeyUp = function onKeyUp(event) {
    switch (event.key) {
      case 'Enter':
        if (props.onEnter) props.onEnter();
        break;
      case 'Tab':
        if (props.onTab) props.onTab();
        break;
      default:
        if (props.onKeyUp) props.onKeyUp();
    }
  };
  return React$4.createElement("input", {
    ref: props.ref,
    className: props.disabled ? 'Disabled' : ''
    ,
    onWheel: function onWheel() {
      return document.activeElement.blur();
    },
    value: props.value,
    onChange: function onChange(e) {
      return props.onChange(handleInputChange(e.target));
    },
    onKeyUp: onKeyUp,
    disabled: props.disabled,
    autoComplete: props.autocomplete,
    readOnly: props.readonly,
    "aria-label": props.ariaLabel,
    "aria-required": props.required,
    id: props.id,
    name: props.name,
    placeholder: props.placeholder ? props.placeholder : "".concat(_('forExample', {
      ns: 'ui'
    }), ": 6 12345678"),
    required: props.required
    ,
    autoFocus: props.autofocus,
    style: {
      height: 50,
      width: '75%',
      backgroundColor: Colors.WHITE,
      borderTopRightRadius: 5,
      borderBottomRightRadius: 5,
      borderBottom: props.error ? "solid 2px ".concat(Colors.RED) : "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderTop: props.error ? "solid 2px ".concat(Colors.RED) : "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderRight: props.error ? "solid 2px ".concat(Colors.RED) : "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderLeft: 'none',
      outline: 'none',
      fontSize: '1.25em',
      fontFamily: 'Museo-Sans',
      fontWeight: 300,
      color: props.disabled ? Colors.MEDIUM_GREY : Colors.GREY,
      padding: 10,
      cursor: 'text'
    }
  });
}

function Label$1(props) {
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  return props.isVisible && React$4.createElement("label", {
    className: "DisableSelection",
    htmlFor: props.id,
    style: {
      color: Colors.GREY,
      fontSize: '1em',
      width: '100%',
      position: 'relative',
      height: 20,
      display: 'inline-block',
      marginBottom: 5
    }
  }, props.text, !props.isRequired && !props.isDisabled && React$4.createElement("span", {
    style: {
      fontSize: '0.8em',
      position: 'absolute',
      marginTop: 2,
      paddingLeft: 6,
      color: Colors.DARK_GREY,
      whiteSpace: 'nowrap',
      width: 'auto',
      fontWeight: 300
    }
  }, "- ".concat(_('optional', {
    ns: 'ui'
  }))));
}

function Phone(props) {
  var _props$label, _props$label2;
  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      isDropdownVisible = _React$useState2[0],
      setDropdownVisible = _React$useState2[1];
  var _React$useState3 = React__default.useState(null),
      _React$useState4 = _slicedToArray$5(_React$useState3, 2),
      prefix = _React$useState4[0],
      setPrefix = _React$useState4[1];
  var _React$useState5 = React__default.useState(''),
      _React$useState6 = _slicedToArray$5(_React$useState5, 2),
      number = _React$useState6[0],
      setPhoneNumber = _React$useState6[1];
  useDidMountEffect(function () {
    if (props.onChange) {
      if (prefix && number && number !== '') {
        props.onChange("".concat(prefix.countryCode).concat(number));
      } else props.onChange(null);
    }
  }, [prefix, number]);
  React__default.useEffect(function () {
    if (!props.value) return;
    countryData.filter(handleCountryDataFilter).forEach(function (country) {
      country.phone.forEach(function (prefixFromData) {
        if (props.value.startsWith(prefixFromData)) {
          setPrefix({
            countryIso: country.iso['alpha-3'],
            countryCode: prefixFromData
          });
          setPhoneNumber(props.value.substr(prefixFromData.length, props.value.length));
        }
      });
    });
  }, [props.value]);
  return React__default.createElement("div", {
    style: {
      position: 'relative',
      width: '100%'
    }
  }, React__default.createElement(Label$1, {
    id: props.id,
    isVisible: (_props$label = props.label) !== null && _props$label !== void 0 ? _props$label : false,
    text: props.label,
    isRequired: props.isRequired,
    isDisabled: props.isDisabled
  }), React__default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    }
  }, React__default.createElement(Dropdown$1, {
    id: props.id,
    max: props.maxDropdown,
    isVisible: isDropdownVisible,
    isLabelVisible: (_props$label2 = props.label) !== null && _props$label2 !== void 0 ? _props$label2 : false,
    onClick: function onClick() {
      return setDropdownVisible(!isDropdownVisible);
    },
    onClose: function onClose() {
      return setDropdownVisible(false);
    },
    onChange: setPrefix,
    value: prefix,
    error: props.error
  }), React__default.createElement(Input$1, {
    value: number,
    onChange: setPhoneNumber,
    autofocus: props.autofocus,
    error: props.error
  })), props.error && React__default.createElement("div", {
    style: {
      marginTop: 5
    }
  }, React__default.createElement(Text, {
    fontSize: "1em",
    color: Colors.RED
  }, props.error)));
}

function Label(props) {
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  return props.isVisible ? React$4.createElement("label", {
    className: "DisableSelection",
    htmlFor: props.id,
    style: {
      color: Colors.GREY,
      fontSize: '1em',
      width: '100%',
      position: 'relative',
      height: props.text || !props.isRequired ? 20 : 0,
      display: 'inline-block',
      marginBottom: 5
    }
  }, props.text && props.text, !props.isRequired && !props.isDisabled && React$4.createElement("span", {
    style: {
      fontSize: '0.8em',
      position: 'absolute',
      marginTop: 2,
      paddingLeft: 6,
      color: Colors.DARK_GREY,
      whiteSpace: 'nowrap',
      width: 'auto',
      fontWeight: 300
    }
  }, "- ".concat(_('optional', {
    ns: 'ui'
  })))) : null;
}

var Button$2 = React$4.forwardRef(function (props, ref) {
  var _props$height, _props$width, _props$icon$color, _props$fontSize, _props$fontWeight;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      isHover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("button", {
    ref: ref,
    type: "button",
    className: "Hover",
    onClick: function onClick() {
      if (!props.isEnterClick) {
        props.onClick();
      }
      props.setEnterClick(false);
    },
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    "aria-label": props.ariaLabel,
    style: {
      height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 50,
      width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : '100%',
      minWidth: 50,
      maxWidth: props.maxWidth,
      backgroundColor: isHover ? Colors.LIGHT_GREY : Colors.WHITE,
      border: "solid 2px ".concat(props.isInError ? Colors.RED : Colors.MEDIUM_WHITE),
      borderRadius: 7,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontSize: '1em',
      marginBottom: 0,
      paddingRight: 5
    }
  }, props.icon && React$4.createElement("div", {
    style: {
      width: 35,
      height: 35,
      maxWidth: 35,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, props.icon && React$4.createElement(Icon, {
    name: props.icon.name,
    height: props.icon.height,
    width: props.icon.width,
    color: (_props$icon$color = props.icon.color) !== null && _props$icon$color !== void 0 ? _props$icon$color : Colors.GREY,
    iconSet: props.icon.iconSet
  })), React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'left'
    }
  }, props.text && React$4.createElement("div", {
    style: {
      paddingLeft: props.icon ? 0 : 10,
      paddingRight: props.paddingRight || 5
    }
  }, React$4.createElement(Text, {
    color: Colors.GREY,
    fontSize: (_props$fontSize = props.fontSize) !== null && _props$fontSize !== void 0 ? _props$fontSize : '1.2em',
    fontWeight: (_props$fontWeight = props.fontWeight) !== null && _props$fontWeight !== void 0 ? _props$fontWeight : 300
  }, props.text)), props.subText && React$4.createElement("div", {
    style: {
      paddingLeft: props.icon ? 0 : 10,
      paddingRight: props.paddingRight || 5
    }
  }, React$4.createElement(Text, {
    color: Colors.DARK_GREY,
    fontSize: "1.1em"
  }, props.subText))), React$4.createElement("div", {
    style: {
      width: 30,
      height: 30,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      transform: "rotate(".concat(props.isOpen ? 180 : 0, "deg)")
    }
  }, React$4.createElement(Icon, {
    name: "AngleDown",
    height: 25,
    width: 25,
    color: Colors.GREY
  })));
});

function DropdownItem(props) {
  var _props$onClick, _props$icon$iconSet, _props$color, _props$color2, _props$color3;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      isHover = _React$useState2[0],
      setHover = _React$useState2[1];
  var isItemHighlighted = isHover || props.isHighlight && props.isHighlight.text === props.title;
  return React$4.createElement("button", {
    type: "button",
    className: "Hover DisableSelection",
    id: props.id,
    onClick: props.disabled ? null : props.onClick,
    onMouseEnter: function onMouseEnter() {
      return props.disabled ? null : setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return props.disabled ? null : setHover(false);
    },
    tabIndex: -1,
    style: {
      height: 50,
      width: '100%',
      backgroundColor: isItemHighlighted ? Colors.LIGHT_GREY : 'transparent',
      border: 'none',
      borderTop: "solid ".concat(isItemHighlighted ? 2 : 0, "px ").concat(!props.isFirst && isItemHighlighted ? Colors.MEDIUM_WHITE : 'transparent'),
      borderBottom: "solid ".concat(isItemHighlighted ? 2 : 0, "px ").concat(!props.isLast && isItemHighlighted ? Colors.MEDIUM_WHITE : 'transparent'),
      fontSize: '1em',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'left',
      alignItems: 'center',
      padding: 10,
      position: 'relative'
    }
  }, (props.type === 'radio' || props.type === 'checkbox') && React$4.createElement("span", {
    style: {
      marginTop: -0.7
    }
  }, React$4.createElement(Inputs, {
    type: props.type,
    selected: props.selected,
    onClick: (_props$onClick = props.onClick) !== null && _props$onClick !== void 0 ? _props$onClick : null,
    disabled: props.disabled
  })), props.icon && React$4.createElement("span", {
    style: {
      marginTop: 2,
      paddingRight: 7
    }
  }, React$4.createElement(Icon, {
    name: props.icon.name,
    height: props.icon.height,
    width: props.icon.width,
    color: props.disabled ? Colors.MEDIUM_GREY : Colors.GREY,
    iconSet: (_props$icon$iconSet = props.icon.iconSet) !== null && _props$icon$iconSet !== void 0 ? _props$icon$iconSet : 'FA'
  })), React$4.createElement(Text, {
    fontSize: "1rem",
    fontWeight: 300,
    color: isItemHighlighted ? (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY : props.disabled ? Colors.MEDIUM_GREY : (_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : Colors.DARK_GREY
  }, props.title), React$4.createElement(AnimatePresence, null, isItemHighlighted && React$4.createElement(motion.div, {
    style: {
      position: 'absolute',
      paddingTop: 3
    },
    initial: {
      right: 35,
      opacity: 0
    },
    animate: {
      right: 15,
      opacity: 1
    },
    exit: {
      right: 35,
      opacity: 0
    },
    transition: {
      duration: 0.2
    }
  }, React$4.createElement(Icon, {
    name: "ArrowRight",
    width: 15,
    height: 15,
    color: (_props$color3 = props.color) !== null && _props$color3 !== void 0 ? _props$color3 : Colors.GREY
  }))));
}

var Menu = React$4.forwardRef(function (props, ref) {
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      isHighlight = _React$useState2[0],
      setHighlight = _React$useState2[1];
  var _React$useState3 = React$4.useState('a'),
      _React$useState4 = _slicedToArray$5(_React$useState3, 2),
      itemInView = _React$useState4[0],
      setItemInView = _React$useState4[1];
  React$4.useEffect(function () {
    if (props.isVisible) {
      var keyDownHandler = function keyDownHandler(event) {
        var keyFilter = function keyFilter(key) {
          return props.data.filter(function (object) {
            return object.text.toLowerCase().startsWith(key);
          });
        };
        var element = function element(object) {
          return document.getElementById("".concat(props.id, "_").concat(object.text.toLowerCase()));
        };
        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
          var currentItem = props.data.find(function (object) {
            return object.text.toLowerCase().startsWith(itemInView);
          });
          var currentIndex = props.data.indexOf(currentItem);
          var nextItem = event.key === 'ArrowUp' ? props.data[currentIndex - 1] : props.data[currentIndex + 1];
          if (element !== undefined && nextItem !== undefined) {
            setItemInView(nextItem.text.toLowerCase());
            element(nextItem).scrollIntoView({
              block: 'nearest',
              inline: 'nearest'
            });
            setHighlight({
              id: nextItem.id,
              text: nextItem.text
            });
          }
        } else if (keyFilter(event.key)[0] !== undefined) {
          setItemInView(keyFilter(event.key)[0].text.toLowerCase());
          element(keyFilter(event.key)[0]).scrollIntoView({
            block: 'nearest',
            inline: 'nearest'
          });
          setHighlight({
            id: keyFilter(event.key)[0].id,
            text: keyFilter(event.key)[0].text
          });
        }
        if (event.key === 'Enter') {
          props.onChange({
            id: isHighlight.id
          });
          props.setEnterClick(true);
          props.onClose();
        }
        return null;
      };
      window.addEventListener('keydown', keyDownHandler);
      return function () {
        window.removeEventListener('keydown', keyDownHandler);
      };
    }
    return null;
  }, [props.isVisible, itemInView, isHighlight]);
  return props.isVisible ? React$4.createElement("div", {
    style: {
      position: 'relative',
      top: 5,
      right: props.isRight ? props.width === '100%' ? "calc(240px - ".concat(props.width, ")") : props.width : 'initial',
      left: props.isRight ? 'initial' : 0,
      width: props.isFullWidth ? '100%' : undefined
    }
  }, React$4.createElement("div", {
    ref: ref,
    style: {
      width: '100%',
      height: 'auto',
      minWidth: 240,
      minHeight: 50,
      maxHeight: 270,
      maxWidth: props.maxWidth,
      border: "solid 1px ".concat(Colors.MEDIUM_WHITE),
      position: 'absolute',
      borderRadius: 7.5,
      zIndex: 2147483004,
      boxShadow: "0px 0px 25px 0px ".concat(Colors.GREY, "25"),
      overflowX: 'hidden',
      overflowY: 'scroll',
      backgroundColor: Colors.WHITE,
      transform: props.translateX ? "translateX(".concat(props.translateX, ")") : 'none'
    }
  }, React$4.createElement("div", {
    style: {
      position: 'relative',
      height: '100%',
      overflowY: 'hidden',
      overflowX: 'hidden'
    }
  }, props.data.map(function (item, index) {
    return React$4.createElement(React$4.Fragment, {
      key: index
    }, item.hr ? React$4.createElement("hr", {
      style: {
        border: "solid 1px ".concat(Colors.MEDIUM_WHITE)
      }
    }) : React$4.createElement(DropdownItem, {
      id: "".concat(props.id, "_").concat(item === null || item === void 0 ? void 0 : item.text.toLowerCase()),
      index: index,
      length: props.data.length,
      type: item.type,
      title: item.text,
      color: item.color,
      selected: item.selected,
      isHighlight: isHighlight,
      isFirst: index === 0,
      isLast: index + 1 === props.data.length,
      icon: item.icon,
      disabled: item.disabled,
      onClick: function onClick() {
        item.onClick();
        props.onChange({
          id: item.id
        });
        if (props.onClick) props.onClick();
        if (props.onClickClose) props.onClose();
      }
    }));
  })))) : null;
});

function Error$1(props) {
  return props.isVisible ? React$4.createElement(Text, {
    fontSize: "1em",
    color: Colors.RED
  }, props.text) : null;
}

function Tip$2(props) {
  return props.isVisible ? React$4.createElement(Text, {
    fontSize: "1em",
    color: Colors.DARK_WHITE
  }, props.text) : null;
}

var Dropdown = React$4.forwardRef(function (props, ref) {
  var _props$icon, _props$text, _props$subText;
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var size = useDimensions();
  var buttonRef = React$4.useRef();
  var dropdownRef = React$4.useRef();
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      isDropdownVisible = _React$useState2[0],
      setDropdownVisible = _React$useState2[1];
  var _React$useState3 = React$4.useState(false),
      _React$useState4 = _slicedToArray$5(_React$useState3, 2),
      isEnterClick = _React$useState4[0],
      _setEnterClick = _React$useState4[1];
  var _React$useState5 = React$4.useState('100%'),
      _React$useState6 = _slicedToArray$5(_React$useState5, 2),
      width = _React$useState6[0],
      setWidth = _React$useState6[1];
  var _React$useState7 = React$4.useState({
    text: _('select', {
      ns: 'ui'
    })
  }),
      _React$useState8 = _slicedToArray$5(_React$useState7, 2),
      selected = _React$useState8[0],
      setSelected = _React$useState8[1];
  useDataAttributes(buttonRef, props.dataAttributes, {
    all: {
      id: props.id,
      outsideClickExemption: true,
      functionality: true
    }
  });
  useDataAttributes(dropdownRef, undefined, {
    single: {
      id: props.id
    }
  }, isDropdownVisible);
  useOutsideClick(dropdownRef, function () {
    return setDropdownVisible(false);
  });
  React$4.useEffect(function () {
    var _buttonRef$current;
    if (buttonRef.current !== undefined && ((_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 ? void 0 : _buttonRef$current.clientWidth) >= 240) {
      setWidth(buttonRef.current.clientWidth);
    }
  }, [buttonRef, size]);
  return React$4.createElement("div", {
    ref: ref,
    style: {
      position: 'relative'
    }
  }, React$4.createElement(Label, {
    isVisible: props.label,
    text: props.label,
    id: props.id,
    isRequired: props.required,
    isDisabled: props.disabled
  }), React$4.createElement(Button$2, {
    ref: buttonRef,
    onClick: function onClick() {
      return setDropdownVisible(!isDropdownVisible);
    },
    isOpen: isDropdownVisible,
    ariaLabel: props.ariaLabel,
    icon: (_props$icon = props.icon) !== null && _props$icon !== void 0 ? _props$icon : selected.icon,
    text: (_props$text = props.text) !== null && _props$text !== void 0 ? _props$text : selected.text,
    subText: (_props$subText = props.subText) !== null && _props$subText !== void 0 ? _props$subText : selected.subText,
    maxWidth: props.maxWidth,
    isInError: props.error,
    isEnterClick: isEnterClick,
    setEnterClick: function setEnterClick(value) {
      return _setEnterClick(value);
    },
    fontSize: props.fontSize,
    fontWeight: props.fontWeight,
    width: props.width,
    height: props.height
  }), React$4.createElement(Menu, {
    ref: dropdownRef,
    id: props.id,
    isVisible: isDropdownVisible,
    data: props.items,
    isFullWidth: props.fullWidth,
    isLabelVisible: props.label,
    width: width,
    maxWidth: props.maxWidth,
    translateX: props.translateX,
    isRight: props.right,
    onChange: function onChange(value) {
      if (props.onChange) props.onChange(value);
      setSelected(value);
    },
    onClose: function onClose() {
      return setDropdownVisible(false);
    },
    onClickClose: props.onClickClose,
    setEnterClick: function setEnterClick(value) {
      return _setEnterClick(value);
    }
  }), React$4.createElement("div", {
    style: {
      marginTop: 5
    }
  }, React$4.createElement(Error$1, {
    isVisible: props.error,
    text: props.error
  }), React$4.createElement(Tip$2, {
    isVisible: props.hint,
    text: props.hint
  })));
});

var MultipleCheckboxes = function MultipleCheckboxes(props) {
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  return React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      marginBottom: 15
    }
  }, React$4.createElement("div", {
    style: {
      width: '100%',
      height: 'auto'
    }
  }, props.label && React$4.createElement("label", {
    className: "DisableSelection",
    htmlFor: props.id,
    style: {
      color: Colors.GREY,
      fontSize: '1em',
      width: '100%',
      position: 'relative',
      height: props.label || !props.required ? 20 : 0,
      display: 'inline-block'
    }
  }, props.label && props.label, !props.required && !props.disabled && React$4.createElement("span", {
    style: {
      fontSize: '0.8em',
      position: 'absolute',
      marginTop: 2,
      paddingLeft: 6,
      color: Colors.DARK_GREY,
      whiteSpace: 'nowrap',
      width: 'auto',
      fontWeight: 300
    }
  }, "- ".concat(_('optional', {
    ns: 'ui'
  })))), React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%'
    }
  }, props.options.map(function (option) {
    var _props$disabled;
    return React$4.createElement("div", {
      key: option.value,
      style: {
        marginTop: 7
      }
    }, React$4.createElement(Checkbox, {
      label: option.label,
      selected: option.selected,
      ariaLabel: option.ariaLabel,
      disabled: (_props$disabled = props.disabled) !== null && _props$disabled !== void 0 ? _props$disabled : option.disabled,
      ref: option.ref,
      onClick: function onClick() {
        if (option.onClick) option.onClick();
        if (props.onClick) props.onClick(option.value, !option.selected);
      },
      style: _objectSpread2({
        justifyContent: 'flex-start'
      }, option.style)
    }));
  })), props.hint && React$4.createElement("div", {
    style: {
      marginTop: 15
    }
  }, React$4.createElement(Text, {
    fontSize: "1em",
    color: Colors.DARK_WHITE
  }, props.hint))));
};

var Input = React$4.forwardRef(function (props, ref) {
  var renderInput = function renderInput() {
    switch (props.type) {
      case 'text':
        return React$4.createElement(TextInput, {
          type: "text",
          id: props.id,
          name: props.name,
          label: props.label,
          placeholder: props.placeholder,
          required: props.required,
          error: props.error,
          onChange: props.onChange,
          onEnter: props.onEnter,
          onTab: props.onTab,
          onKeyUp: props.onKeyUp,
          styling: props.styling,
          max: props.max,
          value: props.value,
          disabled: props.disabled,
          autocomplete: props.autocomplete,
          autoCorrect: props.autocorrect,
          readOnly: props.readonly,
          ariaLabel: props.ariaLabel,
          backgroundColor: props.backgroundColor,
          multiline: props.multiline,
          cols: props.cols,
          rows: props.rows,
          minLength: props.minLength,
          maxLength: props.maxLength,
          height: props.height,
          maxHeight: props.maxHeight,
          ref: ref,
          onFocus: props.onFocus,
          onBlur: props.onBlur,
          hint: props.hint,
          prefix: props.prefix,
          suffix: props.suffix,
          isLoading: props.isLoading,
          autofocus: props.autofocus
        });
      case 'email':
        return React$4.createElement(TextInput, {
          type: "email",
          id: props.id,
          name: props.name,
          label: props.label,
          placeholder: props.placeholder,
          required: props.required,
          error: props.error,
          onChange: props.onChange,
          onEnter: props.onEnter,
          onTab: props.onTab,
          onKeyUp: props.onKeyUp,
          styling: props.styling,
          max: props.max,
          value: props.value,
          disabled: props.disabled,
          autocomplete: props.autocomplete,
          autoCorrect: props.autocorrect,
          readOnly: props.readonly,
          ariaLabel: props.ariaLabel,
          backgroundColor: props.backgroundColor,
          ref: ref,
          onFocus: props.onFocus,
          onBlur: props.onBlur,
          hint: props.hint,
          prefix: props.prefix,
          isLoading: props.isLoading,
          autofocus: props.autofocus
        });
      case 'password':
        return React$4.createElement(TextInput, {
          type: "password",
          id: props.id,
          name: props.name,
          label: props.label,
          placeholder: props.placeholder,
          required: props.required,
          error: props.error,
          onChange: props.onChange,
          onEnter: props.onEnter,
          onTab: props.onTab,
          onKeyUp: props.onKeyUp,
          styling: props.styling,
          max: props.max,
          value: props.value,
          disabled: props.disabled,
          autocomplete: props.autocomplete,
          autoCorrect: props.autocorrect,
          readOnly: props.readonly,
          ariaLabel: props.ariaLabel,
          backgroundColor: props.backgroundColor,
          ref: props.ref,
          onFocus: props.onFocus,
          onBlur: props.onBlur,
          hint: props.hint,
          prefix: props.prefix,
          isLoading: props.isLoading,
          autofocus: props.autofocus
        });
      case 'radio':
        return React$4.createElement(Radio, {
          type: "radio",
          selected: props.selected,
          onClick: props.onClick,
          ariaLabel: props.ariaLabel,
          disabled: props.disabled,
          isReadOnly: props.isReadOnly,
          ref: ref
        });
      case 'multiple_checkboxes':
        return React$4.createElement(MultipleCheckboxes, {
          label: props.label,
          options: props.options,
          required: props.required,
          disabled: props.disabled,
          onClick: props.onClick,
          hint: props.hint
        });
      case 'checkbox':
        return React$4.createElement(Checkbox, {
          type: "checkbox",
          selected: props.selected,
          onClick: props.onClick,
          label: props.label,
          ariaLabel: props.ariaLabel,
          disabled: props.disabled,
          ref: ref,
          style: props.style,
          hint: props.hint,
          onKeyUp: props.onKeyUp,
          onKeyDown: props.onKeyDown,
          error: props.error,
          width: props.width
        });
      case 'range':
        return React$4.createElement(Range, {
          type: "range",
          label: props.label,
          required: props.required,
          disabled: props.disabled,
          min: props.min,
          max: props.max,
          step: props.step,
          orient: props.orient,
          name: props.name,
          value: props.value,
          onChange: props.onChange,
          formattedValue: props.formattedValue,
          ariaLabel: props.ariaLabel,
          ref: ref
        });
      case 'dropdown':
        return React$4.createElement(Dropdown, {
          type: "dropdown",
          id: props.id,
          onClick: props.onClick,
          onChange: props.onChange,
          items: props.items,
          selected: props.selected,
          icon: props.icon,
          text: props.text,
          subText: props.subText,
          label: props.label,
          right: props.right,
          ariaLabel: props.ariaLabel,
          ref: ref,
          onClickClose: props.onClickClose,
          required: props.required,
          error: props.error,
          hint: props.hint,
          dataAttributes: props.dataAttributes,
          translateX: props.translateX,
          fullWidth: props.fullWidth,
          maxWidth: props.maxWidth,
          paddingRight: props.paddingRight,
          fontSize: props.fontSize,
          fontWeight: props.fontWeight,
          width: props.width,
          height: props.height
        });
      case 'switch':
        return React$4.createElement(Switch, {
          type: "switch",
          value: props.value,
          onClick: props.onClick,
          disabled: props.disabled,
          ariaLabel: props.ariaLabel,
          ref: props.ref
        });
      case 'date':
        return React$4.createElement(Date$1, {
          title: props.title,
          onClick: props.onClick,
          size: props.size,
          disabled: props.disabled,
          height: props.height,
          value: props.value,
          onChange: props.onChange,
          minDate: props.minDate,
          maxDate: props.maxDate,
          maxDetail: props.maxDetail,
          borderRadius: props.borderRadius,
          format: props.format,
          align: props.align
        });
      case 'fromToDate':
        return React$4.createElement(FromToDate, {
          size: props.size,
          height: props.height,
          borderRadius: props.borderRadius,
          disabled: props.disabled,
          align: props.align,
          start: props.start,
          end: props.end,
          removeFilters: props.removeFilters,
          format: props.format,
          onClose: props.onClose,
          onClear: props.onClear
        });
      case 'number':
        return React$4.createElement(Number$1, {
          type: "number",
          id: props.id,
          name: props.name,
          label: props.label,
          placeholder: props.placeholder,
          required: props.required,
          error: props.error,
          onChange: props.onChange,
          onEnter: props.onEnter,
          onTab: props.onTab,
          onKeyUp: props.onKeyUp,
          styling: props.styling,
          min: props.min,
          max: props.max,
          step: props.step,
          value: props.value,
          autocomplete: props.autocomplete,
          readOnly: props.readonly,
          ariaLabel: props.ariaLabel,
          backgroundColor: props.backgroundColor,
          disabled: props.disabled,
          ref: ref,
          autofocus: props.autofocus,
          suffix: props.suffix,
          lang: props.lang,
          onFocus: props.onFocus,
          onBlur: props.onBlur
        });
      case 'file':
        return React$4.createElement(File, {
          type: "file",
          id: props.id,
          name: props.name,
          label: props.label,
          required: props.required,
          error: props.error,
          ariaLabel: props.ariaLabel,
          disabled: props.disabled,
          accept: props.accept,
          file: props.file,
          loading: props.loading,
          onDrop: props.onDrop,
          ref: ref
        });
      case 'time':
        return React$4.createElement(Time, {
          style: props.style,
          name: props.name,
          value: props.value,
          min: props.min,
          max: props.max,
          step: props.step,
          onChange: props.onChange,
          onBlurHandler: props.onBlurHandler,
          onFocus: props.onFocus,
          onBlur: props.onBlur,
          styling: props.styling,
          suffix: props.suffix,
          error: props.error,
          disabled: props.disabled,
          ref: ref
        });
      case 'copy':
        return React$4.createElement(Copy, {
          label: props.label,
          id: props.id,
          value: props.value,
          ariaLabel: props.ariaLabel,
          name: props.name,
          placeholder: props.placeholder,
          backgroundColor: props.backgroundColor,
          ref: ref
        });
      case 'search':
        return React$4.createElement(Search, {
          size: props.size,
          height: props.height,
          onEnter: props.onEnter,
          onTab: props.onTab,
          onKeyUp: props.onKeyUp,
          borderRadius: props.borderRadius,
          id: props.id,
          name: props.name,
          placeholder: props.placeholder,
          required: props.required,
          value: props.value,
          onChange: props.onChange,
          disabled: props.disabled,
          autocomplete: props.autocomplete,
          onFocus: props.onFocus,
          onBlur: props.onBlur,
          ariaLabel: props.ariaLabel
        });
      case 'tel':
        return React$4.createElement(TextInput, {
          type: "tel",
          id: props.id,
          name: props.name,
          label: props.label,
          placeholder: props.placeholder,
          required: props.required,
          error: props.error,
          onChange: props.onChange,
          onEnter: props.onEnter,
          onTab: props.onTab,
          onKeyUp: props.onKeyUp,
          styling: props.styling,
          max: props.max,
          value: props.value,
          disabled: props.disabled,
          autocomplete: props.autocomplete,
          ariaLabel: props.ariaLabel,
          backgroundColor: props.backgroundColor,
          multiline: props.multiline,
          cols: props.cols,
          rows: props.rows,
          minLength: props.minLength,
          maxLength: props.maxLength,
          height: props.height,
          maxHeight: props.maxHeight,
          ref: ref,
          onFocus: props.onFocus,
          onBlur: props.onBlur,
          prefix: props.prefix,
          autofocus: props.autofocus
        });
      case 'phone':
        return React$4.createElement(Phone, {
          type: "phone",
          id: props.id,
          name: props.name,
          label: props.label,
          placeholder: props.placeholder,
          isRequired: props.required,
          error: props.error,
          onChange: props.onChange,
          onEnter: props.onEnter,
          onTab: props.onTab,
          onKeyUp: props.onKeyUp,
          styling: props.styling,
          step: props.step,
          value: props.value,
          setValue: props.setValue,
          autocomplete: props.autocomplete,
          readOnly: props.readonly,
          ariaLabel: props.ariaLabel,
          backgroundColor: props.backgroundColor,
          disabled: props.disabled,
          maxDropdown: props.maxDropdown,
          ref: ref,
          autofocus: props.autofocus
        });
      default:
        return React$4.createElement(TextInput, {
          type: "text",
          id: props.id,
          name: props.name,
          label: props.label,
          placeholder: props.placeholder,
          required: props.required,
          error: props.error,
          onChange: props.onChange,
          onEnter: props.onEnter,
          onTab: props.onTab,
          onKeyUp: props.onKeyUp,
          styling: props.styling,
          max: props.max,
          value: props.value,
          disabled: props.disabled,
          autocomplete: props.autocomplete,
          autoCorrect: props.autocorrect,
          readOnly: props.readonly,
          ariaLabel: props.ariaLabel,
          backgroundColor: props.backgroundColor,
          multiline: props.multiline,
          cols: props.cols,
          rows: props.rows,
          minLength: props.minLength,
          maxLength: props.maxLength,
          height: props.height,
          maxHeight: props.maxHeight,
          ref: ref,
          onFocus: props.onFocus,
          onBlur: props.onBlur,
          hint: props.hint,
          prefix: props.prefix,
          suffix: props.suffix,
          autofocus: props.autofocus
        });
    }
  };
  return React$4.createElement(React$4.Fragment, null, renderInput());
});
var Inputs = Input;

function ArrowButton(props) {
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement(motion.button, {
    className: "Hover",
    type: "button",
    "aria-label": props.ariaLabel,
    onClick: props.onClick,
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    style: {
      height: 50,
      width: 50,
      position: 'absolute',
      backgroundColor: props.colorScheme.vibrant,
      left: props.left ? 0 : 'inherit',
      right: props.right ? 0 : 'inherit',
      top: '50%',
      transform: 'translateY(-50%)',
      borderRadius: 10,
      border: "solid 2px ".concat(props.colorScheme.dark_shade),
      paddingLeft: props.left ? 0 : 6
    },
    initial: {
      opacity: props.visisble ? 1 : 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: props.visisble ? 1 : 0
    },
    transition: {
      duration: 0.3
    }
  }, React$4.createElement("div", {
    style: {
      position: 'absolute',
      top: 12,
      left: props.left ? hover ? 5 : 9 : hover ? 16 : 12,
      transition: 'all 0.05s linear'
    }
  }, React$4.createElement(Icon, {
    name: props.left ? 'ChevronLeft' : 'ChevronRight',
    iconSet: "Feather",
    height: 25,
    width: 25,
    color: props.colorScheme.type === 'white' ? Colors.DARK_GREY : props.colorScheme.text
  })));
}

function Carousel(props) {
  var _childRef$current, _props$height, _props$width;
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var _React$useState = React$4.useState(0),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      active = _React$useState2[0],
      setActive = _React$useState2[1];
  var _React$useState3 = React$4.useState(0),
      _React$useState4 = _slicedToArray$5(_React$useState3, 2),
      childOffsetWidth = _React$useState4[0],
      setChildOffsetWidth = _React$useState4[1];
  var _React$useState5 = React$4.useState(0),
      _React$useState6 = _slicedToArray$5(_React$useState5, 2),
      wrapperOffsetWidth = _React$useState6[0],
      setWrapperOffsetWidth = _React$useState6[1];
  var _React$useState7 = React$4.useState(false),
      _React$useState8 = _slicedToArray$5(_React$useState7, 2),
      hover = _React$useState8[0],
      setHover = _React$useState8[1];
  var childRef = React$4.useRef(props.height);
  var wrapperRef = React$4.useRef();
  var getWrapperOffsetWidth = function getWrapperOffsetWidth() {
    var _wrapperRef$current;
    if ((_wrapperRef$current = wrapperRef.current) !== null && _wrapperRef$current !== void 0 && _wrapperRef$current.clientWidth) {
      setWrapperOffsetWidth(wrapperRef.current.clientWidth);
    }
  };
  React$4.useEffect(function () {
    getWrapperOffsetWidth();
    setChildOffsetWidth(childRef.current.offsetWidth);
  }, [wrapperOffsetWidth, (_childRef$current = childRef.current) === null || _childRef$current === void 0 ? void 0 : _childRef$current.clientWidth]);
  React$4.useEffect(function () {
    window.addEventListener('resize', getWrapperOffsetWidth);
    return function () {
      return window.removeEventListener('resize', getWrapperOffsetWidth);
    };
  }, []);
  React$4.useEffect(function () {
    if (props.onChangeActive) props.onChangeActive(active);
  }, [active]);
  var fadeSelection = function fadeSelection(e) {
    var direction = 0;
    if (e === 'left') direction = -90;
    if (e === 'right') direction = 90;
    var greenGradient = "linear-gradient(".concat(direction, "deg, rgba(0, 202, 139, 0.001) 0%, rgba(0, 202, 139, 1) 90%)");
    var whiteGradient = "linear-gradient(".concat(direction, "deg, rgba(255, 255, 255, 0.001) 0%, rgba(255, 255, 255, 1) 90%)");
    if (props.colorScheme === 'green') return greenGradient;
    if (props.colorScheme === 'white') return whiteGradient;
    return whiteGradient;
  };
  var delta = 1;
  function calcLastItems() {
    if (props.maxItems !== 1) delta = props.maxItems;
    for (var i = 0; i < props.children.length; i += delta) {
    }
  }
  calcLastItems();
  return React$4.createElement("div", {
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    style: {
      height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 300,
      width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : '100%',
      display: 'flex',
      overflow: 'hidden',
      position: 'relative',
      backgroundColor: 'transparent'
    }
  }, React$4.createElement("div", {
    ref: wrapperRef,
    style: {
      flex: 1,
      height: '100%',
      width: '100%',
      transform: "translateX(\n              ".concat(childOffsetWidth > props.height ? "calc(-".concat(active, " * (101% / (").concat(props.maxItems, ")")
      : active === props.children.length - props.maxItems && !props.toEnd ? "calc(".concat(wrapperOffsetWidth, "px - (").concat(props.children.length, " * (").concat(childOffsetWidth, "px + 1%) - 1%))")
      : "calc(-".concat(active, " * (").concat(childOffsetWidth, "px + 1%))")
      , "\n            )"),
      transition: 'all ease .5s',
      whiteSpace: 'nowrap'
    }
  }, React$4.Children.map(props.children, function (child) {
    var _props$minWidth;
    return React$4.createElement("div", {
      style: {
        display: 'inline-block',
        marginRight: '1%',
        width: props.maxItems === 1 ? '100%' : "calc(".concat("".concat(100 - (props.maxItems - 1)), "% / ", props.maxItems, ")"),
        minWidth: (_props$minWidth = props.minWidth) !== null && _props$minWidth !== void 0 ? _props$minWidth : props.height,
        maxWidth: props.maxItems === 1 ? '100%' : "calc(".concat("".concat(100 - (props.maxItems - 1)), "% / ", props.maxItems, ")"),
        height: '100%',
        overflow: 'hidden'
      }
    }, React$4.cloneElement(child, {
      ref: childRef,
      style: _objectSpread2({
        maxWidth: '100%',
        whiteSpace: 'normal'
      }, child.props.style)
    }));
  })), React$4.createElement(AnimatePresence, null, active !== 0 && React$4.createElement(motion.div, {
    style: {
      background: props.fade ? fadeSelection('left') : 'transparent',
      position: 'absolute',
      height: '100%',
      width: 45,
      left: 0
    },
    initial: {
      width: 0,
      opacity: 0
    },
    animate: {
      width: 45,
      opacity: 1
    },
    exit: {
      width: 0,
      opacity: 0
    },
    transition: {
      duration: 0.4
    }
  })), React$4.createElement(AnimatePresence, null, active !== 0 && (hover || props.visibleArrows) && !props.disable && React$4.createElement(ArrowButton, {
    left: true,
    ariaLabel: "".concat(_('previous', {
      ns: 'ui'
    }), " ").concat(_('accessibility.button', {
      ns: 'ui'
    }).toLowerCase()),
    colorScheme: getColorScheme(props.colorScheme),
    visible: props.visibleArrows,
    onClick: function onClick() {
      return active !== 0 && setActive(active - 1);
    }
  })), React$4.createElement(AnimatePresence, null, props.children.length >= props.maxItems && active !== props.children.length - props.maxItems && React$4.createElement(motion.div, {
    style: {
      background: props.fade ? fadeSelection('right') : 'transparent',
      position: 'absolute',
      height: '100%',
      width: 45,
      right: 0
    },
    initial: {
      width: 0,
      opacity: 0
    },
    animate: {
      width: 45,
      opacity: 1
    },
    exit: {
      width: 0,
      opacity: 0
    },
    transition: {
      duration: 0.4
    }
  })), React$4.createElement(AnimatePresence, null, (props.toEnd ? active !== props.children.length - 1 && (hover || props.visibleArrows) : props.children.length >= props.maxItems && active !== props.children.length - props.maxItems && !props.disable && (hover || props.visibleArrows)) && React$4.createElement(ArrowButton, {
    right: true,
    ariaLabel: "".concat(_('next', {
      ns: 'ui'
    }), " ").concat(_('accessibility.button', {
      ns: 'ui'
    }).toLowerCase()),
    colorScheme: getColorScheme(props.colorScheme),
    visible: props.visibleArrows,
    onClick:
    function onClick() {
      return (props.toEnd ? active !== props.children.length - 1 : active !== props.children.length - props.maxItems) && setActive(active + 1);
    }
  })));
}

function ModuleHeader$1(props) {
  var _props$icon$width, _props$icon$height, _props$icon$color, _props$icon$width2, _props$icon$height2, _props$icon$color2;
  var size = useDimensions();
  return React$4.createElement("div", {
    style: {
      height: 60,
      width: '100%',
      display: 'flex',
      flexDirection: 'row'
    }
  }, props.icon && size.width > Breakpoint.fd && !props.iconRight && React$4.createElement("div", {
    style: {
      width: 60,
      height: 60,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, React$4.createElement(Icon, {
    name: props.icon.name,
    width: (_props$icon$width = props.icon.width) !== null && _props$icon$width !== void 0 ? _props$icon$width : 45,
    height: (_props$icon$height = props.icon.height) !== null && _props$icon$height !== void 0 ? _props$icon$height : 45,
    color: (_props$icon$color = props.icon.color) !== null && _props$icon$color !== void 0 ? _props$icon$color : Colors.GREY
  })), React$4.createElement("div", {
    style: {
      width: 'auto',
      height: 60,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      paddingTop: props.clickable ? 0 : 2
    }
  }, React$4.createElement(Text, {
    fontSize: "1.25em",
    fontWeight: 500
  }, props.title), React$4.createElement("div", {
    style: {
      paddingTop: 3
    }
  }, React$4.createElement(Text, {
    fontSize: "1.1em"
  }, props.subTitle))), props.icon && size.width > Breakpoint.fd && props.iconRight && React$4.createElement("div", {
    style: {
      width: 60,
      height: 60,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, React$4.createElement(Icon, {
    name: props.icon.name,
    width: (_props$icon$width2 = props.icon.width) !== null && _props$icon$width2 !== void 0 ? _props$icon$width2 : 45,
    height: (_props$icon$height2 = props.icon.height) !== null && _props$icon$height2 !== void 0 ? _props$icon$height2 : 45,
    color: (_props$icon$color2 = props.icon.color) !== null && _props$icon$color2 !== void 0 ? _props$icon$color2 : Colors.GREY
  })));
}

function Item$5(props) {
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      isHover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("button", {
    type: "button",
    className: "Hover",
    onClick: props.onClick,
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    style: {
      height: 60,
      width: 40,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-end',
      justifyContent: 'flex-end',
      backgroundColor: 'transparent',
      border: 'solid 0px transparent',
      fontSize: '1em',
      marginRight: props.isLast ? 10 : 0
    }
  }, React$4.createElement("div", {
    style: {
      height: 40,
      width: 40,
      minWidth: 40,
      minHeight: 40,
      borderRadius: 7,
      border: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      transform: "rotate(".concat(props.active ? "".concat(180, "deg") : "".concat(0, "deg"), ")"),
      backgroundColor: isHover ? Colors.LIGHT_GREY : Colors.WHITE,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, React$4.createElement(Icon, {
    name: props.icon.name,
    height: props.icon.height,
    width: props.icon.width,
    color: props.icon.color,
    iconSet: props.icon.iconSet
  })));
}

function Clickable(props) {
  return React$4.createElement("div", {
    style: {
      width: '100%',
      height: 'auto',
      maxHeight: 60,
      display: 'flex',
      flexDirection: 'row',
      fontSize: '1em',
      padding: 0,
      margin: 0,
      backgroundColor: 'transparent',
      border: 'solid 0px transparent',
      position: 'relative',
      zIndex: 1
    }
  }, React$4.createElement(ModuleHeader$1, {
    title: props.title,
    subTitle: props.subTitle,
    icon: props.icon,
    clickable: true
  }), props.options && props.options.map(function (item, index) {
    return React$4.createElement(Item$5, {
      key: item.id,
      onClick: item.onClick,
      active: item.active,
      isLast: index !== props.options.length - 1,
      icon: item.icon
    });
  }));
}

function ModuleHeader(props) {
  return props.options ? React$4.createElement(Clickable, {
    title: props.title,
    subTitle: props.subTitle,
    icon: props.icon,
    active: props.active,
    options: props.options
  }) : React$4.createElement(ModuleHeader$1, {
    title: props.title,
    subTitle: props.subTitle,
    icon: props.icon,
    style: props.style,
    iconRight: props.iconRight
  });
}

function DropdownMenu(props) {
  return React$4.createElement("div", {
    style: {
      height: 'auto',
      width: props.width,
      minHeight: 50,
      minWidth: 240,
      maxHeight: 270,
      maxWidth: props.maxWidth,
      border: "solid 1px ".concat(Colors.MEDIUM_WHITE),
      position: 'absolute',
      top: 70,
      borderRadius: 10,
      paddingTop: 10,
      paddingBottom: 10,
      zIndex: 2147483004,
      boxShadow: "0px 0px 25px 0px ".concat(Colors.GREY, "25"),
      overflowX: 'hidden',
      overflowY: 'auto',
      backgroundColor: Colors.WHITE,
      transform: props.translateX ? "translateX(".concat(props.translateX, ")") : {}
    }
  }, props.items.map(function (event, index) {
    return React$4.createElement(React$4.Fragment, {
      key: index
    }, event.hr ? React$4.createElement("hr", {
      style: {
        border: "solid 1px ".concat(Colors.MEDIUM_WHITE)
      }
    }) : React$4.createElement(DropdownItem, {
      type: event.type,
      title: event.title,
      color: event.color,
      onClick: function onClick() {
        event.onClick();
        if (props.onClick) props.onClick();
        if (props.onClickClose) props.onClose();
      },
      selected: event.selected,
      icon: event.icon,
      disabled: event.disabled,
      length: props.items.length,
      index: index
    }));
  }));
}

function NavigationItem(props) {
  var _props$icon$height, _props$icon$width, _props$icon$color;
  var size = useDimensions();
  var dropdownRef = React$4.useRef();
  var dataRef = React$4.useRef();
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      isDropdownVisible = _React$useState2[0],
      setDropdownVisible = _React$useState2[1];
  useDataAttributes(dataRef, props.dataAttributes, {
    all: {
      id: props.id,
      outsideClickExemption: true
    }
  });
  useDataAttributes(dropdownRef, undefined, {
    single: {
      id: props.id
    }
  }, isDropdownVisible);
  useOutsideClick(dropdownRef, function () {
    return setDropdownVisible(false);
  });
  return React$4.createElement("div", {
    ref: dataRef,
    style: {
      width: 'auto',
      height: '100%',
      maxHeight: 80,
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start'
    }
  }, React$4.createElement("button", {
    type: "button",
    className: "Hover",
    onClick: function onClick() {
      setDropdownVisible(!isDropdownVisible);
    },
    style: {
      width: '100%',
      height: 80,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-end',
      fontSize: '1.1em',
      backgroundColor: 'transparent',
      padding: '0',
      border: 'none'
    }
  }, props.icon && React$4.createElement("div", {
    style: {
      marginRight: size.width > Breakpoint.xs && props.title ? 5 : 0,
      paddingTop: 3
    }
  }, React$4.createElement(Icon, {
    name: props.icon.name,
    height: (_props$icon$height = props.icon.height) !== null && _props$icon$height !== void 0 ? _props$icon$height : 30,
    width: (_props$icon$width = props.icon.width) !== null && _props$icon$width !== void 0 ? _props$icon$width : 30,
    color: (_props$icon$color = props.icon.color) !== null && _props$icon$color !== void 0 ? _props$icon$color : Colors.BLUE
  })), size.width > Breakpoint.xs && props.title && React$4.createElement(Text, {
    color: Colors.BLUE,
    fontWeight: 300,
    fontSize: "1.1em",
    textAlign: "center"
  }, props.title), props.dropdownMenu && React$4.createElement("div", {
    style: {
      marginLeft: size.width > Breakpoint.xs ? 3 : 0,
      paddingTop: 5,
      transform: "rotate(".concat(isDropdownVisible ? "".concat(180, "deg") : "".concat(0, "deg"), ")")
    }
  }, React$4.createElement(Icon, {
    name: "AngleDown",
    height: 25,
    width: 25,
    color: Colors.BLUE
  }))), isDropdownVisible && React$4.createElement("div", {
    ref: dropdownRef,
    style: {
      position: 'absolute',
      right: 240,
      zIndex: 2147483004
    }
  }, React$4.createElement(DropdownMenu, {
    id: props.id,
    onClose: function onClose() {
      return setDropdownVisible(!isDropdownVisible);
    },
    items: props.dropdownMenu,
    visible: isDropdownVisible
  })));
}

function Link(props) {
  var _props$href, _props$color, _props$fontSize, _props$fontWeight, _props$title;
  var _React$useState = React$4.useState(),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("a", {
    href: (_props$href = props.href) !== null && _props$href !== void 0 ? _props$href : '/404',
    className: "Hover DisableSelection",
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    style: {
      color: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.BLUE,
      fontFamily: 'Museo-Sans',
      fontSize: (_props$fontSize = props.fontSize) !== null && _props$fontSize !== void 0 ? _props$fontSize : '1em',
      fontWeight: (_props$fontWeight = props.fontWeight) !== null && _props$fontWeight !== void 0 ? _props$fontWeight : '300',
      textDecoration: hover ? 'underline' : 'none'
    }
  }, (_props$title = props.title) !== null && _props$title !== void 0 ? _props$title : props.href);
}

function RangeMeter(props) {
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: props.horizontal ? 'column-reverse' : 'column',
      alignItems: props.horizontal ? 'flex-start' : 'center',
      height: '100%'
    }
  }, React$4.createElement("div", {
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    style: {
      height: props.horizontal ? 30 : '100%',
      width: props.horizontal ? '100%' : 30,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative'
    }
  }, React$4.createElement("div", {
    style: {
      height: props.horizontal ? 10 : '100%',
      minHeight: props.horizontal ? 0 : 200,
      width: props.horizontal ? '100%' : 10,
      borderRadius: 15,
      backgroundColor: Colors.MEDIUM_GREY,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: props.horizontal ? 'center' : 'flex-end'
    }
  }, React$4.createElement("div", {
    style: {
      height: props.horizontal ? 10 : props.value ? "".concat(props.value, "%") : '0%',
      width: props.horizontal ? props.value ? "".concat(props.value, "%") : '0%' : 10,
      backgroundColor: Colors.GREY,
      borderRadius: 15,
      transition: 'all .3s ease'
    }
  })), React$4.createElement(AnimatePresence, null, hover && !props.horizontal && React$4.createElement(motion.div, {
    className: "Hover ContextMenu",
    style: {
      left: 30,
      position: 'absolute',
      height: 30,
      width: 'auto',
      backgroundColor: Colors.GREY,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      paddingLeft: 10,
      paddingRight: 10,
      borderRadius: 7,
      boxShadow: "0px 0px 25px 0px ".concat(Colors.GREY, "25"),
      zIndex: 1
    },
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: 0.3,
      delay: 0.1
    }
  }, React$4.createElement(Text, {
    color: Colors.WHITE,
    fontSize: "1.1em"
  }, props.content, props.unit)))), React$4.createElement("div", {
    style: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'space-between'
    }
  }, props.description && React$4.createElement("div", {
    style: {
      paddingTop: props.horizontal ? 5 : 10,
      paddingBottom: 5,
      paddingLeft: 0,
      width: props.horizontal ? '50%' : '100%'
    }
  }, React$4.createElement(Text, {
    fontSize: "1em",
    fontWeight: props.active ? 500 : 300,
    textAlign: props.horizontal ? 'left' : 'center'
  }, props.description)), props.horizontal && React$4.createElement("div", {
    style: {
      paddingTop: 5,
      paddingBottom: 5,
      paddingLeft: 0,
      width: '50%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end'
    }
  }, React$4.createElement(Text, {
    fontSize: "1em",
    fontWeight: props.active ? 500 : 300
  }, props.content, props.unit))));
}

const pi$1 = Math.PI,
    tau$1 = 2 * pi$1,
    epsilon$1 = 1e-6,
    tauEpsilon = tau$1 - epsilon$1;
function Path() {
  this._x0 = this._y0 =
  this._x1 = this._y1 = null;
  this._ = "";
}
function path() {
  return new Path;
}
Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;
    if (r < 0) throw new Error("negative radius: " + r);
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }
    else if (!(l01_2 > epsilon$1));
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon$1) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi$1 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;
      if (Math.abs(t01 - 1) > epsilon$1) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }
      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r, ccw = !!ccw;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;
    if (r < 0) throw new Error("negative radius: " + r);
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }
    else if (Math.abs(this._x1 - x0) > epsilon$1 || Math.abs(this._y1 - y0) > epsilon$1) {
      this._ += "L" + x0 + "," + y0;
    }
    if (!r) return;
    if (da < 0) da = da % tau$1 + tau$1;
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }
    else if (da > epsilon$1) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi$1)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

function constant$1(x) {
  return function constant() {
    return x;
  };
}

const abs = Math.abs;
const atan2 = Math.atan2;
const cos = Math.cos;
const max = Math.max;
const min = Math.min;
const sin = Math.sin;
const sqrt = Math.sqrt;
const epsilon = 1e-12;
const pi = Math.PI;
const halfPi = pi / 2;
const tau = 2 * pi;
function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function asin(x) {
  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}

function arcInnerRadius(d) {
  return d.innerRadius;
}
function arcOuterRadius(d) {
  return d.outerRadius;
}
function arcStartAngle(d) {
  return d.startAngle;
}
function arcEndAngle(d) {
  return d.endAngle;
}
function arcPadAngle(d) {
  return d && d.padAngle;
}
function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = y32 * x10 - x32 * y10;
  if (t * t < epsilon) return;
  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
  return [x0 + t * x10, y0 + t * y10];
}
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}
function arc() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = constant$1(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;
  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - halfPi,
        a1 = endAngle.apply(this, arguments) - halfPi,
        da = abs(a1 - a0),
        cw = a1 > a0;
    if (!context) context = buffer = path();
    if (r1 < r0) r = r1, r1 = r0, r0 = r;
    if (!(r1 > epsilon)) context.moveTo(0, 0);
    else if (da > tau - epsilon) {
      context.moveTo(r1 * cos(a0), r1 * sin(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > epsilon) {
        context.moveTo(r0 * cos(a1), r0 * sin(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
          rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;
      if (rp > epsilon) {
        var p0 = asin(rp / r0 * sin(ap)),
            p1 = asin(rp / r1 * sin(ap));
        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }
      var x01 = r1 * cos(a01),
          y01 = r1 * sin(a01),
          x10 = r0 * cos(a10),
          y10 = r0 * sin(a10);
      if (rc > epsilon) {
        var x11 = r1 * cos(a11),
            y11 = r1 * sin(a11),
            x00 = r0 * cos(a00),
            y00 = r0 * sin(a00),
            oc;
        if (da < pi && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
          var ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
              lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = min(rc, (r0 - lc) / (kc - 1));
          rc1 = min(rc, (r1 - lc) / (kc + 1));
        }
      }
      if (!(da1 > epsilon)) context.moveTo(x01, y01);
      else if (rc1 > epsilon) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
        else {
          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
        }
      }
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
      else if (rc0 > epsilon) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
        else {
          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
        }
      }
      else context.arc(0, 0, r0, a10, a00, cw);
    }
    context.closePath();
    if (buffer) return context = null, buffer + "" || null;
  }
  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
    return [cos(a) * r, sin(a) * r];
  };
  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : innerRadius;
  };
  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : outerRadius;
  };
  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : cornerRadius;
  };
  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), arc) : padRadius;
  };
  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : startAngle;
  };
  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : endAngle;
  };
  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : padAngle;
  };
  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };
  return arc;
}

function ascending(a, b) {
  return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

function descending(a, b) {
  return a == null || b == null ? NaN
    : b < a ? -1
    : b > a ? 1
    : b >= a ? 0
    : NaN;
}

function bisector(f) {
  let compare1, compare2, delta;
  if (f.length !== 2) {
    compare1 = ascending;
    compare2 = (d, x) => ascending(f(d), x);
    delta = (d, x) => f(d) - x;
  } else {
    compare1 = f === ascending || f === descending ? f : zero$1;
    compare2 = f;
    delta = f;
  }
  function left(a, x, lo = 0, hi = a.length) {
    if (lo < hi) {
      if (compare1(x, x) !== 0) return hi;
      do {
        const mid = (lo + hi) >>> 1;
        if (compare2(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      } while (lo < hi);
    }
    return lo;
  }
  function right(a, x, lo = 0, hi = a.length) {
    if (lo < hi) {
      if (compare1(x, x) !== 0) return hi;
      do {
        const mid = (lo + hi) >>> 1;
        if (compare2(a[mid], x) <= 0) lo = mid + 1;
        else hi = mid;
      } while (lo < hi);
    }
    return lo;
  }
  function center(a, x, lo = 0, hi = a.length) {
    const i = left(a, x, lo, hi - 1);
    return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
  }
  return {left, center, right};
}
function zero$1() {
  return 0;
}

function number$1(x) {
  return x === null ? NaN : +x;
}

const ascendingBisect = bisector(ascending);
const bisectRight = ascendingBisect.right;
bisector(number$1).center;
var bisect = bisectRight;

var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);
function ticks(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;
  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
  if (step > 0) {
    let r0 = Math.round(start / step), r1 = Math.round(stop / step);
    if (r0 * step < start) ++r0;
    if (r1 * step > stop) --r1;
    ticks = new Array(n = r1 - r0 + 1);
    while (++i < n) ticks[i] = (r0 + i) * step;
  } else {
    step = -step;
    let r0 = Math.round(start * step), r1 = Math.round(stop * step);
    if (r0 / step < start) ++r0;
    if (r1 / step > stop) --r1;
    ticks = new Array(n = r1 - r0 + 1);
    while (++i < n) ticks[i] = (r0 + i) / step;
  }
  if (reverse) ticks.reverse();
  return ticks;
}
function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}
function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}

function initRange(domain, range) {
  switch (arguments.length) {
    case 0: break;
    case 1: this.range(domain); break;
    default: this.range(range).domain(domain); break;
  }
  return this;
}

function define(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}
function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}

function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex = /^#([0-9a-f]{3,8})$/,
    reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`),
    reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`),
    reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`),
    reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`),
    reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`),
    reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};
define(Color, color, {
  copy(channels) {
    return Object.assign(new this.constructor, this, channels);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex,
  formatHex: color_formatHex,
  formatHex8: color_formatHex8,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});
function color_formatHex() {
  return this.rgb().formatHex();
}
function color_formatHex8() {
  return this.rgb().formatHex8();
}
function color_formatHsl() {
  return hslConvert(this).formatHsl();
}
function color_formatRgb() {
  return this.rgb().formatRgb();
}
function color(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m)
      : l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)
      : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff)
      : l === 4 ? rgba((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff)
      : null)
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4])
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4])
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4])
      : named.hasOwnProperty(format) ? rgbn(named[format])
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}
function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb$1(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}
define(Rgb, rgb$1, extend(Color, {
  brighter(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
  },
  displayable() {
    return (-0.5 <= this.r && this.r < 255.5)
        && (-0.5 <= this.g && this.g < 255.5)
        && (-0.5 <= this.b && this.b < 255.5)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex,
  formatHex: rgb_formatHex,
  formatHex8: rgb_formatHex8,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));
function rgb_formatHex() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
  const a = clampa(this.opacity);
  return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
  return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
  return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
  value = clampi(value);
  return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}
function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}
define(Hsl, hsl, extend(Color, {
  brighter(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  clamp() {
    return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
  }
}));
function clamph(value) {
  value = (value || 0) % 360;
  return value < 0 ? value + 360 : value;
}
function clampt(value) {
  return Math.max(0, Math.min(1, value || 0));
}
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}

var constant = x => () => x;

function linear$1(a, d) {
  return function(t) {
    return a + t * d;
  };
}
function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}
function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
  };
}
function nogamma(a, b) {
  var d = b - a;
  return d ? linear$1(a, d) : constant(isNaN(a) ? b : a);
}

var rgb = (function rgbGamma(y) {
  var color = gamma(y);
  function rgb(start, end) {
    var r = color((start = rgb$1(start)).r, (end = rgb$1(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
  rgb.gamma = rgbGamma;
  return rgb;
})(1);

function numberArray(a, b) {
  if (!b) b = [];
  var n = a ? Math.min(b.length, a.length) : 0,
      c = b.slice(),
      i;
  return function(t) {
    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
    return c;
  };
}
function isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

function genericArray(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;
  for (i = 0; i < na; ++i) x[i] = interpolate(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];
  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
}

function date(a, b) {
  var d = new Date;
  return a = +a, b = +b, function(t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
}

function interpolateNumber(a, b) {
  return a = +a, b = +b, function(t) {
    return a * (1 - t) + b * t;
  };
}

function object(a, b) {
  var i = {},
      c = {},
      k;
  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};
  for (k in b) {
    if (k in a) {
      i[k] = interpolate(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }
  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
}

var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");
function zero(b) {
  return function() {
    return b;
  };
}
function one(b) {
  return function(t) {
    return b(t) + "";
  };
}
function string(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0,
      am,
      bm,
      bs,
      i = -1,
      s = [],
      q = [];
  a = a + "", b = b + "";
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) {
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs;
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) {
      if (s[i]) s[i] += bm;
      else s[++i] = bm;
    } else {
      s[++i] = null;
      q.push({i: i, x: interpolateNumber(am, bm)});
    }
    bi = reB.lastIndex;
  }
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs;
    else s[++i] = bs;
  }
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
}

function interpolate(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? constant(b)
      : (t === "number" ? interpolateNumber
      : t === "string" ? ((c = color(b)) ? (b = c, rgb) : string)
      : b instanceof color ? rgb
      : b instanceof Date ? date
      : isNumberArray(b) ? numberArray
      : Array.isArray(b) ? genericArray
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
      : interpolateNumber)(a, b);
}

function interpolateRound(a, b) {
  return a = +a, b = +b, function(t) {
    return Math.round(a * (1 - t) + b * t);
  };
}

function constants(x) {
  return function() {
    return x;
  };
}

function number(x) {
  return +x;
}

var unit = [0, 1];
function identity$1(x) {
  return x;
}
function normalize(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : constants(isNaN(b) ? NaN : 0.5);
}
function clamper(a, b) {
  var t;
  if (a > b) t = a, a = b, b = t;
  return function(x) { return Math.max(a, Math.min(b, x)); };
}
function bimap(domain, range, interpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
  else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}
function polymap(domain, range, interpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }
  while (++i < j) {
    d[i] = normalize(domain[i], domain[i + 1]);
    r[i] = interpolate(range[i], range[i + 1]);
  }
  return function(x) {
    var i = bisect(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}
function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp())
      .unknown(source.unknown());
}
function transformer() {
  var domain = unit,
      range = unit,
      interpolate$1 = interpolate,
      transform,
      untransform,
      unknown,
      clamp = identity$1,
      piecewise,
      output,
      input;
  function rescale() {
    var n = Math.min(domain.length, range.length);
    if (clamp !== identity$1) clamp = clamper(domain[0], domain[n - 1]);
    piecewise = n > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }
  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate$1)))(transform(clamp(x)));
  }
  scale.invert = function(y) {
    return clamp(untransform((input || (input = piecewise(range, domain.map(transform), interpolateNumber)))(y)));
  };
  scale.domain = function(_) {
    return arguments.length ? (domain = Array.from(_, number), rescale()) : domain.slice();
  };
  scale.range = function(_) {
    return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
  };
  scale.rangeRound = function(_) {
    return range = Array.from(_), interpolate$1 = interpolateRound, rescale();
  };
  scale.clamp = function(_) {
    return arguments.length ? (clamp = _ ? true : identity$1, rescale()) : clamp !== identity$1;
  };
  scale.interpolate = function(_) {
    return arguments.length ? (interpolate$1 = _, rescale()) : interpolate$1;
  };
  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };
  return function(t, u) {
    transform = t, untransform = u;
    return rescale();
  };
}
function continuous() {
  return transformer()(identity$1, identity$1);
}

function formatDecimal(x) {
  return Math.abs(x = Math.round(x)) >= 1e21
      ? x.toLocaleString("en").replace(/,/g, "")
      : x.toString(10);
}
function formatDecimalParts(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null;
  var i, coefficient = x.slice(0, i);
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
}

function exponent(x) {
  return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
}

function formatGroup(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;
    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }
    return t.reverse().join(thousands);
  };
}

function formatNumerals(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}

var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}
formatSpecifier.prototype = FormatSpecifier.prototype;
function FormatSpecifier(specifier) {
  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
  this.align = specifier.align === undefined ? ">" : specifier.align + "";
  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === undefined ? undefined : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === undefined ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width === undefined ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0))
      + (this.trim ? "~" : "")
      + this.type;
};

function formatTrim(s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      default: if (!+s[i]) break out; if (i0 > 0) i0 = 0; break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

var prefixExponent;
function formatPrefixAuto(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0];
}

function formatRounded(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

var formatTypes = {
  "%": (x, p) => (x * 100).toFixed(p),
  "b": (x) => Math.round(x).toString(2),
  "c": (x) => x + "",
  "d": formatDecimal,
  "e": (x, p) => x.toExponential(p),
  "f": (x, p) => x.toFixed(p),
  "g": (x, p) => x.toPrecision(p),
  "o": (x) => Math.round(x).toString(8),
  "p": (x, p) => formatRounded(x * 100, p),
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": (x) => Math.round(x).toString(16).toUpperCase(),
  "x": (x) => Math.round(x).toString(16)
};

function identity(x) {
  return x;
}

var map = Array.prototype.map,
    prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
function formatLocale(locale) {
  var group = locale.grouping === undefined || locale.thousands === undefined ? identity : formatGroup(map.call(locale.grouping, Number), locale.thousands + ""),
      currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
      currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
      decimal = locale.decimal === undefined ? "." : locale.decimal + "",
      numerals = locale.numerals === undefined ? identity : formatNumerals(map.call(locale.numerals, String)),
      percent = locale.percent === undefined ? "%" : locale.percent + "",
      minus = locale.minus === undefined ? "−" : locale.minus + "",
      nan = locale.nan === undefined ? "NaN" : locale.nan + "";
  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);
    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        trim = specifier.trim,
        type = specifier.type;
    if (type === "n") comma = true, type = "g";
    else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";
    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
    var formatType = formatTypes[type],
        maybeSuffix = /[defgprs%]/.test(type);
    precision = precision === undefined ? 6
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));
    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;
      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;
        var valueNegative = value < 0 || 1 / value < 0;
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
        if (trim) value = formatTrim(value);
        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
        valuePrefix = (valueNegative ? (sign === "(" ? sign : minus) : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }
      if (comma && !zero) value = group(value, Infinity);
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }
      return numerals(value);
    }
    format.toString = function() {
      return specifier + "";
    };
    return format;
  }
  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }
  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
}

var locale;
var format;
var formatPrefix;
defaultLocale({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function defaultLocale(definition) {
  locale = formatLocale(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}

function precisionFixed(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}

function precisionPrefix(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
}

function precisionRound(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, exponent(max) - exponent(step)) + 1;
}

function tickFormat(start, stop, count, specifier) {
  var step = tickStep(start, stop, count),
      precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
      return formatPrefix(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return format(specifier);
}

function linearish(scale) {
  var domain = scale.domain;
  scale.ticks = function(count) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
  };
  scale.tickFormat = function(count, specifier) {
    var d = domain();
    return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
  };
  scale.nice = function(count) {
    if (count == null) count = 10;
    var d = domain();
    var i0 = 0;
    var i1 = d.length - 1;
    var start = d[i0];
    var stop = d[i1];
    var prestep;
    var step;
    var maxIter = 10;
    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }
    while (maxIter-- > 0) {
      step = tickIncrement(start, stop, count);
      if (step === prestep) {
        d[i0] = start;
        d[i1] = stop;
        return domain(d);
      } else if (step > 0) {
        start = Math.floor(start / step) * step;
        stop = Math.ceil(stop / step) * step;
      } else if (step < 0) {
        start = Math.ceil(start * step) / step;
        stop = Math.floor(stop * step) / step;
      } else {
        break;
      }
      prestep = step;
    }
    return scale;
  };
  return scale;
}
function linear() {
  var scale = continuous();
  scale.copy = function() {
    return copy(scale, linear());
  };
  initRange.apply(scale, arguments);
  return linearish(scale);
}

function CircularArcMeter(props) {
  var _props$width, _props$height, _props$height2, _props$width2, _props$height3, _props$width3;
  var size = useDimensions();
  var value = props.value,
      max = props.max;
  var min = 0;
  var duration = 1000;
  var backgroundColor = Colors.MEDIUM_WHITE;
  var _React$useState = React$4.useState(0),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      previousValue = _React$useState2[0],
      setPreviousValue = _React$useState2[1];
  var backgroundArc = arc().innerRadius(0.6).outerRadius(0.7).startAngle(-Math.PI / 1.3).endAngle(Math.PI / 1.3).cornerRadius(1)();
  var percentScale = linear().domain([min, max]).range([0, 1]);
  var percent = percentScale(counter(previousValue, value, 1, 2));
  setTimeout(function () {
    setPreviousValue(value);
  }, duration);
  var angleScale = linear().domain([0, 1]).range([-Math.PI / 1.3, Math.PI / 1.3]).clamp(true);
  var angle = angleScale(percent);
  var filledArc = arc().innerRadius(0.6).outerRadius(0.7).startAngle(-Math.PI / 1.3).endAngle(angle).cornerRadius(1)();
  var colorScale = linear().domain([0, 1]).range([Colors.MEDIUM_BLUE, Colors.BLUE]);
  var gradientSteps = colorScale.ticks(10)
  .map(function (value) {
    return colorScale(value);
  });
  return React$4.createElement("div", {
    style: {
      width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : props.size,
      height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : props.size,
      position: 'relative'
    }
  }, React$4.createElement("svg", {
    style: {
      overflow: 'visible'
    },
    height: (_props$height2 = props.height) !== null && _props$height2 !== void 0 ? _props$height2 : props.size,
    width: (_props$width2 = props.width) !== null && _props$width2 !== void 0 ? _props$width2 : props.size,
    viewBox: [-0.75, -0.6, 1.5, 1].join(' ')
  }, React$4.createElement("defs", null, React$4.createElement("linearGradient", {
    id: "gradient",
    gradientUnits: "userSpaceOnUse",
    x1: -1,
    x2: 1,
    y2: 0
  }, gradientSteps.map(function (color, index) {
    return React$4.createElement("stop", {
      key: color,
      stopColor: color,
      offset: "".concat(index / (gradientSteps.length - 1))
    });
  }))), React$4.createElement("path", {
    d: backgroundArc,
    fill: backgroundColor
  }), React$4.createElement("path", {
    d: filledArc,
    fill: Colors.BLUE,
    style: {
      transition: 'd .3s linear'
    }
  })), React$4.createElement("div", {
    style: {
      position: 'absolute',
      height: (_props$height3 = props.height) !== null && _props$height3 !== void 0 ? _props$height3 : props.size,
      width: (_props$width3 = props.width) !== null && _props$width3 !== void 0 ? _props$width3 : props.size,
      top: 0
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%'
    }
  }, React$4.createElement(Text, {
    fontWeight: 700,
    fontSize: size.width < Breakpoint.sm ? '3em' : '4em'
  }, counter(previousValue, value, 1, 0), "/", props.max), React$4.createElement(Text, {
    fontSize: "1.3em"
  }, props.unit))));
}

function Status(props) {
  var _props$fontSize;
  var _Lang$useTranslation = Lang.useTranslation('chargepoint'),
      _ = _Lang$useTranslation._;
  var renderBackground = function renderBackground(e) {
    switch (e) {
      case 'available':
        return Colors.GREEN;
      case 'charging':
        return Colors.BLUE;
      case 'offline':
        return Colors.GREY;
      case 'unavailable':
        return Colors.ORANGE;
      case 'error':
        return Colors.RED;
      case 'delayed':
        return Colors.PURPLE;
      default:
        return Colors.RED;
    }
  };
  return React$4.createElement("div", {
    style: {
      width: props.size === 'small' ? 4 : 'auto',
      height: 30,
      backgroundColor: renderBackground(props.status),
      borderRadius: 7,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      paddingLeft: props.size === 'small' ? 0 : 15,
      paddingRight: props.size === 'small' ? 0 : 15
    }
  }, props.size !== 'small' && React$4.createElement(Text, {
    fontSize: (_props$fontSize = props.fontSize) !== null && _props$fontSize !== void 0 ? _props$fontSize : '1.1em',
    fontWeight: 500,
    color: Colors.WHITE
  }, "".concat(_("status.".concat(props.status)))));
}

var Row = React$4.forwardRef(function (props, ref) {
  var _props$height;
  return React$4.createElement("tr", {
    ref: ref,
    style: {
      width: '100%',
      height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 'auto',
      backgroundColor: 'transparent',
      borderRadius: props.styling ? 10 : 0,
      borderTop: "solid ".concat(!props.thead ? "2px ".concat(Colors.MEDIUM_WHITE) : '0px transparent'),
      borderBottom: "solid ".concat(!props.thead ? "2px ".concat(Colors.MEDIUM_WHITE) : '0px transparent')
    }
  }, props.columns.length !== 0 ? React$4.createElement(React$4.Fragment, null, React$4.Children.map(props.children, function (child, i) {
    var _props$columns, _props$columns2, _props$columns3;
    return React$4.createElement(React$4.Fragment, {
      key: child.key
    }, React$4.cloneElement(child, {
      columns: props.columns.map(function (e) {
        return {
          id: e.wrap ? e.id : null,
          wrapTitle: e.wrap ? e.wrapTitle : null,
          width: props.columns[i].width
        };
      }).filter(function (_ref) {
        var id = _ref.id;
        return id;
      }),
      wrap: child.type.name === 'Wrap',
      colspan: (child.type.name === 'Wrap' ? ((_props$columns = props.columns) === null || _props$columns === void 0 ? void 0 : _props$columns.length) === 0 || ((_props$columns2 = props.columns) === null || _props$columns2 === void 0 ? void 0 : _props$columns2.length) === i : ((_props$columns3 = props.columns) === null || _props$columns3 === void 0 ? void 0 : _props$columns3.length) === 0) ? null : child.type.name === 'Wrap' ? props.columns[i].width + props.columns[i + 1].width : i > 1 && props.columns[i - 1].wrap ? props.columns[i + 1].width : props.columns[i].width
    }));
  })) : props.children);
});

function Cell(props) {
  return props.wrap ? React$4.createElement("div", {
    style: {
      boxSizing: 'border-box',
      width: '100%',
      paddingLeft: !props.active && props.index === 1 ? 10 : 0
    }
  }, props.children) : React$4.createElement("td", {
    colSpan: props.colspan,
    style: {
      boxSizing: 'border-box'
    }
  }, props.children);
}

function ColumnTitle(props) {
  var _props$textAlign;
  return React$4.createElement(Text, {
    color: Colors.MEDIUM_GREY,
    fontSize: "1em",
    fontWeight: 500,
    textAlign: (_props$textAlign = props.textAlign) !== null && _props$textAlign !== void 0 ? _props$textAlign : 'left'
  }, props.title);
}

function Table(props) {
  var key = function key(index) {
    return new Date().getTime() + index;
  };
  return React$4.createElement("table", {
    cellSpacing: "0",
    style: {
      width: '100%',
      height: 'auto',
      borderCollapse: 'collapse'
    }
  }, React$4.createElement("colgroup", null, _toConsumableArray$5(Array(20)).map(function (e, i) {
    return React$4.createElement("col", {
      key: key(i),
      width: "5%"
    });
  })), props.thead && React$4.createElement("thead", {
    style: {
      paddingBottom: 0,
      width: '100%',
      paddingLeft: 2,
      paddingRight: 2
    }
  }, React$4.createElement(Row, {
    gap: props.gap,
    columns: [],
    thead: true
  }, props.columns.map(function (e) {
    var _e$wrapTitle;
    return React$4.createElement(Cell, {
      key: e.id,
      colspan: e.width
    }, React$4.createElement("div", {
      style: {
        paddingBottom: 7,
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
        justifyContent: e.titleTextAlign === 'right' ? 'flex-end' : 'flex-start'
      }
    }, (!e.wrap || e.wrapTitle) && React$4.createElement(ColumnTitle, {
      title: (_e$wrapTitle = e.wrapTitle) !== null && _e$wrapTitle !== void 0 ? _e$wrapTitle : e.title,
      textAlign: e.titleTextAlign
    })));
  }))), React$4.createElement("tbody", null, React$4.Children.map(props.children, function (child) {
    return React$4.createElement(React$4.Fragment, {
      key: child.key
    }, React$4.cloneElement(child, {
      columns: props.columns
    }));
  })));
}

function Wrap(props) {
  return React$4.createElement("td", {
    colSpan: props.colspan,
    style: _objectSpread2({}, props.style)
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: props.active ? 'column' : 'row',
      width: '100%'
    }
  }, React$4.Children.map(props.children, function (child, i) {
    var _props$columns$i;
    return React$4.createElement(React$4.Fragment, {
      key: child.key
    }, React$4.cloneElement(child, {
      column: (_props$columns$i = props.columns[i]) !== null && _props$columns$i !== void 0 ? _props$columns$i : [],
      index: i,
      wrap: props.wrap,
      active: props.active,
      width: props.width,
      style: {
        minHeight: props.active ? 60 : 'auto'
      }
    }));
  })));
}

function CustomModal(props) {
  var size = useDimensions();
  var onBackgroundClick = function onBackgroundClick(e) {
    if (e.target === e.currentTarget) props.onClose();
  };
  var _onKeyDown = function onKeyDown(e) {
    if (e.key === 'Escape') {
      props.onClose();
    }
  };
  return React$4.createElement("div", {
    tabIndex: 0,
    role: "button",
    onKeyDown: function onKeyDown(e) {
      return _onKeyDown(e);
    },
    onClick: onBackgroundClick,
    style: {
      width: '100vw',
      height: '100vh',
      position: 'fixed',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 2147483003,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "".concat(Colors.GREY, "25")
    }
  }, React$4.createElement("div", {
    style: {
      minHeight: 300,
      maxHeight: size.width < Breakpoint.sm ? '90%' : '80%',
      height: '100%',
      width: size.width < Breakpoint.sm ? '100%' : '60%',
      maxWidth: size.width < Breakpoint.sm ? '95%' : 640,
      overflow: 'hidden',
      position: 'relative'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      flex: 'auto',
      height: '100%'
    }
  }, React$4.createElement("div", {
    style: {
      height: 60,
      maxHeight: 60,
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
      flex: 'auto'
    }
  }, React$4.createElement("button", {
    type: "button",
    className: "Hover",
    onClick: function onClick() {
      return props.onClose();
    },
    style: {
      height: 58,
      width: 58,
      backgroundColor: 'transparent',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-end',
      border: 'solid 0px transparent',
      marginRight: 10
    }
  }, React$4.createElement(Icon, {
    name: "Times",
    height: 25,
    width: 25,
    color: Colors.GREY,
    iconSet: "Feather"
  }))), props.children)));
}

var Item$4 = function Item(_ref) {
  var _data$minWidth;
  var data = _ref.data,
      styling = _ref.styling,
      _onMouseEnter = _ref.onMouseEnter,
      _onMouseLeave = _ref.onMouseLeave;
  return React$4.createElement(React$4.Fragment, null, data.keepOpen && React$4.createElement("div", {
    onMouseEnter: function onMouseEnter() {
      return _onMouseEnter();
    },
    onMouseLeave: function onMouseLeave() {
      return _onMouseLeave();
    },
    style: {
      position: 'absolute',
      backgroundColor: 'transparent',
      height: 50,
      width: 50,
      left: 0
    }
  }), React$4.createElement("div", {
    onMouseEnter: function onMouseEnter() {
      if (data.keepOpen) _onMouseEnter();
    },
    onMouseLeave: function onMouseLeave() {
      if (data.keepOpen) _onMouseLeave();
    },
    style: {
      position: 'absolute',
      width: 'auto',
      maxWidth: 500,
      height: 'auto',
      right: data.left !== undefined ? typeof data.left === 'boolean' ? 32 : data.left : false,
      left: data.right !== undefined ? typeof data.right === 'boolean' ? 32 : data.right : false,
      top: data.bottom !== undefined ? typeof data.bottom === 'boolean' ? 32 : data.bottom : false,
      bottom: data.top !== undefined ? typeof data.top === 'boolean' ? 32 : data.top : false
    }
  }, React$4.createElement("div", {
    style: {
      position: 'relative',
      display: 'flex',
      flexDirection: styling.flexDirection,
      justifyContent: styling.justifyContent,
      alignItems: styling.alignItems,
      width: '100%',
      height: '100%'
    }
  }, React$4.createElement("div", {
    style: {
      height: 15,
      width: 15,
      backgroundColor: Colors.GREY,
      transform: 'rotate(45deg)',
      position: 'absolute',
      right: styling.right,
      left: styling.left,
      top: styling.top,
      bottom: styling.bottom,
      zIndex: 0
    }
  }), React$4.createElement("div", {
    style: {
      width: '100%',
      minWidth: (_data$minWidth = data.minWidth) !== null && _data$minWidth !== void 0 ? _data$minWidth : 200,
      height: 'auto',
      minHeight: 25,
      backgroundColor: Colors.GREY,
      position: 'relative',
      zIndex: 1,
      borderRadius: 10,
      marginRight: data.left && 3,
      marginLeft: data.right && 3,
      padding: 10
    }
  }, React$4.createElement(Text, {
    color: Colors.MEDIUM_WHITE,
    fontSize: "1em"
  }, data.text)))));
};
function Tooltip(props) {
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      active = _React$useState2[0],
      setActive = _React$useState2[1];
  var getStyling = function getStyling() {
    var style = {};
    if (props.left !== undefined && props.top !== undefined) {
      style = {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        right: 0,
        bottom: 7
      };
    } else if (props.left !== undefined && props.bottom !== undefined) {
      style = {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        right: 0,
        top: 7
      };
    } else if (props.right !== undefined && props.top !== undefined) {
      style = {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        left: 0,
        bottom: 7
      };
    } else if (props.right !== undefined && props.bottom !== undefined) {
      style = {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        left: 0,
        top: 7
      };
    } else if (props.left !== undefined) {
      style = {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        right: 0
      };
    } else if (props.right !== undefined) {
      style = {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        left: 0
      };
    } else if (props.top !== undefined) {
      style = {
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        bottom: -3
      };
    } else if (props.bottom !== undefined) {
      style = {
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'center',
        top: -3
      };
    } else {
      style = {
        flexDirection: 'row'
      };
    }
    return style;
  };
  return React$4.createElement("div", {
    ref: props.tipRef,
    style: {
      height: '100%',
      position: 'absolute',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start'
    }
  }, props.visible && React$4.createElement(Item$4, {
    data: props,
    styling: getStyling(),
    active: active,
    onMouseEnter: function onMouseEnter() {
      return setActive(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setActive(false);
    }
  }), props.visible === undefined && React$4.createElement("div", {
    onMouseEnter: function onMouseEnter() {
      return setActive(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setActive(false);
    },
    style: {
      height: 22,
      width: 23,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative'
    }
  }, React$4.createElement(Icon, {
    name: "InfoCircle",
    height: 20,
    width: 20,
    color: Colors.GREY,
    iconSet: "FA"
  }), active && React$4.createElement(Item$4, {
    data: props,
    styling: getStyling(),
    onMouseEnter: function onMouseEnter() {
      return setActive(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setActive(false);
    }
  })));
}

function Boolean$1(props) {
  var _props$icon$height, _props$icon$width, _props$customTooltip, _props$customTooltip2;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      tooltip = _React$useState2[0],
      setTooltip = _React$useState2[1];
  var _React$useState3 = React$4.useState(false),
      _React$useState4 = _slicedToArray$5(_React$useState3, 2),
      tooltipError = _React$useState4[0],
      setTooltipError = _React$useState4[1];
  var _React$useState5 = React$4.useState(false),
      _React$useState6 = _slicedToArray$5(_React$useState5, 2),
      tooltipPermission = _React$useState6[0],
      setTooltipPermission = _React$useState6[1];
  return React$4.createElement("div", {
    style: {
      width: '100%',
      height: props.subTitle ? 75 : 35,
      paddingTop: props.subTitle ? 5 : 0,
      paddingBottom: props.subTitle ? 5 : 0
    }
  }, React$4.createElement("div", {
    style: {
      height: 35,
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      height: 35,
      alignItems: 'center'
    }
  }, props.icon && React$4.createElement("div", {
    style: {
      height: 35,
      width: 35,
      marginRight: 5,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start'
    }
  }, React$4.createElement(Icon, {
    name: props.icon.name,
    height: (_props$icon$height = props.icon.height) !== null && _props$icon$height !== void 0 ? _props$icon$height : 35,
    width: (_props$icon$width = props.icon.width) !== null && _props$icon$width !== void 0 ? _props$icon$width : 35,
    color: props.icon.color,
    iconSet: props.icon.iconSet
  })), React$4.createElement(Text, {
    color: props.disabled || props.noPermission ? Colors.MEDIUM_GREY : Colors.GREY
  }, props.title)), React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    }
  }, !props.disabled && !props.noPermission && props.suffix && React$4.createElement("div", {
    style: {
      marginRight: 15
    }
  }, React$4.createElement(Text, {
    fontSize: "1em",
    color: Colors.GREY
  }, props.suffix)), ((_props$customTooltip = props.customTooltip) === null || _props$customTooltip === void 0 ? void 0 : _props$customTooltip.visible) && React$4.createElement("div", {
    onMouseEnter: function onMouseEnter() {
      setTooltip(true);
    },
    onMouseLeave: function onMouseLeave() {
      setTooltip(false);
    },
    style: {
      marginRight: 15,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 3,
      position: 'relative'
    }
  }, React$4.createElement(Icon, {
    iconSet: "FA",
    name: "InfoCircle",
    type: "light",
    color: Colors.GREY,
    width: 20,
    height: 20
  }), React$4.createElement(Tooltip, {
    visible: tooltip,
    text: (_props$customTooltip2 = props.customTooltip) === null || _props$customTooltip2 === void 0 ? void 0 : _props$customTooltip2.text,
    left: true
  })), props.error && React$4.createElement("div", {
    onMouseEnter: function onMouseEnter() {
      setTooltipError(true);
    },
    onMouseLeave: function onMouseLeave() {
      setTooltipError(false);
    },
    style: {
      marginRight: 15,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 3,
      position: 'relative'
    }
  }, React$4.createElement(Icon, {
    name: "ExclamationTriangle",
    color: Colors.ORANGE,
    type: "solid",
    width: 20,
    height: 20,
    iconSet: "FA"
  }), React$4.createElement(Tooltip, {
    visible: props.tooltip.error && tooltipError,
    text: props.tooltip.error,
    left: true
  })), props.noPermission && React$4.createElement("div", {
    onMouseEnter: function onMouseEnter() {
      setTooltipPermission(true);
    },
    onMouseLeave: function onMouseLeave() {
      setTooltipPermission(false);
    },
    style: {
      marginRight: 15,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 3,
      position: 'relative'
    }
  }, React$4.createElement(Icon, {
    iconSet: "FA",
    name: "Lock",
    type: "solid",
    color: Colors.MEDIUM_GREY,
    width: 15,
    height: 15
  }), React$4.createElement(Tooltip, {
    visible: props.tooltip.permission && tooltipPermission,
    text: props.tooltip.permission,
    left: true
  })), React$4.createElement(Inputs, {
    type: "switch",
    value: props.value,
    onClick: props.onSwitch,
    disabled: props.disabled || props.noPermission
  }))), props.subTitle && React$4.createElement("div", {
    style: {
      height: 20,
      marginLeft: props.icon ? 40 : 0
    }
  }, React$4.createElement(Text, {
    fontSize: "1em",
    color: props.disabled || props.noPermission ? Colors.MEDIUM_GREY : Colors.GREY
  }, props.subTitle)));
}

function Item$3(props) {
  var _props$justifyContent, _props$fontWeight, _props$fontSize, _props$color;
  return React$4.createElement("div", {
    style: {
      height: 'auto',
      paddingTop: props.justifyContent ? 0.5 : 5,
      paddingBottom: props.justifyContent ? 0.5 : 5,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: (_props$justifyContent = props.justifyContent) !== null && _props$justifyContent !== void 0 ? _props$justifyContent : 'space-between'
    }
  }, props.title && React$4.createElement(Text, {
    fontWeight: (_props$fontWeight = props.fontWeight) !== null && _props$fontWeight !== void 0 ? _props$fontWeight : 500,
    textAlign: props.textAlign,
    fontSize: (_props$fontSize = props.fontSize) !== null && _props$fontSize !== void 0 ? _props$fontSize : '1.25em',
    color: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY
  }, props.title), props.subTitle && React$4.createElement(Text, {
    fontSize: "1em",
    color: Colors.MEDIUM_GREY,
    textAlign: props.textAlign
  }, props.subTitle));
}

function Button$1(props) {
  var _props$icon$height, _props$icon$width;
  var size = useDimensions();
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      tooltipError = _React$useState2[0],
      setTooltipError = _React$useState2[1];
  var _React$useState3 = React$4.useState(false),
      _React$useState4 = _slicedToArray$5(_React$useState3, 2),
      tooltipPermission = _React$useState4[0],
      setTooltipPermission = _React$useState4[1];
  return React$4.createElement("button", {
    type: "button",
    className: !props.disabled ? 'Hover' : 'Disabled',
    onClick: !props.disabled && !props.noPermission ? props.onClick : null,
    style: {
      width: '100%',
      height: props.subTitle ? 75 : 35,
      paddingTop: props.subTitle ? 5 : 0,
      paddingBottom: props.subTitle ? 5 : 0,
      backgroundColor: 'transparent',
      fontSize: '1em',
      border: 'solid 0px transparent',
      textAlign: 'left',
      paddingLeft: 0,
      paddingRight: 0
    }
  }, React$4.createElement("div", {
    style: {
      height: 35,
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      height: 35,
      alignItems: 'center'
    }
  }, props.icon && React$4.createElement("div", {
    style: {
      height: 35,
      width: 35,
      marginRight: 5,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start'
    }
  }, React$4.createElement(Icon, {
    name: props.icon.name,
    height: (_props$icon$height = props.icon.height) !== null && _props$icon$height !== void 0 ? _props$icon$height : 35,
    width: (_props$icon$width = props.icon.width) !== null && _props$icon$width !== void 0 ? _props$icon$width : 35,
    color: props.icon.color,
    iconSet: props.icon.iconSet
  })), React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: size.width < Breakpoint.sm ? 'column' : 'row',
      justifyContent: size.width < Breakpoint.sm ? 'center' : 'flex-start',
      alignItems: size.width >= Breakpoint.sm ? 'center' : 'flex-start'
    }
  }, React$4.createElement(Text, {
    color: props.disabled || props.noPermission ? Colors.MEDIUM_GREY : Colors.GREY
  }, props.title), props.suffix && size.width < Breakpoint.sm && React$4.createElement("div", {
    style: {
      marginTop: 5
    }
  }, React$4.createElement(Text, {
    fontSize: "1em",
    color: props.disabled || props.noPermission ? Colors.MEDIUM_GREY : Colors.GREY
  }, props.suffix)))), React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    }
  }, size.width >= Breakpoint.sm && !props.noPermission && props.suffix && React$4.createElement("div", {
    style: {
      marginRight: 15
    }
  }, React$4.createElement(Text, {
    fontSize: "1em",
    color: props.disabled || props.noPermission ? Colors.MEDIUM_GREY : Colors.GREY
  }, props.suffix)), props.error && React$4.createElement("div", {
    onMouseEnter: function onMouseEnter() {
      setTooltipError(true);
    },
    onMouseLeave: function onMouseLeave() {
      setTooltipError(false);
    },
    style: {
      marginRight: 15,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 3,
      position: 'relative'
    }
  }, React$4.createElement(Icon, {
    name: "ExclamationTriangle",
    color: Colors.ORANGE,
    type: "solid",
    width: 20,
    height: 20,
    iconSet: "FA"
  }), React$4.createElement(Tooltip, {
    visible: props.tooltip.error && tooltipError,
    text: props.tooltip.error,
    left: true
  })), props.noPermission && React$4.createElement("div", {
    onMouseEnter: function onMouseEnter() {
      setTooltipPermission(true);
    },
    onMouseLeave: function onMouseLeave() {
      setTooltipPermission(false);
    },
    style: {
      marginRight: 15,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 3,
      position: 'relative'
    }
  }, React$4.createElement(Icon, {
    iconSet: "FA",
    name: "Lock",
    type: "solid",
    color: Colors.MEDIUM_GREY,
    width: 15,
    height: 15
  }), React$4.createElement(Tooltip, {
    visible: props.tooltip.permission && tooltipPermission,
    text: props.tooltip.permission,
    left: true
  })), React$4.createElement("div", {
    style: {
      height: 30,
      width: 30,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, React$4.createElement(Icon, {
    name: "AngleRight",
    height: 30,
    width: 30,
    color: props.disabled || props.noPermission ? Colors.MEDIUM_GREY : Colors.DARK_GREY,
    iconSet: "FA"
  })))), props.subTitle && React$4.createElement("div", {
    style: {
      height: 20,
      marginLeft: props.icon ? 40 : 0
    }
  }, React$4.createElement(Text, {
    fontSize: "1em",
    color: props.disabled || props.noPermission ? Colors.MEDIUM_GREY : Colors.GREY
  }, props.subTitle)));
}

function Items(props) {
  var renderButtons = function renderButtons() {
    switch (props.type) {
      case 'boolean':
        return React$4.createElement(Boolean$1, {
          title: props.title,
          subTitle: props.subTitle,
          suffix: props.suffix,
          value: props.value,
          disabled: props.disabled,
          onSwitch: props.onSwitch,
          colorScheme: getColorScheme(props.colorScheme),
          icon: props.icon,
          error: props.error,
          noPermission: props.noPermission,
          tooltip: props.tooltip,
          customTooltip: props.customTooltip
        });
      case 'text':
        return React$4.createElement(Item$3, {
          title: props.title,
          subTitle: props.subTitle,
          textAlign: props.textAlign,
          justifyContent: props.justifyContent,
          fontWeight: props.fontWeight,
          fontSize: props.fontSize,
          color: props.color
        });
      case 'button':
        return React$4.createElement(Button$1, {
          title: props.title,
          subTitle: props.subTitle,
          suffix: props.suffix,
          value: props.value,
          disabled: props.disabled,
          onClick: props.onClick,
          colorScheme: getColorScheme(props.colorScheme),
          icon: props.icon,
          error: props.error,
          noPermission: props.noPermission,
          tooltip: props.tooltip
        });
      default:
        return React$4.createElement(Boolean$1, {
          title: props.title,
          subTitle: props.subTitle,
          suffix: props.suffix,
          value: props.value,
          onSwitch: props.onSwitch,
          disabled: props.disabled,
          colorScheme: getColorScheme(props.colorScheme),
          icon: props.icon,
          error: props.error,
          noPermission: props.noPermission,
          tooltip: props.tooltip,
          customTooltip: props.customTooltip
        });
    }
  };
  return React$4.createElement(React$4.Fragment, null, renderButtons());
}

function AppStore$2(props) {
  var _props$width, _props$height;
  return React$4.createElement("svg", {
    id: "livetype",
    xmlns: "http://www.w3.org/2000/svg",
    className: "Badge",
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 119.66407,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 40,
    viewBox: "0 0 119.66407 40"
  }, React$4.createElement("title", null, "Download on the App Store Badge"), React$4.createElement("g", null, React$4.createElement("g", null, React$4.createElement("g", null, React$4.createElement("path", {
    d: "M110.13477,0H9.53468c-.3667,0-.729,0-1.09473.002-.30615.002-.60986.00781-.91895.0127A13.21476,13.21476,0,0,0,5.5171.19141a6.66509,6.66509,0,0,0-1.90088.627A6.43779,6.43779,0,0,0,1.99757,1.99707,6.25844,6.25844,0,0,0,.81935,3.61816a6.60119,6.60119,0,0,0-.625,1.90332,12.993,12.993,0,0,0-.1792,2.002C.00587,7.83008.00489,8.1377,0,8.44434V31.5586c.00489.3105.00587.6113.01515.9219a12.99232,12.99232,0,0,0,.1792,2.0019,6.58756,6.58756,0,0,0,.625,1.9043A6.20778,6.20778,0,0,0,1.99757,38.001a6.27445,6.27445,0,0,0,1.61865,1.1787,6.70082,6.70082,0,0,0,1.90088.6308,13.45514,13.45514,0,0,0,2.0039.1768c.30909.0068.6128.0107.91895.0107C8.80567,40,9.168,40,9.53468,40H110.13477c.3594,0,.7246,0,1.084-.002.3047,0,.6172-.0039.9219-.0107a13.279,13.279,0,0,0,2-.1768,6.80432,6.80432,0,0,0,1.9082-.6308,6.27742,6.27742,0,0,0,1.6172-1.1787,6.39482,6.39482,0,0,0,1.1816-1.6143,6.60413,6.60413,0,0,0,.6191-1.9043,13.50643,13.50643,0,0,0,.1856-2.0019c.0039-.3106.0039-.6114.0039-.9219.0078-.3633.0078-.7246.0078-1.0938V9.53613c0-.36621,0-.72949-.0078-1.09179,0-.30664,0-.61426-.0039-.9209a13.5071,13.5071,0,0,0-.1856-2.002,6.6177,6.6177,0,0,0-.6191-1.90332,6.46619,6.46619,0,0,0-2.7988-2.7998,6.76754,6.76754,0,0,0-1.9082-.627,13.04394,13.04394,0,0,0-2-.17676c-.3047-.00488-.6172-.01074-.9219-.01269-.3594-.002-.7246-.002-1.084-.002Z",
    style: {
      fill: '#a6a6a6'
    }
  }), React$4.createElement("path", {
    d: "M8.44483,39.125c-.30468,0-.602-.0039-.90429-.0107a12.68714,12.68714,0,0,1-1.86914-.1631,5.88381,5.88381,0,0,1-1.65674-.5479,5.40573,5.40573,0,0,1-1.397-1.0166,5.32082,5.32082,0,0,1-1.02051-1.3965,5.72186,5.72186,0,0,1-.543-1.6572,12.41351,12.41351,0,0,1-.1665-1.875c-.00634-.2109-.01464-.9131-.01464-.9131V8.44434S.88185,7.75293.8877,7.5498a12.37039,12.37039,0,0,1,.16553-1.87207,5.7555,5.7555,0,0,1,.54346-1.6621A5.37349,5.37349,0,0,1,2.61183,2.61768,5.56543,5.56543,0,0,1,4.01417,1.59521a5.82309,5.82309,0,0,1,1.65332-.54394A12.58589,12.58589,0,0,1,7.543.88721L8.44532.875H111.21387l.9131.0127a12.38493,12.38493,0,0,1,1.8584.16259,5.93833,5.93833,0,0,1,1.6709.54785,5.59374,5.59374,0,0,1,2.415,2.41993,5.76267,5.76267,0,0,1,.5352,1.64892,12.995,12.995,0,0,1,.1738,1.88721c.0029.2832.0029.5874.0029.89014.0079.375.0079.73193.0079,1.09179V30.4648c0,.3633,0,.7178-.0079,1.0752,0,.3252,0,.6231-.0039.9297a12.73126,12.73126,0,0,1-.1709,1.8535,5.739,5.739,0,0,1-.54,1.67,5.48029,5.48029,0,0,1-1.0156,1.3857,5.4129,5.4129,0,0,1-1.3994,1.0225,5.86168,5.86168,0,0,1-1.668.5498,12.54218,12.54218,0,0,1-1.8692.1631c-.2929.0068-.5996.0107-.8974.0107l-1.084.002Z"
  })), React$4.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, React$4.createElement("g", {
    id: "_Group_2",
    "data-name": "<Group>"
  }, React$4.createElement("g", {
    id: "_Group_3",
    "data-name": "<Group>"
  }, React$4.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    d: "M24.76888,20.30068a4.94881,4.94881,0,0,1,2.35656-4.15206,5.06566,5.06566,0,0,0-3.99116-2.15768c-1.67924-.17626-3.30719,1.00483-4.1629,1.00483-.87227,0-2.18977-.98733-3.6085-.95814a5.31529,5.31529,0,0,0-4.47292,2.72787c-1.934,3.34842-.49141,8.26947,1.3612,10.97608.9269,1.32535,2.01018,2.8058,3.42763,2.7533,1.38706-.05753,1.9051-.88448,3.5794-.88448,1.65876,0,2.14479.88448,3.591.8511,1.48838-.02416,2.42613-1.33124,3.32051-2.66914a10.962,10.962,0,0,0,1.51842-3.09251A4.78205,4.78205,0,0,1,24.76888,20.30068Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    id: "_Path_2",
    "data-name": "<Path>",
    d: "M22.03725,12.21089a4.87248,4.87248,0,0,0,1.11452-3.49062,4.95746,4.95746,0,0,0-3.20758,1.65961,4.63634,4.63634,0,0,0-1.14371,3.36139A4.09905,4.09905,0,0,0,22.03725,12.21089Z",
    style: {
      fill: '#ffffff'
    }
  }))), React$4.createElement("g", null, React$4.createElement("path", {
    d: "M42.30227,27.13965h-4.7334l-1.13672,3.35645H34.42727l4.4834-12.418h2.083l4.4834,12.418H43.438ZM38.0591,25.59082h3.752l-1.84961-5.44727h-.05176Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M55.15969,25.96973c0,2.81348-1.50586,4.62109-3.77832,4.62109a3.0693,3.0693,0,0,1-2.84863-1.584h-.043v4.48438h-1.8584V21.44238H48.4302v1.50586h.03418a3.21162,3.21162,0,0,1,2.88281-1.60059C53.645,21.34766,55.15969,23.16406,55.15969,25.96973Zm-1.91016,0c0-1.833-.94727-3.03809-2.39258-3.03809-1.41992,0-2.375,1.23047-2.375,3.03809,0,1.82422.95508,3.0459,2.375,3.0459C52.30227,29.01563,53.24953,27.81934,53.24953,25.96973Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M65.12453,25.96973c0,2.81348-1.50586,4.62109-3.77832,4.62109a3.0693,3.0693,0,0,1-2.84863-1.584h-.043v4.48438h-1.8584V21.44238H58.395v1.50586h.03418A3.21162,3.21162,0,0,1,61.312,21.34766C63.60988,21.34766,65.12453,23.16406,65.12453,25.96973Zm-1.91016,0c0-1.833-.94727-3.03809-2.39258-3.03809-1.41992,0-2.375,1.23047-2.375,3.03809,0,1.82422.95508,3.0459,2.375,3.0459C62.26711,29.01563,63.21438,27.81934,63.21438,25.96973Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M71.71047,27.03613c.1377,1.23145,1.334,2.04,2.96875,2.04,1.56641,0,2.69336-.80859,2.69336-1.91895,0-.96387-.67969-1.541-2.28906-1.93652l-1.60937-.3877c-2.28027-.55078-3.33887-1.61719-3.33887-3.34766,0-2.14258,1.86719-3.61426,4.51855-3.61426,2.624,0,4.42285,1.47168,4.4834,3.61426h-1.876c-.1123-1.23926-1.13672-1.9873-2.63379-1.9873s-2.52148.75684-2.52148,1.8584c0,.87793.6543,1.39453,2.25488,1.79l1.36816.33594c2.54785.60254,3.60645,1.626,3.60645,3.44238,0,2.32324-1.85059,3.77832-4.79395,3.77832-2.75391,0-4.61328-1.4209-4.7334-3.667Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M83.34621,19.2998v2.14258h1.72168v1.47168H83.34621v4.99121c0,.77539.34473,1.13672,1.10156,1.13672a5.80752,5.80752,0,0,0,.61133-.043v1.46289a5.10351,5.10351,0,0,1-1.03223.08594c-1.833,0-2.54785-.68848-2.54785-2.44434V22.91406H80.16262V21.44238H81.479V19.2998Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M86.065,25.96973c0-2.84863,1.67773-4.63867,4.29395-4.63867,2.625,0,4.29492,1.79,4.29492,4.63867,0,2.85645-1.66113,4.63867-4.29492,4.63867C87.72609,30.6084,86.065,28.82617,86.065,25.96973Zm6.69531,0c0-1.9541-.89551-3.10742-2.40137-3.10742s-2.40039,1.16211-2.40039,3.10742c0,1.96191.89453,3.10645,2.40039,3.10645S92.76027,27.93164,92.76027,25.96973Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M96.18606,21.44238h1.77246v1.541h.043a2.1594,2.1594,0,0,1,2.17773-1.63574,2.86616,2.86616,0,0,1,.63672.06934v1.73828a2.59794,2.59794,0,0,0-.835-.1123,1.87264,1.87264,0,0,0-1.93652,2.083v5.37012h-1.8584Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M109.3843,27.83691c-.25,1.64355-1.85059,2.77148-3.89844,2.77148-2.63379,0-4.26855-1.76465-4.26855-4.5957,0-2.83984,1.64355-4.68164,4.19043-4.68164,2.50488,0,4.08008,1.7207,4.08008,4.46582v.63672h-6.39453v.1123a2.358,2.358,0,0,0,2.43555,2.56445,2.04834,2.04834,0,0,0,2.09082-1.27344Zm-6.28223-2.70215h4.52637a2.1773,2.1773,0,0,0-2.2207-2.29785A2.292,2.292,0,0,0,103.10207,25.13477Z",
    style: {
      fill: '#ffffff'
    }
  })))), React$4.createElement("g", {
    id: "_Group_4",
    "data-name": "<Group>"
  }, React$4.createElement("g", null, React$4.createElement("path", {
    d: "M37.82619,8.731a2.63964,2.63964,0,0,1,2.80762,2.96484c0,1.90625-1.03027,3.002-2.80762,3.002H35.67092V8.731Zm-1.22852,5.123h1.125a1.87588,1.87588,0,0,0,1.96777-2.146,1.881,1.881,0,0,0-1.96777-2.13379h-1.125Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M41.68068,12.44434a2.13323,2.13323,0,1,1,4.24707,0,2.13358,2.13358,0,1,1-4.24707,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C44.57522,13.99463,45.01369,13.42432,45.01369,12.44434Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M51.57326,14.69775h-.92187l-.93066-3.31641h-.07031l-.92676,3.31641h-.91309l-1.24121-4.50293h.90137l.80664,3.436h.06641l.92578-3.436h.85254l.92578,3.436h.07031l.80273-3.436h.88867Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M53.85354,10.19482H54.709v.71533h.06641a1.348,1.348,0,0,1,1.34375-.80225,1.46456,1.46456,0,0,1,1.55859,1.6748v2.915h-.88867V12.00586c0-.72363-.31445-1.0835-.97168-1.0835a1.03294,1.03294,0,0,0-1.0752,1.14111v2.63428h-.88867Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M59.09377,8.437h.88867v6.26074h-.88867Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M61.21779,12.44434a2.13346,2.13346,0,1,1,4.24756,0,2.1338,2.1338,0,1,1-4.24756,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C64.11232,13.99463,64.5508,13.42432,64.5508,12.44434Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M66.4009,13.42432c0-.81055.60352-1.27783,1.6748-1.34424l1.21973-.07031v-.38867c0-.47559-.31445-.74414-.92187-.74414-.49609,0-.83984.18213-.93848.50049h-.86035c.09082-.77344.81836-1.26953,1.83984-1.26953,1.12891,0,1.76563.562,1.76563,1.51318v3.07666h-.85547v-.63281h-.07031a1.515,1.515,0,0,1-1.35254.707A1.36026,1.36026,0,0,1,66.4009,13.42432Zm2.89453-.38477v-.37646l-1.09961.07031c-.62012.0415-.90137.25244-.90137.64941,0,.40527.35156.64111.835.64111A1.0615,1.0615,0,0,0,69.29543,13.03955Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M71.34816,12.44434c0-1.42285.73145-2.32422,1.86914-2.32422a1.484,1.484,0,0,1,1.38086.79h.06641V8.437h.88867v6.26074h-.85156v-.71143h-.07031a1.56284,1.56284,0,0,1-1.41406.78564C72.0718,14.772,71.34816,13.87061,71.34816,12.44434Zm.918,0c0,.95508.4502,1.52979,1.20313,1.52979.749,0,1.21191-.583,1.21191-1.52588,0-.93848-.46777-1.52979-1.21191-1.52979C72.72121,10.91846,72.26613,11.49707,72.26613,12.44434Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M79.23,12.44434a2.13323,2.13323,0,1,1,4.24707,0,2.13358,2.13358,0,1,1-4.24707,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C82.12453,13.99463,82.563,13.42432,82.563,12.44434Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M84.66945,10.19482h.85547v.71533h.06641a1.348,1.348,0,0,1,1.34375-.80225,1.46456,1.46456,0,0,1,1.55859,1.6748v2.915H87.605V12.00586c0-.72363-.31445-1.0835-.97168-1.0835a1.03294,1.03294,0,0,0-1.0752,1.14111v2.63428h-.88867Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M93.51516,9.07373v1.1416h.97559v.74854h-.97559V13.2793c0,.47168.19434.67822.63672.67822a2.96657,2.96657,0,0,0,.33887-.02051v.74023a2.9155,2.9155,0,0,1-.4834.04541c-.98828,0-1.38184-.34766-1.38184-1.21582v-2.543h-.71484v-.74854h.71484V9.07373Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M95.70461,8.437h.88086v2.48145h.07031a1.3856,1.3856,0,0,1,1.373-.80664,1.48339,1.48339,0,0,1,1.55078,1.67871v2.90723H98.69v-2.688c0-.71924-.335-1.0835-.96289-1.0835a1.05194,1.05194,0,0,0-1.13379,1.1416v2.62988h-.88867Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M104.76125,13.48193a1.828,1.828,0,0,1-1.95117,1.30273A2.04531,2.04531,0,0,1,100.73,12.46045a2.07685,2.07685,0,0,1,2.07617-2.35254c1.25293,0,2.00879.856,2.00879,2.27V12.688h-3.17969v.0498a1.1902,1.1902,0,0,0,1.19922,1.29,1.07934,1.07934,0,0,0,1.07129-.5459Zm-3.126-1.45117h2.27441a1.08647,1.08647,0,0,0-1.1084-1.1665A1.15162,1.15162,0,0,0,101.63527,12.03076Z",
    style: {
      fill: '#ffffff'
    }
  })))));
}

function AppStore$1(props) {
  var _props$width, _props$height;
  return React$4.createElement("svg", {
    id: "livetype",
    xmlns: "http://www.w3.org/2000/svg",
    className: "Badge",
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 119.66407,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 40,
    viewBox: "0 0 119.66407 40"
  }, React$4.createElement("title", null, "Download on the App Store"), React$4.createElement("g", null, React$4.createElement("g", null, React$4.createElement("g", null, React$4.createElement("path", {
    d: "M110.13477,0H9.53468c-.3667,0-.729,0-1.09473.002-.30615.002-.60986.00781-.91895.0127A13.21476,13.21476,0,0,0,5.5171.19141a6.66509,6.66509,0,0,0-1.90088.627A6.43779,6.43779,0,0,0,1.99757,1.99707,6.25844,6.25844,0,0,0,.81935,3.61816a6.60119,6.60119,0,0,0-.625,1.90332,12.993,12.993,0,0,0-.1792,2.002C.00587,7.83008.00489,8.1377,0,8.44434V31.5586c.00489.3105.00587.6113.01515.9219a12.99232,12.99232,0,0,0,.1792,2.0019,6.58756,6.58756,0,0,0,.625,1.9043A6.20778,6.20778,0,0,0,1.99757,38.001a6.27445,6.27445,0,0,0,1.61865,1.1787,6.70082,6.70082,0,0,0,1.90088.6308,13.45514,13.45514,0,0,0,2.0039.1768c.30909.0068.6128.0107.91895.0107C8.80567,40,9.168,40,9.53468,40H110.13477c.3594,0,.7246,0,1.084-.002.3047,0,.6172-.0039.9219-.0107a13.279,13.279,0,0,0,2-.1768,6.80432,6.80432,0,0,0,1.9082-.6308,6.27742,6.27742,0,0,0,1.6172-1.1787,6.39482,6.39482,0,0,0,1.1816-1.6143,6.60413,6.60413,0,0,0,.6191-1.9043,13.50643,13.50643,0,0,0,.1856-2.0019c.0039-.3106.0039-.6114.0039-.9219.0078-.3633.0078-.7246.0078-1.0938V9.53613c0-.36621,0-.72949-.0078-1.09179,0-.30664,0-.61426-.0039-.9209a13.5071,13.5071,0,0,0-.1856-2.002,6.6177,6.6177,0,0,0-.6191-1.90332,6.46619,6.46619,0,0,0-2.7988-2.7998,6.76754,6.76754,0,0,0-1.9082-.627,13.04394,13.04394,0,0,0-2-.17676c-.3047-.00488-.6172-.01074-.9219-.01269-.3594-.002-.7246-.002-1.084-.002Z",
    style: {
      fill: '#a6a6a6'
    }
  }), React$4.createElement("path", {
    d: "M8.44483,39.125c-.30468,0-.602-.0039-.90429-.0107a12.68714,12.68714,0,0,1-1.86914-.1631,5.88381,5.88381,0,0,1-1.65674-.5479,5.40573,5.40573,0,0,1-1.397-1.0166,5.32082,5.32082,0,0,1-1.02051-1.3965,5.72186,5.72186,0,0,1-.543-1.6572,12.41351,12.41351,0,0,1-.1665-1.875c-.00634-.2109-.01464-.9131-.01464-.9131V8.44434S.88185,7.75293.8877,7.5498a12.37039,12.37039,0,0,1,.16553-1.87207,5.7555,5.7555,0,0,1,.54346-1.6621A5.37349,5.37349,0,0,1,2.61183,2.61768,5.56543,5.56543,0,0,1,4.01417,1.59521a5.82309,5.82309,0,0,1,1.65332-.54394A12.58589,12.58589,0,0,1,7.543.88721L8.44532.875H111.21387l.9131.0127a12.38493,12.38493,0,0,1,1.8584.16259,5.93833,5.93833,0,0,1,1.6709.54785,5.59374,5.59374,0,0,1,2.415,2.41993,5.76267,5.76267,0,0,1,.5352,1.64892,12.995,12.995,0,0,1,.1738,1.88721c.0029.2832.0029.5874.0029.89014.0079.375.0079.73193.0079,1.09179V30.4648c0,.3633,0,.7178-.0079,1.0752,0,.3252,0,.6231-.0039.9297a12.73126,12.73126,0,0,1-.1709,1.8535,5.739,5.739,0,0,1-.54,1.67,5.48029,5.48029,0,0,1-1.0156,1.3857,5.4129,5.4129,0,0,1-1.3994,1.0225,5.86168,5.86168,0,0,1-1.668.5498,12.54218,12.54218,0,0,1-1.8692.1631c-.2929.0068-.5996.0107-.8974.0107l-1.084.002Z"
  })), React$4.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, React$4.createElement("g", {
    id: "_Group_2",
    "data-name": "<Group>"
  }, React$4.createElement("g", {
    id: "_Group_3",
    "data-name": "<Group>"
  }, React$4.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    d: "M24.76888,20.30068a4.94881,4.94881,0,0,1,2.35656-4.15206,5.06566,5.06566,0,0,0-3.99116-2.15768c-1.67924-.17626-3.30719,1.00483-4.1629,1.00483-.87227,0-2.18977-.98733-3.6085-.95814a5.31529,5.31529,0,0,0-4.47292,2.72787c-1.934,3.34842-.49141,8.26947,1.3612,10.97608.9269,1.32535,2.01018,2.8058,3.42763,2.7533,1.38706-.05753,1.9051-.88448,3.5794-.88448,1.65876,0,2.14479.88448,3.591.8511,1.48838-.02416,2.42613-1.33124,3.32051-2.66914a10.962,10.962,0,0,0,1.51842-3.09251A4.78205,4.78205,0,0,1,24.76888,20.30068Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    id: "_Path_2",
    "data-name": "<Path>",
    d: "M22.03725,12.21089a4.87248,4.87248,0,0,0,1.11452-3.49062,4.95746,4.95746,0,0,0-3.20758,1.65961,4.63634,4.63634,0,0,0-1.14371,3.36139A4.09905,4.09905,0,0,0,22.03725,12.21089Z",
    style: {
      fill: '#ffffff'
    }
  }))), React$4.createElement("g", null, React$4.createElement("path", {
    d: "M42.30227,27.13965h-4.7334l-1.13672,3.35645H34.42727l4.4834-12.418h2.083l4.4834,12.418H43.438ZM38.0591,25.59082h3.752l-1.84961-5.44727h-.05176Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M55.15969,25.96973c0,2.81348-1.50586,4.62109-3.77832,4.62109a3.0693,3.0693,0,0,1-2.84863-1.584h-.043v4.48438h-1.8584V21.44238H48.4302v1.50586h.03418a3.21162,3.21162,0,0,1,2.88281-1.60059C53.645,21.34766,55.15969,23.16406,55.15969,25.96973Zm-1.91016,0c0-1.833-.94727-3.03809-2.39258-3.03809-1.41992,0-2.375,1.23047-2.375,3.03809,0,1.82422.95508,3.0459,2.375,3.0459C52.30227,29.01563,53.24953,27.81934,53.24953,25.96973Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M65.12453,25.96973c0,2.81348-1.50586,4.62109-3.77832,4.62109a3.0693,3.0693,0,0,1-2.84863-1.584h-.043v4.48438h-1.8584V21.44238H58.395v1.50586h.03418A3.21162,3.21162,0,0,1,61.312,21.34766C63.60988,21.34766,65.12453,23.16406,65.12453,25.96973Zm-1.91016,0c0-1.833-.94727-3.03809-2.39258-3.03809-1.41992,0-2.375,1.23047-2.375,3.03809,0,1.82422.95508,3.0459,2.375,3.0459C62.26711,29.01563,63.21438,27.81934,63.21438,25.96973Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M71.71047,27.03613c.1377,1.23145,1.334,2.04,2.96875,2.04,1.56641,0,2.69336-.80859,2.69336-1.91895,0-.96387-.67969-1.541-2.28906-1.93652l-1.60937-.3877c-2.28027-.55078-3.33887-1.61719-3.33887-3.34766,0-2.14258,1.86719-3.61426,4.51855-3.61426,2.624,0,4.42285,1.47168,4.4834,3.61426h-1.876c-.1123-1.23926-1.13672-1.9873-2.63379-1.9873s-2.52148.75684-2.52148,1.8584c0,.87793.6543,1.39453,2.25488,1.79l1.36816.33594c2.54785.60254,3.60645,1.626,3.60645,3.44238,0,2.32324-1.85059,3.77832-4.79395,3.77832-2.75391,0-4.61328-1.4209-4.7334-3.667Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M83.34621,19.2998v2.14258h1.72168v1.47168H83.34621v4.99121c0,.77539.34473,1.13672,1.10156,1.13672a5.80752,5.80752,0,0,0,.61133-.043v1.46289a5.10351,5.10351,0,0,1-1.03223.08594c-1.833,0-2.54785-.68848-2.54785-2.44434V22.91406H80.16262V21.44238H81.479V19.2998Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M86.065,25.96973c0-2.84863,1.67773-4.63867,4.29395-4.63867,2.625,0,4.29492,1.79,4.29492,4.63867,0,2.85645-1.66113,4.63867-4.29492,4.63867C87.72609,30.6084,86.065,28.82617,86.065,25.96973Zm6.69531,0c0-1.9541-.89551-3.10742-2.40137-3.10742s-2.40039,1.16211-2.40039,3.10742c0,1.96191.89453,3.10645,2.40039,3.10645S92.76027,27.93164,92.76027,25.96973Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M96.18606,21.44238h1.77246v1.541h.043a2.1594,2.1594,0,0,1,2.17773-1.63574,2.86616,2.86616,0,0,1,.63672.06934v1.73828a2.59794,2.59794,0,0,0-.835-.1123,1.87264,1.87264,0,0,0-1.93652,2.083v5.37012h-1.8584Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M109.3843,27.83691c-.25,1.64355-1.85059,2.77148-3.89844,2.77148-2.63379,0-4.26855-1.76465-4.26855-4.5957,0-2.83984,1.64355-4.68164,4.19043-4.68164,2.50488,0,4.08008,1.7207,4.08008,4.46582v.63672h-6.39453v.1123a2.358,2.358,0,0,0,2.43555,2.56445,2.04834,2.04834,0,0,0,2.09082-1.27344Zm-6.28223-2.70215h4.52637a2.1773,2.1773,0,0,0-2.2207-2.29785A2.292,2.292,0,0,0,103.10207,25.13477Z",
    style: {
      fill: '#ffffff'
    }
  })))), React$4.createElement("g", {
    id: "_Group_4",
    "data-name": "<Group>"
  }, React$4.createElement("g", null, React$4.createElement("path", {
    d: "M37.82619,8.731a2.63964,2.63964,0,0,1,2.80762,2.96484c0,1.90625-1.03027,3.002-2.80762,3.002H35.67092V8.731Zm-1.22852,5.123h1.125a1.87588,1.87588,0,0,0,1.96777-2.146,1.881,1.881,0,0,0-1.96777-2.13379h-1.125Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M41.68068,12.44434a2.13323,2.13323,0,1,1,4.24707,0,2.13358,2.13358,0,1,1-4.24707,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C44.57522,13.99463,45.01369,13.42432,45.01369,12.44434Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M51.57326,14.69775h-.92187l-.93066-3.31641h-.07031l-.92676,3.31641h-.91309l-1.24121-4.50293h.90137l.80664,3.436h.06641l.92578-3.436h.85254l.92578,3.436h.07031l.80273-3.436h.88867Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M53.85354,10.19482H54.709v.71533h.06641a1.348,1.348,0,0,1,1.34375-.80225,1.46456,1.46456,0,0,1,1.55859,1.6748v2.915h-.88867V12.00586c0-.72363-.31445-1.0835-.97168-1.0835a1.03294,1.03294,0,0,0-1.0752,1.14111v2.63428h-.88867Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M59.09377,8.437h.88867v6.26074h-.88867Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M61.21779,12.44434a2.13346,2.13346,0,1,1,4.24756,0,2.1338,2.1338,0,1,1-4.24756,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C64.11232,13.99463,64.5508,13.42432,64.5508,12.44434Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M66.4009,13.42432c0-.81055.60352-1.27783,1.6748-1.34424l1.21973-.07031v-.38867c0-.47559-.31445-.74414-.92187-.74414-.49609,0-.83984.18213-.93848.50049h-.86035c.09082-.77344.81836-1.26953,1.83984-1.26953,1.12891,0,1.76563.562,1.76563,1.51318v3.07666h-.85547v-.63281h-.07031a1.515,1.515,0,0,1-1.35254.707A1.36026,1.36026,0,0,1,66.4009,13.42432Zm2.89453-.38477v-.37646l-1.09961.07031c-.62012.0415-.90137.25244-.90137.64941,0,.40527.35156.64111.835.64111A1.0615,1.0615,0,0,0,69.29543,13.03955Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M71.34816,12.44434c0-1.42285.73145-2.32422,1.86914-2.32422a1.484,1.484,0,0,1,1.38086.79h.06641V8.437h.88867v6.26074h-.85156v-.71143h-.07031a1.56284,1.56284,0,0,1-1.41406.78564C72.0718,14.772,71.34816,13.87061,71.34816,12.44434Zm.918,0c0,.95508.4502,1.52979,1.20313,1.52979.749,0,1.21191-.583,1.21191-1.52588,0-.93848-.46777-1.52979-1.21191-1.52979C72.72121,10.91846,72.26613,11.49707,72.26613,12.44434Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M79.33742,8.86328a.57572.57572,0,1,1,.5752.5415A.54735.54735,0,0,1,79.33742,8.86328Zm.13184,1.33154H80.355v4.50293h-.88574Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M81.78859,10.19482h.85547v.71533h.06641a1.348,1.348,0,0,1,1.34375-.80225,1.46456,1.46456,0,0,1,1.55859,1.6748v2.915h-.88867V12.00586c0-.72363-.31445-1.0835-.97168-1.0835a1.03294,1.03294,0,0,0-1.0752,1.14111v2.63428h-.88867Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M89.20754,12.44434c0-1.42285.73145-2.32422,1.86914-2.32422a1.484,1.484,0,0,1,1.38086.79h.06641V8.437h.88867v6.26074h-.85156v-.71143h-.07031a1.56284,1.56284,0,0,1-1.41406.78564C89.93117,14.772,89.20754,13.87061,89.20754,12.44434Zm.918,0c0,.95508.4502,1.52979,1.20313,1.52979.749,0,1.21191-.583,1.21191-1.52588,0-.93848-.46777-1.52979-1.21191-1.52979C90.58059,10.91846,90.12551,11.49707,90.12551,12.44434Z",
    style: {
      fill: '#ffffff'
    }
  }), React$4.createElement("path", {
    d: "M98.67824,13.48193a1.828,1.828,0,0,1-1.95117,1.30273A2.04531,2.04531,0,0,1,94.647,12.46045a2.07685,2.07685,0,0,1,2.07617-2.35254c1.25293,0,2.00879.856,2.00879,2.27V12.688H95.55227v.0498a1.1902,1.1902,0,0,0,1.19922,1.29,1.07934,1.07934,0,0,0,1.07129-.5459Zm-3.126-1.45117h2.27441a1.08647,1.08647,0,0,0-1.1084-1.1665A1.15162,1.15162,0,0,0,95.55227,12.03076Z",
    style: {
      fill: '#ffffff'
    }
  })))));
}

function AppStore(props) {
  var _Lang$useTranslation = Lang.useTranslation(),
      i18n = _Lang$useTranslation.i18n;
  var svg = function svg() {
    var _props$width, _props$height, _props$width2, _props$height2, _props$width3, _props$height3;
    switch (i18n.language) {
      case 'en':
        return React$4.createElement(AppStore$2, {
          width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 119.66407,
          height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 40
        });
      case 'nl':
        return React$4.createElement(AppStore$1, {
          width: (_props$width2 = props.width) !== null && _props$width2 !== void 0 ? _props$width2 : 119.66407,
          height: (_props$height2 = props.height) !== null && _props$height2 !== void 0 ? _props$height2 : 40
        });
      default:
        return React$4.createElement(AppStore$2, {
          width: (_props$width3 = props.width) !== null && _props$width3 !== void 0 ? _props$width3 : 119.66407,
          height: (_props$height3 = props.height) !== null && _props$height3 !== void 0 ? _props$height3 : 40
        });
    }
  };
  return props.interactive ? React$4.createElement("a", {
    className: "Hover",
    target: "_blank",
    href: "https://apps.apple.com/nl/app/bluecurrent/id1447733712",
    rel: "noreferrer"
  }, svg()) : svg();
}

function PlayStore(props) {
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._,
      i18n = _Lang$useTranslation.i18n;
  var url = function url() {
    switch (i18n.language) {
      case 'en':
        return 'https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png';
      case 'nl':
        return 'https://play.google.com/intl/en_us/badges/static/images/badges/nl_badge_web_generic.png';
      default:
        return 'https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png';
    }
  };
  return props.interactive ? React$4.createElement("a", {
    className: "Hover",
    target: "_blank",
    href: "https://play.google.com/store/apps/details?id=com.bluecurrent.bcuweb",
    rel: "noreferrer"
  }, React$4.createElement("img", {
    className: "Badge",
    alt: _('getOnPlayStore', {
      ns: 'ui'
    }),
    src: url(),
    style: {
      height: '100%',
      width: 'auto',
      marginLeft: -10
    }
  })) : React$4.createElement(React$4.Fragment, null, React$4.createElement("img", {
    className: "Badge",
    alt: _('getOnPlayStore', {
      ns: 'ui'
    }),
    src: url(),
    style: {
      height: '100%',
      width: 'auto',
      marginLeft: -10
    }
  }));
}

function Badge(props) {
  var render = function render() {
    switch (props.store) {
      case 'AppStore':
        return React$4.createElement(AppStore, {
          width: props.width,
          height: props.height,
          interactive: props.interactive
        });
      case 'PlayStore':
        return React$4.createElement(PlayStore, {
          interactive: props.interactive
        });
      default:
        return React$4.createElement("div", null);
    }
  };
  return render();
}

function Toast(props) {
  var icon = function icon(e) {
    switch (e) {
      case 'success':
        return {
          name: 'Check',
          height: 15,
          width: 15,
          color: Colors.GREEN,
          iconSet: 'FA'
        };
      case 'failed':
        return {
          name: 'Times',
          height: 18,
          width: 18,
          color: Colors.RED,
          iconSet: 'Feather'
        };
      case 'info':
        return {
          name: 'Info',
          height: 15,
          width: 15,
          color: Colors.BLUE,
          iconSet: 'FA'
        };
      default:
        return {
          name: false,
          color: false,
          iconSet: false
        };
    }
  };
  return React$4.createElement(AnimatePresence, null, props.visible && React$4.createElement(motion.div, {
    className: "Blur",
    style: {
      position: 'relative',
      height: 'auto',
      width: '100%',
      backgroundColor: props.colorScheme === 'white' ? Colors.WHITE : getColorScheme(props.colorScheme).delicate,
      border: "solid 2px ".concat(props.colorScheme === 'white' ? Colors.MEDIUM_WHITE : getColorScheme(props.colorScheme).vibrant),
      borderRadius: 10,
      paddingTop: 15,
      paddingLeft: 15,
      paddingRight: props.onClose ? 7.5 : 15,
      paddingBottom: 15,
      marginTop: 10,
      overflow: 'hidden',
      zIndex: 2147483005
    },
    initial: {
      marginRight: -450
    },
    animate: {
      marginRight: 0
    },
    exit: {
      marginRight: -450
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      height: '100%',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  }, React$4.createElement("div", {
    style: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start'
    }
  }, props.type && React$4.createElement("div", {
    style: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      paddingRight: 15
    }
  }, React$4.createElement("div", {
    style: {
      height: 25,
      width: 25,
      backgroundColor: icon(props.type).color,
      borderRadius: 25,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, React$4.createElement(Icon, {
    name: icon(props.type).name,
    height: icon(props.type).height,
    width: icon(props.type).width,
    color: Colors.WHITE,
    iconSet: icon(props.type).iconSet
  }))), React$4.createElement(Text, {
    animate: true
  }, props.text)), props.onClose && React$4.createElement("button", {
    type: "button",
    className: "Hover",
    onClick: props.onClose,
    style: {
      height: 40,
      width: 40,
      minWidth: 40,
      backgroundColor: 'transparent',
      border: 'solid 0px transparent'
    }
  }, React$4.createElement(Icon, {
    name: "Times",
    height: 20,
    width: 20,
    color: Colors.GREY,
    iconSet: "Feather"
  })))));
}

function ItemMenu(props) {
  var dropdownRef = React$4.useRef();
  var dataRef = React$4.useRef();
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  var _React$useState3 = React$4.useState(false),
      _React$useState4 = _slicedToArray$5(_React$useState3, 2),
      dropdownMenu = _React$useState4[0],
      setDropdownMenu = _React$useState4[1];
  useDataAttributes(dataRef, props.dataAttributes, {
    all: {
      id: props.id,
      outsideClickExemption: true
    }
  });
  useDataAttributes(dropdownRef, undefined, {
    single: {
      id: props.id
    }
  }, dropdownMenu);
  useOutsideClick(dropdownRef, function () {
    return setDropdownMenu(false);
  });
  return React$4.createElement("div", {
    ref: dataRef,
    style: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      justifyContent: 'flex-end'
    }
  }, React$4.createElement("button", {
    type: "button",
    className: "Hover",
    onClick: function onClick() {
      setDropdownMenu(!dropdownMenu);
    },
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    style: {
      border: 'solid 0px transparent',
      backgroundColor: 'transparent',
      height: 60,
      width: 60,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-end'
    }
  }, React$4.createElement("div", {
    style: {
      width: dropdownMenu ? 30 : 35,
      height: dropdownMenu ? 30 : 35,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      transform: "rotate(".concat(dropdownMenu ? 180 : 0, "deg)")
    }
  }, React$4.createElement(Icon, {
    name: dropdownMenu ? 'AngleDown' : 'Ellipsis-H',
    height: dropdownMenu ? 30 : 35,
    width: dropdownMenu ? 30 : 35,
    color: hover || dropdownMenu ? Colors.GREY : Colors.MEDIUM_GREY
  }))), dropdownMenu && props.items && React$4.createElement("div", {
    ref: dropdownRef,
    style: {
      position: 'absolute',
      top: -20,
      right: 240
    }
  }, React$4.createElement(DropdownMenu, {
    id: props.id,
    items: props.items,
    onClose: function onClose() {
      setDropdownMenu(false);
    },
    right: props.right
  })));
}

function WrapperFigure(props) {
  var _props$width, _props$height;
  return React$4.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : '100%',
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : '100%',
    viewBox: "0 0 400 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2
    }
  }, React$4.createElement("path", {
    d: "M378.463 137.923c8.209 0 12.501 4.204 14.472 7.899a32.2 32.2 0 0 1 3.81 15.194c0 17.704-14.325 32.061-32 32.061-17.676 0-32-14.357-32-32.061a32.122 32.122 0 0 1 3.816-15.194c1.964-3.695 6.256-7.899 14.465-7.899h27.437Z",
    fill: "url(#".concat(props.id, ")"),
    transform: "translate(-1709.35 -716.352) scale(5.23476)"
  }), React$4.createElement("defs", null, React$4.createElement("pattern", {
    id: props.id,
    patternUnits: "objectBoundingBox",
    width: "100%",
    height: "100%"
  }, React$4.createElement("image", {
    width: "100%",
    height: "100%",
    href: props.src,
    xlinkHref: props.src,
    x: "0",
    y: "0",
    transform: "translate(-7 0) scale(0.2)"
  }))));
}

function C(props) {
  var _props$width, _props$height, _props$position, _props$zIndex, _props$marginLeft, _props$marginRight, _props$marginTop, _props$marginBottom, _props$transform, _props$top, _props$left, _props$right, _props$bottom, _props$opacity, _props$color;
  return React__default.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 54,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 47,
    viewBox: "0 0 54 47",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      position: (_props$position = props.position) !== null && _props$position !== void 0 ? _props$position : 'relative',
      zIndex: (_props$zIndex = props.zIndex) !== null && _props$zIndex !== void 0 ? _props$zIndex : 1.1,
      marginLeft: (_props$marginLeft = props.marginLeft) !== null && _props$marginLeft !== void 0 ? _props$marginLeft : 0,
      marginRight: (_props$marginRight = props.marginRight) !== null && _props$marginRight !== void 0 ? _props$marginRight : 0,
      marginTop: (_props$marginTop = props.marginTop) !== null && _props$marginTop !== void 0 ? _props$marginTop : 0,
      marginBottom: (_props$marginBottom = props.marginBottom) !== null && _props$marginBottom !== void 0 ? _props$marginBottom : 0,
      transform: (_props$transform = props.transform) !== null && _props$transform !== void 0 ? _props$transform : 'initial',
      top: (_props$top = props.top) !== null && _props$top !== void 0 ? _props$top : 'initial',
      left: (_props$left = props.left) !== null && _props$left !== void 0 ? _props$left : 'initial',
      right: (_props$right = props.right) !== null && _props$right !== void 0 ? _props$right : 'initial',
      bottom: (_props$bottom = props.bottom) !== null && _props$bottom !== void 0 ? _props$bottom : 'initial',
      opacity: (_props$opacity = props.opacity) !== null && _props$opacity !== void 0 ? _props$opacity : 1
    }
  }, React__default.createElement("path", {
    d: "M48.263 29.437v6.346a4.782 4.782 0 0 1-4.775 4.775h-32.98a4.782 4.782 0 0 1-4.775-4.775V11.22a4.782 4.782 0 0 1 4.775-4.775h32.98a4.782 4.782 0 0 1 4.775 4.775v5.292h5.735V11.22c0-5.79-4.71-10.512-10.51-10.512h-32.98c-5.79 0-10.51 4.722-10.51 10.512v24.564c0 5.8 4.72 10.51 10.51 10.51h32.98c5.8 0 10.51-4.71 10.51-10.51v-6.346h-5.735Z",
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.BLUE,
    fillRule: "nonzero"
  }));
}

function DotsPath(props) {
  var _props$width, _props$height, _props$position, _props$marginLeft, _props$marginRight, _props$marginTop, _props$marginBottom, _props$transform, _props$top, _props$left, _props$right, _props$bottom, _props$opacity, _props$zIndex, _props$color;
  return React__default.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 491,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 274,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 491 274",
    style: {
      position: (_props$position = props.position) !== null && _props$position !== void 0 ? _props$position : 'relative',
      marginLeft: (_props$marginLeft = props.marginLeft) !== null && _props$marginLeft !== void 0 ? _props$marginLeft : 0,
      marginRight: (_props$marginRight = props.marginRight) !== null && _props$marginRight !== void 0 ? _props$marginRight : 0,
      marginTop: (_props$marginTop = props.marginTop) !== null && _props$marginTop !== void 0 ? _props$marginTop : 0,
      marginBottom: (_props$marginBottom = props.marginBottom) !== null && _props$marginBottom !== void 0 ? _props$marginBottom : 0,
      transform: (_props$transform = props.transform) !== null && _props$transform !== void 0 ? _props$transform : 'initial',
      top: (_props$top = props.top) !== null && _props$top !== void 0 ? _props$top : 'initial',
      left: (_props$left = props.left) !== null && _props$left !== void 0 ? _props$left : 'initial',
      right: (_props$right = props.right) !== null && _props$right !== void 0 ? _props$right : 'initial',
      bottom: (_props$bottom = props.bottom) !== null && _props$bottom !== void 0 ? _props$bottom : 'initial',
      opacity: (_props$opacity = props.opacity) !== null && _props$opacity !== void 0 ? _props$opacity : 1,
      zIndex: (_props$zIndex = props.zIndex) !== null && _props$zIndex !== void 0 ? _props$zIndex : 0
    }
  }, React__default.createElement("g", {
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : '#FFFFFF',
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M171.175 151.982a2.805 2.805 0 0 1 3.807-1.097 2.8 2.8 0 1 1-2.703 4.904 2.797 2.797 0 0 1-1.104-3.807M184.848 151.673a2.796 2.796 0 0 1 3.8-1.098 2.791 2.791 0 0 1 1.107 3.807 2.802 2.802 0 0 1-3.81 1.097 2.8 2.8 0 0 1-1.097-3.806M198.491 150.417a2.808 2.808 0 0 1 3.807-1.103 2.8 2.8 0 0 1 1.1 3.806 2.8 2.8 0 0 1-3.804 1.104 2.803 2.803 0 0 1-1.103-3.807M204.483 162.36a2.794 2.794 0 0 1 4.895 2.697 2.79 2.79 0 0 1-3.797 1.101 2.792 2.792 0 0 1-1.098-3.797M191.109 164.843a2.801 2.801 0 0 1 3.806-1.097 2.795 2.795 0 0 1 1.107 3.806 2.807 2.807 0 0 1-3.81 1.104 2.803 2.803 0 0 1-1.103-3.813M176.817 166.023a2.76 2.76 0 1 1 4.835 2.664 2.761 2.761 0 0 1-4.835-2.664M161.878 163.984a2.73 2.73 0 0 1 3.714-1.079 2.74 2.74 0 0 1 1.076 3.72 2.746 2.746 0 0 1-3.717 1.073 2.732 2.732 0 0 1-1.073-3.714M157.456 150.078a2.801 2.801 0 0 1 3.807-1.097 2.802 2.802 0 0 1 1.106 3.807 2.805 2.805 0 0 1-3.81 1.097 2.802 2.802 0 0 1-1.103-3.807M164.517 138.036a2.798 2.798 0 0 1 3.807-1.104 2.802 2.802 0 1 1-2.703 4.91 2.805 2.805 0 0 1-1.104-3.806M171.362 125.829a2.8 2.8 0 1 1 4.907 2.703 2.801 2.801 0 1 1-4.907-2.703M178.628 138.579a2.803 2.803 0 0 1 3.806-1.098 2.807 2.807 0 0 1 1.107 3.807 2.814 2.814 0 0 1-3.816 1.103 2.807 2.807 0 0 1-1.097-3.812M192.65 137.913a2.801 2.801 0 0 1 3.807-1.098 2.8 2.8 0 1 1-2.703 4.904 2.802 2.802 0 0 1-1.103-3.806M186.477 126.08a2.805 2.805 0 0 1 3.813-1.103 2.798 2.798 0 0 1 1.1 3.806 2.812 2.812 0 0 1-3.81 1.104 2.803 2.803 0 0 1-1.103-3.807M200.99 124.468a2.808 2.808 0 0 1 3.807-1.103 2.8 2.8 0 0 1 1.1 3.806 2.801 2.801 0 1 1-4.907-2.703M213.77 125.613a2.801 2.801 0 0 1 3.806-1.097 2.801 2.801 0 0 1 1.107 3.8 2.802 2.802 0 0 1-3.81 1.104 2.798 2.798 0 0 1-1.103-3.807M206.3 137.557a2.808 2.808 0 0 1 3.806-1.104 2.8 2.8 0 0 1 1.1 3.807 2.8 2.8 0 0 1-3.803 1.103 2.803 2.803 0 0 1-1.104-3.806M212.531 149.886a2.803 2.803 0 0 1 3.807-1.104 2.802 2.802 0 1 1-2.703 4.91 2.803 2.803 0 0 1-1.104-3.806M218.413 161.543a2.617 2.617 0 1 1 4.584 2.53 2.602 2.602 0 0 1-3.55 1.026 2.61 2.61 0 0 1-1.034-3.556M227.518 152.461a2.806 2.806 0 0 1 4.913 2.71 2.802 2.802 0 0 1-3.81 1.103 2.809 2.809 0 0 1-1.103-3.813M234.112 139.174a2.801 2.801 0 0 1 3.806-1.097 2.795 2.795 0 0 1 1.107 3.807 2.807 2.807 0 0 1-3.81 1.103 2.809 2.809 0 0 1-1.103-3.813M220.48 138.836a2.801 2.801 0 0 1 3.807-1.098 2.802 2.802 0 0 1 1.106 3.807 2.805 2.805 0 0 1-3.81 1.097 2.802 2.802 0 0 1-1.103-3.806M227.985 126.775a2.8 2.8 0 0 1 3.807-1.11 2.802 2.802 0 1 1-2.704 4.91 2.798 2.798 0 0 1-1.103-3.8M241.64 125.94a2.807 2.807 0 0 1 3.812-1.097 2.8 2.8 0 0 1 1.1 3.806 2.807 2.807 0 0 1-3.809 1.104 2.81 2.81 0 0 1-1.103-3.813M247.346 138.69a2.8 2.8 0 0 1 3.807-1.098 2.798 2.798 0 0 1 1.1 3.8 2.809 2.809 0 0 1-3.81 1.11 2.808 2.808 0 0 1-1.097-3.812M240.402 151.539a2.801 2.801 0 0 1 3.806-1.098 2.802 2.802 0 0 1 1.107 3.807 2.812 2.812 0 0 1-3.816 1.103 2.812 2.812 0 0 1-1.097-3.812M253.38 151.702a2.801 2.801 0 0 1 3.806-1.097 2.793 2.793 0 0 1 1.1 3.8 2.795 2.795 0 0 1-3.803 1.104 2.798 2.798 0 0 1-1.104-3.807M266.064 154.02a2.803 2.803 0 0 1 3.807-1.103 2.8 2.8 0 0 1 1.1 3.807 2.801 2.801 0 1 1-4.907-2.703M260.47 139.77a2.802 2.802 0 0 1 3.806-1.103 2.809 2.809 0 0 1 1.106 3.812 2.81 2.81 0 0 1-3.815 1.098 2.8 2.8 0 0 1-1.098-3.807M272.822 142.083a2.803 2.803 0 1 1 4.913 2.7 2.803 2.803 0 0 1-4.913-2.7M284.327 137.422a2.801 2.801 0 0 1 3.807-1.097 2.793 2.793 0 0 1 1.1 3.8 2.798 2.798 0 0 1-3.803 1.104 2.798 2.798 0 0 1-1.104-3.807M297.988 133.252a2.808 2.808 0 0 1 3.806-1.103 2.8 2.8 0 0 1 1.107 3.806 2.8 2.8 0 0 1-3.81 1.104 2.803 2.803 0 0 1-1.103-3.807M307.257 144.577a2.798 2.798 0 0 1 3.806-1.103 2.8 2.8 0 0 1 1.107 3.806 2.81 2.81 0 0 1-3.81 1.098 2.793 2.793 0 0 1-1.103-3.801M300.622 156.252a2.803 2.803 0 0 1 3.807-1.104 2.807 2.807 0 0 1 1.106 3.813 2.805 2.805 0 0 1-3.81 1.098 2.803 2.803 0 0 1-1.103-3.807M293.304 146.726a2.798 2.798 0 0 1 3.807-1.103 2.802 2.802 0 0 1 1.106 3.806 2.807 2.807 0 0 1-3.816 1.104 2.801 2.801 0 0 1-1.097-3.807M281.284 152.058a2.799 2.799 0 0 1 3.807-1.11 2.809 2.809 0 0 1 1.106 3.814 2.81 2.81 0 0 1-3.815 1.097 2.794 2.794 0 0 1-1.098-3.8M289.28 163.529a2.808 2.808 0 0 1 3.806-1.104 2.802 2.802 0 0 1 1.107 3.807 2.807 2.807 0 0 1-3.816 1.103 2.806 2.806 0 0 1-1.097-3.806M303.443 168.365a2.796 2.796 0 0 1 3.8-1.104 2.796 2.796 0 0 1 1.107 3.807 2.798 2.798 0 0 1-3.81 1.097 2.793 2.793 0 0 1-1.097-3.8M306.883 180.992a2.8 2.8 0 0 1 3.806-1.098 2.8 2.8 0 0 1 1.107 3.807 2.814 2.814 0 0 1-3.816 1.103 2.807 2.807 0 0 1-1.097-3.812M309.81 193.63a2.808 2.808 0 0 1 3.806-1.103 2.796 2.796 0 0 1 1.106 3.807 2.807 2.807 0 0 1-3.81 1.103 2.808 2.808 0 0 1-1.103-3.807M293.234 177.704a2.802 2.802 0 1 1 4.907 2.703 2.8 2.8 0 0 1-3.804 1.103 2.798 2.798 0 0 1-1.103-3.806M274.574 163.75a2.794 2.794 0 0 1 3.8-1.097 2.792 2.792 0 0 1 1.101 3.795 2.792 2.792 0 0 1-3.798 1.1 2.799 2.799 0 0 1-1.103-3.797M280.56 175.134a2.794 2.794 0 0 1 3.792-1.098 2.792 2.792 0 0 1-2.694 4.89 2.794 2.794 0 0 1-1.098-3.792M282.692 188.806a2.658 2.658 0 0 1 4.656 2.563 2.667 2.667 0 0 1-3.615 1.046 2.662 2.662 0 0 1-1.041-3.609M296.096 191.218a2.8 2.8 0 0 1 3.806-1.097 2.807 2.807 0 0 1 1.107 3.806 2.808 2.808 0 0 1-3.81 1.104 2.798 2.798 0 0 1-1.103-3.813M299.074 204.68a2.803 2.803 0 0 1 3.807-1.103 2.807 2.807 0 0 1 1.106 3.813 2.812 2.812 0 0 1-3.815 1.097 2.8 2.8 0 0 1-1.098-3.807M285.694 202.21a2.765 2.765 0 0 1 4.841 2.67 2.77 2.77 0 0 1-3.756 1.086 2.767 2.767 0 0 1-1.085-3.756M289.549 216.507a2.715 2.715 0 0 1 3.69-1.068 2.715 2.715 0 0 1 1.07 3.69 2.718 2.718 0 0 1-4.76-2.622M302.251 218.359a2.798 2.798 0 0 1 3.807-1.104 2.807 2.807 0 0 1 1.106 3.813 2.815 2.815 0 0 1-3.815 1.097 2.801 2.801 0 0 1-1.098-3.806M314.668 218.084a2.798 2.798 0 0 1 3.807-1.103 2.796 2.796 0 0 1 1.106 3.806 2.803 2.803 0 0 1-4.913-2.703M312.274 206.053a2.798 2.798 0 0 1 3.806-1.104 2.802 2.802 0 1 1-2.703 4.91 2.798 2.798 0 0 1-1.103-3.806M323.662 197.356a2.802 2.802 0 0 1 3.801-1.103 2.805 2.805 0 0 1 1.112 3.807 2.808 2.808 0 0 1-3.815 1.103 2.8 2.8 0 0 1-1.098-3.807M333.69 188.45a2.803 2.803 0 0 1 3.807-1.104 2.802 2.802 0 1 1-2.703 4.91 2.808 2.808 0 0 1-1.104-3.806M320.66 183.836a2.803 2.803 0 0 1 3.807-1.103 2.8 2.8 0 0 1 1.1 3.806 2.795 2.795 0 0 1-3.803 1.104 2.798 2.798 0 0 1-1.104-3.807M317.261 170.613a2.803 2.803 0 1 1 4.907 2.71 2.805 2.805 0 0 1-3.81 1.103 2.812 2.812 0 0 1-1.097-3.813M330.998 173.75a2.809 2.809 0 0 1 3.813-1.104 2.81 2.81 0 0 1 1.1 3.813 2.805 2.805 0 0 1-3.81 1.097 2.803 2.803 0 0 1-1.103-3.806M326.834 160.042a2.803 2.803 0 0 1 3.806-1.103 2.809 2.809 0 0 1 1.107 3.812 2.805 2.805 0 0 1-3.81 1.098 2.798 2.798 0 0 1-1.103-3.807M313.64 157.379a2.803 2.803 0 0 1 3.807-1.103 2.807 2.807 0 0 1 1.106 3.812 2.812 2.812 0 0 1-3.815 1.104 2.813 2.813 0 0 1-1.098-3.813M322.126 146.306a2.798 2.798 0 0 1 3.807-1.104 2.796 2.796 0 0 1 1.106 3.807 2.803 2.803 0 0 1-4.913-2.703M314.277 134.496a2.803 2.803 0 0 1 3.812-1.103 2.798 2.798 0 0 1 1.1 3.807 2.812 2.812 0 0 1-3.809 1.103 2.81 2.81 0 0 1-1.103-3.807M306.912 123.557a2.788 2.788 0 0 1 3.786-1.097 2.784 2.784 0 0 1 1.097 3.783 2.787 2.787 0 1 1-4.883-2.685M295.278 118.073a2.803 2.803 0 0 1 3.807-1.103 2.802 2.802 0 1 1-2.704 4.91 2.798 2.798 0 0 1-1.103-3.807M284.134 110.253a2.798 2.798 0 0 1 3.807-1.104 2.8 2.8 0 0 1 1.107 3.807 2.803 2.803 0 0 1-4.913-2.703M270.281 104.844a2.797 2.797 0 0 1 3.798-1.097 2.787 2.787 0 0 1 1.097 3.795 2.794 2.794 0 1 1-4.895-2.698M274.001 117.524a2.805 2.805 0 0 1 4.913 2.71 2.8 2.8 0 0 1-3.803 1.097 2.799 2.799 0 0 1-1.11-3.807M284.596 125.245a2.801 2.801 0 0 1 3.807-1.097 2.8 2.8 0 0 1 1.106 3.806 2.807 2.807 0 0 1-3.81 1.104 2.803 2.803 0 0 1-1.103-3.813M269.82 129.117a2.803 2.803 0 0 1 3.806-1.103 2.802 2.802 0 1 1-2.703 4.91 2.808 2.808 0 0 1-1.103-3.807M255.523 126.694a2.801 2.801 0 0 1 3.806-1.098 2.8 2.8 0 0 1 1.107 3.807 2.807 2.807 0 0 1-3.81 1.103 2.803 2.803 0 0 1-1.103-3.812M261.439 114.913a2.803 2.803 0 1 1 4.913 2.701 2.803 2.803 0 0 1-4.913-2.7M248.38 113.231a2.809 2.809 0 0 1 3.812-1.103 2.8 2.8 0 0 1 1.1 3.806 2.807 2.807 0 0 1-3.803 1.104 2.802 2.802 0 0 1-1.11-3.807M256.124 101.206a2.705 2.705 0 0 1 4.737 2.61 2.704 2.704 0 1 1-4.737-2.61M240.84 101.434a2.802 2.802 0 0 1 3.8-1.104 2.798 2.798 0 0 1-2.697 4.901 2.8 2.8 0 0 1-1.103-3.797M234.561 113.605a2.798 2.798 0 0 1 3.807-1.103 2.802 2.802 0 1 1-2.703 4.91 2.803 2.803 0 0 1-1.104-3.807M224.82 102.946a2.787 2.787 0 1 1 1.097 3.786 2.787 2.787 0 0 1-1.097-3.786M221.123 115.106a2.809 2.809 0 0 1 3.812-1.103 2.8 2.8 0 0 1 1.1 3.806 2.804 2.804 0 1 1-4.912-2.703M209.22 109.914a2.798 2.798 0 0 1 3.806-1.103 2.796 2.796 0 0 1 1.107 3.806 2.805 2.805 0 0 1-3.816 1.098 2.793 2.793 0 0 1-1.097-3.8M194.654 113.681a2.798 2.798 0 0 1 3.806-1.103 2.802 2.802 0 1 1-2.703 4.91 2.798 2.798 0 0 1-1.103-3.807M178.984 115.369a2.796 2.796 0 0 1 3.807-1.097 2.791 2.791 0 0 1 1.1 3.8 2.8 2.8 0 0 1-3.803 1.104 2.798 2.798 0 0 1-1.104-3.807M163.898 112.133a2.793 2.793 0 0 1 3.8-1.103 2.797 2.797 0 0 1 1.113 3.806 2.81 2.81 0 0 1-3.815 1.098 2.8 2.8 0 0 1-1.098-3.8M157.345 123.966a2.798 2.798 0 0 1 3.807-1.103 2.796 2.796 0 0 1 1.106 3.806 2.802 2.802 0 0 1-3.81 1.104 2.798 2.798 0 0 1-1.103-3.807M150.804 135.553a2.798 2.798 0 0 1 3.8-1.103 2.796 2.796 0 0 1 1.107 3.807 2.801 2.801 0 1 1-4.907-2.703M144.467 146.691a2.796 2.796 0 0 1 3.801-1.103 2.804 2.804 0 0 1 1.112 3.806 2.805 2.805 0 0 1-3.815 1.098 2.793 2.793 0 0 1-1.098-3.8M146.646 159.733a2.554 2.554 0 0 1 4.473 2.464 2.552 2.552 0 0 1-3.469.998 2.55 2.55 0 0 1-1.004-3.462M132.015 149.746a2.75 2.75 0 0 1 3.738-1.086 2.752 2.752 0 0 1 1.074 3.738 2.74 2.74 0 0 1-3.732 1.08 2.743 2.743 0 0 1-1.08-3.732M135.76 135.717a2.795 2.795 0 0 1 3.806-1.097 2.791 2.791 0 0 1 1.1 3.8 2.802 2.802 0 0 1-3.803 1.11 2.806 2.806 0 0 1-1.104-3.813M121.69 138.497a2.796 2.796 0 0 1 3.8-1.103 2.796 2.796 0 0 1 1.107 3.806 2.801 2.801 0 1 1-4.907-2.703M112.351 126.991a2.809 2.809 0 0 1 3.813-1.103 2.805 2.805 0 1 1-3.813 1.103M105.4 114.177a2.762 2.762 0 0 1 3.75-1.08 2.756 2.756 0 0 1 1.08 3.745 2.759 2.759 0 1 1-4.83-2.664M119.394 112.455a2.803 2.803 0 0 1 3.807-1.104 2.8 2.8 0 0 1 1.1 3.807 2.8 2.8 0 0 1-3.803 1.103 2.803 2.803 0 0 1-1.104-3.806M126.929 124.673a2.798 2.798 0 0 1 3.806-1.104 2.802 2.802 0 1 1-2.703 4.91 2.805 2.805 0 0 1-1.103-3.806M133.96 111.55a2.803 2.803 0 0 1 3.801-1.104 2.796 2.796 0 0 1 1.106 3.806 2.801 2.801 0 1 1-4.907-2.703M142.306 123.429a2.802 2.802 0 1 1 4.907 2.703 2.801 2.801 0 1 1-4.907-2.703M148.76 111.73a2.798 2.798 0 0 1 3.806-1.103 2.796 2.796 0 0 1 1.107 3.807 2.803 2.803 0 0 1-4.913-2.703M153.56 100.207a2.803 2.803 0 0 1 3.807-1.103 2.802 2.802 0 0 1 1.107 3.807 2.807 2.807 0 0 1-3.816 1.103 2.806 2.806 0 0 1-1.097-3.807M139.982 98.741a2.803 2.803 0 0 1 3.807-1.103 2.802 2.802 0 1 1-2.704 4.91 2.808 2.808 0 0 1-1.103-3.807M125.848 98.806a2.8 2.8 0 0 1 3.807-1.098 2.798 2.798 0 0 1 1.1 3.807 2.807 2.807 0 0 1-3.81 1.103 2.807 2.807 0 0 1-1.097-3.812M133.844 85.22a2.807 2.807 0 0 1 3.812-1.097 2.803 2.803 0 0 1 1.1 3.807 2.803 2.803 0 0 1-3.809 1.097 2.808 2.808 0 0 1-1.103-3.806M147.68 86.225a2.806 2.806 0 0 1 3.806-1.097 2.795 2.795 0 0 1 1.107 3.8 2.802 2.802 0 0 1-3.81 1.104 2.802 2.802 0 0 1-1.104-3.807M145.297 71.998a2.8 2.8 0 1 1 4.907 2.703 2.801 2.801 0 1 1-4.907-2.703M128.68 72.968a2.805 2.805 0 0 1 3.807-1.098 2.802 2.802 0 1 1-2.703 4.91 2.803 2.803 0 0 1-1.103-3.812M138.101 60.347a2.791 2.791 0 0 1 3.8-1.104 2.795 2.795 0 0 1 1.107 3.807 2.81 2.81 0 0 1-3.81 1.097 2.796 2.796 0 0 1-1.097-3.8M139.217 47.1a2.74 2.74 0 0 1 3.714-1.079 2.742 2.742 0 0 1 1.076 3.72 2.74 2.74 0 0 1-3.717 1.073 2.73 2.73 0 0 1-1.073-3.713M120.557 61.947a2.805 2.805 0 0 1 3.806-1.11 2.809 2.809 0 0 1 1.107 3.813 2.814 2.814 0 0 1-3.816 1.103 2.801 2.801 0 0 1-1.097-3.806M104.817 62.846a2.803 2.803 0 0 1 3.806-1.103 2.802 2.802 0 0 1 1.107 3.806 2.807 2.807 0 0 1-3.816 1.104 2.806 2.806 0 0 1-1.097-3.807M110.529 49.834a2.803 2.803 0 0 1 3.806-1.103 2.8 2.8 0 0 1 1.1 3.806 2.8 2.8 0 1 1-4.906-2.703M125.655 49.156a2.8 2.8 0 0 1 3.807-1.097 2.802 2.802 0 0 1 1.106 3.807 2.805 2.805 0 0 1-3.81 1.097 2.798 2.798 0 0 1-1.103-3.807M130.088 34.374a2.805 2.805 0 0 1 3.807-1.097 2.8 2.8 0 0 1 1.1 3.806 2.805 2.805 0 0 1-3.81 1.104 2.807 2.807 0 0 1-1.097-3.813M115.902 36.798a2.805 2.805 0 1 1 4.913 2.71 2.807 2.807 0 0 1-3.81 1.103 2.809 2.809 0 0 1-1.103-3.813M120.311 21.952a2.798 2.798 0 0 1 4.901 2.697 2.802 2.802 0 0 1-3.803 1.103 2.805 2.805 0 0 1-1.098-3.8M106.785 25.403a2.803 2.803 0 0 1 3.807-1.103 2.802 2.802 0 1 1-2.704 4.91 2.803 2.803 0 0 1-1.103-3.807M105.518 12.368a2.803 2.803 0 0 1 3.806-1.104 2.798 2.798 0 0 1 1.107 3.807 2.803 2.803 0 0 1-4.913-2.703M92.003 5.523a2.806 2.806 0 0 1 4.913 2.709 2.812 2.812 0 0 1-3.81 1.103 2.809 2.809 0 0 1-1.103-3.812M76.106 1.785a2.796 2.796 0 0 1 3.8-1.104 2.798 2.798 0 0 1 1.113 3.807 2.808 2.808 0 0 1-3.816 1.104 2.801 2.801 0 0 1-1.097-3.807M60.564 1.452A2.803 2.803 0 0 1 64.371.35a2.802 2.802 0 1 1-2.703 4.91 2.798 2.798 0 0 1-1.104-3.807M45.327 1.586A2.795 2.795 0 0 1 49.118.495a2.784 2.784 0 0 1 1.098 3.783 2.793 2.793 0 0 1-3.792 1.1 2.8 2.8 0 0 1-1.097-3.792M32.49 7.362a2.801 2.801 0 0 1 3.806-1.097 2.802 2.802 0 1 1-2.703 4.91 2.809 2.809 0 0 1-1.104-3.813M16.995 7.304A2.56 2.56 0 0 1 20.458 6.3a2.56 2.56 0 0 1 1.004 3.47 2.558 2.558 0 0 1-3.468 1.004 2.556 2.556 0 0 1-1-3.469M23.232 21.928a2.798 2.798 0 0 1 3.807-1.103 2.8 2.8 0 0 1 1.106 3.807 2.807 2.807 0 0 1-3.81 1.103 2.798 2.798 0 0 1-1.103-3.807M37.465 23.155a2.802 2.802 0 0 1 3.807-1.103 2.807 2.807 0 0 1 1.106 3.812 2.81 2.81 0 0 1-3.81 1.098 2.798 2.798 0 0 1-1.103-3.807M50.542 16.748a2.803 2.803 0 0 1 3.807-1.103 2.802 2.802 0 1 1-2.704 4.91 2.803 2.803 0 0 1-1.103-3.807M65.768 15.983a2.803 2.803 0 0 1 3.806-1.104 2.796 2.796 0 0 1 1.107 3.807 2.805 2.805 0 0 1-3.81 1.103 2.808 2.808 0 0 1-1.103-3.806M80.456 15.79a2.798 2.798 0 0 1 3.807-1.103 2.8 2.8 0 0 1 1.1 3.806 2.801 2.801 0 1 1-4.907-2.703M92.16 23.354a2.803 2.803 0 0 1 3.807-1.104 2.8 2.8 0 0 1 1.1 3.807 2.802 2.802 0 1 1-4.906-2.703M100.232 37.487a2.803 2.803 0 0 1 3.807-1.103 2.796 2.796 0 0 1 1.106 3.807 2.803 2.803 0 0 1-4.913-2.703M85.187 38.223a2.797 2.797 0 0 1 3.807-1.103 2.802 2.802 0 0 1 1.106 3.806 2.814 2.814 0 0 1-3.815 1.104 2.801 2.801 0 0 1-1.098-3.807M74.388 29.632a2.803 2.803 0 0 1 3.813-1.103 2.8 2.8 0 0 1 1.1 3.812 2.808 2.808 0 0 1-3.81 1.098 2.803 2.803 0 0 1-1.103-3.807M59.361 31.273a2.795 2.795 0 0 1 3.8-1.103 2.796 2.796 0 0 1 1.107 3.806 2.803 2.803 0 0 1-3.81 1.098 2.794 2.794 0 0 1-1.097-3.801M45.233 35.747a2.805 2.805 0 0 1 4.913 2.703 2.803 2.803 0 0 1-4.913-2.703M29.604 39.128a2.803 2.803 0 1 1 4.914 2.701 2.803 2.803 0 0 1-4.914-2.7M14.916 34.812a2.807 2.807 0 0 1 4.919 2.703 2.81 2.81 0 0 1-3.816 1.104 2.802 2.802 0 0 1-1.103-3.807M7.335 21.192a2.777 2.777 0 0 1 3.767-1.091 2.775 2.775 0 0 1-2.676 4.86 2.782 2.782 0 0 1-1.091-3.769M.951 38.573a1.174 1.174 0 0 1 1.594-.466c.574.314.771 1.026.46 1.594a1.167 1.167 0 0 1-1.593.466 1.177 1.177 0 0 1-.461-1.594M13.374 49.588a2.795 2.795 0 0 1 3.8-1.103 2.796 2.796 0 0 1 1.107 3.807 2.802 2.802 0 1 1-4.907-2.704M27.005 55.803a2.806 2.806 0 0 1 4.913 2.71 2.805 2.805 0 0 1-3.81 1.097 2.802 2.802 0 0 1-1.103-3.807M41.32 52.158a2.801 2.801 0 0 1 3.806-1.097 2.8 2.8 0 0 1 1.107 3.807 2.815 2.815 0 0 1-3.816 1.097 2.806 2.806 0 0 1-1.097-3.807M55.39 47.877a2.802 2.802 0 1 1 4.907 2.704 2.801 2.801 0 1 1-4.907-2.703M68.852 45.635a2.808 2.808 0 0 1 3.806-1.104 2.796 2.796 0 0 1 1.107 3.807 2.803 2.803 0 0 1-4.913-2.703M80.492 52.514a2.803 2.803 0 1 1 1.103 3.8 2.795 2.795 0 0 1-1.103-3.8M95.373 50.406a2.809 2.809 0 0 1 3.812-1.103 2.8 2.8 0 0 1 1.1 3.807 2.802 2.802 0 0 1-3.809 1.103 2.802 2.802 0 0 1-1.103-3.807M90.105 63.477a2.803 2.803 0 0 1 3.806-1.103 2.8 2.8 0 0 1 1.1 3.806 2.798 2.798 0 0 1-3.803 1.104 2.803 2.803 0 0 1-1.103-3.807M96.506 76.022a2.8 2.8 0 0 1 3.812-1.103 2.798 2.798 0 0 1 1.1 3.806 2.805 2.805 0 0 1-3.803 1.104 2.808 2.808 0 0 1-1.11-3.807M112.059 74.97a2.803 2.803 0 0 1 3.807-1.103 2.796 2.796 0 0 1 1.106 3.807 2.803 2.803 0 0 1-4.913-2.703M118.53 86.383a2.803 2.803 0 1 1 4.91 2.705 2.803 2.803 0 0 1-4.91-2.705M111.048 99.851a2.803 2.803 0 0 1 3.807-1.103 2.802 2.802 0 0 1 1.107 3.806 2.812 2.812 0 0 1-3.816 1.104 2.806 2.806 0 0 1-1.098-3.807M101.646 88.159a2.808 2.808 0 0 1 3.806-1.104 2.8 2.8 0 0 1 1.107 3.807 2.796 2.796 0 0 1-3.81 1.103 2.802 2.802 0 0 1-1.103-3.806M97.639 102.117a1.459 1.459 0 0 1 1.973-.571c.703.386.957 1.27.575 1.973a1.46 1.46 0 0 1-1.977.572 1.459 1.459 0 0 1-.571-1.974M296.464 231.412a2.667 2.667 0 0 1 3.62-1.053 2.67 2.67 0 0 1 1.048 3.621 2.664 2.664 0 1 1-4.668-2.568M310.084 230.612a2.803 2.803 0 0 1 3.806-1.104 2.802 2.802 0 1 1-2.703 4.91 2.798 2.798 0 0 1-1.103-3.806M307.49 243.595a2.784 2.784 0 0 1 3.78-1.092 2.78 2.78 0 0 1 1.098 3.777 2.789 2.789 0 0 1-3.78 1.094 2.782 2.782 0 0 1-1.098-3.78M319.463 253.547a2.768 2.768 0 1 1 4.847 2.676 2.77 2.77 0 0 1-3.755 1.08 2.763 2.763 0 0 1-1.092-3.756M333.305 262.629a2.542 2.542 0 0 1 3.457-.999 2.537 2.537 0 0 1 .998 3.45 2.536 2.536 0 0 1-3.45 1 2.538 2.538 0 0 1-1.005-3.451M349.775 267.786a2.643 2.643 0 0 1 4.626 2.554 2.644 2.644 0 0 1-3.592 1.037 2.639 2.639 0 0 1-1.034-3.591M344.443 255.457a2.806 2.806 0 0 1 3.806-1.098 2.8 2.8 0 0 1 1.1 3.807 2.805 2.805 0 0 1-3.803 1.103 2.809 2.809 0 0 1-1.103-3.812M332.294 248.121a2.803 2.803 0 0 1 3.807-1.103 2.807 2.807 0 0 1 1.107 3.812 2.806 2.806 0 0 1-3.81 1.098 2.797 2.797 0 0 1-1.104-3.807M320.993 239.6a2.803 2.803 0 0 1 3.807-1.103 2.809 2.809 0 0 1 1.106 3.812 2.805 2.805 0 0 1-3.81 1.098 2.802 2.802 0 0 1-1.103-3.807M323.96 225.67a2.798 2.798 0 0 1 3.807-1.103 2.796 2.796 0 0 1 1.106 3.807 2.812 2.812 0 0 1-3.815 1.103 2.806 2.806 0 0 1-1.098-3.806M333.883 233.205a2.802 2.802 0 1 1 4.907 2.703 2.802 2.802 0 1 1-4.907-2.703M344.034 240.593a2.8 2.8 0 0 1 3.806-1.098 2.798 2.798 0 0 1 1.1 3.801 2.809 2.809 0 0 1-3.809 1.11 2.808 2.808 0 0 1-1.097-3.813M354.517 246.866a2.803 2.803 0 0 1 3.807-1.104 2.796 2.796 0 0 1 1.106 3.807 2.802 2.802 0 0 1-3.81 1.103 2.798 2.798 0 0 1-1.103-3.806M359.58 258.447a2.801 2.801 0 0 1 3.807-1.098 2.8 2.8 0 1 1-2.703 4.905 2.802 2.802 0 0 1-1.103-3.807M366.875 269.625a2.741 2.741 0 1 1 4.8 2.647 2.739 2.739 0 0 1-3.72 1.08 2.744 2.744 0 0 1-1.08-3.727M382.142 267.704a2.79 2.79 0 0 1 4.89 2.691 2.786 2.786 0 0 1-3.792 1.095 2.787 2.787 0 0 1-1.098-3.786M373.785 256.38a2.801 2.801 0 0 1 3.806-1.098 2.798 2.798 0 0 1 1.1 3.807 2.796 2.796 0 0 1-3.803 1.097 2.798 2.798 0 0 1-1.103-3.807M387.644 254.084a2.803 2.803 0 0 1 3.807-1.103 2.802 2.802 0 1 1-2.704 4.91 2.803 2.803 0 0 1-1.103-3.807M397.187 265.333a2.697 2.697 0 1 1 4.726 2.603 2.697 2.697 0 0 1-4.726-2.603M410.351 259.183a2.801 2.801 0 0 1 3.807-1.098 2.793 2.793 0 0 1 1.106 3.801 2.808 2.808 0 0 1-3.81 1.103 2.798 2.798 0 0 1-1.103-3.806M400.639 250.06a2.803 2.803 0 0 1 3.807-1.103 2.8 2.8 0 0 1 1.1 3.806 2.805 2.805 0 0 1-3.81 1.104 2.806 2.806 0 0 1-1.097-3.807M392.287 239.36a2.797 2.797 0 0 1 3.807-1.103 2.805 2.805 0 0 1 1.1 3.807 2.805 2.805 0 0 1-3.81 1.097 2.794 2.794 0 0 1-1.097-3.8M379.38 242.567a2.805 2.805 0 0 1 3.806-1.097 2.802 2.802 0 0 1 1.107 3.806 2.805 2.805 0 0 1-3.81 1.098 2.797 2.797 0 0 1-1.103-3.807M366.671 244.757a2.798 2.798 0 0 1 3.807-1.103 2.802 2.802 0 1 1-2.703 4.91 2.798 2.798 0 0 1-1.104-3.807M357.128 233.614a2.808 2.808 0 0 1 3.8-1.104 2.812 2.812 0 0 1 1.113 3.813 2.805 2.805 0 0 1-3.816 1.097 2.798 2.798 0 0 1-1.097-3.806M346.545 226.284a2.797 2.797 0 0 1 3.807-1.103 2.8 2.8 0 0 1 1.1 3.806 2.801 2.801 0 1 1-4.907-2.703M335.816 218.271a2.803 2.803 0 0 1 3.807-1.103 2.802 2.802 0 1 1-2.703 4.91 2.803 2.803 0 0 1-1.104-3.807M325.7 210.52a2.8 2.8 0 0 1 3.807-1.103 2.799 2.799 0 0 1 1.107 3.807 2.812 2.812 0 0 1-3.81 1.103 2.808 2.808 0 0 1-1.103-3.806M337.603 202.636a2.797 2.797 0 0 1 3.807-1.103 2.802 2.802 0 1 1-2.703 4.91 2.798 2.798 0 0 1-1.104-3.807M347.993 212.495a2.803 2.803 0 0 1 3.807-1.104 2.807 2.807 0 0 1 1.107 3.813 2.81 2.81 0 0 1-3.816 1.097 2.806 2.806 0 0 1-1.098-3.806M360.107 219.422a2.807 2.807 0 0 1 3.812-1.098 2.802 2.802 0 0 1 1.107 3.807 2.812 2.812 0 0 1-3.816 1.103 2.809 2.809 0 0 1-1.103-3.812M373.65 218.312a2.801 2.801 0 0 1 3.807-1.098 2.8 2.8 0 0 1 1.106 3.807 2.81 2.81 0 0 1-3.81 1.098 2.803 2.803 0 0 1-1.103-3.807M369.89 231.167a2.801 2.801 0 0 1 3.806-1.098 2.795 2.795 0 0 1 1.106 3.8 2.802 2.802 0 0 1-3.81 1.104 2.802 2.802 0 0 1-1.103-3.806M383.088 228.778a2.8 2.8 0 0 1 3.807-1.098 2.8 2.8 0 0 1 1.106 3.807 2.812 2.812 0 0 1-3.815 1.104 2.807 2.807 0 0 1-1.098-3.813M396.27 225.098a2.801 2.801 0 0 1 3.807-1.097 2.8 2.8 0 0 1 1.106 3.807 2.807 2.807 0 0 1-3.81 1.103 2.803 2.803 0 0 1-1.103-3.813M387.036 215.105a2.797 2.797 0 0 1 3.807-1.103 2.8 2.8 0 0 1 1.1 3.807 2.801 2.801 0 1 1-4.907-2.703M399.967 210.643a2.803 2.803 0 0 1 3.807-1.103 2.802 2.802 0 1 1-2.704 4.91 2.798 2.798 0 0 1-1.103-3.807M413.184 206.789a2.8 2.8 0 0 1 3.807-1.098 2.793 2.793 0 0 1 1.1 3.8 2.801 2.801 0 1 1-4.907-2.703M427.335 204.178a2.801 2.801 0 0 1 3.807-1.097 2.802 2.802 0 1 1-2.703 4.91 2.809 2.809 0 0 1-1.104-3.813M442.585 205.002a2.803 2.803 0 1 1 4.91 2.705 2.803 2.803 0 0 1-4.91-2.705M456.648 208.062a2.802 2.802 0 0 1 3.807-1.104 2.802 2.802 0 0 1 1.106 3.807 2.808 2.808 0 0 1-3.815 1.103 2.8 2.8 0 0 1-1.098-3.806M470.227 213.33a2.805 2.805 0 0 1 4.913 2.703 2.803 2.803 0 0 1-4.913-2.703M459.61 222.102a2.801 2.801 0 0 1 3.806-1.097 2.793 2.793 0 0 1 1.1 3.8 2.8 2.8 0 1 1-4.907-2.703M446.369 218.487a2.803 2.803 0 0 1 3.807-1.103 2.802 2.802 0 0 1 1.106 3.806 2.812 2.812 0 0 1-3.816 1.104 2.801 2.801 0 0 1-1.097-3.807M434.174 215.251a2.801 2.801 0 0 1 3.807-1.097 2.799 2.799 0 1 1-2.703 4.904 2.803 2.803 0 0 1-1.104-3.807M433.584 228.44a2.81 2.81 0 0 1 3.813-1.104 2.802 2.802 0 1 1-2.703 4.91 2.8 2.8 0 0 1-1.11-3.807M427.814 242.036a2.794 2.794 0 0 1 3.8-1.098 2.804 2.804 0 0 1 1.113 3.807 2.812 2.812 0 0 1-3.816 1.097 2.8 2.8 0 0 1-1.097-3.806M419.182 231.558a2.797 2.797 0 0 1 3.807-1.104 2.802 2.802 0 0 1 1.106 3.807 2.805 2.805 0 0 1-3.81 1.097 2.791 2.791 0 0 1-1.103-3.8M421.904 217.979a2.801 2.801 0 0 1 3.806-1.098 2.795 2.795 0 0 1 1.107 3.801 2.802 2.802 0 0 1-3.81 1.103 2.802 2.802 0 0 1-1.103-3.806M409.183 221.197a2.802 2.802 0 1 1 4.907 2.703 2.801 2.801 0 1 1-4.907-2.703M405.469 235.36a2.803 2.803 0 0 1 3.806-1.104 2.8 2.8 0 0 1 1.1 3.807 2.8 2.8 0 0 1-3.803 1.103 2.798 2.798 0 0 1-1.103-3.806M414.048 245.505a2.807 2.807 0 0 1 4.919 2.71 2.81 2.81 0 0 1-3.815 1.096 2.803 2.803 0 0 1-1.104-3.806M424.368 254.931a2.794 2.794 0 0 1 3.801-1.097 2.795 2.795 0 1 1-2.697 4.895 2.8 2.8 0 0 1-1.104-3.798M438.882 253.751a2.801 2.801 0 0 1 3.806-1.097 2.795 2.795 0 0 1 1.107 3.8 2.81 2.81 0 0 1-3.81 1.11 2.805 2.805 0 0 1-1.103-3.813M440.768 241.014a2.802 2.802 0 0 1 3.807-1.104 2.807 2.807 0 0 1 1.106 3.813 2.805 2.805 0 0 1-3.81 1.097 2.797 2.797 0 0 1-1.103-3.806M448.408 231.458a2.802 2.802 0 1 1 4.907 2.704 2.802 2.802 0 1 1-4.907-2.704M460.707 236.148a2.803 2.803 0 1 1 4.91 2.706 2.803 2.803 0 0 1-4.91-2.706M453.74 247.368a2.798 2.798 0 0 1 3.806-1.103 2.8 2.8 0 1 1-2.703 4.904 2.791 2.791 0 0 1-1.103-3.801M452.151 260.807a2.72 2.72 0 0 1 3.696-1.062 2.71 2.71 0 0 1 1.07 3.684 2.715 2.715 0 0 1-3.692 1.074 2.727 2.727 0 0 1-1.074-3.696M464.457 258.283a2.796 2.796 0 0 1 3.813-1.097 2.796 2.796 0 0 1 1.1 3.8 2.809 2.809 0 0 1-3.81 1.11 2.806 2.806 0 0 1-1.103-3.813M478.223 259.194a2.42 2.42 0 0 1 3.295-.95 2.423 2.423 0 0 1 .957 3.298 2.43 2.43 0 0 1-3.301.954 2.43 2.43 0 0 1-.951-3.302M484.518 246.655a2.803 2.803 0 0 1 3.807-1.103 2.802 2.802 0 0 1 1.106 3.813 2.81 2.81 0 0 1-3.815 1.097 2.801 2.801 0 0 1-1.098-3.807M470.753 244.833a2.801 2.801 0 0 1 3.806-1.097 2.796 2.796 0 0 1 1.107 3.806 2.803 2.803 0 0 1-3.81 1.098 2.803 2.803 0 0 1-1.103-3.807M472.347 229.07a2.809 2.809 0 0 1 3.813-1.104 2.805 2.805 0 1 1-3.813 1.104M485.05 233.952a2.803 2.803 0 0 1 3.807-1.103 2.802 2.802 0 1 1-2.703 4.91 2.798 2.798 0 0 1-1.104-3.807M483.286 219.976a2.737 2.737 0 0 1 4.796 2.64 2.748 2.748 0 0 1-3.722 1.08 2.742 2.742 0 0 1-1.074-3.72"
  })));
}

function Figures(props) {
  var _props$width, _props$height, _props$position, _props$zIndex, _props$marginLeft, _props$marginRight, _props$marginTop, _props$marginBottom, _props$transform, _props$top, _props$left, _props$right, _props$bottom, _props$opacity, _props$color;
  return React__default.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 65,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 57,
    viewBox: "0 0 65 57",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      position: (_props$position = props.position) !== null && _props$position !== void 0 ? _props$position : 'relative',
      zIndex: (_props$zIndex = props.zIndex) !== null && _props$zIndex !== void 0 ? _props$zIndex : 1.1,
      marginLeft: (_props$marginLeft = props.marginLeft) !== null && _props$marginLeft !== void 0 ? _props$marginLeft : 0,
      marginRight: (_props$marginRight = props.marginRight) !== null && _props$marginRight !== void 0 ? _props$marginRight : 0,
      marginTop: (_props$marginTop = props.marginTop) !== null && _props$marginTop !== void 0 ? _props$marginTop : 0,
      marginBottom: (_props$marginBottom = props.marginBottom) !== null && _props$marginBottom !== void 0 ? _props$marginBottom : 0,
      transform: (_props$transform = props.transform) !== null && _props$transform !== void 0 ? _props$transform : 'initial',
      top: (_props$top = props.top) !== null && _props$top !== void 0 ? _props$top : 'initial',
      left: (_props$left = props.left) !== null && _props$left !== void 0 ? _props$left : 'initial',
      right: (_props$right = props.right) !== null && _props$right !== void 0 ? _props$right : 'initial',
      bottom: (_props$bottom = props.bottom) !== null && _props$bottom !== void 0 ? _props$bottom : 'initial',
      opacity: (_props$opacity = props.opacity) !== null && _props$opacity !== void 0 ? _props$opacity : 1
    }
  }, React__default.createElement("path", {
    d: "M46.463.923c8.21 0 12.501 4.204 14.472 7.899a32.203 32.203 0 0 1 3.81 15.194c0 17.704-14.325 32.061-32 32.061-17.676 0-32-14.357-32-32.061A32.127 32.127 0 0 1 4.56 8.822c1.964-3.695 6.256-7.9 14.465-7.9ZM42.85 8.184H22.638c-6.047 0-9.209 3.097-10.656 5.82a23.667 23.667 0 0 0-2.811 11.193c0 13.042 10.552 23.619 23.574 23.619 13.021 0 23.573-10.577 23.573-23.62 0-4.05-1.027-7.855-2.806-11.193-1.452-2.722-4.614-5.819-10.661-5.819Z",
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.BLUE,
    fillRule: "nonzero"
  }));
}

function FiguresFull(props) {
  var _props$width, _props$height, _props$position, _props$zIndex, _props$marginLeft, _props$marginRight, _props$marginTop, _props$marginBottom, _props$transform, _props$top, _props$left, _props$right, _props$bottom, _props$opacity, _props$color;
  return React__default.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 100,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      position: (_props$position = props.position) !== null && _props$position !== void 0 ? _props$position : 'relative',
      zIndex: (_props$zIndex = props.zIndex) !== null && _props$zIndex !== void 0 ? _props$zIndex : 1.1,
      marginLeft: (_props$marginLeft = props.marginLeft) !== null && _props$marginLeft !== void 0 ? _props$marginLeft : 0,
      marginRight: (_props$marginRight = props.marginRight) !== null && _props$marginRight !== void 0 ? _props$marginRight : 0,
      marginTop: (_props$marginTop = props.marginTop) !== null && _props$marginTop !== void 0 ? _props$marginTop : 0,
      marginBottom: (_props$marginBottom = props.marginBottom) !== null && _props$marginBottom !== void 0 ? _props$marginBottom : 0,
      transform: (_props$transform = props.transform) !== null && _props$transform !== void 0 ? _props$transform : 'initial',
      top: (_props$top = props.top) !== null && _props$top !== void 0 ? _props$top : 'initial',
      left: (_props$left = props.left) !== null && _props$left !== void 0 ? _props$left : 'initial',
      right: (_props$right = props.right) !== null && _props$right !== void 0 ? _props$right : 'initial',
      bottom: (_props$bottom = props.bottom) !== null && _props$bottom !== void 0 ? _props$bottom : 'initial',
      opacity: (_props$opacity = props.opacity) !== null && _props$opacity !== void 0 ? _props$opacity : 1
    }
  }, React__default.createElement("g", {
    transform: "matrix(0.233081,0,0,0.233081,71.4347,93.0895)"
  }, React__default.createElement("path", {
    d: "M0,-369.738C55.033,-369.738 83.804,-341.555 97.017,-316.787C113.206,-286.416 122.555,-251.79 122.555,-214.929C122.555,-96.244 26.531,0 -91.963,0C-210.455,0 -306.48,-96.244 -306.48,-214.929C-306.48,-251.79 -297.131,-286.416 -280.895,-316.787C-267.729,-341.555 -238.958,-369.738 -183.925,-369.738L0,-369.738Z",
    style: {
      fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY
    }
  })));
}

function Oval(props) {
  var _props$width, _props$height, _props$position, _props$zIndex, _props$marginLeft, _props$marginRight, _props$marginTop, _props$marginBottom, _props$transform, _props$top, _props$left, _props$right, _props$bottom, _props$opacity, _props$color;
  return React__default.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 55,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 55,
    viewBox: "0 0 55 55",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      position: (_props$position = props.position) !== null && _props$position !== void 0 ? _props$position : 'relative',
      zIndex: (_props$zIndex = props.zIndex) !== null && _props$zIndex !== void 0 ? _props$zIndex : 1.1,
      marginLeft: (_props$marginLeft = props.marginLeft) !== null && _props$marginLeft !== void 0 ? _props$marginLeft : 0,
      marginRight: (_props$marginRight = props.marginRight) !== null && _props$marginRight !== void 0 ? _props$marginRight : 0,
      marginTop: (_props$marginTop = props.marginTop) !== null && _props$marginTop !== void 0 ? _props$marginTop : 0,
      marginBottom: (_props$marginBottom = props.marginBottom) !== null && _props$marginBottom !== void 0 ? _props$marginBottom : 0,
      transform: (_props$transform = props.transform) !== null && _props$transform !== void 0 ? _props$transform : 'initial',
      top: (_props$top = props.top) !== null && _props$top !== void 0 ? _props$top : 'initial',
      left: (_props$left = props.left) !== null && _props$left !== void 0 ? _props$left : 'initial',
      right: (_props$right = props.right) !== null && _props$right !== void 0 ? _props$right : 'initial',
      bottom: (_props$bottom = props.bottom) !== null && _props$bottom !== void 0 ? _props$bottom : 'initial',
      opacity: (_props$opacity = props.opacity) !== null && _props$opacity !== void 0 ? _props$opacity : 1
    }
  }, React__default.createElement("ellipse", {
    cx: 487.491,
    cy: 165.5,
    rx: 27,
    ry: 26.985,
    transform: "translate(-460 -138)",
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.BLUE,
    fillRule: "nonzero"
  }));
}

function Stripes(props) {
  var _props$width, _props$height, _props$position, _props$zIndex, _props$marginLeft, _props$marginRight, _props$marginTop, _props$marginBottom, _props$transform, _props$top, _props$left, _props$right, _props$bottom, _props$opacity, _props$color;
  return React__default.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 76,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 33,
    viewBox: "0 0 76 33",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      position: (_props$position = props.position) !== null && _props$position !== void 0 ? _props$position : 'relative',
      zIndex: (_props$zIndex = props.zIndex) !== null && _props$zIndex !== void 0 ? _props$zIndex : 1.1,
      marginLeft: (_props$marginLeft = props.marginLeft) !== null && _props$marginLeft !== void 0 ? _props$marginLeft : 0,
      marginRight: (_props$marginRight = props.marginRight) !== null && _props$marginRight !== void 0 ? _props$marginRight : 0,
      marginTop: (_props$marginTop = props.marginTop) !== null && _props$marginTop !== void 0 ? _props$marginTop : 0,
      marginBottom: (_props$marginBottom = props.marginBottom) !== null && _props$marginBottom !== void 0 ? _props$marginBottom : 0,
      transform: (_props$transform = props.transform) !== null && _props$transform !== void 0 ? _props$transform : 'initial',
      top: (_props$top = props.top) !== null && _props$top !== void 0 ? _props$top : 'initial',
      left: (_props$left = props.left) !== null && _props$left !== void 0 ? _props$left : 'initial',
      right: (_props$right = props.right) !== null && _props$right !== void 0 ? _props$right : 'initial',
      bottom: (_props$bottom = props.bottom) !== null && _props$bottom !== void 0 ? _props$bottom : 'initial',
      opacity: (_props$opacity = props.opacity) !== null && _props$opacity !== void 0 ? _props$opacity : 1
    }
  }, React__default.createElement("g", {
    transform: "translate(-572 -149)",
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("g", {
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.BLUE
  }, React__default.createElement("path", {
    d: "M592.65 181.5h48.244c3.265 0 5.924-2.625 5.924-5.838 0-3.212-2.659-5.833-5.924-5.833h-48.245V181.5ZM572.737 161.17h48.245c3.265 0 5.924-2.624 5.924-5.837 0-3.213-2.66-5.833-5.924-5.833h-48.245v11.67Z"
  }))));
}

function Confetti(props) {
  var render = function render() {
    switch (props.type) {
      case 'C':
        return React$4.createElement(C, {
          height: props.height,
          width: props.width,
          color: props.color,
          marginLeft: props.marginLeft,
          marginRight: props.marginRight,
          marginTop: props.marginTop,
          marginBottom: props.marginBottom,
          transform: props.transform,
          position: props.position,
          top: props.top,
          left: props.left,
          right: props.right,
          bottom: props.bottom,
          opacity: props.opacity,
          zIndex: props.zIndex
        });
      case 'DotsPath':
        return React$4.createElement(DotsPath, {
          height: props.height,
          width: props.width,
          color: props.color,
          marginLeft: props.marginLeft,
          marginRight: props.marginRight,
          marginTop: props.marginTop,
          marginBottom: props.marginBottom,
          transform: props.transform,
          position: props.position,
          top: props.top,
          left: props.left,
          right: props.right,
          bottom: props.bottom,
          opacity: props.opacity,
          zIndex: props.zIndex
        });
      case 'Figure':
        return React$4.createElement(Figures, {
          height: props.height,
          width: props.width,
          color: props.color,
          marginLeft: props.marginLeft,
          marginRight: props.marginRight,
          marginTop: props.marginTop,
          marginBottom: props.marginBottom,
          transform: props.transform,
          position: props.position,
          top: props.top,
          left: props.left,
          right: props.right,
          bottom: props.bottom,
          opacity: props.opacity,
          zIndex: props.zIndex
        });
      case 'FigureFull':
        return React$4.createElement(FiguresFull, {
          height: props.height,
          width: props.width,
          color: props.color,
          marginLeft: props.marginLeft,
          marginRight: props.marginRight,
          marginTop: props.marginTop,
          marginBottom: props.marginBottom,
          transform: props.transform,
          position: props.position,
          top: props.top,
          left: props.left,
          right: props.right,
          bottom: props.bottom,
          opacity: props.opacity,
          zIndex: props.zIndex
        });
      case 'Oval':
        return React$4.createElement(Oval, {
          height: props.height,
          width: props.width,
          color: props.color,
          marginLeft: props.marginLeft,
          marginRight: props.marginRight,
          marginTop: props.marginTop,
          marginBottom: props.marginBottom,
          transform: props.transform,
          position: props.position,
          top: props.top,
          left: props.left,
          right: props.right,
          bottom: props.bottom,
          opacity: props.opacity,
          zIndex: props.zIndex
        });
      case 'Stripes':
        return React$4.createElement(Stripes, {
          height: props.height,
          width: props.width,
          color: props.color,
          marginLeft: props.marginLeft,
          marginRight: props.marginRight,
          marginTop: props.marginTop,
          marginBottom: props.marginBottom,
          transform: props.transform,
          position: props.position,
          top: props.top,
          left: props.left,
          right: props.right,
          bottom: props.bottom,
          opacity: props.opacity,
          zIndex: props.zIndex
        });
      default:
        return React$4.createElement("div", null);
    }
  };
  return render();
}

function Image(props) {
  var renderWrapper = function renderWrapper() {
    var _props$width, _props$height, _props$minHeight, _props$minWidth, _props$backgroundSize, _props$borderRadius, _props$backdropFilter;
    switch (props.wrapper) {
      case 'Figure':
        return React$4.createElement(WrapperFigure, {
          id: props.id,
          src: props.src,
          width: props.width,
          height: props.height
        });
      default:
        return React$4.createElement("div", {
          id: props.id,
          style: {
            width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : '100%',
            height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : '100%',
            minHeight: (_props$minHeight = props.minHeight) !== null && _props$minHeight !== void 0 ? _props$minHeight : 'auto',
            minWidth: (_props$minWidth = props.minWidth) !== null && _props$minWidth !== void 0 ? _props$minWidth : 'auto',
            backgroundColor: props.transparent ? 'transparent' : Colors.MEDIUM_WHITE,
            backgroundImage: "url('".concat(props.src, "')"),
            backgroundPosition: 'center',
            backgroundSize: (_props$backgroundSize = props.backgroundSize) !== null && _props$backgroundSize !== void 0 ? _props$backgroundSize : 'cover',
            backgroundRepeat: 'no-repeat',
            borderRadius: (_props$borderRadius = props.borderRadius) !== null && _props$borderRadius !== void 0 ? _props$borderRadius : 10,
            aspectRatio: '1.85 / 1',
            backdropFilter: (_props$backdropFilter = props.backdropFilter) !== null && _props$backdropFilter !== void 0 ? _props$backdropFilter : 'initial'
          }
        });
    }
  };
  return React$4.createElement("div", {
    className: "DisableSelection",
    style: {
      height: '100%',
      width: '100%',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, renderWrapper(), props.confetti && React$4.createElement("div", {
    style: {
      position: 'absolute',
      width: '100%',
      height: '100%'
    }
  }, React$4.createElement(Confetti, {
    type: props.confetti.type,
    height: props.confetti.height,
    width: props.confetti.width,
    color: props.confetti.color,
    marginLeft: props.confetti.marginLeft,
    marginRight: props.confetti.marginRight,
    marginTop: props.confetti.marginTop,
    marginBottom: props.confetti.marginBottom,
    transform: props.confetti.transform,
    position: props.confetti.position,
    top: props.confetti.top,
    left: props.confetti.left,
    right: props.confetti.right,
    bottom: props.confetti.bottom,
    opacity: props.confetti.opacity
  })));
}

function SegmentedControl(props) {
  var size = useDimensions();
  return size.width < Breakpoint.sm ? React$4.createElement("div", {
    style: {
      height: size.width < Breakpoint.fd ? 'auto' : 40,
      width: '100%',
      backgroundColor: Colors.WHITE,
      border: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderRadius: 7,
      display: 'flex',
      flexDirection: size.width < Breakpoint.fd ? 'column' : 'row',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  }, props.items.map(function (e, i) {
    return React$4.createElement(React$4.Fragment, null, React$4.createElement("button", {
      key: e.id,
      type: "button",
      className: "Hover",
      onClick: e.onClick,
      style: {
        height: 40,
        width: '100%',
        border: 'solid 0px transparent',
        backgroundColor: e.selected ? Colors.WHITE : 'transparent',
        borderRadius: 7,
        fontSize: '1em',
        boxShadow: e.selected ? "0px 0px 10px 1px ".concat(Colors.MEDIUM_GREY) : 'inherit',
        paddingBottom: !e.selected && i + 1 !== props.items.length && !props.items[i + 1].selected ? 0 : 2
      }
    }, React$4.createElement(Text, {
      textAlign: "center",
      fontSize: "1em"
    }, e.title)), React$4.createElement("span", {
      style: {
        width: size.width < Breakpoint.fd ? '90%' : 2,
        minWidth: size.width < Breakpoint.fd ? '90%' : 2,
        maxWidth: size.width < Breakpoint.fd ? '90%' : 2,
        height: size.width < Breakpoint.fd ? 2 : '60%',
        marginTop: size.width < Breakpoint.fd ? 0 : '20%',
        marginBottom: size.width < Breakpoint.fd ? 0 : '20%',
        backgroundColor: !e.selected && i + 1 !== props.items.length && !props.items[i + 1].selected ? Colors.MEDIUM_WHITE : 'transparent'
      }
    }));
  })) : React$4.createElement("div", {
    style: {
      width: '100%',
      height: 'auto',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start'
    }
  }, props.items.map(function (e, i) {
    return React$4.createElement("div", {
      key: e.id,
      style: {
        marginRight: i + 1 === props.items.length ? 0 : 15,
        width: 'auto'
      }
    }, React$4.createElement(Buttons$1, {
      text: e.title,
      onClick: e.onClick,
      size: "medium",
      colorScheme: "white",
      selectable: true,
      selected: e.selected
    }));
  }));
}

function ScrollDownArrow() {
  return React$4.createElement("div", {
    style: {
      height: 80,
      width: 80,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, React$4.createElement("span", {
    className: "ScrollDownLine",
    style: {
      display: 'block',
      position: 'relative',
      paddingTop: 79,
      textAlign: 'center'
    }
  }, React$4.createElement("span", {
    className: "ScrollDownArrow",
    style: {
      display: 'block',
      margin: '0 auto',
      width: 10,
      height: 38
    }
  })));
}

var Tip$1 = function Tip(_ref, ref) {
  var size = _ref.size,
      position = _ref.position,
      content = _ref.content,
      width = _ref.width;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      visible = _React$useState2[0],
      setVisible = _React$useState2[1];
  var iconRef = React$4.useRef();
  var DEFAULT_SIZE = 25;
  var getPosition = function getPosition() {
    switch (position) {
      case 'right':
        return {
          left: iconRef.current.offsetLeft + 35
        };
      case 'top':
        return {
          bottom: iconRef.current.offsetTop + 35
        };
      case 'bottom':
        return {
          top: iconRef.current.offsetTop + 35
        };
      case 'left':
        return {
          right: iconRef.current.offsetLeft + 35
        };
      default:
        return {
          left: iconRef.current.offsetLeft + 35
        };
    }
  };
  return React$4.createElement("div", {
    ref: ref,
    style: {
      position: 'relative'
    }
  }, visible && React$4.createElement(React$4.Fragment, null, React$4.createElement("div", {
    onMouseEnter: function onMouseEnter() {
      setVisible(true);
    },
    onMouseLeave: function onMouseLeave() {
      setVisible(false);
    },
    style: {
      position: 'absolute',
      height: 50,
      width: 50,
      left: -12.5,
      top: -12.5
    }
  }), React$4.createElement("div", {
    className: "Blur",
    onMouseEnter: function onMouseEnter() {
      setVisible(true);
    },
    onMouseLeave: function onMouseLeave() {
      setVisible(false);
    },
    style: _objectSpread2(_objectSpread2({
      position: 'absolute'
    }, getPosition()), {}, {
      minHeight: 30,
      width: width !== null && width !== void 0 ? width : 300,
      border: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderRadius: 10,
      padding: 15,
      zIndex: 99,
      background: Backgrounds.BLUR
    })
  }, React$4.createElement(Text, {
    fontSize: "1em",
    color: Colors.GREY
  }, content))), React$4.createElement("div", {
    ref: iconRef,
    onMouseEnter: function onMouseEnter() {
      setVisible(true);
    },
    style: {
      cursor: 'pointer',
      width: size !== null && size !== void 0 ? size : DEFAULT_SIZE,
      height: size !== null && size !== void 0 ? size : DEFAULT_SIZE
    }
  }, React$4.createElement(Icon, {
    name: "InfoCircle",
    height: size !== null && size !== void 0 ? size : DEFAULT_SIZE,
    width: size !== null && size !== void 0 ? size : DEFAULT_SIZE,
    color: Colors.DARK_WHITE,
    iconSet: "FA"
  })));
};
var index = React$4.forwardRef(Tip$1);

function Tag(props) {
  return React$4.createElement("div", {
    style: {
      width: 'auto',
      paddingLeft: 15,
      paddingRight: 15,
      paddingTop: 5,
      paddingBottom: 5,
      borderRadius: 7.5,
      backgroundColor: props.backgroundColor
    }
  }, React$4.createElement(Text, {
    color: Colors.WHITE,
    fontSize: "1.1em",
    fontWeight: 500
  }, props.title));
}

function PayAttention(props) {
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  return React$4.createElement("div", {
    style: {
      width: '100%',
      height: 'auto',
      backgroundColor: Colors.GRADIENT,
      borderRadius: 10,
      border: "solid 2px ".concat(Colors.BLUE),
      padding: 15
    }
  }, React$4.createElement("div", {
    className: "DisableSelection",
    style: {
      marginBottom: 15
    }
  }, React$4.createElement(Text, {
    color: Colors.BLUE,
    fontWeight: 500
  }, "".concat(_('payAttention', {
    ns: 'ui'
  }), ":"))), React$4.createElement(Text, {
    color: Colors.BLUE
  }, props.text));
}

function Tip(props) {
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  return React$4.createElement("div", {
    style: {
      width: '100%',
      height: 'auto',
      backgroundColor: Colors.LIGHT_GREEN,
      borderRadius: 10,
      border: "solid 2px ".concat(Colors.GREEN),
      padding: 15
    }
  }, React$4.createElement("div", {
    className: "DisableSelection",
    style: {
      marginBottom: 15
    }
  }, React$4.createElement(Text, {
    color: "#00B67D",
    fontWeight: 500
  }, "".concat(_('tip', {
    ns: 'ui'
  }), ":"))), React$4.createElement(Text, {
    color: "#00B67D"
  }, props.text));
}

function NB(props) {
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  return React$4.createElement("div", {
    style: {
      width: '100%',
      height: 'auto',
      backgroundColor: Colors.LIGHT_RED,
      borderRadius: 10,
      border: "solid 2px ".concat(Colors.RED),
      padding: 15
    }
  }, React$4.createElement("div", {
    className: "DisableSelection",
    style: {
      marginBottom: 15
    }
  }, React$4.createElement(Text, {
    color: Colors.DARK_RED,
    fontWeight: 500
  }, "".concat(_('payAttention', {
    ns: 'ui'
  }), ":"))), React$4.createElement(Text, {
    color: Colors.DARK_RED
  }, props.warningType === 'expiredCardWarning' ? _('chargeCardExpired', {
    ns: 'chargecard',
    date: props.readableDate
  }) : _('authenticationChargeCard', {
    ns: 'chargecard'
  })));
}

function InfoBlock(props) {
  switch (props.type) {
    case 'payAttention':
      return React$4.createElement(PayAttention, {
        text: props.text
      });
    case 'tip':
      return React$4.createElement(Tip, {
        text: props.text
      });
    case 'NB':
      return React$4.createElement(NB, {
        text: props.text,
        warningType: props.warningType,
        readableDate: props.readableDate
      });
    default:
      return React$4.createElement("div", null);
  }
}

var globalId = 0;
var Hubspot = function (_React$Component) {
  _inherits$4(Hubspot, _React$Component);
  var _super = _createSuper$5(Hubspot);
  function Hubspot(props) {
    var _this;
    _classCallCheck$6(this, Hubspot);
    _this = _super.call(this, props);
    _this.state = {
      loaded: false
    };
    _this.id = globalId++;
    _this.createForm = _this.createForm.bind(_assertThisInitialized$4(_this));
    _this.findFormElement = _this.findFormElement.bind(_assertThisInitialized$4(_this));
    return _this;
  }
  _createClass$6(Hubspot, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!window.hbspt && !this.props.noScript) {
        this.loadScript();
      } else {
        this.createForm();
        this.findFormElement();
      }
    }
  }, {
    key: "createForm",
    value: function createForm() {
      var _this2 = this;
      if (window.hbspt) {
        if (this.el === null) return;
        var props = _objectSpread2({}, this.props);
        delete props.loading;
        delete props.onSubmit;
        delete props.onReady;
        var options = _objectSpread2(_objectSpread2({}, props), {}, {
          target: "#".concat(this.el.getAttribute('id')),
          onFormSubmit: function onFormSubmit($form) {
            var data = $form.serializeArray();
            _this2.props.onSubmit(data);
          }
        });
        window.hbspt.forms.create(options);
      } else {
        setTimeout(this.createForm, 1);
      }
    }
  }, {
    key: "loadScript",
    value: function loadScript() {
      var _this3 = this;
      var script = document.createElement('script');
      script.defer = true;
      script.onload = function () {
        _this3.createForm();
        _this3.findFormElement();
      };
      script.src = '//js.hsforms.net/forms/v2.js';
      document.head.appendChild(script);
    }
  }, {
    key: "findFormElement",
    value: function findFormElement() {
      if (this.el === null) return;
      var form = this.el.querySelector('iframe');
      if (form) {
        this.setState({
          loaded: true
        });
        if (this.props.onReady) {
          this.props.onReady(form);
        }
      } else {
        setTimeout(this.findFormElement, 1);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      return React$4.createElement("div", null, React$4.createElement("div", {
        ref: function ref(el) {
          return _this4.el = el;
        },
        id: "Form".concat(this.id),
        style: {
          display: this.state.loaded ? 'block' : 'none',
          visibility: this.state.loaded ? 'visible' : 'hidden'
        }
      }));
    }
  }]);
  return Hubspot;
}(React$4.Component);

var cookieUniversalCommon=function(e){function t(o){if(r[o])return r[o].exports;var n=r[o]={i:o,l:!1,exports:{}};return e[o].call(n.exports,n,n.exports,t),n.l=!0,n.exports}var r={};return t.m=e,t.c=r,t.d=function(e,r,o){t.o(e,r)||Object.defineProperty(e,r,{configurable:!1,enumerable:!0,get:o});},t.n=function(e){var r=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(r,"a",r),r},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=0)}([function(e,t,r){var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},n=r(1);e.exports=function(t,r){var i=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],a="object"===("undefined"==typeof document?"undefined":o(document))&&"string"==typeof document.cookie,s="object"===(void 0===t?"undefined":o(t))&&"object"===(void 0===r?"undefined":o(r))&&void 0!==e,u=!a&&!s||a&&s,f=function(e){if(s){var o=t.headers.cookie||"";return e&&(o=r.getHeaders(),o=o["set-cookie"]?o["set-cookie"].map(function(e){return e.split(";")[0]}).join(";"):""),o}if(a)return document.cookie||""},c=function(){var e=r.getHeader("Set-Cookie");return (e="string"==typeof e?[e]:e)||[]},p=function(e){return r.setHeader("Set-Cookie",e)},d=function(e,t){if(!t)return e;try{return JSON.parse(e)}catch(t){return e}},l={parseJSON:i,set:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{path:"/"};if(!u)if(t="object"===(void 0===t?"undefined":o(t))?JSON.stringify(t):t,s){var i=c();i.push(n.serialize(e,t,r)),p(i);}else document.cookie=n.serialize(e,t,r);},setAll:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];u||Array.isArray(e)&&e.forEach(function(e){var t=e.name,r=void 0===t?"":t,o=e.value,n=void 0===o?"":o,i=e.opts,a=void 0===i?{path:"/"}:i;l.set(r,n,a);});},get:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{fromRes:!1,parseJSON:l.parseJSON};if(u)return "";var r=n.parse(f(t.fromRes)),o=r[e];return d(o,t.parseJSON)},getAll:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{fromRes:!1,parseJSON:l.parseJSON};if(u)return {};var t=n.parse(f(e.fromRes));for(var r in t)t[r]=d(t[r],e.parseJSON);return t},remove:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{path:"/"};u||(t.expires=new Date(0),l.set(e,"",t));},removeAll:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{path:"/"};if(!u){var t=n.parse(f());for(var r in t)l.remove(r,e);}},nodeCookie:n};return l};},function(e,t,r){function o(e,t){if("string"!=typeof e)throw new TypeError("argument str must be a string");for(var r={},o=t||{},n=e.split(u),s=o.decode||a,f=0;f<n.length;f++){var c=n[f],p=c.indexOf("=");if(!(p<0)){var d=c.substr(0,p).trim(),l=c.substr(++p,c.length).trim();'"'==l[0]&&(l=l.slice(1,-1)),void 0==r[d]&&(r[d]=i(l,s));}}return r}function n(e,t,r){var o=r||{},n=o.encode||s;if("function"!=typeof n)throw new TypeError("option encode is invalid");if(!f.test(e))throw new TypeError("argument name is invalid");var i=n(t);if(i&&!f.test(i))throw new TypeError("argument val is invalid");var a=e+"="+i;if(null!=o.maxAge){var u=o.maxAge-0;if(isNaN(u))throw new Error("maxAge should be a Number");a+="; Max-Age="+Math.floor(u);}if(o.domain){if(!f.test(o.domain))throw new TypeError("option domain is invalid");a+="; Domain="+o.domain;}if(o.path){if(!f.test(o.path))throw new TypeError("option path is invalid");a+="; Path="+o.path;}if(o.expires){if("function"!=typeof o.expires.toUTCString)throw new TypeError("option expires is invalid");a+="; Expires="+o.expires.toUTCString();}if(o.httpOnly&&(a+="; HttpOnly"),o.secure&&(a+="; Secure"),o.sameSite){switch("string"==typeof o.sameSite?o.sameSite.toLowerCase():o.sameSite){case!0:a+="; SameSite=Strict";break;case"lax":a+="; SameSite=Lax";break;case"strict":a+="; SameSite=Strict";break;case"none":a+="; SameSite=None";break;default:throw new TypeError("option sameSite is invalid")}}return a}function i(e,t){try{return t(e)}catch(t){return e}}/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */
t.parse=o,t.serialize=n;var a=decodeURIComponent,s=encodeURIComponent,u=/; */,f=/^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;}]);

const ErrorBoundaryContext = createContext(null);
const initialState = {
  didCatch: false,
  error: null
};
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
    this.state = initialState;
  }
  static getDerivedStateFromError(error) {
    return {
      didCatch: true,
      error
    };
  }
  resetErrorBoundary(...args) {
    const {
      error
    } = this.state;
    if (error !== null) {
      this.props.onReset?.({
        args,
        reason: "imperative-api"
      });
      this.setState(initialState);
    }
  }
  componentDidCatch(error, info) {
    this.props.onError?.(error, info);
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      didCatch
    } = this.state;
    const {
      resetKeys
    } = this.props;
    if (didCatch && prevState.error !== null && hasArrayChanged(prevProps.resetKeys, resetKeys)) {
      this.props.onReset?.({
        next: resetKeys,
        prev: prevProps.resetKeys,
        reason: "keys"
      });
      this.setState(initialState);
    }
  }
  render() {
    const {
      children,
      fallbackRender,
      FallbackComponent,
      fallback
    } = this.props;
    const {
      didCatch,
      error
    } = this.state;
    let childToRender = children;
    if (didCatch) {
      const props = {
        error,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (isValidElement(fallback)) {
        childToRender = fallback;
      } else if (typeof fallbackRender === "function") {
        childToRender = fallbackRender(props);
      } else if (FallbackComponent) {
        childToRender = createElement(FallbackComponent, props);
      } else {
        throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
      }
    }
    return createElement(ErrorBoundaryContext.Provider, {
      value: {
        didCatch,
        error,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, childToRender);
  }
}
function hasArrayChanged(a = [], b = []) {
  return a.length !== b.length || a.some((item, index) => !Object.is(item, b[index]));
}

var loadScriptByURL = function loadScriptByURL(id, url, callback) {
  var isScriptExist = document.getElementById(id);
  if (!isScriptExist) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.id = id;
    script.onload = function () {
      if (callback) callback();
    };
    document.body.appendChild(script);
  }
  if (isScriptExist && callback) callback();
};

var HubspotCustom = function HubspotCustom(props) {
  var _ref2, _props$submitButton$t, _props$submitButton, _form$displayOptions, _props$submitButton$c, _props$submitButton2;
  var size = useDimensions();
  var cookies = cookieUniversalCommon();
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var ref = React$4.useRef();
  var _React$useState = React$4.useState({}),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      form = _React$useState2[0],
      setForm = _React$useState2[1];
  var _React$useState3 = React$4.useState(true),
      _React$useState4 = _slicedToArray$5(_React$useState3, 2),
      loading = _React$useState4[0],
      setLoading = _React$useState4[1];
  var _React$useState5 = React$4.useState([]),
      _React$useState6 = _slicedToArray$5(_React$useState5, 2),
      requiredFields = _React$useState6[0],
      setRequiredFields = _React$useState6[1];
  var _React$useState7 = React$4.useState(null),
      _React$useState8 = _slicedToArray$5(_React$useState7, 2),
      error = _React$useState8[0],
      setError = _React$useState8[1];
  var _React$useState9 = React$4.useState([]),
      _React$useState10 = _slicedToArray$5(_React$useState9, 2),
      response = _React$useState10[0],
      setResponse = _React$useState10[1];
  var _React$useState11 = React$4.useState([]),
      _React$useState12 = _slicedToArray$5(_React$useState11, 2),
      notFilled = _React$useState12[0],
      setNotFilled = _React$useState12[1];
  var _React$useState13 = React$4.useState(false),
      _React$useState14 = _slicedToArray$5(_React$useState13, 2),
      submitting = _React$useState14[0],
      setSubmitting = _React$useState14[1];
  var updateInput = function updateInput(name, value, objectTypeId) {
    var existing = response.find(function (i) {
      return i.name === name;
    });
    if (existing) {
      setResponse(function (prev) {
        return prev.map(function (i) {
          if (i.name === name) {
            return _objectSpread2(_objectSpread2({}, i), {}, {
              value: value
            });
          }
          return i;
        });
      });
    } else {
      setResponse(function (prev) {
        return [].concat(_toConsumableArray$5(prev), [{
          objectTypeId: objectTypeId,
          name: name,
          value: value
        }]);
      });
    }
  };
  React$4.useEffect(function () {
    if (!props.id) {
      throw new Error('form id is not specified but is a required prop of the Form component.');
    }
    fetch("".concat(process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://www.bluecurrent.nl', "/api/get-form?form=").concat(props.id)).then( function () {
      var _ref = _asyncToGenerator( _regeneratorRuntime().mark(function _callee(data) {
        var body;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return data.json();
              case 2:
                body = _context.sent;
                if (data.ok) {
                  _context.next = 7;
                  break;
                }
                setError(_('errors.somethingWrong', {
                  ns: 'ui'
                }));
                if (props.onError) props.onError(body.message, 'getting');
                return _context.abrupt("return");
              case 7:
                setForm(body);
                setLoading(false);
                body.fieldGroups.forEach(function (fieldGroup) {
                  if (fieldGroup.fields) {
                    fieldGroup.fields.forEach(function (field) {
                      if (field.required) {
                        setRequiredFields(function (prev) {
                          return [].concat(_toConsumableArray$5(prev), [field.name]);
                        });
                      }
                      if (field.defaultValue) {
                        updateInput(field.name, field.defaultValue, field.objectTypeId);
                      }
                      if (field.defaultValues) {
                        updateInput(field.name, field.defaultValues.join(';'), field.objectTypeId);
                      }
                    });
                  }
                });
              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()).catch(function (err) {
      setError(_('errors.somethingWrong', {
        ns: 'ui'
      }));
      if (props.onError) props.onError(err, 'getting');
    });
  }, [props.id]);
  React$4.useEffect(function () {
    if (props.reCaptchaCredential) {
      loadScriptByURL('recaptcha-key', "https://www.google.com/recaptcha/api.js?render=".concat(props.reCaptchaCredential));
    }
  }, [props.reCaptchaCredential]);
  var submitForm = function submitForm() {
    setNotFilled([]);
    var errors = [];
    setError(false);
    requiredFields.forEach(function (field) {
      var found = response.find(function (i) {
        return i.name === field;
      });
      if (!found) errors.push(field);
    });
    if (errors.length > 0) {
      setNotFilled(errors);
      return;
    }
    setSubmitting(true);
    var hubspotCookie = cookies.get('hubspotutk');
    window.grecaptcha.ready(function () {
      window.grecaptcha.execute(props.reCaptchaCredential, {
        action: 'submit'
      }).then(function (token) {
        fetch("".concat(process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://www.bluecurrent.nl', "/api/submit-form"), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            form: props.id,
            fields: response,
            hutk: hubspotCookie,
            page: {
              uri: window.location.href,
              name: document.title
            },
            reCaptchaToken: token
          })
        }).then(function () {
          var _form$configuration$p;
          if (props.getResponse) props.getResponse(response);
          setResponse([]);
          setSubmitting(false);
          ref.current.dispatchEvent(new Event('submit', {
            cancelable: true,
            bubbles: true
          }));
          if (props.onSubmit) props.onSubmit((_form$configuration$p = form.configuration.postSubmitAction) === null || _form$configuration$p === void 0 ? void 0 : _form$configuration$p.value);
        }).catch(function (err) {
          setError(_('errors.somethingWrong', {
            ns: 'ui'
          }));
          if (props.onError) props.onError(err, 'submit');
          setSubmitting(false);
        });
      });
    });
  };
  var renderInput = function renderInput(input) {
    var _response$find$value, _response$find, _response$find$value2, _response$find2, _response$find$value3, _response$find3, _response$find$value4, _response$find4;
    switch (input.fieldType) {
      case 'single_line_text':
        return React$4.createElement(Inputs, {
          type: "text",
          label: input.label,
          name: input.name,
          required: input.required,
          hint: input.description,
          styling: true,
          error: notFilled.includes(input.name) && _('errors.fieldRequired', {
            ns: 'ui'
          }),
          onChange: function onChange(e) {
            updateInput(input.name, e.target.value, input.objectTypeId);
          },
          value: (_response$find$value = (_response$find = response.find(function (i) {
            return i.name === input.name;
          })) === null || _response$find === void 0 ? void 0 : _response$find.value) !== null && _response$find$value !== void 0 ? _response$find$value : ''
        });
      case 'multi_line_text':
        return React$4.createElement(Inputs, {
          multiline: true,
          rows: 5,
          type: "text",
          label: input.label,
          name: input.name,
          required: input.required,
          placeholder: input.placeholder,
          hint: input.description,
          styling: true,
          error: notFilled.includes(input.name) && _('errors.fieldRequired', {
            ns: 'ui'
          }),
          onChange: function onChange(e) {
            updateInput(input.name, e.target.value, input.objectTypeId);
          },
          value: (_response$find$value2 = (_response$find2 = response.find(function (i) {
            return i.name === input.name;
          })) === null || _response$find2 === void 0 ? void 0 : _response$find2.value) !== null && _response$find$value2 !== void 0 ? _response$find$value2 : ''
        });
      case 'email':
        return React$4.createElement(Inputs, {
          type: "email",
          id: "email",
          label: input.label,
          name: input.name,
          required: input.required,
          placeholder: input.placeholder,
          hint: input.description,
          styling: true,
          error: notFilled.includes(input.name) && _('errors.fieldRequired', {
            ns: 'ui'
          }),
          onChange: function onChange(e) {
            updateInput(input.name, e.target.value, input.objectTypeId);
          },
          value: (_response$find$value3 = (_response$find3 = response.find(function (i) {
            return i.name === input.name;
          })) === null || _response$find3 === void 0 ? void 0 : _response$find3.value) !== null && _response$find$value3 !== void 0 ? _response$find$value3 : ''
        });
      case 'mobile_phone':
      case 'phone':
        return React$4.createElement(Inputs, {
          type: "tel",
          id: "phone",
          label: input.label,
          name: input.name,
          required: input.required,
          placeholder: input.placeholder,
          hint: input.description,
          styling: true,
          error: notFilled.includes(input.name) && _('errors.fieldRequired', {
            ns: 'ui'
          }),
          onChange: function onChange(e) {
            updateInput(input.name, e.target.value, input.objectTypeId);
          },
          value: (_response$find$value4 = (_response$find4 = response.find(function (i) {
            return i.name === input.name;
          })) === null || _response$find4 === void 0 ? void 0 : _response$find4.value) !== null && _response$find$value4 !== void 0 ? _response$find$value4 : ''
        });
      case 'multiple_checkboxes':
        {
          var _response$find5;
          var res = ((_response$find5 = response.find(function (i) {
            return i.name === input.name;
          })) === null || _response$find5 === void 0 ? void 0 : _response$find5.value) || null;
          return React$4.createElement(Inputs, {
            type: "multiple_checkboxes",
            label: input.label,
            required: input.required,
            hint: input.description,
            onClick: function onClick(value, select) {
              if (select) {
                var _res$split;
                updateInput(input.name, [].concat(_toConsumableArray$5((_res$split = res === null || res === void 0 ? void 0 : res.split(';')) !== null && _res$split !== void 0 ? _res$split : []), [value]).join(';'), input.objectTypeId);
              } else {
                updateInput(input.name, res.split(';').filter(function (i) {
                  return i !== value;
                }).join(';'), input.objectTypeId);
              }
            },
            options: input.options.map(function (i) {
              return {
                label: i.label,
                value: i.value,
                selected: res === null || res === void 0 ? void 0 : res.includes(i.value)
              };
            })
          });
        }
      case 'single_checkbox':
        {
          var _response$find6;
          var value = (_response$find6 = response.find(function (i) {
            return i.name === input.name;
          })) === null || _response$find6 === void 0 ? void 0 : _response$find6.value;
          return React$4.createElement(Inputs, {
            type: "checkbox",
            label: input.label,
            disabled: input.disabled,
            hint: input.description,
            onClick: function onClick() {
              return updateInput(input.name, !value, input.objectTypeId);
            },
            selected: value,
            style: {
              justifyContent: 'flex-start',
              marginBottom: 15,
              marginTop: 15
            }
          });
        }
      case 'dropdown':
        {
          var _response$find7, _input$options$find;
          var _value = (_response$find7 = response.find(function (i) {
            return i.name === input.name;
          })) === null || _response$find7 === void 0 ? void 0 : _response$find7.value;
          return React$4.createElement(Inputs, {
            type: "dropdown",
            id: input.label,
            label: input.label,
            text: (_input$options$find = input.options.find(function (i) {
              return i.value === _value;
            })) === null || _input$options$find === void 0 ? void 0 : _input$options$find.label,
            onClickClose: true,
            required: input.required,
            hint: input.description,
            error: notFilled.includes(input.name) && _('errors.fieldRequired', {
              ns: 'ui'
            }),
            items: input.options.map(function (i) {
              return {
                text: i.label,
                id: i.value,
                onClick: function onClick() {
                  return updateInput(input.name, i.value, input.objectTypeId);
                }
              };
            })
          });
        }
      default:
        return React$4.createElement(Text, {
          color: Colors.RED
        }, "Input", ' "', input.fieldType, '" ', "is not yet supported.");
    }
  };
  return React$4.createElement("form", {
    ref: ref,
    id: props.id,
    onSubmit: function onSubmit(e) {
      e.preventDefault();
    }
  }, loading ? React$4.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center'
    }
  }, React$4.createElement("div", {
    style: {
      padding: 25,
      backgroundColor: Colors.LIGHT_GREY,
      borderRadius: 7
    }
  }, React$4.createElement(Loaders, null))) : React$4.createElement(React$4.Fragment, null, form.fieldGroups.map(function (group, groupIndex) {
    return React$4.createElement("div", {
      key: groupIndex,
      style: {
        display: 'flex',
        flexDirection: size.width < Breakpoint.sm ? 'column' : 'row',
        width: '100%'
      }
    }, group.richText && React$4.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: group.richText
      },
      style: {
        marginBottom: 15
      }
    }), group.fields && group.fields.map(function (input, index) {
      if (input.hidden) return null;
      return React$4.createElement("div", {
        key: input.name,
        style: {
          marginRight: index === group.fields.length - 1 ? 0 : 15,
          width: '100%',
          marginBottom: 15
        }
      }, renderInput(input));
    }));
  }), React$4.createElement("div", {
    style: {
      marginTop: 5,
      marginBottom: 15
    }
  }, React$4.createElement(Text, {
    color: Colors.DARK_GREY,
    fontSize: "0.9em"
  }, _('recaptchaPolicy', {
    ns: 'legal'
  }))), React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    }
  }, React$4.createElement("div", {
    style: {
      minWidth: 150,
      width: 'auto'
    }
  }, React$4.createElement(Buttons$1, {
    text: (_ref2 = (_props$submitButton$t = (_props$submitButton = props.submitButton) === null || _props$submitButton === void 0 ? void 0 : _props$submitButton.text) !== null && _props$submitButton$t !== void 0 ? _props$submitButton$t : (_form$displayOptions = form.displayOptions) === null || _form$displayOptions === void 0 ? void 0 : _form$displayOptions.submitButtonText) !== null && _ref2 !== void 0 ? _ref2 : _('send', {
      ns: 'ui'
    }),
    colorScheme: (_props$submitButton$c = (_props$submitButton2 = props.submitButton) === null || _props$submitButton2 === void 0 ? void 0 : _props$submitButton2.colorScheme) !== null && _props$submitButton$c !== void 0 ? _props$submitButton$c : 'green',
    loading: submitting,
    onClick: submitForm
  })), error && React$4.createElement("div", {
    style: {
      marginLeft: 25
    }
  }, React$4.createElement(Text, {
    color: Colors.RED
  }, error)))));
};
var Form$1 = function Form(props) {
  return React$4.createElement(ErrorBoundary, {
    fallback: React$4.createElement(Text, null, "Something went wrong.")
  }, React$4.createElement(HubspotCustom, {
    id: props.id,
    reCaptchaCredential: props.reCaptchaCredential,
    onError: props.onError,
    onSubmit: props.onSubmit,
    getResponse: props.getResponse,
    submitButton: props.submitButton
  }));
};

function Form(props) {
  var render = function render() {
    switch (props.type) {
      case 'Hubspot':
        return React$4.createElement(Hubspot, {
          portalId: props.portalId,
          formId: props.formId,
          onSubmit: props.onSubmit,
          onReady: props.onReady
        });
      case 'HubspotCustom':
        return React$4.createElement(Form$1, {
          id: props.id,
          onSubmit: props.onSubmit,
          reCaptchaCredential: props.reCaptchaCredential,
          submitButton: props.submitButton,
          onError: props.onError,
          getResponse: props.getResponse
        });
      default:
        return React$4.createElement("div", null);
    }
  };
  return render();
}

function Single(props) {
  var _props$accordionColor, _props$titleColor, _props$titleColor2, _props$dropdownColor, _props$textColor;
  var _React$useState = React__default.useState(props.id !== undefined),
      _React$useState2 = _slicedToArray$5(_React$useState, 1),
      isMultiple = _React$useState2[0];
  var _React$useState3 = React__default.useState(false),
      _React$useState4 = _slicedToArray$5(_React$useState3, 2),
      isActive = _React$useState4[0],
      setActive = _React$useState4[1];
  React__default.useEffect(function () {
    if (isMultiple) {
      if (props.selected === props.id) {
        setActive(true);
      } else {
        setActive(false);
      }
    }
  }, [props.selected]);
  return React__default.createElement("div", {
    style: {
      width: '100%',
      height: 'auto',
      borderRadius: 10,
      overflow: 'hidden'
    }
  }, React__default.createElement("button", {
    type: "button",
    onClick: function onClick() {
      if (isMultiple) {
        if (props.selected === props.id) {
          props.setSelected(-1);
        } else {
          props.setSelected(props.id);
        }
      } else {
        setActive(!isActive);
      }
    },
    style: {
      backgroundColor: (_props$accordionColor = props.accordionColor) !== null && _props$accordionColor !== void 0 ? _props$accordionColor : Colors.BLUE,
      paddingLeft: 15,
      paddingRight: 15,
      paddingTop: 5,
      paddingBottom: 5,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      minHeight: 60,
      height: 'auto',
      width: '100%',
      border: 'solid 0.5px transparent',
      borderRadius: isActive ? 0 : 10,
      fontSize: '1em',
      cursor: 'pointer',
      transition: 'border-radius .2s ease-in-out'
    }
  }, React__default.createElement("div", {
    style: {
      width: 'calc(100% - 120px)'
    }
  }, React__default.createElement(Text, {
    fontSize: 18,
    fontWeight: 700,
    portableText: props.items.title.portableText,
    color: (_props$titleColor = props.titleColor) !== null && _props$titleColor !== void 0 ? _props$titleColor : Colors.WHITE
  }, props.items.title.content)), React__default.createElement("div", {
    style: {
      height: 60,
      width: 60,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      transform: 'rotate(90deg)'
    }
  }, React__default.createElement("div", {
    style: {
      height: 30,
      width: 30,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      transform: "rotate(".concat(isActive ? 180 : 0, "deg)")
    }
  }, React__default.createElement(Icon, {
    name: "ChevronRight",
    width: 30,
    height: 30,
    color: (_props$titleColor2 = props.titleColor) !== null && _props$titleColor2 !== void 0 ? _props$titleColor2 : Colors.WHITE,
    iconSet: "Feather"
  })))), React__default.createElement(AnimatePresence, null, isActive && React__default.createElement(motion.div, {
    style: {
      backgroundColor: (_props$dropdownColor = props.dropdownColor) !== null && _props$dropdownColor !== void 0 ? _props$dropdownColor : Colors.LIGHT_BLUE,
      paddingLeft: 15,
      paddingRight: 15
    },
    initial: {
      height: 0
    },
    animate: {
      height: 'auto'
    },
    exit: {
      height: 0
    }
  }, React__default.createElement("div", {
    style: {
      height: '100%',
      paddingTop: 15,
      paddingBottom: 15
    }
  }, React__default.createElement(Text, {
    portableText: props.items.text.portableText,
    color: (_props$textColor = props.textColor) !== null && _props$textColor !== void 0 ? _props$textColor : Colors.GREY,
    fontSize: 14
  }, props.items.text.content)))));
}

function Multiple(props) {
  var _React$useState = React__default.useState(-1),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      selected = _React$useState2[0],
      setSelected = _React$useState2[1];
  return props.items.map(function (e) {
    return React__default.createElement("div", {
      key: e.id,
      style: {
        marginBottom: e.id !== props.items.findLast(function (a) {
          return a;
        }).id ? 10 : 0
      }
    }, React__default.createElement(Single, {
      id: e.id,
      items: e,
      selected: selected,
      setSelected: setSelected,
      titleColor: props.titleColor,
      textColor: props.textColor,
      accordionColor: props.accordionColor,
      dropdownColor: props.dropdownColor
    }));
  });
}

function Accordion(props) {
  if (props.items.length > 1) {
    return React__default.createElement(Multiple, {
      items: props.items,
      titleColor: props.titleColor,
      textColor: props.textColor,
      accordionColor: props.accordionColor,
      dropdownColor: props.dropdownColor
    });
  }
  return React__default.createElement(Single, {
    items: props.items,
    titleColor: props.titleColor,
    textColor: props.textColor,
    accordionColor: props.accordionColor,
    dropdownColor: props.dropdownColor
  });
}

function SearchGroupTitle(props) {
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  return React$4.createElement("div", {
    style: {
      paddingTop: 15,
      paddingBottom: 15,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  }, React$4.createElement(Text, {
    fontSize: "0.9em",
    fontWeight: 500,
    textTransform: "capitalize"
  }, props.title), (props.selectAll || props.deselectAll) && React$4.createElement("button", {
    type: "button",
    style: {
      backgroundColor: 'transparent',
      border: 'solid 0px transparent',
      fontSize: '1em'
    },
    onClick: props.selectAll ? props.selectAll : props.deselectAll,
    className: "Hover"
  }, React$4.createElement(Text, {
    color: Colors.BLUE,
    fontSize: "0.9em",
    fontWeight: 500
  }, props.selectAll ? _('selectAll', {
    ns: 'ui'
  }) : _('deselectAll', {
    ns: 'ui'
  }))));
}

function SearchChargePointItem(props) {
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var size = useDimensions();
  var deleteRef = React$4.useRef();
  var unlinkRef = React$4.useRef();
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  var _React$useState3 = React$4.useState(false),
      _React$useState4 = _slicedToArray$5(_React$useState3, 2),
      iconHover = _React$useState4[0],
      setIconHover = _React$useState4[1];
  var onClick = function onClick(event) {
    if (deleteRef.current && (event.target === deleteRef.current || _toConsumableArray$5(deleteRef.current.children).includes(event.target))) return;
    if (unlinkRef.current && (event.target === unlinkRef.current || _toConsumableArray$5(unlinkRef.current.children).includes(event.target))) return;
    if (props.onClick) props.onClick(event);
  };
  return React$4.createElement("button", {
    type: "button",
    className: props.onClick !== undefined ? 'Hover' : 'DisableSelection',
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    onClick: onClick,
    style: {
      width: '100%',
      height: 70,
      border: props.disabled ? "solid 2px ".concat(Colors.LIGHT_WHITE) : props.selected ? "solid 2px ".concat(Colors.BLUE) : "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderRadius: 10,
      marginBottom: 15,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      overflow: 'hidden',
      fontSize: size.width < Breakpoint.fd ? '0.8em' : '1em',
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 15,
      paddingRight: 15,
      backgroundColor: hover && !props.selected && props.onClick !== undefined ? Colors.LIGHT_WHITE : props.selected ? Colors.LIGHT_BLUE : Colors.WHITE,
      transition: 'all .2s linear'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: 70,
      width: '100%'
    }
  }, React$4.createElement("div", {
    style: {
      height: 60,
      width: 'auto',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      marginRight: 15
    }
  }, props.icon && React$4.createElement("div", {
    style: {
      width: 45,
      height: 45,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: 15
    }
  }, React$4.createElement(Icon, {
    name: props.icon.name,
    color: props.icon.color,
    height: props.icon.height,
    width: props.icon.width,
    iconSet: props.icon.iconSet
  })), React$4.createElement("div", {
    style: {
      marginTop: -7
    }
  }, React$4.createElement(ModuleHeader, {
    title: props.title,
    subTitle: props.subTitle
  }))),
  props.onDelete && React$4.createElement("div", {
    ref: deleteRef,
    onClick: props.onDelete,
    className: "Hover",
    role: "button",
    tabIndex: 0,
    onMouseEnter: function onMouseEnter() {
      setIconHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setIconHover(false);
    },
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: 50,
      width: 50,
      backgroundColor: iconHover ? Colors.LIGHT_GREY : Colors.WHITE,
      border: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderRadius: 10
    }
  }, props.deleteLoading ? React$4.createElement(Loaders, {
    size: 25
  }) : React$4.createElement(Icon, {
    name: "Bin",
    height: 23,
    width: 23,
    color: iconHover ? Colors.RED : Colors.GREY,
    iconSet: "FA"
  })),
  props.onUnlink && React$4.createElement("div", {
    ref: unlinkRef,
    onClick: props.onUnlink,
    className: "Hover",
    role: "button",
    tabIndex: 0,
    onMouseEnter: function onMouseEnter() {
      setIconHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setIconHover(false);
    },
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: 50,
      width: 50,
      backgroundColor: iconHover ? Colors.LIGHT_GREY : Colors.WHITE,
      border: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderRadius: 10
    }
  }, props.unlinkLoading ? React$4.createElement(Loaders, {
    size: 25
  }) : React$4.createElement(Icon, {
    name: "Unlink",
    height: 23,
    width: 23,
    color: Colors.GREY,
    iconSet: "FA"
  })),
  props.onLink && React$4.createElement("div", {
    ref: unlinkRef,
    onClick: props.onLink,
    className: "Hover",
    role: "button",
    tabIndex: 0,
    onMouseEnter: function onMouseEnter() {
      setIconHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setIconHover(false);
    },
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: 50,
      width: 50,
      backgroundColor: iconHover ? Colors.LIGHT_GREY : Colors.WHITE,
      border: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderRadius: 10
    }
  }, props.linkLoading ? React$4.createElement(Loaders, {
    size: 25
  }) : React$4.createElement(Icon, {
    name: "Link",
    height: 23,
    width: 23,
    color: Colors.GREY,
    iconSet: "FA"
  }))), props.selected && React$4.createElement("div", {
    style: {
      width: 'auto',
      paddingRight: 15,
      paddingTop: 20
    }
  }, React$4.createElement(Icon, {
    name: "CheckCircle",
    height: 23,
    width: 23,
    color: Colors.BLUE,
    iconSet: "FA"
  })), props.disabled && React$4.createElement("div", {
    style: {
      width: 'auto',
      paddingRight: 15,
      paddingTop: 10
    }
  }, React$4.createElement(Text, {
    fontSize: "1em",
    color: Colors.DARK_WHITE,
    fontWeight: 500
  }, _('disabled', {
    ns: 'ui'
  }))));
}

function SearchPageItem$1(props) {
  var _props$onClick;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("button", {
    type: "button",
    className: props.onClick !== undefined ? 'Hover' : 'DisableSelection',
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    onClick: (_props$onClick = props.onClick) !== null && _props$onClick !== void 0 ? _props$onClick : props.onClick,
    style: {
      width: '100%',
      height: 50,
      border: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderRadius: 10,
      paddingLeft: 3,
      paddingRight: 15,
      marginBottom: 15,
      backgroundColor: hover && props.onClick !== undefined ? Colors.LIGHT_WHITE : Colors.WHITE,
      transition: 'all .2s linear',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      fontSize: '0.9em'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: 45,
      width: 45
    }
  }, React$4.createElement(Icon, {
    name: props.icon.name,
    color: props.icon.color,
    height: props.icon.height,
    width: props.icon.width,
    iconSet: props.icon.iconSet
  })), React$4.createElement("div", {
    style: {
      paddingTop: 2
    }
  }, React$4.createElement(Text, {
    fontWeight: 300
  }, props.title))), React$4.createElement(AnimatePresence, null, hover && props.onClick !== undefined && React$4.createElement(motion.div, {
    style: {
      height: 45,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    },
    initial: {
      paddingRight: 15,
      opacity: 0
    },
    animate: {
      paddingRight: 0,
      opacity: 1
    },
    exit: {
      paddingRight: 15,
      opacity: 0
    }
  }, React$4.createElement(Icon, {
    name: "ArrowRight",
    color: Colors.GREY,
    height: 13,
    width: 13
  }))));
}

function SearchChargeCardItem(props) {
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var deleteRef = React$4.useRef();
  var unlinkRef = React$4.useRef();
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  var _React$useState3 = React$4.useState(false),
      _React$useState4 = _slicedToArray$5(_React$useState3, 2),
      binHover = _React$useState4[0],
      setBinHover = _React$useState4[1];
  var onClick = function onClick(event) {
    if (deleteRef.current && (event.target === deleteRef.current || _toConsumableArray$5(deleteRef.current.children).includes(event.target))) return;
    if (unlinkRef.current && (event.target === unlinkRef.current || _toConsumableArray$5(unlinkRef.current.children).includes(event.target))) return;
    if (props.onClick) props.onClick(event);
  };
  return React$4.createElement("button", {
    type: "button",
    className: props.onClick !== undefined ? 'Hover' : 'DisableSelection',
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    onClick: onClick,
    style: {
      width: '100%',
      height: 70,
      border: props.selected ? "solid 2px ".concat(Colors.BLUE) : "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderRadius: 10,
      marginBottom: 15,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      overflow: 'hidden',
      fontSize: '1em',
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 10,
      paddingRight: 10,
      backgroundColor: hover && !binHover && !props.selected && props.onClick !== undefined ? Colors.LIGHT_GREY : props.selected ? Colors.LIGHT_BLUE : Colors.WHITE,
      transition: 'all .2s linear'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: 70,
      width: '100%'
    }
  }, React$4.createElement("div", {
    style: {
      height: 60,
      width: 'auto',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      marginRight: 15
    }
  }, React$4.createElement("div", {
    style: {
      width: 45,
      height: 45,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: 15
    }
  }, React$4.createElement(Icon, {
    name: "Card",
    height: 40,
    width: 40,
    color: Colors.GREY,
    iconSet: "FA"
  })), React$4.createElement("div", {
    style: {
      marginTop: -7
    }
  }, React$4.createElement(ModuleHeader, {
    title: props.title === '' ? props.subTitle : props.title,
    subTitle: props.title === '' ? '' : props.subTitle
  }))),
  props.onDelete && React$4.createElement("div", {
    ref: deleteRef,
    onClick: props.deleteLoading ? null : props.onDelete,
    className: "Hover",
    role: "button",
    tabIndex: 0,
    onMouseEnter: function onMouseEnter() {
      setBinHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setBinHover(false);
    },
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: 50,
      width: 50,
      backgroundColor: binHover ? Colors.LIGHT_GREY : Colors.WHITE,
      border: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderRadius: 10
    }
  }, props.deleteLoading ? React$4.createElement(Loaders, {
    size: 25
  }) : React$4.createElement(Icon, {
    name: "Bin",
    height: 23,
    width: 23,
    color: binHover ? Colors.RED : Colors.GREY,
    iconSet: "FA"
  })),
  props.onUnlink && React$4.createElement("div", {
    ref: unlinkRef,
    onClick: props.unlinkLoading ? null : props.onUnlink,
    className: "Hover",
    role: "button",
    tabIndex: 0,
    onMouseEnter: function onMouseEnter() {
      setBinHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setBinHover(false);
    },
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: 50,
      width: 50,
      backgroundColor: binHover ? Colors.LIGHT_GREY : Colors.WHITE,
      border: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderRadius: 10
    }
  }, props.unlinkLoading ? React$4.createElement(Loaders, {
    size: 25
  }) : React$4.createElement(Icon, {
    name: "Unlink",
    height: 23,
    width: 23,
    color: Colors.GREY,
    iconSet: "FA"
  }))), props.selected && React$4.createElement("div", {
    style: {
      width: 'auto',
      paddingRight: 15,
      paddingTop: 10
    }
  }, React$4.createElement(Text, {
    fontSize: "1em",
    color: Colors.BLUE,
    fontWeight: 500
  }, typeof props.selected === 'boolean' ? _('selected', {
    ns: 'ui'
  }) : props.selected)));
}

function SearchGridItem(props) {
  var size = useDimensions();
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("button", {
    type: "button",
    className: props.disabled ? 'Disabled' : props.onClick !== undefined ? 'Hover' : 'DisableSelection',
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    onClick: props.onClick !== undefined ? props.onClick : null,
    style: {
      width: '100%',
      height: size.width < Breakpoint.fd && props.selected ? 110 : 85,
      border: props.selected ? "solid 2px ".concat(Colors.BLUE) : "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderRadius: 10,
      marginBottom: 15,
      display: 'flex',
      flexDirection: 'row',
      overflow: 'hidden',
      fontSize: '1em',
      padding: 0,
      backgroundColor: hover && !props.selected && props.onClick !== undefined ? Colors.LIGHT_WHITE : props.selected ? Colors.LIGHT_BLUE : Colors.WHITE,
      transition: 'all .2s linear'
    }
  }, React$4.createElement("div", {
    style: {
      width: '100%',
      paddingLeft: 10,
      display: 'flex',
      flexDirection: size.width < Breakpoint.fd ? props.selected ? 'column-reverse' : 'column' : 'row',
      justifyContent: 'space-between'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: size.width < Breakpoint.fd && props.selected ? 'row-reverse' : 'row',
      justifyContent: size.width < Breakpoint.fd && props.selected ? 'space-between' : 'flex-start',
      minWidth: 200,
      width: '100%'
    }
  }, React$4.createElement("div", {
    style: {
      height: size.width < Breakpoint.fd && props.selected ? 75 : 80,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: size.width < Breakpoint.fd && props.selected ? 'flex-start' : 'center',
      alignItems: 'center'
    }
  }, React$4.createElement(ModuleHeader, {
    title: props.title,
    subTitle: props.subTitle
  }))), props.selected && React$4.createElement("div", {
    style: {
      width: '50%',
      paddingRight: 15,
      height: 80,
      paddingTop: 10
    }
  }, React$4.createElement(Text, {
    textAlign: size.width < Breakpoint.fd ? 'left' : 'right',
    fontSize: "1em",
    color: Colors.BLUE,
    fontWeight: 500
  }, typeof props.selected === 'boolean' ? _('selected', {
    ns: 'ui'
  }) : props.selected))));
}

function SearchPageItem(props) {
  var _props$onClick;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("button", {
    type: "button",
    className: props.onClick !== undefined ? 'Hover' : 'DisableSelection',
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    onClick: (_props$onClick = props.onClick) !== null && _props$onClick !== void 0 ? _props$onClick : props.onClick,
    style: {
      width: '100%',
      height: 50,
      border: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderRadius: 10,
      padding: 15,
      marginBottom: 15,
      backgroundColor: hover && props.onClick !== undefined ? Colors.LIGHT_WHITE : Colors.WHITE,
      transition: 'all .2s linear',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      fontSize: '0.9em'
    }
  }, React$4.createElement(Text, {
    fontWeight: 300
  }, props.title), React$4.createElement(AnimatePresence, null, hover && props.onClick !== undefined && React$4.createElement(motion.div, {
    style: {
      paddingTop: 2
    },
    initial: {
      paddingRight: 15,
      opacity: 0
    },
    animate: {
      paddingRight: 0,
      opacity: 1
    },
    exit: {
      paddingRight: 15,
      opacity: 0
    }
  }, React$4.createElement(Icon, {
    name: "ArrowRight",
    color: Colors.GREY,
    height: 13,
    width: 13
  }))));
}

function SearchTariffItem(props) {
  var _props$text;
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._,
      i18n = _Lang$useTranslation.i18n;
  var currencyFormat = useCurrencyFormat(i18n.language);
  var tipRef = React$4.useRef();
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("button", {
    type: "button",
    className: props.onClick !== undefined ? 'Hover' : 'DisableSelection',
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    onClick: function onClick(event) {
      if (!props.hint) {
        if (props.onClick) props.onClick(event);
        return;
      }
      if (!tipRef.current.contains(event.target)) {
        if (props.onClick) props.onClick(event);
      }
    },
    style: {
      width: '100%',
      height: 70,
      border: props.selected ? "solid 2px ".concat(Colors.BLUE) : "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderRadius: 10,
      marginBottom: 15,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      fontSize: '1em',
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 15,
      paddingRight: 15,
      backgroundColor: hover && !props.selected && props.onClick !== undefined ? Colors.LIGHT_WHITE : props.selected ? Colors.LIGHT_BLUE : Colors.WHITE,
      transition: 'all .2s linear',
      position: 'relative'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: 70,
      width: '100%'
    }
  }, React$4.createElement("div", {
    style: {
      height: 60,
      width: 'auto',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      marginRight: 15
    }
  }, React$4.createElement("div", {
    style: {
      marginTop: -7
    }
  }, React$4.createElement(ModuleHeader, {
    title: (_props$text = props.text) !== null && _props$text !== void 0 ? _props$text : currencyFormat(props.amount, props.currency),
    subTitle: React$4.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row'
      }
    }, !props.hideVat && React$4.createElement("span", {
      style: {
        width: 'auto'
      }
    }, "".concat(props.exclusive ? _('excl', {
      ns: 'ui'
    }) : _('incl', {
      ns: 'ui'
    }), " "), props.vat, "%", " ".concat(_('vat', {
      ns: 'finance'
    }))), props.hint && React$4.createElement("div", {
      style: {
        marginLeft: 10,
        width: 'auto',
        position: 'relative',
        marginTop: -1.5
      }
    }, React$4.createElement(Tooltip, {
      tipRef: tipRef,
      text: props.hint,
      right: true,
      keepOpen: true
    })))
  })))), props.selected && React$4.createElement("div", {
    style: {
      width: 'auto',
      paddingRight: 15,
      paddingTop: 10
    }
  }, React$4.createElement(Text, {
    fontSize: "1em",
    color: Colors.BLUE,
    fontWeight: 500
  }, typeof props.selected === 'boolean' ? _('selected', {
    ns: 'ui'
  }) : props.selected)));
}

function OverlaySearch(props) {
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var dynamicSort = function dynamicSort(input) {
    return input.reduce(function (r, a) {
      r[a.type] = r[a.type] || [];
      if (
      a.type === 'chargepoint' || a.type === 'page' || a.type === 'chargecard' || a.type === 'grid' || a.type === 'tariff') {
        r[a.type].push(a);
      } else {
        r.default = [];
        r.default.push(a);
      }
      return r;
    }, Object.create(null));
  };
  var sortedData = dynamicSort(props.data);
  return React$4.createElement(React$4.Fragment, null, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      height: 48,
      borderBottom: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      paddingLeft: 15,
      paddingRight: 15,
      backgroundColor: Colors.WHITE
    }
  }, React$4.createElement("div", {
    style: {
      height: 45,
      width: 30,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start'
    }
  }, React$4.createElement(Icon, {
    name: "Search",
    color: Colors.GREY,
    height: 20,
    width: 20,
    iconSet: "Feather"
  })), React$4.createElement("div", {
    style: {
      marginTop: -5,
      width: '100%'
    }
  }, React$4.createElement(Inputs, {
    type: "text",
    styling: false,
    required: true,
    placeholder: "".concat(_('search', {
      ns: 'ui'
    }), "..."),
    backgroundColor: "transparent",
    onChange: props.onSearch
  }))), props.empty && props.empty.condition ? React$4.createElement("div", {
    style: {
      overflowY: 'scroll',
      height: '100%',
      width: '100%'
    }
  }, props.empty.component) : React$4.createElement("div", {
    style: {
      overflowY: 'scroll',
      height: '100%',
      width: '100%'
    }
  }, props.loading && React$4.createElement("div", {
    style: {
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, React$4.createElement(Loaders, {
    type: "spinner"
  })), sortedData.chargepoint && React$4.createElement("div", {
    style: {
      paddingLeft: 15,
      paddingRight: 15
    }
  }, React$4.createElement(SearchGroupTitle, {
    title: _('chargePoints', {
      ns: 'ui'
    }),
    selectAll: props.selectAll,
    deselectAll: props.deselectAll
  }), sortedData.chargepoint.map(function (e) {
    return React$4.createElement(React$4.Fragment, {
      key: e.id
    }, React$4.createElement(SearchChargePointItem, {
      title: e.name,
      subTitle: e.serial,
      selected: e.selected,
      onClick: e.onClick,
      onDelete: e.onDelete,
      deleteLoading: e.deleteLoading,
      onUnlink: e.onUnlink,
      unlinkLoading: e.unlinkLoading,
      icon: e.icon,
      disabled: e.disabled
    }));
  })), sortedData.page && React$4.createElement("div", {
    style: {
      paddingLeft: 15,
      paddingRight: 15
    }
  }, React$4.createElement(SearchGroupTitle, {
    title: _('pages', {
      ns: 'ui'
    }),
    selectAll: props.selectAll,
    deselectAll: props.deselectAll
  }), sortedData.page.map(function (e) {
    return React$4.createElement(React$4.Fragment, {
      key: e.id
    }, React$4.createElement(SearchPageItem$1, {
      title: e.title,
      onClick: e.onClick,
      icon: e.icon
    }));
  })), sortedData.grid && React$4.createElement("div", {
    style: {
      paddingLeft: 15,
      paddingRight: 15
    }
  }, React$4.createElement(SearchGroupTitle, {
    title: _('grids', {
      ns: 'ui'
    }),
    selectAll: props.selectAll,
    deselectAll: props.deselectAll
  }), sortedData.grid.map(function (e) {
    return React$4.createElement(React$4.Fragment, {
      key: e.id
    }, React$4.createElement(SearchGridItem, {
      title: e.name,
      subTitle: e.serial,
      selected: e.selected,
      onClick: e.onClick
    }));
  })), sortedData.chargecard && React$4.createElement("div", {
    style: {
      paddingLeft: 15,
      paddingRight: 15
    }
  }, React$4.createElement(SearchGroupTitle, {
    title: _('chargeCards', {
      ns: 'ui'
    }),
    selectAll: props.selectAll,
    deselectAll: props.deselectAll
  }), sortedData.chargecard.map(function (e) {
    return React$4.createElement(React$4.Fragment, {
      key: e.id
    }, React$4.createElement(SearchChargeCardItem, {
      title: e.name,
      subTitle: e.serial,
      uid: e.uid,
      selected: e.selected,
      onClick: e.onClick,
      onDelete: e.onDelete,
      deleteLoading: e.deleteLoading,
      onUnlink: e.onUnlink,
      unlinkLoading: e.unlinkLoading
    }));
  })), sortedData.tariff && React$4.createElement("div", {
    style: {
      paddingLeft: 15,
      paddingRight: 15
    }
  }, React$4.createElement(SearchGroupTitle, {
    title: _('tariffs', {
      ns: 'finance'
    }),
    selectAll: props.selectAll,
    deselectAll: props.deselectAll
  }), sortedData.tariff.map(function (e) {
    return React$4.createElement(React$4.Fragment, {
      key: e.id
    }, React$4.createElement(SearchTariffItem, {
      selected: e.selected,
      onClick: e.onClick,
      amount: e.amount,
      currency: e.currency,
      exclusive: e.exclusive,
      vat: e.vat,
      hint: e.hint,
      text: e.text,
      hideVat: e.hideVat
    }));
  })), sortedData.default && React$4.createElement("div", {
    style: {
      paddingLeft: 15,
      paddingRight: 15
    }
  }, React$4.createElement(SearchGroupTitle, {
    title: _('other', {
      ns: 'ui'
    }),
    selectAll: props.selectAll,
    deselectAll: props.deselectAll
  }), sortedData.default.map(function (e) {
    return React$4.createElement(React$4.Fragment, {
      key: e.id
    }, React$4.createElement(SearchPageItem, {
      title: e.title,
      onClick: e.onClick,
      icon: e.icon
    }));
  }))));
}

function Overlay(props) {
  var renderContent = function renderContent() {
    switch (props.type) {
      case 'Search':
        return React$4.createElement(OverlaySearch, {
          data: props.data,
          empty: props.empty,
          onSearch: props.onSearch,
          selectAll: props.selectAll
        });
      default:
        return React$4.createElement(OverlaySearch, {
          empty: props.empty,
          data: props.data,
          onSearch: props.onSearch,
          selectAll: props.selectAll
        });
    }
  };
  return React$4.createElement(Modal, {
    title: props.title,
    subTitle: props.subTitle,
    onClose: props.onClose,
    visible: props.visible
  }, renderContent());
}

function CookiePopup(props) {
  var size = useDimensions();
  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      visible = _React$useState2[0],
      setVisible = _React$useState2[1];
  var _Lang$useTranslation = Lang.useTranslation('ui'),
      _ = _Lang$useTranslation._;
  React__default.useEffect(function () {
    if (props.showDefault === undefined || props.showDefault) {
      setVisible(true);
    }
  }, []);
  if (!visible) return null;
  return React__default.createElement("div", {
    style: {
      position: 'fixed',
      zIndex: 2147483004,
      bottom: size.width < Breakpoint.sm ? 0 : 10,
      left: size.width < Breakpoint.sm ? 0 : 10,
      backgroundColor: Colors.WHITE,
      width: size.width < Breakpoint.sm ? '100%' : 350,
      minHeight: 200,
      height: 'auto',
      borderRadius: size.width < Breakpoint.sm ? 0 : 10,
      WebkitBoxShadow: "0px 3px 15px 2px ".concat(Colors.BLACK, "40"),
      boxShadow: "0px 3px 15px 2px ".concat(Colors.BLACK, "40"),
      overflow: 'hidden',
      padding: 15
    }
  }, React__default.createElement("button", {
    className: "Hover",
    type: "button",
    "aria-label": "".concat(_('cookie.closeCookiePopup'), " ").concat(_('accessibility.button').toLowerCase()),
    style: {
      position: 'absolute',
      right: 10,
      top: 15,
      backgroundColor: 'transparent',
      padding: 0,
      border: 0
    },
    onClick: function onClick() {
      if (props.callback) props.callback(false);
      setVisible(false);
    }
  }, React__default.createElement(Icon, {
    name: "Times",
    width: "20px",
    height: "20px",
    color: Colors.MEDIUM_GREY,
    iconSet: "Feather"
  })), React__default.createElement("p", {
    style: {
      color: Colors.GREY,
      fontSize: '1em',
      fontWeight: 500
    }
  }, _('cookie.title')), React__default.createElement("p", {
    style: {
      color: Colors.GREY,
      fontSize: '1em',
      fontWeight: 300,
      marginTop: 10
    }
  }, _('cookie.text', {
    cookie_link: 'https://www.bluecurrent.nl/legal/cookies'
  })), React__default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, React__default.createElement("div", {
    style: {
      marginTop: 20
    }
  }, React__default.createElement(Buttons$1, {
    id: "cookies-accept-button",
    text: _('cookie.button'),
    borderColor: Colors.BLUE,
    textColor: Colors.WHITE,
    backgroundColor: Colors.BLUE,
    hoverBackgroundColor: Colors.WHITE,
    hoverTextColor: Colors.BLUE,
    ariaLabel: "".concat(_('cookie.button'), " ").concat(_('accessibility.button')),
    onClick: function onClick() {
      if (props.callback) props.callback(true);
      setVisible(false);
    }
  }))));
}

function SideNavigationItem(props) {
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("button", {
    key: props.path + props.title,
    type: "button",
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    onClick: props.onClick,
    className: "Hover",
    "aria-label": props.title,
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      padding: 0,
      margin: 0,
      backgroundColor: 'transparent',
      border: 'none',
      position: 'relative'
    }
  }, props.active && React$4.createElement("div", {
    style: {
      height: 50,
      width: 5,
      marginRight: 5,
      backgroundColor: props.colorScheme.vibrant,
      borderTopRightRadius: 5,
      borderBottomRightRadius: 5
    }
  }), React$4.createElement("div", {
    style: {
      height: 50,
      width: 'auto',
      marginBottom: 10,
      marginLeft: props.active ? 0 : 10,
      backgroundColor: props.active ? Colors.LIGHT_WHITE : 'transparent',
      borderTopLeftRadius: 5,
      borderBottomLeftRadius: 5,
      borderTopRightRadius: props.extended ? 0 : 5,
      borderBottomRightRadius: props.extended ? 0 : 5
    }
  }, React$4.createElement("div", {
    style: {
      height: 50,
      width: 50,
      maxWidth: 50,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, React$4.createElement(Icon, {
    name: props.icon.name,
    height: props.icon.height,
    width: props.icon.width,
    color: props.active || hover ? Colors.GREY : Colors.DARK_GREY,
    iconSet: props.icon.iconSet
  }))), React$4.createElement(AnimatePresence, null, props.extended && React$4.createElement(motion.div, {
    style: {
      width: 50,
      height: 50,
      backgroundColor: props.active ? Colors.LIGHT_WHITE : 'transparent',
      position: 'absolute',
      left: 60,
      borderTopRightRadius: 5,
      borderBottomRightRadius: 5
    },
    initial: {
      width: 0
    },
    animate: {
      width: 170
    },
    exit: {
      width: 0
    },
    transition: {
      duration: 0.2,
      type: 'linear'
    }
  }, React$4.createElement(motion.div, {
    style: {
      width: 170,
      position: 'absolute',
      height: 50,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      paddingLeft: 5
    },
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: 0.1
    }
  }, React$4.createElement(Text, {
    color: props.active || hover ? Colors.GREY : Colors.DARK_GREY,
    fontWeight: props.active ? 500 : 300,
    fontSize: "1.5em"
  }, props.title)))));
}

var LogoNormal = function (_React$PureComponent) {
  _inherits$4(LogoNormal, _React$PureComponent);
  var _super = _createSuper$5(LogoNormal);
  function LogoNormal() {
    _classCallCheck$6(this, LogoNormal);
    return _super.apply(this, arguments);
  }
  _createClass$6(LogoNormal, [{
    key: "render",
    value: function render() {
      return React$4.createElement("svg", {
        height: this.props.height || '10px',
        width: this.props.width || '10px',
        fill: this.props.color || Colors.BLUE,
        viewBox: "0 0 200 50",
        xmlns: "http://www.w3.org/2000/svg"
      }, React$4.createElement("g", {
        id: "Brandbook",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, React$4.createElement("g", {
        id: "Brandbook/Logo",
        transform: "translate(-40.000000, -159.000000)",
        fillRule: "nonzero"
      }, React$4.createElement("g", {
        id: "Group",
        transform: "translate(40.333333, 159.000000)"
      }, React$4.createElement("g", {
        fill: "#0098DB",
        id: "Combined-Shape"
      }, React$4.createElement("path", {
        d: "M41.5127497,5.68434189e-14 C48.9669586,5.68434189e-14 52.8640158,3.81010461 54.6536583,7.15856999 C56.8464446,11.2643134 58.1127906,15.9455249 58.1127906,20.9286991 C58.1127906,36.9738243 45.1062633,49.9850944 29.0563953,49.9850944 C13.0065272,49.9850944 1.20792265e-13,36.9738243 1.20792265e-13,20.9286991 C1.20792265e-13,15.9455249 1.26634597,11.2643134 3.46545614,7.15856999 C5.24877482,3.81010461 9.14583202,5.68434189e-14 16.6000408,5.68434189e-14 L16.6000408,5.68434189e-14 Z M39.8889496,7.73071807 L18.2235248,7.73071807 C14.419744,7.73071807 11.3194888,10.8325543 11.3194888,14.6363351 L11.3194888,30.7731557 C11.3194888,34.5832603 14.419744,37.6771917 18.2235248,37.6771917 L39.8889496,37.6771917 C43.6990542,37.6771917 46.7929856,34.5832603 46.7929856,30.7731557 L46.7929856,26.604174 L43.0255668,26.604174 L43.0255668,30.7731557 C43.0255668,32.5027219 41.6169348,33.9097729 39.8889496,33.9097729 L18.2235248,33.9097729 C16.4955396,33.9097729 15.0869076,32.5027219 15.0869076,30.7731557 L15.0869076,14.6363351 C15.0869076,12.9067689 16.4955396,11.4997178 18.2235248,11.4997178 L39.8889496,11.4997178 C41.6169348,11.4997178 43.0255668,12.9067689 43.0255668,14.6363351 L43.0255668,18.1128579 L46.7929856,18.1128579 L46.7929856,14.6363351 C46.7929856,10.8325543 43.6990542,7.73071807 39.8889496,7.73071807 Z M36.0219305,25.1417895 L20.675588,25.1417895 L20.675588,28.9076273 L36.0219305,28.9076273 C37.0606188,28.9076273 37.9064304,28.0681395 37.9064304,27.0310322 C37.9064304,25.9876011 37.0606188,25.1417895 36.0219305,25.1417895 L36.0219305,25.1417895 Z M36.0219305,16.5018635 L20.675588,16.5018635 L20.675588,20.2692822 L36.0219305,20.2692822 C37.0606188,20.2692822 37.9064304,19.4218897 37.9064304,18.3847824 C37.9064304,17.3476751 37.0606188,16.5018635 36.0219305,16.5018635 Z"
      })), React$4.createElement("g", {
        transform: "translate(69.312697, 16.500000)",
        fill: "#37424A",
        id: "Blue-Current"
      }, React$4.createElement("path", {
        d: "M2.16755566,7.04903312 L9.7015596,7.04903312 C11.2485651,7.04903312 11.6753754,7.35541181 11.6753754,8.45605184 L11.6753754,9.30113429 C11.6753754,10.0779713 11.3796672,10.5948945 9.94045686,10.5948945 L2.16755566,10.5948945 L2.16755566,7.04903312 Z M11.6025409,4.02009498 C11.6025409,4.51959389 11.4481317,5.18317238 10.12837,5.18317238 L2.16755566,5.18317238 L2.16755566,2.00177091 L10.2084879,2.00177091 C10.4415584,2.00177091 11.6025409,2.04678389 11.6025409,2.94849558 L11.6025409,4.02009498 Z M12.6950588,5.86998337 C13.3826168,5.50697545 13.7700965,4.86517743 13.7700965,4.03751936 L13.7700965,3.02835733 C13.7700965,1.94514167 13.3258059,0.130102041 10.3556137,0.130102041 L2.79776202e-14,0.130102041 L2.79776202e-14,12.4622073 L10.5202197,12.4622073 C12.7737201,12.4622073 13.8502145,11.3659234 13.8502145,9.6772105 L13.8502145,8.280356 C13.8502145,7.02725264 13.7132856,6.22137505 12.6950588,5.86998337 L12.6950588,5.86998337 Z",
        id: "Fill-1"
      }), React$4.createElement("polygon", {
        id: "Fill-4",
        points: "16.2103447 12.4609005 18.1797904 12.4609005 18.1797904 0.130247244 16.2103447 0.130247244"
      }), React$4.createElement("path", {
        d: "M29.5374616,8.60459468 C29.5374616,10.1916653 29.1849425,10.8842845 25.7995934,10.8842845 L25.4397908,10.8842845 C22.8570784,10.8842845 22.6633385,10.2032816 22.6633385,9.15346267 L22.6633385,3.60670155 L20.6895227,3.60670155 L20.6895227,9.49469012 C20.6895227,10.6519594 21.1789708,12.5918737 24.4273909,12.5918737 L26.5323088,12.5918737 C27.9103382,12.5918737 28.9576987,12.420534 29.6336032,11.68871 L29.6336032,12.4611909 L31.5112774,12.4611909 L31.5112774,3.60670155 L29.5374616,3.60670155 L29.5374616,8.60459468 Z",
        id: "Fill-6"
      }), React$4.createElement("path", {
        d: "M42.6874449,6.59091711 L42.6874449,6.85663892 L35.4491492,6.85663892 C35.5919049,5.42638769 36.0361955,5.18244636 38.0041845,5.18244636 L40.0581183,5.18244636 C41.2598881,5.18244636 42.6874449,5.42638769 42.6874449,6.59091711 M40.0581183,3.47485707 L37.8104447,3.47485707 C35.6545426,3.47485707 33.4461996,3.90611049 33.4461996,7.10493634 L33.4461996,8.90981175 C33.4461996,12.172527 35.6938732,12.5921642 37.6458386,12.5921642 L40.1892205,12.5921642 C42.2722881,12.5921642 44.6612607,12.2799773 44.6612607,9.83330391 L44.6612607,9.39188627 L42.710752,9.39188627 L42.6932717,9.65760808 C42.6248072,10.6522498 42.1979969,10.8845749 40.4164642,10.8845749 L38.4936326,10.8845749 C36.0813529,10.8845749 35.4214721,10.434445 35.4214721,8.79655328 L35.4214721,8.56277617 L44.6612607,8.56277617 L44.6612607,7.34887766 C44.6612607,3.93660316 42.3349258,3.47485707 40.0581183,3.47485707",
        id: "Fill-7"
      }), React$4.createElement("path", {
        d: "M68.6140792,8.96193969 C68.6140792,10.2832885 68.2557333,10.7203501 66.133335,10.7203501 L60.539643,10.7203501 C58.7755906,10.7203501 58.0530721,10.0785521 58.0530721,8.50745376 L58.0530721,4.08892128 C58.0530721,2.51201485 58.7755906,1.87166887 60.539643,1.87166887 L66.0823509,1.87166887 C67.5900257,1.87166887 68.5004573,1.99073547 68.5004573,3.67944834 L68.5004573,4.50275032 L70.4742731,4.50275032 L70.4742731,3.2104421 C70.4742731,0.556128143 68.3067174,-3.19744231e-14 66.4916809,-3.19744231e-14 L60.3808637,-3.19744231e-14 C57.1877979,-3.19744231e-14 55.8913432,1.36055371 55.8913432,4.69006241 L55.8913432,7.9048606 C55.8913432,11.2343693 57.1877979,12.592019 60.3808637,12.592019 L66.4057362,12.592019 C69.9746282,12.592019 70.6854932,11.2300132 70.6854932,9.02437705 L70.6854932,7.94551749 L68.6140792,7.94551749 L68.6140792,8.96193969 Z",
        id: "Fill-8"
      }), React$4.createElement("path", {
        d: "M81.5365274,8.60459468 C81.5365274,10.1916653 81.1840083,10.8842845 77.7986593,10.8842845 L77.4388567,10.8842845 C74.8561442,10.8842845 74.6624043,10.2032816 74.6624043,9.15346267 L74.6624043,3.60670155 L72.6885885,3.60670155 L72.6885885,9.49469012 C72.6885885,10.6519594 73.1722098,12.5918737 76.4264567,12.5918737 L78.5313747,12.5918737 C79.909404,12.5918737 80.9567646,12.420534 81.632669,11.68871 L81.632669,12.4611909 L83.5103432,12.4611909 L83.5103432,3.60670155 L81.5365274,3.60670155 L81.5365274,8.60459468 Z",
        id: "Fill-9"
      }), React$4.createElement("path", {
        d: "M109.111244,6.59091711 L109.111244,6.85663892 L101.867122,6.85663892 C102.015704,5.42638769 102.454168,5.18244636 104.422157,5.18244636 L106.476091,5.18244636 C107.67786,5.18244636 109.111244,5.42638769 109.111244,6.59091711 M106.476091,3.47485707 L104.228417,3.47485707 C102.072515,3.47485707 99.8699987,3.90611049 99.8699987,7.10493634 L99.8699987,8.90981175 C99.8699987,12.172527 102.111846,12.5921642 104.063811,12.5921642 L106.607193,12.5921642 C108.69026,12.5921642 111.08506,12.2799773 111.08506,9.83330391 L111.08506,9.39188627 L109.128724,9.39188627 L109.111244,9.65760808 C109.04278,10.6522498 108.621796,10.8845749 106.835893,10.8845749 L104.911605,10.8845749 C102.505152,10.8845749 101.845271,10.434445 101.845271,8.79655328 L101.845271,8.56277617 L111.08506,8.56277617 L111.08506,7.34887766 C111.08506,3.93660316 108.758725,3.47485707 106.476091,3.47485707",
        id: "Fill-10"
      }), React$4.createElement("path", {
        d: "M120.036424,3.47558309 L117.937333,3.47558309 C116.553476,3.47558309 115.513399,3.6454708 114.830211,4.37729478 L114.830211,3.60626594 L112.958364,3.60626594 L112.958364,12.4607553 L114.926353,12.4607553 L114.926353,7.46286215 C114.926353,5.8757915 115.278872,5.18317238 118.665678,5.18317238 L119.029851,5.18317238 C121.612563,5.18317238 121.806303,5.86998337 121.806303,6.91254214 L121.806303,12.4607553 L123.774292,12.4607553 L123.774292,6.57276672 C123.774292,5.41549745 123.290671,3.47558309 120.036424,3.47558309",
        id: "Fill-11"
      }), React$4.createElement("path", {
        d: "M125.550143,5.31341962 L125.550143,9.69419928 C125.550143,11.6166893 126.738803,12.5924546 129.084075,12.5924546 L129.79494,12.5924546 L129.79494,10.8848653 L129.305492,10.8848653 C127.905612,10.8848653 127.523959,10.5087891 127.523959,9.15404348 L127.523959,5.31341962 L129.824074,5.31341962 L129.824074,3.60583033 L127.523959,3.60583033 L127.523959,1.64558753 L125.550143,1.64558753 L125.550143,5.31341962 Z",
        id: "Fill-12"
      }), React$4.createElement("path", {
        d: "M91.4089568,3.47558309 L90.1008486,3.47558309 C89.110299,3.47558309 88.3426231,3.7369488 87.8123877,4.25242005 L87.8123877,3.60626594 L85.9347134,3.60626594 L85.9347134,12.4607553 L87.9099859,12.4607553 L87.9099859,6.91254214 C87.9099859,6.07326781 88.4096308,5.18317238 89.821164,5.18317238 L90.6864383,5.18317238 C90.9544694,5.18317238 91.1933666,5.1889805 91.4089568,5.19478863 L91.4089568,3.47558309 Z",
        id: "Fill-13"
      }), React$4.createElement("path", {
        d: "M98.4648749,3.47558309 L97.15094,3.47558309 C96.1603903,3.47558309 95.3985411,3.7369488 94.862479,4.25242005 L94.862479,3.60626594 L92.9906315,3.60626594 L92.9906315,12.4607553 L94.9600773,12.4607553 L94.9600773,6.91254214 C94.9600773,6.07326781 95.4655489,5.18317238 96.8770821,5.18317238 L97.7423564,5.18317238 C98.0103874,5.18317238 98.2492847,5.1889805 98.4648749,5.19478863 L98.4648749,3.47558309 Z",
        id: "Fill-14"
      }))))));
    }
  }]);
  return LogoNormal;
}(React$4.PureComponent);

var LogoVerticalDiapositive = function (_React$PureComponent) {
  _inherits$4(LogoVerticalDiapositive, _React$PureComponent);
  var _super = _createSuper$5(LogoVerticalDiapositive);
  function LogoVerticalDiapositive() {
    _classCallCheck$6(this, LogoVerticalDiapositive);
    return _super.apply(this, arguments);
  }
  _createClass$6(LogoVerticalDiapositive, [{
    key: "render",
    value: function render() {
      return React$4.createElement("svg", {
        width: this.props.width || '130px',
        height: this.props.height || '62px',
        viewBox: "0 0 130 62",
        xmlns: "http://www.w3.org/2000/svg"
      }, React$4.createElement("g", {
        fill: "#FFF",
        fillRule: "evenodd"
      }, React$4.createElement("path", {
        d: "M74.61.011c5.964 0 9.081 3.048 10.513 5.727a23.312 23.312 0 0 1 2.767 11.016C87.89 29.59 77.485 40 64.645 40 51.805 40 41.4 29.59 41.4 16.754c0-3.986 1.013-7.731 2.772-11.016C45.6 3.06 48.717.011 54.68.011Zm-1.299 6.185H55.98a5.534 5.534 0 0 0-5.523 5.524v12.91a5.53 5.53 0 0 0 5.523 5.523H73.31a5.526 5.526 0 0 0 5.523-5.523v-3.335H75.82v3.335a2.513 2.513 0 0 1-2.509 2.51H55.98a2.513 2.513 0 0 1-2.51-2.51V11.72a2.513 2.513 0 0 1 2.51-2.509H73.31a2.513 2.513 0 0 1 2.51 2.51v2.78h3.013v-2.78a5.53 5.53 0 0 0-5.523-5.525Zm-3.093 13.929H57.94v3.012h12.278a1.505 1.505 0 1 0 0-3.012Zm0-6.912H57.94v3.014h12.278a1.51 1.51 0 0 0 1.507-1.508 1.51 1.51 0 0 0-1.507-1.506ZM2.168 56.178h7.534c1.547 0 1.973.306 1.973 1.407v.845c0 .777-.295 1.294-1.735 1.294H2.168v-3.546Zm9.435-3.03c0 .5-.155 1.164-1.475 1.164h-7.96V51.13h8.04c.234 0 1.395.045 1.395.947v1.072Zm1.092 1.85c.688-.362 1.075-1.004 1.075-1.832v-1.009c0-1.083-.444-2.898-3.414-2.898H0V61.59h10.52c2.254 0 3.33-1.096 3.33-2.785v-1.397c0-1.253-.137-2.059-1.155-2.41ZM16.21 61.59h1.97V49.259h-1.97zM29.537 57.733c0 1.587-.352 2.28-3.737 2.28h-.36c-2.583 0-2.777-.681-2.777-1.73v-5.548H20.69v5.888c0 1.158.489 3.098 3.737 3.098h2.105c1.378 0 2.426-.172 3.102-.904v.773h1.877v-8.855h-1.974v4.998ZM42.687 55.72v.265H35.45c.143-1.43.587-1.674 2.555-1.674h2.054c1.202 0 2.63.244 2.63 1.409m-2.63-3.116H37.81c-2.155 0-4.364.43-4.364 3.63v1.804c0 3.263 2.248 3.683 4.2 3.683h2.543c2.083 0 4.472-.312 4.472-2.759v-.441h-1.95l-.018.265c-.068.995-.495 1.227-2.277 1.227h-1.922c-2.413 0-3.073-.45-3.073-2.088v-.234h9.24v-1.213c0-3.413-2.326-3.874-4.603-3.874M68.614 58.09c0 1.322-.358 1.759-2.48 1.759H60.54c-1.764 0-2.487-.642-2.487-2.213v-4.418c0-1.577.723-2.218 2.487-2.218h5.542c1.508 0 2.418.12 2.418 1.808v.823h1.974V52.34c0-2.654-2.167-3.21-3.982-3.21H60.38c-3.193 0-4.49 1.36-4.49 4.69v3.215c0 3.33 1.297 4.687 4.49 4.687h6.025c3.569 0 4.28-1.362 4.28-3.568v-1.079h-2.072v1.017ZM81.537 57.733c0 1.587-.353 2.28-3.738 2.28h-.36c-2.583 0-2.777-.681-2.777-1.73v-5.548H72.69v5.888c0 1.158.483 3.098 3.737 3.098h2.105c1.378 0 2.426-.172 3.102-.904v.773h1.877v-8.855h-1.973v4.998ZM109.111 55.72v.265h-7.244c.149-1.43.587-1.674 2.555-1.674h2.054c1.202 0 2.635.244 2.635 1.409m-2.635-3.116h-2.248c-2.155 0-4.358.43-4.358 3.63v1.804c0 3.263 2.242 3.683 4.194 3.683h2.543c2.083 0 4.478-.312 4.478-2.759v-.441h-1.956l-.018.265c-.068.995-.49 1.227-2.275 1.227h-1.924c-2.407 0-3.067-.45-3.067-2.088v-.234h9.24v-1.213c0-3.413-2.326-3.874-4.609-3.874M120.036 52.604h-2.099c-1.384 0-2.424.17-3.107.902v-.771h-1.872v8.854h1.968v-4.997c0-1.588.353-2.28 3.74-2.28h.364c2.583 0 2.776.687 2.776 1.73v5.547h1.968v-5.888c0-1.157-.483-3.097-3.738-3.097M125.55 54.442v4.38c0 1.923 1.189 2.9 3.534 2.9h.71v-1.708h-.489c-1.4 0-1.781-.377-1.781-1.731v-3.84h2.3v-1.708h-2.3v-1.96h-1.974v3.667ZM91.409 52.604h-1.308c-.99 0-1.758.262-2.289.777v-.646h-1.877v8.854h1.975v-5.548c0-.839.5-1.73 1.911-1.73h.865c.268 0 .507.007.723.012v-1.719ZM98.465 52.604H97.15c-.99 0-1.752.262-2.289.777v-.646h-1.871v8.854h1.97v-5.548c0-.839.505-1.73 1.916-1.73h.865c.268 0 .507.007.723.012v-1.719Z"
      })));
    }
  }]);
  return LogoVerticalDiapositive;
}(React$4.PureComponent);

var LogoHorizontalDiapositive = function (_React$PureComponent) {
  _inherits$4(LogoHorizontalDiapositive, _React$PureComponent);
  var _super = _createSuper$5(LogoHorizontalDiapositive);
  function LogoHorizontalDiapositive() {
    _classCallCheck$6(this, LogoHorizontalDiapositive);
    return _super.apply(this, arguments);
  }
  _createClass$6(LogoHorizontalDiapositive, [{
    key: "render",
    value: function render() {
      return React$4.createElement("svg", {
        height: this.props.height || '50px',
        width: this.props.width || '200px',
        viewBox: "0 0 200 50",
        xmlns: "http://www.w3.org/2000/svg"
      }, React$4.createElement("g", {
        fill: "#FFF",
        fillRule: "evenodd"
      }, React$4.createElement("path", {
        d: "M41.513 0c7.454 0 11.351 3.81 13.14 7.159a29.14 29.14 0 0 1 3.46 13.77c0 16.045-13.007 29.056-29.057 29.056C13.006 49.985 0 36.974 0 20.93c0-4.983 1.266-9.665 3.465-13.77C5.25 3.81 9.145 0 16.6 0Zm-1.624 7.73H18.224c-3.804 0-6.905 3.103-6.905 6.906v16.137c0 3.81 3.1 6.904 6.905 6.904h21.665a6.908 6.908 0 0 0 6.904-6.904v-4.169h-3.767v4.17a3.141 3.141 0 0 1-3.137 3.136H18.224a3.141 3.141 0 0 1-3.137-3.137V14.636a3.141 3.141 0 0 1 3.137-3.136h21.665a3.141 3.141 0 0 1 3.137 3.136v3.477h3.767v-3.477c0-3.803-3.094-6.905-6.904-6.905Zm-3.867 17.412H20.676v3.766h15.346c1.039 0 1.884-.84 1.884-1.877 0-1.043-.845-1.89-1.884-1.89Zm0-8.64H20.676v3.767h15.346a1.888 1.888 0 0 0 1.884-1.884 1.887 1.887 0 0 0-1.884-1.883ZM71.387 23.549h7.534c1.547 0 1.973.306 1.973 1.407v.845c0 .777-.295 1.294-1.735 1.294h-7.772v-3.546Zm9.434-3.029c0 .5-.154 1.163-1.474 1.163h-7.96v-3.181h8.04c.234 0 1.394.045 1.394.946v1.072Zm1.093 1.85c.688-.363 1.075-1.005 1.075-1.832v-1.01c0-1.083-.444-2.898-3.414-2.898H69.219v12.332h10.52c2.254 0 3.33-1.096 3.33-2.785V24.78c0-1.253-.137-2.059-1.155-2.41ZM85.43 28.96h1.969V16.63h-1.97zM98.756 25.105c0 1.587-.352 2.28-3.737 2.28h-.36c-2.583 0-2.777-.682-2.777-1.732v-5.546h-1.974v5.888c0 1.157.49 3.097 3.738 3.097h2.105c1.378 0 2.426-.171 3.102-.903v.772h1.877v-8.854h-1.974v4.998ZM111.906 23.09v.267h-7.238c.143-1.43.587-1.675 2.555-1.675h2.054c1.202 0 2.63.244 2.63 1.409m-2.63-3.116h-2.248c-2.156 0-4.364.431-4.364 3.63v1.805c0 3.263 2.248 3.682 4.2 3.682h2.543c2.083 0 4.472-.312 4.472-2.759v-.441h-1.95l-.018.266c-.068.994-.495 1.227-2.277 1.227h-1.922c-2.413 0-3.073-.45-3.073-2.088v-.234h9.24v-1.214c0-3.412-2.326-3.874-4.603-3.874M137.833 25.462c0 1.321-.358 1.758-2.48 1.758h-5.594c-1.764 0-2.487-.641-2.487-2.213V20.59c0-1.577.723-2.217 2.487-2.217h5.542c1.508 0 2.418.119 2.418 1.807v.824h1.974V19.71c0-2.654-2.167-3.21-3.982-3.21H129.6c-3.193 0-4.49 1.36-4.49 4.69v3.215c0 3.33 1.297 4.687 4.49 4.687h6.025c3.569 0 4.28-1.362 4.28-3.568v-1.078h-2.072v1.016ZM150.755 25.105c0 1.587-.352 2.28-3.737 2.28h-.36c-2.583 0-2.777-.682-2.777-1.732v-5.546h-1.973v5.888c0 1.157.483 3.097 3.737 3.097h2.105c1.378 0 2.426-.171 3.102-.903v.772h1.877v-8.854h-1.974v4.998ZM178.33 23.09v.267h-7.244c.149-1.43.587-1.675 2.555-1.675h2.054c1.202 0 2.635.244 2.635 1.409m-2.635-3.116h-2.248c-2.156 0-4.358.431-4.358 3.63v1.805c0 3.263 2.242 3.682 4.194 3.682h2.543c2.083 0 4.478-.312 4.478-2.759v-.441h-1.956l-.018.266c-.068.994-.49 1.227-2.275 1.227h-1.924c-2.407 0-3.067-.45-3.067-2.088v-.234h9.24v-1.214c0-3.412-2.326-3.874-4.609-3.874M189.255 19.976h-2.099c-1.384 0-2.424.17-3.107.901v-.77h-1.872v8.854h1.968v-4.998c0-1.587.353-2.28 3.74-2.28h.364c2.583 0 2.776.687 2.776 1.73v5.548h1.968v-5.888c0-1.158-.483-3.097-3.738-3.097M194.77 21.813v4.381c0 1.923 1.188 2.898 3.533 2.898h.71v-1.707h-.489c-1.4 0-1.781-.376-1.781-1.731v-3.84h2.3v-1.708h-2.3v-1.96h-1.974v3.667ZM160.628 19.976h-1.308c-.99 0-1.758.26-2.289.776v-.646h-1.877v8.855h1.975v-5.548c0-.84.5-1.73 1.911-1.73h.865c.268 0 .507.006.723.012v-1.72ZM167.684 19.976h-1.314c-.99 0-1.753.26-2.289.776v-.646h-1.871v8.855h1.969v-5.548c0-.84.505-1.73 1.917-1.73h.865c.268 0 .507.006.723.012v-1.72Z"
      })));
    }
  }]);
  return LogoHorizontalDiapositive;
}(React$4.PureComponent);

var LogoApp = function (_React$PureComponent) {
  _inherits$4(LogoApp, _React$PureComponent);
  var _super = _createSuper$5(LogoApp);
  function LogoApp() {
    _classCallCheck$6(this, LogoApp);
    return _super.apply(this, arguments);
  }
  _createClass$6(LogoApp, [{
    key: "render",
    value: function render() {
      return React__default.createElement("svg", {
        viewBox: "0 0 1112 1112",
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        height: this.props.height || '10px',
        width: this.props.width || '10px',
        style: {
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          strokeLinejoin: 'round',
          strokeMiterlimit: 2
        }
      }, React__default.createElement("path", {
        d: "M74.61 0c6 0 9.08 3.05 10.51 5.73a23.258 23.258 0 0 1 2.775 11.015c0 12.755-10.495 23.25-23.25 23.25s-23.25-10.495-23.25-23.25c0-3.844.954-7.629 2.775-11.015C45.6 3.06 48.72 0 54.68 0h19.93Zm-1.3 6.2H56c-3.026.005-5.515 2.494-5.52 5.52v12.91c0 3.028 2.492 5.52 5.52 5.52h17.31c3.028 0 5.52-2.492 5.52-5.52v-3.34h-3v3.34a2.531 2.531 0 0 1-2.51 2.51H56a2.531 2.531 0 0 1-2.51-2.51V11.72A2.531 2.531 0 0 1 56 9.21h17.31a2.531 2.531 0 0 1 2.51 2.51v2.78h3v-2.78c0-3.024-2.486-5.515-5.51-5.52Zm-3.09 13.92H57.94v3h12.28a1.517 1.517 0 0 0 1.683-1.5 1.517 1.517 0 0 0-1.683-1.5Zm0-6.91H57.94v3h12.28a1.516 1.516 0 0 0 1.337-1.5c0-.763-.579-1.412-1.337-1.5Z",
        style: {
          fill: '#0098db',
          fillRule: 'nonzero'
        },
        transform: "matrix(23.49196 0 0 23.49196 -963.084 85.772)"
      }));
    }
  }]);
  return LogoApp;
}(React__default.PureComponent);

function Logo(props) {
  var render = function render() {
    switch (props.type) {
      case 'Normal':
        return React$4.createElement(LogoNormal, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'VerticalDiapositive':
        return React$4.createElement(LogoVerticalDiapositive, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'HorizontalDiapositive':
        return React$4.createElement(LogoHorizontalDiapositive, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'App':
        return React$4.createElement(LogoApp, {
          height: props.height,
          width: props.width
        });
      default:
        return React$4.createElement("div", null);
    }
  };
  return render();
}

function SideBarNavigation(props) {
  var size = useDimensions();
  var _React$useState = React$4.useState(true),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      extended = _React$useState2[0],
      setExtended = _React$useState2[1];
  React$4.useEffect(function () {
    if (props.alwaysOpen) {
      setExtended(true);
    } else {
      setExtended(false);
    }
  }, [props.alwaysOpen]);
  return React$4.createElement("div", {
    className: "Blur",
    onMouseEnter: function onMouseEnter() {
      if (!props.alwaysOpen) setExtended(true);
    },
    onMouseLeave: function onMouseLeave() {
      if (!props.alwaysOpen) setExtended(false);
    },
    style: {
      width: extended ? 240 : 70,
      height: size.height,
      position: 'absolute',
      transition: 'all .2s linear',
      borderRight: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      paddingTop: 0,
      paddingBottom: 10,
      zIndex: 2147483004,
      overflow: 'hidden',
      backgroundColor: Backgrounds.BLUR
    }
  }, React$4.createElement("div", {
    style: {
      height: 60,
      width: '100%',
      backgroundColor: Colors.WHITE,
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10
    }
  }, React$4.createElement(Logo, {
    type: "Normal",
    height: 50,
    width: 170
  })), React$4.createElement("div", {
    style: {
      position: 'absolute',
      height: 50,
      width: '100%',
      background: "linear-gradient(0deg, ".concat(Colors.WHITE, "15 0%, ").concat(Colors.WHITE, " 70%)"),
      zIndex: 1
    }
  }), React$4.createElement("div", {
    style: {
      height: 'calc(100% - 40px)',
      width: extended ? 253 : 70,
      backgroundColor: 'transparent',
      paddingLeft: 0,
      paddingTop: 100,
      overflowY: 'scroll',
      overflowX: 'hidden',
      paddingRight: 300,
      transition: 'all .2s linear'
    }
  }, props.items.map(function (e) {
    return React$4.createElement(SideNavigationItem, {
      key: e.path,
      title: e.title,
      path: e.path,
      icon: e.icon,
      active: e.active,
      colorScheme: getColorScheme(e.colorScheme),
      extended: extended,
      onClick: e.onClick
    });
  })));
}

function TabNavigationItem(props) {
  return React$4.createElement("div", {
    style: {
      width: '100%',
      transition: 'all .3s ease-in-out .1s'
    }
  }, React$4.createElement("button", {
    onClick: function onClick() {
      props.onClick();
    },
    type: "button",
    style: {
      height: 50,
      width: '100%',
      backgroundColor: 'transparent',
      border: 'none'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'inline-block'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      paddingLeft: 5,
      paddingRight: 5,
      borderRadius: 20,
      paddingTop: 5,
      paddingBottom: 5,
      backgroundColor: 'transparent'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      height: 30,
      widht: 30,
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, React$4.createElement(Icon, {
    name: props.icon.name,
    height: props.icon.height,
    width: props.icon.width,
    color: props.active ? props.colorScheme.vibrant : Colors.GREY,
    iconSet: props.icon.iconSet
  }))))));
}

function TabNavigation(props) {
  return React$4.createElement("div", {
    style: {
      height: 60,
      width: '100%',
      backgroundColor: Colors.WHITE,
      position: 'fixed',
      bottom: 0,
      borderTop: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderLeft: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderRight: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderTopRightRadius: 15,
      borderTopLeftRadius: 15,
      zIndex: 10000
    }
  }, props.items && props.items.map(function (e) {
    var _e$colorScheme;
    return React$4.createElement(TabNavigationItem, {
      key: e.title,
      title: e.title,
      icon: e.icon,
      active: e.active,
      onClick: e.onClick,
      colorScheme: getColorScheme("".concat((_e$colorScheme = e.colorScheme) !== null && _e$colorScheme !== void 0 ? _e$colorScheme : 'blue'))
    });
  }));
}

function TabFixed(props) {
  return React$4.createElement("div", {
    style: {
      bottom: 0,
      width: '100%',
      backgroundColor: Colors.WHITE,
      borderTop: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderTopLeftRadius: 10,
      borderTopRightRadius: 10,
      position: 'fixed',
      paddingLeft: props.paddingLeft,
      paddingRight: props.paddingRight,
      paddingTop: props.paddingTop,
      paddingBottom: props.paddingBottom
    }
  }, React$4.createElement(MainContainer, null, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingTop: 10,
      paddingBottom: 10
    }
  }, props.children)));
}

function UMOVE(props) {
  var _props$color, _props$color2;
  return React__default.createElement("svg", {
    viewBox: "0 0 450 350",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeMiterlimit: 1.5,
      position: 'relative',
      zIndex: 1
    },
    width: "100%",
    height: "100%"
  }, React__default.createElement("path", {
    style: {
      fill: 'none'
    },
    d: "M0 0h450v350H0z"
  }), React__default.createElement("g", null, React__default.createElement("use", {
    xlinkHref: "#UMOVE_Body",
    x: 58.025,
    y: 42.349,
    width: 334.221,
    height: 307.693,
    transform: "scale(.99767 .999)"
  }), React__default.createElement("path", {
    d: "M81.904 350V108.35c0-20.541 16.871-34.194 37.193-37.193 42.399-6.256 169.407-6.659 211.806 0 20.293 3.188 37.193 16.652 37.193 37.193V350H81.904Z",
    style: {
      fill: '#fdfdfd'
    }
  }), React__default.createElement("use", {
    xlinkHref: "#UMOVE_TopBody",
    x: 109.111,
    y: 27.806,
    width: 231.886,
    height: 263.25,
    transform: "scale(.9995 .99716)"
  }), React__default.createElement("path", {
    d: "M306.963 67.248c0-.859-.651-1.576-1.505-1.659-53.294-5.141-106.93-5.175-160.915.001-.854.082-1.506.8-1.506 1.659v149.735c0 22.091 17.908 40 40 40h83.926c22.092 0 40-17.909 40-40V67.248Z",
    style: {
      fill: '#fdfdfd',
      stroke: '#fdfdfd',
      strokeWidth: 20
    }
  }), React__default.createElement("path", {
    d: "M271.95 261.941a40 40 0 0 0 40-40V108.963h-8.152a1.845 1.845 0 0 0-1.845 1.845v101.17c0 22.091-17.908 40-40 40h-73.922c-22.092 0-40-17.909-40-40V110.797a1.834 1.834 0 0 0-1.834-1.834h-8.147v112.978a40 40 0 0 0 40 40h93.9Z",
    style: {
      fill: '#EEEEEE',
      stroke: '#EEEEEE',
      strokeWidth: 10,
      strokeLinejoin: 'miter'
    }
  }), React__default.createElement("path", {
    d: "M271.95 261.941a40 40 0 0 0 40-40V108.963h-8.152a1.845 1.845 0 0 0-1.845 1.845v101.17c0 22.091-17.908 40-40 40h-73.922c-22.092 0-40-17.909-40-40V110.797a1.834 1.834 0 0 0-1.834-1.834h-8.147v112.978a40 40 0 0 0 40 40h93.9Z",
    style: {
      fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : '#ef6a6b',
      stroke: (_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : '#ef6a6b',
      strokeWidth: 10,
      strokeLinejoin: 'miter'
    }
  })), React__default.createElement("defs", null, React__default.createElement("image", {
    id: "UMOVE_Body",
    width: 335,
    height: 308,
    xlinkHref: "data:image/png;base64,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"
  }), React__default.createElement("image", {
    id: "UMOVE_TopBody",
    width: 232,
    height: 264,
    xlinkHref: "data:image/png;base64,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"
  })));
}

function Hidden() {
  return React__default.createElement("svg", {
    viewBox: "0 0 450 350",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
      position: 'relative',
      zIndex: 1
    },
    width: "100%",
    height: "100%"
  }, React__default.createElement("path", {
    d: "M1044.64 3519.86c-268.906-255.34-382.721-755.45-425.729-1324.79-63.39-839.14 322.652-1554.291 837.689-1596.774 601.87-49.644 941.08 786.164 844.87 1596.774-43.64 367.73-136.79 708.92-252.08 974.78 77.66-251.71 132.78-560.06 184.47-886.23 132.01-832.99-378.74-1713.728-780.19-1574.631C956.765 881.158 681.619 1455.15 754.285 2283.62c44.516 507.54 85.829 962.39 290.355 1236.24Z",
    style: {
      fill: '#2472d0'
    },
    transform: "matrix(.19149 0 0 .19149 -55.125 4.715)"
  }), React__default.createElement("path", {
    d: "M764.112 2943.63C602.553 2760.72 475.31 2455.35 505.205 1945c39.072-667.02 475.192-1198.268 952.855-1205.262 505.71-7.405 931.54 508.702 911.01 1205.262-9.1 309.01-78.8 588.29-215.88 807.58 68.02-193.17 75.41-425.73 97.81-667.35 53.58-577.94-156.77-1239.717-792.94-1265.741-477.361-19.527-878.711 591.721-856.519 1265.741 13.768 418.13 78.554 674.87 162.571 858.4Z",
    style: {
      fill: '#2f7bd6'
    },
    transform: "matrix(.1928 0 0 .19149 -45.4 -11.48)"
  }), React__default.createElement("path", {
    d: "M1702.47 753.654c0-87.783-87.06-158.945-194.44-158.945h-.01c-107.39 0-194.44 71.162-194.44 158.945V953.78c0 87.78 87.05 158.95 194.44 158.95h.01c107.38 0 194.44-71.17 194.44-158.95V753.654Z",
    style: {
      fill: '#3c444c'
    },
    transform: "matrix(.20068 0 0 .2455 -65.123 -62.441)"
  }), React__default.createElement("path", {
    d: "M960.699 1070.39h43.211c8.88 0 11.33 1.86 11.33 8.52v5.12c0 4.7-1.7 7.83-9.96 7.83h-44.581v-21.47Zm54.121-18.34c0 3.02-.89 7.04-8.46 7.04h-45.661v-19.27h46.121c1.34 0 8 .28 8 5.74v6.49Zm6.26 11.2c3.95-2.2 6.17-6.09 6.17-11.1v-6.11c0-6.56-2.55-17.55-19.58-17.55h-59.404v74.68h60.344c12.92 0 19.1-6.64 19.1-16.86v-8.46c0-7.59-.79-12.47-6.63-14.6ZM1041.25 1028.48h11.297v74.676h-11.297zM1117.69 1079.81c0 9.61-2.02 13.81-21.44 13.81h-2.06c-14.82 0-15.93-4.13-15.93-10.49v-33.59h-11.32v35.66c0 7.01 2.81 18.76 21.44 18.76h12.07c7.91 0 13.91-1.04 17.79-5.47v4.68h10.77v-53.63h-11.32v30.27ZM1193.12 1067.62v1.61h-41.52c.82-8.66 3.37-10.14 14.66-10.14h11.78c6.89 0 15.08 1.48 15.08 8.53m-15.08-18.87h-12.89c-12.37 0-25.04 2.61-25.04 21.98v10.93c0 19.76 12.9 22.3 24.09 22.3h14.59c11.95 0 25.65-1.89 25.65-16.7v-2.68h-11.19l-.1 1.61c-.39 6.03-2.84 7.43-13.06 7.43h-11.02c-13.84 0-17.63-2.72-17.63-12.64v-1.42h53v-7.35c0-20.66-13.34-23.46-26.4-23.46M1341.83 1081.97c0 8-2.05 10.65-14.23 10.65h-32.08c-10.12 0-14.27-3.89-14.27-13.4v-26.76c0-9.55 4.15-13.43 14.27-13.43h31.79c8.65 0 13.87.72 13.87 10.95v4.98h11.32v-7.82c0-16.08-12.43-19.45-22.84-19.45h-35.05c-18.32 0-25.76 8.24-25.76 28.41v19.47c0 20.16 7.44 28.38 25.76 28.38h34.55c20.47 0 24.55-8.24 24.55-21.6v-6.54h-11.88v6.16ZM1415.95 1079.81c0 9.61-2.02 13.81-21.44 13.81h-2.06c-14.82 0-15.93-4.13-15.93-10.49v-33.59h-11.32v35.66c0 7.01 2.77 18.76 21.44 18.76h12.07c7.91 0 13.91-1.04 17.79-5.47v4.68h10.77v-53.63h-11.32v30.27ZM1574.12 1067.62v1.61h-41.55c.85-8.66 3.37-10.14 14.65-10.14h11.79c6.89 0 15.11 1.48 15.11 8.53m-15.11-18.87h-12.9c-12.36 0-25 2.61-25 21.98v10.93c0 19.76 12.86 22.3 24.06 22.3h14.59c11.94 0 25.68-1.89 25.68-16.7v-2.68h-11.22l-.1 1.61c-.39 6.03-2.81 7.43-13.05 7.43h-11.04c-13.8 0-17.59-2.72-17.59-12.64v-1.42h53v-7.35c0-20.66-13.34-23.46-26.43-23.46M1636.79 1048.75h-12.04c-7.94 0-13.9 1.03-17.82 5.46v-4.67h-10.74v53.62h11.29v-30.26c0-9.61 2.02-13.81 21.45-13.81h2.09c14.81 0 15.92 4.16 15.92 10.48v33.59h11.29v-35.65c0-7.01-2.77-18.76-21.44-18.76M1668.41 1037.66v48.74c0 11.65 6.82 17.56 20.27 17.56h4.08v-10.34h-2.81c-8.03 0-10.22-2.28-10.22-10.49v-23.26h13.19v-10.34h-13.19v-11.87h-11.32ZM1472.58 1048.75h-7.5c-5.69 0-10.09 1.58-13.13 4.7v-3.91h-10.77v53.62h11.33v-33.59c0-5.09 2.87-10.48 10.96-10.48h4.97c1.53 0 2.9.04 4.14.07v-10.41ZM1513.05 1048.75h-7.54c-5.68 0-10.05 1.58-13.12 4.7v-3.91h-10.74v53.62h11.3v-33.59c0-5.09 2.9-10.48 10.99-10.48h4.97c1.53 0 2.9.04 4.14.07v-10.41Z",
    style: {
      fill: '#4b87d1'
    },
    transform: "matrix(.06958 0 0 .06958 150.563 47.723)"
  }), React__default.createElement("path", {
    d: "M806.062 1103.59h24.352c11.944 0 21.848-7.22 21.848-21.38 0-8.41-4.038-15.85-11.156-18.19v-.21c5.191-2.98 8.461-8.83 8.461-16.18 0-12.13-8.27-19.14-19.73-19.14h-23.775v75.1Zm9.519-43.5v-22.46h14.064c6.55 0 10.21 4.47 10.21 11.07 0 6.6-3.853 11.39-10.018 11.39h-14.256Zm0 34.36v-25.65h15.22c7.126 0 11.75 5.22 11.75 12.88 0 7.66-4.335 12.77-11.655 12.77h-15.315ZM858.34 1122.64s3.946 3.29 9.432 3.29c6.834 0 12.802-4.35 15.786-12.64l22.811-63.52h-10.106l-11.839 35.32c-.866 2.77-1.636 6.39-1.636 6.39h-.193s-.866-3.73-1.829-6.49l-12.224-35.22h-10.491l20.405 53.2-2.406 6.17c-1.829 4.89-5.005 7.87-8.759 7.87-2.984 0-5.679-2.23-5.679-2.23l-3.272 7.86Z",
    style: {
      fill: '#fff',
      fillRule: 'nonzero'
    },
    transform: "matrix(.06958 0 0 .06958 150.563 47.723)"
  }), React__default.createElement("path", {
    d: "M1528.43 974.484c-116.4 8.24-87.03-104.622 83.44-82.961 449.1 57.066 729.64 569.217 676.31 1116.687-45.81 470.22-105.29 483.96-80.61 72.2 36.96-616.63-256.8-1135.822-679.14-1105.926Z",
    style: {
      fill: '#3c85dc'
    },
    transform: "matrix(.19149 0 0 .19149 -44.732 -11.48)"
  }), React__default.createElement("g", {
    transform: "matrix(.19149 0 0 .19149 -44.732 -11.48)"
  }, React__default.createElement("path", {
    d: "M675.088 1150.42H501.271c-6.95 0-13.616 1.21-18.531 3.38-4.914 2.17-7.675 5.1-7.675 8.17v109.96c0 3.02 2.726 5.92 7.578 8.06 4.853 2.14 11.435 3.34 18.297 3.34h174.148v-132.91Z",
    style: {
      fill: '#242f39'
    },
    transform: "matrix(.81283 -.5825 1.32136 1.84386 -1523.12 -645.093)"
  }), React__default.createElement("path", {
    d: "M675.088 1185.2c0-19.21-19.117-34.78-42.7-34.78H517.174c-23.256 0-42.109 15.35-42.109 34.3V1248c0 19.52 19.419 35.33 43.374 35.33h113.742c11.379 0 22.293-3.68 30.34-10.23 8.047-6.56 12.568-15.45 12.567-24.72v-63.18Z",
    style: {
      fill: '#121a21'
    },
    transform: "matrix(.1983 -.1421 .17445 .24344 169.577 1048.07)"
  }), React__default.createElement("path", {
    d: "M1249.2 802.581a1184.497 1184.497 0 0 0-264.602 49.07c-57.199 17.353-138.325 42.2-138.436 42.235-1.332.408-2.661.827-3.985 1.259-75.21 24.761-167.01 74.553-275.277 149.235a52.144 52.144 0 0 0-13.027 73.14c37.056 52.39 99.634 140.71 136.903 193.3a52.028 52.028 0 0 0 34.225 21.3 52.05 52.05 0 0 0 39.164-9.54c71.911-52.61 97.604-73.26 137.602-154.31 12.198-24.71 32.249-71.17 66.008-107.54a69.143 69.143 0 0 1 20.369-14.92c9.375-4.62 19.646-7.3 30.586-6.2 61.88 6.22 70.62 12.65 140.2 18.39 38.84 3.19 111.18 7.27 168.63 8.91a51.95 51.95 0 0 0 37.27-14.93 51.979 51.979 0 0 0 15.51-37.04c.02-47.284.02-116.28.02-163.254a52.36 52.36 0 0 0-52.55-52.361c-26.42.324-52.62 1.398-78.61 3.256Z",
    style: {
      fill: '#1b83ec'
    }
  }), React__default.createElement("clipPath", {
    id: "a"
  }, React__default.createElement("path", {
    d: "M1249.2 802.581a1184.497 1184.497 0 0 0-264.602 49.07c-57.199 17.353-138.325 42.2-138.436 42.235-1.332.408-2.661.827-3.985 1.259-75.21 24.761-167.01 74.553-275.277 149.235a52.144 52.144 0 0 0-13.027 73.14c37.056 52.39 99.634 140.71 136.903 193.3a52.028 52.028 0 0 0 34.225 21.3 52.05 52.05 0 0 0 39.164-9.54c71.911-52.61 97.604-73.26 137.602-154.31 12.198-24.71 32.249-71.17 66.008-107.54a69.143 69.143 0 0 1 20.369-14.92c9.375-4.62 19.646-7.3 30.586-6.2 61.88 6.22 70.62 12.65 140.2 18.39 38.84 3.19 111.18 7.27 168.63 8.91a51.95 51.95 0 0 0 37.27-14.93 51.979 51.979 0 0 0 15.51-37.04c.02-47.284.02-116.28.02-163.254a52.36 52.36 0 0 0-52.55-52.361c-26.42.324-52.62 1.398-78.61 3.256Z"
  })), React__default.createElement("g", {
    clipPath: "url(#a)"
  }, React__default.createElement("path", {
    d: "M1166.42 875.941a237.513 237.513 0 0 0-184.581-15.723c-32.152 10.484-67.273 21.952-89.431 29.187a72.17 72.17 0 0 0-40.887 33.91c-32.871 59.95 32.191 72.793 135.605 126.205a52.408 52.408 0 0 0 39.704 3.55c11.81-3.79 21.51-5.39 34.1-3.64a51.905 51.905 0 0 0 33.87-7.53c122.45-76.032 154.48-122.147 71.62-165.959Z",
    style: {
      fill: '#242f39'
    },
    transform: "translate(-28 -5.758)"
  })), React__default.createElement("path", {
    style: {
      fill: '#1b83ec'
    },
    d: "M1501.37 1024.82h32.986v16.483h-32.986z",
    transform: "rotate(-29.339 1517.38 1030.976)"
  }), React__default.createElement("path", {
    d: "m1580.61 891.424-14.4-27.249v139.175l14.4-25.959v-85.967Z",
    style: {
      fill: '#242f39'
    },
    transform: "translate(.217 -.658)"
  }), React__default.createElement("path", {
    d: "M1580.51 875.427c0-21.14-15.93-39.062-37.37-42.048l-109.18-15.208c-12.55-1.747-25.26 1.906-34.83 10.015-9.57 8.108-15.07 19.874-15.07 32.248v147.706c0 12.31 5.46 24.02 14.97 32.1 9.51 8.08 22.14 11.75 34.63 10.05 34-4.63 78.4-10.67 109.44-14.89 21.45-2.91 37.41-20.82 37.41-41.955V875.427Z",
    style: {
      fill: '#242f39'
    },
    transform: "matrix(.9593 0 0 .98261 52.639 15.203)"
  }), React__default.createElement("path", {
    d: "M1513.21 840.442c0-22.307-17.76-40.404-39.69-40.445-.01.156-.02.156-.03.156-10.35-.016-20.28 4.154-27.6 11.593-7.33 7.438-11.45 17.534-11.45 28.061-.14 47.876-.14 138.012-.14 185.073 0 21.85 17.32 39.62 38.8 39.8.01-.21.02-.21.02-.21 10.55.09 20.7-4.12 28.19-11.67 7.48-7.56 11.7-17.85 11.7-28.57.2-47.033.2-135.976.2-183.788Z",
    style: {
      fill: '#1b83ec'
    },
    transform: "matrix(1.01713 0 0 1 -25.931 0)"
  })));
}

function NanoCharge(props) {
  var _props$color, _props$color2;
  return React__default.createElement("svg", {
    viewBox: "0 0 450 350",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
      position: 'relative',
      zIndex: 1
    },
    width: "100%",
    height: "100%"
  }, React__default.createElement("path", {
    d: "M442.773 1023.2C456.002 568.404 838.235 211.629 1250 209.394c421.91-2.29 781.88 345.641 807.23 816.446v968.62H442.772v-968.62l.005-2.64h-.004Z",
    style: {
      fill: '#444',
      stroke: '#dadada',
      strokeWidth: '38.89px'
    },
    transform: "translate(17.602 29.715) scale(.16585)"
  }), React__default.createElement("path", {
    d: "M978.179 1286.78h543.641c258.64 103.33 440.8 349.56 440.8 636.57 0 380-319.32 688.51-712.62 688.51-393.304 0-712.617-308.51-712.617-688.51 0-287.01 182.161-533.24 440.796-636.57Z",
    style: {
      fill: '#63605f'
    },
    transform: "translate(17.602 29.715) scale(.16585)"
  }), React__default.createElement("use", {
    xlinkHref: "#a",
    width: 1408,
    height: 787,
    transform: "matrix(.16582 0 0 .16567 108.178 221.823)"
  }), React__default.createElement("path", {
    d: "M1474.77 1359.24c0 48.1 25.87 92.49 67.72 116.2 177.21 100.26 296.7 288.78 296.7 504.62 0 320.82-264.01 581.29-589.19 581.29-325.19 0-589.201-260.47-589.201-581.29 0-215.92 119.578-404.5 296.917-504.75 41.734-23.62 67.534-67.87 67.534-115.83v-71.14c0-6.24 5.07-11.31 11.32-11.31h426.86c3.01 0 5.89 1.2 8.02 3.32a11.33 11.33 0 0 1 3.32 8.02v70.87Z",
    style: {
      fill: '#63605f'
    },
    transform: "translate(17.602 29.715) scale(.16585)"
  }), React__default.createElement("g", {
    transform: "translate(17.602 29.715) scale(.16585)"
  }, React__default.createElement("circle", {
    cx: 1250.31,
    cy: 757.835,
    r: 22.222,
    style: {
      fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : '#ef6a6b'
    }
  }), React__default.createElement("path", {
    d: "M1434.24 652.815c11.03 13.36 19.76 39.418 24.17 69.588 6.82 46.588 3.02 103.275-23.67 141.386-4.69 6.697-3.06 15.943 3.64 20.633 6.7 4.689 15.95 3.059 20.63-3.639 30.75-43.915 36.58-108.989 28.72-162.673-5.37-36.679-17.23-67.914-30.64-84.156-5.2-6.306-14.55-7.2-20.85-1.995-6.31 5.204-7.2 14.55-2 20.856ZM1372.21 693.766c9.63 9.873 17.27 32.253 19.22 56.77 1.98 24.882-2.13 52.356-18.76 72.197-5.25 6.267-4.42 15.618 1.84 20.87 6.27 5.252 15.62 4.428 20.87-1.839 21.63-25.804 28.16-61.216 25.58-93.575-2.6-32.726-14.68-61.932-27.54-75.111-5.71-5.854-15.09-5.971-20.95-.262-5.85 5.709-5.97 15.096-.26 20.95ZM1313.1 730.479c.27.53 4.02 7.912 5.51 14.226 2.88 12.271 3.52 28.924-5.95 42.45-4.68 6.699-3.05 15.944 3.65 20.632 6.7 4.687 15.94 3.054 20.63-3.645 14.81-21.158 15.02-47.028 10.51-66.223-3.37-14.323-9.69-24.909-13.72-28.694-5.96-5.599-15.34-5.306-20.94.653-5.49 5.841-5.31 14.972.31 20.601ZM1042.91 633.954c-13.41 16.242-25.27 47.477-30.64 84.156-7.86 53.684-2.03 118.758 28.72 162.673 4.69 6.698 13.93 8.328 20.63 3.639 6.7-4.69 8.33-13.936 3.64-20.633-26.69-38.111-30.49-94.798-23.67-141.386 4.42-30.17 13.14-56.228 24.17-69.588 5.21-6.306 4.31-15.652-1.99-20.856-6.31-5.205-15.65-4.311-20.86 1.995ZM1106.58 673.078c-12.85 13.179-24.94 42.385-27.54 75.111-2.58 32.359 3.95 67.771 25.58 93.575 5.25 6.267 14.6 7.091 20.87 1.839 6.26-5.252 7.09-14.603 1.84-20.87-16.63-19.841-20.73-47.315-18.76-72.197 1.95-24.517 9.59-46.897 19.22-56.77 5.71-5.854 5.59-15.241-.26-20.95s-15.24-5.592-20.95.262ZM1187.23 730.479c5.62-5.629 5.8-14.76.31-20.601-5.6-5.959-14.98-6.252-20.94-.653-4.03 3.785-10.35 14.371-13.72 28.694-4.51 19.195-4.3 45.065 10.51 66.223 4.69 6.699 13.93 8.332 20.63 3.645 6.7-4.688 8.33-13.933 3.65-20.632-9.47-13.526-8.83-30.179-5.94-42.45 1.48-6.314 5.23-13.696 5.5-14.226Z",
    style: {
      fill: (_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : '#ef6a6b'
    }
  })), React__default.createElement("path", {
    d: "M960.699 1070.39h43.211c8.88 0 11.33 1.86 11.33 8.52v5.12c0 4.7-1.7 7.83-9.96 7.83h-44.581v-21.47Zm54.121-18.34c0 3.02-.89 7.04-8.46 7.04h-45.661v-19.27h46.121c1.34 0 8 .28 8 5.74v6.49Zm6.26 11.2c3.95-2.2 6.17-6.09 6.17-11.1v-6.11c0-6.56-2.55-17.55-19.58-17.55h-59.404v74.68h60.344c12.92 0 19.1-6.64 19.1-16.86v-8.46c0-7.59-.79-12.47-6.63-14.6ZM1041.25 1028.48h11.297v74.676h-11.297zM1117.69 1079.81c0 9.61-2.02 13.81-21.44 13.81h-2.06c-14.82 0-15.93-4.13-15.93-10.49v-33.59h-11.32v35.66c0 7.01 2.81 18.76 21.44 18.76h12.07c7.91 0 13.91-1.04 17.79-5.47v4.68h10.77v-53.63h-11.32v30.27ZM1193.12 1067.62v1.61h-41.52c.82-8.66 3.37-10.14 14.66-10.14h11.78c6.89 0 15.08 1.48 15.08 8.53m-15.08-18.87h-12.89c-12.37 0-25.04 2.61-25.04 21.98v10.93c0 19.76 12.9 22.3 24.09 22.3h14.59c11.95 0 25.65-1.89 25.65-16.7v-2.68h-11.19l-.1 1.61c-.39 6.03-2.84 7.43-13.06 7.43h-11.02c-13.84 0-17.63-2.72-17.63-12.64v-1.42h53v-7.35c0-20.66-13.34-23.46-26.4-23.46M1341.83 1081.97c0 8-2.05 10.65-14.23 10.65h-32.08c-10.12 0-14.27-3.89-14.27-13.4v-26.76c0-9.55 4.15-13.43 14.27-13.43h31.79c8.65 0 13.87.72 13.87 10.95v4.98h11.32v-7.82c0-16.08-12.43-19.45-22.84-19.45h-35.05c-18.32 0-25.76 8.24-25.76 28.41v19.47c0 20.16 7.44 28.38 25.76 28.38h34.55c20.47 0 24.55-8.24 24.55-21.6v-6.54h-11.88v6.16ZM1415.95 1079.81c0 9.61-2.02 13.81-21.44 13.81h-2.06c-14.82 0-15.93-4.13-15.93-10.49v-33.59h-11.32v35.66c0 7.01 2.77 18.76 21.44 18.76h12.07c7.91 0 13.91-1.04 17.79-5.47v4.68h10.77v-53.63h-11.32v30.27ZM1574.12 1067.62v1.61h-41.55c.85-8.66 3.37-10.14 14.65-10.14h11.79c6.89 0 15.11 1.48 15.11 8.53m-15.11-18.87h-12.9c-12.36 0-25 2.61-25 21.98v10.93c0 19.76 12.86 22.3 24.06 22.3h14.59c11.94 0 25.68-1.89 25.68-16.7v-2.68h-11.22l-.1 1.61c-.39 6.03-2.81 7.43-13.05 7.43h-11.04c-13.8 0-17.59-2.72-17.59-12.64v-1.42h53v-7.35c0-20.66-13.34-23.46-26.43-23.46M1636.79 1048.75h-12.04c-7.94 0-13.9 1.03-17.82 5.46v-4.67h-10.74v53.62h11.29v-30.26c0-9.61 2.02-13.81 21.45-13.81h2.09c14.81 0 15.92 4.16 15.92 10.48v33.59h11.29v-35.65c0-7.01-2.77-18.76-21.44-18.76M1668.41 1037.66v48.74c0 11.65 6.82 17.56 20.27 17.56h4.08v-10.34h-2.81c-8.03 0-10.22-2.28-10.22-10.49v-23.26h13.19v-10.34h-13.19v-11.87h-11.32ZM1472.58 1048.75h-7.5c-5.69 0-10.09 1.58-13.13 4.7v-3.91h-10.77v53.62h11.33v-33.59c0-5.09 2.87-10.48 10.96-10.48h4.97c1.53 0 2.9.04 4.14.07v-10.41ZM1513.05 1048.75h-7.54c-5.68 0-10.05 1.58-13.12 4.7v-3.91h-10.74v53.62h11.3v-33.59c0-5.09 2.9-10.48 10.99-10.48h4.97c1.53 0 2.9.04 4.14.07v-10.41Z",
    style: {
      fill: '#4b87d1'
    },
    transform: "translate(17.602 29.715) scale(.16585)"
  }), React__default.createElement("path", {
    d: "M806.062 1103.59h24.352c11.944 0 21.848-7.22 21.848-21.38 0-8.41-4.038-15.85-11.156-18.19v-.21c5.191-2.98 8.461-8.83 8.461-16.18 0-12.13-8.27-19.14-19.73-19.14h-23.775v75.1Zm9.519-43.5v-22.46h14.064c6.55 0 10.21 4.47 10.21 11.07 0 6.6-3.853 11.39-10.018 11.39h-14.256Zm0 34.36v-25.65h15.22c7.126 0 11.75 5.22 11.75 12.88 0 7.66-4.335 12.77-11.655 12.77h-15.315ZM858.34 1122.64s3.946 3.29 9.432 3.29c6.834 0 12.802-4.35 15.786-12.64l22.811-63.52h-10.106l-11.839 35.32c-.866 2.77-1.636 6.39-1.636 6.39h-.193s-.866-3.73-1.829-6.49l-12.224-35.22h-10.491l20.405 53.2-2.406 6.17c-1.829 4.89-5.005 7.87-8.759 7.87-2.984 0-5.679-2.23-5.679-2.23l-3.272 7.86Z",
    style: {
      fill: '#4b87d1',
      fillRule: 'nonzero'
    },
    transform: "translate(17.602 29.715) scale(.16585)"
  }), React__default.createElement("defs", null, React__default.createElement("image", {
    id: "a",
    width: 1408,
    height: 787,
    xlinkHref: "data:image/png;base64,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"
  })));
}

function GridItem(props) {
  var dropdownRef = React__default.useRef();
  var dataRef = React__default.useRef();
  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  var _React$useState3 = React__default.useState(false),
      _React$useState4 = _slicedToArray$5(_React$useState3, 2),
      dropdownMenu = _React$useState4[0],
      setDropdownMenu = _React$useState4[1];
  useDataAttributes(dataRef, props.dataAttributes, {
    all: {
      id: props.id,
      outsideClickExemption: true
    }
  });
  useDataAttributes(dropdownRef, undefined, {
    single: {
      id: props.id
    }
  }, dropdownMenu);
  useOutsideClick(dropdownRef, function () {
    return setDropdownMenu(false);
  });
  var lightColor = function lightColor() {
    switch (props.activity) {
      case 'available':
        return Colors.GREEN;
      case 'error':
        return Colors.RED;
      case 'charging':
        return Colors.BLUE;
      case 'offline':
        return Colors.MEDIUM_GREY;
      case 'unavailable':
        return Colors.MEDIUM_GREY;
      default:
        return Colors.MEDIUM_GREY;
    }
  };
  return React__default.createElement("div", {
    ref: dataRef,
    style: {
      position: 'relative'
    }
  }, React__default.createElement("div", {
    style: {
      width: props.width,
      height: props.width,
      backgroundColor: Colors.WHITE,
      borderRadius: 10,
      border: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      overflow: 'hidden',
      padding: 0,
      position: 'relative'
    }
  }, React__default.createElement("div", {
    style: {
      height: props.width,
      width: props.width,
      backgroundColor: Colors.WHITE,
      paddingLeft: 15,
      paddingRight: 15,
      paddingTop: 15
    }
  }, React__default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    }
  }, React__default.createElement("button", {
    type: "button",
    className: "Hover",
    onClick: props.onClick,
    style: {
      height: 35,
      width: props.menu ? 'calc(100% - 35px)' : '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: 'transparent',
      border: 'solid 0px transparent',
      fontSize: '1em'
    }
  }, React__default.createElement(Text, {
    fontSize: "1em"
  }, props.name)), props.menu && React__default.createElement("button", {
    type: "button",
    className: "Hover",
    onClick: function onClick() {
      setDropdownMenu(!dropdownMenu);
    },
    onMouseEnter: function onMouseEnter() {
      setHover(true);
      setDropdownMenu(dropdownMenu);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
      setDropdownMenu(false);
    },
    style: {
      border: 'solid 0px transparent',
      height: 35,
      width: 35,
      backgroundColor: Colors.WHITE,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, React__default.createElement("div", {
    style: {
      width: dropdownMenu ? 30 : 35,
      height: dropdownMenu ? 30 : 35,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      transform: "rotate(".concat(dropdownMenu ? 180 : 0, "deg)")
    }
  }, React__default.createElement(Icon, {
    name: dropdownMenu ? 'AngleDown' : 'Ellipsis-H',
    height: dropdownMenu ? 30 : 35,
    width: dropdownMenu ? 30 : 35,
    color: hover || dropdownMenu ? Colors.GREY : Colors.MEDIUM_GREY
  })))), React__default.createElement("button", {
    type: "button",
    className: "Hover",
    onClick: props.onClick,
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-end',
      height: '100%',
      width: '100%',
      backgroundColor: 'transparent',
      border: 'solid 0px transparent',
      position: 'relative',
      padding: 0,
      margin: 0
    }
  }, props.type === 'UMOVE' && React__default.createElement(UMOVE, {
    color: lightColor()
  }), props.type === 'HIDDEN' && React__default.createElement(Hidden, null), props.type === 'NANOCHARGE' && React__default.createElement(NanoCharge, {
    color: lightColor()
  }), React__default.createElement("div", {
    style: {
      position: 'absolute',
      top: 30,
      zIndex: 0
    }
  }, React__default.createElement(DotsPath, {
    color: Colors.MEDIUM_WHITE,
    height: "250%",
    width: "250%",
    marginLeft: "-50%"
  }))))), dropdownMenu && props.menu && React__default.createElement("div", {
    ref: dropdownRef,
    style: {
      position: 'absolute',
      top: -20,
      left: props.width - 240
    }
  }, React__default.createElement(DropdownMenu, {
    id: props.id,
    items: props.menu,
    onMouseEnter: function onMouseEnter() {
      setDropdownMenu(true);
    },
    onMouseLeave: function onMouseLeave() {
      setDropdownMenu(false);
    },
    onClick: function onClick() {
      setDropdownMenu(false);
    }
  })));
}

function GlobalHeaderItem(props) {
  var e = props.data;
  var dropdownRef = React$4.useRef();
  var dataRef = React$4.useRef();
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  var _React$useState3 = React$4.useState(false),
      _React$useState4 = _slicedToArray$5(_React$useState3, 2),
      dropdownMenu = _React$useState4[0],
      setDropdownMenu = _React$useState4[1];
  React$4.useEffect(function () {
    props.onChangeDropdown(dropdownMenu);
  }, [dropdownMenu]);
  useDataAttributes(dataRef, props.dataAttributes, {
    all: {
      id: props.id,
      outsideClickExemption: true
    }
  });
  useDataAttributes(dropdownRef, undefined, {
    single: {
      id: props.id
    }
  }, dropdownMenu);
  useOutsideClick(dropdownRef, function () {
    return setDropdownMenu(false);
  });
  return React$4.createElement("div", {
    ref: dataRef,
    style: {
      position: 'relative',
      height: '100%'
    }
  }, React$4.createElement("button", {
    className: e.disabled ? 'Disabled' : e.onClick || e.dropdownMenu ? 'Hover' : 'Disabled',
    type: "button",
    onClick: function onClick() {
      if (e.onClick) {
        e.onClick();
      }
      if (e.dropdownMenu) {
        setDropdownMenu(!dropdownMenu);
      }
    },
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    style: {
      height: '100%',
      width: 'auto',
      color: Colors.BLUE,
      border: 'solid 0px transparent',
      backgroundColor: 'transparent',
      marginRight: e.align === 'left' ? 30 : 0,
      marginLeft: e.align === 'right' ? 30 : 0,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      fontSize: '1em',
      textDecoration: !e.disabled && hover && (e.onClick || e.dropdownMenu) ? 'underline' : 'none'
    }
  }, e.icon && React$4.createElement("div", {
    style: {
      height: '100%',
      width: 27,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start'
    }
  }, React$4.createElement(Icon, {
    name: e.icon.name,
    width: e.icon.width,
    height: e.icon.height,
    color: e.icon.color,
    iconSet: e.icon.iconSet
  })), e.title && React$4.createElement(Text, {
    fontSize: "0.9em",
    color: Colors.BLUE
  }, e.title), e.component && e.component, e.dropdownMenu && React$4.createElement("div", {
    style: {
      width: 27,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      transform: "rotate(".concat(dropdownMenu ? '180deg' : '0', ")"),
      paddingTop: dropdownMenu ? 0 : 3,
      paddingBottom: dropdownMenu ? 2 : 0
    }
  }, React$4.createElement(Icon, {
    name: "AngleDown",
    width: 20,
    height: 20,
    color: Colors.BLUE,
    iconSet: "FA"
  })), e.suffix && React$4.createElement("div", {
    style: {
      width: 27,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      paddingLeft: hover ? 5 : 0,
      transition: 'all .1s linear'
    }
  }, React$4.createElement(Icon, {
    name: e.suffix.name,
    width: e.suffix.width,
    height: e.suffix.height,
    color: e.suffix.color,
    iconSet: e.suffix.iconSet
  }))), dropdownMenu && React$4.createElement("div", {
    ref: dropdownRef,
    style: {
      position: 'absolute',
      top: -20,
      left: e.align === 'left' ? 0 : 'initial',
      right: e.align === 'right' ? 240 : 'initial',
      zIndex: 2147483005
    }
  }, React$4.createElement(DropdownMenu, {
    id: props.id,
    items: e.dropdownMenu,
    onClose: function onClose() {
      setDropdownMenu(false);
    },
    onClickClose: true,
    right: e.align === 'right'
  })));
}

function GlobalHeader(props) {
  return React__default.createElement("div", {
    style: {
      height: 45,
      width: '100%',
      backgroundColor: Colors.GRADIENT,
      position: 'fixed',
      zIndex: 2147483003
    }
  }, React__default.createElement(MainContainer$1, null, React__default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: 45
    }
  }, React__default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start'
    }
  }, props.items.map(function (e) {
    return e.align === 'left' && !e.breakpoint && React__default.createElement(GlobalHeaderItem, {
      key: e.id,
      id: e.id,
      data: e,
      onChangeDropdown: props.onChangeDropdown
    });
  })), React__default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-end'
    }
  }, props.items.map(function (e) {
    return e.align === 'right' && !e.breakpoint && React__default.createElement(GlobalHeaderItem, {
      key: e.id,
      id: e.id,
      data: e,
      onChangeDropdown: props.onChangeDropdown
    });
  })))));
}

function Item$2(props) {
  var _props$image$size;
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  var flexAlignHandler = function flexAlignHandler() {
    switch (props.align) {
      case 'left':
        return 'flex-start';
      case 'right':
        return 'flex-end';
      default:
        return 'center';
    }
  };
  return React$4.createElement(motion.button, {
    type: "button",
    className: "Hover",
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    onClick: function onClick() {
      var _props$target;
      window.open(props.href, (_props$target = props.target) !== null && _props$target !== void 0 ? _props$target : '_self');
    },
    style: {
      width: '100%',
      backgroundColor: hover ? Colors.LIGHT_GREY : 'transparent',
      border: "solid 2px ".concat(hover ? Colors.MEDIUM_WHITE : 'transparent'),
      fontSize: '1em',
      borderRadius: 7.5,
      paddingBottom: 15,
      paddingTop: 10,
      paddingRight: 10,
      paddingLeft: 10,
      display: 'flex',
      flexDirection: props.icon ? 'row' : 'column',
      alignItems: props.icon ? 'flex-start' : flexAlignHandler(),
      justifyContent: 'space-between'
    },
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    }
  }, props.icon && React$4.createElement("div", {
    style: {
      width: 30,
      minWidth: 30,
      maxWidth: 30,
      height: 30,
      minHeight: 30,
      maxHeight: 30,
      marginRight: 10,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      marginTop: -7
    }
  }, React$4.createElement(Icon, {
    name: props.icon.name,
    height: props.icon.height,
    width: props.icon.width,
    color: props.icon.color,
    iconSet: props.icon.iconSet
  })), React$4.createElement("div", {
    style: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch'
    }
  }, props.image && React$4.createElement("div", {
    style: {
      marginBottom: 15,
      position: 'relative'
    }
  }, React$4.createElement("div", {
    style: {
      height: 150,
      width: '100%',
      backgroundImage: "url('".concat(props.image.src, "')"),
      backgroundSize: (_props$image$size = props.image.size) !== null && _props$image$size !== void 0 ? _props$image$size : 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      borderRadius: 7.5,
      position: 'relative',
      zIndex: 1
    }
  }), props.confetti && hover && React$4.createElement(motion.div, {
    style: {
      height: '100%',
      width: '100%',
      overflow: 'hidden',
      position: 'absolute',
      top: 0,
      left: 0
    }
  }, React$4.createElement(Confetti, {
    type: props.confetti.type,
    height: props.confetti.height,
    width: props.confetti.width,
    position: props.confetti.position,
    top: props.confetti.top,
    left: props.confetti.left,
    zIndex: props.confetti.zIndex,
    opacity: props.confetti.opacity,
    transition: props.confetti.transition
  }))), React$4.createElement("div", {
    style: {
      height: 'auto',
      display: 'flex',
      flexDirection: 'column',
      alignItems: flexAlignHandler(),
      justifyContent: 'flex-start'
    }
  }, props.title && React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'flex-start'
    }
  }, React$4.createElement(Text, {
    fontWeight: 700,
    color: Colors.GREY,
    fontSize: "1.1em",
    textAlign: props.align
  }, Array.isArray(props.title) ? _.apply(void 0, _toConsumableArray$5(props.title)) : props.title), props.suffix && React$4.createElement("div", {
    style: {
      height: 'auto',
      width: 'auto',
      backgroundColor: getColorScheme(props.suffix.colorScheme).delicate,
      paddingLeft: 6,
      paddingRight: 6,
      paddingTop: 2,
      paddingBottom: 2,
      marginLeft: 10,
      borderRadius: 5
    }
  }, React$4.createElement(Text, {
    color: getColorScheme(props.suffix.colorScheme).vibrant,
    fontSize: "0.9em"
  }, props.suffix.text))), props.description.text && React$4.createElement("div", {
    style: {
      marginTop: 10
    }
  }, React$4.createElement(Text, {
    fontWeight: 300,
    color: Colors.DARK_GREY,
    fontSize: "0.9em",
    textAlign: props.align,
    portableText: props.description.portableText
  }, Array.isArray(props.description.text) ? _.apply(void 0, _toConsumableArray$5(props.description.text)) : props.description.text)))), props.link && React$4.createElement("div", {
    style: {
      height: 'auto',
      width: '100%',
      marginTop: 10
    }
  }, React$4.createElement("a", {
    href: props.href,
    style: {
      fontSize: '1em',
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: props.align === 'center' ? flexAlignHandler() : 'space-between',
      position: 'relative',
      height: 'auto'
    }
  }, React$4.createElement(Text, {
    fontSize: "1em",
    color: Colors.BLUE,
    textAlign: props.align
  }, props.link.title), props.align !== 'center' && React$4.createElement("div", {
    style: {
      width: 20,
      height: 20,
      position: 'absolute',
      right: hover ? 0 : 30,
      opacity: hover ? 1 : 0,
      transition: 'opacity .2s linear, right .2s linear'
    }
  }, React$4.createElement(Icon, {
    name: "ArrowRight",
    height: 12,
    width: 12,
    color: Colors.BLUE,
    iconSet: "FA"
  })))));
}

function SubMenu$1(props) {
  var maxItems = 4;
  var ref = React$4.useRef(0);
  var _React$useState = React$4.useState([]),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      rows = _React$useState2[0],
      setRows = _React$useState2[1];
  var _React$useState3 = React$4.useState('100%'),
      _React$useState4 = _slicedToArray$5(_React$useState3, 2),
      width = _React$useState4[0],
      setWidth = _React$useState4[1];
  var _React$useState5 = React$4.useState('100%'),
      _React$useState6 = _slicedToArray$5(_React$useState5, 2),
      height = _React$useState6[0],
      setHeight = _React$useState6[1];
  React$4.useEffect(function () {
    var array = [];
    setRows(props.data);
    if (props.data !== undefined) {
      for (var i = 0; i < props.data.length; i += maxItems) {
        array.push(props.data.slice(i, i + maxItems));
      }
      setRows(array);
    }
  }, [props.data]);
  var getDimensions = function getDimensions() {
    if (ref.current.clientWidth !== null) setWidth(ref.current.clientWidth);
    if (ref.current.clientHeight !== null) setHeight(ref.current.clientHeight);
  };
  React$4.useEffect(function () {
    getDimensions();
  }, [width]);
  React$4.useEffect(function () {
    window.addEventListener('resize', getDimensions);
    return function () {
      window.removeEventListener('resize', getDimensions);
    };
  });
  return React$4.createElement(motion.div, {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'center',
      width: '100%',
      position: 'absolute',
      left: 0,
      top: 63,
      zIndex: 1
    },
    initial: {
      top: 83
    },
    animate: {
      top: 63
    },
    exit: {
      top: 83
    },
    transition: {
      duration: 0.2
    }
  }, React$4.createElement(motion.div, {
    onMouseEnter: props.onMouseEnter,
    onMouseLeave: props.onMouseLeave,
    style: {
      height: 'auto',
      width: '100%',
      paddingTop: 22,
      backgroundColor: 'transparent',
      maxWidth: props.maxWidth
    },
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: 0.2
    }
  }, React$4.createElement("div", {
    style: {
      height: 'auto',
      width: '100%',
      backgroundColor: Colors.WHITE,
      paddingTop: props.banner ? 0 : 15,
      paddingBottom: props.banner ? 0 : 15,
      paddingLeft: 15,
      paddingRight: props.banner ? 0 : 15,
      borderRadius: 10,
      border: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'space-between',
      justifyContent: 'flex-start',
      position: 'relative',
      boxShadow: "0px 3px 15px 2px ".concat(Colors.GREY, "25"),
      overflow: 'hidden'
    }
  }, React$4.createElement("div", {
    ref: ref,
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      width: '100%',
      position: 'relative'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'space-between',
      justifyContent: 'stretch',
      position: 'relative',
      width: props.banner ? '80%' : '100%',
      paddingTop: props.banner ? 15 : 0,
      paddingBottom: props.banner ? 15 : 0,
      height: '100%'
    }
  }, React$4.createElement(AnimatePresence, null, props.data && rows.map(function (columns, index) {
    return React$4.createElement("div", {
      key: index,
      style: {
        display: 'grid',
        gridTemplateColumns: "repeat(".concat(columns.length, ", minmax(0px, ").concat((width - 15 * (maxItems - 1)) / maxItems, "px))"),
        gridGap: 15,
        marginBottom: rows.length - 1 === index ? 0 : 15,
        width: '100%',
        paddingRight: props.banner ? 15 : 0,
        height: '100%'
      }
    }, columns.map(function (item, i) {
      return React$4.createElement(Item$2, {
        title: item.title,
        description: item.description,
        image: item.image,
        link: item.link,
        align: item.align,
        confetti: item.confetti,
        icon: item.icon,
        href: item.href,
        target: item.target,
        suffix: item.suffix,
        index: index,
        last: columns.length - 1 === i,
        length: columns.length
      });
    }));
  }))), props.banner && React$4.createElement("div", {
    style: {
      width: '20%',
      height: '100%',
      minHeight: height,
      position: 'relative',
      display: 'flex',
      flexDirection: 'column'
    }
  }, props.banner)))));
}

var LinkContent = function LinkContent(_ref) {
  var data = _ref.data;
  return React$4.createElement("div", {
    style: {
      height: 40,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      borderBottom: "solid 2px ".concat(data.active ? Colors.BLUE : 'transparent')
    }
  }, React$4.createElement(Text, {
    fontSize: "1em"
  }, data.text));
};
function HeaderLink(props) {
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement(React$4.Fragment, null, React$4.createElement("div", {
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    style: {
      paddingLeft: 15,
      paddingRight: 15,
      height: '100%'
    }
  }, props.href !== undefined ? React$4.createElement("a", {
    className: "Hover HeaderLink DisableSelection",
    href: props.href,
    onClick: props.onClick !== undefined && props.onClick,
    rel: props.rel,
    style: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative'
    }
  }, React$4.createElement(LinkContent, {
    data: props
  })) : React$4.createElement("button", {
    className: "Hover HeaderLink DisableSelection",
    type: "button",
    onClick: props.onClick && props.onClick,
    style: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      backgroundColor: 'transparent',
      border: 'solid 0px transparent',
      fontSize: '1em',
      padding: 0
    }
  }, React$4.createElement(LinkContent, {
    data: props
  }))), React$4.createElement(AnimatePresence, null, props.subMenu && hover && React$4.createElement(SubMenu$1, {
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    maxWidth: props.maxWidth,
    data: props.subMenu,
    title: props.text,
    banner: props.subMenuBanner
  })));
}

function SubMenuItem(props) {
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("a", {
    href: props.data.href,
    style: {
      height: 50,
      minHeight: 50,
      width: '100%',
      borderLeft: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      backgroundColor: hover ? Colors.LIGHT_GREY : 'transparent',
      paddingRight: 20
    },
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    }
  }, React$4.createElement("div", {
    style: {
      height: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, React$4.createElement("div", {
    style: {
      height: 2,
      width: 15,
      backgroundColor: Colors.MEDIUM_WHITE,
      marginRight: 10
    }
  }), React$4.createElement(Text, null, Array.isArray(props.data.title) ? _.apply(void 0, _toConsumableArray$5(props.data.title)) : props.data.title), props.data.suffix && React$4.createElement("div", {
    style: {
      height: 'auto',
      width: 'auto',
      backgroundColor: getColorScheme(props.data.suffix.colorScheme).delicate,
      paddingLeft: 6,
      paddingRight: 6,
      paddingTop: 2,
      paddingBottom: 2,
      marginLeft: 10,
      borderRadius: 5
    }
  }, React$4.createElement(Text, {
    color: getColorScheme(props.data.suffix.colorScheme).vibrant,
    fontSize: "0.9em"
  }, props.data.suffix.text))), React$4.createElement(AnimatePresence, null, hover && React$4.createElement(motion.div, {
    style: {
      height: '100%',
      width: 50,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-end'
    },
    initial: {
      opacity: 0,
      marginRight: 30
    },
    animate: {
      opacity: 1,
      marginRight: 0
    },
    exit: {
      opacity: 0,
      marginRight: 30
    }
  }, React$4.createElement(Icon, {
    name: "ArrowRight",
    height: 15,
    width: 15,
    color: Colors.DARK_GREY,
    iconSet: "FA"
  })))));
}

function SubMenu(props) {
  return React$4.createElement("div", {
    style: {
      width: '100%',
      height: props.open ? props.data.length * 50 + 20 : 0,
      paddingLeft: 23,
      borderBottom: props.open && "solid 2px ".concat(Colors.LIGHT_WHITE),
      overflow: 'hidden',
      transition: 'all .2s linear'
    }
  }, React$4.createElement("div", {
    style: {
      paddingTop: 10,
      paddingBottom: 10,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start'
    }
  }, props.data.map(function (item) {
    return React$4.createElement(SubMenuItem, {
      key: item.id,
      data: item
    });
  })));
}

var ButtonContent = function ButtonContent(_ref) {
  var data = _ref.data,
      colorScheme = _ref.colorScheme,
      subMenuOpen = _ref.subMenuOpen,
      hover = _ref.hover;
  return React$4.createElement(React$4.Fragment, null, data.icon && React$4.createElement("div", {
    style: {
      height: 30,
      width: 30,
      marginRight: 10,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, React$4.createElement(Icon, {
    name: data.icon.name,
    width: data.icon.width,
    height: data.icon.height,
    color: data.active || hover ? colorScheme.vibrant : data.icon.color,
    iconSet: data.icon.iconSet
  })), React$4.createElement("div", {
    style: {
      overflowWrap: 'break-word',
      hyphens: 'manual',
      inlineSize: '100%'
    }
  }, React$4.createElement(Text, {
    fontWeight: data.active ? 500 : 300
  }, data.title)), data.subMenu && React$4.createElement("div", {
    style: {
      height: 50,
      width: 50,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: subMenuOpen ? 'flex-start' : 'flex-end',
      transform: "rotate(".concat(subMenuOpen ? 180 : 0, "deg)")
    }
  }, React$4.createElement(Icon, {
    name: "AngleDown",
    height: 25,
    width: 25,
    color: Colors.GREY,
    iconSet: "FA"
  })));
};
function Buttons(props) {
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  var _React$useState3 = React$4.useState(false),
      _React$useState4 = _slicedToArray$5(_React$useState3, 2),
      subMenuOpen = _React$useState4[0],
      setSubMenuOpen = _React$useState4[1];
  return props.data.href && props.data.subMenu !== null && !props.data.onClick ? React$4.createElement("a", {
    href: props.data.href,
    rel: props.data.rel,
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    style: {
      minHeight: 60,
      height: 'auto',
      width: '100%',
      borderBottom: "solid 2px ".concat(Colors.LIGHT_WHITE),
      borderLeft: 'solid 0px transparent',
      borderRight: 'solid 0px transparent',
      borderTop: 'solid 0px transparent',
      backgroundColor: hover ? Colors.LIGHT_GREY : Colors.WHITE,
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'noWrap',
      alignItems: 'center',
      paddingLeft: 10,
      paddingRight: 15,
      fontSize: '1em',
      paddingTop: 5,
      paddingBottom: 5
    }
  }, React$4.createElement(ButtonContent, {
    data: props.data,
    colorScheme: props.colorScheme,
    hover: hover,
    subMenuOpen: subMenuOpen
  })) : React$4.createElement(React$4.Fragment, null, React$4.createElement("button", {
    type: "button",
    onClick: function onClick() {
      if (props.data.subMenu) {
        setSubMenuOpen(!subMenuOpen);
      } else {
        props.data.onClick();
        props.onClose();
      }
    },
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    className: "Hover DisableSelection",
    style: {
      minHeight: 60,
      height: 'auto',
      width: '100%',
      borderBottom: "solid 2px ".concat(Colors.LIGHT_WHITE),
      borderLeft: 'solid 0px transparent',
      borderRight: 'solid 0px transparent',
      borderTop: 'solid 0px transparent',
      backgroundColor: hover ? Colors.LIGHT_GREY : Colors.WHITE,
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'noWrap',
      alignItems: 'center',
      paddingLeft: 10,
      paddingRight: 15,
      fontSize: '1em',
      paddingTop: 5,
      paddingBottom: 5
    }
  }, React$4.createElement(ButtonContent, {
    data: props.data,
    colorScheme: props.colorScheme,
    hover: hover,
    subMenuOpen: subMenuOpen
  })), props.data.subMenu && React$4.createElement(SubMenu, {
    data: props.data.subMenu,
    open: subMenuOpen
  }));
}

var Button = function Button(_ref) {
  var _Colors$GREY;
  var data = _ref.data;
  var _React$useState = React$4.useState(),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("button", {
    type: "button",
    className: "".concat(data.onClick || data.href ? 'Hover' : '', " DisableSelection"),
    onClick: function onClick() {
      if (data.onClick) data.onClick();
    },
    onMouseEnter: function onMouseEnter() {
      if (data.onClick || data.href) setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      if (data.onClick || data.href) setHover(false);
    },
    style: {
      height: 40,
      width: '100%',
      backgroundColor: Colors.WHITE,
      border: 'solid 0px transparent',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      paddingLeft: 15,
      color: data.onClick || data.href ? (_Colors$GREY = Colors.GREY) !== null && _Colors$GREY !== void 0 ? _Colors$GREY : data.color : Colors.DARK_GREY
    }
  }, data.icon && React$4.createElement("div", {
    style: {
      height: 30,
      width: 'auto',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      marginRight: 7.5
    }
  }, React$4.createElement(Icon, {
    name: data.icon.name,
    width: data.icon.width,
    height: data.icon.height,
    color: data.icon.color,
    iconSet: data.icon.iconSet
  })), React$4.createElement(Text, {
    color: data.onClick || data.href ? data.color : Colors.DARK_GREY,
    textDecoration: hover ? 'underline' : 'none'
  }, data.title), data.suffix && React$4.createElement("div", {
    style: {
      height: 30,
      width: 30,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, React$4.createElement(Icon, {
    name: data.suffix.name,
    width: data.suffix.width,
    height: data.suffix.height,
    color: data.suffix.color,
    iconSet: data.suffix.iconSet
  })));
};
function Links(props) {
  var _props$data$target;
  return props.data.href ? React$4.createElement("a", {
    href: props.data.href,
    target: (_props$data$target = props.data.target) !== null && _props$data$target !== void 0 ? _props$data$target : '_self'
  }, React$4.createElement(Button, {
    data: props.data
  })) : React$4.createElement(Button, {
    data: props.data
  });
}

function TopButton(props) {
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("button", {
    type: "button",
    className: "Hover DisableSelection",
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    onClick: function onClick() {
      props.onClick();
    },
    style: {
      backgroundColor: Colors.WHITE,
      height: 45,
      width: '100%',
      border: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      borderRadius: 7,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      transition: 'all 0.3s ease-in-out'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center'
    }
  }, props.data.icon && React$4.createElement("div", {
    style: {
      height: 40,
      width: 30,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, React$4.createElement(Icon, {
    name: props.data.icon.name,
    width: props.data.icon.width,
    height: props.data.icon.height,
    color: hover || props.open ? Colors.GREY : props.data.icon.color,
    iconSet: props.data.iconSet
  })), React$4.createElement(Text, {
    color: hover || props.open ? Colors.GREY : Colors.MEDIUM_GREY
  }, props.data.title)), props.data.dropdownMenu && React$4.createElement("div", {
    style: {
      width: 27,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      transform: "rotate(".concat(props.open ? '180deg' : '0', ")"),
      paddingTop: props.open ? 0 : 3,
      paddingBottom: props.open ? 2 : 0
    }
  }, React$4.createElement(Icon, {
    name: "AngleDown",
    width: 20,
    height: 20,
    color: hover || props.open ? Colors.GREY : Colors.MEDIUM_GREY,
    iconSet: "FA"
  })));
}

function Item$1(props) {
  var _props$onClick, _props$icon$iconSet, _props$color, _props$color2;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("button", {
    onMouseEnter: function onMouseEnter() {
      return props.disabled ? null : setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return props.disabled ? null : setHover(false);
    },
    type: "button",
    className: "Hover",
    onClick: props.disabled ? null : props.onClick,
    style: {
      height: '100%',
      width: '100%',
      backgroundColor: hover ? Colors.LIGHT_GREY : 'transparent',
      border: 'solid 0px transparent',
      fontSize: '1em',
      padding: 0,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'left',
      alignItems: 'center',
      paddingLeft: 15,
      paddingRight: 15,
      position: 'relative'
    }
  }, (props.type === 'radio' || props.type === 'checkbox') && React$4.createElement("span", {
    style: {
      marginTop: -0.7
    }
  }, React$4.createElement(Inputs, {
    type: props.type,
    selected: props.selected,
    onClick: (_props$onClick = props.onClick) !== null && _props$onClick !== void 0 ? _props$onClick : null,
    disabled: props.disabled
  })), props.icon && React$4.createElement("span", {
    style: {
      marginTop: 2,
      paddingRight: 7
    }
  }, React$4.createElement(Icon, {
    name: props.icon.name,
    height: props.icon.height,
    width: props.icon.width,
    color: props.disabled ? Colors.MEDIUM_GREY : Colors.GREY,
    iconSet: (_props$icon$iconSet = props.icon.iconSet) !== null && _props$icon$iconSet !== void 0 ? _props$icon$iconSet : 'FA'
  })), React$4.createElement(Text, {
    fontSize: "1.1em",
    fontWeight: 300,
    color: props.disabled ? Colors.MEDIUM_GREY : (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY
  }, props.title), React$4.createElement(AnimatePresence, null, hover && React$4.createElement(motion.div, {
    style: {
      position: 'absolute',
      paddingTop: 3
    },
    initial: {
      right: 35,
      opacity: 0
    },
    animate: {
      right: 15,
      opacity: 1
    },
    exit: {
      right: 35,
      opacity: 0
    },
    transition: {
      duration: 0.2
    }
  }, React$4.createElement(Icon, {
    name: "ArrowRight",
    width: 15,
    height: 15,
    color: (_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : Colors.GREY
  }))));
}

function HeaderSideBar(props) {
  var items = props.items === undefined ? [] : props.items;
  var links = props.links === undefined ? [] : props.links;
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      dropdownMenu = _React$useState2[0],
      setDropdownMenu = _React$useState2[1];
  return React$4.createElement("div", {
    style: {
      height: items.length < 1 ? 78 : '100dvh',
      minHeight: items.length < 1 ? 78 : '100vh',
      width: '100%',
      backgroundColor: Colors.WHITE,
      positon: 'relative'
    }
  }, React$4.createElement("div", {
    style: {
      height: items.length < 1 ? 78 : 80,
      width: '80%',
      backgroundColor: Colors.WHITE,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      paddingLeft: 15,
      paddingRight: 15
    }
  }, props.topButton && React$4.createElement(TopButton, {
    data: props.topButton,
    onClick: function onClick() {
      if (props.topButton.dropdownMenu) {
        setDropdownMenu(!dropdownMenu);
      }
    },
    open: dropdownMenu
  })), React$4.createElement("div", {
    style: {
      width: '100%',
      marginTop: -2,
      borderBottom: "solid ".concat(items < 1 ? 0 : 2, "px ").concat(Colors.MEDIUM_WHITE)
    }
  }), React$4.createElement(AnimatePresence, null, dropdownMenu && React$4.createElement(motion.div, {
    style: {
      width: items.length < 1 ? 'calc(100% + 2px)' : '100%',
      backgroundColor: Colors.WHITE,
      position: 'absolute',
      zIndex: 1,
      overflowY: 'auto',
      overflowX: 'hidden',
      height: 'calc(100dvh - 80px)',
      borderLeft: items.length < 1 ? "solid 2px ".concat(Colors.MEDIUM_WHITE) : 'solid 0px transparent',
      borderTop: items.length < 1 ? "solid 2px ".concat(Colors.MEDIUM_WHITE) : 'solid 0px transparent'
    },
    initial: {
      right: '-100%'
    },
    animate: {
      right: 0
    },
    exit: {
      right: '-100%'
    },
    transition: {
      ease: 'easeInOut',
      duration: 0.3
    }
  }, props.topButton.dropdownMenu.map(function (e) {
    return React$4.createElement("div", {
      key: e.id,
      style: {
        height: 60,
        width: '100%',
        borderBottom: "solid 2px ".concat(Colors.LIGHT_WHITE),
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start'
      }
    }, React$4.createElement(Item$1, {
      title: e.title,
      type: "radio",
      selected: e.selected,
      onClick: function onClick() {
        e.onClick();
        setDropdownMenu(false);
      }
    }));
  }))), React$4.createElement("div", {
    style: {
      width: '100%',
      height: links.length < 1 && items.length < 1 ? 0 : 'calc(100dvh - 80px)',
      backgroundColor: Colors.WHITE,
      overflowY: 'auto',
      overflowX: 'hidden',
      zIndex: 0,
      position: 'relative',
      transition: 'all 0.3s linear',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: links.length > 1 && items.length < 1 ? 'flex-end' : links.length > 0 && items.length > 0 ? 'space-between' : 'flex-start'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      width: '100%'
    }
  }, props.items !== undefined && items.filter(function (_ref) {
    var sideNav = _ref.sideNav;
    return sideNav;
  }).map(function (e) {
    var _e$colorScheme;
    return React$4.createElement(Buttons, {
      key: e.id,
      data: e,
      colorScheme: getColorScheme("".concat((_e$colorScheme = e.colorScheme) !== null && _e$colorScheme !== void 0 ? _e$colorScheme : 'blue')),
      onClose: props.onClose
    });
  })), props.links && React$4.createElement("div", {
    style: {
      marginTop: 15,
      marginBottom: 15
    }
  }, links.map(function (e) {
    return React$4.createElement(Links, {
      key: e.id,
      data: e
    });
  }))));
}

function SideNavButton(props) {
  return React$4.createElement("button", {
    type: "button",
    className: "Hover",
    onClick: props.onClick,
    style: {
      height: '2rem',
      width: '2rem',
      position: 'absolute',
      zIndex: 2147483005,
      right: 1,
      backgroundColor: 'transparent',
      border: 'solid 0px transparent',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-around',
      alignItems: 'center',
      flexWrap: 'noWrap',
      padding: 0
    }
  }, React$4.createElement("div", {
    style: {
      width: 32.5,
      height: 2,
      backgroundColor: Colors.GREY,
      transformOrigin: 1,
      transition: 'all .3s linear',
      transform: props.active ? 'rotate(45deg)' : 'rotate(0deg)'
    }
  }), React$4.createElement("div", {
    style: {
      width: 32.5,
      height: 2,
      backgroundColor: Colors.GREY,
      transformOrigin: 1,
      transition: 'all .3s linear',
      transform: props.active ? 'translateX(100%)' : 'translateX(0)',
      opacity: props.active ? 0 : 1.0
    }
  }), React$4.createElement("div", {
    style: {
      width: 32.5,
      height: 2,
      backgroundColor: Colors.GREY,
      transformOrigin: 1,
      transition: 'all .3s linear',
      transform: props.active ? 'rotate(-45deg)' : 'rotate(0deg)'
    }
  }));
}

function Header(props) {
  var _props$breakpoint, _props$logoURL, _props$logoTarget;
  var size = useDimensions();
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var contentRef = React$4.useRef(0);
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      sideNav = _React$useState2[0],
      setSideNav = _React$useState2[1];
  var _React$useState3 = React$4.useState([]),
      _React$useState4 = _slicedToArray$5(_React$useState3, 2),
      sortedOnId = _React$useState4[0],
      setSortedOnId = _React$useState4[1];
  var _React$useState5 = React$4.useState('100%'),
      _React$useState6 = _slicedToArray$5(_React$useState5, 2),
      contentWidth = _React$useState6[0],
      setContentWidth = _React$useState6[1];
  var sideNavBreakpoint = (_props$breakpoint = props.breakpoint) !== null && _props$breakpoint !== void 0 ? _props$breakpoint : Breakpoint.lg;
  React$4.useEffect(function () {
    if (props.items) {
      var sortedItems = props.items.sort(function (a) {
        return a.type === 'link' ? -1 : 1;
      });
      setSortedOnId(sortedItems.sort(function (a, b) {
        return a.id - b.id;
      }));
    }
  }, [props.items]);
  React$4.useEffect(function () {
    document.querySelector('body').style.overflow = sideNav && size.width < sideNavBreakpoint ? 'hidden' : 'auto';
  });
  var getWidth = function getWidth() {
    if (contentRef.current !== null) {
      setContentWidth(contentRef.current.clientWidth);
    }
  };
  React$4.useEffect(function () {
    getWidth();
  }, [contentWidth]);
  React$4.useEffect(function () {
    window.addEventListener('resize', getWidth);
    return function () {
      return window.removeEventListener('resize', getWidth);
    };
  }, []);
  return React$4.createElement("div", {
    style: {
      position: 'fixed',
      height: 80,
      width: '100%',
      backgroundColor: Colors.WHITE,
      borderBottom: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      zIndex: 2147483003
    }
  }, React$4.createElement(MainContainer$1, null, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: Colors.WHITE,
      height: 78,
      width: '100%',
      position: 'relative'
    }
  }, React$4.createElement("a", {
    href: (_props$logoURL = props.logoURL) !== null && _props$logoURL !== void 0 ? _props$logoURL : 'https://www.bluecurrent.nl',
    target: (_props$logoTarget = props.logoTarget) !== null && _props$logoTarget !== void 0 ? _props$logoTarget : '_blank',
    className: "Hover",
    style: {
      minWidth: size.width < 360 ? 160 : 204,
      maxWidth: size.width < 360 ? 160 : 204,
      width: size.width < 360 ? 160 : 204,
      height: 60,
      maxHeight: 60,
      minHeight: 60,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    rel: "noreferrer",
    "aria-label": _('blueCurrent', {
      ns: 'branding'
    })
  }, React$4.createElement(Logo, {
    type: "Normal",
    height: 60,
    width: size.width < 360 ? 160 : 204
  }), props.logoSubfix && size.width >= Breakpoint.xs && React$4.createElement("div", {
    style: {
      marginTop: -7.5,
      marginLeft: 10,
      position: 'absolute',
      left: size.width < 360 ? 40 : 204,
      transform: 'rotate(-5deg)',
      bottom: size.width < 360 ? 10 : 'initial'
    }
  }, React$4.createElement(Text, {
    fontFamily: "Caveat",
    fontSize: "1.3em",
    color: Colors.BLUE,
    fontWeight: 500
  }, props.logoSubfix))), size.width >= sideNavBreakpoint ? React$4.createElement("div", {
    style: {
      width: 'auto',
      height: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center'
    }
  }, sortedOnId.filter(function (_ref) {
    var header = _ref.header;
    return header;
  }).map(function (e, i) {
    return React$4.createElement(React$4.Fragment, {
      key: i
    }, e.type === 'link' && React$4.createElement("div", {
      style: {
        height: '100%'
      }
    }, React$4.createElement(HeaderLink, {
      text: e.title,
      onClick: e.onClick,
      href: e.href,
      subMenu: e.subMenu,
      subMenuBanner: e.subMenuBanner,
      maxWidth: contentWidth,
      active: e.active
    })), e.type === 'button' && React$4.createElement("div", {
      style: {
        marginLeft: 30
      }
    }, React$4.createElement(Buttons$1, {
      text: e.title,
      colorScheme: e.colorScheme,
      onClick: e.onClick,
      fontSize: "1em",
      disabled: e.disabled,
      loading: e.loading
    })), e.type === 'component' && React$4.createElement("div", null, e.component));
  })) : (props.items || props.links || props.topButton) && React$4.createElement("div", {
    style: {
      height: 60,
      width: 60,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, React$4.createElement(SideNavButton, {
    onClick: function onClick() {
      setSideNav(!sideNav);
    },
    active: sideNav
  })))), React$4.createElement(AnimatePresence, null, size.width < sideNavBreakpoint && sideNav && React$4.createElement(motion.div, {
    style: {
      height: props.items.length < 1 ? 78 : props.globalHeader ? 'calc(100vh - 45px)' : '100vh',
      width: size.width < 360 ? '100%' : 350,
      backgroundColor: Colors.WHITE,
      borderLeft: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      position: 'fixed',
      zIndex: 2147483003,
      right: 0,
      top: props.globalHeader ? 45 : 0,
      transition: 'top .2s linear'
    },
    initial: {
      right: '-100%'
    },
    animate: {
      right: 0
    },
    exit: {
      right: '-100%'
    },
    transition: {
      duration: 0.3,
      ease: 'easeInOut'
    }
  }, React$4.createElement(HeaderSideBar, {
    items: props.items,
    links: props.links,
    topButton: props.topButton,
    onClose: function onClose() {
      setSideNav(false);
    }
  }))), React$4.createElement(AnimatePresence, null, size.width < sideNavBreakpoint && sideNav && React$4.createElement(motion.div, {
    onClick: function onClick() {
      setSideNav(false);
    },
    style: {
      height: '100dvh',
      minHeight: '100vh',
      width: '100%',
      backgroundColor: Colors.GREY,
      position: 'fixed',
      zIndex: 2147483002
    },
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 0.2
    },
    exit: {
      opacity: 0
    }
  })), React$4.createElement(MainContainer, null, React$4.createElement("div", {
    ref: contentRef,
    style: {
      width: '100%',
      height: 0
    }
  })));
}

function TextBlock(props) {
  var _props$breakpoint, _props$align, _props$title$fontSize, _props$title$fontSize2, _props$align2, _props$align3;
  var size = useDimensions();
  var breakpoint = (_props$breakpoint = props.breakpoint) !== null && _props$breakpoint !== void 0 ? _props$breakpoint : Breakpoint.xs;
  return React$4.createElement("div", {
    style: {
      height: 'auto',
      width: '100%'
    }
  }, React$4.createElement("div", {
    style: {
      paddingTop: 15
    }
  }, React$4.createElement(Title, {
    textAlign: (_props$align = props.align) !== null && _props$align !== void 0 ? _props$align : 'left',
    fontSize: props.align === 'center' ? (_props$title$fontSize = props.title.fontSize) !== null && _props$title$fontSize !== void 0 ? _props$title$fontSize : '2.8em' : (_props$title$fontSize2 = props.title.fontSize) !== null && _props$title$fontSize2 !== void 0 ? _props$title$fontSize2 : '2.5em',
    fontFamily: props.title.fontFamily,
    fontWeight: props.title.fontWeight,
    color: props.title.color,
    portableText: props.title.portableText,
    heading: props.title.heading
  }, props.title.content)), React$4.createElement("div", {
    style: {
      paddingTop: 15,
      paddingBottom: 15
    }
  }, React$4.createElement(Text, {
    textAlign: (_props$align2 = props.align) !== null && _props$align2 !== void 0 ? _props$align2 : 'left',
    lineHeight: 1.3,
    color: props.text.color,
    portableText: props.text.portableText
  }, props.text.content)), props.buttons && React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: props.buttons && props.buttons.length > 1 && size.width < breakpoint ? 'column' : 'row',
      justifyContent: (_props$align3 = props.align) !== null && _props$align3 !== void 0 ? _props$align3 : 'flex-start',
      flexWrap: 'wrap',
      alignItems: 'center',
      marginTop: 15
    }
  }, props.buttons.map(function (e) {
    return React$4.createElement("div", {
      key: e.id,
      style: {
        width: 'auto',
        marginRight: size.width < breakpoint || props.buttons.length === e.id ? 0 : 15,
        marginBottom: props.buttons.length === e.id ? 0 : 15
      }
    }, React$4.createElement(Buttons$1, {
      id: e.customId,
      text: e.text,
      onClick: e.onClick,
      colorScheme: e.colorScheme
    }));
  })));
}

function Small(props) {
  var size = useDimensions();
  return React$4.createElement("div", {
    style: {
      height: 'auto',
      width: '100%',
      overflow: 'hidden'
    }
  }, React$4.createElement("div", {
    style: {
      height: 'auto',
      width: '100%',
      position: 'relative'
    }
  }, React$4.createElement("div", {
    style: {
      width: '100%',
      height: 'auto',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-end',
      position: 'relative'
    }
  }, React$4.createElement("div", {
    style: {
      minHeight: 230,
      minWidth: 230,
      height: 230,
      width: 230,
      position: 'relative',
      zIndex: 3
    }
  }, React$4.createElement(Image, {
    src: props.src,
    wrapper: "Figure",
    id: "ContactCardBig"
  })), React$4.createElement("div", {
    style: {
      height: '50%',
      width: '100%',
      backgroundColor: Colors.GREEN,
      position: 'absolute',
      zIndex: 0,
      borderTopLeftRadius: 15,
      borderTopRightRadius: 15
    }
  })), React$4.createElement("div", {
    style: {
      height: 'auto',
      width: '100%',
      backgroundColor: Colors.GREEN,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 15,
      borderBottomRightRadius: 15,
      borderTopRightRadius: 0,
      paddingLeft: 20,
      paddingRight: 20,
      paddingBottom: 20,
      position: 'relative',
      zIndex: 1
    }
  }, React$4.createElement("div", {
    style: {
      position: 'relative',
      zIndex: 2
    }
  }, props.children), size.width >= Breakpoint.xs && React$4.createElement("div", {
    style: {
      position: 'absolute',
      height: '100%',
      width: '100%',
      borderRadius: 15,
      top: 0,
      zIndex: 1
    }
  }, React$4.createElement(Confetti, {
    type: "DotsPath",
    height: 700,
    width: 700,
    color: Colors.WHITE,
    right: -250,
    top: -150,
    position: "absolute",
    transform: "scaleX(-1) rotate(60deg)",
    opacity: 0.5
  })))));
}

function Medium(props) {
  var contentRef = React$4.useRef(0);
  var _React$useState = React$4.useState(0),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      height = _React$useState2[0],
      setHeight = _React$useState2[1];
  var getHeight = function getHeight() {
    var _contentRef$current;
    if ((_contentRef$current = contentRef.current) !== null && _contentRef$current !== void 0 && _contentRef$current.offsetHeight) {
      setHeight(contentRef.current.offsetHeight);
    }
  };
  React$4.useEffect(function () {
    getHeight();
  }, [height]);
  React$4.useEffect(function () {
    window.addEventListener('resize', getHeight);
    return function () {
      window.removeEventListener('resize', getHeight);
    };
  }, []);
  return React$4.createElement("div", {
    style: {
      width: '100%',
      height: 'auto',
      position: 'relative'
    }
  }, React$4.createElement("div", {
    style: {
      width: '30%',
      height: height,
      position: 'absolute',
      zIndex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, React$4.createElement(Image, {
    src: props.src,
    wrapper: "Figure",
    id: "ContactCardMedium"
  })), React$4.createElement("div", {
    style: {
      height: height,
      width: '85%',
      backgroundColor: Colors.GREEN,
      borderRadius: 15,
      position: 'relative',
      marginLeft: '15%',
      zIndex: 0,
      overflow: 'hidden'
    }
  }, React$4.createElement("div", {
    style: {
      position: 'relative',
      height: '100%',
      width: '100%',
      borderRadius: 15
    }
  }, React$4.createElement(Confetti, {
    type: "DotsPath",
    height: 700,
    width: 700,
    color: Colors.WHITE,
    right: -400,
    top: -250,
    position: "absolute",
    transform: "scaleX(-1)",
    opacity: 0.5
  }))), React$4.createElement("div", {
    ref: contentRef,
    style: {
      height: 'auto',
      width: '100%',
      position: 'absolute',
      top: 0,
      padding: 20,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      zIndex: 2
    }
  }, props.children));
}

function Item(props) {
  return props.item.href ? React$4.createElement("a", {
    className: "Hover",
    href: props.item.href
  }, React$4.createElement(Text, {
    color: Colors.WHITE,
    textAlign: "center",
    fontWeight: props.fontWeight,
    portableText: props.item.portableText
  }, props.item.text)) : React$4.createElement(Text, {
    color: Colors.WHITE,
    textAlign: "center",
    fontWeight: props.fontWeight,
    portableText: props.item.portableText
  }, props.item.text);
}

function Big(props) {
  var size = useDimensions();
  return React$4.createElement("div", {
    style: {
      height: 230,
      width: '100%',
      paddingTop: 65
    }
  }, React$4.createElement("div", {
    style: {
      height: 100,
      width: size.width < Breakpoint.xxl ? '100%' : '90%',
      marginLeft: size.width < Breakpoint.xxl ? 0 : '5%',
      marginRight: size.width < Breakpoint.xxl ? 0 : '5%',
      backgroundColor: Colors.GREEN,
      borderRadius: 67.5,
      position: 'relative'
    }
  }, React$4.createElement("div", {
    style: {
      position: 'relative',
      zIndex: 2,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: 100
    }
  }, React$4.createElement("div", {
    style: {
      width: '100%',
      paddingLeft: 50,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, props.text && React$4.createElement(React$4.Fragment, null, React$4.createElement(Item, {
    item: props.text.topLeft
  }), React$4.createElement("div", {
    style: {
      paddingTop: 10
    }
  }, React$4.createElement(Item, {
    item: props.text.bottomLeft
  })))), React$4.createElement("div", {
    style: {
      minHeight: 230,
      minWidth: 230,
      height: 230,
      width: 230
    }
  }, React$4.createElement(Image, {
    src: props.src,
    wrapper: "Figure",
    id: "ContactCardBig"
  })), React$4.createElement("address", {
    style: {
      width: '100%',
      paddingRight: 50,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, props.text && React$4.createElement(React$4.Fragment, null, React$4.createElement(Item, {
    item: props.text.topRight
  }), React$4.createElement("div", {
    style: {
      paddingTop: 10
    }
  }, React$4.createElement(Item, {
    item: props.text.bottomRight
  }))))), React$4.createElement("div", {
    style: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      zIndex: 1,
      borderRadius: 67.5,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden'
    }
  }, React$4.createElement(Confetti, {
    type: "DotsPath",
    height: 700,
    width: 700,
    color: Colors.WHITE,
    opacity: 0.5,
    marginLeft: 90
  }))));
}

function Content(props) {
  return React$4.createElement(React$4.Fragment, null, props.text && React$4.createElement(React$4.Fragment, null, React$4.createElement(Item, {
    item: props.text.topLeft,
    fontWeight: 500
  }), React$4.createElement("div", {
    style: {
      marginTop: 10
    }
  }, React$4.createElement(Item, {
    item: props.text.bottomLeft,
    fontWeight: 500
  }))), React$4.createElement("hr", {
    style: {
      height: 0,
      border: "solid 1px ".concat(Colors.LIGHT_GREEN),
      width: '25%',
      color: Colors.LIGHT_GREEN,
      marginTop: 15,
      marginBottom: 15
    }
  }), React$4.createElement("address", null, props.text && React$4.createElement(React$4.Fragment, null, React$4.createElement(Item, {
    item: props.text.topRight
  }), React$4.createElement("div", {
    style: {
      marginTop: 10
    }
  }, React$4.createElement(Item, {
    item: props.text.bottomRight
  })))), props.buttons && React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: 20
    }
  }, props.buttons.map(function (e) {
    return React$4.createElement("div", {
      key: e.id,
      style: {
        marginRight: 7.5,
        marginLeft: 7.5,
        width: 'auto'
      }
    }, React$4.createElement(Buttons$1, {
      text: e.text,
      onClick: e.onClick,
      colorScheme: e.colorScheme
    }));
  })));
}

function ContactCard(props) {
  var _Breakpoint$sm, _Breakpoint$md, _Breakpoint$lg;
  var size = useDimensions();
  var breakpoints = {
    small: (_Breakpoint$sm = Breakpoint.sm) !== null && _Breakpoint$sm !== void 0 ? _Breakpoint$sm : props.breakpoints.small,
    medium: (_Breakpoint$md = Breakpoint.md) !== null && _Breakpoint$md !== void 0 ? _Breakpoint$md : props.breakpoints.medium,
    big: (_Breakpoint$lg = Breakpoint.lg) !== null && _Breakpoint$lg !== void 0 ? _Breakpoint$lg : props.breakpoints.big
  };
  var renderContactCard = function renderContactCard() {
    if (size.width < breakpoints.small) {
      return React$4.createElement(Small, {
        src: props.src
      }, React$4.createElement(Content, {
        text: props.text,
        buttons: props.buttons,
        portableText: props.portableText
      }));
    }
    if (size.width >= breakpoints.small && size.width < breakpoints.medium) {
      return React$4.createElement(Medium, {
        src: props.src
      }, React$4.createElement(Content, {
        text: props.text,
        buttons: props.buttons,
        portableText: props.portableText
      }));
    }
    if (size.width >= breakpoints.medium && size.width < breakpoints.big) {
      return React$4.createElement(Big, {
        text: props.text,
        src: props.src,
        portableText: props.portableText
      });
    }
    return React$4.createElement(Big, {
      text: props.text,
      src: props.src,
      portableText: props.portableText
    });
  };
  return renderContactCard();
}

function AddressLink(props) {
  var size = useDimensions();
  var _React$useState = React$4.useState(false),
      _React$useState2 = _slicedToArray$5(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];
  return React$4.createElement("a", {
    href: props.data.href,
    onMouseEnter: function onMouseEnter() {
      setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      setHover(false);
    },
    style: {
      paddingTop: 10,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: size.width < Breakpoint.md ? 'center' : 'flex-start'
    }
  }, React$4.createElement("div", {
    style: {
      height: 20,
      width: 20,
      marginRight: 10,
      transform: props.data.icon.name === 'Phone' && hover ? 'rotate(10deg)' : 'rotate(0deg)'
    }
  }, props.data.icon.name === 'Envelope' && hover ? React$4.createElement("div", {
    style: {
      marginTop: -2.55
    }
  }, React$4.createElement(Icon, {
    name: "EnvelopeOpen",
    height: props.data.icon.height,
    width: props.data.icon.width,
    color: props.data.icon.color,
    iconSet: props.data.icon.iconSet
  })) : React$4.createElement(Icon, {
    name: props.data.icon.name,
    height: props.data.icon.height,
    width: props.data.icon.width,
    color: props.data.icon.color,
    iconSet: props.data.icon.iconSet
  })), React$4.createElement(Text, {
    color: Colors.GREY,
    fontSize: "1.1em"
  }, props.data.text));
}
function Contact() {
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var size = useDimensions();
  var _React$useState3 = React$4.useState('nl'),
      _React$useState4 = _slicedToArray$5(_React$useState3, 2),
      tld = _React$useState4[0],
      setTLD = _React$useState4[1];
  React$4.useEffect(function () {
    var hostname = document.location.hostname.split('.');
    setTLD(hostname[hostname.length - 1]);
  }, []);
  var data = [{
    id: 0,
    text: _('email', {
      ns: 'branding'
    }),
    href: "mailto:".concat(_('notFormatted.email', {
      ns: 'branding'
    })),
    icon: {
      name: 'Envelope',
      height: 20,
      width: 20,
      color: Colors.GREY,
      iconSet: 'FA'
    }
  }, {
    id: 1,
    text: _(tld === 'be' ? 'telBE' : 'tel', {
      ns: 'branding'
    }),
    href: "tel:".concat(_(tld === 'be' ? 'notFormatted.telBE' : 'notFormatted.tel', {
      ns: 'branding'
    })),
    icon: {
      name: 'Phone',
      height: 20,
      width: 20,
      color: Colors.GREY,
      iconSet: 'FA'
    }
  }];
  return React$4.createElement("div", {
    style: {
      width: 'auto',
      height: 'auto'
    }
  }, size.width >= Breakpoint.md && React$4.createElement("div", {
    style: {
      height: 'auto',
      width: 'auto',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end'
    }
  }, React$4.createElement(Text, {
    fontWeight: 500,
    color: Colors.GREY,
    fontSize: "1.1em"
  }, _('support', {
    ns: 'ui'
  }))), React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center'
    }
  }, React$4.createElement("address", {
    style: {
      paddingTop: 2,
      paddingBottom: 15,
      borderBottom: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      width: 'auto'
    }
  }, data.map(function (e) {
    return React$4.createElement(AddressLink, {
      key: e.id,
      data: e
    });
  }))), React$4.createElement("div", {
    style: {
      paddingTop: 15
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    }
  }, React$4.createElement(Text, {
    color: Colors.GREY,
    fontSize: "1.1em"
  }, "".concat(_('weekdays.mon', {
    ns: 'dates'
  }), "/").concat(_('weekdays.fri', {
    ns: 'dates'
  }), ":")), React$4.createElement(Text, {
    color: Colors.GREY,
    fontSize: "1.1em"
  }, "".concat(_('openingHours.week', {
    ns: 'branding'
  })))), React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginTop: 5
    }
  }, React$4.createElement(Text, {
    color: Colors.GREY,
    fontSize: "1.1em"
  }, "".concat(_('weekdays.saturday', {
    ns: 'dates'
  }), ":")), React$4.createElement(Text, {
    color: Colors.GREY,
    fontSize: "1.1em"
  }, "".concat(_('openingHours.weekend', {
    ns: 'branding'
  }))))));
}

function Footer(props) {
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  var size = useDimensions();
  return React$4.createElement("div", {
    style: {
      height: 'auto',
      width: '100%',
      backgroundColor: Colors.LIGHT_GREY,
      borderTop: "solid 2px ".concat(Colors.MEDIUM_WHITE)
    }
  }, React$4.createElement(MainContainer$1, null, React$4.createElement("div", {
    style: {
      paddingTop: 30,
      paddingBottom: 30,
      display: 'flex',
      flexDirection: size.width < Breakpoint.md ? 'column' : 'row',
      justifyContent: 'space-between',
      alignItems: size.width < Breakpoint.md ? 'center' : 'flex-start'
    }
  }, React$4.createElement("div", {
    style: {
      width: size.width < Breakpoint.md ? '100%' : '50%'
    }
  }, React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: size.width < Breakpoint.md ? 'center' : 'flex-start'
    }
  }, React$4.createElement(Logo, {
    type: "Normal",
    height: 60,
    width: 220
  })), React$4.createElement("div", {
    style: {
      marginTop: 15,
      marginBottom: 30,
      width: size.width < Breakpoint.md ? '100%' : '75%'
    }
  }, React$4.createElement(Text, {
    fontSize: "1.1em",
    lineHeight: "24px",
    textAlign: size.width < Breakpoint.md ? 'center' : 'left'
  }, props.text)), size.width >= Breakpoint.md && props.links && React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      gap: 30
    }
  }, props.links.map(function (item) {
    return React$4.createElement("a", {
      key: item.id,
      href: item.href,
      target: item.target,
      style: {
        textDecorationLine: 'none'
      },
      rel: "noreferrer"
    }, React$4.createElement(Text, {
      color: Colors.BLUE
    }, item.text));
  }))), React$4.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: size.width < Breakpoint.md ? 'center' : 'flex-end',
      alignItems: 'flex-start',
      gap: 30,
      width: size.width < Breakpoint.md ? '100%' : '50%'
    }
  }, props.contact && React$4.createElement(Contact, null))), React$4.createElement("div", {
    style: {
      borderTop: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      paddingTop: 20,
      paddingBottom: 20
    }
  }, React$4.createElement(Text, {
    fontSize: "1.1em",
    color: Colors.DARK_GREY,
    textAlign: "center",
    lineHeight: "24px"
  }, "\xA9", " ".concat(new Date().getFullYear(), " ").concat(_('blueCurrent', {
    ns: 'branding'
  }), ", ").concat(_('allRightsReserved', {
    ns: 'legal'
  })), props.subItems.map(function (item) {
    return React$4.createElement("span", {
      key: item.id
    }, ' • ', React$4.createElement("a", {
      href: item.href,
      target: item.target,
      style: {
        color: Colors.DARK_GREY
      },
      rel: "noreferrer"
    }, item.text));
  })))));
}

function ConfirmDialog(props) {
  var _props$cancel$text, _props$cancel, _props$cancel$colorSc, _props$cancel2, _props$cancel3, _props$accept$text, _props$accept, _props$accept$colorSc, _props$accept2, _props$accept3;
  var size = useDimensions();
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  return React$4.createElement(AnimatePresence, null, props.visible && React$4.createElement(motion.div, {
    style: {
      position: 'fixed',
      height: '100%',
      width: '100%',
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      zIndex: 2147483005,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center'
    },
    initial: {
      backgroundColor: 'rgba(55, 66, 74, 0)'
    },
    animate: {
      backgroundColor: 'rgba(55, 66, 74, 0.7)'
    },
    exit: {
      backgroundColor: 'rgba(55, 66, 74, 0)'
    },
    transition: {
      duration: 0.2
    }
  }, React$4.createElement(motion.div, {
    style: {
      height: 'auto',
      width: size.width < Breakpoint.xs ? '90%' : 500,
      backgroundColor: Colors.WHITE,
      borderRadius: 10,
      border: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      paddingLeft: 15,
      paddingRight: 15,
      paddingBottom: 15,
      paddingTop: 20
    },
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: 0.3
    }
  }, React$4.createElement(Title, null, props.title), React$4.createElement("div", {
    style: {
      marginTop: 20
    }
  }, React$4.createElement(Text, null, props.description)), React$4.createElement(motion.div, {
    style: {
      display: 'flex',
      flexDirection: size.width < Breakpoint.xs ? 'column-reverse' : 'row',
      justifyContent: 'flex-end',
      gap: 15,
      marginTop: 45
    },
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: 0.3
    }
  }, props.cancel && React$4.createElement("div", {
    style: {
      width: 'auto'
    }
  }, React$4.createElement(Buttons$1, {
    text: (_props$cancel$text = (_props$cancel = props.cancel) === null || _props$cancel === void 0 ? void 0 : _props$cancel.text) !== null && _props$cancel$text !== void 0 ? _props$cancel$text : _('cancel', {
      ns: 'ui'
    }),
    colorScheme: (_props$cancel$colorSc = (_props$cancel2 = props.cancel) === null || _props$cancel2 === void 0 ? void 0 : _props$cancel2.colorScheme) !== null && _props$cancel$colorSc !== void 0 ? _props$cancel$colorSc : 'white',
    onClick: (_props$cancel3 = props.cancel) === null || _props$cancel3 === void 0 ? void 0 : _props$cancel3.onClick
  })), !props.buttonless && React$4.createElement("div", {
    style: {
      width: 'auto'
    }
  }, React$4.createElement(Buttons$1, {
    text: (_props$accept$text = (_props$accept = props.accept) === null || _props$accept === void 0 ? void 0 : _props$accept.text) !== null && _props$accept$text !== void 0 ? _props$accept$text : _('ok', {
      ns: 'ui'
    }),
    colorScheme: (_props$accept$colorSc = (_props$accept2 = props.accept) === null || _props$accept2 === void 0 ? void 0 : _props$accept2.colorScheme) !== null && _props$accept$colorSc !== void 0 ? _props$accept$colorSc : 'blue',
    onClick: (_props$accept3 = props.accept) === null || _props$accept3 === void 0 ? void 0 : _props$accept3.onClick
  }))))));
}

function Dialog(props) {
  var size = useDimensions();
  return React$4.createElement(AnimatePresence, null, props.visible && React$4.createElement(motion.div, {
    style: {
      position: 'fixed',
      height: '100%',
      width: '100%',
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      zIndex: 2147483005,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center'
    },
    initial: {
      backgroundColor: 'rgba(55, 66, 74, 0)'
    },
    animate: {
      backgroundColor: 'rgba(55, 66, 74, 0.7)'
    },
    exit: {
      backgroundColor: 'rgba(55, 66, 74, 0)'
    },
    transition: {
      duration: 0.2
    }
  }, React$4.createElement(motion.div, {
    style: {
      height: 'auto',
      width: size.width < Breakpoint.xs ? '90%' : 500,
      backgroundColor: Colors.WHITE,
      borderRadius: 10,
      border: "solid 2px ".concat(Colors.MEDIUM_WHITE),
      paddingLeft: 15,
      paddingRight: 15,
      paddingBottom: 15,
      paddingTop: 20
    },
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: 0.3
    }
  }, props.children)));
}

function Heart(props) {
  var _props$width, _props$height, _props$color;
  return React$4.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 62,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 53,
    viewBox: "0 0 62 53",
    xmlns: "http://www.w3.org/2000/svg"
  }, React$4.createElement("g", {
    transform: "translate(-335 -256)",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React$4.createElement("g", {
    stroke: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    strokeWidth: 3
  }, React$4.createElement("path", {
    d: "M338.47 282.349h-1.528M395.302 282.349h-1.529M348.062 305.504l-1.08 1.08M385.263 258.113l-1.08 1.081M348.062 259.194l-1.08-1.081M385.263 306.584l-1.08-1.08M340.735 294.599l-2.767 1.147M394.276 268.952l-2.767 1.146M340.735 270.098l-2.767-1.146M394.276 295.746l-2.767-1.147M365.744 297.318c-.61-.37-14.935-9.17-14.935-18.489 0-4.496 3.658-8.153 8.153-8.153a8.177 8.177 0 0 1 7.16 4.252 8.177 8.177 0 0 1 7.16-4.252c4.495 0 8.153 3.657 8.153 8.153 0 9.319-14.325 18.119-14.935 18.489l-.378.23-.378-.23Z"
  }), React$4.createElement("path", {
    d: "M373.281 275.69a3.143 3.143 0 0 1 3.14 3.14"
  }))));
}

function Earth(props) {
  var _props$width, _props$height, _props$color;
  return React$4.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 76,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 75,
    viewBox: "0 0 76 75",
    xmlns: "http://www.w3.org/2000/svg"
  }, React$4.createElement("g", {
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    fillRule: "evenodd"
  }, React$4.createElement("path", {
    d: "M55.814 56.345c-.477 1.55-.9 2.272-1.144 2.593a2.54 2.54 0 0 1-.09-.118c-.286-.392.14-1.357.423-1.995l.015-.034c.456-1.03.334-1.82.245-2.397-.057-.37-.077-.53-.006-.748.059-.179.409-.353.937-.598.234-.11.491-.229.751-.373l-1.13 3.67zm3.917-8.275a1.48 1.48 0 0 0-1.268-1.06 1.51 1.51 0 0 0-1.49.743c-.165.29-.312.598-.455.896-.24.501-.488 1.02-.746 1.305-.145.16-.517.334-.877.501-.861.4-2.04.948-2.49 2.33-.28.857-.175 1.535-.099 2.03.066.429.081.578-.038.848l-.015.034c-.476 1.074-1.361 3.075-.12 4.777C53.02 61.688 53.95 62 54.673 62c.142 0 .276-.011.4-.03 1.524-.24 2.67-1.768 3.607-4.807l1.758-5.705c.078-.253.083-.523.012-.778l-.72-2.61z"
  }), React$4.createElement("path", {
    d: "M56.843 52.798c-.216.115-.43.215-.62.304-.5.234-.853.409-.904.566-.067.206-.047.36.008.718.089.58.21 1.374-.246 2.41l-.015.033c-.258.586-.689 1.565-.424 1.93l.043.058c.26-.363.646-1.085 1.08-2.5l1.078-3.519zm-2.155 6.196-.044-.054c-.028-.036-.06-.075-.092-.12-.3-.413.129-1.387.413-2.032l.015-.034c.444-1.008.325-1.784.239-2.351-.058-.377-.079-.538-.005-.766.065-.2.404-.37.954-.627.231-.108.486-.227.739-.368l.119-.067-1.157 3.772c-.462 1.51-.874 2.242-1.138 2.591l-.043.056zm3.57-11.888c-.52 0-.998.27-1.25.72-.161.29-.306.593-.446.887-.239.5-.485 1.018-.746 1.308-.15.168-.523.342-.884.51-.84.393-1.993.931-2.43 2.281-.273.84-.17 1.506-.096 1.993.065.428.082.59-.042.87l-.015.034c-.465 1.058-1.332 3.027-.124 4.692.72.99 1.549 1.493 2.465 1.493.128 0 .257-.01.385-.03 1.483-.235 2.602-1.74 3.52-4.735l1.737-5.665c.074-.242.078-.5.01-.744l-.71-2.591a1.4 1.4 0 0 0-1.205-1.013 1.385 1.385 0 0 0-.17-.01zM54.698 62h-.008c-.656 0-1.631-.267-2.554-1.538-1.244-1.713-.361-3.718.113-4.795l.014-.033c.113-.256.1-.39.035-.814-.077-.496-.181-1.176.1-2.04.45-1.393 1.627-1.943 2.486-2.344.351-.164.714-.333.85-.484.25-.279.493-.79.728-1.283.14-.296.286-.602.45-.894.3-.536.9-.835 1.528-.765a1.509 1.509 0 0 1 1.298 1.092l.71 2.591c.073.263.069.54-.011.802L58.7 57.16c-.932 3.039-2.078 4.567-3.607 4.808a2.527 2.527 0 0 1-.396.032zM40.53 18.119l-.099-.035a1.444 1.444 0 0 0-1.849.908c-.265.772.133 1.618.89 1.89l.097.034c.159.057.32.084.48.084.599 0 1.16-.382 1.369-.992.265-.773-.133-1.618-.889-1.89"
  }), React$4.createElement("path", {
    d: "M39.954 18.106c-.557 0-1.079.355-1.273.921-.12.347-.1.721.057 1.052.156.332.429.581.769.703l.094.034c.144.052.294.078.446.078a1.35 1.35 0 0 0 1.272-.922 1.386 1.386 0 0 0-.825-1.754l-.095-.034a1.309 1.309 0 0 0-.445-.078M40.047 21a1.41 1.41 0 0 1-.48-.084l-.095-.034a1.45 1.45 0 0 1-.828-.757 1.498 1.498 0 0 1-.061-1.133 1.445 1.445 0 0 1 1.85-.908l.095.033c.366.132.66.4.828.757.168.357.19.76.061 1.134a1.455 1.455 0 0 1-1.37.992"
  }), React$4.createElement("path", {
    d: "M32.962 26.296c.07.454.35.85.756 1.066.275.147.657.402 1.062.672 1.145.763 2.442 1.628 3.661 1.706 1.109.072 1.726-.56 1.99-.829.021-.021.041-.043.062-.062.15-.122.288-.284.392-.48.234.067.48.133.733.202.867.235 2.481.672 2.838 1.05.634.671 1.127 1.95 1.563 3.077.22.57.429 1.108.662 1.607.1.214.199.435.299.658.675 1.507 1.442 3.216 3.067 4.279.737.481 1.64.62 2.437.742l.32.05c-.473.66-1.147 1.288-1.86 1.95-1.813 1.69-4.07 3.791-3.03 7.144.49 1.583.513 1.754-.276 2.612l-.3.324c-.676.719-1.21 1.287-1.652 2.679-.128.404-.294.591-.596.931-.242.272-.543.61-.82 1.085-.332.569-.442 1.116-.53 1.556-.087.433-.136.65-.306.86a8.523 8.523 0 0 1-1.85 1.634c-.688.437-1.09.497-1.227.489-.156-.168-.722-.901-1.578-3.44-.21-.627-.503-1.271-.786-1.894-.624-1.375-1.269-2.795-.955-3.766.037-.115.073-.227.11-.336.5-1.528.974-2.97.097-5.071-.267-.64-.691-1.108-1.066-1.52-.243-.267-.517-.57-.56-.743-.05-.212-.05-.457-.048-.741.005-.766.013-1.922-1.137-2.999-1.62-1.517-3.511-1.05-4.762-.74-.384.095-.747.185-1.069.222-2.058.242-3.895-.535-5.042-2.13-1.2-1.67-1.374-3.917-.454-5.864.445-.942 1.117-1.699 1.896-2.575.17-.191.342-.384.513-.582.286-.33.6-.775.933-1.247.397-.564 1.136-1.613 1.457-1.812.653-.368 2.17-.422 3.276-.46.444-.016.864-.031 1.238-.063.198-.016.417-.013.624.003a1.458 1.458 0 0 0-.082.756M38 72a34.317 34.317 0 0 1-20.653-6.882l1.287-6.722.633-.205a4.562 4.562 0 0 0 2.926-5.742l-.464-1.428c-.108-.33-.107-.68.001-1.01a4.557 4.557 0 0 0-3.456-5.893l-3.306-.646-6.379-4.85a1.468 1.468 0 0 0-1.34-.227l-3.684 1.197a34.473 34.473 0 0 1-.015-3.945c.124.115.21.199.262.254.073.121.164.233.27.33.305.277.581.403 1.161.403.533 0 1.323-.106 2.626-.299 1.235-.182 2.465-.388 2.477-.39a1.463 1.463 0 0 0 .968-2.27l-1.796-2.634 2.572-1.84c.172-.122.315-.28.42-.463l3.987-6.962 1.608-1.722a6.188 6.188 0 0 0 1.193-6.562 6.726 6.726 0 0 0-2.61-3.105 34.332 34.332 0 0 1 20.879-7.381L34.99 6.238l-9.699 3.4c-.394.138-.71.438-.87.824l-2.708 6.566c-.193.467-.131.999.162 1.41l3.956 5.542c-.567.516-1.118 1.27-1.777 2.204-.289.41-.562.797-.75 1.015-.164.189-.328.373-.49.556-.852.957-1.731 1.947-2.356 3.27-1.375 2.909-1.097 6.29.724 8.824 1.76 2.45 4.664 3.695 7.762 3.33.505-.058.976-.175 1.431-.288 1.256-.31 1.654-.341 2.057.036.196.183.214.218.21.84-.003.396-.006.89.13 1.452.219.9.784 1.522 1.238 2.022.226.248.46.505.532.677.456 1.095.258 1.701-.178 3.03l-.114.349c-.662 2.05.26 4.083 1.075 5.877.265.583.515 1.133.678 1.619 1.317 3.908 2.305 4.803 3.097 5.163.415.189.844.272 1.278.271 2.112 0 4.315-1.96 5.328-3.203.635-.78.792-1.562.906-2.133.057-.284.102-.508.187-.655.131-.223.286-.397.481-.617.393-.442.881-.993 1.198-1.99.24-.758.415-.944.994-1.56l.324-.347c1.95-2.123 1.448-3.745.916-5.462-.448-1.444.335-2.368 2.23-4.132.82-.764 1.669-1.555 2.325-2.505.287-.415 1.16-1.68.62-2.934-.53-1.228-1.877-1.435-2.958-1.6-.428-.066-1.073-.165-1.28-.3-.906-.592-1.46-1.829-1.996-3.025-.107-.238-.212-.473-.319-.701-.19-.407-.38-.9-.582-1.42-.533-1.38-1.137-2.943-2.165-4.033-.924-.98-2.666-1.45-4.203-1.867-.517-.14-1.006-.272-1.327-.39-.27-.1-.563-.119-.842-.053-.748.175-1.215.369-1.561.646a1.827 1.827 0 0 0-.522.702c-.536-.258-1.273-.749-1.727-1.051l-.029-.02a2.073 2.073 0 0 0-.13-1.41c-.818-1.73-3.535-1.595-4.07-1.55-.305.026-.69.04-1.097.054-.64.023-1.347.049-2.047.127l.036-.1a3.745 3.745 0 0 1 3.517-2.475h.833a1.465 1.465 0 0 0 0-2.929h-.833a6.685 6.685 0 0 0-5.67 3.162l-2.185-3.06 2.15-5.21 9.478-3.324c.26-.09.489-.253.66-.469l4.18-5.243c14.542 1.343 26.496 11.747 30.15 25.498l-.58.516a3.912 3.912 0 0 0-1.303 2.846v.035l-1.012-2.782a3.664 3.664 0 0 0-.66-1.131l-1.805-2.113a3.669 3.669 0 0 0-2.795-1.288h-2.208c-.785 0-1.501.429-1.871 1.12-.37.691-.33 1.526.105 2.178l.224.336a16.248 16.248 0 0 1-4.836 2.872l-3.028-5.8v-1.294c0-.4-.163-.783-.453-1.06l-2.727-2.603a1.471 1.471 0 0 0-.526-.322l-2.454-.862a1.464 1.464 0 1 0-.971 2.763l2.157.759 2.045 1.952v1.026c0 .236.057.469.166.678l3.79 7.26a1.464 1.464 0 0 0 1.806.697l1.104-.407a19.18 19.18 0 0 0 6.873-4.399c.494-.494.57-1.267.183-1.848l-.078-.117h.7c.218 0 .425.095.567.262l1.805 2.112a.725.725 0 0 1 .133.23l1.992 5.476a1.468 1.468 0 0 0 1.376.964c.384 0 .759-.151 1.036-.429l.948-.948c.576-.577.978-1.3 1.184-2.103.174 1.402.265 2.828.265 4.276C72.5 56.523 57.024 72 38 72M15.92 56.995l-1.148 5.992c-5.74-5.235-9.71-12.378-10.898-20.415l3.552-1.154 6.04 4.593c.179.135.386.228.606.271l3.64.711c.465.091.853.366 1.092.774.24.409.29.881.143 1.33a4.523 4.523 0 0 0-.004 2.829l.464 1.428a1.628 1.628 0 0 1-1.046 2.05l-1.455.474a1.463 1.463 0 0 0-.986 1.117M3.626 35.415a1.339 1.339 0 0 1 0 .001M14.29 12.46a3.809 3.809 0 0 1 2.299 2.147 3.25 3.25 0 0 1-.627 3.447l-1.723 1.847a1.437 1.437 0 0 0-.2.271l-3.913 6.832-3.478 2.486a1.464 1.464 0 0 0-.358 2.017l1.3 1.907c-.75.112-1.422.204-1.87.253-.086-.083-.176-.166-.269-.253a71.233 71.233 0 0 0-1.521-1.358c1.22-7.66 4.967-14.487 10.36-19.596m61.207 24.9c0-.168-.003-.337-.006-.505-.002-.141-.004-.282-.008-.423l-.012-.32a37.168 37.168 0 0 0-2.92-13.21 37.273 37.273 0 0 0-5.764-9.435l-.12-.142a37.093 37.093 0 0 0-6.973-6.421l-.028-.02c-.198-.14-.397-.277-.597-.413l-.268-.18-.367-.241a31.842 31.842 0 0 0-.53-.339l-.115-.071a37.256 37.256 0 0 0-5.193-2.693A37.226 37.226 0 0 0 38.663.008c-.096-.002-.193-.002-.29-.003C38.25.003 38.125 0 38 0l-.171.002c-.18 0-.36.003-.54.007-.115.002-.23.003-.346.007-.209.005-.418.013-.626.023l-.303.013c-.193.01-.386.023-.58.036l-.383.027c-.14.01-.28.024-.42.036-.19.017-.378.034-.566.054l-.17.018a37.117 37.117 0 0 0-10.492 2.725 37.37 37.37 0 0 0-11.92 8.035l-.24.246-.01.012c-.197.2-.392.402-.583.606l-.116.124a40.39 40.39 0 0 0-.487.533l-.14.157c-.158.179-.315.359-.469.54l-.107.126c-.17.202-.338.404-.503.608l-.037.046a37.25 37.25 0 0 0-5.343 8.922A37.21 37.21 0 0 0 .508 36.85l-.004.288c0 .12-.004.24-.004.361l.002.165c0 .201.003.401.007.602l.006.264c.006.25.016.501.027.752l.008.158c.012.256.029.513.047.77l.012.173c.017.227.037.454.059.68l.027.288c.017.168.037.336.056.504.019.159.037.319.057.477l.035.254a37.088 37.088 0 0 0 2.605 9.51 37.37 37.37 0 0 0 8.035 11.92 37.37 37.37 0 0 0 11.92 8.035 37.18 37.18 0 0 0 13.03 2.914l.107.004c.22.008.441.016.662.02.17.004.338.005.507.007L38 75h.031c.3 0 .598-.004.897-.011l.17-.006c.242-.007.486-.015.729-.027.11-.005.219-.013.329-.019.183-.01.366-.02.549-.034.15-.01.3-.023.45-.035l.408-.036c.186-.017.372-.037.557-.057l.279-.031c.22-.026.44-.054.659-.083l.152-.021c.255-.035.509-.073.763-.114l.016-.002a37.134 37.134 0 0 0 8.608-2.472 37.281 37.281 0 0 0 8.575-5.063l.02-.015a37.21 37.21 0 0 0 7.294-7.63 37.327 37.327 0 0 0 6.94-19.498l.012-.203c.01-.185.02-.37.027-.556l.015-.407c.004-.142.008-.285.01-.428.004-.172.006-.344.007-.515 0-.08.003-.158.003-.237l-.002-.139"
  })));
}

function CarHouse(props) {
  var _props$width, _props$height, _props$color, _props$color2;
  return React$4.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 132,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 86,
    viewBox: "0 0 132 86",
    xmlns: "http://www.w3.org/2000/svg"
  }, React$4.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React$4.createElement("g", {
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY
  }, React$4.createElement("g", null, React$4.createElement("g", null, React$4.createElement("g", {
    stroke: (_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : Colors.GREY
  }, React$4.createElement("path", {
    d: "M94.394 20.42c-.445-.595-.885-1.003-1.211-1.266-.032-.373-.08-.91-.14-1.49-.055-.532-.118-1.095-.188-1.598-.072-.509-.14-.93-.245-1.293l-.076-.188c-1.41-2.75-3.667-5.727-5.58-8.056-1.912-2.325-3.48-3.98-3.491-3.994l-.105-.095c-.3-.225-1.109-.76-4.654-1.332-3.545-.56-9.828-1.107-21-1.108-20.917.007-33.786 9.863-35.742 11.465-1.264.176-5.901.908-10.618 2.862-2.75 1.144-5.538 2.701-7.693 4.878C1.497 21.375-.007 24.233 0 27.737c.001 1.338.061 2.447.24 3.41.138.72.344 1.365.67 1.937.482.864 1.274 1.503 2.198 1.855.926.363 1.982.511 3.252.592.614.037 1.144-.429 1.182-1.04.037-.612-.43-1.138-1.045-1.176-1.032-.06-1.821-.183-2.371-.367-.416-.138-.692-.3-.905-.491-.311-.286-.55-.688-.732-1.453-.179-.759-.26-1.84-.258-3.267.007-2.868 1.167-5.096 3.01-6.975 2.76-2.81 7.108-4.651 10.763-5.722 1.827-.54 3.477-.896 4.664-1.115.594-.11 1.072-.185 1.398-.233.165-.026.291-.042.374-.052l.12-.016c.227-.027.437-.12.609-.27l.026-.023c.672-.575 13.318-11.119 34.508-11.112 11.097-.002 17.288.548 20.65 1.08 1.681.265 2.652.528 3.168.704.221.077.353.135.425.168l.156.169c.6.65 2.153 2.365 3.838 4.472 1.658 2.073 3.444 4.537 4.556 6.685.04.171.1.503.15.874.096.692.186 1.564.25 2.258.065.693.105 1.205.105 1.206.028.36.23.68.539.866l-.001.001c.002 0 .138.084.35.266.636.568 1.872 1.914 1.88 4.582.002 1.178-.105 2.109-.307 2.818-.203.714-.482 1.2-.86 1.597-.425.443-.41 1.145.035 1.568.446.424 1.151.408 1.577-.034.66-.685 1.12-1.544 1.395-2.531.278-.99.39-2.111.391-3.418.004-2.34-.791-4.049-1.606-5.13",
    transform: "translate(-547.000000, -796.000000) translate(1.000000, 766.000000) translate(547.000000, 30.000000) translate(0.000000, 44.000000)"
  }), React$4.createElement("path", {
    d: "M85.694 37.01c-1.076 1.08-2.547 1.744-4.185 1.744-1.637 0-3.11-.664-4.184-1.744-1.073-1.081-1.733-2.563-1.733-4.21 0-1.647.66-3.128 1.733-4.21 1.074-1.08 2.547-1.743 4.184-1.743 1.638 0 3.11.664 4.185 1.744 1.072 1.08 1.733 2.562 1.733 4.21 0 1.646-.661 3.128-1.733 4.209M81.509 24.6c-4.501 0-8.15 3.671-8.15 8.2s3.649 8.2 8.15 8.2c4.502-.001 8.15-3.67 8.151-8.2 0-4.53-3.649-8.198-8.15-8.2M22.298 37.01c-1.075 1.08-2.547 1.744-4.185 1.744-1.637 0-3.11-.664-4.184-1.744-1.073-1.081-1.733-2.563-1.733-4.21 0-1.647.66-3.128 1.733-4.21 1.074-1.08 2.547-1.743 4.184-1.743 1.638 0 3.11.664 4.185 1.744 1.073 1.08 1.733 2.562 1.733 4.21 0 1.646-.66 3.128-1.733 4.209M18.113 24.6c-4.501.002-8.149 3.67-8.15 8.2.001 4.53 3.649 8.199 8.15 8.2 4.502 0 8.151-3.671 8.151-8.2s-3.65-8.2-8.15-8.2M70.435 32.8H29.187c-.614 0-1.112.612-1.112 1.366 0 .755.498 1.367 1.112 1.367h41.248c.614 0 1.112-.612 1.112-1.367 0-.754-.498-1.366-1.112-1.366M34.346 13.206c5.787-3.197 16.089-5.398 22.643-5.381h.123l-.252 6.22c-3.221.233-6.51.475-9.551.7-6.72.5-12.189.92-13.044 1-.662.064-1.384.198-2.08.31-.617.103-1.208.182-1.633.197.67-.991 1.997-2.068 3.794-3.046m37.101-3.861c1.233.408 2.018.836 2.62 1.242.603.407 1.028.808 1.566 1.214.357.27.62.533.765.726l.075.126c-.211.078-.66.171-1.323.179-.882.015-3.664.191-7.483.45-2.517.17-5.466.379-8.551.6l.245-6.033c6.252.128 9.889.766 12.086 1.496m-42.062 8.95c.353.1.684.123 1.018.124.7-.002 1.436-.116 2.16-.233.717-.119 1.418-.242 1.922-.29 1.053-.1 10.473-.816 19.986-1.51 4.76-.348 9.554-.69 13.356-.948 3.789-.26 6.635-.435 7.36-.445.982-.021 1.749-.14 2.407-.459.327-.161.633-.39.857-.703.227-.31.345-.701.341-1.058-.006-.6-.256-1.081-.565-1.503-.318-.423-.726-.805-1.209-1.17-.394-.292-.9-.766-1.658-1.282-1.141-.775-2.824-1.581-5.645-2.168-2.827-.59-6.818-.986-12.726-.986-4.69.003-10.858.993-16.336 2.66-2.74.836-5.3 1.843-7.421 3.005-2.117 1.168-3.818 2.474-4.782 4.074l-.027.051c-.201.39-.343.767-.347 1.216-.004.293.078.623.263.9.28.419.703.627 1.046.724",
    transform: "translate(-547.000000, -796.000000) translate(1.000000, 766.000000) translate(547.000000, 30.000000) translate(0.000000, 44.000000)"
  })), React$4.createElement("g", null, React$4.createElement("path", {
    d: "M78.998 36.008v38.16c0 1.33-.547 2.54-1.427 3.414-.88.875-2.097 1.418-3.436 1.418H60.35v-3.708h13.784c.309 0 .591-.126.798-.331.206-.205.334-.486.334-.793v-38.16h3.731zM43.5 0c.566-.012 1.132.229 1.509.702l.014.018 41.27 32.418c.805.632.943 1.804.307 2.604-.637.8-1.816.937-2.62.304L43.5 4.25 3.02 36.046c-.804.633-1.983.495-2.62-.304-.636-.8-.498-1.972.306-2.604L41.977.72l.014-.018.119-.135c.37-.384.88-.578 1.39-.567zM21.903 5.927v3.708H11.865V20.7l-3.731 2.93V9.024c0-.854.35-1.628.914-2.189.564-.56 1.343-.908 2.202-.908h10.653z",
    transform: "translate(-547.000000, -796.000000) translate(1.000000, 766.000000) translate(547.000000, 30.000000) translate(44.000000, 0.000000)"
  })))))));
}

function App(props) {
  var _props$width, _props$height, _props$color, _props$color2;
  return React$4.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 89,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 93,
    viewBox: "0 0 89 93",
    xmlns: "http://www.w3.org/2000/svg"
  }, React$4.createElement("g", {
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    stroke: (_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : Colors.GREY,
    fillRule: "evenodd"
  }, React$4.createElement("path", {
    d: "M28.18 3.78a5.409 5.409 0 0 0-5.401 5.404v74.632a5.409 5.409 0 0 0 5.402 5.404H62.82a5.409 5.409 0 0 0 5.402-5.404V9.184A5.409 5.409 0 0 0 62.82 3.78H28.18zM62.82 92H28.18C23.67 92 20 88.329 20 83.816V9.184C20 4.67 23.67 1 28.18 1h34.64C67.33 1 71 4.67 71 9.184v74.632C71 88.33 67.33 92 62.82 92z"
  }), React$4.createElement("path", {
    d: "M69.61 13H21.39c-.768 0-1.39-.672-1.39-1.5s.622-1.5 1.39-1.5h48.22c.768 0 1.39.672 1.39 1.5s-.622 1.5-1.39 1.5m0 64H21.39c-.768 0-1.39-.672-1.39-1.5s.622-1.5 1.39-1.5h48.22c.768 0 1.39.672 1.39 1.5s-.622 1.5-1.39 1.5m-21.93 7h-6.36c-.73 0-1.32-.672-1.32-1.5s.59-1.5 1.319-1.5h6.362c.729 0 1.32.672 1.32 1.5S48.41 84 47.68 84m-9.762-41.28h4.42c.464 0 .896.238 1.15.632.254.394.295.892.109 1.323l-5.42 12.58 12.866-11.744h-3.698c-.437 0-.847-.21-1.106-.567a1.412 1.412 0 0 1-.207-1.24l4.054-13.342L37.918 42.72zM34.374 64c-.281 0-.563-.087-.804-.264a1.408 1.408 0 0 1-.455-1.69l7.123-16.535h-5.636c-.556 0-1.057-.34-1.27-.861a1.41 1.41 0 0 1 .298-1.52l18.432-18.721a1.357 1.357 0 0 1 1.68-.21c.54.332.79.995.604 1.608l-5.14 16.913h5.42c.57 0 1.08.357 1.283.896a1.41 1.41 0 0 1-.364 1.537l-20.253 18.49c-.26.236-.588.357-.918.357zm48.099-8c-.33 0-.663-.108-.935-.33a1.336 1.336 0 0 1-.161-1.943c2.41-2.703 3.739-6.147 3.739-9.697 0-4.043-1.664-7.831-4.684-10.668a1.335 1.335 0 0 1-.018-1.95 1.492 1.492 0 0 1 2.04-.017C86.03 34.755 88 39.242 88 44.03c0 4.206-1.573 8.285-4.43 11.486-.284.32-.69.484-1.097.484m-5.5-7c-.21 0-.423-.061-.62-.19-.62-.404-.845-1.326-.502-2.058.38-.812.58-1.734.58-2.666 0-1.314-.398-2.587-1.122-3.586-.462-.636-.4-1.592.14-2.136s1.35-.47 1.81.166c1.124 1.547 1.74 3.52 1.74 5.556a9.799 9.799 0 0 1-.901 4.132c-.234.5-.673.782-1.125.782M7.558 56c-.365 0-.73-.131-1.01-.395C2.97 52.245 1 47.759 1 42.97c0-4.206 1.573-8.285 4.429-11.486a1.488 1.488 0 0 1 2.033-.154c.606.494.679 1.364.162 1.943-2.411 2.703-3.74 6.147-3.74 9.697 0 4.043 1.664 7.83 4.685 10.668.568.534.576 1.406.018 1.95a1.477 1.477 0 0 1-1.03.412m5.16-7c-.363 0-.723-.18-.977-.53-1.122-1.547-1.74-3.52-1.74-5.556 0-1.443.312-2.872.902-4.131.343-.733 1.125-1 1.745-.593.62.405.846 1.326.503 2.059a6.32 6.32 0 0 0-.582 2.665c0 1.314.4 2.587 1.124 3.586.46.636.398 1.592-.141 2.136-.242.244-.54.364-.834.364"
  })));
}

function LightBulb$1(props) {
  var _props$width, _props$height, _props$color;
  return React$4.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 55,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 61,
    viewBox: "0 0 55 61",
    xmlns: "http://www.w3.org/2000/svg"
  }, React$4.createElement("path", {
    d: "M14.486 26.697c0 3.721 1.821 6.83 4 9.514 3.5 4.314 3.03 9.3 3.03 9.3h12.828s-.471-4.986 3.03-9.3c2.179-2.685 4-5.793 4-9.514 0-7.38-6.024-13.373-13.444-13.373-7.42 0-13.444 5.993-13.444 13.373Zm7.2 22.236h12.488M21.686 52.3h12.488m-12.488 3.368h12.488m-2.197-.037c0 1.859-1.813 3.368-4.047 3.368s-4.048-1.509-4.048-3.368m4.05-48.014V2m13.572 10.142 4.128-4.107m-32.136 4.107L9.367 8.035m37.696 17.778L53 25.71m-45.063.104L2 25.71m40.792 13.157 4.27 4.104m-34.855-4.104-4.27 4.104",
    stroke: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    strokeWidth: 2.488,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

function Graph(props) {
  var _props$width, _props$height, _props$color;
  return React$4.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 76,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 66,
    viewBox: "0 0 76 66",
    xmlns: "http://www.w3.org/2000/svg"
  }, React$4.createElement("g", {
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    fillRule: "evenodd"
  }, React$4.createElement("path", {
    d: "M9.177 63.845h12.58V46.644H9.176v17.201ZM22.827 66H8.104c-.592 0-1.07-.483-1.07-1.077V45.567c0-.595.478-1.078 1.07-1.078h14.723c.592 0 1.072.483 1.072 1.078v19.356c0 .594-.48 1.077-1.072 1.077Z"
  }), React$4.createElement("path", {
    d: "M23.9 63.845h12.58V38.313H23.9v25.532ZM37.55 66H22.827c-.59 0-1.07-.483-1.07-1.077V37.236c0-.596.48-1.077 1.07-1.077h14.724c.592 0 1.071.481 1.071 1.077v27.687c0 .594-.48 1.077-1.07 1.077Z"
  }), React$4.createElement("path", {
    d: "M38.622 63.845h12.581V29.562h-12.58v34.283ZM52.274 66H37.55a1.075 1.075 0 0 1-1.072-1.077V28.485c0-.595.48-1.077 1.072-1.077h14.723c.592 0 1.072.482 1.072 1.077v36.438c0 .594-.48 1.077-1.072 1.077ZM66.993 49.62a1.074 1.074 0 0 1-1.071-1.077v-3.156c0-1.436 2.143-1.436 2.143 0v3.156c0 .595-.48 1.078-1.072 1.078"
  }), React$4.createElement("path", {
    d: "M66.993 65.996H52.272a1.075 1.075 0 0 1-1.071-1.078V17.032h-6.364c-.955 0-1.433-1.16-.758-1.84L58.875.316a1.068 1.068 0 0 1 1.515 0l14.807 14.878c.674.679.197 1.838-.757 1.84h-6.375v10.104c0 1.437-2.143 1.437-2.143 0V15.954c0-.594.48-1.076 1.071-1.076h4.858L59.637 2.596 47.423 14.878h4.849c.592 0 1.072.482 1.072 1.076v47.887h12.578v-7.746c0-1.436 2.143-1.436 2.143 0v8.823c0 .595-.48 1.078-1.072 1.078"
  }), React$4.createElement("path", {
    d: "M66.993 38.923a1.074 1.074 0 0 1-1.071-1.077v-3.178c0-1.437 2.143-1.437 2.143 0v3.178c0 .595-.48 1.077-1.072 1.077M74.156 66H1.584c-1.429 0-1.429-2.155 0-2.155h72.572c1.429 0 1.429 2.155 0 2.155"
  })));
}

function Battery(props) {
  var _props$width, _props$height, _props$color, _props$colorBattery, _props$color2;
  return React$4.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 64,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 35,
    viewBox: "0 0 64 35",
    xmlns: "http://www.w3.org/2000/svg"
  }, React$4.createElement("g", {
    transform: "translate(2 2)",
    fill: "none",
    fillRule: "evenodd"
  }, React$4.createElement("path", {
    d: "M50.87 31c1.44 0 2.608-1.157 2.608-2.583V2.583C53.478 1.157 52.31 0 50.87 0H2.609C1.169 0 0 1.157 0 2.583v25.834C0 29.843 1.169 31 2.609 31h48.26Z",
    stroke: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    strokeWidth: 2.442
  }), React$4.createElement("rect", {
    fill: (_props$colorBattery = props.colorBattery) !== null && _props$colorBattery !== void 0 ? _props$colorBattery : Colors.GREY,
    x: 6,
    y: 5,
    width: 41,
    height: 21,
    rx: 1
  }), React$4.createElement("path", {
    d: "M53.478 7.75h3.913c1.44 0 2.609 1.157 2.609 2.583v10.334c0 1.426-1.169 2.583-2.609 2.583h-3.913",
    stroke: (_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : Colors.GREY,
    strokeWidth: 2.442
  })));
}

function Portal(props) {
  var _props$width, _props$height, _props$color, _props$color2, _props$color3;
  return React$4.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 55,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 61,
    viewBox: "0 0 111 83",
    xmlns: "http://www.w3.org/2000/svg"
  }, React$4.createElement("defs", null, React$4.createElement("path", {
    id: "q3na2umg6a",
    d: "M0 0L43 0 43 5 0 5z"
  }), React$4.createElement("path", {
    id: "07f4z069fc",
    d: "M0 83L111 83 111 0 0 0z"
  })), React$4.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React$4.createElement("g", null, React$4.createElement("g", null, React$4.createElement("g", {
    transform: "translate(-925.000000, -1796.000000) translate(0.000000, 1759.000000) translate(925.000000, 37.000000)"
  }, React$4.createElement("g", {
    transform: "translate(35.000000, 78.000000)"
  }, React$4.createElement("path", {
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    d: "M40.702 0H2.298C1.028 0 0 1.118 0 2.5S1.028 5 2.298 5h38.404C41.972 5 43 3.882 43 2.5S41.972 0 40.702 0",
    mask: "url(#3eg1jco33b)"
  })), React$4.createElement("path", {
    fill: (_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : Colors.GREY,
    d: "M4.625 70.313h101.75V4.687H4.625v65.626zM108.687 0H2.313C1.034 0 0 1.048 0 2.344v70.312C0 73.952 1.034 75 2.313 75h106.374c1.279 0 2.313-1.048 2.313-2.344V2.344C111 1.048 109.966 0 108.687 0z",
    mask: "url(#hsh6hgeuhd)"
  }), React$4.createElement("path", {
    fill: (_props$color3 = props.color) !== null && _props$color3 !== void 0 ? _props$color3 : Colors.GREY,
    d: "M83.5 16.522c.73 0 1.44.09 2.122.255l-4.114 7.654c-.353.654-.357 1.44-.017 2.102.34.663.984 1.118 1.722 1.21l8.618 1.096c-1.328 3.301-4.56 5.639-8.331 5.639-4.95 0-8.978-4.028-8.978-8.978s4.028-8.978 8.978-8.978zm6.102 2.4c1.502 1.395 2.526 3.296 2.8 5.43l-5.352-.68 2.552-4.75zM83.5 39c6.848 0 12.516-5.124 13.381-11.74.004-.019.01-.036.013-.055.005-.036.005-.071.008-.107.062-.524.098-1.057.098-1.598 0-5.12-2.864-9.583-7.073-11.87-.013-.007-.024-.016-.037-.022-.028-.016-.057-.027-.085-.04-1.883-1-4.028-1.568-6.305-1.568C76.054 12 70 18.054 70 25.5 70 32.945 76.054 39 83.5 39zM44.5 61c1.382 0 2.5-1.054 2.5-2.357V30.357C47 29.054 45.882 28 44.5 28S42 29.054 42 30.357v28.286C42 59.946 43.118 61 44.5 61M15.5 60c1.382 0 2.5-1.044 2.5-2.333v-9.334C18 47.043 16.882 46 15.5 46S13 47.044 13 48.333v9.334C13 58.957 14.118 60 15.5 60M72.25 51h22.5c1.244 0 2.25-1.118 2.25-2.5S95.994 46 94.75 46h-22.5C71.006 46 70 47.118 70 48.5s1.006 2.5 2.25 2.5M72.25 60h22.5c1.244 0 2.25-1.118 2.25-2.5S95.994 55 94.75 55h-22.5C71.006 55 70 56.118 70 57.5s1.006 2.5 2.25 2.5M35.5 60c1.382 0 2.5-1.029 2.5-2.3V39.3c0-1.272-1.118-2.3-2.5-2.3S33 38.028 33 39.3v18.4c0 1.271 1.118 2.3 2.5 2.3M53.5 60c1.382 0 2.5-1.051 2.5-2.35v-42.3c0-1.298-1.118-2.35-2.5-2.35S51 14.052 51 15.35v42.3C51 58.95 52.118 60 53.5 60M25.5 60c1.382 0 2.5-1.006 2.5-2.25v-22.5c0-1.244-1.118-2.25-2.5-2.25S23 34.006 23 35.25v22.5c0 1.244 1.118 2.25 2.5 2.25",
    mask: "url(#hsh6hgeuhd)"
  }))))));
}

function LightBulb(props) {
  var _props$width, _props$height, _props$color, _props$color2, _props$color3, _props$color4;
  return React$4.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 56,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 48,
    viewBox: "0 0 56 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, React$4.createElement("defs", null, React$4.createElement("path", {
    id: "a",
    d: "M0 47.063h55.092V0H0z"
  })), React$4.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React$4.createElement("path", {
    d: "m12.17 34.419 40.971.14-7.01-18.62H19.306l-7.137 18.48Zm42.125 1.738h-.003l-43.136-.147a.797.797 0 0 1-.771-.992.795.795 0 0 1 .03-.48l7.601-19.684a.797.797 0 0 1 .744-.51h27.922c.332 0 .629.205.746.516L55.04 35.08a.797.797 0 0 1-.746 1.078Z",
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY
  }), React$4.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, React$4.createElement("use", {
    xlinkHref: "#a"
  })), React$4.createElement("path", {
    fill: (_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : Colors.GREY,
    mask: "url(#b)",
    d: "M31.86 46.032h1.594v-8.157H31.86z"
  }), React$4.createElement("path", {
    fill: (_props$color3 = props.color) !== null && _props$color3 !== void 0 ? _props$color3 : Colors.GREY,
    mask: "url(#b)",
    d: "M24.079 47.063h17.344V45.47H24.08zM39.287 17.603l-.444-1.586 1.535-.43.444 1.586zM40.42 22.23l-.191-.773c-.114-.462-.224-.86-.331-1.245-.1-.36-.195-.701-.286-1.07l-.19-.774 1.548-.382.19.775c.086.346.177.676.274 1.025.11.396.224.805.343 1.29l.191.773-1.548.382ZM42.415 30.514l-1.88-7.627 1.548-.381 1.88 7.626zM43.715 35.79l-1.145-4.646 1.548-.381 1.145 4.645zM24.816 23.556l-1.563-.312 1.7-8.505 1.563.313zM23.72 28.943l-1.555-.349 1.038-4.63 1.556.349zM22.33 36l-1.564-.313 1.207-6.038 1.563.313zM31.93 35.622 31.93 14.88h1.594l.002 20.742zM25.157 14.16l-.208-.77a9.118 9.118 0 0 0-.13-.434l-.246-.759 1.517-.492.246.759c.054.167.105.338.152.51l.208.769-1.54.416ZM9.42 24.583l-.602-.523a10.9 10.9 0 0 1-3.755-8.232c0-6.01 4.89-10.901 10.901-10.901 3.729 0 7.16 1.875 9.178 5.016l.43.67-1.34.862-.432-.67a9.277 9.277 0 0 0-7.836-4.283c-5.131 0-9.306 4.174-9.306 9.306a9.307 9.307 0 0 0 3.205 7.029l.602.522-1.045 1.204ZM12.735 26.274l-.742-.29c-.341-.134-.68-.287-1.006-.455l-.71-.365.73-1.418.709.365c.278.143.567.273.858.387l.742.29-.58 1.486ZM14.61 4.22h1.594V0H14.61zM9.454 6.124 7.07 2.317l1.352-.846 2.382 3.807zM22.052 5.573l-1.305-.916 2.64-3.76 1.305.916z"
  }), React$4.createElement("path", {
    fill: (_props$color4 = props.color) !== null && _props$color4 !== void 0 ? _props$color4 : Colors.GREY,
    mask: "url(#b)",
    d: "M6.13 10.084 2.39 7.821l.826-1.364 3.74 2.263zM.001 15.72v-1.595l4.281-.003.001 1.595zM26.527 9.24l-.914-1.306 3.58-2.507.915 1.306zM1.696 24.15l-.59-1.481L5.65 20.86l.59 1.482zM8.57 29.966l-1.454-.654 1.516-3.372 1.454.654zM12.067 4.634l-.914-2.545 1.5-.539.915 2.546zM19.216 4.634l-1.5-.538.913-2.546 1.501.539zM24.664 7.078l-1.221-1.025 1.738-2.072 1.222 1.025zM27.744 11.578l-.34-1.557 2.76-.603.34 1.558zM7.369 7.64 5.63 5.57l1.222-1.025L8.59 6.616zM4.44 12.67l-2.6-.747.44-1.533 2.6.747zM1.317 19.544l-.111-1.59 2.698-.189.11 1.59zM5.135 26.64l-.903-1.314 2.229-1.532.903 1.314zM10.297 38.157h1.595v-3.47h-1.595zM53.422 38.157h1.595v-3.47h-1.595zM13.766 39h2.72v-1.594h-2.72zM17.141 39h3.845v-1.594H17.14v1.595Zm4.5 0h3.845v-1.594H21.64v1.595Zm4.5 0h3.845v-1.594H26.14v1.595Zm4.5 0h3.845v-1.594H30.64v1.595Zm4.5 0h3.845v-1.594H35.14v1.595Zm4.5 0h3.845v-1.594H39.64v1.595Zm4.5 0h3.845v-1.594H44.14v1.595ZM48.454 39h2.72v-1.594h-2.72zM43.579 20.813h5.344V19.22H43.58zM38.516 20.813h4.22V19.22h-4.22zM20.704 20.813h16.97V19.22h-16.97zM16.579 20.813h2.907V19.22h-2.907zM27.454 27h23.532v-1.594H27.454zM20.891 27h5.345v-1.594H20.89zM14.704 27h5.157v-1.594h-5.157z"
  })));
}

function Cactus(props) {
  var _props$width, _props$height, _props$color, _props$color2;
  return React$4.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 45,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 51,
    viewBox: "0 0 45 51",
    xmlns: "http://www.w3.org/2000/svg"
  }, React$4.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React$4.createElement("g", {
    transform: "translate(.705)"
  }, React$4.createElement("path", {
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    d: "M39.48 23.087a4.854 4.854 0 0 1-4.85 4.848h-7.833c-.672 0-1.217.545-1.217 1.218v19.186h-9.117V7.451a4.564 4.564 0 0 1 4.559-4.558 4.564 4.564 0 0 1 4.558 4.558v14.397c0 .672.545 1.217 1.217 1.217h6.594a1.218 1.218 0 0 0 1.218-1.217v-8.849c0-1.355 1.078-2.472 2.402-2.489a2.419 2.419 0 0 1 1.744.702c.467.461.724 1.077.724 1.733v10.142ZM14.027 38.754H8.48c-.444 0-.875-.06-1.284-.173l.086-.174a.913.913 0 1 0-1.638-.809l-.085.174a4.86 4.86 0 0 1-1.784-2.698l.194-.01a.913.913 0 0 0-.096-1.824l-.241.013v-4.536h.282a.913.913 0 0 0 0-1.826h-.282v-4.247l.116.033a.914.914 0 0 0 1.127-.63.913.913 0 0 0-.63-1.128l-.1-.028a2.424 2.424 0 0 1 2.106-.934l-.045.089a.913.913 0 1 0 1.626.83l.048-.093c.386.441.622 1.023.622 1.657v1.432h-.283a.913.913 0 0 0 0 1.826h.283v6.969c0 .672.545 1.217 1.217 1.217h4.31v4.87Zm28.169-24.537a.913.913 0 0 0 0-1.827h-.315a4.83 4.83 0 0 0-1.417-2.911 4.827 4.827 0 0 0-2.938-1.38l-.033-.367a.914.914 0 0 0-1.819.164l.033.37a4.94 4.94 0 0 0-3.534 4.733v.057h-.283a.913.913 0 0 0 0 1.826h.283v5.748h-4.159v-5.556h.283a.913.913 0 0 0 0-1.827h-.283V8.903h.283a.913.913 0 0 0 0-1.826h-.293a6.98 6.98 0 0 0-2.339-4.85l.194-.285A.913.913 0 1 0 24.35.916l-.194.285a6.95 6.95 0 0 0-3.134-.743c-.822 0-1.612.143-2.345.405l-.156-.305a.913.913 0 0 0-1.626.833l.157.306a7.004 7.004 0 0 0-2.934 4.636l-.34-.01a.913.913 0 1 0-.054 1.825l.304.01v4.38h-.282a.913.913 0 0 0 0 1.826h.282v4.344h-.282a.913.913 0 0 0 0 1.826h.282v4.345h-.282a.913.913 0 0 0 0 1.826h.282v4.744h-3.092v-5.751h.282a.913.913 0 1 0 0-1.826h-.282V22.44c0-1.582-.75-2.999-1.91-3.902l.17-.333a.913.913 0 1 0-1.626-.831l-.17.331a4.769 4.769 0 0 0-1.335-.19c-1.29 0-2.502.497-3.42 1.404-.386.38-.699.815-.935 1.285l-.354-.1A.913.913 0 1 0 .86 21.86l.355.1c-.012.14-.02.282-.02.424v4.506H.914a.913.913 0 0 0 0 1.826h.283v4.664l-.32.017a.913.913 0 0 0 .096 1.824l.34-.018a7.3 7.3 0 0 0 3.155 4.778l-.151.306a.913.913 0 0 0 1.637.809l.151-.306a7.252 7.252 0 0 0 2.375.399h5.55v2.202h-.283a.913.913 0 0 0 0 1.826h.282v3.121h-3.05a1.217 1.217 0 1 0 0 2.435H31.331a1.217 1.217 0 1 0 0-2.435h-3.316v-3.512h.283a.913.913 0 0 0 0-1.826h-.283v-4.857h.283a.913.913 0 0 0 0-1.827h-.283V30.37h5.757l.002.288a.913.913 0 0 0 .913.907h.007a.913.913 0 0 0 .906-.92l-.002-.34a7.289 7.289 0 0 0 4.913-2.926l.3.166a.913.913 0 0 0 .884-1.598l-.298-.165a7.246 7.246 0 0 0 .517-2.695v-2.448h.283a.913.913 0 0 0 0-1.826h-.283v-4.596h.283Z"
  })), React$4.createElement("path", {
    fill: (_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : Colors.GREY,
    d: "M21.86 6.293a1.232 1.232 0 1 0 0 2.464 1.232 1.232 0 0 0 0-2.464M21.86 14.249a1.232 1.232 0 1 0 0 2.464 1.232 1.232 0 0 0 0-2.464M21.86 22.204a1.232 1.232 0 1 0 0 2.464 1.232 1.232 0 0 0 0-2.464M21.86 30.16a1.232 1.232 0 1 0 0 2.464 1.232 1.232 0 0 0 0-2.464M21.86 38.115a1.232 1.232 0 1 0 0 2.465 1.232 1.232 0 0 0 0-2.465"
  })));
}

function WaterGun(props) {
  var _props$width, _props$height, _props$color;
  return React$4.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 59,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 61,
    viewBox: "0 0 59 61",
    xmlns: "http://www.w3.org/2000/svg"
  }, React$4.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-581 -252)"
  }, React$4.createElement("g", {
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY
  }, React$4.createElement("path", {
    d: "M636.054 256.76c-.012.023-.144.237-.927.51-.709.247-1.689.451-2.726.667-.428.09-.876.182-1.337.285.308-.505.644-.95 1.041-1.459.808-1.034 1.762-1.395 2.473-1.395.091 0 .179.006.262.017.37.051.86.234 1.1.819.147.356.132.522.114.555m2.219-1.515c-.536-1.302-1.662-2.161-3.09-2.357-1.81-.249-3.751.641-5.065 2.323-1.128 1.444-1.789 2.484-2.488 4.487a1.261 1.261 0 0 0 1.571 1.618c1.253-.397 2.56-.669 3.714-.909 2.55-.53 4.564-.95 5.367-2.465.411-.775.408-1.682-.01-2.697M584.972 281.32l7.231-7.23 4.022 4.022a3.678 3.678 0 0 1 .002 5.193l-4.635 4.635a4.159 4.159 0 0 1-2.96 1.226 4.16 4.16 0 0 1-2.96-1.226l-.7-.7a4.191 4.191 0 0 1 0-5.92Zm16.245-16.244a4.16 4.16 0 0 1 2.96-1.227 4.16 4.16 0 0 1 2.96 1.227l.7.699a4.191 4.191 0 0 1 0 5.92l-.257.257a3.678 3.678 0 0 1-5.194-.001l-4.022-4.022 2.853-2.853Zm17.337 23.184a2.69 2.69 0 0 1-.513 3.088l-4.72 4.72-.997-2.05 2.519-2.518a1.261 1.261 0 0 0-1.784-1.784l-1.902 1.903-.94-1.931 6.063-6.063 2.274 4.635Zm-3.908 17.15-3.742 3.742a.54.54 0 0 1-.482.155.541.541 0 0 1-.406-.304l-6.255-12.86 4.57-4.569 6.421 13.204a.554.554 0 0 1-.106.633Zm6.606-40.878 2.123-2.123 2.594 2.594-2.123 2.123-2.594-2.594Zm-25.644 4.408c.075 0 .22.019.343.142l4.652 4.652a6.202 6.202 0 0 0 8.761 0l.256-.255 8.101-8.102a.57.57 0 0 1 .81 0l5.81 5.811a.573.573 0 0 1 0 .809l-27.144 27.144a.76.76 0 0 1-.895.135l-7.26-3.819a.749.749 0 0 1-.4-.56.749.749 0 0 1 .215-.655l9.152-9.152a6.203 6.203 0 0 0 0-8.761l-4.652-4.652a.483.483 0 0 1 0-.686l1.908-1.909a.483.483 0 0 1 .343-.142Zm-11.72 20.783a6.657 6.657 0 0 0 3.997 1.924l-.811.811a3.255 3.255 0 0 0-.926 2.817 3.255 3.255 0 0 0 1.72 2.414l7.26 3.82a3.273 3.273 0 0 0 3.853-.585l2.893-2.894 5.874 12.076a3.08 3.08 0 0 0 2.763 1.73c.809 0 1.596-.32 2.177-.9l3.741-3.742a3.077 3.077 0 0 0 .591-3.52l-2.532-5.206 5.336-5.336a5.212 5.212 0 0 0 .994-5.982l-2.654-5.41 7.96-7.96a3.097 3.097 0 0 0 0-4.375l-.495-.495 2.126-2.127a2.502 2.502 0 0 0 .738-1.78c0-.673-.262-1.305-.738-1.78l-2.6-2.6a2.502 2.502 0 0 0-1.78-.738c-.673 0-1.305.262-1.78.738l-2.295 2.294a3.09 3.09 0 0 0-1.174-.23c-.827 0-1.604.322-2.188.907l-4.398 4.398a6.677 6.677 0 0 0-1.92-4l-.699-.7a6.665 6.665 0 0 0-4.744-1.965 6.665 6.665 0 0 0-4.743 1.965l-3.194 3.193a2.987 2.987 0 0 0-2.759.814l-1.908 1.908a2.987 2.987 0 0 0-.813 2.76l-7.571 7.57a6.716 6.716 0 0 0 0 9.487l.699.7Z"
  }), React$4.createElement("path", {
    d: "M602.007 289.04a1.26 1.26 0 1 0-1.784-1.782l-5.276 5.276a1.261 1.261 0 0 0 1.784 1.783l5.276-5.276ZM630.369 264.842c.181 0 .365-.039.54-.122.308-.146.896-.215 1.309-.153a1.261 1.261 0 0 0 .372-2.495c-.916-.136-2 .009-2.762.37a1.261 1.261 0 0 0 .54 2.4M625.565 258.997a1.262 1.262 0 0 0 1.527-.92c.223-.9.181-1.994-.107-2.786a1.26 1.26 0 1 0-2.37.86c.116.322.13.913.03 1.319a1.26 1.26 0 0 0 .92 1.527"
  }))));
}

function Bus(props) {
  var _props$width, _props$height, _props$color, _props$color2;
  return React$4.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 71,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 34,
    viewBox: "0 0 71 34"
  }, React$4.createElement("g", {
    fill: "none",
    transform: "translate(-452 -266)"
  }, React$4.createElement("g", {
    transform: "translate(452.754 266.077)"
  }, React$4.createElement("path", {
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    d: "M66.274 24.378c.007.643-.579.976-1.162 1.02-.67.05-2.868.212-4.803.305-.39-2.977-2.937-5.284-6.018-5.284-3.082 0-5.63 2.309-6.02 5.287-5.624.063-13.451.137-19.67.137-2.784 0-5.009-.015-6.642-.044-.364-3.005-2.926-5.342-6.027-5.342-3.03 0-5.54 2.231-5.995 5.135-2.935-.149-6.6-.45-6.689-.456-.255-.01-.845-.104-.832-.765.01-.466.838-.84 1.034-.905l.852-.268-.007-.893a785.694 785.694 0 0 1-.009-7.632l62.055 4.196-.067 5.51Zm-8.34 2.467c-.041.427-.158.83-.333 1.202a3.662 3.662 0 0 1-3.31 2.108 3.661 3.661 0 0 1-3.316-2.119 3.623 3.623 0 0 1-.233-2.423 3.663 3.663 0 0 1 3.549-2.779 3.664 3.664 0 0 1 3.551 2.789c.068.28.11.57.11.872 0 .118-.007.235-.019.35Zm-38.359.041a3.63 3.63 0 0 1-.333 1.2 3.661 3.661 0 0 1-3.31 2.108c-1.499 0-2.788-.907-3.354-2.2a3.653 3.653 0 0 1-.293-1.208c-.006-.084-.013-.168-.013-.253 0-.331.048-.65.13-.955a3.663 3.663 0 0 1 3.53-2.705 3.664 3.664 0 0 1 3.643 4.013ZM4.351 3.523a1.12 1.12 0 0 1 1.117-1.106h7.269v10.406l-8.443-.571c.017-3.722.044-7.096.057-8.729Zm10.801-1.106h9.607v11.219l-9.607-.65V2.417Zm12.022 0h10.18v12.071l-10.18-.689V2.417Zm12.595 0h10.18V15.34l-10.18-.688V2.417Zm12.595 0h6.041c.795 0 1.813.662 2.122 1.356l5.182 12.632-13.345-.902V2.417Zm10.385.408c-.715-1.61-2.583-2.823-4.344-2.823H5.468a3.541 3.541 0 0 0-3.532 3.501c-.024 3.006-.095 11.895-.062 18.033-.894.505-1.845 1.42-1.873 2.787-.045 2.278 1.862 3.178 3.102 3.224.04.003 3.931.323 6.944.468.664 2.636 3.047 4.594 5.885 4.594 2.768 0 5.105-1.862 5.836-4.398 1.66.03 3.95.047 6.833.047 6.283 0 14.2-.075 19.841-.139.713 2.563 3.062 4.452 5.849 4.452 2.784 0 5.13-1.885 5.847-4.443 2.033-.09 4.445-.268 5.157-.321 1.986-.151 3.413-1.604 3.394-3.427l.085-6.87L62.75 2.825Z"
  })), React$4.createElement("path", {
    fill: (_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : Colors.GREY,
    d: "M507.045 290.792c-.658 0-1.227.361-1.535.893a1.766 1.766 0 0 0-.245.887 1.772 1.772 0 0 0 .88 1.528c.265.157.57.253.9.253.328 0 .63-.095.895-.25a1.776 1.776 0 0 0 .885-1.53 1.76 1.76 0 0 0-.244-.886 1.772 1.772 0 0 0-1.536-.895M468.686 290.815c-.642 0-1.2.339-1.519.844-.173.277-.277.601-.277.952 0 .09.014.176.026.263a1.791 1.791 0 0 0 1.77 1.533 1.794 1.794 0 0 0 1.765-1.486c.017-.101.031-.204.031-.31 0-.34-.1-.655-.264-.926-.315-.52-.88-.87-1.532-.87"
  })));
}

function Construction(props) {
  var _props$width, _props$height, _props$color;
  return React$4.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 99,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 81,
    viewBox: "0 0 99 81"
  }, React$4.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    strokeLinejoin: "round",
    strokeWidth: 4
  }, React$4.createElement("path", {
    d: "m61.263 63.955-7.56 9.3C51.935 75.66 53.705 79 56.75 79h35.5c3.046 0 4.816-3.34 3.046-5.744l-18.06-22.734c-1.492-2.03-4.599-2.03-6.092 0l-5.456 7.418M65 10.5a8.5 8.5 0 1 1-17.001-.001A8.5 8.5 0 0 1 65 10.5zM21.405 41s-4.059 3.94-4.108 4.096L11.135 61.48 7.148 74.732c-.557 1.757.509 3.607 2.38 4.129.335.094 2.728.139 3.063.139 1.522 0 2.93-.932 3.385-2.374l5.513-12.033 6.078-13.353 5.764 10.56 1.674 13.437c0 1.78 1.99 3.426 3.858 3.713 2.382.364 5.137-1.354 5.137-3.523v-14.21c0-1.438-1.175-2.839-2.066-4.008l-5.296-8.592M19 32.684 22.27 27H31l-4.365 6"
  }), React$4.createElement("path", {
    d: "M54 52V38c0-3.416-1.209-10.096-4.09-12l-8.365-6.006c-2.23-1.474-5.31-1.994-8-1.994H20.266c-1.796 0-3.463.636-4.416 2.124L9 30"
  }), React$4.createElement("path", {
    d: "M39 38.652 45 35v12M1 24l71 38"
  })));
}

function Drill(props) {
  var _props$width, _props$height, _props$color;
  return React$4.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 93,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 64,
    viewBox: "0 0 93 64"
  }, React$4.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M49.778 36.813 46 38.75l3.778 3.875V54.25L46 56.188V62h17v-5.812l-3.778-1.938V42.627L63 38.752l-3.778-1.939V31M53 7.8C51.718 5.867 47.073 2 43.387 2H8.782c-4.403 0-.14 5.257 0 7.733.14 2.477-3.038 6.839-5.768 17.4C.284 37.695 3.576 60 6.86 60h9.613c5.687 0 3.605-4.915 1.922-7.733-1.478-2.477 3.846-9.195 3.846-15.467 0-4.269 3.806-5.777 5.767-5.777 1.961 0 .3-.023 9.613-.023 5.154 0 12.016-1.208 15.38-3.867V7.8zM57 27h10v-6m0-7V8H57m10 17 12-1.875v-11.25L67 10M21 2v10m7-10v10m8-10v10m43 5h14"
  }));
}

function Car(props) {
  var _props$width, _props$height, _props$color;
  return React$4.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 64,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 32,
    viewBox: "0 0 64 32"
  }, React$4.createElement("path", {
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 0.585,
    d: "M60.454 21.434c-.436 2.442-.462 2.589-2.541 2.589-2.122 0-3.906.063-4.95.11-.488-2.678-2.833-4.715-5.649-4.715-2.833 0-5.188 2.063-5.656 4.764H20.282v.13c-.414-2.764-2.797-4.894-5.676-4.894-2.833 0-5.188 2.063-5.656 4.764H6.095c-2.825 0-3.049-3.204-3.049-7.393 0-2.428.607-4.425.948-5.354 1.185-.045 3.631-.132 4.506-.132.673 0 1.082-.492 1.978-1.57 1.72-2.067 5.3-6.37 10.44-6.37 1.018 0 2.9-.073 4.893-.151 2.081-.082 4.233-.166 5.427-.166 4.93 0 10.69 4.363 13.648 6.925H31.344v-3.66h-2.046v3.66h-7.03c-3.901 0-4.57-2.747-4.631-3.052l-2.013.37c.3 1.635 2.076 4.728 6.643 4.728h24.819l.007.008.324.056c.062.01 6.266 1.093 8.818 1.731 2.152.538 4.556 3.018 4.623 5.568-.178.782-.298 1.456-.404 2.054m-13.14 7.432c-2.04 0-3.7-1.66-3.7-3.701 0-2.041 1.66-3.7 3.7-3.7s3.7 1.659 3.7 3.7c0 2.04-1.66 3.7-3.7 3.7m-32.708 0c-2.04 0-3.7-1.66-3.7-3.7 0-2.041 1.66-3.7 3.7-3.7s3.7 1.659 3.7 3.7c0 2.04-1.66 3.7-3.7 3.7m42.126-17.038c-2.316-.578-7.323-1.473-8.646-1.706C46.574 8.64 38.436 1 31.238 1c-1.234 0-3.406.085-5.507.167-1.972.077-3.835.15-4.813.15-6.1 0-10.093 4.801-12.013 7.108-.256.308-.539.648-.715.834-1.451.02-4.785.151-4.937.157l-.62.025-.265.562C2.312 10.12 1 12.953 1 16.789c0 3.759 0 9.439 5.095 9.439h2.867c.5 2.662 2.839 4.684 5.644 4.684 2.879 0 5.262-2.13 5.676-4.895v.21H41.67c.5 2.663 2.84 4.685 5.644 4.685 2.822 0 5.17-2.046 5.651-4.73 1.01-.047 2.818-.113 4.948-.113 3.793 0 4.096-1.701 4.555-4.276.108-.605.23-1.29.41-2.074l.027-.114v-.117c0-3.659-3.192-6.915-6.173-7.66"
  }));
}

function House(props) {
  var _props$width, _props$height, _props$color;
  return React$4.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 38,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 38,
    viewBox: "0 0 38 38"
  }, React$4.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    strokeLinejoin: "round",
    strokeWidth: 1.17
  }, React$4.createElement("path", {
    strokeLinecap: "round",
    d: "M1 16.21 19.135 1 37.27 16.21M27.91 4.51V2.17h5.85v7.02"
  }), React$4.createElement("path", {
    strokeLinecap: "square",
    d: "M4.51 18.55v14.04h5.85V18.55h7.02v14.04h16.38V18.55M10.36 34.93h7.02M9.19 37.27h9.36"
  }), React$4.createElement("path", {
    strokeLinecap: "square",
    d: "M22.06 24.4h5.85v-5.85h-5.85z"
  })));
}

function Parking(props) {
  var _props$width, _props$height, _props$color;
  return React$4.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 135,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 99,
    viewBox: "0 0 135 99"
  }, React$4.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY
  }, React$4.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5,
    d: "M2 49h131M13 2v95M49 2v95M85 2v95"
  }), React$4.createElement("path", {
    fill: "#37424A",
    strokeWidth: 0.3,
    d: "M97.85 20.976h3.458c.363 0 .701.19.9.506.199.315.23.713.085 1.058l-4.241 10.065 10.068-9.396h-2.894c-.341 0-.662-.169-.865-.454a1.149 1.149 0 0 1-.162-.992l3.173-10.673-9.523 9.886zM95.074 38c-.22 0-.44-.07-.63-.211a1.143 1.143 0 0 1-.355-1.353l5.574-13.227h-4.41c-.436 0-.828-.272-.994-.69a1.148 1.148 0 0 1 .233-1.216l14.425-14.976c.35-.363.892-.432 1.315-.167.423.265.618.795.473 1.286l-4.023 13.53h4.242c.445 0 .844.285 1.004.717.16.432.046.92-.285 1.23l-15.85 14.79a1.05 1.05 0 0 1-.719.287zM61.85 74.976h3.458c.363 0 .701.19.9.506.199.315.23.713.085 1.058l-4.241 10.065 10.068-9.396h-2.894c-.341 0-.662-.169-.865-.454a1.149 1.149 0 0 1-.162-.992l3.173-10.673-9.523 9.886zM59.074 92c-.22 0-.44-.07-.63-.211a1.143 1.143 0 0 1-.355-1.353l5.574-13.227h-4.41c-.436 0-.828-.272-.994-.69a1.148 1.148 0 0 1 .233-1.216l14.425-14.976c.35-.363.892-.432 1.315-.167.423.265.618.795.473 1.286l-4.023 13.53h4.242c.445 0 .844.285 1.004.717.16.432.046.92-.285 1.23l-15.85 14.79a1.05 1.05 0 0 1-.719.287z"
  }), React$4.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5,
    d: "M121 2v95M33.326 40h-3.652C25.437 40 22 38.14 22 33.98V12.457C22 7.787 25.858 4 30.616 4h1.768C37.144 4 41 7.787 41 12.457V33.98c0 4.16-3.435 6.02-7.674 6.02z"
  }), React$4.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5,
    d: "M36 15.54s-1.361-1.24-4.5-1.24c-2.695 0-4.5 1.4-4.5 1.4M35 31h-7"
  }), React$4.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5,
    d: "M33.326 40h-3.652C25.437 40 22 38.14 22 33.98V12.457C22 7.787 25.858 4 30.616 4h1.768C37.144 4 41 7.787 41 12.457V33.98c0 4.16-3.435 6.02-7.674 6.02z"
  }), React$4.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5,
    d: "M36 15.54s-1.361-1.24-4.5-1.24c-2.695 0-4.5 1.4-4.5 1.4M35 31h-7M65.674 4h3.652C73.565 4 77 5.861 77 10.02v21.523C77 36.213 73.142 40 68.384 40h-1.768C61.858 40 58 36.213 58 31.543V10.02C58 5.86 61.435 4 65.674 4z"
  }), React$4.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5,
    d: "M63 29.461s1.361 1.238 4.5 1.238c2.695 0 4.5-1.398 4.5-1.398M64 14h7m33.326 80h-3.652C96.435 94 93 92.14 93 87.98V66.457c0-4.67 3.856-8.457 8.616-8.457h1.768c4.758 0 8.616 3.787 8.616 8.457V87.98c0 4.16-3.437 6.02-7.674 6.02z"
  }), React$4.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5,
    d: "M107 69.54s-1.363-1.24-4.5-1.24c-2.697 0-4.5 1.4-4.5 1.4m8 15.3h-7M29.674 58h3.652C37.565 58 41 59.861 41 64.02v21.523C41 90.213 37.144 94 32.384 94h-1.768C25.858 94 22 90.213 22 85.543V64.02c0-4.16 3.437-6.02 7.674-6.02z"
  }), React$4.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5,
    d: "M27 83.461s1.363 1.238 4.5 1.238c2.697 0 4.5-1.398 4.5-1.398M28 68h7"
  })));
}

function ParkingClock(props) {
  var _props$width, _props$height, _props$color, _props$color2;
  return React$4.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 88,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 87,
    viewBox: "0 0 88 87"
  }, React$4.createElement("g", {
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    fillRule: "evenodd",
    stroke: (_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : Colors.GREY,
    strokeWidth: 2
  }, React$4.createElement("path", {
    d: "M66 76.696v-30.57a1.008 1.008 0 1 0-2.016-.001v30.57c0 4.02-3.27 7.29-7.288 7.29H10.304c-4.018 0-7.288-3.27-7.288-7.29v-46.39c0-4.02 3.27-7.289 7.288-7.289h30.833a1.008 1.008 0 0 0 0-2.016H10.304C5.174 21 1 25.174 1 30.304v46.392C1 81.826 5.174 86 10.304 86h46.392C61.826 86 66 81.826 66 76.696"
  }), React$4.createElement("path", {
    d: "M40.963 46.124v1.752c0 1.685-1.349 3.055-3.007 3.055h-6.92V43.07h6.92c1.658 0 3.007 1.37 3.007 3.055zM30.018 41c-.562 0-1.018.463-1.018 1.034v9.932c0 .57.456 1.034 1.018 1.034h7.938C40.737 53 43 50.701 43 47.876v-1.752C43 43.299 40.737 41 37.956 41h-7.938z"
  }), React$4.createElement("path", {
    d: "M48.97 44.404v4.324c0 5.177-4.244 9.389-9.46 9.389h-9.826c-.56 0-1.015.451-1.015 1.007v12.86H22.03v-36.97h17.48c5.216 0 9.46 4.213 9.46 9.39zM21.015 33c-.56 0-1.015.451-1.015 1.008v38.984c0 .557.455 1.008 1.015 1.008h8.669c.56 0 1.015-.451 1.015-1.008v-12.86h8.81C45.846 60.132 51 55.016 51 48.728v-4.324C51 38.116 45.845 33 39.51 33H21.015zM50.982 20c0-9.384 7.635-17.018 17.019-17.018 9.383 0 17.017 7.634 17.017 17.018S77.384 37.018 68 37.018c-9.383 0-17.018-7.634-17.018-17.018M87 20C87 9.523 78.477 1 68 1 57.525 1 49 9.523 49 20s8.524 19 19 19c10.477 0 19-8.523 19-19"
  }), React$4.createElement("path", {
    d: "M79 22.968c0-.57-.49-1.033-1.094-1.033H67.189V9.032c0-.57-.49-1.032-1.095-1.032C65.49 8 65 8.462 65 9.032v13.936c0 .57.49 1.032 1.094 1.032h11.812C78.51 24 79 23.538 79 22.968"
  })));
}

function Partner(props) {
  var _props$width, _props$height, _props$color;
  return React$4.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 73,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 75,
    viewBox: "0 0 73 75"
  }, React$4.createElement("g", {
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    fillRule: "nonzero"
  }, React$4.createElement("path", {
    d: "M24.409 37.886c8.762-3.415 9.844-4.802 10.194-5.929.044-.145.068-.3.068-.45v-1.373a1.51 1.51 0 0 0-.433-1.06c-.74-.757-1.319-1.827-1.671-3.09a1.53 1.53 0 0 0-.587-.833.693.693 0 0 1-.285-.474.698.698 0 0 1 .157-.552c.222-.272.34-.607.34-.957v-3.074c0-2.54 1.445-3.827 4.29-3.827 2.926 0 4.29 1.215 4.29 3.827v3.074c0 .35.118.688.34.957a.692.692 0 0 1 .158.552.693.693 0 0 1-.285.474 1.53 1.53 0 0 0-.587.833c-.352 1.263-.93 2.333-1.672 3.09a1.514 1.514 0 0 0-.432 1.06v1.373c0 .154.023.305.068.453.356 1.13 1.44 2.52 10.197 5.926v2.526H24.41v-2.526zm-.555 5.561h25.26c1.37 0 2.48-1.117 2.48-2.493v-3.436c0-1.022-.64-1.956-1.588-2.327-.003 0-.003 0-.006-.003-6.741-2.602-8.345-3.803-8.67-4.075v-.398c.794-.949 1.425-2.128 1.855-3.456a3.763 3.763 0 0 0 1.094-2.167 3.7 3.7 0 0 0-.472-2.39v-2.608c0-4.298-2.739-6.863-7.325-6.863-4.517 0-7.325 2.63-7.325 6.863v2.608c-.42.72-.586 1.55-.468 2.39.113.83.504 1.594 1.091 2.167.43 1.328 1.061 2.505 1.856 3.456v.344c-.469.445-2.212 1.63-8.677 4.132a2.48 2.48 0 0 0-1.586 2.327v3.436a2.488 2.488 0 0 0 2.481 2.493zm26.291 9.107H22.763a1.517 1.517 0 1 0 0 3.035h27.382a1.517 1.517 0 1 0 0-3.035m-3.035 6.071H25.799a1.516 1.516 0 1 0 0 3.035h21.31a1.517 1.517 0 1 0 .001-3.035"
  }), React$4.createElement("path", {
    d: "M57.675 69.19a1.52 1.52 0 0 1-1.518 1.517H16.695a1.52 1.52 0 0 1-1.518-1.517V5.444c0-.836.682-1.518 1.518-1.518h39.462c.836 0 1.518.682 1.518 1.518V69.19zM56.157.89H16.695a4.56 4.56 0 0 0-4.553 4.554V69.19a4.558 4.558 0 0 0 4.553 4.553h39.462a4.558 4.558 0 0 0 4.553-4.553V5.444A4.558 4.558 0 0 0 56.157.891zM4.553 9.997H7.59a1.517 1.517 0 1 0 0-3.035H4.553A4.558 4.558 0 0 0 0 11.515V63.12a4.559 4.559 0 0 0 4.553 4.553H7.59a1.517 1.517 0 1 0 0-3.036H4.553a1.52 1.52 0 0 1-1.517-1.517V11.515a1.52 1.52 0 0 1 1.517-1.518m63.746-3.035h-3.036c-.839 0-1.517.68-1.517 1.517 0 .84.678 1.518 1.517 1.518H68.3c.836 0 1.518.682 1.518 1.518V63.12a1.52 1.52 0 0 1-1.518 1.517h-3.036a1.517 1.517 0 1 0 0 3.036H68.3a4.559 4.559 0 0 0 4.553-4.553V11.515A4.558 4.558 0 0 0 68.3 6.962"
  })));
}

function Cable(props) {
  var _props$width, _props$height, _props$color;
  return React$4.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 79,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 78,
    viewBox: "0 0 79 78"
  }, React$4.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M69 8V5a3 3 0 0 1 6 0v3M10 8V5a3 3 0 1 0-6 0v3m64 9h9V8h-9zM2 17h9V8H2zm75 0c0 3.803-1.728 6.51-4.5 10-2.772-3.49-4.5-6.197-4.5-10M2 17c0 3.803 1.728 6.51 4.5 10 2.772-3.49 4.5-6.197 4.5-10M7 27v26.603C7 63.379 10.54 76 24.582 76c28.33 0 35.92-44.545 14.918-44.545C18.498 31.455 26.088 76 54.417 76 68.46 76 72 63.379 72 53.603V27"
  }));
}

function Quote(props) {
  var _props$width, _props$height, _props$color;
  return React$4.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 69,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 75,
    viewBox: "0 0 69 75"
  }, React$4.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M11 15h10m-9 8h31M12 33h31m-31 9h31M30 58h12m9.524-46.74H67V9.718C67 5.454 63.536 2 59.262 2c-4.275 0-7.738 3.454-7.738 7.717v60.196L46.556 73l-4.971-3.087L36.623 73l-4.949-3.087L26.719 73l-4.95-3.087L16.823 73l-4.952-3.087L6.937 73 2 69.913V9.717C2 5.454 5.464 2 9.738 2h49.524"
  }));
}

function Offices(props) {
  var _props$width, _props$height, _props$color;
  return React$4.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 119,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 97,
    viewBox: "0 0 119 97"
  }, React$4.createElement("g", {
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1.5
  }, React$4.createElement("path", {
    d: "M45 19.815C45 18.26 43.657 17 42 17s-3 1.26-3 2.815v7.37C39 28.74 40.343 30 42 30s3-1.26 3-2.815v-7.37zm-14 0C31 18.26 29.657 17 28 17s-3 1.26-3 2.815v7.37C25 28.74 26.343 30 28 30s3-1.26 3-2.815v-7.37zm14 23C45 41.26 43.657 40 42 40s-3 1.26-3 2.815v7.37C39 51.74 40.343 53 42 53s3-1.26 3-2.815v-7.37zm-14 0C31 41.26 29.657 40 28 40s-3 1.26-3 2.815v7.37C25 51.74 26.343 53 28 53s3-1.26 3-2.815v-7.37zM42 63c-1.657 0-3 1.26-3 2.815v7.37C39 74.74 40.343 76 42 76s3-1.26 3-2.814v-7.371C45 64.26 43.657 63 42 63m-14 0c-1.657 0-3 1.26-3 2.815v7.37C25 74.74 26.343 76 28 76s3-1.26 3-2.814v-7.371C31 64.26 29.657 63 28 63"
  }), React$4.createElement("path", {
    d: "M56.279 83C57.782 83 59 81.795 59 80.307V3.693C59 2.205 57.782 1 56.279 1H11.72C10.218 1 9 2.205 9 3.693v76.614C9 81.795 10.218 83 11.721 83c1.503 0 2.721-1.205 2.721-2.693V6.385h39.116v73.922c0 1.488 1.218 2.693 2.72 2.693M78 53c1.657 0 3-1.26 3-2.815v-7.37C81 41.26 79.657 40 78 40s-3 1.26-3 2.814v7.371C75 51.74 76.343 53 78 53m14 0c1.657 0 3-1.26 3-2.815v-7.37C95 41.26 93.657 40 92 40s-3 1.26-3 2.814v7.371C89 51.74 90.343 53 92 53M75 73.185C75 74.74 76.343 76 78 76s3-1.26 3-2.815v-7.37C81 64.26 79.657 63 78 63s-3 1.26-3 2.815v7.37zm14 0C89 74.74 90.343 76 92 76s3-1.26 3-2.815v-7.37C95 64.26 93.657 63 92 63s-3 1.26-3 2.815v7.37zM1 93c0 1.657 1.243 3 2.778 3h111.444c1.535 0 2.778-1.343 2.778-3s-1.243-3-2.778-3H3.778C2.243 90 1 91.343 1 93"
  }), React$4.createElement("path", {
    d: "M66 27.726a2.733 2.733 0 0 0 2.74 2.726h34.78v49.822A2.733 2.733 0 0 0 106.26 83c1.513 0 2.74-1.22 2.74-2.726V27.726A2.733 2.733 0 0 0 106.26 25H68.74A2.733 2.733 0 0 0 66 27.726"
  })));
}

function ShoppingCart(props) {
  var _props$width, _props$height, _props$color, _props$color2, _props$color3, _props$color4;
  return React$4.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 89,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 78,
    viewBox: "0 0 89 78"
  }, React$4.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React$4.createElement("g", null, React$4.createElement("path", {
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    d: "M82.185 59H32.23c-3.608 0-6.786-2.58-7.555-6.133L15.133 8.858c-.655-3.011-3.347-5.197-6.405-5.197H1.815A1.823 1.823 0 0 1 0 1.83 1.82 1.82 0 0 1 1.815 0h6.913c4.75 0 8.936 3.396 9.95 8.076l9.541 44.008c.41 1.886 2.096 3.255 4.01 3.255h49.956c1.003 0 1.815.819 1.815 1.83A1.822 1.822 0 0 1 82.185 59"
  })), React$4.createElement("path", {
    fill: (_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : Colors.GREY,
    d: "M76.243 47h-51.02c-1.01 0-1.829-.805-1.829-1.8 0-.994.818-1.8 1.829-1.8h51.02c2.69 0 5.001-1.889 5.494-4.493l3.537-18.675a3.861 3.861 0 0 0-.85-3.22 3.992 3.992 0 0 0-3.06-1.413H18.828c-1.01 0-1.828-.804-1.828-1.8 0-.994.818-1.799 1.828-1.799h62.536c2.276 0 4.417.99 5.872 2.714a7.408 7.408 0 0 1 1.634 6.179l-3.537 18.675c-.818 4.306-4.64 7.432-9.09 7.432"
  }), React$4.createElement("g", {
    transform: "translate(29 64)"
  }, React$4.createElement("path", {
    fill: (_props$color3 = props.color) !== null && _props$color3 !== void 0 ? _props$color3 : Colors.GREY,
    d: "M7 3.54C5.09 3.54 3.54 5.09 3.54 7A3.464 3.464 0 0 0 7 10.46 3.465 3.465 0 0 0 10.46 7 3.464 3.464 0 0 0 7 3.54M7 14c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7"
  })), React$4.createElement("g", {
    transform: "translate(63 64)"
  }, React$4.createElement("path", {
    fill: (_props$color4 = props.color) !== null && _props$color4 !== void 0 ? _props$color4 : Colors.GREY,
    d: "M7 3.54C5.09 3.54 3.54 5.09 3.54 7A3.464 3.464 0 0 0 7 10.46 3.465 3.465 0 0 0 10.46 7 3.464 3.464 0 0 0 7 3.54M7 14c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7"
  }))));
}

function Diagram(props) {
  var _props$width, _props$height, _props$color;
  return React$4.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 95,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 74,
    viewBox: "0 0 95 74",
    xmlns: "http://www.w3.org/2000/svg"
  }, React$4.createElement("path", {
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY,
    fillRule: "evenodd",
    d: "M93.311 50.248c-.063-.001-6.294-.177-11.152-2.607-1.542-.771-3.105-2.111-4.761-3.53-3.603-3.087-8.088-6.93-14.94-6.93-.153 0-.3.022-.441.06a1.68 1.68 0 0 0-.44-.06c-.198 0-.392.005-.585.01-.255-.94-.474-1.9-.648-2.888C58.008 21.05 54.319 7.386 44.67 6.542a1.645 1.645 0 0 0-.314.002c-.1-.01-.204-.011-.309-.002-9.648.844-13.336 14.507-15.672 27.761-1.093 6.199-3.787 11.483-8.01 15.706-3.157 3.158-6.042 4.515-6.1 4.542a1.73 1.73 0 0 0 1.433 3.149c.137-.062 3.394-1.563 6.995-5.128 3.3-3.266 7.557-8.984 9.087-17.668 2.95-16.729 6.826-24.413 12.57-24.916l.01-.001.01.001c5.744.503 9.62 8.187 12.568 24.916.168.953.37 1.868.6 2.75-4.669 1.12-8.06 4.022-10.902 6.457-1.656 1.419-3.22 2.759-4.761 3.53-4.858 2.43-11.09 2.606-11.152 2.607a1.73 1.73 0 0 0 .039 3.459h.04c.285-.006 7.054-.188 12.62-2.972 1.92-.96 3.642-2.435 5.463-3.996 2.828-2.423 5.735-4.912 9.69-5.778 1.997 5.376 4.989 9.175 7.45 11.611 3.601 3.565 6.858 5.066 6.995 5.128a1.724 1.724 0 0 0 2.285-.857 1.733 1.733 0 0 0-.851-2.292c-.03-.013-2.928-1.368-6.101-4.542a28.059 28.059 0 0 1-6.216-9.398c.104.019.21.03.32.03 5.575 0 9.193 3.1 12.692 6.098 1.821 1.56 3.542 3.035 5.463 3.996 5.566 2.784 12.335 2.966 12.62 2.972h.04a1.73 1.73 0 0 0 .039-3.459m-.907 20.292H86.45v-3.239a1.73 1.73 0 1 0-3.458 0v3.24H69.687V67.3a1.73 1.73 0 1 0-3.458 0v3.24H52.926V67.3a1.73 1.73 0 1 0-3.458 0v3.24H36.164V67.3a1.73 1.73 0 1 0-3.458 0v3.24H19.404V67.3a1.73 1.73 0 1 0-3.458 0v3.24H3.458v-9.42h3.045a1.729 1.729 0 1 0 0-3.459H3.458V48.82h3.045a1.73 1.73 0 0 0 0-3.46H3.458v-8.842h3.045a1.73 1.73 0 0 0 0-3.46H3.458v-8.84h3.045a1.73 1.73 0 0 0 0-3.46H3.458v-8.842h3.045a1.73 1.73 0 0 0 0-3.46H3.458V1.73A1.73 1.73 0 1 0 0 1.73v70.54C0 73.225.774 74 1.729 74h90.675a1.73 1.73 0 0 0 0-3.46"
  }));
}

function Invoice(props) {
  var _props$width, _props$width2, _props$color;
  return React$4.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 39,
    height: (_props$width2 = props.width) !== null && _props$width2 !== void 0 ? _props$width2 : 43,
    viewBox: "0 0 39 43"
  }, React$4.createElement("path", {
    d: "M2 0.5C0.895431 0.5 0 1.39543 0 2.5V37.5C0 38.6046 0.895431 39.5 2 39.5H24V36.5H3V3.5H18V12.5H27V15.5H30V12.0707C30 11.6921 29.9464 11.3155 29.8409 10.9519V10.9519C29.6501 10.2949 29.2946 9.69755 28.808 9.21664L21.6407 2.13321C21.2162 1.71371 20.7281 1.36403 20.1943 1.09714V1.09714C19.4089 0.704445 18.5428 0.5 17.6647 0.5H2ZM21 5.6L24.9 9.5H21V5.6ZM6 15.5V18.5H24V15.5H6ZM31.5 18.5V21.5C28.95 21.95 27 24.05 27 26.75C27 29.75 29.25 32 32.25 32H33.75C34.95 32 36 33.05 36 34.25C36 35.45 34.95 36.5 33.75 36.5H28.5V39.5H31.5V42.5H34.5V39.5C37.05 39.05 39 36.95 39 34.25C39 31.25 36.75 29 33.75 29H32.25C31.05 29 30 27.95 30 26.75C30 25.55 31.05 24.5 32.25 24.5H37.5V21.5H34.5V18.5H31.5ZM6 23V26H16.5V23H6ZM19.5 23V26H24V23H19.5ZM6 29V32H16.5V29H6ZM19.5 29V32H24V29H19.5Z",
    fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY
  }));
}

function CustomIcon(props) {
  var renderCustomIcon = function renderCustomIcon() {
    switch (props.name) {
      case 'Heart':
        return React$4.createElement(Heart, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'Portal':
        return React$4.createElement(Portal, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'Earth':
        return React$4.createElement(Earth, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'CarHouse':
        return React$4.createElement(CarHouse, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'App':
        return React$4.createElement(App, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'LightBulb':
        return React$4.createElement(LightBulb$1, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'Graph':
        return React$4.createElement(Graph, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'Solar':
        return React$4.createElement(LightBulb, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'Battery':
        return React$4.createElement(Battery, {
          height: props.height,
          width: props.width,
          color: props.color,
          colorBattery: props.colorBattery
        });
      case 'Cactus':
        return React$4.createElement(Cactus, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'WaterGun':
        return React$4.createElement(WaterGun, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'Bus':
        return React$4.createElement(Bus, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'Construction':
        return React$4.createElement(Construction, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'Drill':
        return React$4.createElement(Drill, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'Car':
        return React$4.createElement(Car, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'House':
        return React$4.createElement(House, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'Parking':
        return React$4.createElement(Parking, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'ParkingClock':
        return React$4.createElement(ParkingClock, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'Partner':
        return React$4.createElement(Partner, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'Cable':
        return React$4.createElement(Cable, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'Quote':
        return React$4.createElement(Quote, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'Offices':
        return React$4.createElement(Offices, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'ShoppingCart':
        return React$4.createElement(ShoppingCart, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'Diagram':
        return React$4.createElement(Diagram, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      case 'Invoice':
        return React$4.createElement(Invoice, {
          height: props.height,
          width: props.width,
          color: props.color
        });
      default:
        return React$4.createElement(Icon, {
          height: props.height,
          width: props.width,
          color: props.color,
          name: props.name,
          iconSet: props.iconSet
        });
    }
  };
  return renderCustomIcon();
}

function ChargeCard(props) {
  var _props$borderRadius;
  var _Lang$useTranslation = Lang.useTranslation(),
      _ = _Lang$useTranslation._;
  return React__default.createElement("svg", {
    viewBox: "0 0 5278 3334",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
      boxShadow: props.shadow ? '0px 0px 20px 3px rgba(137,139,143,0.2)' : 'inherit',
      borderRadius: (_props$borderRadius = props.borderRadius) !== null && _props$borderRadius !== void 0 ? _props$borderRadius : 0
    }
  }, React__default.createElement("path", {
    style: {
      fill: '#ffffff'
    },
    d: "M0 0h4722.22v3333.33H0z"
  }), React__default.createElement("path", {
    style: {
      fill: '#0098db'
    },
    d: "M4722.22 0h555.556v3333.33H4722.22z"
  }), React__default.createElement("path", {
    d: "M4166.67 0H0v2777.78h3944.45a222.219 222.219 0 0 0 157.134-65.088 222.22 222.22 0 0 0 65.088-157.135V.007Z",
    style: {
      fill: '#e5f4fb'
    }
  }), React__default.createElement("text", {
    x: 939.611,
    y: 665.509,
    style: {
      fontFamily: 'Museo-Sans',
      fontWeight: 700,
      fontSize: '388.889px'
    }
  }, _('chargeCard', {
    ns: 'ui'
  })), React__default.createElement("path", {
    d: "M3625.78 1166.66c0-122.724-99.488-222.212-222.212-222.212H763.098c-122.724 0-222.211 99.488-222.211 222.212v.022c0 122.724 99.487 222.211 222.211 222.211h2640.47c122.724 0 222.212-99.487 222.212-222.211v-.022Z",
    style: {
      fill: '#0098db'
    }
  }), React__default.createElement("text", {
    x: 1186.77,
    y: 1227.96,
    style: {
      fontFamily: 'Museo-Sans',
      fontWeigth: 500,
      fontSize: '188.889px',
      fill: '#fff'
    }
  }, props.serial), React__default.createElement("text", {
    x: 8072.28,
    y: 1893.53,
    style: {
      fontFamily: 'Caveat',
      fontSize: '266.667px',
      fill: '#fff'
    },
    transform: "rotate(90 7017.47 -207.78)"
  }, _('pppsstIamHere', {
    ns: 'ui'
  })), React__default.createElement("path", {
    d: "M5143.7 460.917c0 42.861-21.908 65.269-41.161 75.559-23.608 12.608-50.524 19.89-79.177 19.89-92.258 0-167.072-74.787-167.072-167.072s74.814-167.072 167.072-167.072c28.653 0 55.569 7.282 79.177 19.926 19.253 10.254 41.161 32.662 41.161 75.523v143.246Zm-44.451-9.337V327.006c0-21.871-17.835-39.698-39.707-39.698h-92.785c-21.908 0-39.698 17.827-39.698 39.698V451.58c0 21.908 17.79 39.698 39.698 39.698h23.971v-21.662h-23.971c-9.945 0-18.035-8.1-18.035-18.036V327.006c0-9.936 8.09-18.035 18.035-18.035h92.785c9.945 0 18.036 8.099 18.036 18.035V451.58c0 9.936-8.091 18.036-18.036 18.036h-19.989v21.662h19.989c21.872 0 39.707-17.79 39.707-39.698Zm-100.112-22.235v-88.24h-21.653v88.24c0 5.973 4.827 10.836 10.79 10.836 6 0 10.863-4.863 10.863-10.836Zm49.679 0v-88.24h-21.663v88.24c0 5.973 4.873 10.836 10.836 10.836s10.827-4.863 10.827-10.836Z",
    style: {
      fill: '#fff'
    }
  }), React__default.createElement("text", {
    x: 355.968,
    y: 3116.99,
    style: {
      fontFamily: 'Museo-Sans',
      fontSize: '111.111px',
      fill: '#ccc'
    }
  }, "+31 (0) 85 04 66 050"), React__default.createElement("text", {
    x: 3633.14,
    y: 3113.76,
    style: {
      fontFamily: 'Museo-Sans',
      fontSize: '111.111px',
      fill: '#ccc'
    }
  }, "bluecurrent.nl"), React__default.createElement("path", {
    d: "M2038.58 2936.36c41.412 0 63.062 21.167 73.005 39.77 12.182 22.809 19.217 48.816 19.217 76.5 0 89.14-72.258 161.425-161.424 161.425-89.166 0-161.425-72.285-161.425-161.425 0-27.684 7.036-53.691 19.253-76.5 9.907-18.603 31.558-39.77 72.97-39.77h138.404Zm-9.021 42.948h-120.364c-21.132 0-38.356 17.233-38.356 38.365v89.649c0 21.167 17.224 38.355 38.356 38.355h120.364c21.167 0 38.355-17.188 38.355-38.355v-23.161h-20.93v23.161c0 9.608-7.825 17.425-17.425 17.425h-120.364c-9.6 0-17.425-7.817-17.425-17.425v-89.649c0-9.609 7.825-17.426 17.425-17.426h120.364c9.6 0 17.425 7.817 17.425 17.426v19.314h20.93v-19.314c0-21.132-17.188-38.365-38.355-38.365Zm-21.484 96.728h-85.257v20.922h85.257c5.771 0 10.47-4.664 10.47-10.426 0-5.797-4.699-10.496-10.47-10.496Zm0-47.999h-85.257v20.93h85.257c5.771 0 10.47-4.708 10.47-10.47 0-5.761-4.699-10.46-10.47-10.46Z",
    style: {
      fill: '#0098db',
      fillRule: 'nonzero'
    }
  }), React__default.createElement("path", {
    d: "M2205.07 3067.19h41.856c8.594 0 10.965 1.702 10.965 7.816v4.695c0 4.316-1.643 7.188-9.638 7.188h-43.183v-19.699Zm52.417-16.828c0 2.775-.858 6.462-8.19 6.462h-44.227v-17.675h44.672c1.295 0 7.745.25 7.745 5.26v5.953Zm6.069 10.277c3.82-2.016 5.972-5.582 5.972-10.18v-5.606c0-6.018-2.468-16.102-18.969-16.102h-57.531v68.512h58.446c12.519 0 18.5-6.091 18.5-15.472v-7.761c0-6.961-.761-11.438-6.418-13.391ZM2283.08 3028.75h10.941v68.504h-10.941zM2357.12 3075.83c0 8.817-1.958 12.665-20.766 12.665h-1.999c-14.348 0-15.425-3.784-15.425-9.616v-30.815h-10.965v32.711c0 6.429 2.719 17.206 20.766 17.206h11.694c7.655 0 13.474-.952 17.229-5.017v4.291h10.432v-49.191h-10.966v27.766ZM2430.18 3064.64v1.476h-40.212c.793-7.946 3.261-9.301 14.194-9.301h11.411c6.677 0 14.607 1.355 14.607 7.825m-14.607-17.312h-12.487c-11.977 0-24.246 2.396-24.246 20.167v10.027c0 18.127 12.487 20.458 23.332 20.458h14.129c11.573 0 24.845-1.734 24.845-15.327v-2.452h-10.836l-.097 1.476c-.381 5.526-2.752 6.816-12.649 6.816h-10.683c-13.401 0-17.067-2.5-17.067-11.6v-1.299h51.332v-6.743c0-18.958-12.924-21.523-25.573-21.523M2574.21 3077.82c0 7.341-1.991 9.769-13.782 9.769h-31.076c-9.8 0-13.814-3.566-13.814-12.294v-24.547c0-8.761 4.014-12.318 13.814-12.318h30.793c8.376 0 13.434.661 13.434 10.043v4.574h10.966v-7.18c0-14.746-12.042-17.836-22.126-17.836h-33.949c-17.739 0-24.942 7.559-24.942 26.056v17.86c0 18.498 7.203 26.04 24.942 26.04h33.472c19.827 0 23.776-7.567 23.776-19.82v-5.994h-11.508v5.647ZM2646.01 3075.83c0 8.817-1.959 12.665-20.766 12.665h-1.999c-14.349 0-15.425-3.784-15.425-9.616v-30.815h-10.966v32.711c0 6.429 2.687 17.206 20.766 17.206h11.694c7.656 0 13.475-.952 17.23-5.017v4.291h10.431v-49.191h-10.965v27.766ZM2799.2 3064.64v1.476h-40.246c.826-7.946 3.262-9.301 14.195-9.301h11.411c6.676 0 14.64 1.355 14.64 7.825m-14.64-17.312h-12.487c-11.978 0-24.214 2.396-24.214 20.167v10.027c0 18.127 12.455 20.458 23.299 20.458h14.13c11.573 0 24.877-1.734 24.877-15.327v-2.452h-10.868l-.097 1.476c-.381 5.526-2.72 6.816-12.641 6.816h-10.691c-13.369 0-17.035-2.5-17.035-11.6v-1.299h51.332v-6.743c0-18.958-12.924-21.523-25.605-21.523M2859.89 3047.34h-11.662c-7.688 0-13.466.944-17.261 5.01v-4.284h-10.4v49.192h10.934v-27.766c0-8.817 1.958-12.665 20.774-12.665h2.023c14.348 0 15.425 3.815 15.425 9.607v30.824h10.933v-32.711c0-6.429-2.687-17.207-20.766-17.207M2890.53 3037.17v44.714c0 10.681 6.603 16.101 19.633 16.101h3.949v-9.486h-2.719c-7.777 0-9.898-2.089-9.898-9.616v-21.337h12.779v-9.486h-12.779v-10.89h-10.965ZM2700.85 3047.34h-7.267c-5.503 0-9.768 1.452-12.713 4.316v-3.59h-10.432v49.192h10.974v-30.824c0-4.662 2.776-9.607 10.617-9.607h4.807c1.49 0 2.817.032 4.014.064v-9.551ZM2740.05 3047.34h-7.3c-5.503 0-9.735 1.452-12.713 4.316v-3.59h-10.399v49.192h10.941v-30.824c0-4.662 2.808-9.607 10.65-9.607h4.807c1.489 0 2.816.032 4.014.064v-9.551Z",
    style: {
      fill: '#37424a',
      fillRule: 'nonzero'
    }
  }), React__default.createElement("path", {
    d: "M2361.88 2304.5c174.762-156.198 174.698-399.131 0-555.267-6.569-5.872-17.693-5.987-24.507-.309l-36.228 30.187c-6.506 5.413-6.644 14.124-.406 19.749 142.566 128.647 142.598 327.348 0 456.022-6.238 5.625-6.089 14.335.406 19.748l36.228 30.187c6.814 5.669 17.938 5.555 24.507-.317Zm-557.085-555.266c-174.762 156.198-174.698 399.131 0 555.267 6.569 5.872 17.692 5.986 24.507.309l36.228-30.187c6.505-5.413 6.644-14.124.405-19.749-142.565-128.647-142.597-327.348 0-456.022 6.239-5.625 6.09-14.335-.405-19.749l-36.228-30.186c-6.815-5.669-17.938-5.555-24.507.317Zm121.076 98.954c-108.705 101.616-108.588 255.857 0 357.359 6.505 6.083 17.799 6.277 24.688.503l36.25-30.364c6.313-5.289 6.74-13.806.853-19.439-77.394-74.013-77.223-184.913 0-258.75 5.887-5.633 5.471-14.15-.853-19.44l-36.25-30.363c-6.889-5.783-18.193-5.581-24.688.494Zm314.933 357.358c108.705-101.616 108.588-255.857 0-357.359-6.506-6.084-17.799-6.277-24.689-.503l-36.249 30.363c-6.314 5.29-6.74 13.807-.853 19.44 77.393 74.013 77.223 184.913 0 258.75-5.887 5.633-5.471 14.15.853 19.439l36.249 30.364c6.89 5.783 18.194 5.58 24.689-.494Zm-230.35-176.21c0 40.064 32.471 72.534 72.535 72.534s72.534-32.47 72.534-72.534c0-40.064-32.47-72.535-72.534-72.535-40.064 0-72.535 32.471-72.535 72.535Z",
    style: {
      fill: '#fff'
    }
  }), React__default.createElement("path", {
    d: "M3537.84 2588.45a13.4 13.4 0 0 0-13.4-13.4h-27.46a13.4 13.4 0 0 0-13.4 13.4v.015a13.402 13.402 0 0 0 13.4 13.4h27.46a13.399 13.399 0 0 0 13.4-13.4v-.015ZM3613.34 2765.73a13.4 13.4 0 0 0-18.939.684l-18.704 20.105a13.404 13.404 0 0 0 .684 18.938l.011.01a13.4 13.4 0 0 0 18.938-.683l18.705-20.105a13.404 13.404 0 0 0-.684-18.938l-.011-.011ZM3558.43 2679.66a13.404 13.404 0 0 0-18.502-4.102l-12.421 7.913a13.402 13.402 0 0 0-4.102 18.501l.008.013a13.398 13.398 0 0 0 18.501 4.102l12.422-7.913a13.402 13.402 0 0 0 4.094-18.514ZM3703.32 2820.58a13.4 13.4 0 0 0-17.915 6.179l-6.45 13.24a13.4 13.4 0 0 0 6.178 17.915l.014.007a13.4 13.4 0 0 0 17.915-6.178l6.45-13.241a13.4 13.4 0 0 0-6.192-17.922ZM3557.35 2484.1a13.4 13.4 0 0 0-7.539-17.387l-13.697-5.411a13.4 13.4 0 0 0-17.392 7.553 13.397 13.397 0 0 0 7.539 17.386l13.697 5.412a13.4 13.4 0 0 0 17.392-7.553ZM4471.71 2709.95a13.399 13.399 0 0 0 13.4 13.4h27.46a13.4 13.4 0 0 0 13.4-13.4v-.016a13.4 13.4 0 0 0-13.4-13.4h-27.46a13.402 13.402 0 0 0-13.4 13.4v.016ZM4396.21 2532.67a13.4 13.4 0 0 0 18.938-.683l18.704-20.105a13.4 13.4 0 0 0-.683-18.938l-.012-.011a13.4 13.4 0 0 0-18.938.684l-18.704 20.105a13.399 13.399 0 0 0 .684 18.938l.011.01ZM4451.12 2618.74a13.4 13.4 0 0 0 18.501 4.102l12.422-7.913a13.402 13.402 0 0 0 4.102-18.502l-.009-.013a13.4 13.4 0 0 0-18.501-4.102l-12.421 7.913a13.4 13.4 0 0 0-4.102 18.502l.008.013ZM4306.22 2477.82a13.395 13.395 0 0 0 10.237.621 13.395 13.395 0 0 0 7.678-6.799l6.45-13.24a13.4 13.4 0 0 0-6.192-17.922 13.395 13.395 0 0 0-10.237-.621 13.395 13.395 0 0 0-7.678 6.799l-6.45 13.24a13.396 13.396 0 0 0-.621 10.237 13.395 13.395 0 0 0 6.813 7.685ZM4452.2 2814.3a13.4 13.4 0 0 0 7.539 17.386l13.697 5.412a13.4 13.4 0 0 0 17.392-7.553 13.402 13.402 0 0 0-7.539-17.387l-13.697-5.411a13.4 13.4 0 0 0-17.387 7.539l-.005.014Z",
    style: {
      fill: '#37424a'
    }
  }), React__default.createElement("text", {
    x: 2905.36,
    y: 4101.69,
    style: {
      fontFamily: 'Caveat',
      fontSize: 250,
      fill: '#37424a'
    },
    transform: "rotate(-22.158 -272.088 1523.858)"
  }, "Bliep"), React__default.createElement("text", {
    x: 3268.07,
    y: 4265.26,
    style: {
      fontFamily: 'Caveat',
      fontSize: 250,
      fill: '#37424a'
    },
    transform: "rotate(-22.158 90.624 1687.422)"
  }, "Bliep"));
}

function ChargeCards(props) {
  var renderChargeCard = function renderChargeCard(company) {
    switch (company) {
      case 'BlueCurrent':
        return React__default.createElement(ChargeCard, {
          serial: props.serial,
          shadow: props.shadow,
          borderRadius: props.borderRadius
        });
      default:
        return React__default.createElement(ChargeCard, {
          serial: props.serial,
          shadow: props.shadow,
          borderRadius: props.borderRadius
        });
    }
  };
  return React__default.createElement("div", {
    style: {}
  }, renderChargeCard(props.company));
}

function Curved(props) {
  var _props$width, _props$height, _props$position, _props$marginLeft, _props$marginRight, _props$marginTop, _props$marginBottom, _props$transform, _props$top, _props$left, _props$right, _props$bottom, _props$opacity, _props$color, _props$color2, _props$color3, _props$color4;
  return React__default.createElement("svg", {
    width: (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 100,
    height: (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 50,
    viewBox: "0 0 100 50",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      position: (_props$position = props.position) !== null && _props$position !== void 0 ? _props$position : 'relative',
      zIndex: 1.1,
      marginLeft: (_props$marginLeft = props.marginLeft) !== null && _props$marginLeft !== void 0 ? _props$marginLeft : 0,
      marginRight: (_props$marginRight = props.marginRight) !== null && _props$marginRight !== void 0 ? _props$marginRight : 0,
      marginTop: (_props$marginTop = props.marginTop) !== null && _props$marginTop !== void 0 ? _props$marginTop : 0,
      marginBottom: (_props$marginBottom = props.marginBottom) !== null && _props$marginBottom !== void 0 ? _props$marginBottom : 0,
      transform: (_props$transform = props.transform) !== null && _props$transform !== void 0 ? _props$transform : 'initial',
      top: (_props$top = props.top) !== null && _props$top !== void 0 ? _props$top : 'initial',
      left: (_props$left = props.left) !== null && _props$left !== void 0 ? _props$left : 'initial',
      right: (_props$right = props.right) !== null && _props$right !== void 0 ? _props$right : 'initial',
      bottom: (_props$bottom = props.bottom) !== null && _props$bottom !== void 0 ? _props$bottom : 'initial',
      opacity: (_props$opacity = props.opacity) !== null && _props$opacity !== void 0 ? _props$opacity : 1,
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2
    }
  }, React__default.createElement("path", {
    d: "M148.353 90.273c7.447-5.765 18.307-15.657 35.067-16.699 22.372-1.391 31.149 3.258 37.405 6.863 4.793 2.762 8.34 4.833 14.347 4.013 13.282-1.813 19.582-13.822 19.334-25.083-.168-7.605-3.358-14.76-9.091-18.253a2.299 2.299 0 0 0-2.392 3.924c4.496 2.739 6.757 8.467 6.889 14.43.2 9.089-4.642 18.966-15.362 20.429-4.814.658-7.59-1.228-11.43-3.441-6.692-3.856-16.057-8.956-39.985-7.468-17.922 1.114-29.632 11.487-37.595 17.652a2.297 2.297 0 0 0 2.813 3.633Z",
    style: {
      fill: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : Colors.GREY
    },
    transform: "translate(-102.92 -23.251) scale(.76169)"
  }), React__default.createElement("path", {
    d: "M153.94 75.287c-.058.385-.369 2.308-.84 3.639-.95 2.679-3.373 6.505-3.646 6.933-.306.158-.457.301-.502.339-.135.113-.7 6.254 3.058 4.997 1.79-.598 13.18-4.643 15.755-6.186a2.956 2.956 0 0 0 1.015-4.053 2.955 2.955 0 0 0-4.052-1.015c-1.094.656-3.913 1.785-6.802 2.867a34.82 34.82 0 0 0 .742-1.908c.764-2.155 1.21-4.209 1.196-5.632-.011-1.158-.304-2.075-.71-2.725a2.956 2.956 0 0 0-4.07-.944 2.957 2.957 0 0 0-1.144 3.688Zm-1.685 15.777.1-.055a2.404 2.404 0 0 1-.24.124l.14-.069Z",
    style: {
      fill: (_props$color2 = props.color) !== null && _props$color2 !== void 0 ? _props$color2 : Colors.GREY
    },
    transform: "translate(-105.904 -23.258) scale(.76169)"
  }), React__default.createElement("path", {
    d: "M150.261 101.537c1.624-1.193 6.579-3.377 10.056-4.546.686-.231 1.5-.438 2.006-.558a2.956 2.956 0 0 0 3.961-2.612c.054-.975-.278-1.751-.876-2.375-.398-.414-.986-.815-1.857-.97-.493-.087-1.288-.09-2.297.117-3.204.658-10.388 3.664-13.485 5.523-1.397.838-2.18 1.727-2.43 2.203a2.955 2.955 0 0 0 4.922 3.218Zm10.159-7.4Z",
    style: {
      fill: (_props$color3 = props.color) !== null && _props$color3 !== void 0 ? _props$color3 : Colors.GREY
    },
    transform: "translate(-103.686 -31.776) scale(.76169)"
  }), React__default.createElement("path", {
    d: "M133.379 67.031c-.904 2.394-5.42 13.358-5.81 14.474a2.955 2.955 0 0 0 1.814 3.763 2.955 2.955 0 0 0 3.763-1.814c.386-1.106 4.864-11.964 5.76-14.336a2.955 2.955 0 0 0-5.527-2.087Z",
    style: {
      fill: (_props$color4 = props.color) !== null && _props$color4 !== void 0 ? _props$color4 : Colors.GREY
    },
    transform: "translate(-90.286 -18.664) scale(.76169)"
  }));
}

function Arrows(props) {
  var render = function render() {
    switch (props.type) {
      case 'Curved':
        return React$4.createElement(Curved, {
          height: props.height,
          width: props.width,
          color: props.color,
          marginLeft: props.marginLeft,
          marginRight: props.marginRight,
          marginTop: props.marginTop,
          marginBottom: props.marginBottom,
          transform: props.transform,
          position: props.position,
          top: props.top,
          left: props.left,
          right: props.right,
          bottom: props.bottom,
          opacity: props.opacity
        });
      default:
        return React$4.createElement("div", null);
    }
  };
  return render();
}

export { Accordion, Arrows as Arrow, Backgrounds, Badge, Breakpoint, Buttons$1 as Button, Carousel, Cell, ChargeCards as ChargeCard, GridItem as ChargePointGridItem, CircularArcMeter, ColorSchemes, Colors, ColumnTitle, Confetti, ConfirmDialog, ContactCard, Container, MainContainer as ContentContainer, CookiePopup, CustomIcon, CustomModal, Dialog, DropdownMenu, Footer, Form, GlobalHeader, Header, Icon, Image, InfoBlock, Inputs as Input, Items as Item, ItemMenu, Lang, LargeContainer, Link, Loaders as Loader, Logo, MainContainer$1 as MainContainer, Modal, ModuleHeader, NavigationItem, Overlay, OverlaySearch, PortableTextComponent as PortableText, RangeMeter, Row, ScrollDownArrow, SegmentedControl, SideBarNavigation, Status, TabFixed, TabNavigation, Table, Tag, Text, TextBlock, index as Tip, Title, Toast, Tooltip, Wrap, counter, countryData, filterBasedOnId, filterBasedOnType, getColorScheme, getCurrency, getScrollDirection, getScrollHeight, scrollTo as scrollToId, toCapital, truncate, useCountDecimals, useCountry, useCurrencyFormat, useDataAttributes, useDidMountEffect, useDimensions, useOutsideClick, usePhoneValidation, useRandomConfetti, useRandomPosition, useSweetName };
